var Me2 = Object.defineProperty;
var _e2 = (e, t, r) => t in e ? Me2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Oe2 = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports);
var A0 = (e, t, r) => _e2(e, typeof t != "symbol" ? t + "" : t, r);
var pQ2 = Oe2((_Q2, eS) => {
  function bZ(e, t) {
    for (var r = 0; r < t.length; r++) {
      const n = t[r];
      if (typeof n != "string" && !Array.isArray(n)) {
        for (const i in n)
          if (i !== "default" && !(i in e)) {
            const o = Object.getOwnPropertyDescriptor(n, i);
            o && Object.defineProperty(e, i, o.get ? o : {
              enumerable: !0,
              get: () => n[i]
            });
          }
      }
    }
    return Object.freeze(Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }));
  }
  var wi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
  function tt(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }
  function Te2(e) {
    if (Object.prototype.hasOwnProperty.call(e, "__esModule")) return e;
    var t = e.default;
    if (typeof t == "function") {
      var r = function n() {
        return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
      };
      r.prototype = t.prototype;
    } else r = {};
    return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
      var i = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(r, n, i.get ? i : {
        enumerable: !0,
        get: function() {
          return e[n];
        }
      });
    }), r;
  }
  var ud = { exports: {} }, re = {};
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var qD;
  function De2() {
    if (qD) return re;
    qD = 1;
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), d = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), h = Symbol.iterator;
    function E(H) {
      return H === null || typeof H != "object" ? null : (H = h && H[h] || H["@@iterator"], typeof H == "function" ? H : null);
    }
    var y = { isMounted: function() {
      return !1;
    }, enqueueForceUpdate: function() {
    }, enqueueReplaceState: function() {
    }, enqueueSetState: function() {
    } }, I = Object.assign, Q = {};
    function B(H, Y, r2) {
      this.props = H, this.context = Y, this.refs = Q, this.updater = r2 || y;
    }
    B.prototype.isReactComponent = {}, B.prototype.setState = function(H, Y) {
      if (typeof H != "object" && typeof H != "function" && H != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, H, Y, "setState");
    }, B.prototype.forceUpdate = function(H) {
      this.updater.enqueueForceUpdate(this, H, "forceUpdate");
    };
    function _() {
    }
    _.prototype = B.prototype;
    function M(H, Y, r2) {
      this.props = H, this.context = Y, this.refs = Q, this.updater = r2 || y;
    }
    var S = M.prototype = new _();
    S.constructor = M, I(S, B.prototype), S.isPureReactComponent = !0;
    var O = Array.isArray, w = Object.prototype.hasOwnProperty, D = { current: null }, k = { key: !0, ref: !0, __self: !0, __source: !0 };
    function F(H, Y, r2) {
      var o2, O2 = {}, S2 = null, M2 = null;
      if (Y != null) for (o2 in Y.ref !== void 0 && (M2 = Y.ref), Y.key !== void 0 && (S2 = "" + Y.key), Y) w.call(Y, o2) && !k.hasOwnProperty(o2) && (O2[o2] = Y[o2]);
      var w2 = arguments.length - 2;
      if (w2 === 1) O2.children = r2;
      else if (1 < w2) {
        for (var v2 = Array(w2), L2 = 0; L2 < w2; L2++) v2[L2] = arguments[L2 + 2];
        O2.children = v2;
      }
      if (H && H.defaultProps) for (o2 in w2 = H.defaultProps, w2) O2[o2] === void 0 && (O2[o2] = w2[o2]);
      return { $$typeof: e, type: H, key: S2, ref: M2, props: O2, _owner: D.current };
    }
    function z(H, Y) {
      return { $$typeof: e, type: H.type, key: Y, ref: H.ref, props: H.props, _owner: H._owner };
    }
    function Z(H) {
      return typeof H == "object" && H !== null && H.$$typeof === e;
    }
    function V(H) {
      var Y = { "=": "=0", ":": "=2" };
      return "$" + H.replace(/[=:]/g, function(r2) {
        return Y[r2];
      });
    }
    var $ = /\/+/g;
    function W(H, Y) {
      return typeof H == "object" && H !== null && H.key != null ? V("" + H.key) : Y.toString(36);
    }
    function t2(H, Y, r2, o2, O2) {
      var S2 = typeof H;
      (S2 === "undefined" || S2 === "boolean") && (H = null);
      var M2 = !1;
      if (H === null) M2 = !0;
      else switch (S2) {
        case "string":
        case "number":
          M2 = !0;
          break;
        case "object":
          switch (H.$$typeof) {
            case e:
            case t:
              M2 = !0;
          }
      }
      if (M2) return M2 = H, O2 = O2(M2), H = o2 === "" ? "." + W(M2, 0) : o2, O(O2) ? (r2 = "", H != null && (r2 = H.replace($, "$&/") + "/"), t2(O2, Y, r2, "", function(L2) {
        return L2;
      })) : O2 != null && (Z(O2) && (O2 = z(O2, r2 + (!O2.key || M2 && M2.key === O2.key ? "" : ("" + O2.key).replace($, "$&/") + "/") + H)), Y.push(O2)), 1;
      if (M2 = 0, o2 = o2 === "" ? "." : o2 + ":", O(H)) for (var w2 = 0; w2 < H.length; w2++) {
        S2 = H[w2];
        var v2 = o2 + W(S2, w2);
        M2 += t2(S2, Y, r2, v2, O2);
      }
      else if (v2 = E(H), typeof v2 == "function") for (H = v2.call(H), w2 = 0; !(S2 = H.next()).done; ) S2 = S2.value, v2 = o2 + W(S2, w2++), M2 += t2(S2, Y, r2, v2, O2);
      else if (S2 === "object") throw Y = String(H), Error("Objects are not valid as a React child (found: " + (Y === "[object Object]" ? "object with keys {" + Object.keys(H).join(", ") + "}" : Y) + "). If you meant to render a collection of children, use an array instead.");
      return M2;
    }
    function n2(H, Y, r2) {
      if (H == null) return H;
      var o2 = [], O2 = 0;
      return t2(H, o2, "", "", function(S2) {
        return Y.call(r2, S2, O2++);
      }), o2;
    }
    function s2(H) {
      if (H._status === -1) {
        var Y = H._result;
        Y = Y(), Y.then(function(r2) {
          (H._status === 0 || H._status === -1) && (H._status = 1, H._result = r2);
        }, function(r2) {
          (H._status === 0 || H._status === -1) && (H._status = 2, H._result = r2);
        }), H._status === -1 && (H._status = 0, H._result = Y);
      }
      if (H._status === 1) return H._result.default;
      throw H._result;
    }
    var l2 = { current: null }, X = { transition: null }, a2 = { ReactCurrentDispatcher: l2, ReactCurrentBatchConfig: X, ReactCurrentOwner: D };
    function e2() {
      throw Error("act(...) is not supported in production builds of React.");
    }
    return re.Children = { map: n2, forEach: function(H, Y, r2) {
      n2(H, function() {
        Y.apply(this, arguments);
      }, r2);
    }, count: function(H) {
      var Y = 0;
      return n2(H, function() {
        Y++;
      }), Y;
    }, toArray: function(H) {
      return n2(H, function(Y) {
        return Y;
      }) || [];
    }, only: function(H) {
      if (!Z(H)) throw Error("React.Children.only expected to receive a single React element child.");
      return H;
    } }, re.Component = B, re.Fragment = r, re.Profiler = i, re.PureComponent = M, re.StrictMode = n, re.Suspense = f, re.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = a2, re.act = e2, re.cloneElement = function(H, Y, r2) {
      if (H == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + H + ".");
      var o2 = I({}, H.props), O2 = H.key, S2 = H.ref, M2 = H._owner;
      if (Y != null) {
        if (Y.ref !== void 0 && (S2 = Y.ref, M2 = D.current), Y.key !== void 0 && (O2 = "" + Y.key), H.type && H.type.defaultProps) var w2 = H.type.defaultProps;
        for (v2 in Y) w.call(Y, v2) && !k.hasOwnProperty(v2) && (o2[v2] = Y[v2] === void 0 && w2 !== void 0 ? w2[v2] : Y[v2]);
      }
      var v2 = arguments.length - 2;
      if (v2 === 1) o2.children = r2;
      else if (1 < v2) {
        w2 = Array(v2);
        for (var L2 = 0; L2 < v2; L2++) w2[L2] = arguments[L2 + 2];
        o2.children = w2;
      }
      return { $$typeof: e, type: H.type, key: O2, ref: S2, props: o2, _owner: M2 };
    }, re.createContext = function(H) {
      return H = { $$typeof: u, _currentValue: H, _currentValue2: H, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, H.Provider = { $$typeof: o, _context: H }, H.Consumer = H;
    }, re.createElement = F, re.createFactory = function(H) {
      var Y = F.bind(null, H);
      return Y.type = H, Y;
    }, re.createRef = function() {
      return { current: null };
    }, re.forwardRef = function(H) {
      return { $$typeof: c, render: H };
    }, re.isValidElement = Z, re.lazy = function(H) {
      return { $$typeof: g, _payload: { _status: -1, _result: H }, _init: s2 };
    }, re.memo = function(H, Y) {
      return { $$typeof: d, type: H, compare: Y === void 0 ? null : Y };
    }, re.startTransition = function(H) {
      var Y = X.transition;
      X.transition = {};
      try {
        H();
      } finally {
        X.transition = Y;
      }
    }, re.unstable_act = e2, re.useCallback = function(H, Y) {
      return l2.current.useCallback(H, Y);
    }, re.useContext = function(H) {
      return l2.current.useContext(H);
    }, re.useDebugValue = function() {
    }, re.useDeferredValue = function(H) {
      return l2.current.useDeferredValue(H);
    }, re.useEffect = function(H, Y) {
      return l2.current.useEffect(H, Y);
    }, re.useId = function() {
      return l2.current.useId();
    }, re.useImperativeHandle = function(H, Y, r2) {
      return l2.current.useImperativeHandle(H, Y, r2);
    }, re.useInsertionEffect = function(H, Y) {
      return l2.current.useInsertionEffect(H, Y);
    }, re.useLayoutEffect = function(H, Y) {
      return l2.current.useLayoutEffect(H, Y);
    }, re.useMemo = function(H, Y) {
      return l2.current.useMemo(H, Y);
    }, re.useReducer = function(H, Y, r2) {
      return l2.current.useReducer(H, Y, r2);
    }, re.useRef = function(H) {
      return l2.current.useRef(H);
    }, re.useState = function(H) {
      return l2.current.useState(H);
    }, re.useSyncExternalStore = function(H, Y, r2) {
      return l2.current.useSyncExternalStore(H, Y, r2);
    }, re.useTransition = function() {
      return l2.current.useTransition();
    }, re.version = "18.3.1", re;
  }
  var Zl = { exports: {} };
  /**
   * @license React
   * react.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  Zl.exports;
  var WD;
  function Le2() {
    return WD || (WD = 1, function(e, t) {
      process.env.NODE_ENV !== "production" && function() {
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var r = "18.3.1", n = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), u = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), d = Symbol.for("react.context"), g = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), E = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), I = Symbol.for("react.lazy"), Q = Symbol.for("react.offscreen"), B = Symbol.iterator, _ = "@@iterator";
        function M(j) {
          if (j === null || typeof j != "object")
            return null;
          var u2 = B && j[B] || j[_];
          return typeof u2 == "function" ? u2 : null;
        }
        var S = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        }, O = {
          transition: null
        }, w = {
          current: null,
          // Used to reproduce behavior of `batchedUpdates` in legacy mode.
          isBatchingLegacy: !1,
          didScheduleLegacyUpdate: !1
        }, D = {
          /**
           * @internal
           * @type {ReactComponent}
           */
          current: null
        }, k = {}, F = null;
        function z(j) {
          F = j;
        }
        k.setExtraStackFrame = function(j) {
          F = j;
        }, k.getCurrentStack = null, k.getStackAddendum = function() {
          var j = "";
          F && (j += F);
          var u2 = k.getCurrentStack;
          return u2 && (j += u2() || ""), j;
        };
        var Z = !1, V = !1, $ = !1, W = !1, t2 = !1, n2 = {
          ReactCurrentDispatcher: S,
          ReactCurrentBatchConfig: O,
          ReactCurrentOwner: D
        };
        n2.ReactDebugCurrentFrame = k, n2.ReactCurrentActQueue = w;
        function s2(j) {
          {
            for (var u2 = arguments.length, Q2 = new Array(u2 > 1 ? u2 - 1 : 0), _2 = 1; _2 < u2; _2++)
              Q2[_2 - 1] = arguments[_2];
            X("warn", j, Q2);
          }
        }
        function l2(j) {
          {
            for (var u2 = arguments.length, Q2 = new Array(u2 > 1 ? u2 - 1 : 0), _2 = 1; _2 < u2; _2++)
              Q2[_2 - 1] = arguments[_2];
            X("error", j, Q2);
          }
        }
        function X(j, u2, Q2) {
          {
            var _2 = n2.ReactDebugCurrentFrame, q2 = _2.getStackAddendum();
            q2 !== "" && (u2 += "%s", Q2 = Q2.concat([q2]));
            var Q0 = Q2.map(function(K2) {
              return String(K2);
            });
            Q0.unshift("Warning: " + u2), Function.prototype.apply.call(console[j], console, Q0);
          }
        }
        var a2 = {};
        function e2(j, u2) {
          {
            var Q2 = j.constructor, _2 = Q2 && (Q2.displayName || Q2.name) || "ReactClass", q2 = _2 + "." + u2;
            if (a2[q2])
              return;
            l2("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", u2, _2), a2[q2] = !0;
          }
        }
        var H = {
          /**
           * Checks whether or not this composite component is mounted.
           * @param {ReactClass} publicInstance The instance we want to test.
           * @return {boolean} True if mounted, false otherwise.
           * @protected
           * @final
           */
          isMounted: function(j) {
            return !1;
          },
          /**
           * Forces an update. This should only be invoked when it is known with
           * certainty that we are **not** in a DOM transaction.
           *
           * You may want to call this when you know that some deeper aspect of the
           * component's state has changed but `setState` was not called.
           *
           * This will not invoke `shouldComponentUpdate`, but it will invoke
           * `componentWillUpdate` and `componentDidUpdate`.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueForceUpdate: function(j, u2, Q2) {
            e2(j, "forceUpdate");
          },
          /**
           * Replaces all of the state. Always use this or `setState` to mutate state.
           * You should treat `this.state` as immutable.
           *
           * There is no guarantee that `this.state` will be immediately updated, so
           * accessing `this.state` after calling this method may return the old value.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} completeState Next state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} callerName name of the calling function in the public API.
           * @internal
           */
          enqueueReplaceState: function(j, u2, Q2, _2) {
            e2(j, "replaceState");
          },
          /**
           * Sets a subset of the state. This only exists because _pendingState is
           * internal. This provides a merging strategy that is not available to deep
           * properties which is confusing. TODO: Expose pendingState or don't use it
           * during the merge.
           *
           * @param {ReactClass} publicInstance The instance that should rerender.
           * @param {object} partialState Next partial state to be merged with state.
           * @param {?function} callback Called after component is updated.
           * @param {?string} Name of the calling function in the public API.
           * @internal
           */
          enqueueSetState: function(j, u2, Q2, _2) {
            e2(j, "setState");
          }
        }, Y = Object.assign, r2 = {};
        Object.freeze(r2);
        function o2(j, u2, Q2) {
          this.props = j, this.context = u2, this.refs = r2, this.updater = Q2 || H;
        }
        o2.prototype.isReactComponent = {}, o2.prototype.setState = function(j, u2) {
          if (typeof j != "object" && typeof j != "function" && j != null)
            throw new Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
          this.updater.enqueueSetState(this, j, u2, "setState");
        }, o2.prototype.forceUpdate = function(j) {
          this.updater.enqueueForceUpdate(this, j, "forceUpdate");
        };
        {
          var O2 = {
            isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."],
            replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."]
          }, S2 = function(j, u2) {
            Object.defineProperty(o2.prototype, j, {
              get: function() {
                s2("%s(...) is deprecated in plain JavaScript React classes. %s", u2[0], u2[1]);
              }
            });
          };
          for (var M2 in O2)
            O2.hasOwnProperty(M2) && S2(M2, O2[M2]);
        }
        function w2() {
        }
        w2.prototype = o2.prototype;
        function v2(j, u2, Q2) {
          this.props = j, this.context = u2, this.refs = r2, this.updater = Q2 || H;
        }
        var L2 = v2.prototype = new w2();
        L2.constructor = v2, Y(L2, o2.prototype), L2.isPureReactComponent = !0;
        function W2() {
          var j = {
            current: null
          };
          return Object.seal(j), j;
        }
        var d2 = Array.isArray;
        function X2(j) {
          return d2(j);
        }
        function k2(j) {
          {
            var u2 = typeof Symbol == "function" && Symbol.toStringTag, Q2 = u2 && j[Symbol.toStringTag] || j.constructor.name || "Object";
            return Q2;
          }
        }
        function b0(j) {
          try {
            return S0(j), !1;
          } catch {
            return !0;
          }
        }
        function S0(j) {
          return "" + j;
        }
        function G0(j) {
          if (b0(j))
            return l2("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", k2(j)), S0(j);
        }
        function $e(j, u2, Q2) {
          var _2 = j.displayName;
          if (_2)
            return _2;
          var q2 = u2.displayName || u2.name || "";
          return q2 !== "" ? Q2 + "(" + q2 + ")" : Q2;
        }
        function _e(j) {
          return j.displayName || "Context";
        }
        function Oe(j) {
          if (j == null)
            return null;
          if (typeof j.tag == "number" && l2("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof j == "function")
            return j.displayName || j.name || null;
          if (typeof j == "string")
            return j;
          switch (j) {
            case o:
              return "Fragment";
            case i:
              return "Portal";
            case c:
              return "Profiler";
            case u:
              return "StrictMode";
            case h:
              return "Suspense";
            case E:
              return "SuspenseList";
          }
          if (typeof j == "object")
            switch (j.$$typeof) {
              case d:
                var u2 = j;
                return _e(u2) + ".Consumer";
              case f:
                var Q2 = j;
                return _e(Q2._context) + ".Provider";
              case g:
                return $e(j, j.render, "ForwardRef");
              case y:
                var _2 = j.displayName || null;
                return _2 !== null ? _2 : Oe(j.type) || "Memo";
              case I: {
                var q2 = j, Q0 = q2._payload, K2 = q2._init;
                try {
                  return Oe(K2(Q0));
                } catch {
                  return null;
                }
              }
            }
          return null;
        }
        var U0 = Object.prototype.hasOwnProperty, Z0 = {
          key: !0,
          ref: !0,
          __self: !0,
          __source: !0
        }, Te, Lt, Ge;
        Ge = {};
        function rt(j) {
          if (U0.call(j, "ref")) {
            var u2 = Object.getOwnPropertyDescriptor(j, "ref").get;
            if (u2 && u2.isReactWarning)
              return !1;
          }
          return j.ref !== void 0;
        }
        function yt(j) {
          if (U0.call(j, "key")) {
            var u2 = Object.getOwnPropertyDescriptor(j, "key").get;
            if (u2 && u2.isReactWarning)
              return !1;
          }
          return j.key !== void 0;
        }
        function D1(j, u2) {
          var Q2 = function() {
            Te || (Te = !0, l2("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u2));
          };
          Q2.isReactWarning = !0, Object.defineProperty(j, "key", {
            get: Q2,
            configurable: !0
          });
        }
        function L1(j, u2) {
          var Q2 = function() {
            Lt || (Lt = !0, l2("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", u2));
          };
          Q2.isReactWarning = !0, Object.defineProperty(j, "ref", {
            get: Q2,
            configurable: !0
          });
        }
        function Y2(j) {
          if (typeof j.ref == "string" && D.current && j.__self && D.current.stateNode !== j.__self) {
            var u2 = Oe(D.current.type);
            Ge[u2] || (l2('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', u2, j.ref), Ge[u2] = !0);
          }
        }
        var c0 = function(j, u2, Q2, _2, q2, Q0, K2) {
          var M0 = {
            // This tag allows us to uniquely identify this as a React Element
            $$typeof: n,
            // Built-in properties that belong on the element
            type: j,
            key: u2,
            ref: Q2,
            props: K2,
            // Record the component responsible for creating this element.
            _owner: Q0
          };
          return M0._store = {}, Object.defineProperty(M0._store, "validated", {
            configurable: !1,
            enumerable: !1,
            writable: !0,
            value: !1
          }), Object.defineProperty(M0, "_self", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: _2
          }), Object.defineProperty(M0, "_source", {
            configurable: !1,
            enumerable: !1,
            writable: !1,
            value: q2
          }), Object.freeze && (Object.freeze(M0.props), Object.freeze(M0)), M0;
        };
        function k0(j, u2, Q2) {
          var _2, q2 = {}, Q0 = null, K2 = null, M0 = null, X0 = null;
          if (u2 != null) {
            rt(u2) && (K2 = u2.ref, Y2(u2)), yt(u2) && (G0(u2.key), Q0 = "" + u2.key), M0 = u2.__self === void 0 ? null : u2.__self, X0 = u2.__source === void 0 ? null : u2.__source;
            for (_2 in u2)
              U0.call(u2, _2) && !Z0.hasOwnProperty(_2) && (q2[_2] = u2[_2]);
          }
          var le = arguments.length - 2;
          if (le === 1)
            q2.children = Q2;
          else if (le > 1) {
            for (var at = Array(le), Fe = 0; Fe < le; Fe++)
              at[Fe] = arguments[Fe + 2];
            Object.freeze && Object.freeze(at), q2.children = at;
          }
          if (j && j.defaultProps) {
            var q0 = j.defaultProps;
            for (_2 in q0)
              q2[_2] === void 0 && (q2[_2] = q0[_2]);
          }
          if (Q0 || K2) {
            var Ne = typeof j == "function" ? j.displayName || j.name || "Unknown" : j;
            Q0 && D1(q2, Ne), K2 && L1(q2, Ne);
          }
          return c0(j, Q0, K2, M0, X0, D.current, q2);
        }
        function fe(j, u2) {
          var Q2 = c0(j.type, u2, j.ref, j._self, j._source, j._owner, j.props);
          return Q2;
        }
        function De(j, u2, Q2) {
          if (j == null)
            throw new Error("React.cloneElement(...): The argument must be a React element, but you passed " + j + ".");
          var _2, q2 = Y({}, j.props), Q0 = j.key, K2 = j.ref, M0 = j._self, X0 = j._source, le = j._owner;
          if (u2 != null) {
            rt(u2) && (K2 = u2.ref, le = D.current), yt(u2) && (G0(u2.key), Q0 = "" + u2.key);
            var at;
            j.type && j.type.defaultProps && (at = j.type.defaultProps);
            for (_2 in u2)
              U0.call(u2, _2) && !Z0.hasOwnProperty(_2) && (u2[_2] === void 0 && at !== void 0 ? q2[_2] = at[_2] : q2[_2] = u2[_2]);
          }
          var Fe = arguments.length - 2;
          if (Fe === 1)
            q2.children = Q2;
          else if (Fe > 1) {
            for (var q0 = Array(Fe), Ne = 0; Ne < Fe; Ne++)
              q0[Ne] = arguments[Ne + 2];
            q2.children = q0;
          }
          return c0(j.type, Q0, K2, M0, X0, le, q2);
        }
        function nt(j) {
          return typeof j == "object" && j !== null && j.$$typeof === n;
        }
        var Ke = ".", kt = ":";
        function Le(j) {
          var u2 = /[=:]/g, Q2 = {
            "=": "=0",
            ":": "=2"
          }, _2 = j.replace(u2, function(q2) {
            return Q2[q2];
          });
          return "$" + _2;
        }
        var be = !1, Qe = /\/+/g;
        function Z5(j) {
          return j.replace(Qe, "$&/");
        }
        function Gt(j, u2) {
          return typeof j == "object" && j !== null && j.key != null ? (G0(j.key), Le("" + j.key)) : u2.toString(36);
        }
        function c1(j, u2, Q2, _2, q2) {
          var Q0 = typeof j;
          (Q0 === "undefined" || Q0 === "boolean") && (j = null);
          var K2 = !1;
          if (j === null)
            K2 = !0;
          else
            switch (Q0) {
              case "string":
              case "number":
                K2 = !0;
                break;
              case "object":
                switch (j.$$typeof) {
                  case n:
                  case i:
                    K2 = !0;
                }
            }
          if (K2) {
            var M0 = j, X0 = q2(M0), le = _2 === "" ? Ke + Gt(M0, 0) : _2;
            if (X2(X0)) {
              var at = "";
              le != null && (at = Z5(le) + "/"), c1(X0, u2, at, "", function(Is) {
                return Is;
              });
            } else X0 != null && (nt(X0) && (X0.key && (!M0 || M0.key !== X0.key) && G0(X0.key), X0 = fe(
              X0,
              // Keep both the (mapped) and old keys if they differ, just as
              // traverseAllChildren used to do for objects as children
              Q2 + // $FlowFixMe Flow incorrectly thinks React.Portal doesn't have a key
              (X0.key && (!M0 || M0.key !== X0.key) ? (
                // $FlowFixMe Flow incorrectly thinks existing element's key can be a number
                // eslint-disable-next-line react-internal/safe-string-coercion
                Z5("" + X0.key) + "/"
              ) : "") + le
            )), u2.push(X0));
            return 1;
          }
          var Fe, q0, Ne = 0, pt = _2 === "" ? Ke : _2 + kt;
          if (X2(j))
            for (var Sn = 0; Sn < j.length; Sn++)
              Fe = j[Sn], q0 = pt + Gt(Fe, Sn), Ne += c1(Fe, u2, Q2, q0, q2);
          else {
            var u7 = M(j);
            if (typeof u7 == "function") {
              var k4 = j;
              u7 === k4.entries && (be || s2("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), be = !0);
              for (var l7 = u7.call(k4), Q3, ys = 0; !(Q3 = l7.next()).done; )
                Fe = Q3.value, q0 = pt + Gt(Fe, ys++), Ne += c1(Fe, u2, Q2, q0, q2);
            } else if (Q0 === "object") {
              var sa = String(j);
              throw new Error("Objects are not valid as a React child (found: " + (sa === "[object Object]" ? "object with keys {" + Object.keys(j).join(", ") + "}" : sa) + "). If you meant to render a collection of children, use an array instead.");
            }
          }
          return Ne;
        }
        function Br(j, u2, Q2) {
          if (j == null)
            return j;
          var _2 = [], q2 = 0;
          return c1(j, _2, "", "", function(Q0) {
            return u2.call(Q2, Q0, q2++);
          }), _2;
        }
        function T4(j) {
          var u2 = 0;
          return Br(j, function() {
            u2++;
          }), u2;
        }
        function Yr(j, u2, Q2) {
          Br(j, function() {
            u2.apply(this, arguments);
          }, Q2);
        }
        function $r(j) {
          return Br(j, function(u2) {
            return u2;
          }) || [];
        }
        function Gr(j) {
          if (!nt(j))
            throw new Error("React.Children.only expected to receive a single React element child.");
          return j;
        }
        function Kr(j) {
          var u2 = {
            $$typeof: d,
            // As a workaround to support multiple concurrent renderers, we categorize
            // some renderers as primary and others as secondary. We only expect
            // there to be two concurrent renderers at most: React Native (primary) and
            // Fabric (secondary); React DOM (primary) and React ART (secondary).
            // Secondary renderers store their context values on separate fields.
            _currentValue: j,
            _currentValue2: j,
            // Used to track how many concurrent renderers this context currently
            // supports within in a single renderer. Such as parallel server rendering.
            _threadCount: 0,
            // These are circular
            Provider: null,
            Consumer: null,
            // Add these to use same hidden class in VM as ServerContext
            _defaultValue: null,
            _globalName: null
          };
          u2.Provider = {
            $$typeof: f,
            _context: u2
          };
          var Q2 = !1, _2 = !1, q2 = !1;
          {
            var Q0 = {
              $$typeof: d,
              _context: u2
            };
            Object.defineProperties(Q0, {
              Provider: {
                get: function() {
                  return _2 || (_2 = !0, l2("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), u2.Provider;
                },
                set: function(K2) {
                  u2.Provider = K2;
                }
              },
              _currentValue: {
                get: function() {
                  return u2._currentValue;
                },
                set: function(K2) {
                  u2._currentValue = K2;
                }
              },
              _currentValue2: {
                get: function() {
                  return u2._currentValue2;
                },
                set: function(K2) {
                  u2._currentValue2 = K2;
                }
              },
              _threadCount: {
                get: function() {
                  return u2._threadCount;
                },
                set: function(K2) {
                  u2._threadCount = K2;
                }
              },
              Consumer: {
                get: function() {
                  return Q2 || (Q2 = !0, l2("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), u2.Consumer;
                }
              },
              displayName: {
                get: function() {
                  return u2.displayName;
                },
                set: function(K2) {
                  q2 || (s2("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", K2), q2 = !0);
                }
              }
            }), u2.Consumer = Q0;
          }
          return u2._currentRenderer = null, u2._currentRenderer2 = null, u2;
        }
        var g5 = -1, o5 = 0, xe = 1, Kt = 2;
        function A1(j) {
          if (j._status === g5) {
            var u2 = j._result, Q2 = u2();
            if (Q2.then(function(Q0) {
              if (j._status === o5 || j._status === g5) {
                var K2 = j;
                K2._status = xe, K2._result = Q0;
              }
            }, function(Q0) {
              if (j._status === o5 || j._status === g5) {
                var K2 = j;
                K2._status = Kt, K2._result = Q0;
              }
            }), j._status === g5) {
              var _2 = j;
              _2._status = o5, _2._result = Q2;
            }
          }
          if (j._status === xe) {
            var q2 = j._result;
            return q2 === void 0 && l2(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))

Did you accidentally put curly braces around the import?`, q2), "default" in q2 || l2(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, q2), q2.default;
          } else
            throw j._result;
        }
        function X1(j) {
          var u2 = {
            // We use these fields to store the result.
            _status: g5,
            _result: j
          }, Q2 = {
            $$typeof: I,
            _payload: u2,
            _init: A1
          };
          {
            var _2, q2;
            Object.defineProperties(Q2, {
              defaultProps: {
                configurable: !0,
                get: function() {
                  return _2;
                },
                set: function(Q0) {
                  l2("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), _2 = Q0, Object.defineProperty(Q2, "defaultProps", {
                    enumerable: !0
                  });
                }
              },
              propTypes: {
                configurable: !0,
                get: function() {
                  return q2;
                },
                set: function(Q0) {
                  l2("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), q2 = Q0, Object.defineProperty(Q2, "propTypes", {
                    enumerable: !0
                  });
                }
              }
            });
          }
          return Q2;
        }
        function Xr(j) {
          j != null && j.$$typeof === y ? l2("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof j != "function" ? l2("forwardRef requires a render function but was given %s.", j === null ? "null" : typeof j) : j.length !== 0 && j.length !== 2 && l2("forwardRef render functions accept exactly two parameters: props and ref. %s", j.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), j != null && (j.defaultProps != null || j.propTypes != null) && l2("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
          var u2 = {
            $$typeof: g,
            render: j
          };
          {
            var Q2;
            Object.defineProperty(u2, "displayName", {
              enumerable: !1,
              configurable: !0,
              get: function() {
                return Q2;
              },
              set: function(_2) {
                Q2 = _2, !j.name && !j.displayName && (j.displayName = _2);
              }
            });
          }
          return u2;
        }
        var c2;
        c2 = Symbol.for("react.module.reference");
        function N2(j) {
          return !!(typeof j == "string" || typeof j == "function" || j === o || j === c || t2 || j === u || j === h || j === E || W || j === Q || Z || V || $ || typeof j == "object" && j !== null && (j.$$typeof === I || j.$$typeof === y || j.$$typeof === f || j.$$typeof === d || j.$$typeof === g || // This needs to include all possible module reference object
          // types supported by any Flight configuration anywhere since
          // we don't know which Flight build this will end up being used
          // with.
          j.$$typeof === c2 || j.getModuleId !== void 0));
        }
        function J2(j, u2) {
          N2(j) || l2("memo: The first argument must be a component. Instead received: %s", j === null ? "null" : typeof j);
          var Q2 = {
            $$typeof: y,
            type: j,
            compare: u2 === void 0 ? null : u2
          };
          {
            var _2;
            Object.defineProperty(Q2, "displayName", {
              enumerable: !1,
              configurable: !0,
              get: function() {
                return _2;
              },
              set: function(q2) {
                _2 = q2, !j.name && !j.displayName && (j.displayName = q2);
              }
            });
          }
          return Q2;
        }
        function l0() {
          var j = S.current;
          return j === null && l2(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`), j;
        }
        function H0(j) {
          var u2 = l0();
          if (j._context !== void 0) {
            var Q2 = j._context;
            Q2.Consumer === j ? l2("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Q2.Provider === j && l2("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
          }
          return u2.useContext(j);
        }
        function P0(j) {
          var u2 = l0();
          return u2.useState(j);
        }
        function K0(j, u2, Q2) {
          var _2 = l0();
          return _2.useReducer(j, u2, Q2);
        }
        function W0(j) {
          var u2 = l0();
          return u2.useRef(j);
        }
        function Qt(j, u2) {
          var Q2 = l0();
          return Q2.useEffect(j, u2);
        }
        function it(j, u2) {
          var Q2 = l0();
          return Q2.useInsertionEffect(j, u2);
        }
        function ut(j, u2) {
          var Q2 = l0();
          return Q2.useLayoutEffect(j, u2);
        }
        function p5(j, u2) {
          var Q2 = l0();
          return Q2.useCallback(j, u2);
        }
        function Qr(j, u2) {
          var Q2 = l0();
          return Q2.useMemo(j, u2);
        }
        function xr(j, u2, Q2) {
          var _2 = l0();
          return _2.useImperativeHandle(j, u2, Q2);
        }
        function j0(j, u2) {
          {
            var Q2 = l0();
            return Q2.useDebugValue(j, u2);
          }
        }
        function z0() {
          var j = l0();
          return j.useTransition();
        }
        function br(j) {
          var u2 = l0();
          return u2.useDeferredValue(j);
        }
        function v3() {
          var j = l0();
          return j.useId();
        }
        function E3(j, u2, Q2) {
          var _2 = l0();
          return _2.useSyncExternalStore(j, u2, Q2);
        }
        var yn = 0, T8, In, f1, i7, z5, aa, oa;
        function D8() {
        }
        D8.__reactDisabledLog = !0;
        function Bn() {
          {
            if (yn === 0) {
              T8 = console.log, In = console.info, f1 = console.warn, i7 = console.error, z5 = console.group, aa = console.groupCollapsed, oa = console.groupEnd;
              var j = {
                configurable: !0,
                enumerable: !0,
                value: D8,
                writable: !0
              };
              Object.defineProperties(console, {
                info: j,
                log: j,
                warn: j,
                error: j,
                group: j,
                groupCollapsed: j,
                groupEnd: j
              });
            }
            yn++;
          }
        }
        function k1() {
          {
            if (yn--, yn === 0) {
              var j = {
                configurable: !0,
                enumerable: !0,
                writable: !0
              };
              Object.defineProperties(console, {
                log: Y({}, j, {
                  value: T8
                }),
                info: Y({}, j, {
                  value: In
                }),
                warn: Y({}, j, {
                  value: f1
                }),
                error: Y({}, j, {
                  value: i7
                }),
                group: Y({}, j, {
                  value: z5
                }),
                groupCollapsed: Y({}, j, {
                  value: aa
                }),
                groupEnd: Y({}, j, {
                  value: oa
                })
              });
            }
            yn < 0 && l2("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
          }
        }
        var wr = n2.ReactCurrentDispatcher, Sr;
        function L8(j, u2, Q2) {
          {
            if (Sr === void 0)
              try {
                throw Error();
              } catch (q2) {
                var _2 = q2.stack.trim().match(/\n( *(at )?)/);
                Sr = _2 && _2[1] || "";
              }
            return `
` + Sr + j;
          }
        }
        var m3 = !1, Qn;
        {
          var k8 = typeof WeakMap == "function" ? WeakMap : Map;
          Qn = new k8();
        }
        function R8(j, u2) {
          if (!j || m3)
            return "";
          {
            var Q2 = Qn.get(j);
            if (Q2 !== void 0)
              return Q2;
          }
          var _2;
          m3 = !0;
          var q2 = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          var Q0;
          Q0 = wr.current, wr.current = null, Bn();
          try {
            if (u2) {
              var K2 = function() {
                throw Error();
              };
              if (Object.defineProperty(K2.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(K2, []);
                } catch (pt) {
                  _2 = pt;
                }
                Reflect.construct(j, [], K2);
              } else {
                try {
                  K2.call();
                } catch (pt) {
                  _2 = pt;
                }
                j.call(K2.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (pt) {
                _2 = pt;
              }
              j();
            }
          } catch (pt) {
            if (pt && _2 && typeof pt.stack == "string") {
              for (var M0 = pt.stack.split(`
`), X0 = _2.stack.split(`
`), le = M0.length - 1, at = X0.length - 1; le >= 1 && at >= 0 && M0[le] !== X0[at]; )
                at--;
              for (; le >= 1 && at >= 0; le--, at--)
                if (M0[le] !== X0[at]) {
                  if (le !== 1 || at !== 1)
                    do
                      if (le--, at--, at < 0 || M0[le] !== X0[at]) {
                        var Fe = `
` + M0[le].replace(" at new ", " at ");
                        return j.displayName && Fe.includes("<anonymous>") && (Fe = Fe.replace("<anonymous>", j.displayName)), typeof j == "function" && Qn.set(j, Fe), Fe;
                      }
                    while (le >= 1 && at >= 0);
                  break;
                }
            }
          } finally {
            m3 = !1, wr.current = Q0, k1(), Error.prepareStackTrace = q2;
          }
          var q0 = j ? j.displayName || j.name : "", Ne = q0 ? L8(q0) : "";
          return typeof j == "function" && Qn.set(j, Ne), Ne;
        }
        function D4(j, u2, Q2) {
          return R8(j, !1);
        }
        function Es(j) {
          var u2 = j.prototype;
          return !!(u2 && u2.isReactComponent);
        }
        function L4(j, u2, Q2) {
          if (j == null)
            return "";
          if (typeof j == "function")
            return R8(j, Es(j));
          if (typeof j == "string")
            return L8(j);
          switch (j) {
            case h:
              return L8("Suspense");
            case E:
              return L8("SuspenseList");
          }
          if (typeof j == "object")
            switch (j.$$typeof) {
              case g:
                return D4(j.render);
              case y:
                return L4(j.type, u2, Q2);
              case I: {
                var _2 = j, q2 = _2._payload, Q0 = _2._init;
                try {
                  return L4(Q0(q2), u2, Q2);
                } catch {
                }
              }
            }
          return "";
        }
        var ve = {}, P8 = n2.ReactDebugCurrentFrame;
        function ue(j) {
          if (j) {
            var u2 = j._owner, Q2 = L4(j.type, j._source, u2 ? u2.type : null);
            P8.setExtraStackFrame(Q2);
          } else
            P8.setExtraStackFrame(null);
        }
        function a7(j, u2, Q2, _2, q2) {
          {
            var Q0 = Function.call.bind(U0);
            for (var K2 in j)
              if (Q0(j, K2)) {
                var M0 = void 0;
                try {
                  if (typeof j[K2] != "function") {
                    var X0 = Error((_2 || "React class") + ": " + Q2 + " type `" + K2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof j[K2] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                    throw X0.name = "Invariant Violation", X0;
                  }
                  M0 = j[K2](u2, K2, _2, Q2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
                } catch (le) {
                  M0 = le;
                }
                M0 && !(M0 instanceof Error) && (ue(q2), l2("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", _2 || "React class", Q2, K2, typeof M0), ue(null)), M0 instanceof Error && !(M0.message in ve) && (ve[M0.message] = !0, ue(q2), l2("Failed %s type: %s", Q2, M0.message), ue(null));
              }
          }
        }
        function Jr(j) {
          if (j) {
            var u2 = j._owner, Q2 = L4(j.type, j._source, u2 ? u2.type : null);
            z(Q2);
          } else
            z(null);
        }
        var R0;
        R0 = !1;
        function F8() {
          if (D.current) {
            var j = Oe(D.current.type);
            if (j)
              return `

Check the render method of \`` + j + "`.";
          }
          return "";
        }
        function h5(j) {
          if (j !== void 0) {
            var u2 = j.fileName.replace(/^.*[\\\/]/, ""), Q2 = j.lineNumber;
            return `

Check your code at ` + u2 + ":" + Q2 + ".";
          }
          return "";
        }
        function e4(j) {
          return j != null ? h5(j.__source) : "";
        }
        var U5 = {};
        function t4(j) {
          var u2 = F8();
          if (!u2) {
            var Q2 = typeof j == "string" ? j : j.displayName || j.name;
            Q2 && (u2 = `

Check the top-level render call using <` + Q2 + ">.");
          }
          return u2;
        }
        function lt(j, u2) {
          if (!(!j._store || j._store.validated || j.key != null)) {
            j._store.validated = !0;
            var Q2 = t4(u2);
            if (!U5[Q2]) {
              U5[Q2] = !0;
              var _2 = "";
              j && j._owner && j._owner !== D.current && (_2 = " It was passed a child from " + Oe(j._owner.type) + "."), Jr(j), l2('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Q2, _2), Jr(null);
            }
          }
        }
        function Pe(j, u2) {
          if (typeof j == "object") {
            if (X2(j))
              for (var Q2 = 0; Q2 < j.length; Q2++) {
                var _2 = j[Q2];
                nt(_2) && lt(_2, u2);
              }
            else if (nt(j))
              j._store && (j._store.validated = !0);
            else if (j) {
              var q2 = M(j);
              if (typeof q2 == "function" && q2 !== j.entries)
                for (var Q0 = q2.call(j), K2; !(K2 = Q0.next()).done; )
                  nt(K2.value) && lt(K2.value, u2);
            }
          }
        }
        function xn(j) {
          {
            var u2 = j.type;
            if (u2 == null || typeof u2 == "string")
              return;
            var Q2;
            if (typeof u2 == "function")
              Q2 = u2.propTypes;
            else if (typeof u2 == "object" && (u2.$$typeof === g || // Note: Memo only checks outer props here.
            // Inner props are checked in the reconciler.
            u2.$$typeof === y))
              Q2 = u2.propTypes;
            else
              return;
            if (Q2) {
              var _2 = Oe(u2);
              a7(Q2, j.props, "prop", _2, j);
            } else if (u2.PropTypes !== void 0 && !R0) {
              R0 = !0;
              var q2 = Oe(u2);
              l2("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", q2 || "Unknown");
            }
            typeof u2.getDefaultProps == "function" && !u2.getDefaultProps.isReactClassApproved && l2("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
          }
        }
        function Xt(j) {
          {
            for (var u2 = Object.keys(j.props), Q2 = 0; Q2 < u2.length; Q2++) {
              var _2 = u2[Q2];
              if (_2 !== "children" && _2 !== "key") {
                Jr(j), l2("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", _2), Jr(null);
                break;
              }
            }
            j.ref !== null && (Jr(j), l2("Invalid attribute `ref` supplied to `React.Fragment`."), Jr(null));
          }
        }
        function q5(j, u2, Q2) {
          var _2 = N2(j);
          if (!_2) {
            var q2 = "";
            (j === void 0 || typeof j == "object" && j !== null && Object.keys(j).length === 0) && (q2 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Q0 = e4(u2);
            Q0 ? q2 += Q0 : q2 += F8();
            var K2;
            j === null ? K2 = "null" : X2(j) ? K2 = "array" : j !== void 0 && j.$$typeof === n ? (K2 = "<" + (Oe(j.type) || "Unknown") + " />", q2 = " Did you accidentally export a JSX literal instead of a component?") : K2 = typeof j, l2("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", K2, q2);
          }
          var M0 = k0.apply(this, arguments);
          if (M0 == null)
            return M0;
          if (_2)
            for (var X0 = 2; X0 < arguments.length; X0++)
              Pe(arguments[X0], j);
          return j === o ? Xt(M0) : xn(M0), M0;
        }
        var J1 = !1;
        function y3(j) {
          var u2 = q5.bind(null, j);
          return u2.type = j, J1 || (J1 = !0, s2("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(u2, "type", {
            enumerable: !1,
            get: function() {
              return s2("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", {
                value: j
              }), j;
            }
          }), u2;
        }
        function o7(j, u2, Q2) {
          for (var _2 = De.apply(this, arguments), q2 = 2; q2 < arguments.length; q2++)
            Pe(arguments[q2], _2.type);
          return xn(_2), _2;
        }
        function s7(j, u2) {
          var Q2 = O.transition;
          O.transition = {};
          var _2 = O.transition;
          O.transition._updatedFibers = /* @__PURE__ */ new Set();
          try {
            j();
          } finally {
            if (O.transition = Q2, Q2 === null && _2._updatedFibers) {
              var q2 = _2._updatedFibers.size;
              q2 > 10 && s2("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), _2._updatedFibers.clear();
            }
          }
        }
        var bn = !1, I3 = null;
        function ms(j) {
          if (I3 === null)
            try {
              var u2 = ("require" + Math.random()).slice(0, 7), Q2 = e && e[u2];
              I3 = Q2.call(e, "timers").setImmediate;
            } catch {
              I3 = function(q2) {
                bn === !1 && (bn = !0, typeof MessageChannel > "u" && l2("This browser does not have a MessageChannel implementation, so enqueuing tasks via await act(async () => ...) will fail. Please file an issue at https://github.com/facebook/react/issues if you encounter this warning."));
                var Q0 = new MessageChannel();
                Q0.port1.onmessage = q2, Q0.port2.postMessage(void 0);
              };
            }
          return I3(j);
        }
        var er = 0, Mr = !1;
        function r4(j) {
          {
            var u2 = er;
            er++, w.current === null && (w.current = []);
            var Q2 = w.isBatchingLegacy, _2;
            try {
              if (w.isBatchingLegacy = !0, _2 = j(), !Q2 && w.didScheduleLegacyUpdate) {
                var q2 = w.current;
                q2 !== null && (w.didScheduleLegacyUpdate = !1, wn(q2));
              }
            } catch (q0) {
              throw tr(u2), q0;
            } finally {
              w.isBatchingLegacy = Q2;
            }
            if (_2 !== null && typeof _2 == "object" && typeof _2.then == "function") {
              var Q0 = _2, K2 = !1, M0 = {
                then: function(q0, Ne) {
                  K2 = !0, Q0.then(function(pt) {
                    tr(u2), er === 0 ? N8(pt, q0, Ne) : q0(pt);
                  }, function(pt) {
                    tr(u2), Ne(pt);
                  });
                }
              };
              return !Mr && typeof Promise < "u" && Promise.resolve().then(function() {
              }).then(function() {
                K2 || (Mr = !0, l2("You called act(async () => ...) without await. This could lead to unexpected testing behaviour, interleaving multiple act calls and mixing their scopes. You should - await act(async () => ...);"));
              }), M0;
            } else {
              var X0 = _2;
              if (tr(u2), er === 0) {
                var le = w.current;
                le !== null && (wn(le), w.current = null);
                var at = {
                  then: function(q0, Ne) {
                    w.current === null ? (w.current = [], N8(X0, q0, Ne)) : q0(X0);
                  }
                };
                return at;
              } else {
                var Fe = {
                  then: function(q0, Ne) {
                    q0(X0);
                  }
                };
                return Fe;
              }
            }
          }
        }
        function tr(j) {
          j !== er - 1 && l2("You seem to have overlapping act() calls, this is not supported. Be sure to await previous act() calls before making a new one. "), er = j;
        }
        function N8(j, u2, Q2) {
          {
            var _2 = w.current;
            if (_2 !== null)
              try {
                wn(_2), ms(function() {
                  _2.length === 0 ? (w.current = null, u2(j)) : N8(j, u2, Q2);
                });
              } catch (q2) {
                Q2(q2);
              }
            else
              u2(j);
          }
        }
        var H8 = !1;
        function wn(j) {
          if (!H8) {
            H8 = !0;
            var u2 = 0;
            try {
              for (; u2 < j.length; u2++) {
                var Q2 = j[u2];
                do
                  Q2 = Q2(!0);
                while (Q2 !== null);
              }
              j.length = 0;
            } catch (_2) {
              throw j = j.slice(u2 + 1), _2;
            } finally {
              H8 = !1;
            }
          }
        }
        var B3 = q5, j8 = o7, V8 = y3, _r = {
          map: Br,
          forEach: Yr,
          count: T4,
          toArray: $r,
          only: Gr
        };
        t.Children = _r, t.Component = o2, t.Fragment = o, t.Profiler = c, t.PureComponent = v2, t.StrictMode = u, t.Suspense = h, t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = n2, t.act = r4, t.cloneElement = j8, t.createContext = Kr, t.createElement = B3, t.createFactory = V8, t.createRef = W2, t.forwardRef = Xr, t.isValidElement = nt, t.lazy = X1, t.memo = J2, t.startTransition = s7, t.unstable_act = r4, t.useCallback = p5, t.useContext = H0, t.useDebugValue = j0, t.useDeferredValue = br, t.useEffect = Qt, t.useId = v3, t.useImperativeHandle = xr, t.useInsertionEffect = it, t.useLayoutEffect = ut, t.useMemo = Qr, t.useReducer = K0, t.useRef = W0, t.useState = P0, t.useSyncExternalStore = E3, t.useTransition = z0, t.version = r, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(Zl, Zl.exports)), Zl.exports;
  }
  var YD;
  function X9() {
    return YD || (YD = 1, process.env.NODE_ENV === "production" ? ud.exports = De2() : ud.exports = Le2()), ud.exports;
  }
  var q = X9();
  const f2 = /* @__PURE__ */ tt(q), wZ = /* @__PURE__ */ bZ({
    __proto__: null,
    default: f2
  }, [q]);
  var Uo = {}, ld = { exports: {} }, hr = {}, cd = { exports: {} }, Cy = {};
  /**
   * @license React
   * scheduler.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var $D;
  function ke2() {
    return $D || ($D = 1, function(e) {
      function t(X, a2) {
        var e2 = X.length;
        X.push(a2);
        e: for (; 0 < e2; ) {
          var H = e2 - 1 >>> 1, Y = X[H];
          if (0 < i(Y, a2)) X[H] = a2, X[e2] = Y, e2 = H;
          else break e;
        }
      }
      function r(X) {
        return X.length === 0 ? null : X[0];
      }
      function n(X) {
        if (X.length === 0) return null;
        var a2 = X[0], e2 = X.pop();
        if (e2 !== a2) {
          X[0] = e2;
          e: for (var H = 0, Y = X.length, r2 = Y >>> 1; H < r2; ) {
            var o2 = 2 * (H + 1) - 1, O2 = X[o2], S2 = o2 + 1, M2 = X[S2];
            if (0 > i(O2, e2)) S2 < Y && 0 > i(M2, O2) ? (X[H] = M2, X[S2] = e2, H = S2) : (X[H] = O2, X[o2] = e2, H = o2);
            else if (S2 < Y && 0 > i(M2, e2)) X[H] = M2, X[S2] = e2, H = S2;
            else break e;
          }
        }
        return a2;
      }
      function i(X, a2) {
        var e2 = X.sortIndex - a2.sortIndex;
        return e2 !== 0 ? e2 : X.id - a2.id;
      }
      if (typeof performance == "object" && typeof performance.now == "function") {
        var o = performance;
        e.unstable_now = function() {
          return o.now();
        };
      } else {
        var u = Date, c = u.now();
        e.unstable_now = function() {
          return u.now() - c;
        };
      }
      var f = [], d = [], g = 1, h = null, E = 3, y = !1, I = !1, Q = !1, B = typeof setTimeout == "function" ? setTimeout : null, _ = typeof clearTimeout == "function" ? clearTimeout : null, M = typeof setImmediate < "u" ? setImmediate : null;
      typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
      function S(X) {
        for (var a2 = r(d); a2 !== null; ) {
          if (a2.callback === null) n(d);
          else if (a2.startTime <= X) n(d), a2.sortIndex = a2.expirationTime, t(f, a2);
          else break;
          a2 = r(d);
        }
      }
      function O(X) {
        if (Q = !1, S(X), !I) if (r(f) !== null) I = !0, s2(w);
        else {
          var a2 = r(d);
          a2 !== null && l2(O, a2.startTime - X);
        }
      }
      function w(X, a2) {
        I = !1, Q && (Q = !1, _(F), F = -1), y = !0;
        var e2 = E;
        try {
          for (S(a2), h = r(f); h !== null && (!(h.expirationTime > a2) || X && !V()); ) {
            var H = h.callback;
            if (typeof H == "function") {
              h.callback = null, E = h.priorityLevel;
              var Y = H(h.expirationTime <= a2);
              a2 = e.unstable_now(), typeof Y == "function" ? h.callback = Y : h === r(f) && n(f), S(a2);
            } else n(f);
            h = r(f);
          }
          if (h !== null) var r2 = !0;
          else {
            var o2 = r(d);
            o2 !== null && l2(O, o2.startTime - a2), r2 = !1;
          }
          return r2;
        } finally {
          h = null, E = e2, y = !1;
        }
      }
      var D = !1, k = null, F = -1, z = 5, Z = -1;
      function V() {
        return !(e.unstable_now() - Z < z);
      }
      function $() {
        if (k !== null) {
          var X = e.unstable_now();
          Z = X;
          var a2 = !0;
          try {
            a2 = k(!0, X);
          } finally {
            a2 ? W() : (D = !1, k = null);
          }
        } else D = !1;
      }
      var W;
      if (typeof M == "function") W = function() {
        M($);
      };
      else if (typeof MessageChannel < "u") {
        var t2 = new MessageChannel(), n2 = t2.port2;
        t2.port1.onmessage = $, W = function() {
          n2.postMessage(null);
        };
      } else W = function() {
        B($, 0);
      };
      function s2(X) {
        k = X, D || (D = !0, W());
      }
      function l2(X, a2) {
        F = B(function() {
          X(e.unstable_now());
        }, a2);
      }
      e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(X) {
        X.callback = null;
      }, e.unstable_continueExecution = function() {
        I || y || (I = !0, s2(w));
      }, e.unstable_forceFrameRate = function(X) {
        0 > X || 125 < X ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : z = 0 < X ? Math.floor(1e3 / X) : 5;
      }, e.unstable_getCurrentPriorityLevel = function() {
        return E;
      }, e.unstable_getFirstCallbackNode = function() {
        return r(f);
      }, e.unstable_next = function(X) {
        switch (E) {
          case 1:
          case 2:
          case 3:
            var a2 = 3;
            break;
          default:
            a2 = E;
        }
        var e2 = E;
        E = a2;
        try {
          return X();
        } finally {
          E = e2;
        }
      }, e.unstable_pauseExecution = function() {
      }, e.unstable_requestPaint = function() {
      }, e.unstable_runWithPriority = function(X, a2) {
        switch (X) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            X = 3;
        }
        var e2 = E;
        E = X;
        try {
          return a2();
        } finally {
          E = e2;
        }
      }, e.unstable_scheduleCallback = function(X, a2, e2) {
        var H = e.unstable_now();
        switch (typeof e2 == "object" && e2 !== null ? (e2 = e2.delay, e2 = typeof e2 == "number" && 0 < e2 ? H + e2 : H) : e2 = H, X) {
          case 1:
            var Y = -1;
            break;
          case 2:
            Y = 250;
            break;
          case 5:
            Y = 1073741823;
            break;
          case 4:
            Y = 1e4;
            break;
          default:
            Y = 5e3;
        }
        return Y = e2 + Y, X = { id: g++, callback: a2, priorityLevel: X, startTime: e2, expirationTime: Y, sortIndex: -1 }, e2 > H ? (X.sortIndex = e2, t(d, X), r(f) === null && X === r(d) && (Q ? (_(F), F = -1) : Q = !0, l2(O, e2 - H))) : (X.sortIndex = Y, t(f, X), I || y || (I = !0, s2(w))), X;
      }, e.unstable_shouldYield = V, e.unstable_wrapCallback = function(X) {
        var a2 = E;
        return function() {
          var e2 = E;
          E = a2;
          try {
            return X.apply(this, arguments);
          } finally {
            E = e2;
          }
        };
      };
    }(Cy)), Cy;
  }
  var dy = {};
  /**
   * @license React
   * scheduler.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var GD;
  function Re2() {
    return GD || (GD = 1, function(e) {
      process.env.NODE_ENV !== "production" && function() {
        typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
        var t = !1, r = 5;
        function n(Y2, c0) {
          var k0 = Y2.length;
          Y2.push(c0), u(Y2, c0, k0);
        }
        function i(Y2) {
          return Y2.length === 0 ? null : Y2[0];
        }
        function o(Y2) {
          if (Y2.length === 0)
            return null;
          var c0 = Y2[0], k0 = Y2.pop();
          return k0 !== c0 && (Y2[0] = k0, c(Y2, k0, 0)), c0;
        }
        function u(Y2, c0, k0) {
          for (var fe = k0; fe > 0; ) {
            var De = fe - 1 >>> 1, nt = Y2[De];
            if (f(nt, c0) > 0)
              Y2[De] = c0, Y2[fe] = nt, fe = De;
            else
              return;
          }
        }
        function c(Y2, c0, k0) {
          for (var fe = k0, De = Y2.length, nt = De >>> 1; fe < nt; ) {
            var Ke = (fe + 1) * 2 - 1, kt = Y2[Ke], Le = Ke + 1, be = Y2[Le];
            if (f(kt, c0) < 0)
              Le < De && f(be, kt) < 0 ? (Y2[fe] = be, Y2[Le] = c0, fe = Le) : (Y2[fe] = kt, Y2[Ke] = c0, fe = Ke);
            else if (Le < De && f(be, c0) < 0)
              Y2[fe] = be, Y2[Le] = c0, fe = Le;
            else
              return;
          }
        }
        function f(Y2, c0) {
          var k0 = Y2.sortIndex - c0.sortIndex;
          return k0 !== 0 ? k0 : Y2.id - c0.id;
        }
        var d = 1, g = 2, h = 3, E = 4, y = 5;
        function I(Y2, c0) {
        }
        var Q = typeof performance == "object" && typeof performance.now == "function";
        if (Q) {
          var B = performance;
          e.unstable_now = function() {
            return B.now();
          };
        } else {
          var _ = Date, M = _.now();
          e.unstable_now = function() {
            return _.now() - M;
          };
        }
        var S = 1073741823, O = -1, w = 250, D = 5e3, k = 1e4, F = S, z = [], Z = [], V = 1, $ = null, W = h, t2 = !1, n2 = !1, s2 = !1, l2 = typeof setTimeout == "function" ? setTimeout : null, X = typeof clearTimeout == "function" ? clearTimeout : null, a2 = typeof setImmediate < "u" ? setImmediate : null;
        typeof navigator < "u" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
        function e2(Y2) {
          for (var c0 = i(Z); c0 !== null; ) {
            if (c0.callback === null)
              o(Z);
            else if (c0.startTime <= Y2)
              o(Z), c0.sortIndex = c0.expirationTime, n(z, c0);
            else
              return;
            c0 = i(Z);
          }
        }
        function H(Y2) {
          if (s2 = !1, e2(Y2), !n2)
            if (i(z) !== null)
              n2 = !0, Ge(Y);
            else {
              var c0 = i(Z);
              c0 !== null && rt(H, c0.startTime - Y2);
            }
        }
        function Y(Y2, c0) {
          n2 = !1, s2 && (s2 = !1, yt()), t2 = !0;
          var k0 = W;
          try {
            var fe;
            if (!t) return r2(Y2, c0);
          } finally {
            $ = null, W = k0, t2 = !1;
          }
        }
        function r2(Y2, c0) {
          var k0 = c0;
          for (e2(k0), $ = i(z); $ !== null && !($.expirationTime > k0 && (!Y2 || $e())); ) {
            var fe = $.callback;
            if (typeof fe == "function") {
              $.callback = null, W = $.priorityLevel;
              var De = $.expirationTime <= k0, nt = fe(De);
              k0 = e.unstable_now(), typeof nt == "function" ? $.callback = nt : $ === i(z) && o(z), e2(k0);
            } else
              o(z);
            $ = i(z);
          }
          if ($ !== null)
            return !0;
          var Ke = i(Z);
          return Ke !== null && rt(H, Ke.startTime - k0), !1;
        }
        function o2(Y2, c0) {
          switch (Y2) {
            case d:
            case g:
            case h:
            case E:
            case y:
              break;
            default:
              Y2 = h;
          }
          var k0 = W;
          W = Y2;
          try {
            return c0();
          } finally {
            W = k0;
          }
        }
        function O2(Y2) {
          var c0;
          switch (W) {
            case d:
            case g:
            case h:
              c0 = h;
              break;
            default:
              c0 = W;
              break;
          }
          var k0 = W;
          W = c0;
          try {
            return Y2();
          } finally {
            W = k0;
          }
        }
        function S2(Y2) {
          var c0 = W;
          return function() {
            var k0 = W;
            W = c0;
            try {
              return Y2.apply(this, arguments);
            } finally {
              W = k0;
            }
          };
        }
        function M2(Y2, c0, k0) {
          var fe = e.unstable_now(), De;
          if (typeof k0 == "object" && k0 !== null) {
            var nt = k0.delay;
            typeof nt == "number" && nt > 0 ? De = fe + nt : De = fe;
          } else
            De = fe;
          var Ke;
          switch (Y2) {
            case d:
              Ke = O;
              break;
            case g:
              Ke = w;
              break;
            case y:
              Ke = F;
              break;
            case E:
              Ke = k;
              break;
            case h:
            default:
              Ke = D;
              break;
          }
          var kt = De + Ke, Le = {
            id: V++,
            callback: c0,
            priorityLevel: Y2,
            startTime: De,
            expirationTime: kt,
            sortIndex: -1
          };
          return De > fe ? (Le.sortIndex = De, n(Z, Le), i(z) === null && Le === i(Z) && (s2 ? yt() : s2 = !0, rt(H, De - fe))) : (Le.sortIndex = kt, n(z, Le), !n2 && !t2 && (n2 = !0, Ge(Y))), Le;
        }
        function w2() {
        }
        function v2() {
          !n2 && !t2 && (n2 = !0, Ge(Y));
        }
        function L2() {
          return i(z);
        }
        function W2(Y2) {
          Y2.callback = null;
        }
        function d2() {
          return W;
        }
        var X2 = !1, k2 = null, b0 = -1, S0 = r, G0 = -1;
        function $e() {
          var Y2 = e.unstable_now() - G0;
          return !(Y2 < S0);
        }
        function _e() {
        }
        function Oe(Y2) {
          if (Y2 < 0 || Y2 > 125) {
            console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported");
            return;
          }
          Y2 > 0 ? S0 = Math.floor(1e3 / Y2) : S0 = r;
        }
        var U0 = function() {
          if (k2 !== null) {
            var Y2 = e.unstable_now();
            G0 = Y2;
            var c0 = !0, k0 = !0;
            try {
              k0 = k2(c0, Y2);
            } finally {
              k0 ? Z0() : (X2 = !1, k2 = null);
            }
          } else
            X2 = !1;
        }, Z0;
        if (typeof a2 == "function")
          Z0 = function() {
            a2(U0);
          };
        else if (typeof MessageChannel < "u") {
          var Te = new MessageChannel(), Lt = Te.port2;
          Te.port1.onmessage = U0, Z0 = function() {
            Lt.postMessage(null);
          };
        } else
          Z0 = function() {
            l2(U0, 0);
          };
        function Ge(Y2) {
          k2 = Y2, X2 || (X2 = !0, Z0());
        }
        function rt(Y2, c0) {
          b0 = l2(function() {
            Y2(e.unstable_now());
          }, c0);
        }
        function yt() {
          X(b0), b0 = -1;
        }
        var D1 = _e, L1 = null;
        e.unstable_IdlePriority = y, e.unstable_ImmediatePriority = d, e.unstable_LowPriority = E, e.unstable_NormalPriority = h, e.unstable_Profiling = L1, e.unstable_UserBlockingPriority = g, e.unstable_cancelCallback = W2, e.unstable_continueExecution = v2, e.unstable_forceFrameRate = Oe, e.unstable_getCurrentPriorityLevel = d2, e.unstable_getFirstCallbackNode = L2, e.unstable_next = O2, e.unstable_pauseExecution = w2, e.unstable_requestPaint = D1, e.unstable_runWithPriority = o2, e.unstable_scheduleCallback = M2, e.unstable_shouldYield = $e, e.unstable_wrapCallback = S2, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
      }();
    }(dy)), dy;
  }
  var KD;
  function SZ() {
    return KD || (KD = 1, process.env.NODE_ENV === "production" ? cd.exports = ke2() : cd.exports = Re2()), cd.exports;
  }
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var XD;
  function Pe2() {
    if (XD) return hr;
    XD = 1;
    var e = X9(), t = SZ();
    function r(l) {
      for (var A = "https://reactjs.org/docs/error-decoder.html?invariant=" + l, v = 1; v < arguments.length; v++) A += "&args[]=" + encodeURIComponent(arguments[v]);
      return "Minified React error #" + l + "; visit " + A + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    var n = /* @__PURE__ */ new Set(), i = {};
    function o(l, A) {
      u(l, A), u(l + "Capture", A);
    }
    function u(l, A) {
      for (i[l] = A, l = 0; l < A.length; l++) n.add(A[l]);
    }
    var c = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), f = Object.prototype.hasOwnProperty, d = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, g = {}, h = {};
    function E(l) {
      return f.call(h, l) ? !0 : f.call(g, l) ? !1 : d.test(l) ? h[l] = !0 : (g[l] = !0, !1);
    }
    function y(l, A, v, x) {
      if (v !== null && v.type === 0) return !1;
      switch (typeof A) {
        case "function":
        case "symbol":
          return !0;
        case "boolean":
          return x ? !1 : v !== null ? !v.acceptsBooleans : (l = l.toLowerCase().slice(0, 5), l !== "data-" && l !== "aria-");
        default:
          return !1;
      }
    }
    function I(l, A, v, x) {
      if (A === null || typeof A > "u" || y(l, A, v, x)) return !0;
      if (x) return !1;
      if (v !== null) switch (v.type) {
        case 3:
          return !A;
        case 4:
          return A === !1;
        case 5:
          return isNaN(A);
        case 6:
          return isNaN(A) || 1 > A;
      }
      return !1;
    }
    function Q(l, A, v, x, T, R, U) {
      this.acceptsBooleans = A === 2 || A === 3 || A === 4, this.attributeName = x, this.attributeNamespace = T, this.mustUseProperty = v, this.propertyName = l, this.type = A, this.sanitizeURL = R, this.removeEmptyString = U;
    }
    var B = {};
    "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(l) {
      B[l] = new Q(l, 0, !1, l, null, !1, !1);
    }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(l) {
      var A = l[0];
      B[A] = new Q(A, 1, !1, l[1], null, !1, !1);
    }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(l) {
      B[l] = new Q(l, 2, !1, l.toLowerCase(), null, !1, !1);
    }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(l) {
      B[l] = new Q(l, 2, !1, l, null, !1, !1);
    }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(l) {
      B[l] = new Q(l, 3, !1, l.toLowerCase(), null, !1, !1);
    }), ["checked", "multiple", "muted", "selected"].forEach(function(l) {
      B[l] = new Q(l, 3, !0, l, null, !1, !1);
    }), ["capture", "download"].forEach(function(l) {
      B[l] = new Q(l, 4, !1, l, null, !1, !1);
    }), ["cols", "rows", "size", "span"].forEach(function(l) {
      B[l] = new Q(l, 6, !1, l, null, !1, !1);
    }), ["rowSpan", "start"].forEach(function(l) {
      B[l] = new Q(l, 5, !1, l.toLowerCase(), null, !1, !1);
    });
    var _ = /[\-:]([a-z])/g;
    function M(l) {
      return l[1].toUpperCase();
    }
    "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(l) {
      var A = l.replace(
        _,
        M
      );
      B[A] = new Q(A, 1, !1, l, null, !1, !1);
    }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(l) {
      var A = l.replace(_, M);
      B[A] = new Q(A, 1, !1, l, "http://www.w3.org/1999/xlink", !1, !1);
    }), ["xml:base", "xml:lang", "xml:space"].forEach(function(l) {
      var A = l.replace(_, M);
      B[A] = new Q(A, 1, !1, l, "http://www.w3.org/XML/1998/namespace", !1, !1);
    }), ["tabIndex", "crossOrigin"].forEach(function(l) {
      B[l] = new Q(l, 1, !1, l.toLowerCase(), null, !1, !1);
    }), B.xlinkHref = new Q("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(l) {
      B[l] = new Q(l, 1, !1, l.toLowerCase(), null, !0, !0);
    });
    function S(l, A, v, x) {
      var T = B.hasOwnProperty(A) ? B[A] : null;
      (T !== null ? T.type !== 0 : x || !(2 < A.length) || A[0] !== "o" && A[0] !== "O" || A[1] !== "n" && A[1] !== "N") && (I(A, v, T, x) && (v = null), x || T === null ? E(A) && (v === null ? l.removeAttribute(A) : l.setAttribute(A, "" + v)) : T.mustUseProperty ? l[T.propertyName] = v === null ? T.type === 3 ? !1 : "" : v : (A = T.attributeName, x = T.attributeNamespace, v === null ? l.removeAttribute(A) : (T = T.type, v = T === 3 || T === 4 && v === !0 ? "" : "" + v, x ? l.setAttributeNS(x, A, v) : l.setAttribute(A, v))));
    }
    var O = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, w = Symbol.for("react.element"), D = Symbol.for("react.portal"), k = Symbol.for("react.fragment"), F = Symbol.for("react.strict_mode"), z = Symbol.for("react.profiler"), Z = Symbol.for("react.provider"), V = Symbol.for("react.context"), $ = Symbol.for("react.forward_ref"), W = Symbol.for("react.suspense"), t2 = Symbol.for("react.suspense_list"), n2 = Symbol.for("react.memo"), s2 = Symbol.for("react.lazy"), l2 = Symbol.for("react.offscreen"), X = Symbol.iterator;
    function a2(l) {
      return l === null || typeof l != "object" ? null : (l = X && l[X] || l["@@iterator"], typeof l == "function" ? l : null);
    }
    var e2 = Object.assign, H;
    function Y(l) {
      if (H === void 0) try {
        throw Error();
      } catch (v) {
        var A = v.stack.trim().match(/\n( *(at )?)/);
        H = A && A[1] || "";
      }
      return `
` + H + l;
    }
    var r2 = !1;
    function o2(l, A) {
      if (!l || r2) return "";
      r2 = !0;
      var v = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      try {
        if (A) if (A = function() {
          throw Error();
        }, Object.defineProperty(A.prototype, "props", { set: function() {
          throw Error();
        } }), typeof Reflect == "object" && Reflect.construct) {
          try {
            Reflect.construct(A, []);
          } catch (x2) {
            var x = x2;
          }
          Reflect.construct(l, [], A);
        } else {
          try {
            A.call();
          } catch (x2) {
            x = x2;
          }
          l.call(A.prototype);
        }
        else {
          try {
            throw Error();
          } catch (x2) {
            x = x2;
          }
          l();
        }
      } catch (x2) {
        if (x2 && x && typeof x2.stack == "string") {
          for (var T = x2.stack.split(`
`), R = x.stack.split(`
`), U = T.length - 1, i2 = R.length - 1; 1 <= U && 0 <= i2 && T[U] !== R[i2]; ) i2--;
          for (; 1 <= U && 0 <= i2; U--, i2--) if (T[U] !== R[i2]) {
            if (U !== 1 || i2 !== 1)
              do
                if (U--, i2--, 0 > i2 || T[U] !== R[i2]) {
                  var A2 = `
` + T[U].replace(" at new ", " at ");
                  return l.displayName && A2.includes("<anonymous>") && (A2 = A2.replace("<anonymous>", l.displayName)), A2;
                }
              while (1 <= U && 0 <= i2);
            break;
          }
        }
      } finally {
        r2 = !1, Error.prepareStackTrace = v;
      }
      return (l = l ? l.displayName || l.name : "") ? Y(l) : "";
    }
    function O2(l) {
      switch (l.tag) {
        case 5:
          return Y(l.type);
        case 16:
          return Y("Lazy");
        case 13:
          return Y("Suspense");
        case 19:
          return Y("SuspenseList");
        case 0:
        case 2:
        case 15:
          return l = o2(l.type, !1), l;
        case 11:
          return l = o2(l.type.render, !1), l;
        case 1:
          return l = o2(l.type, !0), l;
        default:
          return "";
      }
    }
    function S2(l) {
      if (l == null) return null;
      if (typeof l == "function") return l.displayName || l.name || null;
      if (typeof l == "string") return l;
      switch (l) {
        case k:
          return "Fragment";
        case D:
          return "Portal";
        case z:
          return "Profiler";
        case F:
          return "StrictMode";
        case W:
          return "Suspense";
        case t2:
          return "SuspenseList";
      }
      if (typeof l == "object") switch (l.$$typeof) {
        case V:
          return (l.displayName || "Context") + ".Consumer";
        case Z:
          return (l._context.displayName || "Context") + ".Provider";
        case $:
          var A = l.render;
          return l = l.displayName, l || (l = A.displayName || A.name || "", l = l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef"), l;
        case n2:
          return A = l.displayName || null, A !== null ? A : S2(l.type) || "Memo";
        case s2:
          A = l._payload, l = l._init;
          try {
            return S2(l(A));
          } catch {
          }
      }
      return null;
    }
    function M2(l) {
      var A = l.type;
      switch (l.tag) {
        case 24:
          return "Cache";
        case 9:
          return (A.displayName || "Context") + ".Consumer";
        case 10:
          return (A._context.displayName || "Context") + ".Provider";
        case 18:
          return "DehydratedFragment";
        case 11:
          return l = A.render, l = l.displayName || l.name || "", A.displayName || (l !== "" ? "ForwardRef(" + l + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 5:
          return A;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return S2(A);
        case 8:
          return A === F ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
          if (typeof A == "function") return A.displayName || A.name || null;
          if (typeof A == "string") return A;
      }
      return null;
    }
    function w2(l) {
      switch (typeof l) {
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return l;
        case "object":
          return l;
        default:
          return "";
      }
    }
    function v2(l) {
      var A = l.type;
      return (l = l.nodeName) && l.toLowerCase() === "input" && (A === "checkbox" || A === "radio");
    }
    function L2(l) {
      var A = v2(l) ? "checked" : "value", v = Object.getOwnPropertyDescriptor(l.constructor.prototype, A), x = "" + l[A];
      if (!l.hasOwnProperty(A) && typeof v < "u" && typeof v.get == "function" && typeof v.set == "function") {
        var T = v.get, R = v.set;
        return Object.defineProperty(l, A, { configurable: !0, get: function() {
          return T.call(this);
        }, set: function(U) {
          x = "" + U, R.call(this, U);
        } }), Object.defineProperty(l, A, { enumerable: v.enumerable }), { getValue: function() {
          return x;
        }, setValue: function(U) {
          x = "" + U;
        }, stopTracking: function() {
          l._valueTracker = null, delete l[A];
        } };
      }
    }
    function W2(l) {
      l._valueTracker || (l._valueTracker = L2(l));
    }
    function d2(l) {
      if (!l) return !1;
      var A = l._valueTracker;
      if (!A) return !0;
      var v = A.getValue(), x = "";
      return l && (x = v2(l) ? l.checked ? "true" : "false" : l.value), l = x, l !== v ? (A.setValue(l), !0) : !1;
    }
    function X2(l) {
      if (l = l || (typeof document < "u" ? document : void 0), typeof l > "u") return null;
      try {
        return l.activeElement || l.body;
      } catch {
        return l.body;
      }
    }
    function k2(l, A) {
      var v = A.checked;
      return e2({}, A, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: v ?? l._wrapperState.initialChecked });
    }
    function b0(l, A) {
      var v = A.defaultValue == null ? "" : A.defaultValue, x = A.checked != null ? A.checked : A.defaultChecked;
      v = w2(A.value != null ? A.value : v), l._wrapperState = { initialChecked: x, initialValue: v, controlled: A.type === "checkbox" || A.type === "radio" ? A.checked != null : A.value != null };
    }
    function S0(l, A) {
      A = A.checked, A != null && S(l, "checked", A, !1);
    }
    function G0(l, A) {
      S0(l, A);
      var v = w2(A.value), x = A.type;
      if (v != null) x === "number" ? (v === 0 && l.value === "" || l.value != v) && (l.value = "" + v) : l.value !== "" + v && (l.value = "" + v);
      else if (x === "submit" || x === "reset") {
        l.removeAttribute("value");
        return;
      }
      A.hasOwnProperty("value") ? _e(l, A.type, v) : A.hasOwnProperty("defaultValue") && _e(l, A.type, w2(A.defaultValue)), A.checked == null && A.defaultChecked != null && (l.defaultChecked = !!A.defaultChecked);
    }
    function $e(l, A, v) {
      if (A.hasOwnProperty("value") || A.hasOwnProperty("defaultValue")) {
        var x = A.type;
        if (!(x !== "submit" && x !== "reset" || A.value !== void 0 && A.value !== null)) return;
        A = "" + l._wrapperState.initialValue, v || A === l.value || (l.value = A), l.defaultValue = A;
      }
      v = l.name, v !== "" && (l.name = ""), l.defaultChecked = !!l._wrapperState.initialChecked, v !== "" && (l.name = v);
    }
    function _e(l, A, v) {
      (A !== "number" || X2(l.ownerDocument) !== l) && (v == null ? l.defaultValue = "" + l._wrapperState.initialValue : l.defaultValue !== "" + v && (l.defaultValue = "" + v));
    }
    var Oe = Array.isArray;
    function U0(l, A, v, x) {
      if (l = l.options, A) {
        A = {};
        for (var T = 0; T < v.length; T++) A["$" + v[T]] = !0;
        for (v = 0; v < l.length; v++) T = A.hasOwnProperty("$" + l[v].value), l[v].selected !== T && (l[v].selected = T), T && x && (l[v].defaultSelected = !0);
      } else {
        for (v = "" + w2(v), A = null, T = 0; T < l.length; T++) {
          if (l[T].value === v) {
            l[T].selected = !0, x && (l[T].defaultSelected = !0);
            return;
          }
          A !== null || l[T].disabled || (A = l[T]);
        }
        A !== null && (A.selected = !0);
      }
    }
    function Z0(l, A) {
      if (A.dangerouslySetInnerHTML != null) throw Error(r(91));
      return e2({}, A, { value: void 0, defaultValue: void 0, children: "" + l._wrapperState.initialValue });
    }
    function Te(l, A) {
      var v = A.value;
      if (v == null) {
        if (v = A.children, A = A.defaultValue, v != null) {
          if (A != null) throw Error(r(92));
          if (Oe(v)) {
            if (1 < v.length) throw Error(r(93));
            v = v[0];
          }
          A = v;
        }
        A == null && (A = ""), v = A;
      }
      l._wrapperState = { initialValue: w2(v) };
    }
    function Lt(l, A) {
      var v = w2(A.value), x = w2(A.defaultValue);
      v != null && (v = "" + v, v !== l.value && (l.value = v), A.defaultValue == null && l.defaultValue !== v && (l.defaultValue = v)), x != null && (l.defaultValue = "" + x);
    }
    function Ge(l) {
      var A = l.textContent;
      A === l._wrapperState.initialValue && A !== "" && A !== null && (l.value = A);
    }
    function rt(l) {
      switch (l) {
        case "svg":
          return "http://www.w3.org/2000/svg";
        case "math":
          return "http://www.w3.org/1998/Math/MathML";
        default:
          return "http://www.w3.org/1999/xhtml";
      }
    }
    function yt(l, A) {
      return l == null || l === "http://www.w3.org/1999/xhtml" ? rt(A) : l === "http://www.w3.org/2000/svg" && A === "foreignObject" ? "http://www.w3.org/1999/xhtml" : l;
    }
    var D1, L1 = function(l) {
      return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(A, v, x, T) {
        MSApp.execUnsafeLocalFunction(function() {
          return l(A, v, x, T);
        });
      } : l;
    }(function(l, A) {
      if (l.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in l) l.innerHTML = A;
      else {
        for (D1 = D1 || document.createElement("div"), D1.innerHTML = "<svg>" + A.valueOf().toString() + "</svg>", A = D1.firstChild; l.firstChild; ) l.removeChild(l.firstChild);
        for (; A.firstChild; ) l.appendChild(A.firstChild);
      }
    });
    function Y2(l, A) {
      if (A) {
        var v = l.firstChild;
        if (v && v === l.lastChild && v.nodeType === 3) {
          v.nodeValue = A;
          return;
        }
      }
      l.textContent = A;
    }
    var c0 = {
      animationIterationCount: !0,
      aspectRatio: !0,
      borderImageOutset: !0,
      borderImageSlice: !0,
      borderImageWidth: !0,
      boxFlex: !0,
      boxFlexGroup: !0,
      boxOrdinalGroup: !0,
      columnCount: !0,
      columns: !0,
      flex: !0,
      flexGrow: !0,
      flexPositive: !0,
      flexShrink: !0,
      flexNegative: !0,
      flexOrder: !0,
      gridArea: !0,
      gridRow: !0,
      gridRowEnd: !0,
      gridRowSpan: !0,
      gridRowStart: !0,
      gridColumn: !0,
      gridColumnEnd: !0,
      gridColumnSpan: !0,
      gridColumnStart: !0,
      fontWeight: !0,
      lineClamp: !0,
      lineHeight: !0,
      opacity: !0,
      order: !0,
      orphans: !0,
      tabSize: !0,
      widows: !0,
      zIndex: !0,
      zoom: !0,
      fillOpacity: !0,
      floodOpacity: !0,
      stopOpacity: !0,
      strokeDasharray: !0,
      strokeDashoffset: !0,
      strokeMiterlimit: !0,
      strokeOpacity: !0,
      strokeWidth: !0
    }, k0 = ["Webkit", "ms", "Moz", "O"];
    Object.keys(c0).forEach(function(l) {
      k0.forEach(function(A) {
        A = A + l.charAt(0).toUpperCase() + l.substring(1), c0[A] = c0[l];
      });
    });
    function fe(l, A, v) {
      return A == null || typeof A == "boolean" || A === "" ? "" : v || typeof A != "number" || A === 0 || c0.hasOwnProperty(l) && c0[l] ? ("" + A).trim() : A + "px";
    }
    function De(l, A) {
      l = l.style;
      for (var v in A) if (A.hasOwnProperty(v)) {
        var x = v.indexOf("--") === 0, T = fe(v, A[v], x);
        v === "float" && (v = "cssFloat"), x ? l.setProperty(v, T) : l[v] = T;
      }
    }
    var nt = e2({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
    function Ke(l, A) {
      if (A) {
        if (nt[l] && (A.children != null || A.dangerouslySetInnerHTML != null)) throw Error(r(137, l));
        if (A.dangerouslySetInnerHTML != null) {
          if (A.children != null) throw Error(r(60));
          if (typeof A.dangerouslySetInnerHTML != "object" || !("__html" in A.dangerouslySetInnerHTML)) throw Error(r(61));
        }
        if (A.style != null && typeof A.style != "object") throw Error(r(62));
      }
    }
    function kt(l, A) {
      if (l.indexOf("-") === -1) return typeof A.is == "string";
      switch (l) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return !1;
        default:
          return !0;
      }
    }
    var Le = null;
    function be(l) {
      return l = l.target || l.srcElement || window, l.correspondingUseElement && (l = l.correspondingUseElement), l.nodeType === 3 ? l.parentNode : l;
    }
    var Qe = null, Z5 = null, Gt = null;
    function c1(l) {
      if (l = I0(l)) {
        if (typeof Qe != "function") throw Error(r(280));
        var A = l.stateNode;
        A && (A = xt(A), Qe(l.stateNode, l.type, A));
      }
    }
    function Br(l) {
      Z5 ? Gt ? Gt.push(l) : Gt = [l] : Z5 = l;
    }
    function T4() {
      if (Z5) {
        var l = Z5, A = Gt;
        if (Gt = Z5 = null, c1(l), A) for (l = 0; l < A.length; l++) c1(A[l]);
      }
    }
    function Yr(l, A) {
      return l(A);
    }
    function $r() {
    }
    var Gr = !1;
    function Kr(l, A, v) {
      if (Gr) return l(A, v);
      Gr = !0;
      try {
        return Yr(l, A, v);
      } finally {
        Gr = !1, (Z5 !== null || Gt !== null) && ($r(), T4());
      }
    }
    function g5(l, A) {
      var v = l.stateNode;
      if (v === null) return null;
      var x = xt(v);
      if (x === null) return null;
      v = x[A];
      e: switch (A) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (x = !x.disabled) || (l = l.type, x = !(l === "button" || l === "input" || l === "select" || l === "textarea")), l = !x;
          break e;
        default:
          l = !1;
      }
      if (l) return null;
      if (v && typeof v != "function") throw Error(r(231, A, typeof v));
      return v;
    }
    var o5 = !1;
    if (c) try {
      var xe = {};
      Object.defineProperty(xe, "passive", { get: function() {
        o5 = !0;
      } }), window.addEventListener("test", xe, xe), window.removeEventListener("test", xe, xe);
    } catch {
      o5 = !1;
    }
    function Kt(l, A, v, x, T, R, U, i2, A2) {
      var x2 = Array.prototype.slice.call(arguments, 3);
      try {
        A.apply(v, x2);
      } catch (V2) {
        this.onError(V2);
      }
    }
    var A1 = !1, X1 = null, Xr = !1, c2 = null, N2 = { onError: function(l) {
      A1 = !0, X1 = l;
    } };
    function J2(l, A, v, x, T, R, U, i2, A2) {
      A1 = !1, X1 = null, Kt.apply(N2, arguments);
    }
    function l0(l, A, v, x, T, R, U, i2, A2) {
      if (J2.apply(this, arguments), A1) {
        if (A1) {
          var x2 = X1;
          A1 = !1, X1 = null;
        } else throw Error(r(198));
        Xr || (Xr = !0, c2 = x2);
      }
    }
    function H0(l) {
      var A = l, v = l;
      if (l.alternate) for (; A.return; ) A = A.return;
      else {
        l = A;
        do
          A = l, (A.flags & 4098) !== 0 && (v = A.return), l = A.return;
        while (l);
      }
      return A.tag === 3 ? v : null;
    }
    function P0(l) {
      if (l.tag === 13) {
        var A = l.memoizedState;
        if (A === null && (l = l.alternate, l !== null && (A = l.memoizedState)), A !== null) return A.dehydrated;
      }
      return null;
    }
    function K0(l) {
      if (H0(l) !== l) throw Error(r(188));
    }
    function W0(l) {
      var A = l.alternate;
      if (!A) {
        if (A = H0(l), A === null) throw Error(r(188));
        return A !== l ? null : l;
      }
      for (var v = l, x = A; ; ) {
        var T = v.return;
        if (T === null) break;
        var R = T.alternate;
        if (R === null) {
          if (x = T.return, x !== null) {
            v = x;
            continue;
          }
          break;
        }
        if (T.child === R.child) {
          for (R = T.child; R; ) {
            if (R === v) return K0(T), l;
            if (R === x) return K0(T), A;
            R = R.sibling;
          }
          throw Error(r(188));
        }
        if (v.return !== x.return) v = T, x = R;
        else {
          for (var U = !1, i2 = T.child; i2; ) {
            if (i2 === v) {
              U = !0, v = T, x = R;
              break;
            }
            if (i2 === x) {
              U = !0, x = T, v = R;
              break;
            }
            i2 = i2.sibling;
          }
          if (!U) {
            for (i2 = R.child; i2; ) {
              if (i2 === v) {
                U = !0, v = R, x = T;
                break;
              }
              if (i2 === x) {
                U = !0, x = R, v = T;
                break;
              }
              i2 = i2.sibling;
            }
            if (!U) throw Error(r(189));
          }
        }
        if (v.alternate !== x) throw Error(r(190));
      }
      if (v.tag !== 3) throw Error(r(188));
      return v.stateNode.current === v ? l : A;
    }
    function Qt(l) {
      return l = W0(l), l !== null ? it(l) : null;
    }
    function it(l) {
      if (l.tag === 5 || l.tag === 6) return l;
      for (l = l.child; l !== null; ) {
        var A = it(l);
        if (A !== null) return A;
        l = l.sibling;
      }
      return null;
    }
    var ut = t.unstable_scheduleCallback, p5 = t.unstable_cancelCallback, Qr = t.unstable_shouldYield, xr = t.unstable_requestPaint, j0 = t.unstable_now, z0 = t.unstable_getCurrentPriorityLevel, br = t.unstable_ImmediatePriority, v3 = t.unstable_UserBlockingPriority, E3 = t.unstable_NormalPriority, yn = t.unstable_LowPriority, T8 = t.unstable_IdlePriority, In = null, f1 = null;
    function i7(l) {
      if (f1 && typeof f1.onCommitFiberRoot == "function") try {
        f1.onCommitFiberRoot(In, l, void 0, (l.current.flags & 128) === 128);
      } catch {
      }
    }
    var z5 = Math.clz32 ? Math.clz32 : D8, aa = Math.log, oa = Math.LN2;
    function D8(l) {
      return l >>>= 0, l === 0 ? 32 : 31 - (aa(l) / oa | 0) | 0;
    }
    var Bn = 64, k1 = 4194304;
    function wr(l) {
      switch (l & -l) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return l & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return l & 130023424;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 1073741824;
        default:
          return l;
      }
    }
    function Sr(l, A) {
      var v = l.pendingLanes;
      if (v === 0) return 0;
      var x = 0, T = l.suspendedLanes, R = l.pingedLanes, U = v & 268435455;
      if (U !== 0) {
        var i2 = U & ~T;
        i2 !== 0 ? x = wr(i2) : (R &= U, R !== 0 && (x = wr(R)));
      } else U = v & ~T, U !== 0 ? x = wr(U) : R !== 0 && (x = wr(R));
      if (x === 0) return 0;
      if (A !== 0 && A !== x && (A & T) === 0 && (T = x & -x, R = A & -A, T >= R || T === 16 && (R & 4194240) !== 0)) return A;
      if ((x & 4) !== 0 && (x |= v & 16), A = l.entangledLanes, A !== 0) for (l = l.entanglements, A &= x; 0 < A; ) v = 31 - z5(A), T = 1 << v, x |= l[v], A &= ~T;
      return x;
    }
    function L8(l, A) {
      switch (l) {
        case 1:
        case 2:
        case 4:
          return A + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return A + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
          return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return -1;
      }
    }
    function m3(l, A) {
      for (var v = l.suspendedLanes, x = l.pingedLanes, T = l.expirationTimes, R = l.pendingLanes; 0 < R; ) {
        var U = 31 - z5(R), i2 = 1 << U, A2 = T[U];
        A2 === -1 ? ((i2 & v) === 0 || (i2 & x) !== 0) && (T[U] = L8(i2, A)) : A2 <= A && (l.expiredLanes |= i2), R &= ~i2;
      }
    }
    function Qn(l) {
      return l = l.pendingLanes & -1073741825, l !== 0 ? l : l & 1073741824 ? 1073741824 : 0;
    }
    function k8() {
      var l = Bn;
      return Bn <<= 1, (Bn & 4194240) === 0 && (Bn = 64), l;
    }
    function R8(l) {
      for (var A = [], v = 0; 31 > v; v++) A.push(l);
      return A;
    }
    function D4(l, A, v) {
      l.pendingLanes |= A, A !== 536870912 && (l.suspendedLanes = 0, l.pingedLanes = 0), l = l.eventTimes, A = 31 - z5(A), l[A] = v;
    }
    function Es(l, A) {
      var v = l.pendingLanes & ~A;
      l.pendingLanes = A, l.suspendedLanes = 0, l.pingedLanes = 0, l.expiredLanes &= A, l.mutableReadLanes &= A, l.entangledLanes &= A, A = l.entanglements;
      var x = l.eventTimes;
      for (l = l.expirationTimes; 0 < v; ) {
        var T = 31 - z5(v), R = 1 << T;
        A[T] = 0, x[T] = -1, l[T] = -1, v &= ~R;
      }
    }
    function L4(l, A) {
      var v = l.entangledLanes |= A;
      for (l = l.entanglements; v; ) {
        var x = 31 - z5(v), T = 1 << x;
        T & A | l[x] & A && (l[x] |= A), v &= ~T;
      }
    }
    var ve = 0;
    function P8(l) {
      return l &= -l, 1 < l ? 4 < l ? (l & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
    }
    var ue, a7, Jr, R0, F8, h5 = !1, e4 = [], U5 = null, t4 = null, lt = null, Pe = /* @__PURE__ */ new Map(), xn = /* @__PURE__ */ new Map(), Xt = [], q5 = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
    function J1(l, A) {
      switch (l) {
        case "focusin":
        case "focusout":
          U5 = null;
          break;
        case "dragenter":
        case "dragleave":
          t4 = null;
          break;
        case "mouseover":
        case "mouseout":
          lt = null;
          break;
        case "pointerover":
        case "pointerout":
          Pe.delete(A.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          xn.delete(A.pointerId);
      }
    }
    function y3(l, A, v, x, T, R) {
      return l === null || l.nativeEvent !== R ? (l = { blockedOn: A, domEventName: v, eventSystemFlags: x, nativeEvent: R, targetContainers: [T] }, A !== null && (A = I0(A), A !== null && a7(A)), l) : (l.eventSystemFlags |= x, A = l.targetContainers, T !== null && A.indexOf(T) === -1 && A.push(T), l);
    }
    function o7(l, A, v, x, T) {
      switch (A) {
        case "focusin":
          return U5 = y3(U5, l, A, v, x, T), !0;
        case "dragenter":
          return t4 = y3(t4, l, A, v, x, T), !0;
        case "mouseover":
          return lt = y3(lt, l, A, v, x, T), !0;
        case "pointerover":
          var R = T.pointerId;
          return Pe.set(R, y3(Pe.get(R) || null, l, A, v, x, T)), !0;
        case "gotpointercapture":
          return R = T.pointerId, xn.set(R, y3(xn.get(R) || null, l, A, v, x, T)), !0;
      }
      return !1;
    }
    function s7(l) {
      var A = _3(l.target);
      if (A !== null) {
        var v = H0(A);
        if (v !== null) {
          if (A = v.tag, A === 13) {
            if (A = P0(v), A !== null) {
              l.blockedOn = A, F8(l.priority, function() {
                Jr(v);
              });
              return;
            }
          } else if (A === 3 && v.stateNode.current.memoizedState.isDehydrated) {
            l.blockedOn = v.tag === 3 ? v.stateNode.containerInfo : null;
            return;
          }
        }
      }
      l.blockedOn = null;
    }
    function bn(l) {
      if (l.blockedOn !== null) return !1;
      for (var A = l.targetContainers; 0 < A.length; ) {
        var v = j8(l.domEventName, l.eventSystemFlags, A[0], l.nativeEvent);
        if (v === null) {
          v = l.nativeEvent;
          var x = new v.constructor(v.type, v);
          Le = x, v.target.dispatchEvent(x), Le = null;
        } else return A = I0(v), A !== null && a7(A), l.blockedOn = v, !1;
        A.shift();
      }
      return !0;
    }
    function I3(l, A, v) {
      bn(l) && v.delete(A);
    }
    function ms() {
      h5 = !1, U5 !== null && bn(U5) && (U5 = null), t4 !== null && bn(t4) && (t4 = null), lt !== null && bn(lt) && (lt = null), Pe.forEach(I3), xn.forEach(I3);
    }
    function er(l, A) {
      l.blockedOn === A && (l.blockedOn = null, h5 || (h5 = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, ms)));
    }
    function Mr(l) {
      function A(T) {
        return er(T, l);
      }
      if (0 < e4.length) {
        er(e4[0], l);
        for (var v = 1; v < e4.length; v++) {
          var x = e4[v];
          x.blockedOn === l && (x.blockedOn = null);
        }
      }
      for (U5 !== null && er(U5, l), t4 !== null && er(t4, l), lt !== null && er(lt, l), Pe.forEach(A), xn.forEach(A), v = 0; v < Xt.length; v++) x = Xt[v], x.blockedOn === l && (x.blockedOn = null);
      for (; 0 < Xt.length && (v = Xt[0], v.blockedOn === null); ) s7(v), v.blockedOn === null && Xt.shift();
    }
    var r4 = O.ReactCurrentBatchConfig, tr = !0;
    function N8(l, A, v, x) {
      var T = ve, R = r4.transition;
      r4.transition = null;
      try {
        ve = 1, wn(l, A, v, x);
      } finally {
        ve = T, r4.transition = R;
      }
    }
    function H8(l, A, v, x) {
      var T = ve, R = r4.transition;
      r4.transition = null;
      try {
        ve = 4, wn(l, A, v, x);
      } finally {
        ve = T, r4.transition = R;
      }
    }
    function wn(l, A, v, x) {
      if (tr) {
        var T = j8(l, A, v, x);
        if (T === null) va(l, A, x, B3, v), J1(l, x);
        else if (o7(T, l, A, v, x)) x.stopPropagation();
        else if (J1(l, x), A & 4 && -1 < q5.indexOf(l)) {
          for (; T !== null; ) {
            var R = I0(T);
            if (R !== null && ue(R), R = j8(l, A, v, x), R === null && va(l, A, x, B3, v), R === T) break;
            T = R;
          }
          T !== null && x.stopPropagation();
        } else va(l, A, x, null, v);
      }
    }
    var B3 = null;
    function j8(l, A, v, x) {
      if (B3 = null, l = be(x), l = _3(l), l !== null) if (A = H0(l), A === null) l = null;
      else if (v = A.tag, v === 13) {
        if (l = P0(A), l !== null) return l;
        l = null;
      } else if (v === 3) {
        if (A.stateNode.current.memoizedState.isDehydrated) return A.tag === 3 ? A.stateNode.containerInfo : null;
        l = null;
      } else A !== l && (l = null);
      return B3 = l, null;
    }
    function V8(l) {
      switch (l) {
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return 4;
        case "message":
          switch (z0()) {
            case br:
              return 1;
            case v3:
              return 4;
            case E3:
            case yn:
              return 16;
            case T8:
              return 536870912;
            default:
              return 16;
          }
        default:
          return 16;
      }
    }
    var _r = null, j = null, u2 = null;
    function Q2() {
      if (u2) return u2;
      var l, A = j, v = A.length, x, T = "value" in _r ? _r.value : _r.textContent, R = T.length;
      for (l = 0; l < v && A[l] === T[l]; l++) ;
      var U = v - l;
      for (x = 1; x <= U && A[v - x] === T[R - x]; x++) ;
      return u2 = T.slice(l, 1 < x ? 1 - x : void 0);
    }
    function _2(l) {
      var A = l.keyCode;
      return "charCode" in l ? (l = l.charCode, l === 0 && A === 13 && (l = 13)) : l = A, l === 10 && (l = 13), 32 <= l || l === 13 ? l : 0;
    }
    function q2() {
      return !0;
    }
    function Q0() {
      return !1;
    }
    function K2(l) {
      function A(v, x, T, R, U) {
        this._reactName = v, this._targetInst = T, this.type = x, this.nativeEvent = R, this.target = U, this.currentTarget = null;
        for (var i2 in l) l.hasOwnProperty(i2) && (v = l[i2], this[i2] = v ? v(R) : R[i2]);
        return this.isDefaultPrevented = (R.defaultPrevented != null ? R.defaultPrevented : R.returnValue === !1) ? q2 : Q0, this.isPropagationStopped = Q0, this;
      }
      return e2(A.prototype, { preventDefault: function() {
        this.defaultPrevented = !0;
        var v = this.nativeEvent;
        v && (v.preventDefault ? v.preventDefault() : typeof v.returnValue != "unknown" && (v.returnValue = !1), this.isDefaultPrevented = q2);
      }, stopPropagation: function() {
        var v = this.nativeEvent;
        v && (v.stopPropagation ? v.stopPropagation() : typeof v.cancelBubble != "unknown" && (v.cancelBubble = !0), this.isPropagationStopped = q2);
      }, persist: function() {
      }, isPersistent: q2 }), A;
    }
    var M0 = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(l) {
      return l.timeStamp || Date.now();
    }, defaultPrevented: 0, isTrusted: 0 }, X0 = K2(M0), le = e2({}, M0, { view: 0, detail: 0 }), at = K2(le), Fe, q0, Ne, pt = e2({}, le, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: xs, button: 0, buttons: 0, relatedTarget: function(l) {
      return l.relatedTarget === void 0 ? l.fromElement === l.srcElement ? l.toElement : l.fromElement : l.relatedTarget;
    }, movementX: function(l) {
      return "movementX" in l ? l.movementX : (l !== Ne && (Ne && l.type === "mousemove" ? (Fe = l.screenX - Ne.screenX, q0 = l.screenY - Ne.screenY) : q0 = Fe = 0, Ne = l), Fe);
    }, movementY: function(l) {
      return "movementY" in l ? l.movementY : q0;
    } }), Sn = K2(pt), u7 = e2({}, pt, { dataTransfer: 0 }), k4 = K2(u7), l7 = e2({}, le, { relatedTarget: 0 }), Q3 = K2(l7), ys = e2({}, M0, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), sa = K2(ys), Is = e2({}, M0, { clipboardData: function(l) {
      return "clipboardData" in l ? l.clipboardData : window.clipboardData;
    } }), pA = K2(Is), Bs = e2({}, M0, { data: 0 }), Qs = K2(Bs), hA = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, vA = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, Kh = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
    function R4(l) {
      var A = this.nativeEvent;
      return A.getModifierState ? A.getModifierState(l) : (l = Kh[l]) ? !!A[l] : !1;
    }
    function xs() {
      return R4;
    }
    var bs = e2({}, le, { key: function(l) {
      if (l.key) {
        var A = hA[l.key] || l.key;
        if (A !== "Unidentified") return A;
      }
      return l.type === "keypress" ? (l = _2(l), l === 13 ? "Enter" : String.fromCharCode(l)) : l.type === "keydown" || l.type === "keyup" ? vA[l.keyCode] || "Unidentified" : "";
    }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: xs, charCode: function(l) {
      return l.type === "keypress" ? _2(l) : 0;
    }, keyCode: function(l) {
      return l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    }, which: function(l) {
      return l.type === "keypress" ? _2(l) : l.type === "keydown" || l.type === "keyup" ? l.keyCode : 0;
    } }), ws = K2(bs), Ss = e2({}, pt, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), EA = K2(Ss), ua = e2({}, le, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: xs }), mA = K2(ua), C1 = e2({}, M0, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), P4 = K2(C1), Rt = e2({}, pt, {
      deltaX: function(l) {
        return "deltaX" in l ? l.deltaX : "wheelDeltaX" in l ? -l.wheelDeltaX : 0;
      },
      deltaY: function(l) {
        return "deltaY" in l ? l.deltaY : "wheelDeltaY" in l ? -l.wheelDeltaY : "wheelDelta" in l ? -l.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), F4 = K2(Rt), Ms = [9, 13, 27, 32], Z8 = c && "CompositionEvent" in window, c7 = null;
    c && "documentMode" in document && (c7 = document.documentMode);
    var A7 = c && "TextEvent" in window && !c7, yA = c && (!Z8 || c7 && 8 < c7 && 11 >= c7), IA = " ", la = !1;
    function BA(l, A) {
      switch (l) {
        case "keyup":
          return Ms.indexOf(A.keyCode) !== -1;
        case "keydown":
          return A.keyCode !== 229;
        case "keypress":
        case "mousedown":
        case "focusout":
          return !0;
        default:
          return !1;
      }
    }
    function QA(l) {
      return l = l.detail, typeof l == "object" && "data" in l ? l.data : null;
    }
    var z8 = !1;
    function xA(l, A) {
      switch (l) {
        case "compositionend":
          return QA(A);
        case "keypress":
          return A.which !== 32 ? null : (la = !0, IA);
        case "textInput":
          return l = A.data, l === IA && la ? null : l;
        default:
          return null;
      }
    }
    function Xh(l, A) {
      if (z8) return l === "compositionend" || !Z8 && BA(l, A) ? (l = Q2(), u2 = j = _r = null, z8 = !1, l) : null;
      switch (l) {
        case "paste":
          return null;
        case "keypress":
          if (!(A.ctrlKey || A.altKey || A.metaKey) || A.ctrlKey && A.altKey) {
            if (A.char && 1 < A.char.length) return A.char;
            if (A.which) return String.fromCharCode(A.which);
          }
          return null;
        case "compositionend":
          return yA && A.locale !== "ko" ? null : A.data;
        default:
          return null;
      }
    }
    var Jh = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
    function bA(l) {
      var A = l && l.nodeName && l.nodeName.toLowerCase();
      return A === "input" ? !!Jh[l.type] : A === "textarea";
    }
    function _s(l, A, v, x) {
      Br(x), A = h7(A, "onChange"), 0 < A.length && (v = new X0("onChange", "change", null, v, x), l.push({ event: v, listeners: A }));
    }
    var n4 = null, x3 = null;
    function wA(l) {
      S3(l, 0);
    }
    function f7(l) {
      var A = Tr(l);
      if (d2(A)) return l;
    }
    function ev(l, A) {
      if (l === "change") return A;
    }
    var SA = !1;
    if (c) {
      var Os;
      if (c) {
        var Ts = "oninput" in document;
        if (!Ts) {
          var MA = document.createElement("div");
          MA.setAttribute("oninput", "return;"), Ts = typeof MA.oninput == "function";
        }
        Os = Ts;
      } else Os = !1;
      SA = Os && (!document.documentMode || 9 < document.documentMode);
    }
    function _A() {
      n4 && (n4.detachEvent("onpropertychange", OA), x3 = n4 = null);
    }
    function OA(l) {
      if (l.propertyName === "value" && f7(x3)) {
        var A = [];
        _s(A, x3, l, be(l)), Kr(wA, A);
      }
    }
    function tv(l, A, v) {
      l === "focusin" ? (_A(), n4 = A, x3 = v, n4.attachEvent("onpropertychange", OA)) : l === "focusout" && _A();
    }
    function TA(l) {
      if (l === "selectionchange" || l === "keyup" || l === "keydown") return f7(x3);
    }
    function rv(l, A) {
      if (l === "click") return f7(A);
    }
    function DA(l, A) {
      if (l === "input" || l === "change") return f7(A);
    }
    function nv(l, A) {
      return l === A && (l !== 0 || 1 / l === 1 / A) || l !== l && A !== A;
    }
    var Or = typeof Object.is == "function" ? Object.is : nv;
    function C7(l, A) {
      if (Or(l, A)) return !0;
      if (typeof l != "object" || l === null || typeof A != "object" || A === null) return !1;
      var v = Object.keys(l), x = Object.keys(A);
      if (v.length !== x.length) return !1;
      for (x = 0; x < v.length; x++) {
        var T = v[x];
        if (!f.call(A, T) || !Or(l[T], A[T])) return !1;
      }
      return !0;
    }
    function LA(l) {
      for (; l && l.firstChild; ) l = l.firstChild;
      return l;
    }
    function ca(l, A) {
      var v = LA(l);
      l = 0;
      for (var x; v; ) {
        if (v.nodeType === 3) {
          if (x = l + v.textContent.length, l <= A && x >= A) return { node: v, offset: A - l };
          l = x;
        }
        e: {
          for (; v; ) {
            if (v.nextSibling) {
              v = v.nextSibling;
              break e;
            }
            v = v.parentNode;
          }
          v = void 0;
        }
        v = LA(v);
      }
    }
    function Mn(l, A) {
      return l && A ? l === A ? !0 : l && l.nodeType === 3 ? !1 : A && A.nodeType === 3 ? Mn(l, A.parentNode) : "contains" in l ? l.contains(A) : l.compareDocumentPosition ? !!(l.compareDocumentPosition(A) & 16) : !1 : !1;
    }
    function d7() {
      for (var l = window, A = X2(); A instanceof l.HTMLIFrameElement; ) {
        try {
          var v = typeof A.contentWindow.location.href == "string";
        } catch {
          v = !1;
        }
        if (v) l = A.contentWindow;
        else break;
        A = X2(l.document);
      }
      return A;
    }
    function Aa(l) {
      var A = l && l.nodeName && l.nodeName.toLowerCase();
      return A && (A === "input" && (l.type === "text" || l.type === "search" || l.type === "tel" || l.type === "url" || l.type === "password") || A === "textarea" || l.contentEditable === "true");
    }
    function U8(l) {
      var A = d7(), v = l.focusedElem, x = l.selectionRange;
      if (A !== v && v && v.ownerDocument && Mn(v.ownerDocument.documentElement, v)) {
        if (x !== null && Aa(v)) {
          if (A = x.start, l = x.end, l === void 0 && (l = A), "selectionStart" in v) v.selectionStart = A, v.selectionEnd = Math.min(l, v.value.length);
          else if (l = (A = v.ownerDocument || document) && A.defaultView || window, l.getSelection) {
            l = l.getSelection();
            var T = v.textContent.length, R = Math.min(x.start, T);
            x = x.end === void 0 ? R : Math.min(x.end, T), !l.extend && R > x && (T = x, x = R, R = T), T = ca(v, R);
            var U = ca(
              v,
              x
            );
            T && U && (l.rangeCount !== 1 || l.anchorNode !== T.node || l.anchorOffset !== T.offset || l.focusNode !== U.node || l.focusOffset !== U.offset) && (A = A.createRange(), A.setStart(T.node, T.offset), l.removeAllRanges(), R > x ? (l.addRange(A), l.extend(U.node, U.offset)) : (A.setEnd(U.node, U.offset), l.addRange(A)));
          }
        }
        for (A = [], l = v; l = l.parentNode; ) l.nodeType === 1 && A.push({ element: l, left: l.scrollLeft, top: l.scrollTop });
        for (typeof v.focus == "function" && v.focus(), v = 0; v < A.length; v++) l = A[v], l.element.scrollLeft = l.left, l.element.scrollTop = l.top;
      }
    }
    var iv = c && "documentMode" in document && 11 >= document.documentMode, q8 = null, Ds = null, g7 = null, Ls = !1;
    function ks(l, A, v) {
      var x = v.window === v ? v.document : v.nodeType === 9 ? v : v.ownerDocument;
      Ls || q8 == null || q8 !== X2(x) || (x = q8, "selectionStart" in x && Aa(x) ? x = { start: x.selectionStart, end: x.selectionEnd } : (x = (x.ownerDocument && x.ownerDocument.defaultView || window).getSelection(), x = { anchorNode: x.anchorNode, anchorOffset: x.anchorOffset, focusNode: x.focusNode, focusOffset: x.focusOffset }), g7 && C7(g7, x) || (g7 = x, x = h7(Ds, "onSelect"), 0 < x.length && (A = new X0("onSelect", "select", null, A, v), l.push({ event: A, listeners: x }), A.target = q8)));
    }
    function fa(l, A) {
      var v = {};
      return v[l.toLowerCase()] = A.toLowerCase(), v["Webkit" + l] = "webkit" + A, v["Moz" + l] = "moz" + A, v;
    }
    var b3 = { animationend: fa("Animation", "AnimationEnd"), animationiteration: fa("Animation", "AnimationIteration"), animationstart: fa("Animation", "AnimationStart"), transitionend: fa("Transition", "TransitionEnd") }, v5 = {}, Rs = {};
    c && (Rs = document.createElement("div").style, "AnimationEvent" in window || (delete b3.animationend.animation, delete b3.animationiteration.animation, delete b3.animationstart.animation), "TransitionEvent" in window || delete b3.transitionend.transition);
    function Ca(l) {
      if (v5[l]) return v5[l];
      if (!b3[l]) return l;
      var A = b3[l], v;
      for (v in A) if (A.hasOwnProperty(v) && v in Rs) return v5[l] = A[v];
      return l;
    }
    var kA = Ca("animationend"), RA = Ca("animationiteration"), PA = Ca("animationstart"), FA = Ca("transitionend"), Ps = /* @__PURE__ */ new Map(), da = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
    function rr(l, A) {
      Ps.set(l, A), o(A, [l]);
    }
    for (var Fs = 0; Fs < da.length; Fs++) {
      var w3 = da[Fs], av = w3.toLowerCase(), ov = w3[0].toUpperCase() + w3.slice(1);
      rr(av, "on" + ov);
    }
    rr(kA, "onAnimationEnd"), rr(RA, "onAnimationIteration"), rr(PA, "onAnimationStart"), rr("dblclick", "onDoubleClick"), rr("focusin", "onFocus"), rr("focusout", "onBlur"), rr(FA, "onTransitionEnd"), u("onMouseEnter", ["mouseout", "mouseover"]), u("onMouseLeave", ["mouseout", "mouseover"]), u("onPointerEnter", ["pointerout", "pointerover"]), u("onPointerLeave", ["pointerout", "pointerover"]), o("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), o("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), o("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), o("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), o("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
    var p7 = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ns = new Set("cancel close invalid load scroll toggle".split(" ").concat(p7));
    function ga(l, A, v) {
      var x = l.type || "unknown-event";
      l.currentTarget = v, l0(x, A, void 0, l), l.currentTarget = null;
    }
    function S3(l, A) {
      A = (A & 4) !== 0;
      for (var v = 0; v < l.length; v++) {
        var x = l[v], T = x.event;
        x = x.listeners;
        e: {
          var R = void 0;
          if (A) for (var U = x.length - 1; 0 <= U; U--) {
            var i2 = x[U], A2 = i2.instance, x2 = i2.currentTarget;
            if (i2 = i2.listener, A2 !== R && T.isPropagationStopped()) break e;
            ga(T, i2, x2), R = A2;
          }
          else for (U = 0; U < x.length; U++) {
            if (i2 = x[U], A2 = i2.instance, x2 = i2.currentTarget, i2 = i2.listener, A2 !== R && T.isPropagationStopped()) break e;
            ga(T, i2, x2), R = A2;
          }
        }
      }
      if (Xr) throw l = c2, Xr = !1, c2 = null, l;
    }
    function we(l, A) {
      var v = A[m7];
      v === void 0 && (v = A[m7] = /* @__PURE__ */ new Set());
      var x = l + "__bubble";
      v.has(x) || (NA(A, l, 2, !1), v.add(x));
    }
    function pa(l, A, v) {
      var x = 0;
      A && (x |= 4), NA(v, l, x, A);
    }
    var ha = "_reactListening" + Math.random().toString(36).slice(2);
    function W8(l) {
      if (!l[ha]) {
        l[ha] = !0, n.forEach(function(v) {
          v !== "selectionchange" && (Ns.has(v) || pa(v, !1, l), pa(v, !0, l));
        });
        var A = l.nodeType === 9 ? l : l.ownerDocument;
        A === null || A[ha] || (A[ha] = !0, pa("selectionchange", !1, A));
      }
    }
    function NA(l, A, v, x) {
      switch (V8(A)) {
        case 1:
          var T = N8;
          break;
        case 4:
          T = H8;
          break;
        default:
          T = wn;
      }
      v = T.bind(null, A, v, l), T = void 0, !o5 || A !== "touchstart" && A !== "touchmove" && A !== "wheel" || (T = !0), x ? T !== void 0 ? l.addEventListener(A, v, { capture: !0, passive: T }) : l.addEventListener(A, v, !0) : T !== void 0 ? l.addEventListener(A, v, { passive: T }) : l.addEventListener(A, v, !1);
    }
    function va(l, A, v, x, T) {
      var R = x;
      if ((A & 1) === 0 && (A & 2) === 0 && x !== null) e: for (; ; ) {
        if (x === null) return;
        var U = x.tag;
        if (U === 3 || U === 4) {
          var i2 = x.stateNode.containerInfo;
          if (i2 === T || i2.nodeType === 8 && i2.parentNode === T) break;
          if (U === 4) for (U = x.return; U !== null; ) {
            var A2 = U.tag;
            if ((A2 === 3 || A2 === 4) && (A2 = U.stateNode.containerInfo, A2 === T || A2.nodeType === 8 && A2.parentNode === T)) return;
            U = U.return;
          }
          for (; i2 !== null; ) {
            if (U = _3(i2), U === null) return;
            if (A2 = U.tag, A2 === 5 || A2 === 6) {
              x = R = U;
              continue e;
            }
            i2 = i2.parentNode;
          }
        }
        x = x.return;
      }
      Kr(function() {
        var x2 = R, V2 = be(v), z2 = [];
        e: {
          var j2 = Ps.get(l);
          if (j2 !== void 0) {
            var n0 = X0, f0 = l;
            switch (l) {
              case "keypress":
                if (_2(v) === 0) break e;
              case "keydown":
              case "keyup":
                n0 = ws;
                break;
              case "focusin":
                f0 = "focus", n0 = Q3;
                break;
              case "focusout":
                f0 = "blur", n0 = Q3;
                break;
              case "beforeblur":
              case "afterblur":
                n0 = Q3;
                break;
              case "click":
                if (v.button === 2) break e;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                n0 = Sn;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                n0 = k4;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                n0 = mA;
                break;
              case kA:
              case RA:
              case PA:
                n0 = sa;
                break;
              case FA:
                n0 = P4;
                break;
              case "scroll":
                n0 = at;
                break;
              case "wheel":
                n0 = F4;
                break;
              case "copy":
              case "cut":
              case "paste":
                n0 = pA;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                n0 = EA;
            }
            var p0 = (A & 4) !== 0, _t = !p0 && l === "scroll", E2 = p0 ? j2 !== null ? j2 + "Capture" : null : j2;
            p0 = [];
            for (var p2 = x2, I2; p2 !== null; ) {
              I2 = p2;
              var Z2 = I2.stateNode;
              if (I2.tag === 5 && Z2 !== null && (I2 = Z2, E2 !== null && (Z2 = g5(p2, E2), Z2 != null && p0.push(Y8(p2, Z2, I2)))), _t) break;
              p2 = p2.return;
            }
            0 < p0.length && (j2 = new n0(j2, f0, null, v, V2), z2.push({ event: j2, listeners: p0 }));
          }
        }
        if ((A & 7) === 0) {
          e: {
            if (j2 = l === "mouseover" || l === "pointerover", n0 = l === "mouseout" || l === "pointerout", j2 && v !== Le && (f0 = v.relatedTarget || v.fromElement) && (_3(f0) || f0[N4])) break e;
            if ((n0 || j2) && (j2 = V2.window === V2 ? V2 : (j2 = V2.ownerDocument) ? j2.defaultView || j2.parentWindow : window, n0 ? (f0 = v.relatedTarget || v.toElement, n0 = x2, f0 = f0 ? _3(f0) : null, f0 !== null && (_t = H0(f0), f0 !== _t || f0.tag !== 5 && f0.tag !== 6) && (f0 = null)) : (n0 = null, f0 = x2), n0 !== f0)) {
              if (p0 = Sn, Z2 = "onMouseLeave", E2 = "onMouseEnter", p2 = "mouse", (l === "pointerout" || l === "pointerover") && (p0 = EA, Z2 = "onPointerLeave", E2 = "onPointerEnter", p2 = "pointer"), _t = n0 == null ? j2 : Tr(n0), I2 = f0 == null ? j2 : Tr(f0), j2 = new p0(Z2, p2 + "leave", n0, v, V2), j2.target = _t, j2.relatedTarget = I2, Z2 = null, _3(V2) === x2 && (p0 = new p0(E2, p2 + "enter", f0, v, V2), p0.target = I2, p0.relatedTarget = _t, Z2 = p0), _t = Z2, n0 && f0) t: {
                for (p0 = n0, E2 = f0, p2 = 0, I2 = p0; I2; I2 = _n(I2)) p2++;
                for (I2 = 0, Z2 = E2; Z2; Z2 = _n(Z2)) I2++;
                for (; 0 < p2 - I2; ) p0 = _n(p0), p2--;
                for (; 0 < I2 - p2; ) E2 = _n(E2), I2--;
                for (; p2--; ) {
                  if (p0 === E2 || E2 !== null && p0 === E2.alternate) break t;
                  p0 = _n(p0), E2 = _n(E2);
                }
                p0 = null;
              }
              else p0 = null;
              n0 !== null && HA(z2, j2, n0, p0, !1), f0 !== null && _t !== null && HA(z2, _t, f0, p0, !0);
            }
          }
          e: {
            if (j2 = x2 ? Tr(x2) : window, n0 = j2.nodeName && j2.nodeName.toLowerCase(), n0 === "select" || n0 === "input" && j2.type === "file") var C0 = ev;
            else if (bA(j2)) if (SA) C0 = DA;
            else {
              C0 = TA;
              var w0 = tv;
            }
            else (n0 = j2.nodeName) && n0.toLowerCase() === "input" && (j2.type === "checkbox" || j2.type === "radio") && (C0 = rv);
            if (C0 && (C0 = C0(l, x2))) {
              _s(z2, C0, v, V2);
              break e;
            }
            w0 && w0(l, j2, x2), l === "focusout" && (w0 = j2._wrapperState) && w0.controlled && j2.type === "number" && _e(j2, "number", j2.value);
          }
          switch (w0 = x2 ? Tr(x2) : window, l) {
            case "focusin":
              (bA(w0) || w0.contentEditable === "true") && (q8 = w0, Ds = x2, g7 = null);
              break;
            case "focusout":
              g7 = Ds = q8 = null;
              break;
            case "mousedown":
              Ls = !0;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              Ls = !1, ks(z2, v, V2);
              break;
            case "selectionchange":
              if (iv) break;
            case "keydown":
            case "keyup":
              ks(z2, v, V2);
          }
          var _0;
          if (Z8) e: {
            switch (l) {
              case "compositionstart":
                var D0 = "onCompositionStart";
                break e;
              case "compositionend":
                D0 = "onCompositionEnd";
                break e;
              case "compositionupdate":
                D0 = "onCompositionUpdate";
                break e;
            }
            D0 = void 0;
          }
          else z8 ? BA(l, v) && (D0 = "onCompositionEnd") : l === "keydown" && v.keyCode === 229 && (D0 = "onCompositionStart");
          D0 && (yA && v.locale !== "ko" && (z8 || D0 !== "onCompositionStart" ? D0 === "onCompositionEnd" && z8 && (_0 = Q2()) : (_r = V2, j = "value" in _r ? _r.value : _r.textContent, z8 = !0)), w0 = h7(x2, D0), 0 < w0.length && (D0 = new Qs(D0, l, null, v, V2), z2.push({ event: D0, listeners: w0 }), _0 ? D0.data = _0 : (_0 = QA(v), _0 !== null && (D0.data = _0)))), (_0 = A7 ? xA(l, v) : Xh(l, v)) && (x2 = h7(x2, "onBeforeInput"), 0 < x2.length && (V2 = new Qs("onBeforeInput", "beforeinput", null, v, V2), z2.push({ event: V2, listeners: x2 }), V2.data = _0));
        }
        S3(z2, A);
      });
    }
    function Y8(l, A, v) {
      return { instance: l, listener: A, currentTarget: v };
    }
    function h7(l, A) {
      for (var v = A + "Capture", x = []; l !== null; ) {
        var T = l, R = T.stateNode;
        T.tag === 5 && R !== null && (T = R, R = g5(l, v), R != null && x.unshift(Y8(l, R, T)), R = g5(l, A), R != null && x.push(Y8(l, R, T))), l = l.return;
      }
      return x;
    }
    function _n(l) {
      if (l === null) return null;
      do
        l = l.return;
      while (l && l.tag !== 5);
      return l || null;
    }
    function HA(l, A, v, x, T) {
      for (var R = A._reactName, U = []; v !== null && v !== x; ) {
        var i2 = v, A2 = i2.alternate, x2 = i2.stateNode;
        if (A2 !== null && A2 === x) break;
        i2.tag === 5 && x2 !== null && (i2 = x2, T ? (A2 = g5(v, R), A2 != null && U.unshift(Y8(v, A2, i2))) : T || (A2 = g5(v, R), A2 != null && U.push(Y8(v, A2, i2)))), v = v.return;
      }
      U.length !== 0 && l.push({ event: A, listeners: U });
    }
    var jA = /\r\n?/g, sv = /\u0000|\uFFFD/g;
    function VA(l) {
      return (typeof l == "string" ? l : "" + l).replace(jA, `
`).replace(sv, "");
    }
    function Ea(l, A, v) {
      if (A = VA(A), VA(l) !== A && v) throw Error(r(425));
    }
    function On() {
    }
    var v7 = null, M3 = null;
    function ma(l, A) {
      return l === "textarea" || l === "noscript" || typeof A.children == "string" || typeof A.children == "number" || typeof A.dangerouslySetInnerHTML == "object" && A.dangerouslySetInnerHTML !== null && A.dangerouslySetInnerHTML.__html != null;
    }
    var ya = typeof setTimeout == "function" ? setTimeout : void 0, Hs = typeof clearTimeout == "function" ? clearTimeout : void 0, ZA = typeof Promise == "function" ? Promise : void 0, $8 = typeof queueMicrotask == "function" ? queueMicrotask : typeof ZA < "u" ? function(l) {
      return ZA.resolve(null).then(l).catch(Ia);
    } : ya;
    function Ia(l) {
      setTimeout(function() {
        throw l;
      });
    }
    function G8(l, A) {
      var v = A, x = 0;
      do {
        var T = v.nextSibling;
        if (l.removeChild(v), T && T.nodeType === 8) if (v = T.data, v === "/$") {
          if (x === 0) {
            l.removeChild(T), Mr(A);
            return;
          }
          x--;
        } else v !== "$" && v !== "$?" && v !== "$!" || x++;
        v = T;
      } while (v);
      Mr(A);
    }
    function i4(l) {
      for (; l != null; l = l.nextSibling) {
        var A = l.nodeType;
        if (A === 1 || A === 3) break;
        if (A === 8) {
          if (A = l.data, A === "$" || A === "$!" || A === "$?") break;
          if (A === "/$") return null;
        }
      }
      return l;
    }
    function zA(l) {
      l = l.previousSibling;
      for (var A = 0; l; ) {
        if (l.nodeType === 8) {
          var v = l.data;
          if (v === "$" || v === "$!" || v === "$?") {
            if (A === 0) return l;
            A--;
          } else v === "/$" && A++;
        }
        l = l.previousSibling;
      }
      return null;
    }
    var Tn = Math.random().toString(36).slice(2), a4 = "__reactFiber$" + Tn, E7 = "__reactProps$" + Tn, N4 = "__reactContainer$" + Tn, m7 = "__reactEvents$" + Tn, K8 = "__reactListeners$" + Tn, uv = "__reactHandles$" + Tn;
    function _3(l) {
      var A = l[a4];
      if (A) return A;
      for (var v = l.parentNode; v; ) {
        if (A = v[N4] || v[a4]) {
          if (v = A.alternate, A.child !== null || v !== null && v.child !== null) for (l = zA(l); l !== null; ) {
            if (v = l[a4]) return v;
            l = zA(l);
          }
          return A;
        }
        l = v, v = l.parentNode;
      }
      return null;
    }
    function I0(l) {
      return l = l[a4] || l[N4], !l || l.tag !== 5 && l.tag !== 6 && l.tag !== 13 && l.tag !== 3 ? null : l;
    }
    function Tr(l) {
      if (l.tag === 5 || l.tag === 6) return l.stateNode;
      throw Error(r(33));
    }
    function xt(l) {
      return l[E7] || null;
    }
    var ie = [], nr = -1;
    function Dr(l) {
      return { current: l };
    }
    function ot(l) {
      0 > nr || (l.current = ie[nr], ie[nr] = null, nr--);
    }
    function y0(l, A) {
      nr++, ie[nr] = l.current, l.current = A;
    }
    var d1 = {}, It = Dr(d1), Jt = Dr(!1), g1 = d1;
    function ir(l, A) {
      var v = l.type.contextTypes;
      if (!v) return d1;
      var x = l.stateNode;
      if (x && x.__reactInternalMemoizedUnmaskedChildContext === A) return x.__reactInternalMemoizedMaskedChildContext;
      var T = {}, R;
      for (R in v) T[R] = A[R];
      return x && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = A, l.__reactInternalMemoizedMaskedChildContext = T), T;
    }
    function Pt(l) {
      return l = l.childContextTypes, l != null;
    }
    function X8() {
      ot(Jt), ot(It);
    }
    function UA(l, A, v) {
      if (It.current !== d1) throw Error(r(168));
      y0(It, A), y0(Jt, v);
    }
    function y7(l, A, v) {
      var x = l.stateNode;
      if (A = A.childContextTypes, typeof x.getChildContext != "function") return v;
      x = x.getChildContext();
      for (var T in x) if (!(T in A)) throw Error(r(108, M2(l) || "Unknown", T));
      return e2({}, v, x);
    }
    function p1(l) {
      return l = (l = l.stateNode) && l.__reactInternalMemoizedMergedChildContext || d1, g1 = It.current, y0(It, l), y0(Jt, Jt.current), !0;
    }
    function Ba(l, A, v) {
      var x = l.stateNode;
      if (!x) throw Error(r(169));
      v ? (l = y7(l, A, g1), x.__reactInternalMemoizedMergedChildContext = l, ot(Jt), ot(It), y0(It, l)) : ot(Jt), y0(Jt, v);
    }
    var o4 = null, J8 = !1, H4 = !1;
    function Qa(l) {
      o4 === null ? o4 = [l] : o4.push(l);
    }
    function Dn(l) {
      J8 = !0, Qa(l);
    }
    function s4() {
      if (!H4 && o4 !== null) {
        H4 = !0;
        var l = 0, A = ve;
        try {
          var v = o4;
          for (ve = 1; l < v.length; l++) {
            var x = v[l];
            do
              x = x(!0);
            while (x !== null);
          }
          o4 = null, J8 = !1;
        } catch (T) {
          throw o4 !== null && (o4 = o4.slice(l + 1)), ut(br, s4), T;
        } finally {
          ve = A, H4 = !1;
        }
      }
      return null;
    }
    var Ln = [], kn = 0, Rn = null, j4 = 0, Ft = [], ar = 0, R1 = null, u4 = 1, l4 = "";
    function O3(l, A) {
      Ln[kn++] = j4, Ln[kn++] = Rn, Rn = l, j4 = A;
    }
    function qA(l, A, v) {
      Ft[ar++] = u4, Ft[ar++] = l4, Ft[ar++] = R1, R1 = l;
      var x = u4;
      l = l4;
      var T = 32 - z5(x) - 1;
      x &= ~(1 << T), v += 1;
      var R = 32 - z5(A) + T;
      if (30 < R) {
        var U = T - T % 5;
        R = (x & (1 << U) - 1).toString(32), x >>= U, T -= U, u4 = 1 << 32 - z5(A) + T | v << T | x, l4 = R + l;
      } else u4 = 1 << R | v << T | x, l4 = l;
    }
    function xa(l) {
      l.return !== null && (O3(l, 1), qA(l, 1, 0));
    }
    function ba(l) {
      for (; l === Rn; ) Rn = Ln[--kn], Ln[kn] = null, j4 = Ln[--kn], Ln[kn] = null;
      for (; l === R1; ) R1 = Ft[--ar], Ft[ar] = null, l4 = Ft[--ar], Ft[ar] = null, u4 = Ft[--ar], Ft[ar] = null;
    }
    var h1 = null, v1 = null, Ct = !1, or = null;
    function js(l, A) {
      var v = Ar(5, null, null, 0);
      v.elementType = "DELETED", v.stateNode = A, v.return = l, A = l.deletions, A === null ? (l.deletions = [v], l.flags |= 16) : A.push(v);
    }
    function WA(l, A) {
      switch (l.tag) {
        case 5:
          var v = l.type;
          return A = A.nodeType !== 1 || v.toLowerCase() !== A.nodeName.toLowerCase() ? null : A, A !== null ? (l.stateNode = A, h1 = l, v1 = i4(A.firstChild), !0) : !1;
        case 6:
          return A = l.pendingProps === "" || A.nodeType !== 3 ? null : A, A !== null ? (l.stateNode = A, h1 = l, v1 = null, !0) : !1;
        case 13:
          return A = A.nodeType !== 8 ? null : A, A !== null ? (v = R1 !== null ? { id: u4, overflow: l4 } : null, l.memoizedState = { dehydrated: A, treeContext: v, retryLane: 1073741824 }, v = Ar(18, null, null, 0), v.stateNode = A, v.return = l, l.child = v, h1 = l, v1 = null, !0) : !1;
        default:
          return !1;
      }
    }
    function Vs(l) {
      return (l.mode & 1) !== 0 && (l.flags & 128) === 0;
    }
    function Zs(l) {
      if (Ct) {
        var A = v1;
        if (A) {
          var v = A;
          if (!WA(l, A)) {
            if (Vs(l)) throw Error(r(418));
            A = i4(v.nextSibling);
            var x = h1;
            A && WA(l, A) ? js(x, v) : (l.flags = l.flags & -4097 | 2, Ct = !1, h1 = l);
          }
        } else {
          if (Vs(l)) throw Error(r(418));
          l.flags = l.flags & -4097 | 2, Ct = !1, h1 = l;
        }
      }
    }
    function e5(l) {
      for (l = l.return; l !== null && l.tag !== 5 && l.tag !== 3 && l.tag !== 13; ) l = l.return;
      h1 = l;
    }
    function wa(l) {
      if (l !== h1) return !1;
      if (!Ct) return e5(l), Ct = !0, !1;
      var A;
      if ((A = l.tag !== 3) && !(A = l.tag !== 5) && (A = l.type, A = A !== "head" && A !== "body" && !ma(l.type, l.memoizedProps)), A && (A = v1)) {
        if (Vs(l)) throw I7(), Error(r(418));
        for (; A; ) js(l, A), A = i4(A.nextSibling);
      }
      if (e5(l), l.tag === 13) {
        if (l = l.memoizedState, l = l !== null ? l.dehydrated : null, !l) throw Error(r(317));
        e: {
          for (l = l.nextSibling, A = 0; l; ) {
            if (l.nodeType === 8) {
              var v = l.data;
              if (v === "/$") {
                if (A === 0) {
                  v1 = i4(l.nextSibling);
                  break e;
                }
                A--;
              } else v !== "$" && v !== "$!" && v !== "$?" || A++;
            }
            l = l.nextSibling;
          }
          v1 = null;
        }
      } else v1 = h1 ? i4(l.stateNode.nextSibling) : null;
      return !0;
    }
    function I7() {
      for (var l = v1; l; ) l = i4(l.nextSibling);
    }
    function Pn() {
      v1 = h1 = null, Ct = !1;
    }
    function V4(l) {
      or === null ? or = [l] : or.push(l);
    }
    var lv = O.ReactCurrentBatchConfig;
    function T3(l, A, v) {
      if (l = v.ref, l !== null && typeof l != "function" && typeof l != "object") {
        if (v._owner) {
          if (v = v._owner, v) {
            if (v.tag !== 1) throw Error(r(309));
            var x = v.stateNode;
          }
          if (!x) throw Error(r(147, l));
          var T = x, R = "" + l;
          return A !== null && A.ref !== null && typeof A.ref == "function" && A.ref._stringRef === R ? A.ref : (A = function(U) {
            var i2 = T.refs;
            U === null ? delete i2[R] : i2[R] = U;
          }, A._stringRef = R, A);
        }
        if (typeof l != "string") throw Error(r(284));
        if (!v._owner) throw Error(r(290, l));
      }
      return l;
    }
    function Sa(l, A) {
      throw l = Object.prototype.toString.call(A), Error(r(31, l === "[object Object]" ? "object with keys {" + Object.keys(A).join(", ") + "}" : l));
    }
    function YA(l) {
      var A = l._init;
      return A(l._payload);
    }
    function D3(l) {
      function A(E2, p2) {
        if (l) {
          var I2 = E2.deletions;
          I2 === null ? (E2.deletions = [p2], E2.flags |= 16) : I2.push(p2);
        }
      }
      function v(E2, p2) {
        if (!l) return null;
        for (; p2 !== null; ) A(E2, p2), p2 = p2.sibling;
        return null;
      }
      function x(E2, p2) {
        for (E2 = /* @__PURE__ */ new Map(); p2 !== null; ) p2.key !== null ? E2.set(p2.key, p2) : E2.set(p2.index, p2), p2 = p2.sibling;
        return E2;
      }
      function T(E2, p2) {
        return E2 = Un(E2, p2), E2.index = 0, E2.sibling = null, E2;
      }
      function R(E2, p2, I2) {
        return E2.index = I2, l ? (I2 = E2.alternate, I2 !== null ? (I2 = I2.index, I2 < p2 ? (E2.flags |= 2, p2) : I2) : (E2.flags |= 2, p2)) : (E2.flags |= 1048576, p2);
      }
      function U(E2) {
        return l && E2.alternate === null && (E2.flags |= 2), E2;
      }
      function i2(E2, p2, I2, Z2) {
        return p2 === null || p2.tag !== 6 ? (p2 = mu(I2, E2.mode, Z2), p2.return = E2, p2) : (p2 = T(p2, I2), p2.return = E2, p2);
      }
      function A2(E2, p2, I2, Z2) {
        var C0 = I2.type;
        return C0 === k ? V2(E2, p2, I2.props.children, Z2, I2.key) : p2 !== null && (p2.elementType === C0 || typeof C0 == "object" && C0 !== null && C0.$$typeof === s2 && YA(C0) === p2.type) ? (Z2 = T(p2, I2.props), Z2.ref = T3(E2, p2, I2), Z2.return = E2, Z2) : (Z2 = X7(I2.type, I2.key, I2.props, null, E2.mode, Z2), Z2.ref = T3(E2, p2, I2), Z2.return = E2, Z2);
      }
      function x2(E2, p2, I2, Z2) {
        return p2 === null || p2.tag !== 4 || p2.stateNode.containerInfo !== I2.containerInfo || p2.stateNode.implementation !== I2.implementation ? (p2 = so(I2, E2.mode, Z2), p2.return = E2, p2) : (p2 = T(p2, I2.children || []), p2.return = E2, p2);
      }
      function V2(E2, p2, I2, Z2, C0) {
        return p2 === null || p2.tag !== 7 ? (p2 = Y4(I2, E2.mode, Z2, C0), p2.return = E2, p2) : (p2 = T(p2, I2), p2.return = E2, p2);
      }
      function z2(E2, p2, I2) {
        if (typeof p2 == "string" && p2 !== "" || typeof p2 == "number") return p2 = mu("" + p2, E2.mode, I2), p2.return = E2, p2;
        if (typeof p2 == "object" && p2 !== null) {
          switch (p2.$$typeof) {
            case w:
              return I2 = X7(p2.type, p2.key, p2.props, null, E2.mode, I2), I2.ref = T3(E2, null, p2), I2.return = E2, I2;
            case D:
              return p2 = so(p2, E2.mode, I2), p2.return = E2, p2;
            case s2:
              var Z2 = p2._init;
              return z2(E2, Z2(p2._payload), I2);
          }
          if (Oe(p2) || a2(p2)) return p2 = Y4(p2, E2.mode, I2, null), p2.return = E2, p2;
          Sa(E2, p2);
        }
        return null;
      }
      function j2(E2, p2, I2, Z2) {
        var C0 = p2 !== null ? p2.key : null;
        if (typeof I2 == "string" && I2 !== "" || typeof I2 == "number") return C0 !== null ? null : i2(E2, p2, "" + I2, Z2);
        if (typeof I2 == "object" && I2 !== null) {
          switch (I2.$$typeof) {
            case w:
              return I2.key === C0 ? A2(E2, p2, I2, Z2) : null;
            case D:
              return I2.key === C0 ? x2(E2, p2, I2, Z2) : null;
            case s2:
              return C0 = I2._init, j2(
                E2,
                p2,
                C0(I2._payload),
                Z2
              );
          }
          if (Oe(I2) || a2(I2)) return C0 !== null ? null : V2(E2, p2, I2, Z2, null);
          Sa(E2, I2);
        }
        return null;
      }
      function n0(E2, p2, I2, Z2, C0) {
        if (typeof Z2 == "string" && Z2 !== "" || typeof Z2 == "number") return E2 = E2.get(I2) || null, i2(p2, E2, "" + Z2, C0);
        if (typeof Z2 == "object" && Z2 !== null) {
          switch (Z2.$$typeof) {
            case w:
              return E2 = E2.get(Z2.key === null ? I2 : Z2.key) || null, A2(p2, E2, Z2, C0);
            case D:
              return E2 = E2.get(Z2.key === null ? I2 : Z2.key) || null, x2(p2, E2, Z2, C0);
            case s2:
              var w0 = Z2._init;
              return n0(E2, p2, I2, w0(Z2._payload), C0);
          }
          if (Oe(Z2) || a2(Z2)) return E2 = E2.get(I2) || null, V2(p2, E2, Z2, C0, null);
          Sa(p2, Z2);
        }
        return null;
      }
      function f0(E2, p2, I2, Z2) {
        for (var C0 = null, w0 = null, _0 = p2, D0 = p2 = 0, l5 = null; _0 !== null && D0 < I2.length; D0++) {
          _0.index > D0 ? (l5 = _0, _0 = null) : l5 = _0.sibling;
          var ye = j2(E2, _0, I2[D0], Z2);
          if (ye === null) {
            _0 === null && (_0 = l5);
            break;
          }
          l && _0 && ye.alternate === null && A(E2, _0), p2 = R(ye, p2, D0), w0 === null ? C0 = ye : w0.sibling = ye, w0 = ye, _0 = l5;
        }
        if (D0 === I2.length) return v(E2, _0), Ct && O3(E2, D0), C0;
        if (_0 === null) {
          for (; D0 < I2.length; D0++) _0 = z2(E2, I2[D0], Z2), _0 !== null && (p2 = R(_0, p2, D0), w0 === null ? C0 = _0 : w0.sibling = _0, w0 = _0);
          return Ct && O3(E2, D0), C0;
        }
        for (_0 = x(E2, _0); D0 < I2.length; D0++) l5 = n0(_0, E2, D0, I2[D0], Z2), l5 !== null && (l && l5.alternate !== null && _0.delete(l5.key === null ? D0 : l5.key), p2 = R(l5, p2, D0), w0 === null ? C0 = l5 : w0.sibling = l5, w0 = l5);
        return l && _0.forEach(function(Yn) {
          return A(E2, Yn);
        }), Ct && O3(E2, D0), C0;
      }
      function p0(E2, p2, I2, Z2) {
        var C0 = a2(I2);
        if (typeof C0 != "function") throw Error(r(150));
        if (I2 = C0.call(I2), I2 == null) throw Error(r(151));
        for (var w0 = C0 = null, _0 = p2, D0 = p2 = 0, l5 = null, ye = I2.next(); _0 !== null && !ye.done; D0++, ye = I2.next()) {
          _0.index > D0 ? (l5 = _0, _0 = null) : l5 = _0.sibling;
          var Yn = j2(E2, _0, ye.value, Z2);
          if (Yn === null) {
            _0 === null && (_0 = l5);
            break;
          }
          l && _0 && Yn.alternate === null && A(E2, _0), p2 = R(Yn, p2, D0), w0 === null ? C0 = Yn : w0.sibling = Yn, w0 = Yn, _0 = l5;
        }
        if (ye.done) return v(
          E2,
          _0
        ), Ct && O3(E2, D0), C0;
        if (_0 === null) {
          for (; !ye.done; D0++, ye = I2.next()) ye = z2(E2, ye.value, Z2), ye !== null && (p2 = R(ye, p2, D0), w0 === null ? C0 = ye : w0.sibling = ye, w0 = ye);
          return Ct && O3(E2, D0), C0;
        }
        for (_0 = x(E2, _0); !ye.done; D0++, ye = I2.next()) ye = n0(_0, E2, D0, ye.value, Z2), ye !== null && (l && ye.alternate !== null && _0.delete(ye.key === null ? D0 : ye.key), p2 = R(ye, p2, D0), w0 === null ? C0 = ye : w0.sibling = ye, w0 = ye);
        return l && _0.forEach(function(Of) {
          return A(E2, Of);
        }), Ct && O3(E2, D0), C0;
      }
      function _t(E2, p2, I2, Z2) {
        if (typeof I2 == "object" && I2 !== null && I2.type === k && I2.key === null && (I2 = I2.props.children), typeof I2 == "object" && I2 !== null) {
          switch (I2.$$typeof) {
            case w:
              e: {
                for (var C0 = I2.key, w0 = p2; w0 !== null; ) {
                  if (w0.key === C0) {
                    if (C0 = I2.type, C0 === k) {
                      if (w0.tag === 7) {
                        v(E2, w0.sibling), p2 = T(w0, I2.props.children), p2.return = E2, E2 = p2;
                        break e;
                      }
                    } else if (w0.elementType === C0 || typeof C0 == "object" && C0 !== null && C0.$$typeof === s2 && YA(C0) === w0.type) {
                      v(E2, w0.sibling), p2 = T(w0, I2.props), p2.ref = T3(E2, w0, I2), p2.return = E2, E2 = p2;
                      break e;
                    }
                    v(E2, w0);
                    break;
                  } else A(E2, w0);
                  w0 = w0.sibling;
                }
                I2.type === k ? (p2 = Y4(I2.props.children, E2.mode, Z2, I2.key), p2.return = E2, E2 = p2) : (Z2 = X7(I2.type, I2.key, I2.props, null, E2.mode, Z2), Z2.ref = T3(E2, p2, I2), Z2.return = E2, E2 = Z2);
              }
              return U(E2);
            case D:
              e: {
                for (w0 = I2.key; p2 !== null; ) {
                  if (p2.key === w0) if (p2.tag === 4 && p2.stateNode.containerInfo === I2.containerInfo && p2.stateNode.implementation === I2.implementation) {
                    v(E2, p2.sibling), p2 = T(p2, I2.children || []), p2.return = E2, E2 = p2;
                    break e;
                  } else {
                    v(E2, p2);
                    break;
                  }
                  else A(E2, p2);
                  p2 = p2.sibling;
                }
                p2 = so(I2, E2.mode, Z2), p2.return = E2, E2 = p2;
              }
              return U(E2);
            case s2:
              return w0 = I2._init, _t(E2, p2, w0(I2._payload), Z2);
          }
          if (Oe(I2)) return f0(E2, p2, I2, Z2);
          if (a2(I2)) return p0(E2, p2, I2, Z2);
          Sa(E2, I2);
        }
        return typeof I2 == "string" && I2 !== "" || typeof I2 == "number" ? (I2 = "" + I2, p2 !== null && p2.tag === 6 ? (v(E2, p2.sibling), p2 = T(p2, I2), p2.return = E2, E2 = p2) : (v(E2, p2), p2 = mu(I2, E2.mode, Z2), p2.return = E2, E2 = p2), U(E2)) : v(E2, p2);
      }
      return _t;
    }
    var bt = D3(!0), e0 = D3(!1), P1 = Dr(null), E1 = null, e6 = null, zs = null;
    function Us() {
      zs = e6 = E1 = null;
    }
    function qs(l) {
      var A = P1.current;
      ot(P1), l._currentValue = A;
    }
    function Ws(l, A, v) {
      for (; l !== null; ) {
        var x = l.alternate;
        if ((l.childLanes & A) !== A ? (l.childLanes |= A, x !== null && (x.childLanes |= A)) : x !== null && (x.childLanes & A) !== A && (x.childLanes |= A), l === v) break;
        l = l.return;
      }
    }
    function ht(l, A) {
      E1 = l, zs = e6 = null, l = l.dependencies, l !== null && l.firstContext !== null && ((l.lanes & A) !== 0 && (Ht = !0), l.firstContext = null);
    }
    function sr(l) {
      var A = l._currentValue;
      if (zs !== l) if (l = { context: l, memoizedValue: A, next: null }, e6 === null) {
        if (E1 === null) throw Error(r(308));
        e6 = l, E1.dependencies = { lanes: 0, firstContext: l };
      } else e6 = e6.next = l;
      return A;
    }
    var L3 = null;
    function Ys(l) {
      L3 === null ? L3 = [l] : L3.push(l);
    }
    function $s(l, A, v, x) {
      var T = A.interleaved;
      return T === null ? (v.next = v, Ys(A)) : (v.next = T.next, T.next = v), A.interleaved = v, F1(l, x);
    }
    function F1(l, A) {
      l.lanes |= A;
      var v = l.alternate;
      for (v !== null && (v.lanes |= A), v = l, l = l.return; l !== null; ) l.childLanes |= A, v = l.alternate, v !== null && (v.childLanes |= A), v = l, l = l.return;
      return v.tag === 3 ? v.stateNode : null;
    }
    var N1 = !1;
    function Gs(l) {
      l.updateQueue = { baseState: l.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
    }
    function $A(l, A) {
      l = l.updateQueue, A.updateQueue === l && (A.updateQueue = { baseState: l.baseState, firstBaseUpdate: l.firstBaseUpdate, lastBaseUpdate: l.lastBaseUpdate, shared: l.shared, effects: l.effects });
    }
    function Z4(l, A) {
      return { eventTime: l, lane: A, tag: 0, payload: null, callback: null, next: null };
    }
    function Fn(l, A, v) {
      var x = l.updateQueue;
      if (x === null) return null;
      if (x = x.shared, (ae & 2) !== 0) {
        var T = x.pending;
        return T === null ? A.next = A : (A.next = T.next, T.next = A), x.pending = A, F1(l, v);
      }
      return T = x.interleaved, T === null ? (A.next = A, Ys(x)) : (A.next = T.next, T.next = A), x.interleaved = A, F1(l, v);
    }
    function Ma(l, A, v) {
      if (A = A.updateQueue, A !== null && (A = A.shared, (v & 4194240) !== 0)) {
        var x = A.lanes;
        x &= l.pendingLanes, v |= x, A.lanes = v, L4(l, v);
      }
    }
    function GA(l, A) {
      var v = l.updateQueue, x = l.alternate;
      if (x !== null && (x = x.updateQueue, v === x)) {
        var T = null, R = null;
        if (v = v.firstBaseUpdate, v !== null) {
          do {
            var U = { eventTime: v.eventTime, lane: v.lane, tag: v.tag, payload: v.payload, callback: v.callback, next: null };
            R === null ? T = R = U : R = R.next = U, v = v.next;
          } while (v !== null);
          R === null ? T = R = A : R = R.next = A;
        } else T = R = A;
        v = { baseState: x.baseState, firstBaseUpdate: T, lastBaseUpdate: R, shared: x.shared, effects: x.effects }, l.updateQueue = v;
        return;
      }
      l = v.lastBaseUpdate, l === null ? v.firstBaseUpdate = A : l.next = A, v.lastBaseUpdate = A;
    }
    function B7(l, A, v, x) {
      var T = l.updateQueue;
      N1 = !1;
      var R = T.firstBaseUpdate, U = T.lastBaseUpdate, i2 = T.shared.pending;
      if (i2 !== null) {
        T.shared.pending = null;
        var A2 = i2, x2 = A2.next;
        A2.next = null, U === null ? R = x2 : U.next = x2, U = A2;
        var V2 = l.alternate;
        V2 !== null && (V2 = V2.updateQueue, i2 = V2.lastBaseUpdate, i2 !== U && (i2 === null ? V2.firstBaseUpdate = x2 : i2.next = x2, V2.lastBaseUpdate = A2));
      }
      if (R !== null) {
        var z2 = T.baseState;
        U = 0, V2 = x2 = A2 = null, i2 = R;
        do {
          var j2 = i2.lane, n0 = i2.eventTime;
          if ((x & j2) === j2) {
            V2 !== null && (V2 = V2.next = {
              eventTime: n0,
              lane: 0,
              tag: i2.tag,
              payload: i2.payload,
              callback: i2.callback,
              next: null
            });
            e: {
              var f0 = l, p0 = i2;
              switch (j2 = A, n0 = v, p0.tag) {
                case 1:
                  if (f0 = p0.payload, typeof f0 == "function") {
                    z2 = f0.call(n0, z2, j2);
                    break e;
                  }
                  z2 = f0;
                  break e;
                case 3:
                  f0.flags = f0.flags & -65537 | 128;
                case 0:
                  if (f0 = p0.payload, j2 = typeof f0 == "function" ? f0.call(n0, z2, j2) : f0, j2 == null) break e;
                  z2 = e2({}, z2, j2);
                  break e;
                case 2:
                  N1 = !0;
              }
            }
            i2.callback !== null && i2.lane !== 0 && (l.flags |= 64, j2 = T.effects, j2 === null ? T.effects = [i2] : j2.push(i2));
          } else n0 = { eventTime: n0, lane: j2, tag: i2.tag, payload: i2.payload, callback: i2.callback, next: null }, V2 === null ? (x2 = V2 = n0, A2 = z2) : V2 = V2.next = n0, U |= j2;
          if (i2 = i2.next, i2 === null) {
            if (i2 = T.shared.pending, i2 === null) break;
            j2 = i2, i2 = j2.next, j2.next = null, T.lastBaseUpdate = j2, T.shared.pending = null;
          }
        } while (!0);
        if (V2 === null && (A2 = z2), T.baseState = A2, T.firstBaseUpdate = x2, T.lastBaseUpdate = V2, A = T.shared.interleaved, A !== null) {
          T = A;
          do
            U |= T.lane, T = T.next;
          while (T !== A);
        } else R === null && (T.shared.lanes = 0);
        d4 |= U, l.lanes = U, l.memoizedState = z2;
      }
    }
    function Ks(l, A, v) {
      if (l = A.effects, A.effects = null, l !== null) for (A = 0; A < l.length; A++) {
        var x = l[A], T = x.callback;
        if (T !== null) {
          if (x.callback = null, x = v, typeof T != "function") throw Error(r(191, T));
          T.call(x);
        }
      }
    }
    var Q7 = {}, c4 = Dr(Q7), x7 = Dr(Q7), b7 = Dr(Q7);
    function k3(l) {
      if (l === Q7) throw Error(r(174));
      return l;
    }
    function Xs(l, A) {
      switch (y0(b7, A), y0(x7, l), y0(c4, Q7), l = A.nodeType, l) {
        case 9:
        case 11:
          A = (A = A.documentElement) ? A.namespaceURI : yt(null, "");
          break;
        default:
          l = l === 8 ? A.parentNode : A, A = l.namespaceURI || null, l = l.tagName, A = yt(A, l);
      }
      ot(c4), y0(c4, A);
    }
    function R3() {
      ot(c4), ot(x7), ot(b7);
    }
    function KA(l) {
      k3(b7.current);
      var A = k3(c4.current), v = yt(A, l.type);
      A !== v && (y0(x7, l), y0(c4, v));
    }
    function _a(l) {
      x7.current === l && (ot(c4), ot(x7));
    }
    var vt = Dr(0);
    function Oa(l) {
      for (var A = l; A !== null; ) {
        if (A.tag === 13) {
          var v = A.memoizedState;
          if (v !== null && (v = v.dehydrated, v === null || v.data === "$?" || v.data === "$!")) return A;
        } else if (A.tag === 19 && A.memoizedProps.revealOrder !== void 0) {
          if ((A.flags & 128) !== 0) return A;
        } else if (A.child !== null) {
          A.child.return = A, A = A.child;
          continue;
        }
        if (A === l) break;
        for (; A.sibling === null; ) {
          if (A.return === null || A.return === l) return null;
          A = A.return;
        }
        A.sibling.return = A.return, A = A.sibling;
      }
      return null;
    }
    var w7 = [];
    function B0() {
      for (var l = 0; l < w7.length; l++) w7[l]._workInProgressVersionPrimary = null;
      w7.length = 0;
    }
    var Y0 = O.ReactCurrentDispatcher, Ee = O.ReactCurrentBatchConfig, He = 0, me = null, Nt = null, s5 = null, Ta = !1, S7 = !1, P3 = 0, H2 = 0;
    function Ce() {
      throw Error(r(321));
    }
    function O0(l, A) {
      if (A === null) return !1;
      for (var v = 0; v < A.length && v < l.length; v++) if (!Or(l[v], A[v])) return !1;
      return !0;
    }
    function Nn(l, A, v, x, T, R) {
      if (He = R, me = A, A.memoizedState = null, A.updateQueue = null, A.lanes = 0, Y0.current = l === null || l.memoizedState === null ? Wa : L7, l = v(x, T), S7) {
        R = 0;
        do {
          if (S7 = !1, P3 = 0, 25 <= R) throw Error(r(301));
          R += 1, s5 = Nt = null, A.updateQueue = null, Y0.current = Ya, l = v(x, T);
        } while (S7);
      }
      if (Y0.current = V3, A = Nt !== null && Nt.next !== null, He = 0, s5 = Nt = me = null, Ta = !1, A) throw Error(r(300));
      return l;
    }
    function Lr() {
      var l = P3 !== 0;
      return P3 = 0, l;
    }
    function L5() {
      var l = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
      return s5 === null ? me.memoizedState = s5 = l : s5 = s5.next = l, s5;
    }
    function wt() {
      if (Nt === null) {
        var l = me.alternate;
        l = l !== null ? l.memoizedState : null;
      } else l = Nt.next;
      var A = s5 === null ? me.memoizedState : s5.next;
      if (A !== null) s5 = A, Nt = l;
      else {
        if (l === null) throw Error(r(310));
        Nt = l, l = { memoizedState: Nt.memoizedState, baseState: Nt.baseState, baseQueue: Nt.baseQueue, queue: Nt.queue, next: null }, s5 === null ? me.memoizedState = s5 = l : s5 = s5.next = l;
      }
      return s5;
    }
    function z4(l, A) {
      return typeof A == "function" ? A(l) : A;
    }
    function Hn(l) {
      var A = wt(), v = A.queue;
      if (v === null) throw Error(r(311));
      v.lastRenderedReducer = l;
      var x = Nt, T = x.baseQueue, R = v.pending;
      if (R !== null) {
        if (T !== null) {
          var U = T.next;
          T.next = R.next, R.next = U;
        }
        x.baseQueue = T = R, v.pending = null;
      }
      if (T !== null) {
        R = T.next, x = x.baseState;
        var i2 = U = null, A2 = null, x2 = R;
        do {
          var V2 = x2.lane;
          if ((He & V2) === V2) A2 !== null && (A2 = A2.next = { lane: 0, action: x2.action, hasEagerState: x2.hasEagerState, eagerState: x2.eagerState, next: null }), x = x2.hasEagerState ? x2.eagerState : l(x, x2.action);
          else {
            var z2 = {
              lane: V2,
              action: x2.action,
              hasEagerState: x2.hasEagerState,
              eagerState: x2.eagerState,
              next: null
            };
            A2 === null ? (i2 = A2 = z2, U = x) : A2 = A2.next = z2, me.lanes |= V2, d4 |= V2;
          }
          x2 = x2.next;
        } while (x2 !== null && x2 !== R);
        A2 === null ? U = x : A2.next = i2, Or(x, A.memoizedState) || (Ht = !0), A.memoizedState = x, A.baseState = U, A.baseQueue = A2, v.lastRenderedState = x;
      }
      if (l = v.interleaved, l !== null) {
        T = l;
        do
          R = T.lane, me.lanes |= R, d4 |= R, T = T.next;
        while (T !== l);
      } else T === null && (v.lanes = 0);
      return [A.memoizedState, v.dispatch];
    }
    function F3(l) {
      var A = wt(), v = A.queue;
      if (v === null) throw Error(r(311));
      v.lastRenderedReducer = l;
      var x = v.dispatch, T = v.pending, R = A.memoizedState;
      if (T !== null) {
        v.pending = null;
        var U = T = T.next;
        do
          R = l(R, U.action), U = U.next;
        while (U !== T);
        Or(R, A.memoizedState) || (Ht = !0), A.memoizedState = R, A.baseQueue === null && (A.baseState = R), v.lastRenderedState = R;
      }
      return [R, x];
    }
    function Da() {
    }
    function La(l, A) {
      var v = me, x = wt(), T = A(), R = !Or(x.memoizedState, T);
      if (R && (x.memoizedState = T, Ht = !0), x = x.queue, M7(Pa.bind(null, v, x, l), [l]), x.getSnapshot !== A || R || s5 !== null && s5.memoizedState.tag & 1) {
        if (v.flags |= 2048, N3(9, Ra.bind(null, v, x, T, A), void 0, null), t5 === null) throw Error(r(349));
        (He & 30) !== 0 || ka(v, A, T);
      }
      return T;
    }
    function ka(l, A, v) {
      l.flags |= 16384, l = { getSnapshot: A, value: v }, A = me.updateQueue, A === null ? (A = { lastEffect: null, stores: null }, me.updateQueue = A, A.stores = [l]) : (v = A.stores, v === null ? A.stores = [l] : v.push(l));
    }
    function Ra(l, A, v, x) {
      A.value = v, A.getSnapshot = x, Fa(A) && Na(l);
    }
    function Pa(l, A, v) {
      return v(function() {
        Fa(A) && Na(l);
      });
    }
    function Fa(l) {
      var A = l.getSnapshot;
      l = l.value;
      try {
        var v = A();
        return !Or(l, v);
      } catch {
        return !0;
      }
    }
    function Na(l) {
      var A = F1(l, 1);
      A !== null && G5(A, l, 1, -1);
    }
    function Ha(l) {
      var A = L5();
      return typeof l == "function" && (l = l()), A.memoizedState = A.baseState = l, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: z4, lastRenderedState: l }, A.queue = l, l = l.dispatch = j3.bind(null, me, l), [A.memoizedState, l];
    }
    function N3(l, A, v, x) {
      return l = { tag: l, create: A, destroy: v, deps: x, next: null }, A = me.updateQueue, A === null ? (A = { lastEffect: null, stores: null }, me.updateQueue = A, A.lastEffect = l.next = l) : (v = A.lastEffect, v === null ? A.lastEffect = l.next = l : (x = v.next, v.next = l, l.next = x, A.lastEffect = l)), l;
    }
    function ja() {
      return wt().memoizedState;
    }
    function t6(l, A, v, x) {
      var T = L5();
      me.flags |= l, T.memoizedState = N3(1 | A, v, void 0, x === void 0 ? null : x);
    }
    function r6(l, A, v, x) {
      var T = wt();
      x = x === void 0 ? null : x;
      var R = void 0;
      if (Nt !== null) {
        var U = Nt.memoizedState;
        if (R = U.destroy, x !== null && O0(x, U.deps)) {
          T.memoizedState = N3(A, v, R, x);
          return;
        }
      }
      me.flags |= l, T.memoizedState = N3(1 | A, v, R, x);
    }
    function Va(l, A) {
      return t6(8390656, 8, l, A);
    }
    function M7(l, A) {
      return r6(2048, 8, l, A);
    }
    function Za(l, A) {
      return r6(4, 2, l, A);
    }
    function _7(l, A) {
      return r6(4, 4, l, A);
    }
    function H3(l, A) {
      if (typeof A == "function") return l = l(), A(l), function() {
        A(null);
      };
      if (A != null) return l = l(), A.current = l, function() {
        A.current = null;
      };
    }
    function za(l, A, v) {
      return v = v != null ? v.concat([l]) : null, r6(4, 4, H3.bind(null, A, l), v);
    }
    function O7() {
    }
    function Ua(l, A) {
      var v = wt();
      A = A === void 0 ? null : A;
      var x = v.memoizedState;
      return x !== null && A !== null && O0(A, x[1]) ? x[0] : (v.memoizedState = [l, A], l);
    }
    function qa(l, A) {
      var v = wt();
      A = A === void 0 ? null : A;
      var x = v.memoizedState;
      return x !== null && A !== null && O0(A, x[1]) ? x[0] : (l = l(), v.memoizedState = [l, A], l);
    }
    function Js(l, A, v) {
      return (He & 21) === 0 ? (l.baseState && (l.baseState = !1, Ht = !0), l.memoizedState = v) : (Or(v, A) || (v = k8(), me.lanes |= v, d4 |= v, l.baseState = !0), A);
    }
    function T7(l, A) {
      var v = ve;
      ve = v !== 0 && 4 > v ? v : 4, l(!0);
      var x = Ee.transition;
      Ee.transition = {};
      try {
        l(!1), A();
      } finally {
        ve = v, Ee.transition = x;
      }
    }
    function eu() {
      return wt().memoizedState;
    }
    function D7(l, A, v) {
      var x = g4(l);
      if (v = { lane: x, action: v, hasEagerState: !1, eagerState: null, next: null }, H1(l)) XA(A, v);
      else if (v = $s(l, A, v, x), v !== null) {
        var T = Zt();
        G5(v, l, x, T), Xe(v, A, x);
      }
    }
    function j3(l, A, v) {
      var x = g4(l), T = { lane: x, action: v, hasEagerState: !1, eagerState: null, next: null };
      if (H1(l)) XA(A, T);
      else {
        var R = l.alternate;
        if (l.lanes === 0 && (R === null || R.lanes === 0) && (R = A.lastRenderedReducer, R !== null)) try {
          var U = A.lastRenderedState, i2 = R(U, v);
          if (T.hasEagerState = !0, T.eagerState = i2, Or(i2, U)) {
            var A2 = A.interleaved;
            A2 === null ? (T.next = T, Ys(A)) : (T.next = A2.next, A2.next = T), A.interleaved = T;
            return;
          }
        } catch {
        } finally {
        }
        v = $s(l, A, T, x), v !== null && (T = Zt(), G5(v, l, x, T), Xe(v, A, x));
      }
    }
    function H1(l) {
      var A = l.alternate;
      return l === me || A !== null && A === me;
    }
    function XA(l, A) {
      S7 = Ta = !0;
      var v = l.pending;
      v === null ? A.next = A : (A.next = v.next, v.next = A), l.pending = A;
    }
    function Xe(l, A, v) {
      if ((v & 4194240) !== 0) {
        var x = A.lanes;
        x &= l.pendingLanes, v |= x, A.lanes = v, L4(l, v);
      }
    }
    var V3 = { readContext: sr, useCallback: Ce, useContext: Ce, useEffect: Ce, useImperativeHandle: Ce, useInsertionEffect: Ce, useLayoutEffect: Ce, useMemo: Ce, useReducer: Ce, useRef: Ce, useState: Ce, useDebugValue: Ce, useDeferredValue: Ce, useTransition: Ce, useMutableSource: Ce, useSyncExternalStore: Ce, useId: Ce, unstable_isNewReconciler: !1 }, Wa = { readContext: sr, useCallback: function(l, A) {
      return L5().memoizedState = [l, A === void 0 ? null : A], l;
    }, useContext: sr, useEffect: Va, useImperativeHandle: function(l, A, v) {
      return v = v != null ? v.concat([l]) : null, t6(
        4194308,
        4,
        H3.bind(null, A, l),
        v
      );
    }, useLayoutEffect: function(l, A) {
      return t6(4194308, 4, l, A);
    }, useInsertionEffect: function(l, A) {
      return t6(4, 2, l, A);
    }, useMemo: function(l, A) {
      var v = L5();
      return A = A === void 0 ? null : A, l = l(), v.memoizedState = [l, A], l;
    }, useReducer: function(l, A, v) {
      var x = L5();
      return A = v !== void 0 ? v(A) : A, x.memoizedState = x.baseState = A, l = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: l, lastRenderedState: A }, x.queue = l, l = l.dispatch = D7.bind(null, me, l), [x.memoizedState, l];
    }, useRef: function(l) {
      var A = L5();
      return l = { current: l }, A.memoizedState = l;
    }, useState: Ha, useDebugValue: O7, useDeferredValue: function(l) {
      return L5().memoizedState = l;
    }, useTransition: function() {
      var l = Ha(!1), A = l[0];
      return l = T7.bind(null, l[1]), L5().memoizedState = l, [A, l];
    }, useMutableSource: function() {
    }, useSyncExternalStore: function(l, A, v) {
      var x = me, T = L5();
      if (Ct) {
        if (v === void 0) throw Error(r(407));
        v = v();
      } else {
        if (v = A(), t5 === null) throw Error(r(349));
        (He & 30) !== 0 || ka(x, A, v);
      }
      T.memoizedState = v;
      var R = { value: v, getSnapshot: A };
      return T.queue = R, Va(Pa.bind(
        null,
        x,
        R,
        l
      ), [l]), x.flags |= 2048, N3(9, Ra.bind(null, x, R, v, A), void 0, null), v;
    }, useId: function() {
      var l = L5(), A = t5.identifierPrefix;
      if (Ct) {
        var v = l4, x = u4;
        v = (x & ~(1 << 32 - z5(x) - 1)).toString(32) + v, A = ":" + A + "R" + v, v = P3++, 0 < v && (A += "H" + v.toString(32)), A += ":";
      } else v = H2++, A = ":" + A + "r" + v.toString(32) + ":";
      return l.memoizedState = A;
    }, unstable_isNewReconciler: !1 }, L7 = {
      readContext: sr,
      useCallback: Ua,
      useContext: sr,
      useEffect: M7,
      useImperativeHandle: za,
      useInsertionEffect: Za,
      useLayoutEffect: _7,
      useMemo: qa,
      useReducer: Hn,
      useRef: ja,
      useState: function() {
        return Hn(z4);
      },
      useDebugValue: O7,
      useDeferredValue: function(l) {
        var A = wt();
        return Js(A, Nt.memoizedState, l);
      },
      useTransition: function() {
        var l = Hn(z4)[0], A = wt().memoizedState;
        return [l, A];
      },
      useMutableSource: Da,
      useSyncExternalStore: La,
      useId: eu,
      unstable_isNewReconciler: !1
    }, Ya = { readContext: sr, useCallback: Ua, useContext: sr, useEffect: M7, useImperativeHandle: za, useInsertionEffect: Za, useLayoutEffect: _7, useMemo: qa, useReducer: F3, useRef: ja, useState: function() {
      return F3(z4);
    }, useDebugValue: O7, useDeferredValue: function(l) {
      var A = wt();
      return Nt === null ? A.memoizedState = l : Js(A, Nt.memoizedState, l);
    }, useTransition: function() {
      var l = F3(z4)[0], A = wt().memoizedState;
      return [l, A];
    }, useMutableSource: Da, useSyncExternalStore: La, useId: eu, unstable_isNewReconciler: !1 };
    function kr(l, A) {
      if (l && l.defaultProps) {
        A = e2({}, A), l = l.defaultProps;
        for (var v in l) A[v] === void 0 && (A[v] = l[v]);
        return A;
      }
      return A;
    }
    function tu(l, A, v, x) {
      A = l.memoizedState, v = v(x, A), v = v == null ? A : e2({}, A, v), l.memoizedState = v, l.lanes === 0 && (l.updateQueue.baseState = v);
    }
    var $a = { isMounted: function(l) {
      return (l = l._reactInternals) ? H0(l) === l : !1;
    }, enqueueSetState: function(l, A, v) {
      l = l._reactInternals;
      var x = Zt(), T = g4(l), R = Z4(x, T);
      R.payload = A, v != null && (R.callback = v), A = Fn(l, R, T), A !== null && (G5(A, l, T, x), Ma(A, l, T));
    }, enqueueReplaceState: function(l, A, v) {
      l = l._reactInternals;
      var x = Zt(), T = g4(l), R = Z4(x, T);
      R.tag = 1, R.payload = A, v != null && (R.callback = v), A = Fn(l, R, T), A !== null && (G5(A, l, T, x), Ma(A, l, T));
    }, enqueueForceUpdate: function(l, A) {
      l = l._reactInternals;
      var v = Zt(), x = g4(l), T = Z4(v, x);
      T.tag = 2, A != null && (T.callback = A), A = Fn(l, T, x), A !== null && (G5(A, l, x, v), Ma(A, l, x));
    } };
    function JA(l, A, v, x, T, R, U) {
      return l = l.stateNode, typeof l.shouldComponentUpdate == "function" ? l.shouldComponentUpdate(x, R, U) : A.prototype && A.prototype.isPureReactComponent ? !C7(v, x) || !C7(T, R) : !0;
    }
    function Ga(l, A, v) {
      var x = !1, T = d1, R = A.contextType;
      return typeof R == "object" && R !== null ? R = sr(R) : (T = Pt(A) ? g1 : It.current, x = A.contextTypes, R = (x = x != null) ? ir(l, T) : d1), A = new A(v, R), l.memoizedState = A.state !== null && A.state !== void 0 ? A.state : null, A.updater = $a, l.stateNode = A, A._reactInternals = l, x && (l = l.stateNode, l.__reactInternalMemoizedUnmaskedChildContext = T, l.__reactInternalMemoizedMaskedChildContext = R), A;
    }
    function ef(l, A, v, x) {
      l = A.state, typeof A.componentWillReceiveProps == "function" && A.componentWillReceiveProps(v, x), typeof A.UNSAFE_componentWillReceiveProps == "function" && A.UNSAFE_componentWillReceiveProps(v, x), A.state !== l && $a.enqueueReplaceState(A, A.state, null);
    }
    function k7(l, A, v, x) {
      var T = l.stateNode;
      T.props = v, T.state = l.memoizedState, T.refs = {}, Gs(l);
      var R = A.contextType;
      typeof R == "object" && R !== null ? T.context = sr(R) : (R = Pt(A) ? g1 : It.current, T.context = ir(l, R)), T.state = l.memoizedState, R = A.getDerivedStateFromProps, typeof R == "function" && (tu(l, A, R, v), T.state = l.memoizedState), typeof A.getDerivedStateFromProps == "function" || typeof T.getSnapshotBeforeUpdate == "function" || typeof T.UNSAFE_componentWillMount != "function" && typeof T.componentWillMount != "function" || (A = T.state, typeof T.componentWillMount == "function" && T.componentWillMount(), typeof T.UNSAFE_componentWillMount == "function" && T.UNSAFE_componentWillMount(), A !== T.state && $a.enqueueReplaceState(T, T.state, null), B7(l, v, T, x), T.state = l.memoizedState), typeof T.componentDidMount == "function" && (l.flags |= 4194308);
    }
    function Z3(l, A) {
      try {
        var v = "", x = A;
        do
          v += O2(x), x = x.return;
        while (x);
        var T = v;
      } catch (R) {
        T = `
Error generating stack: ` + R.message + `
` + R.stack;
      }
      return { value: l, source: A, stack: T, digest: null };
    }
    function ru(l, A, v) {
      return { value: l, source: null, stack: v ?? null, digest: A ?? null };
    }
    function nu(l, A) {
      try {
        console.error(A.value);
      } catch (v) {
        setTimeout(function() {
          throw v;
        });
      }
    }
    var Ka = typeof WeakMap == "function" ? WeakMap : Map;
    function tf(l, A, v) {
      v = Z4(-1, v), v.tag = 3, v.payload = { element: null };
      var x = A.value;
      return v.callback = function() {
        u6 || (u6 = !0, q3 = x), nu(l, A);
      }, v;
    }
    function iu(l, A, v) {
      v = Z4(-1, v), v.tag = 3;
      var x = l.type.getDerivedStateFromError;
      if (typeof x == "function") {
        var T = A.value;
        v.payload = function() {
          return x(T);
        }, v.callback = function() {
          nu(l, A);
        };
      }
      var R = l.stateNode;
      return R !== null && typeof R.componentDidCatch == "function" && (v.callback = function() {
        nu(l, A), typeof x != "function" && (Zn === null ? Zn = /* @__PURE__ */ new Set([this]) : Zn.add(this));
        var U = A.stack;
        this.componentDidCatch(A.value, { componentStack: U !== null ? U : "" });
      }), v;
    }
    function au(l, A, v) {
      var x = l.pingCache;
      if (x === null) {
        x = l.pingCache = new Ka();
        var T = /* @__PURE__ */ new Set();
        x.set(A, T);
      } else T = x.get(A), T === void 0 && (T = /* @__PURE__ */ new Set(), x.set(A, T));
      T.has(v) || (T.add(v), l = pv.bind(null, l, A, v), A.then(l, l));
    }
    function rf(l) {
      do {
        var A;
        if ((A = l.tag === 13) && (A = l.memoizedState, A = A !== null ? A.dehydrated !== null : !0), A) return l;
        l = l.return;
      } while (l !== null);
      return null;
    }
    function jn(l, A, v, x, T) {
      return (l.mode & 1) === 0 ? (l === A ? l.flags |= 65536 : (l.flags |= 128, v.flags |= 131072, v.flags &= -52805, v.tag === 1 && (v.alternate === null ? v.tag = 17 : (A = Z4(-1, 1), A.tag = 2, Fn(v, A, 1))), v.lanes |= 1), l) : (l.flags |= 65536, l.lanes = T, l);
    }
    var R7 = O.ReactCurrentOwner, Ht = !1;
    function E5(l, A, v, x) {
      A.child = l === null ? e0(A, null, v, x) : bt(A, l.child, v, x);
    }
    function m1(l, A, v, x, T) {
      v = v.render;
      var R = A.ref;
      return ht(A, T), x = Nn(l, A, v, x, R, T), v = Lr(), l !== null && !Ht ? (A.updateQueue = l.updateQueue, A.flags &= -2053, l.lanes &= ~T, lr(l, A, T)) : (Ct && v && xa(A), A.flags |= 1, E5(l, A, x, T), A.child);
    }
    function z3(l, A, v, x, T) {
      if (l === null) {
        var R = v.type;
        return typeof R == "function" && !Eu(R) && R.defaultProps === void 0 && v.compare === null && v.defaultProps === void 0 ? (A.tag = 15, A.type = R, V0(l, A, R, x, T)) : (l = X7(v.type, null, x, A, A.mode, T), l.ref = A.ref, l.return = A, A.child = l);
      }
      if (R = l.child, (l.lanes & T) === 0) {
        var U = R.memoizedProps;
        if (v = v.compare, v = v !== null ? v : C7, v(U, x) && l.ref === A.ref) return lr(l, A, T);
      }
      return A.flags |= 1, l = Un(R, x), l.ref = A.ref, l.return = A, A.child = l;
    }
    function V0(l, A, v, x, T) {
      if (l !== null) {
        var R = l.memoizedProps;
        if (C7(R, x) && l.ref === A.ref) if (Ht = !1, A.pendingProps = x = R, (l.lanes & T) !== 0) (l.flags & 131072) !== 0 && (Ht = !0);
        else return A.lanes = l.lanes, lr(l, A, T);
      }
      return nf(l, A, v, x, T);
    }
    function P7(l, A, v) {
      var x = A.pendingProps, T = x.children, R = l !== null ? l.memoizedState : null;
      if (x.mode === "hidden") if ((A.mode & 1) === 0) A.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, y0(a6, j1), j1 |= v;
      else {
        if ((v & 1073741824) === 0) return l = R !== null ? R.baseLanes | v : v, A.lanes = A.childLanes = 1073741824, A.memoizedState = { baseLanes: l, cachePool: null, transitions: null }, A.updateQueue = null, y0(a6, j1), j1 |= l, null;
        A.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, x = R !== null ? R.baseLanes : v, y0(a6, j1), j1 |= x;
      }
      else R !== null ? (x = R.baseLanes | v, A.memoizedState = null) : x = v, y0(a6, j1), j1 |= x;
      return E5(l, A, T, v), A.child;
    }
    function ou(l, A) {
      var v = A.ref;
      (l === null && v !== null || l !== null && l.ref !== v) && (A.flags |= 512, A.flags |= 2097152);
    }
    function nf(l, A, v, x, T) {
      var R = Pt(v) ? g1 : It.current;
      return R = ir(A, R), ht(A, T), v = Nn(l, A, v, x, R, T), x = Lr(), l !== null && !Ht ? (A.updateQueue = l.updateQueue, A.flags &= -2053, l.lanes &= ~T, lr(l, A, T)) : (Ct && x && xa(A), A.flags |= 1, E5(l, A, v, T), A.child);
    }
    function af(l, A, v, x, T) {
      if (Pt(v)) {
        var R = !0;
        p1(A);
      } else R = !1;
      if (ht(A, T), A.stateNode === null) ur(l, A), Ga(A, v, x), k7(A, v, x, T), x = !0;
      else if (l === null) {
        var U = A.stateNode, i2 = A.memoizedProps;
        U.props = i2;
        var A2 = U.context, x2 = v.contextType;
        typeof x2 == "object" && x2 !== null ? x2 = sr(x2) : (x2 = Pt(v) ? g1 : It.current, x2 = ir(A, x2));
        var V2 = v.getDerivedStateFromProps, z2 = typeof V2 == "function" || typeof U.getSnapshotBeforeUpdate == "function";
        z2 || typeof U.UNSAFE_componentWillReceiveProps != "function" && typeof U.componentWillReceiveProps != "function" || (i2 !== x || A2 !== x2) && ef(A, U, x, x2), N1 = !1;
        var j2 = A.memoizedState;
        U.state = j2, B7(A, x, U, T), A2 = A.memoizedState, i2 !== x || j2 !== A2 || Jt.current || N1 ? (typeof V2 == "function" && (tu(A, v, V2, x), A2 = A.memoizedState), (i2 = N1 || JA(A, v, i2, x, j2, A2, x2)) ? (z2 || typeof U.UNSAFE_componentWillMount != "function" && typeof U.componentWillMount != "function" || (typeof U.componentWillMount == "function" && U.componentWillMount(), typeof U.UNSAFE_componentWillMount == "function" && U.UNSAFE_componentWillMount()), typeof U.componentDidMount == "function" && (A.flags |= 4194308)) : (typeof U.componentDidMount == "function" && (A.flags |= 4194308), A.memoizedProps = x, A.memoizedState = A2), U.props = x, U.state = A2, U.context = x2, x = i2) : (typeof U.componentDidMount == "function" && (A.flags |= 4194308), x = !1);
      } else {
        U = A.stateNode, $A(l, A), i2 = A.memoizedProps, x2 = A.type === A.elementType ? i2 : kr(A.type, i2), U.props = x2, z2 = A.pendingProps, j2 = U.context, A2 = v.contextType, typeof A2 == "object" && A2 !== null ? A2 = sr(A2) : (A2 = Pt(v) ? g1 : It.current, A2 = ir(A, A2));
        var n0 = v.getDerivedStateFromProps;
        (V2 = typeof n0 == "function" || typeof U.getSnapshotBeforeUpdate == "function") || typeof U.UNSAFE_componentWillReceiveProps != "function" && typeof U.componentWillReceiveProps != "function" || (i2 !== z2 || j2 !== A2) && ef(A, U, x, A2), N1 = !1, j2 = A.memoizedState, U.state = j2, B7(A, x, U, T);
        var f0 = A.memoizedState;
        i2 !== z2 || j2 !== f0 || Jt.current || N1 ? (typeof n0 == "function" && (tu(A, v, n0, x), f0 = A.memoizedState), (x2 = N1 || JA(A, v, x2, x, j2, f0, A2) || !1) ? (V2 || typeof U.UNSAFE_componentWillUpdate != "function" && typeof U.componentWillUpdate != "function" || (typeof U.componentWillUpdate == "function" && U.componentWillUpdate(x, f0, A2), typeof U.UNSAFE_componentWillUpdate == "function" && U.UNSAFE_componentWillUpdate(x, f0, A2)), typeof U.componentDidUpdate == "function" && (A.flags |= 4), typeof U.getSnapshotBeforeUpdate == "function" && (A.flags |= 1024)) : (typeof U.componentDidUpdate != "function" || i2 === l.memoizedProps && j2 === l.memoizedState || (A.flags |= 4), typeof U.getSnapshotBeforeUpdate != "function" || i2 === l.memoizedProps && j2 === l.memoizedState || (A.flags |= 1024), A.memoizedProps = x, A.memoizedState = f0), U.props = x, U.state = f0, U.context = A2, x = x2) : (typeof U.componentDidUpdate != "function" || i2 === l.memoizedProps && j2 === l.memoizedState || (A.flags |= 4), typeof U.getSnapshotBeforeUpdate != "function" || i2 === l.memoizedProps && j2 === l.memoizedState || (A.flags |= 1024), x = !1);
      }
      return F7(l, A, v, x, R, T);
    }
    function F7(l, A, v, x, T, R) {
      ou(l, A);
      var U = (A.flags & 128) !== 0;
      if (!x && !U) return T && Ba(A, v, !1), lr(l, A, R);
      x = A.stateNode, R7.current = A;
      var i2 = U && typeof v.getDerivedStateFromError != "function" ? null : x.render();
      return A.flags |= 1, l !== null && U ? (A.child = bt(A, l.child, null, R), A.child = bt(A, null, i2, R)) : E5(l, A, i2, R), A.memoizedState = x.state, T && Ba(A, v, !0), A.child;
    }
    function n6(l) {
      var A = l.stateNode;
      A.pendingContext ? UA(l, A.pendingContext, A.pendingContext !== A.context) : A.context && UA(l, A.context, !1), Xs(l, A.containerInfo);
    }
    function of(l, A, v, x, T) {
      return Pn(), V4(T), A.flags |= 256, E5(l, A, v, x), A.child;
    }
    var Xa = { dehydrated: null, treeContext: null, retryLane: 0 };
    function su(l) {
      return { baseLanes: l, cachePool: null, transitions: null };
    }
    function Ja(l, A, v) {
      var x = A.pendingProps, T = vt.current, R = !1, U = (A.flags & 128) !== 0, i2;
      if ((i2 = U) || (i2 = l !== null && l.memoizedState === null ? !1 : (T & 2) !== 0), i2 ? (R = !0, A.flags &= -129) : (l === null || l.memoizedState !== null) && (T |= 1), y0(vt, T & 1), l === null)
        return Zs(A), l = A.memoizedState, l !== null && (l = l.dehydrated, l !== null) ? ((A.mode & 1) === 0 ? A.lanes = 1 : l.data === "$!" ? A.lanes = 8 : A.lanes = 1073741824, null) : (U = x.children, l = x.fallback, R ? (x = A.mode, R = A.child, U = { mode: "hidden", children: U }, (x & 1) === 0 && R !== null ? (R.childLanes = 0, R.pendingProps = U) : R = qn(U, x, 0, null), l = Y4(l, x, v, null), R.return = A, l.return = A, R.sibling = l, A.child = R, A.child.memoizedState = su(v), A.memoizedState = Xa, l) : uu(A, U));
      if (T = l.memoizedState, T !== null && (i2 = T.dehydrated, i2 !== null)) return sf(l, A, U, x, i2, T, v);
      if (R) {
        R = x.fallback, U = A.mode, T = l.child, i2 = T.sibling;
        var A2 = { mode: "hidden", children: x.children };
        return (U & 1) === 0 && A.child !== T ? (x = A.child, x.childLanes = 0, x.pendingProps = A2, A.deletions = null) : (x = Un(T, A2), x.subtreeFlags = T.subtreeFlags & 14680064), i2 !== null ? R = Un(i2, R) : (R = Y4(R, U, v, null), R.flags |= 2), R.return = A, x.return = A, x.sibling = R, A.child = x, x = R, R = A.child, U = l.child.memoizedState, U = U === null ? su(v) : { baseLanes: U.baseLanes | v, cachePool: null, transitions: U.transitions }, R.memoizedState = U, R.childLanes = l.childLanes & ~v, A.memoizedState = Xa, x;
      }
      return R = l.child, l = R.sibling, x = Un(R, { mode: "visible", children: x.children }), (A.mode & 1) === 0 && (x.lanes = v), x.return = A, x.sibling = null, l !== null && (v = A.deletions, v === null ? (A.deletions = [l], A.flags |= 16) : v.push(l)), A.child = x, A.memoizedState = null, x;
    }
    function uu(l, A) {
      return A = qn({ mode: "visible", children: A }, l.mode, 0, null), A.return = l, l.child = A;
    }
    function N7(l, A, v, x) {
      return x !== null && V4(x), bt(A, l.child, null, v), l = uu(A, A.pendingProps.children), l.flags |= 2, A.memoizedState = null, l;
    }
    function sf(l, A, v, x, T, R, U) {
      if (v)
        return A.flags & 256 ? (A.flags &= -257, x = ru(Error(r(422))), N7(l, A, U, x)) : A.memoizedState !== null ? (A.child = l.child, A.flags |= 128, null) : (R = x.fallback, T = A.mode, x = qn({ mode: "visible", children: x.children }, T, 0, null), R = Y4(R, T, U, null), R.flags |= 2, x.return = A, R.return = A, x.sibling = R, A.child = x, (A.mode & 1) !== 0 && bt(A, l.child, null, U), A.child.memoizedState = su(U), A.memoizedState = Xa, R);
      if ((A.mode & 1) === 0) return N7(l, A, U, null);
      if (T.data === "$!") {
        if (x = T.nextSibling && T.nextSibling.dataset, x) var i2 = x.dgst;
        return x = i2, R = Error(r(419)), x = ru(R, x, void 0), N7(l, A, U, x);
      }
      if (i2 = (U & l.childLanes) !== 0, Ht || i2) {
        if (x = t5, x !== null) {
          switch (U & -U) {
            case 4:
              T = 2;
              break;
            case 16:
              T = 8;
              break;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              T = 32;
              break;
            case 536870912:
              T = 268435456;
              break;
            default:
              T = 0;
          }
          T = (T & (x.suspendedLanes | U)) !== 0 ? 0 : T, T !== 0 && T !== R.retryLane && (R.retryLane = T, F1(l, T), G5(x, l, T, -1));
        }
        return vu(), x = ru(Error(r(421))), N7(l, A, U, x);
      }
      return T.data === "$?" ? (A.flags |= 128, A.child = l.child, A = hv.bind(null, l), T._reactRetry = A, null) : (l = R.treeContext, v1 = i4(T.nextSibling), h1 = A, Ct = !0, or = null, l !== null && (Ft[ar++] = u4, Ft[ar++] = l4, Ft[ar++] = R1, u4 = l.id, l4 = l.overflow, R1 = A), A = uu(A, x.children), A.flags |= 4096, A);
    }
    function lu(l, A, v) {
      l.lanes |= A;
      var x = l.alternate;
      x !== null && (x.lanes |= A), Ws(l.return, A, v);
    }
    function W5(l, A, v, x, T) {
      var R = l.memoizedState;
      R === null ? l.memoizedState = { isBackwards: A, rendering: null, renderingStartTime: 0, last: x, tail: v, tailMode: T } : (R.isBackwards = A, R.rendering = null, R.renderingStartTime = 0, R.last = x, R.tail = v, R.tailMode = T);
    }
    function A4(l, A, v) {
      var x = A.pendingProps, T = x.revealOrder, R = x.tail;
      if (E5(l, A, x.children, v), x = vt.current, (x & 2) !== 0) x = x & 1 | 2, A.flags |= 128;
      else {
        if (l !== null && (l.flags & 128) !== 0) e: for (l = A.child; l !== null; ) {
          if (l.tag === 13) l.memoizedState !== null && lu(l, v, A);
          else if (l.tag === 19) lu(l, v, A);
          else if (l.child !== null) {
            l.child.return = l, l = l.child;
            continue;
          }
          if (l === A) break e;
          for (; l.sibling === null; ) {
            if (l.return === null || l.return === A) break e;
            l = l.return;
          }
          l.sibling.return = l.return, l = l.sibling;
        }
        x &= 1;
      }
      if (y0(vt, x), (A.mode & 1) === 0) A.memoizedState = null;
      else switch (T) {
        case "forwards":
          for (v = A.child, T = null; v !== null; ) l = v.alternate, l !== null && Oa(l) === null && (T = v), v = v.sibling;
          v = T, v === null ? (T = A.child, A.child = null) : (T = v.sibling, v.sibling = null), W5(A, !1, T, v, R);
          break;
        case "backwards":
          for (v = null, T = A.child, A.child = null; T !== null; ) {
            if (l = T.alternate, l !== null && Oa(l) === null) {
              A.child = T;
              break;
            }
            l = T.sibling, T.sibling = v, v = T, T = l;
          }
          W5(A, !0, v, null, R);
          break;
        case "together":
          W5(A, !1, null, null, void 0);
          break;
        default:
          A.memoizedState = null;
      }
      return A.child;
    }
    function ur(l, A) {
      (A.mode & 1) === 0 && l !== null && (l.alternate = null, A.alternate = null, A.flags |= 2);
    }
    function lr(l, A, v) {
      if (l !== null && (A.dependencies = l.dependencies), d4 |= A.lanes, (v & A.childLanes) === 0) return null;
      if (l !== null && A.child !== l.child) throw Error(r(153));
      if (A.child !== null) {
        for (l = A.child, v = Un(l, l.pendingProps), A.child = v, v.return = A; l.sibling !== null; ) l = l.sibling, v = v.sibling = Un(l, l.pendingProps), v.return = A;
        v.sibling = null;
      }
      return A.child;
    }
    function H7(l, A, v) {
      switch (A.tag) {
        case 3:
          n6(A), Pn();
          break;
        case 5:
          KA(A);
          break;
        case 1:
          Pt(A.type) && p1(A);
          break;
        case 4:
          Xs(A, A.stateNode.containerInfo);
          break;
        case 10:
          var x = A.type._context, T = A.memoizedProps.value;
          y0(P1, x._currentValue), x._currentValue = T;
          break;
        case 13:
          if (x = A.memoizedState, x !== null)
            return x.dehydrated !== null ? (y0(vt, vt.current & 1), A.flags |= 128, null) : (v & A.child.childLanes) !== 0 ? Ja(l, A, v) : (y0(vt, vt.current & 1), l = lr(l, A, v), l !== null ? l.sibling : null);
          y0(vt, vt.current & 1);
          break;
        case 19:
          if (x = (v & A.childLanes) !== 0, (l.flags & 128) !== 0) {
            if (x) return A4(l, A, v);
            A.flags |= 128;
          }
          if (T = A.memoizedState, T !== null && (T.rendering = null, T.tail = null, T.lastEffect = null), y0(vt, vt.current), x) break;
          return null;
        case 22:
        case 23:
          return A.lanes = 0, P7(l, A, v);
      }
      return lr(l, A, v);
    }
    var cr, jt, uf, lf;
    cr = function(l, A) {
      for (var v = A.child; v !== null; ) {
        if (v.tag === 5 || v.tag === 6) l.appendChild(v.stateNode);
        else if (v.tag !== 4 && v.child !== null) {
          v.child.return = v, v = v.child;
          continue;
        }
        if (v === A) break;
        for (; v.sibling === null; ) {
          if (v.return === null || v.return === A) return;
          v = v.return;
        }
        v.sibling.return = v.return, v = v.sibling;
      }
    }, jt = function() {
    }, uf = function(l, A, v, x) {
      var T = l.memoizedProps;
      if (T !== x) {
        l = A.stateNode, k3(c4.current);
        var R = null;
        switch (v) {
          case "input":
            T = k2(l, T), x = k2(l, x), R = [];
            break;
          case "select":
            T = e2({}, T, { value: void 0 }), x = e2({}, x, { value: void 0 }), R = [];
            break;
          case "textarea":
            T = Z0(l, T), x = Z0(l, x), R = [];
            break;
          default:
            typeof T.onClick != "function" && typeof x.onClick == "function" && (l.onclick = On);
        }
        Ke(v, x);
        var U;
        v = null;
        for (x2 in T) if (!x.hasOwnProperty(x2) && T.hasOwnProperty(x2) && T[x2] != null) if (x2 === "style") {
          var i2 = T[x2];
          for (U in i2) i2.hasOwnProperty(U) && (v || (v = {}), v[U] = "");
        } else x2 !== "dangerouslySetInnerHTML" && x2 !== "children" && x2 !== "suppressContentEditableWarning" && x2 !== "suppressHydrationWarning" && x2 !== "autoFocus" && (i.hasOwnProperty(x2) ? R || (R = []) : (R = R || []).push(x2, null));
        for (x2 in x) {
          var A2 = x[x2];
          if (i2 = T != null ? T[x2] : void 0, x.hasOwnProperty(x2) && A2 !== i2 && (A2 != null || i2 != null)) if (x2 === "style") if (i2) {
            for (U in i2) !i2.hasOwnProperty(U) || A2 && A2.hasOwnProperty(U) || (v || (v = {}), v[U] = "");
            for (U in A2) A2.hasOwnProperty(U) && i2[U] !== A2[U] && (v || (v = {}), v[U] = A2[U]);
          } else v || (R || (R = []), R.push(
            x2,
            v
          )), v = A2;
          else x2 === "dangerouslySetInnerHTML" ? (A2 = A2 ? A2.__html : void 0, i2 = i2 ? i2.__html : void 0, A2 != null && i2 !== A2 && (R = R || []).push(x2, A2)) : x2 === "children" ? typeof A2 != "string" && typeof A2 != "number" || (R = R || []).push(x2, "" + A2) : x2 !== "suppressContentEditableWarning" && x2 !== "suppressHydrationWarning" && (i.hasOwnProperty(x2) ? (A2 != null && x2 === "onScroll" && we("scroll", l), R || i2 === A2 || (R = [])) : (R = R || []).push(x2, A2));
        }
        v && (R = R || []).push("style", v);
        var x2 = R;
        (A.updateQueue = x2) && (A.flags |= 4);
      }
    }, lf = function(l, A, v, x) {
      v !== x && (A.flags |= 4);
    };
    function j7(l, A) {
      if (!Ct) switch (l.tailMode) {
        case "hidden":
          A = l.tail;
          for (var v = null; A !== null; ) A.alternate !== null && (v = A), A = A.sibling;
          v === null ? l.tail = null : v.sibling = null;
          break;
        case "collapsed":
          v = l.tail;
          for (var x = null; v !== null; ) v.alternate !== null && (x = v), v = v.sibling;
          x === null ? A || l.tail === null ? l.tail = null : l.tail.sibling = null : x.sibling = null;
      }
    }
    function u5(l) {
      var A = l.alternate !== null && l.alternate.child === l.child, v = 0, x = 0;
      if (A) for (var T = l.child; T !== null; ) v |= T.lanes | T.childLanes, x |= T.subtreeFlags & 14680064, x |= T.flags & 14680064, T.return = l, T = T.sibling;
      else for (T = l.child; T !== null; ) v |= T.lanes | T.childLanes, x |= T.subtreeFlags, x |= T.flags, T.return = l, T = T.sibling;
      return l.subtreeFlags |= x, l.childLanes = v, A;
    }
    function cf(l, A, v) {
      var x = A.pendingProps;
      switch (ba(A), A.tag) {
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return u5(A), null;
        case 1:
          return Pt(A.type) && X8(), u5(A), null;
        case 3:
          return x = A.stateNode, R3(), ot(Jt), ot(It), B0(), x.pendingContext && (x.context = x.pendingContext, x.pendingContext = null), (l === null || l.child === null) && (wa(A) ? A.flags |= 4 : l === null || l.memoizedState.isDehydrated && (A.flags & 256) === 0 || (A.flags |= 1024, or !== null && (W3(or), or = null))), jt(l, A), u5(A), null;
        case 5:
          _a(A);
          var T = k3(b7.current);
          if (v = A.type, l !== null && A.stateNode != null) uf(l, A, v, x, T), l.ref !== A.ref && (A.flags |= 512, A.flags |= 2097152);
          else {
            if (!x) {
              if (A.stateNode === null) throw Error(r(166));
              return u5(A), null;
            }
            if (l = k3(c4.current), wa(A)) {
              x = A.stateNode, v = A.type;
              var R = A.memoizedProps;
              switch (x[a4] = A, x[E7] = R, l = (A.mode & 1) !== 0, v) {
                case "dialog":
                  we("cancel", x), we("close", x);
                  break;
                case "iframe":
                case "object":
                case "embed":
                  we("load", x);
                  break;
                case "video":
                case "audio":
                  for (T = 0; T < p7.length; T++) we(p7[T], x);
                  break;
                case "source":
                  we("error", x);
                  break;
                case "img":
                case "image":
                case "link":
                  we(
                    "error",
                    x
                  ), we("load", x);
                  break;
                case "details":
                  we("toggle", x);
                  break;
                case "input":
                  b0(x, R), we("invalid", x);
                  break;
                case "select":
                  x._wrapperState = { wasMultiple: !!R.multiple }, we("invalid", x);
                  break;
                case "textarea":
                  Te(x, R), we("invalid", x);
              }
              Ke(v, R), T = null;
              for (var U in R) if (R.hasOwnProperty(U)) {
                var i2 = R[U];
                U === "children" ? typeof i2 == "string" ? x.textContent !== i2 && (R.suppressHydrationWarning !== !0 && Ea(x.textContent, i2, l), T = ["children", i2]) : typeof i2 == "number" && x.textContent !== "" + i2 && (R.suppressHydrationWarning !== !0 && Ea(
                  x.textContent,
                  i2,
                  l
                ), T = ["children", "" + i2]) : i.hasOwnProperty(U) && i2 != null && U === "onScroll" && we("scroll", x);
              }
              switch (v) {
                case "input":
                  W2(x), $e(x, R, !0);
                  break;
                case "textarea":
                  W2(x), Ge(x);
                  break;
                case "select":
                case "option":
                  break;
                default:
                  typeof R.onClick == "function" && (x.onclick = On);
              }
              x = T, A.updateQueue = x, x !== null && (A.flags |= 4);
            } else {
              U = T.nodeType === 9 ? T : T.ownerDocument, l === "http://www.w3.org/1999/xhtml" && (l = rt(v)), l === "http://www.w3.org/1999/xhtml" ? v === "script" ? (l = U.createElement("div"), l.innerHTML = "<script><\/script>", l = l.removeChild(l.firstChild)) : typeof x.is == "string" ? l = U.createElement(v, { is: x.is }) : (l = U.createElement(v), v === "select" && (U = l, x.multiple ? U.multiple = !0 : x.size && (U.size = x.size))) : l = U.createElementNS(l, v), l[a4] = A, l[E7] = x, cr(l, A, !1, !1), A.stateNode = l;
              e: {
                switch (U = kt(v, x), v) {
                  case "dialog":
                    we("cancel", l), we("close", l), T = x;
                    break;
                  case "iframe":
                  case "object":
                  case "embed":
                    we("load", l), T = x;
                    break;
                  case "video":
                  case "audio":
                    for (T = 0; T < p7.length; T++) we(p7[T], l);
                    T = x;
                    break;
                  case "source":
                    we("error", l), T = x;
                    break;
                  case "img":
                  case "image":
                  case "link":
                    we(
                      "error",
                      l
                    ), we("load", l), T = x;
                    break;
                  case "details":
                    we("toggle", l), T = x;
                    break;
                  case "input":
                    b0(l, x), T = k2(l, x), we("invalid", l);
                    break;
                  case "option":
                    T = x;
                    break;
                  case "select":
                    l._wrapperState = { wasMultiple: !!x.multiple }, T = e2({}, x, { value: void 0 }), we("invalid", l);
                    break;
                  case "textarea":
                    Te(l, x), T = Z0(l, x), we("invalid", l);
                    break;
                  default:
                    T = x;
                }
                Ke(v, T), i2 = T;
                for (R in i2) if (i2.hasOwnProperty(R)) {
                  var A2 = i2[R];
                  R === "style" ? De(l, A2) : R === "dangerouslySetInnerHTML" ? (A2 = A2 ? A2.__html : void 0, A2 != null && L1(l, A2)) : R === "children" ? typeof A2 == "string" ? (v !== "textarea" || A2 !== "") && Y2(l, A2) : typeof A2 == "number" && Y2(l, "" + A2) : R !== "suppressContentEditableWarning" && R !== "suppressHydrationWarning" && R !== "autoFocus" && (i.hasOwnProperty(R) ? A2 != null && R === "onScroll" && we("scroll", l) : A2 != null && S(l, R, A2, U));
                }
                switch (v) {
                  case "input":
                    W2(l), $e(l, x, !1);
                    break;
                  case "textarea":
                    W2(l), Ge(l);
                    break;
                  case "option":
                    x.value != null && l.setAttribute("value", "" + w2(x.value));
                    break;
                  case "select":
                    l.multiple = !!x.multiple, R = x.value, R != null ? U0(l, !!x.multiple, R, !1) : x.defaultValue != null && U0(
                      l,
                      !!x.multiple,
                      x.defaultValue,
                      !0
                    );
                    break;
                  default:
                    typeof T.onClick == "function" && (l.onclick = On);
                }
                switch (v) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    x = !!x.autoFocus;
                    break e;
                  case "img":
                    x = !0;
                    break e;
                  default:
                    x = !1;
                }
              }
              x && (A.flags |= 4);
            }
            A.ref !== null && (A.flags |= 512, A.flags |= 2097152);
          }
          return u5(A), null;
        case 6:
          if (l && A.stateNode != null) lf(l, A, l.memoizedProps, x);
          else {
            if (typeof x != "string" && A.stateNode === null) throw Error(r(166));
            if (v = k3(b7.current), k3(c4.current), wa(A)) {
              if (x = A.stateNode, v = A.memoizedProps, x[a4] = A, (R = x.nodeValue !== v) && (l = h1, l !== null)) switch (l.tag) {
                case 3:
                  Ea(x.nodeValue, v, (l.mode & 1) !== 0);
                  break;
                case 5:
                  l.memoizedProps.suppressHydrationWarning !== !0 && Ea(x.nodeValue, v, (l.mode & 1) !== 0);
              }
              R && (A.flags |= 4);
            } else x = (v.nodeType === 9 ? v : v.ownerDocument).createTextNode(x), x[a4] = A, A.stateNode = x;
          }
          return u5(A), null;
        case 13:
          if (ot(vt), x = A.memoizedState, l === null || l.memoizedState !== null && l.memoizedState.dehydrated !== null) {
            if (Ct && v1 !== null && (A.mode & 1) !== 0 && (A.flags & 128) === 0) I7(), Pn(), A.flags |= 98560, R = !1;
            else if (R = wa(A), x !== null && x.dehydrated !== null) {
              if (l === null) {
                if (!R) throw Error(r(318));
                if (R = A.memoizedState, R = R !== null ? R.dehydrated : null, !R) throw Error(r(317));
                R[a4] = A;
              } else Pn(), (A.flags & 128) === 0 && (A.memoizedState = null), A.flags |= 4;
              u5(A), R = !1;
            } else or !== null && (W3(or), or = null), R = !0;
            if (!R) return A.flags & 65536 ? A : null;
          }
          return (A.flags & 128) !== 0 ? (A.lanes = v, A) : (x = x !== null, x !== (l !== null && l.memoizedState !== null) && x && (A.child.flags |= 8192, (A.mode & 1) !== 0 && (l === null || (vt.current & 1) !== 0 ? Mt === 0 && (Mt = 3) : vu())), A.updateQueue !== null && (A.flags |= 4), u5(A), null);
        case 4:
          return R3(), jt(l, A), l === null && W8(A.stateNode.containerInfo), u5(A), null;
        case 10:
          return qs(A.type._context), u5(A), null;
        case 17:
          return Pt(A.type) && X8(), u5(A), null;
        case 19:
          if (ot(vt), R = A.memoizedState, R === null) return u5(A), null;
          if (x = (A.flags & 128) !== 0, U = R.rendering, U === null) if (x) j7(R, !1);
          else {
            if (Mt !== 0 || l !== null && (l.flags & 128) !== 0) for (l = A.child; l !== null; ) {
              if (U = Oa(l), U !== null) {
                for (A.flags |= 128, j7(R, !1), x = U.updateQueue, x !== null && (A.updateQueue = x, A.flags |= 4), A.subtreeFlags = 0, x = v, v = A.child; v !== null; ) R = v, l = x, R.flags &= 14680066, U = R.alternate, U === null ? (R.childLanes = 0, R.lanes = l, R.child = null, R.subtreeFlags = 0, R.memoizedProps = null, R.memoizedState = null, R.updateQueue = null, R.dependencies = null, R.stateNode = null) : (R.childLanes = U.childLanes, R.lanes = U.lanes, R.child = U.child, R.subtreeFlags = 0, R.deletions = null, R.memoizedProps = U.memoizedProps, R.memoizedState = U.memoizedState, R.updateQueue = U.updateQueue, R.type = U.type, l = U.dependencies, R.dependencies = l === null ? null : { lanes: l.lanes, firstContext: l.firstContext }), v = v.sibling;
                return y0(vt, vt.current & 1 | 2), A.child;
              }
              l = l.sibling;
            }
            R.tail !== null && j0() > s6 && (A.flags |= 128, x = !0, j7(R, !1), A.lanes = 4194304);
          }
          else {
            if (!x) if (l = Oa(U), l !== null) {
              if (A.flags |= 128, x = !0, v = l.updateQueue, v !== null && (A.updateQueue = v, A.flags |= 4), j7(R, !0), R.tail === null && R.tailMode === "hidden" && !U.alternate && !Ct) return u5(A), null;
            } else 2 * j0() - R.renderingStartTime > s6 && v !== 1073741824 && (A.flags |= 128, x = !0, j7(R, !1), A.lanes = 4194304);
            R.isBackwards ? (U.sibling = A.child, A.child = U) : (v = R.last, v !== null ? v.sibling = U : A.child = U, R.last = U);
          }
          return R.tail !== null ? (A = R.tail, R.rendering = A, R.tail = A.sibling, R.renderingStartTime = j0(), A.sibling = null, v = vt.current, y0(vt, x ? v & 1 | 2 : v & 1), A) : (u5(A), null);
        case 22:
        case 23:
          return hu(), x = A.memoizedState !== null, l !== null && l.memoizedState !== null !== x && (A.flags |= 8192), x && (A.mode & 1) !== 0 ? (j1 & 1073741824) !== 0 && (u5(A), A.subtreeFlags & 6 && (A.flags |= 8192)) : u5(A), null;
        case 24:
          return null;
        case 25:
          return null;
      }
      throw Error(r(156, A.tag));
    }
    function eo(l, A) {
      switch (ba(A), A.tag) {
        case 1:
          return Pt(A.type) && X8(), l = A.flags, l & 65536 ? (A.flags = l & -65537 | 128, A) : null;
        case 3:
          return R3(), ot(Jt), ot(It), B0(), l = A.flags, (l & 65536) !== 0 && (l & 128) === 0 ? (A.flags = l & -65537 | 128, A) : null;
        case 5:
          return _a(A), null;
        case 13:
          if (ot(vt), l = A.memoizedState, l !== null && l.dehydrated !== null) {
            if (A.alternate === null) throw Error(r(340));
            Pn();
          }
          return l = A.flags, l & 65536 ? (A.flags = l & -65537 | 128, A) : null;
        case 19:
          return ot(vt), null;
        case 4:
          return R3(), null;
        case 10:
          return qs(A.type._context), null;
        case 22:
        case 23:
          return hu(), null;
        case 24:
          return null;
        default:
          return null;
      }
    }
    var V7 = !1, k5 = !1, cv = typeof WeakSet == "function" ? WeakSet : Set, s0 = null;
    function i6(l, A) {
      var v = l.ref;
      if (v !== null) if (typeof v == "function") try {
        v(null);
      } catch (x) {
        dt(l, A, x);
      }
      else v.current = null;
    }
    function to(l, A, v) {
      try {
        v();
      } catch (x) {
        dt(l, A, x);
      }
    }
    var Af = !1;
    function ff(l, A) {
      if (v7 = tr, l = d7(), Aa(l)) {
        if ("selectionStart" in l) var v = { start: l.selectionStart, end: l.selectionEnd };
        else e: {
          v = (v = l.ownerDocument) && v.defaultView || window;
          var x = v.getSelection && v.getSelection();
          if (x && x.rangeCount !== 0) {
            v = x.anchorNode;
            var T = x.anchorOffset, R = x.focusNode;
            x = x.focusOffset;
            try {
              v.nodeType, R.nodeType;
            } catch {
              v = null;
              break e;
            }
            var U = 0, i2 = -1, A2 = -1, x2 = 0, V2 = 0, z2 = l, j2 = null;
            t: for (; ; ) {
              for (var n0; z2 !== v || T !== 0 && z2.nodeType !== 3 || (i2 = U + T), z2 !== R || x !== 0 && z2.nodeType !== 3 || (A2 = U + x), z2.nodeType === 3 && (U += z2.nodeValue.length), (n0 = z2.firstChild) !== null; )
                j2 = z2, z2 = n0;
              for (; ; ) {
                if (z2 === l) break t;
                if (j2 === v && ++x2 === T && (i2 = U), j2 === R && ++V2 === x && (A2 = U), (n0 = z2.nextSibling) !== null) break;
                z2 = j2, j2 = z2.parentNode;
              }
              z2 = n0;
            }
            v = i2 === -1 || A2 === -1 ? null : { start: i2, end: A2 };
          } else v = null;
        }
        v = v || { start: 0, end: 0 };
      } else v = null;
      for (M3 = { focusedElem: l, selectionRange: v }, tr = !1, s0 = A; s0 !== null; ) if (A = s0, l = A.child, (A.subtreeFlags & 1028) !== 0 && l !== null) l.return = A, s0 = l;
      else for (; s0 !== null; ) {
        A = s0;
        try {
          var f0 = A.alternate;
          if ((A.flags & 1024) !== 0) switch (A.tag) {
            case 0:
            case 11:
            case 15:
              break;
            case 1:
              if (f0 !== null) {
                var p0 = f0.memoizedProps, _t = f0.memoizedState, E2 = A.stateNode, p2 = E2.getSnapshotBeforeUpdate(A.elementType === A.type ? p0 : kr(A.type, p0), _t);
                E2.__reactInternalSnapshotBeforeUpdate = p2;
              }
              break;
            case 3:
              var I2 = A.stateNode.containerInfo;
              I2.nodeType === 1 ? I2.textContent = "" : I2.nodeType === 9 && I2.documentElement && I2.removeChild(I2.documentElement);
              break;
            case 5:
            case 6:
            case 4:
            case 17:
              break;
            default:
              throw Error(r(163));
          }
        } catch (Z2) {
          dt(A, A.return, Z2);
        }
        if (l = A.sibling, l !== null) {
          l.return = A.return, s0 = l;
          break;
        }
        s0 = A.return;
      }
      return f0 = Af, Af = !1, f0;
    }
    function Z7(l, A, v) {
      var x = A.updateQueue;
      if (x = x !== null ? x.lastEffect : null, x !== null) {
        var T = x = x.next;
        do {
          if ((T.tag & l) === l) {
            var R = T.destroy;
            T.destroy = void 0, R !== void 0 && to(A, v, R);
          }
          T = T.next;
        } while (T !== x);
      }
    }
    function z7(l, A) {
      if (A = A.updateQueue, A = A !== null ? A.lastEffect : null, A !== null) {
        var v = A = A.next;
        do {
          if ((v.tag & l) === l) {
            var x = v.create;
            v.destroy = x();
          }
          v = v.next;
        } while (v !== A);
      }
    }
    function cu(l) {
      var A = l.ref;
      if (A !== null) {
        var v = l.stateNode;
        switch (l.tag) {
          case 5:
            l = v;
            break;
          default:
            l = v;
        }
        typeof A == "function" ? A(l) : A.current = l;
      }
    }
    function ro(l) {
      var A = l.alternate;
      A !== null && (l.alternate = null, ro(A)), l.child = null, l.deletions = null, l.sibling = null, l.tag === 5 && (A = l.stateNode, A !== null && (delete A[a4], delete A[E7], delete A[m7], delete A[K8], delete A[uv])), l.stateNode = null, l.return = null, l.dependencies = null, l.memoizedProps = null, l.memoizedState = null, l.pendingProps = null, l.stateNode = null, l.updateQueue = null;
    }
    function U7(l) {
      return l.tag === 5 || l.tag === 3 || l.tag === 4;
    }
    function U4(l) {
      e: for (; ; ) {
        for (; l.sibling === null; ) {
          if (l.return === null || U7(l.return)) return null;
          l = l.return;
        }
        for (l.sibling.return = l.return, l = l.sibling; l.tag !== 5 && l.tag !== 6 && l.tag !== 18; ) {
          if (l.flags & 2 || l.child === null || l.tag === 4) continue e;
          l.child.return = l, l = l.child;
        }
        if (!(l.flags & 2)) return l.stateNode;
      }
    }
    function f4(l, A, v) {
      var x = l.tag;
      if (x === 5 || x === 6) l = l.stateNode, A ? v.nodeType === 8 ? v.parentNode.insertBefore(l, A) : v.insertBefore(l, A) : (v.nodeType === 8 ? (A = v.parentNode, A.insertBefore(l, v)) : (A = v, A.appendChild(l)), v = v._reactRootContainer, v != null || A.onclick !== null || (A.onclick = On));
      else if (x !== 4 && (l = l.child, l !== null)) for (f4(l, A, v), l = l.sibling; l !== null; ) f4(l, A, v), l = l.sibling;
    }
    function C4(l, A, v) {
      var x = l.tag;
      if (x === 5 || x === 6) l = l.stateNode, A ? v.insertBefore(l, A) : v.appendChild(l);
      else if (x !== 4 && (l = l.child, l !== null)) for (C4(l, A, v), l = l.sibling; l !== null; ) C4(l, A, v), l = l.sibling;
    }
    var St = null, Y5 = !1;
    function $5(l, A, v) {
      for (v = v.child; v !== null; ) Cf(l, A, v), v = v.sibling;
    }
    function Cf(l, A, v) {
      if (f1 && typeof f1.onCommitFiberUnmount == "function") try {
        f1.onCommitFiberUnmount(In, v);
      } catch {
      }
      switch (v.tag) {
        case 5:
          k5 || i6(v, A);
        case 6:
          var x = St, T = Y5;
          St = null, $5(l, A, v), St = x, Y5 = T, St !== null && (Y5 ? (l = St, v = v.stateNode, l.nodeType === 8 ? l.parentNode.removeChild(v) : l.removeChild(v)) : St.removeChild(v.stateNode));
          break;
        case 18:
          St !== null && (Y5 ? (l = St, v = v.stateNode, l.nodeType === 8 ? G8(l.parentNode, v) : l.nodeType === 1 && G8(l, v), Mr(l)) : G8(St, v.stateNode));
          break;
        case 4:
          x = St, T = Y5, St = v.stateNode.containerInfo, Y5 = !0, $5(l, A, v), St = x, Y5 = T;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          if (!k5 && (x = v.updateQueue, x !== null && (x = x.lastEffect, x !== null))) {
            T = x = x.next;
            do {
              var R = T, U = R.destroy;
              R = R.tag, U !== void 0 && ((R & 2) !== 0 || (R & 4) !== 0) && to(v, A, U), T = T.next;
            } while (T !== x);
          }
          $5(l, A, v);
          break;
        case 1:
          if (!k5 && (i6(v, A), x = v.stateNode, typeof x.componentWillUnmount == "function")) try {
            x.props = v.memoizedProps, x.state = v.memoizedState, x.componentWillUnmount();
          } catch (i2) {
            dt(v, A, i2);
          }
          $5(l, A, v);
          break;
        case 21:
          $5(l, A, v);
          break;
        case 22:
          v.mode & 1 ? (k5 = (x = k5) || v.memoizedState !== null, $5(l, A, v), k5 = x) : $5(l, A, v);
          break;
        default:
          $5(l, A, v);
      }
    }
    function df(l) {
      var A = l.updateQueue;
      if (A !== null) {
        l.updateQueue = null;
        var v = l.stateNode;
        v === null && (v = l.stateNode = new cv()), A.forEach(function(x) {
          var T = Bf.bind(null, l, x);
          v.has(x) || (v.add(x), x.then(T, T));
        });
      }
    }
    function Rr(l, A) {
      var v = A.deletions;
      if (v !== null) for (var x = 0; x < v.length; x++) {
        var T = v[x];
        try {
          var R = l, U = A, i2 = U;
          e: for (; i2 !== null; ) {
            switch (i2.tag) {
              case 5:
                St = i2.stateNode, Y5 = !1;
                break e;
              case 3:
                St = i2.stateNode.containerInfo, Y5 = !0;
                break e;
              case 4:
                St = i2.stateNode.containerInfo, Y5 = !0;
                break e;
            }
            i2 = i2.return;
          }
          if (St === null) throw Error(r(160));
          Cf(R, U, T), St = null, Y5 = !1;
          var A2 = T.alternate;
          A2 !== null && (A2.return = null), T.return = null;
        } catch (x2) {
          dt(T, A, x2);
        }
      }
      if (A.subtreeFlags & 12854) for (A = A.child; A !== null; ) Au(A, l), A = A.sibling;
    }
    function Au(l, A) {
      var v = l.alternate, x = l.flags;
      switch (l.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          if (Rr(A, l), y1(l), x & 4) {
            try {
              Z7(3, l, l.return), z7(3, l);
            } catch (p0) {
              dt(l, l.return, p0);
            }
            try {
              Z7(5, l, l.return);
            } catch (p0) {
              dt(l, l.return, p0);
            }
          }
          break;
        case 1:
          Rr(A, l), y1(l), x & 512 && v !== null && i6(v, v.return);
          break;
        case 5:
          if (Rr(A, l), y1(l), x & 512 && v !== null && i6(v, v.return), l.flags & 32) {
            var T = l.stateNode;
            try {
              Y2(T, "");
            } catch (p0) {
              dt(l, l.return, p0);
            }
          }
          if (x & 4 && (T = l.stateNode, T != null)) {
            var R = l.memoizedProps, U = v !== null ? v.memoizedProps : R, i2 = l.type, A2 = l.updateQueue;
            if (l.updateQueue = null, A2 !== null) try {
              i2 === "input" && R.type === "radio" && R.name != null && S0(T, R), kt(i2, U);
              var x2 = kt(i2, R);
              for (U = 0; U < A2.length; U += 2) {
                var V2 = A2[U], z2 = A2[U + 1];
                V2 === "style" ? De(T, z2) : V2 === "dangerouslySetInnerHTML" ? L1(T, z2) : V2 === "children" ? Y2(T, z2) : S(T, V2, z2, x2);
              }
              switch (i2) {
                case "input":
                  G0(T, R);
                  break;
                case "textarea":
                  Lt(T, R);
                  break;
                case "select":
                  var j2 = T._wrapperState.wasMultiple;
                  T._wrapperState.wasMultiple = !!R.multiple;
                  var n0 = R.value;
                  n0 != null ? U0(T, !!R.multiple, n0, !1) : j2 !== !!R.multiple && (R.defaultValue != null ? U0(
                    T,
                    !!R.multiple,
                    R.defaultValue,
                    !0
                  ) : U0(T, !!R.multiple, R.multiple ? [] : "", !1));
              }
              T[E7] = R;
            } catch (p0) {
              dt(l, l.return, p0);
            }
          }
          break;
        case 6:
          if (Rr(A, l), y1(l), x & 4) {
            if (l.stateNode === null) throw Error(r(162));
            T = l.stateNode, R = l.memoizedProps;
            try {
              T.nodeValue = R;
            } catch (p0) {
              dt(l, l.return, p0);
            }
          }
          break;
        case 3:
          if (Rr(A, l), y1(l), x & 4 && v !== null && v.memoizedState.isDehydrated) try {
            Mr(A.containerInfo);
          } catch (p0) {
            dt(l, l.return, p0);
          }
          break;
        case 4:
          Rr(A, l), y1(l);
          break;
        case 13:
          Rr(A, l), y1(l), T = l.child, T.flags & 8192 && (R = T.memoizedState !== null, T.stateNode.isHidden = R, !R || T.alternate !== null && T.alternate.memoizedState !== null || (du = j0())), x & 4 && df(l);
          break;
        case 22:
          if (V2 = v !== null && v.memoizedState !== null, l.mode & 1 ? (k5 = (x2 = k5) || V2, Rr(A, l), k5 = x2) : Rr(A, l), y1(l), x & 8192) {
            if (x2 = l.memoizedState !== null, (l.stateNode.isHidden = x2) && !V2 && (l.mode & 1) !== 0) for (s0 = l, V2 = l.child; V2 !== null; ) {
              for (z2 = s0 = V2; s0 !== null; ) {
                switch (j2 = s0, n0 = j2.child, j2.tag) {
                  case 0:
                  case 11:
                  case 14:
                  case 15:
                    Z7(4, j2, j2.return);
                    break;
                  case 1:
                    i6(j2, j2.return);
                    var f0 = j2.stateNode;
                    if (typeof f0.componentWillUnmount == "function") {
                      x = j2, v = j2.return;
                      try {
                        A = x, f0.props = A.memoizedProps, f0.state = A.memoizedState, f0.componentWillUnmount();
                      } catch (p0) {
                        dt(x, v, p0);
                      }
                    }
                    break;
                  case 5:
                    i6(j2, j2.return);
                    break;
                  case 22:
                    if (j2.memoizedState !== null) {
                      q7(z2);
                      continue;
                    }
                }
                n0 !== null ? (n0.return = j2, s0 = n0) : q7(z2);
              }
              V2 = V2.sibling;
            }
            e: for (V2 = null, z2 = l; ; ) {
              if (z2.tag === 5) {
                if (V2 === null) {
                  V2 = z2;
                  try {
                    T = z2.stateNode, x2 ? (R = T.style, typeof R.setProperty == "function" ? R.setProperty("display", "none", "important") : R.display = "none") : (i2 = z2.stateNode, A2 = z2.memoizedProps.style, U = A2 != null && A2.hasOwnProperty("display") ? A2.display : null, i2.style.display = fe("display", U));
                  } catch (p0) {
                    dt(l, l.return, p0);
                  }
                }
              } else if (z2.tag === 6) {
                if (V2 === null) try {
                  z2.stateNode.nodeValue = x2 ? "" : z2.memoizedProps;
                } catch (p0) {
                  dt(l, l.return, p0);
                }
              } else if ((z2.tag !== 22 && z2.tag !== 23 || z2.memoizedState === null || z2 === l) && z2.child !== null) {
                z2.child.return = z2, z2 = z2.child;
                continue;
              }
              if (z2 === l) break e;
              for (; z2.sibling === null; ) {
                if (z2.return === null || z2.return === l) break e;
                V2 === z2 && (V2 = null), z2 = z2.return;
              }
              V2 === z2 && (V2 = null), z2.sibling.return = z2.return, z2 = z2.sibling;
            }
          }
          break;
        case 19:
          Rr(A, l), y1(l), x & 4 && df(l);
          break;
        case 21:
          break;
        default:
          Rr(
            A,
            l
          ), y1(l);
      }
    }
    function y1(l) {
      var A = l.flags;
      if (A & 2) {
        try {
          e: {
            for (var v = l.return; v !== null; ) {
              if (U7(v)) {
                var x = v;
                break e;
              }
              v = v.return;
            }
            throw Error(r(160));
          }
          switch (x.tag) {
            case 5:
              var T = x.stateNode;
              x.flags & 32 && (Y2(T, ""), x.flags &= -33);
              var R = U4(l);
              C4(l, R, T);
              break;
            case 3:
            case 4:
              var U = x.stateNode.containerInfo, i2 = U4(l);
              f4(l, i2, U);
              break;
            default:
              throw Error(r(161));
          }
        } catch (A2) {
          dt(l, l.return, A2);
        }
        l.flags &= -3;
      }
      A & 4096 && (l.flags &= -4097);
    }
    function Av(l, A, v) {
      s0 = l, fu(l);
    }
    function fu(l, A, v) {
      for (var x = (l.mode & 1) !== 0; s0 !== null; ) {
        var T = s0, R = T.child;
        if (T.tag === 22 && x) {
          var U = T.memoizedState !== null || V7;
          if (!U) {
            var i2 = T.alternate, A2 = i2 !== null && i2.memoizedState !== null || k5;
            i2 = V7;
            var x2 = k5;
            if (V7 = U, (k5 = A2) && !x2) for (s0 = T; s0 !== null; ) U = s0, A2 = U.child, U.tag === 22 && U.memoizedState !== null ? Cu(T) : A2 !== null ? (A2.return = U, s0 = A2) : Cu(T);
            for (; R !== null; ) s0 = R, fu(R), R = R.sibling;
            s0 = T, V7 = i2, k5 = x2;
          }
          gf(l);
        } else (T.subtreeFlags & 8772) !== 0 && R !== null ? (R.return = T, s0 = R) : gf(l);
      }
    }
    function gf(l) {
      for (; s0 !== null; ) {
        var A = s0;
        if ((A.flags & 8772) !== 0) {
          var v = A.alternate;
          try {
            if ((A.flags & 8772) !== 0) switch (A.tag) {
              case 0:
              case 11:
              case 15:
                k5 || z7(5, A);
                break;
              case 1:
                var x = A.stateNode;
                if (A.flags & 4 && !k5) if (v === null) x.componentDidMount();
                else {
                  var T = A.elementType === A.type ? v.memoizedProps : kr(A.type, v.memoizedProps);
                  x.componentDidUpdate(T, v.memoizedState, x.__reactInternalSnapshotBeforeUpdate);
                }
                var R = A.updateQueue;
                R !== null && Ks(A, R, x);
                break;
              case 3:
                var U = A.updateQueue;
                if (U !== null) {
                  if (v = null, A.child !== null) switch (A.child.tag) {
                    case 5:
                      v = A.child.stateNode;
                      break;
                    case 1:
                      v = A.child.stateNode;
                  }
                  Ks(A, U, v);
                }
                break;
              case 5:
                var i2 = A.stateNode;
                if (v === null && A.flags & 4) {
                  v = i2;
                  var A2 = A.memoizedProps;
                  switch (A.type) {
                    case "button":
                    case "input":
                    case "select":
                    case "textarea":
                      A2.autoFocus && v.focus();
                      break;
                    case "img":
                      A2.src && (v.src = A2.src);
                  }
                }
                break;
              case 6:
                break;
              case 4:
                break;
              case 12:
                break;
              case 13:
                if (A.memoizedState === null) {
                  var x2 = A.alternate;
                  if (x2 !== null) {
                    var V2 = x2.memoizedState;
                    if (V2 !== null) {
                      var z2 = V2.dehydrated;
                      z2 !== null && Mr(z2);
                    }
                  }
                }
                break;
              case 19:
              case 17:
              case 21:
              case 22:
              case 23:
              case 25:
                break;
              default:
                throw Error(r(163));
            }
            k5 || A.flags & 512 && cu(A);
          } catch (j2) {
            dt(A, A.return, j2);
          }
        }
        if (A === l) {
          s0 = null;
          break;
        }
        if (v = A.sibling, v !== null) {
          v.return = A.return, s0 = v;
          break;
        }
        s0 = A.return;
      }
    }
    function q7(l) {
      for (; s0 !== null; ) {
        var A = s0;
        if (A === l) {
          s0 = null;
          break;
        }
        var v = A.sibling;
        if (v !== null) {
          v.return = A.return, s0 = v;
          break;
        }
        s0 = A.return;
      }
    }
    function Cu(l) {
      for (; s0 !== null; ) {
        var A = s0;
        try {
          switch (A.tag) {
            case 0:
            case 11:
            case 15:
              var v = A.return;
              try {
                z7(4, A);
              } catch (A2) {
                dt(A, v, A2);
              }
              break;
            case 1:
              var x = A.stateNode;
              if (typeof x.componentDidMount == "function") {
                var T = A.return;
                try {
                  x.componentDidMount();
                } catch (A2) {
                  dt(A, T, A2);
                }
              }
              var R = A.return;
              try {
                cu(A);
              } catch (A2) {
                dt(A, R, A2);
              }
              break;
            case 5:
              var U = A.return;
              try {
                cu(A);
              } catch (A2) {
                dt(A, U, A2);
              }
          }
        } catch (A2) {
          dt(A, A.return, A2);
        }
        if (A === l) {
          s0 = null;
          break;
        }
        var i2 = A.sibling;
        if (i2 !== null) {
          i2.return = A.return, s0 = i2;
          break;
        }
        s0 = A.return;
      }
    }
    var fv = Math.ceil, Vn = O.ReactCurrentDispatcher, U3 = O.ReactCurrentOwner, m5 = O.ReactCurrentBatchConfig, ae = 0, t5 = null, Vt = null, y5 = 0, j1 = 0, a6 = Dr(0), Mt = 0, W7 = null, d4 = 0, o6 = 0, no = 0, Y7 = null, I1 = null, du = 0, s6 = 1 / 0, V1 = null, u6 = !1, q3 = null, Zn = null, io = !1, q4 = null, $7 = 0, zn = 0, l6 = null, G7 = -1, R5 = 0;
    function Zt() {
      return (ae & 6) !== 0 ? j0() : G7 !== -1 ? G7 : G7 = j0();
    }
    function g4(l) {
      return (l.mode & 1) === 0 ? 1 : (ae & 2) !== 0 && y5 !== 0 ? y5 & -y5 : lv.transition !== null ? (R5 === 0 && (R5 = k8()), R5) : (l = ve, l !== 0 || (l = window.event, l = l === void 0 ? 16 : V8(l.type)), l);
    }
    function G5(l, A, v, x) {
      if (50 < zn) throw zn = 0, l6 = null, Error(r(185));
      D4(l, v, x), ((ae & 2) === 0 || l !== t5) && (l === t5 && ((ae & 2) === 0 && (o6 |= v), Mt === 4 && Pr(l, y5)), B1(l, x), v === 1 && ae === 0 && (A.mode & 1) === 0 && (s6 = j0() + 500, J8 && s4()));
    }
    function B1(l, A) {
      var v = l.callbackNode;
      m3(l, A);
      var x = Sr(l, l === t5 ? y5 : 0);
      if (x === 0) v !== null && p5(v), l.callbackNode = null, l.callbackPriority = 0;
      else if (A = x & -x, l.callbackPriority !== A) {
        if (v != null && p5(v), A === 1) l.tag === 0 ? Dn(gu.bind(null, l)) : Qa(gu.bind(null, l)), $8(function() {
          (ae & 6) === 0 && s4();
        }), v = null;
        else {
          switch (P8(x)) {
            case 1:
              v = br;
              break;
            case 4:
              v = v3;
              break;
            case 16:
              v = E3;
              break;
            case 536870912:
              v = T8;
              break;
            default:
              v = E3;
          }
          v = xf(v, ao.bind(null, l));
        }
        l.callbackPriority = A, l.callbackNode = v;
      }
    }
    function ao(l, A) {
      if (G7 = -1, R5 = 0, (ae & 6) !== 0) throw Error(r(327));
      var v = l.callbackNode;
      if (c6() && l.callbackNode !== v) return null;
      var x = Sr(l, l === t5 ? y5 : 0);
      if (x === 0) return null;
      if ((x & 30) !== 0 || (x & l.expiredLanes) !== 0 || A) A = oo(l, x);
      else {
        A = x;
        var T = ae;
        ae |= 2;
        var R = hf();
        (t5 !== l || y5 !== A) && (V1 = null, s6 = j0() + 500, W4(l, A));
        do
          try {
            vf();
            break;
          } catch (i2) {
            pf(l, i2);
          }
        while (!0);
        Us(), Vn.current = R, ae = T, Vt !== null ? A = 0 : (t5 = null, y5 = 0, A = Mt);
      }
      if (A !== 0) {
        if (A === 2 && (T = Qn(l), T !== 0 && (x = T, A = K7(l, T))), A === 1) throw v = W7, W4(l, 0), Pr(l, x), B1(l, j0()), v;
        if (A === 6) Pr(l, x);
        else {
          if (T = l.current.alternate, (x & 30) === 0 && !Cv(T) && (A = oo(l, x), A === 2 && (R = Qn(l), R !== 0 && (x = R, A = K7(l, R))), A === 1)) throw v = W7, W4(l, 0), Pr(l, x), B1(l, j0()), v;
          switch (l.finishedWork = T, l.finishedLanes = x, A) {
            case 0:
            case 1:
              throw Error(r(345));
            case 2:
              $3(l, I1, V1);
              break;
            case 3:
              if (Pr(l, x), (x & 130023424) === x && (A = du + 500 - j0(), 10 < A)) {
                if (Sr(l, 0) !== 0) break;
                if (T = l.suspendedLanes, (T & x) !== x) {
                  Zt(), l.pingedLanes |= l.suspendedLanes & T;
                  break;
                }
                l.timeoutHandle = ya($3.bind(null, l, I1, V1), A);
                break;
              }
              $3(l, I1, V1);
              break;
            case 4:
              if (Pr(l, x), (x & 4194240) === x) break;
              for (A = l.eventTimes, T = -1; 0 < x; ) {
                var U = 31 - z5(x);
                R = 1 << U, U = A[U], U > T && (T = U), x &= ~R;
              }
              if (x = T, x = j0() - x, x = (120 > x ? 120 : 480 > x ? 480 : 1080 > x ? 1080 : 1920 > x ? 1920 : 3e3 > x ? 3e3 : 4320 > x ? 4320 : 1960 * fv(x / 1960)) - x, 10 < x) {
                l.timeoutHandle = ya($3.bind(null, l, I1, V1), x);
                break;
              }
              $3(l, I1, V1);
              break;
            case 5:
              $3(l, I1, V1);
              break;
            default:
              throw Error(r(329));
          }
        }
      }
      return B1(l, j0()), l.callbackNode === v ? ao.bind(null, l) : null;
    }
    function K7(l, A) {
      var v = Y7;
      return l.current.memoizedState.isDehydrated && (W4(l, A).flags |= 256), l = oo(l, A), l !== 2 && (A = I1, I1 = v, A !== null && W3(A)), l;
    }
    function W3(l) {
      I1 === null ? I1 = l : I1.push.apply(I1, l);
    }
    function Cv(l) {
      for (var A = l; ; ) {
        if (A.flags & 16384) {
          var v = A.updateQueue;
          if (v !== null && (v = v.stores, v !== null)) for (var x = 0; x < v.length; x++) {
            var T = v[x], R = T.getSnapshot;
            T = T.value;
            try {
              if (!Or(R(), T)) return !1;
            } catch {
              return !1;
            }
          }
        }
        if (v = A.child, A.subtreeFlags & 16384 && v !== null) v.return = A, A = v;
        else {
          if (A === l) break;
          for (; A.sibling === null; ) {
            if (A.return === null || A.return === l) return !0;
            A = A.return;
          }
          A.sibling.return = A.return, A = A.sibling;
        }
      }
      return !0;
    }
    function Pr(l, A) {
      for (A &= ~no, A &= ~o6, l.suspendedLanes |= A, l.pingedLanes &= ~A, l = l.expirationTimes; 0 < A; ) {
        var v = 31 - z5(A), x = 1 << v;
        l[v] = -1, A &= ~x;
      }
    }
    function gu(l) {
      if ((ae & 6) !== 0) throw Error(r(327));
      c6();
      var A = Sr(l, 0);
      if ((A & 1) === 0) return B1(l, j0()), null;
      var v = oo(l, A);
      if (l.tag !== 0 && v === 2) {
        var x = Qn(l);
        x !== 0 && (A = x, v = K7(l, x));
      }
      if (v === 1) throw v = W7, W4(l, 0), Pr(l, A), B1(l, j0()), v;
      if (v === 6) throw Error(r(345));
      return l.finishedWork = l.current.alternate, l.finishedLanes = A, $3(l, I1, V1), B1(l, j0()), null;
    }
    function pu(l, A) {
      var v = ae;
      ae |= 1;
      try {
        return l(A);
      } finally {
        ae = v, ae === 0 && (s6 = j0() + 500, J8 && s4());
      }
    }
    function Y3(l) {
      q4 !== null && q4.tag === 0 && (ae & 6) === 0 && c6();
      var A = ae;
      ae |= 1;
      var v = m5.transition, x = ve;
      try {
        if (m5.transition = null, ve = 1, l) return l();
      } finally {
        ve = x, m5.transition = v, ae = A, (ae & 6) === 0 && s4();
      }
    }
    function hu() {
      j1 = a6.current, ot(a6);
    }
    function W4(l, A) {
      l.finishedWork = null, l.finishedLanes = 0;
      var v = l.timeoutHandle;
      if (v !== -1 && (l.timeoutHandle = -1, Hs(v)), Vt !== null) for (v = Vt.return; v !== null; ) {
        var x = v;
        switch (ba(x), x.tag) {
          case 1:
            x = x.type.childContextTypes, x != null && X8();
            break;
          case 3:
            R3(), ot(Jt), ot(It), B0();
            break;
          case 5:
            _a(x);
            break;
          case 4:
            R3();
            break;
          case 13:
            ot(vt);
            break;
          case 19:
            ot(vt);
            break;
          case 10:
            qs(x.type._context);
            break;
          case 22:
          case 23:
            hu();
        }
        v = v.return;
      }
      if (t5 = l, Vt = l = Un(l.current, null), y5 = j1 = A, Mt = 0, W7 = null, no = o6 = d4 = 0, I1 = Y7 = null, L3 !== null) {
        for (A = 0; A < L3.length; A++) if (v = L3[A], x = v.interleaved, x !== null) {
          v.interleaved = null;
          var T = x.next, R = v.pending;
          if (R !== null) {
            var U = R.next;
            R.next = T, x.next = U;
          }
          v.pending = x;
        }
        L3 = null;
      }
      return l;
    }
    function pf(l, A) {
      do {
        var v = Vt;
        try {
          if (Us(), Y0.current = V3, Ta) {
            for (var x = me.memoizedState; x !== null; ) {
              var T = x.queue;
              T !== null && (T.pending = null), x = x.next;
            }
            Ta = !1;
          }
          if (He = 0, s5 = Nt = me = null, S7 = !1, P3 = 0, U3.current = null, v === null || v.return === null) {
            Mt = 1, W7 = A, Vt = null;
            break;
          }
          e: {
            var R = l, U = v.return, i2 = v, A2 = A;
            if (A = y5, i2.flags |= 32768, A2 !== null && typeof A2 == "object" && typeof A2.then == "function") {
              var x2 = A2, V2 = i2, z2 = V2.tag;
              if ((V2.mode & 1) === 0 && (z2 === 0 || z2 === 11 || z2 === 15)) {
                var j2 = V2.alternate;
                j2 ? (V2.updateQueue = j2.updateQueue, V2.memoizedState = j2.memoizedState, V2.lanes = j2.lanes) : (V2.updateQueue = null, V2.memoizedState = null);
              }
              var n0 = rf(U);
              if (n0 !== null) {
                n0.flags &= -257, jn(n0, U, i2, R, A), n0.mode & 1 && au(R, x2, A), A = n0, A2 = x2;
                var f0 = A.updateQueue;
                if (f0 === null) {
                  var p0 = /* @__PURE__ */ new Set();
                  p0.add(A2), A.updateQueue = p0;
                } else f0.add(A2);
                break e;
              } else {
                if ((A & 1) === 0) {
                  au(R, x2, A), vu();
                  break e;
                }
                A2 = Error(r(426));
              }
            } else if (Ct && i2.mode & 1) {
              var _t = rf(U);
              if (_t !== null) {
                (_t.flags & 65536) === 0 && (_t.flags |= 256), jn(_t, U, i2, R, A), V4(Z3(A2, i2));
                break e;
              }
            }
            R = A2 = Z3(A2, i2), Mt !== 4 && (Mt = 2), Y7 === null ? Y7 = [R] : Y7.push(R), R = U;
            do {
              switch (R.tag) {
                case 3:
                  R.flags |= 65536, A &= -A, R.lanes |= A;
                  var E2 = tf(R, A2, A);
                  GA(R, E2);
                  break e;
                case 1:
                  i2 = A2;
                  var p2 = R.type, I2 = R.stateNode;
                  if ((R.flags & 128) === 0 && (typeof p2.getDerivedStateFromError == "function" || I2 !== null && typeof I2.componentDidCatch == "function" && (Zn === null || !Zn.has(I2)))) {
                    R.flags |= 65536, A &= -A, R.lanes |= A;
                    var Z2 = iu(R, i2, A);
                    GA(R, Z2);
                    break e;
                  }
              }
              R = R.return;
            } while (R !== null);
          }
          mf(v);
        } catch (C0) {
          A = C0, Vt === v && v !== null && (Vt = v = v.return);
          continue;
        }
        break;
      } while (!0);
    }
    function hf() {
      var l = Vn.current;
      return Vn.current = V3, l === null ? V3 : l;
    }
    function vu() {
      (Mt === 0 || Mt === 3 || Mt === 2) && (Mt = 4), t5 === null || (d4 & 268435455) === 0 && (o6 & 268435455) === 0 || Pr(t5, y5);
    }
    function oo(l, A) {
      var v = ae;
      ae |= 2;
      var x = hf();
      (t5 !== l || y5 !== A) && (V1 = null, W4(l, A));
      do
        try {
          dv();
          break;
        } catch (T) {
          pf(l, T);
        }
      while (!0);
      if (Us(), ae = v, Vn.current = x, Vt !== null) throw Error(r(261));
      return t5 = null, y5 = 0, Mt;
    }
    function dv() {
      for (; Vt !== null; ) Ef(Vt);
    }
    function vf() {
      for (; Vt !== null && !Qr(); ) Ef(Vt);
    }
    function Ef(l) {
      var A = Qf(l.alternate, l, j1);
      l.memoizedProps = l.pendingProps, A === null ? mf(l) : Vt = A, U3.current = null;
    }
    function mf(l) {
      var A = l;
      do {
        var v = A.alternate;
        if (l = A.return, (A.flags & 32768) === 0) {
          if (v = cf(v, A, j1), v !== null) {
            Vt = v;
            return;
          }
        } else {
          if (v = eo(v, A), v !== null) {
            v.flags &= 32767, Vt = v;
            return;
          }
          if (l !== null) l.flags |= 32768, l.subtreeFlags = 0, l.deletions = null;
          else {
            Mt = 6, Vt = null;
            return;
          }
        }
        if (A = A.sibling, A !== null) {
          Vt = A;
          return;
        }
        Vt = A = l;
      } while (A !== null);
      Mt === 0 && (Mt = 5);
    }
    function $3(l, A, v) {
      var x = ve, T = m5.transition;
      try {
        m5.transition = null, ve = 1, gv(l, A, v, x);
      } finally {
        m5.transition = T, ve = x;
      }
      return null;
    }
    function gv(l, A, v, x) {
      do
        c6();
      while (q4 !== null);
      if ((ae & 6) !== 0) throw Error(r(327));
      v = l.finishedWork;
      var T = l.finishedLanes;
      if (v === null) return null;
      if (l.finishedWork = null, l.finishedLanes = 0, v === l.current) throw Error(r(177));
      l.callbackNode = null, l.callbackPriority = 0;
      var R = v.lanes | v.childLanes;
      if (Es(l, R), l === t5 && (Vt = t5 = null, y5 = 0), (v.subtreeFlags & 2064) === 0 && (v.flags & 2064) === 0 || io || (io = !0, xf(E3, function() {
        return c6(), null;
      })), R = (v.flags & 15990) !== 0, (v.subtreeFlags & 15990) !== 0 || R) {
        R = m5.transition, m5.transition = null;
        var U = ve;
        ve = 1;
        var i2 = ae;
        ae |= 4, U3.current = null, ff(l, v), Au(v, l), U8(M3), tr = !!v7, M3 = v7 = null, l.current = v, Av(v), xr(), ae = i2, ve = U, m5.transition = R;
      } else l.current = v;
      if (io && (io = !1, q4 = l, $7 = T), R = l.pendingLanes, R === 0 && (Zn = null), i7(v.stateNode), B1(l, j0()), A !== null) for (x = l.onRecoverableError, v = 0; v < A.length; v++) T = A[v], x(T.value, { componentStack: T.stack, digest: T.digest });
      if (u6) throw u6 = !1, l = q3, q3 = null, l;
      return ($7 & 1) !== 0 && l.tag !== 0 && c6(), R = l.pendingLanes, (R & 1) !== 0 ? l === l6 ? zn++ : (zn = 0, l6 = l) : zn = 0, s4(), null;
    }
    function c6() {
      if (q4 !== null) {
        var l = P8($7), A = m5.transition, v = ve;
        try {
          if (m5.transition = null, ve = 16 > l ? 16 : l, q4 === null) var x = !1;
          else {
            if (l = q4, q4 = null, $7 = 0, (ae & 6) !== 0) throw Error(r(331));
            var T = ae;
            for (ae |= 4, s0 = l.current; s0 !== null; ) {
              var R = s0, U = R.child;
              if ((s0.flags & 16) !== 0) {
                var i2 = R.deletions;
                if (i2 !== null) {
                  for (var A2 = 0; A2 < i2.length; A2++) {
                    var x2 = i2[A2];
                    for (s0 = x2; s0 !== null; ) {
                      var V2 = s0;
                      switch (V2.tag) {
                        case 0:
                        case 11:
                        case 15:
                          Z7(8, V2, R);
                      }
                      var z2 = V2.child;
                      if (z2 !== null) z2.return = V2, s0 = z2;
                      else for (; s0 !== null; ) {
                        V2 = s0;
                        var j2 = V2.sibling, n0 = V2.return;
                        if (ro(V2), V2 === x2) {
                          s0 = null;
                          break;
                        }
                        if (j2 !== null) {
                          j2.return = n0, s0 = j2;
                          break;
                        }
                        s0 = n0;
                      }
                    }
                  }
                  var f0 = R.alternate;
                  if (f0 !== null) {
                    var p0 = f0.child;
                    if (p0 !== null) {
                      f0.child = null;
                      do {
                        var _t = p0.sibling;
                        p0.sibling = null, p0 = _t;
                      } while (p0 !== null);
                    }
                  }
                  s0 = R;
                }
              }
              if ((R.subtreeFlags & 2064) !== 0 && U !== null) U.return = R, s0 = U;
              else e: for (; s0 !== null; ) {
                if (R = s0, (R.flags & 2048) !== 0) switch (R.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Z7(9, R, R.return);
                }
                var E2 = R.sibling;
                if (E2 !== null) {
                  E2.return = R.return, s0 = E2;
                  break e;
                }
                s0 = R.return;
              }
            }
            var p2 = l.current;
            for (s0 = p2; s0 !== null; ) {
              U = s0;
              var I2 = U.child;
              if ((U.subtreeFlags & 2064) !== 0 && I2 !== null) I2.return = U, s0 = I2;
              else e: for (U = p2; s0 !== null; ) {
                if (i2 = s0, (i2.flags & 2048) !== 0) try {
                  switch (i2.tag) {
                    case 0:
                    case 11:
                    case 15:
                      z7(9, i2);
                  }
                } catch (C0) {
                  dt(i2, i2.return, C0);
                }
                if (i2 === U) {
                  s0 = null;
                  break e;
                }
                var Z2 = i2.sibling;
                if (Z2 !== null) {
                  Z2.return = i2.return, s0 = Z2;
                  break e;
                }
                s0 = i2.return;
              }
            }
            if (ae = T, s4(), f1 && typeof f1.onPostCommitFiberRoot == "function") try {
              f1.onPostCommitFiberRoot(In, l);
            } catch {
            }
            x = !0;
          }
          return x;
        } finally {
          ve = v, m5.transition = A;
        }
      }
      return !1;
    }
    function yf(l, A, v) {
      A = Z3(v, A), A = tf(l, A, 1), l = Fn(l, A, 1), A = Zt(), l !== null && (D4(l, 1, A), B1(l, A));
    }
    function dt(l, A, v) {
      if (l.tag === 3) yf(l, l, v);
      else for (; A !== null; ) {
        if (A.tag === 3) {
          yf(A, l, v);
          break;
        } else if (A.tag === 1) {
          var x = A.stateNode;
          if (typeof A.type.getDerivedStateFromError == "function" || typeof x.componentDidCatch == "function" && (Zn === null || !Zn.has(x))) {
            l = Z3(v, l), l = iu(A, l, 1), A = Fn(A, l, 1), l = Zt(), A !== null && (D4(A, 1, l), B1(A, l));
            break;
          }
        }
        A = A.return;
      }
    }
    function pv(l, A, v) {
      var x = l.pingCache;
      x !== null && x.delete(A), A = Zt(), l.pingedLanes |= l.suspendedLanes & v, t5 === l && (y5 & v) === v && (Mt === 4 || Mt === 3 && (y5 & 130023424) === y5 && 500 > j0() - du ? W4(l, 0) : no |= v), B1(l, A);
    }
    function If(l, A) {
      A === 0 && ((l.mode & 1) === 0 ? A = 1 : (A = k1, k1 <<= 1, (k1 & 130023424) === 0 && (k1 = 4194304)));
      var v = Zt();
      l = F1(l, A), l !== null && (D4(l, A, v), B1(l, v));
    }
    function hv(l) {
      var A = l.memoizedState, v = 0;
      A !== null && (v = A.retryLane), If(l, v);
    }
    function Bf(l, A) {
      var v = 0;
      switch (l.tag) {
        case 13:
          var x = l.stateNode, T = l.memoizedState;
          T !== null && (v = T.retryLane);
          break;
        case 19:
          x = l.stateNode;
          break;
        default:
          throw Error(r(314));
      }
      x !== null && x.delete(A), If(l, v);
    }
    var Qf;
    Qf = function(l, A, v) {
      if (l !== null) if (l.memoizedProps !== A.pendingProps || Jt.current) Ht = !0;
      else {
        if ((l.lanes & v) === 0 && (A.flags & 128) === 0) return Ht = !1, H7(l, A, v);
        Ht = (l.flags & 131072) !== 0;
      }
      else Ht = !1, Ct && (A.flags & 1048576) !== 0 && qA(A, j4, A.index);
      switch (A.lanes = 0, A.tag) {
        case 2:
          var x = A.type;
          ur(l, A), l = A.pendingProps;
          var T = ir(A, It.current);
          ht(A, v), T = Nn(null, A, x, l, T, v);
          var R = Lr();
          return A.flags |= 1, typeof T == "object" && T !== null && typeof T.render == "function" && T.$$typeof === void 0 ? (A.tag = 1, A.memoizedState = null, A.updateQueue = null, Pt(x) ? (R = !0, p1(A)) : R = !1, A.memoizedState = T.state !== null && T.state !== void 0 ? T.state : null, Gs(A), T.updater = $a, A.stateNode = T, T._reactInternals = A, k7(A, x, l, v), A = F7(null, A, x, !0, R, v)) : (A.tag = 0, Ct && R && xa(A), E5(null, A, T, v), A = A.child), A;
        case 16:
          x = A.elementType;
          e: {
            switch (ur(l, A), l = A.pendingProps, T = x._init, x = T(x._payload), A.type = x, T = A.tag = Ev(x), l = kr(x, l), T) {
              case 0:
                A = nf(null, A, x, l, v);
                break e;
              case 1:
                A = af(null, A, x, l, v);
                break e;
              case 11:
                A = m1(null, A, x, l, v);
                break e;
              case 14:
                A = z3(null, A, x, kr(x.type, l), v);
                break e;
            }
            throw Error(r(
              306,
              x,
              ""
            ));
          }
          return A;
        case 0:
          return x = A.type, T = A.pendingProps, T = A.elementType === x ? T : kr(x, T), nf(l, A, x, T, v);
        case 1:
          return x = A.type, T = A.pendingProps, T = A.elementType === x ? T : kr(x, T), af(l, A, x, T, v);
        case 3:
          e: {
            if (n6(A), l === null) throw Error(r(387));
            x = A.pendingProps, R = A.memoizedState, T = R.element, $A(l, A), B7(A, x, null, v);
            var U = A.memoizedState;
            if (x = U.element, R.isDehydrated) if (R = { element: x, isDehydrated: !1, cache: U.cache, pendingSuspenseBoundaries: U.pendingSuspenseBoundaries, transitions: U.transitions }, A.updateQueue.baseState = R, A.memoizedState = R, A.flags & 256) {
              T = Z3(Error(r(423)), A), A = of(l, A, x, v, T);
              break e;
            } else if (x !== T) {
              T = Z3(Error(r(424)), A), A = of(l, A, x, v, T);
              break e;
            } else for (v1 = i4(A.stateNode.containerInfo.firstChild), h1 = A, Ct = !0, or = null, v = e0(A, null, x, v), A.child = v; v; ) v.flags = v.flags & -3 | 4096, v = v.sibling;
            else {
              if (Pn(), x === T) {
                A = lr(l, A, v);
                break e;
              }
              E5(l, A, x, v);
            }
            A = A.child;
          }
          return A;
        case 5:
          return KA(A), l === null && Zs(A), x = A.type, T = A.pendingProps, R = l !== null ? l.memoizedProps : null, U = T.children, ma(x, T) ? U = null : R !== null && ma(x, R) && (A.flags |= 32), ou(l, A), E5(l, A, U, v), A.child;
        case 6:
          return l === null && Zs(A), null;
        case 13:
          return Ja(l, A, v);
        case 4:
          return Xs(A, A.stateNode.containerInfo), x = A.pendingProps, l === null ? A.child = bt(A, null, x, v) : E5(l, A, x, v), A.child;
        case 11:
          return x = A.type, T = A.pendingProps, T = A.elementType === x ? T : kr(x, T), m1(l, A, x, T, v);
        case 7:
          return E5(l, A, A.pendingProps, v), A.child;
        case 8:
          return E5(l, A, A.pendingProps.children, v), A.child;
        case 12:
          return E5(l, A, A.pendingProps.children, v), A.child;
        case 10:
          e: {
            if (x = A.type._context, T = A.pendingProps, R = A.memoizedProps, U = T.value, y0(P1, x._currentValue), x._currentValue = U, R !== null) if (Or(R.value, U)) {
              if (R.children === T.children && !Jt.current) {
                A = lr(l, A, v);
                break e;
              }
            } else for (R = A.child, R !== null && (R.return = A); R !== null; ) {
              var i2 = R.dependencies;
              if (i2 !== null) {
                U = R.child;
                for (var A2 = i2.firstContext; A2 !== null; ) {
                  if (A2.context === x) {
                    if (R.tag === 1) {
                      A2 = Z4(-1, v & -v), A2.tag = 2;
                      var x2 = R.updateQueue;
                      if (x2 !== null) {
                        x2 = x2.shared;
                        var V2 = x2.pending;
                        V2 === null ? A2.next = A2 : (A2.next = V2.next, V2.next = A2), x2.pending = A2;
                      }
                    }
                    R.lanes |= v, A2 = R.alternate, A2 !== null && (A2.lanes |= v), Ws(
                      R.return,
                      v,
                      A
                    ), i2.lanes |= v;
                    break;
                  }
                  A2 = A2.next;
                }
              } else if (R.tag === 10) U = R.type === A.type ? null : R.child;
              else if (R.tag === 18) {
                if (U = R.return, U === null) throw Error(r(341));
                U.lanes |= v, i2 = U.alternate, i2 !== null && (i2.lanes |= v), Ws(U, v, A), U = R.sibling;
              } else U = R.child;
              if (U !== null) U.return = R;
              else for (U = R; U !== null; ) {
                if (U === A) {
                  U = null;
                  break;
                }
                if (R = U.sibling, R !== null) {
                  R.return = U.return, U = R;
                  break;
                }
                U = U.return;
              }
              R = U;
            }
            E5(l, A, T.children, v), A = A.child;
          }
          return A;
        case 9:
          return T = A.type, x = A.pendingProps.children, ht(A, v), T = sr(T), x = x(T), A.flags |= 1, E5(l, A, x, v), A.child;
        case 14:
          return x = A.type, T = kr(x, A.pendingProps), T = kr(x.type, T), z3(l, A, x, T, v);
        case 15:
          return V0(l, A, A.type, A.pendingProps, v);
        case 17:
          return x = A.type, T = A.pendingProps, T = A.elementType === x ? T : kr(x, T), ur(l, A), A.tag = 1, Pt(x) ? (l = !0, p1(A)) : l = !1, ht(A, v), Ga(A, x, T), k7(A, x, T, v), F7(null, A, x, !0, l, v);
        case 19:
          return A4(l, A, v);
        case 22:
          return P7(l, A, v);
      }
      throw Error(r(156, A.tag));
    };
    function xf(l, A) {
      return ut(l, A);
    }
    function vv(l, A, v, x) {
      this.tag = l, this.key = v, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = A, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = x, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
    }
    function Ar(l, A, v, x) {
      return new vv(l, A, v, x);
    }
    function Eu(l) {
      return l = l.prototype, !(!l || !l.isReactComponent);
    }
    function Ev(l) {
      if (typeof l == "function") return Eu(l) ? 1 : 0;
      if (l != null) {
        if (l = l.$$typeof, l === $) return 11;
        if (l === n2) return 14;
      }
      return 2;
    }
    function Un(l, A) {
      var v = l.alternate;
      return v === null ? (v = Ar(l.tag, A, l.key, l.mode), v.elementType = l.elementType, v.type = l.type, v.stateNode = l.stateNode, v.alternate = l, l.alternate = v) : (v.pendingProps = A, v.type = l.type, v.flags = 0, v.subtreeFlags = 0, v.deletions = null), v.flags = l.flags & 14680064, v.childLanes = l.childLanes, v.lanes = l.lanes, v.child = l.child, v.memoizedProps = l.memoizedProps, v.memoizedState = l.memoizedState, v.updateQueue = l.updateQueue, A = l.dependencies, v.dependencies = A === null ? null : { lanes: A.lanes, firstContext: A.firstContext }, v.sibling = l.sibling, v.index = l.index, v.ref = l.ref, v;
    }
    function X7(l, A, v, x, T, R) {
      var U = 2;
      if (x = l, typeof l == "function") Eu(l) && (U = 1);
      else if (typeof l == "string") U = 5;
      else e: switch (l) {
        case k:
          return Y4(v.children, T, R, A);
        case F:
          U = 8, T |= 8;
          break;
        case z:
          return l = Ar(12, v, A, T | 2), l.elementType = z, l.lanes = R, l;
        case W:
          return l = Ar(13, v, A, T), l.elementType = W, l.lanes = R, l;
        case t2:
          return l = Ar(19, v, A, T), l.elementType = t2, l.lanes = R, l;
        case l2:
          return qn(v, T, R, A);
        default:
          if (typeof l == "object" && l !== null) switch (l.$$typeof) {
            case Z:
              U = 10;
              break e;
            case V:
              U = 9;
              break e;
            case $:
              U = 11;
              break e;
            case n2:
              U = 14;
              break e;
            case s2:
              U = 16, x = null;
              break e;
          }
          throw Error(r(130, l == null ? l : typeof l, ""));
      }
      return A = Ar(U, v, A, T), A.elementType = l, A.type = x, A.lanes = R, A;
    }
    function Y4(l, A, v, x) {
      return l = Ar(7, l, x, A), l.lanes = v, l;
    }
    function qn(l, A, v, x) {
      return l = Ar(22, l, x, A), l.elementType = l2, l.lanes = v, l.stateNode = { isHidden: !1 }, l;
    }
    function mu(l, A, v) {
      return l = Ar(6, l, null, A), l.lanes = v, l;
    }
    function so(l, A, v) {
      return A = Ar(4, l.children !== null ? l.children : [], l.key, A), A.lanes = v, A.stateNode = { containerInfo: l.containerInfo, pendingChildren: null, implementation: l.implementation }, A;
    }
    function bf(l, A, v, x, T) {
      this.tag = A, this.containerInfo = l, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = R8(0), this.expirationTimes = R8(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = R8(0), this.identifierPrefix = x, this.onRecoverableError = T, this.mutableSourceEagerHydrationData = null;
    }
    function uo(l, A, v, x, T, R, U, i2, A2) {
      return l = new bf(l, A, v, i2, A2), A === 1 ? (A = 1, R === !0 && (A |= 8)) : A = 0, R = Ar(3, null, null, A), l.current = R, R.stateNode = l, R.memoizedState = { element: x, isDehydrated: v, cache: null, transitions: null, pendingSuspenseBoundaries: null }, Gs(R), l;
    }
    function mv(l, A, v) {
      var x = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
      return { $$typeof: D, key: x == null ? null : "" + x, children: l, containerInfo: A, implementation: v };
    }
    function yu(l) {
      if (!l) return d1;
      l = l._reactInternals;
      e: {
        if (H0(l) !== l || l.tag !== 1) throw Error(r(170));
        var A = l;
        do {
          switch (A.tag) {
            case 3:
              A = A.stateNode.context;
              break e;
            case 1:
              if (Pt(A.type)) {
                A = A.stateNode.__reactInternalMemoizedMergedChildContext;
                break e;
              }
          }
          A = A.return;
        } while (A !== null);
        throw Error(r(171));
      }
      if (l.tag === 1) {
        var v = l.type;
        if (Pt(v)) return y7(l, v, A);
      }
      return A;
    }
    function wf(l, A, v, x, T, R, U, i2, A2) {
      return l = uo(v, x, !0, l, T, R, U, i2, A2), l.context = yu(null), v = l.current, x = Zt(), T = g4(v), R = Z4(x, T), R.callback = A ?? null, Fn(v, R, T), l.current.lanes = T, D4(l, T, x), B1(l, x), l;
    }
    function lo(l, A, v, x) {
      var T = A.current, R = Zt(), U = g4(T);
      return v = yu(v), A.context === null ? A.context = v : A.pendingContext = v, A = Z4(R, U), A.payload = { element: l }, x = x === void 0 ? null : x, x !== null && (A.callback = x), l = Fn(T, A, U), l !== null && (G5(l, T, U, R), Ma(l, T, U)), U;
    }
    function co(l) {
      if (l = l.current, !l.child) return null;
      switch (l.child.tag) {
        case 5:
          return l.child.stateNode;
        default:
          return l.child.stateNode;
      }
    }
    function Iu(l, A) {
      if (l = l.memoizedState, l !== null && l.dehydrated !== null) {
        var v = l.retryLane;
        l.retryLane = v !== 0 && v < A ? v : A;
      }
    }
    function Ao(l, A) {
      Iu(l, A), (l = l.alternate) && Iu(l, A);
    }
    function Sf() {
      return null;
    }
    var G3 = typeof reportError == "function" ? reportError : function(l) {
      console.error(l);
    };
    function Bu(l) {
      this._internalRoot = l;
    }
    fo.prototype.render = Bu.prototype.render = function(l) {
      var A = this._internalRoot;
      if (A === null) throw Error(r(409));
      lo(l, A, null, null);
    }, fo.prototype.unmount = Bu.prototype.unmount = function() {
      var l = this._internalRoot;
      if (l !== null) {
        this._internalRoot = null;
        var A = l.containerInfo;
        Y3(function() {
          lo(null, l, null, null);
        }), A[N4] = null;
      }
    };
    function fo(l) {
      this._internalRoot = l;
    }
    fo.prototype.unstable_scheduleHydration = function(l) {
      if (l) {
        var A = R0();
        l = { blockedOn: null, target: l, priority: A };
        for (var v = 0; v < Xt.length && A !== 0 && A < Xt[v].priority; v++) ;
        Xt.splice(v, 0, l), v === 0 && s7(l);
      }
    };
    function Qu(l) {
      return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11);
    }
    function Co(l) {
      return !(!l || l.nodeType !== 1 && l.nodeType !== 9 && l.nodeType !== 11 && (l.nodeType !== 8 || l.nodeValue !== " react-mount-point-unstable "));
    }
    function Mf() {
    }
    function yv(l, A, v, x, T) {
      if (T) {
        if (typeof x == "function") {
          var R = x;
          x = function() {
            var x2 = co(U);
            R.call(x2);
          };
        }
        var U = wf(A, x, l, 0, null, !1, !1, "", Mf);
        return l._reactRootContainer = U, l[N4] = U.current, W8(l.nodeType === 8 ? l.parentNode : l), Y3(), U;
      }
      for (; T = l.lastChild; ) l.removeChild(T);
      if (typeof x == "function") {
        var i2 = x;
        x = function() {
          var x2 = co(A2);
          i2.call(x2);
        };
      }
      var A2 = uo(l, 0, !1, null, null, !1, !1, "", Mf);
      return l._reactRootContainer = A2, l[N4] = A2.current, W8(l.nodeType === 8 ? l.parentNode : l), Y3(function() {
        lo(A, A2, v, x);
      }), A2;
    }
    function J7(l, A, v, x, T) {
      var R = v._reactRootContainer;
      if (R) {
        var U = R;
        if (typeof T == "function") {
          var i2 = T;
          T = function() {
            var A2 = co(U);
            i2.call(A2);
          };
        }
        lo(A, U, l, T);
      } else U = yv(v, A, l, T, x);
      return co(U);
    }
    ue = function(l) {
      switch (l.tag) {
        case 3:
          var A = l.stateNode;
          if (A.current.memoizedState.isDehydrated) {
            var v = wr(A.pendingLanes);
            v !== 0 && (L4(A, v | 1), B1(A, j0()), (ae & 6) === 0 && (s6 = j0() + 500, s4()));
          }
          break;
        case 13:
          Y3(function() {
            var x = F1(l, 1);
            if (x !== null) {
              var T = Zt();
              G5(x, l, 1, T);
            }
          }), Ao(l, 1);
      }
    }, a7 = function(l) {
      if (l.tag === 13) {
        var A = F1(l, 134217728);
        if (A !== null) {
          var v = Zt();
          G5(A, l, 134217728, v);
        }
        Ao(l, 134217728);
      }
    }, Jr = function(l) {
      if (l.tag === 13) {
        var A = g4(l), v = F1(l, A);
        if (v !== null) {
          var x = Zt();
          G5(v, l, A, x);
        }
        Ao(l, A);
      }
    }, R0 = function() {
      return ve;
    }, F8 = function(l, A) {
      var v = ve;
      try {
        return ve = l, A();
      } finally {
        ve = v;
      }
    }, Qe = function(l, A, v) {
      switch (A) {
        case "input":
          if (G0(l, v), A = v.name, v.type === "radio" && A != null) {
            for (v = l; v.parentNode; ) v = v.parentNode;
            for (v = v.querySelectorAll("input[name=" + JSON.stringify("" + A) + '][type="radio"]'), A = 0; A < v.length; A++) {
              var x = v[A];
              if (x !== l && x.form === l.form) {
                var T = xt(x);
                if (!T) throw Error(r(90));
                d2(x), G0(x, T);
              }
            }
          }
          break;
        case "textarea":
          Lt(l, v);
          break;
        case "select":
          A = v.value, A != null && U0(l, !!v.multiple, A, !1);
      }
    }, Yr = pu, $r = Y3;
    var Iv = { usingClientEntryPoint: !1, Events: [I0, Tr, xt, Br, T4, pu] }, ei = { findFiberByHostInstance: _3, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, _f = { bundleType: ei.bundleType, version: ei.version, rendererPackageName: ei.rendererPackageName, rendererConfig: ei.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: O.ReactCurrentDispatcher, findHostInstanceByFiber: function(l) {
      return l = Qt(l), l === null ? null : l.stateNode;
    }, findFiberByHostInstance: ei.findFiberByHostInstance || Sf, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
      var Wn = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (!Wn.isDisabled && Wn.supportsFiber) try {
        In = Wn.inject(_f), f1 = Wn;
      } catch {
      }
    }
    return hr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = Iv, hr.createPortal = function(l, A) {
      var v = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
      if (!Qu(A)) throw Error(r(200));
      return mv(l, A, null, v);
    }, hr.createRoot = function(l, A) {
      if (!Qu(l)) throw Error(r(299));
      var v = !1, x = "", T = G3;
      return A != null && (A.unstable_strictMode === !0 && (v = !0), A.identifierPrefix !== void 0 && (x = A.identifierPrefix), A.onRecoverableError !== void 0 && (T = A.onRecoverableError)), A = uo(l, 1, !1, null, null, v, !1, x, T), l[N4] = A.current, W8(l.nodeType === 8 ? l.parentNode : l), new Bu(A);
    }, hr.findDOMNode = function(l) {
      if (l == null) return null;
      if (l.nodeType === 1) return l;
      var A = l._reactInternals;
      if (A === void 0)
        throw typeof l.render == "function" ? Error(r(188)) : (l = Object.keys(l).join(","), Error(r(268, l)));
      return l = Qt(A), l = l === null ? null : l.stateNode, l;
    }, hr.flushSync = function(l) {
      return Y3(l);
    }, hr.hydrate = function(l, A, v) {
      if (!Co(A)) throw Error(r(200));
      return J7(null, l, A, !0, v);
    }, hr.hydrateRoot = function(l, A, v) {
      if (!Qu(l)) throw Error(r(405));
      var x = v != null && v.hydratedSources || null, T = !1, R = "", U = G3;
      if (v != null && (v.unstable_strictMode === !0 && (T = !0), v.identifierPrefix !== void 0 && (R = v.identifierPrefix), v.onRecoverableError !== void 0 && (U = v.onRecoverableError)), A = wf(A, null, l, 1, v ?? null, T, !1, R, U), l[N4] = A.current, W8(l), x) for (l = 0; l < x.length; l++) v = x[l], T = v._getVersion, T = T(v._source), A.mutableSourceEagerHydrationData == null ? A.mutableSourceEagerHydrationData = [v, T] : A.mutableSourceEagerHydrationData.push(
        v,
        T
      );
      return new fo(A);
    }, hr.render = function(l, A, v) {
      if (!Co(A)) throw Error(r(200));
      return J7(null, l, A, !1, v);
    }, hr.unmountComponentAtNode = function(l) {
      if (!Co(l)) throw Error(r(40));
      return l._reactRootContainer ? (Y3(function() {
        J7(null, null, l, !1, function() {
          l._reactRootContainer = null, l[N4] = null;
        });
      }), !0) : !1;
    }, hr.unstable_batchedUpdates = pu, hr.unstable_renderSubtreeIntoContainer = function(l, A, v, x) {
      if (!Co(v)) throw Error(r(200));
      if (l == null || l._reactInternals === void 0) throw Error(r(38));
      return J7(l, A, v, !1, x);
    }, hr.version = "18.3.1-next-f1338f8080-20240426", hr;
  }
  var vr = {};
  /**
   * @license React
   * react-dom.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var JD;
  function Fe2() {
    return JD || (JD = 1, process.env.NODE_ENV !== "production" && function() {
      typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
      var e = X9(), t = SZ(), r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, n = !1;
      function i(a) {
        n = a;
      }
      function o(a) {
        if (!n) {
          for (var s = arguments.length, C = new Array(s > 1 ? s - 1 : 0), p = 1; p < s; p++)
            C[p - 1] = arguments[p];
          c("warn", a, C);
        }
      }
      function u(a) {
        if (!n) {
          for (var s = arguments.length, C = new Array(s > 1 ? s - 1 : 0), p = 1; p < s; p++)
            C[p - 1] = arguments[p];
          c("error", a, C);
        }
      }
      function c(a, s, C) {
        {
          var p = r.ReactDebugCurrentFrame, m = p.getStackAddendum();
          m !== "" && (s += "%s", C = C.concat([m]));
          var b = C.map(function(L) {
            return String(L);
          });
          b.unshift("Warning: " + s), Function.prototype.apply.call(console[a], console, b);
        }
      }
      var f = 0, d = 1, g = 2, h = 3, E = 4, y = 5, I = 6, Q = 7, B = 8, _ = 9, M = 10, S = 11, O = 12, w = 13, D = 14, k = 15, F = 16, z = 17, Z = 18, V = 19, $ = 21, W = 22, t2 = 23, n2 = 24, s2 = 25, l2 = !0, X = !1, a2 = !1, e2 = !1, H = !1, Y = !0, r2 = !0, o2 = !0, O2 = !0, S2 = /* @__PURE__ */ new Set(), M2 = {}, w2 = {};
      function v2(a, s) {
        L2(a, s), L2(a + "Capture", s);
      }
      function L2(a, s) {
        M2[a] && u("EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.", a), M2[a] = s;
        {
          var C = a.toLowerCase();
          w2[C] = a, a === "onDoubleClick" && (w2.ondblclick = a);
        }
        for (var p = 0; p < s.length; p++)
          S2.add(s[p]);
      }
      var W2 = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", d2 = Object.prototype.hasOwnProperty;
      function X2(a) {
        {
          var s = typeof Symbol == "function" && Symbol.toStringTag, C = s && a[Symbol.toStringTag] || a.constructor.name || "Object";
          return C;
        }
      }
      function k2(a) {
        try {
          return b0(a), !1;
        } catch {
          return !0;
        }
      }
      function b0(a) {
        return "" + a;
      }
      function S0(a, s) {
        if (k2(a))
          return u("The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before before using it here.", s, X2(a)), b0(a);
      }
      function G0(a) {
        if (k2(a))
          return u("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", X2(a)), b0(a);
      }
      function $e(a, s) {
        if (k2(a))
          return u("The provided `%s` prop is an unsupported type %s. This value must be coerced to a string before before using it here.", s, X2(a)), b0(a);
      }
      function _e(a, s) {
        if (k2(a))
          return u("The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before before using it here.", s, X2(a)), b0(a);
      }
      function Oe(a) {
        if (k2(a))
          return u("The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before before using it here.", X2(a)), b0(a);
      }
      function U0(a) {
        if (k2(a))
          return u("Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before before using it here.", X2(a)), b0(a);
      }
      var Z0 = 0, Te = 1, Lt = 2, Ge = 3, rt = 4, yt = 5, D1 = 6, L1 = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Y2 = L1 + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", c0 = new RegExp("^[" + L1 + "][" + Y2 + "]*$"), k0 = {}, fe = {};
      function De(a) {
        return d2.call(fe, a) ? !0 : d2.call(k0, a) ? !1 : c0.test(a) ? (fe[a] = !0, !0) : (k0[a] = !0, u("Invalid attribute name: `%s`", a), !1);
      }
      function nt(a, s, C) {
        return s !== null ? s.type === Z0 : C ? !1 : a.length > 2 && (a[0] === "o" || a[0] === "O") && (a[1] === "n" || a[1] === "N");
      }
      function Ke(a, s, C, p) {
        if (C !== null && C.type === Z0)
          return !1;
        switch (typeof s) {
          case "function":
          // $FlowIssue symbol is perfectly valid here
          case "symbol":
            return !0;
          case "boolean": {
            if (p)
              return !1;
            if (C !== null)
              return !C.acceptsBooleans;
            var m = a.toLowerCase().slice(0, 5);
            return m !== "data-" && m !== "aria-";
          }
          default:
            return !1;
        }
      }
      function kt(a, s, C, p) {
        if (s === null || typeof s > "u" || Ke(a, s, C, p))
          return !0;
        if (p)
          return !1;
        if (C !== null)
          switch (C.type) {
            case Ge:
              return !s;
            case rt:
              return s === !1;
            case yt:
              return isNaN(s);
            case D1:
              return isNaN(s) || s < 1;
          }
        return !1;
      }
      function Le(a) {
        return Qe.hasOwnProperty(a) ? Qe[a] : null;
      }
      function be(a, s, C, p, m, b, L) {
        this.acceptsBooleans = s === Lt || s === Ge || s === rt, this.attributeName = p, this.attributeNamespace = m, this.mustUseProperty = C, this.propertyName = a, this.type = s, this.sanitizeURL = b, this.removeEmptyString = L;
      }
      var Qe = {}, Z5 = [
        "children",
        "dangerouslySetInnerHTML",
        // TODO: This prevents the assignment of defaultValue to regular
        // elements (not just inputs). Now that ReactDOMInput assigns to the
        // defaultValue property -- do we need this?
        "defaultValue",
        "defaultChecked",
        "innerHTML",
        "suppressContentEditableWarning",
        "suppressHydrationWarning",
        "style"
      ];
      Z5.forEach(function(a) {
        Qe[a] = new be(
          a,
          Z0,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(a) {
        var s = a[0], C = a[1];
        Qe[s] = new be(
          s,
          Te,
          !1,
          // mustUseProperty
          C,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(a) {
        Qe[a] = new be(
          a,
          Lt,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(a) {
        Qe[a] = new be(
          a,
          Lt,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "allowFullScreen",
        "async",
        // Note: there is a special case that prevents it from being written to the DOM
        // on the client side because the browsers are inconsistent. Instead we call focus().
        "autoFocus",
        "autoPlay",
        "controls",
        "default",
        "defer",
        "disabled",
        "disablePictureInPicture",
        "disableRemotePlayback",
        "formNoValidate",
        "hidden",
        "loop",
        "noModule",
        "noValidate",
        "open",
        "playsInline",
        "readOnly",
        "required",
        "reversed",
        "scoped",
        "seamless",
        // Microdata
        "itemScope"
      ].forEach(function(a) {
        Qe[a] = new be(
          a,
          Ge,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "checked",
        // Note: `option.selected` is not updated if `select.multiple` is
        // disabled with `removeAttribute`. We have special logic for handling this.
        "multiple",
        "muted",
        "selected"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Qe[a] = new be(
          a,
          Ge,
          !0,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "capture",
        "download"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Qe[a] = new be(
          a,
          rt,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "cols",
        "rows",
        "size",
        "span"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        Qe[a] = new be(
          a,
          D1,
          !1,
          // mustUseProperty
          a,
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), ["rowSpan", "start"].forEach(function(a) {
        Qe[a] = new be(
          a,
          yt,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      });
      var Gt = /[\-\:]([a-z])/g, c1 = function(a) {
        return a[1].toUpperCase();
      };
      [
        "accent-height",
        "alignment-baseline",
        "arabic-form",
        "baseline-shift",
        "cap-height",
        "clip-path",
        "clip-rule",
        "color-interpolation",
        "color-interpolation-filters",
        "color-profile",
        "color-rendering",
        "dominant-baseline",
        "enable-background",
        "fill-opacity",
        "fill-rule",
        "flood-color",
        "flood-opacity",
        "font-family",
        "font-size",
        "font-size-adjust",
        "font-stretch",
        "font-style",
        "font-variant",
        "font-weight",
        "glyph-name",
        "glyph-orientation-horizontal",
        "glyph-orientation-vertical",
        "horiz-adv-x",
        "horiz-origin-x",
        "image-rendering",
        "letter-spacing",
        "lighting-color",
        "marker-end",
        "marker-mid",
        "marker-start",
        "overline-position",
        "overline-thickness",
        "paint-order",
        "panose-1",
        "pointer-events",
        "rendering-intent",
        "shape-rendering",
        "stop-color",
        "stop-opacity",
        "strikethrough-position",
        "strikethrough-thickness",
        "stroke-dasharray",
        "stroke-dashoffset",
        "stroke-linecap",
        "stroke-linejoin",
        "stroke-miterlimit",
        "stroke-opacity",
        "stroke-width",
        "text-anchor",
        "text-decoration",
        "text-rendering",
        "underline-position",
        "underline-thickness",
        "unicode-bidi",
        "unicode-range",
        "units-per-em",
        "v-alphabetic",
        "v-hanging",
        "v-ideographic",
        "v-mathematical",
        "vector-effect",
        "vert-adv-y",
        "vert-origin-x",
        "vert-origin-y",
        "word-spacing",
        "writing-mode",
        "xmlns:xlink",
        "x-height"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var s = a.replace(Gt, c1);
        Qe[s] = new be(
          s,
          Te,
          !1,
          // mustUseProperty
          a,
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "xlink:actuate",
        "xlink:arcrole",
        "xlink:role",
        "xlink:show",
        "xlink:title",
        "xlink:type"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var s = a.replace(Gt, c1);
        Qe[s] = new be(
          s,
          Te,
          !1,
          // mustUseProperty
          a,
          "http://www.w3.org/1999/xlink",
          !1,
          // sanitizeURL
          !1
        );
      }), [
        "xml:base",
        "xml:lang",
        "xml:space"
        // NOTE: if you add a camelCased prop to this list,
        // you'll need to set attributeName to name.toLowerCase()
        // instead in the assignment below.
      ].forEach(function(a) {
        var s = a.replace(Gt, c1);
        Qe[s] = new be(
          s,
          Te,
          !1,
          // mustUseProperty
          a,
          "http://www.w3.org/XML/1998/namespace",
          !1,
          // sanitizeURL
          !1
        );
      }), ["tabIndex", "crossOrigin"].forEach(function(a) {
        Qe[a] = new be(
          a,
          Te,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !1,
          // sanitizeURL
          !1
        );
      });
      var Br = "xlinkHref";
      Qe[Br] = new be(
        "xlinkHref",
        Te,
        !1,
        // mustUseProperty
        "xlink:href",
        "http://www.w3.org/1999/xlink",
        !0,
        // sanitizeURL
        !1
      ), ["src", "href", "action", "formAction"].forEach(function(a) {
        Qe[a] = new be(
          a,
          Te,
          !1,
          // mustUseProperty
          a.toLowerCase(),
          // attributeName
          null,
          // attributeNamespace
          !0,
          // sanitizeURL
          !0
        );
      });
      var T4 = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*\:/i, Yr = !1;
      function $r(a) {
        !Yr && T4.test(a) && (Yr = !0, u("A future version of React will block javascript: URLs as a security precaution. Use event handlers instead if you can. If you need to generate unsafe HTML try using dangerouslySetInnerHTML instead. React was passed %s.", JSON.stringify(a)));
      }
      function Gr(a, s, C, p) {
        if (p.mustUseProperty) {
          var m = p.propertyName;
          return a[m];
        } else {
          S0(C, s), p.sanitizeURL && $r("" + C);
          var b = p.attributeName, L = null;
          if (p.type === rt) {
            if (a.hasAttribute(b)) {
              var P = a.getAttribute(b);
              return P === "" ? !0 : kt(s, C, p, !1) ? P : P === "" + C ? C : P;
            }
          } else if (a.hasAttribute(b)) {
            if (kt(s, C, p, !1))
              return a.getAttribute(b);
            if (p.type === Ge)
              return C;
            L = a.getAttribute(b);
          }
          return kt(s, C, p, !1) ? L === null ? C : L : L === "" + C ? C : L;
        }
      }
      function Kr(a, s, C, p) {
        {
          if (!De(s))
            return;
          if (!a.hasAttribute(s))
            return C === void 0 ? void 0 : null;
          var m = a.getAttribute(s);
          return S0(C, s), m === "" + C ? C : m;
        }
      }
      function g5(a, s, C, p) {
        var m = Le(s);
        if (!nt(s, m, p)) {
          if (kt(s, C, m, p) && (C = null), p || m === null) {
            if (De(s)) {
              var b = s;
              C === null ? a.removeAttribute(b) : (S0(C, s), a.setAttribute(b, "" + C));
            }
            return;
          }
          var L = m.mustUseProperty;
          if (L) {
            var P = m.propertyName;
            if (C === null) {
              var N = m.type;
              a[P] = N === Ge ? !1 : "";
            } else
              a[P] = C;
            return;
          }
          var G = m.attributeName, J = m.attributeNamespace;
          if (C === null)
            a.removeAttribute(G);
          else {
            var h2 = m.type, g2;
            h2 === Ge || h2 === rt && C === !0 ? g2 = "" : (S0(C, G), g2 = "" + C, m.sanitizeURL && $r(g2.toString())), J ? a.setAttributeNS(J, G, g2) : a.setAttribute(G, g2);
          }
        }
      }
      var o5 = Symbol.for("react.element"), xe = Symbol.for("react.portal"), Kt = Symbol.for("react.fragment"), A1 = Symbol.for("react.strict_mode"), X1 = Symbol.for("react.profiler"), Xr = Symbol.for("react.provider"), c2 = Symbol.for("react.context"), N2 = Symbol.for("react.forward_ref"), J2 = Symbol.for("react.suspense"), l0 = Symbol.for("react.suspense_list"), H0 = Symbol.for("react.memo"), P0 = Symbol.for("react.lazy"), K0 = Symbol.for("react.scope"), W0 = Symbol.for("react.debug_trace_mode"), Qt = Symbol.for("react.offscreen"), it = Symbol.for("react.legacy_hidden"), ut = Symbol.for("react.cache"), p5 = Symbol.for("react.tracing_marker"), Qr = Symbol.iterator, xr = "@@iterator";
      function j0(a) {
        if (a === null || typeof a != "object")
          return null;
        var s = Qr && a[Qr] || a[xr];
        return typeof s == "function" ? s : null;
      }
      var z0 = Object.assign, br = 0, v3, E3, yn, T8, In, f1, i7;
      function z5() {
      }
      z5.__reactDisabledLog = !0;
      function aa() {
        {
          if (br === 0) {
            v3 = console.log, E3 = console.info, yn = console.warn, T8 = console.error, In = console.group, f1 = console.groupCollapsed, i7 = console.groupEnd;
            var a = {
              configurable: !0,
              enumerable: !0,
              value: z5,
              writable: !0
            };
            Object.defineProperties(console, {
              info: a,
              log: a,
              warn: a,
              error: a,
              group: a,
              groupCollapsed: a,
              groupEnd: a
            });
          }
          br++;
        }
      }
      function oa() {
        {
          if (br--, br === 0) {
            var a = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: z0({}, a, {
                value: v3
              }),
              info: z0({}, a, {
                value: E3
              }),
              warn: z0({}, a, {
                value: yn
              }),
              error: z0({}, a, {
                value: T8
              }),
              group: z0({}, a, {
                value: In
              }),
              groupCollapsed: z0({}, a, {
                value: f1
              }),
              groupEnd: z0({}, a, {
                value: i7
              })
            });
          }
          br < 0 && u("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var D8 = r.ReactCurrentDispatcher, Bn;
      function k1(a, s, C) {
        {
          if (Bn === void 0)
            try {
              throw Error();
            } catch (m) {
              var p = m.stack.trim().match(/\n( *(at )?)/);
              Bn = p && p[1] || "";
            }
          return `
` + Bn + a;
        }
      }
      var wr = !1, Sr;
      {
        var L8 = typeof WeakMap == "function" ? WeakMap : Map;
        Sr = new L8();
      }
      function m3(a, s) {
        if (!a || wr)
          return "";
        {
          var C = Sr.get(a);
          if (C !== void 0)
            return C;
        }
        var p;
        wr = !0;
        var m = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var b;
        b = D8.current, D8.current = null, aa();
        try {
          if (s) {
            var L = function() {
              throw Error();
            };
            if (Object.defineProperty(L.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(L, []);
              } catch (b2) {
                p = b2;
              }
              Reflect.construct(a, [], L);
            } else {
              try {
                L.call();
              } catch (b2) {
                p = b2;
              }
              a.call(L.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (b2) {
              p = b2;
            }
            a();
          }
        } catch (b2) {
          if (b2 && p && typeof b2.stack == "string") {
            for (var P = b2.stack.split(`
`), N = p.stack.split(`
`), G = P.length - 1, J = N.length - 1; G >= 1 && J >= 0 && P[G] !== N[J]; )
              J--;
            for (; G >= 1 && J >= 0; G--, J--)
              if (P[G] !== N[J]) {
                if (G !== 1 || J !== 1)
                  do
                    if (G--, J--, J < 0 || P[G] !== N[J]) {
                      var h2 = `
` + P[G].replace(" at new ", " at ");
                      return a.displayName && h2.includes("<anonymous>") && (h2 = h2.replace("<anonymous>", a.displayName)), typeof a == "function" && Sr.set(a, h2), h2;
                    }
                  while (G >= 1 && J >= 0);
                break;
              }
          }
        } finally {
          wr = !1, D8.current = b, oa(), Error.prepareStackTrace = m;
        }
        var g2 = a ? a.displayName || a.name : "", B2 = g2 ? k1(g2) : "";
        return typeof a == "function" && Sr.set(a, B2), B2;
      }
      function Qn(a, s, C) {
        return m3(a, !0);
      }
      function k8(a, s, C) {
        return m3(a, !1);
      }
      function R8(a) {
        var s = a.prototype;
        return !!(s && s.isReactComponent);
      }
      function D4(a, s, C) {
        if (a == null)
          return "";
        if (typeof a == "function")
          return m3(a, R8(a));
        if (typeof a == "string")
          return k1(a);
        switch (a) {
          case J2:
            return k1("Suspense");
          case l0:
            return k1("SuspenseList");
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case N2:
              return k8(a.render);
            case H0:
              return D4(a.type, s, C);
            case P0: {
              var p = a, m = p._payload, b = p._init;
              try {
                return D4(b(m), s, C);
              } catch {
              }
            }
          }
        return "";
      }
      function Es(a) {
        switch (a._debugOwner && a._debugOwner.type, a._debugSource, a.tag) {
          case y:
            return k1(a.type);
          case F:
            return k1("Lazy");
          case w:
            return k1("Suspense");
          case V:
            return k1("SuspenseList");
          case f:
          case g:
          case k:
            return k8(a.type);
          case S:
            return k8(a.type.render);
          case d:
            return Qn(a.type);
          default:
            return "";
        }
      }
      function L4(a) {
        try {
          var s = "", C = a;
          do
            s += Es(C), C = C.return;
          while (C);
          return s;
        } catch (p) {
          return `
Error generating stack: ` + p.message + `
` + p.stack;
        }
      }
      function ve(a, s, C) {
        var p = a.displayName;
        if (p)
          return p;
        var m = s.displayName || s.name || "";
        return m !== "" ? C + "(" + m + ")" : C;
      }
      function P8(a) {
        return a.displayName || "Context";
      }
      function ue(a) {
        if (a == null)
          return null;
        if (typeof a.tag == "number" && u("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof a == "function")
          return a.displayName || a.name || null;
        if (typeof a == "string")
          return a;
        switch (a) {
          case Kt:
            return "Fragment";
          case xe:
            return "Portal";
          case X1:
            return "Profiler";
          case A1:
            return "StrictMode";
          case J2:
            return "Suspense";
          case l0:
            return "SuspenseList";
        }
        if (typeof a == "object")
          switch (a.$$typeof) {
            case c2:
              var s = a;
              return P8(s) + ".Consumer";
            case Xr:
              var C = a;
              return P8(C._context) + ".Provider";
            case N2:
              return ve(a, a.render, "ForwardRef");
            case H0:
              var p = a.displayName || null;
              return p !== null ? p : ue(a.type) || "Memo";
            case P0: {
              var m = a, b = m._payload, L = m._init;
              try {
                return ue(L(b));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      function a7(a, s, C) {
        var p = s.displayName || s.name || "";
        return a.displayName || (p !== "" ? C + "(" + p + ")" : C);
      }
      function Jr(a) {
        return a.displayName || "Context";
      }
      function R0(a) {
        var s = a.tag, C = a.type;
        switch (s) {
          case n2:
            return "Cache";
          case _:
            var p = C;
            return Jr(p) + ".Consumer";
          case M:
            var m = C;
            return Jr(m._context) + ".Provider";
          case Z:
            return "DehydratedFragment";
          case S:
            return a7(C, C.render, "ForwardRef");
          case Q:
            return "Fragment";
          case y:
            return C;
          case E:
            return "Portal";
          case h:
            return "Root";
          case I:
            return "Text";
          case F:
            return ue(C);
          case B:
            return C === A1 ? "StrictMode" : "Mode";
          case W:
            return "Offscreen";
          case O:
            return "Profiler";
          case $:
            return "Scope";
          case w:
            return "Suspense";
          case V:
            return "SuspenseList";
          case s2:
            return "TracingMarker";
          // The display name for this tags come from the user-provided type:
          case d:
          case f:
          case z:
          case g:
          case D:
          case k:
            if (typeof C == "function")
              return C.displayName || C.name || null;
            if (typeof C == "string")
              return C;
            break;
        }
        return null;
      }
      var F8 = r.ReactDebugCurrentFrame, h5 = null, e4 = !1;
      function U5() {
        {
          if (h5 === null)
            return null;
          var a = h5._debugOwner;
          if (a !== null && typeof a < "u")
            return R0(a);
        }
        return null;
      }
      function t4() {
        return h5 === null ? "" : L4(h5);
      }
      function lt() {
        F8.getCurrentStack = null, h5 = null, e4 = !1;
      }
      function Pe(a) {
        F8.getCurrentStack = a === null ? null : t4, h5 = a, e4 = !1;
      }
      function xn() {
        return h5;
      }
      function Xt(a) {
        e4 = a;
      }
      function q5(a) {
        return "" + a;
      }
      function J1(a) {
        switch (typeof a) {
          case "boolean":
          case "number":
          case "string":
          case "undefined":
            return a;
          case "object":
            return U0(a), a;
          default:
            return "";
        }
      }
      var y3 = {
        button: !0,
        checkbox: !0,
        image: !0,
        hidden: !0,
        radio: !0,
        reset: !0,
        submit: !0
      };
      function o7(a, s) {
        y3[s.type] || s.onChange || s.onInput || s.readOnly || s.disabled || s.value == null || u("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."), s.onChange || s.readOnly || s.disabled || s.checked == null || u("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.");
      }
      function s7(a) {
        var s = a.type, C = a.nodeName;
        return C && C.toLowerCase() === "input" && (s === "checkbox" || s === "radio");
      }
      function bn(a) {
        return a._valueTracker;
      }
      function I3(a) {
        a._valueTracker = null;
      }
      function ms(a) {
        var s = "";
        return a && (s7(a) ? s = a.checked ? "true" : "false" : s = a.value), s;
      }
      function er(a) {
        var s = s7(a) ? "checked" : "value", C = Object.getOwnPropertyDescriptor(a.constructor.prototype, s);
        U0(a[s]);
        var p = "" + a[s];
        if (!(a.hasOwnProperty(s) || typeof C > "u" || typeof C.get != "function" || typeof C.set != "function")) {
          var m = C.get, b = C.set;
          Object.defineProperty(a, s, {
            configurable: !0,
            get: function() {
              return m.call(this);
            },
            set: function(P) {
              U0(P), p = "" + P, b.call(this, P);
            }
          }), Object.defineProperty(a, s, {
            enumerable: C.enumerable
          });
          var L = {
            getValue: function() {
              return p;
            },
            setValue: function(P) {
              U0(P), p = "" + P;
            },
            stopTracking: function() {
              I3(a), delete a[s];
            }
          };
          return L;
        }
      }
      function Mr(a) {
        bn(a) || (a._valueTracker = er(a));
      }
      function r4(a) {
        if (!a)
          return !1;
        var s = bn(a);
        if (!s)
          return !0;
        var C = s.getValue(), p = ms(a);
        return p !== C ? (s.setValue(p), !0) : !1;
      }
      function tr(a) {
        if (a = a || (typeof document < "u" ? document : void 0), typeof a > "u")
          return null;
        try {
          return a.activeElement || a.body;
        } catch {
          return a.body;
        }
      }
      var N8 = !1, H8 = !1, wn = !1, B3 = !1;
      function j8(a) {
        var s = a.type === "checkbox" || a.type === "radio";
        return s ? a.checked != null : a.value != null;
      }
      function V8(a, s) {
        var C = a, p = s.checked, m = z0({}, s, {
          defaultChecked: void 0,
          defaultValue: void 0,
          value: void 0,
          checked: p ?? C._wrapperState.initialChecked
        });
        return m;
      }
      function _r(a, s) {
        o7("input", s), s.checked !== void 0 && s.defaultChecked !== void 0 && !H8 && (u("%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", U5() || "A component", s.type), H8 = !0), s.value !== void 0 && s.defaultValue !== void 0 && !N8 && (u("%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://reactjs.org/link/controlled-components", U5() || "A component", s.type), N8 = !0);
        var C = a, p = s.defaultValue == null ? "" : s.defaultValue;
        C._wrapperState = {
          initialChecked: s.checked != null ? s.checked : s.defaultChecked,
          initialValue: J1(s.value != null ? s.value : p),
          controlled: j8(s)
        };
      }
      function j(a, s) {
        var C = a, p = s.checked;
        p != null && g5(C, "checked", p, !1);
      }
      function u2(a, s) {
        var C = a;
        {
          var p = j8(s);
          !C._wrapperState.controlled && p && !B3 && (u("A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), B3 = !0), C._wrapperState.controlled && !p && !wn && (u("A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://reactjs.org/link/controlled-components"), wn = !0);
        }
        j(a, s);
        var m = J1(s.value), b = s.type;
        if (m != null)
          b === "number" ? (m === 0 && C.value === "" || // We explicitly want to coerce to number here if possible.
          // eslint-disable-next-line
          C.value != m) && (C.value = q5(m)) : C.value !== q5(m) && (C.value = q5(m));
        else if (b === "submit" || b === "reset") {
          C.removeAttribute("value");
          return;
        }
        s.hasOwnProperty("value") ? Q0(C, s.type, m) : s.hasOwnProperty("defaultValue") && Q0(C, s.type, J1(s.defaultValue)), s.checked == null && s.defaultChecked != null && (C.defaultChecked = !!s.defaultChecked);
      }
      function Q2(a, s, C) {
        var p = a;
        if (s.hasOwnProperty("value") || s.hasOwnProperty("defaultValue")) {
          var m = s.type, b = m === "submit" || m === "reset";
          if (b && (s.value === void 0 || s.value === null))
            return;
          var L = q5(p._wrapperState.initialValue);
          C || L !== p.value && (p.value = L), p.defaultValue = L;
        }
        var P = p.name;
        P !== "" && (p.name = ""), p.defaultChecked = !p.defaultChecked, p.defaultChecked = !!p._wrapperState.initialChecked, P !== "" && (p.name = P);
      }
      function _2(a, s) {
        var C = a;
        u2(C, s), q2(C, s);
      }
      function q2(a, s) {
        var C = s.name;
        if (s.type === "radio" && C != null) {
          for (var p = a; p.parentNode; )
            p = p.parentNode;
          S0(C, "name");
          for (var m = p.querySelectorAll("input[name=" + JSON.stringify("" + C) + '][type="radio"]'), b = 0; b < m.length; b++) {
            var L = m[b];
            if (!(L === a || L.form !== a.form)) {
              var P = Yf(L);
              if (!P)
                throw new Error("ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.");
              r4(L), u2(L, P);
            }
          }
        }
      }
      function Q0(a, s, C) {
        // Focused number inputs synchronize on blur. See ChangeEventPlugin.js
        (s !== "number" || tr(a.ownerDocument) !== a) && (C == null ? a.defaultValue = q5(a._wrapperState.initialValue) : a.defaultValue !== q5(C) && (a.defaultValue = q5(C)));
      }
      var K2 = !1, M0 = !1, X0 = !1;
      function le(a, s) {
        s.value == null && (typeof s.children == "object" && s.children !== null ? e.Children.forEach(s.children, function(C) {
          C != null && (typeof C == "string" || typeof C == "number" || M0 || (M0 = !0, u("Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>.")));
        }) : s.dangerouslySetInnerHTML != null && (X0 || (X0 = !0, u("Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected.")))), s.selected != null && !K2 && (u("Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."), K2 = !0);
      }
      function at(a, s) {
        s.value != null && a.setAttribute("value", q5(J1(s.value)));
      }
      var Fe = Array.isArray;
      function q0(a) {
        return Fe(a);
      }
      var Ne;
      Ne = !1;
      function pt() {
        var a = U5();
        return a ? `

Check the render method of \`` + a + "`." : "";
      }
      var Sn = ["value", "defaultValue"];
      function u7(a) {
        {
          o7("select", a);
          for (var s = 0; s < Sn.length; s++) {
            var C = Sn[s];
            if (a[C] != null) {
              var p = q0(a[C]);
              a.multiple && !p ? u("The `%s` prop supplied to <select> must be an array if `multiple` is true.%s", C, pt()) : !a.multiple && p && u("The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s", C, pt());
            }
          }
        }
      }
      function k4(a, s, C, p) {
        var m = a.options;
        if (s) {
          for (var b = C, L = {}, P = 0; P < b.length; P++)
            L["$" + b[P]] = !0;
          for (var N = 0; N < m.length; N++) {
            var G = L.hasOwnProperty("$" + m[N].value);
            m[N].selected !== G && (m[N].selected = G), G && p && (m[N].defaultSelected = !0);
          }
        } else {
          for (var J = q5(J1(C)), h2 = null, g2 = 0; g2 < m.length; g2++) {
            if (m[g2].value === J) {
              m[g2].selected = !0, p && (m[g2].defaultSelected = !0);
              return;
            }
            h2 === null && !m[g2].disabled && (h2 = m[g2]);
          }
          h2 !== null && (h2.selected = !0);
        }
      }
      function l7(a, s) {
        return z0({}, s, {
          value: void 0
        });
      }
      function Q3(a, s) {
        var C = a;
        u7(s), C._wrapperState = {
          wasMultiple: !!s.multiple
        }, s.value !== void 0 && s.defaultValue !== void 0 && !Ne && (u("Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://reactjs.org/link/controlled-components"), Ne = !0);
      }
      function ys(a, s) {
        var C = a;
        C.multiple = !!s.multiple;
        var p = s.value;
        p != null ? k4(C, !!s.multiple, p, !1) : s.defaultValue != null && k4(C, !!s.multiple, s.defaultValue, !0);
      }
      function sa(a, s) {
        var C = a, p = C._wrapperState.wasMultiple;
        C._wrapperState.wasMultiple = !!s.multiple;
        var m = s.value;
        m != null ? k4(C, !!s.multiple, m, !1) : p !== !!s.multiple && (s.defaultValue != null ? k4(C, !!s.multiple, s.defaultValue, !0) : k4(C, !!s.multiple, s.multiple ? [] : "", !1));
      }
      function Is(a, s) {
        var C = a, p = s.value;
        p != null && k4(C, !!s.multiple, p, !1);
      }
      var pA = !1;
      function Bs(a, s) {
        var C = a;
        if (s.dangerouslySetInnerHTML != null)
          throw new Error("`dangerouslySetInnerHTML` does not make sense on <textarea>.");
        var p = z0({}, s, {
          value: void 0,
          defaultValue: void 0,
          children: q5(C._wrapperState.initialValue)
        });
        return p;
      }
      function Qs(a, s) {
        var C = a;
        o7("textarea", s), s.value !== void 0 && s.defaultValue !== void 0 && !pA && (u("%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://reactjs.org/link/controlled-components", U5() || "A component"), pA = !0);
        var p = s.value;
        if (p == null) {
          var m = s.children, b = s.defaultValue;
          if (m != null) {
            u("Use the `defaultValue` or `value` props instead of setting children on <textarea>.");
            {
              if (b != null)
                throw new Error("If you supply `defaultValue` on a <textarea>, do not pass children.");
              if (q0(m)) {
                if (m.length > 1)
                  throw new Error("<textarea> can only have at most one child.");
                m = m[0];
              }
              b = m;
            }
          }
          b == null && (b = ""), p = b;
        }
        C._wrapperState = {
          initialValue: J1(p)
        };
      }
      function hA(a, s) {
        var C = a, p = J1(s.value), m = J1(s.defaultValue);
        if (p != null) {
          var b = q5(p);
          b !== C.value && (C.value = b), s.defaultValue == null && C.defaultValue !== b && (C.defaultValue = b);
        }
        m != null && (C.defaultValue = q5(m));
      }
      function vA(a, s) {
        var C = a, p = C.textContent;
        p === C._wrapperState.initialValue && p !== "" && p !== null && (C.value = p);
      }
      function Kh(a, s) {
        hA(a, s);
      }
      var R4 = "http://www.w3.org/1999/xhtml", xs = "http://www.w3.org/1998/Math/MathML", bs = "http://www.w3.org/2000/svg";
      function ws(a) {
        switch (a) {
          case "svg":
            return bs;
          case "math":
            return xs;
          default:
            return R4;
        }
      }
      function Ss(a, s) {
        return a == null || a === R4 ? ws(s) : a === bs && s === "foreignObject" ? R4 : a;
      }
      var EA = function(a) {
        return typeof MSApp < "u" && MSApp.execUnsafeLocalFunction ? function(s, C, p, m) {
          MSApp.execUnsafeLocalFunction(function() {
            return a(s, C, p, m);
          });
        } : a;
      }, ua, mA = EA(function(a, s) {
        if (a.namespaceURI === bs && !("innerHTML" in a)) {
          ua = ua || document.createElement("div"), ua.innerHTML = "<svg>" + s.valueOf().toString() + "</svg>";
          for (var C = ua.firstChild; a.firstChild; )
            a.removeChild(a.firstChild);
          for (; C.firstChild; )
            a.appendChild(C.firstChild);
          return;
        }
        a.innerHTML = s;
      }), C1 = 1, P4 = 3, Rt = 8, F4 = 9, Ms = 11, Z8 = function(a, s) {
        if (s) {
          var C = a.firstChild;
          if (C && C === a.lastChild && C.nodeType === P4) {
            C.nodeValue = s;
            return;
          }
        }
        a.textContent = s;
      }, c7 = {
        animation: ["animationDelay", "animationDirection", "animationDuration", "animationFillMode", "animationIterationCount", "animationName", "animationPlayState", "animationTimingFunction"],
        background: ["backgroundAttachment", "backgroundClip", "backgroundColor", "backgroundImage", "backgroundOrigin", "backgroundPositionX", "backgroundPositionY", "backgroundRepeat", "backgroundSize"],
        backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
        border: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth", "borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth", "borderLeftColor", "borderLeftStyle", "borderLeftWidth", "borderRightColor", "borderRightStyle", "borderRightWidth", "borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderBlockEnd: ["borderBlockEndColor", "borderBlockEndStyle", "borderBlockEndWidth"],
        borderBlockStart: ["borderBlockStartColor", "borderBlockStartStyle", "borderBlockStartWidth"],
        borderBottom: ["borderBottomColor", "borderBottomStyle", "borderBottomWidth"],
        borderColor: ["borderBottomColor", "borderLeftColor", "borderRightColor", "borderTopColor"],
        borderImage: ["borderImageOutset", "borderImageRepeat", "borderImageSlice", "borderImageSource", "borderImageWidth"],
        borderInlineEnd: ["borderInlineEndColor", "borderInlineEndStyle", "borderInlineEndWidth"],
        borderInlineStart: ["borderInlineStartColor", "borderInlineStartStyle", "borderInlineStartWidth"],
        borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
        borderRadius: ["borderBottomLeftRadius", "borderBottomRightRadius", "borderTopLeftRadius", "borderTopRightRadius"],
        borderRight: ["borderRightColor", "borderRightStyle", "borderRightWidth"],
        borderStyle: ["borderBottomStyle", "borderLeftStyle", "borderRightStyle", "borderTopStyle"],
        borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
        borderWidth: ["borderBottomWidth", "borderLeftWidth", "borderRightWidth", "borderTopWidth"],
        columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
        columns: ["columnCount", "columnWidth"],
        flex: ["flexBasis", "flexGrow", "flexShrink"],
        flexFlow: ["flexDirection", "flexWrap"],
        font: ["fontFamily", "fontFeatureSettings", "fontKerning", "fontLanguageOverride", "fontSize", "fontSizeAdjust", "fontStretch", "fontStyle", "fontVariant", "fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition", "fontWeight", "lineHeight"],
        fontVariant: ["fontVariantAlternates", "fontVariantCaps", "fontVariantEastAsian", "fontVariantLigatures", "fontVariantNumeric", "fontVariantPosition"],
        gap: ["columnGap", "rowGap"],
        grid: ["gridAutoColumns", "gridAutoFlow", "gridAutoRows", "gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        gridArea: ["gridColumnEnd", "gridColumnStart", "gridRowEnd", "gridRowStart"],
        gridColumn: ["gridColumnEnd", "gridColumnStart"],
        gridColumnGap: ["columnGap"],
        gridGap: ["columnGap", "rowGap"],
        gridRow: ["gridRowEnd", "gridRowStart"],
        gridRowGap: ["rowGap"],
        gridTemplate: ["gridTemplateAreas", "gridTemplateColumns", "gridTemplateRows"],
        listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
        margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
        marker: ["markerEnd", "markerMid", "markerStart"],
        mask: ["maskClip", "maskComposite", "maskImage", "maskMode", "maskOrigin", "maskPositionX", "maskPositionY", "maskRepeat", "maskSize"],
        maskPosition: ["maskPositionX", "maskPositionY"],
        outline: ["outlineColor", "outlineStyle", "outlineWidth"],
        overflow: ["overflowX", "overflowY"],
        padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
        placeContent: ["alignContent", "justifyContent"],
        placeItems: ["alignItems", "justifyItems"],
        placeSelf: ["alignSelf", "justifySelf"],
        textDecoration: ["textDecorationColor", "textDecorationLine", "textDecorationStyle"],
        textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
        transition: ["transitionDelay", "transitionDuration", "transitionProperty", "transitionTimingFunction"],
        wordWrap: ["overflowWrap"]
      }, A7 = {
        animationIterationCount: !0,
        aspectRatio: !0,
        borderImageOutset: !0,
        borderImageSlice: !0,
        borderImageWidth: !0,
        boxFlex: !0,
        boxFlexGroup: !0,
        boxOrdinalGroup: !0,
        columnCount: !0,
        columns: !0,
        flex: !0,
        flexGrow: !0,
        flexPositive: !0,
        flexShrink: !0,
        flexNegative: !0,
        flexOrder: !0,
        gridArea: !0,
        gridRow: !0,
        gridRowEnd: !0,
        gridRowSpan: !0,
        gridRowStart: !0,
        gridColumn: !0,
        gridColumnEnd: !0,
        gridColumnSpan: !0,
        gridColumnStart: !0,
        fontWeight: !0,
        lineClamp: !0,
        lineHeight: !0,
        opacity: !0,
        order: !0,
        orphans: !0,
        tabSize: !0,
        widows: !0,
        zIndex: !0,
        zoom: !0,
        // SVG-related properties
        fillOpacity: !0,
        floodOpacity: !0,
        stopOpacity: !0,
        strokeDasharray: !0,
        strokeDashoffset: !0,
        strokeMiterlimit: !0,
        strokeOpacity: !0,
        strokeWidth: !0
      };
      function yA(a, s) {
        return a + s.charAt(0).toUpperCase() + s.substring(1);
      }
      var IA = ["Webkit", "ms", "Moz", "O"];
      Object.keys(A7).forEach(function(a) {
        IA.forEach(function(s) {
          A7[yA(s, a)] = A7[a];
        });
      });
      function la(a, s, C) {
        var p = s == null || typeof s == "boolean" || s === "";
        return p ? "" : !C && typeof s == "number" && s !== 0 && !(A7.hasOwnProperty(a) && A7[a]) ? s + "px" : (_e(s, a), ("" + s).trim());
      }
      var BA = /([A-Z])/g, QA = /^ms-/;
      function z8(a) {
        return a.replace(BA, "-$1").toLowerCase().replace(QA, "-ms-");
      }
      var xA = function() {
      };
      {
        var Xh = /^(?:webkit|moz|o)[A-Z]/, Jh = /^-ms-/, bA = /-(.)/g, _s = /;\s*$/, n4 = {}, x3 = {}, wA = !1, f7 = !1, ev = function(a) {
          return a.replace(bA, function(s, C) {
            return C.toUpperCase();
          });
        }, SA = function(a) {
          n4.hasOwnProperty(a) && n4[a] || (n4[a] = !0, u(
            "Unsupported style property %s. Did you mean %s?",
            a,
            // As Andi Smith suggests
            // (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
            // is converted to lowercase `ms`.
            ev(a.replace(Jh, "ms-"))
          ));
        }, Os = function(a) {
          n4.hasOwnProperty(a) && n4[a] || (n4[a] = !0, u("Unsupported vendor-prefixed style property %s. Did you mean %s?", a, a.charAt(0).toUpperCase() + a.slice(1)));
        }, Ts = function(a, s) {
          x3.hasOwnProperty(s) && x3[s] || (x3[s] = !0, u(`Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`, a, s.replace(_s, "")));
        }, MA = function(a, s) {
          wA || (wA = !0, u("`NaN` is an invalid value for the `%s` css style property.", a));
        }, _A = function(a, s) {
          f7 || (f7 = !0, u("`Infinity` is an invalid value for the `%s` css style property.", a));
        };
        xA = function(a, s) {
          a.indexOf("-") > -1 ? SA(a) : Xh.test(a) ? Os(a) : _s.test(s) && Ts(a, s), typeof s == "number" && (isNaN(s) ? MA(a, s) : isFinite(s) || _A(a, s));
        };
      }
      var OA = xA;
      function tv(a) {
        {
          var s = "", C = "";
          for (var p in a)
            if (a.hasOwnProperty(p)) {
              var m = a[p];
              if (m != null) {
                var b = p.indexOf("--") === 0;
                s += C + (b ? p : z8(p)) + ":", s += la(p, m, b), C = ";";
              }
            }
          return s || null;
        }
      }
      function TA(a, s) {
        var C = a.style;
        for (var p in s)
          if (s.hasOwnProperty(p)) {
            var m = p.indexOf("--") === 0;
            m || OA(p, s[p]);
            var b = la(p, s[p], m);
            p === "float" && (p = "cssFloat"), m ? C.setProperty(p, b) : C[p] = b;
          }
      }
      function rv(a) {
        return a == null || typeof a == "boolean" || a === "";
      }
      function DA(a) {
        var s = {};
        for (var C in a)
          for (var p = c7[C] || [C], m = 0; m < p.length; m++)
            s[p[m]] = C;
        return s;
      }
      function nv(a, s) {
        {
          if (!s)
            return;
          var C = DA(a), p = DA(s), m = {};
          for (var b in C) {
            var L = C[b], P = p[b];
            if (P && L !== P) {
              var N = L + "," + P;
              if (m[N])
                continue;
              m[N] = !0, u("%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.", rv(a[L]) ? "Removing" : "Updating", L, P);
            }
          }
        }
      }
      var Or = {
        area: !0,
        base: !0,
        br: !0,
        col: !0,
        embed: !0,
        hr: !0,
        img: !0,
        input: !0,
        keygen: !0,
        link: !0,
        meta: !0,
        param: !0,
        source: !0,
        track: !0,
        wbr: !0
        // NOTE: menuitem's close tag should be omitted, but that causes problems.
      }, C7 = z0({
        menuitem: !0
      }, Or), LA = "__html";
      function ca(a, s) {
        if (s) {
          if (C7[a] && (s.children != null || s.dangerouslySetInnerHTML != null))
            throw new Error(a + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.");
          if (s.dangerouslySetInnerHTML != null) {
            if (s.children != null)
              throw new Error("Can only set one of `children` or `props.dangerouslySetInnerHTML`.");
            if (typeof s.dangerouslySetInnerHTML != "object" || !(LA in s.dangerouslySetInnerHTML))
              throw new Error("`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://reactjs.org/link/dangerously-set-inner-html for more information.");
          }
          if (!s.suppressContentEditableWarning && s.contentEditable && s.children != null && u("A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."), s.style != null && typeof s.style != "object")
            throw new Error("The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX.");
        }
      }
      function Mn(a, s) {
        if (a.indexOf("-") === -1)
          return typeof s.is == "string";
        switch (a) {
          // These are reserved SVG and MathML elements.
          // We don't mind this list too much because we expect it to never grow.
          // The alternative is to track the namespace in a few places which is convoluted.
          // https://w3c.github.io/webcomponents/spec/custom/#custom-elements-core-concepts
          case "annotation-xml":
          case "color-profile":
          case "font-face":
          case "font-face-src":
          case "font-face-uri":
          case "font-face-format":
          case "font-face-name":
          case "missing-glyph":
            return !1;
          default:
            return !0;
        }
      }
      var d7 = {
        // HTML
        accept: "accept",
        acceptcharset: "acceptCharset",
        "accept-charset": "acceptCharset",
        accesskey: "accessKey",
        action: "action",
        allowfullscreen: "allowFullScreen",
        alt: "alt",
        as: "as",
        async: "async",
        autocapitalize: "autoCapitalize",
        autocomplete: "autoComplete",
        autocorrect: "autoCorrect",
        autofocus: "autoFocus",
        autoplay: "autoPlay",
        autosave: "autoSave",
        capture: "capture",
        cellpadding: "cellPadding",
        cellspacing: "cellSpacing",
        challenge: "challenge",
        charset: "charSet",
        checked: "checked",
        children: "children",
        cite: "cite",
        class: "className",
        classid: "classID",
        classname: "className",
        cols: "cols",
        colspan: "colSpan",
        content: "content",
        contenteditable: "contentEditable",
        contextmenu: "contextMenu",
        controls: "controls",
        controlslist: "controlsList",
        coords: "coords",
        crossorigin: "crossOrigin",
        dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
        data: "data",
        datetime: "dateTime",
        default: "default",
        defaultchecked: "defaultChecked",
        defaultvalue: "defaultValue",
        defer: "defer",
        dir: "dir",
        disabled: "disabled",
        disablepictureinpicture: "disablePictureInPicture",
        disableremoteplayback: "disableRemotePlayback",
        download: "download",
        draggable: "draggable",
        enctype: "encType",
        enterkeyhint: "enterKeyHint",
        for: "htmlFor",
        form: "form",
        formmethod: "formMethod",
        formaction: "formAction",
        formenctype: "formEncType",
        formnovalidate: "formNoValidate",
        formtarget: "formTarget",
        frameborder: "frameBorder",
        headers: "headers",
        height: "height",
        hidden: "hidden",
        high: "high",
        href: "href",
        hreflang: "hrefLang",
        htmlfor: "htmlFor",
        httpequiv: "httpEquiv",
        "http-equiv": "httpEquiv",
        icon: "icon",
        id: "id",
        imagesizes: "imageSizes",
        imagesrcset: "imageSrcSet",
        innerhtml: "innerHTML",
        inputmode: "inputMode",
        integrity: "integrity",
        is: "is",
        itemid: "itemID",
        itemprop: "itemProp",
        itemref: "itemRef",
        itemscope: "itemScope",
        itemtype: "itemType",
        keyparams: "keyParams",
        keytype: "keyType",
        kind: "kind",
        label: "label",
        lang: "lang",
        list: "list",
        loop: "loop",
        low: "low",
        manifest: "manifest",
        marginwidth: "marginWidth",
        marginheight: "marginHeight",
        max: "max",
        maxlength: "maxLength",
        media: "media",
        mediagroup: "mediaGroup",
        method: "method",
        min: "min",
        minlength: "minLength",
        multiple: "multiple",
        muted: "muted",
        name: "name",
        nomodule: "noModule",
        nonce: "nonce",
        novalidate: "noValidate",
        open: "open",
        optimum: "optimum",
        pattern: "pattern",
        placeholder: "placeholder",
        playsinline: "playsInline",
        poster: "poster",
        preload: "preload",
        profile: "profile",
        radiogroup: "radioGroup",
        readonly: "readOnly",
        referrerpolicy: "referrerPolicy",
        rel: "rel",
        required: "required",
        reversed: "reversed",
        role: "role",
        rows: "rows",
        rowspan: "rowSpan",
        sandbox: "sandbox",
        scope: "scope",
        scoped: "scoped",
        scrolling: "scrolling",
        seamless: "seamless",
        selected: "selected",
        shape: "shape",
        size: "size",
        sizes: "sizes",
        span: "span",
        spellcheck: "spellCheck",
        src: "src",
        srcdoc: "srcDoc",
        srclang: "srcLang",
        srcset: "srcSet",
        start: "start",
        step: "step",
        style: "style",
        summary: "summary",
        tabindex: "tabIndex",
        target: "target",
        title: "title",
        type: "type",
        usemap: "useMap",
        value: "value",
        width: "width",
        wmode: "wmode",
        wrap: "wrap",
        // SVG
        about: "about",
        accentheight: "accentHeight",
        "accent-height": "accentHeight",
        accumulate: "accumulate",
        additive: "additive",
        alignmentbaseline: "alignmentBaseline",
        "alignment-baseline": "alignmentBaseline",
        allowreorder: "allowReorder",
        alphabetic: "alphabetic",
        amplitude: "amplitude",
        arabicform: "arabicForm",
        "arabic-form": "arabicForm",
        ascent: "ascent",
        attributename: "attributeName",
        attributetype: "attributeType",
        autoreverse: "autoReverse",
        azimuth: "azimuth",
        basefrequency: "baseFrequency",
        baselineshift: "baselineShift",
        "baseline-shift": "baselineShift",
        baseprofile: "baseProfile",
        bbox: "bbox",
        begin: "begin",
        bias: "bias",
        by: "by",
        calcmode: "calcMode",
        capheight: "capHeight",
        "cap-height": "capHeight",
        clip: "clip",
        clippath: "clipPath",
        "clip-path": "clipPath",
        clippathunits: "clipPathUnits",
        cliprule: "clipRule",
        "clip-rule": "clipRule",
        color: "color",
        colorinterpolation: "colorInterpolation",
        "color-interpolation": "colorInterpolation",
        colorinterpolationfilters: "colorInterpolationFilters",
        "color-interpolation-filters": "colorInterpolationFilters",
        colorprofile: "colorProfile",
        "color-profile": "colorProfile",
        colorrendering: "colorRendering",
        "color-rendering": "colorRendering",
        contentscripttype: "contentScriptType",
        contentstyletype: "contentStyleType",
        cursor: "cursor",
        cx: "cx",
        cy: "cy",
        d: "d",
        datatype: "datatype",
        decelerate: "decelerate",
        descent: "descent",
        diffuseconstant: "diffuseConstant",
        direction: "direction",
        display: "display",
        divisor: "divisor",
        dominantbaseline: "dominantBaseline",
        "dominant-baseline": "dominantBaseline",
        dur: "dur",
        dx: "dx",
        dy: "dy",
        edgemode: "edgeMode",
        elevation: "elevation",
        enablebackground: "enableBackground",
        "enable-background": "enableBackground",
        end: "end",
        exponent: "exponent",
        externalresourcesrequired: "externalResourcesRequired",
        fill: "fill",
        fillopacity: "fillOpacity",
        "fill-opacity": "fillOpacity",
        fillrule: "fillRule",
        "fill-rule": "fillRule",
        filter: "filter",
        filterres: "filterRes",
        filterunits: "filterUnits",
        floodopacity: "floodOpacity",
        "flood-opacity": "floodOpacity",
        floodcolor: "floodColor",
        "flood-color": "floodColor",
        focusable: "focusable",
        fontfamily: "fontFamily",
        "font-family": "fontFamily",
        fontsize: "fontSize",
        "font-size": "fontSize",
        fontsizeadjust: "fontSizeAdjust",
        "font-size-adjust": "fontSizeAdjust",
        fontstretch: "fontStretch",
        "font-stretch": "fontStretch",
        fontstyle: "fontStyle",
        "font-style": "fontStyle",
        fontvariant: "fontVariant",
        "font-variant": "fontVariant",
        fontweight: "fontWeight",
        "font-weight": "fontWeight",
        format: "format",
        from: "from",
        fx: "fx",
        fy: "fy",
        g1: "g1",
        g2: "g2",
        glyphname: "glyphName",
        "glyph-name": "glyphName",
        glyphorientationhorizontal: "glyphOrientationHorizontal",
        "glyph-orientation-horizontal": "glyphOrientationHorizontal",
        glyphorientationvertical: "glyphOrientationVertical",
        "glyph-orientation-vertical": "glyphOrientationVertical",
        glyphref: "glyphRef",
        gradienttransform: "gradientTransform",
        gradientunits: "gradientUnits",
        hanging: "hanging",
        horizadvx: "horizAdvX",
        "horiz-adv-x": "horizAdvX",
        horizoriginx: "horizOriginX",
        "horiz-origin-x": "horizOriginX",
        ideographic: "ideographic",
        imagerendering: "imageRendering",
        "image-rendering": "imageRendering",
        in2: "in2",
        in: "in",
        inlist: "inlist",
        intercept: "intercept",
        k1: "k1",
        k2: "k2",
        k3: "k3",
        k4: "k4",
        k: "k",
        kernelmatrix: "kernelMatrix",
        kernelunitlength: "kernelUnitLength",
        kerning: "kerning",
        keypoints: "keyPoints",
        keysplines: "keySplines",
        keytimes: "keyTimes",
        lengthadjust: "lengthAdjust",
        letterspacing: "letterSpacing",
        "letter-spacing": "letterSpacing",
        lightingcolor: "lightingColor",
        "lighting-color": "lightingColor",
        limitingconeangle: "limitingConeAngle",
        local: "local",
        markerend: "markerEnd",
        "marker-end": "markerEnd",
        markerheight: "markerHeight",
        markermid: "markerMid",
        "marker-mid": "markerMid",
        markerstart: "markerStart",
        "marker-start": "markerStart",
        markerunits: "markerUnits",
        markerwidth: "markerWidth",
        mask: "mask",
        maskcontentunits: "maskContentUnits",
        maskunits: "maskUnits",
        mathematical: "mathematical",
        mode: "mode",
        numoctaves: "numOctaves",
        offset: "offset",
        opacity: "opacity",
        operator: "operator",
        order: "order",
        orient: "orient",
        orientation: "orientation",
        origin: "origin",
        overflow: "overflow",
        overlineposition: "overlinePosition",
        "overline-position": "overlinePosition",
        overlinethickness: "overlineThickness",
        "overline-thickness": "overlineThickness",
        paintorder: "paintOrder",
        "paint-order": "paintOrder",
        panose1: "panose1",
        "panose-1": "panose1",
        pathlength: "pathLength",
        patterncontentunits: "patternContentUnits",
        patterntransform: "patternTransform",
        patternunits: "patternUnits",
        pointerevents: "pointerEvents",
        "pointer-events": "pointerEvents",
        points: "points",
        pointsatx: "pointsAtX",
        pointsaty: "pointsAtY",
        pointsatz: "pointsAtZ",
        prefix: "prefix",
        preservealpha: "preserveAlpha",
        preserveaspectratio: "preserveAspectRatio",
        primitiveunits: "primitiveUnits",
        property: "property",
        r: "r",
        radius: "radius",
        refx: "refX",
        refy: "refY",
        renderingintent: "renderingIntent",
        "rendering-intent": "renderingIntent",
        repeatcount: "repeatCount",
        repeatdur: "repeatDur",
        requiredextensions: "requiredExtensions",
        requiredfeatures: "requiredFeatures",
        resource: "resource",
        restart: "restart",
        result: "result",
        results: "results",
        rotate: "rotate",
        rx: "rx",
        ry: "ry",
        scale: "scale",
        security: "security",
        seed: "seed",
        shaperendering: "shapeRendering",
        "shape-rendering": "shapeRendering",
        slope: "slope",
        spacing: "spacing",
        specularconstant: "specularConstant",
        specularexponent: "specularExponent",
        speed: "speed",
        spreadmethod: "spreadMethod",
        startoffset: "startOffset",
        stddeviation: "stdDeviation",
        stemh: "stemh",
        stemv: "stemv",
        stitchtiles: "stitchTiles",
        stopcolor: "stopColor",
        "stop-color": "stopColor",
        stopopacity: "stopOpacity",
        "stop-opacity": "stopOpacity",
        strikethroughposition: "strikethroughPosition",
        "strikethrough-position": "strikethroughPosition",
        strikethroughthickness: "strikethroughThickness",
        "strikethrough-thickness": "strikethroughThickness",
        string: "string",
        stroke: "stroke",
        strokedasharray: "strokeDasharray",
        "stroke-dasharray": "strokeDasharray",
        strokedashoffset: "strokeDashoffset",
        "stroke-dashoffset": "strokeDashoffset",
        strokelinecap: "strokeLinecap",
        "stroke-linecap": "strokeLinecap",
        strokelinejoin: "strokeLinejoin",
        "stroke-linejoin": "strokeLinejoin",
        strokemiterlimit: "strokeMiterlimit",
        "stroke-miterlimit": "strokeMiterlimit",
        strokewidth: "strokeWidth",
        "stroke-width": "strokeWidth",
        strokeopacity: "strokeOpacity",
        "stroke-opacity": "strokeOpacity",
        suppresscontenteditablewarning: "suppressContentEditableWarning",
        suppresshydrationwarning: "suppressHydrationWarning",
        surfacescale: "surfaceScale",
        systemlanguage: "systemLanguage",
        tablevalues: "tableValues",
        targetx: "targetX",
        targety: "targetY",
        textanchor: "textAnchor",
        "text-anchor": "textAnchor",
        textdecoration: "textDecoration",
        "text-decoration": "textDecoration",
        textlength: "textLength",
        textrendering: "textRendering",
        "text-rendering": "textRendering",
        to: "to",
        transform: "transform",
        typeof: "typeof",
        u1: "u1",
        u2: "u2",
        underlineposition: "underlinePosition",
        "underline-position": "underlinePosition",
        underlinethickness: "underlineThickness",
        "underline-thickness": "underlineThickness",
        unicode: "unicode",
        unicodebidi: "unicodeBidi",
        "unicode-bidi": "unicodeBidi",
        unicoderange: "unicodeRange",
        "unicode-range": "unicodeRange",
        unitsperem: "unitsPerEm",
        "units-per-em": "unitsPerEm",
        unselectable: "unselectable",
        valphabetic: "vAlphabetic",
        "v-alphabetic": "vAlphabetic",
        values: "values",
        vectoreffect: "vectorEffect",
        "vector-effect": "vectorEffect",
        version: "version",
        vertadvy: "vertAdvY",
        "vert-adv-y": "vertAdvY",
        vertoriginx: "vertOriginX",
        "vert-origin-x": "vertOriginX",
        vertoriginy: "vertOriginY",
        "vert-origin-y": "vertOriginY",
        vhanging: "vHanging",
        "v-hanging": "vHanging",
        videographic: "vIdeographic",
        "v-ideographic": "vIdeographic",
        viewbox: "viewBox",
        viewtarget: "viewTarget",
        visibility: "visibility",
        vmathematical: "vMathematical",
        "v-mathematical": "vMathematical",
        vocab: "vocab",
        widths: "widths",
        wordspacing: "wordSpacing",
        "word-spacing": "wordSpacing",
        writingmode: "writingMode",
        "writing-mode": "writingMode",
        x1: "x1",
        x2: "x2",
        x: "x",
        xchannelselector: "xChannelSelector",
        xheight: "xHeight",
        "x-height": "xHeight",
        xlinkactuate: "xlinkActuate",
        "xlink:actuate": "xlinkActuate",
        xlinkarcrole: "xlinkArcrole",
        "xlink:arcrole": "xlinkArcrole",
        xlinkhref: "xlinkHref",
        "xlink:href": "xlinkHref",
        xlinkrole: "xlinkRole",
        "xlink:role": "xlinkRole",
        xlinkshow: "xlinkShow",
        "xlink:show": "xlinkShow",
        xlinktitle: "xlinkTitle",
        "xlink:title": "xlinkTitle",
        xlinktype: "xlinkType",
        "xlink:type": "xlinkType",
        xmlbase: "xmlBase",
        "xml:base": "xmlBase",
        xmllang: "xmlLang",
        "xml:lang": "xmlLang",
        xmlns: "xmlns",
        "xml:space": "xmlSpace",
        xmlnsxlink: "xmlnsXlink",
        "xmlns:xlink": "xmlnsXlink",
        xmlspace: "xmlSpace",
        y1: "y1",
        y2: "y2",
        y: "y",
        ychannelselector: "yChannelSelector",
        z: "z",
        zoomandpan: "zoomAndPan"
      }, Aa = {
        "aria-current": 0,
        // state
        "aria-description": 0,
        "aria-details": 0,
        "aria-disabled": 0,
        // state
        "aria-hidden": 0,
        // state
        "aria-invalid": 0,
        // state
        "aria-keyshortcuts": 0,
        "aria-label": 0,
        "aria-roledescription": 0,
        // Widget Attributes
        "aria-autocomplete": 0,
        "aria-checked": 0,
        "aria-expanded": 0,
        "aria-haspopup": 0,
        "aria-level": 0,
        "aria-modal": 0,
        "aria-multiline": 0,
        "aria-multiselectable": 0,
        "aria-orientation": 0,
        "aria-placeholder": 0,
        "aria-pressed": 0,
        "aria-readonly": 0,
        "aria-required": 0,
        "aria-selected": 0,
        "aria-sort": 0,
        "aria-valuemax": 0,
        "aria-valuemin": 0,
        "aria-valuenow": 0,
        "aria-valuetext": 0,
        // Live Region Attributes
        "aria-atomic": 0,
        "aria-busy": 0,
        "aria-live": 0,
        "aria-relevant": 0,
        // Drag-and-Drop Attributes
        "aria-dropeffect": 0,
        "aria-grabbed": 0,
        // Relationship Attributes
        "aria-activedescendant": 0,
        "aria-colcount": 0,
        "aria-colindex": 0,
        "aria-colspan": 0,
        "aria-controls": 0,
        "aria-describedby": 0,
        "aria-errormessage": 0,
        "aria-flowto": 0,
        "aria-labelledby": 0,
        "aria-owns": 0,
        "aria-posinset": 0,
        "aria-rowcount": 0,
        "aria-rowindex": 0,
        "aria-rowspan": 0,
        "aria-setsize": 0
      }, U8 = {}, iv = new RegExp("^(aria)-[" + Y2 + "]*$"), q8 = new RegExp("^(aria)[A-Z][" + Y2 + "]*$");
      function Ds(a, s) {
        {
          if (d2.call(U8, s) && U8[s])
            return !0;
          if (q8.test(s)) {
            var C = "aria-" + s.slice(4).toLowerCase(), p = Aa.hasOwnProperty(C) ? C : null;
            if (p == null)
              return u("Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.", s), U8[s] = !0, !0;
            if (s !== p)
              return u("Invalid ARIA attribute `%s`. Did you mean `%s`?", s, p), U8[s] = !0, !0;
          }
          if (iv.test(s)) {
            var m = s.toLowerCase(), b = Aa.hasOwnProperty(m) ? m : null;
            if (b == null)
              return U8[s] = !0, !1;
            if (s !== b)
              return u("Unknown ARIA attribute `%s`. Did you mean `%s`?", s, b), U8[s] = !0, !0;
          }
        }
        return !0;
      }
      function g7(a, s) {
        {
          var C = [];
          for (var p in s) {
            var m = Ds(a, p);
            m || C.push(p);
          }
          var b = C.map(function(L) {
            return "`" + L + "`";
          }).join(", ");
          C.length === 1 ? u("Invalid aria prop %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a) : C.length > 1 && u("Invalid aria props %s on <%s> tag. For details, see https://reactjs.org/link/invalid-aria-props", b, a);
        }
      }
      function Ls(a, s) {
        Mn(a, s) || g7(a, s);
      }
      var ks = !1;
      function fa(a, s) {
        {
          if (a !== "input" && a !== "textarea" && a !== "select")
            return;
          s != null && s.value === null && !ks && (ks = !0, a === "select" && s.multiple ? u("`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.", a) : u("`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.", a));
        }
      }
      var b3 = function() {
      };
      {
        var v5 = {}, Rs = /^on./, Ca = /^on[^A-Z]/, kA = new RegExp("^(aria)-[" + Y2 + "]*$"), RA = new RegExp("^(aria)[A-Z][" + Y2 + "]*$");
        b3 = function(a, s, C, p) {
          if (d2.call(v5, s) && v5[s])
            return !0;
          var m = s.toLowerCase();
          if (m === "onfocusin" || m === "onfocusout")
            return u("React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."), v5[s] = !0, !0;
          if (p != null) {
            var b = p.registrationNameDependencies, L = p.possibleRegistrationNames;
            if (b.hasOwnProperty(s))
              return !0;
            var P = L.hasOwnProperty(m) ? L[m] : null;
            if (P != null)
              return u("Invalid event handler property `%s`. Did you mean `%s`?", s, P), v5[s] = !0, !0;
            if (Rs.test(s))
              return u("Unknown event handler property `%s`. It will be ignored.", s), v5[s] = !0, !0;
          } else if (Rs.test(s))
            return Ca.test(s) && u("Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.", s), v5[s] = !0, !0;
          if (kA.test(s) || RA.test(s))
            return !0;
          if (m === "innerhtml")
            return u("Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."), v5[s] = !0, !0;
          if (m === "aria")
            return u("The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."), v5[s] = !0, !0;
          if (m === "is" && C !== null && C !== void 0 && typeof C != "string")
            return u("Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.", typeof C), v5[s] = !0, !0;
          if (typeof C == "number" && isNaN(C))
            return u("Received NaN for the `%s` attribute. If this is expected, cast the value to a string.", s), v5[s] = !0, !0;
          var N = Le(s), G = N !== null && N.type === Z0;
          if (d7.hasOwnProperty(m)) {
            var J = d7[m];
            if (J !== s)
              return u("Invalid DOM property `%s`. Did you mean `%s`?", s, J), v5[s] = !0, !0;
          } else if (!G && s !== m)
            return u("React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.", s, m), v5[s] = !0, !0;
          return typeof C == "boolean" && Ke(s, C, N, !1) ? (C ? u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.', C, s, s, C, s) : u('Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.', C, s, s, C, s, s, s), v5[s] = !0, !0) : G ? !0 : Ke(s, C, N, !1) ? (v5[s] = !0, !1) : ((C === "false" || C === "true") && N !== null && N.type === Ge && (u("Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?", C, s, C === "false" ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".', s, C), v5[s] = !0), !0);
        };
      }
      var PA = function(a, s, C) {
        {
          var p = [];
          for (var m in s) {
            var b = b3(a, m, s[m], C);
            b || p.push(m);
          }
          var L = p.map(function(P) {
            return "`" + P + "`";
          }).join(", ");
          p.length === 1 ? u("Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", L, a) : p.length > 1 && u("Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://reactjs.org/link/attribute-behavior ", L, a);
        }
      };
      function FA(a, s, C) {
        Mn(a, s) || PA(a, s, C);
      }
      var Ps = 1, da = 2, rr = 4, Fs = Ps | da | rr, w3 = null;
      function av(a) {
        w3 !== null && u("Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."), w3 = a;
      }
      function ov() {
        w3 === null && u("Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."), w3 = null;
      }
      function p7(a) {
        return a === w3;
      }
      function Ns(a) {
        var s = a.target || a.srcElement || window;
        return s.correspondingUseElement && (s = s.correspondingUseElement), s.nodeType === P4 ? s.parentNode : s;
      }
      var ga = null, S3 = null, we = null;
      function pa(a) {
        var s = C6(a);
        if (s) {
          if (typeof ga != "function")
            throw new Error("setRestoreImplementation() needs to be called to handle a target for controlled events. This error is likely caused by a bug in React. Please file an issue.");
          var C = s.stateNode;
          if (C) {
            var p = Yf(C);
            ga(s.stateNode, s.type, p);
          }
        }
      }
      function ha(a) {
        ga = a;
      }
      function W8(a) {
        S3 ? we ? we.push(a) : we = [a] : S3 = a;
      }
      function NA() {
        return S3 !== null || we !== null;
      }
      function va() {
        if (S3) {
          var a = S3, s = we;
          if (S3 = null, we = null, pa(a), s)
            for (var C = 0; C < s.length; C++)
              pa(s[C]);
        }
      }
      var Y8 = function(a, s) {
        return a(s);
      }, h7 = function() {
      }, _n = !1;
      function HA() {
        var a = NA();
        a && (h7(), va());
      }
      function jA(a, s, C) {
        if (_n)
          return a(s, C);
        _n = !0;
        try {
          return Y8(a, s, C);
        } finally {
          _n = !1, HA();
        }
      }
      function sv(a, s, C) {
        Y8 = a, h7 = C;
      }
      function VA(a) {
        return a === "button" || a === "input" || a === "select" || a === "textarea";
      }
      function Ea(a, s, C) {
        switch (a) {
          case "onClick":
          case "onClickCapture":
          case "onDoubleClick":
          case "onDoubleClickCapture":
          case "onMouseDown":
          case "onMouseDownCapture":
          case "onMouseMove":
          case "onMouseMoveCapture":
          case "onMouseUp":
          case "onMouseUpCapture":
          case "onMouseEnter":
            return !!(C.disabled && VA(s));
          default:
            return !1;
        }
      }
      function On(a, s) {
        var C = a.stateNode;
        if (C === null)
          return null;
        var p = Yf(C);
        if (p === null)
          return null;
        var m = p[s];
        if (Ea(s, a.type, p))
          return null;
        if (m && typeof m != "function")
          throw new Error("Expected `" + s + "` listener to be a function, instead got a value of `" + typeof m + "` type.");
        return m;
      }
      var v7 = !1;
      if (W2)
        try {
          var M3 = {};
          Object.defineProperty(M3, "passive", {
            get: function() {
              v7 = !0;
            }
          }), window.addEventListener("test", M3, M3), window.removeEventListener("test", M3, M3);
        } catch {
          v7 = !1;
        }
      function ma(a, s, C, p, m, b, L, P, N) {
        var G = Array.prototype.slice.call(arguments, 3);
        try {
          s.apply(C, G);
        } catch (J) {
          this.onError(J);
        }
      }
      var ya = ma;
      if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
        var Hs = document.createElement("react");
        ya = function(s, C, p, m, b, L, P, N, G) {
          if (typeof document > "u" || document === null)
            throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
          var J = document.createEvent("Event"), h2 = !1, g2 = !0, B2 = window.event, b2 = Object.getOwnPropertyDescriptor(window, "event");
          function T2() {
            Hs.removeEventListener(D2, x0, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = B2);
          }
          var t0 = Array.prototype.slice.call(arguments, 3);
          function x0() {
            h2 = !0, T2(), C.apply(p, t0), g2 = !1;
          }
          var m0, se = !1, J0 = !1;
          function m2(y2) {
            if (m0 = y2.error, se = !0, m0 === null && y2.colno === 0 && y2.lineno === 0 && (J0 = !0), y2.defaultPrevented && m0 != null && typeof m0 == "object")
              try {
                m0._suppressLogging = !0;
              } catch {
              }
          }
          var D2 = "react-" + (s || "invokeguardedcallback");
          if (window.addEventListener("error", m2), Hs.addEventListener(D2, x0, !1), J.initEvent(D2, !1, !1), Hs.dispatchEvent(J), b2 && Object.defineProperty(window, "event", b2), h2 && g2 && (se ? J0 && (m0 = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : m0 = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(m0)), window.removeEventListener("error", m2), !h2)
            return T2(), ma.apply(this, arguments);
        };
      }
      var ZA = ya, $8 = !1, Ia = null, G8 = !1, i4 = null, zA = {
        onError: function(a) {
          $8 = !0, Ia = a;
        }
      };
      function Tn(a, s, C, p, m, b, L, P, N) {
        $8 = !1, Ia = null, ZA.apply(zA, arguments);
      }
      function a4(a, s, C, p, m, b, L, P, N) {
        if (Tn.apply(this, arguments), $8) {
          var G = m7();
          G8 || (G8 = !0, i4 = G);
        }
      }
      function E7() {
        if (G8) {
          var a = i4;
          throw G8 = !1, i4 = null, a;
        }
      }
      function N4() {
        return $8;
      }
      function m7() {
        if ($8) {
          var a = Ia;
          return $8 = !1, Ia = null, a;
        } else
          throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      }
      function K8(a) {
        return a._reactInternals;
      }
      function uv(a) {
        return a._reactInternals !== void 0;
      }
      function _3(a, s) {
        a._reactInternals = s;
      }
      var I0 = (
        /*                      */
        0
      ), Tr = (
        /*                */
        1
      ), xt = (
        /*                    */
        2
      ), ie = (
        /*                       */
        4
      ), nr = (
        /*                */
        16
      ), Dr = (
        /*                 */
        32
      ), ot = (
        /*                     */
        64
      ), y0 = (
        /*                   */
        128
      ), d1 = (
        /*            */
        256
      ), It = (
        /*                          */
        512
      ), Jt = (
        /*                     */
        1024
      ), g1 = (
        /*                      */
        2048
      ), ir = (
        /*                    */
        4096
      ), Pt = (
        /*                   */
        8192
      ), X8 = (
        /*             */
        16384
      ), UA = (
        /*               */
        32767
      ), y7 = (
        /*                   */
        32768
      ), p1 = (
        /*                */
        65536
      ), Ba = (
        /* */
        131072
      ), o4 = (
        /*                       */
        1048576
      ), J8 = (
        /*                    */
        2097152
      ), H4 = (
        /*                 */
        4194304
      ), Qa = (
        /*                */
        8388608
      ), Dn = (
        /*               */
        16777216
      ), s4 = (
        /*              */
        33554432
      ), Ln = (
        // TODO: Remove Update flag from before mutation phase by re-landing Visibility
        // flag logic (see #20043)
        ie | Jt | 0
      ), kn = xt | ie | nr | Dr | It | ir | Pt, Rn = ie | ot | It | Pt, j4 = g1 | nr, Ft = H4 | Qa | J8, ar = r.ReactCurrentOwner;
      function R1(a) {
        var s = a, C = a;
        if (a.alternate)
          for (; s.return; )
            s = s.return;
        else {
          var p = s;
          do
            s = p, (s.flags & (xt | ir)) !== I0 && (C = s.return), p = s.return;
          while (p);
        }
        return s.tag === h ? C : null;
      }
      function u4(a) {
        if (a.tag === w) {
          var s = a.memoizedState;
          if (s === null) {
            var C = a.alternate;
            C !== null && (s = C.memoizedState);
          }
          if (s !== null)
            return s.dehydrated;
        }
        return null;
      }
      function l4(a) {
        return a.tag === h ? a.stateNode.containerInfo : null;
      }
      function O3(a) {
        return R1(a) === a;
      }
      function qA(a) {
        {
          var s = ar.current;
          if (s !== null && s.tag === d) {
            var C = s, p = C.stateNode;
            p._warnedAboutRefsInRender || u("%s is accessing isMounted inside its render() function. render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", R0(C) || "A component"), p._warnedAboutRefsInRender = !0;
          }
        }
        var m = K8(a);
        return m ? R1(m) === m : !1;
      }
      function xa(a) {
        if (R1(a) !== a)
          throw new Error("Unable to find node on an unmounted component.");
      }
      function ba(a) {
        var s = a.alternate;
        if (!s) {
          var C = R1(a);
          if (C === null)
            throw new Error("Unable to find node on an unmounted component.");
          return C !== a ? null : a;
        }
        for (var p = a, m = s; ; ) {
          var b = p.return;
          if (b === null)
            break;
          var L = b.alternate;
          if (L === null) {
            var P = b.return;
            if (P !== null) {
              p = m = P;
              continue;
            }
            break;
          }
          if (b.child === L.child) {
            for (var N = b.child; N; ) {
              if (N === p)
                return xa(b), a;
              if (N === m)
                return xa(b), s;
              N = N.sibling;
            }
            throw new Error("Unable to find node on an unmounted component.");
          }
          if (p.return !== m.return)
            p = b, m = L;
          else {
            for (var G = !1, J = b.child; J; ) {
              if (J === p) {
                G = !0, p = b, m = L;
                break;
              }
              if (J === m) {
                G = !0, m = b, p = L;
                break;
              }
              J = J.sibling;
            }
            if (!G) {
              for (J = L.child; J; ) {
                if (J === p) {
                  G = !0, p = L, m = b;
                  break;
                }
                if (J === m) {
                  G = !0, m = L, p = b;
                  break;
                }
                J = J.sibling;
              }
              if (!G)
                throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
            }
          }
          if (p.alternate !== m)
            throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
        }
        if (p.tag !== h)
          throw new Error("Unable to find node on an unmounted component.");
        return p.stateNode.current === p ? a : s;
      }
      function h1(a) {
        var s = ba(a);
        return s !== null ? v1(s) : null;
      }
      function v1(a) {
        if (a.tag === y || a.tag === I)
          return a;
        for (var s = a.child; s !== null; ) {
          var C = v1(s);
          if (C !== null)
            return C;
          s = s.sibling;
        }
        return null;
      }
      function Ct(a) {
        var s = ba(a);
        return s !== null ? or(s) : null;
      }
      function or(a) {
        if (a.tag === y || a.tag === I)
          return a;
        for (var s = a.child; s !== null; ) {
          if (s.tag !== E) {
            var C = or(s);
            if (C !== null)
              return C;
          }
          s = s.sibling;
        }
        return null;
      }
      var js = t.unstable_scheduleCallback, WA = t.unstable_cancelCallback, Vs = t.unstable_shouldYield, Zs = t.unstable_requestPaint, e5 = t.unstable_now, wa = t.unstable_getCurrentPriorityLevel, I7 = t.unstable_ImmediatePriority, Pn = t.unstable_UserBlockingPriority, V4 = t.unstable_NormalPriority, lv = t.unstable_LowPriority, T3 = t.unstable_IdlePriority, Sa = t.unstable_yieldValue, YA = t.unstable_setDisableYieldValue, D3 = null, bt = null, e0 = null, P1 = !1, E1 = typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u";
      function e6(a) {
        if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u")
          return !1;
        var s = __REACT_DEVTOOLS_GLOBAL_HOOK__;
        if (s.isDisabled)
          return !0;
        if (!s.supportsFiber)
          return u("The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://reactjs.org/link/react-devtools"), !0;
        try {
          r2 && (a = z0({}, a, {
            getLaneLabelMap: L3,
            injectProfilingHooks: sr
          })), D3 = s.inject(a), bt = s;
        } catch (C) {
          u("React instrumentation encountered an error: %s.", C);
        }
        return !!s.checkDCE;
      }
      function zs(a, s) {
        if (bt && typeof bt.onScheduleFiberRoot == "function")
          try {
            bt.onScheduleFiberRoot(D3, a, s);
          } catch (C) {
            P1 || (P1 = !0, u("React instrumentation encountered an error: %s", C));
          }
      }
      function Us(a, s) {
        if (bt && typeof bt.onCommitFiberRoot == "function")
          try {
            var C = (a.current.flags & y0) === y0;
            if (o2) {
              var p;
              switch (s) {
                case W5:
                  p = I7;
                  break;
                case A4:
                  p = Pn;
                  break;
                case ur:
                  p = V4;
                  break;
                case lr:
                  p = T3;
                  break;
                default:
                  p = V4;
                  break;
              }
              bt.onCommitFiberRoot(D3, a, p, C);
            }
          } catch (m) {
            P1 || (P1 = !0, u("React instrumentation encountered an error: %s", m));
          }
      }
      function qs(a) {
        if (bt && typeof bt.onPostCommitFiberRoot == "function")
          try {
            bt.onPostCommitFiberRoot(D3, a);
          } catch (s) {
            P1 || (P1 = !0, u("React instrumentation encountered an error: %s", s));
          }
      }
      function Ws(a) {
        if (bt && typeof bt.onCommitFiberUnmount == "function")
          try {
            bt.onCommitFiberUnmount(D3, a);
          } catch (s) {
            P1 || (P1 = !0, u("React instrumentation encountered an error: %s", s));
          }
      }
      function ht(a) {
        if (typeof Sa == "function" && (YA(a), i(a)), bt && typeof bt.setStrictMode == "function")
          try {
            bt.setStrictMode(D3, a);
          } catch (s) {
            P1 || (P1 = !0, u("React instrumentation encountered an error: %s", s));
          }
      }
      function sr(a) {
        e0 = a;
      }
      function L3() {
        {
          for (var a = /* @__PURE__ */ new Map(), s = 1, C = 0; C < P3; C++) {
            var p = XA(s);
            a.set(s, p), s *= 2;
          }
          return a;
        }
      }
      function Ys(a) {
        e0 !== null && typeof e0.markCommitStarted == "function" && e0.markCommitStarted(a);
      }
      function $s() {
        e0 !== null && typeof e0.markCommitStopped == "function" && e0.markCommitStopped();
      }
      function F1(a) {
        e0 !== null && typeof e0.markComponentRenderStarted == "function" && e0.markComponentRenderStarted(a);
      }
      function N1() {
        e0 !== null && typeof e0.markComponentRenderStopped == "function" && e0.markComponentRenderStopped();
      }
      function Gs(a) {
        e0 !== null && typeof e0.markComponentPassiveEffectMountStarted == "function" && e0.markComponentPassiveEffectMountStarted(a);
      }
      function $A() {
        e0 !== null && typeof e0.markComponentPassiveEffectMountStopped == "function" && e0.markComponentPassiveEffectMountStopped();
      }
      function Z4(a) {
        e0 !== null && typeof e0.markComponentPassiveEffectUnmountStarted == "function" && e0.markComponentPassiveEffectUnmountStarted(a);
      }
      function Fn() {
        e0 !== null && typeof e0.markComponentPassiveEffectUnmountStopped == "function" && e0.markComponentPassiveEffectUnmountStopped();
      }
      function Ma(a) {
        e0 !== null && typeof e0.markComponentLayoutEffectMountStarted == "function" && e0.markComponentLayoutEffectMountStarted(a);
      }
      function GA() {
        e0 !== null && typeof e0.markComponentLayoutEffectMountStopped == "function" && e0.markComponentLayoutEffectMountStopped();
      }
      function B7(a) {
        e0 !== null && typeof e0.markComponentLayoutEffectUnmountStarted == "function" && e0.markComponentLayoutEffectUnmountStarted(a);
      }
      function Ks() {
        e0 !== null && typeof e0.markComponentLayoutEffectUnmountStopped == "function" && e0.markComponentLayoutEffectUnmountStopped();
      }
      function Q7(a, s, C) {
        e0 !== null && typeof e0.markComponentErrored == "function" && e0.markComponentErrored(a, s, C);
      }
      function c4(a, s, C) {
        e0 !== null && typeof e0.markComponentSuspended == "function" && e0.markComponentSuspended(a, s, C);
      }
      function x7(a) {
        e0 !== null && typeof e0.markLayoutEffectsStarted == "function" && e0.markLayoutEffectsStarted(a);
      }
      function b7() {
        e0 !== null && typeof e0.markLayoutEffectsStopped == "function" && e0.markLayoutEffectsStopped();
      }
      function k3(a) {
        e0 !== null && typeof e0.markPassiveEffectsStarted == "function" && e0.markPassiveEffectsStarted(a);
      }
      function Xs() {
        e0 !== null && typeof e0.markPassiveEffectsStopped == "function" && e0.markPassiveEffectsStopped();
      }
      function R3(a) {
        e0 !== null && typeof e0.markRenderStarted == "function" && e0.markRenderStarted(a);
      }
      function KA() {
        e0 !== null && typeof e0.markRenderYielded == "function" && e0.markRenderYielded();
      }
      function _a() {
        e0 !== null && typeof e0.markRenderStopped == "function" && e0.markRenderStopped();
      }
      function vt(a) {
        e0 !== null && typeof e0.markRenderScheduled == "function" && e0.markRenderScheduled(a);
      }
      function Oa(a, s) {
        e0 !== null && typeof e0.markForceUpdateScheduled == "function" && e0.markForceUpdateScheduled(a, s);
      }
      function w7(a, s) {
        e0 !== null && typeof e0.markStateUpdateScheduled == "function" && e0.markStateUpdateScheduled(a, s);
      }
      var B0 = (
        /*                         */
        0
      ), Y0 = (
        /*                 */
        1
      ), Ee = (
        /*                    */
        2
      ), He = (
        /*               */
        8
      ), me = (
        /*              */
        16
      ), Nt = Math.clz32 ? Math.clz32 : S7, s5 = Math.log, Ta = Math.LN2;
      function S7(a) {
        var s = a >>> 0;
        return s === 0 ? 32 : 31 - (s5(s) / Ta | 0) | 0;
      }
      var P3 = 31, H2 = (
        /*                        */
        0
      ), Ce = (
        /*                          */
        0
      ), O0 = (
        /*                        */
        1
      ), Nn = (
        /*    */
        2
      ), Lr = (
        /*             */
        4
      ), L5 = (
        /*            */
        8
      ), wt = (
        /*                     */
        16
      ), z4 = (
        /*                */
        32
      ), Hn = (
        /*                       */
        4194240
      ), F3 = (
        /*                        */
        64
      ), Da = (
        /*                        */
        128
      ), La = (
        /*                        */
        256
      ), ka = (
        /*                        */
        512
      ), Ra = (
        /*                        */
        1024
      ), Pa = (
        /*                        */
        2048
      ), Fa = (
        /*                        */
        4096
      ), Na = (
        /*                        */
        8192
      ), Ha = (
        /*                        */
        16384
      ), N3 = (
        /*                       */
        32768
      ), ja = (
        /*                       */
        65536
      ), t6 = (
        /*                       */
        131072
      ), r6 = (
        /*                       */
        262144
      ), Va = (
        /*                       */
        524288
      ), M7 = (
        /*                       */
        1048576
      ), Za = (
        /*                       */
        2097152
      ), _7 = (
        /*                            */
        130023424
      ), H3 = (
        /*                             */
        4194304
      ), za = (
        /*                             */
        8388608
      ), O7 = (
        /*                             */
        16777216
      ), Ua = (
        /*                             */
        33554432
      ), qa = (
        /*                             */
        67108864
      ), Js = H3, T7 = (
        /*          */
        134217728
      ), eu = (
        /*                          */
        268435455
      ), D7 = (
        /*               */
        268435456
      ), j3 = (
        /*                        */
        536870912
      ), H1 = (
        /*                   */
        1073741824
      );
      function XA(a) {
        {
          if (a & O0)
            return "Sync";
          if (a & Nn)
            return "InputContinuousHydration";
          if (a & Lr)
            return "InputContinuous";
          if (a & L5)
            return "DefaultHydration";
          if (a & wt)
            return "Default";
          if (a & z4)
            return "TransitionHydration";
          if (a & Hn)
            return "Transition";
          if (a & _7)
            return "Retry";
          if (a & T7)
            return "SelectiveHydration";
          if (a & D7)
            return "IdleHydration";
          if (a & j3)
            return "Idle";
          if (a & H1)
            return "Offscreen";
        }
      }
      var Xe = -1, V3 = F3, Wa = H3;
      function L7(a) {
        switch (jn(a)) {
          case O0:
            return O0;
          case Nn:
            return Nn;
          case Lr:
            return Lr;
          case L5:
            return L5;
          case wt:
            return wt;
          case z4:
            return z4;
          case F3:
          case Da:
          case La:
          case ka:
          case Ra:
          case Pa:
          case Fa:
          case Na:
          case Ha:
          case N3:
          case ja:
          case t6:
          case r6:
          case Va:
          case M7:
          case Za:
            return a & Hn;
          case H3:
          case za:
          case O7:
          case Ua:
          case qa:
            return a & _7;
          case T7:
            return T7;
          case D7:
            return D7;
          case j3:
            return j3;
          case H1:
            return H1;
          default:
            return u("Should have found matching lanes. This is a bug in React."), a;
        }
      }
      function Ya(a, s) {
        var C = a.pendingLanes;
        if (C === H2)
          return H2;
        var p = H2, m = a.suspendedLanes, b = a.pingedLanes, L = C & eu;
        if (L !== H2) {
          var P = L & ~m;
          if (P !== H2)
            p = L7(P);
          else {
            var N = L & b;
            N !== H2 && (p = L7(N));
          }
        } else {
          var G = C & ~m;
          G !== H2 ? p = L7(G) : b !== H2 && (p = L7(b));
        }
        if (p === H2)
          return H2;
        if (s !== H2 && s !== p && // If we already suspended with a delay, then interrupting is fine. Don't
        // bother waiting until the root is complete.
        (s & m) === H2) {
          var J = jn(p), h2 = jn(s);
          if (
            // Tests whether the next lane is equal or lower priority than the wip
            // one. This works because the bits decrease in priority as you go left.
            J >= h2 || // Default priority updates should not interrupt transition updates. The
            // only difference between default updates and transition updates is that
            // default updates do not support refresh transitions.
            J === wt && (h2 & Hn) !== H2
          )
            return s;
        }
        (p & Lr) !== H2 && (p |= C & wt);
        var g2 = a.entangledLanes;
        if (g2 !== H2)
          for (var B2 = a.entanglements, b2 = p & g2; b2 > 0; ) {
            var T2 = Ht(b2), t0 = 1 << T2;
            p |= B2[T2], b2 &= ~t0;
          }
        return p;
      }
      function kr(a, s) {
        for (var C = a.eventTimes, p = Xe; s > 0; ) {
          var m = Ht(s), b = 1 << m, L = C[m];
          L > p && (p = L), s &= ~b;
        }
        return p;
      }
      function tu(a, s) {
        switch (a) {
          case O0:
          case Nn:
          case Lr:
            return s + 250;
          case L5:
          case wt:
          case z4:
          case F3:
          case Da:
          case La:
          case ka:
          case Ra:
          case Pa:
          case Fa:
          case Na:
          case Ha:
          case N3:
          case ja:
          case t6:
          case r6:
          case Va:
          case M7:
          case Za:
            return s + 5e3;
          case H3:
          case za:
          case O7:
          case Ua:
          case qa:
            return Xe;
          case T7:
          case D7:
          case j3:
          case H1:
            return Xe;
          default:
            return u("Should have found matching lanes. This is a bug in React."), Xe;
        }
      }
      function $a(a, s) {
        for (var C = a.pendingLanes, p = a.suspendedLanes, m = a.pingedLanes, b = a.expirationTimes, L = C; L > 0; ) {
          var P = Ht(L), N = 1 << P, G = b[P];
          G === Xe ? ((N & p) === H2 || (N & m) !== H2) && (b[P] = tu(N, s)) : G <= s && (a.expiredLanes |= N), L &= ~N;
        }
      }
      function JA(a) {
        return L7(a.pendingLanes);
      }
      function Ga(a) {
        var s = a.pendingLanes & -1073741825;
        return s !== H2 ? s : s & H1 ? H1 : H2;
      }
      function ef(a) {
        return (a & O0) !== H2;
      }
      function k7(a) {
        return (a & eu) !== H2;
      }
      function Z3(a) {
        return (a & _7) === a;
      }
      function ru(a) {
        var s = O0 | Lr | wt;
        return (a & s) === H2;
      }
      function nu(a) {
        return (a & Hn) === a;
      }
      function Ka(a, s) {
        var C = Nn | Lr | L5 | wt;
        return (s & C) !== H2;
      }
      function tf(a, s) {
        return (s & a.expiredLanes) !== H2;
      }
      function iu(a) {
        return (a & Hn) !== H2;
      }
      function au() {
        var a = V3;
        return V3 <<= 1, (V3 & Hn) === H2 && (V3 = F3), a;
      }
      function rf() {
        var a = Wa;
        return Wa <<= 1, (Wa & _7) === H2 && (Wa = H3), a;
      }
      function jn(a) {
        return a & -a;
      }
      function R7(a) {
        return jn(a);
      }
      function Ht(a) {
        return 31 - Nt(a);
      }
      function E5(a) {
        return Ht(a);
      }
      function m1(a, s) {
        return (a & s) !== H2;
      }
      function z3(a, s) {
        return (a & s) === s;
      }
      function V0(a, s) {
        return a | s;
      }
      function P7(a, s) {
        return a & ~s;
      }
      function ou(a, s) {
        return a & s;
      }
      function nf(a) {
        return a;
      }
      function af(a, s) {
        return a !== Ce && a < s ? a : s;
      }
      function F7(a) {
        for (var s = [], C = 0; C < P3; C++)
          s.push(a);
        return s;
      }
      function n6(a, s, C) {
        a.pendingLanes |= s, s !== j3 && (a.suspendedLanes = H2, a.pingedLanes = H2);
        var p = a.eventTimes, m = E5(s);
        p[m] = C;
      }
      function of(a, s) {
        a.suspendedLanes |= s, a.pingedLanes &= ~s;
        for (var C = a.expirationTimes, p = s; p > 0; ) {
          var m = Ht(p), b = 1 << m;
          C[m] = Xe, p &= ~b;
        }
      }
      function Xa(a, s, C) {
        a.pingedLanes |= a.suspendedLanes & s;
      }
      function su(a, s) {
        var C = a.pendingLanes & ~s;
        a.pendingLanes = s, a.suspendedLanes = H2, a.pingedLanes = H2, a.expiredLanes &= s, a.mutableReadLanes &= s, a.entangledLanes &= s;
        for (var p = a.entanglements, m = a.eventTimes, b = a.expirationTimes, L = C; L > 0; ) {
          var P = Ht(L), N = 1 << P;
          p[P] = H2, m[P] = Xe, b[P] = Xe, L &= ~N;
        }
      }
      function Ja(a, s) {
        for (var C = a.entangledLanes |= s, p = a.entanglements, m = C; m; ) {
          var b = Ht(m), L = 1 << b;
          // Is this one of the newly entangled lanes?
          L & s | // Is this lane transitively entangled with the newly entangled lanes?
          p[b] & s && (p[b] |= s), m &= ~L;
        }
      }
      function uu(a, s) {
        var C = jn(s), p;
        switch (C) {
          case Lr:
            p = Nn;
            break;
          case wt:
            p = L5;
            break;
          case F3:
          case Da:
          case La:
          case ka:
          case Ra:
          case Pa:
          case Fa:
          case Na:
          case Ha:
          case N3:
          case ja:
          case t6:
          case r6:
          case Va:
          case M7:
          case Za:
          case H3:
          case za:
          case O7:
          case Ua:
          case qa:
            p = z4;
            break;
          case j3:
            p = D7;
            break;
          default:
            p = Ce;
            break;
        }
        return (p & (a.suspendedLanes | s)) !== Ce ? Ce : p;
      }
      function N7(a, s, C) {
        if (E1)
          for (var p = a.pendingUpdatersLaneMap; C > 0; ) {
            var m = E5(C), b = 1 << m, L = p[m];
            L.add(s), C &= ~b;
          }
      }
      function sf(a, s) {
        if (E1)
          for (var C = a.pendingUpdatersLaneMap, p = a.memoizedUpdaters; s > 0; ) {
            var m = E5(s), b = 1 << m, L = C[m];
            L.size > 0 && (L.forEach(function(P) {
              var N = P.alternate;
              (N === null || !p.has(N)) && p.add(P);
            }), L.clear()), s &= ~b;
          }
      }
      function lu(a, s) {
        return null;
      }
      var W5 = O0, A4 = Lr, ur = wt, lr = j3, H7 = Ce;
      function cr() {
        return H7;
      }
      function jt(a) {
        H7 = a;
      }
      function uf(a, s) {
        var C = H7;
        try {
          return H7 = a, s();
        } finally {
          H7 = C;
        }
      }
      function lf(a, s) {
        return a !== 0 && a < s ? a : s;
      }
      function j7(a, s) {
        return a > s ? a : s;
      }
      function u5(a, s) {
        return a !== 0 && a < s;
      }
      function cf(a) {
        var s = jn(a);
        return u5(W5, s) ? u5(A4, s) ? k7(s) ? ur : lr : A4 : W5;
      }
      function eo(a) {
        var s = a.current.memoizedState;
        return s.isDehydrated;
      }
      var V7;
      function k5(a) {
        V7 = a;
      }
      function cv(a) {
        V7(a);
      }
      var s0;
      function i6(a) {
        s0 = a;
      }
      var to;
      function Af(a) {
        to = a;
      }
      var ff;
      function Z7(a) {
        ff = a;
      }
      var z7;
      function cu(a) {
        z7 = a;
      }
      var ro = !1, U7 = [], U4 = null, f4 = null, C4 = null, St = /* @__PURE__ */ new Map(), Y5 = /* @__PURE__ */ new Map(), $5 = [], Cf = [
        "mousedown",
        "mouseup",
        "touchcancel",
        "touchend",
        "touchstart",
        "auxclick",
        "dblclick",
        "pointercancel",
        "pointerdown",
        "pointerup",
        "dragend",
        "dragstart",
        "drop",
        "compositionend",
        "compositionstart",
        "keydown",
        "keypress",
        "keyup",
        "input",
        "textInput",
        // Intentionally camelCase
        "copy",
        "cut",
        "paste",
        "click",
        "change",
        "contextmenu",
        "reset",
        "submit"
      ];
      function df(a) {
        return Cf.indexOf(a) > -1;
      }
      function Rr(a, s, C, p, m) {
        return {
          blockedOn: a,
          domEventName: s,
          eventSystemFlags: C,
          nativeEvent: m,
          targetContainers: [p]
        };
      }
      function Au(a, s) {
        switch (a) {
          case "focusin":
          case "focusout":
            U4 = null;
            break;
          case "dragenter":
          case "dragleave":
            f4 = null;
            break;
          case "mouseover":
          case "mouseout":
            C4 = null;
            break;
          case "pointerover":
          case "pointerout": {
            var C = s.pointerId;
            St.delete(C);
            break;
          }
          case "gotpointercapture":
          case "lostpointercapture": {
            var p = s.pointerId;
            Y5.delete(p);
            break;
          }
        }
      }
      function y1(a, s, C, p, m, b) {
        if (a === null || a.nativeEvent !== b) {
          var L = Rr(s, C, p, m, b);
          if (s !== null) {
            var P = C6(s);
            P !== null && s0(P);
          }
          return L;
        }
        a.eventSystemFlags |= p;
        var N = a.targetContainers;
        return m !== null && N.indexOf(m) === -1 && N.push(m), a;
      }
      function Av(a, s, C, p, m) {
        switch (s) {
          case "focusin": {
            var b = m;
            return U4 = y1(U4, a, s, C, p, b), !0;
          }
          case "dragenter": {
            var L = m;
            return f4 = y1(f4, a, s, C, p, L), !0;
          }
          case "mouseover": {
            var P = m;
            return C4 = y1(C4, a, s, C, p, P), !0;
          }
          case "pointerover": {
            var N = m, G = N.pointerId;
            return St.set(G, y1(St.get(G) || null, a, s, C, p, N)), !0;
          }
          case "gotpointercapture": {
            var J = m, h2 = J.pointerId;
            return Y5.set(h2, y1(Y5.get(h2) || null, a, s, C, p, J)), !0;
          }
        }
        return !1;
      }
      function fu(a) {
        var s = ni(a.target);
        if (s !== null) {
          var C = R1(s);
          if (C !== null) {
            var p = C.tag;
            if (p === w) {
              var m = u4(C);
              if (m !== null) {
                a.blockedOn = m, z7(a.priority, function() {
                  to(C);
                });
                return;
              }
            } else if (p === h) {
              var b = C.stateNode;
              if (eo(b)) {
                a.blockedOn = l4(C);
                return;
              }
            }
          }
        }
        a.blockedOn = null;
      }
      function gf(a) {
        for (var s = ff(), C = {
          blockedOn: null,
          target: a,
          priority: s
        }, p = 0; p < $5.length && u5(s, $5[p].priority); p++)
          ;
        $5.splice(p, 0, C), p === 0 && fu(C);
      }
      function q7(a) {
        if (a.blockedOn !== null)
          return !1;
        for (var s = a.targetContainers; s.length > 0; ) {
          var C = s[0], p = o6(a.domEventName, a.eventSystemFlags, C, a.nativeEvent);
          if (p === null) {
            var m = a.nativeEvent, b = new m.constructor(m.type, m);
            av(b), m.target.dispatchEvent(b), ov();
          } else {
            var L = C6(p);
            return L !== null && s0(L), a.blockedOn = p, !1;
          }
          s.shift();
        }
        return !0;
      }
      function Cu(a, s, C) {
        q7(a) && C.delete(s);
      }
      function fv() {
        ro = !1, U4 !== null && q7(U4) && (U4 = null), f4 !== null && q7(f4) && (f4 = null), C4 !== null && q7(C4) && (C4 = null), St.forEach(Cu), Y5.forEach(Cu);
      }
      function Vn(a, s) {
        a.blockedOn === s && (a.blockedOn = null, ro || (ro = !0, t.unstable_scheduleCallback(t.unstable_NormalPriority, fv)));
      }
      function U3(a) {
        if (U7.length > 0) {
          Vn(U7[0], a);
          for (var s = 1; s < U7.length; s++) {
            var C = U7[s];
            C.blockedOn === a && (C.blockedOn = null);
          }
        }
        U4 !== null && Vn(U4, a), f4 !== null && Vn(f4, a), C4 !== null && Vn(C4, a);
        var p = function(P) {
          return Vn(P, a);
        };
        St.forEach(p), Y5.forEach(p);
        for (var m = 0; m < $5.length; m++) {
          var b = $5[m];
          b.blockedOn === a && (b.blockedOn = null);
        }
        for (; $5.length > 0; ) {
          var L = $5[0];
          if (L.blockedOn !== null)
            break;
          fu(L), L.blockedOn === null && $5.shift();
        }
      }
      var m5 = r.ReactCurrentBatchConfig, ae = !0;
      function t5(a) {
        ae = !!a;
      }
      function Vt() {
        return ae;
      }
      function y5(a, s, C) {
        var p = no(s), m;
        switch (p) {
          case W5:
            m = j1;
            break;
          case A4:
            m = a6;
            break;
          case ur:
          default:
            m = Mt;
            break;
        }
        return m.bind(null, s, C, a);
      }
      function j1(a, s, C, p) {
        var m = cr(), b = m5.transition;
        m5.transition = null;
        try {
          jt(W5), Mt(a, s, C, p);
        } finally {
          jt(m), m5.transition = b;
        }
      }
      function a6(a, s, C, p) {
        var m = cr(), b = m5.transition;
        m5.transition = null;
        try {
          jt(A4), Mt(a, s, C, p);
        } finally {
          jt(m), m5.transition = b;
        }
      }
      function Mt(a, s, C, p) {
        ae && W7(a, s, C, p);
      }
      function W7(a, s, C, p) {
        var m = o6(a, s, C, p);
        if (m === null) {
          Mv(a, s, p, d4, C), Au(a, p);
          return;
        }
        if (Av(m, a, s, C, p)) {
          p.stopPropagation();
          return;
        }
        if (Au(a, p), s & rr && df(a)) {
          for (; m !== null; ) {
            var b = C6(m);
            b !== null && cv(b);
            var L = o6(a, s, C, p);
            if (L === null && Mv(a, s, p, d4, C), L === m)
              break;
            m = L;
          }
          m !== null && p.stopPropagation();
          return;
        }
        Mv(a, s, p, null, C);
      }
      var d4 = null;
      function o6(a, s, C, p) {
        d4 = null;
        var m = Ns(p), b = ni(m);
        if (b !== null) {
          var L = R1(b);
          if (L === null)
            b = null;
          else {
            var P = L.tag;
            if (P === w) {
              var N = u4(L);
              if (N !== null)
                return N;
              b = null;
            } else if (P === h) {
              var G = L.stateNode;
              if (eo(G))
                return l4(L);
              b = null;
            } else L !== b && (b = null);
          }
        }
        return d4 = b, null;
      }
      function no(a) {
        switch (a) {
          // Used by SimpleEventPlugin:
          case "cancel":
          case "click":
          case "close":
          case "contextmenu":
          case "copy":
          case "cut":
          case "auxclick":
          case "dblclick":
          case "dragend":
          case "dragstart":
          case "drop":
          case "focusin":
          case "focusout":
          case "input":
          case "invalid":
          case "keydown":
          case "keypress":
          case "keyup":
          case "mousedown":
          case "mouseup":
          case "paste":
          case "pause":
          case "play":
          case "pointercancel":
          case "pointerdown":
          case "pointerup":
          case "ratechange":
          case "reset":
          case "resize":
          case "seeked":
          case "submit":
          case "touchcancel":
          case "touchend":
          case "touchstart":
          case "volumechange":
          // Used by polyfills:
          // eslint-disable-next-line no-fallthrough
          case "change":
          case "selectionchange":
          case "textInput":
          case "compositionstart":
          case "compositionend":
          case "compositionupdate":
          // Only enableCreateEventHandleAPI:
          // eslint-disable-next-line no-fallthrough
          case "beforeblur":
          case "afterblur":
          // Not used by React but could be by user code:
          // eslint-disable-next-line no-fallthrough
          case "beforeinput":
          case "blur":
          case "fullscreenchange":
          case "focus":
          case "hashchange":
          case "popstate":
          case "select":
          case "selectstart":
            return W5;
          case "drag":
          case "dragenter":
          case "dragexit":
          case "dragleave":
          case "dragover":
          case "mousemove":
          case "mouseout":
          case "mouseover":
          case "pointermove":
          case "pointerout":
          case "pointerover":
          case "scroll":
          case "toggle":
          case "touchmove":
          case "wheel":
          // Not used by React but could be by user code:
          // eslint-disable-next-line no-fallthrough
          case "mouseenter":
          case "mouseleave":
          case "pointerenter":
          case "pointerleave":
            return A4;
          case "message": {
            var s = wa();
            switch (s) {
              case I7:
                return W5;
              case Pn:
                return A4;
              case V4:
              case lv:
                return ur;
              case T3:
                return lr;
              default:
                return ur;
            }
          }
          default:
            return ur;
        }
      }
      function Y7(a, s, C) {
        return a.addEventListener(s, C, !1), C;
      }
      function I1(a, s, C) {
        return a.addEventListener(s, C, !0), C;
      }
      function du(a, s, C, p) {
        return a.addEventListener(s, C, {
          capture: !0,
          passive: p
        }), C;
      }
      function s6(a, s, C, p) {
        return a.addEventListener(s, C, {
          passive: p
        }), C;
      }
      var V1 = null, u6 = null, q3 = null;
      function Zn(a) {
        return V1 = a, u6 = $7(), !0;
      }
      function io() {
        V1 = null, u6 = null, q3 = null;
      }
      function q4() {
        if (q3)
          return q3;
        var a, s = u6, C = s.length, p, m = $7(), b = m.length;
        for (a = 0; a < C && s[a] === m[a]; a++)
          ;
        var L = C - a;
        for (p = 1; p <= L && s[C - p] === m[b - p]; p++)
          ;
        var P = p > 1 ? 1 - p : void 0;
        return q3 = m.slice(a, P), q3;
      }
      function $7() {
        return "value" in V1 ? V1.value : V1.textContent;
      }
      function zn(a) {
        var s, C = a.keyCode;
        return "charCode" in a ? (s = a.charCode, s === 0 && C === 13 && (s = 13)) : s = C, s === 10 && (s = 13), s >= 32 || s === 13 ? s : 0;
      }
      function l6() {
        return !0;
      }
      function G7() {
        return !1;
      }
      function R5(a) {
        function s(C, p, m, b, L) {
          this._reactName = C, this._targetInst = m, this.type = p, this.nativeEvent = b, this.target = L, this.currentTarget = null;
          for (var P in a)
            if (a.hasOwnProperty(P)) {
              var N = a[P];
              N ? this[P] = N(b) : this[P] = b[P];
            }
          var G = b.defaultPrevented != null ? b.defaultPrevented : b.returnValue === !1;
          return G ? this.isDefaultPrevented = l6 : this.isDefaultPrevented = G7, this.isPropagationStopped = G7, this;
        }
        return z0(s.prototype, {
          preventDefault: function() {
            this.defaultPrevented = !0;
            var C = this.nativeEvent;
            C && (C.preventDefault ? C.preventDefault() : typeof C.returnValue != "unknown" && (C.returnValue = !1), this.isDefaultPrevented = l6);
          },
          stopPropagation: function() {
            var C = this.nativeEvent;
            C && (C.stopPropagation ? C.stopPropagation() : typeof C.cancelBubble != "unknown" && (C.cancelBubble = !0), this.isPropagationStopped = l6);
          },
          /**
           * We release all dispatched `SyntheticEvent`s after each event loop, adding
           * them back into the pool. This allows a way to hold onto a reference that
           * won't be added back into the pool.
           */
          persist: function() {
          },
          /**
           * Checks if this event should be released back into the pool.
           *
           * @return {boolean} True if this should not be released, false otherwise.
           */
          isPersistent: l6
        }), s;
      }
      var Zt = {
        eventPhase: 0,
        bubbles: 0,
        cancelable: 0,
        timeStamp: function(a) {
          return a.timeStamp || Date.now();
        },
        defaultPrevented: 0,
        isTrusted: 0
      }, g4 = R5(Zt), G5 = z0({}, Zt, {
        view: 0,
        detail: 0
      }), B1 = R5(G5), ao, K7, W3;
      function Cv(a) {
        a !== W3 && (W3 && a.type === "mousemove" ? (ao = a.screenX - W3.screenX, K7 = a.screenY - W3.screenY) : (ao = 0, K7 = 0), W3 = a);
      }
      var Pr = z0({}, G5, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        pageX: 0,
        pageY: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        getModifierState: dt,
        button: 0,
        buttons: 0,
        relatedTarget: function(a) {
          return a.relatedTarget === void 0 ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
        },
        movementX: function(a) {
          return "movementX" in a ? a.movementX : (Cv(a), ao);
        },
        movementY: function(a) {
          return "movementY" in a ? a.movementY : K7;
        }
      }), gu = R5(Pr), pu = z0({}, Pr, {
        dataTransfer: 0
      }), Y3 = R5(pu), hu = z0({}, G5, {
        relatedTarget: 0
      }), W4 = R5(hu), pf = z0({}, Zt, {
        animationName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }), hf = R5(pf), vu = z0({}, Zt, {
        clipboardData: function(a) {
          return "clipboardData" in a ? a.clipboardData : window.clipboardData;
        }
      }), oo = R5(vu), dv = z0({}, Zt, {
        data: 0
      }), vf = R5(dv), Ef = vf, mf = {
        Esc: "Escape",
        Spacebar: " ",
        Left: "ArrowLeft",
        Up: "ArrowUp",
        Right: "ArrowRight",
        Down: "ArrowDown",
        Del: "Delete",
        Win: "OS",
        Menu: "ContextMenu",
        Apps: "ContextMenu",
        Scroll: "ScrollLock",
        MozPrintableKey: "Unidentified"
      }, $3 = {
        8: "Backspace",
        9: "Tab",
        12: "Clear",
        13: "Enter",
        16: "Shift",
        17: "Control",
        18: "Alt",
        19: "Pause",
        20: "CapsLock",
        27: "Escape",
        32: " ",
        33: "PageUp",
        34: "PageDown",
        35: "End",
        36: "Home",
        37: "ArrowLeft",
        38: "ArrowUp",
        39: "ArrowRight",
        40: "ArrowDown",
        45: "Insert",
        46: "Delete",
        112: "F1",
        113: "F2",
        114: "F3",
        115: "F4",
        116: "F5",
        117: "F6",
        118: "F7",
        119: "F8",
        120: "F9",
        121: "F10",
        122: "F11",
        123: "F12",
        144: "NumLock",
        145: "ScrollLock",
        224: "Meta"
      };
      function gv(a) {
        if (a.key) {
          var s = mf[a.key] || a.key;
          if (s !== "Unidentified")
            return s;
        }
        if (a.type === "keypress") {
          var C = zn(a);
          return C === 13 ? "Enter" : String.fromCharCode(C);
        }
        return a.type === "keydown" || a.type === "keyup" ? $3[a.keyCode] || "Unidentified" : "";
      }
      var c6 = {
        Alt: "altKey",
        Control: "ctrlKey",
        Meta: "metaKey",
        Shift: "shiftKey"
      };
      function yf(a) {
        var s = this, C = s.nativeEvent;
        if (C.getModifierState)
          return C.getModifierState(a);
        var p = c6[a];
        return p ? !!C[p] : !1;
      }
      function dt(a) {
        return yf;
      }
      var pv = z0({}, G5, {
        key: gv,
        code: 0,
        location: 0,
        ctrlKey: 0,
        shiftKey: 0,
        altKey: 0,
        metaKey: 0,
        repeat: 0,
        locale: 0,
        getModifierState: dt,
        // Legacy Interface
        charCode: function(a) {
          return a.type === "keypress" ? zn(a) : 0;
        },
        keyCode: function(a) {
          return a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
        },
        which: function(a) {
          return a.type === "keypress" ? zn(a) : a.type === "keydown" || a.type === "keyup" ? a.keyCode : 0;
        }
      }), If = R5(pv), hv = z0({}, Pr, {
        pointerId: 0,
        width: 0,
        height: 0,
        pressure: 0,
        tangentialPressure: 0,
        tiltX: 0,
        tiltY: 0,
        twist: 0,
        pointerType: 0,
        isPrimary: 0
      }), Bf = R5(hv), Qf = z0({}, G5, {
        touches: 0,
        targetTouches: 0,
        changedTouches: 0,
        altKey: 0,
        metaKey: 0,
        ctrlKey: 0,
        shiftKey: 0,
        getModifierState: dt
      }), xf = R5(Qf), vv = z0({}, Zt, {
        propertyName: 0,
        elapsedTime: 0,
        pseudoElement: 0
      }), Ar = R5(vv), Eu = z0({}, Pr, {
        deltaX: function(a) {
          return "deltaX" in a ? a.deltaX : (
            // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
            "wheelDeltaX" in a ? -a.wheelDeltaX : 0
          );
        },
        deltaY: function(a) {
          return "deltaY" in a ? a.deltaY : (
            // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
            "wheelDeltaY" in a ? -a.wheelDeltaY : (
              // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
              "wheelDelta" in a ? -a.wheelDelta : 0
            )
          );
        },
        deltaZ: 0,
        // Browsers without "deltaMode" is reporting in raw wheel delta where one
        // notch on the scroll is always +/- 120, roughly equivalent to pixels.
        // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
        // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
        deltaMode: 0
      }), Ev = R5(Eu), Un = [9, 13, 27, 32], X7 = 229, Y4 = W2 && "CompositionEvent" in window, qn = null;
      W2 && "documentMode" in document && (qn = document.documentMode);
      var mu = W2 && "TextEvent" in window && !qn, so = W2 && (!Y4 || qn && qn > 8 && qn <= 11), bf = 32, uo = String.fromCharCode(bf);
      function mv() {
        v2("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), v2("onCompositionEnd", ["compositionend", "focusout", "keydown", "keypress", "keyup", "mousedown"]), v2("onCompositionStart", ["compositionstart", "focusout", "keydown", "keypress", "keyup", "mousedown"]), v2("onCompositionUpdate", ["compositionupdate", "focusout", "keydown", "keypress", "keyup", "mousedown"]);
      }
      var yu = !1;
      function wf(a) {
        return (a.ctrlKey || a.altKey || a.metaKey) && // ctrlKey && altKey is equivalent to AltGr, and is not a command.
        !(a.ctrlKey && a.altKey);
      }
      function lo(a) {
        switch (a) {
          case "compositionstart":
            return "onCompositionStart";
          case "compositionend":
            return "onCompositionEnd";
          case "compositionupdate":
            return "onCompositionUpdate";
        }
      }
      function co(a, s) {
        return a === "keydown" && s.keyCode === X7;
      }
      function Iu(a, s) {
        switch (a) {
          case "keyup":
            return Un.indexOf(s.keyCode) !== -1;
          case "keydown":
            return s.keyCode !== X7;
          case "keypress":
          case "mousedown":
          case "focusout":
            return !0;
          default:
            return !1;
        }
      }
      function Ao(a) {
        var s = a.detail;
        return typeof s == "object" && "data" in s ? s.data : null;
      }
      function Sf(a) {
        return a.locale === "ko";
      }
      var G3 = !1;
      function Bu(a, s, C, p, m) {
        var b, L;
        if (Y4 ? b = lo(s) : G3 ? Iu(s, p) && (b = "onCompositionEnd") : co(s, p) && (b = "onCompositionStart"), !b)
          return null;
        so && !Sf(p) && (!G3 && b === "onCompositionStart" ? G3 = Zn(m) : b === "onCompositionEnd" && G3 && (L = q4()));
        var P = kf(C, b);
        if (P.length > 0) {
          var N = new vf(b, s, null, p, m);
          if (a.push({
            event: N,
            listeners: P
          }), L)
            N.data = L;
          else {
            var G = Ao(p);
            G !== null && (N.data = G);
          }
        }
      }
      function fo(a, s) {
        switch (a) {
          case "compositionend":
            return Ao(s);
          case "keypress":
            var C = s.which;
            return C !== bf ? null : (yu = !0, uo);
          case "textInput":
            var p = s.data;
            return p === uo && yu ? null : p;
          default:
            return null;
        }
      }
      function Qu(a, s) {
        if (G3) {
          if (a === "compositionend" || !Y4 && Iu(a, s)) {
            var C = q4();
            return io(), G3 = !1, C;
          }
          return null;
        }
        switch (a) {
          case "paste":
            return null;
          case "keypress":
            if (!wf(s)) {
              if (s.char && s.char.length > 1)
                return s.char;
              if (s.which)
                return String.fromCharCode(s.which);
            }
            return null;
          case "compositionend":
            return so && !Sf(s) ? null : s.data;
          default:
            return null;
        }
      }
      function Co(a, s, C, p, m) {
        var b;
        if (mu ? b = fo(s, p) : b = Qu(s, p), !b)
          return null;
        var L = kf(C, "onBeforeInput");
        if (L.length > 0) {
          var P = new Ef("onBeforeInput", "beforeinput", null, p, m);
          a.push({
            event: P,
            listeners: L
          }), P.data = b;
        }
      }
      function Mf(a, s, C, p, m, b, L) {
        Bu(a, s, C, p, m), Co(a, s, C, p, m);
      }
      var yv = {
        color: !0,
        date: !0,
        datetime: !0,
        "datetime-local": !0,
        email: !0,
        month: !0,
        number: !0,
        password: !0,
        range: !0,
        search: !0,
        tel: !0,
        text: !0,
        time: !0,
        url: !0,
        week: !0
      };
      function J7(a) {
        var s = a && a.nodeName && a.nodeName.toLowerCase();
        return s === "input" ? !!yv[a.type] : s === "textarea";
      }
      /**
       * Checks if an event is supported in the current execution environment.
       *
       * NOTE: This will not work correctly for non-generic events such as `change`,
       * `reset`, `load`, `error`, and `select`.
       *
       * Borrows from Modernizr.
       *
       * @param {string} eventNameSuffix Event name, e.g. "click".
       * @return {boolean} True if the event is supported.
       * @internal
       * @license Modernizr 3.0.0pre (Custom Build) | MIT
       */
      function Iv(a) {
        if (!W2)
          return !1;
        var s = "on" + a, C = s in document;
        if (!C) {
          var p = document.createElement("div");
          p.setAttribute(s, "return;"), C = typeof p[s] == "function";
        }
        return C;
      }
      function ei() {
        v2("onChange", ["change", "click", "focusin", "focusout", "input", "keydown", "keyup", "selectionchange"]);
      }
      function _f(a, s, C, p) {
        W8(p);
        var m = kf(s, "onChange");
        if (m.length > 0) {
          var b = new g4("onChange", "change", null, C, p);
          a.push({
            event: b,
            listeners: m
          });
        }
      }
      var Wn = null, l = null;
      function A(a) {
        var s = a.nodeName && a.nodeName.toLowerCase();
        return s === "select" || s === "input" && a.type === "file";
      }
      function v(a) {
        var s = [];
        _f(s, l, a, Ns(a)), jA(x, s);
      }
      function x(a) {
        B_(a, 0);
      }
      function T(a) {
        var s = mo(a);
        if (r4(s))
          return a;
      }
      function R(a, s) {
        if (a === "change")
          return s;
      }
      var U = !1;
      W2 && (U = Iv("input") && (!document.documentMode || document.documentMode > 9));
      function i2(a, s) {
        Wn = a, l = s, Wn.attachEvent("onpropertychange", x2);
      }
      function A2() {
        Wn && (Wn.detachEvent("onpropertychange", x2), Wn = null, l = null);
      }
      function x2(a) {
        a.propertyName === "value" && T(l) && v(a);
      }
      function V2(a, s, C) {
        a === "focusin" ? (A2(), i2(s, C)) : a === "focusout" && A2();
      }
      function z2(a, s) {
        if (a === "selectionchange" || a === "keyup" || a === "keydown")
          return T(l);
      }
      function j2(a) {
        var s = a.nodeName;
        return s && s.toLowerCase() === "input" && (a.type === "checkbox" || a.type === "radio");
      }
      function n0(a, s) {
        if (a === "click")
          return T(s);
      }
      function f0(a, s) {
        if (a === "input" || a === "change")
          return T(s);
      }
      function p0(a) {
        var s = a._wrapperState;
        !s || !s.controlled || a.type !== "number" || Q0(a, "number", a.value);
      }
      function _t(a, s, C, p, m, b, L) {
        var P = C ? mo(C) : window, N, G;
        if (A(P) ? N = R : J7(P) ? U ? N = f0 : (N = z2, G = V2) : j2(P) && (N = n0), N) {
          var J = N(s, C);
          if (J) {
            _f(a, J, p, m);
            return;
          }
        }
        G && G(s, P, C), s === "focusout" && p0(P);
      }
      function E2() {
        L2("onMouseEnter", ["mouseout", "mouseover"]), L2("onMouseLeave", ["mouseout", "mouseover"]), L2("onPointerEnter", ["pointerout", "pointerover"]), L2("onPointerLeave", ["pointerout", "pointerover"]);
      }
      function p2(a, s, C, p, m, b, L) {
        var P = s === "mouseover" || s === "pointerover", N = s === "mouseout" || s === "pointerout";
        if (P && !p7(p)) {
          var G = p.relatedTarget || p.fromElement;
          if (G && (ni(G) || Fu(G)))
            return;
        }
        if (!(!N && !P)) {
          var J;
          if (m.window === m)
            J = m;
          else {
            var h2 = m.ownerDocument;
            h2 ? J = h2.defaultView || h2.parentWindow : J = window;
          }
          var g2, B2;
          if (N) {
            var b2 = p.relatedTarget || p.toElement;
            if (g2 = C, B2 = b2 ? ni(b2) : null, B2 !== null) {
              var T2 = R1(B2);
              (B2 !== T2 || B2.tag !== y && B2.tag !== I) && (B2 = null);
            }
          } else
            g2 = null, B2 = C;
          if (g2 !== B2) {
            var t0 = gu, x0 = "onMouseLeave", m0 = "onMouseEnter", se = "mouse";
            (s === "pointerout" || s === "pointerover") && (t0 = Bf, x0 = "onPointerLeave", m0 = "onPointerEnter", se = "pointer");
            var J0 = g2 == null ? J : mo(g2), m2 = B2 == null ? J : mo(B2), D2 = new t0(x0, se + "leave", g2, p, m);
            D2.target = J0, D2.relatedTarget = m2;
            var y2 = null, U2 = ni(m);
            if (U2 === C) {
              var o0 = new t0(m0, se + "enter", B2, p, m);
              o0.target = m2, o0.relatedTarget = J0, y2 = o0;
            }
            sK(a, D2, y2, g2, B2);
          }
        }
      }
      function I2(a, s) {
        return a === s && (a !== 0 || 1 / a === 1 / s) || a !== a && s !== s;
      }
      var Z2 = typeof Object.is == "function" ? Object.is : I2;
      function C0(a, s) {
        if (Z2(a, s))
          return !0;
        if (typeof a != "object" || a === null || typeof s != "object" || s === null)
          return !1;
        var C = Object.keys(a), p = Object.keys(s);
        if (C.length !== p.length)
          return !1;
        for (var m = 0; m < C.length; m++) {
          var b = C[m];
          if (!d2.call(s, b) || !Z2(a[b], s[b]))
            return !1;
        }
        return !0;
      }
      function w0(a) {
        for (; a && a.firstChild; )
          a = a.firstChild;
        return a;
      }
      function _0(a) {
        for (; a; ) {
          if (a.nextSibling)
            return a.nextSibling;
          a = a.parentNode;
        }
      }
      function D0(a, s) {
        for (var C = w0(a), p = 0, m = 0; C; ) {
          if (C.nodeType === P4) {
            if (m = p + C.textContent.length, p <= s && m >= s)
              return {
                node: C,
                offset: s - p
              };
            p = m;
          }
          C = w0(_0(C));
        }
      }
      function l5(a) {
        var s = a.ownerDocument, C = s && s.defaultView || window, p = C.getSelection && C.getSelection();
        if (!p || p.rangeCount === 0)
          return null;
        var m = p.anchorNode, b = p.anchorOffset, L = p.focusNode, P = p.focusOffset;
        try {
          m.nodeType, L.nodeType;
        } catch {
          return null;
        }
        return ye(a, m, b, L, P);
      }
      function ye(a, s, C, p, m) {
        var b = 0, L = -1, P = -1, N = 0, G = 0, J = a, h2 = null;
        e: for (; ; ) {
          for (var g2 = null; J === s && (C === 0 || J.nodeType === P4) && (L = b + C), J === p && (m === 0 || J.nodeType === P4) && (P = b + m), J.nodeType === P4 && (b += J.nodeValue.length), (g2 = J.firstChild) !== null; )
            h2 = J, J = g2;
          for (; ; ) {
            if (J === a)
              break e;
            if (h2 === s && ++N === C && (L = b), h2 === p && ++G === m && (P = b), (g2 = J.nextSibling) !== null)
              break;
            J = h2, h2 = J.parentNode;
          }
          J = g2;
        }
        return L === -1 || P === -1 ? null : {
          start: L,
          end: P
        };
      }
      function Yn(a, s) {
        var C = a.ownerDocument || document, p = C && C.defaultView || window;
        if (p.getSelection) {
          var m = p.getSelection(), b = a.textContent.length, L = Math.min(s.start, b), P = s.end === void 0 ? L : Math.min(s.end, b);
          if (!m.extend && L > P) {
            var N = P;
            P = L, L = N;
          }
          var G = D0(a, L), J = D0(a, P);
          if (G && J) {
            if (m.rangeCount === 1 && m.anchorNode === G.node && m.anchorOffset === G.offset && m.focusNode === J.node && m.focusOffset === J.offset)
              return;
            var h2 = C.createRange();
            h2.setStart(G.node, G.offset), m.removeAllRanges(), L > P ? (m.addRange(h2), m.extend(J.node, J.offset)) : (h2.setEnd(J.node, J.offset), m.addRange(h2));
          }
        }
      }
      function Of(a) {
        return a && a.nodeType === P4;
      }
      function f_(a, s) {
        return !a || !s ? !1 : a === s ? !0 : Of(a) ? !1 : Of(s) ? f_(a, s.parentNode) : "contains" in a ? a.contains(s) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(s) & 16) : !1;
      }
      function ZG(a) {
        return a && a.ownerDocument && f_(a.ownerDocument.documentElement, a);
      }
      function zG(a) {
        try {
          return typeof a.contentWindow.location.href == "string";
        } catch {
          return !1;
        }
      }
      function C_() {
        for (var a = window, s = tr(); s instanceof a.HTMLIFrameElement; ) {
          if (zG(s))
            a = s.contentWindow;
          else
            return s;
          s = tr(a.document);
        }
        return s;
      }
      function Bv(a) {
        var s = a && a.nodeName && a.nodeName.toLowerCase();
        return s && (s === "input" && (a.type === "text" || a.type === "search" || a.type === "tel" || a.type === "url" || a.type === "password") || s === "textarea" || a.contentEditable === "true");
      }
      function UG() {
        var a = C_();
        return {
          focusedElem: a,
          selectionRange: Bv(a) ? WG(a) : null
        };
      }
      function qG(a) {
        var s = C_(), C = a.focusedElem, p = a.selectionRange;
        if (s !== C && ZG(C)) {
          p !== null && Bv(C) && YG(C, p);
          for (var m = [], b = C; b = b.parentNode; )
            b.nodeType === C1 && m.push({
              element: b,
              left: b.scrollLeft,
              top: b.scrollTop
            });
          typeof C.focus == "function" && C.focus();
          for (var L = 0; L < m.length; L++) {
            var P = m[L];
            P.element.scrollLeft = P.left, P.element.scrollTop = P.top;
          }
        }
      }
      function WG(a) {
        var s;
        return "selectionStart" in a ? s = {
          start: a.selectionStart,
          end: a.selectionEnd
        } : s = l5(a), s || {
          start: 0,
          end: 0
        };
      }
      function YG(a, s) {
        var C = s.start, p = s.end;
        p === void 0 && (p = C), "selectionStart" in a ? (a.selectionStart = C, a.selectionEnd = Math.min(p, a.value.length)) : Yn(a, s);
      }
      var $G = W2 && "documentMode" in document && document.documentMode <= 11;
      function GG() {
        v2("onSelect", ["focusout", "contextmenu", "dragend", "focusin", "keydown", "keyup", "mousedown", "mouseup", "selectionchange"]);
      }
      var go = null, Qv = null, xu = null, xv = !1;
      function KG(a) {
        if ("selectionStart" in a && Bv(a))
          return {
            start: a.selectionStart,
            end: a.selectionEnd
          };
        var s = a.ownerDocument && a.ownerDocument.defaultView || window, C = s.getSelection();
        return {
          anchorNode: C.anchorNode,
          anchorOffset: C.anchorOffset,
          focusNode: C.focusNode,
          focusOffset: C.focusOffset
        };
      }
      function XG(a) {
        return a.window === a ? a.document : a.nodeType === F4 ? a : a.ownerDocument;
      }
      function d_(a, s, C) {
        var p = XG(C);
        if (!(xv || go == null || go !== tr(p))) {
          var m = KG(go);
          if (!xu || !C0(xu, m)) {
            xu = m;
            var b = kf(Qv, "onSelect");
            if (b.length > 0) {
              var L = new g4("onSelect", "select", null, s, C);
              a.push({
                event: L,
                listeners: b
              }), L.target = go;
            }
          }
        }
      }
      function JG(a, s, C, p, m, b, L) {
        var P = C ? mo(C) : window;
        switch (s) {
          // Track the input node that has focus.
          case "focusin":
            (J7(P) || P.contentEditable === "true") && (go = P, Qv = C, xu = null);
            break;
          case "focusout":
            go = null, Qv = null, xu = null;
            break;
          // Don't fire the event while the user is dragging. This matches the
          // semantics of the native select event.
          case "mousedown":
            xv = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            xv = !1, d_(a, p, m);
            break;
          // Chrome and IE fire non-standard event when selection is changed (and
          // sometimes when it hasn't). IE's event fires out of order with respect
          // to key and input events on deletion, so we discard it.
          //
          // Firefox doesn't support selectionchange, so check selection status
          // after each key entry. The selection changes after keydown and before
          // keyup, but we check on keydown as well in the case of holding down a
          // key, when multiple keydown events are fired but only one keyup is.
          // This is also our approach for IE handling, for the reason above.
          case "selectionchange":
            if ($G)
              break;
          // falls through
          case "keydown":
          case "keyup":
            d_(a, p, m);
        }
      }
      function Tf(a, s) {
        var C = {};
        return C[a.toLowerCase()] = s.toLowerCase(), C["Webkit" + a] = "webkit" + s, C["Moz" + a] = "moz" + s, C;
      }
      var po = {
        animationend: Tf("Animation", "AnimationEnd"),
        animationiteration: Tf("Animation", "AnimationIteration"),
        animationstart: Tf("Animation", "AnimationStart"),
        transitionend: Tf("Transition", "TransitionEnd")
      }, bv = {}, g_ = {};
      W2 && (g_ = document.createElement("div").style, "AnimationEvent" in window || (delete po.animationend.animation, delete po.animationiteration.animation, delete po.animationstart.animation), "TransitionEvent" in window || delete po.transitionend.transition);
      function Df(a) {
        if (bv[a])
          return bv[a];
        if (!po[a])
          return a;
        var s = po[a];
        for (var C in s)
          if (s.hasOwnProperty(C) && C in g_)
            return bv[a] = s[C];
        return a;
      }
      var p_ = Df("animationend"), h_ = Df("animationiteration"), v_ = Df("animationstart"), E_ = Df("transitionend"), m_ = /* @__PURE__ */ new Map(), y_ = ["abort", "auxClick", "cancel", "canPlay", "canPlayThrough", "click", "close", "contextMenu", "copy", "cut", "drag", "dragEnd", "dragEnter", "dragExit", "dragLeave", "dragOver", "dragStart", "drop", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "input", "invalid", "keyDown", "keyPress", "keyUp", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "mouseDown", "mouseMove", "mouseOut", "mouseOver", "mouseUp", "paste", "pause", "play", "playing", "pointerCancel", "pointerDown", "pointerMove", "pointerOut", "pointerOver", "pointerUp", "progress", "rateChange", "reset", "resize", "seeked", "seeking", "stalled", "submit", "suspend", "timeUpdate", "touchCancel", "touchEnd", "touchStart", "volumeChange", "scroll", "toggle", "touchMove", "waiting", "wheel"];
      function A6(a, s) {
        m_.set(a, s), v2(s, [a]);
      }
      function eK() {
        for (var a = 0; a < y_.length; a++) {
          var s = y_[a], C = s.toLowerCase(), p = s[0].toUpperCase() + s.slice(1);
          A6(C, "on" + p);
        }
        A6(p_, "onAnimationEnd"), A6(h_, "onAnimationIteration"), A6(v_, "onAnimationStart"), A6("dblclick", "onDoubleClick"), A6("focusin", "onFocus"), A6("focusout", "onBlur"), A6(E_, "onTransitionEnd");
      }
      function tK(a, s, C, p, m, b, L) {
        var P = m_.get(s);
        if (P !== void 0) {
          var N = g4, G = s;
          switch (s) {
            case "keypress":
              if (zn(p) === 0)
                return;
            /* falls through */
            case "keydown":
            case "keyup":
              N = If;
              break;
            case "focusin":
              G = "focus", N = W4;
              break;
            case "focusout":
              G = "blur", N = W4;
              break;
            case "beforeblur":
            case "afterblur":
              N = W4;
              break;
            case "click":
              if (p.button === 2)
                return;
            /* falls through */
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            // TODO: Disabled elements should not respond to mouse events
            /* falls through */
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              N = gu;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              N = Y3;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              N = xf;
              break;
            case p_:
            case h_:
            case v_:
              N = hf;
              break;
            case E_:
              N = Ar;
              break;
            case "scroll":
              N = B1;
              break;
            case "wheel":
              N = Ev;
              break;
            case "copy":
            case "cut":
            case "paste":
              N = oo;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              N = Bf;
              break;
          }
          var J = (b & rr) !== 0;
          {
            var h2 = !J && // TODO: ideally, we'd eventually add all events from
            // nonDelegatedEvents list in DOMPluginEventSystem.
            // Then we can remove this special list.
            // This is a breaking change that can wait until React 18.
            s === "scroll", g2 = aK(C, P, p.type, J, h2);
            if (g2.length > 0) {
              var B2 = new N(P, G, null, p, m);
              a.push({
                event: B2,
                listeners: g2
              });
            }
          }
        }
      }
      eK(), E2(), ei(), GG(), mv();
      function rK(a, s, C, p, m, b, L) {
        tK(a, s, C, p, m, b);
        var P = (b & Fs) === 0;
        P && (p2(a, s, C, p, m), _t(a, s, C, p, m), JG(a, s, C, p, m), Mf(a, s, C, p, m));
      }
      var bu = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "resize", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting"], wv = new Set(["cancel", "close", "invalid", "load", "scroll", "toggle"].concat(bu));
      function I_(a, s, C) {
        var p = a.type || "unknown-event";
        a.currentTarget = C, a4(p, s, void 0, a), a.currentTarget = null;
      }
      function nK(a, s, C) {
        var p;
        if (C)
          for (var m = s.length - 1; m >= 0; m--) {
            var b = s[m], L = b.instance, P = b.currentTarget, N = b.listener;
            if (L !== p && a.isPropagationStopped())
              return;
            I_(a, N, P), p = L;
          }
        else
          for (var G = 0; G < s.length; G++) {
            var J = s[G], h2 = J.instance, g2 = J.currentTarget, B2 = J.listener;
            if (h2 !== p && a.isPropagationStopped())
              return;
            I_(a, B2, g2), p = h2;
          }
      }
      function B_(a, s) {
        for (var C = (s & rr) !== 0, p = 0; p < a.length; p++) {
          var m = a[p], b = m.event, L = m.listeners;
          nK(b, L, C);
        }
        E7();
      }
      function iK(a, s, C, p, m) {
        var b = Ns(C), L = [];
        rK(L, a, p, C, b, s), B_(L, s);
      }
      function Et(a, s) {
        wv.has(a) || u('Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.', a);
        var C = !1, p = LX(s), m = uK(a);
        p.has(m) || (Q_(s, a, da, C), p.add(m));
      }
      function Sv(a, s, C) {
        wv.has(a) && !s && u('Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.', a);
        var p = 0;
        s && (p |= rr), Q_(C, a, p, s);
      }
      var Lf = "_reactListening" + Math.random().toString(36).slice(2);
      function wu(a) {
        if (!a[Lf]) {
          a[Lf] = !0, S2.forEach(function(C) {
            C !== "selectionchange" && (wv.has(C) || Sv(C, !1, a), Sv(C, !0, a));
          });
          var s = a.nodeType === F4 ? a : a.ownerDocument;
          s !== null && (s[Lf] || (s[Lf] = !0, Sv("selectionchange", !1, s)));
        }
      }
      function Q_(a, s, C, p, m) {
        var b = y5(a, s, C), L = void 0;
        v7 && (s === "touchstart" || s === "touchmove" || s === "wheel") && (L = !0), a = a, p ? L !== void 0 ? du(a, s, b, L) : I1(a, s, b) : L !== void 0 ? s6(a, s, b, L) : Y7(a, s, b);
      }
      function x_(a, s) {
        return a === s || a.nodeType === Rt && a.parentNode === s;
      }
      function Mv(a, s, C, p, m) {
        var b = p;
        if ((s & Ps) === 0 && (s & da) === 0) {
          var L = m;
          if (p !== null) {
            var P = p;
            e: for (; ; ) {
              if (P === null)
                return;
              var N = P.tag;
              if (N === h || N === E) {
                var G = P.stateNode.containerInfo;
                if (x_(G, L))
                  break;
                if (N === E)
                  for (var J = P.return; J !== null; ) {
                    var h2 = J.tag;
                    if (h2 === h || h2 === E) {
                      var g2 = J.stateNode.containerInfo;
                      if (x_(g2, L))
                        return;
                    }
                    J = J.return;
                  }
                for (; G !== null; ) {
                  var B2 = ni(G);
                  if (B2 === null)
                    return;
                  var b2 = B2.tag;
                  if (b2 === y || b2 === I) {
                    P = b = B2;
                    continue e;
                  }
                  G = G.parentNode;
                }
              }
              P = P.return;
            }
          }
        }
        jA(function() {
          return iK(a, s, C, b);
        });
      }
      function Su(a, s, C) {
        return {
          instance: a,
          listener: s,
          currentTarget: C
        };
      }
      function aK(a, s, C, p, m, b) {
        for (var L = s !== null ? s + "Capture" : null, P = p ? L : s, N = [], G = a, J = null; G !== null; ) {
          var h2 = G, g2 = h2.stateNode, B2 = h2.tag;
          if (B2 === y && g2 !== null && (J = g2, P !== null)) {
            var b2 = On(G, P);
            b2 != null && N.push(Su(G, b2, J));
          }
          if (m)
            break;
          G = G.return;
        }
        return N;
      }
      function kf(a, s) {
        for (var C = s + "Capture", p = [], m = a; m !== null; ) {
          var b = m, L = b.stateNode, P = b.tag;
          if (P === y && L !== null) {
            var N = L, G = On(m, C);
            G != null && p.unshift(Su(m, G, N));
            var J = On(m, s);
            J != null && p.push(Su(m, J, N));
          }
          m = m.return;
        }
        return p;
      }
      function ho(a) {
        if (a === null)
          return null;
        do
          a = a.return;
        while (a && a.tag !== y);
        return a || null;
      }
      function oK(a, s) {
        for (var C = a, p = s, m = 0, b = C; b; b = ho(b))
          m++;
        for (var L = 0, P = p; P; P = ho(P))
          L++;
        for (; m - L > 0; )
          C = ho(C), m--;
        for (; L - m > 0; )
          p = ho(p), L--;
        for (var N = m; N--; ) {
          if (C === p || p !== null && C === p.alternate)
            return C;
          C = ho(C), p = ho(p);
        }
        return null;
      }
      function b_(a, s, C, p, m) {
        for (var b = s._reactName, L = [], P = C; P !== null && P !== p; ) {
          var N = P, G = N.alternate, J = N.stateNode, h2 = N.tag;
          if (G !== null && G === p)
            break;
          if (h2 === y && J !== null) {
            var g2 = J;
            if (m) {
              var B2 = On(P, b);
              B2 != null && L.unshift(Su(P, B2, g2));
            } else if (!m) {
              var b2 = On(P, b);
              b2 != null && L.push(Su(P, b2, g2));
            }
          }
          P = P.return;
        }
        L.length !== 0 && a.push({
          event: s,
          listeners: L
        });
      }
      function sK(a, s, C, p, m) {
        var b = p && m ? oK(p, m) : null;
        p !== null && b_(a, s, p, b, !1), m !== null && C !== null && b_(a, C, m, b, !0);
      }
      function uK(a, s) {
        return a + "__bubble";
      }
      var fr = !1, Mu = "dangerouslySetInnerHTML", Rf = "suppressContentEditableWarning", f6 = "suppressHydrationWarning", w_ = "autoFocus", ti = "children", ri = "style", Pf = "__html", _v, Ff, _u, S_, Nf, M_, __;
      _v = {
        // There are working polyfills for <dialog>. Let people use it.
        dialog: !0,
        // Electron ships a custom <webview> tag to display external web content in
        // an isolated frame and process.
        // This tag is not present in non Electron environments such as JSDom which
        // is often used for testing purposes.
        // @see https://electronjs.org/docs/api/webview-tag
        webview: !0
      }, Ff = function(a, s) {
        Ls(a, s), fa(a, s), FA(a, s, {
          registrationNameDependencies: M2,
          possibleRegistrationNames: w2
        });
      }, M_ = W2 && !document.documentMode, _u = function(a, s, C) {
        if (!fr) {
          var p = Hf(C), m = Hf(s);
          m !== p && (fr = !0, u("Prop `%s` did not match. Server: %s Client: %s", a, JSON.stringify(m), JSON.stringify(p)));
        }
      }, S_ = function(a) {
        if (!fr) {
          fr = !0;
          var s = [];
          a.forEach(function(C) {
            s.push(C);
          }), u("Extra attributes from the server: %s", s);
        }
      }, Nf = function(a, s) {
        s === !1 ? u("Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.", a, a, a) : u("Expected `%s` listener to be a function, instead got a value of `%s` type.", a, typeof s);
      }, __ = function(a, s) {
        var C = a.namespaceURI === R4 ? a.ownerDocument.createElement(a.tagName) : a.ownerDocument.createElementNS(a.namespaceURI, a.tagName);
        return C.innerHTML = s, C.innerHTML;
      };
      var lK = /\r\n?/g, cK = /\u0000|\uFFFD/g;
      function Hf(a) {
        Oe(a);
        var s = typeof a == "string" ? a : "" + a;
        return s.replace(lK, `
`).replace(cK, "");
      }
      function jf(a, s, C, p) {
        var m = Hf(s), b = Hf(a);
        if (b !== m && (p && (fr || (fr = !0, u('Text content did not match. Server: "%s" Client: "%s"', b, m))), C && l2))
          throw new Error("Text content does not match server-rendered HTML.");
      }
      function O_(a) {
        return a.nodeType === F4 ? a : a.ownerDocument;
      }
      function AK() {
      }
      function Vf(a) {
        a.onclick = AK;
      }
      function fK(a, s, C, p, m) {
        for (var b in p)
          if (p.hasOwnProperty(b)) {
            var L = p[b];
            if (b === ri)
              L && Object.freeze(L), TA(s, L);
            else if (b === Mu) {
              var P = L ? L[Pf] : void 0;
              P != null && mA(s, P);
            } else if (b === ti)
              if (typeof L == "string") {
                var N = a !== "textarea" || L !== "";
                N && Z8(s, L);
              } else typeof L == "number" && Z8(s, "" + L);
            else b === Rf || b === f6 || b === w_ || (M2.hasOwnProperty(b) ? L != null && (typeof L != "function" && Nf(b, L), b === "onScroll" && Et("scroll", s)) : L != null && g5(s, b, L, m));
          }
      }
      function CK(a, s, C, p) {
        for (var m = 0; m < s.length; m += 2) {
          var b = s[m], L = s[m + 1];
          b === ri ? TA(a, L) : b === Mu ? mA(a, L) : b === ti ? Z8(a, L) : g5(a, b, L, p);
        }
      }
      function dK(a, s, C, p) {
        var m, b = O_(C), L, P = p;
        if (P === R4 && (P = ws(a)), P === R4) {
          if (m = Mn(a, s), !m && a !== a.toLowerCase() && u("<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.", a), a === "script") {
            var N = b.createElement("div");
            N.innerHTML = "<script><\/script>";
            var G = N.firstChild;
            L = N.removeChild(G);
          } else if (typeof s.is == "string")
            L = b.createElement(a, {
              is: s.is
            });
          else if (L = b.createElement(a), a === "select") {
            var J = L;
            s.multiple ? J.multiple = !0 : s.size && (J.size = s.size);
          }
        } else
          L = b.createElementNS(P, a);
        return P === R4 && !m && Object.prototype.toString.call(L) === "[object HTMLUnknownElement]" && !d2.call(_v, a) && (_v[a] = !0, u("The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.", a)), L;
      }
      function gK(a, s) {
        return O_(s).createTextNode(a);
      }
      function pK(a, s, C, p) {
        var m = Mn(s, C);
        Ff(s, C);
        var b;
        switch (s) {
          case "dialog":
            Et("cancel", a), Et("close", a), b = C;
            break;
          case "iframe":
          case "object":
          case "embed":
            Et("load", a), b = C;
            break;
          case "video":
          case "audio":
            for (var L = 0; L < bu.length; L++)
              Et(bu[L], a);
            b = C;
            break;
          case "source":
            Et("error", a), b = C;
            break;
          case "img":
          case "image":
          case "link":
            Et("error", a), Et("load", a), b = C;
            break;
          case "details":
            Et("toggle", a), b = C;
            break;
          case "input":
            _r(a, C), b = V8(a, C), Et("invalid", a);
            break;
          case "option":
            le(a, C), b = C;
            break;
          case "select":
            Q3(a, C), b = l7(a, C), Et("invalid", a);
            break;
          case "textarea":
            Qs(a, C), b = Bs(a, C), Et("invalid", a);
            break;
          default:
            b = C;
        }
        switch (ca(s, b), fK(s, a, p, b, m), s) {
          case "input":
            Mr(a), Q2(a, C, !1);
            break;
          case "textarea":
            Mr(a), vA(a);
            break;
          case "option":
            at(a, C);
            break;
          case "select":
            ys(a, C);
            break;
          default:
            typeof b.onClick == "function" && Vf(a);
            break;
        }
      }
      function hK(a, s, C, p, m) {
        Ff(s, p);
        var b = null, L, P;
        switch (s) {
          case "input":
            L = V8(a, C), P = V8(a, p), b = [];
            break;
          case "select":
            L = l7(a, C), P = l7(a, p), b = [];
            break;
          case "textarea":
            L = Bs(a, C), P = Bs(a, p), b = [];
            break;
          default:
            L = C, P = p, typeof L.onClick != "function" && typeof P.onClick == "function" && Vf(a);
            break;
        }
        ca(s, P);
        var N, G, J = null;
        for (N in L)
          if (!(P.hasOwnProperty(N) || !L.hasOwnProperty(N) || L[N] == null))
            if (N === ri) {
              var h2 = L[N];
              for (G in h2)
                h2.hasOwnProperty(G) && (J || (J = {}), J[G] = "");
            } else N === Mu || N === ti || N === Rf || N === f6 || N === w_ || (M2.hasOwnProperty(N) ? b || (b = []) : (b = b || []).push(N, null));
        for (N in P) {
          var g2 = P[N], B2 = L != null ? L[N] : void 0;
          if (!(!P.hasOwnProperty(N) || g2 === B2 || g2 == null && B2 == null))
            if (N === ri)
              if (g2 && Object.freeze(g2), B2) {
                for (G in B2)
                  B2.hasOwnProperty(G) && (!g2 || !g2.hasOwnProperty(G)) && (J || (J = {}), J[G] = "");
                for (G in g2)
                  g2.hasOwnProperty(G) && B2[G] !== g2[G] && (J || (J = {}), J[G] = g2[G]);
              } else
                J || (b || (b = []), b.push(N, J)), J = g2;
            else if (N === Mu) {
              var b2 = g2 ? g2[Pf] : void 0, T2 = B2 ? B2[Pf] : void 0;
              b2 != null && T2 !== b2 && (b = b || []).push(N, b2);
            } else N === ti ? (typeof g2 == "string" || typeof g2 == "number") && (b = b || []).push(N, "" + g2) : N === Rf || N === f6 || (M2.hasOwnProperty(N) ? (g2 != null && (typeof g2 != "function" && Nf(N, g2), N === "onScroll" && Et("scroll", a)), !b && B2 !== g2 && (b = [])) : (b = b || []).push(N, g2));
        }
        return J && (nv(J, P[ri]), (b = b || []).push(ri, J)), b;
      }
      function vK(a, s, C, p, m) {
        C === "input" && m.type === "radio" && m.name != null && j(a, m);
        var b = Mn(C, p), L = Mn(C, m);
        switch (CK(a, s, b, L), C) {
          case "input":
            u2(a, m);
            break;
          case "textarea":
            hA(a, m);
            break;
          case "select":
            sa(a, m);
            break;
        }
      }
      function EK(a) {
        {
          var s = a.toLowerCase();
          return d7.hasOwnProperty(s) && d7[s] || null;
        }
      }
      function mK(a, s, C, p, m, b, L) {
        var P, N;
        switch (P = Mn(s, C), Ff(s, C), s) {
          case "dialog":
            Et("cancel", a), Et("close", a);
            break;
          case "iframe":
          case "object":
          case "embed":
            Et("load", a);
            break;
          case "video":
          case "audio":
            for (var G = 0; G < bu.length; G++)
              Et(bu[G], a);
            break;
          case "source":
            Et("error", a);
            break;
          case "img":
          case "image":
          case "link":
            Et("error", a), Et("load", a);
            break;
          case "details":
            Et("toggle", a);
            break;
          case "input":
            _r(a, C), Et("invalid", a);
            break;
          case "option":
            le(a, C);
            break;
          case "select":
            Q3(a, C), Et("invalid", a);
            break;
          case "textarea":
            Qs(a, C), Et("invalid", a);
            break;
        }
        ca(s, C);
        {
          N = /* @__PURE__ */ new Set();
          for (var J = a.attributes, h2 = 0; h2 < J.length; h2++) {
            var g2 = J[h2].name.toLowerCase();
            switch (g2) {
              // Controlled attributes are not validated
              // TODO: Only ignore them on controlled tags.
              case "value":
                break;
              case "checked":
                break;
              case "selected":
                break;
              default:
                N.add(J[h2].name);
            }
          }
        }
        var B2 = null;
        for (var b2 in C)
          if (C.hasOwnProperty(b2)) {
            var T2 = C[b2];
            if (b2 === ti)
              typeof T2 == "string" ? a.textContent !== T2 && (C[f6] !== !0 && jf(a.textContent, T2, b, L), B2 = [ti, T2]) : typeof T2 == "number" && a.textContent !== "" + T2 && (C[f6] !== !0 && jf(a.textContent, T2, b, L), B2 = [ti, "" + T2]);
            else if (M2.hasOwnProperty(b2))
              T2 != null && (typeof T2 != "function" && Nf(b2, T2), b2 === "onScroll" && Et("scroll", a));
            else if (L && // Convince Flow we've calculated it (it's DEV-only in this method.)
            typeof P == "boolean") {
              var t0 = void 0, x0 = Le(b2);
              if (C[f6] !== !0) {
                if (!(b2 === Rf || b2 === f6 || // Controlled attributes are not validated
                // TODO: Only ignore them on controlled tags.
                b2 === "value" || b2 === "checked" || b2 === "selected")) {
                  if (b2 === Mu) {
                    var m0 = a.innerHTML, se = T2 ? T2[Pf] : void 0;
                    if (se != null) {
                      var J0 = __(a, se);
                      J0 !== m0 && _u(b2, m0, J0);
                    }
                  } else if (b2 === ri) {
                    if (N.delete(b2), M_) {
                      var m2 = tv(T2);
                      t0 = a.getAttribute("style"), m2 !== t0 && _u(b2, t0, m2);
                    }
                  } else if (P)
                    N.delete(b2.toLowerCase()), t0 = Kr(a, b2, T2), T2 !== t0 && _u(b2, t0, T2);
                  else if (!nt(b2, x0, P) && !kt(b2, T2, x0, P)) {
                    var D2 = !1;
                    if (x0 !== null)
                      N.delete(x0.attributeName), t0 = Gr(a, b2, T2, x0);
                    else {
                      var y2 = p;
                      if (y2 === R4 && (y2 = ws(s)), y2 === R4)
                        N.delete(b2.toLowerCase());
                      else {
                        var U2 = EK(b2);
                        U2 !== null && U2 !== b2 && (D2 = !0, N.delete(U2)), N.delete(b2);
                      }
                      t0 = Kr(a, b2, T2);
                    }
                    var o0 = H;
                    !o0 && T2 !== t0 && !D2 && _u(b2, t0, T2);
                  }
                }
              }
            }
          }
        switch (L && // $FlowFixMe - Should be inferred as not undefined.
        N.size > 0 && C[f6] !== !0 && S_(N), s) {
          case "input":
            Mr(a), Q2(a, C, !0);
            break;
          case "textarea":
            Mr(a), vA(a);
            break;
          case "select":
          case "option":
            break;
          default:
            typeof C.onClick == "function" && Vf(a);
            break;
        }
        return B2;
      }
      function yK(a, s, C) {
        var p = a.nodeValue !== s;
        return p;
      }
      function Ov(a, s) {
        {
          if (fr)
            return;
          fr = !0, u("Did not expect server HTML to contain a <%s> in <%s>.", s.nodeName.toLowerCase(), a.nodeName.toLowerCase());
        }
      }
      function Tv(a, s) {
        {
          if (fr)
            return;
          fr = !0, u('Did not expect server HTML to contain the text node "%s" in <%s>.', s.nodeValue, a.nodeName.toLowerCase());
        }
      }
      function Dv(a, s, C) {
        {
          if (fr)
            return;
          fr = !0, u("Expected server HTML to contain a matching <%s> in <%s>.", s, a.nodeName.toLowerCase());
        }
      }
      function Lv(a, s) {
        {
          if (s === "" || fr)
            return;
          fr = !0, u('Expected server HTML to contain a matching text node for "%s" in <%s>.', s, a.nodeName.toLowerCase());
        }
      }
      function IK(a, s, C) {
        switch (s) {
          case "input":
            _2(a, C);
            return;
          case "textarea":
            Kh(a, C);
            return;
          case "select":
            Is(a, C);
            return;
        }
      }
      var Ou = function() {
      }, Tu = function() {
      };
      {
        var BK = ["address", "applet", "area", "article", "aside", "base", "basefont", "bgsound", "blockquote", "body", "br", "button", "caption", "center", "col", "colgroup", "dd", "details", "dir", "div", "dl", "dt", "embed", "fieldset", "figcaption", "figure", "footer", "form", "frame", "frameset", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "iframe", "img", "input", "isindex", "li", "link", "listing", "main", "marquee", "menu", "menuitem", "meta", "nav", "noembed", "noframes", "noscript", "object", "ol", "p", "param", "plaintext", "pre", "script", "section", "select", "source", "style", "summary", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "title", "tr", "track", "ul", "wbr", "xmp"], T_ = [
          "applet",
          "caption",
          "html",
          "table",
          "td",
          "th",
          "marquee",
          "object",
          "template",
          // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
          // TODO: Distinguish by namespace here -- for <title>, including it here
          // errs on the side of fewer warnings
          "foreignObject",
          "desc",
          "title"
        ], QK = T_.concat(["button"]), xK = ["dd", "dt", "li", "option", "optgroup", "p", "rp", "rt"], D_ = {
          current: null,
          formTag: null,
          aTagInScope: null,
          buttonTagInScope: null,
          nobrTagInScope: null,
          pTagInButtonScope: null,
          listItemTagAutoclosing: null,
          dlItemTagAutoclosing: null
        };
        Tu = function(a, s) {
          var C = z0({}, a || D_), p = {
            tag: s
          };
          return T_.indexOf(s) !== -1 && (C.aTagInScope = null, C.buttonTagInScope = null, C.nobrTagInScope = null), QK.indexOf(s) !== -1 && (C.pTagInButtonScope = null), BK.indexOf(s) !== -1 && s !== "address" && s !== "div" && s !== "p" && (C.listItemTagAutoclosing = null, C.dlItemTagAutoclosing = null), C.current = p, s === "form" && (C.formTag = p), s === "a" && (C.aTagInScope = p), s === "button" && (C.buttonTagInScope = p), s === "nobr" && (C.nobrTagInScope = p), s === "p" && (C.pTagInButtonScope = p), s === "li" && (C.listItemTagAutoclosing = p), (s === "dd" || s === "dt") && (C.dlItemTagAutoclosing = p), C;
        };
        var bK = function(a, s) {
          switch (s) {
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
            case "select":
              return a === "option" || a === "optgroup" || a === "#text";
            case "optgroup":
              return a === "option" || a === "#text";
            // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
            // but
            case "option":
              return a === "#text";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
            // No special behavior since these rules fall back to "in body" mode for
            // all except special table nodes which cause bad parsing behavior anyway.
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
            case "tr":
              return a === "th" || a === "td" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
            case "tbody":
            case "thead":
            case "tfoot":
              return a === "tr" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
            case "colgroup":
              return a === "col" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
            case "table":
              return a === "caption" || a === "colgroup" || a === "tbody" || a === "tfoot" || a === "thead" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
            case "head":
              return a === "base" || a === "basefont" || a === "bgsound" || a === "link" || a === "meta" || a === "title" || a === "noscript" || a === "noframes" || a === "style" || a === "script" || a === "template";
            // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
            case "html":
              return a === "head" || a === "body" || a === "frameset";
            case "frameset":
              return a === "frame";
            case "#document":
              return a === "html";
          }
          switch (a) {
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return s !== "h1" && s !== "h2" && s !== "h3" && s !== "h4" && s !== "h5" && s !== "h6";
            case "rp":
            case "rt":
              return xK.indexOf(s) === -1;
            case "body":
            case "caption":
            case "col":
            case "colgroup":
            case "frameset":
            case "frame":
            case "head":
            case "html":
            case "tbody":
            case "td":
            case "tfoot":
            case "th":
            case "thead":
            case "tr":
              return s == null;
          }
          return !0;
        }, wK = function(a, s) {
          switch (a) {
            case "address":
            case "article":
            case "aside":
            case "blockquote":
            case "center":
            case "details":
            case "dialog":
            case "dir":
            case "div":
            case "dl":
            case "fieldset":
            case "figcaption":
            case "figure":
            case "footer":
            case "header":
            case "hgroup":
            case "main":
            case "menu":
            case "nav":
            case "ol":
            case "p":
            case "section":
            case "summary":
            case "ul":
            case "pre":
            case "listing":
            case "table":
            case "hr":
            case "xmp":
            case "h1":
            case "h2":
            case "h3":
            case "h4":
            case "h5":
            case "h6":
              return s.pTagInButtonScope;
            case "form":
              return s.formTag || s.pTagInButtonScope;
            case "li":
              return s.listItemTagAutoclosing;
            case "dd":
            case "dt":
              return s.dlItemTagAutoclosing;
            case "button":
              return s.buttonTagInScope;
            case "a":
              return s.aTagInScope;
            case "nobr":
              return s.nobrTagInScope;
          }
          return null;
        }, L_ = {};
        Ou = function(a, s, C) {
          C = C || D_;
          var p = C.current, m = p && p.tag;
          s != null && (a != null && u("validateDOMNesting: when childText is passed, childTag should be null"), a = "#text");
          var b = bK(a, m) ? null : p, L = b ? null : wK(a, C), P = b || L;
          if (P) {
            var N = P.tag, G = !!b + "|" + a + "|" + N;
            if (!L_[G]) {
              L_[G] = !0;
              var J = a, h2 = "";
              if (a === "#text" ? /\S/.test(s) ? J = "Text nodes" : (J = "Whitespace text nodes", h2 = " Make sure you don't have any extra whitespace between tags on each line of your source code.") : J = "<" + a + ">", b) {
                var g2 = "";
                N === "table" && a === "tr" && (g2 += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), u("validateDOMNesting(...): %s cannot appear as a child of <%s>.%s%s", J, N, h2, g2);
              } else
                u("validateDOMNesting(...): %s cannot appear as a descendant of <%s>.", J, N);
            }
          }
        };
      }
      var Zf = "suppressHydrationWarning", zf = "$", Uf = "/$", Du = "$?", Lu = "$!", SK = "style", kv = null, Rv = null;
      function MK(a) {
        var s, C, p = a.nodeType;
        switch (p) {
          case F4:
          case Ms: {
            s = p === F4 ? "#document" : "#fragment";
            var m = a.documentElement;
            C = m ? m.namespaceURI : Ss(null, "");
            break;
          }
          default: {
            var b = p === Rt ? a.parentNode : a, L = b.namespaceURI || null;
            s = b.tagName, C = Ss(L, s);
            break;
          }
        }
        {
          var P = s.toLowerCase(), N = Tu(null, P);
          return {
            namespace: C,
            ancestorInfo: N
          };
        }
      }
      function _K(a, s, C) {
        {
          var p = a, m = Ss(p.namespace, s), b = Tu(p.ancestorInfo, s);
          return {
            namespace: m,
            ancestorInfo: b
          };
        }
      }
      function hQ2(a) {
        return a;
      }
      function OK(a) {
        kv = Vt(), Rv = UG();
        var s = null;
        return t5(!1), s;
      }
      function TK(a) {
        qG(Rv), t5(kv), kv = null, Rv = null;
      }
      function DK(a, s, C, p, m) {
        var b;
        {
          var L = p;
          if (Ou(a, null, L.ancestorInfo), typeof s.children == "string" || typeof s.children == "number") {
            var P = "" + s.children, N = Tu(L.ancestorInfo, a);
            Ou(null, P, N);
          }
          b = L.namespace;
        }
        var G = dK(a, s, C, b);
        return Pu(m, G), zv(G, s), G;
      }
      function LK(a, s) {
        a.appendChild(s);
      }
      function kK(a, s, C, p, m) {
        switch (pK(a, s, C, p), s) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            return !!C.autoFocus;
          case "img":
            return !0;
          default:
            return !1;
        }
      }
      function RK(a, s, C, p, m, b) {
        {
          var L = b;
          if (typeof p.children != typeof C.children && (typeof p.children == "string" || typeof p.children == "number")) {
            var P = "" + p.children, N = Tu(L.ancestorInfo, s);
            Ou(null, P, N);
          }
        }
        return hK(a, s, C, p);
      }
      function Pv(a, s) {
        return a === "textarea" || a === "noscript" || typeof s.children == "string" || typeof s.children == "number" || typeof s.dangerouslySetInnerHTML == "object" && s.dangerouslySetInnerHTML !== null && s.dangerouslySetInnerHTML.__html != null;
      }
      function PK(a, s, C, p) {
        {
          var m = C;
          Ou(null, a, m.ancestorInfo);
        }
        var b = gK(a, s);
        return Pu(p, b), b;
      }
      function FK() {
        var a = window.event;
        return a === void 0 ? ur : no(a.type);
      }
      var Fv = typeof setTimeout == "function" ? setTimeout : void 0, NK = typeof clearTimeout == "function" ? clearTimeout : void 0, Nv = -1, k_ = typeof Promise == "function" ? Promise : void 0, HK = typeof queueMicrotask == "function" ? queueMicrotask : typeof k_ < "u" ? function(a) {
        return k_.resolve(null).then(a).catch(jK);
      } : Fv;
      function jK(a) {
        setTimeout(function() {
          throw a;
        });
      }
      function VK(a, s, C, p) {
        switch (s) {
          case "button":
          case "input":
          case "select":
          case "textarea":
            C.autoFocus && a.focus();
            return;
          case "img": {
            C.src && (a.src = C.src);
            return;
          }
        }
      }
      function ZK(a, s, C, p, m, b) {
        vK(a, s, C, p, m), zv(a, m);
      }
      function R_(a) {
        Z8(a, "");
      }
      function zK(a, s, C) {
        a.nodeValue = C;
      }
      function UK(a, s) {
        a.appendChild(s);
      }
      function qK(a, s) {
        var C;
        a.nodeType === Rt ? (C = a.parentNode, C.insertBefore(s, a)) : (C = a, C.appendChild(s));
        var p = a._reactRootContainer;
        p == null && C.onclick === null && Vf(C);
      }
      function WK(a, s, C) {
        a.insertBefore(s, C);
      }
      function YK(a, s, C) {
        a.nodeType === Rt ? a.parentNode.insertBefore(s, C) : a.insertBefore(s, C);
      }
      function $K(a, s) {
        a.removeChild(s);
      }
      function GK(a, s) {
        a.nodeType === Rt ? a.parentNode.removeChild(s) : a.removeChild(s);
      }
      function Hv(a, s) {
        var C = s, p = 0;
        do {
          var m = C.nextSibling;
          if (a.removeChild(C), m && m.nodeType === Rt) {
            var b = m.data;
            if (b === Uf)
              if (p === 0) {
                a.removeChild(m), U3(s);
                return;
              } else
                p--;
            else (b === zf || b === Du || b === Lu) && p++;
          }
          C = m;
        } while (C);
        U3(s);
      }
      function KK(a, s) {
        a.nodeType === Rt ? Hv(a.parentNode, s) : a.nodeType === C1 && Hv(a, s), U3(a);
      }
      function XK(a) {
        a = a;
        var s = a.style;
        typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
      }
      function JK(a) {
        a.nodeValue = "";
      }
      function eX(a, s) {
        a = a;
        var C = s[SK], p = C != null && C.hasOwnProperty("display") ? C.display : null;
        a.style.display = la("display", p);
      }
      function tX(a, s) {
        a.nodeValue = s;
      }
      function rX(a) {
        a.nodeType === C1 ? a.textContent = "" : a.nodeType === F4 && a.documentElement && a.removeChild(a.documentElement);
      }
      function nX(a, s, C) {
        return a.nodeType !== C1 || s.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
      }
      function iX(a, s) {
        return s === "" || a.nodeType !== P4 ? null : a;
      }
      function aX(a) {
        return a.nodeType !== Rt ? null : a;
      }
      function P_(a) {
        return a.data === Du;
      }
      function jv(a) {
        return a.data === Lu;
      }
      function oX(a) {
        var s = a.nextSibling && a.nextSibling.dataset, C, p, m;
        return s && (C = s.dgst, p = s.msg, m = s.stck), {
          message: p,
          digest: C,
          stack: m
        };
      }
      function sX(a, s) {
        a._reactRetry = s;
      }
      function qf(a) {
        for (; a != null; a = a.nextSibling) {
          var s = a.nodeType;
          if (s === C1 || s === P4)
            break;
          if (s === Rt) {
            var C = a.data;
            if (C === zf || C === Lu || C === Du)
              break;
            if (C === Uf)
              return null;
          }
        }
        return a;
      }
      function ku(a) {
        return qf(a.nextSibling);
      }
      function uX(a) {
        return qf(a.firstChild);
      }
      function lX(a) {
        return qf(a.firstChild);
      }
      function cX(a) {
        return qf(a.nextSibling);
      }
      function AX(a, s, C, p, m, b, L) {
        Pu(b, a), zv(a, C);
        var P;
        {
          var N = m;
          P = N.namespace;
        }
        var G = (b.mode & Y0) !== B0;
        return mK(a, s, C, P, p, G, L);
      }
      function fX(a, s, C, p) {
        return Pu(C, a), C.mode & Y0, yK(a, s);
      }
      function CX(a, s) {
        Pu(s, a);
      }
      function dX(a) {
        for (var s = a.nextSibling, C = 0; s; ) {
          if (s.nodeType === Rt) {
            var p = s.data;
            if (p === Uf) {
              if (C === 0)
                return ku(s);
              C--;
            } else (p === zf || p === Lu || p === Du) && C++;
          }
          s = s.nextSibling;
        }
        return null;
      }
      function F_(a) {
        for (var s = a.previousSibling, C = 0; s; ) {
          if (s.nodeType === Rt) {
            var p = s.data;
            if (p === zf || p === Lu || p === Du) {
              if (C === 0)
                return s;
              C--;
            } else p === Uf && C++;
          }
          s = s.previousSibling;
        }
        return null;
      }
      function gX(a) {
        U3(a);
      }
      function pX(a) {
        U3(a);
      }
      function hX(a) {
        return a !== "head" && a !== "body";
      }
      function vX(a, s, C, p) {
        var m = !0;
        jf(s.nodeValue, C, p, m);
      }
      function EX(a, s, C, p, m, b) {
        if (s[Zf] !== !0) {
          var L = !0;
          jf(p.nodeValue, m, b, L);
        }
      }
      function mX(a, s) {
        s.nodeType === C1 ? Ov(a, s) : s.nodeType === Rt || Tv(a, s);
      }
      function yX(a, s) {
        {
          var C = a.parentNode;
          C !== null && (s.nodeType === C1 ? Ov(C, s) : s.nodeType === Rt || Tv(C, s));
        }
      }
      function IX(a, s, C, p, m) {
        (m || s[Zf] !== !0) && (p.nodeType === C1 ? Ov(C, p) : p.nodeType === Rt || Tv(C, p));
      }
      function BX(a, s, C) {
        Dv(a, s);
      }
      function QX(a, s) {
        Lv(a, s);
      }
      function xX(a, s, C) {
        {
          var p = a.parentNode;
          p !== null && Dv(p, s);
        }
      }
      function bX(a, s) {
        {
          var C = a.parentNode;
          C !== null && Lv(C, s);
        }
      }
      function wX(a, s, C, p, m, b) {
        (b || s[Zf] !== !0) && Dv(C, p);
      }
      function SX(a, s, C, p, m) {
        (m || s[Zf] !== !0) && Lv(C, p);
      }
      function MX(a) {
        u("An error occurred during hydration. The server HTML was replaced with client content in <%s>.", a.nodeName.toLowerCase());
      }
      function _X(a) {
        wu(a);
      }
      var vo = Math.random().toString(36).slice(2), Eo = "__reactFiber$" + vo, Vv = "__reactProps$" + vo, Ru = "__reactContainer$" + vo, Zv = "__reactEvents$" + vo, OX = "__reactListeners$" + vo, TX = "__reactHandles$" + vo;
      function DX(a) {
        delete a[Eo], delete a[Vv], delete a[Zv], delete a[OX], delete a[TX];
      }
      function Pu(a, s) {
        s[Eo] = a;
      }
      function Wf(a, s) {
        s[Ru] = a;
      }
      function N_(a) {
        a[Ru] = null;
      }
      function Fu(a) {
        return !!a[Ru];
      }
      function ni(a) {
        var s = a[Eo];
        if (s)
          return s;
        for (var C = a.parentNode; C; ) {
          if (s = C[Ru] || C[Eo], s) {
            var p = s.alternate;
            if (s.child !== null || p !== null && p.child !== null)
              for (var m = F_(a); m !== null; ) {
                var b = m[Eo];
                if (b)
                  return b;
                m = F_(m);
              }
            return s;
          }
          a = C, C = a.parentNode;
        }
        return null;
      }
      function C6(a) {
        var s = a[Eo] || a[Ru];
        return s && (s.tag === y || s.tag === I || s.tag === w || s.tag === h) ? s : null;
      }
      function mo(a) {
        if (a.tag === y || a.tag === I)
          return a.stateNode;
        throw new Error("getNodeFromInstance: Invalid argument.");
      }
      function Yf(a) {
        return a[Vv] || null;
      }
      function zv(a, s) {
        a[Vv] = s;
      }
      function LX(a) {
        var s = a[Zv];
        return s === void 0 && (s = a[Zv] = /* @__PURE__ */ new Set()), s;
      }
      var H_ = {}, j_ = r.ReactDebugCurrentFrame;
      function $f(a) {
        if (a) {
          var s = a._owner, C = D4(a.type, a._source, s ? s.type : null);
          j_.setExtraStackFrame(C);
        } else
          j_.setExtraStackFrame(null);
      }
      function $4(a, s, C, p, m) {
        {
          var b = Function.call.bind(d2);
          for (var L in a)
            if (b(a, L)) {
              var P = void 0;
              try {
                if (typeof a[L] != "function") {
                  var N = Error((p || "React class") + ": " + C + " type `" + L + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[L] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw N.name = "Invariant Violation", N;
                }
                P = a[L](s, L, p, C, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (G) {
                P = G;
              }
              P && !(P instanceof Error) && ($f(m), u("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", p || "React class", C, L, typeof P), $f(null)), P instanceof Error && !(P.message in H_) && (H_[P.message] = !0, $f(m), u("Failed %s type: %s", C, P.message), $f(null));
            }
        }
      }
      var Uv = [], Gf;
      Gf = [];
      var K3 = -1;
      function d6(a) {
        return {
          current: a
        };
      }
      function Q1(a, s) {
        if (K3 < 0) {
          u("Unexpected pop.");
          return;
        }
        s !== Gf[K3] && u("Unexpected Fiber popped."), a.current = Uv[K3], Uv[K3] = null, Gf[K3] = null, K3--;
      }
      function x1(a, s, C) {
        K3++, Uv[K3] = a.current, Gf[K3] = C, a.current = s;
      }
      var qv;
      qv = {};
      var Fr = {};
      Object.freeze(Fr);
      var X3 = d6(Fr), $n = d6(!1), Wv = Fr;
      function yo(a, s, C) {
        return C && Gn(s) ? Wv : X3.current;
      }
      function V_(a, s, C) {
        {
          var p = a.stateNode;
          p.__reactInternalMemoizedUnmaskedChildContext = s, p.__reactInternalMemoizedMaskedChildContext = C;
        }
      }
      function Io(a, s) {
        {
          var C = a.type, p = C.contextTypes;
          if (!p)
            return Fr;
          var m = a.stateNode;
          if (m && m.__reactInternalMemoizedUnmaskedChildContext === s)
            return m.__reactInternalMemoizedMaskedChildContext;
          var b = {};
          for (var L in p)
            b[L] = s[L];
          {
            var P = R0(a) || "Unknown";
            $4(p, b, "context", P);
          }
          return m && V_(a, s, b), b;
        }
      }
      function Kf() {
        return $n.current;
      }
      function Gn(a) {
        {
          var s = a.childContextTypes;
          return s != null;
        }
      }
      function Xf(a) {
        Q1($n, a), Q1(X3, a);
      }
      function Yv(a) {
        Q1($n, a), Q1(X3, a);
      }
      function Z_(a, s, C) {
        {
          if (X3.current !== Fr)
            throw new Error("Unexpected context found on stack. This error is likely caused by a bug in React. Please file an issue.");
          x1(X3, s, a), x1($n, C, a);
        }
      }
      function z_(a, s, C) {
        {
          var p = a.stateNode, m = s.childContextTypes;
          if (typeof p.getChildContext != "function") {
            {
              var b = R0(a) || "Unknown";
              qv[b] || (qv[b] = !0, u("%s.childContextTypes is specified but there is no getChildContext() method on the instance. You can either define getChildContext() on %s or remove childContextTypes from it.", b, b));
            }
            return C;
          }
          var L = p.getChildContext();
          for (var P in L)
            if (!(P in m))
              throw new Error((R0(a) || "Unknown") + '.getChildContext(): key "' + P + '" is not defined in childContextTypes.');
          {
            var N = R0(a) || "Unknown";
            $4(m, L, "child context", N);
          }
          return z0({}, C, L);
        }
      }
      function Jf(a) {
        {
          var s = a.stateNode, C = s && s.__reactInternalMemoizedMergedChildContext || Fr;
          return Wv = X3.current, x1(X3, C, a), x1($n, $n.current, a), !0;
        }
      }
      function U_(a, s, C) {
        {
          var p = a.stateNode;
          if (!p)
            throw new Error("Expected to have an instance by this point. This error is likely caused by a bug in React. Please file an issue.");
          if (C) {
            var m = z_(a, s, Wv);
            p.__reactInternalMemoizedMergedChildContext = m, Q1($n, a), Q1(X3, a), x1(X3, m, a), x1($n, C, a);
          } else
            Q1($n, a), x1($n, C, a);
        }
      }
      function kX(a) {
        {
          if (!O3(a) || a.tag !== d)
            throw new Error("Expected subtree parent to be a mounted class component. This error is likely caused by a bug in React. Please file an issue.");
          var s = a;
          do {
            switch (s.tag) {
              case h:
                return s.stateNode.context;
              case d: {
                var C = s.type;
                if (Gn(C))
                  return s.stateNode.__reactInternalMemoizedMergedChildContext;
                break;
              }
            }
            s = s.return;
          } while (s !== null);
          throw new Error("Found unexpected detached subtree parent. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      var g6 = 0, eC = 1, J3 = null, $v = !1, Gv = !1;
      function q_(a) {
        J3 === null ? J3 = [a] : J3.push(a);
      }
      function RX(a) {
        $v = !0, q_(a);
      }
      function W_() {
        $v && p6();
      }
      function p6() {
        if (!Gv && J3 !== null) {
          Gv = !0;
          var a = 0, s = cr();
          try {
            var C = !0, p = J3;
            for (jt(W5); a < p.length; a++) {
              var m = p[a];
              do
                m = m(C);
              while (m !== null);
            }
            J3 = null, $v = !1;
          } catch (b) {
            throw J3 !== null && (J3 = J3.slice(a + 1)), js(I7, p6), b;
          } finally {
            jt(s), Gv = !1;
          }
        }
        return null;
      }
      var Bo = [], Qo = 0, tC = null, rC = 0, p4 = [], h4 = 0, ii = null, e8 = 1, t8 = "";
      function PX(a) {
        return oi(), (a.flags & o4) !== I0;
      }
      function FX(a) {
        return oi(), rC;
      }
      function NX() {
        var a = t8, s = e8, C = s & ~HX(s);
        return C.toString(32) + a;
      }
      function ai(a, s) {
        oi(), Bo[Qo++] = rC, Bo[Qo++] = tC, tC = a, rC = s;
      }
      function Y_(a, s, C) {
        oi(), p4[h4++] = e8, p4[h4++] = t8, p4[h4++] = ii, ii = a;
        var p = e8, m = t8, b = nC(p) - 1, L = p & ~(1 << b), P = C + 1, N = nC(s) + b;
        if (N > 30) {
          var G = b - b % 5, J = (1 << G) - 1, h2 = (L & J).toString(32), g2 = L >> G, B2 = b - G, b2 = nC(s) + B2, T2 = P << B2, t0 = T2 | g2, x0 = h2 + m;
          e8 = 1 << b2 | t0, t8 = x0;
        } else {
          var m0 = P << b, se = m0 | L, J0 = m;
          e8 = 1 << N | se, t8 = J0;
        }
      }
      function Kv(a) {
        oi();
        var s = a.return;
        if (s !== null) {
          var C = 1, p = 0;
          ai(a, C), Y_(a, C, p);
        }
      }
      function nC(a) {
        return 32 - Nt(a);
      }
      function HX(a) {
        return 1 << nC(a) - 1;
      }
      function Xv(a) {
        for (; a === tC; )
          tC = Bo[--Qo], Bo[Qo] = null, rC = Bo[--Qo], Bo[Qo] = null;
        for (; a === ii; )
          ii = p4[--h4], p4[h4] = null, t8 = p4[--h4], p4[h4] = null, e8 = p4[--h4], p4[h4] = null;
      }
      function jX() {
        return oi(), ii !== null ? {
          id: e8,
          overflow: t8
        } : null;
      }
      function VX(a, s) {
        oi(), p4[h4++] = e8, p4[h4++] = t8, p4[h4++] = ii, e8 = s.id, t8 = s.overflow, ii = a;
      }
      function oi() {
        X5() || u("Expected to be hydrating. This is a bug in React. Please file an issue.");
      }
      var K5 = null, v4 = null, G4 = !1, si = !1, h6 = null;
      function ZX() {
        G4 && u("We should not be hydrating here. This is a bug in React. Please file a bug.");
      }
      function $_() {
        si = !0;
      }
      function zX() {
        return si;
      }
      function UX(a) {
        var s = a.stateNode.containerInfo;
        return v4 = lX(s), K5 = a, G4 = !0, h6 = null, si = !1, !0;
      }
      function qX(a, s, C) {
        return v4 = cX(s), K5 = a, G4 = !0, h6 = null, si = !1, C !== null && VX(a, C), !0;
      }
      function G_(a, s) {
        switch (a.tag) {
          case h: {
            mX(a.stateNode.containerInfo, s);
            break;
          }
          case y: {
            var C = (a.mode & Y0) !== B0;
            IX(
              a.type,
              a.memoizedProps,
              a.stateNode,
              s,
              // TODO: Delete this argument when we remove the legacy root API.
              C
            );
            break;
          }
          case w: {
            var p = a.memoizedState;
            p.dehydrated !== null && yX(p.dehydrated, s);
            break;
          }
        }
      }
      function K_(a, s) {
        G_(a, s);
        var C = G02();
        C.stateNode = s, C.return = a;
        var p = a.deletions;
        p === null ? (a.deletions = [C], a.flags |= nr) : p.push(C);
      }
      function Jv(a, s) {
        {
          if (si)
            return;
          switch (a.tag) {
            case h: {
              var C = a.stateNode.containerInfo;
              switch (s.tag) {
                case y:
                  var p = s.type;
                  s.pendingProps, BX(C, p);
                  break;
                case I:
                  var m = s.pendingProps;
                  QX(C, m);
                  break;
              }
              break;
            }
            case y: {
              var b = a.type, L = a.memoizedProps, P = a.stateNode;
              switch (s.tag) {
                case y: {
                  var N = s.type, G = s.pendingProps, J = (a.mode & Y0) !== B0;
                  wX(
                    b,
                    L,
                    P,
                    N,
                    G,
                    // TODO: Delete this argument when we remove the legacy root API.
                    J
                  );
                  break;
                }
                case I: {
                  var h2 = s.pendingProps, g2 = (a.mode & Y0) !== B0;
                  SX(
                    b,
                    L,
                    P,
                    h2,
                    // TODO: Delete this argument when we remove the legacy root API.
                    g2
                  );
                  break;
                }
              }
              break;
            }
            case w: {
              var B2 = a.memoizedState, b2 = B2.dehydrated;
              if (b2 !== null) switch (s.tag) {
                case y:
                  var T2 = s.type;
                  s.pendingProps, xX(b2, T2);
                  break;
                case I:
                  var t0 = s.pendingProps;
                  bX(b2, t0);
                  break;
              }
              break;
            }
            default:
              return;
          }
        }
      }
      function X_(a, s) {
        s.flags = s.flags & -4097 | xt, Jv(a, s);
      }
      function J_(a, s) {
        switch (a.tag) {
          case y: {
            var C = a.type;
            a.pendingProps;
            var p = nX(s, C);
            return p !== null ? (a.stateNode = p, K5 = a, v4 = uX(p), !0) : !1;
          }
          case I: {
            var m = a.pendingProps, b = iX(s, m);
            return b !== null ? (a.stateNode = b, K5 = a, v4 = null, !0) : !1;
          }
          case w: {
            var L = aX(s);
            if (L !== null) {
              var P = {
                dehydrated: L,
                treeContext: jX(),
                retryLane: H1
              };
              a.memoizedState = P;
              var N = K02(L);
              return N.return = a, a.child = N, K5 = a, v4 = null, !0;
            }
            return !1;
          }
          default:
            return !1;
        }
      }
      function eE(a) {
        return (a.mode & Y0) !== B0 && (a.flags & y0) === I0;
      }
      function tE(a) {
        throw new Error("Hydration failed because the initial UI does not match what was rendered on the server.");
      }
      function rE(a) {
        if (G4) {
          var s = v4;
          if (!s) {
            eE(a) && (Jv(K5, a), tE()), X_(K5, a), G4 = !1, K5 = a;
            return;
          }
          var C = s;
          if (!J_(a, s)) {
            eE(a) && (Jv(K5, a), tE()), s = ku(C);
            var p = K5;
            if (!s || !J_(a, s)) {
              X_(K5, a), G4 = !1, K5 = a;
              return;
            }
            K_(p, C);
          }
        }
      }
      function WX(a, s, C) {
        var p = a.stateNode, m = !si, b = AX(p, a.type, a.memoizedProps, s, C, a, m);
        return a.updateQueue = b, b !== null;
      }
      function YX(a) {
        var s = a.stateNode, C = a.memoizedProps, p = fX(s, C, a);
        if (p) {
          var m = K5;
          if (m !== null)
            switch (m.tag) {
              case h: {
                var b = m.stateNode.containerInfo, L = (m.mode & Y0) !== B0;
                vX(
                  b,
                  s,
                  C,
                  // TODO: Delete this argument when we remove the legacy root API.
                  L
                );
                break;
              }
              case y: {
                var P = m.type, N = m.memoizedProps, G = m.stateNode, J = (m.mode & Y0) !== B0;
                EX(
                  P,
                  N,
                  G,
                  s,
                  C,
                  // TODO: Delete this argument when we remove the legacy root API.
                  J
                );
                break;
              }
            }
        }
        return p;
      }
      function $X(a) {
        var s = a.memoizedState, C = s !== null ? s.dehydrated : null;
        if (!C)
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        CX(C, a);
      }
      function GX(a) {
        var s = a.memoizedState, C = s !== null ? s.dehydrated : null;
        if (!C)
          throw new Error("Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue.");
        return dX(C);
      }
      function eO(a) {
        for (var s = a.return; s !== null && s.tag !== y && s.tag !== h && s.tag !== w; )
          s = s.return;
        K5 = s;
      }
      function iC(a) {
        if (a !== K5)
          return !1;
        if (!G4)
          return eO(a), G4 = !0, !1;
        if (a.tag !== h && (a.tag !== y || hX(a.type) && !Pv(a.type, a.memoizedProps))) {
          var s = v4;
          if (s)
            if (eE(a))
              tO(a), tE();
            else
              for (; s; )
                K_(a, s), s = ku(s);
        }
        return eO(a), a.tag === w ? v4 = GX(a) : v4 = K5 ? ku(a.stateNode) : null, !0;
      }
      function KX() {
        return G4 && v4 !== null;
      }
      function tO(a) {
        for (var s = v4; s; )
          G_(a, s), s = ku(s);
      }
      function xo() {
        K5 = null, v4 = null, G4 = !1, si = !1;
      }
      function rO() {
        h6 !== null && ($T(h6), h6 = null);
      }
      function X5() {
        return G4;
      }
      function nE(a) {
        h6 === null ? h6 = [a] : h6.push(a);
      }
      var XX = r.ReactCurrentBatchConfig, JX = null;
      function eJ() {
        return XX.transition;
      }
      var K4 = {
        recordUnsafeLifecycleWarnings: function(a, s) {
        },
        flushPendingUnsafeLifecycleWarnings: function() {
        },
        recordLegacyContextWarning: function(a, s) {
        },
        flushLegacyContextWarning: function() {
        },
        discardPendingWarnings: function() {
        }
      };
      {
        var tJ = function(a) {
          for (var s = null, C = a; C !== null; )
            C.mode & He && (s = C), C = C.return;
          return s;
        }, ui = function(a) {
          var s = [];
          return a.forEach(function(C) {
            s.push(C);
          }), s.sort().join(", ");
        }, Nu = [], Hu = [], ju = [], Vu = [], Zu = [], zu = [], li = /* @__PURE__ */ new Set();
        K4.recordUnsafeLifecycleWarnings = function(a, s) {
          li.has(a.type) || (typeof s.componentWillMount == "function" && // Don't warn about react-lifecycles-compat polyfilled components.
          s.componentWillMount.__suppressDeprecationWarning !== !0 && Nu.push(a), a.mode & He && typeof s.UNSAFE_componentWillMount == "function" && Hu.push(a), typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps.__suppressDeprecationWarning !== !0 && ju.push(a), a.mode & He && typeof s.UNSAFE_componentWillReceiveProps == "function" && Vu.push(a), typeof s.componentWillUpdate == "function" && s.componentWillUpdate.__suppressDeprecationWarning !== !0 && Zu.push(a), a.mode & He && typeof s.UNSAFE_componentWillUpdate == "function" && zu.push(a));
        }, K4.flushPendingUnsafeLifecycleWarnings = function() {
          var a = /* @__PURE__ */ new Set();
          Nu.length > 0 && (Nu.forEach(function(g2) {
            a.add(R0(g2) || "Component"), li.add(g2.type);
          }), Nu = []);
          var s = /* @__PURE__ */ new Set();
          Hu.length > 0 && (Hu.forEach(function(g2) {
            s.add(R0(g2) || "Component"), li.add(g2.type);
          }), Hu = []);
          var C = /* @__PURE__ */ new Set();
          ju.length > 0 && (ju.forEach(function(g2) {
            C.add(R0(g2) || "Component"), li.add(g2.type);
          }), ju = []);
          var p = /* @__PURE__ */ new Set();
          Vu.length > 0 && (Vu.forEach(function(g2) {
            p.add(R0(g2) || "Component"), li.add(g2.type);
          }), Vu = []);
          var m = /* @__PURE__ */ new Set();
          Zu.length > 0 && (Zu.forEach(function(g2) {
            m.add(R0(g2) || "Component"), li.add(g2.type);
          }), Zu = []);
          var b = /* @__PURE__ */ new Set();
          if (zu.length > 0 && (zu.forEach(function(g2) {
            b.add(R0(g2) || "Component"), li.add(g2.type);
          }), zu = []), s.size > 0) {
            var L = ui(s);
            u(`Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.

Please update the following components: %s`, L);
          }
          if (p.size > 0) {
            var P = ui(p);
            u(`Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state

Please update the following components: %s`, P);
          }
          if (b.size > 0) {
            var N = ui(b);
            u(`Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.

Please update the following components: %s`, N);
          }
          if (a.size > 0) {
            var G = ui(a);
            o(`componentWillMount has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move code with side effects to componentDidMount, and set initial state in the constructor.
* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, G);
          }
          if (C.size > 0) {
            var J = ui(C);
            o(`componentWillReceiveProps has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://reactjs.org/link/derived-state
* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, J);
          }
          if (m.size > 0) {
            var h2 = ui(m);
            o(`componentWillUpdate has been renamed, and is not recommended for use. See https://reactjs.org/link/unsafe-component-lifecycles for details.

* Move data fetching code or side effects to componentDidUpdate.
* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run \`npx react-codemod rename-unsafe-lifecycles\` in your project source folder.

Please update the following components: %s`, h2);
          }
        };
        var aC = /* @__PURE__ */ new Map(), nO = /* @__PURE__ */ new Set();
        K4.recordLegacyContextWarning = function(a, s) {
          var C = tJ(a);
          if (C === null) {
            u("Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue.");
            return;
          }
          if (!nO.has(a.type)) {
            var p = aC.get(C);
            (a.type.contextTypes != null || a.type.childContextTypes != null || s !== null && typeof s.getChildContext == "function") && (p === void 0 && (p = [], aC.set(C, p)), p.push(a));
          }
        }, K4.flushLegacyContextWarning = function() {
          aC.forEach(function(a, s) {
            if (a.length !== 0) {
              var C = a[0], p = /* @__PURE__ */ new Set();
              a.forEach(function(b) {
                p.add(R0(b) || "Component"), nO.add(b.type);
              });
              var m = ui(p);
              try {
                Pe(C), u(`Legacy context API has been detected within a strict-mode tree.

The old API will be supported in all 16.x releases, but applications using it should migrate to the new version.

Please update the following components: %s

Learn more about this warning here: https://reactjs.org/link/legacy-context`, m);
              } finally {
                lt();
              }
            }
          });
        }, K4.discardPendingWarnings = function() {
          Nu = [], Hu = [], ju = [], Vu = [], Zu = [], zu = [], aC = /* @__PURE__ */ new Map();
        };
      }
      var iE, aE, oE, sE, uE, iO = function(a, s) {
      };
      iE = !1, aE = !1, oE = {}, sE = {}, uE = {}, iO = function(a, s) {
        if (!(a === null || typeof a != "object") && !(!a._store || a._store.validated || a.key != null)) {
          if (typeof a._store != "object")
            throw new Error("React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue.");
          a._store.validated = !0;
          var C = R0(s) || "Component";
          sE[C] || (sE[C] = !0, u('Each child in a list should have a unique "key" prop. See https://reactjs.org/link/warning-keys for more information.'));
        }
      };
      function rJ(a) {
        return a.prototype && a.prototype.isReactComponent;
      }
      function Uu(a, s, C) {
        var p = C.ref;
        if (p !== null && typeof p != "function" && typeof p != "object") {
          if ((a.mode & He || Y) && // We warn in ReactElement.js if owner and self are equal for string refs
          // because these cannot be automatically converted to an arrow function
          // using a codemod. Therefore, we don't have to warn about string refs again.
          !(C._owner && C._self && C._owner.stateNode !== C._self) && // Will already throw with "Function components cannot have string refs"
          !(C._owner && C._owner.tag !== d) && // Will already warn with "Function components cannot be given refs"
          !(typeof C.type == "function" && !rJ(C.type)) && // Will already throw with "Element ref was specified as a string (someStringRef) but no owner was set"
          C._owner) {
            var m = R0(a) || "Component";
            oE[m] || (u('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. We recommend using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', m, p), oE[m] = !0);
          }
          if (C._owner) {
            var b = C._owner, L;
            if (b) {
              var P = b;
              if (P.tag !== d)
                throw new Error("Function components cannot have string refs. We recommend using useRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref");
              L = P.stateNode;
            }
            if (!L)
              throw new Error("Missing owner for string ref " + p + ". This error is likely caused by a bug in React. Please file an issue.");
            var N = L;
            $e(p, "ref");
            var G = "" + p;
            if (s !== null && s.ref !== null && typeof s.ref == "function" && s.ref._stringRef === G)
              return s.ref;
            var J = function(h2) {
              var g2 = N.refs;
              h2 === null ? delete g2[G] : g2[G] = h2;
            };
            return J._stringRef = G, J;
          } else {
            if (typeof p != "string")
              throw new Error("Expected ref to be a function, a string, an object returned by React.createRef(), or null.");
            if (!C._owner)
              throw new Error("Element ref was specified as a string (" + p + `) but no owner was set. This could happen for one of the following reasons:
1. You may be adding a ref to a function component
2. You may be adding a ref to a component that was not created inside a component's render method
3. You have multiple copies of React loaded
See https://reactjs.org/link/refs-must-have-owner for more information.`);
          }
        }
        return p;
      }
      function oC(a, s) {
        var C = Object.prototype.toString.call(s);
        throw new Error("Objects are not valid as a React child (found: " + (C === "[object Object]" ? "object with keys {" + Object.keys(s).join(", ") + "}" : C) + "). If you meant to render a collection of children, use an array instead.");
      }
      function sC(a) {
        {
          var s = R0(a) || "Component";
          if (uE[s])
            return;
          uE[s] = !0, u("Functions are not valid as a React child. This may happen if you return a Component instead of <Component /> from render. Or maybe you meant to call this function rather than return it.");
        }
      }
      function aO(a) {
        var s = a._payload, C = a._init;
        return C(s);
      }
      function oO(a) {
        function s(m2, D2) {
          if (a) {
            var y2 = m2.deletions;
            y2 === null ? (m2.deletions = [D2], m2.flags |= nr) : y2.push(D2);
          }
        }
        function C(m2, D2) {
          if (!a)
            return null;
          for (var y2 = D2; y2 !== null; )
            s(m2, y2), y2 = y2.sibling;
          return null;
        }
        function p(m2, D2) {
          for (var y2 = /* @__PURE__ */ new Map(), U2 = D2; U2 !== null; )
            U2.key !== null ? y2.set(U2.key, U2) : y2.set(U2.index, U2), U2 = U2.sibling;
          return y2;
        }
        function m(m2, D2) {
          var y2 = vi(m2, D2);
          return y2.index = 0, y2.sibling = null, y2;
        }
        function b(m2, D2, y2) {
          if (m2.index = y2, !a)
            return m2.flags |= o4, D2;
          var U2 = m2.alternate;
          if (U2 !== null) {
            var o0 = U2.index;
            return o0 < D2 ? (m2.flags |= xt, D2) : o0;
          } else
            return m2.flags |= xt, D2;
        }
        function L(m2) {
          return a && m2.alternate === null && (m2.flags |= xt), m2;
        }
        function P(m2, D2, y2, U2) {
          if (D2 === null || D2.tag !== I) {
            var o0 = ny(y2, m2.mode, U2);
            return o0.return = m2, o0;
          } else {
            var r0 = m(D2, y2);
            return r0.return = m2, r0;
          }
        }
        function N(m2, D2, y2, U2) {
          var o0 = y2.type;
          if (o0 === Kt)
            return J(m2, D2, y2.props.children, U2, y2.key);
          if (D2 !== null && (D2.elementType === o0 || // Keep this check inline so it only runs on the false path:
          AD(D2, y2) || // Lazy types should reconcile their resolved type.
          // We need to do this after the Hot Reloading check above,
          // because hot reloading has different semantics than prod because
          // it doesn't resuspend. So we can't let the call below suspend.
          typeof o0 == "object" && o0 !== null && o0.$$typeof === P0 && aO(o0) === D2.type)) {
            var r0 = m(D2, y2.props);
            return r0.ref = Uu(m2, D2, y2), r0.return = m2, r0._debugSource = y2._source, r0._debugOwner = y2._owner, r0;
          }
          var T0 = ry(y2, m2.mode, U2);
          return T0.ref = Uu(m2, D2, y2), T0.return = m2, T0;
        }
        function G(m2, D2, y2, U2) {
          if (D2 === null || D2.tag !== E || D2.stateNode.containerInfo !== y2.containerInfo || D2.stateNode.implementation !== y2.implementation) {
            var o0 = iy(y2, m2.mode, U2);
            return o0.return = m2, o0;
          } else {
            var r0 = m(D2, y2.children || []);
            return r0.return = m2, r0;
          }
        }
        function J(m2, D2, y2, U2, o0) {
          if (D2 === null || D2.tag !== Q) {
            var r0 = S6(y2, m2.mode, U2, o0);
            return r0.return = m2, r0;
          } else {
            var T0 = m(D2, y2);
            return T0.return = m2, T0;
          }
        }
        function h2(m2, D2, y2) {
          if (typeof D2 == "string" && D2 !== "" || typeof D2 == "number") {
            var U2 = ny("" + D2, m2.mode, y2);
            return U2.return = m2, U2;
          }
          if (typeof D2 == "object" && D2 !== null) {
            switch (D2.$$typeof) {
              case o5: {
                var o0 = ry(D2, m2.mode, y2);
                return o0.ref = Uu(m2, null, D2), o0.return = m2, o0;
              }
              case xe: {
                var r0 = iy(D2, m2.mode, y2);
                return r0.return = m2, r0;
              }
              case P0: {
                var T0 = D2._payload, N0 = D2._init;
                return h2(m2, N0(T0), y2);
              }
            }
            if (q0(D2) || j0(D2)) {
              var Ve = S6(D2, m2.mode, y2, null);
              return Ve.return = m2, Ve;
            }
            oC(m2, D2);
          }
          return typeof D2 == "function" && sC(m2), null;
        }
        function g2(m2, D2, y2, U2) {
          var o0 = D2 !== null ? D2.key : null;
          if (typeof y2 == "string" && y2 !== "" || typeof y2 == "number")
            return o0 !== null ? null : P(m2, D2, "" + y2, U2);
          if (typeof y2 == "object" && y2 !== null) {
            switch (y2.$$typeof) {
              case o5:
                return y2.key === o0 ? N(m2, D2, y2, U2) : null;
              case xe:
                return y2.key === o0 ? G(m2, D2, y2, U2) : null;
              case P0: {
                var r0 = y2._payload, T0 = y2._init;
                return g2(m2, D2, T0(r0), U2);
              }
            }
            if (q0(y2) || j0(y2))
              return o0 !== null ? null : J(m2, D2, y2, U2, null);
            oC(m2, y2);
          }
          return typeof y2 == "function" && sC(m2), null;
        }
        function B2(m2, D2, y2, U2, o0) {
          if (typeof U2 == "string" && U2 !== "" || typeof U2 == "number") {
            var r0 = m2.get(y2) || null;
            return P(D2, r0, "" + U2, o0);
          }
          if (typeof U2 == "object" && U2 !== null) {
            switch (U2.$$typeof) {
              case o5: {
                var T0 = m2.get(U2.key === null ? y2 : U2.key) || null;
                return N(D2, T0, U2, o0);
              }
              case xe: {
                var N0 = m2.get(U2.key === null ? y2 : U2.key) || null;
                return G(D2, N0, U2, o0);
              }
              case P0:
                var Ve = U2._payload, Ie = U2._init;
                return B2(m2, D2, y2, Ie(Ve), o0);
            }
            if (q0(U2) || j0(U2)) {
              var r5 = m2.get(y2) || null;
              return J(D2, r5, U2, o0, null);
            }
            oC(D2, U2);
          }
          return typeof U2 == "function" && sC(D2), null;
        }
        function b2(m2, D2, y2) {
          {
            if (typeof m2 != "object" || m2 === null)
              return D2;
            switch (m2.$$typeof) {
              case o5:
              case xe:
                iO(m2, y2);
                var U2 = m2.key;
                if (typeof U2 != "string")
                  break;
                if (D2 === null) {
                  D2 = /* @__PURE__ */ new Set(), D2.add(U2);
                  break;
                }
                if (!D2.has(U2)) {
                  D2.add(U2);
                  break;
                }
                u("Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.", U2);
                break;
              case P0:
                var o0 = m2._payload, r0 = m2._init;
                b2(r0(o0), D2, y2);
                break;
            }
          }
          return D2;
        }
        function T2(m2, D2, y2, U2) {
          for (var o0 = null, r0 = 0; r0 < y2.length; r0++) {
            var T0 = y2[r0];
            o0 = b2(T0, o0, m2);
          }
          for (var N0 = null, Ve = null, Ie = D2, r5 = 0, Be = 0, zt = null; Ie !== null && Be < y2.length; Be++) {
            Ie.index > Be ? (zt = Ie, Ie = null) : zt = Ie.sibling;
            var w1 = g2(m2, Ie, y2[Be], U2);
            if (w1 === null) {
              Ie === null && (Ie = zt);
              break;
            }
            a && Ie && w1.alternate === null && s(m2, Ie), r5 = b(w1, r5, Be), Ve === null ? N0 = w1 : Ve.sibling = w1, Ve = w1, Ie = zt;
          }
          if (Be === y2.length) {
            if (C(m2, Ie), X5()) {
              var a1 = Be;
              ai(m2, a1);
            }
            return N0;
          }
          if (Ie === null) {
            for (; Be < y2.length; Be++) {
              var Hr = h2(m2, y2[Be], U2);
              Hr !== null && (r5 = b(Hr, r5, Be), Ve === null ? N0 = Hr : Ve.sibling = Hr, Ve = Hr);
            }
            if (X5()) {
              var q1 = Be;
              ai(m2, q1);
            }
            return N0;
          }
          for (var W1 = p(m2, Ie); Be < y2.length; Be++) {
            var S1 = B2(W1, m2, Be, y2[Be], U2);
            S1 !== null && (a && S1.alternate !== null && W1.delete(S1.key === null ? Be : S1.key), r5 = b(S1, r5, Be), Ve === null ? N0 = S1 : Ve.sibling = S1, Ve = S1);
          }
          if (a && W1.forEach(function(zo) {
            return s(m2, zo);
          }), X5()) {
            var u8 = Be;
            ai(m2, u8);
          }
          return N0;
        }
        function t0(m2, D2, y2, U2) {
          var o0 = j0(y2);
          if (typeof o0 != "function")
            throw new Error("An object is not an iterable. This error is likely caused by a bug in React. Please file an issue.");
          {
            typeof Symbol == "function" && // $FlowFixMe Flow doesn't know about toStringTag
            y2[Symbol.toStringTag] === "Generator" && (aE || u("Using Generators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. Keep in mind you might need to polyfill these features for older browsers."), aE = !0), y2.entries === o0 && (iE || u("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), iE = !0);
            var r0 = o0.call(y2);
            if (r0)
              for (var T0 = null, N0 = r0.next(); !N0.done; N0 = r0.next()) {
                var Ve = N0.value;
                T0 = b2(Ve, T0, m2);
              }
          }
          var Ie = o0.call(y2);
          if (Ie == null)
            throw new Error("An iterable object provided no iterator.");
          for (var r5 = null, Be = null, zt = D2, w1 = 0, a1 = 0, Hr = null, q1 = Ie.next(); zt !== null && !q1.done; a1++, q1 = Ie.next()) {
            zt.index > a1 ? (Hr = zt, zt = null) : Hr = zt.sibling;
            var W1 = g2(m2, zt, q1.value, U2);
            if (W1 === null) {
              zt === null && (zt = Hr);
              break;
            }
            a && zt && W1.alternate === null && s(m2, zt), w1 = b(W1, w1, a1), Be === null ? r5 = W1 : Be.sibling = W1, Be = W1, zt = Hr;
          }
          if (q1.done) {
            if (C(m2, zt), X5()) {
              var S1 = a1;
              ai(m2, S1);
            }
            return r5;
          }
          if (zt === null) {
            for (; !q1.done; a1++, q1 = Ie.next()) {
              var u8 = h2(m2, q1.value, U2);
              u8 !== null && (w1 = b(u8, w1, a1), Be === null ? r5 = u8 : Be.sibling = u8, Be = u8);
            }
            if (X5()) {
              var zo = a1;
              ai(m2, zo);
            }
            return r5;
          }
          for (var Bl = p(m2, zt); !q1.done; a1++, q1 = Ie.next()) {
            var i3 = B2(Bl, m2, a1, q1.value, U2);
            i3 !== null && (a && i3.alternate !== null && Bl.delete(i3.key === null ? a1 : i3.key), w1 = b(i3, w1, a1), Be === null ? r5 = i3 : Be.sibling = i3, Be = i3);
          }
          if (a && Bl.forEach(function(Se2) {
            return s(m2, Se2);
          }), X5()) {
            var we2 = a1;
            ai(m2, we2);
          }
          return r5;
        }
        function x0(m2, D2, y2, U2) {
          if (D2 !== null && D2.tag === I) {
            C(m2, D2.sibling);
            var o0 = m(D2, y2);
            return o0.return = m2, o0;
          }
          C(m2, D2);
          var r0 = ny(y2, m2.mode, U2);
          return r0.return = m2, r0;
        }
        function m0(m2, D2, y2, U2) {
          for (var o0 = y2.key, r0 = D2; r0 !== null; ) {
            if (r0.key === o0) {
              var T0 = y2.type;
              if (T0 === Kt) {
                if (r0.tag === Q) {
                  C(m2, r0.sibling);
                  var N0 = m(r0, y2.props.children);
                  return N0.return = m2, N0._debugSource = y2._source, N0._debugOwner = y2._owner, N0;
                }
              } else if (r0.elementType === T0 || // Keep this check inline so it only runs on the false path:
              AD(r0, y2) || // Lazy types should reconcile their resolved type.
              // We need to do this after the Hot Reloading check above,
              // because hot reloading has different semantics than prod because
              // it doesn't resuspend. So we can't let the call below suspend.
              typeof T0 == "object" && T0 !== null && T0.$$typeof === P0 && aO(T0) === r0.type) {
                C(m2, r0.sibling);
                var Ve = m(r0, y2.props);
                return Ve.ref = Uu(m2, r0, y2), Ve.return = m2, Ve._debugSource = y2._source, Ve._debugOwner = y2._owner, Ve;
              }
              C(m2, r0);
              break;
            } else
              s(m2, r0);
            r0 = r0.sibling;
          }
          if (y2.type === Kt) {
            var Ie = S6(y2.props.children, m2.mode, U2, y2.key);
            return Ie.return = m2, Ie;
          } else {
            var r5 = ry(y2, m2.mode, U2);
            return r5.ref = Uu(m2, D2, y2), r5.return = m2, r5;
          }
        }
        function se(m2, D2, y2, U2) {
          for (var o0 = y2.key, r0 = D2; r0 !== null; ) {
            if (r0.key === o0)
              if (r0.tag === E && r0.stateNode.containerInfo === y2.containerInfo && r0.stateNode.implementation === y2.implementation) {
                C(m2, r0.sibling);
                var T0 = m(r0, y2.children || []);
                return T0.return = m2, T0;
              } else {
                C(m2, r0);
                break;
              }
            else
              s(m2, r0);
            r0 = r0.sibling;
          }
          var N0 = iy(y2, m2.mode, U2);
          return N0.return = m2, N0;
        }
        function J0(m2, D2, y2, U2) {
          var o0 = typeof y2 == "object" && y2 !== null && y2.type === Kt && y2.key === null;
          if (o0 && (y2 = y2.props.children), typeof y2 == "object" && y2 !== null) {
            switch (y2.$$typeof) {
              case o5:
                return L(m0(m2, D2, y2, U2));
              case xe:
                return L(se(m2, D2, y2, U2));
              case P0:
                var r0 = y2._payload, T0 = y2._init;
                return J0(m2, D2, T0(r0), U2);
            }
            if (q0(y2))
              return T2(m2, D2, y2, U2);
            if (j0(y2))
              return t0(m2, D2, y2, U2);
            oC(m2, y2);
          }
          return typeof y2 == "string" && y2 !== "" || typeof y2 == "number" ? L(x0(m2, D2, "" + y2, U2)) : (typeof y2 == "function" && sC(m2), C(m2, D2));
        }
        return J0;
      }
      var bo = oO(!0), sO = oO(!1);
      function nJ(a, s) {
        if (a !== null && s.child !== a.child)
          throw new Error("Resuming work not yet implemented.");
        if (s.child !== null) {
          var C = s.child, p = vi(C, C.pendingProps);
          for (s.child = p, p.return = s; C.sibling !== null; )
            C = C.sibling, p = p.sibling = vi(C, C.pendingProps), p.return = s;
          p.sibling = null;
        }
      }
      function iJ(a, s) {
        for (var C = a.child; C !== null; )
          U02(C, s), C = C.sibling;
      }
      var lE = d6(null), cE;
      cE = {};
      var uC = null, wo = null, AE = null, lC = !1;
      function cC() {
        uC = null, wo = null, AE = null, lC = !1;
      }
      function uO() {
        lC = !0;
      }
      function lO() {
        lC = !1;
      }
      function cO(a, s, C) {
        x1(lE, s._currentValue, a), s._currentValue = C, s._currentRenderer !== void 0 && s._currentRenderer !== null && s._currentRenderer !== cE && u("Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."), s._currentRenderer = cE;
      }
      function fE(a, s) {
        var C = lE.current;
        Q1(lE, s), a._currentValue = C;
      }
      function CE(a, s, C) {
        for (var p = a; p !== null; ) {
          var m = p.alternate;
          if (z3(p.childLanes, s) ? m !== null && !z3(m.childLanes, s) && (m.childLanes = V0(m.childLanes, s)) : (p.childLanes = V0(p.childLanes, s), m !== null && (m.childLanes = V0(m.childLanes, s))), p === C)
            break;
          p = p.return;
        }
        p !== C && u("Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue.");
      }
      function aJ(a, s, C) {
        oJ(a, s, C);
      }
      function oJ(a, s, C) {
        var p = a.child;
        for (p !== null && (p.return = a); p !== null; ) {
          var m = void 0, b = p.dependencies;
          if (b !== null) {
            m = p.child;
            for (var L = b.firstContext; L !== null; ) {
              if (L.context === s) {
                if (p.tag === d) {
                  var P = R7(C), N = r8(Xe, P);
                  N.tag = fC;
                  var G = p.updateQueue;
                  if (G !== null) {
                    var J = G.shared, h2 = J.pending;
                    h2 === null ? N.next = N : (N.next = h2.next, h2.next = N), J.pending = N;
                  }
                }
                p.lanes = V0(p.lanes, C);
                var g2 = p.alternate;
                g2 !== null && (g2.lanes = V0(g2.lanes, C)), CE(p.return, C, a), b.lanes = V0(b.lanes, C);
                break;
              }
              L = L.next;
            }
          } else if (p.tag === M)
            m = p.type === a.type ? null : p.child;
          else if (p.tag === Z) {
            var B2 = p.return;
            if (B2 === null)
              throw new Error("We just came from a parent so we must have had a parent. This is a bug in React.");
            B2.lanes = V0(B2.lanes, C);
            var b2 = B2.alternate;
            b2 !== null && (b2.lanes = V0(b2.lanes, C)), CE(B2, C, a), m = p.sibling;
          } else
            m = p.child;
          if (m !== null)
            m.return = p;
          else
            for (m = p; m !== null; ) {
              if (m === a) {
                m = null;
                break;
              }
              var T2 = m.sibling;
              if (T2 !== null) {
                T2.return = m.return, m = T2;
                break;
              }
              m = m.return;
            }
          p = m;
        }
      }
      function So(a, s) {
        uC = a, wo = null, AE = null;
        var C = a.dependencies;
        if (C !== null) {
          var p = C.firstContext;
          p !== null && (m1(C.lanes, s) && ol(), C.firstContext = null);
        }
      }
      function c5(a) {
        lC && u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        var s = a._currentValue;
        if (AE !== a) {
          var C = {
            context: a,
            memoizedValue: s,
            next: null
          };
          if (wo === null) {
            if (uC === null)
              throw new Error("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
            wo = C, uC.dependencies = {
              lanes: H2,
              firstContext: C
            };
          } else
            wo = wo.next = C;
        }
        return s;
      }
      var ci = null;
      function dE(a) {
        ci === null ? ci = [a] : ci.push(a);
      }
      function sJ() {
        if (ci !== null) {
          for (var a = 0; a < ci.length; a++) {
            var s = ci[a], C = s.interleaved;
            if (C !== null) {
              s.interleaved = null;
              var p = C.next, m = s.pending;
              if (m !== null) {
                var b = m.next;
                m.next = p, C.next = b;
              }
              s.pending = C;
            }
          }
          ci = null;
        }
      }
      function AO(a, s, C, p) {
        var m = s.interleaved;
        return m === null ? (C.next = C, dE(s)) : (C.next = m.next, m.next = C), s.interleaved = C, AC(a, p);
      }
      function uJ(a, s, C, p) {
        var m = s.interleaved;
        m === null ? (C.next = C, dE(s)) : (C.next = m.next, m.next = C), s.interleaved = C;
      }
      function lJ(a, s, C, p) {
        var m = s.interleaved;
        return m === null ? (C.next = C, dE(s)) : (C.next = m.next, m.next = C), s.interleaved = C, AC(a, p);
      }
      function Cr(a, s) {
        return AC(a, s);
      }
      var cJ = AC;
      function AC(a, s) {
        a.lanes = V0(a.lanes, s);
        var C = a.alternate;
        C !== null && (C.lanes = V0(C.lanes, s)), C === null && (a.flags & (xt | ir)) !== I0 && sD(a);
        for (var p = a, m = a.return; m !== null; )
          m.childLanes = V0(m.childLanes, s), C = m.alternate, C !== null ? C.childLanes = V0(C.childLanes, s) : (m.flags & (xt | ir)) !== I0 && sD(a), p = m, m = m.return;
        if (p.tag === h) {
          var b = p.stateNode;
          return b;
        } else
          return null;
      }
      var fO = 0, CO = 1, fC = 2, gE = 3, CC = !1, pE, dC;
      pE = !1, dC = null;
      function hE(a) {
        var s = {
          baseState: a.memoizedState,
          firstBaseUpdate: null,
          lastBaseUpdate: null,
          shared: {
            pending: null,
            interleaved: null,
            lanes: H2
          },
          effects: null
        };
        a.updateQueue = s;
      }
      function dO(a, s) {
        var C = s.updateQueue, p = a.updateQueue;
        if (C === p) {
          var m = {
            baseState: p.baseState,
            firstBaseUpdate: p.firstBaseUpdate,
            lastBaseUpdate: p.lastBaseUpdate,
            shared: p.shared,
            effects: p.effects
          };
          s.updateQueue = m;
        }
      }
      function r8(a, s) {
        var C = {
          eventTime: a,
          lane: s,
          tag: fO,
          payload: null,
          callback: null,
          next: null
        };
        return C;
      }
      function v6(a, s, C) {
        var p = a.updateQueue;
        if (p === null)
          return null;
        var m = p.shared;
        if (dC === m && !pE && (u("An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback."), pE = !0), u02()) {
          var b = m.pending;
          return b === null ? s.next = s : (s.next = b.next, b.next = s), m.pending = s, cJ(a, C);
        } else
          return lJ(a, m, s, C);
      }
      function gC(a, s, C) {
        var p = s.updateQueue;
        if (p !== null) {
          var m = p.shared;
          if (iu(C)) {
            var b = m.lanes;
            b = ou(b, a.pendingLanes);
            var L = V0(b, C);
            m.lanes = L, Ja(a, L);
          }
        }
      }
      function vE(a, s) {
        var C = a.updateQueue, p = a.alternate;
        if (p !== null) {
          var m = p.updateQueue;
          if (C === m) {
            var b = null, L = null, P = C.firstBaseUpdate;
            if (P !== null) {
              var N = P;
              do {
                var G = {
                  eventTime: N.eventTime,
                  lane: N.lane,
                  tag: N.tag,
                  payload: N.payload,
                  callback: N.callback,
                  next: null
                };
                L === null ? b = L = G : (L.next = G, L = G), N = N.next;
              } while (N !== null);
              L === null ? b = L = s : (L.next = s, L = s);
            } else
              b = L = s;
            C = {
              baseState: m.baseState,
              firstBaseUpdate: b,
              lastBaseUpdate: L,
              shared: m.shared,
              effects: m.effects
            }, a.updateQueue = C;
            return;
          }
        }
        var J = C.lastBaseUpdate;
        J === null ? C.firstBaseUpdate = s : J.next = s, C.lastBaseUpdate = s;
      }
      function AJ(a, s, C, p, m, b) {
        switch (C.tag) {
          case CO: {
            var L = C.payload;
            if (typeof L == "function") {
              uO();
              var P = L.call(b, p, m);
              {
                if (a.mode & He) {
                  ht(!0);
                  try {
                    L.call(b, p, m);
                  } finally {
                    ht(!1);
                  }
                }
                lO();
              }
              return P;
            }
            return L;
          }
          case gE:
            a.flags = a.flags & -65537 | y0;
          // Intentional fallthrough
          case fO: {
            var N = C.payload, G;
            if (typeof N == "function") {
              uO(), G = N.call(b, p, m);
              {
                if (a.mode & He) {
                  ht(!0);
                  try {
                    N.call(b, p, m);
                  } finally {
                    ht(!1);
                  }
                }
                lO();
              }
            } else
              G = N;
            return G == null ? p : z0({}, p, G);
          }
          case fC:
            return CC = !0, p;
        }
        return p;
      }
      function pC(a, s, C, p) {
        var m = a.updateQueue;
        CC = !1, dC = m.shared;
        var b = m.firstBaseUpdate, L = m.lastBaseUpdate, P = m.shared.pending;
        if (P !== null) {
          m.shared.pending = null;
          var N = P, G = N.next;
          N.next = null, L === null ? b = G : L.next = G, L = N;
          var J = a.alternate;
          if (J !== null) {
            var h2 = J.updateQueue, g2 = h2.lastBaseUpdate;
            g2 !== L && (g2 === null ? h2.firstBaseUpdate = G : g2.next = G, h2.lastBaseUpdate = N);
          }
        }
        if (b !== null) {
          var B2 = m.baseState, b2 = H2, T2 = null, t0 = null, x0 = null, m0 = b;
          do {
            var se = m0.lane, J0 = m0.eventTime;
            if (z3(p, se)) {
              if (x0 !== null) {
                var D2 = {
                  eventTime: J0,
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: Ce,
                  tag: m0.tag,
                  payload: m0.payload,
                  callback: m0.callback,
                  next: null
                };
                x0 = x0.next = D2;
              }
              B2 = AJ(a, m, m0, B2, s, C);
              var y2 = m0.callback;
              if (y2 !== null && // If the update was already committed, we should not queue its
              // callback again.
              m0.lane !== Ce) {
                a.flags |= ot;
                var U2 = m.effects;
                U2 === null ? m.effects = [m0] : U2.push(m0);
              }
            } else {
              var m2 = {
                eventTime: J0,
                lane: se,
                tag: m0.tag,
                payload: m0.payload,
                callback: m0.callback,
                next: null
              };
              x0 === null ? (t0 = x0 = m2, T2 = B2) : x0 = x0.next = m2, b2 = V0(b2, se);
            }
            if (m0 = m0.next, m0 === null) {
              if (P = m.shared.pending, P === null)
                break;
              var o0 = P, r0 = o0.next;
              o0.next = null, m0 = r0, m.lastBaseUpdate = o0, m.shared.pending = null;
            }
          } while (!0);
          x0 === null && (T2 = B2), m.baseState = T2, m.firstBaseUpdate = t0, m.lastBaseUpdate = x0;
          var T0 = m.shared.interleaved;
          if (T0 !== null) {
            var N0 = T0;
            do
              b2 = V0(b2, N0.lane), N0 = N0.next;
            while (N0 !== T0);
          } else b === null && (m.shared.lanes = H2);
          vl(b2), a.lanes = b2, a.memoizedState = B2;
        }
        dC = null;
      }
      function fJ(a, s) {
        if (typeof a != "function")
          throw new Error("Invalid argument passed as callback. Expected a function. Instead " + ("received: " + a));
        a.call(s);
      }
      function gO() {
        CC = !1;
      }
      function hC() {
        return CC;
      }
      function pO(a, s, C) {
        var p = s.effects;
        if (s.effects = null, p !== null)
          for (var m = 0; m < p.length; m++) {
            var b = p[m], L = b.callback;
            L !== null && (b.callback = null, fJ(L, C));
          }
      }
      var qu = {}, E6 = d6(qu), Wu = d6(qu), vC = d6(qu);
      function EC(a) {
        if (a === qu)
          throw new Error("Expected host context to exist. This error is likely caused by a bug in React. Please file an issue.");
        return a;
      }
      function hO() {
        var a = EC(vC.current);
        return a;
      }
      function EE(a, s) {
        x1(vC, s, a), x1(Wu, a, a), x1(E6, qu, a);
        var C = MK(s);
        Q1(E6, a), x1(E6, C, a);
      }
      function Mo(a) {
        Q1(E6, a), Q1(Wu, a), Q1(vC, a);
      }
      function mE() {
        var a = EC(E6.current);
        return a;
      }
      function vO(a) {
        EC(vC.current);
        var s = EC(E6.current), C = _K(s, a.type);
        s !== C && (x1(Wu, a, a), x1(E6, C, a));
      }
      function yE(a) {
        Wu.current === a && (Q1(E6, a), Q1(Wu, a));
      }
      var CJ = 0, EO = 1, mO = 1, Yu = 2, X4 = d6(CJ);
      function IE(a, s) {
        return (a & s) !== 0;
      }
      function _o(a) {
        return a & EO;
      }
      function BE(a, s) {
        return a & EO | s;
      }
      function dJ(a, s) {
        return a | s;
      }
      function m6(a, s) {
        x1(X4, s, a);
      }
      function Oo(a) {
        Q1(X4, a);
      }
      function gJ(a, s) {
        var C = a.memoizedState;
        return C !== null ? C.dehydrated !== null : (a.memoizedProps, !0);
      }
      function mC(a) {
        for (var s = a; s !== null; ) {
          if (s.tag === w) {
            var C = s.memoizedState;
            if (C !== null) {
              var p = C.dehydrated;
              if (p === null || P_(p) || jv(p))
                return s;
            }
          } else if (s.tag === V && // revealOrder undefined can't be trusted because it don't
          // keep track of whether it suspended or not.
          s.memoizedProps.revealOrder !== void 0) {
            var m = (s.flags & y0) !== I0;
            if (m)
              return s;
          } else if (s.child !== null) {
            s.child.return = s, s = s.child;
            continue;
          }
          if (s === a)
            return null;
          for (; s.sibling === null; ) {
            if (s.return === null || s.return === a)
              return null;
            s = s.return;
          }
          s.sibling.return = s.return, s = s.sibling;
        }
        return null;
      }
      var dr = (
        /*   */
        0
      ), I5 = (
        /* */
        1
      ), Kn = (
        /*  */
        2
      ), B5 = (
        /*    */
        4
      ), J5 = (
        /*   */
        8
      ), QE = [];
      function xE() {
        for (var a = 0; a < QE.length; a++) {
          var s = QE[a];
          s._workInProgressVersionPrimary = null;
        }
        QE.length = 0;
      }
      function pJ(a, s) {
        var C = s._getVersion, p = C(s._source);
        a.mutableSourceEagerHydrationData == null ? a.mutableSourceEagerHydrationData = [s, p] : a.mutableSourceEagerHydrationData.push(s, p);
      }
      var i0 = r.ReactCurrentDispatcher, $u = r.ReactCurrentBatchConfig, bE, To;
      bE = /* @__PURE__ */ new Set();
      var Ai = H2, je = null, Q5 = null, x5 = null, yC = !1, Gu = !1, Ku = 0, hJ = 0, vJ = 25, P2 = null, E4 = null, y6 = -1, wE = !1;
      function Se() {
        {
          var a = P2;
          E4 === null ? E4 = [a] : E4.push(a);
        }
      }
      function $2() {
        {
          var a = P2;
          E4 !== null && (y6++, E4[y6] !== a && EJ(a));
        }
      }
      function Do(a) {
        a != null && !q0(a) && u("%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.", P2, typeof a);
      }
      function EJ(a) {
        {
          var s = R0(je);
          if (!bE.has(s) && (bE.add(s), E4 !== null)) {
            for (var C = "", p = 30, m = 0; m <= y6; m++) {
              for (var b = E4[m], L = m === y6 ? a : b, P = m + 1 + ". " + b; P.length < p; )
                P += " ";
              P += L + `
`, C += P;
            }
            u(`React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://reactjs.org/link/rules-of-hooks

   Previous render            Next render
   ------------------------------------------------------
%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^
`, s, C);
          }
        }
      }
      function b1() {
        throw new Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      }
      function SE(a, s) {
        if (wE)
          return !1;
        if (s === null)
          return u("%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.", P2), !1;
        a.length !== s.length && u(`The final argument passed to %s changed size between renders. The order and size of this array must remain constant.

Previous: %s
Incoming: %s`, P2, "[" + s.join(", ") + "]", "[" + a.join(", ") + "]");
        for (var C = 0; C < s.length && C < a.length; C++)
          if (!Z2(a[C], s[C]))
            return !1;
        return !0;
      }
      function Lo(a, s, C, p, m, b) {
        Ai = b, je = s, E4 = a !== null ? a._debugHookTypes : null, y6 = -1, wE = a !== null && a.type !== s.type, s.memoizedState = null, s.updateQueue = null, s.lanes = H2, a !== null && a.memoizedState !== null ? i0.current = VO : E4 !== null ? i0.current = jO : i0.current = HO;
        var L = C(p, m);
        if (Gu) {
          var P = 0;
          do {
            if (Gu = !1, Ku = 0, P >= vJ)
              throw new Error("Too many re-renders. React limits the number of renders to prevent an infinite loop.");
            P += 1, wE = !1, Q5 = null, x5 = null, s.updateQueue = null, y6 = -1, i0.current = ZO, L = C(p, m);
          } while (Gu);
        }
        i0.current = LC, s._debugHookTypes = E4;
        var N = Q5 !== null && Q5.next !== null;
        if (Ai = H2, je = null, Q5 = null, x5 = null, P2 = null, E4 = null, y6 = -1, a !== null && (a.flags & Ft) !== (s.flags & Ft) && // Disable this warning in legacy mode, because legacy Suspense is weird
        // and creates false positives. To make this work in legacy mode, we'd
        // need to mark fibers that commit in an incomplete state, somehow. For
        // now I'll disable the warning that most of the bugs that would trigger
        // it are either exclusive to concurrent mode or exist in both.
        (a.mode & Y0) !== B0 && u("Internal React error: Expected static flag was missing. Please notify the React team."), yC = !1, N)
          throw new Error("Rendered fewer hooks than expected. This may be caused by an accidental early return statement.");
        return L;
      }
      function ko() {
        var a = Ku !== 0;
        return Ku = 0, a;
      }
      function yO(a, s, C) {
        s.updateQueue = a.updateQueue, (s.mode & me) !== B0 ? s.flags &= -50333701 : s.flags &= -2053, a.lanes = P7(a.lanes, C);
      }
      function IO() {
        if (i0.current = LC, yC) {
          for (var a = je.memoizedState; a !== null; ) {
            var s = a.queue;
            s !== null && (s.pending = null), a = a.next;
          }
          yC = !1;
        }
        Ai = H2, je = null, Q5 = null, x5 = null, E4 = null, y6 = -1, P2 = null, kO = !1, Gu = !1, Ku = 0;
      }
      function Xn() {
        var a = {
          memoizedState: null,
          baseState: null,
          baseQueue: null,
          queue: null,
          next: null
        };
        return x5 === null ? je.memoizedState = x5 = a : x5 = x5.next = a, x5;
      }
      function m4() {
        var a;
        if (Q5 === null) {
          var s = je.alternate;
          s !== null ? a = s.memoizedState : a = null;
        } else
          a = Q5.next;
        var C;
        if (x5 === null ? C = je.memoizedState : C = x5.next, C !== null)
          x5 = C, C = x5.next, Q5 = a;
        else {
          if (a === null)
            throw new Error("Rendered more hooks than during the previous render.");
          Q5 = a;
          var p = {
            memoizedState: Q5.memoizedState,
            baseState: Q5.baseState,
            baseQueue: Q5.baseQueue,
            queue: Q5.queue,
            next: null
          };
          x5 === null ? je.memoizedState = x5 = p : x5 = x5.next = p;
        }
        return x5;
      }
      function BO() {
        return {
          lastEffect: null,
          stores: null
        };
      }
      function ME(a, s) {
        return typeof s == "function" ? s(a) : s;
      }
      function _E(a, s, C) {
        var p = Xn(), m;
        C !== void 0 ? m = C(s) : m = s, p.memoizedState = p.baseState = m;
        var b = {
          pending: null,
          interleaved: null,
          lanes: H2,
          dispatch: null,
          lastRenderedReducer: a,
          lastRenderedState: m
        };
        p.queue = b;
        var L = b.dispatch = BJ.bind(null, je, b);
        return [p.memoizedState, L];
      }
      function OE(a, s, C) {
        var p = m4(), m = p.queue;
        if (m === null)
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        m.lastRenderedReducer = a;
        var b = Q5, L = b.baseQueue, P = m.pending;
        if (P !== null) {
          if (L !== null) {
            var N = L.next, G = P.next;
            L.next = G, P.next = N;
          }
          b.baseQueue !== L && u("Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."), b.baseQueue = L = P, m.pending = null;
        }
        if (L !== null) {
          var J = L.next, h2 = b.baseState, g2 = null, B2 = null, b2 = null, T2 = J;
          do {
            var t0 = T2.lane;
            if (z3(Ai, t0)) {
              if (b2 !== null) {
                var m0 = {
                  // This update is going to be committed so we never want uncommit
                  // it. Using NoLane works because 0 is a subset of all bitmasks, so
                  // this will never be skipped by the check above.
                  lane: Ce,
                  action: T2.action,
                  hasEagerState: T2.hasEagerState,
                  eagerState: T2.eagerState,
                  next: null
                };
                b2 = b2.next = m0;
              }
              if (T2.hasEagerState)
                h2 = T2.eagerState;
              else {
                var se = T2.action;
                h2 = a(h2, se);
              }
            } else {
              var x0 = {
                lane: t0,
                action: T2.action,
                hasEagerState: T2.hasEagerState,
                eagerState: T2.eagerState,
                next: null
              };
              b2 === null ? (B2 = b2 = x0, g2 = h2) : b2 = b2.next = x0, je.lanes = V0(je.lanes, t0), vl(t0);
            }
            T2 = T2.next;
          } while (T2 !== null && T2 !== J);
          b2 === null ? g2 = h2 : b2.next = B2, Z2(h2, p.memoizedState) || ol(), p.memoizedState = h2, p.baseState = g2, p.baseQueue = b2, m.lastRenderedState = h2;
        }
        var J0 = m.interleaved;
        if (J0 !== null) {
          var m2 = J0;
          do {
            var D2 = m2.lane;
            je.lanes = V0(je.lanes, D2), vl(D2), m2 = m2.next;
          } while (m2 !== J0);
        } else L === null && (m.lanes = H2);
        var y2 = m.dispatch;
        return [p.memoizedState, y2];
      }
      function TE(a, s, C) {
        var p = m4(), m = p.queue;
        if (m === null)
          throw new Error("Should have a queue. This is likely a bug in React. Please file an issue.");
        m.lastRenderedReducer = a;
        var b = m.dispatch, L = m.pending, P = p.memoizedState;
        if (L !== null) {
          m.pending = null;
          var N = L.next, G = N;
          do {
            var J = G.action;
            P = a(P, J), G = G.next;
          } while (G !== N);
          Z2(P, p.memoizedState) || ol(), p.memoizedState = P, p.baseQueue === null && (p.baseState = P), m.lastRenderedState = P;
        }
        return [P, b];
      }
      function vQ2(a, s, C) {
      }
      function EQ2(a, s, C) {
      }
      function DE(a, s, C) {
        var p = je, m = Xn(), b, L = X5();
        if (L) {
          if (C === void 0)
            throw new Error("Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering.");
          b = C(), To || b !== C() && (u("The result of getServerSnapshot should be cached to avoid an infinite loop"), To = !0);
        } else {
          if (b = s(), !To) {
            var P = s();
            Z2(b, P) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), To = !0);
          }
          var N = JC();
          if (N === null)
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          Ka(N, Ai) || QO(p, s, b);
        }
        m.memoizedState = b;
        var G = {
          value: b,
          getSnapshot: s
        };
        return m.queue = G, bC(bO.bind(null, p, G, a), [a]), p.flags |= g1, Xu(I5 | J5, xO.bind(null, p, G, b, s), void 0, null), b;
      }
      function IC(a, s, C) {
        var p = je, m = m4(), b = s();
        if (!To) {
          var L = s();
          Z2(b, L) || (u("The result of getSnapshot should be cached to avoid an infinite loop"), To = !0);
        }
        var P = m.memoizedState, N = !Z2(P, b);
        N && (m.memoizedState = b, ol());
        var G = m.queue;
        if (el(bO.bind(null, p, G, a), [a]), G.getSnapshot !== s || N || // Check if the susbcribe function changed. We can save some memory by
        // checking whether we scheduled a subscription effect above.
        x5 !== null && x5.memoizedState.tag & I5) {
          p.flags |= g1, Xu(I5 | J5, xO.bind(null, p, G, b, s), void 0, null);
          var J = JC();
          if (J === null)
            throw new Error("Expected a work-in-progress root. This is a bug in React. Please file an issue.");
          Ka(J, Ai) || QO(p, s, b);
        }
        return b;
      }
      function QO(a, s, C) {
        a.flags |= X8;
        var p = {
          getSnapshot: s,
          value: C
        }, m = je.updateQueue;
        if (m === null)
          m = BO(), je.updateQueue = m, m.stores = [p];
        else {
          var b = m.stores;
          b === null ? m.stores = [p] : b.push(p);
        }
      }
      function xO(a, s, C, p) {
        s.value = C, s.getSnapshot = p, wO(s) && SO(a);
      }
      function bO(a, s, C) {
        var p = function() {
          wO(s) && SO(a);
        };
        return C(p);
      }
      function wO(a) {
        var s = a.getSnapshot, C = a.value;
        try {
          var p = s();
          return !Z2(C, p);
        } catch {
          return !0;
        }
      }
      function SO(a) {
        var s = Cr(a, O0);
        s !== null && M5(s, a, O0, Xe);
      }
      function BC(a) {
        var s = Xn();
        typeof a == "function" && (a = a()), s.memoizedState = s.baseState = a;
        var C = {
          pending: null,
          interleaved: null,
          lanes: H2,
          dispatch: null,
          lastRenderedReducer: ME,
          lastRenderedState: a
        };
        s.queue = C;
        var p = C.dispatch = QJ.bind(null, je, C);
        return [s.memoizedState, p];
      }
      function LE(a) {
        return OE(ME);
      }
      function kE(a) {
        return TE(ME);
      }
      function Xu(a, s, C, p) {
        var m = {
          tag: a,
          create: s,
          destroy: C,
          deps: p,
          // Circular
          next: null
        }, b = je.updateQueue;
        if (b === null)
          b = BO(), je.updateQueue = b, b.lastEffect = m.next = m;
        else {
          var L = b.lastEffect;
          if (L === null)
            b.lastEffect = m.next = m;
          else {
            var P = L.next;
            L.next = m, m.next = P, b.lastEffect = m;
          }
        }
        return m;
      }
      function RE(a) {
        var s = Xn();
        {
          var C = {
            current: a
          };
          return s.memoizedState = C, C;
        }
      }
      function QC(a) {
        var s = m4();
        return s.memoizedState;
      }
      function Ju(a, s, C, p) {
        var m = Xn(), b = p === void 0 ? null : p;
        je.flags |= a, m.memoizedState = Xu(I5 | s, C, void 0, b);
      }
      function xC(a, s, C, p) {
        var m = m4(), b = p === void 0 ? null : p, L = void 0;
        if (Q5 !== null) {
          var P = Q5.memoizedState;
          if (L = P.destroy, b !== null) {
            var N = P.deps;
            if (SE(b, N)) {
              m.memoizedState = Xu(s, C, L, b);
              return;
            }
          }
        }
        je.flags |= a, m.memoizedState = Xu(I5 | s, C, L, b);
      }
      function bC(a, s) {
        return (je.mode & me) !== B0 ? Ju(s4 | g1 | Qa, J5, a, s) : Ju(g1 | Qa, J5, a, s);
      }
      function el(a, s) {
        return xC(g1, J5, a, s);
      }
      function PE(a, s) {
        return Ju(ie, Kn, a, s);
      }
      function wC(a, s) {
        return xC(ie, Kn, a, s);
      }
      function FE(a, s) {
        var C = ie;
        return C |= H4, (je.mode & me) !== B0 && (C |= Dn), Ju(C, B5, a, s);
      }
      function SC(a, s) {
        return xC(ie, B5, a, s);
      }
      function MO(a, s) {
        if (typeof s == "function") {
          var C = s, p = a();
          return C(p), function() {
            C(null);
          };
        } else if (s != null) {
          var m = s;
          m.hasOwnProperty("current") || u("Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.", "an object with keys {" + Object.keys(m).join(", ") + "}");
          var b = a();
          return m.current = b, function() {
            m.current = null;
          };
        }
      }
      function NE(a, s, C) {
        typeof s != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", s !== null ? typeof s : "null");
        var p = C != null ? C.concat([a]) : null, m = ie;
        return m |= H4, (je.mode & me) !== B0 && (m |= Dn), Ju(m, B5, MO.bind(null, s, a), p);
      }
      function MC(a, s, C) {
        typeof s != "function" && u("Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.", s !== null ? typeof s : "null");
        var p = C != null ? C.concat([a]) : null;
        return xC(ie, B5, MO.bind(null, s, a), p);
      }
      function mJ(a, s) {
      }
      var _C = mJ;
      function HE(a, s) {
        var C = Xn(), p = s === void 0 ? null : s;
        return C.memoizedState = [a, p], a;
      }
      function OC(a, s) {
        var C = m4(), p = s === void 0 ? null : s, m = C.memoizedState;
        if (m !== null && p !== null) {
          var b = m[1];
          if (SE(p, b))
            return m[0];
        }
        return C.memoizedState = [a, p], a;
      }
      function jE(a, s) {
        var C = Xn(), p = s === void 0 ? null : s, m = a();
        return C.memoizedState = [m, p], m;
      }
      function TC(a, s) {
        var C = m4(), p = s === void 0 ? null : s, m = C.memoizedState;
        if (m !== null && p !== null) {
          var b = m[1];
          if (SE(p, b))
            return m[0];
        }
        var L = a();
        return C.memoizedState = [L, p], L;
      }
      function VE(a) {
        var s = Xn();
        return s.memoizedState = a, a;
      }
      function _O(a) {
        var s = m4(), C = Q5, p = C.memoizedState;
        return TO(s, p, a);
      }
      function OO(a) {
        var s = m4();
        if (Q5 === null)
          return s.memoizedState = a, a;
        var C = Q5.memoizedState;
        return TO(s, C, a);
      }
      function TO(a, s, C) {
        var p = !ru(Ai);
        if (p) {
          if (!Z2(C, s)) {
            var m = au();
            je.lanes = V0(je.lanes, m), vl(m), a.baseState = !0;
          }
          return s;
        } else
          return a.baseState && (a.baseState = !1, ol()), a.memoizedState = C, C;
      }
      function yJ(a, s, C) {
        var p = cr();
        jt(lf(p, A4)), a(!0);
        var m = $u.transition;
        $u.transition = {};
        var b = $u.transition;
        $u.transition._updatedFibers = /* @__PURE__ */ new Set();
        try {
          a(!1), s();
        } finally {
          if (jt(p), $u.transition = m, m === null && b._updatedFibers) {
            var L = b._updatedFibers.size;
            L > 10 && o("Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."), b._updatedFibers.clear();
          }
        }
      }
      function ZE() {
        var a = BC(!1), s = a[0], C = a[1], p = yJ.bind(null, C), m = Xn();
        return m.memoizedState = p, [s, p];
      }
      function DO() {
        var a = LE(), s = a[0], C = m4(), p = C.memoizedState;
        return [s, p];
      }
      function LO() {
        var a = kE(), s = a[0], C = m4(), p = C.memoizedState;
        return [s, p];
      }
      var kO = !1;
      function IJ() {
        return kO;
      }
      function zE() {
        var a = Xn(), s = JC(), C = s.identifierPrefix, p;
        if (X5()) {
          var m = NX();
          p = ":" + C + "R" + m;
          var b = Ku++;
          b > 0 && (p += "H" + b.toString(32)), p += ":";
        } else {
          var L = hJ++;
          p = ":" + C + "r" + L.toString(32) + ":";
        }
        return a.memoizedState = p, p;
      }
      function DC() {
        var a = m4(), s = a.memoizedState;
        return s;
      }
      function BJ(a, s, C) {
        typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var p = b6(a), m = {
          lane: p,
          action: C,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
        if (RO(a))
          PO(s, m);
        else {
          var b = AO(a, s, m, p);
          if (b !== null) {
            var L = U1();
            M5(b, a, p, L), FO(b, s, p);
          }
        }
        NO(a, p);
      }
      function QJ(a, s, C) {
        typeof arguments[3] == "function" && u("State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect().");
        var p = b6(a), m = {
          lane: p,
          action: C,
          hasEagerState: !1,
          eagerState: null,
          next: null
        };
        if (RO(a))
          PO(s, m);
        else {
          var b = a.alternate;
          if (a.lanes === H2 && (b === null || b.lanes === H2)) {
            var L = s.lastRenderedReducer;
            if (L !== null) {
              var P;
              P = i0.current, i0.current = J4;
              try {
                var N = s.lastRenderedState, G = L(N, C);
                if (m.hasEagerState = !0, m.eagerState = G, Z2(G, N)) {
                  uJ(a, s, m, p);
                  return;
                }
              } catch {
              } finally {
                i0.current = P;
              }
            }
          }
          var J = AO(a, s, m, p);
          if (J !== null) {
            var h2 = U1();
            M5(J, a, p, h2), FO(J, s, p);
          }
        }
        NO(a, p);
      }
      function RO(a) {
        var s = a.alternate;
        return a === je || s !== null && s === je;
      }
      function PO(a, s) {
        Gu = yC = !0;
        var C = a.pending;
        C === null ? s.next = s : (s.next = C.next, C.next = s), a.pending = s;
      }
      function FO(a, s, C) {
        if (iu(C)) {
          var p = s.lanes;
          p = ou(p, a.pendingLanes);
          var m = V0(p, C);
          s.lanes = m, Ja(a, m);
        }
      }
      function NO(a, s, C) {
        w7(a, s);
      }
      var LC = {
        readContext: c5,
        useCallback: b1,
        useContext: b1,
        useEffect: b1,
        useImperativeHandle: b1,
        useInsertionEffect: b1,
        useLayoutEffect: b1,
        useMemo: b1,
        useReducer: b1,
        useRef: b1,
        useState: b1,
        useDebugValue: b1,
        useDeferredValue: b1,
        useTransition: b1,
        useMutableSource: b1,
        useSyncExternalStore: b1,
        useId: b1,
        unstable_isNewReconciler: X
      }, HO = null, jO = null, VO = null, ZO = null, Jn = null, J4 = null, kC = null;
      {
        var UE = function() {
          u("Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo().");
        }, F0 = function() {
          u("Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://reactjs.org/link/rules-of-hooks");
        };
        HO = {
          readContext: function(a) {
            return c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", Se(), Do(s), HE(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", Se(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", Se(), Do(s), bC(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", Se(), Do(C), NE(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", Se(), Do(s), PE(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", Se(), Do(s), FE(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", Se(), Do(s);
            var C = i0.current;
            i0.current = Jn;
            try {
              return jE(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", Se();
            var p = i0.current;
            i0.current = Jn;
            try {
              return _E(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", Se(), RE(a);
          },
          useState: function(a) {
            P2 = "useState", Se();
            var s = i0.current;
            i0.current = Jn;
            try {
              return BC(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", Se(), void 0;
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", Se(), VE(a);
          },
          useTransition: function() {
            return P2 = "useTransition", Se(), ZE();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", Se(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", Se(), DE(a, s, C);
          },
          useId: function() {
            return P2 = "useId", Se(), zE();
          },
          unstable_isNewReconciler: X
        }, jO = {
          readContext: function(a) {
            return c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", $2(), HE(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", $2(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", $2(), bC(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", $2(), NE(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", $2(), PE(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", $2(), FE(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", $2();
            var C = i0.current;
            i0.current = Jn;
            try {
              return jE(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", $2();
            var p = i0.current;
            i0.current = Jn;
            try {
              return _E(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", $2(), RE(a);
          },
          useState: function(a) {
            P2 = "useState", $2();
            var s = i0.current;
            i0.current = Jn;
            try {
              return BC(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", $2(), void 0;
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", $2(), VE(a);
          },
          useTransition: function() {
            return P2 = "useTransition", $2(), ZE();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", $2(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", $2(), DE(a, s, C);
          },
          useId: function() {
            return P2 = "useId", $2(), zE();
          },
          unstable_isNewReconciler: X
        }, VO = {
          readContext: function(a) {
            return c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", $2(), OC(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", $2(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", $2(), el(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", $2(), MC(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", $2(), wC(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", $2(), SC(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", $2();
            var C = i0.current;
            i0.current = J4;
            try {
              return TC(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", $2();
            var p = i0.current;
            i0.current = J4;
            try {
              return OE(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", $2(), QC();
          },
          useState: function(a) {
            P2 = "useState", $2();
            var s = i0.current;
            i0.current = J4;
            try {
              return LE(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", $2(), _C();
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", $2(), _O(a);
          },
          useTransition: function() {
            return P2 = "useTransition", $2(), DO();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", $2(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", $2(), IC(a, s);
          },
          useId: function() {
            return P2 = "useId", $2(), DC();
          },
          unstable_isNewReconciler: X
        }, ZO = {
          readContext: function(a) {
            return c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", $2(), OC(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", $2(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", $2(), el(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", $2(), MC(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", $2(), wC(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", $2(), SC(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", $2();
            var C = i0.current;
            i0.current = kC;
            try {
              return TC(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", $2();
            var p = i0.current;
            i0.current = kC;
            try {
              return TE(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", $2(), QC();
          },
          useState: function(a) {
            P2 = "useState", $2();
            var s = i0.current;
            i0.current = kC;
            try {
              return kE(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", $2(), _C();
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", $2(), OO(a);
          },
          useTransition: function() {
            return P2 = "useTransition", $2(), LO();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", $2(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", $2(), IC(a, s);
          },
          useId: function() {
            return P2 = "useId", $2(), DC();
          },
          unstable_isNewReconciler: X
        }, Jn = {
          readContext: function(a) {
            return UE(), c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", F0(), Se(), HE(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", F0(), Se(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", F0(), Se(), bC(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", F0(), Se(), NE(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", F0(), Se(), PE(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", F0(), Se(), FE(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", F0(), Se();
            var C = i0.current;
            i0.current = Jn;
            try {
              return jE(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", F0(), Se();
            var p = i0.current;
            i0.current = Jn;
            try {
              return _E(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", F0(), Se(), RE(a);
          },
          useState: function(a) {
            P2 = "useState", F0(), Se();
            var s = i0.current;
            i0.current = Jn;
            try {
              return BC(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", F0(), Se(), void 0;
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", F0(), Se(), VE(a);
          },
          useTransition: function() {
            return P2 = "useTransition", F0(), Se(), ZE();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", F0(), Se(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", F0(), Se(), DE(a, s, C);
          },
          useId: function() {
            return P2 = "useId", F0(), Se(), zE();
          },
          unstable_isNewReconciler: X
        }, J4 = {
          readContext: function(a) {
            return UE(), c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", F0(), $2(), OC(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", F0(), $2(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", F0(), $2(), el(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", F0(), $2(), MC(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", F0(), $2(), wC(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", F0(), $2(), SC(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", F0(), $2();
            var C = i0.current;
            i0.current = J4;
            try {
              return TC(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", F0(), $2();
            var p = i0.current;
            i0.current = J4;
            try {
              return OE(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", F0(), $2(), QC();
          },
          useState: function(a) {
            P2 = "useState", F0(), $2();
            var s = i0.current;
            i0.current = J4;
            try {
              return LE(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", F0(), $2(), _C();
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", F0(), $2(), _O(a);
          },
          useTransition: function() {
            return P2 = "useTransition", F0(), $2(), DO();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", F0(), $2(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", F0(), $2(), IC(a, s);
          },
          useId: function() {
            return P2 = "useId", F0(), $2(), DC();
          },
          unstable_isNewReconciler: X
        }, kC = {
          readContext: function(a) {
            return UE(), c5(a);
          },
          useCallback: function(a, s) {
            return P2 = "useCallback", F0(), $2(), OC(a, s);
          },
          useContext: function(a) {
            return P2 = "useContext", F0(), $2(), c5(a);
          },
          useEffect: function(a, s) {
            return P2 = "useEffect", F0(), $2(), el(a, s);
          },
          useImperativeHandle: function(a, s, C) {
            return P2 = "useImperativeHandle", F0(), $2(), MC(a, s, C);
          },
          useInsertionEffect: function(a, s) {
            return P2 = "useInsertionEffect", F0(), $2(), wC(a, s);
          },
          useLayoutEffect: function(a, s) {
            return P2 = "useLayoutEffect", F0(), $2(), SC(a, s);
          },
          useMemo: function(a, s) {
            P2 = "useMemo", F0(), $2();
            var C = i0.current;
            i0.current = J4;
            try {
              return TC(a, s);
            } finally {
              i0.current = C;
            }
          },
          useReducer: function(a, s, C) {
            P2 = "useReducer", F0(), $2();
            var p = i0.current;
            i0.current = J4;
            try {
              return TE(a, s, C);
            } finally {
              i0.current = p;
            }
          },
          useRef: function(a) {
            return P2 = "useRef", F0(), $2(), QC();
          },
          useState: function(a) {
            P2 = "useState", F0(), $2();
            var s = i0.current;
            i0.current = J4;
            try {
              return kE(a);
            } finally {
              i0.current = s;
            }
          },
          useDebugValue: function(a, s) {
            return P2 = "useDebugValue", F0(), $2(), _C();
          },
          useDeferredValue: function(a) {
            return P2 = "useDeferredValue", F0(), $2(), OO(a);
          },
          useTransition: function() {
            return P2 = "useTransition", F0(), $2(), LO();
          },
          useMutableSource: function(a, s, C) {
            return P2 = "useMutableSource", F0(), $2(), void 0;
          },
          useSyncExternalStore: function(a, s, C) {
            return P2 = "useSyncExternalStore", F0(), $2(), IC(a, s);
          },
          useId: function() {
            return P2 = "useId", F0(), $2(), DC();
          },
          unstable_isNewReconciler: X
        };
      }
      var I6 = t.unstable_now, zO = 0, RC = -1, tl = -1, PC = -1, qE = !1, FC = !1;
      function UO() {
        return qE;
      }
      function xJ() {
        FC = !0;
      }
      function bJ() {
        qE = !1, FC = !1;
      }
      function wJ() {
        qE = FC, FC = !1;
      }
      function qO() {
        return zO;
      }
      function WO() {
        zO = I6();
      }
      function WE(a) {
        tl = I6(), a.actualStartTime < 0 && (a.actualStartTime = I6());
      }
      function YO(a) {
        tl = -1;
      }
      function NC(a, s) {
        if (tl >= 0) {
          var C = I6() - tl;
          a.actualDuration += C, s && (a.selfBaseDuration = C), tl = -1;
        }
      }
      function e3(a) {
        if (RC >= 0) {
          var s = I6() - RC;
          RC = -1;
          for (var C = a.return; C !== null; ) {
            switch (C.tag) {
              case h:
                var p = C.stateNode;
                p.effectDuration += s;
                return;
              case O:
                var m = C.stateNode;
                m.effectDuration += s;
                return;
            }
            C = C.return;
          }
        }
      }
      function YE(a) {
        if (PC >= 0) {
          var s = I6() - PC;
          PC = -1;
          for (var C = a.return; C !== null; ) {
            switch (C.tag) {
              case h:
                var p = C.stateNode;
                p !== null && (p.passiveEffectDuration += s);
                return;
              case O:
                var m = C.stateNode;
                m !== null && (m.passiveEffectDuration += s);
                return;
            }
            C = C.return;
          }
        }
      }
      function t3() {
        RC = I6();
      }
      function $E() {
        PC = I6();
      }
      function GE(a) {
        for (var s = a.child; s; )
          a.actualDuration += s.actualDuration, s = s.sibling;
      }
      function en(a, s) {
        if (a && a.defaultProps) {
          var C = z0({}, s), p = a.defaultProps;
          for (var m in p)
            C[m] === void 0 && (C[m] = p[m]);
          return C;
        }
        return s;
      }
      var KE = {}, XE, JE, em, tm, rm, $O, HC, nm, im, am, rl;
      {
        XE = /* @__PURE__ */ new Set(), JE = /* @__PURE__ */ new Set(), em = /* @__PURE__ */ new Set(), tm = /* @__PURE__ */ new Set(), nm = /* @__PURE__ */ new Set(), rm = /* @__PURE__ */ new Set(), im = /* @__PURE__ */ new Set(), am = /* @__PURE__ */ new Set(), rl = /* @__PURE__ */ new Set();
        var GO = /* @__PURE__ */ new Set();
        HC = function(a, s) {
          if (!(a === null || typeof a == "function")) {
            var C = s + "_" + a;
            GO.has(C) || (GO.add(C), u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", s, a));
          }
        }, $O = function(a, s) {
          if (s === void 0) {
            var C = ue(a) || "Component";
            rm.has(C) || (rm.add(C), u("%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.", C));
          }
        }, Object.defineProperty(KE, "_processChildContext", {
          enumerable: !1,
          value: function() {
            throw new Error("_processChildContext is not available in React 16+. This likely means you have multiple copies of React and are attempting to nest a React 15 tree inside a React 16 tree using unstable_renderSubtreeIntoContainer, which isn't supported. Try to make sure you have only one copy of React (and ideally, switch to ReactDOM.createPortal).");
          }
        }), Object.freeze(KE);
      }
      function om(a, s, C, p) {
        var m = a.memoizedState, b = C(p, m);
        {
          if (a.mode & He) {
            ht(!0);
            try {
              b = C(p, m);
            } finally {
              ht(!1);
            }
          }
          $O(s, b);
        }
        var L = b == null ? m : z0({}, m, b);
        if (a.memoizedState = L, a.lanes === H2) {
          var P = a.updateQueue;
          P.baseState = L;
        }
      }
      var sm = {
        isMounted: qA,
        enqueueSetState: function(a, s, C) {
          var p = K8(a), m = U1(), b = b6(p), L = r8(m, b);
          L.payload = s, C != null && (HC(C, "setState"), L.callback = C);
          var P = v6(p, L, b);
          P !== null && (M5(P, p, b, m), gC(P, p, b)), w7(p, b);
        },
        enqueueReplaceState: function(a, s, C) {
          var p = K8(a), m = U1(), b = b6(p), L = r8(m, b);
          L.tag = CO, L.payload = s, C != null && (HC(C, "replaceState"), L.callback = C);
          var P = v6(p, L, b);
          P !== null && (M5(P, p, b, m), gC(P, p, b)), w7(p, b);
        },
        enqueueForceUpdate: function(a, s) {
          var C = K8(a), p = U1(), m = b6(C), b = r8(p, m);
          b.tag = fC, s != null && (HC(s, "forceUpdate"), b.callback = s);
          var L = v6(C, b, m);
          L !== null && (M5(L, C, m, p), gC(L, C, m)), Oa(C, m);
        }
      };
      function KO(a, s, C, p, m, b, L) {
        var P = a.stateNode;
        if (typeof P.shouldComponentUpdate == "function") {
          var N = P.shouldComponentUpdate(p, b, L);
          {
            if (a.mode & He) {
              ht(!0);
              try {
                N = P.shouldComponentUpdate(p, b, L);
              } finally {
                ht(!1);
              }
            }
            N === void 0 && u("%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.", ue(s) || "Component");
          }
          return N;
        }
        return s.prototype && s.prototype.isPureReactComponent ? !C0(C, p) || !C0(m, b) : !0;
      }
      function SJ(a, s, C) {
        var p = a.stateNode;
        {
          var m = ue(s) || "Component", b = p.render;
          b || (s.prototype && typeof s.prototype.render == "function" ? u("%s(...): No `render` method found on the returned component instance: did you accidentally return an object from the constructor?", m) : u("%s(...): No `render` method found on the returned component instance: you may have forgotten to define `render`.", m)), p.getInitialState && !p.getInitialState.isReactClassApproved && !p.state && u("getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?", m), p.getDefaultProps && !p.getDefaultProps.isReactClassApproved && u("getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.", m), p.propTypes && u("propTypes was defined as an instance property on %s. Use a static property to define propTypes instead.", m), p.contextType && u("contextType was defined as an instance property on %s. Use a static property to define contextType instead.", m), s.childContextTypes && !rl.has(s) && // Strict Mode has its own warning for legacy context, so we can skip
          // this one.
          (a.mode & He) === B0 && (rl.add(s), u(`%s uses the legacy childContextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() instead

.Learn more about this warning here: https://reactjs.org/link/legacy-context`, m)), s.contextTypes && !rl.has(s) && // Strict Mode has its own warning for legacy context, so we can skip
          // this one.
          (a.mode & He) === B0 && (rl.add(s), u(`%s uses the legacy contextTypes API which is no longer supported and will be removed in the next major release. Use React.createContext() with static contextType instead.

Learn more about this warning here: https://reactjs.org/link/legacy-context`, m)), p.contextTypes && u("contextTypes was defined as an instance property on %s. Use a static property to define contextTypes instead.", m), s.contextType && s.contextTypes && !im.has(s) && (im.add(s), u("%s declares both contextTypes and contextType static properties. The legacy contextTypes property will be ignored.", m)), typeof p.componentShouldUpdate == "function" && u("%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.", m), s.prototype && s.prototype.isPureReactComponent && typeof p.shouldComponentUpdate < "u" && u("%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.", ue(s) || "A pure component"), typeof p.componentDidUnmount == "function" && u("%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?", m), typeof p.componentDidReceiveProps == "function" && u("%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().", m), typeof p.componentWillRecieveProps == "function" && u("%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?", m), typeof p.UNSAFE_componentWillRecieveProps == "function" && u("%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?", m);
          var L = p.props !== C;
          p.props !== void 0 && L && u("%s(...): When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.", m, m), p.defaultProps && u("Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.", m, m), typeof p.getSnapshotBeforeUpdate == "function" && typeof p.componentDidUpdate != "function" && !em.has(s) && (em.add(s), u("%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.", ue(s))), typeof p.getDerivedStateFromProps == "function" && u("%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.", m), typeof p.getDerivedStateFromError == "function" && u("%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.", m), typeof s.getSnapshotBeforeUpdate == "function" && u("%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.", m);
          var P = p.state;
          P && (typeof P != "object" || q0(P)) && u("%s.state: must be set to an object or null", m), typeof p.getChildContext == "function" && typeof s.childContextTypes != "object" && u("%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().", m);
        }
      }
      function XO(a, s) {
        s.updater = sm, a.stateNode = s, _3(s, a), s._reactInternalInstance = KE;
      }
      function JO(a, s, C) {
        var p = !1, m = Fr, b = Fr, L = s.contextType;
        if ("contextType" in s) {
          var P = (
            // Allow null for conditional declaration
            L === null || L !== void 0 && L.$$typeof === c2 && L._context === void 0
          );
          if (!P && !am.has(s)) {
            am.add(s);
            var N = "";
            L === void 0 ? N = " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : typeof L != "object" ? N = " However, it is set to a " + typeof L + "." : L.$$typeof === Xr ? N = " Did you accidentally pass the Context.Provider instead?" : L._context !== void 0 ? N = " Did you accidentally pass the Context.Consumer instead?" : N = " However, it is set to an object with keys {" + Object.keys(L).join(", ") + "}.", u("%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s", ue(s) || "Component", N);
          }
        }
        if (typeof L == "object" && L !== null)
          b = c5(L);
        else {
          m = yo(a, s, !0);
          var G = s.contextTypes;
          p = G != null, b = p ? Io(a, m) : Fr;
        }
        var J = new s(C, b);
        if (a.mode & He) {
          ht(!0);
          try {
            J = new s(C, b);
          } finally {
            ht(!1);
          }
        }
        var h2 = a.memoizedState = J.state !== null && J.state !== void 0 ? J.state : null;
        XO(a, J);
        {
          if (typeof s.getDerivedStateFromProps == "function" && h2 === null) {
            var g2 = ue(s) || "Component";
            JE.has(g2) || (JE.add(g2), u("`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.", g2, J.state === null ? "null" : "undefined", g2));
          }
          if (typeof s.getDerivedStateFromProps == "function" || typeof J.getSnapshotBeforeUpdate == "function") {
            var B2 = null, b2 = null, T2 = null;
            if (typeof J.componentWillMount == "function" && J.componentWillMount.__suppressDeprecationWarning !== !0 ? B2 = "componentWillMount" : typeof J.UNSAFE_componentWillMount == "function" && (B2 = "UNSAFE_componentWillMount"), typeof J.componentWillReceiveProps == "function" && J.componentWillReceiveProps.__suppressDeprecationWarning !== !0 ? b2 = "componentWillReceiveProps" : typeof J.UNSAFE_componentWillReceiveProps == "function" && (b2 = "UNSAFE_componentWillReceiveProps"), typeof J.componentWillUpdate == "function" && J.componentWillUpdate.__suppressDeprecationWarning !== !0 ? T2 = "componentWillUpdate" : typeof J.UNSAFE_componentWillUpdate == "function" && (T2 = "UNSAFE_componentWillUpdate"), B2 !== null || b2 !== null || T2 !== null) {
              var t0 = ue(s) || "Component", x0 = typeof s.getDerivedStateFromProps == "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
              tm.has(t0) || (tm.add(t0), u(`Unsafe legacy lifecycles will not be called for components using new component APIs.

%s uses %s but also contains the following legacy lifecycles:%s%s%s

The above lifecycles should be removed. Learn more about this warning here:
https://reactjs.org/link/unsafe-component-lifecycles`, t0, x0, B2 !== null ? `
  ` + B2 : "", b2 !== null ? `
  ` + b2 : "", T2 !== null ? `
  ` + T2 : ""));
            }
          }
        }
        return p && V_(a, m, b), J;
      }
      function MJ(a, s) {
        var C = s.state;
        typeof s.componentWillMount == "function" && s.componentWillMount(), typeof s.UNSAFE_componentWillMount == "function" && s.UNSAFE_componentWillMount(), C !== s.state && (u("%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", R0(a) || "Component"), sm.enqueueReplaceState(s, s.state, null));
      }
      function eT(a, s, C, p) {
        var m = s.state;
        if (typeof s.componentWillReceiveProps == "function" && s.componentWillReceiveProps(C, p), typeof s.UNSAFE_componentWillReceiveProps == "function" && s.UNSAFE_componentWillReceiveProps(C, p), s.state !== m) {
          {
            var b = R0(a) || "Component";
            XE.has(b) || (XE.add(b), u("%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.", b));
          }
          sm.enqueueReplaceState(s, s.state, null);
        }
      }
      function um(a, s, C, p) {
        SJ(a, s, C);
        var m = a.stateNode;
        m.props = C, m.state = a.memoizedState, m.refs = {}, hE(a);
        var b = s.contextType;
        if (typeof b == "object" && b !== null)
          m.context = c5(b);
        else {
          var L = yo(a, s, !0);
          m.context = Io(a, L);
        }
        {
          if (m.state === C) {
            var P = ue(s) || "Component";
            nm.has(P) || (nm.add(P), u("%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.", P));
          }
          a.mode & He && K4.recordLegacyContextWarning(a, m), K4.recordUnsafeLifecycleWarnings(a, m);
        }
        m.state = a.memoizedState;
        var N = s.getDerivedStateFromProps;
        if (typeof N == "function" && (om(a, s, N, C), m.state = a.memoizedState), typeof s.getDerivedStateFromProps != "function" && typeof m.getSnapshotBeforeUpdate != "function" && (typeof m.UNSAFE_componentWillMount == "function" || typeof m.componentWillMount == "function") && (MJ(a, m), pC(a, C, m, p), m.state = a.memoizedState), typeof m.componentDidMount == "function") {
          var G = ie;
          G |= H4, (a.mode & me) !== B0 && (G |= Dn), a.flags |= G;
        }
      }
      function _J(a, s, C, p) {
        var m = a.stateNode, b = a.memoizedProps;
        m.props = b;
        var L = m.context, P = s.contextType, N = Fr;
        if (typeof P == "object" && P !== null)
          N = c5(P);
        else {
          var G = yo(a, s, !0);
          N = Io(a, G);
        }
        var J = s.getDerivedStateFromProps, h2 = typeof J == "function" || typeof m.getSnapshotBeforeUpdate == "function";
        !h2 && (typeof m.UNSAFE_componentWillReceiveProps == "function" || typeof m.componentWillReceiveProps == "function") && (b !== C || L !== N) && eT(a, m, C, N), gO();
        var g2 = a.memoizedState, B2 = m.state = g2;
        if (pC(a, C, m, p), B2 = a.memoizedState, b === C && g2 === B2 && !Kf() && !hC()) {
          if (typeof m.componentDidMount == "function") {
            var b2 = ie;
            b2 |= H4, (a.mode & me) !== B0 && (b2 |= Dn), a.flags |= b2;
          }
          return !1;
        }
        typeof J == "function" && (om(a, s, J, C), B2 = a.memoizedState);
        var T2 = hC() || KO(a, s, b, C, g2, B2, N);
        if (T2) {
          if (!h2 && (typeof m.UNSAFE_componentWillMount == "function" || typeof m.componentWillMount == "function") && (typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount()), typeof m.componentDidMount == "function") {
            var t0 = ie;
            t0 |= H4, (a.mode & me) !== B0 && (t0 |= Dn), a.flags |= t0;
          }
        } else {
          if (typeof m.componentDidMount == "function") {
            var x0 = ie;
            x0 |= H4, (a.mode & me) !== B0 && (x0 |= Dn), a.flags |= x0;
          }
          a.memoizedProps = C, a.memoizedState = B2;
        }
        return m.props = C, m.state = B2, m.context = N, T2;
      }
      function OJ(a, s, C, p, m) {
        var b = s.stateNode;
        dO(a, s);
        var L = s.memoizedProps, P = s.type === s.elementType ? L : en(s.type, L);
        b.props = P;
        var N = s.pendingProps, G = b.context, J = C.contextType, h2 = Fr;
        if (typeof J == "object" && J !== null)
          h2 = c5(J);
        else {
          var g2 = yo(s, C, !0);
          h2 = Io(s, g2);
        }
        var B2 = C.getDerivedStateFromProps, b2 = typeof B2 == "function" || typeof b.getSnapshotBeforeUpdate == "function";
        !b2 && (typeof b.UNSAFE_componentWillReceiveProps == "function" || typeof b.componentWillReceiveProps == "function") && (L !== N || G !== h2) && eT(s, b, p, h2), gO();
        var T2 = s.memoizedState, t0 = b.state = T2;
        if (pC(s, p, b, m), t0 = s.memoizedState, L === N && T2 === t0 && !Kf() && !hC())
          return typeof b.componentDidUpdate == "function" && (L !== a.memoizedProps || T2 !== a.memoizedState) && (s.flags |= ie), typeof b.getSnapshotBeforeUpdate == "function" && (L !== a.memoizedProps || T2 !== a.memoizedState) && (s.flags |= Jt), !1;
        typeof B2 == "function" && (om(s, C, B2, p), t0 = s.memoizedState);
        var x0 = hC() || KO(s, C, P, p, T2, t0, h2) || // TODO: In some cases, we'll end up checking if context has changed twice,
        // both before and after `shouldComponentUpdate` has been called. Not ideal,
        // but I'm loath to refactor this function. This only happens for memoized
        // components so it's not that common.
        a2;
        return x0 ? (!b2 && (typeof b.UNSAFE_componentWillUpdate == "function" || typeof b.componentWillUpdate == "function") && (typeof b.componentWillUpdate == "function" && b.componentWillUpdate(p, t0, h2), typeof b.UNSAFE_componentWillUpdate == "function" && b.UNSAFE_componentWillUpdate(p, t0, h2)), typeof b.componentDidUpdate == "function" && (s.flags |= ie), typeof b.getSnapshotBeforeUpdate == "function" && (s.flags |= Jt)) : (typeof b.componentDidUpdate == "function" && (L !== a.memoizedProps || T2 !== a.memoizedState) && (s.flags |= ie), typeof b.getSnapshotBeforeUpdate == "function" && (L !== a.memoizedProps || T2 !== a.memoizedState) && (s.flags |= Jt), s.memoizedProps = p, s.memoizedState = t0), b.props = p, b.state = t0, b.context = h2, x0;
      }
      function fi(a, s) {
        return {
          value: a,
          source: s,
          stack: L4(s),
          digest: null
        };
      }
      function lm(a, s, C) {
        return {
          value: a,
          source: null,
          stack: C ?? null,
          digest: s ?? null
        };
      }
      function TJ(a, s) {
        return !0;
      }
      function cm(a, s) {
        try {
          var C = TJ(a, s);
          if (C === !1)
            return;
          var p = s.value, m = s.source, b = s.stack, L = b !== null ? b : "";
          if (p != null && p._suppressLogging) {
            if (a.tag === d)
              return;
            console.error(p);
          }
          var P = m ? R0(m) : null, N = P ? "The above error occurred in the <" + P + "> component:" : "The above error occurred in one of your React components:", G;
          if (a.tag === h)
            G = `Consider adding an error boundary to your tree to customize error handling behavior.
Visit https://reactjs.org/link/error-boundaries to learn more about error boundaries.`;
          else {
            var J = R0(a) || "Anonymous";
            G = "React will try to recreate this component tree from scratch " + ("using the error boundary you provided, " + J + ".");
          }
          var h2 = N + `
` + L + `

` + ("" + G);
          console.error(h2);
        } catch (g2) {
          setTimeout(function() {
            throw g2;
          });
        }
      }
      var DJ = typeof WeakMap == "function" ? WeakMap : Map;
      function tT(a, s, C) {
        var p = r8(Xe, C);
        p.tag = gE, p.payload = {
          element: null
        };
        var m = s.value;
        return p.callback = function() {
          x02(m), cm(a, s);
        }, p;
      }
      function Am(a, s, C) {
        var p = r8(Xe, C);
        p.tag = gE;
        var m = a.type.getDerivedStateFromError;
        if (typeof m == "function") {
          var b = s.value;
          p.payload = function() {
            return m(b);
          }, p.callback = function() {
            fD(a), cm(a, s);
          };
        }
        var L = a.stateNode;
        return L !== null && typeof L.componentDidCatch == "function" && (p.callback = function() {
          fD(a), cm(a, s), typeof m != "function" && B02(this);
          var N = s.value, G = s.stack;
          this.componentDidCatch(N, {
            componentStack: G !== null ? G : ""
          }), typeof m != "function" && (m1(a.lanes, O0) || u("%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.", R0(a) || "Unknown"));
        }), p;
      }
      function rT(a, s, C) {
        var p = a.pingCache, m;
        if (p === null ? (p = a.pingCache = new DJ(), m = /* @__PURE__ */ new Set(), p.set(s, m)) : (m = p.get(s), m === void 0 && (m = /* @__PURE__ */ new Set(), p.set(s, m))), !m.has(C)) {
          m.add(C);
          var b = b02.bind(null, a, s, C);
          E1 && El(a, C), s.then(b, b);
        }
      }
      function LJ(a, s, C, p) {
        var m = a.updateQueue;
        if (m === null) {
          var b = /* @__PURE__ */ new Set();
          b.add(C), a.updateQueue = b;
        } else
          m.add(C);
      }
      function kJ(a, s) {
        var C = a.tag;
        if ((a.mode & Y0) === B0 && (C === f || C === S || C === k)) {
          var p = a.alternate;
          p ? (a.updateQueue = p.updateQueue, a.memoizedState = p.memoizedState, a.lanes = p.lanes) : (a.updateQueue = null, a.memoizedState = null);
        }
      }
      function nT(a) {
        var s = a;
        do {
          if (s.tag === w && gJ(s))
            return s;
          s = s.return;
        } while (s !== null);
        return null;
      }
      function iT(a, s, C, p, m) {
        if ((a.mode & Y0) === B0) {
          if (a === s)
            a.flags |= p1;
          else {
            if (a.flags |= y0, C.flags |= Ba, C.flags &= -52805, C.tag === d) {
              var b = C.alternate;
              if (b === null)
                C.tag = z;
              else {
                var L = r8(Xe, O0);
                L.tag = fC, v6(C, L, O0);
              }
            }
            C.lanes = V0(C.lanes, O0);
          }
          return a;
        }
        return a.flags |= p1, a.lanes = m, a;
      }
      function RJ(a, s, C, p, m) {
        if (C.flags |= y7, E1 && El(a, m), p !== null && typeof p == "object" && typeof p.then == "function") {
          var b = p;
          kJ(C), X5() && C.mode & Y0 && $_();
          var L = nT(s);
          if (L !== null) {
            L.flags &= -257, iT(L, s, C, a, m), L.mode & Y0 && rT(a, b, m), LJ(L, a, b);
            return;
          } else {
            if (!ef(m)) {
              rT(a, b, m), zm();
              return;
            }
            var P = new Error("A component suspended while responding to synchronous input. This will cause the UI to be replaced with a loading indicator. To fix, updates that suspend should be wrapped with startTransition.");
            p = P;
          }
        } else if (X5() && C.mode & Y0) {
          $_();
          var N = nT(s);
          if (N !== null) {
            (N.flags & p1) === I0 && (N.flags |= d1), iT(N, s, C, a, m), nE(fi(p, C));
            return;
          }
        }
        p = fi(p, C), g02(p);
        var G = s;
        do {
          switch (G.tag) {
            case h: {
              var J = p;
              G.flags |= p1;
              var h2 = R7(m);
              G.lanes = V0(G.lanes, h2);
              var g2 = tT(G, J, h2);
              vE(G, g2);
              return;
            }
            case d:
              var B2 = p, b2 = G.type, T2 = G.stateNode;
              if ((G.flags & y0) === I0 && (typeof b2.getDerivedStateFromError == "function" || T2 !== null && typeof T2.componentDidCatch == "function" && !nD(T2))) {
                G.flags |= p1;
                var t0 = R7(m);
                G.lanes = V0(G.lanes, t0);
                var x0 = Am(G, B2, t0);
                vE(G, x0);
                return;
              }
              break;
          }
          G = G.return;
        } while (G !== null);
      }
      function PJ() {
        return null;
      }
      var nl = r.ReactCurrentOwner, tn = !1, fm, il, Cm, dm, gm, Ci, pm, jC, al;
      fm = {}, il = {}, Cm = {}, dm = {}, gm = {}, Ci = !1, pm = {}, jC = {}, al = {};
      function Z1(a, s, C, p) {
        a === null ? s.child = sO(s, null, C, p) : s.child = bo(s, a.child, C, p);
      }
      function FJ(a, s, C, p) {
        s.child = bo(s, a.child, null, p), s.child = bo(s, null, C, p);
      }
      function aT(a, s, C, p, m) {
        if (s.type !== s.elementType) {
          var b = C.propTypes;
          b && $4(
            b,
            p,
            // Resolved props
            "prop",
            ue(C)
          );
        }
        var L = C.render, P = s.ref, N, G;
        So(s, m), F1(s);
        {
          if (nl.current = s, Xt(!0), N = Lo(a, s, L, p, P, m), G = ko(), s.mode & He) {
            ht(!0);
            try {
              N = Lo(a, s, L, p, P, m), G = ko();
            } finally {
              ht(!1);
            }
          }
          Xt(!1);
        }
        return N1(), a !== null && !tn ? (yO(a, s, m), n8(a, s, m)) : (X5() && G && Kv(s), s.flags |= Tr, Z1(a, s, N, m), s.child);
      }
      function oT(a, s, C, p, m) {
        if (a === null) {
          var b = C.type;
          if (Z02(b) && C.compare === null && // SimpleMemoComponent codepath doesn't resolve outer props either.
          C.defaultProps === void 0) {
            var L = b;
            return L = Zo(b), s.tag = k, s.type = L, Em(s, b), sT(a, s, L, p, m);
          }
          {
            var P = b.propTypes;
            if (P && $4(
              P,
              p,
              // Resolved props
              "prop",
              ue(b)
            ), C.defaultProps !== void 0) {
              var N = ue(b) || "Unknown";
              al[N] || (u("%s: Support for defaultProps will be removed from memo components in a future major release. Use JavaScript default parameters instead.", N), al[N] = !0);
            }
          }
          var G = ty(C.type, null, p, s, s.mode, m);
          return G.ref = s.ref, G.return = s, s.child = G, G;
        }
        {
          var J = C.type, h2 = J.propTypes;
          h2 && $4(
            h2,
            p,
            // Resolved props
            "prop",
            ue(J)
          );
        }
        var g2 = a.child, B2 = xm(a, m);
        if (!B2) {
          var b2 = g2.memoizedProps, T2 = C.compare;
          if (T2 = T2 !== null ? T2 : C0, T2(b2, p) && a.ref === s.ref)
            return n8(a, s, m);
        }
        s.flags |= Tr;
        var t0 = vi(g2, p);
        return t0.ref = s.ref, t0.return = s, s.child = t0, t0;
      }
      function sT(a, s, C, p, m) {
        if (s.type !== s.elementType) {
          var b = s.elementType;
          if (b.$$typeof === P0) {
            var L = b, P = L._payload, N = L._init;
            try {
              b = N(P);
            } catch {
              b = null;
            }
            var G = b && b.propTypes;
            G && $4(
              G,
              p,
              // Resolved (SimpleMemoComponent has no defaultProps)
              "prop",
              ue(b)
            );
          }
        }
        if (a !== null) {
          var J = a.memoizedProps;
          if (C0(J, p) && a.ref === s.ref && // Prevent bailout if the implementation changed due to hot reload.
          s.type === a.type)
            if (tn = !1, s.pendingProps = p = J, xm(a, m))
              (a.flags & Ba) !== I0 && (tn = !0);
            else return s.lanes = a.lanes, n8(a, s, m);
        }
        return hm(a, s, C, p, m);
      }
      function uT(a, s, C) {
        var p = s.pendingProps, m = p.children, b = a !== null ? a.memoizedState : null;
        if (p.mode === "hidden" || e2)
          if ((s.mode & Y0) === B0) {
            var L = {
              baseLanes: H2,
              cachePool: null,
              transitions: null
            };
            s.memoizedState = L, ed(s, C);
          } else if (m1(C, H1)) {
            var h2 = {
              baseLanes: H2,
              cachePool: null,
              transitions: null
            };
            s.memoizedState = h2;
            var g2 = b !== null ? b.baseLanes : C;
            ed(s, g2);
          } else {
            var P = null, N;
            if (b !== null) {
              var G = b.baseLanes;
              N = V0(G, C);
            } else
              N = C;
            s.lanes = s.childLanes = H1;
            var J = {
              baseLanes: N,
              cachePool: P,
              transitions: null
            };
            return s.memoizedState = J, s.updateQueue = null, ed(s, N), null;
          }
        else {
          var B2;
          b !== null ? (B2 = V0(b.baseLanes, C), s.memoizedState = null) : B2 = C, ed(s, B2);
        }
        return Z1(a, s, m, C), s.child;
      }
      function NJ(a, s, C) {
        var p = s.pendingProps;
        return Z1(a, s, p, C), s.child;
      }
      function HJ(a, s, C) {
        var p = s.pendingProps.children;
        return Z1(a, s, p, C), s.child;
      }
      function jJ(a, s, C) {
        {
          s.flags |= ie;
          {
            var p = s.stateNode;
            p.effectDuration = 0, p.passiveEffectDuration = 0;
          }
        }
        var m = s.pendingProps, b = m.children;
        return Z1(a, s, b, C), s.child;
      }
      function lT(a, s) {
        var C = s.ref;
        (a === null && C !== null || a !== null && a.ref !== C) && (s.flags |= It, s.flags |= J8);
      }
      function hm(a, s, C, p, m) {
        if (s.type !== s.elementType) {
          var b = C.propTypes;
          b && $4(
            b,
            p,
            // Resolved props
            "prop",
            ue(C)
          );
        }
        var L;
        {
          var P = yo(s, C, !0);
          L = Io(s, P);
        }
        var N, G;
        So(s, m), F1(s);
        {
          if (nl.current = s, Xt(!0), N = Lo(a, s, C, p, L, m), G = ko(), s.mode & He) {
            ht(!0);
            try {
              N = Lo(a, s, C, p, L, m), G = ko();
            } finally {
              ht(!1);
            }
          }
          Xt(!1);
        }
        return N1(), a !== null && !tn ? (yO(a, s, m), n8(a, s, m)) : (X5() && G && Kv(s), s.flags |= Tr, Z1(a, s, N, m), s.child);
      }
      function cT(a, s, C, p, m) {
        {
          switch (ie2(s)) {
            case !1: {
              var b = s.stateNode, L = s.type, P = new L(s.memoizedProps, b.context), N = P.state;
              b.updater.enqueueSetState(b, N, null);
              break;
            }
            case !0: {
              s.flags |= y0, s.flags |= p1;
              var G = new Error("Simulated error coming from DevTools"), J = R7(m);
              s.lanes = V0(s.lanes, J);
              var h2 = Am(s, fi(G, s), J);
              vE(s, h2);
              break;
            }
          }
          if (s.type !== s.elementType) {
            var g2 = C.propTypes;
            g2 && $4(
              g2,
              p,
              // Resolved props
              "prop",
              ue(C)
            );
          }
        }
        var B2;
        Gn(C) ? (B2 = !0, Jf(s)) : B2 = !1, So(s, m);
        var b2 = s.stateNode, T2;
        b2 === null ? (ZC(a, s), JO(s, C, p), um(s, C, p, m), T2 = !0) : a === null ? T2 = _J(s, C, p, m) : T2 = OJ(a, s, C, p, m);
        var t0 = vm(a, s, C, T2, B2, m);
        {
          var x0 = s.stateNode;
          T2 && x0.props !== p && (Ci || u("It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.", R0(s) || "a component"), Ci = !0);
        }
        return t0;
      }
      function vm(a, s, C, p, m, b) {
        lT(a, s);
        var L = (s.flags & y0) !== I0;
        if (!p && !L)
          return m && U_(s, C, !1), n8(a, s, b);
        var P = s.stateNode;
        nl.current = s;
        var N;
        if (L && typeof C.getDerivedStateFromError != "function")
          N = null, YO();
        else {
          F1(s);
          {
            if (Xt(!0), N = P.render(), s.mode & He) {
              ht(!0);
              try {
                P.render();
              } finally {
                ht(!1);
              }
            }
            Xt(!1);
          }
          N1();
        }
        return s.flags |= Tr, a !== null && L ? FJ(a, s, N, b) : Z1(a, s, N, b), s.memoizedState = P.state, m && U_(s, C, !0), s.child;
      }
      function AT(a) {
        var s = a.stateNode;
        s.pendingContext ? Z_(a, s.pendingContext, s.pendingContext !== s.context) : s.context && Z_(a, s.context, !1), EE(a, s.containerInfo);
      }
      function VJ(a, s, C) {
        if (AT(s), a === null)
          throw new Error("Should have a current fiber. This is a bug in React.");
        var p = s.pendingProps, m = s.memoizedState, b = m.element;
        dO(a, s), pC(s, p, null, C);
        var L = s.memoizedState;
        s.stateNode;
        var P = L.element;
        if (m.isDehydrated) {
          var N = {
            element: P,
            isDehydrated: !1,
            cache: L.cache,
            pendingSuspenseBoundaries: L.pendingSuspenseBoundaries,
            transitions: L.transitions
          }, G = s.updateQueue;
          if (G.baseState = N, s.memoizedState = N, s.flags & d1) {
            var J = fi(new Error("There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering."), s);
            return fT(a, s, P, C, J);
          } else if (P !== b) {
            var h2 = fi(new Error("This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."), s);
            return fT(a, s, P, C, h2);
          } else {
            UX(s);
            var g2 = sO(s, null, P, C);
            s.child = g2;
            for (var B2 = g2; B2; )
              B2.flags = B2.flags & -3 | ir, B2 = B2.sibling;
          }
        } else {
          if (xo(), P === b)
            return n8(a, s, C);
          Z1(a, s, P, C);
        }
        return s.child;
      }
      function fT(a, s, C, p, m) {
        return xo(), nE(m), s.flags |= d1, Z1(a, s, C, p), s.child;
      }
      function ZJ(a, s, C) {
        vO(s), a === null && rE(s);
        var p = s.type, m = s.pendingProps, b = a !== null ? a.memoizedProps : null, L = m.children, P = Pv(p, m);
        return P ? L = null : b !== null && Pv(p, b) && (s.flags |= Dr), lT(a, s), Z1(a, s, L, C), s.child;
      }
      function zJ(a, s) {
        return a === null && rE(s), null;
      }
      function UJ(a, s, C, p) {
        ZC(a, s);
        var m = s.pendingProps, b = C, L = b._payload, P = b._init, N = P(L);
        s.type = N;
        var G = s.tag = z02(N), J = en(N, m), h2;
        switch (G) {
          case f:
            return Em(s, N), s.type = N = Zo(N), h2 = hm(null, s, N, J, p), h2;
          case d:
            return s.type = N = $m(N), h2 = cT(null, s, N, J, p), h2;
          case S:
            return s.type = N = Gm(N), h2 = aT(null, s, N, J, p), h2;
          case D: {
            if (s.type !== s.elementType) {
              var g2 = N.propTypes;
              g2 && $4(
                g2,
                J,
                // Resolved for outer only
                "prop",
                ue(N)
              );
            }
            return h2 = oT(
              null,
              s,
              N,
              en(N.type, J),
              // The inner type can have defaults too
              p
            ), h2;
          }
        }
        var B2 = "";
        throw N !== null && typeof N == "object" && N.$$typeof === P0 && (B2 = " Did you wrap a component in React.lazy() more than once?"), new Error("Element type is invalid. Received a promise that resolves to: " + N + ". " + ("Lazy element type must resolve to a class or function." + B2));
      }
      function qJ(a, s, C, p, m) {
        ZC(a, s), s.tag = d;
        var b;
        return Gn(C) ? (b = !0, Jf(s)) : b = !1, So(s, m), JO(s, C, p), um(s, C, p, m), vm(null, s, C, !0, b, m);
      }
      function WJ(a, s, C, p) {
        ZC(a, s);
        var m = s.pendingProps, b;
        {
          var L = yo(s, C, !1);
          b = Io(s, L);
        }
        So(s, p);
        var P, N;
        F1(s);
        {
          if (C.prototype && typeof C.prototype.render == "function") {
            var G = ue(C) || "Unknown";
            fm[G] || (u("The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.", G, G), fm[G] = !0);
          }
          s.mode & He && K4.recordLegacyContextWarning(s, null), Xt(!0), nl.current = s, P = Lo(null, s, C, m, b, p), N = ko(), Xt(!1);
        }
        if (N1(), s.flags |= Tr, typeof P == "object" && P !== null && typeof P.render == "function" && P.$$typeof === void 0) {
          var J = ue(C) || "Unknown";
          il[J] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", J, J, J), il[J] = !0);
        }
        if (
          // Run these checks in production only if the flag is off.
          // Eventually we'll delete this branch altogether.
          typeof P == "object" && P !== null && typeof P.render == "function" && P.$$typeof === void 0
        ) {
          {
            var h2 = ue(C) || "Unknown";
            il[h2] || (u("The <%s /> component appears to be a function component that returns a class instance. Change %s to a class that extends React.Component instead. If you can't use a class try assigning the prototype on the function as a workaround. `%s.prototype = React.Component.prototype`. Don't use an arrow function since it cannot be called with `new` by React.", h2, h2, h2), il[h2] = !0);
          }
          s.tag = d, s.memoizedState = null, s.updateQueue = null;
          var g2 = !1;
          return Gn(C) ? (g2 = !0, Jf(s)) : g2 = !1, s.memoizedState = P.state !== null && P.state !== void 0 ? P.state : null, hE(s), XO(s, P), um(s, C, m, p), vm(null, s, C, !0, g2, p);
        } else {
          if (s.tag = f, s.mode & He) {
            ht(!0);
            try {
              P = Lo(null, s, C, m, b, p), N = ko();
            } finally {
              ht(!1);
            }
          }
          return X5() && N && Kv(s), Z1(null, s, P, p), Em(s, C), s.child;
        }
      }
      function Em(a, s) {
        {
          if (s && s.childContextTypes && u("%s(...): childContextTypes cannot be defined on a function component.", s.displayName || s.name || "Component"), a.ref !== null) {
            var C = "", p = U5();
            p && (C += `

Check the render method of \`` + p + "`.");
            var m = p || "", b = a._debugSource;
            b && (m = b.fileName + ":" + b.lineNumber), gm[m] || (gm[m] = !0, u("Function components cannot be given refs. Attempts to access this ref will fail. Did you mean to use React.forwardRef()?%s", C));
          }
          if (s.defaultProps !== void 0) {
            var L = ue(s) || "Unknown";
            al[L] || (u("%s: Support for defaultProps will be removed from function components in a future major release. Use JavaScript default parameters instead.", L), al[L] = !0);
          }
          if (typeof s.getDerivedStateFromProps == "function") {
            var P = ue(s) || "Unknown";
            dm[P] || (u("%s: Function components do not support getDerivedStateFromProps.", P), dm[P] = !0);
          }
          if (typeof s.contextType == "object" && s.contextType !== null) {
            var N = ue(s) || "Unknown";
            Cm[N] || (u("%s: Function components do not support contextType.", N), Cm[N] = !0);
          }
        }
      }
      var mm = {
        dehydrated: null,
        treeContext: null,
        retryLane: Ce
      };
      function ym(a) {
        return {
          baseLanes: a,
          cachePool: PJ(),
          transitions: null
        };
      }
      function YJ(a, s) {
        var C = null;
        return {
          baseLanes: V0(a.baseLanes, s),
          cachePool: C,
          transitions: a.transitions
        };
      }
      function $J(a, s, C, p) {
        if (s !== null) {
          var m = s.memoizedState;
          if (m === null)
            return !1;
        }
        return IE(a, Yu);
      }
      function GJ(a, s) {
        return P7(a.childLanes, s);
      }
      function CT(a, s, C) {
        var p = s.pendingProps;
        ae2(s) && (s.flags |= y0);
        var m = X4.current, b = !1, L = (s.flags & y0) !== I0;
        if (L || $J(m, a) ? (b = !0, s.flags &= -129) : (a === null || a.memoizedState !== null) && (m = dJ(m, mO)), m = _o(m), m6(s, m), a === null) {
          rE(s);
          var P = s.memoizedState;
          if (P !== null) {
            var N = P.dehydrated;
            if (N !== null)
              return t22(s, N);
          }
          var G = p.children, J = p.fallback;
          if (b) {
            var h2 = KJ(s, G, J, C), g2 = s.child;
            return g2.memoizedState = ym(C), s.memoizedState = mm, h2;
          } else
            return Im(s, G);
        } else {
          var B2 = a.memoizedState;
          if (B2 !== null) {
            var b2 = B2.dehydrated;
            if (b2 !== null)
              return r22(a, s, L, p, b2, B2, C);
          }
          if (b) {
            var T2 = p.fallback, t0 = p.children, x0 = JJ(a, s, t0, T2, C), m0 = s.child, se = a.child.memoizedState;
            return m0.memoizedState = se === null ? ym(C) : YJ(se, C), m0.childLanes = GJ(a, C), s.memoizedState = mm, x0;
          } else {
            var J0 = p.children, m2 = XJ(a, s, J0, C);
            return s.memoizedState = null, m2;
          }
        }
      }
      function Im(a, s, C) {
        var p = a.mode, m = {
          mode: "visible",
          children: s
        }, b = Bm(m, p);
        return b.return = a, a.child = b, b;
      }
      function KJ(a, s, C, p) {
        var m = a.mode, b = a.child, L = {
          mode: "hidden",
          children: s
        }, P, N;
        return (m & Y0) === B0 && b !== null ? (P = b, P.childLanes = H2, P.pendingProps = L, a.mode & Ee && (P.actualDuration = 0, P.actualStartTime = -1, P.selfBaseDuration = 0, P.treeBaseDuration = 0), N = S6(C, m, p, null)) : (P = Bm(L, m), N = S6(C, m, p, null)), P.return = a, N.return = a, P.sibling = N, a.child = P, N;
      }
      function Bm(a, s, C) {
        return dD(a, s, H2, null);
      }
      function dT(a, s) {
        return vi(a, s);
      }
      function XJ(a, s, C, p) {
        var m = a.child, b = m.sibling, L = dT(m, {
          mode: "visible",
          children: C
        });
        if ((s.mode & Y0) === B0 && (L.lanes = p), L.return = s, L.sibling = null, b !== null) {
          var P = s.deletions;
          P === null ? (s.deletions = [b], s.flags |= nr) : P.push(b);
        }
        return s.child = L, L;
      }
      function JJ(a, s, C, p, m) {
        var b = s.mode, L = a.child, P = L.sibling, N = {
          mode: "hidden",
          children: C
        }, G;
        if (
          // In legacy mode, we commit the primary tree as if it successfully
          // completed, even though it's in an inconsistent state.
          (b & Y0) === B0 && // Make sure we're on the second pass, i.e. the primary child fragment was
          // already cloned. In legacy mode, the only case where this isn't true is
          // when DevTools forces us to display a fallback; we skip the first render
          // pass entirely and go straight to rendering the fallback. (In Concurrent
          // Mode, SuspenseList can also trigger this scenario, but this is a legacy-
          // only codepath.)
          s.child !== L
        ) {
          var J = s.child;
          G = J, G.childLanes = H2, G.pendingProps = N, s.mode & Ee && (G.actualDuration = 0, G.actualStartTime = -1, G.selfBaseDuration = L.selfBaseDuration, G.treeBaseDuration = L.treeBaseDuration), s.deletions = null;
        } else
          G = dT(L, N), G.subtreeFlags = L.subtreeFlags & Ft;
        var h2;
        return P !== null ? h2 = vi(P, p) : (h2 = S6(p, b, m, null), h2.flags |= xt), h2.return = s, G.return = s, G.sibling = h2, s.child = G, h2;
      }
      function VC(a, s, C, p) {
        p !== null && nE(p), bo(s, a.child, null, C);
        var m = s.pendingProps, b = m.children, L = Im(s, b);
        return L.flags |= xt, s.memoizedState = null, L;
      }
      function e22(a, s, C, p, m) {
        var b = s.mode, L = {
          mode: "visible",
          children: C
        }, P = Bm(L, b), N = S6(p, b, m, null);
        return N.flags |= xt, P.return = s, N.return = s, P.sibling = N, s.child = P, (s.mode & Y0) !== B0 && bo(s, a.child, null, m), N;
      }
      function t22(a, s, C) {
        return (a.mode & Y0) === B0 ? (u("Cannot hydrate Suspense in legacy mode. Switch from ReactDOM.hydrate(element, container) to ReactDOMClient.hydrateRoot(container, <App />).render(element) or remove the Suspense components from the server rendered components."), a.lanes = O0) : jv(s) ? a.lanes = L5 : a.lanes = H1, null;
      }
      function r22(a, s, C, p, m, b, L) {
        if (C)
          if (s.flags & d1) {
            s.flags &= -257;
            var m2 = lm(new Error("There was an error while hydrating this Suspense boundary. Switched to client rendering."));
            return VC(a, s, L, m2);
          } else {
            if (s.memoizedState !== null)
              return s.child = a.child, s.flags |= y0, null;
            var D2 = p.children, y2 = p.fallback, U2 = e22(a, s, D2, y2, L), o0 = s.child;
            return o0.memoizedState = ym(L), s.memoizedState = mm, U2;
          }
        else {
          if (ZX(), (s.mode & Y0) === B0)
            return VC(
              a,
              s,
              L,
              // TODO: When we delete legacy mode, we should make this error argument
              // required — every concurrent mode path that causes hydration to
              // de-opt to client rendering should have an error message.
              null
            );
          if (jv(m)) {
            var P, N, G;
            {
              var J = oX(m);
              P = J.digest, N = J.message, G = J.stack;
            }
            var h2;
            N ? h2 = new Error(N) : h2 = new Error("The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering.");
            var g2 = lm(h2, P, G);
            return VC(a, s, L, g2);
          }
          var B2 = m1(L, a.childLanes);
          if (tn || B2) {
            var b2 = JC();
            if (b2 !== null) {
              var T2 = uu(b2, L);
              if (T2 !== Ce && T2 !== b.retryLane) {
                b.retryLane = T2;
                var t0 = Xe;
                Cr(a, T2), M5(b2, a, T2, t0);
              }
            }
            zm();
            var x0 = lm(new Error("This Suspense boundary received an update before it finished hydrating. This caused the boundary to switch to client rendering. The usual way to fix this is to wrap the original update in startTransition."));
            return VC(a, s, L, x0);
          } else if (P_(m)) {
            s.flags |= y0, s.child = a.child;
            var m0 = w02.bind(null, a);
            return sX(m, m0), null;
          } else {
            qX(s, m, b.treeContext);
            var se = p.children, J0 = Im(s, se);
            return J0.flags |= ir, J0;
          }
        }
      }
      function gT(a, s, C) {
        a.lanes = V0(a.lanes, s);
        var p = a.alternate;
        p !== null && (p.lanes = V0(p.lanes, s)), CE(a.return, s, C);
      }
      function n22(a, s, C) {
        for (var p = s; p !== null; ) {
          if (p.tag === w) {
            var m = p.memoizedState;
            m !== null && gT(p, C, a);
          } else if (p.tag === V)
            gT(p, C, a);
          else if (p.child !== null) {
            p.child.return = p, p = p.child;
            continue;
          }
          if (p === a)
            return;
          for (; p.sibling === null; ) {
            if (p.return === null || p.return === a)
              return;
            p = p.return;
          }
          p.sibling.return = p.return, p = p.sibling;
        }
      }
      function i22(a) {
        for (var s = a, C = null; s !== null; ) {
          var p = s.alternate;
          p !== null && mC(p) === null && (C = s), s = s.sibling;
        }
        return C;
      }
      function a22(a) {
        if (a !== void 0 && a !== "forwards" && a !== "backwards" && a !== "together" && !pm[a])
          if (pm[a] = !0, typeof a == "string")
            switch (a.toLowerCase()) {
              case "together":
              case "forwards":
              case "backwards": {
                u('"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.', a, a.toLowerCase());
                break;
              }
              case "forward":
              case "backward": {
                u('"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.', a, a.toLowerCase());
                break;
              }
              default:
                u('"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
                break;
            }
          else
            u('%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "together", "forwards" or "backwards"?', a);
      }
      function o22(a, s) {
        a !== void 0 && !jC[a] && (a !== "collapsed" && a !== "hidden" ? (jC[a] = !0, u('"%s" is not a supported value for tail on <SuspenseList />. Did you mean "collapsed" or "hidden"?', a)) : s !== "forwards" && s !== "backwards" && (jC[a] = !0, u('<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?', a)));
      }
      function pT(a, s) {
        {
          var C = q0(a), p = !C && typeof j0(a) == "function";
          if (C || p) {
            var m = C ? "array" : "iterable";
            return u("A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>", m, s, m), !1;
          }
        }
        return !0;
      }
      function s22(a, s) {
        if ((s === "forwards" || s === "backwards") && a !== void 0 && a !== null && a !== !1)
          if (q0(a)) {
            for (var C = 0; C < a.length; C++)
              if (!pT(a[C], C))
                return;
          } else {
            var p = j0(a);
            if (typeof p == "function") {
              var m = p.call(a);
              if (m)
                for (var b = m.next(), L = 0; !b.done; b = m.next()) {
                  if (!pT(b.value, L))
                    return;
                  L++;
                }
            } else
              u('A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?', s);
          }
      }
      function Qm(a, s, C, p, m) {
        var b = a.memoizedState;
        b === null ? a.memoizedState = {
          isBackwards: s,
          rendering: null,
          renderingStartTime: 0,
          last: p,
          tail: C,
          tailMode: m
        } : (b.isBackwards = s, b.rendering = null, b.renderingStartTime = 0, b.last = p, b.tail = C, b.tailMode = m);
      }
      function hT(a, s, C) {
        var p = s.pendingProps, m = p.revealOrder, b = p.tail, L = p.children;
        a22(m), o22(b, m), s22(L, m), Z1(a, s, L, C);
        var P = X4.current, N = IE(P, Yu);
        if (N)
          P = BE(P, Yu), s.flags |= y0;
        else {
          var G = a !== null && (a.flags & y0) !== I0;
          G && n22(s, s.child, C), P = _o(P);
        }
        if (m6(s, P), (s.mode & Y0) === B0)
          s.memoizedState = null;
        else
          switch (m) {
            case "forwards": {
              var J = i22(s.child), h2;
              J === null ? (h2 = s.child, s.child = null) : (h2 = J.sibling, J.sibling = null), Qm(
                s,
                !1,
                // isBackwards
                h2,
                J,
                b
              );
              break;
            }
            case "backwards": {
              var g2 = null, B2 = s.child;
              for (s.child = null; B2 !== null; ) {
                var b2 = B2.alternate;
                if (b2 !== null && mC(b2) === null) {
                  s.child = B2;
                  break;
                }
                var T2 = B2.sibling;
                B2.sibling = g2, g2 = B2, B2 = T2;
              }
              Qm(
                s,
                !0,
                // isBackwards
                g2,
                null,
                // last
                b
              );
              break;
            }
            case "together": {
              Qm(
                s,
                !1,
                // isBackwards
                null,
                // tail
                null,
                // last
                void 0
              );
              break;
            }
            default:
              s.memoizedState = null;
          }
        return s.child;
      }
      function u22(a, s, C) {
        EE(s, s.stateNode.containerInfo);
        var p = s.pendingProps;
        return a === null ? s.child = bo(s, null, p, C) : Z1(a, s, p, C), s.child;
      }
      var vT = !1;
      function l22(a, s, C) {
        var p = s.type, m = p._context, b = s.pendingProps, L = s.memoizedProps, P = b.value;
        {
          "value" in b || vT || (vT = !0, u("The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"));
          var N = s.type.propTypes;
          N && $4(N, b, "prop", "Context.Provider");
        }
        if (cO(s, m, P), L !== null) {
          var G = L.value;
          if (Z2(G, P)) {
            if (L.children === b.children && !Kf())
              return n8(a, s, C);
          } else
            aJ(s, m, C);
        }
        var J = b.children;
        return Z1(a, s, J, C), s.child;
      }
      var ET = !1;
      function c22(a, s, C) {
        var p = s.type;
        p._context === void 0 ? p !== p.Consumer && (ET || (ET = !0, u("Rendering <Context> directly is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?"))) : p = p._context;
        var m = s.pendingProps, b = m.children;
        typeof b != "function" && u("A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."), So(s, C);
        var L = c5(p);
        F1(s);
        var P;
        return nl.current = s, Xt(!0), P = b(L), Xt(!1), N1(), s.flags |= Tr, Z1(a, s, P, C), s.child;
      }
      function ol() {
        tn = !0;
      }
      function ZC(a, s) {
        (s.mode & Y0) === B0 && a !== null && (a.alternate = null, s.alternate = null, s.flags |= xt);
      }
      function n8(a, s, C) {
        return a !== null && (s.dependencies = a.dependencies), YO(), vl(s.lanes), m1(C, s.childLanes) ? (nJ(a, s), s.child) : null;
      }
      function A22(a, s, C) {
        {
          var p = s.return;
          if (p === null)
            throw new Error("Cannot swap the root fiber.");
          if (a.alternate = null, s.alternate = null, C.index = s.index, C.sibling = s.sibling, C.return = s.return, C.ref = s.ref, s === p.child)
            p.child = C;
          else {
            var m = p.child;
            if (m === null)
              throw new Error("Expected parent to have a child.");
            for (; m.sibling !== s; )
              if (m = m.sibling, m === null)
                throw new Error("Expected to find the previous sibling.");
            m.sibling = C;
          }
          var b = p.deletions;
          return b === null ? (p.deletions = [a], p.flags |= nr) : b.push(a), C.flags |= xt, C;
        }
      }
      function xm(a, s) {
        var C = a.lanes;
        return !!m1(C, s);
      }
      function f22(a, s, C) {
        switch (s.tag) {
          case h:
            AT(s), s.stateNode, xo();
            break;
          case y:
            vO(s);
            break;
          case d: {
            var p = s.type;
            Gn(p) && Jf(s);
            break;
          }
          case E:
            EE(s, s.stateNode.containerInfo);
            break;
          case M: {
            var m = s.memoizedProps.value, b = s.type._context;
            cO(s, b, m);
            break;
          }
          case O:
            {
              var L = m1(C, s.childLanes);
              L && (s.flags |= ie);
              {
                var P = s.stateNode;
                P.effectDuration = 0, P.passiveEffectDuration = 0;
              }
            }
            break;
          case w: {
            var N = s.memoizedState;
            if (N !== null) {
              if (N.dehydrated !== null)
                return m6(s, _o(X4.current)), s.flags |= y0, null;
              var G = s.child, J = G.childLanes;
              if (m1(C, J))
                return CT(a, s, C);
              m6(s, _o(X4.current));
              var h2 = n8(a, s, C);
              return h2 !== null ? h2.sibling : null;
            } else
              m6(s, _o(X4.current));
            break;
          }
          case V: {
            var g2 = (a.flags & y0) !== I0, B2 = m1(C, s.childLanes);
            if (g2) {
              if (B2)
                return hT(a, s, C);
              s.flags |= y0;
            }
            var b2 = s.memoizedState;
            if (b2 !== null && (b2.rendering = null, b2.tail = null, b2.lastEffect = null), m6(s, X4.current), B2)
              break;
            return null;
          }
          case W:
          case t2:
            return s.lanes = H2, uT(a, s, C);
        }
        return n8(a, s, C);
      }
      function mT(a, s, C) {
        if (s._debugNeedsRemount && a !== null)
          return A22(a, s, ty(s.type, s.key, s.pendingProps, s._debugOwner || null, s.mode, s.lanes));
        if (a !== null) {
          var p = a.memoizedProps, m = s.pendingProps;
          if (p !== m || Kf() || // Force a re-render if the implementation changed due to hot reload:
          s.type !== a.type)
            tn = !0;
          else {
            var b = xm(a, C);
            if (!b && // If this is the second pass of an error or suspense boundary, there
            // may not be work scheduled on `current`, so we check for this flag.
            (s.flags & y0) === I0)
              return tn = !1, f22(a, s, C);
            (a.flags & Ba) !== I0 ? tn = !0 : tn = !1;
          }
        } else if (tn = !1, X5() && PX(s)) {
          var L = s.index, P = FX();
          Y_(s, P, L);
        }
        switch (s.lanes = H2, s.tag) {
          case g:
            return WJ(a, s, s.type, C);
          case F: {
            var N = s.elementType;
            return UJ(a, s, N, C);
          }
          case f: {
            var G = s.type, J = s.pendingProps, h2 = s.elementType === G ? J : en(G, J);
            return hm(a, s, G, h2, C);
          }
          case d: {
            var g2 = s.type, B2 = s.pendingProps, b2 = s.elementType === g2 ? B2 : en(g2, B2);
            return cT(a, s, g2, b2, C);
          }
          case h:
            return VJ(a, s, C);
          case y:
            return ZJ(a, s, C);
          case I:
            return zJ(a, s);
          case w:
            return CT(a, s, C);
          case E:
            return u22(a, s, C);
          case S: {
            var T2 = s.type, t0 = s.pendingProps, x0 = s.elementType === T2 ? t0 : en(T2, t0);
            return aT(a, s, T2, x0, C);
          }
          case Q:
            return NJ(a, s, C);
          case B:
            return HJ(a, s, C);
          case O:
            return jJ(a, s, C);
          case M:
            return l22(a, s, C);
          case _:
            return c22(a, s, C);
          case D: {
            var m0 = s.type, se = s.pendingProps, J0 = en(m0, se);
            if (s.type !== s.elementType) {
              var m2 = m0.propTypes;
              m2 && $4(
                m2,
                J0,
                // Resolved for outer only
                "prop",
                ue(m0)
              );
            }
            return J0 = en(m0.type, J0), oT(a, s, m0, J0, C);
          }
          case k:
            return sT(a, s, s.type, s.pendingProps, C);
          case z: {
            var D2 = s.type, y2 = s.pendingProps, U2 = s.elementType === D2 ? y2 : en(D2, y2);
            return qJ(a, s, D2, U2, C);
          }
          case V:
            return hT(a, s, C);
          case $:
            break;
          case W:
            return uT(a, s, C);
        }
        throw new Error("Unknown unit of work tag (" + s.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function Ro(a) {
        a.flags |= ie;
      }
      function yT(a) {
        a.flags |= It, a.flags |= J8;
      }
      var IT, bm, BT, QT;
      IT = function(a, s, C, p) {
        for (var m = s.child; m !== null; ) {
          if (m.tag === y || m.tag === I)
            LK(a, m.stateNode);
          else if (m.tag !== E) {
            if (m.child !== null) {
              m.child.return = m, m = m.child;
              continue;
            }
          }
          if (m === s)
            return;
          for (; m.sibling === null; ) {
            if (m.return === null || m.return === s)
              return;
            m = m.return;
          }
          m.sibling.return = m.return, m = m.sibling;
        }
      }, bm = function(a, s) {
      }, BT = function(a, s, C, p, m) {
        var b = a.memoizedProps;
        if (b !== p) {
          var L = s.stateNode, P = mE(), N = RK(L, C, b, p, m, P);
          s.updateQueue = N, N && Ro(s);
        }
      }, QT = function(a, s, C, p) {
        C !== p && Ro(s);
      };
      function sl(a, s) {
        if (!X5())
          switch (a.tailMode) {
            case "hidden": {
              for (var C = a.tail, p = null; C !== null; )
                C.alternate !== null && (p = C), C = C.sibling;
              p === null ? a.tail = null : p.sibling = null;
              break;
            }
            case "collapsed": {
              for (var m = a.tail, b = null; m !== null; )
                m.alternate !== null && (b = m), m = m.sibling;
              b === null ? !s && a.tail !== null ? a.tail.sibling = null : a.tail = null : b.sibling = null;
              break;
            }
          }
      }
      function e1(a) {
        var s = a.alternate !== null && a.alternate.child === a.child, C = H2, p = I0;
        if (s) {
          if ((a.mode & Ee) !== B0) {
            for (var N = a.selfBaseDuration, G = a.child; G !== null; )
              C = V0(C, V0(G.lanes, G.childLanes)), p |= G.subtreeFlags & Ft, p |= G.flags & Ft, N += G.treeBaseDuration, G = G.sibling;
            a.treeBaseDuration = N;
          } else
            for (var J = a.child; J !== null; )
              C = V0(C, V0(J.lanes, J.childLanes)), p |= J.subtreeFlags & Ft, p |= J.flags & Ft, J.return = a, J = J.sibling;
          a.subtreeFlags |= p;
        } else {
          if ((a.mode & Ee) !== B0) {
            for (var m = a.actualDuration, b = a.selfBaseDuration, L = a.child; L !== null; )
              C = V0(C, V0(L.lanes, L.childLanes)), p |= L.subtreeFlags, p |= L.flags, m += L.actualDuration, b += L.treeBaseDuration, L = L.sibling;
            a.actualDuration = m, a.treeBaseDuration = b;
          } else
            for (var P = a.child; P !== null; )
              C = V0(C, V0(P.lanes, P.childLanes)), p |= P.subtreeFlags, p |= P.flags, P.return = a, P = P.sibling;
          a.subtreeFlags |= p;
        }
        return a.childLanes = C, s;
      }
      function C22(a, s, C) {
        if (KX() && (s.mode & Y0) !== B0 && (s.flags & y0) === I0)
          return tO(s), xo(), s.flags |= d1 | y7 | p1, !1;
        var p = iC(s);
        if (C !== null && C.dehydrated !== null)
          if (a === null) {
            if (!p)
              throw new Error("A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React.");
            if ($X(s), e1(s), (s.mode & Ee) !== B0) {
              var m = C !== null;
              if (m) {
                var b = s.child;
                b !== null && (s.treeBaseDuration -= b.treeBaseDuration);
              }
            }
            return !1;
          } else {
            if (xo(), (s.flags & y0) === I0 && (s.memoizedState = null), s.flags |= ie, e1(s), (s.mode & Ee) !== B0) {
              var L = C !== null;
              if (L) {
                var P = s.child;
                P !== null && (s.treeBaseDuration -= P.treeBaseDuration);
              }
            }
            return !1;
          }
        else
          return rO(), !0;
      }
      function xT(a, s, C) {
        var p = s.pendingProps;
        switch (Xv(s), s.tag) {
          case g:
          case F:
          case k:
          case f:
          case S:
          case Q:
          case B:
          case O:
          case _:
          case D:
            return e1(s), null;
          case d: {
            var m = s.type;
            return Gn(m) && Xf(s), e1(s), null;
          }
          case h: {
            var b = s.stateNode;
            if (Mo(s), Yv(s), xE(), b.pendingContext && (b.context = b.pendingContext, b.pendingContext = null), a === null || a.child === null) {
              var L = iC(s);
              if (L)
                Ro(s);
              else if (a !== null) {
                var P = a.memoizedState;
                // Check if this is a client root
                (!P.isDehydrated || // Check if we reverted to client rendering (e.g. due to an error)
                (s.flags & d1) !== I0) && (s.flags |= Jt, rO());
              }
            }
            return bm(a, s), e1(s), null;
          }
          case y: {
            yE(s);
            var N = hO(), G = s.type;
            if (a !== null && s.stateNode != null)
              BT(a, s, G, p, N), a.ref !== s.ref && yT(s);
            else {
              if (!p) {
                if (s.stateNode === null)
                  throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
                return e1(s), null;
              }
              var J = mE(), h2 = iC(s);
              if (h2)
                WX(s, N, J) && Ro(s);
              else {
                var g2 = DK(G, p, N, J, s);
                IT(g2, s, !1, !1), s.stateNode = g2, kK(g2, G, p, N) && Ro(s);
              }
              s.ref !== null && yT(s);
            }
            return e1(s), null;
          }
          case I: {
            var B2 = p;
            if (a && s.stateNode != null) {
              var b2 = a.memoizedProps;
              QT(a, s, b2, B2);
            } else {
              if (typeof B2 != "string" && s.stateNode === null)
                throw new Error("We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue.");
              var T2 = hO(), t0 = mE(), x0 = iC(s);
              x0 ? YX(s) && Ro(s) : s.stateNode = PK(B2, T2, t0, s);
            }
            return e1(s), null;
          }
          case w: {
            Oo(s);
            var m0 = s.memoizedState;
            if (a === null || a.memoizedState !== null && a.memoizedState.dehydrated !== null) {
              var se = C22(a, s, m0);
              if (!se)
                return s.flags & p1 ? s : null;
            }
            if ((s.flags & y0) !== I0)
              return s.lanes = C, (s.mode & Ee) !== B0 && GE(s), s;
            var J0 = m0 !== null, m2 = a !== null && a.memoizedState !== null;
            if (J0 !== m2 && J0) {
              var D2 = s.child;
              if (D2.flags |= Pt, (s.mode & Y0) !== B0) {
                var y2 = a === null && (s.memoizedProps.unstable_avoidThisFallback !== !0 || !0);
                y2 || IE(X4.current, mO) ? d02() : zm();
              }
            }
            var U2 = s.updateQueue;
            if (U2 !== null && (s.flags |= ie), e1(s), (s.mode & Ee) !== B0 && J0) {
              var o0 = s.child;
              o0 !== null && (s.treeBaseDuration -= o0.treeBaseDuration);
            }
            return null;
          }
          case E:
            return Mo(s), bm(a, s), a === null && _X(s.stateNode.containerInfo), e1(s), null;
          case M:
            var r0 = s.type._context;
            return fE(r0, s), e1(s), null;
          case z: {
            var T0 = s.type;
            return Gn(T0) && Xf(s), e1(s), null;
          }
          case V: {
            Oo(s);
            var N0 = s.memoizedState;
            if (N0 === null)
              return e1(s), null;
            var Ve = (s.flags & y0) !== I0, Ie = N0.rendering;
            if (Ie === null)
              if (Ve)
                sl(N0, !1);
              else {
                var r5 = p02() && (a === null || (a.flags & y0) === I0);
                if (!r5)
                  for (var Be = s.child; Be !== null; ) {
                    var zt = mC(Be);
                    if (zt !== null) {
                      Ve = !0, s.flags |= y0, sl(N0, !1);
                      var w1 = zt.updateQueue;
                      return w1 !== null && (s.updateQueue = w1, s.flags |= ie), s.subtreeFlags = I0, iJ(s, C), m6(s, BE(X4.current, Yu)), s.child;
                    }
                    Be = Be.sibling;
                  }
                N0.tail !== null && e5() > qT() && (s.flags |= y0, Ve = !0, sl(N0, !1), s.lanes = Js);
              }
            else {
              if (!Ve) {
                var a1 = mC(Ie);
                if (a1 !== null) {
                  s.flags |= y0, Ve = !0;
                  var Hr = a1.updateQueue;
                  if (Hr !== null && (s.updateQueue = Hr, s.flags |= ie), sl(N0, !0), N0.tail === null && N0.tailMode === "hidden" && !Ie.alternate && !X5())
                    return e1(s), null;
                } else // The time it took to render last row is greater than the remaining
                // time we have to render. So rendering one more row would likely
                // exceed it.
                e5() * 2 - N0.renderingStartTime > qT() && C !== H1 && (s.flags |= y0, Ve = !0, sl(N0, !1), s.lanes = Js);
              }
              if (N0.isBackwards)
                Ie.sibling = s.child, s.child = Ie;
              else {
                var q1 = N0.last;
                q1 !== null ? q1.sibling = Ie : s.child = Ie, N0.last = Ie;
              }
            }
            if (N0.tail !== null) {
              var W1 = N0.tail;
              N0.rendering = W1, N0.tail = W1.sibling, N0.renderingStartTime = e5(), W1.sibling = null;
              var S1 = X4.current;
              return Ve ? S1 = BE(S1, Yu) : S1 = _o(S1), m6(s, S1), W1;
            }
            return e1(s), null;
          }
          case $:
            break;
          case W:
          case t2: {
            Zm(s);
            var u8 = s.memoizedState, zo = u8 !== null;
            if (a !== null) {
              var Bl = a.memoizedState, i3 = Bl !== null;
              i3 !== zo && (s.flags |= Pt);
            }
            return !zo || (s.mode & Y0) === B0 ? e1(s) : m1(n3, H1) && (e1(s), s.subtreeFlags & (xt | ie) && (s.flags |= Pt)), null;
          }
          case n2:
            return null;
          case s2:
            return null;
        }
        throw new Error("Unknown unit of work tag (" + s.tag + "). This error is likely caused by a bug in React. Please file an issue.");
      }
      function d22(a, s, C) {
        switch (Xv(s), s.tag) {
          case d: {
            var p = s.type;
            Gn(p) && Xf(s);
            var m = s.flags;
            return m & p1 ? (s.flags = m & -65537 | y0, (s.mode & Ee) !== B0 && GE(s), s) : null;
          }
          case h: {
            s.stateNode, Mo(s), Yv(s), xE();
            var b = s.flags;
            return (b & p1) !== I0 && (b & y0) === I0 ? (s.flags = b & -65537 | y0, s) : null;
          }
          case y:
            return yE(s), null;
          case w: {
            Oo(s);
            var L = s.memoizedState;
            if (L !== null && L.dehydrated !== null) {
              if (s.alternate === null)
                throw new Error("Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue.");
              xo();
            }
            var P = s.flags;
            return P & p1 ? (s.flags = P & -65537 | y0, (s.mode & Ee) !== B0 && GE(s), s) : null;
          }
          case V:
            return Oo(s), null;
          case E:
            return Mo(s), null;
          case M:
            var N = s.type._context;
            return fE(N, s), null;
          case W:
          case t2:
            return Zm(s), null;
          case n2:
            return null;
          default:
            return null;
        }
      }
      function bT(a, s, C) {
        switch (Xv(s), s.tag) {
          case d: {
            var p = s.type.childContextTypes;
            p != null && Xf(s);
            break;
          }
          case h: {
            s.stateNode, Mo(s), Yv(s), xE();
            break;
          }
          case y: {
            yE(s);
            break;
          }
          case E:
            Mo(s);
            break;
          case w:
            Oo(s);
            break;
          case V:
            Oo(s);
            break;
          case M:
            var m = s.type._context;
            fE(m, s);
            break;
          case W:
          case t2:
            Zm(s);
            break;
        }
      }
      var wT = null;
      wT = /* @__PURE__ */ new Set();
      var zC = !1, t1 = !1, g22 = typeof WeakSet == "function" ? WeakSet : Set, d0 = null, Po = null, Fo = null;
      function p22(a) {
        Tn(null, function() {
          throw a;
        }), m7();
      }
      var h22 = function(a, s) {
        if (s.props = a.memoizedProps, s.state = a.memoizedState, a.mode & Ee)
          try {
            t3(), s.componentWillUnmount();
          } finally {
            e3(a);
          }
        else
          s.componentWillUnmount();
      };
      function ST(a, s) {
        try {
          B6(B5, a);
        } catch (C) {
          ct(a, s, C);
        }
      }
      function wm(a, s, C) {
        try {
          h22(a, C);
        } catch (p) {
          ct(a, s, p);
        }
      }
      function v22(a, s, C) {
        try {
          C.componentDidMount();
        } catch (p) {
          ct(a, s, p);
        }
      }
      function MT(a, s) {
        try {
          OT(a);
        } catch (C) {
          ct(a, s, C);
        }
      }
      function No(a, s) {
        var C = a.ref;
        if (C !== null)
          if (typeof C == "function") {
            var p;
            try {
              if (o2 && O2 && a.mode & Ee)
                try {
                  t3(), p = C(null);
                } finally {
                  e3(a);
                }
              else
                p = C(null);
            } catch (m) {
              ct(a, s, m);
            }
            typeof p == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", R0(a));
          } else
            C.current = null;
      }
      function UC(a, s, C) {
        try {
          C();
        } catch (p) {
          ct(a, s, p);
        }
      }
      var _T = !1;
      function E22(a, s) {
        OK(a.containerInfo), d0 = s, m22();
        var C = _T;
        return _T = !1, C;
      }
      function m22() {
        for (; d0 !== null; ) {
          var a = d0, s = a.child;
          (a.subtreeFlags & Ln) !== I0 && s !== null ? (s.return = a, d0 = s) : y22();
        }
      }
      function y22() {
        for (; d0 !== null; ) {
          var a = d0;
          Pe(a);
          try {
            I22(a);
          } catch (C) {
            ct(a, a.return, C);
          }
          lt();
          var s = a.sibling;
          if (s !== null) {
            s.return = a.return, d0 = s;
            return;
          }
          d0 = a.return;
        }
      }
      function I22(a) {
        var s = a.alternate, C = a.flags;
        if ((C & Jt) !== I0) {
          switch (Pe(a), a.tag) {
            case f:
            case S:
            case k:
              break;
            case d: {
              if (s !== null) {
                var p = s.memoizedProps, m = s.memoizedState, b = a.stateNode;
                a.type === a.elementType && !Ci && (b.props !== a.memoizedProps && u("Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", R0(a) || "instance"), b.state !== a.memoizedState && u("Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", R0(a) || "instance"));
                var L = b.getSnapshotBeforeUpdate(a.elementType === a.type ? p : en(a.type, p), m);
                {
                  var P = wT;
                  L === void 0 && !P.has(a.type) && (P.add(a.type), u("%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.", R0(a)));
                }
                b.__reactInternalSnapshotBeforeUpdate = L;
              }
              break;
            }
            case h: {
              {
                var N = a.stateNode;
                rX(N.containerInfo);
              }
              break;
            }
            case y:
            case I:
            case E:
            case z:
              break;
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
          lt();
        }
      }
      function rn(a, s, C) {
        var p = s.updateQueue, m = p !== null ? p.lastEffect : null;
        if (m !== null) {
          var b = m.next, L = b;
          do {
            if ((L.tag & a) === a) {
              var P = L.destroy;
              L.destroy = void 0, P !== void 0 && ((a & J5) !== dr ? Z4(s) : (a & B5) !== dr && B7(s), (a & Kn) !== dr && ml(!0), UC(s, C, P), (a & Kn) !== dr && ml(!1), (a & J5) !== dr ? Fn() : (a & B5) !== dr && Ks());
            }
            L = L.next;
          } while (L !== b);
        }
      }
      function B6(a, s) {
        var C = s.updateQueue, p = C !== null ? C.lastEffect : null;
        if (p !== null) {
          var m = p.next, b = m;
          do {
            if ((b.tag & a) === a) {
              (a & J5) !== dr ? Gs(s) : (a & B5) !== dr && Ma(s);
              var L = b.create;
              (a & Kn) !== dr && ml(!0), b.destroy = L(), (a & Kn) !== dr && ml(!1), (a & J5) !== dr ? $A() : (a & B5) !== dr && GA();
              {
                var P = b.destroy;
                if (P !== void 0 && typeof P != "function") {
                  var N = void 0;
                  (b.tag & B5) !== I0 ? N = "useLayoutEffect" : (b.tag & Kn) !== I0 ? N = "useInsertionEffect" : N = "useEffect";
                  var G = void 0;
                  P === null ? G = " You returned null. If your effect does not require clean up, return undefined (or nothing)." : typeof P.then == "function" ? G = `

It looks like you wrote ` + N + `(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:

` + N + `(() => {
  async function fetchData() {
    // You can await here
    const response = await MyAPI.getData(someId);
    // ...
  }
  fetchData();
}, [someId]); // Or [] if effect doesn't need props or state

Learn more about data fetching with Hooks: https://reactjs.org/link/hooks-data-fetching` : G = " You returned: " + P, u("%s must not return anything besides a function, which is used for clean-up.%s", N, G);
                }
              }
            }
            b = b.next;
          } while (b !== m);
        }
      }
      function B22(a, s) {
        if ((s.flags & ie) !== I0)
          switch (s.tag) {
            case O: {
              var C = s.stateNode.passiveEffectDuration, p = s.memoizedProps, m = p.id, b = p.onPostCommit, L = qO(), P = s.alternate === null ? "mount" : "update";
              UO() && (P = "nested-update"), typeof b == "function" && b(m, P, C, L);
              var N = s.return;
              e: for (; N !== null; ) {
                switch (N.tag) {
                  case h:
                    var G = N.stateNode;
                    G.passiveEffectDuration += C;
                    break e;
                  case O:
                    var J = N.stateNode;
                    J.passiveEffectDuration += C;
                    break e;
                }
                N = N.return;
              }
              break;
            }
          }
      }
      function Q22(a, s, C, p) {
        if ((C.flags & Rn) !== I0)
          switch (C.tag) {
            case f:
            case S:
            case k: {
              if (!t1)
                if (C.mode & Ee)
                  try {
                    t3(), B6(B5 | I5, C);
                  } finally {
                    e3(C);
                  }
                else
                  B6(B5 | I5, C);
              break;
            }
            case d: {
              var m = C.stateNode;
              if (C.flags & ie && !t1)
                if (s === null)
                  if (C.type === C.elementType && !Ci && (m.props !== C.memoizedProps && u("Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", R0(C) || "instance"), m.state !== C.memoizedState && u("Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", R0(C) || "instance")), C.mode & Ee)
                    try {
                      t3(), m.componentDidMount();
                    } finally {
                      e3(C);
                    }
                  else
                    m.componentDidMount();
                else {
                  var b = C.elementType === C.type ? s.memoizedProps : en(C.type, s.memoizedProps), L = s.memoizedState;
                  if (C.type === C.elementType && !Ci && (m.props !== C.memoizedProps && u("Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", R0(C) || "instance"), m.state !== C.memoizedState && u("Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", R0(C) || "instance")), C.mode & Ee)
                    try {
                      t3(), m.componentDidUpdate(b, L, m.__reactInternalSnapshotBeforeUpdate);
                    } finally {
                      e3(C);
                    }
                  else
                    m.componentDidUpdate(b, L, m.__reactInternalSnapshotBeforeUpdate);
                }
              var P = C.updateQueue;
              P !== null && (C.type === C.elementType && !Ci && (m.props !== C.memoizedProps && u("Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.", R0(C) || "instance"), m.state !== C.memoizedState && u("Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.", R0(C) || "instance")), pO(C, P, m));
              break;
            }
            case h: {
              var N = C.updateQueue;
              if (N !== null) {
                var G = null;
                if (C.child !== null)
                  switch (C.child.tag) {
                    case y:
                      G = C.child.stateNode;
                      break;
                    case d:
                      G = C.child.stateNode;
                      break;
                  }
                pO(C, N, G);
              }
              break;
            }
            case y: {
              var J = C.stateNode;
              if (s === null && C.flags & ie) {
                var h2 = C.type, g2 = C.memoizedProps;
                VK(J, h2, g2);
              }
              break;
            }
            case I:
              break;
            case E:
              break;
            case O: {
              {
                var B2 = C.memoizedProps, b2 = B2.onCommit, T2 = B2.onRender, t0 = C.stateNode.effectDuration, x0 = qO(), m0 = s === null ? "mount" : "update";
                UO() && (m0 = "nested-update"), typeof T2 == "function" && T2(C.memoizedProps.id, m0, C.actualDuration, C.treeBaseDuration, C.actualStartTime, x0);
                {
                  typeof b2 == "function" && b2(C.memoizedProps.id, m0, t0, x0), y02(C);
                  var se = C.return;
                  e: for (; se !== null; ) {
                    switch (se.tag) {
                      case h:
                        var J0 = se.stateNode;
                        J0.effectDuration += t0;
                        break e;
                      case O:
                        var m2 = se.stateNode;
                        m2.effectDuration += t0;
                        break e;
                    }
                    se = se.return;
                  }
                }
              }
              break;
            }
            case w: {
              T22(a, C);
              break;
            }
            case V:
            case z:
            case $:
            case W:
            case t2:
            case s2:
              break;
            default:
              throw new Error("This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue.");
          }
        t1 || C.flags & It && OT(C);
      }
      function x22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            if (a.mode & Ee)
              try {
                t3(), ST(a, a.return);
              } finally {
                e3(a);
              }
            else
              ST(a, a.return);
            break;
          }
          case d: {
            var s = a.stateNode;
            typeof s.componentDidMount == "function" && v22(a, a.return, s), MT(a, a.return);
            break;
          }
          case y: {
            MT(a, a.return);
            break;
          }
        }
      }
      function b22(a, s) {
        for (var C = null, p = a; ; ) {
          if (p.tag === y) {
            if (C === null) {
              C = p;
              try {
                var m = p.stateNode;
                s ? XK(m) : eX(p.stateNode, p.memoizedProps);
              } catch (L) {
                ct(a, a.return, L);
              }
            }
          } else if (p.tag === I) {
            if (C === null)
              try {
                var b = p.stateNode;
                s ? JK(b) : tX(b, p.memoizedProps);
              } catch (L) {
                ct(a, a.return, L);
              }
          } else if (!((p.tag === W || p.tag === t2) && p.memoizedState !== null && p !== a)) {
            if (p.child !== null) {
              p.child.return = p, p = p.child;
              continue;
            }
          }
          if (p === a)
            return;
          for (; p.sibling === null; ) {
            if (p.return === null || p.return === a)
              return;
            C === p && (C = null), p = p.return;
          }
          C === p && (C = null), p.sibling.return = p.return, p = p.sibling;
        }
      }
      function OT(a) {
        var s = a.ref;
        if (s !== null) {
          var C = a.stateNode, p;
          switch (a.tag) {
            case y:
              p = C;
              break;
            default:
              p = C;
          }
          if (typeof s == "function") {
            var m;
            if (a.mode & Ee)
              try {
                t3(), m = s(p);
              } finally {
                e3(a);
              }
            else
              m = s(p);
            typeof m == "function" && u("Unexpected return value from a callback ref in %s. A callback ref should not return a function.", R0(a));
          } else
            s.hasOwnProperty("current") || u("Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().", R0(a)), s.current = p;
        }
      }
      function w22(a) {
        var s = a.alternate;
        s !== null && (s.return = null), a.return = null;
      }
      function TT(a) {
        var s = a.alternate;
        s !== null && (a.alternate = null, TT(s));
        {
          if (a.child = null, a.deletions = null, a.sibling = null, a.tag === y) {
            var C = a.stateNode;
            C !== null && DX(C);
          }
          a.stateNode = null, a._debugOwner = null, a.return = null, a.dependencies = null, a.memoizedProps = null, a.memoizedState = null, a.pendingProps = null, a.stateNode = null, a.updateQueue = null;
        }
      }
      function S22(a) {
        for (var s = a.return; s !== null; ) {
          if (DT(s))
            return s;
          s = s.return;
        }
        throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
      }
      function DT(a) {
        return a.tag === y || a.tag === h || a.tag === E;
      }
      function LT(a) {
        var s = a;
        e: for (; ; ) {
          for (; s.sibling === null; ) {
            if (s.return === null || DT(s.return))
              return null;
            s = s.return;
          }
          for (s.sibling.return = s.return, s = s.sibling; s.tag !== y && s.tag !== I && s.tag !== Z; ) {
            if (s.flags & xt || s.child === null || s.tag === E)
              continue e;
            s.child.return = s, s = s.child;
          }
          if (!(s.flags & xt))
            return s.stateNode;
        }
      }
      function M22(a) {
        var s = S22(a);
        switch (s.tag) {
          case y: {
            var C = s.stateNode;
            s.flags & Dr && (R_(C), s.flags &= -33);
            var p = LT(a);
            Mm(a, p, C);
            break;
          }
          case h:
          case E: {
            var m = s.stateNode.containerInfo, b = LT(a);
            Sm(a, b, m);
            break;
          }
          // eslint-disable-next-line-no-fallthrough
          default:
            throw new Error("Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue.");
        }
      }
      function Sm(a, s, C) {
        var p = a.tag, m = p === y || p === I;
        if (m) {
          var b = a.stateNode;
          s ? YK(C, b, s) : qK(C, b);
        } else if (p !== E) {
          var L = a.child;
          if (L !== null) {
            Sm(L, s, C);
            for (var P = L.sibling; P !== null; )
              Sm(P, s, C), P = P.sibling;
          }
        }
      }
      function Mm(a, s, C) {
        var p = a.tag, m = p === y || p === I;
        if (m) {
          var b = a.stateNode;
          s ? WK(C, b, s) : UK(C, b);
        } else if (p !== E) {
          var L = a.child;
          if (L !== null) {
            Mm(L, s, C);
            for (var P = L.sibling; P !== null; )
              Mm(P, s, C), P = P.sibling;
          }
        }
      }
      var r1 = null, nn = !1;
      function _22(a, s, C) {
        {
          var p = s;
          e: for (; p !== null; ) {
            switch (p.tag) {
              case y: {
                r1 = p.stateNode, nn = !1;
                break e;
              }
              case h: {
                r1 = p.stateNode.containerInfo, nn = !0;
                break e;
              }
              case E: {
                r1 = p.stateNode.containerInfo, nn = !0;
                break e;
              }
            }
            p = p.return;
          }
          if (r1 === null)
            throw new Error("Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue.");
          kT(a, s, C), r1 = null, nn = !1;
        }
        w22(C);
      }
      function Q6(a, s, C) {
        for (var p = C.child; p !== null; )
          kT(a, s, p), p = p.sibling;
      }
      function kT(a, s, C) {
        switch (Ws(C), C.tag) {
          case y:
            t1 || No(C, s);
          // eslint-disable-next-line-no-fallthrough
          case I: {
            {
              var p = r1, m = nn;
              r1 = null, Q6(a, s, C), r1 = p, nn = m, r1 !== null && (nn ? GK(r1, C.stateNode) : $K(r1, C.stateNode));
            }
            return;
          }
          case Z: {
            r1 !== null && (nn ? KK(r1, C.stateNode) : Hv(r1, C.stateNode));
            return;
          }
          case E: {
            {
              var b = r1, L = nn;
              r1 = C.stateNode.containerInfo, nn = !0, Q6(a, s, C), r1 = b, nn = L;
            }
            return;
          }
          case f:
          case S:
          case D:
          case k: {
            if (!t1) {
              var P = C.updateQueue;
              if (P !== null) {
                var N = P.lastEffect;
                if (N !== null) {
                  var G = N.next, J = G;
                  do {
                    var h2 = J, g2 = h2.destroy, B2 = h2.tag;
                    g2 !== void 0 && ((B2 & Kn) !== dr ? UC(C, s, g2) : (B2 & B5) !== dr && (B7(C), C.mode & Ee ? (t3(), UC(C, s, g2), e3(C)) : UC(C, s, g2), Ks())), J = J.next;
                  } while (J !== G);
                }
              }
            }
            Q6(a, s, C);
            return;
          }
          case d: {
            if (!t1) {
              No(C, s);
              var b2 = C.stateNode;
              typeof b2.componentWillUnmount == "function" && wm(C, s, b2);
            }
            Q6(a, s, C);
            return;
          }
          case $: {
            Q6(a, s, C);
            return;
          }
          case W: {
            if (
              // TODO: Remove this dead flag
              C.mode & Y0
            ) {
              var T2 = t1;
              t1 = T2 || C.memoizedState !== null, Q6(a, s, C), t1 = T2;
            } else
              Q6(a, s, C);
            break;
          }
          default: {
            Q6(a, s, C);
            return;
          }
        }
      }
      function O22(a) {
        a.memoizedState;
      }
      function T22(a, s) {
        var C = s.memoizedState;
        if (C === null) {
          var p = s.alternate;
          if (p !== null) {
            var m = p.memoizedState;
            if (m !== null) {
              var b = m.dehydrated;
              b !== null && pX(b);
            }
          }
        }
      }
      function RT(a) {
        var s = a.updateQueue;
        if (s !== null) {
          a.updateQueue = null;
          var C = a.stateNode;
          C === null && (C = a.stateNode = new g22()), s.forEach(function(p) {
            var m = S02.bind(null, a, p);
            if (!C.has(p)) {
              if (C.add(p), E1)
                if (Po !== null && Fo !== null)
                  El(Fo, Po);
                else
                  throw Error("Expected finished root and lanes to be set. This is a bug in React.");
              p.then(m, m);
            }
          });
        }
      }
      function D22(a, s, C) {
        Po = C, Fo = a, Pe(s), PT(s, a), Pe(s), Po = null, Fo = null;
      }
      function an(a, s, C) {
        var p = s.deletions;
        if (p !== null)
          for (var m = 0; m < p.length; m++) {
            var b = p[m];
            try {
              _22(a, s, b);
            } catch (N) {
              ct(b, s, N);
            }
          }
        var L = xn();
        if (s.subtreeFlags & kn)
          for (var P = s.child; P !== null; )
            Pe(P), PT(P, a), P = P.sibling;
        Pe(L);
      }
      function PT(a, s, C) {
        var p = a.alternate, m = a.flags;
        switch (a.tag) {
          case f:
          case S:
          case D:
          case k: {
            if (an(s, a), r3(a), m & ie) {
              try {
                rn(Kn | I5, a, a.return), B6(Kn | I5, a);
              } catch (T0) {
                ct(a, a.return, T0);
              }
              if (a.mode & Ee) {
                try {
                  t3(), rn(B5 | I5, a, a.return);
                } catch (T0) {
                  ct(a, a.return, T0);
                }
                e3(a);
              } else
                try {
                  rn(B5 | I5, a, a.return);
                } catch (T0) {
                  ct(a, a.return, T0);
                }
            }
            return;
          }
          case d: {
            an(s, a), r3(a), m & It && p !== null && No(p, p.return);
            return;
          }
          case y: {
            an(s, a), r3(a), m & It && p !== null && No(p, p.return);
            {
              if (a.flags & Dr) {
                var b = a.stateNode;
                try {
                  R_(b);
                } catch (T0) {
                  ct(a, a.return, T0);
                }
              }
              if (m & ie) {
                var L = a.stateNode;
                if (L != null) {
                  var P = a.memoizedProps, N = p !== null ? p.memoizedProps : P, G = a.type, J = a.updateQueue;
                  if (a.updateQueue = null, J !== null)
                    try {
                      ZK(L, J, G, N, P, a);
                    } catch (T0) {
                      ct(a, a.return, T0);
                    }
                }
              }
            }
            return;
          }
          case I: {
            if (an(s, a), r3(a), m & ie) {
              if (a.stateNode === null)
                throw new Error("This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue.");
              var h2 = a.stateNode, g2 = a.memoizedProps, B2 = p !== null ? p.memoizedProps : g2;
              try {
                zK(h2, B2, g2);
              } catch (T0) {
                ct(a, a.return, T0);
              }
            }
            return;
          }
          case h: {
            if (an(s, a), r3(a), m & ie && p !== null) {
              var b2 = p.memoizedState;
              if (b2.isDehydrated)
                try {
                  gX(s.containerInfo);
                } catch (T0) {
                  ct(a, a.return, T0);
                }
            }
            return;
          }
          case E: {
            an(s, a), r3(a);
            return;
          }
          case w: {
            an(s, a), r3(a);
            var T2 = a.child;
            if (T2.flags & Pt) {
              var t0 = T2.stateNode, x0 = T2.memoizedState, m0 = x0 !== null;
              if (t0.isHidden = m0, m0) {
                var se = T2.alternate !== null && T2.alternate.memoizedState !== null;
                se || C02();
              }
            }
            if (m & ie) {
              try {
                O22(a);
              } catch (T0) {
                ct(a, a.return, T0);
              }
              RT(a);
            }
            return;
          }
          case W: {
            var J0 = p !== null && p.memoizedState !== null;
            if (
              // TODO: Remove this dead flag
              a.mode & Y0
            ) {
              var m2 = t1;
              t1 = m2 || J0, an(s, a), t1 = m2;
            } else
              an(s, a);
            if (r3(a), m & Pt) {
              var D2 = a.stateNode, y2 = a.memoizedState, U2 = y2 !== null, o0 = a;
              if (D2.isHidden = U2, U2 && !J0 && (o0.mode & Y0) !== B0) {
                d0 = o0;
                for (var r0 = o0.child; r0 !== null; )
                  d0 = r0, k22(r0), r0 = r0.sibling;
              }
              b22(o0, U2);
            }
            return;
          }
          case V: {
            an(s, a), r3(a), m & ie && RT(a);
            return;
          }
          case $:
            return;
          default: {
            an(s, a), r3(a);
            return;
          }
        }
      }
      function r3(a) {
        var s = a.flags;
        if (s & xt) {
          try {
            M22(a);
          } catch (C) {
            ct(a, a.return, C);
          }
          a.flags &= -3;
        }
        s & ir && (a.flags &= -4097);
      }
      function L22(a, s, C) {
        Po = C, Fo = s, d0 = a, FT(a, s, C), Po = null, Fo = null;
      }
      function FT(a, s, C) {
        for (var p = (a.mode & Y0) !== B0; d0 !== null; ) {
          var m = d0, b = m.child;
          if (m.tag === W && p) {
            var L = m.memoizedState !== null, P = L || zC;
            if (P) {
              _m(a, s, C);
              continue;
            } else {
              var N = m.alternate, G = N !== null && N.memoizedState !== null, J = G || t1, h2 = zC, g2 = t1;
              zC = P, t1 = J, t1 && !g2 && (d0 = m, R22(m));
              for (var B2 = b; B2 !== null; )
                d0 = B2, FT(
                  B2,
                  // New root; bubble back up to here and stop.
                  s,
                  C
                ), B2 = B2.sibling;
              d0 = m, zC = h2, t1 = g2, _m(a, s, C);
              continue;
            }
          }
          (m.subtreeFlags & Rn) !== I0 && b !== null ? (b.return = m, d0 = b) : _m(a, s, C);
        }
      }
      function _m(a, s, C) {
        for (; d0 !== null; ) {
          var p = d0;
          if ((p.flags & Rn) !== I0) {
            var m = p.alternate;
            Pe(p);
            try {
              Q22(s, m, p, C);
            } catch (L) {
              ct(p, p.return, L);
            }
            lt();
          }
          if (p === a) {
            d0 = null;
            return;
          }
          var b = p.sibling;
          if (b !== null) {
            b.return = p.return, d0 = b;
            return;
          }
          d0 = p.return;
        }
      }
      function k22(a) {
        for (; d0 !== null; ) {
          var s = d0, C = s.child;
          switch (s.tag) {
            case f:
            case S:
            case D:
            case k: {
              if (s.mode & Ee)
                try {
                  t3(), rn(B5, s, s.return);
                } finally {
                  e3(s);
                }
              else
                rn(B5, s, s.return);
              break;
            }
            case d: {
              No(s, s.return);
              var p = s.stateNode;
              typeof p.componentWillUnmount == "function" && wm(s, s.return, p);
              break;
            }
            case y: {
              No(s, s.return);
              break;
            }
            case W: {
              var m = s.memoizedState !== null;
              if (m) {
                NT(a);
                continue;
              }
              break;
            }
          }
          C !== null ? (C.return = s, d0 = C) : NT(a);
        }
      }
      function NT(a) {
        for (; d0 !== null; ) {
          var s = d0;
          if (s === a) {
            d0 = null;
            return;
          }
          var C = s.sibling;
          if (C !== null) {
            C.return = s.return, d0 = C;
            return;
          }
          d0 = s.return;
        }
      }
      function R22(a) {
        for (; d0 !== null; ) {
          var s = d0, C = s.child;
          if (s.tag === W) {
            var p = s.memoizedState !== null;
            if (p) {
              HT(a);
              continue;
            }
          }
          C !== null ? (C.return = s, d0 = C) : HT(a);
        }
      }
      function HT(a) {
        for (; d0 !== null; ) {
          var s = d0;
          Pe(s);
          try {
            x22(s);
          } catch (p) {
            ct(s, s.return, p);
          }
          if (lt(), s === a) {
            d0 = null;
            return;
          }
          var C = s.sibling;
          if (C !== null) {
            C.return = s.return, d0 = C;
            return;
          }
          d0 = s.return;
        }
      }
      function P22(a, s, C, p) {
        d0 = s, F22(s, a, C, p);
      }
      function F22(a, s, C, p) {
        for (; d0 !== null; ) {
          var m = d0, b = m.child;
          (m.subtreeFlags & j4) !== I0 && b !== null ? (b.return = m, d0 = b) : N22(a, s, C, p);
        }
      }
      function N22(a, s, C, p) {
        for (; d0 !== null; ) {
          var m = d0;
          if ((m.flags & g1) !== I0) {
            Pe(m);
            try {
              H22(s, m, C, p);
            } catch (L) {
              ct(m, m.return, L);
            }
            lt();
          }
          if (m === a) {
            d0 = null;
            return;
          }
          var b = m.sibling;
          if (b !== null) {
            b.return = m.return, d0 = b;
            return;
          }
          d0 = m.return;
        }
      }
      function H22(a, s, C, p) {
        switch (s.tag) {
          case f:
          case S:
          case k: {
            if (s.mode & Ee) {
              $E();
              try {
                B6(J5 | I5, s);
              } finally {
                YE(s);
              }
            } else
              B6(J5 | I5, s);
            break;
          }
        }
      }
      function j22(a) {
        d0 = a, V22();
      }
      function V22() {
        for (; d0 !== null; ) {
          var a = d0, s = a.child;
          if ((d0.flags & nr) !== I0) {
            var C = a.deletions;
            if (C !== null) {
              for (var p = 0; p < C.length; p++) {
                var m = C[p];
                d0 = m, U22(m, a);
              }
              {
                var b = a.alternate;
                if (b !== null) {
                  var L = b.child;
                  if (L !== null) {
                    b.child = null;
                    do {
                      var P = L.sibling;
                      L.sibling = null, L = P;
                    } while (L !== null);
                  }
                }
              }
              d0 = a;
            }
          }
          (a.subtreeFlags & j4) !== I0 && s !== null ? (s.return = a, d0 = s) : Z22();
        }
      }
      function Z22() {
        for (; d0 !== null; ) {
          var a = d0;
          (a.flags & g1) !== I0 && (Pe(a), z22(a), lt());
          var s = a.sibling;
          if (s !== null) {
            s.return = a.return, d0 = s;
            return;
          }
          d0 = a.return;
        }
      }
      function z22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            a.mode & Ee ? ($E(), rn(J5 | I5, a, a.return), YE(a)) : rn(J5 | I5, a, a.return);
            break;
          }
        }
      }
      function U22(a, s) {
        for (; d0 !== null; ) {
          var C = d0;
          Pe(C), W22(C, s), lt();
          var p = C.child;
          p !== null ? (p.return = C, d0 = p) : q22(a);
        }
      }
      function q22(a) {
        for (; d0 !== null; ) {
          var s = d0, C = s.sibling, p = s.return;
          if (TT(s), s === a) {
            d0 = null;
            return;
          }
          if (C !== null) {
            C.return = p, d0 = C;
            return;
          }
          d0 = p;
        }
      }
      function W22(a, s) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            a.mode & Ee ? ($E(), rn(J5, a, s), YE(a)) : rn(J5, a, s);
            break;
          }
        }
      }
      function Y22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            try {
              B6(B5 | I5, a);
            } catch (C) {
              ct(a, a.return, C);
            }
            break;
          }
          case d: {
            var s = a.stateNode;
            try {
              s.componentDidMount();
            } catch (C) {
              ct(a, a.return, C);
            }
            break;
          }
        }
      }
      function $22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            try {
              B6(J5 | I5, a);
            } catch (s) {
              ct(a, a.return, s);
            }
            break;
          }
        }
      }
      function G22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k: {
            try {
              rn(B5 | I5, a, a.return);
            } catch (C) {
              ct(a, a.return, C);
            }
            break;
          }
          case d: {
            var s = a.stateNode;
            typeof s.componentWillUnmount == "function" && wm(a, a.return, s);
            break;
          }
        }
      }
      function K22(a) {
        switch (a.tag) {
          case f:
          case S:
          case k:
            try {
              rn(J5 | I5, a, a.return);
            } catch (s) {
              ct(a, a.return, s);
            }
        }
      }
      if (typeof Symbol == "function" && Symbol.for) {
        var ul = Symbol.for;
        ul("selector.component"), ul("selector.has_pseudo_class"), ul("selector.role"), ul("selector.test_id"), ul("selector.text");
      }
      var X22 = [];
      function J22() {
        X22.forEach(function(a) {
          return a();
        });
      }
      var e02 = r.ReactCurrentActQueue;
      function t02(a) {
        {
          var s = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
          ), C = typeof jest < "u";
          return C && s !== !1;
        }
      }
      function jT() {
        {
          var a = (
            // $FlowExpectedError – Flow doesn't know about IS_REACT_ACT_ENVIRONMENT global
            typeof IS_REACT_ACT_ENVIRONMENT < "u" ? IS_REACT_ACT_ENVIRONMENT : void 0
          );
          return !a && e02.current !== null && u("The current testing environment is not configured to support act(...)"), a;
        }
      }
      var r02 = Math.ceil, Om = r.ReactCurrentDispatcher, Tm = r.ReactCurrentOwner, n1 = r.ReactCurrentBatchConfig, on = r.ReactCurrentActQueue, b5 = (
        /*             */
        0
      ), VT = (
        /*               */
        1
      ), i1 = (
        /*                */
        2
      ), y4 = (
        /*                */
        4
      ), i8 = 0, ll = 1, di = 2, qC = 3, cl = 4, ZT = 5, Dm = 6, oe = b5, z1 = null, Ot = null, w5 = H2, n3 = H2, Lm = d6(H2), S5 = i8, Al = null, WC = H2, fl = H2, YC = H2, Cl = null, gr = null, km = 0, zT = 500, UT = 1 / 0, n02 = 500, a8 = null;
      function dl() {
        UT = e5() + n02;
      }
      function qT() {
        return UT;
      }
      var $C = !1, Rm = null, Ho = null, gi = !1, x6 = null, gl = H2, Pm = [], Fm = null, i02 = 50, pl = 0, Nm = null, Hm = !1, GC = !1, a02 = 50, jo = 0, KC = null, hl = Xe, XC = H2, WT = !1;
      function JC() {
        return z1;
      }
      function U1() {
        return (oe & (i1 | y4)) !== b5 ? e5() : (hl !== Xe || (hl = e5()), hl);
      }
      function b6(a) {
        var s = a.mode;
        if ((s & Y0) === B0)
          return O0;
        if ((oe & i1) !== b5 && w5 !== H2)
          return R7(w5);
        var C = eJ() !== JX;
        if (C) {
          if (n1.transition !== null) {
            var p = n1.transition;
            p._updatedFibers || (p._updatedFibers = /* @__PURE__ */ new Set()), p._updatedFibers.add(a);
          }
          return XC === Ce && (XC = au()), XC;
        }
        var m = cr();
        if (m !== Ce)
          return m;
        var b = FK();
        return b;
      }
      function o02(a) {
        var s = a.mode;
        return (s & Y0) === B0 ? O0 : rf();
      }
      function M5(a, s, C, p) {
        _02(), WT && u("useInsertionEffect must not schedule updates."), Hm && (GC = !0), n6(a, C, p), (oe & i1) !== H2 && a === z1 ? D02(s) : (E1 && N7(a, s, C), L02(s), a === z1 && ((oe & i1) === b5 && (fl = V0(fl, C)), S5 === cl && w6(a, w5)), pr(a, p), C === O0 && oe === b5 && (s.mode & Y0) === B0 && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
        !on.isBatchingLegacy && (dl(), W_()));
      }
      function s02(a, s, C) {
        var p = a.current;
        p.lanes = s, n6(a, s, C), pr(a, C);
      }
      function u02(a) {
        return (
          // TODO: Remove outdated deferRenderPhaseUpdateToNextBatch experiment. We
          // decided not to enable it.
          (oe & i1) !== b5
        );
      }
      function pr(a, s) {
        var C = a.callbackNode;
        $a(a, s);
        var p = Ya(a, a === z1 ? w5 : H2);
        if (p === H2) {
          C !== null && lD(C), a.callbackNode = null, a.callbackPriority = Ce;
          return;
        }
        var m = jn(p), b = a.callbackPriority;
        if (b === m && // Special case related to `act`. If the currently scheduled task is a
        // Scheduler task, rather than an `act` task, cancel it and re-scheduled
        // on the `act` queue.
        !(on.current !== null && C !== Wm)) {
          C == null && b !== O0 && u("Expected scheduled callback to exist. This error is likely caused by a bug in React. Please file an issue.");
          return;
        }
        C != null && lD(C);
        var L;
        if (m === O0)
          a.tag === g6 ? (on.isBatchingLegacy !== null && (on.didScheduleLegacyUpdate = !0), RX(GT.bind(null, a))) : q_(GT.bind(null, a)), on.current !== null ? on.current.push(p6) : HK(function() {
            (oe & (i1 | y4)) === b5 && p6();
          }), L = null;
        else {
          var P;
          switch (cf(p)) {
            case W5:
              P = I7;
              break;
            case A4:
              P = Pn;
              break;
            case ur:
              P = V4;
              break;
            case lr:
              P = T3;
              break;
            default:
              P = V4;
              break;
          }
          L = Ym(P, YT.bind(null, a));
        }
        a.callbackPriority = m, a.callbackNode = L;
      }
      function YT(a, s) {
        if (bJ(), hl = Xe, XC = H2, (oe & (i1 | y4)) !== b5)
          throw new Error("Should not already be working.");
        var C = a.callbackNode, p = s8();
        if (p && a.callbackNode !== C)
          return null;
        var m = Ya(a, a === z1 ? w5 : H2);
        if (m === H2)
          return null;
        var b = !Ka(a, m) && !tf(a, m) && !s, L = b ? v02(a, m) : td(a, m);
        if (L !== i8) {
          if (L === di) {
            var P = Ga(a);
            P !== H2 && (m = P, L = jm(a, P));
          }
          if (L === ll) {
            var N = Al;
            throw pi(a, H2), w6(a, m), pr(a, e5()), N;
          }
          if (L === Dm)
            w6(a, m);
          else {
            var G = !Ka(a, m), J = a.current.alternate;
            if (G && !c02(J)) {
              if (L = td(a, m), L === di) {
                var h2 = Ga(a);
                h2 !== H2 && (m = h2, L = jm(a, h2));
              }
              if (L === ll) {
                var g2 = Al;
                throw pi(a, H2), w6(a, m), pr(a, e5()), g2;
              }
            }
            a.finishedWork = J, a.finishedLanes = m, l02(a, L, m);
          }
        }
        return pr(a, e5()), a.callbackNode === C ? YT.bind(null, a) : null;
      }
      function jm(a, s) {
        var C = Cl;
        if (eo(a)) {
          var p = pi(a, s);
          p.flags |= d1, MX(a.containerInfo);
        }
        var m = td(a, s);
        if (m !== di) {
          var b = gr;
          gr = C, b !== null && $T(b);
        }
        return m;
      }
      function $T(a) {
        gr === null ? gr = a : gr.push.apply(gr, a);
      }
      function l02(a, s, C) {
        switch (s) {
          case i8:
          case ll:
            throw new Error("Root did not complete. This is a bug in React.");
          // Flow knows about invariant, so it complains if I add a break
          // statement, but eslint doesn't know about invariant, so it complains
          // if I do. eslint-disable-next-line no-fallthrough
          case di: {
            hi(a, gr, a8);
            break;
          }
          case qC: {
            if (w6(a, C), Z3(C) && // do not delay if we're inside an act() scope
            !cD()) {
              var p = km + zT - e5();
              if (p > 10) {
                var m = Ya(a, H2);
                if (m !== H2)
                  break;
                var b = a.suspendedLanes;
                if (!z3(b, C)) {
                  U1(), Xa(a, b);
                  break;
                }
                a.timeoutHandle = Fv(hi.bind(null, a, gr, a8), p);
                break;
              }
            }
            hi(a, gr, a8);
            break;
          }
          case cl: {
            if (w6(a, C), nu(C))
              break;
            if (!cD()) {
              var L = kr(a, C), P = L, N = e5() - P, G = M02(N) - N;
              if (G > 10) {
                a.timeoutHandle = Fv(hi.bind(null, a, gr, a8), G);
                break;
              }
            }
            hi(a, gr, a8);
            break;
          }
          case ZT: {
            hi(a, gr, a8);
            break;
          }
          default:
            throw new Error("Unknown root exit status.");
        }
      }
      function c02(a) {
        for (var s = a; ; ) {
          if (s.flags & X8) {
            var C = s.updateQueue;
            if (C !== null) {
              var p = C.stores;
              if (p !== null)
                for (var m = 0; m < p.length; m++) {
                  var b = p[m], L = b.getSnapshot, P = b.value;
                  try {
                    if (!Z2(L(), P))
                      return !1;
                  } catch {
                    return !1;
                  }
                }
            }
          }
          var N = s.child;
          if (s.subtreeFlags & X8 && N !== null) {
            N.return = s, s = N;
            continue;
          }
          if (s === a)
            return !0;
          for (; s.sibling === null; ) {
            if (s.return === null || s.return === a)
              return !0;
            s = s.return;
          }
          s.sibling.return = s.return, s = s.sibling;
        }
        return !0;
      }
      function w6(a, s) {
        s = P7(s, YC), s = P7(s, fl), of(a, s);
      }
      function GT(a) {
        if (wJ(), (oe & (i1 | y4)) !== b5)
          throw new Error("Should not already be working.");
        s8();
        var s = Ya(a, H2);
        if (!m1(s, O0))
          return pr(a, e5()), null;
        var C = td(a, s);
        if (a.tag !== g6 && C === di) {
          var p = Ga(a);
          p !== H2 && (s = p, C = jm(a, p));
        }
        if (C === ll) {
          var m = Al;
          throw pi(a, H2), w6(a, s), pr(a, e5()), m;
        }
        if (C === Dm)
          throw new Error("Root did not complete. This is a bug in React.");
        var b = a.current.alternate;
        return a.finishedWork = b, a.finishedLanes = s, hi(a, gr, a8), pr(a, e5()), null;
      }
      function A02(a, s) {
        s !== H2 && (Ja(a, V0(s, O0)), pr(a, e5()), (oe & (i1 | y4)) === b5 && (dl(), p6()));
      }
      function Vm(a, s) {
        var C = oe;
        oe |= VT;
        try {
          return a(s);
        } finally {
          oe = C, oe === b5 && // Treat `act` as if it's inside `batchedUpdates`, even in legacy mode.
          !on.isBatchingLegacy && (dl(), W_());
        }
      }
      function f02(a, s, C, p, m) {
        var b = cr(), L = n1.transition;
        try {
          return n1.transition = null, jt(W5), a(s, C, p, m);
        } finally {
          jt(b), n1.transition = L, oe === b5 && dl();
        }
      }
      function o8(a) {
        x6 !== null && x6.tag === g6 && (oe & (i1 | y4)) === b5 && s8();
        var s = oe;
        oe |= VT;
        var C = n1.transition, p = cr();
        try {
          return n1.transition = null, jt(W5), a ? a() : void 0;
        } finally {
          jt(p), n1.transition = C, oe = s, (oe & (i1 | y4)) === b5 && p6();
        }
      }
      function KT() {
        return (oe & (i1 | y4)) !== b5;
      }
      function ed(a, s) {
        x1(Lm, n3, a), n3 = V0(n3, s);
      }
      function Zm(a) {
        n3 = Lm.current, Q1(Lm, a);
      }
      function pi(a, s) {
        a.finishedWork = null, a.finishedLanes = H2;
        var C = a.timeoutHandle;
        if (C !== Nv && (a.timeoutHandle = Nv, NK(C)), Ot !== null)
          for (var p = Ot.return; p !== null; ) {
            var m = p.alternate;
            bT(m, p), p = p.return;
          }
        z1 = a;
        var b = vi(a.current, null);
        return Ot = b, w5 = n3 = s, S5 = i8, Al = null, WC = H2, fl = H2, YC = H2, Cl = null, gr = null, sJ(), K4.discardPendingWarnings(), b;
      }
      function XT(a, s) {
        do {
          var C = Ot;
          try {
            if (cC(), IO(), lt(), Tm.current = null, C === null || C.return === null) {
              S5 = ll, Al = s, Ot = null;
              return;
            }
            if (o2 && C.mode & Ee && NC(C, !0), r2)
              if (N1(), s !== null && typeof s == "object" && typeof s.then == "function") {
                var p = s;
                c4(C, p, w5);
              } else
                Q7(C, s, w5);
            RJ(a, C.return, C, s, w5), rD(C);
          } catch (m) {
            s = m, Ot === C && C !== null ? (C = C.return, Ot = C) : C = Ot;
            continue;
          }
          return;
        } while (!0);
      }
      function JT() {
        var a = Om.current;
        return Om.current = LC, a === null ? LC : a;
      }
      function eD(a) {
        Om.current = a;
      }
      function C02() {
        km = e5();
      }
      function vl(a) {
        WC = V0(a, WC);
      }
      function d02() {
        S5 === i8 && (S5 = qC);
      }
      function zm() {
        (S5 === i8 || S5 === qC || S5 === di) && (S5 = cl), z1 !== null && (k7(WC) || k7(fl)) && w6(z1, w5);
      }
      function g02(a) {
        S5 !== cl && (S5 = di), Cl === null ? Cl = [a] : Cl.push(a);
      }
      function p02() {
        return S5 === i8;
      }
      function td(a, s) {
        var C = oe;
        oe |= i1;
        var p = JT();
        if (z1 !== a || w5 !== s) {
          if (E1) {
            var m = a.memoizedUpdaters;
            m.size > 0 && (El(a, w5), m.clear()), sf(a, s);
          }
          a8 = lu(), pi(a, s);
        }
        R3(s);
        do
          try {
            h02();
            break;
          } catch (b) {
            XT(a, b);
          }
        while (!0);
        if (cC(), oe = C, eD(p), Ot !== null)
          throw new Error("Cannot commit an incomplete root. This error is likely caused by a bug in React. Please file an issue.");
        return _a(), z1 = null, w5 = H2, S5;
      }
      function h02() {
        for (; Ot !== null; )
          tD(Ot);
      }
      function v02(a, s) {
        var C = oe;
        oe |= i1;
        var p = JT();
        if (z1 !== a || w5 !== s) {
          if (E1) {
            var m = a.memoizedUpdaters;
            m.size > 0 && (El(a, w5), m.clear()), sf(a, s);
          }
          a8 = lu(), dl(), pi(a, s);
        }
        R3(s);
        do
          try {
            E02();
            break;
          } catch (b) {
            XT(a, b);
          }
        while (!0);
        return cC(), eD(p), oe = C, Ot !== null ? (KA(), i8) : (_a(), z1 = null, w5 = H2, S5);
      }
      function E02() {
        for (; Ot !== null && !Vs(); )
          tD(Ot);
      }
      function tD(a) {
        var s = a.alternate;
        Pe(a);
        var C;
        (a.mode & Ee) !== B0 ? (WE(a), C = Um(s, a, n3), NC(a, !0)) : C = Um(s, a, n3), lt(), a.memoizedProps = a.pendingProps, C === null ? rD(a) : Ot = C, Tm.current = null;
      }
      function rD(a) {
        var s = a;
        do {
          var C = s.alternate, p = s.return;
          if ((s.flags & y7) === I0) {
            Pe(s);
            var m = void 0;
            if ((s.mode & Ee) === B0 ? m = xT(C, s, n3) : (WE(s), m = xT(C, s, n3), NC(s, !1)), lt(), m !== null) {
              Ot = m;
              return;
            }
          } else {
            var b = d22(C, s);
            if (b !== null) {
              b.flags &= UA, Ot = b;
              return;
            }
            if ((s.mode & Ee) !== B0) {
              NC(s, !1);
              for (var L = s.actualDuration, P = s.child; P !== null; )
                L += P.actualDuration, P = P.sibling;
              s.actualDuration = L;
            }
            if (p !== null)
              p.flags |= y7, p.subtreeFlags = I0, p.deletions = null;
            else {
              S5 = Dm, Ot = null;
              return;
            }
          }
          var N = s.sibling;
          if (N !== null) {
            Ot = N;
            return;
          }
          s = p, Ot = s;
        } while (s !== null);
        S5 === i8 && (S5 = ZT);
      }
      function hi(a, s, C) {
        var p = cr(), m = n1.transition;
        try {
          n1.transition = null, jt(W5), m02(a, s, C, p);
        } finally {
          n1.transition = m, jt(p);
        }
        return null;
      }
      function m02(a, s, C, p) {
        do
          s8();
        while (x6 !== null);
        if (O02(), (oe & (i1 | y4)) !== b5)
          throw new Error("Should not already be working.");
        var m = a.finishedWork, b = a.finishedLanes;
        if (Ys(b), m === null)
          return $s(), null;
        if (b === H2 && u("root.finishedLanes should not be empty during a commit. This is a bug in React."), a.finishedWork = null, a.finishedLanes = H2, m === a.current)
          throw new Error("Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue.");
        a.callbackNode = null, a.callbackPriority = Ce;
        var L = V0(m.lanes, m.childLanes);
        su(a, L), a === z1 && (z1 = null, Ot = null, w5 = H2), ((m.subtreeFlags & j4) !== I0 || (m.flags & j4) !== I0) && (gi || (gi = !0, Fm = C, Ym(V4, function() {
          return s8(), null;
        })));
        var P = (m.subtreeFlags & (Ln | kn | Rn | j4)) !== I0, N = (m.flags & (Ln | kn | Rn | j4)) !== I0;
        if (P || N) {
          var G = n1.transition;
          n1.transition = null;
          var J = cr();
          jt(W5);
          var h2 = oe;
          oe |= y4, Tm.current = null, E22(a, m), WO(), D22(a, m, b), TK(a.containerInfo), a.current = m, x7(b), L22(m, a, b), b7(), Zs(), oe = h2, jt(J), n1.transition = G;
        } else
          a.current = m, WO();
        var g2 = gi;
        if (gi ? (gi = !1, x6 = a, gl = b) : (jo = 0, KC = null), L = a.pendingLanes, L === H2 && (Ho = null), g2 || oD(a.current, !1), Us(m.stateNode, p), E1 && a.memoizedUpdaters.clear(), J22(), pr(a, e5()), s !== null)
          for (var B2 = a.onRecoverableError, b2 = 0; b2 < s.length; b2++) {
            var T2 = s[b2], t0 = T2.stack, x0 = T2.digest;
            B2(T2.value, {
              componentStack: t0,
              digest: x0
            });
          }
        if ($C) {
          $C = !1;
          var m0 = Rm;
          throw Rm = null, m0;
        }
        return m1(gl, O0) && a.tag !== g6 && s8(), L = a.pendingLanes, m1(L, O0) ? (xJ(), a === Nm ? pl++ : (pl = 0, Nm = a)) : pl = 0, p6(), $s(), null;
      }
      function s8() {
        if (x6 !== null) {
          var a = cf(gl), s = j7(ur, a), C = n1.transition, p = cr();
          try {
            return n1.transition = null, jt(s), I02();
          } finally {
            jt(p), n1.transition = C;
          }
        }
        return !1;
      }
      function y02(a) {
        Pm.push(a), gi || (gi = !0, Ym(V4, function() {
          return s8(), null;
        }));
      }
      function I02() {
        if (x6 === null)
          return !1;
        var a = Fm;
        Fm = null;
        var s = x6, C = gl;
        if (x6 = null, gl = H2, (oe & (i1 | y4)) !== b5)
          throw new Error("Cannot flush passive effects while already rendering.");
        Hm = !0, GC = !1, k3(C);
        var p = oe;
        oe |= y4, j22(s.current), P22(s, s.current, C, a);
        {
          var m = Pm;
          Pm = [];
          for (var b = 0; b < m.length; b++) {
            var L = m[b];
            B22(s, L);
          }
        }
        Xs(), oD(s.current, !0), oe = p, p6(), GC ? s === KC ? jo++ : (jo = 0, KC = s) : jo = 0, Hm = !1, GC = !1, qs(s);
        {
          var P = s.current.stateNode;
          P.effectDuration = 0, P.passiveEffectDuration = 0;
        }
        return !0;
      }
      function nD(a) {
        return Ho !== null && Ho.has(a);
      }
      function B02(a) {
        Ho === null ? Ho = /* @__PURE__ */ new Set([a]) : Ho.add(a);
      }
      function Q02(a) {
        $C || ($C = !0, Rm = a);
      }
      var x02 = Q02;
      function iD(a, s, C) {
        var p = fi(C, s), m = tT(a, p, O0), b = v6(a, m, O0), L = U1();
        b !== null && (n6(b, O0, L), pr(b, L));
      }
      function ct(a, s, C) {
        if (p22(C), ml(!1), a.tag === h) {
          iD(a, a, C);
          return;
        }
        var p = null;
        for (p = s; p !== null; ) {
          if (p.tag === h) {
            iD(p, a, C);
            return;
          } else if (p.tag === d) {
            var m = p.type, b = p.stateNode;
            if (typeof m.getDerivedStateFromError == "function" || typeof b.componentDidCatch == "function" && !nD(b)) {
              var L = fi(C, a), P = Am(p, L, O0), N = v6(p, P, O0), G = U1();
              N !== null && (n6(N, O0, G), pr(N, G));
              return;
            }
          }
          p = p.return;
        }
        u(`Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Likely causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.

Error message:

%s`, C);
      }
      function b02(a, s, C) {
        var p = a.pingCache;
        p !== null && p.delete(s);
        var m = U1();
        Xa(a, C), k02(a), z1 === a && z3(w5, C) && (S5 === cl || S5 === qC && Z3(w5) && e5() - km < zT ? pi(a, H2) : YC = V0(YC, C)), pr(a, m);
      }
      function aD(a, s) {
        s === Ce && (s = o02(a));
        var C = U1(), p = Cr(a, s);
        p !== null && (n6(p, s, C), pr(p, C));
      }
      function w02(a) {
        var s = a.memoizedState, C = Ce;
        s !== null && (C = s.retryLane), aD(a, C);
      }
      function S02(a, s) {
        var C = Ce, p;
        switch (a.tag) {
          case w:
            p = a.stateNode;
            var m = a.memoizedState;
            m !== null && (C = m.retryLane);
            break;
          case V:
            p = a.stateNode;
            break;
          default:
            throw new Error("Pinged unknown suspense boundary type. This is probably a bug in React.");
        }
        p !== null && p.delete(s), aD(a, C);
      }
      function M02(a) {
        return a < 120 ? 120 : a < 480 ? 480 : a < 1080 ? 1080 : a < 1920 ? 1920 : a < 3e3 ? 3e3 : a < 4320 ? 4320 : r02(a / 1960) * 1960;
      }
      function _02() {
        if (pl > i02)
          throw pl = 0, Nm = null, new Error("Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops.");
        jo > a02 && (jo = 0, KC = null, u("Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."));
      }
      function O02() {
        K4.flushLegacyContextWarning(), K4.flushPendingUnsafeLifecycleWarnings();
      }
      function oD(a, s) {
        Pe(a), rd(a, Dn, G22), s && rd(a, s4, K22), rd(a, Dn, Y22), s && rd(a, s4, $22), lt();
      }
      function rd(a, s, C) {
        for (var p = a, m = null; p !== null; ) {
          var b = p.subtreeFlags & s;
          p !== m && p.child !== null && b !== I0 ? p = p.child : ((p.flags & s) !== I0 && C(p), p.sibling !== null ? p = p.sibling : p = m = p.return);
        }
      }
      var nd = null;
      function sD(a) {
        {
          if ((oe & i1) !== b5 || !(a.mode & Y0))
            return;
          var s = a.tag;
          if (s !== g && s !== h && s !== d && s !== f && s !== S && s !== D && s !== k)
            return;
          var C = R0(a) || "ReactComponent";
          if (nd !== null) {
            if (nd.has(C))
              return;
            nd.add(C);
          } else
            nd = /* @__PURE__ */ new Set([C]);
          var p = h5;
          try {
            Pe(a), u("Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously later calls tries to update the component. Move this work to useEffect instead.");
          } finally {
            p ? Pe(a) : lt();
          }
        }
      }
      var Um;
      {
        var T02 = null;
        Um = function(a, s, C) {
          var p = gD(T02, s);
          try {
            return mT(a, s, C);
          } catch (b) {
            if (zX() || b !== null && typeof b == "object" && typeof b.then == "function")
              throw b;
            if (cC(), IO(), bT(a, s), gD(s, p), s.mode & Ee && WE(s), Tn(null, mT, null, a, s, C), N4()) {
              var m = m7();
              typeof m == "object" && m !== null && m._suppressLogging && typeof b == "object" && b !== null && !b._suppressLogging && (b._suppressLogging = !0);
            }
            throw b;
          }
        };
      }
      var uD = !1, qm;
      qm = /* @__PURE__ */ new Set();
      function D02(a) {
        if (e4 && !IJ())
          switch (a.tag) {
            case f:
            case S:
            case k: {
              var s = Ot && R0(Ot) || "Unknown", C = s;
              if (!qm.has(C)) {
                qm.add(C);
                var p = R0(a) || "Unknown";
                u("Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://reactjs.org/link/setstate-in-render", p, s, s);
              }
              break;
            }
            case d: {
              uD || (u("Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."), uD = !0);
              break;
            }
          }
      }
      function El(a, s) {
        if (E1) {
          var C = a.memoizedUpdaters;
          C.forEach(function(p) {
            N7(a, p, s);
          });
        }
      }
      var Wm = {};
      function Ym(a, s) {
        {
          var C = on.current;
          return C !== null ? (C.push(s), Wm) : js(a, s);
        }
      }
      function lD(a) {
        if (a !== Wm)
          return WA(a);
      }
      function cD() {
        return on.current !== null;
      }
      function L02(a) {
        {
          if (a.mode & Y0) {
            if (!jT())
              return;
          } else if (!t02() || oe !== b5 || a.tag !== f && a.tag !== S && a.tag !== k)
            return;
          if (on.current === null) {
            var s = h5;
            try {
              Pe(a), u(`An update to %s inside a test was not wrapped in act(...).

When testing, code that causes React state updates should be wrapped into act(...):

act(() => {
  /* fire events that update state */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`, R0(a));
            } finally {
              s ? Pe(a) : lt();
            }
          }
        }
      }
      function k02(a) {
        a.tag !== g6 && jT() && on.current === null && u(`A suspended resource finished loading inside a test, but the event was not wrapped in act(...).

When testing, code that resolves suspended data should be wrapped into act(...):

act(() => {
  /* finish loading suspended data */
});
/* assert on the output */

This ensures that you're testing the behavior the user would see in the browser. Learn more at https://reactjs.org/link/wrap-tests-with-act`);
      }
      function ml(a) {
        WT = a;
      }
      var I4 = null, Vo = null, R02 = function(a) {
        I4 = a;
      };
      function Zo(a) {
        {
          if (I4 === null)
            return a;
          var s = I4(a);
          return s === void 0 ? a : s.current;
        }
      }
      function $m(a) {
        return Zo(a);
      }
      function Gm(a) {
        {
          if (I4 === null)
            return a;
          var s = I4(a);
          if (s === void 0) {
            if (a != null && typeof a.render == "function") {
              var C = Zo(a.render);
              if (a.render !== C) {
                var p = {
                  $$typeof: N2,
                  render: C
                };
                return a.displayName !== void 0 && (p.displayName = a.displayName), p;
              }
            }
            return a;
          }
          return s.current;
        }
      }
      function AD(a, s) {
        {
          if (I4 === null)
            return !1;
          var C = a.elementType, p = s.type, m = !1, b = typeof p == "object" && p !== null ? p.$$typeof : null;
          switch (a.tag) {
            case d: {
              typeof p == "function" && (m = !0);
              break;
            }
            case f: {
              (typeof p == "function" || b === P0) && (m = !0);
              break;
            }
            case S: {
              (b === N2 || b === P0) && (m = !0);
              break;
            }
            case D:
            case k: {
              (b === H0 || b === P0) && (m = !0);
              break;
            }
            default:
              return !1;
          }
          if (m) {
            var L = I4(C);
            if (L !== void 0 && L === I4(p))
              return !0;
          }
          return !1;
        }
      }
      function fD(a) {
        {
          if (I4 === null || typeof WeakSet != "function")
            return;
          Vo === null && (Vo = /* @__PURE__ */ new WeakSet()), Vo.add(a);
        }
      }
      var P02 = function(a, s) {
        {
          if (I4 === null)
            return;
          var C = s.staleFamilies, p = s.updatedFamilies;
          s8(), o8(function() {
            Km(a.current, p, C);
          });
        }
      }, F02 = function(a, s) {
        {
          if (a.context !== Fr)
            return;
          s8(), o8(function() {
            yl(s, a, null, null);
          });
        }
      };
      function Km(a, s, C) {
        {
          var p = a.alternate, m = a.child, b = a.sibling, L = a.tag, P = a.type, N = null;
          switch (L) {
            case f:
            case k:
            case d:
              N = P;
              break;
            case S:
              N = P.render;
              break;
          }
          if (I4 === null)
            throw new Error("Expected resolveFamily to be set during hot reload.");
          var G = !1, J = !1;
          if (N !== null) {
            var h2 = I4(N);
            h2 !== void 0 && (C.has(h2) ? J = !0 : s.has(h2) && (L === d ? J = !0 : G = !0));
          }
          if (Vo !== null && (Vo.has(a) || p !== null && Vo.has(p)) && (J = !0), J && (a._debugNeedsRemount = !0), J || G) {
            var g2 = Cr(a, O0);
            g2 !== null && M5(g2, a, O0, Xe);
          }
          m !== null && !J && Km(m, s, C), b !== null && Km(b, s, C);
        }
      }
      var N02 = function(a, s) {
        {
          var C = /* @__PURE__ */ new Set(), p = new Set(s.map(function(m) {
            return m.current;
          }));
          return Xm(a.current, p, C), C;
        }
      };
      function Xm(a, s, C) {
        {
          var p = a.child, m = a.sibling, b = a.tag, L = a.type, P = null;
          switch (b) {
            case f:
            case k:
            case d:
              P = L;
              break;
            case S:
              P = L.render;
              break;
          }
          var N = !1;
          P !== null && s.has(P) && (N = !0), N ? H02(a, C) : p !== null && Xm(p, s, C), m !== null && Xm(m, s, C);
        }
      }
      function H02(a, s) {
        {
          var C = j02(a, s);
          if (C)
            return;
          for (var p = a; ; ) {
            switch (p.tag) {
              case y:
                s.add(p.stateNode);
                return;
              case E:
                s.add(p.stateNode.containerInfo);
                return;
              case h:
                s.add(p.stateNode.containerInfo);
                return;
            }
            if (p.return === null)
              throw new Error("Expected to reach root first.");
            p = p.return;
          }
        }
      }
      function j02(a, s) {
        for (var C = a, p = !1; ; ) {
          if (C.tag === y)
            p = !0, s.add(C.stateNode);
          else if (C.child !== null) {
            C.child.return = C, C = C.child;
            continue;
          }
          if (C === a)
            return p;
          for (; C.sibling === null; ) {
            if (C.return === null || C.return === a)
              return p;
            C = C.return;
          }
          C.sibling.return = C.return, C = C.sibling;
        }
        return !1;
      }
      var Jm;
      {
        Jm = !1;
        try {
          var CD = Object.preventExtensions({});
        } catch {
          Jm = !0;
        }
      }
      function V02(a, s, C, p) {
        this.tag = a, this.key = C, this.elementType = null, this.type = null, this.stateNode = null, this.return = null, this.child = null, this.sibling = null, this.index = 0, this.ref = null, this.pendingProps = s, this.memoizedProps = null, this.updateQueue = null, this.memoizedState = null, this.dependencies = null, this.mode = p, this.flags = I0, this.subtreeFlags = I0, this.deletions = null, this.lanes = H2, this.childLanes = H2, this.alternate = null, this.actualDuration = Number.NaN, this.actualStartTime = Number.NaN, this.selfBaseDuration = Number.NaN, this.treeBaseDuration = Number.NaN, this.actualDuration = 0, this.actualStartTime = -1, this.selfBaseDuration = 0, this.treeBaseDuration = 0, this._debugSource = null, this._debugOwner = null, this._debugNeedsRemount = !1, this._debugHookTypes = null, !Jm && typeof Object.preventExtensions == "function" && Object.preventExtensions(this);
      }
      var Nr = function(a, s, C, p) {
        return new V02(a, s, C, p);
      };
      function ey(a) {
        var s = a.prototype;
        return !!(s && s.isReactComponent);
      }
      function Z02(a) {
        return typeof a == "function" && !ey(a) && a.defaultProps === void 0;
      }
      function z02(a) {
        if (typeof a == "function")
          return ey(a) ? d : f;
        if (a != null) {
          var s = a.$$typeof;
          if (s === N2)
            return S;
          if (s === H0)
            return D;
        }
        return g;
      }
      function vi(a, s) {
        var C = a.alternate;
        C === null ? (C = Nr(a.tag, s, a.key, a.mode), C.elementType = a.elementType, C.type = a.type, C.stateNode = a.stateNode, C._debugSource = a._debugSource, C._debugOwner = a._debugOwner, C._debugHookTypes = a._debugHookTypes, C.alternate = a, a.alternate = C) : (C.pendingProps = s, C.type = a.type, C.flags = I0, C.subtreeFlags = I0, C.deletions = null, C.actualDuration = 0, C.actualStartTime = -1), C.flags = a.flags & Ft, C.childLanes = a.childLanes, C.lanes = a.lanes, C.child = a.child, C.memoizedProps = a.memoizedProps, C.memoizedState = a.memoizedState, C.updateQueue = a.updateQueue;
        var p = a.dependencies;
        switch (C.dependencies = p === null ? null : {
          lanes: p.lanes,
          firstContext: p.firstContext
        }, C.sibling = a.sibling, C.index = a.index, C.ref = a.ref, C.selfBaseDuration = a.selfBaseDuration, C.treeBaseDuration = a.treeBaseDuration, C._debugNeedsRemount = a._debugNeedsRemount, C.tag) {
          case g:
          case f:
          case k:
            C.type = Zo(a.type);
            break;
          case d:
            C.type = $m(a.type);
            break;
          case S:
            C.type = Gm(a.type);
            break;
        }
        return C;
      }
      function U02(a, s) {
        a.flags &= Ft | xt;
        var C = a.alternate;
        if (C === null)
          a.childLanes = H2, a.lanes = s, a.child = null, a.subtreeFlags = I0, a.memoizedProps = null, a.memoizedState = null, a.updateQueue = null, a.dependencies = null, a.stateNode = null, a.selfBaseDuration = 0, a.treeBaseDuration = 0;
        else {
          a.childLanes = C.childLanes, a.lanes = C.lanes, a.child = C.child, a.subtreeFlags = I0, a.deletions = null, a.memoizedProps = C.memoizedProps, a.memoizedState = C.memoizedState, a.updateQueue = C.updateQueue, a.type = C.type;
          var p = C.dependencies;
          a.dependencies = p === null ? null : {
            lanes: p.lanes,
            firstContext: p.firstContext
          }, a.selfBaseDuration = C.selfBaseDuration, a.treeBaseDuration = C.treeBaseDuration;
        }
        return a;
      }
      function q02(a, s, C) {
        var p;
        return a === eC ? (p = Y0, s === !0 && (p |= He, p |= me)) : p = B0, E1 && (p |= Ee), Nr(h, null, null, p);
      }
      function ty(a, s, C, p, m, b) {
        var L = g, P = a;
        if (typeof a == "function")
          ey(a) ? (L = d, P = $m(P)) : P = Zo(P);
        else if (typeof a == "string")
          L = y;
        else
          e: switch (a) {
            case Kt:
              return S6(C.children, m, b, s);
            case A1:
              L = B, m |= He, (m & Y0) !== B0 && (m |= me);
              break;
            case X1:
              return W02(C, m, b, s);
            case J2:
              return Y02(C, m, b, s);
            case l0:
              return $02(C, m, b, s);
            case Qt:
              return dD(C, m, b, s);
            case it:
            // eslint-disable-next-line no-fallthrough
            case K0:
            // eslint-disable-next-line no-fallthrough
            case ut:
            // eslint-disable-next-line no-fallthrough
            case p5:
            // eslint-disable-next-line no-fallthrough
            case W0:
            // eslint-disable-next-line no-fallthrough
            default: {
              if (typeof a == "object" && a !== null)
                switch (a.$$typeof) {
                  case Xr:
                    L = M;
                    break e;
                  case c2:
                    L = _;
                    break e;
                  case N2:
                    L = S, P = Gm(P);
                    break e;
                  case H0:
                    L = D;
                    break e;
                  case P0:
                    L = F, P = null;
                    break e;
                }
              var N = "";
              {
                (a === void 0 || typeof a == "object" && a !== null && Object.keys(a).length === 0) && (N += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
                var G = p ? R0(p) : null;
                G && (N += `

Check the render method of \`` + G + "`.");
              }
              throw new Error("Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) " + ("but got: " + (a == null ? a : typeof a) + "." + N));
            }
          }
        var J = Nr(L, C, s, m);
        return J.elementType = a, J.type = P, J.lanes = b, J._debugOwner = p, J;
      }
      function ry(a, s, C) {
        var p = null;
        p = a._owner;
        var m = a.type, b = a.key, L = a.props, P = ty(m, b, L, p, s, C);
        return P._debugSource = a._source, P._debugOwner = a._owner, P;
      }
      function S6(a, s, C, p) {
        var m = Nr(Q, a, p, s);
        return m.lanes = C, m;
      }
      function W02(a, s, C, p) {
        typeof a.id != "string" && u('Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.', typeof a.id);
        var m = Nr(O, a, p, s | Ee);
        return m.elementType = X1, m.lanes = C, m.stateNode = {
          effectDuration: 0,
          passiveEffectDuration: 0
        }, m;
      }
      function Y02(a, s, C, p) {
        var m = Nr(w, a, p, s);
        return m.elementType = J2, m.lanes = C, m;
      }
      function $02(a, s, C, p) {
        var m = Nr(V, a, p, s);
        return m.elementType = l0, m.lanes = C, m;
      }
      function dD(a, s, C, p) {
        var m = Nr(W, a, p, s);
        m.elementType = Qt, m.lanes = C;
        var b = {
          isHidden: !1
        };
        return m.stateNode = b, m;
      }
      function ny(a, s, C) {
        var p = Nr(I, a, null, s);
        return p.lanes = C, p;
      }
      function G02() {
        var a = Nr(y, null, null, B0);
        return a.elementType = "DELETED", a;
      }
      function K02(a) {
        var s = Nr(Z, null, null, B0);
        return s.stateNode = a, s;
      }
      function iy(a, s, C) {
        var p = a.children !== null ? a.children : [], m = Nr(E, p, a.key, s);
        return m.lanes = C, m.stateNode = {
          containerInfo: a.containerInfo,
          pendingChildren: null,
          // Used by persistent updates
          implementation: a.implementation
        }, m;
      }
      function gD(a, s) {
        return a === null && (a = Nr(g, null, null, B0)), a.tag = s.tag, a.key = s.key, a.elementType = s.elementType, a.type = s.type, a.stateNode = s.stateNode, a.return = s.return, a.child = s.child, a.sibling = s.sibling, a.index = s.index, a.ref = s.ref, a.pendingProps = s.pendingProps, a.memoizedProps = s.memoizedProps, a.updateQueue = s.updateQueue, a.memoizedState = s.memoizedState, a.dependencies = s.dependencies, a.mode = s.mode, a.flags = s.flags, a.subtreeFlags = s.subtreeFlags, a.deletions = s.deletions, a.lanes = s.lanes, a.childLanes = s.childLanes, a.alternate = s.alternate, a.actualDuration = s.actualDuration, a.actualStartTime = s.actualStartTime, a.selfBaseDuration = s.selfBaseDuration, a.treeBaseDuration = s.treeBaseDuration, a._debugSource = s._debugSource, a._debugOwner = s._debugOwner, a._debugNeedsRemount = s._debugNeedsRemount, a._debugHookTypes = s._debugHookTypes, a;
      }
      function X02(a, s, C, p, m) {
        this.tag = s, this.containerInfo = a, this.pendingChildren = null, this.current = null, this.pingCache = null, this.finishedWork = null, this.timeoutHandle = Nv, this.context = null, this.pendingContext = null, this.callbackNode = null, this.callbackPriority = Ce, this.eventTimes = F7(H2), this.expirationTimes = F7(Xe), this.pendingLanes = H2, this.suspendedLanes = H2, this.pingedLanes = H2, this.expiredLanes = H2, this.mutableReadLanes = H2, this.finishedLanes = H2, this.entangledLanes = H2, this.entanglements = F7(H2), this.identifierPrefix = p, this.onRecoverableError = m, this.mutableSourceEagerHydrationData = null, this.effectDuration = 0, this.passiveEffectDuration = 0;
        {
          this.memoizedUpdaters = /* @__PURE__ */ new Set();
          for (var b = this.pendingUpdatersLaneMap = [], L = 0; L < P3; L++)
            b.push(/* @__PURE__ */ new Set());
        }
        switch (s) {
          case eC:
            this._debugRootType = C ? "hydrateRoot()" : "createRoot()";
            break;
          case g6:
            this._debugRootType = C ? "hydrate()" : "render()";
            break;
        }
      }
      function pD(a, s, C, p, m, b, L, P, N, G) {
        var J = new X02(a, s, C, P, N), h2 = q02(s, b);
        J.current = h2, h2.stateNode = J;
        {
          var g2 = {
            element: p,
            isDehydrated: C,
            cache: null,
            // not enabled yet
            transitions: null,
            pendingSuspenseBoundaries: null
          };
          h2.memoizedState = g2;
        }
        return hE(h2), J;
      }
      var ay = "18.3.1";
      function J02(a, s, C) {
        var p = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        return G0(p), {
          // This tag allow us to uniquely identify this as a React Portal
          $$typeof: xe,
          key: p == null ? null : "" + p,
          children: a,
          containerInfo: s,
          implementation: C
        };
      }
      var oy, sy;
      oy = !1, sy = {};
      function hD(a) {
        if (!a)
          return Fr;
        var s = K8(a), C = kX(s);
        if (s.tag === d) {
          var p = s.type;
          if (Gn(p))
            return z_(s, p, C);
        }
        return C;
      }
      function ee2(a, s) {
        {
          var C = K8(a);
          if (C === void 0) {
            if (typeof a.render == "function")
              throw new Error("Unable to find node on an unmounted component.");
            var p = Object.keys(a).join(",");
            throw new Error("Argument appears to not be a ReactComponent. Keys: " + p);
          }
          var m = h1(C);
          if (m === null)
            return null;
          if (m.mode & He) {
            var b = R0(C) || "Component";
            if (!sy[b]) {
              sy[b] = !0;
              var L = h5;
              try {
                Pe(m), C.mode & He ? u("%s is deprecated in StrictMode. %s was passed an instance of %s which is inside StrictMode. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", s, s, b) : u("%s is deprecated in StrictMode. %s was passed an instance of %s which renders StrictMode children. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node", s, s, b);
              } finally {
                L ? Pe(L) : lt();
              }
            }
          }
          return m.stateNode;
        }
      }
      function vD(a, s, C, p, m, b, L, P) {
        var N = !1, G = null;
        return pD(a, s, N, G, C, p, m, b, L);
      }
      function ED(a, s, C, p, m, b, L, P, N, G) {
        var J = !0, h2 = pD(C, p, J, a, m, b, L, P, N);
        h2.context = hD(null);
        var g2 = h2.current, B2 = U1(), b2 = b6(g2), T2 = r8(B2, b2);
        return T2.callback = s ?? null, v6(g2, T2, b2), s02(h2, b2, B2), h2;
      }
      function yl(a, s, C, p) {
        zs(s, a);
        var m = s.current, b = U1(), L = b6(m);
        vt(L);
        var P = hD(C);
        s.context === null ? s.context = P : s.pendingContext = P, e4 && h5 !== null && !oy && (oy = !0, u(`Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.

Check the render method of %s.`, R0(h5) || "Unknown"));
        var N = r8(b, L);
        N.payload = {
          element: a
        }, p = p === void 0 ? null : p, p !== null && (typeof p != "function" && u("render(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", p), N.callback = p);
        var G = v6(m, N, L);
        return G !== null && (M5(G, m, L, b), gC(G, m, L)), L;
      }
      function id(a) {
        var s = a.current;
        if (!s.child)
          return null;
        switch (s.child.tag) {
          case y:
            return s.child.stateNode;
          default:
            return s.child.stateNode;
        }
      }
      function te2(a) {
        switch (a.tag) {
          case h: {
            var s = a.stateNode;
            if (eo(s)) {
              var C = JA(s);
              A02(s, C);
            }
            break;
          }
          case w: {
            o8(function() {
              var m = Cr(a, O0);
              if (m !== null) {
                var b = U1();
                M5(m, a, O0, b);
              }
            });
            var p = O0;
            uy(a, p);
            break;
          }
        }
      }
      function mD(a, s) {
        var C = a.memoizedState;
        C !== null && C.dehydrated !== null && (C.retryLane = af(C.retryLane, s));
      }
      function uy(a, s) {
        mD(a, s);
        var C = a.alternate;
        C && mD(C, s);
      }
      function re2(a) {
        if (a.tag === w) {
          var s = T7, C = Cr(a, s);
          if (C !== null) {
            var p = U1();
            M5(C, a, s, p);
          }
          uy(a, s);
        }
      }
      function ne2(a) {
        if (a.tag === w) {
          var s = b6(a), C = Cr(a, s);
          if (C !== null) {
            var p = U1();
            M5(C, a, s, p);
          }
          uy(a, s);
        }
      }
      function yD(a) {
        var s = Ct(a);
        return s === null ? null : s.stateNode;
      }
      var ID = function(a) {
        return null;
      };
      function ie2(a) {
        return ID(a);
      }
      var BD = function(a) {
        return !1;
      };
      function ae2(a) {
        return BD(a);
      }
      var QD = null, xD = null, bD = null, wD = null, SD = null, MD = null, _D = null, OD = null, TD = null;
      {
        var DD = function(a, s, C) {
          var p = s[C], m = q0(a) ? a.slice() : z0({}, a);
          return C + 1 === s.length ? (q0(m) ? m.splice(p, 1) : delete m[p], m) : (m[p] = DD(a[p], s, C + 1), m);
        }, LD = function(a, s) {
          return DD(a, s, 0);
        }, kD = function(a, s, C, p) {
          var m = s[p], b = q0(a) ? a.slice() : z0({}, a);
          if (p + 1 === s.length) {
            var L = C[p];
            b[L] = b[m], q0(b) ? b.splice(m, 1) : delete b[m];
          } else
            b[m] = kD(
              // $FlowFixMe number or string is fine here
              a[m],
              s,
              C,
              p + 1
            );
          return b;
        }, RD = function(a, s, C) {
          if (s.length !== C.length) {
            o("copyWithRename() expects paths of the same length");
            return;
          } else
            for (var p = 0; p < C.length - 1; p++)
              if (s[p] !== C[p]) {
                o("copyWithRename() expects paths to be the same except for the deepest key");
                return;
              }
          return kD(a, s, C, 0);
        }, PD = function(a, s, C, p) {
          if (C >= s.length)
            return p;
          var m = s[C], b = q0(a) ? a.slice() : z0({}, a);
          return b[m] = PD(a[m], s, C + 1, p), b;
        }, FD = function(a, s, C) {
          return PD(a, s, 0, C);
        }, ly = function(a, s) {
          for (var C = a.memoizedState; C !== null && s > 0; )
            C = C.next, s--;
          return C;
        };
        QD = function(a, s, C, p) {
          var m = ly(a, s);
          if (m !== null) {
            var b = FD(m.memoizedState, C, p);
            m.memoizedState = b, m.baseState = b, a.memoizedProps = z0({}, a.memoizedProps);
            var L = Cr(a, O0);
            L !== null && M5(L, a, O0, Xe);
          }
        }, xD = function(a, s, C) {
          var p = ly(a, s);
          if (p !== null) {
            var m = LD(p.memoizedState, C);
            p.memoizedState = m, p.baseState = m, a.memoizedProps = z0({}, a.memoizedProps);
            var b = Cr(a, O0);
            b !== null && M5(b, a, O0, Xe);
          }
        }, bD = function(a, s, C, p) {
          var m = ly(a, s);
          if (m !== null) {
            var b = RD(m.memoizedState, C, p);
            m.memoizedState = b, m.baseState = b, a.memoizedProps = z0({}, a.memoizedProps);
            var L = Cr(a, O0);
            L !== null && M5(L, a, O0, Xe);
          }
        }, wD = function(a, s, C) {
          a.pendingProps = FD(a.memoizedProps, s, C), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var p = Cr(a, O0);
          p !== null && M5(p, a, O0, Xe);
        }, SD = function(a, s) {
          a.pendingProps = LD(a.memoizedProps, s), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var C = Cr(a, O0);
          C !== null && M5(C, a, O0, Xe);
        }, MD = function(a, s, C) {
          a.pendingProps = RD(a.memoizedProps, s, C), a.alternate && (a.alternate.pendingProps = a.pendingProps);
          var p = Cr(a, O0);
          p !== null && M5(p, a, O0, Xe);
        }, _D = function(a) {
          var s = Cr(a, O0);
          s !== null && M5(s, a, O0, Xe);
        }, OD = function(a) {
          ID = a;
        }, TD = function(a) {
          BD = a;
        };
      }
      function oe2(a) {
        var s = h1(a);
        return s === null ? null : s.stateNode;
      }
      function se2(a) {
        return null;
      }
      function ue2() {
        return h5;
      }
      function le2(a) {
        var s = a.findFiberByHostInstance, C = r.ReactCurrentDispatcher;
        return e6({
          bundleType: a.bundleType,
          version: a.version,
          rendererPackageName: a.rendererPackageName,
          rendererConfig: a.rendererConfig,
          overrideHookState: QD,
          overrideHookStateDeletePath: xD,
          overrideHookStateRenamePath: bD,
          overrideProps: wD,
          overridePropsDeletePath: SD,
          overridePropsRenamePath: MD,
          setErrorHandler: OD,
          setSuspenseHandler: TD,
          scheduleUpdate: _D,
          currentDispatcherRef: C,
          findHostInstanceByFiber: oe2,
          findFiberByHostInstance: s || se2,
          // React Refresh
          findHostInstancesForRefresh: N02,
          scheduleRefresh: P02,
          scheduleRoot: F02,
          setRefreshHandler: R02,
          // Enables DevTools to append owner stacks to error messages in DEV mode.
          getCurrentFiber: ue2,
          // Enables DevTools to detect reconciler version rather than renderer version
          // which may not match for third party renderers.
          reconcilerVersion: ay
        });
      }
      var ND = typeof reportError == "function" ? (
        // In modern browsers, reportError will dispatch an error event,
        // emulating an uncaught JavaScript error.
        reportError
      ) : function(a) {
        console.error(a);
      };
      function cy(a) {
        this._internalRoot = a;
      }
      ad.prototype.render = cy.prototype.render = function(a) {
        var s = this._internalRoot;
        if (s === null)
          throw new Error("Cannot update an unmounted root.");
        {
          typeof arguments[1] == "function" ? u("render(...): does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().") : od(arguments[1]) ? u("You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root.") : typeof arguments[1] < "u" && u("You passed a second argument to root.render(...) but it only accepts one argument.");
          var C = s.containerInfo;
          if (C.nodeType !== Rt) {
            var p = yD(s.current);
            p && p.parentNode !== C && u("render(...): It looks like the React-rendered content of the root container was removed without using React. This is not supported and will cause errors. Instead, call root.unmount() to empty a root's container.");
          }
        }
        yl(a, s, null, null);
      }, ad.prototype.unmount = cy.prototype.unmount = function() {
        typeof arguments[0] == "function" && u("unmount(...): does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect().");
        var a = this._internalRoot;
        if (a !== null) {
          this._internalRoot = null;
          var s = a.containerInfo;
          KT() && u("Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."), o8(function() {
            yl(null, a, null, null);
          }), N_(s);
        }
      };
      function ce2(a, s) {
        if (!od(a))
          throw new Error("createRoot(...): Target container is not a DOM element.");
        HD(a);
        var C = !1, p = !1, m = "", b = ND;
        s != null && (s.hydrate ? o("hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead.") : typeof s == "object" && s !== null && s.$$typeof === o5 && u(`You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:

  let root = createRoot(domContainer);
  root.render(<App />);`), s.unstable_strictMode === !0 && (C = !0), s.identifierPrefix !== void 0 && (m = s.identifierPrefix), s.onRecoverableError !== void 0 && (b = s.onRecoverableError), s.transitionCallbacks !== void 0 && s.transitionCallbacks);
        var L = vD(a, eC, null, C, p, m, b);
        Wf(L.current, a);
        var P = a.nodeType === Rt ? a.parentNode : a;
        return wu(P), new cy(L);
      }
      function ad(a) {
        this._internalRoot = a;
      }
      function Ae2(a) {
        a && gf(a);
      }
      ad.prototype.unstable_scheduleHydration = Ae2;
      function fe2(a, s, C) {
        if (!od(a))
          throw new Error("hydrateRoot(...): Target container is not a DOM element.");
        HD(a), s === void 0 && u("Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)");
        var p = C ?? null, m = C != null && C.hydratedSources || null, b = !1, L = !1, P = "", N = ND;
        C != null && (C.unstable_strictMode === !0 && (b = !0), C.identifierPrefix !== void 0 && (P = C.identifierPrefix), C.onRecoverableError !== void 0 && (N = C.onRecoverableError));
        var G = ED(s, null, a, eC, p, b, L, P, N);
        if (Wf(G.current, a), wu(a), m)
          for (var J = 0; J < m.length; J++) {
            var h2 = m[J];
            pJ(G, h2);
          }
        return new ad(G);
      }
      function od(a) {
        return !!(a && (a.nodeType === C1 || a.nodeType === F4 || a.nodeType === Ms));
      }
      function Il(a) {
        return !!(a && (a.nodeType === C1 || a.nodeType === F4 || a.nodeType === Ms || a.nodeType === Rt && a.nodeValue === " react-mount-point-unstable "));
      }
      function HD(a) {
        a.nodeType === C1 && a.tagName && a.tagName.toUpperCase() === "BODY" && u("createRoot(): Creating roots directly with document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try using a container element created for your app."), Fu(a) && (a._reactRootContainer ? u("You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported.") : u("You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."));
      }
      var Ce2 = r.ReactCurrentOwner, jD;
      jD = function(a) {
        if (a._reactRootContainer && a.nodeType !== Rt) {
          var s = yD(a._reactRootContainer.current);
          s && s.parentNode !== a && u("render(...): It looks like the React-rendered content of this container was removed without using React. This is not supported and will cause errors. Instead, call ReactDOM.unmountComponentAtNode to empty a container.");
        }
        var C = !!a._reactRootContainer, p = Ay(a), m = !!(p && C6(p));
        m && !C && u("render(...): Replacing React-rendered children with a new root component. If you intended to update the children of this node, you should instead have the existing children update their state and render the new components instead of calling ReactDOM.render."), a.nodeType === C1 && a.tagName && a.tagName.toUpperCase() === "BODY" && u("render(): Rendering components directly into document.body is discouraged, since its children are often manipulated by third-party scripts and browser extensions. This may lead to subtle reconciliation issues. Try rendering into a container element created for your app.");
      };
      function Ay(a) {
        return a ? a.nodeType === F4 ? a.documentElement : a.firstChild : null;
      }
      function VD() {
      }
      function de2(a, s, C, p, m) {
        if (m) {
          if (typeof p == "function") {
            var b = p;
            p = function() {
              var g2 = id(L);
              b.call(g2);
            };
          }
          var L = ED(
            s,
            p,
            a,
            g6,
            null,
            // hydrationCallbacks
            !1,
            // isStrictMode
            !1,
            // concurrentUpdatesByDefaultOverride,
            "",
            // identifierPrefix
            VD
          );
          a._reactRootContainer = L, Wf(L.current, a);
          var P = a.nodeType === Rt ? a.parentNode : a;
          return wu(P), o8(), L;
        } else {
          for (var N; N = a.lastChild; )
            a.removeChild(N);
          if (typeof p == "function") {
            var G = p;
            p = function() {
              var g2 = id(J);
              G.call(g2);
            };
          }
          var J = vD(
            a,
            g6,
            null,
            // hydrationCallbacks
            !1,
            // isStrictMode
            !1,
            // concurrentUpdatesByDefaultOverride,
            "",
            // identifierPrefix
            VD
          );
          a._reactRootContainer = J, Wf(J.current, a);
          var h2 = a.nodeType === Rt ? a.parentNode : a;
          return wu(h2), o8(function() {
            yl(s, J, C, p);
          }), J;
        }
      }
      function ge2(a, s) {
        a !== null && typeof a != "function" && u("%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.", s, a);
      }
      function sd(a, s, C, p, m) {
        jD(C), ge2(m === void 0 ? null : m, "render");
        var b = C._reactRootContainer, L;
        if (!b)
          L = de2(C, s, a, m, p);
        else {
          if (L = b, typeof m == "function") {
            var P = m;
            m = function() {
              var N = id(L);
              P.call(N);
            };
          }
          yl(s, L, a, m);
        }
        return id(L);
      }
      var ZD = !1;
      function pe2(a) {
        {
          ZD || (ZD = !0, u("findDOMNode is deprecated and will be removed in the next major release. Instead, add a ref directly to the element you want to reference. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-find-node"));
          var s = Ce2.current;
          if (s !== null && s.stateNode !== null) {
            var C = s.stateNode._warnedAboutRefsInRender;
            C || u("%s is accessing findDOMNode inside its render(). render() should be a pure function of props and state. It should never access something that requires stale data from the previous render, such as refs. Move this logic to componentDidMount and componentDidUpdate instead.", ue(s.type) || "A component"), s.stateNode._warnedAboutRefsInRender = !0;
          }
        }
        return a == null ? null : a.nodeType === C1 ? a : ee2(a, "findDOMNode");
      }
      function he2(a, s, C) {
        if (u("ReactDOM.hydrate is no longer supported in React 18. Use hydrateRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Il(s))
          throw new Error("Target container is not a DOM element.");
        {
          var p = Fu(s) && s._reactRootContainer === void 0;
          p && u("You are calling ReactDOM.hydrate() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call hydrateRoot(container, element)?");
        }
        return sd(null, a, s, !0, C);
      }
      function ve2(a, s, C) {
        if (u("ReactDOM.render is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Il(s))
          throw new Error("Target container is not a DOM element.");
        {
          var p = Fu(s) && s._reactRootContainer === void 0;
          p && u("You are calling ReactDOM.render() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.render(element)?");
        }
        return sd(null, a, s, !1, C);
      }
      function Ee2(a, s, C, p) {
        if (u("ReactDOM.unstable_renderSubtreeIntoContainer() is no longer supported in React 18. Consider using a portal instead. Until you switch to the createRoot API, your app will behave as if it's running React 17. Learn more: https://reactjs.org/link/switch-to-createroot"), !Il(C))
          throw new Error("Target container is not a DOM element.");
        if (a == null || !uv(a))
          throw new Error("parentComponent must be a valid React Component");
        return sd(a, s, C, !1, p);
      }
      var zD = !1;
      function me2(a) {
        if (zD || (zD = !0, u("unmountComponentAtNode is deprecated and will be removed in the next major release. Switch to the createRoot API. Learn more: https://reactjs.org/link/switch-to-createroot")), !Il(a))
          throw new Error("unmountComponentAtNode(...): Target container is not a DOM element.");
        {
          var s = Fu(a) && a._reactRootContainer === void 0;
          s && u("You are calling ReactDOM.unmountComponentAtNode() on a container that was previously passed to ReactDOMClient.createRoot(). This is not supported. Did you mean to call root.unmount()?");
        }
        if (a._reactRootContainer) {
          {
            var C = Ay(a), p = C && !C6(C);
            p && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by another copy of React.");
          }
          return o8(function() {
            sd(null, null, a, !1, function() {
              a._reactRootContainer = null, N_(a);
            });
          }), !0;
        } else {
          {
            var m = Ay(a), b = !!(m && C6(m)), L = a.nodeType === C1 && Il(a.parentNode) && !!a.parentNode._reactRootContainer;
            b && u("unmountComponentAtNode(): The node you're attempting to unmount was rendered by React and is not a top-level container. %s", L ? "You may have accidentally passed in a React root node instead of its container." : "Instead, have the parent component update its state and rerender in order to remove this component.");
          }
          return !1;
        }
      }
      k5(te2), i6(re2), Af(ne2), Z7(cr), cu(uf), (typeof Map != "function" || // $FlowIssue Flow incorrectly thinks Map has no prototype
      Map.prototype == null || typeof Map.prototype.forEach != "function" || typeof Set != "function" || // $FlowIssue Flow incorrectly thinks Set has no prototype
      Set.prototype == null || typeof Set.prototype.clear != "function" || typeof Set.prototype.forEach != "function") && u("React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills"), ha(IK), sv(Vm, f02, o8);
      function ye2(a, s) {
        var C = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        if (!od(s))
          throw new Error("Target container is not a DOM element.");
        return J02(a, s, null, C);
      }
      function Ie2(a, s, C, p) {
        return Ee2(a, s, C, p);
      }
      var fy = {
        usingClientEntryPoint: !1,
        // Keep in sync with ReactTestUtils.js.
        // This is an array for better minification.
        Events: [C6, mo, Yf, W8, va, Vm]
      };
      function Be2(a, s) {
        return fy.usingClientEntryPoint || u('You are importing createRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), ce2(a, s);
      }
      function Qe2(a, s, C) {
        return fy.usingClientEntryPoint || u('You are importing hydrateRoot from "react-dom" which is not supported. You should instead import it from "react-dom/client".'), fe2(a, s, C);
      }
      function xe2(a) {
        return KT() && u("flushSync was called from inside a lifecycle method. React cannot flush when React is already rendering. Consider moving this call to a scheduler task or micro task."), o8(a);
      }
      var be2 = le2({
        findFiberByHostInstance: ni,
        bundleType: 1,
        version: ay,
        rendererPackageName: "react-dom"
      });
      if (!be2 && W2 && window.top === window.self && (navigator.userAgent.indexOf("Chrome") > -1 && navigator.userAgent.indexOf("Edge") === -1 || navigator.userAgent.indexOf("Firefox") > -1)) {
        var UD = window.location.protocol;
        /^(https?|file):$/.test(UD) && console.info("%cDownload the React DevTools for a better development experience: https://reactjs.org/link/react-devtools" + (UD === "file:" ? `
You might need to use a local HTTP server (instead of file://): https://reactjs.org/link/react-devtools-faq` : ""), "font-weight:bold");
      }
      vr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fy, vr.createPortal = ye2, vr.createRoot = Be2, vr.findDOMNode = pe2, vr.flushSync = xe2, vr.hydrate = he2, vr.hydrateRoot = Qe2, vr.render = ve2, vr.unmountComponentAtNode = me2, vr.unstable_batchedUpdates = Vm, vr.unstable_renderSubtreeIntoContainer = Ie2, vr.version = ay, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
    }()), vr;
  }
  var eL;
  function MZ() {
    if (eL) return ld.exports;
    eL = 1;
    function e() {
      if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) {
        if (process.env.NODE_ENV !== "production")
          throw new Error("^_^");
        try {
          __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
        } catch (t) {
          console.error(t);
        }
      }
    }
    return process.env.NODE_ENV === "production" ? (e(), ld.exports = Pe2()) : ld.exports = Fe2(), ld.exports;
  }
  var tL;
  function Ne2() {
    if (tL) return Uo;
    tL = 1;
    var e = MZ();
    if (process.env.NODE_ENV === "production")
      Uo.createRoot = e.createRoot, Uo.hydrateRoot = e.hydrateRoot;
    else {
      var t = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      Uo.createRoot = function(r, n) {
        t.usingClientEntryPoint = !0;
        try {
          return e.createRoot(r, n);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      }, Uo.hydrateRoot = function(r, n, i) {
        t.usingClientEntryPoint = !0;
        try {
          return e.hydrateRoot(r, n, i);
        } finally {
          t.usingClientEntryPoint = !1;
        }
      };
    }
    return Uo;
  }
  var He2 = Ne2(), je2 = Object.defineProperty, Ve2 = (e, t, r) => t in e ? je2(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Ad = (e, t, r) => Ve2(e, typeof t != "symbol" ? t + "" : t, r);
  const Ze2 = {
    stringify: (e) => e ? "true" : "false",
    parse: (e) => /^[ty1-9]/i.test(e)
  }, ze2 = {
    stringify: (e) => e.name,
    parse: (e, t, r) => {
      const n = (() => {
        if (typeof window < "u" && e in window)
          return window[e];
        if (typeof global < "u" && e in global)
          return global[e];
      })();
      return typeof n == "function" ? n.bind(r) : void 0;
    }
  }, Ue2 = {
    stringify: (e) => JSON.stringify(e),
    parse: (e) => JSON.parse(e)
  }, qe2 = {
    stringify: (e) => `${e}`,
    parse: (e) => parseFloat(e)
  }, We2 = {
    stringify: (e) => e,
    parse: (e) => e
  }, gy = {
    string: We2,
    number: qe2,
    boolean: Ze2,
    function: ze2,
    json: Ue2
  };
  function Ye2(e) {
    return e.replace(
      /([a-z0-9])([A-Z])/g,
      (t, r, n) => `${r}-${n.toLowerCase()}`
    );
  }
  const fd = Symbol.for("r2wc.render"), Cd = Symbol.for("r2wc.connected"), Ei = Symbol.for("r2wc.context"), l8 = Symbol.for("r2wc.props");
  function $e2(e, t, r) {
    var n, i, o;
    t.props || (t.props = e.propTypes ? Object.keys(e.propTypes) : []), t.events || (t.events = []);
    const u = Array.isArray(t.props) ? t.props.slice() : Object.keys(t.props), c = Array.isArray(t.events) ? t.events.slice() : Object.keys(t.events), f = {}, d = {}, g = {}, h = {};
    for (const y of u) {
      f[y] = Array.isArray(t.props) ? "string" : t.props[y];
      const I = Ye2(y);
      g[y] = I, h[I] = y;
    }
    for (const y of c)
      d[y] = Array.isArray(t.events) ? {} : t.events[y];
    class E extends HTMLElement {
      constructor() {
        super(), Ad(this, o, !0), Ad(this, i), Ad(this, n, {}), Ad(this, "container"), t.shadow ? this.container = this.attachShadow({
          mode: t.shadow
        }) : this.container = this, this[l8].container = this.container;
        for (const I of u) {
          const Q = g[I], B = this.getAttribute(Q), _ = f[I], M = _ ? gy[_] : null;
          M != null && M.parse && B && (this[l8][I] = M.parse(B, Q, this));
        }
        for (const I of c)
          this[l8][I] = (Q) => {
            const B = I.replace(/^on/, "").toLowerCase();
            this.dispatchEvent(
              new CustomEvent(B, { detail: Q, ...d[I] })
            );
          };
      }
      static get observedAttributes() {
        return Object.keys(h);
      }
      connectedCallback() {
        this[Cd] = !0, this[fd]();
      }
      disconnectedCallback() {
        this[Cd] = !1, this[Ei] && r.unmount(this[Ei]), delete this[Ei];
      }
      attributeChangedCallback(I, Q, B) {
        const _ = h[I], M = f[_], S = M ? gy[M] : null;
        _ in f && S != null && S.parse && B && (this[l8][_] = S.parse(B, I, this), this[fd]());
      }
      [(o = Cd, i = Ei, n = l8, fd)]() {
        this[Cd] && (this[Ei] ? r.update(this[Ei], this[l8]) : this[Ei] = r.mount(
          this.container,
          e,
          this[l8]
        ));
      }
    }
    for (const y of u) {
      const I = g[y], Q = f[y];
      Object.defineProperty(E.prototype, y, {
        enumerable: !0,
        configurable: !0,
        get() {
          return this[l8][y];
        },
        set(B) {
          this[l8][y] = B;
          const _ = Q ? gy[Q] : null;
          if (_ != null && _.stringify) {
            const M = _.stringify(B, I, this);
            this.getAttribute(I) !== M && this.setAttribute(I, M);
          } else
            this[fd]();
        }
      });
    }
    return E;
  }
  function Ge2(e, t, r) {
    const n = He2.createRoot(e), i = f2.createElement(t, r);
    return n.render(i), {
      root: n,
      ReactComponent: t
    };
  }
  function Ke2({ root: e, ReactComponent: t }, r) {
    const n = f2.createElement(t, r);
    e.render(n);
  }
  function Xe2({ root: e }) {
    e.unmount();
  }
  function Je2(e, t = {}) {
    return $e2(e, t, { mount: Ge2, update: Ke2, unmount: Xe2 });
  }
  var dd = { exports: {} }, Ql = {};
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var rL;
  function et2() {
    if (rL) return Ql;
    rL = 1;
    var e = X9(), t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
    function u(c, f, d) {
      var g, h = {}, E = null, y = null;
      d !== void 0 && (E = "" + d), f.key !== void 0 && (E = "" + f.key), f.ref !== void 0 && (y = f.ref);
      for (g in f) n.call(f, g) && !o.hasOwnProperty(g) && (h[g] = f[g]);
      if (c && c.defaultProps) for (g in f = c.defaultProps, f) h[g] === void 0 && (h[g] = f[g]);
      return { $$typeof: t, type: c, key: E, ref: y, props: h, _owner: i.current };
    }
    return Ql.Fragment = r, Ql.jsx = u, Ql.jsxs = u, Ql;
  }
  var xl = {};
  /**
   * @license React
   * react-jsx-runtime.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var nL;
  function tt2() {
    return nL || (nL = 1, process.env.NODE_ENV !== "production" && function() {
      var e = X9(), t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), u = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), I = Symbol.iterator, Q = "@@iterator";
      function B(c2) {
        if (c2 === null || typeof c2 != "object")
          return null;
        var N2 = I && c2[I] || c2[Q];
        return typeof N2 == "function" ? N2 : null;
      }
      var _ = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function M(c2) {
        {
          for (var N2 = arguments.length, J2 = new Array(N2 > 1 ? N2 - 1 : 0), l0 = 1; l0 < N2; l0++)
            J2[l0 - 1] = arguments[l0];
          S("error", c2, J2);
        }
      }
      function S(c2, N2, J2) {
        {
          var l0 = _.ReactDebugCurrentFrame, H0 = l0.getStackAddendum();
          H0 !== "" && (N2 += "%s", J2 = J2.concat([H0]));
          var P0 = J2.map(function(K0) {
            return String(K0);
          });
          P0.unshift("Warning: " + N2), Function.prototype.apply.call(console[c2], console, P0);
        }
      }
      var O = !1, w = !1, D = !1, k = !1, F = !1, z;
      z = Symbol.for("react.module.reference");
      function Z(c2) {
        return !!(typeof c2 == "string" || typeof c2 == "function" || c2 === n || c2 === o || F || c2 === i || c2 === d || c2 === g || k || c2 === y || O || w || D || typeof c2 == "object" && c2 !== null && (c2.$$typeof === E || c2.$$typeof === h || c2.$$typeof === u || c2.$$typeof === c || c2.$$typeof === f || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        c2.$$typeof === z || c2.getModuleId !== void 0));
      }
      function V(c2, N2, J2) {
        var l0 = c2.displayName;
        if (l0)
          return l0;
        var H0 = N2.displayName || N2.name || "";
        return H0 !== "" ? J2 + "(" + H0 + ")" : J2;
      }
      function $(c2) {
        return c2.displayName || "Context";
      }
      function W(c2) {
        if (c2 == null)
          return null;
        if (typeof c2.tag == "number" && M("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c2 == "function")
          return c2.displayName || c2.name || null;
        if (typeof c2 == "string")
          return c2;
        switch (c2) {
          case n:
            return "Fragment";
          case r:
            return "Portal";
          case o:
            return "Profiler";
          case i:
            return "StrictMode";
          case d:
            return "Suspense";
          case g:
            return "SuspenseList";
        }
        if (typeof c2 == "object")
          switch (c2.$$typeof) {
            case c:
              var N2 = c2;
              return $(N2) + ".Consumer";
            case u:
              var J2 = c2;
              return $(J2._context) + ".Provider";
            case f:
              return V(c2, c2.render, "ForwardRef");
            case h:
              var l0 = c2.displayName || null;
              return l0 !== null ? l0 : W(c2.type) || "Memo";
            case E: {
              var H0 = c2, P0 = H0._payload, K0 = H0._init;
              try {
                return W(K0(P0));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var t2 = Object.assign, n2 = 0, s2, l2, X, a2, e2, H, Y;
      function r2() {
      }
      r2.__reactDisabledLog = !0;
      function o2() {
        {
          if (n2 === 0) {
            s2 = console.log, l2 = console.info, X = console.warn, a2 = console.error, e2 = console.group, H = console.groupCollapsed, Y = console.groupEnd;
            var c2 = {
              configurable: !0,
              enumerable: !0,
              value: r2,
              writable: !0
            };
            Object.defineProperties(console, {
              info: c2,
              log: c2,
              warn: c2,
              error: c2,
              group: c2,
              groupCollapsed: c2,
              groupEnd: c2
            });
          }
          n2++;
        }
      }
      function O2() {
        {
          if (n2--, n2 === 0) {
            var c2 = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: t2({}, c2, {
                value: s2
              }),
              info: t2({}, c2, {
                value: l2
              }),
              warn: t2({}, c2, {
                value: X
              }),
              error: t2({}, c2, {
                value: a2
              }),
              group: t2({}, c2, {
                value: e2
              }),
              groupCollapsed: t2({}, c2, {
                value: H
              }),
              groupEnd: t2({}, c2, {
                value: Y
              })
            });
          }
          n2 < 0 && M("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var S2 = _.ReactCurrentDispatcher, M2;
      function w2(c2, N2, J2) {
        {
          if (M2 === void 0)
            try {
              throw Error();
            } catch (H0) {
              var l0 = H0.stack.trim().match(/\n( *(at )?)/);
              M2 = l0 && l0[1] || "";
            }
          return `
` + M2 + c2;
        }
      }
      var v2 = !1, L2;
      {
        var W2 = typeof WeakMap == "function" ? WeakMap : Map;
        L2 = new W2();
      }
      function d2(c2, N2) {
        if (!c2 || v2)
          return "";
        {
          var J2 = L2.get(c2);
          if (J2 !== void 0)
            return J2;
        }
        var l0;
        v2 = !0;
        var H0 = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var P0;
        P0 = S2.current, S2.current = null, o2();
        try {
          if (N2) {
            var K0 = function() {
              throw Error();
            };
            if (Object.defineProperty(K0.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(K0, []);
              } catch (j0) {
                l0 = j0;
              }
              Reflect.construct(c2, [], K0);
            } else {
              try {
                K0.call();
              } catch (j0) {
                l0 = j0;
              }
              c2.call(K0.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (j0) {
              l0 = j0;
            }
            c2();
          }
        } catch (j0) {
          if (j0 && l0 && typeof j0.stack == "string") {
            for (var W0 = j0.stack.split(`
`), Qt = l0.stack.split(`
`), it = W0.length - 1, ut = Qt.length - 1; it >= 1 && ut >= 0 && W0[it] !== Qt[ut]; )
              ut--;
            for (; it >= 1 && ut >= 0; it--, ut--)
              if (W0[it] !== Qt[ut]) {
                if (it !== 1 || ut !== 1)
                  do
                    if (it--, ut--, ut < 0 || W0[it] !== Qt[ut]) {
                      var p5 = `
` + W0[it].replace(" at new ", " at ");
                      return c2.displayName && p5.includes("<anonymous>") && (p5 = p5.replace("<anonymous>", c2.displayName)), typeof c2 == "function" && L2.set(c2, p5), p5;
                    }
                  while (it >= 1 && ut >= 0);
                break;
              }
          }
        } finally {
          v2 = !1, S2.current = P0, O2(), Error.prepareStackTrace = H0;
        }
        var Qr = c2 ? c2.displayName || c2.name : "", xr = Qr ? w2(Qr) : "";
        return typeof c2 == "function" && L2.set(c2, xr), xr;
      }
      function X2(c2, N2, J2) {
        return d2(c2, !1);
      }
      function k2(c2) {
        var N2 = c2.prototype;
        return !!(N2 && N2.isReactComponent);
      }
      function b0(c2, N2, J2) {
        if (c2 == null)
          return "";
        if (typeof c2 == "function")
          return d2(c2, k2(c2));
        if (typeof c2 == "string")
          return w2(c2);
        switch (c2) {
          case d:
            return w2("Suspense");
          case g:
            return w2("SuspenseList");
        }
        if (typeof c2 == "object")
          switch (c2.$$typeof) {
            case f:
              return X2(c2.render);
            case h:
              return b0(c2.type, N2, J2);
            case E: {
              var l0 = c2, H0 = l0._payload, P0 = l0._init;
              try {
                return b0(P0(H0), N2, J2);
              } catch {
              }
            }
          }
        return "";
      }
      var S0 = Object.prototype.hasOwnProperty, G0 = {}, $e = _.ReactDebugCurrentFrame;
      function _e(c2) {
        if (c2) {
          var N2 = c2._owner, J2 = b0(c2.type, c2._source, N2 ? N2.type : null);
          $e.setExtraStackFrame(J2);
        } else
          $e.setExtraStackFrame(null);
      }
      function Oe(c2, N2, J2, l0, H0) {
        {
          var P0 = Function.call.bind(S0);
          for (var K0 in c2)
            if (P0(c2, K0)) {
              var W0 = void 0;
              try {
                if (typeof c2[K0] != "function") {
                  var Qt = Error((l0 || "React class") + ": " + J2 + " type `" + K0 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c2[K0] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Qt.name = "Invariant Violation", Qt;
                }
                W0 = c2[K0](N2, K0, l0, J2, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (it) {
                W0 = it;
              }
              W0 && !(W0 instanceof Error) && (_e(H0), M("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", l0 || "React class", J2, K0, typeof W0), _e(null)), W0 instanceof Error && !(W0.message in G0) && (G0[W0.message] = !0, _e(H0), M("Failed %s type: %s", J2, W0.message), _e(null));
            }
        }
      }
      var U0 = Array.isArray;
      function Z0(c2) {
        return U0(c2);
      }
      function Te(c2) {
        {
          var N2 = typeof Symbol == "function" && Symbol.toStringTag, J2 = N2 && c2[Symbol.toStringTag] || c2.constructor.name || "Object";
          return J2;
        }
      }
      function Lt(c2) {
        try {
          return Ge(c2), !1;
        } catch {
          return !0;
        }
      }
      function Ge(c2) {
        return "" + c2;
      }
      function rt(c2) {
        if (Lt(c2))
          return M("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Te(c2)), Ge(c2);
      }
      var yt = _.ReactCurrentOwner, D1 = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, L1, Y2;
      function c0(c2) {
        if (S0.call(c2, "ref")) {
          var N2 = Object.getOwnPropertyDescriptor(c2, "ref").get;
          if (N2 && N2.isReactWarning)
            return !1;
        }
        return c2.ref !== void 0;
      }
      function k0(c2) {
        if (S0.call(c2, "key")) {
          var N2 = Object.getOwnPropertyDescriptor(c2, "key").get;
          if (N2 && N2.isReactWarning)
            return !1;
        }
        return c2.key !== void 0;
      }
      function fe(c2, N2) {
        typeof c2.ref == "string" && yt.current;
      }
      function De(c2, N2) {
        {
          var J2 = function() {
            L1 || (L1 = !0, M("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N2));
          };
          J2.isReactWarning = !0, Object.defineProperty(c2, "key", {
            get: J2,
            configurable: !0
          });
        }
      }
      function nt(c2, N2) {
        {
          var J2 = function() {
            Y2 || (Y2 = !0, M("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N2));
          };
          J2.isReactWarning = !0, Object.defineProperty(c2, "ref", {
            get: J2,
            configurable: !0
          });
        }
      }
      var Ke = function(c2, N2, J2, l0, H0, P0, K0) {
        var W0 = {
          // This tag allows us to uniquely identify this as a React Element
          $$typeof: t,
          // Built-in properties that belong on the element
          type: c2,
          key: N2,
          ref: J2,
          props: K0,
          // Record the component responsible for creating this element.
          _owner: P0
        };
        return W0._store = {}, Object.defineProperty(W0._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(W0, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: l0
        }), Object.defineProperty(W0, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: H0
        }), Object.freeze && (Object.freeze(W0.props), Object.freeze(W0)), W0;
      };
      function kt(c2, N2, J2, l0, H0) {
        {
          var P0, K0 = {}, W0 = null, Qt = null;
          J2 !== void 0 && (rt(J2), W0 = "" + J2), k0(N2) && (rt(N2.key), W0 = "" + N2.key), c0(N2) && (Qt = N2.ref, fe(N2, H0));
          for (P0 in N2)
            S0.call(N2, P0) && !D1.hasOwnProperty(P0) && (K0[P0] = N2[P0]);
          if (c2 && c2.defaultProps) {
            var it = c2.defaultProps;
            for (P0 in it)
              K0[P0] === void 0 && (K0[P0] = it[P0]);
          }
          if (W0 || Qt) {
            var ut = typeof c2 == "function" ? c2.displayName || c2.name || "Unknown" : c2;
            W0 && De(K0, ut), Qt && nt(K0, ut);
          }
          return Ke(c2, W0, Qt, H0, l0, yt.current, K0);
        }
      }
      var Le = _.ReactCurrentOwner, be = _.ReactDebugCurrentFrame;
      function Qe(c2) {
        if (c2) {
          var N2 = c2._owner, J2 = b0(c2.type, c2._source, N2 ? N2.type : null);
          be.setExtraStackFrame(J2);
        } else
          be.setExtraStackFrame(null);
      }
      var Z5;
      Z5 = !1;
      function Gt(c2) {
        return typeof c2 == "object" && c2 !== null && c2.$$typeof === t;
      }
      function c1() {
        {
          if (Le.current) {
            var c2 = W(Le.current.type);
            if (c2)
              return `

Check the render method of \`` + c2 + "`.";
          }
          return "";
        }
      }
      function Br(c2) {
        return "";
      }
      var T4 = {};
      function Yr(c2) {
        {
          var N2 = c1();
          if (!N2) {
            var J2 = typeof c2 == "string" ? c2 : c2.displayName || c2.name;
            J2 && (N2 = `

Check the top-level render call using <` + J2 + ">.");
          }
          return N2;
        }
      }
      function $r(c2, N2) {
        {
          if (!c2._store || c2._store.validated || c2.key != null)
            return;
          c2._store.validated = !0;
          var J2 = Yr(N2);
          if (T4[J2])
            return;
          T4[J2] = !0;
          var l0 = "";
          c2 && c2._owner && c2._owner !== Le.current && (l0 = " It was passed a child from " + W(c2._owner.type) + "."), Qe(c2), M('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', J2, l0), Qe(null);
        }
      }
      function Gr(c2, N2) {
        {
          if (typeof c2 != "object")
            return;
          if (Z0(c2))
            for (var J2 = 0; J2 < c2.length; J2++) {
              var l0 = c2[J2];
              Gt(l0) && $r(l0, N2);
            }
          else if (Gt(c2))
            c2._store && (c2._store.validated = !0);
          else if (c2) {
            var H0 = B(c2);
            if (typeof H0 == "function" && H0 !== c2.entries)
              for (var P0 = H0.call(c2), K0; !(K0 = P0.next()).done; )
                Gt(K0.value) && $r(K0.value, N2);
          }
        }
      }
      function Kr(c2) {
        {
          var N2 = c2.type;
          if (N2 == null || typeof N2 == "string")
            return;
          var J2;
          if (typeof N2 == "function")
            J2 = N2.propTypes;
          else if (typeof N2 == "object" && (N2.$$typeof === f || // Note: Memo only checks outer props here.
          // Inner props are checked in the reconciler.
          N2.$$typeof === h))
            J2 = N2.propTypes;
          else
            return;
          if (J2) {
            var l0 = W(N2);
            Oe(J2, c2.props, "prop", l0, c2);
          } else if (N2.PropTypes !== void 0 && !Z5) {
            Z5 = !0;
            var H0 = W(N2);
            M("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", H0 || "Unknown");
          }
          typeof N2.getDefaultProps == "function" && !N2.getDefaultProps.isReactClassApproved && M("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function g5(c2) {
        {
          for (var N2 = Object.keys(c2.props), J2 = 0; J2 < N2.length; J2++) {
            var l0 = N2[J2];
            if (l0 !== "children" && l0 !== "key") {
              Qe(c2), M("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", l0), Qe(null);
              break;
            }
          }
          c2.ref !== null && (Qe(c2), M("Invalid attribute `ref` supplied to `React.Fragment`."), Qe(null));
        }
      }
      var o5 = {};
      function xe(c2, N2, J2, l0, H0, P0) {
        {
          var K0 = Z(c2);
          if (!K0) {
            var W0 = "";
            (c2 === void 0 || typeof c2 == "object" && c2 !== null && Object.keys(c2).length === 0) && (W0 += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Qt = Br();
            Qt ? W0 += Qt : W0 += c1();
            var it;
            c2 === null ? it = "null" : Z0(c2) ? it = "array" : c2 !== void 0 && c2.$$typeof === t ? (it = "<" + (W(c2.type) || "Unknown") + " />", W0 = " Did you accidentally export a JSX literal instead of a component?") : it = typeof c2, M("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", it, W0);
          }
          var ut = kt(c2, N2, J2, H0, P0);
          if (ut == null)
            return ut;
          if (K0) {
            var p5 = N2.children;
            if (p5 !== void 0)
              if (l0)
                if (Z0(p5)) {
                  for (var Qr = 0; Qr < p5.length; Qr++)
                    Gr(p5[Qr], c2);
                  Object.freeze && Object.freeze(p5);
                } else
                  M("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                Gr(p5, c2);
          }
          if (S0.call(N2, "key")) {
            var xr = W(c2), j0 = Object.keys(N2).filter(function(v3) {
              return v3 !== "key";
            }), z0 = j0.length > 0 ? "{key: someKey, " + j0.join(": ..., ") + ": ...}" : "{key: someKey}";
            if (!o5[xr + z0]) {
              var br = j0.length > 0 ? "{" + j0.join(": ..., ") + ": ...}" : "{}";
              M(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, z0, xr, br, xr), o5[xr + z0] = !0;
            }
          }
          return c2 === n ? g5(ut) : Kr(ut), ut;
        }
      }
      function Kt(c2, N2, J2) {
        return xe(c2, N2, J2, !0);
      }
      function A1(c2, N2, J2) {
        return xe(c2, N2, J2, !1);
      }
      var X1 = A1, Xr = Kt;
      xl.Fragment = n, xl.jsx = X1, xl.jsxs = Xr;
    }()), xl;
  }
  var iL;
  function rt2() {
    return iL || (iL = 1, process.env.NODE_ENV === "production" ? dd.exports = et2() : dd.exports = tt2()), dd.exports;
  }
  var K = rt2(), Gx = function(e, t) {
    return Gx = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
      r.__proto__ = n;
    } || function(r, n) {
      for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (r[i] = n[i]);
    }, Gx(e, t);
  };
  function g3(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
    Gx(e, t);
    function r() {
      this.constructor = e;
    }
    e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
  }
  var C2 = function() {
    return C2 = Object.assign || function(t) {
      for (var r, n = 1, i = arguments.length; n < i; n++) {
        r = arguments[n];
        for (var o in r) Object.prototype.hasOwnProperty.call(r, o) && (t[o] = r[o]);
      }
      return t;
    }, C2.apply(this, arguments);
  };
  function yr(e, t) {
    var r = {};
    for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
    if (e != null && typeof Object.getOwnPropertySymbols == "function")
      for (var i = 0, n = Object.getOwnPropertySymbols(e); i < n.length; i++)
        t.indexOf(n[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[i]) && (r[n[i]] = e[n[i]]);
    return r;
  }
  function D6(e, t, r, n) {
    function i(o) {
      return o instanceof r ? o : new r(function(u) {
        u(o);
      });
    }
    return new (r || (r = Promise))(function(o, u) {
      function c(g) {
        try {
          d(n.next(g));
        } catch (h) {
          u(h);
        }
      }
      function f(g) {
        try {
          d(n.throw(g));
        } catch (h) {
          u(h);
        }
      }
      function d(g) {
        g.done ? o(g.value) : i(g.value).then(c, f);
      }
      d((n = n.apply(e, t || [])).next());
    });
  }
  function L6(e, t) {
    var r = { label: 0, sent: function() {
      if (o[0] & 1) throw o[1];
      return o[1];
    }, trys: [], ops: [] }, n, i, o, u = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
    return u.next = c(0), u.throw = c(1), u.return = c(2), typeof Symbol == "function" && (u[Symbol.iterator] = function() {
      return this;
    }), u;
    function c(d) {
      return function(g) {
        return f([d, g]);
      };
    }
    function f(d) {
      if (n) throw new TypeError("Generator is already executing.");
      for (; u && (u = 0, d[0] && (r = 0)), r; ) try {
        if (n = 1, i && (o = d[0] & 2 ? i.return : d[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, d[1])).done) return o;
        switch (i = 0, o && (d = [d[0] & 2, o.value]), d[0]) {
          case 0:
          case 1:
            o = d;
            break;
          case 4:
            return r.label++, { value: d[1], done: !1 };
          case 5:
            r.label++, i = d[1], d = [0];
            continue;
          case 7:
            d = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (o = r.trys, !(o = o.length > 0 && o[o.length - 1]) && (d[0] === 6 || d[0] === 2)) {
              r = 0;
              continue;
            }
            if (d[0] === 3 && (!o || d[1] > o[0] && d[1] < o[3])) {
              r.label = d[1];
              break;
            }
            if (d[0] === 6 && r.label < o[1]) {
              r.label = o[1], o = d;
              break;
            }
            if (o && r.label < o[2]) {
              r.label = o[2], r.ops.push(d);
              break;
            }
            o[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        d = t.call(e, r);
      } catch (g) {
        d = [6, g], i = 0;
      } finally {
        n = o = 0;
      }
      if (d[0] & 5) throw d[1];
      return { value: d[0] ? d[1] : void 0, done: !0 };
    }
  }
  function l1(e, t, r) {
    if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
      (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
    return e.concat(o || Array.prototype.slice.call(t));
  }
  var py = "Invariant Violation", aL = Object.setPrototypeOf, nt2 = aL === void 0 ? function(e, t) {
    return e.__proto__ = t, e;
  } : aL, _Z = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        r === void 0 && (r = py);
        var n = e.call(this, typeof r == "number" ? py + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
        return n.framesToPop = 1, n.name = py, nt2(n, t.prototype), n;
      }
      return t;
    }(Error)
  );
  function bi(e, t) {
    if (!e)
      throw new _Z(t);
  }
  var OZ = ["debug", "log", "warn", "error", "silent"], it2 = OZ.indexOf("log");
  function gd(e) {
    return function() {
      if (OZ.indexOf(e) >= it2) {
        var t = console[e] || console.log;
        return t.apply(console, arguments);
      }
    };
  }
  (function(e) {
    e.debug = gd("debug"), e.log = gd("log"), e.warn = gd("warn"), e.error = gd("error");
  })(bi || (bi = {}));
  var tS = "3.13.8";
  function Cn(e) {
    try {
      return e();
    } catch {
    }
  }
  const sc = Cn(function() {
    return globalThis;
  }) || Cn(function() {
    return window;
  }) || Cn(function() {
    return self;
  }) || Cn(function() {
    return global;
  }) || // We don't expect the Function constructor ever to be invoked at runtime, as
  // long as at least one of globalThis, window, self, or global is defined, so
  // we are under no obligation to make it easy for static analysis tools to
  // detect syntactic usage of the Function constructor. If you think you can
  // improve your static analysis to detect this obfuscation, think again. This
  // is an arms race you cannot win, at least not in JavaScript.
  Cn(function() {
    return Cn.constructor("return this")();
  });
  var oL = /* @__PURE__ */ new Map();
  function Kx(e) {
    var t = oL.get(e) || 1;
    return oL.set(e, t + 1), "".concat(e, ":").concat(t, ":").concat(Math.random().toString(36).slice(2));
  }
  function TZ(e, t) {
    t === void 0 && (t = 0);
    var r = Kx("stringifyForDisplay");
    return JSON.stringify(e, function(n, i) {
      return i === void 0 ? r : i;
    }, t).split(JSON.stringify(r)).join("<undefined>");
  }
  function pd(e) {
    return function(t) {
      for (var r = [], n = 1; n < arguments.length; n++)
        r[n - 1] = arguments[n];
      if (typeof t == "number") {
        var i = t;
        t = rS(i), t || (t = nS(i, r), r = []);
      }
      e.apply(void 0, [t].concat(r));
    };
  }
  var u0 = Object.assign(function(t, r) {
    for (var n = [], i = 2; i < arguments.length; i++)
      n[i - 2] = arguments[i];
    t || bi(t, rS(r, n) || nS(r, n));
  }, {
    debug: pd(bi.debug),
    log: pd(bi.log),
    warn: pd(bi.warn),
    error: pd(bi.error)
  });
  function G1(e) {
    for (var t = [], r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
    return new _Z(rS(e, t) || nS(e, t));
  }
  var Rg = Symbol.for("ApolloErrorMessageHandler_" + tS);
  function DZ(e) {
    if (typeof e == "string")
      return e;
    try {
      return TZ(e, 2).slice(0, 1e3);
    } catch {
      return "<non-serializable>";
    }
  }
  function rS(e, t) {
    if (t === void 0 && (t = []), !!e)
      return sc[Rg] && sc[Rg](e, t.map(DZ));
  }
  function nS(e, t) {
    if (t === void 0 && (t = []), !!e)
      return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: tS,
        message: e,
        args: t.map(DZ)
      })));
  }
  function Zd(e, t) {
    if (!!!e)
      throw new Error(t);
  }
  function at2(e) {
    return typeof e == "object" && e !== null;
  }
  function ot2(e, t) {
    if (!!!e)
      throw new Error(
        "Unexpected invariant triggered."
      );
  }
  const st2 = /\r\n|[\n\r]/g;
  function Xx(e, t) {
    let r = 0, n = 1;
    for (const i of e.body.matchAll(st2)) {
      if (typeof i.index == "number" || ot2(!1), i.index >= t)
        break;
      r = i.index + i[0].length, n += 1;
    }
    return {
      line: n,
      column: t + 1 - r
    };
  }
  function ut2(e) {
    return LZ(
      e.source,
      Xx(e.source, e.start)
    );
  }
  function LZ(e, t) {
    const r = e.locationOffset.column - 1, n = "".padStart(r) + e.body, i = t.line - 1, o = e.locationOffset.line - 1, u = t.line + o, c = t.line === 1 ? r : 0, f = t.column + c, d = `${e.name}:${u}:${f}
`, g = n.split(/\r\n|[\n\r]/g), h = g[i];
    if (h.length > 120) {
      const E = Math.floor(f / 80), y = f % 80, I = [];
      for (let Q = 0; Q < h.length; Q += 80)
        I.push(h.slice(Q, Q + 80));
      return d + sL([
        [`${u} |`, I[0]],
        ...I.slice(1, E + 1).map((Q) => ["|", Q]),
        ["|", "^".padStart(y)],
        ["|", I[E + 1]]
      ]);
    }
    return d + sL([
      // Lines specified like this: ["prefix", "string"],
      [`${u - 1} |`, g[i - 1]],
      [`${u} |`, h],
      ["|", "^".padStart(f)],
      [`${u + 1} |`, g[i + 1]]
    ]);
  }
  function sL(e) {
    const t = e.filter(([n, i]) => i !== void 0), r = Math.max(...t.map(([n]) => n.length));
    return t.map(([n, i]) => n.padStart(r) + (i ? " " + i : "")).join(`
`);
  }
  function lt2(e) {
    const t = e[0];
    return t == null || "kind" in t || "length" in t ? {
      nodes: t,
      source: e[1],
      positions: e[2],
      path: e[3],
      originalError: e[4],
      extensions: e[5]
    } : t;
  }
  class iS extends Error {
    /**
     * An array of `{ line, column }` locations within the source GraphQL document
     * which correspond to this error.
     *
     * Errors during validation often contain multiple locations, for example to
     * point out two things with the same name. Errors during execution include a
     * single location, the field which produced the error.
     *
     * Enumerable, and appears in the result of JSON.stringify().
     */
    /**
     * An array describing the JSON-path into the execution response which
     * corresponds to this error. Only included for errors during execution.
     *
     * Enumerable, and appears in the result of JSON.stringify().
     */
    /**
     * An array of GraphQL AST Nodes corresponding to this error.
     */
    /**
     * The source GraphQL document for the first location of this error.
     *
     * Note that if this Error represents more than one node, the source may not
     * represent nodes after the first node.
     */
    /**
     * An array of character offsets within the source GraphQL document
     * which correspond to this error.
     */
    /**
     * The original error thrown from a field resolver during execution.
     */
    /**
     * Extension fields to add to the formatted error.
     */
    /**
     * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
     */
    constructor(t, ...r) {
      var n, i, o;
      const { nodes: u, source: c, positions: f, path: d, originalError: g, extensions: h } = lt2(r);
      super(t), this.name = "GraphQLError", this.path = d ?? void 0, this.originalError = g ?? void 0, this.nodes = uL(
        Array.isArray(u) ? u : u ? [u] : void 0
      );
      const E = uL(
        (n = this.nodes) === null || n === void 0 ? void 0 : n.map((I) => I.loc).filter((I) => I != null)
      );
      this.source = c ?? (E == null || (i = E[0]) === null || i === void 0 ? void 0 : i.source), this.positions = f ?? (E == null ? void 0 : E.map((I) => I.start)), this.locations = f && c ? f.map((I) => Xx(c, I)) : E == null ? void 0 : E.map((I) => Xx(I.source, I.start));
      const y = at2(
        g == null ? void 0 : g.extensions
      ) ? g == null ? void 0 : g.extensions : void 0;
      this.extensions = (o = h ?? y) !== null && o !== void 0 ? o : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
        message: {
          writable: !0,
          enumerable: !0
        },
        name: {
          enumerable: !1
        },
        nodes: {
          enumerable: !1
        },
        source: {
          enumerable: !1
        },
        positions: {
          enumerable: !1
        },
        originalError: {
          enumerable: !1
        }
      }), g != null && g.stack ? Object.defineProperty(this, "stack", {
        value: g.stack,
        writable: !0,
        configurable: !0
      }) : Error.captureStackTrace ? Error.captureStackTrace(this, iS) : Object.defineProperty(this, "stack", {
        value: Error().stack,
        writable: !0,
        configurable: !0
      });
    }
    get [Symbol.toStringTag]() {
      return "GraphQLError";
    }
    toString() {
      let t = this.message;
      if (this.nodes)
        for (const r of this.nodes)
          r.loc && (t += `

` + ut2(r.loc));
      else if (this.source && this.locations)
        for (const r of this.locations)
          t += `

` + LZ(this.source, r);
      return t;
    }
    toJSON() {
      const t = {
        message: this.message
      };
      return this.locations != null && (t.locations = this.locations), this.path != null && (t.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (t.extensions = this.extensions), t;
    }
  }
  function uL(e) {
    return e === void 0 || e.length === 0 ? void 0 : e;
  }
  function N5(e, t, r) {
    return new iS(`Syntax Error: ${r}`, {
      source: e,
      positions: [t]
    });
  }
  class ct2 {
    /**
     * The character offset at which this Node begins.
     */
    /**
     * The character offset at which this Node ends.
     */
    /**
     * The Token at which this Node begins.
     */
    /**
     * The Token at which this Node ends.
     */
    /**
     * The Source document the AST represents.
     */
    constructor(t, r, n) {
      this.start = t.start, this.end = r.end, this.startToken = t, this.endToken = r, this.source = n;
    }
    get [Symbol.toStringTag]() {
      return "Location";
    }
    toJSON() {
      return {
        start: this.start,
        end: this.end
      };
    }
  }
  class kZ {
    /**
     * The kind of Token.
     */
    /**
     * The character offset at which this Node begins.
     */
    /**
     * The character offset at which this Node ends.
     */
    /**
     * The 1-indexed line number on which this Token appears.
     */
    /**
     * The 1-indexed column number at which this Token begins.
     */
    /**
     * For non-punctuation tokens, represents the interpreted value of the token.
     *
     * Note: is undefined for punctuation tokens, but typed as string for
     * convenience in the parser.
     */
    /**
     * Tokens exist as nodes in a double-linked-list amongst all tokens
     * including ignored tokens. <SOF> is always the first node and <EOF>
     * the last.
     */
    constructor(t, r, n, i, o, u) {
      this.kind = t, this.start = r, this.end = n, this.line = i, this.column = o, this.value = u, this.prev = null, this.next = null;
    }
    get [Symbol.toStringTag]() {
      return "Token";
    }
    toJSON() {
      return {
        kind: this.kind,
        value: this.value,
        line: this.line,
        column: this.column
      };
    }
  }
  const RZ = {
    Name: [],
    Document: ["definitions"],
    OperationDefinition: [
      "name",
      "variableDefinitions",
      "directives",
      "selectionSet"
    ],
    VariableDefinition: ["variable", "type", "defaultValue", "directives"],
    Variable: ["name"],
    SelectionSet: ["selections"],
    Field: ["alias", "name", "arguments", "directives", "selectionSet"],
    Argument: ["name", "value"],
    FragmentSpread: ["name", "directives"],
    InlineFragment: ["typeCondition", "directives", "selectionSet"],
    FragmentDefinition: [
      "name",
      // Note: fragment variable definitions are deprecated and will removed in v17.0.0
      "variableDefinitions",
      "typeCondition",
      "directives",
      "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: ["values"],
    ObjectValue: ["fields"],
    ObjectField: ["name", "value"],
    Directive: ["name", "arguments"],
    NamedType: ["name"],
    ListType: ["type"],
    NonNullType: ["type"],
    SchemaDefinition: ["description", "directives", "operationTypes"],
    OperationTypeDefinition: ["type"],
    ScalarTypeDefinition: ["description", "name", "directives"],
    ObjectTypeDefinition: [
      "description",
      "name",
      "interfaces",
      "directives",
      "fields"
    ],
    FieldDefinition: ["description", "name", "arguments", "type", "directives"],
    InputValueDefinition: [
      "description",
      "name",
      "type",
      "defaultValue",
      "directives"
    ],
    InterfaceTypeDefinition: [
      "description",
      "name",
      "interfaces",
      "directives",
      "fields"
    ],
    UnionTypeDefinition: ["description", "name", "directives", "types"],
    EnumTypeDefinition: ["description", "name", "directives", "values"],
    EnumValueDefinition: ["description", "name", "directives"],
    InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
    DirectiveDefinition: ["description", "name", "arguments", "locations"],
    SchemaExtension: ["directives", "operationTypes"],
    ScalarTypeExtension: ["name", "directives"],
    ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
    InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
    UnionTypeExtension: ["name", "directives", "types"],
    EnumTypeExtension: ["name", "directives", "values"],
    InputObjectTypeExtension: ["name", "directives", "fields"]
  }, At2 = new Set(Object.keys(RZ));
  function lL(e) {
    const t = e == null ? void 0 : e.kind;
    return typeof t == "string" && At2.has(t);
  }
  var n9;
  (function(e) {
    e.QUERY = "query", e.MUTATION = "mutation", e.SUBSCRIPTION = "subscription";
  })(n9 || (n9 = {}));
  var Jx;
  (function(e) {
    e.QUERY = "QUERY", e.MUTATION = "MUTATION", e.SUBSCRIPTION = "SUBSCRIPTION", e.FIELD = "FIELD", e.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", e.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", e.INLINE_FRAGMENT = "INLINE_FRAGMENT", e.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", e.SCHEMA = "SCHEMA", e.SCALAR = "SCALAR", e.OBJECT = "OBJECT", e.FIELD_DEFINITION = "FIELD_DEFINITION", e.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", e.INTERFACE = "INTERFACE", e.UNION = "UNION", e.ENUM = "ENUM", e.ENUM_VALUE = "ENUM_VALUE", e.INPUT_OBJECT = "INPUT_OBJECT", e.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
  })(Jx || (Jx = {}));
  var a0;
  (function(e) {
    e.NAME = "Name", e.DOCUMENT = "Document", e.OPERATION_DEFINITION = "OperationDefinition", e.VARIABLE_DEFINITION = "VariableDefinition", e.SELECTION_SET = "SelectionSet", e.FIELD = "Field", e.ARGUMENT = "Argument", e.FRAGMENT_SPREAD = "FragmentSpread", e.INLINE_FRAGMENT = "InlineFragment", e.FRAGMENT_DEFINITION = "FragmentDefinition", e.VARIABLE = "Variable", e.INT = "IntValue", e.FLOAT = "FloatValue", e.STRING = "StringValue", e.BOOLEAN = "BooleanValue", e.NULL = "NullValue", e.ENUM = "EnumValue", e.LIST = "ListValue", e.OBJECT = "ObjectValue", e.OBJECT_FIELD = "ObjectField", e.DIRECTIVE = "Directive", e.NAMED_TYPE = "NamedType", e.LIST_TYPE = "ListType", e.NON_NULL_TYPE = "NonNullType", e.SCHEMA_DEFINITION = "SchemaDefinition", e.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", e.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", e.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", e.FIELD_DEFINITION = "FieldDefinition", e.INPUT_VALUE_DEFINITION = "InputValueDefinition", e.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", e.UNION_TYPE_DEFINITION = "UnionTypeDefinition", e.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", e.ENUM_VALUE_DEFINITION = "EnumValueDefinition", e.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", e.DIRECTIVE_DEFINITION = "DirectiveDefinition", e.SCHEMA_EXTENSION = "SchemaExtension", e.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", e.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", e.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", e.UNION_TYPE_EXTENSION = "UnionTypeExtension", e.ENUM_TYPE_EXTENSION = "EnumTypeExtension", e.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
  })(a0 || (a0 = {}));
  function eb(e) {
    return e === 9 || e === 32;
  }
  function uc(e) {
    return e >= 48 && e <= 57;
  }
  function PZ(e) {
    return e >= 97 && e <= 122 || // A-Z
    e >= 65 && e <= 90;
  }
  function FZ(e) {
    return PZ(e) || e === 95;
  }
  function ft2(e) {
    return PZ(e) || uc(e) || e === 95;
  }
  function Ct2(e) {
    var t;
    let r = Number.MAX_SAFE_INTEGER, n = null, i = -1;
    for (let u = 0; u < e.length; ++u) {
      var o;
      const c = e[u], f = dt2(c);
      f !== c.length && (n = (o = n) !== null && o !== void 0 ? o : u, i = u, u !== 0 && f < r && (r = f));
    }
    return e.map((u, c) => c === 0 ? u : u.slice(r)).slice(
      (t = n) !== null && t !== void 0 ? t : 0,
      i + 1
    );
  }
  function dt2(e) {
    let t = 0;
    for (; t < e.length && eb(e.charCodeAt(t)); )
      ++t;
    return t;
  }
  function gt2(e, t) {
    const r = e.replace(/"""/g, '\\"""'), n = r.split(/\r\n|[\n\r]/g), i = n.length === 1, o = n.length > 1 && n.slice(1).every((y) => y.length === 0 || eb(y.charCodeAt(0))), u = r.endsWith('\\"""'), c = e.endsWith('"') && !u, f = e.endsWith("\\"), d = c || f, g = (
      // add leading and trailing new lines only if it improves readability
      !i || e.length > 70 || d || o || u
    );
    let h = "";
    const E = i && eb(e.charCodeAt(0));
    return (g && !E || o) && (h += `
`), h += r, (g || d) && (h += `
`), '"""' + h + '"""';
  }
  var F2;
  (function(e) {
    e.SOF = "<SOF>", e.EOF = "<EOF>", e.BANG = "!", e.DOLLAR = "$", e.AMP = "&", e.PAREN_L = "(", e.PAREN_R = ")", e.SPREAD = "...", e.COLON = ":", e.EQUALS = "=", e.AT = "@", e.BRACKET_L = "[", e.BRACKET_R = "]", e.BRACE_L = "{", e.PIPE = "|", e.BRACE_R = "}", e.NAME = "Name", e.INT = "Int", e.FLOAT = "Float", e.STRING = "String", e.BLOCK_STRING = "BlockString", e.COMMENT = "Comment";
  })(F2 || (F2 = {}));
  class pt2 {
    /**
     * The previously focused non-ignored token.
     */
    /**
     * The currently focused non-ignored token.
     */
    /**
     * The (1-indexed) line containing the current token.
     */
    /**
     * The character offset at which the current line begins.
     */
    constructor(t) {
      const r = new kZ(F2.SOF, 0, 0, 0, 0);
      this.source = t, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
      return "Lexer";
    }
    /**
     * Advances the token stream to the next non-ignored token.
     */
    advance() {
      return this.lastToken = this.token, this.token = this.lookahead();
    }
    /**
     * Looks ahead and returns the next non-ignored token, but does not change
     * the state of Lexer.
     */
    lookahead() {
      let t = this.token;
      if (t.kind !== F2.EOF)
        do
          if (t.next)
            t = t.next;
          else {
            const r = vt2(this, t.end);
            t.next = r, r.prev = t, t = r;
          }
        while (t.kind === F2.COMMENT);
      return t;
    }
  }
  function ht2(e) {
    return e === F2.BANG || e === F2.DOLLAR || e === F2.AMP || e === F2.PAREN_L || e === F2.PAREN_R || e === F2.SPREAD || e === F2.COLON || e === F2.EQUALS || e === F2.AT || e === F2.BRACKET_L || e === F2.BRACKET_R || e === F2.BRACE_L || e === F2.PIPE || e === F2.BRACE_R;
  }
  function J9(e) {
    return e >= 0 && e <= 55295 || e >= 57344 && e <= 1114111;
  }
  function Kp(e, t) {
    return NZ(e.charCodeAt(t)) && HZ(e.charCodeAt(t + 1));
  }
  function NZ(e) {
    return e >= 55296 && e <= 56319;
  }
  function HZ(e) {
    return e >= 56320 && e <= 57343;
  }
  function Pi(e, t) {
    const r = e.source.body.codePointAt(t);
    if (r === void 0)
      return F2.EOF;
    if (r >= 32 && r <= 126) {
      const n = String.fromCodePoint(r);
      return n === '"' ? `'"'` : `"${n}"`;
    }
    return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
  }
  function A5(e, t, r, n, i) {
    const o = e.line, u = 1 + r - e.lineStart;
    return new kZ(t, r, n, o, u, i);
  }
  function vt2(e, t) {
    const r = e.source.body, n = r.length;
    let i = t;
    for (; i < n; ) {
      const o = r.charCodeAt(i);
      switch (o) {
        // Ignored ::
        //   - UnicodeBOM
        //   - WhiteSpace
        //   - LineTerminator
        //   - Comment
        //   - Comma
        //
        // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
        //
        // WhiteSpace ::
        //   - "Horizontal Tab (U+0009)"
        //   - "Space (U+0020)"
        //
        // Comma :: ,
        case 65279:
        // <BOM>
        case 9:
        // \t
        case 32:
        // <space>
        case 44:
          ++i;
          continue;
        // LineTerminator ::
        //   - "New Line (U+000A)"
        //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
        //   - "Carriage Return (U+000D)" "New Line (U+000A)"
        case 10:
          ++i, ++e.line, e.lineStart = i;
          continue;
        case 13:
          r.charCodeAt(i + 1) === 10 ? i += 2 : ++i, ++e.line, e.lineStart = i;
          continue;
        // Comment
        case 35:
          return Et2(e, i);
        // Token ::
        //   - Punctuator
        //   - Name
        //   - IntValue
        //   - FloatValue
        //   - StringValue
        //
        // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
        case 33:
          return A5(e, F2.BANG, i, i + 1);
        case 36:
          return A5(e, F2.DOLLAR, i, i + 1);
        case 38:
          return A5(e, F2.AMP, i, i + 1);
        case 40:
          return A5(e, F2.PAREN_L, i, i + 1);
        case 41:
          return A5(e, F2.PAREN_R, i, i + 1);
        case 46:
          if (r.charCodeAt(i + 1) === 46 && r.charCodeAt(i + 2) === 46)
            return A5(e, F2.SPREAD, i, i + 3);
          break;
        case 58:
          return A5(e, F2.COLON, i, i + 1);
        case 61:
          return A5(e, F2.EQUALS, i, i + 1);
        case 64:
          return A5(e, F2.AT, i, i + 1);
        case 91:
          return A5(e, F2.BRACKET_L, i, i + 1);
        case 93:
          return A5(e, F2.BRACKET_R, i, i + 1);
        case 123:
          return A5(e, F2.BRACE_L, i, i + 1);
        case 124:
          return A5(e, F2.PIPE, i, i + 1);
        case 125:
          return A5(e, F2.BRACE_R, i, i + 1);
        // StringValue
        case 34:
          return r.charCodeAt(i + 1) === 34 && r.charCodeAt(i + 2) === 34 ? xt2(e, i) : yt2(e, i);
      }
      if (uc(o) || o === 45)
        return mt2(e, i, o);
      if (FZ(o))
        return bt2(e, i);
      throw N5(
        e.source,
        i,
        o === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : J9(o) || Kp(r, i) ? `Unexpected character: ${Pi(e, i)}.` : `Invalid character: ${Pi(e, i)}.`
      );
    }
    return A5(e, F2.EOF, n, n);
  }
  function Et2(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1;
    for (; i < n; ) {
      const o = r.charCodeAt(i);
      if (o === 10 || o === 13)
        break;
      if (J9(o))
        ++i;
      else if (Kp(r, i))
        i += 2;
      else
        break;
    }
    return A5(
      e,
      F2.COMMENT,
      t,
      i,
      r.slice(t + 1, i)
    );
  }
  function mt2(e, t, r) {
    const n = e.source.body;
    let i = t, o = r, u = !1;
    if (o === 45 && (o = n.charCodeAt(++i)), o === 48) {
      if (o = n.charCodeAt(++i), uc(o))
        throw N5(
          e.source,
          i,
          `Invalid number, unexpected digit after 0: ${Pi(
            e,
            i
          )}.`
        );
    } else
      i = hy(e, i, o), o = n.charCodeAt(i);
    if (o === 46 && (u = !0, o = n.charCodeAt(++i), i = hy(e, i, o), o = n.charCodeAt(i)), (o === 69 || o === 101) && (u = !0, o = n.charCodeAt(++i), (o === 43 || o === 45) && (o = n.charCodeAt(++i)), i = hy(e, i, o), o = n.charCodeAt(i)), o === 46 || FZ(o))
      throw N5(
        e.source,
        i,
        `Invalid number, expected digit but got: ${Pi(
          e,
          i
        )}.`
      );
    return A5(
      e,
      u ? F2.FLOAT : F2.INT,
      t,
      i,
      n.slice(t, i)
    );
  }
  function hy(e, t, r) {
    if (!uc(r))
      throw N5(
        e.source,
        t,
        `Invalid number, expected digit but got: ${Pi(
          e,
          t
        )}.`
      );
    const n = e.source.body;
    let i = t + 1;
    for (; uc(n.charCodeAt(i)); )
      ++i;
    return i;
  }
  function yt2(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1, o = i, u = "";
    for (; i < n; ) {
      const c = r.charCodeAt(i);
      if (c === 34)
        return u += r.slice(o, i), A5(e, F2.STRING, t, i + 1, u);
      if (c === 92) {
        u += r.slice(o, i);
        const f = r.charCodeAt(i + 1) === 117 ? r.charCodeAt(i + 2) === 123 ? It2(e, i) : Bt2(e, i) : Qt2(e, i);
        u += f.value, i += f.size, o = i;
        continue;
      }
      if (c === 10 || c === 13)
        break;
      if (J9(c))
        ++i;
      else if (Kp(r, i))
        i += 2;
      else
        throw N5(
          e.source,
          i,
          `Invalid character within String: ${Pi(
            e,
            i
          )}.`
        );
    }
    throw N5(e.source, i, "Unterminated string.");
  }
  function It2(e, t) {
    const r = e.source.body;
    let n = 0, i = 3;
    for (; i < 12; ) {
      const o = r.charCodeAt(t + i++);
      if (o === 125) {
        if (i < 5 || !J9(n))
          break;
        return {
          value: String.fromCodePoint(n),
          size: i
        };
      }
      if (n = n << 4 | zl(o), n < 0)
        break;
    }
    throw N5(
      e.source,
      t,
      `Invalid Unicode escape sequence: "${r.slice(
        t,
        t + i
      )}".`
    );
  }
  function Bt2(e, t) {
    const r = e.source.body, n = cL(r, t + 2);
    if (J9(n))
      return {
        value: String.fromCodePoint(n),
        size: 6
      };
    if (NZ(n) && r.charCodeAt(t + 6) === 92 && r.charCodeAt(t + 7) === 117) {
      const i = cL(r, t + 8);
      if (HZ(i))
        return {
          value: String.fromCodePoint(n, i),
          size: 12
        };
    }
    throw N5(
      e.source,
      t,
      `Invalid Unicode escape sequence: "${r.slice(t, t + 6)}".`
    );
  }
  function cL(e, t) {
    return zl(e.charCodeAt(t)) << 12 | zl(e.charCodeAt(t + 1)) << 8 | zl(e.charCodeAt(t + 2)) << 4 | zl(e.charCodeAt(t + 3));
  }
  function zl(e) {
    return e >= 48 && e <= 57 ? e - 48 : e >= 65 && e <= 70 ? e - 55 : e >= 97 && e <= 102 ? e - 87 : -1;
  }
  function Qt2(e, t) {
    const r = e.source.body;
    switch (r.charCodeAt(t + 1)) {
      case 34:
        return {
          value: '"',
          size: 2
        };
      case 92:
        return {
          value: "\\",
          size: 2
        };
      case 47:
        return {
          value: "/",
          size: 2
        };
      case 98:
        return {
          value: "\b",
          size: 2
        };
      case 102:
        return {
          value: "\f",
          size: 2
        };
      case 110:
        return {
          value: `
`,
          size: 2
        };
      case 114:
        return {
          value: "\r",
          size: 2
        };
      case 116:
        return {
          value: "	",
          size: 2
        };
    }
    throw N5(
      e.source,
      t,
      `Invalid character escape sequence: "${r.slice(
        t,
        t + 2
      )}".`
    );
  }
  function xt2(e, t) {
    const r = e.source.body, n = r.length;
    let i = e.lineStart, o = t + 3, u = o, c = "";
    const f = [];
    for (; o < n; ) {
      const d = r.charCodeAt(o);
      if (d === 34 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34) {
        c += r.slice(u, o), f.push(c);
        const g = A5(
          e,
          F2.BLOCK_STRING,
          t,
          o + 3,
          // Return a string of the lines joined with U+000A.
          Ct2(f).join(`
`)
        );
        return e.line += f.length - 1, e.lineStart = i, g;
      }
      if (d === 92 && r.charCodeAt(o + 1) === 34 && r.charCodeAt(o + 2) === 34 && r.charCodeAt(o + 3) === 34) {
        c += r.slice(u, o), u = o + 1, o += 4;
        continue;
      }
      if (d === 10 || d === 13) {
        c += r.slice(u, o), f.push(c), d === 13 && r.charCodeAt(o + 1) === 10 ? o += 2 : ++o, c = "", u = o, i = o;
        continue;
      }
      if (J9(d))
        ++o;
      else if (Kp(r, o))
        o += 2;
      else
        throw N5(
          e.source,
          o,
          `Invalid character within String: ${Pi(
            e,
            o
          )}.`
        );
    }
    throw N5(e.source, o, "Unterminated string.");
  }
  function bt2(e, t) {
    const r = e.source.body, n = r.length;
    let i = t + 1;
    for (; i < n; ) {
      const o = r.charCodeAt(i);
      if (ft2(o))
        ++i;
      else
        break;
    }
    return A5(
      e,
      F2.NAME,
      t,
      i,
      r.slice(t, i)
    );
  }
  const wt2 = 10, jZ = 2;
  function aS(e) {
    return Xp(e, []);
  }
  function Xp(e, t) {
    switch (typeof e) {
      case "string":
        return JSON.stringify(e);
      case "function":
        return e.name ? `[function ${e.name}]` : "[function]";
      case "object":
        return St2(e, t);
      default:
        return String(e);
    }
  }
  function St2(e, t) {
    if (e === null)
      return "null";
    if (t.includes(e))
      return "[Circular]";
    const r = [...t, e];
    if (Mt2(e)) {
      const n = e.toJSON();
      if (n !== e)
        return typeof n == "string" ? n : Xp(n, r);
    } else if (Array.isArray(e))
      return Ot2(e, r);
    return _t2(e, r);
  }
  function Mt2(e) {
    return typeof e.toJSON == "function";
  }
  function _t2(e, t) {
    const r = Object.entries(e);
    return r.length === 0 ? "{}" : t.length > jZ ? "[" + Tt2(e) + "]" : "{ " + r.map(
      ([i, o]) => i + ": " + Xp(o, t)
    ).join(", ") + " }";
  }
  function Ot2(e, t) {
    if (e.length === 0)
      return "[]";
    if (t.length > jZ)
      return "[Array]";
    const r = Math.min(wt2, e.length), n = e.length - r, i = [];
    for (let o = 0; o < r; ++o)
      i.push(Xp(e[o], t));
    return n === 1 ? i.push("... 1 more item") : n > 1 && i.push(`... ${n} more items`), "[" + i.join(", ") + "]";
  }
  function Tt2(e) {
    const t = Object.prototype.toString.call(e).replace(/^\[object /, "").replace(/]$/, "");
    if (t === "Object" && typeof e.constructor == "function") {
      const r = e.constructor.name;
      if (typeof r == "string" && r !== "")
        return r;
    }
    return t;
  }
  const Dt2 = globalThis.process && // eslint-disable-next-line no-undef
  process.env.NODE_ENV === "production", Lt2 = (
    /* c8 ignore next 6 */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317
    Dt2 ? function(t, r) {
      return t instanceof r;
    } : function(t, r) {
      if (t instanceof r)
        return !0;
      if (typeof t == "object" && t !== null) {
        var n;
        const i = r.prototype[Symbol.toStringTag], o = (
          // We still need to support constructor's name to detect conflicts with older versions of this library.
          Symbol.toStringTag in t ? t[Symbol.toStringTag] : (n = t.constructor) === null || n === void 0 ? void 0 : n.name
        );
        if (i === o) {
          const u = aS(t);
          throw new Error(`Cannot use ${i} "${u}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
      }
      return !1;
    }
  );
  class VZ {
    constructor(t, r = "GraphQL request", n = {
      line: 1,
      column: 1
    }) {
      typeof t == "string" || Zd(!1, `Body must be a string. Received: ${aS(t)}.`), this.body = t, this.name = r, this.locationOffset = n, this.locationOffset.line > 0 || Zd(
        !1,
        "line in locationOffset is 1-indexed and must be positive."
      ), this.locationOffset.column > 0 || Zd(
        !1,
        "column in locationOffset is 1-indexed and must be positive."
      );
    }
    get [Symbol.toStringTag]() {
      return "Source";
    }
  }
  function kt2(e) {
    return Lt2(e, VZ);
  }
  function Rt2(e, t) {
    const r = new Pt2(e, t), n = r.parseDocument();
    return Object.defineProperty(n, "tokenCount", {
      enumerable: !1,
      value: r.tokenCount
    }), n;
  }
  let Pt2 = class {
    constructor(t, r = {}) {
      const n = kt2(t) ? t : new VZ(t);
      this._lexer = new pt2(n), this._options = r, this._tokenCounter = 0;
    }
    get tokenCount() {
      return this._tokenCounter;
    }
    /**
     * Converts a name lex token into a name parse node.
     */
    parseName() {
      const t = this.expectToken(F2.NAME);
      return this.node(t, {
        kind: a0.NAME,
        value: t.value
      });
    }
    // Implements the parsing rules in the Document section.
    /**
     * Document : Definition+
     */
    parseDocument() {
      return this.node(this._lexer.token, {
        kind: a0.DOCUMENT,
        definitions: this.many(
          F2.SOF,
          this.parseDefinition,
          F2.EOF
        )
      });
    }
    /**
     * Definition :
     *   - ExecutableDefinition
     *   - TypeSystemDefinition
     *   - TypeSystemExtension
     *
     * ExecutableDefinition :
     *   - OperationDefinition
     *   - FragmentDefinition
     *
     * TypeSystemDefinition :
     *   - SchemaDefinition
     *   - TypeDefinition
     *   - DirectiveDefinition
     *
     * TypeDefinition :
     *   - ScalarTypeDefinition
     *   - ObjectTypeDefinition
     *   - InterfaceTypeDefinition
     *   - UnionTypeDefinition
     *   - EnumTypeDefinition
     *   - InputObjectTypeDefinition
     */
    parseDefinition() {
      if (this.peek(F2.BRACE_L))
        return this.parseOperationDefinition();
      const t = this.peekDescription(), r = t ? this._lexer.lookahead() : this._lexer.token;
      if (r.kind === F2.NAME) {
        switch (r.value) {
          case "schema":
            return this.parseSchemaDefinition();
          case "scalar":
            return this.parseScalarTypeDefinition();
          case "type":
            return this.parseObjectTypeDefinition();
          case "interface":
            return this.parseInterfaceTypeDefinition();
          case "union":
            return this.parseUnionTypeDefinition();
          case "enum":
            return this.parseEnumTypeDefinition();
          case "input":
            return this.parseInputObjectTypeDefinition();
          case "directive":
            return this.parseDirectiveDefinition();
        }
        if (t)
          throw N5(
            this._lexer.source,
            this._lexer.token.start,
            "Unexpected description, descriptions are supported only on type definitions."
          );
        switch (r.value) {
          case "query":
          case "mutation":
          case "subscription":
            return this.parseOperationDefinition();
          case "fragment":
            return this.parseFragmentDefinition();
          case "extend":
            return this.parseTypeSystemExtension();
        }
      }
      throw this.unexpected(r);
    }
    // Implements the parsing rules in the Operations section.
    /**
     * OperationDefinition :
     *  - SelectionSet
     *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
     */
    parseOperationDefinition() {
      const t = this._lexer.token;
      if (this.peek(F2.BRACE_L))
        return this.node(t, {
          kind: a0.OPERATION_DEFINITION,
          operation: n9.QUERY,
          name: void 0,
          variableDefinitions: [],
          directives: [],
          selectionSet: this.parseSelectionSet()
        });
      const r = this.parseOperationType();
      let n;
      return this.peek(F2.NAME) && (n = this.parseName()), this.node(t, {
        kind: a0.OPERATION_DEFINITION,
        operation: r,
        name: n,
        variableDefinitions: this.parseVariableDefinitions(),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * OperationType : one of query mutation subscription
     */
    parseOperationType() {
      const t = this.expectToken(F2.NAME);
      switch (t.value) {
        case "query":
          return n9.QUERY;
        case "mutation":
          return n9.MUTATION;
        case "subscription":
          return n9.SUBSCRIPTION;
      }
      throw this.unexpected(t);
    }
    /**
     * VariableDefinitions : ( VariableDefinition+ )
     */
    parseVariableDefinitions() {
      return this.optionalMany(
        F2.PAREN_L,
        this.parseVariableDefinition,
        F2.PAREN_R
      );
    }
    /**
     * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
     */
    parseVariableDefinition() {
      return this.node(this._lexer.token, {
        kind: a0.VARIABLE_DEFINITION,
        variable: this.parseVariable(),
        type: (this.expectToken(F2.COLON), this.parseTypeReference()),
        defaultValue: this.expectOptionalToken(F2.EQUALS) ? this.parseConstValueLiteral() : void 0,
        directives: this.parseConstDirectives()
      });
    }
    /**
     * Variable : $ Name
     */
    parseVariable() {
      const t = this._lexer.token;
      return this.expectToken(F2.DOLLAR), this.node(t, {
        kind: a0.VARIABLE,
        name: this.parseName()
      });
    }
    /**
     * ```
     * SelectionSet : { Selection+ }
     * ```
     */
    parseSelectionSet() {
      return this.node(this._lexer.token, {
        kind: a0.SELECTION_SET,
        selections: this.many(
          F2.BRACE_L,
          this.parseSelection,
          F2.BRACE_R
        )
      });
    }
    /**
     * Selection :
     *   - Field
     *   - FragmentSpread
     *   - InlineFragment
     */
    parseSelection() {
      return this.peek(F2.SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
     * Field : Alias? Name Arguments? Directives? SelectionSet?
     *
     * Alias : Name :
     */
    parseField() {
      const t = this._lexer.token, r = this.parseName();
      let n, i;
      return this.expectOptionalToken(F2.COLON) ? (n = r, i = this.parseName()) : i = r, this.node(t, {
        kind: a0.FIELD,
        alias: n,
        name: i,
        arguments: this.parseArguments(!1),
        directives: this.parseDirectives(!1),
        selectionSet: this.peek(F2.BRACE_L) ? this.parseSelectionSet() : void 0
      });
    }
    /**
     * Arguments[Const] : ( Argument[?Const]+ )
     */
    parseArguments(t) {
      const r = t ? this.parseConstArgument : this.parseArgument;
      return this.optionalMany(F2.PAREN_L, r, F2.PAREN_R);
    }
    /**
     * Argument[Const] : Name : Value[?Const]
     */
    parseArgument(t = !1) {
      const r = this._lexer.token, n = this.parseName();
      return this.expectToken(F2.COLON), this.node(r, {
        kind: a0.ARGUMENT,
        name: n,
        value: this.parseValueLiteral(t)
      });
    }
    parseConstArgument() {
      return this.parseArgument(!0);
    }
    // Implements the parsing rules in the Fragments section.
    /**
     * Corresponds to both FragmentSpread and InlineFragment in the spec.
     *
     * FragmentSpread : ... FragmentName Directives?
     *
     * InlineFragment : ... TypeCondition? Directives? SelectionSet
     */
    parseFragment() {
      const t = this._lexer.token;
      this.expectToken(F2.SPREAD);
      const r = this.expectOptionalKeyword("on");
      return !r && this.peek(F2.NAME) ? this.node(t, {
        kind: a0.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(!1)
      }) : this.node(t, {
        kind: a0.INLINE_FRAGMENT,
        typeCondition: r ? this.parseNamedType() : void 0,
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentDefinition :
     *   - fragment FragmentName on TypeCondition Directives? SelectionSet
     *
     * TypeCondition : NamedType
     */
    parseFragmentDefinition() {
      const t = this._lexer.token;
      return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(t, {
        kind: a0.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      }) : this.node(t, {
        kind: a0.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
        directives: this.parseDirectives(!1),
        selectionSet: this.parseSelectionSet()
      });
    }
    /**
     * FragmentName : Name but not `on`
     */
    parseFragmentName() {
      if (this._lexer.token.value === "on")
        throw this.unexpected();
      return this.parseName();
    }
    // Implements the parsing rules in the Values section.
    /**
     * Value[Const] :
     *   - [~Const] Variable
     *   - IntValue
     *   - FloatValue
     *   - StringValue
     *   - BooleanValue
     *   - NullValue
     *   - EnumValue
     *   - ListValue[?Const]
     *   - ObjectValue[?Const]
     *
     * BooleanValue : one of `true` `false`
     *
     * NullValue : `null`
     *
     * EnumValue : Name but not `true`, `false` or `null`
     */
    parseValueLiteral(t) {
      const r = this._lexer.token;
      switch (r.kind) {
        case F2.BRACKET_L:
          return this.parseList(t);
        case F2.BRACE_L:
          return this.parseObject(t);
        case F2.INT:
          return this.advanceLexer(), this.node(r, {
            kind: a0.INT,
            value: r.value
          });
        case F2.FLOAT:
          return this.advanceLexer(), this.node(r, {
            kind: a0.FLOAT,
            value: r.value
          });
        case F2.STRING:
        case F2.BLOCK_STRING:
          return this.parseStringLiteral();
        case F2.NAME:
          switch (this.advanceLexer(), r.value) {
            case "true":
              return this.node(r, {
                kind: a0.BOOLEAN,
                value: !0
              });
            case "false":
              return this.node(r, {
                kind: a0.BOOLEAN,
                value: !1
              });
            case "null":
              return this.node(r, {
                kind: a0.NULL
              });
            default:
              return this.node(r, {
                kind: a0.ENUM,
                value: r.value
              });
          }
        case F2.DOLLAR:
          if (t)
            if (this.expectToken(F2.DOLLAR), this._lexer.token.kind === F2.NAME) {
              const n = this._lexer.token.value;
              throw N5(
                this._lexer.source,
                r.start,
                `Unexpected variable "$${n}" in constant value.`
              );
            } else
              throw this.unexpected(r);
          return this.parseVariable();
        default:
          throw this.unexpected();
      }
    }
    parseConstValueLiteral() {
      return this.parseValueLiteral(!0);
    }
    parseStringLiteral() {
      const t = this._lexer.token;
      return this.advanceLexer(), this.node(t, {
        kind: a0.STRING,
        value: t.value,
        block: t.kind === F2.BLOCK_STRING
      });
    }
    /**
     * ListValue[Const] :
     *   - [ ]
     *   - [ Value[?Const]+ ]
     */
    parseList(t) {
      const r = () => this.parseValueLiteral(t);
      return this.node(this._lexer.token, {
        kind: a0.LIST,
        values: this.any(F2.BRACKET_L, r, F2.BRACKET_R)
      });
    }
    /**
     * ```
     * ObjectValue[Const] :
     *   - { }
     *   - { ObjectField[?Const]+ }
     * ```
     */
    parseObject(t) {
      const r = () => this.parseObjectField(t);
      return this.node(this._lexer.token, {
        kind: a0.OBJECT,
        fields: this.any(F2.BRACE_L, r, F2.BRACE_R)
      });
    }
    /**
     * ObjectField[Const] : Name : Value[?Const]
     */
    parseObjectField(t) {
      const r = this._lexer.token, n = this.parseName();
      return this.expectToken(F2.COLON), this.node(r, {
        kind: a0.OBJECT_FIELD,
        name: n,
        value: this.parseValueLiteral(t)
      });
    }
    // Implements the parsing rules in the Directives section.
    /**
     * Directives[Const] : Directive[?Const]+
     */
    parseDirectives(t) {
      const r = [];
      for (; this.peek(F2.AT); )
        r.push(this.parseDirective(t));
      return r;
    }
    parseConstDirectives() {
      return this.parseDirectives(!0);
    }
    /**
     * ```
     * Directive[Const] : @ Name Arguments[?Const]?
     * ```
     */
    parseDirective(t) {
      const r = this._lexer.token;
      return this.expectToken(F2.AT), this.node(r, {
        kind: a0.DIRECTIVE,
        name: this.parseName(),
        arguments: this.parseArguments(t)
      });
    }
    // Implements the parsing rules in the Types section.
    /**
     * Type :
     *   - NamedType
     *   - ListType
     *   - NonNullType
     */
    parseTypeReference() {
      const t = this._lexer.token;
      let r;
      if (this.expectOptionalToken(F2.BRACKET_L)) {
        const n = this.parseTypeReference();
        this.expectToken(F2.BRACKET_R), r = this.node(t, {
          kind: a0.LIST_TYPE,
          type: n
        });
      } else
        r = this.parseNamedType();
      return this.expectOptionalToken(F2.BANG) ? this.node(t, {
        kind: a0.NON_NULL_TYPE,
        type: r
      }) : r;
    }
    /**
     * NamedType : Name
     */
    parseNamedType() {
      return this.node(this._lexer.token, {
        kind: a0.NAMED_TYPE,
        name: this.parseName()
      });
    }
    // Implements the parsing rules in the Type Definition section.
    peekDescription() {
      return this.peek(F2.STRING) || this.peek(F2.BLOCK_STRING);
    }
    /**
     * Description : StringValue
     */
    parseDescription() {
      if (this.peekDescription())
        return this.parseStringLiteral();
    }
    /**
     * ```
     * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
     * ```
     */
    parseSchemaDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("schema");
      const n = this.parseConstDirectives(), i = this.many(
        F2.BRACE_L,
        this.parseOperationTypeDefinition,
        F2.BRACE_R
      );
      return this.node(t, {
        kind: a0.SCHEMA_DEFINITION,
        description: r,
        directives: n,
        operationTypes: i
      });
    }
    /**
     * OperationTypeDefinition : OperationType : NamedType
     */
    parseOperationTypeDefinition() {
      const t = this._lexer.token, r = this.parseOperationType();
      this.expectToken(F2.COLON);
      const n = this.parseNamedType();
      return this.node(t, {
        kind: a0.OPERATION_TYPE_DEFINITION,
        operation: r,
        type: n
      });
    }
    /**
     * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
     */
    parseScalarTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("scalar");
      const n = this.parseName(), i = this.parseConstDirectives();
      return this.node(t, {
        kind: a0.SCALAR_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i
      });
    }
    /**
     * ObjectTypeDefinition :
     *   Description?
     *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
     */
    parseObjectTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("type");
      const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), u = this.parseFieldsDefinition();
      return this.node(t, {
        kind: a0.OBJECT_TYPE_DEFINITION,
        description: r,
        name: n,
        interfaces: i,
        directives: o,
        fields: u
      });
    }
    /**
     * ImplementsInterfaces :
     *   - implements `&`? NamedType
     *   - ImplementsInterfaces & NamedType
     */
    parseImplementsInterfaces() {
      return this.expectOptionalKeyword("implements") ? this.delimitedMany(F2.AMP, this.parseNamedType) : [];
    }
    /**
     * ```
     * FieldsDefinition : { FieldDefinition+ }
     * ```
     */
    parseFieldsDefinition() {
      return this.optionalMany(
        F2.BRACE_L,
        this.parseFieldDefinition,
        F2.BRACE_R
      );
    }
    /**
     * FieldDefinition :
     *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
     */
    parseFieldDefinition() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseName(), i = this.parseArgumentDefs();
      this.expectToken(F2.COLON);
      const o = this.parseTypeReference(), u = this.parseConstDirectives();
      return this.node(t, {
        kind: a0.FIELD_DEFINITION,
        description: r,
        name: n,
        arguments: i,
        type: o,
        directives: u
      });
    }
    /**
     * ArgumentsDefinition : ( InputValueDefinition+ )
     */
    parseArgumentDefs() {
      return this.optionalMany(
        F2.PAREN_L,
        this.parseInputValueDef,
        F2.PAREN_R
      );
    }
    /**
     * InputValueDefinition :
     *   - Description? Name : Type DefaultValue? Directives[Const]?
     */
    parseInputValueDef() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseName();
      this.expectToken(F2.COLON);
      const i = this.parseTypeReference();
      let o;
      this.expectOptionalToken(F2.EQUALS) && (o = this.parseConstValueLiteral());
      const u = this.parseConstDirectives();
      return this.node(t, {
        kind: a0.INPUT_VALUE_DEFINITION,
        description: r,
        name: n,
        type: i,
        defaultValue: o,
        directives: u
      });
    }
    /**
     * InterfaceTypeDefinition :
     *   - Description? interface Name Directives[Const]? FieldsDefinition?
     */
    parseInterfaceTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("interface");
      const n = this.parseName(), i = this.parseImplementsInterfaces(), o = this.parseConstDirectives(), u = this.parseFieldsDefinition();
      return this.node(t, {
        kind: a0.INTERFACE_TYPE_DEFINITION,
        description: r,
        name: n,
        interfaces: i,
        directives: o,
        fields: u
      });
    }
    /**
     * UnionTypeDefinition :
     *   - Description? union Name Directives[Const]? UnionMemberTypes?
     */
    parseUnionTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("union");
      const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseUnionMemberTypes();
      return this.node(t, {
        kind: a0.UNION_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        types: o
      });
    }
    /**
     * UnionMemberTypes :
     *   - = `|`? NamedType
     *   - UnionMemberTypes | NamedType
     */
    parseUnionMemberTypes() {
      return this.expectOptionalToken(F2.EQUALS) ? this.delimitedMany(F2.PIPE, this.parseNamedType) : [];
    }
    /**
     * EnumTypeDefinition :
     *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
     */
    parseEnumTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("enum");
      const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseEnumValuesDefinition();
      return this.node(t, {
        kind: a0.ENUM_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        values: o
      });
    }
    /**
     * ```
     * EnumValuesDefinition : { EnumValueDefinition+ }
     * ```
     */
    parseEnumValuesDefinition() {
      return this.optionalMany(
        F2.BRACE_L,
        this.parseEnumValueDefinition,
        F2.BRACE_R
      );
    }
    /**
     * EnumValueDefinition : Description? EnumValue Directives[Const]?
     */
    parseEnumValueDefinition() {
      const t = this._lexer.token, r = this.parseDescription(), n = this.parseEnumValueName(), i = this.parseConstDirectives();
      return this.node(t, {
        kind: a0.ENUM_VALUE_DEFINITION,
        description: r,
        name: n,
        directives: i
      });
    }
    /**
     * EnumValue : Name but not `true`, `false` or `null`
     */
    parseEnumValueName() {
      if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
        throw N5(
          this._lexer.source,
          this._lexer.token.start,
          `${hd(
            this._lexer.token
          )} is reserved and cannot be used for an enum value.`
        );
      return this.parseName();
    }
    /**
     * InputObjectTypeDefinition :
     *   - Description? input Name Directives[Const]? InputFieldsDefinition?
     */
    parseInputObjectTypeDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("input");
      const n = this.parseName(), i = this.parseConstDirectives(), o = this.parseInputFieldsDefinition();
      return this.node(t, {
        kind: a0.INPUT_OBJECT_TYPE_DEFINITION,
        description: r,
        name: n,
        directives: i,
        fields: o
      });
    }
    /**
     * ```
     * InputFieldsDefinition : { InputValueDefinition+ }
     * ```
     */
    parseInputFieldsDefinition() {
      return this.optionalMany(
        F2.BRACE_L,
        this.parseInputValueDef,
        F2.BRACE_R
      );
    }
    /**
     * TypeSystemExtension :
     *   - SchemaExtension
     *   - TypeExtension
     *
     * TypeExtension :
     *   - ScalarTypeExtension
     *   - ObjectTypeExtension
     *   - InterfaceTypeExtension
     *   - UnionTypeExtension
     *   - EnumTypeExtension
     *   - InputObjectTypeDefinition
     */
    parseTypeSystemExtension() {
      const t = this._lexer.lookahead();
      if (t.kind === F2.NAME)
        switch (t.value) {
          case "schema":
            return this.parseSchemaExtension();
          case "scalar":
            return this.parseScalarTypeExtension();
          case "type":
            return this.parseObjectTypeExtension();
          case "interface":
            return this.parseInterfaceTypeExtension();
          case "union":
            return this.parseUnionTypeExtension();
          case "enum":
            return this.parseEnumTypeExtension();
          case "input":
            return this.parseInputObjectTypeExtension();
        }
      throw this.unexpected(t);
    }
    /**
     * ```
     * SchemaExtension :
     *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
     *  - extend schema Directives[Const]
     * ```
     */
    parseSchemaExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("schema");
      const r = this.parseConstDirectives(), n = this.optionalMany(
        F2.BRACE_L,
        this.parseOperationTypeDefinition,
        F2.BRACE_R
      );
      if (r.length === 0 && n.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.SCHEMA_EXTENSION,
        directives: r,
        operationTypes: n
      });
    }
    /**
     * ScalarTypeExtension :
     *   - extend scalar Name Directives[Const]
     */
    parseScalarTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("scalar");
      const r = this.parseName(), n = this.parseConstDirectives();
      if (n.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.SCALAR_TYPE_EXTENSION,
        name: r,
        directives: n
      });
    }
    /**
     * ObjectTypeExtension :
     *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend type Name ImplementsInterfaces? Directives[Const]
     *  - extend type Name ImplementsInterfaces
     */
    parseObjectTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("type");
      const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
      if (n.length === 0 && i.length === 0 && o.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.OBJECT_TYPE_EXTENSION,
        name: r,
        interfaces: n,
        directives: i,
        fields: o
      });
    }
    /**
     * InterfaceTypeExtension :
     *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
     *  - extend interface Name ImplementsInterfaces? Directives[Const]
     *  - extend interface Name ImplementsInterfaces
     */
    parseInterfaceTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("interface");
      const r = this.parseName(), n = this.parseImplementsInterfaces(), i = this.parseConstDirectives(), o = this.parseFieldsDefinition();
      if (n.length === 0 && i.length === 0 && o.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.INTERFACE_TYPE_EXTENSION,
        name: r,
        interfaces: n,
        directives: i,
        fields: o
      });
    }
    /**
     * UnionTypeExtension :
     *   - extend union Name Directives[Const]? UnionMemberTypes
     *   - extend union Name Directives[Const]
     */
    parseUnionTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("union");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseUnionMemberTypes();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.UNION_TYPE_EXTENSION,
        name: r,
        directives: n,
        types: i
      });
    }
    /**
     * EnumTypeExtension :
     *   - extend enum Name Directives[Const]? EnumValuesDefinition
     *   - extend enum Name Directives[Const]
     */
    parseEnumTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("enum");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseEnumValuesDefinition();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.ENUM_TYPE_EXTENSION,
        name: r,
        directives: n,
        values: i
      });
    }
    /**
     * InputObjectTypeExtension :
     *   - extend input Name Directives[Const]? InputFieldsDefinition
     *   - extend input Name Directives[Const]
     */
    parseInputObjectTypeExtension() {
      const t = this._lexer.token;
      this.expectKeyword("extend"), this.expectKeyword("input");
      const r = this.parseName(), n = this.parseConstDirectives(), i = this.parseInputFieldsDefinition();
      if (n.length === 0 && i.length === 0)
        throw this.unexpected();
      return this.node(t, {
        kind: a0.INPUT_OBJECT_TYPE_EXTENSION,
        name: r,
        directives: n,
        fields: i
      });
    }
    /**
     * ```
     * DirectiveDefinition :
     *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
     * ```
     */
    parseDirectiveDefinition() {
      const t = this._lexer.token, r = this.parseDescription();
      this.expectKeyword("directive"), this.expectToken(F2.AT);
      const n = this.parseName(), i = this.parseArgumentDefs(), o = this.expectOptionalKeyword("repeatable");
      this.expectKeyword("on");
      const u = this.parseDirectiveLocations();
      return this.node(t, {
        kind: a0.DIRECTIVE_DEFINITION,
        description: r,
        name: n,
        arguments: i,
        repeatable: o,
        locations: u
      });
    }
    /**
     * DirectiveLocations :
     *   - `|`? DirectiveLocation
     *   - DirectiveLocations | DirectiveLocation
     */
    parseDirectiveLocations() {
      return this.delimitedMany(F2.PIPE, this.parseDirectiveLocation);
    }
    /*
     * DirectiveLocation :
     *   - ExecutableDirectiveLocation
     *   - TypeSystemDirectiveLocation
     *
     * ExecutableDirectiveLocation : one of
     *   `QUERY`
     *   `MUTATION`
     *   `SUBSCRIPTION`
     *   `FIELD`
     *   `FRAGMENT_DEFINITION`
     *   `FRAGMENT_SPREAD`
     *   `INLINE_FRAGMENT`
     *
     * TypeSystemDirectiveLocation : one of
     *   `SCHEMA`
     *   `SCALAR`
     *   `OBJECT`
     *   `FIELD_DEFINITION`
     *   `ARGUMENT_DEFINITION`
     *   `INTERFACE`
     *   `UNION`
     *   `ENUM`
     *   `ENUM_VALUE`
     *   `INPUT_OBJECT`
     *   `INPUT_FIELD_DEFINITION`
     */
    parseDirectiveLocation() {
      const t = this._lexer.token, r = this.parseName();
      if (Object.prototype.hasOwnProperty.call(Jx, r.value))
        return r;
      throw this.unexpected(t);
    }
    // Core parsing utility functions
    /**
     * Returns a node that, if configured to do so, sets a "loc" field as a
     * location object, used to identify the place in the source that created a
     * given parsed object.
     */
    node(t, r) {
      return this._options.noLocation !== !0 && (r.loc = new ct2(
        t,
        this._lexer.lastToken,
        this._lexer.source
      )), r;
    }
    /**
     * Determines if the next token is of a given kind
     */
    peek(t) {
      return this._lexer.token.kind === t;
    }
    /**
     * If the next token is of the given kind, return that token after advancing the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */
    expectToken(t) {
      const r = this._lexer.token;
      if (r.kind === t)
        return this.advanceLexer(), r;
      throw N5(
        this._lexer.source,
        r.start,
        `Expected ${ZZ(t)}, found ${hd(r)}.`
      );
    }
    /**
     * If the next token is of the given kind, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */
    expectOptionalToken(t) {
      return this._lexer.token.kind === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * If the next token is a given keyword, advance the lexer.
     * Otherwise, do not change the parser state and throw an error.
     */
    expectKeyword(t) {
      const r = this._lexer.token;
      if (r.kind === F2.NAME && r.value === t)
        this.advanceLexer();
      else
        throw N5(
          this._lexer.source,
          r.start,
          `Expected "${t}", found ${hd(r)}.`
        );
    }
    /**
     * If the next token is a given keyword, return "true" after advancing the lexer.
     * Otherwise, do not change the parser state and return "false".
     */
    expectOptionalKeyword(t) {
      const r = this._lexer.token;
      return r.kind === F2.NAME && r.value === t ? (this.advanceLexer(), !0) : !1;
    }
    /**
     * Helper function for creating an error when an unexpected lexed token is encountered.
     */
    unexpected(t) {
      const r = t ?? this._lexer.token;
      return N5(
        this._lexer.source,
        r.start,
        `Unexpected ${hd(r)}.`
      );
    }
    /**
     * Returns a possibly empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    any(t, r, n) {
      this.expectToken(t);
      const i = [];
      for (; !this.expectOptionalToken(n); )
        i.push(r.call(this));
      return i;
    }
    /**
     * Returns a list of parse nodes, determined by the parseFn.
     * It can be empty only if open token is missing otherwise it will always return non-empty list
     * that begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    optionalMany(t, r, n) {
      if (this.expectOptionalToken(t)) {
        const i = [];
        do
          i.push(r.call(this));
        while (!this.expectOptionalToken(n));
        return i;
      }
      return [];
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list begins with a lex token of openKind and ends with a lex token of closeKind.
     * Advances the parser to the next lex token after the closing token.
     */
    many(t, r, n) {
      this.expectToken(t);
      const i = [];
      do
        i.push(r.call(this));
      while (!this.expectOptionalToken(n));
      return i;
    }
    /**
     * Returns a non-empty list of parse nodes, determined by the parseFn.
     * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
     * Advances the parser to the next lex token after last item in the list.
     */
    delimitedMany(t, r) {
      this.expectOptionalToken(t);
      const n = [];
      do
        n.push(r.call(this));
      while (this.expectOptionalToken(t));
      return n;
    }
    advanceLexer() {
      const { maxTokens: t } = this._options, r = this._lexer.advance();
      if (r.kind !== F2.EOF && (++this._tokenCounter, t !== void 0 && this._tokenCounter > t))
        throw N5(
          this._lexer.source,
          r.start,
          `Document contains more that ${t} tokens. Parsing aborted.`
        );
    }
  };
  function hd(e) {
    const t = e.value;
    return ZZ(e.kind) + (t != null ? ` "${t}"` : "");
  }
  function ZZ(e) {
    return ht2(e) ? `"${e}"` : e;
  }
  function Ft2(e) {
    return `"${e.replace(Nt2, Ht2)}"`;
  }
  const Nt2 = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
  function Ht2(e) {
    return jt2[e.charCodeAt(0)];
  }
  const jt2 = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 2F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 3F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 4F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    // 5F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    // 6F
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
  ], Jp = Object.freeze({});
  function hn(e, t, r = RZ) {
    const n = /* @__PURE__ */ new Map();
    for (const _ of Object.values(a0))
      n.set(_, Vt2(t, _));
    let i, o = Array.isArray(e), u = [e], c = -1, f = [], d = e, g, h;
    const E = [], y = [];
    do {
      c++;
      const _ = c === u.length, M = _ && f.length !== 0;
      if (_) {
        if (g = y.length === 0 ? void 0 : E[E.length - 1], d = h, h = y.pop(), M)
          if (o) {
            d = d.slice();
            let O = 0;
            for (const [w, D] of f) {
              const k = w - O;
              D === null ? (d.splice(k, 1), O++) : d[k] = D;
            }
          } else {
            d = { ...d };
            for (const [O, w] of f)
              d[O] = w;
          }
        c = i.index, u = i.keys, f = i.edits, o = i.inArray, i = i.prev;
      } else if (h) {
        if (g = o ? c : u[c], d = h[g], d == null)
          continue;
        E.push(g);
      }
      let S;
      if (!Array.isArray(d)) {
        var I, Q;
        lL(d) || Zd(!1, `Invalid AST Node: ${aS(d)}.`);
        const O = _ ? (I = n.get(d.kind)) === null || I === void 0 ? void 0 : I.leave : (Q = n.get(d.kind)) === null || Q === void 0 ? void 0 : Q.enter;
        if (S = O == null ? void 0 : O.call(t, d, g, h, E, y), S === Jp)
          break;
        if (S === !1) {
          if (!_) {
            E.pop();
            continue;
          }
        } else if (S !== void 0 && (f.push([g, S]), !_))
          if (lL(S))
            d = S;
          else {
            E.pop();
            continue;
          }
      }
      if (S === void 0 && M && f.push([g, d]), _)
        E.pop();
      else {
        var B;
        i = {
          inArray: o,
          index: c,
          keys: u,
          edits: f,
          prev: i
        }, o = Array.isArray(d), u = o ? d : (B = r[d.kind]) !== null && B !== void 0 ? B : [], c = -1, f = [], h && y.push(h), h = d;
      }
    } while (i !== void 0);
    return f.length !== 0 ? f[f.length - 1][1] : e;
  }
  function Vt2(e, t) {
    const r = e[t];
    return typeof r == "object" ? r : typeof r == "function" ? {
      enter: r,
      leave: void 0
    } : {
      enter: e.enter,
      leave: e.leave
    };
  }
  function Zt2(e) {
    return hn(e, Ut2);
  }
  const zt2 = 80, Ut2 = {
    Name: {
      leave: (e) => e.value
    },
    Variable: {
      leave: (e) => "$" + e.name
    },
    // Document
    Document: {
      leave: (e) => E0(e.definitions, `

`)
    },
    OperationDefinition: {
      leave(e) {
        const t = ce("(", E0(e.variableDefinitions, ", "), ")"), r = E0(
          [
            e.operation,
            E0([e.name, t]),
            E0(e.directives, " ")
          ],
          " "
        );
        return (r === "query" ? "" : r + " ") + e.selectionSet;
      }
    },
    VariableDefinition: {
      leave: ({ variable: e, type: t, defaultValue: r, directives: n }) => e + ": " + t + ce(" = ", r) + ce(" ", E0(n, " "))
    },
    SelectionSet: {
      leave: ({ selections: e }) => sn(e)
    },
    Field: {
      leave({ alias: e, name: t, arguments: r, directives: n, selectionSet: i }) {
        const o = ce("", e, ": ") + t;
        let u = o + ce("(", E0(r, ", "), ")");
        return u.length > zt2 && (u = o + ce(`(
`, zd(E0(r, `
`)), `
)`)), E0([u, E0(n, " "), i], " ");
      }
    },
    Argument: {
      leave: ({ name: e, value: t }) => e + ": " + t
    },
    // Fragments
    FragmentSpread: {
      leave: ({ name: e, directives: t }) => "..." + e + ce(" ", E0(t, " "))
    },
    InlineFragment: {
      leave: ({ typeCondition: e, directives: t, selectionSet: r }) => E0(
        [
          "...",
          ce("on ", e),
          E0(t, " "),
          r
        ],
        " "
      )
    },
    FragmentDefinition: {
      leave: ({ name: e, typeCondition: t, variableDefinitions: r, directives: n, selectionSet: i }) => (
        // or removed in the future.
        `fragment ${e}${ce("(", E0(r, ", "), ")")} on ${t} ${ce("", E0(n, " "), " ")}` + i
      )
    },
    // Value
    IntValue: {
      leave: ({ value: e }) => e
    },
    FloatValue: {
      leave: ({ value: e }) => e
    },
    StringValue: {
      leave: ({ value: e, block: t }) => t ? gt2(e) : Ft2(e)
    },
    BooleanValue: {
      leave: ({ value: e }) => e ? "true" : "false"
    },
    NullValue: {
      leave: () => "null"
    },
    EnumValue: {
      leave: ({ value: e }) => e
    },
    ListValue: {
      leave: ({ values: e }) => "[" + E0(e, ", ") + "]"
    },
    ObjectValue: {
      leave: ({ fields: e }) => "{" + E0(e, ", ") + "}"
    },
    ObjectField: {
      leave: ({ name: e, value: t }) => e + ": " + t
    },
    // Directive
    Directive: {
      leave: ({ name: e, arguments: t }) => "@" + e + ce("(", E0(t, ", "), ")")
    },
    // Type
    NamedType: {
      leave: ({ name: e }) => e
    },
    ListType: {
      leave: ({ type: e }) => "[" + e + "]"
    },
    NonNullType: {
      leave: ({ type: e }) => e + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
      leave: ({ description: e, directives: t, operationTypes: r }) => ce("", e, `
`) + E0(["schema", E0(t, " "), sn(r)], " ")
    },
    OperationTypeDefinition: {
      leave: ({ operation: e, type: t }) => e + ": " + t
    },
    ScalarTypeDefinition: {
      leave: ({ description: e, name: t, directives: r }) => ce("", e, `
`) + E0(["scalar", t, E0(r, " ")], " ")
    },
    ObjectTypeDefinition: {
      leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => ce("", e, `
`) + E0(
        [
          "type",
          t,
          ce("implements ", E0(r, " & ")),
          E0(n, " "),
          sn(i)
        ],
        " "
      )
    },
    FieldDefinition: {
      leave: ({ description: e, name: t, arguments: r, type: n, directives: i }) => ce("", e, `
`) + t + (AL(r) ? ce(`(
`, zd(E0(r, `
`)), `
)`) : ce("(", E0(r, ", "), ")")) + ": " + n + ce(" ", E0(i, " "))
    },
    InputValueDefinition: {
      leave: ({ description: e, name: t, type: r, defaultValue: n, directives: i }) => ce("", e, `
`) + E0(
        [t + ": " + r, ce("= ", n), E0(i, " ")],
        " "
      )
    },
    InterfaceTypeDefinition: {
      leave: ({ description: e, name: t, interfaces: r, directives: n, fields: i }) => ce("", e, `
`) + E0(
        [
          "interface",
          t,
          ce("implements ", E0(r, " & ")),
          E0(n, " "),
          sn(i)
        ],
        " "
      )
    },
    UnionTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, types: n }) => ce("", e, `
`) + E0(
        ["union", t, E0(r, " "), ce("= ", E0(n, " | "))],
        " "
      )
    },
    EnumTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, values: n }) => ce("", e, `
`) + E0(["enum", t, E0(r, " "), sn(n)], " ")
    },
    EnumValueDefinition: {
      leave: ({ description: e, name: t, directives: r }) => ce("", e, `
`) + E0([t, E0(r, " ")], " ")
    },
    InputObjectTypeDefinition: {
      leave: ({ description: e, name: t, directives: r, fields: n }) => ce("", e, `
`) + E0(["input", t, E0(r, " "), sn(n)], " ")
    },
    DirectiveDefinition: {
      leave: ({ description: e, name: t, arguments: r, repeatable: n, locations: i }) => ce("", e, `
`) + "directive @" + t + (AL(r) ? ce(`(
`, zd(E0(r, `
`)), `
)`) : ce("(", E0(r, ", "), ")")) + (n ? " repeatable" : "") + " on " + E0(i, " | ")
    },
    SchemaExtension: {
      leave: ({ directives: e, operationTypes: t }) => E0(
        ["extend schema", E0(e, " "), sn(t)],
        " "
      )
    },
    ScalarTypeExtension: {
      leave: ({ name: e, directives: t }) => E0(["extend scalar", e, E0(t, " ")], " ")
    },
    ObjectTypeExtension: {
      leave: ({ name: e, interfaces: t, directives: r, fields: n }) => E0(
        [
          "extend type",
          e,
          ce("implements ", E0(t, " & ")),
          E0(r, " "),
          sn(n)
        ],
        " "
      )
    },
    InterfaceTypeExtension: {
      leave: ({ name: e, interfaces: t, directives: r, fields: n }) => E0(
        [
          "extend interface",
          e,
          ce("implements ", E0(t, " & ")),
          E0(r, " "),
          sn(n)
        ],
        " "
      )
    },
    UnionTypeExtension: {
      leave: ({ name: e, directives: t, types: r }) => E0(
        [
          "extend union",
          e,
          E0(t, " "),
          ce("= ", E0(r, " | "))
        ],
        " "
      )
    },
    EnumTypeExtension: {
      leave: ({ name: e, directives: t, values: r }) => E0(["extend enum", e, E0(t, " "), sn(r)], " ")
    },
    InputObjectTypeExtension: {
      leave: ({ name: e, directives: t, fields: r }) => E0(["extend input", e, E0(t, " "), sn(r)], " ")
    }
  };
  function E0(e, t = "") {
    var r;
    return (r = e == null ? void 0 : e.filter((n) => n).join(t)) !== null && r !== void 0 ? r : "";
  }
  function sn(e) {
    return ce(`{
`, zd(E0(e, `
`)), `
}`);
  }
  function ce(e, t, r = "") {
    return t != null && t !== "" ? e + t + r : "";
  }
  function zd(e) {
    return ce("  ", e.replace(/\n/g, `
  `));
  }
  function AL(e) {
    var t;
    return (t = e == null ? void 0 : e.some((r) => r.includes(`
`))) !== null && t !== void 0 ? t : !1;
  }
  function fL(e) {
    return e.kind === a0.FIELD || e.kind === a0.FRAGMENT_SPREAD || e.kind === a0.INLINE_FRAGMENT;
  }
  function Xc(e, t) {
    var r = e.directives;
    return !r || !r.length ? !0 : Yt2(r).every(function(n) {
      var i = n.directive, o = n.ifArgument, u = !1;
      return o.value.kind === "Variable" ? (u = t && t[o.value.name.value], u0(u !== void 0, 78, i.name.value)) : u = o.value.value, i.name.value === "skip" ? !u : u;
    });
  }
  function lc(e, t, r) {
    var n = new Set(e), i = n.size;
    return hn(t, {
      Directive: function(o) {
        if (n.delete(o.name.value) && (!r || !n.size))
          return Jp;
      }
    }), r ? !n.size : n.size < i;
  }
  function qt2(e) {
    return e && lc(["client", "export"], e, !0);
  }
  function Wt2(e) {
    var t = e.name.value;
    return t === "skip" || t === "include";
  }
  function Yt2(e) {
    var t = [];
    return e && e.length && e.forEach(function(r) {
      if (Wt2(r)) {
        var n = r.arguments, i = r.name.value;
        u0(n && n.length === 1, 79, i);
        var o = n[0];
        u0(o.name && o.name.value === "if", 80, i);
        var u = o.value;
        u0(u && (u.kind === "Variable" || u.kind === "BooleanValue"), 81, i), t.push({ directive: r, ifArgument: o });
      }
    }), t;
  }
  function $t2(e) {
    var t, r, n = (t = e.directives) === null || t === void 0 ? void 0 : t.find(function(o) {
      var u = o.name;
      return u.value === "unmask";
    });
    if (!n)
      return "mask";
    var i = (r = n.arguments) === null || r === void 0 ? void 0 : r.find(function(o) {
      var u = o.name;
      return u.value === "mode";
    });
    return globalThis.__DEV__ !== !1 && i && (i.value.kind === a0.VARIABLE ? globalThis.__DEV__ !== !1 && u0.warn(82) : i.value.kind !== a0.STRING ? globalThis.__DEV__ !== !1 && u0.warn(83) : i.value.value !== "migrate" && globalThis.__DEV__ !== !1 && u0.warn(84, i.value.value)), i && "value" in i.value && i.value.value === "migrate" ? "migrate" : "unmask";
  }
  const Gt2 = () => /* @__PURE__ */ Object.create(null), { forEach: Kt2, slice: CL } = Array.prototype, { hasOwnProperty: Xt2 } = Object.prototype;
  class S8 {
    constructor(t = !0, r = Gt2) {
      this.weakness = t, this.makeData = r;
    }
    lookup() {
      return this.lookupArray(arguments);
    }
    lookupArray(t) {
      let r = this;
      return Kt2.call(t, (n) => r = r.getChildTrie(n)), Xt2.call(r, "data") ? r.data : r.data = this.makeData(CL.call(t));
    }
    peek() {
      return this.peekArray(arguments);
    }
    peekArray(t) {
      let r = this;
      for (let n = 0, i = t.length; r && n < i; ++n) {
        const o = r.mapFor(t[n], !1);
        r = o && o.get(t[n]);
      }
      return r && r.data;
    }
    remove() {
      return this.removeArray(arguments);
    }
    removeArray(t) {
      let r;
      if (t.length) {
        const n = t[0], i = this.mapFor(n, !1), o = i && i.get(n);
        o && (r = o.removeArray(CL.call(t, 1)), !o.data && !o.weak && !(o.strong && o.strong.size) && i.delete(n));
      } else
        r = this.data, delete this.data;
      return r;
    }
    getChildTrie(t) {
      const r = this.mapFor(t, !0);
      let n = r.get(t);
      return n || r.set(t, n = new S8(this.weakness, this.makeData)), n;
    }
    mapFor(t, r) {
      return this.weakness && Jt2(t) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
    }
  }
  function Jt2(e) {
    switch (typeof e) {
      case "object":
        if (e === null)
          break;
      // Fall through to return true...
      case "function":
        return !0;
    }
    return !1;
  }
  var zZ = Cn(function() {
    return navigator.product;
  }) == "ReactNative", qi = typeof WeakMap == "function" && !(zZ && !global.HermesInternal), oS = typeof WeakSet == "function", sS = typeof Symbol == "function" && typeof Symbol.for == "function", eh = sS && Symbol.asyncIterator, UZ = typeof Cn(function() {
    return window.document.createElement;
  }) == "function", e52 = (
    // Following advice found in this comment from @domenic (maintainer of jsdom):
    // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
    //
    // Since we control the version of Jest and jsdom used when running Apollo
    // Client tests, and that version is recent enought to include " jsdom/x.y.z"
    // at the end of the user agent string, I believe this case is all we need to
    // check. Testing for "Node.js" was recommended for backwards compatibility
    // with older version of jsdom, but we don't have that problem.
    Cn(function() {
      return navigator.userAgent.indexOf("jsdom") >= 0;
    }) || !1
  ), t52 = (UZ || zZ) && !e52;
  function qt(e) {
    return e !== null && typeof e == "object";
  }
  function r52(e, t) {
    var r = t, n = [];
    e.definitions.forEach(function(o) {
      if (o.kind === "OperationDefinition")
        throw G1(
          85,
          o.operation,
          o.name ? " named '".concat(o.name.value, "'") : ""
        );
      o.kind === "FragmentDefinition" && n.push(o);
    }), typeof r > "u" && (u0(n.length === 1, 86, n.length), r = n[0].name.value);
    var i = C2(C2({}, e), { definitions: l1([
      {
        kind: "OperationDefinition",
        // OperationTypeNode is an enum
        operation: "query",
        selectionSet: {
          kind: "SelectionSet",
          selections: [
            {
              kind: "FragmentSpread",
              name: {
                kind: "Name",
                value: r
              }
            }
          ]
        }
      }
    ], e.definitions, !0) });
    return i;
  }
  function es(e) {
    e === void 0 && (e = []);
    var t = {};
    return e.forEach(function(r) {
      t[r.name.value] = r;
    }), t;
  }
  function th(e, t) {
    switch (e.kind) {
      case "InlineFragment":
        return e;
      case "FragmentSpread": {
        var r = e.name.value;
        if (typeof t == "function")
          return t(r);
        var n = t && t[r];
        return u0(n, 87, r), n || null;
      }
      default:
        return null;
    }
  }
  function n52(e) {
    var t = !0;
    return hn(e, {
      FragmentSpread: function(r) {
        if (t = !!r.directives && r.directives.some(function(n) {
          return n.name.value === "unmask";
        }), !t)
          return Jp;
      }
    }), t;
  }
  function i52() {
  }
  class tb {
    constructor(t = 1 / 0, r = i52) {
      this.max = t, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
    }
    has(t) {
      return this.map.has(t);
    }
    get(t) {
      const r = this.getNode(t);
      return r && r.value;
    }
    get size() {
      return this.map.size;
    }
    getNode(t) {
      const r = this.map.get(t);
      if (r && r !== this.newest) {
        const { older: n, newer: i } = r;
        i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
      }
      return r;
    }
    set(t, r) {
      let n = this.getNode(t);
      return n ? n.value = r : (n = {
        key: t,
        value: r,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.map.set(t, n), n.value);
    }
    clean() {
      for (; this.oldest && this.map.size > this.max; )
        this.delete(this.oldest.key);
    }
    delete(t) {
      const r = this.map.get(t);
      return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(t), this.dispose(r.value, t), !0) : !1;
    }
  }
  function rb() {
  }
  const a52 = rb, o52 = typeof WeakRef < "u" ? WeakRef : function(e) {
    return { deref: () => e };
  }, s52 = typeof WeakMap < "u" ? WeakMap : Map, u52 = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
    return {
      register: rb,
      unregister: rb
    };
  }, l52 = 10024;
  class Pg {
    constructor(t = 1 / 0, r = a52) {
      this.max = t, this.dispose = r, this.map = new s52(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
        const n = this.unfinalizedNodes.values();
        for (let i = 0; i < l52; i++) {
          const o = n.next().value;
          if (!o)
            break;
          this.unfinalizedNodes.delete(o);
          const u = o.key;
          delete o.key, o.keyRef = new o52(u), this.registry.register(u, o, o);
        }
        this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
      }, this.registry = new u52(this.deleteNode.bind(this));
    }
    has(t) {
      return this.map.has(t);
    }
    get(t) {
      const r = this.getNode(t);
      return r && r.value;
    }
    getNode(t) {
      const r = this.map.get(t);
      if (r && r !== this.newest) {
        const { older: n, newer: i } = r;
        i && (i.older = n), n && (n.newer = i), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = i);
      }
      return r;
    }
    set(t, r) {
      let n = this.getNode(t);
      return n ? n.value = r : (n = {
        key: t,
        value: r,
        newer: null,
        older: this.newest
      }, this.newest && (this.newest.newer = n), this.newest = n, this.oldest = this.oldest || n, this.scheduleFinalization(n), this.map.set(t, n), this.size++, n.value);
    }
    clean() {
      for (; this.oldest && this.size > this.max; )
        this.deleteNode(this.oldest);
    }
    deleteNode(t) {
      t === this.newest && (this.newest = t.older), t === this.oldest && (this.oldest = t.newer), t.newer && (t.newer.older = t.older), t.older && (t.older.newer = t.newer), this.size--;
      const r = t.key || t.keyRef && t.keyRef.deref();
      this.dispose(t.value, r), t.keyRef ? this.registry.unregister(t) : this.unfinalizedNodes.delete(t), r && this.map.delete(r);
    }
    delete(t) {
      const r = this.map.get(t);
      return r ? (this.deleteNode(r), !0) : !1;
    }
    scheduleFinalization(t) {
      this.unfinalizedNodes.add(t), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
    }
  }
  var vy = /* @__PURE__ */ new WeakSet();
  function qZ(e) {
    e.size <= (e.max || -1) || vy.has(e) || (vy.add(e), setTimeout(function() {
      e.clean(), vy.delete(e);
    }, 100));
  }
  var uS = function(e, t) {
    var r = new Pg(e, t);
    return r.set = function(n, i) {
      var o = Pg.prototype.set.call(this, n, i);
      return qZ(this), o;
    }, r;
  }, c52 = function(e, t) {
    var r = new tb(e, t);
    return r.set = function(n, i) {
      var o = tb.prototype.set.call(this, n, i);
      return qZ(this), o;
    }, r;
  }, A52 = Symbol.for("apollo.cacheSize"), f3 = C2({}, sc[A52]), Ii = {};
  function lS(e, t) {
    Ii[e] = t;
  }
  var f52 = globalThis.__DEV__ !== !1 ? p52 : void 0, C52 = globalThis.__DEV__ !== !1 ? h52 : void 0, d52 = globalThis.__DEV__ !== !1 ? WZ : void 0;
  function g52() {
    var e = {
      parser: 1e3,
      canonicalStringify: 1e3,
      print: 2e3,
      "documentTransform.cache": 2e3,
      "queryManager.getDocumentInfo": 2e3,
      "PersistedQueryLink.persistedQueryHashes": 2e3,
      "fragmentRegistry.transform": 2e3,
      "fragmentRegistry.lookup": 1e3,
      "fragmentRegistry.findFragmentSpreads": 4e3,
      "cache.fragmentQueryDocuments": 1e3,
      "removeTypenameFromVariables.getVariableDefinitions": 2e3,
      "inMemoryCache.maybeBroadcastWatch": 5e3,
      "inMemoryCache.executeSelectionSet": 5e4,
      "inMemoryCache.executeSubSelectedArray": 1e4
    };
    return Object.fromEntries(Object.entries(e).map(function(t) {
      var r = t[0], n = t[1];
      return [
        r,
        f3[r] || n
      ];
    }));
  }
  function p52() {
    var e, t, r, n, i;
    if (globalThis.__DEV__ === !1)
      throw new Error("only supported in development mode");
    return {
      limits: g52(),
      sizes: C2({ print: (e = Ii.print) === null || e === void 0 ? void 0 : e.call(Ii), parser: (t = Ii.parser) === null || t === void 0 ? void 0 : t.call(Ii), canonicalStringify: (r = Ii.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Ii), links: ib(this.link), queryManager: {
        getDocumentInfo: this.queryManager.transformCache.size,
        documentTransforms: $Z(this.queryManager.documentTransform)
      } }, (i = (n = this.cache).getMemoryInternals) === null || i === void 0 ? void 0 : i.call(n))
    };
  }
  function WZ() {
    return {
      cache: {
        fragmentQueryDocuments: k6(this.getFragmentDoc)
      }
    };
  }
  function h52() {
    var e = this.config.fragments;
    return C2(C2({}, WZ.apply(this)), { addTypenameDocumentTransform: $Z(this.addTypenameTransform), inMemoryCache: {
      executeSelectionSet: k6(this.storeReader.executeSelectionSet),
      executeSubSelectedArray: k6(this.storeReader.executeSubSelectedArray),
      maybeBroadcastWatch: k6(this.maybeBroadcastWatch)
    }, fragmentRegistry: {
      findFragmentSpreads: k6(e == null ? void 0 : e.findFragmentSpreads),
      lookup: k6(e == null ? void 0 : e.lookup),
      transform: k6(e == null ? void 0 : e.transform)
    } });
  }
  function v52(e) {
    return !!e && "dirtyKey" in e;
  }
  function k6(e) {
    return v52(e) ? e.size : void 0;
  }
  function YZ(e) {
    return e != null;
  }
  function $Z(e) {
    return nb(e).map(function(t) {
      return { cache: t };
    });
  }
  function nb(e) {
    return e ? l1(l1([
      k6(e == null ? void 0 : e.performWork)
    ], nb(e == null ? void 0 : e.left), !0), nb(e == null ? void 0 : e.right), !0).filter(YZ) : [];
  }
  function ib(e) {
    var t;
    return e ? l1(l1([
      (t = e == null ? void 0 : e.getMemoryInternals) === null || t === void 0 ? void 0 : t.call(e)
    ], ib(e == null ? void 0 : e.left), !0), ib(e == null ? void 0 : e.right), !0).filter(YZ) : [];
  }
  var N6 = Object.assign(function(t) {
    return JSON.stringify(t, E52);
  }, {
    reset: function() {
      i9 = new c52(
        f3.canonicalStringify || 1e3
        /* defaultCacheSizes.canonicalStringify */
      );
    }
  });
  globalThis.__DEV__ !== !1 && lS("canonicalStringify", function() {
    return i9.size;
  });
  var i9;
  N6.reset();
  function E52(e, t) {
    if (t && typeof t == "object") {
      var r = Object.getPrototypeOf(t);
      if (r === Object.prototype || r === null) {
        var n = Object.keys(t);
        if (n.every(m52))
          return t;
        var i = JSON.stringify(n), o = i9.get(i);
        if (!o) {
          n.sort();
          var u = JSON.stringify(n);
          o = i9.get(u) || n, i9.set(i, o), i9.set(u, o);
        }
        var c = Object.create(r);
        return o.forEach(function(f) {
          c[f] = t[f];
        }), c;
      }
    }
    return t;
  }
  function m52(e, t, r) {
    return t === 0 || r[t - 1] <= e;
  }
  function A9(e) {
    return { __ref: String(e) };
  }
  function Ye(e) {
    return !!(e && typeof e == "object" && typeof e.__ref == "string");
  }
  function y52(e) {
    return qt(e) && e.kind === "Document" && Array.isArray(e.definitions);
  }
  function I52(e) {
    return e.kind === "StringValue";
  }
  function B52(e) {
    return e.kind === "BooleanValue";
  }
  function Q52(e) {
    return e.kind === "IntValue";
  }
  function x52(e) {
    return e.kind === "FloatValue";
  }
  function b52(e) {
    return e.kind === "Variable";
  }
  function w52(e) {
    return e.kind === "ObjectValue";
  }
  function S52(e) {
    return e.kind === "ListValue";
  }
  function M52(e) {
    return e.kind === "EnumValue";
  }
  function _52(e) {
    return e.kind === "NullValue";
  }
  function y9(e, t, r, n) {
    if (Q52(r) || x52(r))
      e[t.value] = Number(r.value);
    else if (B52(r) || I52(r))
      e[t.value] = r.value;
    else if (w52(r)) {
      var i = {};
      r.fields.map(function(u) {
        return y9(i, u.name, u.value, n);
      }), e[t.value] = i;
    } else if (b52(r)) {
      var o = (n || {})[r.name.value];
      e[t.value] = o;
    } else if (S52(r))
      e[t.value] = r.values.map(function(u) {
        var c = {};
        return y9(c, t, u, n), c[t.value];
      });
    else if (M52(r))
      e[t.value] = r.value;
    else if (_52(r))
      e[t.value] = null;
    else
      throw G1(96, t.value, r.kind);
  }
  function O52(e, t) {
    var r = null;
    e.directives && (r = {}, e.directives.forEach(function(i) {
      r[i.name.value] = {}, i.arguments && i.arguments.forEach(function(o) {
        var u = o.name, c = o.value;
        return y9(r[i.name.value], u, c, t);
      });
    }));
    var n = null;
    return e.arguments && e.arguments.length && (n = {}, e.arguments.forEach(function(i) {
      var o = i.name, u = i.value;
      return y9(n, o, u, t);
    })), GZ(e.name.value, n, r);
  }
  var T52 = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
  ], bl = N6, GZ = Object.assign(function(e, t, r) {
    if (t && r && r.connection && r.connection.key)
      if (r.connection.filter && r.connection.filter.length > 0) {
        var n = r.connection.filter ? r.connection.filter : [];
        n.sort();
        var i = {};
        return n.forEach(function(c) {
          i[c] = t[c];
        }), "".concat(r.connection.key, "(").concat(bl(i), ")");
      } else
        return r.connection.key;
    var o = e;
    if (t) {
      var u = bl(t);
      o += "(".concat(u, ")");
    }
    return r && Object.keys(r).forEach(function(c) {
      T52.indexOf(c) === -1 && (r[c] && Object.keys(r[c]).length ? o += "@".concat(c, "(").concat(bl(r[c]), ")") : o += "@".concat(c));
    }), o;
  }, {
    setStringify: function(e) {
      var t = bl;
      return bl = e, t;
    }
  });
  function rh(e, t) {
    if (e.arguments && e.arguments.length) {
      var r = {};
      return e.arguments.forEach(function(n) {
        var i = n.name, o = n.value;
        return y9(r, i, o, t);
      }), r;
    }
    return null;
  }
  function m8(e) {
    return e.alias ? e.alias.value : e.name.value;
  }
  function ab(e, t, r) {
    for (var n, i = 0, o = t.selections; i < o.length; i++) {
      var u = o[i];
      if (V6(u)) {
        if (u.name.value === "__typename")
          return e[m8(u)];
      } else n ? n.push(u) : n = [u];
    }
    if (typeof e.__typename == "string")
      return e.__typename;
    if (n)
      for (var c = 0, f = n; c < f.length; c++) {
        var u = f[c], d = ab(e, th(u, r).selectionSet, r);
        if (typeof d == "string")
          return d;
      }
  }
  function V6(e) {
    return e.kind === "Field";
  }
  function D52(e) {
    return e.kind === "InlineFragment";
  }
  function ts(e) {
    u0(e && e.kind === "Document", 88);
    var t = e.definitions.filter(function(r) {
      return r.kind !== "FragmentDefinition";
    }).map(function(r) {
      if (r.kind !== "OperationDefinition")
        throw G1(89, r.kind);
      return r;
    });
    return u0(t.length <= 1, 90, t.length), e;
  }
  function Fi(e) {
    return ts(e), e.definitions.filter(function(t) {
      return t.kind === "OperationDefinition";
    })[0];
  }
  function Ul(e) {
    return e.definitions.filter(function(t) {
      return t.kind === "OperationDefinition" && !!t.name;
    }).map(function(t) {
      return t.name.value;
    })[0] || null;
  }
  function rs(e) {
    return e.definitions.filter(function(t) {
      return t.kind === "FragmentDefinition";
    });
  }
  function KZ(e) {
    var t = Fi(e);
    return u0(t && t.operation === "query", 91), t;
  }
  function XZ(e) {
    u0(e.kind === "Document", 92), u0(e.definitions.length <= 1, 93);
    var t = e.definitions[0];
    return u0(t.kind === "FragmentDefinition", 94), t;
  }
  function Jc(e) {
    ts(e);
    for (var t, r = 0, n = e.definitions; r < n.length; r++) {
      var i = n[r];
      if (i.kind === "OperationDefinition") {
        var o = i.operation;
        if (o === "query" || o === "mutation" || o === "subscription")
          return i;
      }
      i.kind === "FragmentDefinition" && !t && (t = i);
    }
    if (t)
      return t;
    throw G1(95);
  }
  function cS(e) {
    var t = /* @__PURE__ */ Object.create(null), r = e && e.variableDefinitions;
    return r && r.length && r.forEach(function(n) {
      n.defaultValue && y9(t, n.variable.name, n.defaultValue);
    }), t;
  }
  let o1 = null;
  const dL = {};
  let L52 = 1;
  const k52 = () => class {
    constructor() {
      this.id = [
        "slot",
        L52++,
        Date.now(),
        Math.random().toString(36).slice(2)
      ].join(":");
    }
    hasValue() {
      for (let t = o1; t; t = t.parent)
        if (this.id in t.slots) {
          const r = t.slots[this.id];
          if (r === dL)
            break;
          return t !== o1 && (o1.slots[this.id] = r), !0;
        }
      return o1 && (o1.slots[this.id] = dL), !1;
    }
    getValue() {
      if (this.hasValue())
        return o1.slots[this.id];
    }
    withValue(t, r, n, i) {
      const o = {
        __proto__: null,
        [this.id]: t
      }, u = o1;
      o1 = { parent: u, slots: o };
      try {
        return r.apply(i, n);
      } finally {
        o1 = u;
      }
    }
    // Capture the current context and wrap a callback function so that it
    // reestablishes the captured context when called.
    static bind(t) {
      const r = o1;
      return function() {
        const n = o1;
        try {
          return o1 = r, t.apply(this, arguments);
        } finally {
          o1 = n;
        }
      };
    }
    // Immediately run a callback function without any captured context.
    static noContext(t, r, n) {
      if (o1) {
        const i = o1;
        try {
          return o1 = null, t.apply(n, r);
        } finally {
          o1 = i;
        }
      } else
        return t.apply(n, r);
    }
  };
  function gL(e) {
    try {
      return e();
    } catch {
    }
  }
  const Ey = "@wry/context:Slot", R52 = (
    // Prefer globalThis when available.
    // https://github.com/benjamn/wryware/issues/347
    gL(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
    // bundlers to the appropriate identifier (window, self, ...) depending on the
    // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
    gL(() => global) || // Otherwise, use a dummy host that's local to this module. We used to fall
    // back to using the Array constructor as a namespace, but that was flagged in
    // https://github.com/benjamn/wryware/issues/347, and can be avoided.
    /* @__PURE__ */ Object.create(null)
  ), pL = R52, eA = pL[Ey] || // Earlier versions of this package stored the globalKey property on the Array
  // constructor, so we check there as well, to prevent Slot class duplication.
  Array[Ey] || function(e) {
    try {
      Object.defineProperty(pL, Ey, {
        value: e,
        enumerable: !1,
        writable: !1,
        // When it was possible for globalHost to be the Array constructor (a
        // legacy Slot dedup strategy), it was important for the property to be
        // configurable:true so it could be deleted. That does not seem to be as
        // important when globalHost is the global object, but I don't want to
        // cause similar problems again, and configurable:true seems safest.
        // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
        configurable: !0
      });
    } finally {
      return e;
    }
  }(k52()), { bind: BQ2, noContext: QQ2 } = eA, nh = new eA(), { hasOwnProperty: P52 } = Object.prototype, AS = Array.from || function(e) {
    const t = [];
    return e.forEach((r) => t.push(r)), t;
  };
  function fS(e) {
    const { unsubscribe: t } = e;
    typeof t == "function" && (e.unsubscribe = void 0, t());
  }
  const cc = [], F52 = 100;
  function I9(e, t) {
    if (!e)
      throw new Error(t || "assertion failure");
  }
  function JZ(e, t) {
    const r = e.length;
    return (
      // Unknown values are not equal to each other.
      r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
      r === t.length && // The underlying value or exception must be the same.
      e[r - 1] === t[r - 1]
    );
  }
  function ez(e) {
    switch (e.length) {
      case 0:
        throw new Error("unknown value");
      case 1:
        return e[0];
      case 2:
        throw e[1];
    }
  }
  function tz(e) {
    return e.slice(0);
  }
  class ih {
    constructor(t) {
      this.fn = t, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++ih.count;
    }
    peek() {
      if (this.value.length === 1 && !Z6(this))
        return hL(this), this.value[0];
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(t) {
      return I9(!this.recomputing, "already recomputing"), hL(this), Z6(this) ? N52(this, t) : ez(this.value);
    }
    setDirty() {
      this.dirty || (this.dirty = !0, rz(this), fS(this));
    }
    dispose() {
      this.setDirty(), sz(this), CS(this, (t, r) => {
        t.setDirty(), uz(t, this);
      });
    }
    forget() {
      this.dispose();
    }
    dependOn(t) {
      t.add(this), this.deps || (this.deps = cc.pop() || /* @__PURE__ */ new Set()), this.deps.add(t);
    }
    forgetDeps() {
      this.deps && (AS(this.deps).forEach((t) => t.delete(this)), this.deps.clear(), cc.push(this.deps), this.deps = null);
    }
  }
  ih.count = 0;
  function hL(e) {
    const t = nh.getValue();
    if (t)
      return e.parents.add(t), t.childValues.has(e) || t.childValues.set(e, []), Z6(e) ? iz(t, e) : az(t, e), t;
  }
  function N52(e, t) {
    return sz(e), nh.withValue(e, H52, [e, t]), V52(e, t) && j52(e), ez(e.value);
  }
  function H52(e, t) {
    e.recomputing = !0;
    const { normalizeResult: r } = e;
    let n;
    r && e.value.length === 1 && (n = tz(e.value)), e.value.length = 0;
    try {
      if (e.value[0] = e.fn.apply(null, t), r && n && !JZ(n, e.value))
        try {
          e.value[0] = r(e.value[0], n[0]);
        } catch {
        }
    } catch (i) {
      e.value[1] = i;
    }
    e.recomputing = !1;
  }
  function Z6(e) {
    return e.dirty || !!(e.dirtyChildren && e.dirtyChildren.size);
  }
  function j52(e) {
    e.dirty = !1, !Z6(e) && nz(e);
  }
  function rz(e) {
    CS(e, iz);
  }
  function nz(e) {
    CS(e, az);
  }
  function CS(e, t) {
    const r = e.parents.size;
    if (r) {
      const n = AS(e.parents);
      for (let i = 0; i < r; ++i)
        t(n[i], e);
    }
  }
  function iz(e, t) {
    I9(e.childValues.has(t)), I9(Z6(t));
    const r = !Z6(e);
    if (!e.dirtyChildren)
      e.dirtyChildren = cc.pop() || /* @__PURE__ */ new Set();
    else if (e.dirtyChildren.has(t))
      return;
    e.dirtyChildren.add(t), r && rz(e);
  }
  function az(e, t) {
    I9(e.childValues.has(t)), I9(!Z6(t));
    const r = e.childValues.get(t);
    r.length === 0 ? e.childValues.set(t, tz(t.value)) : JZ(r, t.value) || e.setDirty(), oz(e, t), !Z6(e) && nz(e);
  }
  function oz(e, t) {
    const r = e.dirtyChildren;
    r && (r.delete(t), r.size === 0 && (cc.length < F52 && cc.push(r), e.dirtyChildren = null));
  }
  function sz(e) {
    e.childValues.size > 0 && e.childValues.forEach((t, r) => {
      uz(e, r);
    }), e.forgetDeps(), I9(e.dirtyChildren === null);
  }
  function uz(e, t) {
    t.parents.delete(e), e.childValues.delete(t), oz(e, t);
  }
  function V52(e, t) {
    if (typeof e.subscribe == "function")
      try {
        fS(e), e.unsubscribe = e.subscribe.apply(null, t);
      } catch {
        return e.setDirty(), !1;
      }
    return !0;
  }
  const Z52 = {
    setDirty: !0,
    dispose: !0,
    forget: !0
    // Fully remove parent Entry from LRU cache and computation graph
  };
  function lz(e) {
    const t = /* @__PURE__ */ new Map();
    function r(n) {
      const i = nh.getValue();
      if (i) {
        let o = t.get(n);
        o || t.set(n, o = /* @__PURE__ */ new Set()), i.dependOn(o);
      }
    }
    return r.dirty = function(i, o) {
      const u = t.get(i);
      if (u) {
        const c = o && P52.call(Z52, o) ? o : "setDirty";
        AS(u).forEach((f) => f[c]()), t.delete(i), fS(u);
      }
    }, r;
  }
  let vL;
  function z52(...e) {
    return (vL || (vL = new S8(typeof WeakMap == "function"))).lookupArray(e);
  }
  const my = /* @__PURE__ */ new Set();
  function Ac(e, { max: t = Math.pow(2, 16), keyArgs: r, makeCacheKey: n = z52, normalizeResult: i, subscribe: o, cache: u = tb } = /* @__PURE__ */ Object.create(null)) {
    const c = typeof u == "function" ? new u(t, (E) => E.dispose()) : u, f = function() {
      const E = n.apply(null, r ? r.apply(null, arguments) : arguments);
      if (E === void 0)
        return e.apply(null, arguments);
      let y = c.get(E);
      y || (c.set(E, y = new ih(e)), y.normalizeResult = i, y.subscribe = o, y.forget = () => c.delete(E));
      const I = y.recompute(Array.prototype.slice.call(arguments));
      return c.set(E, y), my.add(c), nh.hasValue() || (my.forEach((Q) => Q.clean()), my.clear()), I;
    };
    Object.defineProperty(f, "size", {
      get: () => c.size,
      configurable: !1,
      enumerable: !1
    }), Object.freeze(f.options = {
      max: t,
      keyArgs: r,
      makeCacheKey: n,
      normalizeResult: i,
      subscribe: o,
      cache: c
    });
    function d(E) {
      const y = E && c.get(E);
      y && y.setDirty();
    }
    f.dirtyKey = d, f.dirty = function() {
      d(n.apply(null, arguments));
    };
    function g(E) {
      const y = E && c.get(E);
      if (y)
        return y.peek();
    }
    f.peekKey = g, f.peek = function() {
      return g(n.apply(null, arguments));
    };
    function h(E) {
      return E ? c.delete(E) : !1;
    }
    return f.forgetKey = h, f.forget = function() {
      return h(n.apply(null, arguments));
    }, f.makeCacheKey = n, f.getKey = r ? function() {
      return n.apply(null, r.apply(null, arguments));
    } : n, Object.freeze(f);
  }
  function U52(e) {
    return e;
  }
  var cz = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = oS ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = t, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
      }
      return e.prototype.getCacheKey = function(t) {
        return [t];
      }, e.identity = function() {
        return new e(U52, { cache: !1 });
      }, e.split = function(t, r, n) {
        return n === void 0 && (n = e.identity()), Object.assign(new e(
          function(i) {
            var o = t(i) ? r : n;
            return o.transformDocument(i);
          },
          // Reasonably assume both `left` and `right` transforms handle their own caching
          { cache: !1 }
        ), { left: r, right: n });
      }, e.prototype.resetCache = function() {
        var t = this;
        if (this.cached) {
          var r = new S8(qi);
          this.performWork = Ac(e.prototype.performWork.bind(this), {
            makeCacheKey: function(n) {
              var i = t.getCacheKey(n);
              if (i)
                return u0(Array.isArray(i), 77), r.lookupArray(i);
            },
            max: f3["documentTransform.cache"],
            cache: Pg
          });
        }
      }, e.prototype.performWork = function(t) {
        return ts(t), this.transform(t);
      }, e.prototype.transformDocument = function(t) {
        if (this.resultCache.has(t))
          return t;
        var r = this.performWork(t);
        return this.resultCache.add(r), r;
      }, e.prototype.concat = function(t) {
        var r = this;
        return Object.assign(new e(
          function(n) {
            return t.transformDocument(r.transformDocument(n));
          },
          // Reasonably assume both transforms handle their own caching
          { cache: !1 }
        ), {
          left: this,
          right: t
        });
      }, e;
    }()
  ), Kl, Si = Object.assign(function(e) {
    var t = Kl.get(e);
    return t || (t = Zt2(e), Kl.set(e, t)), t;
  }, {
    reset: function() {
      Kl = new uS(
        f3.print || 2e3
        /* defaultCacheSizes.print */
      );
    }
  });
  Si.reset();
  globalThis.__DEV__ !== !1 && lS("print", function() {
    return Kl ? Kl.size : 0;
  });
  var Wt = Array.isArray;
  function M4(e) {
    return Array.isArray(e) && e.length > 0;
  }
  var EL = {
    kind: a0.FIELD,
    name: {
      kind: a0.NAME,
      value: "__typename"
    }
  };
  function Az(e, t) {
    return !e || e.selectionSet.selections.every(function(r) {
      return r.kind === a0.FRAGMENT_SPREAD && Az(t[r.name.value], t);
    });
  }
  function q52(e) {
    return Az(Fi(e) || XZ(e), es(rs(e))) ? null : e;
  }
  function W52(e) {
    var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
    return e.forEach(function(n) {
      n && (n.name ? t.set(n.name, n) : n.test && r.set(n.test, n));
    }), function(n) {
      var i = t.get(n.name.value);
      return !i && r.size && r.forEach(function(o, u) {
        u(n) && (i = o);
      }), i;
    };
  }
  function mL(e) {
    var t = /* @__PURE__ */ new Map();
    return function(n) {
      n === void 0 && (n = e);
      var i = t.get(n);
      return i || t.set(n, i = {
        // Variable and fragment spread names used directly within this
        // operation or fragment definition, as identified by key. These sets
        // will be populated during the first traversal of the document in
        // removeDirectivesFromDocument below.
        variables: /* @__PURE__ */ new Set(),
        fragmentSpreads: /* @__PURE__ */ new Set()
      }), i;
    };
  }
  function fz(e, t) {
    ts(t);
    for (var r = mL(""), n = mL(""), i = function(_) {
      for (var M = 0, S = void 0; M < _.length && (S = _[M]); ++M)
        if (!Wt(S)) {
          if (S.kind === a0.OPERATION_DEFINITION)
            return r(S.name && S.name.value);
          if (S.kind === a0.FRAGMENT_DEFINITION)
            return n(S.name.value);
        }
      return globalThis.__DEV__ !== !1 && u0.error(97), null;
    }, o = 0, u = t.definitions.length - 1; u >= 0; --u)
      t.definitions[u].kind === a0.OPERATION_DEFINITION && ++o;
    var c = W52(e), f = function(_) {
      return M4(_) && _.map(c).some(function(M) {
        return M && M.remove;
      });
    }, d = /* @__PURE__ */ new Map(), g = !1, h = {
      enter: function(_) {
        if (f(_.directives))
          return g = !0, null;
      }
    }, E = hn(t, {
      // These two AST node types share the same implementation, defined above.
      Field: h,
      InlineFragment: h,
      VariableDefinition: {
        enter: function() {
          return !1;
        }
      },
      Variable: {
        enter: function(_, M, S, O, w) {
          var D = i(w);
          D && D.variables.add(_.name.value);
        }
      },
      FragmentSpread: {
        enter: function(_, M, S, O, w) {
          if (f(_.directives))
            return g = !0, null;
          var D = i(w);
          D && D.fragmentSpreads.add(_.name.value);
        }
      },
      FragmentDefinition: {
        enter: function(_, M, S, O) {
          d.set(JSON.stringify(O), _);
        },
        leave: function(_, M, S, O) {
          var w = d.get(JSON.stringify(O));
          if (_ === w)
            return _;
          if (
            // This logic applies only if the document contains one or more
            // operations, since removing all fragments from a document containing
            // only fragments makes the document useless.
            o > 0 && _.selectionSet.selections.every(function(D) {
              return D.kind === a0.FIELD && D.name.value === "__typename";
            })
          )
            return n(_.name.value).removed = !0, g = !0, null;
        }
      },
      Directive: {
        leave: function(_) {
          if (c(_))
            return g = !0, null;
        }
      }
    });
    if (!g)
      return t;
    var y = function(_) {
      return _.transitiveVars || (_.transitiveVars = new Set(_.variables), _.removed || _.fragmentSpreads.forEach(function(M) {
        y(n(M)).transitiveVars.forEach(function(S) {
          _.transitiveVars.add(S);
        });
      })), _;
    }, I = /* @__PURE__ */ new Set();
    E.definitions.forEach(function(_) {
      _.kind === a0.OPERATION_DEFINITION ? y(r(_.name && _.name.value)).fragmentSpreads.forEach(function(M) {
        I.add(M);
      }) : _.kind === a0.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
      // definitions count as usages of their own fragment names. This heuristic
      // prevents accidentally removing all fragment definitions from the
      // document just because it contains no operations that use the fragments.
      o === 0 && !n(_.name.value).removed && I.add(_.name.value);
    }), I.forEach(function(_) {
      y(n(_)).fragmentSpreads.forEach(function(M) {
        I.add(M);
      });
    });
    var Q = function(_) {
      return !!// A fragment definition will be removed if there are no spreads that refer
      // to it, or the fragment was explicitly removed because it had no fields
      // other than __typename.
      (!I.has(_) || n(_).removed);
    }, B = {
      enter: function(_) {
        if (Q(_.name.value))
          return null;
      }
    };
    return q52(hn(E, {
      // If the fragment is going to be removed, then leaving any dangling
      // FragmentSpread nodes with the same name would be a mistake.
      FragmentSpread: B,
      // This is where the fragment definition is actually removed.
      FragmentDefinition: B,
      OperationDefinition: {
        leave: function(_) {
          if (_.variableDefinitions) {
            var M = y(
              // If an operation is anonymous, we use the empty string as its key.
              r(_.name && _.name.value)
            ).transitiveVars;
            if (M.size < _.variableDefinitions.length)
              return C2(C2({}, _), { variableDefinitions: _.variableDefinitions.filter(function(S) {
                return M.has(S.variable.name.value);
              }) });
          }
        }
      }
    }));
  }
  var dS = Object.assign(function(e) {
    return hn(e, {
      SelectionSet: {
        enter: function(t, r, n) {
          if (!(n && n.kind === a0.OPERATION_DEFINITION)) {
            var i = t.selections;
            if (i) {
              var o = i.some(function(c) {
                return V6(c) && (c.name.value === "__typename" || c.name.value.lastIndexOf("__", 0) === 0);
              });
              if (!o) {
                var u = n;
                if (!(V6(u) && u.directives && u.directives.some(function(c) {
                  return c.name.value === "export";
                })))
                  return C2(C2({}, t), { selections: l1(l1([], i, !0), [EL], !1) });
              }
            }
          }
        }
      }
    });
  }, {
    added: function(e) {
      return e === EL;
    }
  });
  function Y52(e) {
    var t = Jc(e), r = t.operation;
    if (r === "query")
      return e;
    var n = hn(e, {
      OperationDefinition: {
        enter: function(i) {
          return C2(C2({}, i), { operation: "query" });
        }
      }
    });
    return n;
  }
  function Cz(e) {
    ts(e);
    var t = fz([
      {
        test: function(r) {
          return r.name.value === "client";
        },
        remove: !0
      }
    ], e);
    return t;
  }
  function $52(e) {
    return ts(e), hn(e, {
      FragmentSpread: function(t) {
        var r;
        if (!(!((r = t.directives) === null || r === void 0) && r.some(function(n) {
          return n.name.value === "unmask";
        })))
          return C2(C2({}, t), { directives: l1(l1([], t.directives || [], !0), [
            {
              kind: a0.DIRECTIVE,
              name: { kind: a0.NAME, value: "nonreactive" }
            }
          ], !1) });
      }
    });
  }
  var G52 = Object.prototype.hasOwnProperty;
  function yL() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    return ah(e);
  }
  function ah(e) {
    var t = e[0] || {}, r = e.length;
    if (r > 1)
      for (var n = new z6(), i = 1; i < r; ++i)
        t = n.merge(t, e[i]);
    return t;
  }
  var K52 = function(e, t, r) {
    return this.merge(e[r], t[r]);
  }, z6 = (
    /** @class */
    function() {
      function e(t) {
        t === void 0 && (t = K52), this.reconciler = t, this.isObject = qt, this.pastCopies = /* @__PURE__ */ new Set();
      }
      return e.prototype.merge = function(t, r) {
        for (var n = this, i = [], o = 2; o < arguments.length; o++)
          i[o - 2] = arguments[o];
        return qt(r) && qt(t) ? (Object.keys(r).forEach(function(u) {
          if (G52.call(t, u)) {
            var c = t[u];
            if (r[u] !== c) {
              var f = n.reconciler.apply(n, l1([
                t,
                r,
                u
              ], i, !1));
              f !== c && (t = n.shallowCopyForMerge(t), t[u] = f);
            }
          } else
            t = n.shallowCopyForMerge(t), t[u] = r[u];
        }), t) : r;
      }, e.prototype.shallowCopyForMerge = function(t) {
        return qt(t) && (this.pastCopies.has(t) || (Array.isArray(t) ? t = t.slice(0) : t = C2({ __proto__: Object.getPrototypeOf(t) }, t), this.pastCopies.add(t))), t;
      }, e;
    }()
  );
  function X52(e, t) {
    var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r) return (r = r.call(e)).next.bind(r);
    if (Array.isArray(e) || (r = J52(e)) || t) {
      r && (e = r);
      var n = 0;
      return function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function J52(e, t) {
    if (e) {
      if (typeof e == "string") return IL(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return IL(e, t);
    }
  }
  function IL(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  function BL(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }
  function gS(e, t, r) {
    return t && BL(e.prototype, t), r && BL(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  var pS = function() {
    return typeof Symbol == "function";
  }, hS = function(e) {
    return pS() && !!Symbol[e];
  }, vS = function(e) {
    return hS(e) ? Symbol[e] : "@@" + e;
  };
  pS() && !hS("observable") && (Symbol.observable = Symbol("observable"));
  var e12 = vS("iterator"), ob = vS("observable"), dz = vS("species");
  function Fg(e, t) {
    var r = e[t];
    if (r != null) {
      if (typeof r != "function") throw new TypeError(r + " is not a function");
      return r;
    }
  }
  function wl(e) {
    var t = e.constructor;
    return t !== void 0 && (t = t[dz], t === null && (t = void 0)), t !== void 0 ? t : At;
  }
  function t12(e) {
    return e instanceof At;
  }
  function B9(e) {
    B9.log ? B9.log(e) : setTimeout(function() {
      throw e;
    });
  }
  function Ud(e) {
    Promise.resolve().then(function() {
      try {
        e();
      } catch (t) {
        B9(t);
      }
    });
  }
  function gz(e) {
    var t = e._cleanup;
    if (t !== void 0 && (e._cleanup = void 0, !!t))
      try {
        if (typeof t == "function")
          t();
        else {
          var r = Fg(t, "unsubscribe");
          r && r.call(t);
        }
      } catch (n) {
        B9(n);
      }
  }
  function sb(e) {
    e._observer = void 0, e._queue = void 0, e._state = "closed";
  }
  function r12(e) {
    var t = e._queue;
    if (t) {
      e._queue = void 0, e._state = "ready";
      for (var r = 0; r < t.length && (pz(e, t[r].type, t[r].value), e._state !== "closed"); ++r)
        ;
    }
  }
  function pz(e, t, r) {
    e._state = "running";
    var n = e._observer;
    try {
      var i = Fg(n, t);
      switch (t) {
        case "next":
          i && i.call(n, r);
          break;
        case "error":
          if (sb(e), i) i.call(n, r);
          else throw r;
          break;
        case "complete":
          sb(e), i && i.call(n);
          break;
      }
    } catch (o) {
      B9(o);
    }
    e._state === "closed" ? gz(e) : e._state === "running" && (e._state = "ready");
  }
  function yy(e, t, r) {
    if (e._state !== "closed") {
      if (e._state === "buffering") {
        e._queue.push({
          type: t,
          value: r
        });
        return;
      }
      if (e._state !== "ready") {
        e._state = "buffering", e._queue = [{
          type: t,
          value: r
        }], Ud(function() {
          return r12(e);
        });
        return;
      }
      pz(e, t, r);
    }
  }
  var n12 = /* @__PURE__ */ function() {
    function e(r, n) {
      this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
      var i = new i12(this);
      try {
        this._cleanup = n.call(void 0, i);
      } catch (o) {
        i.error(o);
      }
      this._state === "initializing" && (this._state = "ready");
    }
    var t = e.prototype;
    return t.unsubscribe = function() {
      this._state !== "closed" && (sb(this), gz(this));
    }, gS(e, [{
      key: "closed",
      get: function() {
        return this._state === "closed";
      }
    }]), e;
  }(), i12 = /* @__PURE__ */ function() {
    function e(r) {
      this._subscription = r;
    }
    var t = e.prototype;
    return t.next = function(n) {
      yy(this._subscription, "next", n);
    }, t.error = function(n) {
      yy(this._subscription, "error", n);
    }, t.complete = function() {
      yy(this._subscription, "complete");
    }, gS(e, [{
      key: "closed",
      get: function() {
        return this._subscription._state === "closed";
      }
    }]), e;
  }(), At = /* @__PURE__ */ function() {
    function e(r) {
      if (!(this instanceof e)) throw new TypeError("Observable cannot be called as a function");
      if (typeof r != "function") throw new TypeError("Observable initializer must be a function");
      this._subscriber = r;
    }
    var t = e.prototype;
    return t.subscribe = function(n) {
      return (typeof n != "object" || n === null) && (n = {
        next: n,
        error: arguments[1],
        complete: arguments[2]
      }), new n12(n, this._subscriber);
    }, t.forEach = function(n) {
      var i = this;
      return new Promise(function(o, u) {
        if (typeof n != "function") {
          u(new TypeError(n + " is not a function"));
          return;
        }
        function c() {
          f.unsubscribe(), o();
        }
        var f = i.subscribe({
          next: function(d) {
            try {
              n(d, c);
            } catch (g) {
              u(g), f.unsubscribe();
            }
          },
          error: u,
          complete: o
        });
      });
    }, t.map = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var o = wl(this);
      return new o(function(u) {
        return i.subscribe({
          next: function(c) {
            try {
              c = n(c);
            } catch (f) {
              return u.error(f);
            }
            u.next(c);
          },
          error: function(c) {
            u.error(c);
          },
          complete: function() {
            u.complete();
          }
        });
      });
    }, t.filter = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var o = wl(this);
      return new o(function(u) {
        return i.subscribe({
          next: function(c) {
            try {
              if (!n(c)) return;
            } catch (f) {
              return u.error(f);
            }
            u.next(c);
          },
          error: function(c) {
            u.error(c);
          },
          complete: function() {
            u.complete();
          }
        });
      });
    }, t.reduce = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var o = wl(this), u = arguments.length > 1, c = !1, f = arguments[1], d = f;
      return new o(function(g) {
        return i.subscribe({
          next: function(h) {
            var E = !c;
            if (c = !0, !E || u)
              try {
                d = n(d, h);
              } catch (y) {
                return g.error(y);
              }
            else
              d = h;
          },
          error: function(h) {
            g.error(h);
          },
          complete: function() {
            if (!c && !u) return g.error(new TypeError("Cannot reduce an empty sequence"));
            g.next(d), g.complete();
          }
        });
      });
    }, t.concat = function() {
      for (var n = this, i = arguments.length, o = new Array(i), u = 0; u < i; u++)
        o[u] = arguments[u];
      var c = wl(this);
      return new c(function(f) {
        var d, g = 0;
        function h(E) {
          d = E.subscribe({
            next: function(y) {
              f.next(y);
            },
            error: function(y) {
              f.error(y);
            },
            complete: function() {
              g === o.length ? (d = void 0, f.complete()) : h(c.from(o[g++]));
            }
          });
        }
        return h(n), function() {
          d && (d.unsubscribe(), d = void 0);
        };
      });
    }, t.flatMap = function(n) {
      var i = this;
      if (typeof n != "function") throw new TypeError(n + " is not a function");
      var o = wl(this);
      return new o(function(u) {
        var c = [], f = i.subscribe({
          next: function(g) {
            if (n)
              try {
                g = n(g);
              } catch (E) {
                return u.error(E);
              }
            var h = o.from(g).subscribe({
              next: function(E) {
                u.next(E);
              },
              error: function(E) {
                u.error(E);
              },
              complete: function() {
                var E = c.indexOf(h);
                E >= 0 && c.splice(E, 1), d();
              }
            });
            c.push(h);
          },
          error: function(g) {
            u.error(g);
          },
          complete: function() {
            d();
          }
        });
        function d() {
          f.closed && c.length === 0 && u.complete();
        }
        return function() {
          c.forEach(function(g) {
            return g.unsubscribe();
          }), f.unsubscribe();
        };
      });
    }, t[ob] = function() {
      return this;
    }, e.from = function(n) {
      var i = typeof this == "function" ? this : e;
      if (n == null) throw new TypeError(n + " is not an object");
      var o = Fg(n, ob);
      if (o) {
        var u = o.call(n);
        if (Object(u) !== u) throw new TypeError(u + " is not an object");
        return t12(u) && u.constructor === i ? u : new i(function(c) {
          return u.subscribe(c);
        });
      }
      if (hS("iterator") && (o = Fg(n, e12), o))
        return new i(function(c) {
          Ud(function() {
            if (!c.closed) {
              for (var f = X52(o.call(n)), d; !(d = f()).done; ) {
                var g = d.value;
                if (c.next(g), c.closed) return;
              }
              c.complete();
            }
          });
        });
      if (Array.isArray(n))
        return new i(function(c) {
          Ud(function() {
            if (!c.closed) {
              for (var f = 0; f < n.length; ++f)
                if (c.next(n[f]), c.closed) return;
              c.complete();
            }
          });
        });
      throw new TypeError(n + " is not observable");
    }, e.of = function() {
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      var u = typeof this == "function" ? this : e;
      return new u(function(c) {
        Ud(function() {
          if (!c.closed) {
            for (var f = 0; f < i.length; ++f)
              if (c.next(i[f]), c.closed) return;
            c.complete();
          }
        });
      });
    }, gS(e, null, [{
      key: dz,
      get: function() {
        return this;
      }
    }]), e;
  }();
  pS() && Object.defineProperty(At, Symbol("extensions"), {
    value: {
      symbol: ob,
      hostReportError: B9
    },
    configurable: !0
  });
  function a12(e) {
    var t, r = e.Symbol;
    if (typeof r == "function")
      if (r.observable)
        t = r.observable;
      else {
        typeof r.for == "function" ? t = r.for("https://github.com/benlesh/symbol-observable") : t = r("https://github.com/benlesh/symbol-observable");
        try {
          r.observable = t;
        } catch {
        }
      }
    else
      t = "@@observable";
    return t;
  }
  var t9;
  typeof self < "u" ? t9 = self : typeof window < "u" ? t9 = window : typeof global < "u" ? t9 = global : typeof eS < "u" ? t9 = eS : t9 = Function("return this")();
  a12(t9);
  var QL = At.prototype, xL = "@@observable";
  QL[xL] || (QL[xL] = function() {
    return this;
  });
  function o12(e) {
    return e.catch(function() {
    }), e;
  }
  var s12 = Object.prototype.toString;
  function hz(e) {
    return ub(e);
  }
  function ub(e, t) {
    switch (s12.call(e)) {
      case "[object Array]": {
        if (t = t || /* @__PURE__ */ new Map(), t.has(e))
          return t.get(e);
        var r = e.slice(0);
        return t.set(e, r), r.forEach(function(i, o) {
          r[o] = ub(i, t);
        }), r;
      }
      case "[object Object]": {
        if (t = t || /* @__PURE__ */ new Map(), t.has(e))
          return t.get(e);
        var n = Object.create(Object.getPrototypeOf(e));
        return t.set(e, n), Object.keys(e).forEach(function(i) {
          n[i] = ub(e[i], t);
        }), n;
      }
      default:
        return e;
    }
  }
  function u12(e) {
    var t = /* @__PURE__ */ new Set([e]);
    return t.forEach(function(r) {
      qt(r) && l12(r) === r && Object.getOwnPropertyNames(r).forEach(function(n) {
        qt(r[n]) && t.add(r[n]);
      });
    }), e;
  }
  function l12(e) {
    if (globalThis.__DEV__ !== !1 && !Object.isFrozen(e))
      try {
        Object.freeze(e);
      } catch (t) {
        if (t instanceof TypeError)
          return null;
        throw t;
      }
    return e;
  }
  function Q9(e) {
    return globalThis.__DEV__ !== !1 && u12(e), e;
  }
  function Xl(e, t, r) {
    var n = [];
    e.forEach(function(i) {
      return i[t] && n.push(i);
    }), n.forEach(function(i) {
      return i[t](r);
    });
  }
  function Iy(e, t, r) {
    return new At(function(n) {
      var i = {
        // Normally we would initialize promiseQueue to Promise.resolve(), but
        // in this case, for backwards compatibility, we need to be careful to
        // invoke the first callback synchronously.
        then: function(f) {
          return new Promise(function(d) {
            return d(f());
          });
        }
      };
      function o(f, d) {
        return function(g) {
          if (f) {
            var h = function() {
              return n.closed ? (
                /* will be swallowed */
                0
              ) : f(g);
            };
            i = i.then(h, h).then(function(E) {
              return n.next(E);
            }, function(E) {
              return n.error(E);
            });
          } else
            n[d](g);
        };
      }
      var u = {
        next: o(t, "next"),
        error: o(r, "error"),
        complete: function() {
          i.then(function() {
            return n.complete();
          });
        }
      }, c = e.subscribe(u);
      return function() {
        return c.unsubscribe();
      };
    });
  }
  function vz(e) {
    function t(r) {
      Object.defineProperty(e, r, { value: At });
    }
    return sS && Symbol.species && t(Symbol.species), t("@@species"), e;
  }
  function bL(e) {
    return e && typeof e.then == "function";
  }
  var r9 = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        var n = e.call(this, function(i) {
          return n.addObserver(i), function() {
            return n.removeObserver(i);
          };
        }) || this;
        return n.observers = /* @__PURE__ */ new Set(), n.promise = new Promise(function(i, o) {
          n.resolve = i, n.reject = o;
        }), n.handlers = {
          next: function(i) {
            n.sub !== null && (n.latest = ["next", i], n.notify("next", i), Xl(n.observers, "next", i));
          },
          error: function(i) {
            var o = n.sub;
            o !== null && (o && setTimeout(function() {
              return o.unsubscribe();
            }), n.sub = null, n.latest = ["error", i], n.reject(i), n.notify("error", i), Xl(n.observers, "error", i));
          },
          complete: function() {
            var i = n, o = i.sub, u = i.sources, c = u === void 0 ? [] : u;
            if (o !== null) {
              var f = c.shift();
              f ? bL(f) ? f.then(function(d) {
                return n.sub = d.subscribe(n.handlers);
              }, n.handlers.error) : n.sub = f.subscribe(n.handlers) : (o && setTimeout(function() {
                return o.unsubscribe();
              }), n.sub = null, n.latest && n.latest[0] === "next" ? n.resolve(n.latest[1]) : n.resolve(), n.notify("complete"), Xl(n.observers, "complete"));
            }
          }
        }, n.nextResultListeners = /* @__PURE__ */ new Set(), n.cancel = function(i) {
          n.reject(i), n.sources = [], n.handlers.error(i);
        }, n.promise.catch(function(i) {
        }), typeof r == "function" && (r = [new At(r)]), bL(r) ? r.then(function(i) {
          return n.start(i);
        }, n.handlers.error) : n.start(r), n;
      }
      return t.prototype.start = function(r) {
        this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
      }, t.prototype.deliverLastMessage = function(r) {
        if (this.latest) {
          var n = this.latest[0], i = r[n];
          i && i.call(r, this.latest[1]), this.sub === null && n === "next" && r.complete && r.complete();
        }
      }, t.prototype.addObserver = function(r) {
        this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
      }, t.prototype.removeObserver = function(r) {
        this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
      }, t.prototype.notify = function(r, n) {
        var i = this.nextResultListeners;
        i.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), i.forEach(function(o) {
          return o(r, n);
        }));
      }, t.prototype.beforeNext = function(r) {
        var n = !1;
        this.nextResultListeners.add(function(i, o) {
          n || (n = !0, r(i, o));
        });
      }, t;
    }(At)
  );
  vz(r9);
  function f9(e) {
    return "incremental" in e;
  }
  function c12(e) {
    return "hasNext" in e && "data" in e;
  }
  function A12(e) {
    return f9(e) || c12(e);
  }
  function f12(e) {
    return qt(e) && "payload" in e;
  }
  function Ez(e, t) {
    var r = e, n = new z6();
    return f9(t) && M4(t.incremental) && t.incremental.forEach(function(i) {
      for (var o = i.data, u = i.path, c = u.length - 1; c >= 0; --c) {
        var f = u[c], d = !isNaN(+f), g = d ? [] : {};
        g[f] = o, o = g;
      }
      r = n.merge(r, o);
    }), r;
  }
  function qd(e) {
    var t = lb(e);
    return M4(t);
  }
  function lb(e) {
    var t = M4(e.errors) ? e.errors.slice(0) : [];
    return f9(e) && M4(e.incremental) && e.incremental.forEach(function(r) {
      r.errors && t.push.apply(t, r.errors);
    }), t;
  }
  function Ni() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    var r = /* @__PURE__ */ Object.create(null);
    return e.forEach(function(n) {
      n && Object.keys(n).forEach(function(i) {
        var o = n[i];
        o !== void 0 && (r[i] = o);
      });
    }), r;
  }
  function C9(e, t) {
    return Ni(e, t, t.variables && {
      variables: Ni(C2(C2({}, e && e.variables), t.variables))
    });
  }
  function By(e) {
    return new At(function(t) {
      t.error(e);
    });
  }
  var mz = function(e, t, r) {
    var n = new Error(r);
    throw n.name = "ServerError", n.response = e, n.statusCode = e.status, n.result = t, n;
  };
  function C12(e) {
    for (var t = [
      "query",
      "operationName",
      "variables",
      "extensions",
      "context"
    ], r = 0, n = Object.keys(e); r < n.length; r++) {
      var i = n[r];
      if (t.indexOf(i) < 0)
        throw G1(46, i);
    }
    return e;
  }
  function d12(e, t) {
    var r = C2({}, e), n = function(o) {
      typeof o == "function" ? r = C2(C2({}, r), o(r)) : r = C2(C2({}, r), o);
    }, i = function() {
      return C2({}, r);
    };
    return Object.defineProperty(t, "setContext", {
      enumerable: !1,
      value: n
    }), Object.defineProperty(t, "getContext", {
      enumerable: !1,
      value: i
    }), t;
  }
  function g12(e) {
    var t = {
      variables: e.variables || {},
      extensions: e.extensions || {},
      operationName: e.operationName,
      query: e.query
    };
    return t.operationName || (t.operationName = typeof t.query != "string" ? Ul(t.query) || void 0 : ""), t;
  }
  function p12(e, t) {
    var r = C2({}, e), n = new Set(Object.keys(e));
    return hn(t, {
      Variable: function(i, o, u) {
        u && u.kind !== "VariableDefinition" && n.delete(i.name.value);
      }
    }), n.forEach(function(i) {
      delete r[i];
    }), r;
  }
  function wL(e, t) {
    return t ? t(e) : At.of();
  }
  function Sl(e) {
    return typeof e == "function" ? new ns(e) : e;
  }
  function vd(e) {
    return e.request.length <= 1;
  }
  var ns = (
    /** @class */
    function() {
      function e(t) {
        t && (this.request = t);
      }
      return e.empty = function() {
        return new e(function() {
          return At.of();
        });
      }, e.from = function(t) {
        return t.length === 0 ? e.empty() : t.map(Sl).reduce(function(r, n) {
          return r.concat(n);
        });
      }, e.split = function(t, r, n) {
        var i = Sl(r), o = Sl(n || new e(wL)), u;
        return vd(i) && vd(o) ? u = new e(function(c) {
          return t(c) ? i.request(c) || At.of() : o.request(c) || At.of();
        }) : u = new e(function(c, f) {
          return t(c) ? i.request(c, f) || At.of() : o.request(c, f) || At.of();
        }), Object.assign(u, { left: i, right: o });
      }, e.execute = function(t, r) {
        return t.request(d12(r.context, g12(C12(r)))) || At.of();
      }, e.concat = function(t, r) {
        var n = Sl(t);
        if (vd(n))
          return globalThis.__DEV__ !== !1 && u0.warn(38, n), n;
        var i = Sl(r), o;
        return vd(i) ? o = new e(function(u) {
          return n.request(u, function(c) {
            return i.request(c) || At.of();
          }) || At.of();
        }) : o = new e(function(u, c) {
          return n.request(u, function(f) {
            return i.request(f, c) || At.of();
          }) || At.of();
        }), Object.assign(o, { left: n, right: i });
      }, e.prototype.split = function(t, r, n) {
        return this.concat(e.split(t, r, n || new e(wL)));
      }, e.prototype.concat = function(t) {
        return e.concat(this, t);
      }, e.prototype.request = function(t, r) {
        throw G1(39);
      }, e.prototype.onError = function(t, r) {
        if (r && r.error)
          return r.error(t), !1;
        throw t;
      }, e.prototype.setOnError = function(t) {
        return this.onError = t, this;
      }, e;
    }()
  ), cb = ns.execute;
  function h12(e) {
    var t, r = e[Symbol.asyncIterator]();
    return t = {
      next: function() {
        return r.next();
      }
    }, t[Symbol.asyncIterator] = function() {
      return this;
    }, t;
  }
  function v12(e) {
    var t = null, r = null, n = !1, i = [], o = [];
    function u(h) {
      if (!r) {
        if (o.length) {
          var E = o.shift();
          if (Array.isArray(E) && E[0])
            return E[0]({ value: h, done: !1 });
        }
        i.push(h);
      }
    }
    function c(h) {
      r = h;
      var E = o.slice();
      E.forEach(function(y) {
        y[1](h);
      }), !t || t();
    }
    function f() {
      n = !0;
      var h = o.slice();
      h.forEach(function(E) {
        E[0]({ value: void 0, done: !0 });
      }), !t || t();
    }
    t = function() {
      t = null, e.removeListener("data", u), e.removeListener("error", c), e.removeListener("end", f), e.removeListener("finish", f), e.removeListener("close", f);
    }, e.on("data", u), e.on("error", c), e.on("end", f), e.on("finish", f), e.on("close", f);
    function d() {
      return new Promise(function(h, E) {
        if (r)
          return E(r);
        if (i.length)
          return h({ value: i.shift(), done: !1 });
        if (n)
          return h({ value: void 0, done: !0 });
        o.push([h, E]);
      });
    }
    var g = {
      next: function() {
        return d();
      }
    };
    return eh && (g[Symbol.asyncIterator] = function() {
      return this;
    }), g;
  }
  function E12(e) {
    var t = !1, r = {
      next: function() {
        return t ? Promise.resolve({
          value: void 0,
          done: !0
        }) : (t = !0, new Promise(function(n, i) {
          e.then(function(o) {
            n({ value: o, done: !1 });
          }).catch(i);
        }));
      }
    };
    return eh && (r[Symbol.asyncIterator] = function() {
      return this;
    }), r;
  }
  function SL(e) {
    var t = {
      next: function() {
        return e.read();
      }
    };
    return eh && (t[Symbol.asyncIterator] = function() {
      return this;
    }), t;
  }
  function m12(e) {
    return !!e.body;
  }
  function y12(e) {
    return !!e.getReader;
  }
  function I12(e) {
    return !!(eh && e[Symbol.asyncIterator]);
  }
  function B12(e) {
    return !!e.stream;
  }
  function Q12(e) {
    return !!e.arrayBuffer;
  }
  function x12(e) {
    return !!e.pipe;
  }
  function b12(e) {
    var t = e;
    if (m12(e) && (t = e.body), I12(t))
      return h12(t);
    if (y12(t))
      return SL(t.getReader());
    if (B12(t))
      return SL(t.stream().getReader());
    if (Q12(t))
      return E12(t.arrayBuffer());
    if (x12(t))
      return v12(t);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
  }
  var ES = Symbol();
  function w12(e) {
    return e.extensions ? Array.isArray(e.extensions[ES]) : !1;
  }
  function yz(e) {
    return e.hasOwnProperty("graphQLErrors");
  }
  var S12 = function(e) {
    var t = l1(l1(l1([], e.graphQLErrors, !0), e.clientErrors, !0), e.protocolErrors, !0);
    return e.networkError && t.push(e.networkError), t.map(function(r) {
      return qt(r) && r.message || "Error message not found.";
    }).join(`
`);
  }, f8 = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        var n = r.graphQLErrors, i = r.protocolErrors, o = r.clientErrors, u = r.networkError, c = r.errorMessage, f = r.extraInfo, d = e.call(this, c) || this;
        return d.name = "ApolloError", d.graphQLErrors = n || [], d.protocolErrors = i || [], d.clientErrors = o || [], d.networkError = u || null, d.message = c || S12(d), d.extraInfo = f, d.cause = l1(l1(l1([
          u
        ], n || [], !0), i || [], !0), o || [], !0).find(function(g) {
          return !!g;
        }) || null, d.__proto__ = t.prototype, d;
      }
      return t;
    }(Error)
  ), ML = Object.prototype.hasOwnProperty;
  function M12(e, t) {
    return D6(this, void 0, void 0, function() {
      var r, n, i, o, u, c, f, d, g, h, E, y, I, Q, B, _, M, S, O, w, D, k, F, z;
      return L6(this, function(Z) {
        switch (Z.label) {
          case 0:
            if (TextDecoder === void 0)
              throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
            r = new TextDecoder("utf-8"), n = (z = e.headers) === null || z === void 0 ? void 0 : z.get("content-type"), i = "boundary=", o = n != null && n.includes(i) ? n == null ? void 0 : n.substring((n == null ? void 0 : n.indexOf(i)) + i.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", u = `\r
--`.concat(o), c = "", f = b12(e), d = !0, Z.label = 1;
          case 1:
            return d ? [4, f.next()] : [3, 3];
          case 2:
            for (g = Z.sent(), h = g.value, E = g.done, y = typeof h == "string" ? h : r.decode(h), I = c.length - u.length + 1, d = !E, c += y, Q = c.indexOf(u, I); Q > -1; ) {
              if (B = void 0, k = [
                c.slice(0, Q),
                c.slice(Q + u.length)
              ], B = k[0], c = k[1], _ = B.indexOf(`\r
\r
`), M = _12(B.slice(0, _)), S = M["content-type"], S && S.toLowerCase().indexOf("application/json") === -1)
                throw new Error("Unsupported patch content type: application/json is required.");
              if (O = B.slice(_), O) {
                if (w = Iz(e, O), Object.keys(w).length > 1 || "data" in w || "incremental" in w || "errors" in w || "payload" in w)
                  if (f12(w)) {
                    if (D = {}, "payload" in w) {
                      if (Object.keys(w).length === 1 && w.payload === null)
                        return [
                          2
                          /*return*/
                        ];
                      D = C2({}, w.payload);
                    }
                    "errors" in w && (D = C2(C2({}, D), { extensions: C2(C2({}, "extensions" in D ? D.extensions : null), (F = {}, F[ES] = w.errors, F)) })), t(D);
                  } else
                    t(w);
                else if (
                  // If the chunk contains only a "hasNext: false", we can call
                  // observer.complete() immediately.
                  Object.keys(w).length === 1 && "hasNext" in w && !w.hasNext
                )
                  return [
                    2
                    /*return*/
                  ];
              }
              Q = c.indexOf(u);
            }
            return [3, 1];
          case 3:
            return [
              2
              /*return*/
            ];
        }
      });
    });
  }
  function _12(e) {
    var t = {};
    return e.split(`
`).forEach(function(r) {
      var n = r.indexOf(":");
      if (n > -1) {
        var i = r.slice(0, n).trim().toLowerCase(), o = r.slice(n + 1).trim();
        t[i] = o;
      }
    }), t;
  }
  function Iz(e, t) {
    if (e.status >= 300) {
      var r = function() {
        try {
          return JSON.parse(t);
        } catch {
          return t;
        }
      };
      mz(e, r(), "Response not successful: Received status code ".concat(e.status));
    }
    try {
      return JSON.parse(t);
    } catch (i) {
      var n = i;
      throw n.name = "ServerParseError", n.response = e, n.statusCode = e.status, n.bodyText = t, n;
    }
  }
  function O12(e, t) {
    e.result && e.result.errors && e.result.data && t.next(e.result), t.error(e);
  }
  function T12(e) {
    return function(t) {
      return t.text().then(function(r) {
        return Iz(t, r);
      }).then(function(r) {
        return !Array.isArray(r) && !ML.call(r, "data") && !ML.call(r, "errors") && mz(t, r, "Server response was missing for query '".concat(Array.isArray(e) ? e.map(function(n) {
          return n.operationName;
        }) : e.operationName, "'.")), r;
      });
    };
  }
  var Ab = function(e, t) {
    var r;
    try {
      r = JSON.stringify(e);
    } catch (i) {
      var n = G1(42, t, i.message);
      throw n.parseError = i, n;
    }
    return r;
  }, D12 = {
    includeQuery: !0,
    includeExtensions: !1,
    preserveHeaderCase: !1
  }, L12 = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
  }, k12 = {
    method: "POST"
  }, R12 = {
    http: D12,
    headers: L12,
    options: k12
  }, P12 = function(e, t) {
    return t(e);
  };
  function F12(e, t) {
    for (var r = [], n = 2; n < arguments.length; n++)
      r[n - 2] = arguments[n];
    var i = {}, o = {};
    r.forEach(function(h) {
      i = C2(C2(C2({}, i), h.options), { headers: C2(C2({}, i.headers), h.headers) }), h.credentials && (i.credentials = h.credentials), o = C2(C2({}, o), h.http);
    }), i.headers && (i.headers = N12(i.headers, o.preserveHeaderCase));
    var u = e.operationName, c = e.extensions, f = e.variables, d = e.query, g = { operationName: u, variables: f };
    return o.includeExtensions && (g.extensions = c), o.includeQuery && (g.query = t(d, Si)), {
      options: i,
      body: g
    };
  }
  function N12(e, t) {
    if (!t) {
      var r = {};
      return Object.keys(Object(e)).forEach(function(o) {
        r[o.toLowerCase()] = e[o];
      }), r;
    }
    var n = {};
    Object.keys(Object(e)).forEach(function(o) {
      n[o.toLowerCase()] = {
        originalName: o,
        value: e[o]
      };
    });
    var i = {};
    return Object.keys(n).forEach(function(o) {
      i[n[o].originalName] = n[o].value;
    }), i;
  }
  var H12 = function(e) {
    if (!e && typeof fetch > "u")
      throw G1(40);
  }, j12 = function(e, t) {
    var r = e.getContext(), n = r.uri;
    return n || (typeof t == "function" ? t(e) : t || "/graphql");
  };
  function V12(e, t) {
    var r = [], n = function(h, E) {
      r.push("".concat(h, "=").concat(encodeURIComponent(E)));
    };
    if ("query" in t && n("query", t.query), t.operationName && n("operationName", t.operationName), t.variables) {
      var i = void 0;
      try {
        i = Ab(t.variables, "Variables map");
      } catch (h) {
        return { parseError: h };
      }
      n("variables", i);
    }
    if (t.extensions) {
      var o = void 0;
      try {
        o = Ab(t.extensions, "Extensions map");
      } catch (h) {
        return { parseError: h };
      }
      n("extensions", o);
    }
    var u = "", c = e, f = e.indexOf("#");
    f !== -1 && (u = e.substr(f), c = e.substr(0, f));
    var d = c.indexOf("?") === -1 ? "?" : "&", g = c + d + r.join("&") + u;
    return { newURI: g };
  }
  var _L = Cn(function() {
    return fetch;
  }), Z12 = function(e) {
    e === void 0 && (e = {});
    var t = e.uri, r = t === void 0 ? "/graphql" : t, n = e.fetch, i = e.print, o = i === void 0 ? P12 : i, u = e.includeExtensions, c = e.preserveHeaderCase, f = e.useGETForQueries, d = e.includeUnusedVariables, g = d === void 0 ? !1 : d, h = yr(e, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
    globalThis.__DEV__ !== !1 && H12(n || _L);
    var E = {
      http: { includeExtensions: u, preserveHeaderCase: c },
      options: h.fetchOptions,
      credentials: h.credentials,
      headers: h.headers
    };
    return new ns(function(y) {
      var I = j12(y, r), Q = y.getContext(), B = {};
      if (Q.clientAwareness) {
        var _ = Q.clientAwareness, M = _.name, S = _.version;
        M && (B["apollographql-client-name"] = M), S && (B["apollographql-client-version"] = S);
      }
      var O = C2(C2({}, B), Q.headers), w = {
        http: Q.http,
        options: Q.fetchOptions,
        credentials: Q.credentials,
        headers: O
      };
      if (lc(["client"], y.query)) {
        var D = Cz(y.query);
        if (!D)
          return By(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
        y.query = D;
      }
      var k = F12(y, o, R12, E, w), F = k.options, z = k.body;
      z.variables && !g && (z.variables = p12(z.variables, y.query));
      var Z;
      !F.signal && typeof AbortController < "u" && (Z = new AbortController(), F.signal = Z.signal);
      var V = function(a2) {
        return a2.kind === "OperationDefinition" && a2.operation === "mutation";
      }, $ = function(a2) {
        return a2.kind === "OperationDefinition" && a2.operation === "subscription";
      }, W = $(Jc(y.query)), t2 = lc(["defer"], y.query);
      if (f && !y.query.definitions.some(V) && (F.method = "GET"), t2 || W) {
        F.headers = F.headers || {};
        var n2 = "multipart/mixed;";
        W && t2 && globalThis.__DEV__ !== !1 && u0.warn(41), W ? n2 += "boundary=graphql;subscriptionSpec=1.0,application/json" : t2 && (n2 += "deferSpec=20220824,application/json"), F.headers.accept = n2;
      }
      if (F.method === "GET") {
        var s2 = V12(I, z), l2 = s2.newURI, X = s2.parseError;
        if (X)
          return By(X);
        I = l2;
      } else
        try {
          F.body = Ab(z, "Payload");
        } catch (a2) {
          return By(a2);
        }
      return new At(function(a2) {
        var e2 = n || Cn(function() {
          return fetch;
        }) || _L, H = a2.next.bind(a2);
        return e2(I, F).then(function(Y) {
          var r2;
          y.setContext({ response: Y });
          var o2 = (r2 = Y.headers) === null || r2 === void 0 ? void 0 : r2.get("content-type");
          return o2 !== null && /^multipart\/mixed/i.test(o2) ? M12(Y, H) : T12(y)(Y).then(H);
        }).then(function() {
          Z = void 0, a2.complete();
        }).catch(function(Y) {
          Z = void 0, O12(Y, a2);
        }), function() {
          Z && Z.abort();
        };
      });
    });
  }, Bz = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        r === void 0 && (r = {});
        var n = e.call(this, Z12(r).request) || this;
        return n.options = r, n;
      }
      return t;
    }(ns)
  );
  const { toString: OL, hasOwnProperty: z12 } = Object.prototype, TL = Function.prototype.toString, fb = /* @__PURE__ */ new Map();
  function et(e, t) {
    try {
      return Cb(e, t);
    } finally {
      fb.clear();
    }
  }
  function Cb(e, t) {
    if (e === t)
      return !0;
    const r = OL.call(e), n = OL.call(t);
    if (r !== n)
      return !1;
    switch (r) {
      case "[object Array]":
        if (e.length !== t.length)
          return !1;
      // Fall through to object case...
      case "[object Object]": {
        if (LL(e, t))
          return !0;
        const i = DL(e), o = DL(t), u = i.length;
        if (u !== o.length)
          return !1;
        for (let c = 0; c < u; ++c)
          if (!z12.call(t, i[c]))
            return !1;
        for (let c = 0; c < u; ++c) {
          const f = i[c];
          if (!Cb(e[f], t[f]))
            return !1;
        }
        return !0;
      }
      case "[object Error]":
        return e.name === t.name && e.message === t.message;
      case "[object Number]":
        if (e !== e)
          return t !== t;
      // Fall through to shared +a === +b case...
      case "[object Boolean]":
      case "[object Date]":
        return +e == +t;
      case "[object RegExp]":
      case "[object String]":
        return e == `${t}`;
      case "[object Map]":
      case "[object Set]": {
        if (e.size !== t.size)
          return !1;
        if (LL(e, t))
          return !0;
        const i = e.entries(), o = r === "[object Map]";
        for (; ; ) {
          const u = i.next();
          if (u.done)
            break;
          const [c, f] = u.value;
          if (!t.has(c) || o && !Cb(f, t.get(c)))
            return !1;
        }
        return !0;
      }
      case "[object Uint16Array]":
      case "[object Uint8Array]":
      // Buffer, in Node.js.
      case "[object Uint32Array]":
      case "[object Int32Array]":
      case "[object Int8Array]":
      case "[object Int16Array]":
      case "[object ArrayBuffer]":
        e = new Uint8Array(e), t = new Uint8Array(t);
      // Fall through...
      case "[object DataView]": {
        let i = e.byteLength;
        if (i === t.byteLength)
          for (; i-- && e[i] === t[i]; )
            ;
        return i === -1;
      }
      case "[object AsyncFunction]":
      case "[object GeneratorFunction]":
      case "[object AsyncGeneratorFunction]":
      case "[object Function]": {
        const i = TL.call(e);
        return i !== TL.call(t) ? !1 : !W12(i, q12);
      }
    }
    return !1;
  }
  function DL(e) {
    return Object.keys(e).filter(U12, e);
  }
  function U12(e) {
    return this[e] !== void 0;
  }
  const q12 = "{ [native code] }";
  function W12(e, t) {
    const r = e.length - t.length;
    return r >= 0 && e.indexOf(t, r) === r;
  }
  function LL(e, t) {
    let r = fb.get(e);
    if (r) {
      if (r.has(t))
        return !0;
    } else
      fb.set(e, r = /* @__PURE__ */ new Set());
    return r.add(t), !1;
  }
  function Qz(e, t, r, n) {
    var i = t.data, o = yr(t, ["data"]), u = r.data, c = yr(r, ["data"]);
    return et(o, c) && Wd(Jc(e).selectionSet, i, u, {
      fragmentMap: es(rs(e)),
      variables: n
    });
  }
  function Wd(e, t, r, n) {
    if (t === r)
      return !0;
    var i = /* @__PURE__ */ new Set();
    return e.selections.every(function(o) {
      if (i.has(o) || (i.add(o), !Xc(o, n.variables)) || kL(o))
        return !0;
      if (V6(o)) {
        var u = m8(o), c = t && t[u], f = r && r[u], d = o.selectionSet;
        if (!d)
          return et(c, f);
        var g = Array.isArray(c), h = Array.isArray(f);
        if (g !== h)
          return !1;
        if (g && h) {
          var E = c.length;
          if (f.length !== E)
            return !1;
          for (var y = 0; y < E; ++y)
            if (!Wd(d, c[y], f[y], n))
              return !1;
          return !0;
        }
        return Wd(d, c, f, n);
      } else {
        var I = th(o, n.fragmentMap);
        if (I)
          return kL(I) ? !0 : Wd(
            I.selectionSet,
            // Notice that we reuse the same aResult and bResult values here,
            // since the fragment ...spread does not specify a field name, but
            // consists of multiple fields (within the fragment's selection set)
            // that should be applied to the current result value(s).
            t,
            r,
            n
          );
      }
    });
  }
  function kL(e) {
    return !!e.directives && e.directives.some(Y12);
  }
  function Y12(e) {
    return e.name.value === "nonreactive";
  }
  var xz = qi ? WeakMap : Map, bz = oS ? WeakSet : Set, mS = new eA(), RL = !1;
  function wz() {
    RL || (RL = !0, globalThis.__DEV__ !== !1 && u0.warn(52));
  }
  function Sz(e, t, r) {
    return mS.withValue(!0, function() {
      var n = ql(e, t, r, !1);
      return Object.isFrozen(e) && Q9(n), n;
    });
  }
  function $12(e, t) {
    if (t.has(e))
      return t.get(e);
    var r = Array.isArray(e) ? [] : /* @__PURE__ */ Object.create(null);
    return t.set(e, r), r;
  }
  function ql(e, t, r, n, i) {
    var o, u = r.knownChanged, c = $12(e, r.mutableTargets);
    if (Array.isArray(e)) {
      for (var f = 0, d = Array.from(e.entries()); f < d.length; f++) {
        var g = d[f], h = g[0], E = g[1];
        if (E === null) {
          c[h] = null;
          continue;
        }
        var y = ql(E, t, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", "[").concat(h, "]") : void 0);
        u.has(y) && u.add(c), c[h] = y;
      }
      return u.has(c) ? c : e;
    }
    for (var I = 0, Q = t.selections; I < Q.length; I++) {
      var B = Q[I], _ = void 0;
      if (n && u.add(c), B.kind === a0.FIELD) {
        var M = m8(B), S = B.selectionSet;
        if (_ = c[M] || e[M], _ === void 0)
          continue;
        if (S && _ !== null) {
          var y = ql(e[M], S, r, n, globalThis.__DEV__ !== !1 ? "".concat(i || "", ".").concat(M) : void 0);
          u.has(y) && (_ = y);
        }
        globalThis.__DEV__ === !1 && (c[M] = _), globalThis.__DEV__ !== !1 && (n && M !== "__typename" && // either the field is not present in the memo object
        // or it has a `get` descriptor, not a `value` descriptor
        // => it is a warning accessor and we can overwrite it
        // with another accessor
        !(!((o = Object.getOwnPropertyDescriptor(c, M)) === null || o === void 0) && o.value) ? Object.defineProperty(c, M, G12(M, _, i || "", r.operationName, r.operationType)) : (delete c[M], c[M] = _));
      }
      if (B.kind === a0.INLINE_FRAGMENT && (!B.typeCondition || r.cache.fragmentMatches(B, e.__typename)) && (_ = ql(e, B.selectionSet, r, n, i)), B.kind === a0.FRAGMENT_SPREAD) {
        var O = B.name.value, w = r.fragmentMap[O] || (r.fragmentMap[O] = r.cache.lookupFragment(O));
        u0(w, 47, O);
        var D = $t2(B);
        D !== "mask" && (_ = ql(e, w.selectionSet, r, D === "migrate", i));
      }
      u.has(_) && u.add(c);
    }
    return "__typename" in e && !("__typename" in c) && (c.__typename = e.__typename), Object.keys(c).length !== Object.keys(e).length && u.add(c), u.has(c) ? c : e;
  }
  function G12(e, t, r, n, i) {
    var o = function() {
      return mS.getValue() || (globalThis.__DEV__ !== !1 && u0.warn(48, n ? "".concat(i, " '").concat(n, "'") : "anonymous ".concat(i), "".concat(r, ".").concat(e).replace(/^\./, "")), o = function() {
        return t;
      }), t;
    };
    return {
      get: function() {
        return o();
      },
      set: function(u) {
        o = function() {
          return u;
        };
      },
      enumerable: !0,
      configurable: !0
    };
  }
  function Mz(e, t, r, n) {
    if (!r.fragmentMatches)
      return globalThis.__DEV__ !== !1 && wz(), e;
    var i = t.definitions.filter(function(u) {
      return u.kind === a0.FRAGMENT_DEFINITION;
    });
    typeof n > "u" && (u0(i.length === 1, 49, i.length), n = i[0].name.value);
    var o = i.find(function(u) {
      return u.name.value === n;
    });
    return u0(!!o, 50, n), e == null || et(e, {}) ? e : Sz(e, o.selectionSet, {
      operationType: "fragment",
      operationName: o.name.value,
      fragmentMap: es(rs(t)),
      cache: r,
      mutableTargets: new xz(),
      knownChanged: new bz()
    });
  }
  function K12(e, t, r) {
    var n;
    if (!r.fragmentMatches)
      return globalThis.__DEV__ !== !1 && wz(), e;
    var i = Fi(t);
    return u0(i, 51), e == null ? e : Sz(e, i.selectionSet, {
      operationType: i.operation,
      operationName: (n = i.name) === null || n === void 0 ? void 0 : n.value,
      fragmentMap: es(rs(t)),
      cache: r,
      mutableTargets: new xz(),
      knownChanged: new bz()
    });
  }
  var _z = (
    /** @class */
    function() {
      function e() {
        this.assumeImmutableResults = !1, this.getFragmentDoc = Ac(r52, {
          max: f3["cache.fragmentQueryDocuments"] || 1e3,
          cache: Pg
        });
      }
      return e.prototype.lookupFragment = function(t) {
        return null;
      }, e.prototype.batch = function(t) {
        var r = this, n = typeof t.optimistic == "string" ? t.optimistic : t.optimistic === !1 ? null : void 0, i;
        return this.performTransaction(function() {
          return i = t.update(r);
        }, n), i;
      }, e.prototype.recordOptimisticTransaction = function(t, r) {
        this.performTransaction(t, r);
      }, e.prototype.transformDocument = function(t) {
        return t;
      }, e.prototype.transformForLink = function(t) {
        return t;
      }, e.prototype.identify = function(t) {
      }, e.prototype.gc = function() {
        return [];
      }, e.prototype.modify = function(t) {
        return !1;
      }, e.prototype.readQuery = function(t, r) {
        return r === void 0 && (r = !!t.optimistic), this.read(C2(C2({}, t), { rootId: t.id || "ROOT_QUERY", optimistic: r }));
      }, e.prototype.watchFragment = function(t) {
        var r = this, n = t.fragment, i = t.fragmentName, o = t.from, u = t.optimistic, c = u === void 0 ? !0 : u, f = yr(t, ["fragment", "fragmentName", "from", "optimistic"]), d = this.getFragmentDoc(n, i), g = typeof o > "u" || typeof o == "string" ? o : this.identify(o), h = !!t[Symbol.for("apollo.dataMasking")];
        if (globalThis.__DEV__ !== !1) {
          var E = i || XZ(n).name.value;
          g || globalThis.__DEV__ !== !1 && u0.warn(1, E);
        }
        var y = C2(C2({}, f), { returnPartialData: !0, id: g, query: d, optimistic: c }), I;
        return new At(function(Q) {
          return r.watch(C2(C2({}, y), { immediate: !0, callback: function(B) {
            var _ = h ? Mz(B.result, n, r, i) : B.result;
            if (
              // Always ensure we deliver the first result
              !(I && Qz(
                d,
                { data: I.result },
                { data: _ },
                // TODO: Fix the type on WatchFragmentOptions so that TVars
                // extends OperationVariables
                t.variables
              ))
            ) {
              var M = {
                data: _,
                complete: !!B.complete
              };
              B.missing && (M.missing = ah(B.missing.map(function(S) {
                return S.missing;
              }))), I = C2(C2({}, B), { result: _ }), Q.next(M);
            }
          } }));
        });
      }, e.prototype.readFragment = function(t, r) {
        return r === void 0 && (r = !!t.optimistic), this.read(C2(C2({}, t), { query: this.getFragmentDoc(t.fragment, t.fragmentName), rootId: t.id, optimistic: r }));
      }, e.prototype.writeQuery = function(t) {
        var r = t.id, n = t.data, i = yr(t, ["id", "data"]);
        return this.write(Object.assign(i, {
          dataId: r || "ROOT_QUERY",
          result: n
        }));
      }, e.prototype.writeFragment = function(t) {
        var r = t.id, n = t.data, i = t.fragment, o = t.fragmentName, u = yr(t, ["id", "data", "fragment", "fragmentName"]);
        return this.write(Object.assign(u, {
          query: this.getFragmentDoc(i, o),
          dataId: r,
          result: n
        }));
      }, e.prototype.updateQuery = function(t, r) {
        return this.batch({
          update: function(n) {
            var i = n.readQuery(t), o = r(i);
            return o == null ? i : (n.writeQuery(C2(C2({}, t), { data: o })), o);
          }
        });
      }, e.prototype.updateFragment = function(t, r) {
        return this.batch({
          update: function(n) {
            var i = n.readFragment(t), o = r(i);
            return o == null ? i : (n.writeFragment(C2(C2({}, t), { data: o })), o);
          }
        });
      }, e;
    }()
  );
  globalThis.__DEV__ !== !1 && (_z.prototype.getMemoryInternals = d52);
  var Oz = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r, n, i, o) {
        var u, c = e.call(this, r) || this;
        if (c.message = r, c.path = n, c.query = i, c.variables = o, Array.isArray(c.path)) {
          c.missing = c.message;
          for (var f = c.path.length - 1; f >= 0; --f)
            c.missing = (u = {}, u[c.path[f]] = c.missing, u);
        } else
          c.missing = c.path;
        return c.__proto__ = t.prototype, c;
      }
      return t;
    }(Error)
  ), P5 = Object.prototype.hasOwnProperty;
  function Ml(e) {
    return e == null;
  }
  function Tz(e, t) {
    var r = e.__typename, n = e.id, i = e._id;
    if (typeof r == "string" && (t && (t.keyObject = Ml(n) ? Ml(i) ? void 0 : { _id: i } : { id: n }), Ml(n) && !Ml(i) && (n = i), !Ml(n)))
      return "".concat(r, ":").concat(typeof n == "number" || typeof n == "string" ? n : JSON.stringify(n));
  }
  var Dz = {
    dataIdFromObject: Tz,
    addTypename: !0,
    resultCaching: !0,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: !1
  };
  function X12(e) {
    return Ni(Dz, e);
  }
  function Lz(e) {
    var t = e.canonizeResults;
    return t === void 0 ? Dz.canonizeResults : t;
  }
  function J12(e, t) {
    return Ye(t) ? e.get(t.__ref, "__typename") : t && t.__typename;
  }
  var kz = /^[_a-z][_0-9a-z]*/i;
  function U6(e) {
    var t = e.match(kz);
    return t ? t[0] : e;
  }
  function db(e, t, r) {
    return qt(t) ? Wt(t) ? t.every(function(n) {
      return db(e, n, r);
    }) : e.selections.every(function(n) {
      if (V6(n) && Xc(n, r)) {
        var i = m8(n);
        return P5.call(t, i) && (!n.selectionSet || db(n.selectionSet, t[i], r));
      }
      return !0;
    }) : !1;
  }
  function a9(e) {
    return qt(e) && !Ye(e) && !Wt(e);
  }
  function er2() {
    return new z6();
  }
  function Rz(e, t) {
    var r = es(rs(e));
    return {
      fragmentMap: r,
      lookupFragment: function(n) {
        var i = r[n];
        return !i && t && (i = t.lookup(n)), i || null;
      }
    };
  }
  var Yd = /* @__PURE__ */ Object.create(null), Qy = function() {
    return Yd;
  }, PL = /* @__PURE__ */ Object.create(null), fc = (
    /** @class */
    function() {
      function e(t, r) {
        var n = this;
        this.policies = t, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(i, o) {
          return Q9(Ye(i) ? n.get(i.__ref, o) : i && i[o]);
        }, this.canRead = function(i) {
          return Ye(i) ? n.has(i.__ref) : typeof i == "object";
        }, this.toReference = function(i, o) {
          if (typeof i == "string")
            return A9(i);
          if (Ye(i))
            return i;
          var u = n.policies.identify(i)[0];
          if (u) {
            var c = A9(u);
            return o && n.merge(u, i), c;
          }
        };
      }
      return e.prototype.toObject = function() {
        return C2({}, this.data);
      }, e.prototype.has = function(t) {
        return this.lookup(t, !0) !== void 0;
      }, e.prototype.get = function(t, r) {
        if (this.group.depend(t, r), P5.call(this.data, t)) {
          var n = this.data[t];
          if (n && P5.call(n, r))
            return n[r];
        }
        if (r === "__typename" && P5.call(this.policies.rootTypenamesById, t))
          return this.policies.rootTypenamesById[t];
        if (this instanceof O6)
          return this.parent.get(t, r);
      }, e.prototype.lookup = function(t, r) {
        if (r && this.group.depend(t, "__exists"), P5.call(this.data, t))
          return this.data[t];
        if (this instanceof O6)
          return this.parent.lookup(t, r);
        if (this.policies.rootTypenamesById[t])
          return /* @__PURE__ */ Object.create(null);
      }, e.prototype.merge = function(t, r) {
        var n = this, i;
        Ye(t) && (t = t.__ref), Ye(r) && (r = r.__ref);
        var o = typeof t == "string" ? this.lookup(i = t) : t, u = typeof r == "string" ? this.lookup(i = r) : r;
        if (u) {
          u0(typeof i == "string", 2);
          var c = new z6(rr2).merge(o, u);
          if (this.data[i] = c, c !== o && (delete this.refs[i], this.group.caching)) {
            var f = /* @__PURE__ */ Object.create(null);
            o || (f.__exists = 1), Object.keys(u).forEach(function(d) {
              if (!o || o[d] !== c[d]) {
                f[d] = 1;
                var g = U6(d);
                g !== d && !n.policies.hasKeyArgs(c.__typename, g) && (f[g] = 1), c[d] === void 0 && !(n instanceof O6) && delete c[d];
              }
            }), f.__typename && !(o && o.__typename) && // Since we return default root __typename strings
            // automatically from store.get, we don't need to dirty the
            // ROOT_QUERY.__typename field if merged.__typename is equal
            // to the default string (usually "Query").
            this.policies.rootTypenamesById[i] === c.__typename && delete f.__typename, Object.keys(f).forEach(function(d) {
              return n.group.dirty(i, d);
            });
          }
        }
      }, e.prototype.modify = function(t, r) {
        var n = this, i = this.lookup(t);
        if (i) {
          var o = /* @__PURE__ */ Object.create(null), u = !1, c = !0, f = {
            DELETE: Yd,
            INVALIDATE: PL,
            isReference: Ye,
            toReference: this.toReference,
            canRead: this.canRead,
            readField: function(d, g) {
              return n.policies.readField(typeof d == "string" ? {
                fieldName: d,
                from: g || A9(t)
              } : d, { store: n });
            }
          };
          if (Object.keys(i).forEach(function(d) {
            var g = U6(d), h = i[d];
            if (h !== void 0) {
              var E = typeof r == "function" ? r : r[d] || r[g];
              if (E) {
                var y = E === Qy ? Yd : E(Q9(h), C2(C2({}, f), { fieldName: g, storeFieldName: d, storage: n.getStorage(t, d) }));
                if (y === PL)
                  n.group.dirty(t, d);
                else if (y === Yd && (y = void 0), y !== h && (o[d] = y, u = !0, h = y, globalThis.__DEV__ !== !1)) {
                  var I = function(w) {
                    if (n.lookup(w.__ref) === void 0)
                      return globalThis.__DEV__ !== !1 && u0.warn(3, w), !0;
                  };
                  if (Ye(y))
                    I(y);
                  else if (Array.isArray(y))
                    for (var Q = !1, B = void 0, _ = 0, M = y; _ < M.length; _++) {
                      var S = M[_];
                      if (Ye(S)) {
                        if (Q = !0, I(S))
                          break;
                      } else if (typeof S == "object" && S) {
                        var O = n.policies.identify(S)[0];
                        O && (B = S);
                      }
                      if (Q && B !== void 0) {
                        globalThis.__DEV__ !== !1 && u0.warn(4, B);
                        break;
                      }
                    }
                }
              }
              h !== void 0 && (c = !1);
            }
          }), u)
            return this.merge(t, o), c && (this instanceof O6 ? this.data[t] = void 0 : delete this.data[t], this.group.dirty(t, "__exists")), !0;
        }
        return !1;
      }, e.prototype.delete = function(t, r, n) {
        var i, o = this.lookup(t);
        if (o) {
          var u = this.getFieldValue(o, "__typename"), c = r && n ? this.policies.getStoreFieldName({ typename: u, fieldName: r, args: n }) : r;
          return this.modify(t, c ? (i = {}, i[c] = Qy, i) : Qy);
        }
        return !1;
      }, e.prototype.evict = function(t, r) {
        var n = !1;
        return t.id && (P5.call(this.data, t.id) && (n = this.delete(t.id, t.fieldName, t.args)), this instanceof O6 && this !== r && (n = this.parent.evict(t, r) || n), (t.fieldName || n) && this.group.dirty(t.id, t.fieldName || "__exists")), n;
      }, e.prototype.clear = function() {
        this.replace(null);
      }, e.prototype.extract = function() {
        var t = this, r = this.toObject(), n = [];
        return this.getRootIdSet().forEach(function(i) {
          P5.call(t.policies.rootTypenamesById, i) || n.push(i);
        }), n.length && (r.__META = { extraRootIds: n.sort() }), r;
      }, e.prototype.replace = function(t) {
        var r = this;
        if (Object.keys(this.data).forEach(function(o) {
          t && P5.call(t, o) || r.delete(o);
        }), t) {
          var n = t.__META, i = yr(t, ["__META"]);
          Object.keys(i).forEach(function(o) {
            r.merge(o, i[o]);
          }), n && n.extraRootIds.forEach(this.retain, this);
        }
      }, e.prototype.retain = function(t) {
        return this.rootIds[t] = (this.rootIds[t] || 0) + 1;
      }, e.prototype.release = function(t) {
        if (this.rootIds[t] > 0) {
          var r = --this.rootIds[t];
          return r || delete this.rootIds[t], r;
        }
        return 0;
      }, e.prototype.getRootIdSet = function(t) {
        return t === void 0 && (t = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(t.add, t), this instanceof O6 ? this.parent.getRootIdSet(t) : Object.keys(this.policies.rootTypenamesById).forEach(t.add, t), t;
      }, e.prototype.gc = function() {
        var t = this, r = this.getRootIdSet(), n = this.toObject();
        r.forEach(function(u) {
          P5.call(n, u) && (Object.keys(t.findChildRefIds(u)).forEach(r.add, r), delete n[u]);
        });
        var i = Object.keys(n);
        if (i.length) {
          for (var o = this; o instanceof O6; )
            o = o.parent;
          i.forEach(function(u) {
            return o.delete(u);
          });
        }
        return i;
      }, e.prototype.findChildRefIds = function(t) {
        if (!P5.call(this.refs, t)) {
          var r = this.refs[t] = /* @__PURE__ */ Object.create(null), n = this.data[t];
          if (!n)
            return r;
          var i = /* @__PURE__ */ new Set([n]);
          i.forEach(function(o) {
            Ye(o) && (r[o.__ref] = !0), qt(o) && Object.keys(o).forEach(function(u) {
              var c = o[u];
              qt(c) && i.add(c);
            });
          });
        }
        return this.refs[t];
      }, e.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
      }, e;
    }()
  ), Pz = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = null), this.caching = t, this.parent = r, this.d = null, this.resetCaching();
      }
      return e.prototype.resetCaching = function() {
        this.d = this.caching ? lz() : null, this.keyMaker = new S8(qi);
      }, e.prototype.depend = function(t, r) {
        if (this.d) {
          this.d(xy(t, r));
          var n = U6(r);
          n !== r && this.d(xy(t, n)), this.parent && this.parent.depend(t, r);
        }
      }, e.prototype.dirty = function(t, r) {
        this.d && this.d.dirty(
          xy(t, r),
          // When storeFieldName === "__exists", that means the entity identified
          // by dataId has either disappeared from the cache or was newly added,
          // so the result caching system would do well to "forget everything it
          // knows" about that object. To achieve that kind of invalidation, we
          // not only dirty the associated result cache entry, but also remove it
          // completely from the dependency graph. For the optimism implementation
          // details, see https://github.com/benjamn/optimism/pull/195.
          r === "__exists" ? "forget" : "setDirty"
        );
      }, e;
    }()
  );
  function xy(e, t) {
    return t + "#" + e;
  }
  function FL(e, t) {
    Jl(e) && e.group.depend(t, "__exists");
  }
  (function(e) {
    var t = (
      /** @class */
      function(r) {
        g3(n, r);
        function n(i) {
          var o = i.policies, u = i.resultCaching, c = u === void 0 ? !0 : u, f = i.seed, d = r.call(this, o, new Pz(c)) || this;
          return d.stump = new tr2(d), d.storageTrie = new S8(qi), f && d.replace(f), d;
        }
        return n.prototype.addLayer = function(i, o) {
          return this.stump.addLayer(i, o);
        }, n.prototype.removeLayer = function() {
          return this;
        }, n.prototype.getStorage = function() {
          return this.storageTrie.lookupArray(arguments);
        }, n;
      }(e)
    );
    e.Root = t;
  })(fc || (fc = {}));
  var O6 = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r, n, i, o) {
        var u = e.call(this, n.policies, o) || this;
        return u.id = r, u.parent = n, u.replay = i, u.group = o, i(u), u;
      }
      return t.prototype.addLayer = function(r, n) {
        return new t(r, this, n, this.group);
      }, t.prototype.removeLayer = function(r) {
        var n = this, i = this.parent.removeLayer(r);
        return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(o) {
          var u = n.data[o], c = i.lookup(o);
          c ? u ? u !== c && Object.keys(u).forEach(function(f) {
            et(u[f], c[f]) || n.group.dirty(o, f);
          }) : (n.group.dirty(o, "__exists"), Object.keys(c).forEach(function(f) {
            n.group.dirty(o, f);
          })) : n.delete(o);
        }), i) : i === this.parent ? this : i.addLayer(this.id, this.replay);
      }, t.prototype.toObject = function() {
        return C2(C2({}, this.parent.toObject()), this.data);
      }, t.prototype.findChildRefIds = function(r) {
        var n = this.parent.findChildRefIds(r);
        return P5.call(this.data, r) ? C2(C2({}, n), e.prototype.findChildRefIds.call(this, r)) : n;
      }, t.prototype.getStorage = function() {
        for (var r = this.parent; r.parent; )
          r = r.parent;
        return r.getStorage.apply(
          r,
          // @ts-expect-error
          arguments
        );
      }, t;
    }(fc)
  ), tr2 = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        return e.call(this, "EntityStore.Stump", r, function() {
        }, new Pz(r.group.caching, r.group)) || this;
      }
      return t.prototype.removeLayer = function() {
        return this;
      }, t.prototype.merge = function(r, n) {
        return this.parent.merge(r, n);
      }, t;
    }(O6)
  );
  function rr2(e, t, r) {
    var n = e[r], i = t[r];
    return et(n, i) ? n : i;
  }
  function Jl(e) {
    return !!(e instanceof fc && e.group.caching);
  }
  function nr2(e) {
    return qt(e) ? Wt(e) ? e.slice(0) : C2({ __proto__: Object.getPrototypeOf(e) }, e) : e;
  }
  var NL = (
    /** @class */
    function() {
      function e() {
        this.known = new (oS ? WeakSet : Set)(), this.pool = new S8(qi), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
      }
      return e.prototype.isKnown = function(t) {
        return qt(t) && this.known.has(t);
      }, e.prototype.pass = function(t) {
        if (qt(t)) {
          var r = nr2(t);
          return this.passes.set(r, t), r;
        }
        return t;
      }, e.prototype.admit = function(t) {
        var r = this;
        if (qt(t)) {
          var n = this.passes.get(t);
          if (n)
            return n;
          var i = Object.getPrototypeOf(t);
          switch (i) {
            case Array.prototype: {
              if (this.known.has(t))
                return t;
              var o = t.map(this.admit, this), u = this.pool.lookupArray(o);
              return u.array || (this.known.add(u.array = o), globalThis.__DEV__ !== !1 && Object.freeze(o)), u.array;
            }
            case null:
            case Object.prototype: {
              if (this.known.has(t))
                return t;
              var c = Object.getPrototypeOf(t), f = [c], d = this.sortedKeys(t);
              f.push(d.json);
              var g = f.length;
              d.sorted.forEach(function(y) {
                f.push(r.admit(t[y]));
              });
              var u = this.pool.lookupArray(f);
              if (!u.object) {
                var h = u.object = Object.create(c);
                this.known.add(h), d.sorted.forEach(function(y, I) {
                  h[y] = f[g + I];
                }), globalThis.__DEV__ !== !1 && Object.freeze(h);
              }
              return u.object;
            }
          }
        }
        return t;
      }, e.prototype.sortedKeys = function(t) {
        var r = Object.keys(t), n = this.pool.lookupArray(r);
        if (!n.keys) {
          r.sort();
          var i = JSON.stringify(r);
          (n.keys = this.keysByJSON.get(i)) || this.keysByJSON.set(i, n.keys = { sorted: r, json: i });
        }
        return n.keys;
      }, e;
    }()
  );
  function HL(e) {
    return [
      e.selectionSet,
      e.objectOrReference,
      e.context,
      // We split out this property so we can pass different values
      // independently without modifying options.context itself.
      e.context.canonizeResults
    ];
  }
  var ir2 = (
    /** @class */
    function() {
      function e(t) {
        var r = this;
        this.knownResults = new (qi ? WeakMap : Map)(), this.config = Ni(t, {
          addTypename: t.addTypename !== !1,
          canonizeResults: Lz(t)
        }), this.canon = t.canon || new NL(), this.executeSelectionSet = Ac(function(n) {
          var i, o = n.context.canonizeResults, u = HL(n);
          u[3] = !o;
          var c = (i = r.executeSelectionSet).peek.apply(i, u);
          return c ? o ? C2(C2({}, c), {
            // If we previously read this result without canonizing it, we can
            // reuse that result simply by canonizing it now.
            result: r.canon.admit(c.result)
          }) : c : (FL(n.context.store, n.enclosingRef.__ref), r.execSelectionSetImpl(n));
        }, {
          max: this.config.resultCacheMaxSize || f3["inMemoryCache.executeSelectionSet"] || 5e4,
          keyArgs: HL,
          // Note that the parameters of makeCacheKey are determined by the
          // array returned by keyArgs.
          makeCacheKey: function(n, i, o, u) {
            if (Jl(o.store))
              return o.store.makeCacheKey(n, Ye(i) ? i.__ref : i, o.varString, u);
          }
        }), this.executeSubSelectedArray = Ac(function(n) {
          return FL(n.context.store, n.enclosingRef.__ref), r.execSubSelectedArrayImpl(n);
        }, {
          max: this.config.resultCacheMaxSize || f3["inMemoryCache.executeSubSelectedArray"] || 1e4,
          makeCacheKey: function(n) {
            var i = n.field, o = n.array, u = n.context;
            if (Jl(u.store))
              return u.store.makeCacheKey(i, o, u.varString);
          }
        });
      }
      return e.prototype.resetCanon = function() {
        this.canon = new NL();
      }, e.prototype.diffQueryAgainstStore = function(t) {
        var r = t.store, n = t.query, i = t.rootId, o = i === void 0 ? "ROOT_QUERY" : i, u = t.variables, c = t.returnPartialData, f = c === void 0 ? !0 : c, d = t.canonizeResults, g = d === void 0 ? this.config.canonizeResults : d, h = this.config.cache.policies;
        u = C2(C2({}, cS(KZ(n))), u);
        var E = A9(o), y = this.executeSelectionSet({
          selectionSet: Jc(n).selectionSet,
          objectOrReference: E,
          enclosingRef: E,
          context: C2({ store: r, query: n, policies: h, variables: u, varString: N6(u), canonizeResults: g }, Rz(n, this.config.fragments))
        }), I;
        if (y.missing && (I = [
          new Oz(ar2(y.missing), y.missing, n, u)
        ], !f))
          throw I[0];
        return {
          result: y.result,
          complete: !I,
          missing: I
        };
      }, e.prototype.isFresh = function(t, r, n, i) {
        if (Jl(i.store) && this.knownResults.get(t) === n) {
          var o = this.executeSelectionSet.peek(
            n,
            r,
            i,
            // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(t)
          );
          if (o && t === o.result)
            return !0;
        }
        return !1;
      }, e.prototype.execSelectionSetImpl = function(t) {
        var r = this, n = t.selectionSet, i = t.objectOrReference, o = t.enclosingRef, u = t.context;
        if (Ye(i) && !u.policies.rootTypenamesById[i.__ref] && !u.store.has(i.__ref))
          return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(i.__ref, " object")
          };
        var c = u.variables, f = u.policies, d = u.store, g = d.getFieldValue(i, "__typename"), h = [], E, y = new z6();
        this.config.addTypename && typeof g == "string" && !f.rootIdsByTypename[g] && h.push({ __typename: g });
        function I(S, O) {
          var w;
          return S.missing && (E = y.merge(E, (w = {}, w[O] = S.missing, w))), S.result;
        }
        var Q = new Set(n.selections);
        Q.forEach(function(S) {
          var O, w;
          if (Xc(S, c))
            if (V6(S)) {
              var D = f.readField({
                fieldName: S.name.value,
                field: S,
                variables: u.variables,
                from: i
              }, u), k = m8(S);
              D === void 0 ? dS.added(S) || (E = y.merge(E, (O = {}, O[k] = "Can't find field '".concat(S.name.value, "' on ").concat(Ye(i) ? i.__ref + " object" : "object " + JSON.stringify(i, null, 2)), O))) : Wt(D) ? D.length > 0 && (D = I(r.executeSubSelectedArray({
                field: S,
                array: D,
                enclosingRef: o,
                context: u
              }), k)) : S.selectionSet ? D != null && (D = I(r.executeSelectionSet({
                selectionSet: S.selectionSet,
                objectOrReference: D,
                enclosingRef: Ye(D) ? D : o,
                context: u
              }), k)) : u.canonizeResults && (D = r.canon.pass(D)), D !== void 0 && h.push((w = {}, w[k] = D, w));
            } else {
              var F = th(S, u.lookupFragment);
              if (!F && S.kind === a0.FRAGMENT_SPREAD)
                throw G1(10, S.name.value);
              F && f.fragmentMatches(F, g) && F.selectionSet.selections.forEach(Q.add, Q);
            }
        });
        var B = ah(h), _ = { result: B, missing: E }, M = u.canonizeResults ? this.canon.admit(_) : Q9(_);
        return M.result && this.knownResults.set(M.result, n), M;
      }, e.prototype.execSubSelectedArrayImpl = function(t) {
        var r = this, n = t.field, i = t.array, o = t.enclosingRef, u = t.context, c, f = new z6();
        function d(g, h) {
          var E;
          return g.missing && (c = f.merge(c, (E = {}, E[h] = g.missing, E))), g.result;
        }
        return n.selectionSet && (i = i.filter(u.store.canRead)), i = i.map(function(g, h) {
          return g === null ? null : Wt(g) ? d(r.executeSubSelectedArray({
            field: n,
            array: g,
            enclosingRef: o,
            context: u
          }), h) : n.selectionSet ? d(r.executeSelectionSet({
            selectionSet: n.selectionSet,
            objectOrReference: g,
            enclosingRef: Ye(g) ? g : o,
            context: u
          }), h) : (globalThis.__DEV__ !== !1 && or2(u.store, n, g), g);
        }), {
          result: u.canonizeResults ? this.canon.admit(i) : i,
          missing: c
        };
      }, e;
    }()
  );
  function ar2(e) {
    try {
      JSON.stringify(e, function(t, r) {
        if (typeof r == "string")
          throw r;
        return r;
      });
    } catch (t) {
      return t;
    }
  }
  function or2(e, t, r) {
    if (!t.selectionSet) {
      var n = /* @__PURE__ */ new Set([r]);
      n.forEach(function(i) {
        qt(i) && (u0(
          !Ye(i),
          11,
          J12(e, i),
          t.name.value
        ), Object.values(i).forEach(n.add, n));
      });
    }
  }
  var yS = new eA(), jL = /* @__PURE__ */ new WeakMap();
  function ec(e) {
    var t = jL.get(e);
    return t || jL.set(e, t = {
      vars: /* @__PURE__ */ new Set(),
      dep: lz()
    }), t;
  }
  function VL(e) {
    ec(e).vars.forEach(function(t) {
      return t.forgetCache(e);
    });
  }
  function sr2(e) {
    ec(e).vars.forEach(function(t) {
      return t.attachCache(e);
    });
  }
  function ur2(e) {
    var t = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), n = function(o) {
      if (arguments.length > 0) {
        if (e !== o) {
          e = o, t.forEach(function(f) {
            ec(f).dep.dirty(n), lr2(f);
          });
          var u = Array.from(r);
          r.clear(), u.forEach(function(f) {
            return f(e);
          });
        }
      } else {
        var c = yS.getValue();
        c && (i(c), ec(c).dep(n));
      }
      return e;
    };
    n.onNextChange = function(o) {
      return r.add(o), function() {
        r.delete(o);
      };
    };
    var i = n.attachCache = function(o) {
      return t.add(o), ec(o).vars.add(n), n;
    };
    return n.forgetCache = function(o) {
      return t.delete(o);
    }, n;
  }
  function lr2(e) {
    e.broadcastWatches && e.broadcastWatches();
  }
  var ZL = /* @__PURE__ */ Object.create(null);
  function IS(e) {
    var t = JSON.stringify(e);
    return ZL[t] || (ZL[t] = /* @__PURE__ */ Object.create(null));
  }
  function zL(e) {
    var t = IS(e);
    return t.keyFieldsFn || (t.keyFieldsFn = function(r, n) {
      var i = function(u, c) {
        return n.readField(c, u);
      }, o = n.keyObject = BS(e, function(u) {
        var c = d9(
          n.storeObject,
          u,
          // Using context.readField to extract paths from context.storeObject
          // allows the extraction to see through Reference objects and respect
          // custom read functions.
          i
        );
        return c === void 0 && r !== n.storeObject && P5.call(r, u[0]) && (c = d9(r, u, Nz)), u0(c !== void 0, 5, u.join("."), r), c;
      });
      return "".concat(n.typename, ":").concat(JSON.stringify(o));
    });
  }
  function UL(e) {
    var t = IS(e);
    return t.keyArgsFn || (t.keyArgsFn = function(r, n) {
      var i = n.field, o = n.variables, u = n.fieldName, c = BS(e, function(d) {
        var g = d[0], h = g.charAt(0);
        if (h === "@") {
          if (i && M4(i.directives)) {
            var E = g.slice(1), y = i.directives.find(function(_) {
              return _.name.value === E;
            }), I = y && rh(y, o);
            return I && d9(
              I,
              // If keyPath.length === 1, this code calls extractKeyPath with an
              // empty path, which works because it uses directiveArgs as the
              // extracted value.
              d.slice(1)
            );
          }
          return;
        }
        if (h === "$") {
          var Q = g.slice(1);
          if (o && P5.call(o, Q)) {
            var B = d.slice(0);
            return B[0] = Q, d9(o, B);
          }
          return;
        }
        if (r)
          return d9(r, d);
      }), f = JSON.stringify(c);
      return (r || f !== "{}") && (u += ":" + f), u;
    });
  }
  function BS(e, t) {
    var r = new z6();
    return Fz(e).reduce(function(n, i) {
      var o, u = t(i);
      if (u !== void 0) {
        for (var c = i.length - 1; c >= 0; --c)
          u = (o = {}, o[i[c]] = u, o);
        n = r.merge(n, u);
      }
      return n;
    }, /* @__PURE__ */ Object.create(null));
  }
  function Fz(e) {
    var t = IS(e);
    if (!t.paths) {
      var r = t.paths = [], n = [];
      e.forEach(function(i, o) {
        Wt(i) ? (Fz(i).forEach(function(u) {
          return r.push(n.concat(u));
        }), n.length = 0) : (n.push(i), Wt(e[o + 1]) || (r.push(n.slice(0)), n.length = 0));
      });
    }
    return t.paths;
  }
  function Nz(e, t) {
    return e[t];
  }
  function d9(e, t, r) {
    return r = r || Nz, Hz(t.reduce(function n(i, o) {
      return Wt(i) ? i.map(function(u) {
        return n(u, o);
      }) : i && r(i, o);
    }, e));
  }
  function Hz(e) {
    return qt(e) ? Wt(e) ? e.map(Hz) : BS(Object.keys(e).sort(), function(t) {
      return d9(e, t);
    }) : e;
  }
  function gb(e) {
    return e.args !== void 0 ? e.args : e.field ? rh(e.field, e.variables) : null;
  }
  var cr2 = function() {
  }, qL = function(e, t) {
    return t.fieldName;
  }, WL = function(e, t, r) {
    var n = r.mergeObjects;
    return n(e, t);
  }, YL = function(e, t) {
    return t;
  }, Ar2 = (
    /** @class */
    function() {
      function e(t) {
        this.config = t, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = C2({ dataIdFromObject: Tz }, t), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), t.possibleTypes && this.addPossibleTypes(t.possibleTypes), t.typePolicies && this.addTypePolicies(t.typePolicies);
      }
      return e.prototype.identify = function(t, r) {
        var n, i = this, o = r && (r.typename || ((n = r.storeObject) === null || n === void 0 ? void 0 : n.__typename)) || t.__typename;
        if (o === this.rootTypenamesById.ROOT_QUERY)
          return ["ROOT_QUERY"];
        var u = r && r.storeObject || t, c = C2(C2({}, r), { typename: o, storeObject: u, readField: r && r.readField || function() {
          var h = QS(arguments, u);
          return i.readField(h, {
            store: i.cache.data,
            variables: h.variables
          });
        } }), f, d = o && this.getTypePolicy(o), g = d && d.keyFn || this.config.dataIdFromObject;
        return mS.withValue(!0, function() {
          for (; g; ) {
            var h = g(C2(C2({}, t), u), c);
            if (Wt(h))
              g = zL(h);
            else {
              f = h;
              break;
            }
          }
        }), f = f ? String(f) : void 0, c.keyObject ? [f, c.keyObject] : [f];
      }, e.prototype.addTypePolicies = function(t) {
        var r = this;
        Object.keys(t).forEach(function(n) {
          var i = t[n], o = i.queryType, u = i.mutationType, c = i.subscriptionType, f = yr(i, ["queryType", "mutationType", "subscriptionType"]);
          o && r.setRootTypename("Query", n), u && r.setRootTypename("Mutation", n), c && r.setRootTypename("Subscription", n), P5.call(r.toBeAdded, n) ? r.toBeAdded[n].push(f) : r.toBeAdded[n] = [f];
        });
      }, e.prototype.updateTypePolicy = function(t, r) {
        var n = this, i = this.getTypePolicy(t), o = r.keyFields, u = r.fields;
        function c(f, d) {
          f.merge = typeof d == "function" ? d : d === !0 ? WL : d === !1 ? YL : f.merge;
        }
        c(i, r.merge), i.keyFn = // Pass false to disable normalization for this typename.
        o === !1 ? cr2 : Wt(o) ? zL(o) : typeof o == "function" ? o : i.keyFn, u && Object.keys(u).forEach(function(f) {
          var d = n.getFieldPolicy(t, f, !0), g = u[f];
          if (typeof g == "function")
            d.read = g;
          else {
            var h = g.keyArgs, E = g.read, y = g.merge;
            d.keyFn = // Pass false to disable argument-based differentiation of
            // field identities.
            h === !1 ? qL : Wt(h) ? UL(h) : typeof h == "function" ? h : d.keyFn, typeof E == "function" && (d.read = E), c(d, y);
          }
          d.read && d.merge && (d.keyFn = d.keyFn || qL);
        });
      }, e.prototype.setRootTypename = function(t, r) {
        r === void 0 && (r = t);
        var n = "ROOT_" + t.toUpperCase(), i = this.rootTypenamesById[n];
        r !== i && (u0(!i || i === t, 6, t), i && delete this.rootIdsByTypename[i], this.rootIdsByTypename[r] = n, this.rootTypenamesById[n] = r);
      }, e.prototype.addPossibleTypes = function(t) {
        var r = this;
        this.usingPossibleTypes = !0, Object.keys(t).forEach(function(n) {
          r.getSupertypeSet(n, !0), t[n].forEach(function(i) {
            r.getSupertypeSet(i, !0).add(n);
            var o = i.match(kz);
            (!o || o[0] !== i) && r.fuzzySubtypes.set(i, new RegExp(i));
          });
        });
      }, e.prototype.getTypePolicy = function(t) {
        var r = this;
        if (!P5.call(this.typePolicies, t)) {
          var n = this.typePolicies[t] = /* @__PURE__ */ Object.create(null);
          n.fields = /* @__PURE__ */ Object.create(null);
          var i = this.supertypeMap.get(t);
          !i && this.fuzzySubtypes.size && (i = this.getSupertypeSet(t, !0), this.fuzzySubtypes.forEach(function(u, c) {
            if (u.test(t)) {
              var f = r.supertypeMap.get(c);
              f && f.forEach(function(d) {
                return i.add(d);
              });
            }
          })), i && i.size && i.forEach(function(u) {
            var c = r.getTypePolicy(u), f = c.fields, d = yr(c, ["fields"]);
            Object.assign(n, d), Object.assign(n.fields, f);
          });
        }
        var o = this.toBeAdded[t];
        return o && o.length && o.splice(0).forEach(function(u) {
          r.updateTypePolicy(t, u);
        }), this.typePolicies[t];
      }, e.prototype.getFieldPolicy = function(t, r, n) {
        if (t) {
          var i = this.getTypePolicy(t).fields;
          return i[r] || n && (i[r] = /* @__PURE__ */ Object.create(null));
        }
      }, e.prototype.getSupertypeSet = function(t, r) {
        var n = this.supertypeMap.get(t);
        return !n && r && this.supertypeMap.set(t, n = /* @__PURE__ */ new Set()), n;
      }, e.prototype.fragmentMatches = function(t, r, n, i) {
        var o = this;
        if (!t.typeCondition)
          return !0;
        if (!r)
          return !1;
        var u = t.typeCondition.name.value;
        if (r === u)
          return !0;
        if (this.usingPossibleTypes && this.supertypeMap.has(u))
          for (var c = this.getSupertypeSet(r, !0), f = [c], d = function(I) {
            var Q = o.getSupertypeSet(I, !1);
            Q && Q.size && f.indexOf(Q) < 0 && f.push(Q);
          }, g = !!(n && this.fuzzySubtypes.size), h = !1, E = 0; E < f.length; ++E) {
            var y = f[E];
            if (y.has(u))
              return c.has(u) || (h && globalThis.__DEV__ !== !1 && u0.warn(7, r, u), c.add(u)), !0;
            y.forEach(d), g && // Start checking fuzzy subtypes only after exhausting all
            // non-fuzzy subtypes (after the final iteration of the loop).
            E === f.length - 1 && // We could wait to compare fragment.selectionSet to result
            // after we verify the supertype, but this check is often less
            // expensive than that search, and we will have to do the
            // comparison anyway whenever we find a potential match.
            db(t.selectionSet, n, i) && (g = !1, h = !0, this.fuzzySubtypes.forEach(function(I, Q) {
              var B = r.match(I);
              B && B[0] === r && d(Q);
            }));
          }
        return !1;
      }, e.prototype.hasKeyArgs = function(t, r) {
        var n = this.getFieldPolicy(t, r, !1);
        return !!(n && n.keyFn);
      }, e.prototype.getStoreFieldName = function(t) {
        var r = t.typename, n = t.fieldName, i = this.getFieldPolicy(r, n, !1), o, u = i && i.keyFn;
        if (u && r)
          for (var c = {
            typename: r,
            fieldName: n,
            field: t.field || null,
            variables: t.variables
          }, f = gb(t); u; ) {
            var d = u(f, c);
            if (Wt(d))
              u = UL(d);
            else {
              o = d || n;
              break;
            }
          }
        return o === void 0 && (o = t.field ? O52(t.field, t.variables) : GZ(n, gb(t))), o === !1 ? n : n === U6(o) ? o : n + ":" + o;
      }, e.prototype.readField = function(t, r) {
        var n = t.from;
        if (n) {
          var i = t.field || t.fieldName;
          if (i) {
            if (t.typename === void 0) {
              var o = r.store.getFieldValue(n, "__typename");
              o && (t.typename = o);
            }
            var u = this.getStoreFieldName(t), c = U6(u), f = r.store.getFieldValue(n, u), d = this.getFieldPolicy(t.typename, c, !1), g = d && d.read;
            if (g) {
              var h = $L(this, n, t, r, r.store.getStorage(Ye(n) ? n.__ref : n, u));
              return yS.withValue(this.cache, g, [
                f,
                h
              ]);
            }
            return f;
          }
        }
      }, e.prototype.getReadFunction = function(t, r) {
        var n = this.getFieldPolicy(t, r, !1);
        return n && n.read;
      }, e.prototype.getMergeFunction = function(t, r, n) {
        var i = this.getFieldPolicy(t, r, !1), o = i && i.merge;
        return !o && n && (i = this.getTypePolicy(n), o = i && i.merge), o;
      }, e.prototype.runMergeFunction = function(t, r, n, i, o) {
        var u = n.field, c = n.typename, f = n.merge;
        return f === WL ? jz(i.store)(t, r) : f === YL ? r : (i.overwrite && (t = void 0), f(t, r, $L(
          this,
          // Unlike options.readField for read functions, we do not fall
          // back to the current object if no foreignObjOrRef is provided,
          // because it's not clear what the current object should be for
          // merge functions: the (possibly undefined) existing object, or
          // the incoming object? If you think your merge function needs
          // to read sibling fields in order to produce a new value for
          // the current field, you might want to rethink your strategy,
          // because that's a recipe for making merge behavior sensitive
          // to the order in which fields are written into the cache.
          // However, readField(name, ref) is useful for merge functions
          // that need to deduplicate child objects and references.
          void 0,
          {
            typename: c,
            fieldName: u.name.value,
            field: u,
            variables: i.variables
          },
          i,
          o || /* @__PURE__ */ Object.create(null)
        )));
      }, e;
    }()
  );
  function $L(e, t, r, n, i) {
    var o = e.getStoreFieldName(r), u = U6(o), c = r.variables || n.variables, f = n.store, d = f.toReference, g = f.canRead;
    return {
      args: gb(r),
      field: r.field || null,
      fieldName: u,
      storeFieldName: o,
      variables: c,
      isReference: Ye,
      toReference: d,
      storage: i,
      cache: e.cache,
      canRead: g,
      readField: function() {
        return e.readField(QS(arguments, t, c), n);
      },
      mergeObjects: jz(n.store)
    };
  }
  function QS(e, t, r) {
    var n = e[0], i = e[1], o = e.length, u;
    return typeof n == "string" ? u = {
      fieldName: n,
      // Default to objectOrReference only when no second argument was
      // passed for the from parameter, not when undefined is explicitly
      // passed as the second argument.
      from: o > 1 ? i : t
    } : (u = C2({}, n), P5.call(u, "from") || (u.from = t)), globalThis.__DEV__ !== !1 && u.from === void 0 && globalThis.__DEV__ !== !1 && u0.warn(8, TZ(Array.from(e))), u.variables === void 0 && (u.variables = r), u;
  }
  function jz(e) {
    return function(r, n) {
      if (Wt(r) || Wt(n))
        throw G1(9);
      if (qt(r) && qt(n)) {
        var i = e.getFieldValue(r, "__typename"), o = e.getFieldValue(n, "__typename"), u = i && o && i !== o;
        if (u)
          return n;
        if (Ye(r) && a9(n))
          return e.merge(r.__ref, n), r;
        if (a9(r) && Ye(n))
          return e.merge(r, n.__ref), n;
        if (a9(r) && a9(n))
          return C2(C2({}, r), n);
      }
      return n;
    };
  }
  function by(e, t, r) {
    var n = "".concat(t).concat(r), i = e.flavors.get(n);
    return i || e.flavors.set(n, i = e.clientOnly === t && e.deferred === r ? e : C2(C2({}, e), { clientOnly: t, deferred: r })), i;
  }
  var fr2 = (
    /** @class */
    function() {
      function e(t, r, n) {
        this.cache = t, this.reader = r, this.fragments = n;
      }
      return e.prototype.writeToStore = function(t, r) {
        var n = this, i = r.query, o = r.result, u = r.dataId, c = r.variables, f = r.overwrite, d = Fi(i), g = er2();
        c = C2(C2({}, cS(d)), c);
        var h = C2(C2({ store: t, written: /* @__PURE__ */ Object.create(null), merge: function(y, I) {
          return g.merge(y, I);
        }, variables: c, varString: N6(c) }, Rz(i, this.fragments)), { overwrite: !!f, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), E = this.processSelectionSet({
          result: o || /* @__PURE__ */ Object.create(null),
          dataId: u,
          selectionSet: d.selectionSet,
          mergeTree: { map: /* @__PURE__ */ new Map() },
          context: h
        });
        if (!Ye(E))
          throw G1(12, o);
        return h.incomingById.forEach(function(y, I) {
          var Q = y.storeObject, B = y.mergeTree, _ = y.fieldNodeSet, M = A9(I);
          if (B && B.map.size) {
            var S = n.applyMerges(B, M, Q, h);
            if (Ye(S))
              return;
            Q = S;
          }
          if (globalThis.__DEV__ !== !1 && !h.overwrite) {
            var O = /* @__PURE__ */ Object.create(null);
            _.forEach(function(k) {
              k.selectionSet && (O[k.name.value] = !0);
            });
            var w = function(k) {
              return O[U6(k)] === !0;
            }, D = function(k) {
              var F = B && B.map.get(k);
              return !!(F && F.info && F.info.merge);
            };
            Object.keys(Q).forEach(function(k) {
              w(k) && !D(k) && Cr2(M, Q, k, h.store);
            });
          }
          t.merge(I, Q);
        }), t.retain(E.__ref), E;
      }, e.prototype.processSelectionSet = function(t) {
        var r = this, n = t.dataId, i = t.result, o = t.selectionSet, u = t.context, c = t.mergeTree, f = this.cache.policies, d = /* @__PURE__ */ Object.create(null), g = n && f.rootTypenamesById[n] || ab(i, o, u.fragmentMap) || n && u.store.get(n, "__typename");
        typeof g == "string" && (d.__typename = g);
        var h = function() {
          var S = QS(arguments, d, u.variables);
          if (Ye(S.from)) {
            var O = u.incomingById.get(S.from.__ref);
            if (O) {
              var w = f.readField(C2(C2({}, S), { from: O.storeObject }), u);
              if (w !== void 0)
                return w;
            }
          }
          return f.readField(S, u);
        }, E = /* @__PURE__ */ new Set();
        this.flattenFields(
          o,
          i,
          // This WriteContext will be the default context value for fields returned
          // by the flattenFields method, but some fields may be assigned a modified
          // context, depending on the presence of @client and other directives.
          u,
          g
        ).forEach(function(S, O) {
          var w, D = m8(O), k = i[D];
          if (E.add(O), k !== void 0) {
            var F = f.getStoreFieldName({
              typename: g,
              fieldName: O.name.value,
              field: O,
              variables: S.variables
            }), z = GL(c, F), Z = r.processFieldValue(
              k,
              O,
              // Reset context.clientOnly and context.deferred to their default
              // values before processing nested selection sets.
              O.selectionSet ? by(S, !1, !1) : S,
              z
            ), V = void 0;
            O.selectionSet && (Ye(Z) || a9(Z)) && (V = h("__typename", Z));
            var $ = f.getMergeFunction(g, O.name.value, V);
            $ ? z.info = {
              // TODO Check compatibility against any existing childTree.field?
              field: O,
              typename: g,
              merge: $
            } : KL(c, F), d = S.merge(d, (w = {}, w[F] = Z, w));
          } else globalThis.__DEV__ !== !1 && !S.clientOnly && !S.deferred && !dS.added(O) && // If the field has a read function, it may be a synthetic field or
          // provide a default value, so its absence from the written data should
          // not be cause for alarm.
          !f.getReadFunction(g, O.name.value) && globalThis.__DEV__ !== !1 && u0.error(13, m8(O), i);
        });
        try {
          var y = f.identify(i, {
            typename: g,
            selectionSet: o,
            fragmentMap: u.fragmentMap,
            storeObject: d,
            readField: h
          }), I = y[0], Q = y[1];
          n = n || I, Q && (d = u.merge(d, Q));
        } catch (S) {
          if (!n)
            throw S;
        }
        if (typeof n == "string") {
          var B = A9(n), _ = u.written[n] || (u.written[n] = []);
          if (_.indexOf(o) >= 0 || (_.push(o), this.reader && this.reader.isFresh(i, B, o, u)))
            return B;
          var M = u.incomingById.get(n);
          return M ? (M.storeObject = u.merge(M.storeObject, d), M.mergeTree = pb(M.mergeTree, c), E.forEach(function(S) {
            return M.fieldNodeSet.add(S);
          })) : u.incomingById.set(n, {
            storeObject: d,
            // Save a reference to mergeTree only if it is not empty, because
            // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
            // reused for entirely different parts of the result tree.
            mergeTree: Ng(c) ? void 0 : c,
            fieldNodeSet: E
          }), B;
        }
        return d;
      }, e.prototype.processFieldValue = function(t, r, n, i) {
        var o = this;
        return !r.selectionSet || t === null ? globalThis.__DEV__ !== !1 ? hz(t) : t : Wt(t) ? t.map(function(u, c) {
          var f = o.processFieldValue(u, r, n, GL(i, c));
          return KL(i, c), f;
        }) : this.processSelectionSet({
          result: t,
          selectionSet: r.selectionSet,
          context: n,
          mergeTree: i
        });
      }, e.prototype.flattenFields = function(t, r, n, i) {
        i === void 0 && (i = ab(r, t, n.fragmentMap));
        var o = /* @__PURE__ */ new Map(), u = this.cache.policies, c = new S8(!1);
        return function f(d, g) {
          var h = c.lookup(
            d,
            // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            g.clientOnly,
            g.deferred
          );
          h.visited || (h.visited = !0, d.selections.forEach(function(E) {
            if (Xc(E, n.variables)) {
              var y = g.clientOnly, I = g.deferred;
              if (
                // Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(y && I) && M4(E.directives) && E.directives.forEach(function(_) {
                  var M = _.name.value;
                  if (M === "client" && (y = !0), M === "defer") {
                    var S = rh(_, n.variables);
                    (!S || S.if !== !1) && (I = !0);
                  }
                }), V6(E)
              ) {
                var Q = o.get(E);
                Q && (y = y && Q.clientOnly, I = I && Q.deferred), o.set(E, by(n, y, I));
              } else {
                var B = th(E, n.lookupFragment);
                if (!B && E.kind === a0.FRAGMENT_SPREAD)
                  throw G1(14, E.name.value);
                B && u.fragmentMatches(B, i, r, n.variables) && f(B.selectionSet, by(n, y, I));
              }
            }
          }));
        }(t, n), o;
      }, e.prototype.applyMerges = function(t, r, n, i, o) {
        var u, c = this;
        if (t.map.size && !Ye(n)) {
          var f = (
            // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !Wt(n) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            (Ye(r) || a9(r)) ? r : void 0
          ), d = n;
          f && !o && (o = [Ye(f) ? f.__ref : f]);
          var g, h = function(E, y) {
            return Wt(E) ? typeof y == "number" ? E[y] : void 0 : i.store.getFieldValue(E, String(y));
          };
          t.map.forEach(function(E, y) {
            var I = h(f, y), Q = h(d, y);
            if (Q !== void 0) {
              o && o.push(y);
              var B = c.applyMerges(E, I, Q, i, o);
              B !== Q && (g = g || /* @__PURE__ */ new Map(), g.set(y, B)), o && u0(o.pop() === y);
            }
          }), g && (n = Wt(d) ? d.slice(0) : C2({}, d), g.forEach(function(E, y) {
            n[y] = E;
          }));
        }
        return t.info ? this.cache.policies.runMergeFunction(r, n, t.info, i, o && (u = i.store).getStorage.apply(u, o)) : n;
      }, e;
    }()
  ), Vz = [];
  function GL(e, t) {
    var r = e.map;
    return r.has(t) || r.set(t, Vz.pop() || { map: /* @__PURE__ */ new Map() }), r.get(t);
  }
  function pb(e, t) {
    if (e === t || !t || Ng(t))
      return e;
    if (!e || Ng(e))
      return t;
    var r = e.info && t.info ? C2(C2({}, e.info), t.info) : e.info || t.info, n = e.map.size && t.map.size, i = n ? /* @__PURE__ */ new Map() : e.map.size ? e.map : t.map, o = { info: r, map: i };
    if (n) {
      var u = new Set(t.map.keys());
      e.map.forEach(function(c, f) {
        o.map.set(f, pb(c, t.map.get(f))), u.delete(f);
      }), u.forEach(function(c) {
        o.map.set(c, pb(t.map.get(c), e.map.get(c)));
      });
    }
    return o;
  }
  function Ng(e) {
    return !e || !(e.info || e.map.size);
  }
  function KL(e, t) {
    var r = e.map, n = r.get(t);
    n && Ng(n) && (Vz.push(n), r.delete(t));
  }
  var XL = /* @__PURE__ */ new Set();
  function Cr2(e, t, r, n) {
    var i = function(h) {
      var E = n.getFieldValue(h, r);
      return typeof E == "object" && E;
    }, o = i(e);
    if (o) {
      var u = i(t);
      if (u && !Ye(o) && !et(o, u) && !Object.keys(o).every(function(h) {
        return n.getFieldValue(u, h) !== void 0;
      })) {
        var c = n.getFieldValue(e, "__typename") || n.getFieldValue(t, "__typename"), f = U6(r), d = "".concat(c, ".").concat(f);
        if (!XL.has(d)) {
          XL.add(d);
          var g = [];
          !Wt(o) && !Wt(u) && [o, u].forEach(function(h) {
            var E = n.getFieldValue(h, "__typename");
            typeof E == "string" && !g.includes(E) && g.push(E);
          }), globalThis.__DEV__ !== !1 && u0.warn(15, f, c, g.length ? "either ensure all objects of type " + g.join(" and ") + " have an ID or a custom merge function, or " : "", d, C2({}, o), C2({}, u));
        }
      }
    }
  }
  var Zz = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        r === void 0 && (r = {});
        var n = e.call(this) || this;
        return n.watches = /* @__PURE__ */ new Set(), n.addTypenameTransform = new cz(dS), n.assumeImmutableResults = !0, n.makeVar = ur2, n.txCount = 0, n.config = X12(r), n.addTypename = !!n.config.addTypename, n.policies = new Ar2({
          cache: n,
          dataIdFromObject: n.config.dataIdFromObject,
          possibleTypes: n.config.possibleTypes,
          typePolicies: n.config.typePolicies
        }), n.init(), n;
      }
      return t.prototype.init = function() {
        var r = this.data = new fc.Root({
          policies: this.policies,
          resultCaching: this.config.resultCaching
        });
        this.optimisticData = r.stump, this.resetResultCache();
      }, t.prototype.resetResultCache = function(r) {
        var n = this, i = this.storeReader, o = this.config.fragments;
        this.storeWriter = new fr2(this, this.storeReader = new ir2({
          cache: this,
          addTypename: this.addTypename,
          resultCacheMaxSize: this.config.resultCacheMaxSize,
          canonizeResults: Lz(this.config),
          canon: r ? void 0 : i && i.canon,
          fragments: o
        }), o), this.maybeBroadcastWatch = Ac(function(u, c) {
          return n.broadcastWatch(u, c);
        }, {
          max: this.config.resultCacheMaxSize || f3["inMemoryCache.maybeBroadcastWatch"] || 5e3,
          makeCacheKey: function(u) {
            var c = u.optimistic ? n.optimisticData : n.data;
            if (Jl(c)) {
              var f = u.optimistic, d = u.id, g = u.variables;
              return c.makeCacheKey(
                u.query,
                // Different watches can have the same query, optimistic
                // status, rootId, and variables, but if their callbacks are
                // different, the (identical) result needs to be delivered to
                // each distinct callback. The easiest way to achieve that
                // separation is to include c.callback in the cache key for
                // maybeBroadcastWatch calls. See issue #5733.
                u.callback,
                N6({ optimistic: f, id: d, variables: g })
              );
            }
          }
        }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(u) {
          return u.resetCaching();
        });
      }, t.prototype.restore = function(r) {
        return this.init(), r && this.data.replace(r), this;
      }, t.prototype.extract = function(r) {
        return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
      }, t.prototype.read = function(r) {
        var n = r.returnPartialData, i = n === void 0 ? !1 : n;
        try {
          return this.storeReader.diffQueryAgainstStore(C2(C2({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: i })).result || null;
        } catch (o) {
          if (o instanceof Oz)
            return null;
          throw o;
        }
      }, t.prototype.write = function(r) {
        try {
          return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.modify = function(r) {
        if (P5.call(r, "id") && !r.id)
          return !1;
        var n = r.optimistic ? this.optimisticData : this.data;
        try {
          return ++this.txCount, n.modify(r.id || "ROOT_QUERY", r.fields);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.diff = function(r) {
        return this.storeReader.diffQueryAgainstStore(C2(C2({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
      }, t.prototype.watch = function(r) {
        var n = this;
        return this.watches.size || sr2(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
          n.watches.delete(r) && !n.watches.size && VL(n), n.maybeBroadcastWatch.forget(r);
        };
      }, t.prototype.gc = function(r) {
        var n;
        N6.reset(), Si.reset(), this.addTypenameTransform.resetCache(), (n = this.config.fragments) === null || n === void 0 || n.resetCaches();
        var i = this.optimisticData.gc();
        return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), i;
      }, t.prototype.retain = function(r, n) {
        return (n ? this.optimisticData : this.data).retain(r);
      }, t.prototype.release = function(r, n) {
        return (n ? this.optimisticData : this.data).release(r);
      }, t.prototype.identify = function(r) {
        if (Ye(r))
          return r.__ref;
        try {
          return this.policies.identify(r)[0];
        } catch (n) {
          globalThis.__DEV__ !== !1 && u0.warn(n);
        }
      }, t.prototype.evict = function(r) {
        if (!r.id) {
          if (P5.call(r, "id"))
            return !1;
          r = C2(C2({}, r), { id: "ROOT_QUERY" });
        }
        try {
          return ++this.txCount, this.optimisticData.evict(r, this.data);
        } finally {
          !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
        }
      }, t.prototype.reset = function(r) {
        var n = this;
        return this.init(), N6.reset(), r && r.discardWatches ? (this.watches.forEach(function(i) {
          return n.maybeBroadcastWatch.forget(i);
        }), this.watches.clear(), VL(this)) : this.broadcastWatches(), Promise.resolve();
      }, t.prototype.removeOptimistic = function(r) {
        var n = this.optimisticData.removeLayer(r);
        n !== this.optimisticData && (this.optimisticData = n, this.broadcastWatches());
      }, t.prototype.batch = function(r) {
        var n = this, i = r.update, o = r.optimistic, u = o === void 0 ? !0 : o, c = r.removeOptimistic, f = r.onWatchUpdated, d, g = function(E) {
          var y = n, I = y.data, Q = y.optimisticData;
          ++n.txCount, E && (n.data = n.optimisticData = E);
          try {
            return d = i(n);
          } finally {
            --n.txCount, n.data = I, n.optimisticData = Q;
          }
        }, h = /* @__PURE__ */ new Set();
        return f && !this.txCount && this.broadcastWatches(C2(C2({}, r), { onWatchUpdated: function(E) {
          return h.add(E), !1;
        } })), typeof u == "string" ? this.optimisticData = this.optimisticData.addLayer(u, g) : u === !1 ? g(this.data) : g(), typeof c == "string" && (this.optimisticData = this.optimisticData.removeLayer(c)), f && h.size ? (this.broadcastWatches(C2(C2({}, r), { onWatchUpdated: function(E, y) {
          var I = f.call(this, E, y);
          return I !== !1 && h.delete(E), I;
        } })), h.size && h.forEach(function(E) {
          return n.maybeBroadcastWatch.dirty(E);
        })) : this.broadcastWatches(r), d;
      }, t.prototype.performTransaction = function(r, n) {
        return this.batch({
          update: r,
          optimistic: n || n !== null
        });
      }, t.prototype.transformDocument = function(r) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(r));
      }, t.prototype.fragmentMatches = function(r, n) {
        return this.policies.fragmentMatches(r, n);
      }, t.prototype.lookupFragment = function(r) {
        var n;
        return ((n = this.config.fragments) === null || n === void 0 ? void 0 : n.lookup(r)) || null;
      }, t.prototype.broadcastWatches = function(r) {
        var n = this;
        this.txCount || this.watches.forEach(function(i) {
          return n.maybeBroadcastWatch(i, r);
        });
      }, t.prototype.addFragmentsToDocument = function(r) {
        var n = this.config.fragments;
        return n ? n.transform(r) : r;
      }, t.prototype.addTypenameToDocument = function(r) {
        return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
      }, t.prototype.broadcastWatch = function(r, n) {
        var i = r.lastDiff, o = this.diff(r);
        n && (r.optimistic && typeof n.optimistic == "string" && (o.fromOptimisticTransaction = !0), n.onWatchUpdated && n.onWatchUpdated.call(this, r, o, i) === !1) || (!i || !et(i.result, o.result)) && r.callback(r.lastDiff = o, i);
      }, t;
    }(_z)
  );
  globalThis.__DEV__ !== !1 && (Zz.prototype.getMemoryInternals = C52);
  var de;
  (function(e) {
    e[e.loading = 1] = "loading", e[e.setVariables = 2] = "setVariables", e[e.fetchMore = 3] = "fetchMore", e[e.refetch = 4] = "refetch", e[e.poll = 6] = "poll", e[e.ready = 7] = "ready", e[e.error = 8] = "error";
  })(de || (de = {}));
  function o9(e) {
    return e ? e < 7 : !1;
  }
  var JL = Object.assign, dr2 = Object.hasOwnProperty, tc = (
    /** @class */
    function(e) {
      g3(t, e);
      function t(r) {
        var n = r.queryManager, i = r.queryInfo, o = r.options, u = this, c = t.inactiveOnCreation.getValue();
        u = e.call(this, function(_) {
          c && (n.queries.set(u.queryId, i), c = !1);
          try {
            var M = _._subscription._observer;
            M && !M.error && (M.error = gr2);
          } catch {
          }
          var S = !u.observers.size;
          u.observers.add(_);
          var O = u.last;
          return O && O.error ? _.error && _.error(O.error) : O && O.result && _.next && _.next(u.maskResult(O.result)), S && u.reobserve().catch(function() {
          }), function() {
            u.observers.delete(_) && !u.observers.size && u.tearDownQuery();
          };
        }) || this, u.observers = /* @__PURE__ */ new Set(), u.subscriptions = /* @__PURE__ */ new Set(), u.dirty = !1, u.queryInfo = i, u.queryManager = n, u.waitForOwnResult = wy(o.fetchPolicy), u.isTornDown = !1, u.subscribeToMore = u.subscribeToMore.bind(u), u.maskResult = u.maskResult.bind(u);
        var f = n.defaultOptions.watchQuery, d = f === void 0 ? {} : f, g = d.fetchPolicy, h = g === void 0 ? "cache-first" : g, E = o.fetchPolicy, y = E === void 0 ? h : E, I = o.initialFetchPolicy, Q = I === void 0 ? y === "standby" ? h : y : I;
        u.options = C2(C2({}, o), {
          // Remember the initial options.fetchPolicy so we can revert back to this
          // policy when variables change. This information can also be specified
          // (or overridden) by providing options.initialFetchPolicy explicitly.
          initialFetchPolicy: Q,
          // This ensures this.options.fetchPolicy always has a string value, in
          // case options.fetchPolicy was not provided.
          fetchPolicy: y
        }), u.queryId = i.queryId || n.generateQueryId();
        var B = Fi(u.query);
        return u.queryName = B && B.name && B.name.value, u;
      }
      return Object.defineProperty(t.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
          return this.lastQuery || this.options.query;
        },
        enumerable: !1,
        configurable: !0
      }), Object.defineProperty(t.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */
        get: function() {
          return this.options.variables;
        },
        enumerable: !1,
        configurable: !0
      }), t.prototype.result = function() {
        var r = this;
        return new Promise(function(n, i) {
          var o = {
            next: function(c) {
              n(c), r.observers.delete(o), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
                u.unsubscribe();
              }, 0);
            },
            error: i
          }, u = r.subscribe(o);
        });
      }, t.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
      }, t.prototype.getCurrentFullResult = function(r) {
        r === void 0 && (r = !0);
        var n = this.getLastResult(!0), i = this.queryInfo.networkStatus || n && n.networkStatus || de.ready, o = C2(C2({}, n), { loading: o9(i), networkStatus: i }), u = this.options.fetchPolicy, c = u === void 0 ? "cache-first" : u;
        if (
          // These fetch policies should never deliver data from the cache, unless
          // redelivering a previously delivered result.
          !(wy(c) || // If this.options.query has @client(always: true) fields, we cannot
          // trust diff.result, since it was read from the cache without running
          // local resolvers (and it's too late to run resolvers now, since we must
          // return a result synchronously).
          this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
        ) if (this.waitForOwnResult)
          this.queryInfo.updateWatch();
        else {
          var f = this.queryInfo.getDiff();
          (f.complete || this.options.returnPartialData) && (o.data = f.result), et(o.data, {}) && (o.data = void 0), f.complete ? (delete o.partial, f.complete && o.networkStatus === de.loading && (c === "cache-first" || c === "cache-only") && (o.networkStatus = de.ready, o.loading = !1)) : o.partial = !0, o.networkStatus === de.ready && (o.error || o.errors) && (o.networkStatus = de.error), globalThis.__DEV__ !== !1 && !f.complete && !this.options.partialRefetch && !o.loading && !o.data && !o.error && zz(f.missing);
        }
        return r && this.updateLastResult(o), o;
      }, t.prototype.getCurrentResult = function(r) {
        return r === void 0 && (r = !0), this.maskResult(this.getCurrentFullResult(r));
      }, t.prototype.isDifferentFromLastResult = function(r, n) {
        if (!this.last)
          return !0;
        var i = this.queryManager.getDocumentInfo(this.query), o = this.queryManager.dataMasking, u = o ? i.nonReactiveQuery : this.query, c = o || i.hasNonreactiveDirective ? !Qz(u, this.last.result, r, this.variables) : !et(this.last.result, r);
        return c || n && !et(this.last.variables, n);
      }, t.prototype.getLast = function(r, n) {
        var i = this.last;
        if (i && i[r] && (!n || et(i.variables, this.variables)))
          return i[r];
      }, t.prototype.getLastResult = function(r) {
        return this.getLast("result", r);
      }, t.prototype.getLastError = function(r) {
        return this.getLast("error", r);
      }, t.prototype.resetLastResults = function() {
        delete this.last, this.isTornDown = !1;
      }, t.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
      }, t.prototype.refetch = function(r) {
        var n, i = {
          // Always disable polling for refetches.
          pollInterval: 0
        }, o = this.options.fetchPolicy;
        if (o === "no-cache" ? i.fetchPolicy = "no-cache" : i.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && dr2.call(r, "variables")) {
          var u = KZ(this.query), c = u.variableDefinitions;
          (!c || !c.some(function(f) {
            return f.variable.name.value === "variables";
          })) && globalThis.__DEV__ !== !1 && u0.warn(
            21,
            r,
            ((n = u.name) === null || n === void 0 ? void 0 : n.value) || u
          );
        }
        return r && !et(this.options.variables, r) && (i.variables = this.options.variables = C2(C2({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(i, de.refetch);
      }, t.prototype.fetchMore = function(r) {
        var n = this, i = C2(C2({}, r.query ? r : C2(C2(C2(C2({}, this.options), { query: this.options.query }), r), { variables: C2(C2({}, this.options.variables), r.variables) })), {
          // The fetchMore request goes immediately to the network and does
          // not automatically write its result to the cache (hence no-cache
          // instead of network-only), because we allow the caller of
          // fetchMore to provide an updateQuery callback that determines how
          // the data gets written to the cache.
          fetchPolicy: "no-cache"
        });
        i.query = this.transformDocument(i.query);
        var o = this.queryManager.generateQueryId();
        this.lastQuery = r.query ? this.transformDocument(this.options.query) : i.query;
        var u = this.queryInfo, c = u.networkStatus;
        u.networkStatus = de.fetchMore, i.notifyOnNetworkStatusChange && this.observe();
        var f = /* @__PURE__ */ new Set(), d = r == null ? void 0 : r.updateQuery, g = this.options.fetchPolicy !== "no-cache";
        return g || u0(d, 22), this.queryManager.fetchQuery(o, i, de.fetchMore).then(function(h) {
          if (n.queryManager.removeQuery(o), u.networkStatus === de.fetchMore && (u.networkStatus = c), g)
            n.queryManager.cache.batch({
              update: function(I) {
                var Q = r.updateQuery;
                Q ? I.updateQuery({
                  query: n.query,
                  variables: n.variables,
                  returnPartialData: !0,
                  optimistic: !1
                }, function(B) {
                  return Q(B, {
                    fetchMoreResult: h.data,
                    variables: i.variables
                  });
                }) : I.writeQuery({
                  query: i.query,
                  variables: i.variables,
                  data: h.data
                });
              },
              onWatchUpdated: function(I) {
                f.add(I.query);
              }
            });
          else {
            var E = n.getLast("result"), y = d(E.data, {
              fetchMoreResult: h.data,
              variables: i.variables
            });
            n.reportResult(C2(C2({}, E), { networkStatus: c, loading: o9(c), data: y }), n.variables);
          }
          return n.maskResult(h);
        }).finally(function() {
          g && !f.has(n.query) && n.reobserveCacheFirst();
        });
      }, t.prototype.subscribeToMore = function(r) {
        var n = this, i = this.queryManager.startGraphQLSubscription({
          query: r.document,
          variables: r.variables,
          context: r.context
        }).subscribe({
          next: function(o) {
            var u = r.updateQuery;
            u && n.updateQuery(function(c, f) {
              return u(c, C2({ subscriptionData: o }, f));
            });
          },
          error: function(o) {
            if (r.onError) {
              r.onError(o);
              return;
            }
            globalThis.__DEV__ !== !1 && u0.error(23, o);
          }
        });
        return this.subscriptions.add(i), function() {
          n.subscriptions.delete(i) && i.unsubscribe();
        };
      }, t.prototype.setOptions = function(r) {
        return this.reobserve(r);
      }, t.prototype.silentSetOptions = function(r) {
        var n = Ni(this.options, r || {});
        JL(this.options, n);
      }, t.prototype.setVariables = function(r) {
        return et(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
          // Reset options.fetchPolicy to its original value.
          fetchPolicy: this.options.initialFetchPolicy,
          variables: r
        }, de.setVariables) : Promise.resolve());
      }, t.prototype.updateQuery = function(r) {
        var n = this.queryManager, i = n.cache.diff({
          query: this.options.query,
          variables: this.variables,
          returnPartialData: !0,
          optimistic: !1
        }), o = i.result, u = i.complete, c = r(o, {
          variables: this.variables,
          complete: !!u,
          previousData: o
        });
        c && (n.cache.writeQuery({
          query: this.options.query,
          data: c,
          variables: this.variables
        }), n.broadcastQueries());
      }, t.prototype.startPolling = function(r) {
        this.options.pollInterval = r, this.updatePolling();
      }, t.prototype.stopPolling = function() {
        this.options.pollInterval = 0, this.updatePolling();
      }, t.prototype.applyNextFetchPolicy = function(r, n) {
        if (n.nextFetchPolicy) {
          var i = n.fetchPolicy, o = i === void 0 ? "cache-first" : i, u = n.initialFetchPolicy, c = u === void 0 ? o : u;
          o === "standby" || (typeof n.nextFetchPolicy == "function" ? n.fetchPolicy = n.nextFetchPolicy(o, {
            reason: r,
            options: n,
            observable: this,
            initialFetchPolicy: c
          }) : r === "variables-changed" ? n.fetchPolicy = c : n.fetchPolicy = n.nextFetchPolicy);
        }
        return n.fetchPolicy;
      }, t.prototype.fetch = function(r, n, i) {
        var o = this.queryManager.getOrCreateQuery(this.queryId);
        return o.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(o, r, n, i);
      }, t.prototype.updatePolling = function() {
        var r = this;
        if (!this.queryManager.ssrMode) {
          var n = this, i = n.pollingInfo, o = n.options.pollInterval;
          if (!o || !this.hasObservers()) {
            i && (clearTimeout(i.timeout), delete this.pollingInfo);
            return;
          }
          if (!(i && i.interval === o)) {
            u0(o, 24);
            var u = i || (this.pollingInfo = {});
            u.interval = o;
            var c = function() {
              var d, g;
              r.pollingInfo && (!o9(r.queryInfo.networkStatus) && !(!((g = (d = r.options).skipPollAttempt) === null || g === void 0) && g.call(d)) ? r.reobserve({
                // Most fetchPolicy options don't make sense to use in a polling context, as
                // users wouldn't want to be polling the cache directly. However, network-only and
                // no-cache are both useful for when the user wants to control whether or not the
                // polled results are written to the cache.
                fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
              }, de.poll).then(f, f) : f());
            }, f = function() {
              var d = r.pollingInfo;
              d && (clearTimeout(d.timeout), d.timeout = setTimeout(c, d.interval));
            };
            f();
          }
        }
      }, t.prototype.updateLastResult = function(r, n) {
        n === void 0 && (n = this.variables);
        var i = this.getLastError();
        return i && this.last && !et(n, this.last.variables) && (i = void 0), this.last = C2({ result: this.queryManager.assumeImmutableResults ? r : hz(r), variables: n }, i ? { error: i } : null);
      }, t.prototype.reobserveAsConcast = function(r, n) {
        var i = this;
        this.isTornDown = !1;
        var o = (
          // Refetching uses a disposable Concast to allow refetches using different
          // options/variables, without permanently altering the options of the
          // original ObservableQuery.
          n === de.refetch || // The fetchMore method does not actually call the reobserve method, but,
          // if it did, it would definitely use a disposable Concast.
          n === de.fetchMore || // Polling uses a disposable Concast so the polling options (which force
          // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
          n === de.poll
        ), u = this.options.variables, c = this.options.fetchPolicy, f = Ni(this.options, r || {}), d = o ? (
          // Disposable Concast fetches receive a shallow copy of this.options
          // (merged with newOptions), leaving this.options unmodified.
          f
        ) : JL(this.options, f), g = this.transformDocument(d.query);
        this.lastQuery = g, o || (this.updatePolling(), r && r.variables && !et(r.variables, u) && // Don't mess with the fetchPolicy if it's currently "standby".
        d.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
        // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
        (d.fetchPolicy === c || // A `nextFetchPolicy` function has even higher priority, though,
        // so in that case `applyNextFetchPolicy` must be called.
        typeof d.nextFetchPolicy == "function") && (this.applyNextFetchPolicy("variables-changed", d), n === void 0 && (n = de.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = wy(d.fetchPolicy));
        var h = function() {
          i.concast === I && (i.waitForOwnResult = !1);
        }, E = d.variables && C2({}, d.variables), y = this.fetch(d, n, g), I = y.concast, Q = y.fromLink, B = {
          next: function(_) {
            et(i.variables, E) && (h(), i.reportResult(_, E));
          },
          error: function(_) {
            et(i.variables, E) && (yz(_) || (_ = new f8({ networkError: _ })), h(), i.reportError(_, E));
          }
        };
        return !o && (Q || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = I, this.observer = B), I.addObserver(B), I;
      }, t.prototype.reobserve = function(r, n) {
        return o12(this.reobserveAsConcast(r, n).promise.then(this.maskResult));
      }, t.prototype.resubscribeAfterError = function() {
        for (var r = [], n = 0; n < arguments.length; n++)
          r[n] = arguments[n];
        var i = this.last;
        this.resetLastResults();
        var o = this.subscribe.apply(this, r);
        return this.last = i, o;
      }, t.prototype.observe = function() {
        this.reportResult(
          // Passing false is important so that this.getCurrentResult doesn't
          // save the fetchMore result as this.lastResult, causing it to be
          // ignored due to the this.isDifferentFromLastResult check in
          // this.reportResult.
          this.getCurrentFullResult(!1),
          this.variables
        );
      }, t.prototype.reportResult = function(r, n) {
        var i = this.getLastError(), o = this.isDifferentFromLastResult(r, n);
        (i || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, n), (i || o) && Xl(this.observers, "next", this.maskResult(r));
      }, t.prototype.reportError = function(r, n) {
        var i = C2(C2({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: de.error, loading: !1 });
        this.updateLastResult(i, n), Xl(this.observers, "error", this.last.error = r);
      }, t.prototype.hasObservers = function() {
        return this.observers.size > 0;
      }, t.prototype.tearDownQuery = function() {
        this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
          return r.unsubscribe();
        }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
      }, t.prototype.transformDocument = function(r) {
        return this.queryManager.transform(r);
      }, t.prototype.maskResult = function(r) {
        return r && "data" in r ? C2(C2({}, r), { data: this.queryManager.maskOperation({
          document: this.query,
          data: r.data,
          fetchPolicy: this.options.fetchPolicy,
          id: this.queryId
        }) }) : r;
      }, t.prototype.resetNotifications = function() {
        this.cancelNotifyTimeout(), this.dirty = !1;
      }, t.prototype.cancelNotifyTimeout = function() {
        this.notifyTimeout && (clearTimeout(this.notifyTimeout), this.notifyTimeout = void 0);
      }, t.prototype.scheduleNotify = function() {
        var r = this;
        this.dirty || (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
          return r.notify();
        }, 0)));
      }, t.prototype.notify = function() {
        if (this.cancelNotifyTimeout(), this.dirty && (this.options.fetchPolicy == "cache-only" || this.options.fetchPolicy == "cache-and-network" || !o9(this.queryInfo.networkStatus))) {
          var r = this.queryInfo.getDiff();
          r.fromOptimisticTransaction ? this.observe() : this.reobserveCacheFirst();
        }
        this.dirty = !1;
      }, t.prototype.reobserveCacheFirst = function() {
        var r = this.options, n = r.fetchPolicy, i = r.nextFetchPolicy;
        return n === "cache-and-network" || n === "network-only" ? this.reobserve({
          fetchPolicy: "cache-first",
          // Use a temporary nextFetchPolicy function that replaces itself with the
          // previous nextFetchPolicy value and returns the original fetchPolicy.
          nextFetchPolicy: function(o, u) {
            return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(o, u) : n;
          }
        }) : this.reobserve();
      }, t.inactiveOnCreation = new eA(), t;
    }(At)
  );
  vz(tc);
  function gr2(e) {
    globalThis.__DEV__ !== !1 && u0.error(25, e.message, e.stack);
  }
  function zz(e) {
    globalThis.__DEV__ !== !1 && e && globalThis.__DEV__ !== !1 && u0.debug(26, e);
  }
  function wy(e) {
    return e === "network-only" || e === "no-cache" || e === "standby";
  }
  var s9 = new (qi ? WeakMap : Map)();
  function Sy(e, t) {
    var r = e[t];
    typeof r == "function" && (e[t] = function() {
      return s9.set(
        e,
        // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        (s9.get(e) + 1) % 1e15
      ), r.apply(this, arguments);
    });
  }
  var My = (
    /** @class */
    function() {
      function e(t, r) {
        r === void 0 && (r = t.generateQueryId()), this.queryId = r, this.document = null, this.lastRequestId = 1, this.stopped = !1, this.observableQuery = null;
        var n = this.cache = t.cache;
        s9.has(n) || (s9.set(n, 0), Sy(n, "evict"), Sy(n, "modify"), Sy(n, "reset"));
      }
      return e.prototype.init = function(t) {
        var r = t.networkStatus || de.loading;
        return this.variables && this.networkStatus !== de.loading && !et(this.variables, t.variables) && (r = de.setVariables), et(t.variables, this.variables) || (this.lastDiff = void 0, this.cancel()), Object.assign(this, {
          document: t.document,
          variables: t.variables,
          networkError: null,
          graphQLErrors: this.graphQLErrors || [],
          networkStatus: r
        }), t.observableQuery && this.setObservableQuery(t.observableQuery), t.lastRequestId && (this.lastRequestId = t.lastRequestId), this;
      }, e.prototype.resetDiff = function() {
        this.lastDiff = void 0;
      }, e.prototype.getDiff = function() {
        var t = this.getDiffOptions();
        if (this.lastDiff && et(t, this.lastDiff.options))
          return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var r = this.observableQuery;
        if (r && r.options.fetchPolicy === "no-cache")
          return { complete: !1 };
        var n = this.cache.diff(t);
        return this.updateLastDiff(n, t), n;
      }, e.prototype.updateLastDiff = function(t, r) {
        this.lastDiff = t ? {
          diff: t,
          options: r || this.getDiffOptions()
        } : void 0;
      }, e.prototype.getDiffOptions = function(t) {
        var r;
        return t === void 0 && (t = this.variables), {
          query: this.document,
          variables: t,
          returnPartialData: !0,
          optimistic: !0,
          canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
        };
      }, e.prototype.setDiff = function(t) {
        var r, n, i = this.lastDiff && this.lastDiff.diff;
        t && !t.complete && (!((r = this.observableQuery) === null || r === void 0) && r.getLastError()) || (this.updateLastDiff(t), et(i && i.result, t && t.result) || (n = this.observableQuery) === null || n === void 0 || n.scheduleNotify());
      }, e.prototype.setObservableQuery = function(t) {
        t !== this.observableQuery && (this.observableQuery = t, t && (t.queryInfo = this));
      }, e.prototype.stop = function() {
        var t;
        if (!this.stopped) {
          this.stopped = !0, (t = this.observableQuery) === null || t === void 0 || t.resetNotifications(), this.cancel();
          var r = this.observableQuery;
          r && r.stopPolling();
        }
      }, e.prototype.cancel = function() {
        var t;
        (t = this.cancelWatch) === null || t === void 0 || t.call(this), this.cancelWatch = void 0;
      }, e.prototype.updateWatch = function(t) {
        var r = this;
        t === void 0 && (t = this.variables);
        var n = this.observableQuery;
        if (!(n && n.options.fetchPolicy === "no-cache")) {
          var i = C2(C2({}, this.getDiffOptions(t)), { watcher: this, callback: function(o) {
            return r.setDiff(o);
          } });
          (!this.lastWatch || !et(i, this.lastWatch)) && (this.cancel(), this.cancelWatch = this.cache.watch(this.lastWatch = i));
        }
      }, e.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
      }, e.prototype.shouldWrite = function(t, r) {
        var n = this.lastWrite;
        return !(n && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        n.dmCount === s9.get(this.cache) && et(r, n.variables) && et(t.data, n.result.data));
      }, e.prototype.markResult = function(t, r, n, i) {
        var o = this, u, c = new z6(), f = M4(t.errors) ? t.errors.slice(0) : [];
        if ((u = this.observableQuery) === null || u === void 0 || u.resetNotifications(), "incremental" in t && M4(t.incremental)) {
          var d = Ez(this.getDiff().result, t);
          t.data = d;
        } else if ("hasNext" in t && t.hasNext) {
          var g = this.getDiff();
          t.data = c.merge(g.result, t.data);
        }
        this.graphQLErrors = f, n.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: t.data, complete: !0 }, this.getDiffOptions(n.variables)) : i !== 0 && (hb(t, n.errorPolicy) ? this.cache.performTransaction(function(h) {
          if (o.shouldWrite(t, n.variables))
            h.writeQuery({
              query: r,
              data: t.data,
              variables: n.variables,
              overwrite: i === 1
            }), o.lastWrite = {
              result: t,
              variables: n.variables,
              dmCount: s9.get(o.cache)
            };
          else if (o.lastDiff && o.lastDiff.diff.complete) {
            t.data = o.lastDiff.diff.result;
            return;
          }
          var E = o.getDiffOptions(n.variables), y = h.diff(E);
          !o.stopped && et(o.variables, n.variables) && o.updateWatch(n.variables), o.updateLastDiff(y, E), y.complete && (t.data = y.result);
        }) : this.lastWrite = void 0);
      }, e.prototype.markReady = function() {
        return this.networkError = null, this.networkStatus = de.ready;
      }, e.prototype.markError = function(t) {
        var r;
        return this.networkStatus = de.error, this.lastWrite = void 0, (r = this.observableQuery) === null || r === void 0 || r.resetNotifications(), t.graphQLErrors && (this.graphQLErrors = t.graphQLErrors), t.networkError && (this.networkError = t.networkError), t;
      }, e;
    }()
  );
  function hb(e, t) {
    t === void 0 && (t = "none");
    var r = t === "ignore" || t === "all", n = !qd(e);
    return !n && r && e.data && (n = !0), n;
  }
  var pr2 = Object.prototype.hasOwnProperty, ek = /* @__PURE__ */ Object.create(null), hr2 = (
    /** @class */
    function() {
      function e(t) {
        var r = this;
        this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new uS(
          f3["queryManager.getDocumentInfo"] || 2e3
          /* defaultCacheSizes["queryManager.getDocumentInfo"] */
        ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new S8(!1), this.noCacheWarningsByQueryId = /* @__PURE__ */ new Set();
        var n = new cz(
          function(o) {
            return r.cache.transformDocument(o);
          },
          // Allow the apollo cache to manage its own transform caches
          { cache: !1 }
        );
        this.cache = t.cache, this.link = t.link, this.defaultOptions = t.defaultOptions, this.queryDeduplication = t.queryDeduplication, this.clientAwareness = t.clientAwareness, this.localState = t.localState, this.ssrMode = t.ssrMode, this.assumeImmutableResults = t.assumeImmutableResults, this.dataMasking = t.dataMasking;
        var i = t.documentTransform;
        this.documentTransform = i ? n.concat(i).concat(n) : n, this.defaultContext = t.defaultContext || /* @__PURE__ */ Object.create(null), (this.onBroadcast = t.onBroadcast) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
      }
      return e.prototype.stop = function() {
        var t = this;
        this.queries.forEach(function(r, n) {
          t.stopQueryNoBroadcast(n);
        }), this.cancelPendingFetches(G1(27));
      }, e.prototype.cancelPendingFetches = function(t) {
        this.fetchCancelFns.forEach(function(r) {
          return r(t);
        }), this.fetchCancelFns.clear();
      }, e.prototype.mutate = function(t) {
        return D6(this, arguments, void 0, function(r) {
          var n, i, o, u, c, f, d, g = r.mutation, h = r.variables, E = r.optimisticResponse, y = r.updateQueries, I = r.refetchQueries, Q = I === void 0 ? [] : I, B = r.awaitRefetchQueries, _ = B === void 0 ? !1 : B, M = r.update, S = r.onQueryUpdated, O = r.fetchPolicy, w = O === void 0 ? ((f = this.defaultOptions.mutate) === null || f === void 0 ? void 0 : f.fetchPolicy) || "network-only" : O, D = r.errorPolicy, k = D === void 0 ? ((d = this.defaultOptions.mutate) === null || d === void 0 ? void 0 : d.errorPolicy) || "none" : D, F = r.keepRootFields, z = r.context;
          return L6(this, function(Z) {
            switch (Z.label) {
              case 0:
                return u0(g, 28), u0(w === "network-only" || w === "no-cache", 29), n = this.generateMutationId(), g = this.cache.transformForLink(this.transform(g)), i = this.getDocumentInfo(g).hasClientExports, h = this.getVariables(g, h), i ? [4, this.localState.addExportedVariables(g, h, z)] : [3, 2];
              case 1:
                h = Z.sent(), Z.label = 2;
              case 2:
                return o = this.mutationStore && (this.mutationStore[n] = {
                  mutation: g,
                  variables: h,
                  loading: !0,
                  error: null
                }), u = E && this.markMutationOptimistic(E, {
                  mutationId: n,
                  document: g,
                  variables: h,
                  fetchPolicy: w,
                  errorPolicy: k,
                  context: z,
                  updateQueries: y,
                  update: M,
                  keepRootFields: F
                }), this.broadcastQueries(), c = this, [2, new Promise(function(V, $) {
                  return Iy(c.getObservableFromLink(g, C2(C2({}, z), { optimisticResponse: u ? E : void 0 }), h, {}, !1), function(W) {
                    if (qd(W) && k === "none")
                      throw new f8({
                        graphQLErrors: lb(W)
                      });
                    o && (o.loading = !1, o.error = null);
                    var t2 = C2({}, W);
                    return typeof Q == "function" && (Q = Q(t2)), k === "ignore" && qd(t2) && delete t2.errors, c.markMutationResult({
                      mutationId: n,
                      result: t2,
                      document: g,
                      variables: h,
                      fetchPolicy: w,
                      errorPolicy: k,
                      context: z,
                      update: M,
                      updateQueries: y,
                      awaitRefetchQueries: _,
                      refetchQueries: Q,
                      removeOptimistic: u ? n : void 0,
                      onQueryUpdated: S,
                      keepRootFields: F
                    });
                  }).subscribe({
                    next: function(W) {
                      c.broadcastQueries(), (!("hasNext" in W) || W.hasNext === !1) && V(C2(C2({}, W), { data: c.maskOperation({
                        document: g,
                        data: W.data,
                        fetchPolicy: w,
                        id: n
                      }) }));
                    },
                    error: function(W) {
                      o && (o.loading = !1, o.error = W), u && c.cache.removeOptimistic(n), c.broadcastQueries(), $(W instanceof f8 ? W : new f8({
                        networkError: W
                      }));
                    }
                  });
                })];
            }
          });
        });
      }, e.prototype.markMutationResult = function(t, r) {
        var n = this;
        r === void 0 && (r = this.cache);
        var i = t.result, o = [], u = t.fetchPolicy === "no-cache";
        if (!u && hb(i, t.errorPolicy)) {
          if (f9(i) || o.push({
            result: i.data,
            dataId: "ROOT_MUTATION",
            query: t.document,
            variables: t.variables
          }), f9(i) && M4(i.incremental)) {
            var c = r.diff({
              id: "ROOT_MUTATION",
              // The cache complains if passed a mutation where it expects a
              // query, so we transform mutations and subscriptions to queries
              // (only once, thanks to this.transformCache).
              query: this.getDocumentInfo(t.document).asQuery,
              variables: t.variables,
              optimistic: !1,
              returnPartialData: !0
            }), f = void 0;
            c.result && (f = Ez(c.result, i)), typeof f < "u" && (i.data = f, o.push({
              result: f,
              dataId: "ROOT_MUTATION",
              query: t.document,
              variables: t.variables
            }));
          }
          var d = t.updateQueries;
          d && this.queries.forEach(function(h, E) {
            var y = h.observableQuery, I = y && y.queryName;
            if (!(!I || !pr2.call(d, I))) {
              var Q = d[I], B = n.queries.get(E), _ = B.document, M = B.variables, S = r.diff({
                query: _,
                variables: M,
                returnPartialData: !0,
                optimistic: !1
              }), O = S.result, w = S.complete;
              if (w && O) {
                var D = Q(O, {
                  mutationResult: i,
                  queryName: _ && Ul(_) || void 0,
                  queryVariables: M
                });
                D && o.push({
                  result: D,
                  dataId: "ROOT_QUERY",
                  query: _,
                  variables: M
                });
              }
            }
          });
        }
        if (o.length > 0 || (t.refetchQueries || "").length > 0 || t.update || t.onQueryUpdated || t.removeOptimistic) {
          var g = [];
          if (this.refetchQueries({
            updateCache: function(h) {
              u || o.forEach(function(Q) {
                return h.write(Q);
              });
              var E = t.update, y = !A12(i) || f9(i) && !i.hasNext;
              if (E) {
                if (!u) {
                  var I = h.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: n.getDocumentInfo(t.document).asQuery,
                    variables: t.variables,
                    optimistic: !1,
                    returnPartialData: !0
                  });
                  I.complete && (i = C2(C2({}, i), { data: I.result }), "incremental" in i && delete i.incremental, "hasNext" in i && delete i.hasNext);
                }
                y && E(h, i, {
                  context: t.context,
                  variables: t.variables
                });
              }
              !u && !t.keepRootFields && y && h.modify({
                id: "ROOT_MUTATION",
                fields: function(Q, B) {
                  var _ = B.fieldName, M = B.DELETE;
                  return _ === "__typename" ? Q : M;
                }
              });
            },
            include: t.refetchQueries,
            // Write the final mutation.result to the root layer of the cache.
            optimistic: !1,
            // Remove the corresponding optimistic layer at the same time as we
            // write the final non-optimistic result.
            removeOptimistic: t.removeOptimistic,
            // Let the caller of client.mutate optionally determine the refetching
            // behavior for watched queries after the mutation.update function runs.
            // If no onQueryUpdated function was provided for this mutation, pass
            // null instead of undefined to disable the default refetching behavior.
            onQueryUpdated: t.onQueryUpdated || null
          }).forEach(function(h) {
            return g.push(h);
          }), t.awaitRefetchQueries || t.onQueryUpdated)
            return Promise.all(g).then(function() {
              return i;
            });
        }
        return Promise.resolve(i);
      }, e.prototype.markMutationOptimistic = function(t, r) {
        var n = this, i = typeof t == "function" ? t(r.variables, { IGNORE: ek }) : t;
        return i === ek ? !1 : (this.cache.recordOptimisticTransaction(function(o) {
          try {
            n.markMutationResult(C2(C2({}, r), { result: { data: i } }), o);
          } catch (u) {
            globalThis.__DEV__ !== !1 && u0.error(u);
          }
        }, r.mutationId), !0);
      }, e.prototype.fetchQuery = function(t, r, n) {
        return this.fetchConcastWithInfo(this.getOrCreateQuery(t), r, n).concast.promise;
      }, e.prototype.getQueryStore = function() {
        var t = /* @__PURE__ */ Object.create(null);
        return this.queries.forEach(function(r, n) {
          t[n] = {
            variables: r.variables,
            networkStatus: r.networkStatus,
            networkError: r.networkError,
            graphQLErrors: r.graphQLErrors
          };
        }), t;
      }, e.prototype.resetErrors = function(t) {
        var r = this.queries.get(t);
        r && (r.networkError = void 0, r.graphQLErrors = []);
      }, e.prototype.transform = function(t) {
        return this.documentTransform.transformDocument(t);
      }, e.prototype.getDocumentInfo = function(t) {
        var r = this.transformCache;
        if (!r.has(t)) {
          var n = {
            // TODO These three calls (hasClientExports, shouldForceResolvers, and
            // usesNonreactiveDirective) are performing independent full traversals
            // of the transformed document. We should consider merging these
            // traversals into a single pass in the future, though the work is
            // cached after the first time.
            hasClientExports: qt2(t),
            hasForcedResolvers: this.localState.shouldForceResolvers(t),
            hasNonreactiveDirective: lc(["nonreactive"], t),
            nonReactiveQuery: $52(t),
            clientQuery: this.localState.clientQuery(t),
            serverQuery: fz([
              { name: "client", remove: !0 },
              { name: "connection" },
              { name: "nonreactive" },
              { name: "unmask" }
            ], t),
            defaultVars: cS(Fi(t)),
            // Transform any mutation or subscription operations to query operations
            // so we can read/write them from/to the cache.
            asQuery: C2(C2({}, t), { definitions: t.definitions.map(function(i) {
              return i.kind === "OperationDefinition" && i.operation !== "query" ? C2(C2({}, i), { operation: "query" }) : i;
            }) })
          };
          r.set(t, n);
        }
        return r.get(t);
      }, e.prototype.getVariables = function(t, r) {
        return C2(C2({}, this.getDocumentInfo(t).defaultVars), r);
      }, e.prototype.watchQuery = function(t) {
        var r = this.transform(t.query);
        t = C2(C2({}, t), { variables: this.getVariables(r, t.variables) }), typeof t.notifyOnNetworkStatusChange > "u" && (t.notifyOnNetworkStatusChange = !1);
        var n = new My(this), i = new tc({
          queryManager: this,
          queryInfo: n,
          options: t
        });
        return i.lastQuery = r, tc.inactiveOnCreation.getValue() || this.queries.set(i.queryId, n), n.init({
          document: r,
          observableQuery: i,
          variables: i.variables
        }), i;
      }, e.prototype.query = function(t, r) {
        var n = this;
        r === void 0 && (r = this.generateQueryId()), u0(t.query, 30), u0(t.query.kind === "Document", 31), u0(!t.returnPartialData, 32), u0(!t.pollInterval, 33);
        var i = this.transform(t.query);
        return this.fetchQuery(r, C2(C2({}, t), { query: i })).then(function(o) {
          return o && C2(C2({}, o), { data: n.maskOperation({
            document: i,
            data: o.data,
            fetchPolicy: t.fetchPolicy,
            id: r
          }) });
        }).finally(function() {
          return n.stopQuery(r);
        });
      }, e.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
      }, e.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
      }, e.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
      }, e.prototype.stopQueryInStore = function(t) {
        this.stopQueryInStoreNoBroadcast(t), this.broadcastQueries();
      }, e.prototype.stopQueryInStoreNoBroadcast = function(t) {
        var r = this.queries.get(t);
        r && r.stop();
      }, e.prototype.clearStore = function(t) {
        return t === void 0 && (t = {
          discardWatches: !0
        }), this.cancelPendingFetches(G1(34)), this.queries.forEach(function(r) {
          r.observableQuery ? r.networkStatus = de.loading : r.stop();
        }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(t);
      }, e.prototype.getObservableQueries = function(t) {
        var r = this;
        t === void 0 && (t = "active");
        var n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set();
        return Array.isArray(t) && t.forEach(function(c) {
          if (typeof c == "string")
            i.set(c, c), o.set(c, !1);
          else if (y52(c)) {
            var f = Si(r.transform(c));
            i.set(f, Ul(c)), o.set(f, !1);
          } else qt(c) && c.query && u.add(c);
        }), this.queries.forEach(function(c, f) {
          var d = c.observableQuery, g = c.document;
          if (d) {
            if (t === "all") {
              n.set(f, d);
              return;
            }
            var h = d.queryName, E = d.options.fetchPolicy;
            if (E === "standby" || t === "active" && !d.hasObservers())
              return;
            (t === "active" || h && o.has(h) || g && o.has(Si(g))) && (n.set(f, d), h && o.set(h, !0), g && o.set(Si(g), !0));
          }
        }), u.size && u.forEach(function(c) {
          var f = Kx("legacyOneTimeQuery"), d = r.getOrCreateQuery(f).init({
            document: c.query,
            variables: c.variables
          }), g = new tc({
            queryManager: r,
            queryInfo: d,
            options: C2(C2({}, c), { fetchPolicy: "network-only" })
          });
          u0(g.queryId === f), d.setObservableQuery(g), n.set(f, g);
        }), globalThis.__DEV__ !== !1 && o.size && o.forEach(function(c, f) {
          if (!c) {
            var d = i.get(f);
            d ? globalThis.__DEV__ !== !1 && u0.warn(35, d) : globalThis.__DEV__ !== !1 && u0.warn(36);
          }
        }), n;
      }, e.prototype.reFetchObservableQueries = function(t) {
        var r = this;
        t === void 0 && (t = !1);
        var n = [];
        return this.getObservableQueries(t ? "all" : "active").forEach(function(i, o) {
          var u = i.options.fetchPolicy;
          i.resetLastResults(), (t || u !== "standby" && u !== "cache-only") && n.push(i.refetch()), (r.queries.get(o) || i.queryInfo).setDiff(null);
        }), this.broadcastQueries(), Promise.all(n);
      }, e.prototype.startGraphQLSubscription = function(t) {
        var r = this, n = t.query, i = t.variables, o = t.fetchPolicy, u = t.errorPolicy, c = u === void 0 ? "none" : u, f = t.context, d = f === void 0 ? {} : f, g = t.extensions, h = g === void 0 ? {} : g;
        n = this.transform(n), i = this.getVariables(n, i);
        var E = function(I) {
          return r.getObservableFromLink(n, d, I, h).map(function(Q) {
            o !== "no-cache" && (hb(Q, c) && r.cache.write({
              query: n,
              result: Q.data,
              dataId: "ROOT_SUBSCRIPTION",
              variables: I
            }), r.broadcastQueries());
            var B = qd(Q), _ = w12(Q);
            if (B || _) {
              var M = {};
              if (B && (M.graphQLErrors = Q.errors), _ && (M.protocolErrors = Q.extensions[ES]), c === "none" || _)
                throw new f8(M);
            }
            return c === "ignore" && delete Q.errors, Q;
          });
        };
        if (this.getDocumentInfo(n).hasClientExports) {
          var y = this.localState.addExportedVariables(n, i, d).then(E);
          return new At(function(I) {
            var Q = null;
            return y.then(function(B) {
              return Q = B.subscribe(I);
            }, I.error), function() {
              return Q && Q.unsubscribe();
            };
          });
        }
        return E(i);
      }, e.prototype.stopQuery = function(t) {
        this.stopQueryNoBroadcast(t), this.broadcastQueries();
      }, e.prototype.stopQueryNoBroadcast = function(t) {
        this.stopQueryInStoreNoBroadcast(t), this.removeQuery(t);
      }, e.prototype.removeQuery = function(t) {
        var r;
        this.fetchCancelFns.delete(t), this.queries.has(t) && ((r = this.queries.get(t)) === null || r === void 0 || r.stop(), this.queries.delete(t));
      }, e.prototype.broadcastQueries = function() {
        this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(t) {
          var r;
          return (r = t.observableQuery) === null || r === void 0 ? void 0 : r.notify();
        });
      }, e.prototype.getLocalState = function() {
        return this.localState;
      }, e.prototype.getObservableFromLink = function(t, r, n, i, o) {
        var u = this, c;
        o === void 0 && (o = (c = r == null ? void 0 : r.queryDeduplication) !== null && c !== void 0 ? c : this.queryDeduplication);
        var f, d = this.getDocumentInfo(t), g = d.serverQuery, h = d.clientQuery;
        if (g) {
          var E = this, y = E.inFlightLinkObservables, I = E.link, Q = {
            query: g,
            variables: n,
            operationName: Ul(g) || void 0,
            context: this.prepareContext(C2(C2({}, r), { forceFetch: !o })),
            extensions: i
          };
          if (r = Q.context, o) {
            var B = Si(g), _ = N6(n), M = y.lookup(B, _);
            if (f = M.observable, !f) {
              var S = new r9([
                cb(I, Q)
              ]);
              f = M.observable = S, S.beforeNext(function O(w, D) {
                w === "next" && "hasNext" in D && D.hasNext ? S.beforeNext(O) : y.remove(B, _);
              });
            }
          } else
            f = new r9([
              cb(I, Q)
            ]);
        } else
          f = new r9([At.of({ data: {} })]), r = this.prepareContext(r);
        return h && (f = Iy(f, function(O) {
          return u.localState.runResolvers({
            document: h,
            remoteResult: O,
            context: r,
            variables: n
          });
        })), f;
      }, e.prototype.getResultsFromLink = function(t, r, n) {
        var i = t.lastRequestId = this.generateRequestId(), o = this.cache.transformForLink(n.query);
        return Iy(this.getObservableFromLink(o, n.context, n.variables), function(u) {
          var c = lb(u), f = c.length > 0, d = n.errorPolicy;
          if (i >= t.lastRequestId) {
            if (f && d === "none")
              throw t.markError(new f8({
                graphQLErrors: c
              }));
            t.markResult(u, o, n, r), t.markReady();
          }
          var g = {
            data: u.data,
            loading: !1,
            networkStatus: de.ready
          };
          return f && d === "none" && (g.data = void 0), f && d !== "ignore" && (g.errors = c, g.networkStatus = de.error), g;
        }, function(u) {
          var c = yz(u) ? u : new f8({ networkError: u });
          throw i >= t.lastRequestId && t.markError(c), c;
        });
      }, e.prototype.fetchConcastWithInfo = function(t, r, n, i) {
        var o = this;
        n === void 0 && (n = de.loading), i === void 0 && (i = r.query);
        var u = this.getVariables(i, r.variables), c = this.defaultOptions.watchQuery, f = r.fetchPolicy, d = f === void 0 ? c && c.fetchPolicy || "cache-first" : f, g = r.errorPolicy, h = g === void 0 ? c && c.errorPolicy || "none" : g, E = r.returnPartialData, y = E === void 0 ? !1 : E, I = r.notifyOnNetworkStatusChange, Q = I === void 0 ? !1 : I, B = r.context, _ = B === void 0 ? {} : B, M = Object.assign({}, r, {
          query: i,
          variables: u,
          fetchPolicy: d,
          errorPolicy: h,
          returnPartialData: y,
          notifyOnNetworkStatusChange: Q,
          context: _
        }), S = function(F) {
          M.variables = F;
          var z = o.fetchQueryByPolicy(t, M, n);
          return (
            // If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            M.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            z.sources.length > 0 && t.observableQuery && t.observableQuery.applyNextFetchPolicy("after-fetch", r), z
          );
        }, O = function() {
          return o.fetchCancelFns.delete(t.queryId);
        };
        this.fetchCancelFns.set(t.queryId, function(F) {
          O(), setTimeout(function() {
            return w.cancel(F);
          });
        });
        var w, D;
        if (this.getDocumentInfo(M.query).hasClientExports)
          w = new r9(this.localState.addExportedVariables(M.query, M.variables, M.context).then(S).then(function(F) {
            return F.sources;
          })), D = !0;
        else {
          var k = S(M.variables);
          D = k.fromLink, w = new r9(k.sources);
        }
        return w.promise.then(O, O), {
          concast: w,
          fromLink: D
        };
      }, e.prototype.refetchQueries = function(t) {
        var r = this, n = t.updateCache, i = t.include, o = t.optimistic, u = o === void 0 ? !1 : o, c = t.removeOptimistic, f = c === void 0 ? u ? Kx("refetchQueries") : void 0 : c, d = t.onQueryUpdated, g = /* @__PURE__ */ new Map();
        i && this.getObservableQueries(i).forEach(function(E, y) {
          g.set(y, {
            oq: E,
            lastDiff: (r.queries.get(y) || E.queryInfo).getDiff()
          });
        });
        var h = /* @__PURE__ */ new Map();
        return n && this.cache.batch({
          update: n,
          // Since you can perform any combination of cache reads and/or writes in
          // the cache.batch update function, its optimistic option can be either
          // a boolean or a string, representing three distinct modes of
          // operation:
          //
          // * false: read/write only the root layer
          // * true: read/write the topmost layer
          // * string: read/write a fresh optimistic layer with that ID string
          //
          // When typeof optimistic === "string", a new optimistic layer will be
          // temporarily created within cache.batch with that string as its ID. If
          // we then pass that same string as the removeOptimistic option, we can
          // make cache.batch immediately remove the optimistic layer after
          // running the updateCache function, triggering only one broadcast.
          //
          // However, the refetchQueries method accepts only true or false for its
          // optimistic option (not string). We interpret true to mean a temporary
          // optimistic layer should be created, to allow efficiently rolling back
          // the effect of the updateCache function, which involves passing a
          // string instead of true as the optimistic option to cache.batch, when
          // refetchQueries receives optimistic: true.
          //
          // In other words, we are deliberately not supporting the use case of
          // writing to an *existing* optimistic layer (using the refetchQueries
          // updateCache function), since that would potentially interfere with
          // other optimistic updates in progress. Instead, you can read/write
          // only the root layer by passing optimistic: false to refetchQueries,
          // or you can read/write a brand new optimistic layer that will be
          // automatically removed by passing optimistic: true.
          optimistic: u && f || !1,
          // The removeOptimistic option can also be provided by itself, even if
          // optimistic === false, to remove some previously-added optimistic
          // layer safely and efficiently, like we do in markMutationResult.
          //
          // If an explicit removeOptimistic string is provided with optimistic:
          // true, the removeOptimistic string will determine the ID of the
          // temporary optimistic layer, in case that ever matters.
          removeOptimistic: f,
          onWatchUpdated: function(E, y, I) {
            var Q = E.watcher instanceof My && E.watcher.observableQuery;
            if (Q) {
              if (d) {
                g.delete(Q.queryId);
                var B = d(Q, y, I);
                return B === !0 && (B = Q.refetch()), B !== !1 && h.set(Q, B), B;
              }
              d !== null && g.set(Q.queryId, { oq: Q, lastDiff: I, diff: y });
            }
          }
        }), g.size && g.forEach(function(E, y) {
          var I = E.oq, Q = E.lastDiff, B = E.diff, _;
          d && (B || (B = r.cache.diff(I.queryInfo.getDiffOptions())), _ = d(I, B, Q)), (!d || _ === !0) && (_ = I.refetch()), _ !== !1 && h.set(I, _), y.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(y);
        }), f && this.cache.removeOptimistic(f), h;
      }, e.prototype.maskOperation = function(t) {
        var r, n, i, o = t.document, u = t.data;
        if (globalThis.__DEV__ !== !1) {
          var c = t.fetchPolicy, f = t.id, d = (r = Fi(o)) === null || r === void 0 ? void 0 : r.operation, g = ((n = d == null ? void 0 : d[0]) !== null && n !== void 0 ? n : "o") + f;
          this.dataMasking && c === "no-cache" && !n52(o) && !this.noCacheWarningsByQueryId.has(g) && (this.noCacheWarningsByQueryId.add(g), globalThis.__DEV__ !== !1 && u0.warn(
            37,
            (i = Ul(o)) !== null && i !== void 0 ? i : "Unnamed ".concat(d ?? "operation")
          ));
        }
        return this.dataMasking ? K12(u, o, this.cache) : u;
      }, e.prototype.maskFragment = function(t) {
        var r = t.data, n = t.fragment, i = t.fragmentName;
        return this.dataMasking ? Mz(r, n, this.cache, i) : r;
      }, e.prototype.fetchQueryByPolicy = function(t, r, n) {
        var i = this, o = r.query, u = r.variables, c = r.fetchPolicy, f = r.refetchWritePolicy, d = r.errorPolicy, g = r.returnPartialData, h = r.context, E = r.notifyOnNetworkStatusChange, y = t.networkStatus;
        t.init({
          document: o,
          variables: u,
          networkStatus: n
        });
        var I = function() {
          return t.getDiff();
        }, Q = function(O, w) {
          w === void 0 && (w = t.networkStatus || de.loading);
          var D = O.result;
          globalThis.__DEV__ !== !1 && !g && !et(D, {}) && zz(O.missing);
          var k = function(F) {
            return At.of(C2({ data: F, loading: o9(w), networkStatus: w }, O.complete ? null : { partial: !0 }));
          };
          return D && i.getDocumentInfo(o).hasForcedResolvers ? i.localState.runResolvers({
            document: o,
            remoteResult: { data: D },
            context: h,
            variables: u,
            onlyRunForcedResolvers: !0
          }).then(function(F) {
            return k(F.data || void 0);
          }) : d === "none" && w === de.refetch && Array.isArray(O.missing) ? k(void 0) : k(D);
        }, B = c === "no-cache" ? 0 : n === de.refetch && f !== "merge" ? 1 : 2, _ = function() {
          return i.getResultsFromLink(t, B, {
            query: o,
            variables: u,
            context: h,
            fetchPolicy: c,
            errorPolicy: d
          });
        }, M = E && typeof y == "number" && y !== n && o9(n);
        switch (c) {
          default:
          case "cache-first": {
            var S = I();
            return S.complete ? {
              fromLink: !1,
              sources: [Q(S, t.markReady())]
            } : g || M ? {
              fromLink: !0,
              sources: [Q(S), _()]
            } : { fromLink: !0, sources: [_()] };
          }
          case "cache-and-network": {
            var S = I();
            return S.complete || g || M ? {
              fromLink: !0,
              sources: [Q(S), _()]
            } : { fromLink: !0, sources: [_()] };
          }
          case "cache-only":
            return {
              fromLink: !1,
              sources: [Q(I(), t.markReady())]
            };
          case "network-only":
            return M ? {
              fromLink: !0,
              sources: [Q(I()), _()]
            } : { fromLink: !0, sources: [_()] };
          case "no-cache":
            return M ? {
              fromLink: !0,
              // Note that queryInfo.getDiff() for no-cache queries does not call
              // cache.diff, but instead returns a { complete: false } stub result
              // when there is no queryInfo.diff already defined.
              sources: [Q(t.getDiff()), _()]
            } : { fromLink: !0, sources: [_()] };
          case "standby":
            return { fromLink: !1, sources: [] };
        }
      }, e.prototype.getOrCreateQuery = function(t) {
        return t && !this.queries.has(t) && this.queries.set(t, new My(this, t)), this.queries.get(t);
      }, e.prototype.prepareContext = function(t) {
        t === void 0 && (t = {});
        var r = this.localState.prepareContext(t);
        return C2(C2(C2({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
      }, e;
    }()
  ), vr2 = (
    /** @class */
    function() {
      function e(t) {
        var r = t.cache, n = t.client, i = t.resolvers, o = t.fragmentMatcher;
        this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, n && (this.client = n), i && this.addResolvers(i), o && this.setFragmentMatcher(o);
      }
      return e.prototype.addResolvers = function(t) {
        var r = this;
        this.resolvers = this.resolvers || {}, Array.isArray(t) ? t.forEach(function(n) {
          r.resolvers = yL(r.resolvers, n);
        }) : this.resolvers = yL(this.resolvers, t);
      }, e.prototype.setResolvers = function(t) {
        this.resolvers = {}, this.addResolvers(t);
      }, e.prototype.getResolvers = function() {
        return this.resolvers || {};
      }, e.prototype.runResolvers = function(t) {
        return D6(this, arguments, void 0, function(r) {
          var n = r.document, i = r.remoteResult, o = r.context, u = r.variables, c = r.onlyRunForcedResolvers, f = c === void 0 ? !1 : c;
          return L6(this, function(d) {
            return n ? [2, this.resolveDocument(n, i.data, o, u, this.fragmentMatcher, f).then(function(g) {
              return C2(C2({}, i), { data: g.result });
            })] : [2, i];
          });
        });
      }, e.prototype.setFragmentMatcher = function(t) {
        this.fragmentMatcher = t;
      }, e.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
      }, e.prototype.clientQuery = function(t) {
        return lc(["client"], t) && this.resolvers ? t : null;
      }, e.prototype.serverQuery = function(t) {
        return Cz(t);
      }, e.prototype.prepareContext = function(t) {
        var r = this.cache;
        return C2(C2({}, t), {
          cache: r,
          // Getting an entry's cache key is useful for local state resolvers.
          getCacheKey: function(n) {
            return r.identify(n);
          }
        });
      }, e.prototype.addExportedVariables = function(t) {
        return D6(this, arguments, void 0, function(r, n, i) {
          return n === void 0 && (n = {}), i === void 0 && (i = {}), L6(this, function(o) {
            return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, n) || {}, this.prepareContext(i), n).then(function(u) {
              return C2(C2({}, n), u.exportedVariables);
            })] : [2, C2({}, n)];
          });
        });
      }, e.prototype.shouldForceResolvers = function(t) {
        var r = !1;
        return hn(t, {
          Directive: {
            enter: function(n) {
              if (n.name.value === "client" && n.arguments && (r = n.arguments.some(function(i) {
                return i.name.value === "always" && i.value.kind === "BooleanValue" && i.value.value === !0;
              }), r))
                return Jp;
            }
          }
        }), r;
      }, e.prototype.buildRootValueFromCache = function(t, r) {
        return this.cache.diff({
          query: Y52(t),
          variables: r,
          returnPartialData: !0,
          optimistic: !1
        }).result;
      }, e.prototype.resolveDocument = function(t, r) {
        return D6(this, arguments, void 0, function(n, i, o, u, c, f) {
          var d, g, h, E, y, I, Q, B, _, M, S;
          return o === void 0 && (o = {}), u === void 0 && (u = {}), c === void 0 && (c = function() {
            return !0;
          }), f === void 0 && (f = !1), L6(this, function(O) {
            return d = Jc(n), g = rs(n), h = es(g), E = this.collectSelectionsToResolve(d, h), y = d.operation, I = y ? y.charAt(0).toUpperCase() + y.slice(1) : "Query", Q = this, B = Q.cache, _ = Q.client, M = {
              fragmentMap: h,
              context: C2(C2({}, o), { cache: B, client: _ }),
              variables: u,
              fragmentMatcher: c,
              defaultOperationType: I,
              exportedVariables: {},
              selectionsToResolve: E,
              onlyRunForcedResolvers: f
            }, S = !1, [2, this.resolveSelectionSet(d.selectionSet, S, i, M).then(function(w) {
              return {
                result: w,
                exportedVariables: M.exportedVariables
              };
            })];
          });
        });
      }, e.prototype.resolveSelectionSet = function(t, r, n, i) {
        return D6(this, void 0, void 0, function() {
          var o, u, c, f, d, g = this;
          return L6(this, function(h) {
            return o = i.fragmentMap, u = i.context, c = i.variables, f = [n], d = function(E) {
              return D6(g, void 0, void 0, function() {
                var y, I;
                return L6(this, function(Q) {
                  return !r && !i.selectionsToResolve.has(E) ? [
                    2
                    /*return*/
                  ] : Xc(E, c) ? V6(E) ? [2, this.resolveField(E, r, n, i).then(function(B) {
                    var _;
                    typeof B < "u" && f.push((_ = {}, _[m8(E)] = B, _));
                  })] : (D52(E) ? y = E : (y = o[E.name.value], u0(y, 19, E.name.value)), y && y.typeCondition && (I = y.typeCondition.name.value, i.fragmentMatcher(n, I, u)) ? [2, this.resolveSelectionSet(y.selectionSet, r, n, i).then(function(B) {
                    f.push(B);
                  })] : [
                    2
                    /*return*/
                  ]) : [
                    2
                    /*return*/
                  ];
                });
              });
            }, [2, Promise.all(t.selections.map(d)).then(function() {
              return ah(f);
            })];
          });
        });
      }, e.prototype.resolveField = function(t, r, n, i) {
        return D6(this, void 0, void 0, function() {
          var o, u, c, f, d, g, h, E, y, I = this;
          return L6(this, function(Q) {
            return n ? (o = i.variables, u = t.name.value, c = m8(t), f = u !== c, d = n[c] || n[u], g = Promise.resolve(d), (!i.onlyRunForcedResolvers || this.shouldForceResolvers(t)) && (h = n.__typename || i.defaultOperationType, E = this.resolvers && this.resolvers[h], E && (y = E[f ? u : c], y && (g = Promise.resolve(
              // In case the resolve function accesses reactive variables,
              // set cacheSlot to the current cache instance.
              yS.withValue(this.cache, y, [
                n,
                rh(t, o),
                i.context,
                { field: t, fragmentMap: i.fragmentMap }
              ])
            )))), [2, g.then(function(B) {
              var _, M;
              if (B === void 0 && (B = d), t.directives && t.directives.forEach(function(O) {
                O.name.value === "export" && O.arguments && O.arguments.forEach(function(w) {
                  w.name.value === "as" && w.value.kind === "StringValue" && (i.exportedVariables[w.value.value] = B);
                });
              }), !t.selectionSet || B == null)
                return B;
              var S = (M = (_ = t.directives) === null || _ === void 0 ? void 0 : _.some(function(O) {
                return O.name.value === "client";
              })) !== null && M !== void 0 ? M : !1;
              if (Array.isArray(B))
                return I.resolveSubSelectedArray(t, r || S, B, i);
              if (t.selectionSet)
                return I.resolveSelectionSet(t.selectionSet, r || S, B, i);
            })]) : [2, null];
          });
        });
      }, e.prototype.resolveSubSelectedArray = function(t, r, n, i) {
        var o = this;
        return Promise.all(n.map(function(u) {
          if (u === null)
            return null;
          if (Array.isArray(u))
            return o.resolveSubSelectedArray(t, r, u, i);
          if (t.selectionSet)
            return o.resolveSelectionSet(t.selectionSet, r, u, i);
        }));
      }, e.prototype.collectSelectionsToResolve = function(t, r) {
        var n = function(u) {
          return !Array.isArray(u);
        }, i = this.selectionsToResolveCache;
        function o(u) {
          if (!i.has(u)) {
            var c = /* @__PURE__ */ new Set();
            i.set(u, c), hn(u, {
              Directive: function(f, d, g, h, E) {
                f.name.value === "client" && E.forEach(function(y) {
                  n(y) && fL(y) && c.add(y);
                });
              },
              FragmentSpread: function(f, d, g, h, E) {
                var y = r[f.name.value];
                u0(y, 20, f.name.value);
                var I = o(y);
                I.size > 0 && (E.forEach(function(Q) {
                  n(Q) && fL(Q) && c.add(Q);
                }), c.add(f), I.forEach(function(Q) {
                  c.add(Q);
                }));
              }
            });
          }
          return i.get(u);
        }
        return o(t);
      }, e;
    }()
  ), tk = !1, Uz = (
    /** @class */
    function() {
      function e(t) {
        var r = this, n;
        if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !t.cache)
          throw G1(16);
        var i = t.uri, o = t.credentials, u = t.headers, c = t.cache, f = t.documentTransform, d = t.ssrMode, g = d === void 0 ? !1 : d, h = t.ssrForceFetchDelay, E = h === void 0 ? 0 : h, y = t.connectToDevTools, I = t.queryDeduplication, Q = I === void 0 ? !0 : I, B = t.defaultOptions, _ = t.defaultContext, M = t.assumeImmutableResults, S = M === void 0 ? c.assumeImmutableResults : M, O = t.resolvers, w = t.typeDefs, D = t.fragmentMatcher, k = t.name, F = t.version, z = t.devtools, Z = t.dataMasking, V = t.link;
        V || (V = i ? new Bz({ uri: i, credentials: o, headers: u }) : ns.empty()), this.link = V, this.cache = c, this.disableNetworkFetches = g || E > 0, this.queryDeduplication = Q, this.defaultOptions = B || /* @__PURE__ */ Object.create(null), this.typeDefs = w, this.devtoolsConfig = C2(C2({}, z), { enabled: (n = z == null ? void 0 : z.enabled) !== null && n !== void 0 ? n : y }), this.devtoolsConfig.enabled === void 0 && (this.devtoolsConfig.enabled = globalThis.__DEV__ !== !1), E && setTimeout(function() {
          return r.disableNetworkFetches = !1;
        }, E), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = tS, this.localState = new vr2({
          cache: c,
          client: this,
          resolvers: O,
          fragmentMatcher: D
        }), this.queryManager = new hr2({
          cache: this.cache,
          link: this.link,
          defaultOptions: this.defaultOptions,
          defaultContext: _,
          documentTransform: f,
          queryDeduplication: Q,
          ssrMode: g,
          dataMasking: !!Z,
          clientAwareness: {
            name: k,
            version: F
          },
          localState: this.localState,
          assumeImmutableResults: S,
          onBroadcast: this.devtoolsConfig.enabled ? function() {
            r.devToolsHookCb && r.devToolsHookCb({
              action: {},
              state: {
                queries: r.queryManager.getQueryStore(),
                mutations: r.queryManager.mutationStore || {}
              },
              dataWithOptimisticResults: r.cache.extract(!0)
            });
          } : void 0
        }), this.devtoolsConfig.enabled && this.connectToDevTools();
      }
      return e.prototype.connectToDevTools = function() {
        if (!(typeof window > "u")) {
          var t = window, r = Symbol.for("apollo.devtools");
          (t[r] = t[r] || []).push(this), t.__APOLLO_CLIENT__ = this, !tk && globalThis.__DEV__ !== !1 && (tk = !0, window.document && window.top === window.self && /^(https?|file):$/.test(window.location.protocol) && setTimeout(function() {
            if (!window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
              var n = window.navigator, i = n && n.userAgent, o = void 0;
              typeof i == "string" && (i.indexOf("Chrome/") > -1 ? o = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : i.indexOf("Firefox/") > -1 && (o = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), o && globalThis.__DEV__ !== !1 && u0.log("Download the Apollo DevTools for a better development experience: %s", o);
            }
          }, 1e4));
        }
      }, Object.defineProperty(e.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */
        get: function() {
          return this.queryManager.documentTransform;
        },
        enumerable: !1,
        configurable: !0
      }), e.prototype.stop = function() {
        this.queryManager.stop();
      }, e.prototype.watchQuery = function(t) {
        return this.defaultOptions.watchQuery && (t = C9(this.defaultOptions.watchQuery, t)), this.disableNetworkFetches && (t.fetchPolicy === "network-only" || t.fetchPolicy === "cache-and-network") && (t = C2(C2({}, t), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(t);
      }, e.prototype.query = function(t) {
        return this.defaultOptions.query && (t = C9(this.defaultOptions.query, t)), u0(t.fetchPolicy !== "cache-and-network", 17), this.disableNetworkFetches && t.fetchPolicy === "network-only" && (t = C2(C2({}, t), { fetchPolicy: "cache-first" })), this.queryManager.query(t);
      }, e.prototype.mutate = function(t) {
        return this.defaultOptions.mutate && (t = C9(this.defaultOptions.mutate, t)), this.queryManager.mutate(t);
      }, e.prototype.subscribe = function(t) {
        var r = this, n = this.queryManager.generateQueryId();
        return this.queryManager.startGraphQLSubscription(t).map(function(i) {
          return C2(C2({}, i), { data: r.queryManager.maskOperation({
            document: t.query,
            data: i.data,
            fetchPolicy: t.fetchPolicy,
            id: n
          }) });
        });
      }, e.prototype.readQuery = function(t, r) {
        return r === void 0 && (r = !1), this.cache.readQuery(t, r);
      }, e.prototype.watchFragment = function(t) {
        var r;
        return this.cache.watchFragment(C2(C2({}, t), (r = {}, r[Symbol.for("apollo.dataMasking")] = this.queryManager.dataMasking, r)));
      }, e.prototype.readFragment = function(t, r) {
        return r === void 0 && (r = !1), this.cache.readFragment(t, r);
      }, e.prototype.writeQuery = function(t) {
        var r = this.cache.writeQuery(t);
        return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
      }, e.prototype.writeFragment = function(t) {
        var r = this.cache.writeFragment(t);
        return t.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
      }, e.prototype.__actionHookForDevTools = function(t) {
        this.devToolsHookCb = t;
      }, e.prototype.__requestRaw = function(t) {
        return cb(this.link, t);
      }, e.prototype.resetStore = function() {
        var t = this;
        return Promise.resolve().then(function() {
          return t.queryManager.clearStore({
            discardWatches: !1
          });
        }).then(function() {
          return Promise.all(t.resetStoreCallbacks.map(function(r) {
            return r();
          }));
        }).then(function() {
          return t.reFetchObservableQueries();
        });
      }, e.prototype.clearStore = function() {
        var t = this;
        return Promise.resolve().then(function() {
          return t.queryManager.clearStore({
            discardWatches: !0
          });
        }).then(function() {
          return Promise.all(t.clearStoreCallbacks.map(function(r) {
            return r();
          }));
        });
      }, e.prototype.onResetStore = function(t) {
        var r = this;
        return this.resetStoreCallbacks.push(t), function() {
          r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(n) {
            return n !== t;
          });
        };
      }, e.prototype.onClearStore = function(t) {
        var r = this;
        return this.clearStoreCallbacks.push(t), function() {
          r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(n) {
            return n !== t;
          });
        };
      }, e.prototype.reFetchObservableQueries = function(t) {
        return this.queryManager.reFetchObservableQueries(t);
      }, e.prototype.refetchQueries = function(t) {
        var r = this.queryManager.refetchQueries(t), n = [], i = [];
        r.forEach(function(u, c) {
          n.push(c), i.push(u);
        });
        var o = Promise.all(i);
        return o.queries = n, o.results = i, o.catch(function(u) {
          globalThis.__DEV__ !== !1 && u0.debug(18, u);
        }), o;
      }, e.prototype.getObservableQueries = function(t) {
        return t === void 0 && (t = "active"), this.queryManager.getObservableQueries(t);
      }, e.prototype.extract = function(t) {
        return this.cache.extract(t);
      }, e.prototype.restore = function(t) {
        return this.cache.restore(t);
      }, e.prototype.addResolvers = function(t) {
        this.localState.addResolvers(t);
      }, e.prototype.setResolvers = function(t) {
        this.localState.setResolvers(t);
      }, e.prototype.getResolvers = function() {
        return this.localState.getResolvers();
      }, e.prototype.setLocalStateFragmentMatcher = function(t) {
        this.localState.setFragmentMatcher(t);
      }, e.prototype.setLink = function(t) {
        this.link = this.queryManager.link = t;
      }, Object.defineProperty(e.prototype, "defaultContext", {
        get: function() {
          return this.queryManager.defaultContext;
        },
        enumerable: !1,
        configurable: !0
      }), e;
    }()
  );
  globalThis.__DEV__ !== !1 && (Uz.prototype.getMemoryInternals = f52);
  var $d = /* @__PURE__ */ new Map(), vb = /* @__PURE__ */ new Map(), qz = !0, Hg = !1;
  function Wz(e) {
    return e.replace(/[\s,]+/g, " ").trim();
  }
  function Er2(e) {
    return Wz(e.source.body.substring(e.start, e.end));
  }
  function mr2(e) {
    var t = /* @__PURE__ */ new Set(), r = [];
    return e.definitions.forEach(function(n) {
      if (n.kind === "FragmentDefinition") {
        var i = n.name.value, o = Er2(n.loc), u = vb.get(i);
        u && !u.has(o) ? qz && console.warn("Warning: fragment with name " + i + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : u || vb.set(i, u = /* @__PURE__ */ new Set()), u.add(o), t.has(o) || (t.add(o), r.push(n));
      } else
        r.push(n);
    }), C2(C2({}, e), { definitions: r });
  }
  function yr2(e) {
    var t = new Set(e.definitions);
    t.forEach(function(n) {
      n.loc && delete n.loc, Object.keys(n).forEach(function(i) {
        var o = n[i];
        o && typeof o == "object" && t.add(o);
      });
    });
    var r = e.loc;
    return r && (delete r.startToken, delete r.endToken), e;
  }
  function Ir2(e) {
    var t = Wz(e);
    if (!$d.has(t)) {
      var r = Rt2(e, {
        experimentalFragmentVariables: Hg,
        allowLegacyFragmentVariables: Hg
      });
      if (!r || r.kind !== "Document")
        throw new Error("Not a valid GraphQL document.");
      $d.set(t, yr2(mr2(r)));
    }
    return $d.get(t);
  }
  function Hi(e) {
    for (var t = [], r = 1; r < arguments.length; r++)
      t[r - 1] = arguments[r];
    typeof e == "string" && (e = [e]);
    var n = e[0];
    return t.forEach(function(i, o) {
      i && i.kind === "Document" ? n += i.loc.source.body : n += i, n += e[o + 1];
    }), Ir2(n);
  }
  function Br2() {
    $d.clear(), vb.clear();
  }
  function Qr2() {
    qz = !1;
  }
  function xr2() {
    Hg = !0;
  }
  function br2() {
    Hg = !1;
  }
  var _l = {
    gql: Hi,
    resetCaches: Br2,
    disableFragmentWarnings: Qr2,
    enableExperimentalFragmentVariables: xr2,
    disableExperimentalFragmentVariables: br2
  };
  (function(e) {
    e.gql = _l.gql, e.resetCaches = _l.resetCaches, e.disableFragmentWarnings = _l.disableFragmentWarnings, e.enableExperimentalFragmentVariables = _l.enableExperimentalFragmentVariables, e.disableExperimentalFragmentVariables = _l.disableExperimentalFragmentVariables;
  })(Hi || (Hi = {}));
  Hi.default = Hi;
  var _y = { exports: {} }, rk;
  function wr2() {
    return rk || (rk = 1, function(e) {
      e.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, e.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, e.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(e.exports, X9());
    }(_y)), _y.exports;
  }
  var ke = wr2();
  const Sr2 = /* @__PURE__ */ tt(ke), Yz = /* @__PURE__ */ bZ({
    __proto__: null,
    default: Sr2
  }, [ke]);
  var nk = sS ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
  function xS() {
    u0("createContext" in Yz, 54);
    var e = ke.createContext[nk];
    return e || (Object.defineProperty(ke.createContext, nk, {
      value: e = ke.createContext({}),
      enumerable: !1,
      writable: !1,
      configurable: !0
    }), e.displayName = "ApolloContext"), e;
  }
  var Mr2 = function(e) {
    var t = e.client, r = e.children, n = xS(), i = ke.useContext(n), o = ke.useMemo(function() {
      return C2(C2({}, i), { client: t || i.client });
    }, [i, t]);
    return u0(o.client, 55), ke.createElement(n.Provider, { value: o }, r);
  };
  function $z(e) {
    var t = ke.useContext(xS()), r = e || t.client;
    return u0(!!r, 58), r;
  }
  var ik = !1, _r2 = "useSyncExternalStore", Or2 = Yz[_r2], Tr2 = Or2 || function(e, t, r) {
    var n = t();
    // DEVIATION: Using __DEV__
    globalThis.__DEV__ !== !1 && !ik && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    n !== t() && (ik = !0, globalThis.__DEV__ !== !1 && u0.error(68));
    var i = ke.useState({
      inst: { value: n, getSnapshot: t }
    }), o = i[0].inst, u = i[1];
    return t52 ? ke.useLayoutEffect(function() {
      Object.assign(o, { value: n, getSnapshot: t }), Oy(o) && u({ inst: o });
    }, [e, n, t]) : Object.assign(o, { value: n, getSnapshot: t }), ke.useEffect(function() {
      return Oy(o) && u({ inst: o }), e(function() {
        Oy(o) && u({ inst: o });
      });
    }, [e]), n;
  };
  function Oy(e) {
    var t = e.value, r = e.getSnapshot;
    try {
      return t !== r();
    } catch {
      return !0;
    }
  }
  var p8;
  (function(e) {
    e[e.Query = 0] = "Query", e[e.Mutation = 1] = "Mutation", e[e.Subscription = 2] = "Subscription";
  })(p8 || (p8 = {}));
  var Mi;
  function ak(e) {
    var t;
    switch (e) {
      case p8.Query:
        t = "Query";
        break;
      case p8.Mutation:
        t = "Mutation";
        break;
      case p8.Subscription:
        t = "Subscription";
        break;
    }
    return t;
  }
  function Gz(e) {
    Mi || (Mi = new uS(
      f3.parser || 1e3
      /* defaultCacheSizes.parser */
    ));
    var t = Mi.get(e);
    if (t)
      return t;
    var r, n, i;
    u0(!!e && !!e.kind, 70, e);
    for (var o = [], u = [], c = [], f = [], d = 0, g = e.definitions; d < g.length; d++) {
      var h = g[d];
      if (h.kind === "FragmentDefinition") {
        o.push(h);
        continue;
      }
      if (h.kind === "OperationDefinition")
        switch (h.operation) {
          case "query":
            u.push(h);
            break;
          case "mutation":
            c.push(h);
            break;
          case "subscription":
            f.push(h);
            break;
        }
    }
    u0(!o.length || u.length || c.length || f.length, 71), u0(
      u.length + c.length + f.length <= 1,
      72,
      e,
      u.length,
      f.length,
      c.length
    ), n = u.length ? p8.Query : p8.Mutation, !u.length && !c.length && (n = p8.Subscription);
    var E = u.length ? u : c.length ? c : f;
    u0(E.length === 1, 73, e, E.length);
    var y = E[0];
    r = y.variableDefinitions || [], y.name && y.name.kind === "Name" ? i = y.name.value : i = "data";
    var I = { name: i, type: n, variables: r };
    return Mi.set(e, I), I;
  }
  Gz.resetCache = function() {
    Mi = void 0;
  };
  globalThis.__DEV__ !== !1 && lS("parser", function() {
    return Mi ? Mi.size : 0;
  });
  function Dr2(e, t) {
    var r = Gz(e), n = ak(t), i = ak(r.type);
    u0(
      r.type === t,
      74,
      n,
      n,
      i
    );
  }
  var Lr2 = UZ ? ke.useLayoutEffect : ke.useEffect, kr2 = Symbol.for("apollo.hook.wrappers");
  function Rr2(e, t, r) {
    var n = r.queryManager, i = n && n[kr2], o = i && i[e];
    return o ? o(t) : t;
  }
  var Pr2 = Object.prototype.hasOwnProperty;
  function ok() {
  }
  var Gd = Symbol();
  function Fr2(e, t) {
    return t === void 0 && (t = /* @__PURE__ */ Object.create(null)), Rr2(
      "useQuery",
      // eslint-disable-next-line react-compiler/react-compiler
      Nr2,
      $z(t && t.client)
    )(e, t);
  }
  function Nr2(e, t) {
    var r = Kz(e, t), n = r.result, i = r.obsQueryFields;
    return ke.useMemo(function() {
      return C2(C2({}, n), i);
    }, [n, i]);
  }
  function Hr2(e, t, r, n, i) {
    function o(h) {
      var E;
      Dr2(t, p8.Query);
      var y = {
        client: e,
        query: t,
        observable: (
          // See if there is an existing observable that was used to fetch the same
          // data and if so, use it instead since it will contain the proper queryId
          // to fetch the result set. This is used during SSR.
          n && n.getSSRObservable(i()) || tc.inactiveOnCreation.withValue(!n, function() {
            return e.watchQuery(bS(void 0, e, r, i()));
          })
        ),
        resultData: {
          // Reuse previousData from previous InternalState (if any) to provide
          // continuity of previousData even if/when the query or client changes.
          previousData: (E = h == null ? void 0 : h.resultData.current) === null || E === void 0 ? void 0 : E.data
        }
      };
      return y;
    }
    var u = ke.useState(o), c = u[0], f = u[1];
    function d(h) {
      var E, y;
      Object.assign(c.observable, (E = {}, E[Gd] = h, E));
      var I = c.resultData;
      f(C2(C2({}, c), {
        // might be a different query
        query: h.query,
        resultData: Object.assign(I, {
          // We need to modify the previous `resultData` object as we rely on the
          // object reference in other places
          previousData: ((y = I.current) === null || y === void 0 ? void 0 : y.data) || I.previousData,
          current: void 0
        })
      }));
    }
    if (e !== c.client || t !== c.query) {
      var g = o(c);
      return f(g), [g, d];
    }
    return [c, d];
  }
  function Kz(e, t) {
    var r = $z(t.client), n = ke.useContext(xS()).renderPromises, i = !!n, o = r.disableNetworkFetches, u = t.ssr !== !1 && !t.skip, c = t.partialRefetch, f = Xz(r, e, t, i), d = Hr2(r, e, t, n, f), g = d[0], h = g.observable, E = g.resultData, y = d[1], I = f(h);
    Zr2(
      E,
      // might get mutated during render
      h,
      // might get mutated during render
      r,
      t,
      I
    );
    var Q = ke.useMemo(function() {
      return Wr2(h);
    }, [h]);
    Vr2(h, n, u);
    var B = jr2(E, h, r, t, I, o, c, i, {
      onCompleted: t.onCompleted || ok,
      onError: t.onError || ok
    });
    return {
      result: B,
      obsQueryFields: Q,
      observable: h,
      resultData: E,
      client: r,
      onQueryExecuted: y
    };
  }
  function jr2(e, t, r, n, i, o, u, c, f) {
    var d = ke.useRef(f);
    ke.useEffect(function() {
      d.current = f;
    });
    var g = (c || o) && n.ssr === !1 && !n.skip ? (
      // If SSR has been explicitly disabled, and this function has been called
      // on the server side, return the default loading state.
      Jz
    ) : n.skip || i.fetchPolicy === "standby" ? (
      // When skipping a query (ie. we're not querying for data but still want to
      // render children), make sure the `data` is cleared out and `loading` is
      // set to `false` (since we aren't loading anything).
      //
      // NOTE: We no longer think this is the correct behavior. Skipping should
      // not automatically set `data` to `undefined`, but instead leave the
      // previous data in place. In other words, skipping should not mandate that
      // previously received data is all of a sudden removed. Unfortunately,
      // changing this is breaking, so we'll have to wait until Apollo Client 4.0
      // to address this.
      eU
    ) : void 0, h = e.previousData, E = ke.useMemo(function() {
      return g && jg(g, h, t, r);
    }, [r, t, g, h]);
    return Tr2(ke.useCallback(function(y) {
      if (c)
        return function() {
        };
      var I = function() {
        var _ = e.current, M = t.getCurrentResult();
        _ && _.loading === M.loading && _.networkStatus === M.networkStatus && et(_.data, M.data) || Eb(M, e, t, r, u, y, d.current);
      }, Q = function(_) {
        if (B.current.unsubscribe(), B.current = t.resubscribeAfterError(I, Q), !Pr2.call(_, "graphQLErrors"))
          throw _;
        var M = e.current;
        (!M || M && M.loading || !et(_, M.error)) && Eb({
          data: M && M.data,
          error: _,
          loading: !1,
          networkStatus: de.error
        }, e, t, r, u, y, d.current);
      }, B = { current: t.subscribe(I, Q) };
      return function() {
        setTimeout(function() {
          return B.current.unsubscribe();
        });
      };
    }, [
      o,
      c,
      t,
      e,
      u,
      r
    ]), function() {
      return E || sk(e, t, d.current, u, r);
    }, function() {
      return E || sk(e, t, d.current, u, r);
    });
  }
  function Vr2(e, t, r) {
    t && r && (t.registerSSRObservable(e), e.getCurrentResult().loading && t.addObservableQueryPromise(e));
  }
  function Zr2(e, t, r, n, i) {
    var o;
    t[Gd] && !et(t[Gd], i) && (t.reobserve(bS(t, r, n, i)), e.previousData = ((o = e.current) === null || o === void 0 ? void 0 : o.data) || e.previousData, e.current = void 0), t[Gd] = i;
  }
  function Xz(e, t, r, n) {
    r === void 0 && (r = {});
    var i = r.skip;
    r.ssr, r.onCompleted, r.onError;
    var o = r.defaultOptions, u = yr(r, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]);
    return function(c) {
      var f = Object.assign(u, { query: t });
      return n && (f.fetchPolicy === "network-only" || f.fetchPolicy === "cache-and-network") && (f.fetchPolicy = "cache-first"), f.variables || (f.variables = {}), i ? (f.initialFetchPolicy = f.initialFetchPolicy || f.fetchPolicy || mb(o, e.defaultOptions), f.fetchPolicy = "standby") : f.fetchPolicy || (f.fetchPolicy = (c == null ? void 0 : c.options.initialFetchPolicy) || mb(o, e.defaultOptions)), f;
    };
  }
  function bS(e, t, r, n) {
    var i = [], o = t.defaultOptions.watchQuery;
    return o && i.push(o), r.defaultOptions && i.push(r.defaultOptions), i.push(Ni(e && e.options, n)), i.reduce(C9);
  }
  function Eb(e, t, r, n, i, o, u) {
    var c = t.current;
    c && c.data && (t.previousData = c.data), !e.error && M4(e.errors) && (e.error = new f8({ graphQLErrors: e.errors })), t.current = jg(qr2(e, r, i), t.previousData, r, n), o(), zr2(e, c == null ? void 0 : c.networkStatus, u);
  }
  function zr2(e, t, r) {
    if (!e.loading) {
      var n = Ur2(e);
      Promise.resolve().then(function() {
        n ? r.onError(n) : e.data && t !== e.networkStatus && e.networkStatus === de.ready && r.onCompleted(e.data);
      }).catch(function(i) {
        globalThis.__DEV__ !== !1 && u0.warn(i);
      });
    }
  }
  function sk(e, t, r, n, i) {
    return e.current || Eb(t.getCurrentResult(), e, t, i, n, function() {
    }, r), e.current;
  }
  function mb(e, t) {
    var r;
    return (e == null ? void 0 : e.fetchPolicy) || ((r = t == null ? void 0 : t.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
  }
  function Ur2(e) {
    return M4(e.errors) ? new f8({ graphQLErrors: e.errors }) : e.error;
  }
  function jg(e, t, r, n) {
    var i = e.data;
    e.partial;
    var o = yr(e, ["data", "partial"]), u = C2(C2({ data: i }, o), { client: n, observable: r, variables: r.variables, called: e !== Jz && e !== eU, previousData: t });
    return u;
  }
  function qr2(e, t, r) {
    return e.partial && r && !e.loading && (!e.data || Object.keys(e.data).length === 0) && t.options.fetchPolicy !== "cache-only" ? (t.refetch(), C2(C2({}, e), { loading: !0, networkStatus: de.refetch })) : e;
  }
  var Jz = Q9({
    loading: !0,
    data: void 0,
    error: void 0,
    networkStatus: de.loading
  }), eU = Q9({
    loading: !1,
    data: void 0,
    error: void 0,
    networkStatus: de.ready
  });
  function Wr2(e) {
    return {
      refetch: e.refetch.bind(e),
      reobserve: e.reobserve.bind(e),
      fetchMore: e.fetchMore.bind(e),
      updateQuery: e.updateQuery.bind(e),
      startPolling: e.startPolling.bind(e),
      stopPolling: e.stopPolling.bind(e),
      subscribeToMore: e.subscribeToMore.bind(e)
    };
  }
  var Yr2 = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "stopPolling",
    "subscribeToMore"
  ];
  function $r2(e, t) {
    var r, n = ke.useRef(void 0), i = ke.useRef(void 0), o = ke.useRef(void 0), u = C9(t, n.current || {}), c = (r = u == null ? void 0 : u.query) !== null && r !== void 0 ? r : e;
    i.current = t, o.current = c;
    var f = C2(C2({}, u), { skip: !n.current }), d = Kz(c, f), g = d.obsQueryFields, h = d.result, E = d.client, y = d.resultData, I = d.observable, Q = d.onQueryExecuted, B = I.options.initialFetchPolicy || mb(f.defaultOptions, E.defaultOptions), _ = ke.useReducer(function(F) {
      return F + 1;
    }, 0)[1], M = ke.useMemo(function() {
      for (var F = {}, z = function(W) {
        var t2 = g[W];
        F[W] = function() {
          return n.current || (n.current = /* @__PURE__ */ Object.create(null), _()), t2.apply(this, arguments);
        };
      }, Z = 0, V = Yr2; Z < V.length; Z++) {
        var $ = V[Z];
        z($);
      }
      return F;
    }, [_, g]), S = !!n.current, O = ke.useMemo(function() {
      return C2(C2(C2({}, h), M), { called: S });
    }, [h, M, S]), w = ke.useCallback(function(F) {
      n.current = F ? C2(C2({}, F), { fetchPolicy: F.fetchPolicy || B }) : {
        fetchPolicy: B
      };
      var z = C9(i.current, C2({ query: o.current }, n.current)), Z = Gr2(y, I, E, c, C2(C2({}, z), { skip: !1 }), Q).then(function(V) {
        return Object.assign(V, M);
      });
      return Z.catch(function() {
      }), Z;
    }, [
      E,
      c,
      M,
      B,
      I,
      y,
      Q
    ]), D = ke.useRef(w);
    Lr2(function() {
      D.current = w;
    });
    var k = ke.useCallback(function() {
      for (var F = [], z = 0; z < arguments.length; z++)
        F[z] = arguments[z];
      return D.current.apply(D, F);
    }, []);
    return [k, O];
  }
  function Gr2(e, t, r, n, i, o) {
    var u = i.query || n, c = Xz(r, u, i, !1)(t), f = t.reobserveAsConcast(bS(t, r, i, c));
    return o(c), new Promise(function(d) {
      var g;
      f.subscribe({
        next: function(h) {
          g = h;
        },
        error: function() {
          d(jg(t.getCurrentResult(), e.previousData, t, r));
        },
        complete: function() {
          d(jg(t.maskResult(g), e.previousData, t, r));
        }
      });
    });
  }
  const Kr2 = (
    // This file is used by the error message display website and the
    // @apollo/client/includeErrors entry point.
    // This file is not meant to be imported manually.
    {
      2: {
        file: "@apollo/client/cache/inmemory/entityStore.js",
        condition: 'typeof dataId === "string"',
        message: "store.merge expects a string ID"
      },
      5: {
        file: "@apollo/client/cache/inmemory/key-extractor.js",
        condition: "extracted !== void 0",
        message: "Missing field '%s' while extracting keyFields from %s"
      },
      6: {
        file: "@apollo/client/cache/inmemory/policies.js",
        condition: "!old || old === which",
        message: "Cannot change root %s __typename more than once"
      },
      9: {
        file: "@apollo/client/cache/inmemory/policies.js",
        message: "Cannot automatically merge arrays"
      },
      10: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        message: "No fragment named %s"
      },
      11: {
        file: "@apollo/client/cache/inmemory/readFromStore.js",
        condition: "!isReference(value)",
        message: "Missing selection set for object of type %s returned for query field %s"
      },
      12: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "Could not identify object %s"
      },
      14: {
        file: "@apollo/client/cache/inmemory/writeToStore.js",
        message: "No fragment named %s"
      },
      16: {
        file: "@apollo/client/core/ApolloClient.js",
        message: `To initialize Apollo Client, you must specify a 'cache' property in the options object. 
For more information, please visit: https://go.apollo.dev/c/docs`
      },
      17: {
        file: "@apollo/client/core/ApolloClient.js",
        condition: 'options.fetchPolicy !== "cache-and-network"',
        message: "The cache-and-network fetchPolicy does not work with client.query, because client.query can only return a single result. Please use client.watchQuery to receive multiple results from the cache and the network, or consider using a different fetchPolicy, such as cache-first or network-only."
      },
      19: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      20: {
        file: "@apollo/client/core/LocalState.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      22: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "updateQuery",
        message: "You must provide an `updateQuery` function when using `fetchMore` with a `no-cache` fetch policy."
      },
      24: {
        file: "@apollo/client/core/ObservableQuery.js",
        condition: "pollInterval",
        message: "Attempted to start a polling query without a polling interval."
      },
      27: {
        file: "@apollo/client/core/QueryManager.js",
        message: "QueryManager stopped while query was in flight"
      },
      28: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "mutation",
        message: "mutation option is required. You must specify your GraphQL document in the mutation option."
      },
      29: {
        file: "@apollo/client/core/QueryManager.js",
        condition: 'fetchPolicy === "network-only" || fetchPolicy === "no-cache"',
        message: "Mutations support only 'network-only' or 'no-cache' fetchPolicy strings. The default `network-only` behavior automatically writes mutation results to the cache. Passing `no-cache` skips the cache write."
      },
      30: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "options.query",
        message: "query option is required. You must specify your GraphQL document in the query option."
      },
      31: {
        file: "@apollo/client/core/QueryManager.js",
        condition: 'options.query.kind === "Document"',
        message: 'You must wrap the query string in a "gql" tag.'
      },
      32: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.returnPartialData",
        message: "returnPartialData option only supported on watchQuery."
      },
      33: {
        file: "@apollo/client/core/QueryManager.js",
        condition: "!options.pollInterval",
        message: "pollInterval option only supported on watchQuery."
      },
      34: {
        file: "@apollo/client/core/QueryManager.js",
        message: "Store reset while query was in flight (not completed in link chain)"
      },
      39: {
        file: "@apollo/client/link/core/ApolloLink.js",
        message: "request is not implemented"
      },
      40: {
        file: "@apollo/client/link/http/checkFetcher.js",
        message: `
"fetch" has not been found globally and no fetcher has been configured. To fix this, install a fetch package (like https://www.npmjs.com/package/cross-fetch), instantiate the fetcher, and pass it into your HttpLink constructor. For example:

import fetch from 'cross-fetch';
import { ApolloClient, HttpLink } from '@apollo/client';
const client = new ApolloClient({
  link: new HttpLink({ uri: '/graphql', fetch })
});
    `
      },
      42: {
        file: "@apollo/client/link/http/serializeFetchParameter.js",
        message: "Network request failed. %s is not serializable: %s"
      },
      43: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: `options &&
    (typeof options.sha256 === "function" ||
        typeof options.generateHash === "function")`,
        message: 'Missing/invalid "sha256" or "generateHash" function. Please configure one using the "createPersistedQueryLink(options)" options parameter.'
      },
      44: {
        file: "@apollo/client/link/persisted-queries/index.js",
        condition: "forward",
        message: "PersistedQueryLink cannot be the last link in the chain."
      },
      46: {
        file: "@apollo/client/link/utils/validateOperation.js",
        message: "illegal argument: %s"
      },
      47: {
        file: "@apollo/client/masking/maskDefinition.js",
        condition: "fragment",
        message: "Could not find fragment with name '%s'."
      },
      49: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
      },
      50: {
        file: "@apollo/client/masking/maskFragment.js",
        condition: "!!fragment",
        message: 'Could not find fragment with name "%s".'
      },
      51: {
        file: "@apollo/client/masking/maskOperation.js",
        condition: "definition",
        message: "Expected a parsed GraphQL document with a query, mutation, or subscription."
      },
      53: {
        file: "@apollo/client/react/context/ApolloConsumer.js",
        condition: "context && context.client",
        message: 'Could not find "client" in the context of ApolloConsumer. Wrap the root component in an <ApolloProvider>.'
      },
      54: {
        file: "@apollo/client/react/context/ApolloContext.js",
        condition: '"createContext" in React',
        message: 'Invoking `getApolloContext` in an environment where `React.createContext` is not available.\nThe Apollo Client functionality you are trying to use is only available in React Client Components.\nPlease make sure to add "use client" at the top of your file.\nFor more information, see https://nextjs.org/docs/getting-started/react-essentials#client-components'
      },
      55: {
        file: "@apollo/client/react/context/ApolloProvider.js",
        condition: "context.client",
        message: 'ApolloProvider was not passed a client instance. Make sure you pass in your client via the "client" prop.'
      },
      56: {
        file: "@apollo/client/react/hoc/hoc-utils.js",
        condition: "this.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
      },
      57: {
        file: "@apollo/client/react/hoc/withApollo.js",
        condition: "operationOptions.withRef",
        message: "To access the wrapped instance, you need to specify { withRef: true } in the options"
      },
      58: {
        file: "@apollo/client/react/hooks/useApolloClient.js",
        condition: "!!client",
        message: 'Could not find "client" in the context or passed in as an option. Wrap the root component in an <ApolloProvider>, or pass an ApolloClient instance in via options.'
      },
      59: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "!calledDuringRender()",
        message: "useLoadableQuery: 'loadQuery' should not be called during render. To start a query during render, use the 'useBackgroundQuery' hook."
      },
      60: {
        file: "@apollo/client/react/hooks/useLoadableQuery.js",
        condition: "internalQueryRef",
        message: "The query has not been loaded. Please load the query."
      },
      65: {
        file: "@apollo/client/react/hooks/useSubscription.js",
        condition: "!optionsRef.current.skip",
        message: "A subscription that is skipped cannot be restarted."
      },
      66: {
        file: "@apollo/client/react/hooks/useSuspenseQuery.js",
        condition: "supportedFetchPolicies.includes(fetchPolicy)",
        message: "The fetch policy `%s` is not supported with suspense."
      },
      69: {
        file: "@apollo/client/react/internal/cache/QueryReference.js",
        condition: "!queryRef || QUERY_REFERENCE_SYMBOL in queryRef",
        message: "Expected a QueryRef object, but got something else instead."
      },
      70: {
        file: "@apollo/client/react/parser/index.js",
        condition: "!!document && !!document.kind",
        message: "Argument of %s passed to parser was not a valid GraphQL DocumentNode. You may need to use 'graphql-tag' or another method to convert your operation into a document"
      },
      71: {
        file: "@apollo/client/react/parser/index.js",
        condition: `!fragments.length ||
    queries.length ||
    mutations.length ||
    subscriptions.length`,
        message: "Passing only a fragment to 'graphql' is not yet supported. You must include a query, subscription or mutation as well"
      },
      72: {
        file: "@apollo/client/react/parser/index.js",
        condition: "queries.length + mutations.length + subscriptions.length <= 1",
        message: "react-apollo only supports a query, subscription, or a mutation per HOC. %s had %s queries, %s subscriptions and %s mutations. You can use 'compose' to join multiple operation types to a component"
      },
      73: {
        file: "@apollo/client/react/parser/index.js",
        condition: "definitions.length === 1",
        message: "react-apollo only supports one definition per HOC. %s had %s definitions. You can use 'compose' to join multiple operation types to a component"
      },
      74: {
        file: "@apollo/client/react/parser/index.js",
        condition: "operation.type === type",
        message: "Running a %s requires a graphql %s, but a %s was used instead."
      },
      75: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "queryWithoutClientOnlyDirectives",
        message: "query is required"
      },
      76: {
        file: "@apollo/client/testing/core/mocking/mockLink.js",
        condition: "mockedResponse.maxUsageCount > 0",
        message: "Mock response maxUsageCount must be greater than 0, %s given"
      },
      77: {
        file: "@apollo/client/utilities/graphql/DocumentTransform.js",
        condition: "Array.isArray(cacheKeys)",
        message: "`getCacheKey` must return an array or undefined"
      },
      78: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "evaledValue !== void 0",
        message: "Invalid variable referenced in @%s directive."
      },
      79: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: "directiveArguments && directiveArguments.length === 1",
        message: "Incorrect number of arguments for the @%s directive."
      },
      80: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: 'ifArgument.name && ifArgument.name.value === "if"',
        message: "Invalid argument for the @%s directive."
      },
      81: {
        file: "@apollo/client/utilities/graphql/directives.js",
        condition: `ifValue &&
    (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue")`,
        message: "Argument for the @%s directive must be a variable or a boolean value."
      },
      85: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        message: "Found a %s operation%s. No operations are allowed when using a fragment as a query. Only fragments are allowed."
      },
      86: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragments.length === 1",
        message: "Found %s fragments. `fragmentName` must be provided when there is not exactly 1 fragment."
      },
      87: {
        file: "@apollo/client/utilities/graphql/fragments.js",
        condition: "fragment",
        message: "No fragment named %s"
      },
      88: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'doc && doc.kind === "Document"',
        message: 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql'
      },
      89: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: 'Schema type definitions not allowed in queries. Found: "%s"'
      },
      90: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "operations.length <= 1",
        message: "Ambiguous GraphQL document: contains %s operations"
      },
      91: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'queryDef && queryDef.operation === "query"',
        message: "Must contain a query definition."
      },
      92: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'doc.kind === "Document"',
        message: 'Expecting a parsed GraphQL document. Perhaps you need to wrap the query string in a "gql" tag? http://docs.apollostack.com/apollo-client/core.html#gql'
      },
      93: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: "doc.definitions.length <= 1",
        message: "Fragment must have exactly one definition."
      },
      94: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        condition: 'fragmentDef.kind === "FragmentDefinition"',
        message: "Must be a fragment definition."
      },
      95: {
        file: "@apollo/client/utilities/graphql/getFromAST.js",
        message: "Expected a parsed GraphQL query with a query, mutation, subscription, or a fragment."
      },
      96: {
        file: "@apollo/client/utilities/graphql/storeUtils.js",
        message: 'The inline argument "%s" of kind "%s"is not supported. Use variables instead of inline arguments to overcome this limitation.'
      }
    }
  ), Xr2 = {
    18: {
      file: "@apollo/client/core/ApolloClient.js",
      message: "In client.refetchQueries, Promise.all promise rejected with error %o"
    },
    26: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Missing cache result fields: %o"
    }
  }, Jr2 = {}, e42 = {
    1: {
      file: "@apollo/client/cache/core/cache.js",
      message: "Could not identify object passed to `from` for '%s' fragment, either because the object is non-normalized or the key fields are missing. If you are masking this object, please ensure the key fields are requested by the parent object."
    },
    3: {
      file: "@apollo/client/cache/inmemory/entityStore.js",
      message: "cache.modify: You are trying to write a Reference that is not part of the store: %o\nPlease make sure to set the `mergeIntoStore` parameter to `true` when creating a Reference that is not part of the store yet:\n`toReference(object, true)`"
    },
    4: {
      file: "@apollo/client/cache/inmemory/entityStore.js",
      message: "cache.modify: Writing an array with a mix of both References and Objects will not result in the Objects being normalized correctly.\nPlease convert the object instance %o to a Reference before writing it to the cache by calling `toReference(object, true)`."
    },
    7: {
      file: "@apollo/client/cache/inmemory/policies.js",
      message: "Inferring subtype %s of supertype %s"
    },
    8: {
      file: "@apollo/client/cache/inmemory/policies.js",
      message: "Undefined 'from' passed to readField with arguments %s"
    },
    15: {
      file: "@apollo/client/cache/inmemory/writeToStore.js",
      message: `Cache data may be lost when replacing the %s field of a %s object.

This could cause additional (usually avoidable) network requests to fetch data that were otherwise cached.

To address this problem (which is not a bug in Apollo Client), %sdefine a custom merge function for the %s field, so InMemoryCache can safely merge these objects:

  existing: %o
  incoming: %o

For more information about these options, please refer to the documentation:

  * Ensuring entity objects have IDs: https://go.apollo.dev/c/generating-unique-identifiers
  * Defining custom merge functions: https://go.apollo.dev/c/merging-non-normalized-objects
`
    },
    21: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: `Called refetch(%o) for query %o, which does not declare a $variables variable.
Did you mean to call refetch(variables) instead of refetch({ variables })?`
    },
    35: {
      file: "@apollo/client/core/QueryManager.js",
      message: 'Unknown query named "%s" requested in refetchQueries options.include array'
    },
    36: {
      file: "@apollo/client/core/QueryManager.js",
      message: "Unknown anonymous query requested in refetchQueries options.include array"
    },
    37: {
      file: "@apollo/client/core/QueryManager.js",
      message: '[%s]: Fragments masked by data masking are inaccessible when using fetch policy "no-cache". Please add `@unmask` to each fragment spread to access the data.'
    },
    38: {
      file: "@apollo/client/link/core/ApolloLink.js",
      message: "You are calling concat on a terminating link, which will have no effect %o"
    },
    41: {
      file: "@apollo/client/link/http/createHttpLink.js",
      message: "Multipart-subscriptions do not support @defer"
    },
    45: {
      file: "@apollo/client/link/utils/toPromise.js",
      message: "Promise Wrapper does not support multiple results from Observable"
    },
    48: {
      file: "@apollo/client/masking/maskDefinition.js",
      message: "Accessing unmasked field on %s at path '%s'. This field will not be available when masking is enabled. Please read the field from the fragment instead."
    },
    52: {
      file: "@apollo/client/masking/utils.js",
      message: "The configured cache does not support data masking which effectively disables it. Please use a cache that supports data masking or disable data masking to silence this warning."
    },
    61: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'useSubscription' supports only the 'onSubscriptionData' or 'onData' option, but not both. Only the 'onData' option will be used."
    },
    62: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'onSubscriptionData' is deprecated and will be removed in a future major version. Please use the 'onData' option instead."
    },
    63: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'useSubscription' supports only the 'onSubscriptionComplete' or 'onComplete' option, but not both. Only the 'onComplete' option will be used."
    },
    64: {
      file: "@apollo/client/react/hooks/useSubscription.js",
      message: "'onSubscriptionComplete' is deprecated and will be removed in a future major version. Please use the 'onComplete' option instead."
    },
    67: {
      file: "@apollo/client/react/hooks/useSuspenseQuery.js",
      message: "Using `returnPartialData` with a `no-cache` fetch policy has no effect. To read partial data from the cache, consider using an alternate fetch policy."
    },
    82: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument does not support variables."
    },
    83: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument must be of type string."
    },
    84: {
      file: "@apollo/client/utilities/graphql/directives.js",
      message: "@unmask 'mode' argument does not recognize value '%s'."
    },
    98: {
      file: "@apollo/client/utilities/graphql/transform.js",
      message: "Removing an @connection directive even though it does not have a key. You may want to use the key parameter to specify a store key."
    }
  }, t42 = {
    13: {
      file: "@apollo/client/cache/inmemory/writeToStore.js",
      message: "Missing field '%s' while writing result %o"
    },
    23: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Unhandled GraphQL subscription error"
    },
    25: {
      file: "@apollo/client/core/ObservableQuery.js",
      message: "Unhandled error"
    },
    68: {
      file: "@apollo/client/react/hooks/useSyncExternalStore.js",
      message: "The result of getSnapshot should be cached to avoid an infinite loop"
    },
    97: {
      file: "@apollo/client/utilities/graphql/transform.js",
      message: "Could not find operation or fragment"
    }
  };
  function r42(e) {
    sc[Rg] = e;
  }
  function tU() {
    for (var e = [], t = 0; t < arguments.length; t++)
      e[t] = arguments[t];
    r42(Ty);
    for (var r = 0, n = e; r < n.length; r++) {
      var i = n[r];
      Object.assign(Ty, i);
    }
    return Ty;
  }
  var Ty = function(e, t) {
    if (typeof e == "number") {
      var r = sc[Rg][e];
      if (!e || !(r != null && r.message))
        return;
      e = r.message;
    }
    return t.reduce(function(n, i) {
      return n.replace(/%[sdfo]/, String(i));
    }, String(e));
  };
  function n42() {
    tU(Xr2, t42, Jr2, e42);
  }
  function i42() {
    tU(Kr2);
  }
  function rU(e) {
    var t, r, n = "";
    if (typeof e == "string" || typeof e == "number") n += e;
    else if (typeof e == "object") if (Array.isArray(e)) {
      var i = e.length;
      for (t = 0; t < i; t++) e[t] && (r = rU(e[t])) && (n && (n += " "), n += r);
    } else for (r in e) e[r] && (n && (n += " "), n += r);
    return n;
  }
  function pe() {
    for (var e, t, r = 0, n = "", i = arguments.length; r < i; r++) (e = arguments[r]) && (t = rU(e)) && (n && (n += " "), n += t);
    return n;
  }
  const wS = "-", a42 = (e) => {
    const t = s42(e), {
      conflictingClassGroups: r,
      conflictingClassGroupModifiers: n
    } = e;
    return {
      getClassGroupId: (u) => {
        const c = u.split(wS);
        return c[0] === "" && c.length !== 1 && c.shift(), nU(c, t) || o42(u);
      },
      getConflictingClassGroupIds: (u, c) => {
        const f = r[u] || [];
        return c && n[u] ? [...f, ...n[u]] : f;
      }
    };
  }, nU = (e, t) => {
    var u;
    if (e.length === 0)
      return t.classGroupId;
    const r = e[0], n = t.nextPart.get(r), i = n ? nU(e.slice(1), n) : void 0;
    if (i)
      return i;
    if (t.validators.length === 0)
      return;
    const o = e.join(wS);
    return (u = t.validators.find(({
      validator: c
    }) => c(o))) == null ? void 0 : u.classGroupId;
  }, uk = /^\[(.+)\]$/, o42 = (e) => {
    if (uk.test(e)) {
      const t = uk.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
      if (r)
        return "arbitrary.." + r;
    }
  }, s42 = (e) => {
    const {
      theme: t,
      classGroups: r
    } = e, n = {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    };
    for (const i in r)
      yb(r[i], n, i, t);
    return n;
  }, yb = (e, t, r, n) => {
    e.forEach((i) => {
      if (typeof i == "string") {
        const o = i === "" ? t : lk(t, i);
        o.classGroupId = r;
        return;
      }
      if (typeof i == "function") {
        if (u42(i)) {
          yb(i(n), t, r, n);
          return;
        }
        t.validators.push({
          validator: i,
          classGroupId: r
        });
        return;
      }
      Object.entries(i).forEach(([o, u]) => {
        yb(u, lk(t, o), r, n);
      });
    });
  }, lk = (e, t) => {
    let r = e;
    return t.split(wS).forEach((n) => {
      r.nextPart.has(n) || r.nextPart.set(n, {
        nextPart: /* @__PURE__ */ new Map(),
        validators: []
      }), r = r.nextPart.get(n);
    }), r;
  }, u42 = (e) => e.isThemeGetter, l42 = (e) => {
    if (e < 1)
      return {
        get: () => {
        },
        set: () => {
        }
      };
    let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
    const i = (o, u) => {
      r.set(o, u), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
    };
    return {
      get(o) {
        let u = r.get(o);
        if (u !== void 0)
          return u;
        if ((u = n.get(o)) !== void 0)
          return i(o, u), u;
      },
      set(o, u) {
        r.has(o) ? r.set(o, u) : i(o, u);
      }
    };
  }, Ib = "!", Bb = ":", c42 = Bb.length, A42 = (e) => {
    const {
      prefix: t,
      experimentalParseClassName: r
    } = e;
    let n = (i) => {
      const o = [];
      let u = 0, c = 0, f = 0, d;
      for (let I = 0; I < i.length; I++) {
        let Q = i[I];
        if (u === 0 && c === 0) {
          if (Q === Bb) {
            o.push(i.slice(f, I)), f = I + c42;
            continue;
          }
          if (Q === "/") {
            d = I;
            continue;
          }
        }
        Q === "[" ? u++ : Q === "]" ? u-- : Q === "(" ? c++ : Q === ")" && c--;
      }
      const g = o.length === 0 ? i : i.substring(f), h = f42(g), E = h !== g, y = d && d > f ? d - f : void 0;
      return {
        modifiers: o,
        hasImportantModifier: E,
        baseClassName: h,
        maybePostfixModifierPosition: y
      };
    };
    if (t) {
      const i = t + Bb, o = n;
      n = (u) => u.startsWith(i) ? o(u.substring(i.length)) : {
        isExternal: !0,
        modifiers: [],
        hasImportantModifier: !1,
        baseClassName: u,
        maybePostfixModifierPosition: void 0
      };
    }
    if (r) {
      const i = n;
      n = (o) => r({
        className: o,
        parseClassName: i
      });
    }
    return n;
  }, f42 = (e) => e.endsWith(Ib) ? e.substring(0, e.length - 1) : e.startsWith(Ib) ? e.substring(1) : e, C42 = (e) => {
    const t = Object.fromEntries(e.orderSensitiveModifiers.map((n) => [n, !0]));
    return (n) => {
      if (n.length <= 1)
        return n;
      const i = [];
      let o = [];
      return n.forEach((u) => {
        u[0] === "[" || t[u] ? (i.push(...o.sort(), u), o = []) : o.push(u);
      }), i.push(...o.sort()), i;
    };
  }, d42 = (e) => ({
    cache: l42(e.cacheSize),
    parseClassName: A42(e),
    sortModifiers: C42(e),
    ...a42(e)
  }), g42 = /\s+/, p42 = (e, t) => {
    const {
      parseClassName: r,
      getClassGroupId: n,
      getConflictingClassGroupIds: i,
      sortModifiers: o
    } = t, u = [], c = e.trim().split(g42);
    let f = "";
    for (let d = c.length - 1; d >= 0; d -= 1) {
      const g = c[d], {
        isExternal: h,
        modifiers: E,
        hasImportantModifier: y,
        baseClassName: I,
        maybePostfixModifierPosition: Q
      } = r(g);
      if (h) {
        f = g + (f.length > 0 ? " " + f : f);
        continue;
      }
      let B = !!Q, _ = n(B ? I.substring(0, Q) : I);
      if (!_) {
        if (!B) {
          f = g + (f.length > 0 ? " " + f : f);
          continue;
        }
        if (_ = n(I), !_) {
          f = g + (f.length > 0 ? " " + f : f);
          continue;
        }
        B = !1;
      }
      const M = o(E).join(":"), S = y ? M + Ib : M, O = S + _;
      if (u.includes(O))
        continue;
      u.push(O);
      const w = i(_, B);
      for (let D = 0; D < w.length; ++D) {
        const k = w[D];
        u.push(S + k);
      }
      f = g + (f.length > 0 ? " " + f : f);
    }
    return f;
  };
  function h42() {
    let e = 0, t, r, n = "";
    for (; e < arguments.length; )
      (t = arguments[e++]) && (r = iU(t)) && (n && (n += " "), n += r);
    return n;
  }
  const iU = (e) => {
    if (typeof e == "string")
      return e;
    let t, r = "";
    for (let n = 0; n < e.length; n++)
      e[n] && (t = iU(e[n])) && (r && (r += " "), r += t);
    return r;
  };
  function v42(e, ...t) {
    let r, n, i, o = u;
    function u(f) {
      const d = t.reduce((g, h) => h(g), e());
      return r = d42(d), n = r.cache.get, i = r.cache.set, o = c, c(f);
    }
    function c(f) {
      const d = n(f);
      if (d)
        return d;
      const g = p42(f, r);
      return i(f, g), g;
    }
    return function() {
      return o(h42.apply(null, arguments));
    };
  }
  const _5 = (e) => {
    const t = (r) => r[e] || [];
    return t.isThemeGetter = !0, t;
  }, aU = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, oU = /^\((?:(\w[\w-]*):)?(.+)\)$/i, E42 = /^\d+\/\d+$/, m42 = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, y42 = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, I42 = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, B42 = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Q42 = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, qo = (e) => E42.test(e), ee = (e) => !!e && !Number.isNaN(Number(e)), M6 = (e) => !!e && Number.isInteger(Number(e)), Dy = (e) => e.endsWith("%") && ee(e.slice(0, -1)), c8 = (e) => m42.test(e), x42 = () => !0, b42 = (e) => (
    // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
    // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
    // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
    y42.test(e) && !I42.test(e)
  ), sU = () => !1, w42 = (e) => B42.test(e), S42 = (e) => Q42.test(e), M42 = (e) => !h0(e) && !v0(e), _42 = (e) => is(e, cU, sU), h0 = (e) => aU.test(e), mi = (e) => is(e, AU, b42), Ly = (e) => is(e, k42, ee), ck = (e) => is(e, uU, sU), O42 = (e) => is(e, lU, S42), Ed = (e) => is(e, fU, w42), v0 = (e) => oU.test(e), Ol = (e) => as(e, AU), T42 = (e) => as(e, R42), Ak = (e) => as(e, uU), D42 = (e) => as(e, cU), L42 = (e) => as(e, lU), md = (e) => as(e, fU, !0), is = (e, t, r) => {
    const n = aU.exec(e);
    return n ? n[1] ? t(n[1]) : r(n[2]) : !1;
  }, as = (e, t, r = !1) => {
    const n = oU.exec(e);
    return n ? n[1] ? t(n[1]) : r : !1;
  }, uU = (e) => e === "position" || e === "percentage", lU = (e) => e === "image" || e === "url", cU = (e) => e === "length" || e === "size" || e === "bg-size", AU = (e) => e === "length", k42 = (e) => e === "number", R42 = (e) => e === "family-name", fU = (e) => e === "shadow", P42 = () => {
    const e = _5("color"), t = _5("font"), r = _5("text"), n = _5("font-weight"), i = _5("tracking"), o = _5("leading"), u = _5("breakpoint"), c = _5("container"), f = _5("spacing"), d = _5("radius"), g = _5("shadow"), h = _5("inset-shadow"), E = _5("text-shadow"), y = _5("drop-shadow"), I = _5("blur"), Q = _5("perspective"), B = _5("aspect"), _ = _5("ease"), M = _5("animate"), S = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], O = () => [
      "center",
      "top",
      "bottom",
      "left",
      "right",
      "top-left",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "left-top",
      "top-right",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "right-top",
      "bottom-right",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "right-bottom",
      "bottom-left",
      // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
      "left-bottom"
    ], w = () => [...O(), v0, h0], D = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", "contain", "none"], F = () => [v0, h0, f], z = () => [qo, "full", "auto", ...F()], Z = () => [M6, "none", "subgrid", v0, h0], V = () => ["auto", {
      span: ["full", M6, v0, h0]
    }, M6, v0, h0], $ = () => [M6, "auto", v0, h0], W = () => ["auto", "min", "max", "fr", v0, h0], t2 = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], n2 = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], s2 = () => ["auto", ...F()], l2 = () => [qo, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...F()], X = () => [e, v0, h0], a2 = () => [...O(), Ak, ck, {
      position: [v0, h0]
    }], e2 = () => ["no-repeat", {
      repeat: ["", "x", "y", "space", "round"]
    }], H = () => ["auto", "cover", "contain", D42, _42, {
      size: [v0, h0]
    }], Y = () => [Dy, Ol, mi], r2 = () => [
      // Deprecated since Tailwind CSS v4.0.0
      "",
      "none",
      "full",
      d,
      v0,
      h0
    ], o2 = () => ["", ee, Ol, mi], O2 = () => ["solid", "dashed", "dotted", "double"], S2 = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], M2 = () => [ee, Dy, Ak, ck], w2 = () => [
      // Deprecated since Tailwind CSS v4.0.0
      "",
      "none",
      I,
      v0,
      h0
    ], v2 = () => ["none", ee, v0, h0], L2 = () => ["none", ee, v0, h0], W2 = () => [ee, v0, h0], d2 = () => [qo, "full", ...F()];
    return {
      cacheSize: 500,
      theme: {
        animate: ["spin", "ping", "pulse", "bounce"],
        aspect: ["video"],
        blur: [c8],
        breakpoint: [c8],
        color: [x42],
        container: [c8],
        "drop-shadow": [c8],
        ease: ["in", "out", "in-out"],
        font: [M42],
        "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
        "inset-shadow": [c8],
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
        perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
        radius: [c8],
        shadow: [c8],
        spacing: ["px", ee],
        text: [c8],
        "text-shadow": [c8],
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
      },
      classGroups: {
        // --------------
        // --- Layout ---
        // --------------
        /**
         * Aspect Ratio
         * @see https://tailwindcss.com/docs/aspect-ratio
         */
        aspect: [{
          aspect: ["auto", "square", qo, h0, v0, B]
        }],
        /**
         * Container
         * @see https://tailwindcss.com/docs/container
         * @deprecated since Tailwind CSS v4.0.0
         */
        container: ["container"],
        /**
         * Columns
         * @see https://tailwindcss.com/docs/columns
         */
        columns: [{
          columns: [ee, h0, v0, c]
        }],
        /**
         * Break After
         * @see https://tailwindcss.com/docs/break-after
         */
        "break-after": [{
          "break-after": S()
        }],
        /**
         * Break Before
         * @see https://tailwindcss.com/docs/break-before
         */
        "break-before": [{
          "break-before": S()
        }],
        /**
         * Break Inside
         * @see https://tailwindcss.com/docs/break-inside
         */
        "break-inside": [{
          "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
        }],
        /**
         * Box Decoration Break
         * @see https://tailwindcss.com/docs/box-decoration-break
         */
        "box-decoration": [{
          "box-decoration": ["slice", "clone"]
        }],
        /**
         * Box Sizing
         * @see https://tailwindcss.com/docs/box-sizing
         */
        box: [{
          box: ["border", "content"]
        }],
        /**
         * Display
         * @see https://tailwindcss.com/docs/display
         */
        display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
        /**
         * Screen Reader Only
         * @see https://tailwindcss.com/docs/display#screen-reader-only
         */
        sr: ["sr-only", "not-sr-only"],
        /**
         * Floats
         * @see https://tailwindcss.com/docs/float
         */
        float: [{
          float: ["right", "left", "none", "start", "end"]
        }],
        /**
         * Clear
         * @see https://tailwindcss.com/docs/clear
         */
        clear: [{
          clear: ["left", "right", "both", "none", "start", "end"]
        }],
        /**
         * Isolation
         * @see https://tailwindcss.com/docs/isolation
         */
        isolation: ["isolate", "isolation-auto"],
        /**
         * Object Fit
         * @see https://tailwindcss.com/docs/object-fit
         */
        "object-fit": [{
          object: ["contain", "cover", "fill", "none", "scale-down"]
        }],
        /**
         * Object Position
         * @see https://tailwindcss.com/docs/object-position
         */
        "object-position": [{
          object: w()
        }],
        /**
         * Overflow
         * @see https://tailwindcss.com/docs/overflow
         */
        overflow: [{
          overflow: D()
        }],
        /**
         * Overflow X
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-x": [{
          "overflow-x": D()
        }],
        /**
         * Overflow Y
         * @see https://tailwindcss.com/docs/overflow
         */
        "overflow-y": [{
          "overflow-y": D()
        }],
        /**
         * Overscroll Behavior
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        overscroll: [{
          overscroll: k()
        }],
        /**
         * Overscroll Behavior X
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-x": [{
          "overscroll-x": k()
        }],
        /**
         * Overscroll Behavior Y
         * @see https://tailwindcss.com/docs/overscroll-behavior
         */
        "overscroll-y": [{
          "overscroll-y": k()
        }],
        /**
         * Position
         * @see https://tailwindcss.com/docs/position
         */
        position: ["static", "fixed", "absolute", "relative", "sticky"],
        /**
         * Top / Right / Bottom / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        inset: [{
          inset: z()
        }],
        /**
         * Right / Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-x": [{
          "inset-x": z()
        }],
        /**
         * Top / Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        "inset-y": [{
          "inset-y": z()
        }],
        /**
         * Start
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        start: [{
          start: z()
        }],
        /**
         * End
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        end: [{
          end: z()
        }],
        /**
         * Top
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        top: [{
          top: z()
        }],
        /**
         * Right
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        right: [{
          right: z()
        }],
        /**
         * Bottom
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        bottom: [{
          bottom: z()
        }],
        /**
         * Left
         * @see https://tailwindcss.com/docs/top-right-bottom-left
         */
        left: [{
          left: z()
        }],
        /**
         * Visibility
         * @see https://tailwindcss.com/docs/visibility
         */
        visibility: ["visible", "invisible", "collapse"],
        /**
         * Z-Index
         * @see https://tailwindcss.com/docs/z-index
         */
        z: [{
          z: [M6, "auto", v0, h0]
        }],
        // ------------------------
        // --- Flexbox and Grid ---
        // ------------------------
        /**
         * Flex Basis
         * @see https://tailwindcss.com/docs/flex-basis
         */
        basis: [{
          basis: [qo, "full", "auto", c, ...F()]
        }],
        /**
         * Flex Direction
         * @see https://tailwindcss.com/docs/flex-direction
         */
        "flex-direction": [{
          flex: ["row", "row-reverse", "col", "col-reverse"]
        }],
        /**
         * Flex Wrap
         * @see https://tailwindcss.com/docs/flex-wrap
         */
        "flex-wrap": [{
          flex: ["nowrap", "wrap", "wrap-reverse"]
        }],
        /**
         * Flex
         * @see https://tailwindcss.com/docs/flex
         */
        flex: [{
          flex: [ee, qo, "auto", "initial", "none", h0]
        }],
        /**
         * Flex Grow
         * @see https://tailwindcss.com/docs/flex-grow
         */
        grow: [{
          grow: ["", ee, v0, h0]
        }],
        /**
         * Flex Shrink
         * @see https://tailwindcss.com/docs/flex-shrink
         */
        shrink: [{
          shrink: ["", ee, v0, h0]
        }],
        /**
         * Order
         * @see https://tailwindcss.com/docs/order
         */
        order: [{
          order: [M6, "first", "last", "none", v0, h0]
        }],
        /**
         * Grid Template Columns
         * @see https://tailwindcss.com/docs/grid-template-columns
         */
        "grid-cols": [{
          "grid-cols": Z()
        }],
        /**
         * Grid Column Start / End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start-end": [{
          col: V()
        }],
        /**
         * Grid Column Start
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-start": [{
          "col-start": $()
        }],
        /**
         * Grid Column End
         * @see https://tailwindcss.com/docs/grid-column
         */
        "col-end": [{
          "col-end": $()
        }],
        /**
         * Grid Template Rows
         * @see https://tailwindcss.com/docs/grid-template-rows
         */
        "grid-rows": [{
          "grid-rows": Z()
        }],
        /**
         * Grid Row Start / End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start-end": [{
          row: V()
        }],
        /**
         * Grid Row Start
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-start": [{
          "row-start": $()
        }],
        /**
         * Grid Row End
         * @see https://tailwindcss.com/docs/grid-row
         */
        "row-end": [{
          "row-end": $()
        }],
        /**
         * Grid Auto Flow
         * @see https://tailwindcss.com/docs/grid-auto-flow
         */
        "grid-flow": [{
          "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
        }],
        /**
         * Grid Auto Columns
         * @see https://tailwindcss.com/docs/grid-auto-columns
         */
        "auto-cols": [{
          "auto-cols": W()
        }],
        /**
         * Grid Auto Rows
         * @see https://tailwindcss.com/docs/grid-auto-rows
         */
        "auto-rows": [{
          "auto-rows": W()
        }],
        /**
         * Gap
         * @see https://tailwindcss.com/docs/gap
         */
        gap: [{
          gap: F()
        }],
        /**
         * Gap X
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-x": [{
          "gap-x": F()
        }],
        /**
         * Gap Y
         * @see https://tailwindcss.com/docs/gap
         */
        "gap-y": [{
          "gap-y": F()
        }],
        /**
         * Justify Content
         * @see https://tailwindcss.com/docs/justify-content
         */
        "justify-content": [{
          justify: [...t2(), "normal"]
        }],
        /**
         * Justify Items
         * @see https://tailwindcss.com/docs/justify-items
         */
        "justify-items": [{
          "justify-items": [...n2(), "normal"]
        }],
        /**
         * Justify Self
         * @see https://tailwindcss.com/docs/justify-self
         */
        "justify-self": [{
          "justify-self": ["auto", ...n2()]
        }],
        /**
         * Align Content
         * @see https://tailwindcss.com/docs/align-content
         */
        "align-content": [{
          content: ["normal", ...t2()]
        }],
        /**
         * Align Items
         * @see https://tailwindcss.com/docs/align-items
         */
        "align-items": [{
          items: [...n2(), {
            baseline: ["", "last"]
          }]
        }],
        /**
         * Align Self
         * @see https://tailwindcss.com/docs/align-self
         */
        "align-self": [{
          self: ["auto", ...n2(), {
            baseline: ["", "last"]
          }]
        }],
        /**
         * Place Content
         * @see https://tailwindcss.com/docs/place-content
         */
        "place-content": [{
          "place-content": t2()
        }],
        /**
         * Place Items
         * @see https://tailwindcss.com/docs/place-items
         */
        "place-items": [{
          "place-items": [...n2(), "baseline"]
        }],
        /**
         * Place Self
         * @see https://tailwindcss.com/docs/place-self
         */
        "place-self": [{
          "place-self": ["auto", ...n2()]
        }],
        // Spacing
        /**
         * Padding
         * @see https://tailwindcss.com/docs/padding
         */
        p: [{
          p: F()
        }],
        /**
         * Padding X
         * @see https://tailwindcss.com/docs/padding
         */
        px: [{
          px: F()
        }],
        /**
         * Padding Y
         * @see https://tailwindcss.com/docs/padding
         */
        py: [{
          py: F()
        }],
        /**
         * Padding Start
         * @see https://tailwindcss.com/docs/padding
         */
        ps: [{
          ps: F()
        }],
        /**
         * Padding End
         * @see https://tailwindcss.com/docs/padding
         */
        pe: [{
          pe: F()
        }],
        /**
         * Padding Top
         * @see https://tailwindcss.com/docs/padding
         */
        pt: [{
          pt: F()
        }],
        /**
         * Padding Right
         * @see https://tailwindcss.com/docs/padding
         */
        pr: [{
          pr: F()
        }],
        /**
         * Padding Bottom
         * @see https://tailwindcss.com/docs/padding
         */
        pb: [{
          pb: F()
        }],
        /**
         * Padding Left
         * @see https://tailwindcss.com/docs/padding
         */
        pl: [{
          pl: F()
        }],
        /**
         * Margin
         * @see https://tailwindcss.com/docs/margin
         */
        m: [{
          m: s2()
        }],
        /**
         * Margin X
         * @see https://tailwindcss.com/docs/margin
         */
        mx: [{
          mx: s2()
        }],
        /**
         * Margin Y
         * @see https://tailwindcss.com/docs/margin
         */
        my: [{
          my: s2()
        }],
        /**
         * Margin Start
         * @see https://tailwindcss.com/docs/margin
         */
        ms: [{
          ms: s2()
        }],
        /**
         * Margin End
         * @see https://tailwindcss.com/docs/margin
         */
        me: [{
          me: s2()
        }],
        /**
         * Margin Top
         * @see https://tailwindcss.com/docs/margin
         */
        mt: [{
          mt: s2()
        }],
        /**
         * Margin Right
         * @see https://tailwindcss.com/docs/margin
         */
        mr: [{
          mr: s2()
        }],
        /**
         * Margin Bottom
         * @see https://tailwindcss.com/docs/margin
         */
        mb: [{
          mb: s2()
        }],
        /**
         * Margin Left
         * @see https://tailwindcss.com/docs/margin
         */
        ml: [{
          ml: s2()
        }],
        /**
         * Space Between X
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-x": [{
          "space-x": F()
        }],
        /**
         * Space Between X Reverse
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-x-reverse": ["space-x-reverse"],
        /**
         * Space Between Y
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-y": [{
          "space-y": F()
        }],
        /**
         * Space Between Y Reverse
         * @see https://tailwindcss.com/docs/margin#adding-space-between-children
         */
        "space-y-reverse": ["space-y-reverse"],
        // --------------
        // --- Sizing ---
        // --------------
        /**
         * Size
         * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
         */
        size: [{
          size: l2()
        }],
        /**
         * Width
         * @see https://tailwindcss.com/docs/width
         */
        w: [{
          w: [c, "screen", ...l2()]
        }],
        /**
         * Min-Width
         * @see https://tailwindcss.com/docs/min-width
         */
        "min-w": [{
          "min-w": [
            c,
            "screen",
            /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            "none",
            ...l2()
          ]
        }],
        /**
         * Max-Width
         * @see https://tailwindcss.com/docs/max-width
         */
        "max-w": [{
          "max-w": [
            c,
            "screen",
            "none",
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            "prose",
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            {
              screen: [u]
            },
            ...l2()
          ]
        }],
        /**
         * Height
         * @see https://tailwindcss.com/docs/height
         */
        h: [{
          h: ["screen", "lh", ...l2()]
        }],
        /**
         * Min-Height
         * @see https://tailwindcss.com/docs/min-height
         */
        "min-h": [{
          "min-h": ["screen", "lh", "none", ...l2()]
        }],
        /**
         * Max-Height
         * @see https://tailwindcss.com/docs/max-height
         */
        "max-h": [{
          "max-h": ["screen", "lh", ...l2()]
        }],
        // ------------------
        // --- Typography ---
        // ------------------
        /**
         * Font Size
         * @see https://tailwindcss.com/docs/font-size
         */
        "font-size": [{
          text: ["base", r, Ol, mi]
        }],
        /**
         * Font Smoothing
         * @see https://tailwindcss.com/docs/font-smoothing
         */
        "font-smoothing": ["antialiased", "subpixel-antialiased"],
        /**
         * Font Style
         * @see https://tailwindcss.com/docs/font-style
         */
        "font-style": ["italic", "not-italic"],
        /**
         * Font Weight
         * @see https://tailwindcss.com/docs/font-weight
         */
        "font-weight": [{
          font: [n, v0, Ly]
        }],
        /**
         * Font Stretch
         * @see https://tailwindcss.com/docs/font-stretch
         */
        "font-stretch": [{
          "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Dy, h0]
        }],
        /**
         * Font Family
         * @see https://tailwindcss.com/docs/font-family
         */
        "font-family": [{
          font: [T42, h0, t]
        }],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-normal": ["normal-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-ordinal": ["ordinal"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-slashed-zero": ["slashed-zero"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-figure": ["lining-nums", "oldstyle-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-spacing": ["proportional-nums", "tabular-nums"],
        /**
         * Font Variant Numeric
         * @see https://tailwindcss.com/docs/font-variant-numeric
         */
        "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
        /**
         * Letter Spacing
         * @see https://tailwindcss.com/docs/letter-spacing
         */
        tracking: [{
          tracking: [i, v0, h0]
        }],
        /**
         * Line Clamp
         * @see https://tailwindcss.com/docs/line-clamp
         */
        "line-clamp": [{
          "line-clamp": [ee, "none", v0, Ly]
        }],
        /**
         * Line Height
         * @see https://tailwindcss.com/docs/line-height
         */
        leading: [{
          leading: [
            /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
            o,
            ...F()
          ]
        }],
        /**
         * List Style Image
         * @see https://tailwindcss.com/docs/list-style-image
         */
        "list-image": [{
          "list-image": ["none", v0, h0]
        }],
        /**
         * List Style Position
         * @see https://tailwindcss.com/docs/list-style-position
         */
        "list-style-position": [{
          list: ["inside", "outside"]
        }],
        /**
         * List Style Type
         * @see https://tailwindcss.com/docs/list-style-type
         */
        "list-style-type": [{
          list: ["disc", "decimal", "none", v0, h0]
        }],
        /**
         * Text Alignment
         * @see https://tailwindcss.com/docs/text-align
         */
        "text-alignment": [{
          text: ["left", "center", "right", "justify", "start", "end"]
        }],
        /**
         * Placeholder Color
         * @deprecated since Tailwind CSS v3.0.0
         * @see https://v3.tailwindcss.com/docs/placeholder-color
         */
        "placeholder-color": [{
          placeholder: X()
        }],
        /**
         * Text Color
         * @see https://tailwindcss.com/docs/text-color
         */
        "text-color": [{
          text: X()
        }],
        /**
         * Text Decoration
         * @see https://tailwindcss.com/docs/text-decoration
         */
        "text-decoration": ["underline", "overline", "line-through", "no-underline"],
        /**
         * Text Decoration Style
         * @see https://tailwindcss.com/docs/text-decoration-style
         */
        "text-decoration-style": [{
          decoration: [...O2(), "wavy"]
        }],
        /**
         * Text Decoration Thickness
         * @see https://tailwindcss.com/docs/text-decoration-thickness
         */
        "text-decoration-thickness": [{
          decoration: [ee, "from-font", "auto", v0, mi]
        }],
        /**
         * Text Decoration Color
         * @see https://tailwindcss.com/docs/text-decoration-color
         */
        "text-decoration-color": [{
          decoration: X()
        }],
        /**
         * Text Underline Offset
         * @see https://tailwindcss.com/docs/text-underline-offset
         */
        "underline-offset": [{
          "underline-offset": [ee, "auto", v0, h0]
        }],
        /**
         * Text Transform
         * @see https://tailwindcss.com/docs/text-transform
         */
        "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
        /**
         * Text Overflow
         * @see https://tailwindcss.com/docs/text-overflow
         */
        "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
        /**
         * Text Wrap
         * @see https://tailwindcss.com/docs/text-wrap
         */
        "text-wrap": [{
          text: ["wrap", "nowrap", "balance", "pretty"]
        }],
        /**
         * Text Indent
         * @see https://tailwindcss.com/docs/text-indent
         */
        indent: [{
          indent: F()
        }],
        /**
         * Vertical Alignment
         * @see https://tailwindcss.com/docs/vertical-align
         */
        "vertical-align": [{
          align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", v0, h0]
        }],
        /**
         * Whitespace
         * @see https://tailwindcss.com/docs/whitespace
         */
        whitespace: [{
          whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
        }],
        /**
         * Word Break
         * @see https://tailwindcss.com/docs/word-break
         */
        break: [{
          break: ["normal", "words", "all", "keep"]
        }],
        /**
         * Overflow Wrap
         * @see https://tailwindcss.com/docs/overflow-wrap
         */
        wrap: [{
          wrap: ["break-word", "anywhere", "normal"]
        }],
        /**
         * Hyphens
         * @see https://tailwindcss.com/docs/hyphens
         */
        hyphens: [{
          hyphens: ["none", "manual", "auto"]
        }],
        /**
         * Content
         * @see https://tailwindcss.com/docs/content
         */
        content: [{
          content: ["none", v0, h0]
        }],
        // -------------------
        // --- Backgrounds ---
        // -------------------
        /**
         * Background Attachment
         * @see https://tailwindcss.com/docs/background-attachment
         */
        "bg-attachment": [{
          bg: ["fixed", "local", "scroll"]
        }],
        /**
         * Background Clip
         * @see https://tailwindcss.com/docs/background-clip
         */
        "bg-clip": [{
          "bg-clip": ["border", "padding", "content", "text"]
        }],
        /**
         * Background Origin
         * @see https://tailwindcss.com/docs/background-origin
         */
        "bg-origin": [{
          "bg-origin": ["border", "padding", "content"]
        }],
        /**
         * Background Position
         * @see https://tailwindcss.com/docs/background-position
         */
        "bg-position": [{
          bg: a2()
        }],
        /**
         * Background Repeat
         * @see https://tailwindcss.com/docs/background-repeat
         */
        "bg-repeat": [{
          bg: e2()
        }],
        /**
         * Background Size
         * @see https://tailwindcss.com/docs/background-size
         */
        "bg-size": [{
          bg: H()
        }],
        /**
         * Background Image
         * @see https://tailwindcss.com/docs/background-image
         */
        "bg-image": [{
          bg: ["none", {
            linear: [{
              to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
            }, M6, v0, h0],
            radial: ["", v0, h0],
            conic: [M6, v0, h0]
          }, L42, O42]
        }],
        /**
         * Background Color
         * @see https://tailwindcss.com/docs/background-color
         */
        "bg-color": [{
          bg: X()
        }],
        /**
         * Gradient Color Stops From Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from-pos": [{
          from: Y()
        }],
        /**
         * Gradient Color Stops Via Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via-pos": [{
          via: Y()
        }],
        /**
         * Gradient Color Stops To Position
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to-pos": [{
          to: Y()
        }],
        /**
         * Gradient Color Stops From
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-from": [{
          from: X()
        }],
        /**
         * Gradient Color Stops Via
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-via": [{
          via: X()
        }],
        /**
         * Gradient Color Stops To
         * @see https://tailwindcss.com/docs/gradient-color-stops
         */
        "gradient-to": [{
          to: X()
        }],
        // ---------------
        // --- Borders ---
        // ---------------
        /**
         * Border Radius
         * @see https://tailwindcss.com/docs/border-radius
         */
        rounded: [{
          rounded: r2()
        }],
        /**
         * Border Radius Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-s": [{
          "rounded-s": r2()
        }],
        /**
         * Border Radius End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-e": [{
          "rounded-e": r2()
        }],
        /**
         * Border Radius Top
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-t": [{
          "rounded-t": r2()
        }],
        /**
         * Border Radius Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-r": [{
          "rounded-r": r2()
        }],
        /**
         * Border Radius Bottom
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-b": [{
          "rounded-b": r2()
        }],
        /**
         * Border Radius Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-l": [{
          "rounded-l": r2()
        }],
        /**
         * Border Radius Start Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ss": [{
          "rounded-ss": r2()
        }],
        /**
         * Border Radius Start End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-se": [{
          "rounded-se": r2()
        }],
        /**
         * Border Radius End End
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-ee": [{
          "rounded-ee": r2()
        }],
        /**
         * Border Radius End Start
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-es": [{
          "rounded-es": r2()
        }],
        /**
         * Border Radius Top Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tl": [{
          "rounded-tl": r2()
        }],
        /**
         * Border Radius Top Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-tr": [{
          "rounded-tr": r2()
        }],
        /**
         * Border Radius Bottom Right
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-br": [{
          "rounded-br": r2()
        }],
        /**
         * Border Radius Bottom Left
         * @see https://tailwindcss.com/docs/border-radius
         */
        "rounded-bl": [{
          "rounded-bl": r2()
        }],
        /**
         * Border Width
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w": [{
          border: o2()
        }],
        /**
         * Border Width X
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-x": [{
          "border-x": o2()
        }],
        /**
         * Border Width Y
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-y": [{
          "border-y": o2()
        }],
        /**
         * Border Width Start
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-s": [{
          "border-s": o2()
        }],
        /**
         * Border Width End
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-e": [{
          "border-e": o2()
        }],
        /**
         * Border Width Top
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-t": [{
          "border-t": o2()
        }],
        /**
         * Border Width Right
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-r": [{
          "border-r": o2()
        }],
        /**
         * Border Width Bottom
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-b": [{
          "border-b": o2()
        }],
        /**
         * Border Width Left
         * @see https://tailwindcss.com/docs/border-width
         */
        "border-w-l": [{
          "border-l": o2()
        }],
        /**
         * Divide Width X
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-x": [{
          "divide-x": o2()
        }],
        /**
         * Divide Width X Reverse
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-x-reverse": ["divide-x-reverse"],
        /**
         * Divide Width Y
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-y": [{
          "divide-y": o2()
        }],
        /**
         * Divide Width Y Reverse
         * @see https://tailwindcss.com/docs/border-width#between-children
         */
        "divide-y-reverse": ["divide-y-reverse"],
        /**
         * Border Style
         * @see https://tailwindcss.com/docs/border-style
         */
        "border-style": [{
          border: [...O2(), "hidden", "none"]
        }],
        /**
         * Divide Style
         * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
         */
        "divide-style": [{
          divide: [...O2(), "hidden", "none"]
        }],
        /**
         * Border Color
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color": [{
          border: X()
        }],
        /**
         * Border Color X
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-x": [{
          "border-x": X()
        }],
        /**
         * Border Color Y
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-y": [{
          "border-y": X()
        }],
        /**
         * Border Color S
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-s": [{
          "border-s": X()
        }],
        /**
         * Border Color E
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-e": [{
          "border-e": X()
        }],
        /**
         * Border Color Top
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-t": [{
          "border-t": X()
        }],
        /**
         * Border Color Right
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-r": [{
          "border-r": X()
        }],
        /**
         * Border Color Bottom
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-b": [{
          "border-b": X()
        }],
        /**
         * Border Color Left
         * @see https://tailwindcss.com/docs/border-color
         */
        "border-color-l": [{
          "border-l": X()
        }],
        /**
         * Divide Color
         * @see https://tailwindcss.com/docs/divide-color
         */
        "divide-color": [{
          divide: X()
        }],
        /**
         * Outline Style
         * @see https://tailwindcss.com/docs/outline-style
         */
        "outline-style": [{
          outline: [...O2(), "none", "hidden"]
        }],
        /**
         * Outline Offset
         * @see https://tailwindcss.com/docs/outline-offset
         */
        "outline-offset": [{
          "outline-offset": [ee, v0, h0]
        }],
        /**
         * Outline Width
         * @see https://tailwindcss.com/docs/outline-width
         */
        "outline-w": [{
          outline: ["", ee, Ol, mi]
        }],
        /**
         * Outline Color
         * @see https://tailwindcss.com/docs/outline-color
         */
        "outline-color": [{
          outline: X()
        }],
        // ---------------
        // --- Effects ---
        // ---------------
        /**
         * Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow
         */
        shadow: [{
          shadow: [
            // Deprecated since Tailwind CSS v4.0.0
            "",
            "none",
            g,
            md,
            Ed
          ]
        }],
        /**
         * Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
         */
        "shadow-color": [{
          shadow: X()
        }],
        /**
         * Inset Box Shadow
         * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
         */
        "inset-shadow": [{
          "inset-shadow": ["none", h, md, Ed]
        }],
        /**
         * Inset Box Shadow Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
         */
        "inset-shadow-color": [{
          "inset-shadow": X()
        }],
        /**
         * Ring Width
         * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
         */
        "ring-w": [{
          ring: o2()
        }],
        /**
         * Ring Width Inset
         * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-w-inset": ["ring-inset"],
        /**
         * Ring Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
         */
        "ring-color": [{
          ring: X()
        }],
        /**
         * Ring Offset Width
         * @see https://v3.tailwindcss.com/docs/ring-offset-width
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-offset-w": [{
          "ring-offset": [ee, mi]
        }],
        /**
         * Ring Offset Color
         * @see https://v3.tailwindcss.com/docs/ring-offset-color
         * @deprecated since Tailwind CSS v4.0.0
         * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
         */
        "ring-offset-color": [{
          "ring-offset": X()
        }],
        /**
         * Inset Ring Width
         * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
         */
        "inset-ring-w": [{
          "inset-ring": o2()
        }],
        /**
         * Inset Ring Color
         * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
         */
        "inset-ring-color": [{
          "inset-ring": X()
        }],
        /**
         * Text Shadow
         * @see https://tailwindcss.com/docs/text-shadow
         */
        "text-shadow": [{
          "text-shadow": ["none", E, md, Ed]
        }],
        /**
         * Text Shadow Color
         * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
         */
        "text-shadow-color": [{
          "text-shadow": X()
        }],
        /**
         * Opacity
         * @see https://tailwindcss.com/docs/opacity
         */
        opacity: [{
          opacity: [ee, v0, h0]
        }],
        /**
         * Mix Blend Mode
         * @see https://tailwindcss.com/docs/mix-blend-mode
         */
        "mix-blend": [{
          "mix-blend": [...S2(), "plus-darker", "plus-lighter"]
        }],
        /**
         * Background Blend Mode
         * @see https://tailwindcss.com/docs/background-blend-mode
         */
        "bg-blend": [{
          "bg-blend": S2()
        }],
        /**
         * Mask Clip
         * @see https://tailwindcss.com/docs/mask-clip
         */
        "mask-clip": [{
          "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
        }, "mask-no-clip"],
        /**
         * Mask Composite
         * @see https://tailwindcss.com/docs/mask-composite
         */
        "mask-composite": [{
          mask: ["add", "subtract", "intersect", "exclude"]
        }],
        /**
         * Mask Image
         * @see https://tailwindcss.com/docs/mask-image
         */
        "mask-image-linear-pos": [{
          "mask-linear": [ee]
        }],
        "mask-image-linear-from-pos": [{
          "mask-linear-from": M2()
        }],
        "mask-image-linear-to-pos": [{
          "mask-linear-to": M2()
        }],
        "mask-image-linear-from-color": [{
          "mask-linear-from": X()
        }],
        "mask-image-linear-to-color": [{
          "mask-linear-to": X()
        }],
        "mask-image-t-from-pos": [{
          "mask-t-from": M2()
        }],
        "mask-image-t-to-pos": [{
          "mask-t-to": M2()
        }],
        "mask-image-t-from-color": [{
          "mask-t-from": X()
        }],
        "mask-image-t-to-color": [{
          "mask-t-to": X()
        }],
        "mask-image-r-from-pos": [{
          "mask-r-from": M2()
        }],
        "mask-image-r-to-pos": [{
          "mask-r-to": M2()
        }],
        "mask-image-r-from-color": [{
          "mask-r-from": X()
        }],
        "mask-image-r-to-color": [{
          "mask-r-to": X()
        }],
        "mask-image-b-from-pos": [{
          "mask-b-from": M2()
        }],
        "mask-image-b-to-pos": [{
          "mask-b-to": M2()
        }],
        "mask-image-b-from-color": [{
          "mask-b-from": X()
        }],
        "mask-image-b-to-color": [{
          "mask-b-to": X()
        }],
        "mask-image-l-from-pos": [{
          "mask-l-from": M2()
        }],
        "mask-image-l-to-pos": [{
          "mask-l-to": M2()
        }],
        "mask-image-l-from-color": [{
          "mask-l-from": X()
        }],
        "mask-image-l-to-color": [{
          "mask-l-to": X()
        }],
        "mask-image-x-from-pos": [{
          "mask-x-from": M2()
        }],
        "mask-image-x-to-pos": [{
          "mask-x-to": M2()
        }],
        "mask-image-x-from-color": [{
          "mask-x-from": X()
        }],
        "mask-image-x-to-color": [{
          "mask-x-to": X()
        }],
        "mask-image-y-from-pos": [{
          "mask-y-from": M2()
        }],
        "mask-image-y-to-pos": [{
          "mask-y-to": M2()
        }],
        "mask-image-y-from-color": [{
          "mask-y-from": X()
        }],
        "mask-image-y-to-color": [{
          "mask-y-to": X()
        }],
        "mask-image-radial": [{
          "mask-radial": [v0, h0]
        }],
        "mask-image-radial-from-pos": [{
          "mask-radial-from": M2()
        }],
        "mask-image-radial-to-pos": [{
          "mask-radial-to": M2()
        }],
        "mask-image-radial-from-color": [{
          "mask-radial-from": X()
        }],
        "mask-image-radial-to-color": [{
          "mask-radial-to": X()
        }],
        "mask-image-radial-shape": [{
          "mask-radial": ["circle", "ellipse"]
        }],
        "mask-image-radial-size": [{
          "mask-radial": [{
            closest: ["side", "corner"],
            farthest: ["side", "corner"]
          }]
        }],
        "mask-image-radial-pos": [{
          "mask-radial-at": O()
        }],
        "mask-image-conic-pos": [{
          "mask-conic": [ee]
        }],
        "mask-image-conic-from-pos": [{
          "mask-conic-from": M2()
        }],
        "mask-image-conic-to-pos": [{
          "mask-conic-to": M2()
        }],
        "mask-image-conic-from-color": [{
          "mask-conic-from": X()
        }],
        "mask-image-conic-to-color": [{
          "mask-conic-to": X()
        }],
        /**
         * Mask Mode
         * @see https://tailwindcss.com/docs/mask-mode
         */
        "mask-mode": [{
          mask: ["alpha", "luminance", "match"]
        }],
        /**
         * Mask Origin
         * @see https://tailwindcss.com/docs/mask-origin
         */
        "mask-origin": [{
          "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
        }],
        /**
         * Mask Position
         * @see https://tailwindcss.com/docs/mask-position
         */
        "mask-position": [{
          mask: a2()
        }],
        /**
         * Mask Repeat
         * @see https://tailwindcss.com/docs/mask-repeat
         */
        "mask-repeat": [{
          mask: e2()
        }],
        /**
         * Mask Size
         * @see https://tailwindcss.com/docs/mask-size
         */
        "mask-size": [{
          mask: H()
        }],
        /**
         * Mask Type
         * @see https://tailwindcss.com/docs/mask-type
         */
        "mask-type": [{
          "mask-type": ["alpha", "luminance"]
        }],
        /**
         * Mask Image
         * @see https://tailwindcss.com/docs/mask-image
         */
        "mask-image": [{
          mask: ["none", v0, h0]
        }],
        // ---------------
        // --- Filters ---
        // ---------------
        /**
         * Filter
         * @see https://tailwindcss.com/docs/filter
         */
        filter: [{
          filter: [
            // Deprecated since Tailwind CSS v3.0.0
            "",
            "none",
            v0,
            h0
          ]
        }],
        /**
         * Blur
         * @see https://tailwindcss.com/docs/blur
         */
        blur: [{
          blur: w2()
        }],
        /**
         * Brightness
         * @see https://tailwindcss.com/docs/brightness
         */
        brightness: [{
          brightness: [ee, v0, h0]
        }],
        /**
         * Contrast
         * @see https://tailwindcss.com/docs/contrast
         */
        contrast: [{
          contrast: [ee, v0, h0]
        }],
        /**
         * Drop Shadow
         * @see https://tailwindcss.com/docs/drop-shadow
         */
        "drop-shadow": [{
          "drop-shadow": [
            // Deprecated since Tailwind CSS v4.0.0
            "",
            "none",
            y,
            md,
            Ed
          ]
        }],
        /**
         * Drop Shadow Color
         * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
         */
        "drop-shadow-color": [{
          "drop-shadow": X()
        }],
        /**
         * Grayscale
         * @see https://tailwindcss.com/docs/grayscale
         */
        grayscale: [{
          grayscale: ["", ee, v0, h0]
        }],
        /**
         * Hue Rotate
         * @see https://tailwindcss.com/docs/hue-rotate
         */
        "hue-rotate": [{
          "hue-rotate": [ee, v0, h0]
        }],
        /**
         * Invert
         * @see https://tailwindcss.com/docs/invert
         */
        invert: [{
          invert: ["", ee, v0, h0]
        }],
        /**
         * Saturate
         * @see https://tailwindcss.com/docs/saturate
         */
        saturate: [{
          saturate: [ee, v0, h0]
        }],
        /**
         * Sepia
         * @see https://tailwindcss.com/docs/sepia
         */
        sepia: [{
          sepia: ["", ee, v0, h0]
        }],
        /**
         * Backdrop Filter
         * @see https://tailwindcss.com/docs/backdrop-filter
         */
        "backdrop-filter": [{
          "backdrop-filter": [
            // Deprecated since Tailwind CSS v3.0.0
            "",
            "none",
            v0,
            h0
          ]
        }],
        /**
         * Backdrop Blur
         * @see https://tailwindcss.com/docs/backdrop-blur
         */
        "backdrop-blur": [{
          "backdrop-blur": w2()
        }],
        /**
         * Backdrop Brightness
         * @see https://tailwindcss.com/docs/backdrop-brightness
         */
        "backdrop-brightness": [{
          "backdrop-brightness": [ee, v0, h0]
        }],
        /**
         * Backdrop Contrast
         * @see https://tailwindcss.com/docs/backdrop-contrast
         */
        "backdrop-contrast": [{
          "backdrop-contrast": [ee, v0, h0]
        }],
        /**
         * Backdrop Grayscale
         * @see https://tailwindcss.com/docs/backdrop-grayscale
         */
        "backdrop-grayscale": [{
          "backdrop-grayscale": ["", ee, v0, h0]
        }],
        /**
         * Backdrop Hue Rotate
         * @see https://tailwindcss.com/docs/backdrop-hue-rotate
         */
        "backdrop-hue-rotate": [{
          "backdrop-hue-rotate": [ee, v0, h0]
        }],
        /**
         * Backdrop Invert
         * @see https://tailwindcss.com/docs/backdrop-invert
         */
        "backdrop-invert": [{
          "backdrop-invert": ["", ee, v0, h0]
        }],
        /**
         * Backdrop Opacity
         * @see https://tailwindcss.com/docs/backdrop-opacity
         */
        "backdrop-opacity": [{
          "backdrop-opacity": [ee, v0, h0]
        }],
        /**
         * Backdrop Saturate
         * @see https://tailwindcss.com/docs/backdrop-saturate
         */
        "backdrop-saturate": [{
          "backdrop-saturate": [ee, v0, h0]
        }],
        /**
         * Backdrop Sepia
         * @see https://tailwindcss.com/docs/backdrop-sepia
         */
        "backdrop-sepia": [{
          "backdrop-sepia": ["", ee, v0, h0]
        }],
        // --------------
        // --- Tables ---
        // --------------
        /**
         * Border Collapse
         * @see https://tailwindcss.com/docs/border-collapse
         */
        "border-collapse": [{
          border: ["collapse", "separate"]
        }],
        /**
         * Border Spacing
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing": [{
          "border-spacing": F()
        }],
        /**
         * Border Spacing X
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-x": [{
          "border-spacing-x": F()
        }],
        /**
         * Border Spacing Y
         * @see https://tailwindcss.com/docs/border-spacing
         */
        "border-spacing-y": [{
          "border-spacing-y": F()
        }],
        /**
         * Table Layout
         * @see https://tailwindcss.com/docs/table-layout
         */
        "table-layout": [{
          table: ["auto", "fixed"]
        }],
        /**
         * Caption Side
         * @see https://tailwindcss.com/docs/caption-side
         */
        caption: [{
          caption: ["top", "bottom"]
        }],
        // ---------------------------------
        // --- Transitions and Animation ---
        // ---------------------------------
        /**
         * Transition Property
         * @see https://tailwindcss.com/docs/transition-property
         */
        transition: [{
          transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", v0, h0]
        }],
        /**
         * Transition Behavior
         * @see https://tailwindcss.com/docs/transition-behavior
         */
        "transition-behavior": [{
          transition: ["normal", "discrete"]
        }],
        /**
         * Transition Duration
         * @see https://tailwindcss.com/docs/transition-duration
         */
        duration: [{
          duration: [ee, "initial", v0, h0]
        }],
        /**
         * Transition Timing Function
         * @see https://tailwindcss.com/docs/transition-timing-function
         */
        ease: [{
          ease: ["linear", "initial", _, v0, h0]
        }],
        /**
         * Transition Delay
         * @see https://tailwindcss.com/docs/transition-delay
         */
        delay: [{
          delay: [ee, v0, h0]
        }],
        /**
         * Animation
         * @see https://tailwindcss.com/docs/animation
         */
        animate: [{
          animate: ["none", M, v0, h0]
        }],
        // ------------------
        // --- Transforms ---
        // ------------------
        /**
         * Backface Visibility
         * @see https://tailwindcss.com/docs/backface-visibility
         */
        backface: [{
          backface: ["hidden", "visible"]
        }],
        /**
         * Perspective
         * @see https://tailwindcss.com/docs/perspective
         */
        perspective: [{
          perspective: [Q, v0, h0]
        }],
        /**
         * Perspective Origin
         * @see https://tailwindcss.com/docs/perspective-origin
         */
        "perspective-origin": [{
          "perspective-origin": w()
        }],
        /**
         * Rotate
         * @see https://tailwindcss.com/docs/rotate
         */
        rotate: [{
          rotate: v2()
        }],
        /**
         * Rotate X
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-x": [{
          "rotate-x": v2()
        }],
        /**
         * Rotate Y
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-y": [{
          "rotate-y": v2()
        }],
        /**
         * Rotate Z
         * @see https://tailwindcss.com/docs/rotate
         */
        "rotate-z": [{
          "rotate-z": v2()
        }],
        /**
         * Scale
         * @see https://tailwindcss.com/docs/scale
         */
        scale: [{
          scale: L2()
        }],
        /**
         * Scale X
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-x": [{
          "scale-x": L2()
        }],
        /**
         * Scale Y
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-y": [{
          "scale-y": L2()
        }],
        /**
         * Scale Z
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-z": [{
          "scale-z": L2()
        }],
        /**
         * Scale 3D
         * @see https://tailwindcss.com/docs/scale
         */
        "scale-3d": ["scale-3d"],
        /**
         * Skew
         * @see https://tailwindcss.com/docs/skew
         */
        skew: [{
          skew: W2()
        }],
        /**
         * Skew X
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-x": [{
          "skew-x": W2()
        }],
        /**
         * Skew Y
         * @see https://tailwindcss.com/docs/skew
         */
        "skew-y": [{
          "skew-y": W2()
        }],
        /**
         * Transform
         * @see https://tailwindcss.com/docs/transform
         */
        transform: [{
          transform: [v0, h0, "", "none", "gpu", "cpu"]
        }],
        /**
         * Transform Origin
         * @see https://tailwindcss.com/docs/transform-origin
         */
        "transform-origin": [{
          origin: w()
        }],
        /**
         * Transform Style
         * @see https://tailwindcss.com/docs/transform-style
         */
        "transform-style": [{
          transform: ["3d", "flat"]
        }],
        /**
         * Translate
         * @see https://tailwindcss.com/docs/translate
         */
        translate: [{
          translate: d2()
        }],
        /**
         * Translate X
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-x": [{
          "translate-x": d2()
        }],
        /**
         * Translate Y
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-y": [{
          "translate-y": d2()
        }],
        /**
         * Translate Z
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-z": [{
          "translate-z": d2()
        }],
        /**
         * Translate None
         * @see https://tailwindcss.com/docs/translate
         */
        "translate-none": ["translate-none"],
        // ---------------------
        // --- Interactivity ---
        // ---------------------
        /**
         * Accent Color
         * @see https://tailwindcss.com/docs/accent-color
         */
        accent: [{
          accent: X()
        }],
        /**
         * Appearance
         * @see https://tailwindcss.com/docs/appearance
         */
        appearance: [{
          appearance: ["none", "auto"]
        }],
        /**
         * Caret Color
         * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
         */
        "caret-color": [{
          caret: X()
        }],
        /**
         * Color Scheme
         * @see https://tailwindcss.com/docs/color-scheme
         */
        "color-scheme": [{
          scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
        }],
        /**
         * Cursor
         * @see https://tailwindcss.com/docs/cursor
         */
        cursor: [{
          cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", v0, h0]
        }],
        /**
         * Field Sizing
         * @see https://tailwindcss.com/docs/field-sizing
         */
        "field-sizing": [{
          "field-sizing": ["fixed", "content"]
        }],
        /**
         * Pointer Events
         * @see https://tailwindcss.com/docs/pointer-events
         */
        "pointer-events": [{
          "pointer-events": ["auto", "none"]
        }],
        /**
         * Resize
         * @see https://tailwindcss.com/docs/resize
         */
        resize: [{
          resize: ["none", "", "y", "x"]
        }],
        /**
         * Scroll Behavior
         * @see https://tailwindcss.com/docs/scroll-behavior
         */
        "scroll-behavior": [{
          scroll: ["auto", "smooth"]
        }],
        /**
         * Scroll Margin
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-m": [{
          "scroll-m": F()
        }],
        /**
         * Scroll Margin X
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mx": [{
          "scroll-mx": F()
        }],
        /**
         * Scroll Margin Y
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-my": [{
          "scroll-my": F()
        }],
        /**
         * Scroll Margin Start
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ms": [{
          "scroll-ms": F()
        }],
        /**
         * Scroll Margin End
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-me": [{
          "scroll-me": F()
        }],
        /**
         * Scroll Margin Top
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mt": [{
          "scroll-mt": F()
        }],
        /**
         * Scroll Margin Right
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mr": [{
          "scroll-mr": F()
        }],
        /**
         * Scroll Margin Bottom
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-mb": [{
          "scroll-mb": F()
        }],
        /**
         * Scroll Margin Left
         * @see https://tailwindcss.com/docs/scroll-margin
         */
        "scroll-ml": [{
          "scroll-ml": F()
        }],
        /**
         * Scroll Padding
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-p": [{
          "scroll-p": F()
        }],
        /**
         * Scroll Padding X
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-px": [{
          "scroll-px": F()
        }],
        /**
         * Scroll Padding Y
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-py": [{
          "scroll-py": F()
        }],
        /**
         * Scroll Padding Start
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-ps": [{
          "scroll-ps": F()
        }],
        /**
         * Scroll Padding End
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pe": [{
          "scroll-pe": F()
        }],
        /**
         * Scroll Padding Top
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pt": [{
          "scroll-pt": F()
        }],
        /**
         * Scroll Padding Right
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pr": [{
          "scroll-pr": F()
        }],
        /**
         * Scroll Padding Bottom
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pb": [{
          "scroll-pb": F()
        }],
        /**
         * Scroll Padding Left
         * @see https://tailwindcss.com/docs/scroll-padding
         */
        "scroll-pl": [{
          "scroll-pl": F()
        }],
        /**
         * Scroll Snap Align
         * @see https://tailwindcss.com/docs/scroll-snap-align
         */
        "snap-align": [{
          snap: ["start", "end", "center", "align-none"]
        }],
        /**
         * Scroll Snap Stop
         * @see https://tailwindcss.com/docs/scroll-snap-stop
         */
        "snap-stop": [{
          snap: ["normal", "always"]
        }],
        /**
         * Scroll Snap Type
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-type": [{
          snap: ["none", "x", "y", "both"]
        }],
        /**
         * Scroll Snap Type Strictness
         * @see https://tailwindcss.com/docs/scroll-snap-type
         */
        "snap-strictness": [{
          snap: ["mandatory", "proximity"]
        }],
        /**
         * Touch Action
         * @see https://tailwindcss.com/docs/touch-action
         */
        touch: [{
          touch: ["auto", "none", "manipulation"]
        }],
        /**
         * Touch Action X
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-x": [{
          "touch-pan": ["x", "left", "right"]
        }],
        /**
         * Touch Action Y
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-y": [{
          "touch-pan": ["y", "up", "down"]
        }],
        /**
         * Touch Action Pinch Zoom
         * @see https://tailwindcss.com/docs/touch-action
         */
        "touch-pz": ["touch-pinch-zoom"],
        /**
         * User Select
         * @see https://tailwindcss.com/docs/user-select
         */
        select: [{
          select: ["none", "text", "all", "auto"]
        }],
        /**
         * Will Change
         * @see https://tailwindcss.com/docs/will-change
         */
        "will-change": [{
          "will-change": ["auto", "scroll", "contents", "transform", v0, h0]
        }],
        // -----------
        // --- SVG ---
        // -----------
        /**
         * Fill
         * @see https://tailwindcss.com/docs/fill
         */
        fill: [{
          fill: ["none", ...X()]
        }],
        /**
         * Stroke Width
         * @see https://tailwindcss.com/docs/stroke-width
         */
        "stroke-w": [{
          stroke: [ee, Ol, mi, Ly]
        }],
        /**
         * Stroke
         * @see https://tailwindcss.com/docs/stroke
         */
        stroke: [{
          stroke: ["none", ...X()]
        }],
        // ---------------------
        // --- Accessibility ---
        // ---------------------
        /**
         * Forced Color Adjust
         * @see https://tailwindcss.com/docs/forced-color-adjust
         */
        "forced-color-adjust": [{
          "forced-color-adjust": ["auto", "none"]
        }]
      },
      conflictingClassGroups: {
        overflow: ["overflow-x", "overflow-y"],
        overscroll: ["overscroll-x", "overscroll-y"],
        inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
        "inset-x": ["right", "left"],
        "inset-y": ["top", "bottom"],
        flex: ["basis", "grow", "shrink"],
        gap: ["gap-x", "gap-y"],
        p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
        px: ["pr", "pl"],
        py: ["pt", "pb"],
        m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
        mx: ["mr", "ml"],
        my: ["mt", "mb"],
        size: ["w", "h"],
        "font-size": ["leading"],
        "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
        "fvn-ordinal": ["fvn-normal"],
        "fvn-slashed-zero": ["fvn-normal"],
        "fvn-figure": ["fvn-normal"],
        "fvn-spacing": ["fvn-normal"],
        "fvn-fraction": ["fvn-normal"],
        "line-clamp": ["display", "overflow"],
        rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
        "rounded-s": ["rounded-ss", "rounded-es"],
        "rounded-e": ["rounded-se", "rounded-ee"],
        "rounded-t": ["rounded-tl", "rounded-tr"],
        "rounded-r": ["rounded-tr", "rounded-br"],
        "rounded-b": ["rounded-br", "rounded-bl"],
        "rounded-l": ["rounded-tl", "rounded-bl"],
        "border-spacing": ["border-spacing-x", "border-spacing-y"],
        "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
        "border-w-x": ["border-w-r", "border-w-l"],
        "border-w-y": ["border-w-t", "border-w-b"],
        "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
        "border-color-x": ["border-color-r", "border-color-l"],
        "border-color-y": ["border-color-t", "border-color-b"],
        translate: ["translate-x", "translate-y", "translate-none"],
        "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
        "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
        "scroll-mx": ["scroll-mr", "scroll-ml"],
        "scroll-my": ["scroll-mt", "scroll-mb"],
        "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
        "scroll-px": ["scroll-pr", "scroll-pl"],
        "scroll-py": ["scroll-pt", "scroll-pb"],
        touch: ["touch-x", "touch-y", "touch-pz"],
        "touch-x": ["touch"],
        "touch-y": ["touch"],
        "touch-pz": ["touch"]
      },
      conflictingClassGroupModifiers: {
        "font-size": ["leading"]
      },
      orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
    };
  }, CU = /* @__PURE__ */ v42(P42);
  function SS(...e) {
    return CU(pe(e));
  }
  const F42 = (e) => e.length === 0 ? "" : e.length === 1 ? e[0] : e.length === 2 ? e.join(" and ") : `${e.slice(0, -1).join(", ")} and ${e.at(-1)}`;
  function N42(e) {
    return e.length > 0;
  }
  const ne = {
    report: {
      headingOne: "Visits",
      headingTwo: "Trends",
      headingThree: "Past visitation reports",
      visitCountTitleOne: "Average daily visits",
      visitCountTitleTwo: "Total visits this month",
      visitsCountDescription: "Based on last 30 days of data received",
      viewPastReports: "View your past end-of-month visitation reports"
    },
    facilitySelection: {
      label: "Select Facility"
    },
    visitsCount: {
      title: (e) => `${e.toLocaleString()} visits`
    },
    trends: {
      monthlyDimensionLabel: "Last Month",
      yearlyDimensionLabel: "Yearly",
      toggleYoYLabel: "Year-on-year"
    },
    chart: {
      ariaContainerLabel: "visit trends line chart",
      legend: {
        thisYear: "This year",
        yoy: "YoY"
      }
    },
    visitTrendsTooltip: {
      visits: "Visits"
    },
    mostPopularBarChart: {
      visits: "Visits",
      ariaContainerLabel: (e) => `Most popular ${e} chart`
    },
    mostPopularDayCard: {
      description: () => /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
        "Based on last 90 days of ",
        /* @__PURE__ */ K.jsx("u", { children: "live data" }),
        " received"
      ] }),
      tooltip: "Live data sources: QR code, manual check-in, and API-linked gym management software.",
      title: (e, t) => {
        if (e === 0)
          return "Popular day for visits: Unknown";
        const r = t.map((o) => `${o}s`), n = F42(r), i = t.length === 1 ? "day" : "days";
        return `${n} are the most popular ${i} for Fitness Passport visits.`;
      }
    },
    mostPopularHourCard: {
      title: (e, t) => e === 0 ? "Popular hour for visits: Unknown" : `Most popular ${t.length > 1 ? "hours" : "hour"} for Fitness Passport visits.`
    },
    daysOfTheWeek: {
      sunday: "Sunday",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday"
    },
    trendIndicator: {
      yoy: "YoY"
    },
    error: {
      title: "Currently unable to fetch visitation report data",
      message: "Please refresh page or try again later"
    },
    loading: {
      title: "Loading..."
    },
    comingSoon: {
      title: "See how we help your business",
      imageLabel: "Coming Soon",
      description: "Want to learn more about visitation and revenue?",
      link: "Register for early access"
    }
  }, H42 = "data:image/svg+xml,%3csvg%20style='display:block;%20height:%20auto;%20width:100%25;'%20width='996'%20height='576'%20viewBox='0%200%20996%20576'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cg%20clip-path='url(%23clip0_12_1053)'%3e%3cpath%20d='M0%200H996V576H0V0Z'%20fill='white'%20/%3e%3cpath%20d='M18%2018H978V558H18V18Z'%20fill='white'%20/%3e%3cpath%20d='M18%2018H978V43.5H18V18Z'%20fill='%233B3A39'%20/%3e%3cmask%20id='mask0_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='17'%20y='43'%20width='962'%20height='97'%3e%3crect%20x='17.52'%20y='43.2'%20width='960.96'%20height='96.24'%20fill='url(%23pattern0_12_1053)'%20/%3e%3c/mask%3e%3cg%20mask='url(%23mask0_12_1053)'%3e%3cmask%20id='mask1_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='18'%20y='18'%20width='960'%20height='540'%3e%3cg%20clip-path='url(%23clip1_12_1053)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M978%2018H18V558H978V18ZM977.2%2044.2H18.7V138H977.2V44.2Z'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask1_12_1053)'%3e%3cpath%20d='M17.52%2043.2H978.48V139.44H17.52V43.2Z'%20fill='black'%20fill-opacity='0.1098'%20/%3e%3c/g%3e%3c/g%3e%3cmask%20id='mask2_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='15'%20y='43'%20width='966'%20height='101'%3e%3crect%20x='15.6001'%20y='43.92'%20width='964.8'%20height='99.84'%20fill='url(%23pattern1_12_1053)'%20/%3e%3c/mask%3e%3cg%20mask='url(%23mask2_12_1053)'%3e%3cmask%20id='mask3_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='18'%20y='18'%20width='960'%20height='540'%3e%3cg%20clip-path='url(%23clip2_12_1053)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M978%2018H18V558H978V18ZM977.2%2044.2H18.7V138H977.2V44.2Z'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask3_12_1053)'%3e%3cpath%20d='M15.6001%2043.92H980.4V143.76H15.6001V43.92Z'%20fill='black'%20fill-opacity='0.1294'%20/%3e%3c/g%3e%3c/g%3e%3cg%20clip-path='url(%23clip3_12_1053)'%3e%3cpath%20d='M18%2043.5H978V138.75H18V43.5Z'%20fill='%23F3F2F1'%20/%3e%3cpath%20d='M464.485%2032.7881H463.74V26.4901H465.769C466.078%2026.4901%20466.357%2026.5224%20466.607%2026.5869C466.856%2026.6515%20467.078%2026.7497%20467.272%2026.8816C467.465%2027.0135%20467.616%2027.1903%20467.722%2027.412C467.829%2027.6338%20467.882%2027.892%20467.882%2028.1867C467.882%2028.4308%20467.86%2028.6498%20467.815%2028.8434C467.77%2029.0343%20467.693%2029.2139%20467.583%2029.3823C467.474%2029.5507%20467.331%2029.691%20467.154%2029.8033C466.977%2029.9127%20466.75%2029.9997%20466.472%2030.0643C466.197%2030.126%20465.877%2030.1569%20465.512%2030.1569C465.223%2030.1569%20464.881%2030.1387%20464.485%2030.1022V32.7881ZM465.584%2029.5128C465.859%2029.5128%20466.094%2029.4861%20466.291%2029.4328C466.487%2029.3795%20466.637%2029.3135%20466.741%2029.2349C466.848%2029.1563%20466.931%2029.0539%20466.99%2028.9276C467.051%2028.8013%20467.089%2028.6862%20467.103%2028.5824C467.117%2028.4757%20467.124%2028.348%20467.124%2028.1993C467.124%2027.8429%20467.004%2027.5804%20466.762%2027.412C466.524%2027.2436%20466.198%2027.1594%20465.786%2027.1594H464.485V29.5044C465.026%2029.51%20465.393%2029.5128%20465.584%2029.5128ZM469.082%2030.4895C469.082%2031.0368%20469.203%2031.476%20469.444%2031.8072C469.688%2032.1356%20470.043%2032.2997%20470.509%2032.2997C470.969%2032.2997%20471.316%2032.1356%20471.549%2031.8072C471.785%2031.4788%20471.903%2031.0368%20471.903%2030.4811C471.903%2029.9169%20471.786%2029.4735%20471.553%2029.1507C471.323%2028.8252%20470.971%2028.6624%20470.497%2028.6624C470.036%2028.6624%20469.685%2028.828%20469.444%2029.1592C469.203%2029.4903%20469.082%2029.9338%20469.082%2030.4895ZM472.631%2030.4769C472.631%2031.1925%20472.44%2031.7735%20472.058%2032.2197C471.677%2032.6632%20471.149%2032.8849%20470.475%2032.8849C469.827%2032.8849%20469.311%2032.6604%20468.926%2032.2113C468.545%2031.7623%20468.354%2031.1855%20468.354%2030.4811C468.354%2029.7626%20468.546%2029.1816%20468.93%2028.7382C469.315%2028.2947%20469.843%2028.073%20470.513%2028.073C471.173%2028.073%20471.691%2028.2961%20472.067%2028.7424C472.443%2029.1858%20472.631%2029.764%20472.631%2030.4769ZM477.582%2032.7881C476.933%2030.7168%20476.532%2029.4272%20476.378%2028.9192C476.291%2029.2279%20476.191%2029.5619%20476.079%2029.9211C475.967%2030.2804%20475.868%2030.5891%20475.784%2030.8473C475.7%2031.1055%20475.591%2031.4395%20475.456%2031.8493C475.321%2032.259%20475.219%2032.572%20475.148%2032.7881H474.391L473.073%2028.1698H473.801L474.791%2031.9503C474.928%2031.5013%20475.332%2030.2411%20476.003%2028.1698H476.799C477.467%2030.286%20477.86%2031.542%20477.978%2031.9377L478.954%2028.1698H479.674L478.344%2032.7881H477.582ZM482.975%2029.0244C482.77%2028.7775%20482.488%2028.654%20482.128%2028.654C481.769%2028.654%20481.476%2028.7817%20481.249%2029.0371C481.021%2029.2897%20480.888%2029.6363%20480.849%2030.0769H483.286C483.286%2029.6194%20483.182%2029.2686%20482.975%2029.0244ZM482.267%2032.8849C481.597%2032.8849%20481.068%2032.6716%20480.68%2032.245C480.296%2031.8184%20480.104%2031.2346%20480.104%2030.4937C480.104%2029.778%20480.29%2029.1984%20480.663%2028.755C481.037%2028.3088%20481.528%2028.0814%20482.137%2028.073C482.709%2028.073%20483.163%2028.2695%20483.497%2028.6624C483.833%2029.0525%20484.002%2029.5745%20484.002%2030.2285C484.002%2030.2621%20484%2030.3239%20483.998%2030.4137C483.998%2030.5035%20483.998%2030.5681%20483.998%2030.6074H480.828C480.836%2031.1322%20480.971%2031.542%20481.232%2031.8366C481.496%2032.1285%20481.849%2032.2745%20482.293%2032.2745C482.781%2032.2745%20483.271%2032.1454%20483.762%2031.8872L483.871%2032.4555C483.403%2032.7418%20482.868%2032.8849%20482.267%2032.8849ZM487.05%2028.1277C487.176%2028.1277%20487.291%2028.1361%20487.395%2028.153L487.37%2028.8013C487.241%2028.7789%20487.128%2028.7676%20487.033%2028.7676C486.64%2028.7676%20486.32%2028.9052%20486.073%2029.1802C485.829%2029.4524%20485.707%2029.7906%20485.707%2030.1948V32.7881H485.004C485.001%2029.9534%20485%2028.414%20485%2028.1698H485.585L485.652%2028.9992C485.812%2028.7382%20486.016%2028.5277%20486.263%2028.3677C486.51%2028.2077%20486.772%2028.1277%20487.05%2028.1277ZM491.133%2029.8243V32.1903H492.434C492.962%2032.1903%20493.358%2032.0935%20493.622%2031.8998C493.885%2031.7033%20494.017%2031.3988%20494.017%2030.9862C494.017%2030.5568%20493.874%2030.2565%20493.588%2030.0853C493.304%2029.9113%20492.861%2029.8243%20492.258%2029.8243H491.133ZM491.133%2029.2391H492.468C492.903%2029.2391%20493.231%2029.1634%20493.453%2029.0118C493.675%2028.8602%20493.786%2028.5908%20493.786%2028.2035C493.786%2027.8134%20493.652%2027.5454%20493.386%2027.3994C493.122%2027.2507%20492.711%2027.1763%20492.152%2027.1763H491.133V29.2391ZM490.405%2026.5616H492.19C492.99%2026.5616%20493.582%2026.6837%20493.967%2026.9279C494.354%2027.1721%20494.548%2027.5608%20494.548%2028.094C494.548%2028.1726%20494.542%2028.2512%20494.531%2028.3298C494.522%2028.4056%20494.497%2028.5038%20494.455%2028.6245C494.416%2028.7452%20494.361%2028.856%20494.291%2028.9571C494.221%2029.0553%20494.117%2029.1549%20493.979%2029.256C493.845%2029.3542%20493.686%2029.4328%20493.504%2029.4917C493.922%2029.5703%20494.239%2029.7471%20494.455%2030.0222C494.671%2030.2972%20494.779%2030.6284%20494.779%2031.0157C494.779%2031.5798%20494.594%2032.0163%20494.224%2032.325C493.856%2032.6337%20493.307%2032.7881%20492.577%2032.7881H490.405V26.5616ZM496.581%2032.7881H495.853V26.5616H496.581V32.7881ZM504.588%2029.6896C504.588%2028.8196%20504.364%2028.1867%20503.915%2027.7909C503.466%2027.3952%20502.812%2027.1973%20501.953%2027.1973H500.976V32.1524H502.075C502.895%2032.1524%20503.518%2031.9461%20503.944%2031.5335C504.374%2031.1182%20504.588%2030.5035%20504.588%2029.6896ZM505.367%2029.6686C505.367%2030.6817%20505.079%2031.455%20504.504%2031.9882C503.929%2032.5215%20503.126%2032.7881%20502.096%2032.7881H500.248V26.5616H501.974C502.493%2026.5616%20502.958%2026.6234%20503.367%2026.7469C503.777%2026.8676%20504.132%2027.0528%20504.433%2027.3026C504.736%2027.5496%20504.967%2027.8737%20505.127%2028.2751C505.287%2028.6736%20505.367%2029.1381%20505.367%2029.6686ZM509.101%2029.0244C508.896%2028.7775%20508.614%2028.654%20508.255%2028.654C507.896%2028.654%20507.603%2028.7817%20507.375%2029.0371C507.148%2029.2897%20507.015%2029.6363%20506.975%2030.0769H509.413C509.413%2029.6194%20509.309%2029.2686%20509.101%2029.0244ZM508.394%2032.8849C507.723%2032.8849%20507.194%2032.6716%20506.807%2032.245C506.422%2031.8184%20506.23%2031.2346%20506.23%2030.4937C506.23%2029.778%20506.417%2029.1984%20506.79%2028.755C507.163%2028.3088%20507.655%2028.0814%20508.264%2028.073C508.836%2028.073%20509.289%2028.2695%20509.623%2028.6624C509.96%2029.0525%20510.129%2029.5745%20510.129%2030.2285C510.129%2030.2621%20510.127%2030.3239%20510.124%2030.4137C510.124%2030.5035%20510.124%2030.5681%20510.124%2030.6074H506.954C506.963%2031.1322%20507.097%2031.542%20507.358%2031.8366C507.622%2032.1285%20507.976%2032.2745%20508.419%2032.2745C508.908%2032.2745%20509.397%2032.1454%20509.889%2031.8872L509.998%2032.4555C509.529%2032.7418%20508.995%2032.8849%20508.394%2032.8849ZM512.482%2032.8849C512.168%2032.8849%20511.877%2032.8512%20511.61%2032.7839C511.347%2032.7165%20511.132%2032.6295%20510.966%2032.5229L511.055%2031.9293C511.523%2032.1791%20511.984%2032.3039%20512.436%2032.3039C513.12%2032.3039%20513.473%2032.0626%20513.492%2031.5798C513.492%2031.375%20513.419%2031.2136%20513.273%2031.0957C513.127%2030.9778%20512.841%2030.8459%20512.415%2030.7L512.065%2030.5779C511.661%2030.4432%20511.372%2030.2762%20511.198%2030.0769C511.027%2029.8776%20510.94%2029.6293%20510.937%2029.3318C510.937%2028.9697%20511.081%2028.6694%20511.37%2028.4308C511.662%2028.1923%20512.061%2028.073%20512.566%2028.073C513.088%2028.073%20513.564%2028.174%20513.993%2028.3761L513.787%2028.915C513.352%2028.7354%20512.945%2028.6455%20512.566%2028.6455C512.271%2028.6455%20512.04%2028.7045%20511.871%2028.8224C511.706%2028.9374%20511.623%2029.1002%20511.623%2029.3107C511.623%2029.4903%20511.683%2029.6279%20511.804%2029.7233C511.925%2029.8187%20512.166%2029.9282%20512.528%2030.0517C512.621%2030.0853%20512.737%2030.1246%20512.878%2030.1695C513.343%2030.3211%20513.673%2030.5007%20513.867%2030.7084C514.061%2030.9133%20514.157%2031.1911%20514.157%2031.542C514.152%2031.9686%20513.999%2032.2997%20513.699%2032.5355C513.398%2032.7684%20512.993%2032.8849%20512.482%2032.8849ZM515.13%2032.7881V26.3764L515.829%2026.3343V29.6896V30.279C515.846%2030.2621%20515.871%2030.2341%20515.905%2030.1948C515.938%2030.1555%20515.965%2030.126%20515.985%2030.1064C516.229%2029.8398%20516.86%2029.1942%20517.879%2028.1698H518.771L516.852%2030.1148L518.906%2032.7881H518.031L516.342%2030.5147L515.829%2030.9568V32.7881H515.13ZM520.982%2032.8723C520.527%2032.8723%20520.204%2032.7614%20520.013%2032.5397C519.823%2032.318%20519.721%2031.9601%20519.71%2031.4662V28.6919H519.024L519.054%2028.2288L519.706%2028.1698L519.946%2027.1131L520.409%2027.0963V28.1698H521.693V28.6919H520.409V31.3399C520.409%2031.6907%20520.462%2031.9377%20520.569%2032.0808C520.676%2032.224%20520.858%2032.2955%20521.116%2032.2955C521.209%2032.2955%20521.41%2032.2731%20521.718%2032.2282L521.748%2032.7839C521.414%2032.8428%20521.158%2032.8723%20520.982%2032.8723ZM522.96%2030.4895C522.96%2031.0368%20523.081%2031.476%20523.322%2031.8072C523.567%2032.1356%20523.922%2032.2997%20524.387%2032.2997C524.848%2032.2997%20525.194%2032.1356%20525.427%2031.8072C525.663%2031.4788%20525.781%2031.0368%20525.781%2030.4811C525.781%2029.9169%20525.664%2029.4735%20525.432%2029.1507C525.201%2028.8252%20524.849%2028.6624%20524.375%2028.6624C523.915%2028.6624%20523.564%2028.828%20523.322%2029.1592C523.081%2029.4903%20522.96%2029.9338%20522.96%2030.4895ZM526.509%2030.4769C526.509%2031.1925%20526.318%2031.7735%20525.937%2032.2197C525.555%2032.6632%20525.027%2032.8849%20524.354%2032.8849C523.705%2032.8849%20523.189%2032.6604%20522.805%2032.2113C522.423%2031.7623%20522.232%2031.1855%20522.232%2030.4811C522.232%2029.7626%20522.424%2029.1816%20522.809%2028.7382C523.193%2028.2947%20523.721%2028.073%20524.392%2028.073C525.051%2028.073%20525.569%2028.2961%20525.945%2028.7424C526.321%2029.1858%20526.509%2029.764%20526.509%2030.4769ZM527.507%2034.792V28.1698H528.126L528.193%2028.7971C528.597%2028.3144%20529.083%2028.073%20529.65%2028.073C530.071%2028.073%20530.427%2028.1782%20530.719%2028.3887C531.011%2028.5992%20531.226%2028.8841%20531.363%2029.2434C531.504%2029.6026%20531.574%2030.0222%20531.574%2030.5021C531.574%2030.9624%20531.498%2031.3722%20531.346%2031.7314C531.195%2032.0878%20530.972%2032.3699%20530.677%2032.5776C530.385%2032.7825%20530.043%2032.8849%20529.65%2032.8849C529.352%2032.8849%20529.073%2032.819%20528.812%2032.687C528.551%2032.5523%20528.342%2032.3755%20528.185%2032.1566C528.202%2032.4597%20528.21%2032.7544%20528.21%2033.0407V34.7457L527.507%2034.792ZM529.553%2032.2913C529.766%2032.2913%20529.957%2032.2436%20530.126%2032.1482C530.294%2032.05%20530.43%2031.9166%20530.534%2031.7482C530.638%2031.5798%20530.716%2031.389%20530.77%2031.1757C530.823%2030.9596%20530.85%2030.7266%20530.85%2030.4769C530.85%2029.9492%20530.739%2029.517%20530.517%2029.1802C530.295%2028.8406%20529.971%2028.6708%20529.545%2028.6708C528.652%2028.6708%20528.206%2029.2476%20528.206%2030.4011C528.206%2031.0269%20528.31%2031.4985%20528.517%2031.8156C528.728%2032.1327%20529.073%2032.2913%20529.553%2032.2913Z'%20fill='white'%20/%3e%3cpath%20d='M18%2018H978V558H18V18Z'%20fill='white'%20/%3e%3cpath%20d='M18%2018H978V558H18V18Z'%20fill='%231C2632'%20/%3e%3c/g%3e%3cmask%20id='mask4_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='23'%20y='63'%20width='946'%20height='83'%3e%3cg%20clip-path='url(%23clip4_12_1053)'%3e%3cpath%20d='M23.2002%2063.7H964.5C965.5%2063.7%20966.4%2064.1%20967.2%2064.8C967.9%2065.6%20968.2%2066.5%20968.2%2067.5V141.7C968.2%20142.8%20967.9%20143.7%20967.2%20144.4C966.4%20145.1%20965.5%20145.5%20964.5%20145.5H27.0002C26.0002%20145.5%2025.1002%20145.1%2024.3002%20144.4C23.6002%20143.7%2023.2002%20142.8%2023.2002%20141.7V67.5C23.2002%2066.5%2023.6002%2065.6%2024.3002%2064.8C25.1002%2064.1%2026.0002%2063.7%2027.0002%2063.7'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask4_12_1053)'%3e%3cpath%20d='M23.25%2063.75H964.5C964.997%2063.75%20965.476%2063.8452%20965.935%2064.0355C966.394%2064.2258%20966.8%2064.4967%20967.152%2064.8483C967.503%2065.2%20967.774%2065.6055%20967.964%2066.0649C968.155%2066.5244%20968.25%2067.0027%20968.25%2067.5V141.75C968.25%20142.247%20968.155%20142.726%20967.964%20143.185C967.774%20143.644%20967.503%20144.05%20967.152%20144.402C966.8%20144.753%20966.394%20145.024%20965.935%20145.215C965.476%20145.405%20964.997%20145.5%20964.5%20145.5H27C26.5027%20145.5%2026.0244%20145.405%2025.5649%20145.215C25.1055%20145.024%2024.7%20144.753%2024.3483%20144.402C23.9967%20144.05%2023.7258%20143.644%2023.5355%20143.185C23.3452%20142.726%2023.25%20142.247%2023.25%20141.75V67.5C23.25%2067.0027%2023.3452%2066.5244%2023.5355%2066.0649C23.7258%2065.6055%2023.9967%2065.2%2024.3483%2064.8483C24.7%2064.4967%2025.1055%2064.2258%2025.5649%2064.0355C26.0244%2063.8452%2026.5027%2063.75%2027%2063.75'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cmask%20id='mask5_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='666'%20y='357'%20width='302'%20height='198'%3e%3cg%20clip-path='url(%23clip5_12_1053)'%3e%3cpath%20d='M666.7%20357H963.7C964.8%20357%20965.7%20357.4%20966.4%20358.1C967.1%20358.8%20967.5%20359.7%20967.5%20360.7V551.2C967.5%20552.3%20967.1%20553.2%20966.4%20553.9C965.7%20554.6%20964.8%20555%20963.7%20555H670.5C669.5%20555%20668.6%20554.6%20667.8%20553.9C667.1%20553.2%20666.7%20552.3%20666.7%20551.2V360.7C666.7%20359.7%20667.1%20358.8%20667.8%20358.1C668.6%20357.4%20669.5%20357%20670.5%20357'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask5_12_1053)'%3e%3cpath%20d='M666.75%20357H963.75C964.247%20357%20964.726%20357.095%20965.185%20357.285C965.644%20357.476%20966.05%20357.747%20966.402%20358.098C966.753%20358.45%20967.024%20358.856%20967.214%20359.315C967.405%20359.774%20967.5%20360.253%20967.5%20360.75V551.25C967.5%20551.747%20967.405%20552.226%20967.215%20552.685C967.024%20553.144%20966.753%20553.55%20966.402%20553.902C966.05%20554.253%20965.644%20554.524%20965.185%20554.715C964.726%20554.905%20964.247%20555%20963.75%20555H670.5C670.003%20555%20669.524%20554.905%20669.065%20554.715C668.606%20554.524%20668.2%20554.253%20667.848%20553.902C667.497%20553.55%20667.226%20553.144%20667.035%20552.685C666.845%20552.226%20666.75%20551.747%20666.75%20551.25V360.75C666.75%20360.253%20666.845%20359.774%20667.035%20359.315C667.226%20358.856%20667.497%20358.45%20667.848%20358.098C668.2%20357.747%20668.606%20357.476%20669.065%20357.285C669.524%20357.095%20670.003%20357%20670.5%20357'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cpath%20d='M129.002%2078.023C128.299%2078.023%20127.693%2078.1933%20127.184%2078.5341C126.68%2078.8748%20126.303%2079.3333%20126.055%2079.9096C125.807%2080.4859%20125.683%2081.1485%20125.683%2081.8973C125.683%2082.4567%20125.75%2082.9678%20125.885%2083.4306C126.019%2083.8891%20126.221%2084.2929%20126.49%2084.6421C126.76%2084.987%20127.109%2085.2562%20127.538%2085.4497C127.971%2085.639%20128.467%2085.7337%20129.027%2085.7337C129.746%2085.7337%20130.491%2085.5465%20131.261%2085.1721L131.444%2086.0996C130.817%2086.4951%20129.969%2086.6928%20128.901%2086.6928C128.198%2086.6928%20127.567%2086.5771%20127.008%2086.3457C126.452%2086.1102%20125.992%2085.7799%20125.626%2085.3551C125.264%2084.926%20124.989%2084.417%20124.799%2083.8281C124.61%2083.235%20124.515%2082.5766%20124.515%2081.8531C124.515%2081.1548%20124.618%2080.5112%20124.824%2079.9223C125.031%2079.3333%20125.321%2078.8285%20125.695%2078.4079C126.074%2077.983%20126.545%2077.6528%20127.109%2077.4172C127.672%2077.1817%20128.299%2077.0639%20128.989%2077.0639C130.036%2077.0639%20130.92%2077.2952%20131.639%2077.758L131.21%2078.6477C130.52%2078.2312%20129.784%2078.023%20129.002%2078.023ZM140.24%2086.554H139.148V82.1875H134.138V86.554H133.046V77.2216H134.138V81.2284H139.148V77.2216H140.24V86.554ZM142.435%2086.554V77.2216H147.786L147.742%2078.187H143.527V81.241H147.534V82.1938H143.527V85.5885H147.881L147.83%2086.554H142.435ZM153.749%2078.023C153.047%2078.023%20152.441%2078.1933%20151.932%2078.5341C151.427%2078.8748%20151.05%2079.3333%20150.802%2079.9096C150.554%2080.4859%20150.43%2081.1485%20150.43%2081.8973C150.43%2082.4567%20150.497%2082.9678%20150.632%2083.4306C150.767%2083.8891%20150.968%2084.2929%20151.238%2084.6421C151.507%2084.987%20151.856%2085.2562%20152.285%2085.4497C152.718%2085.639%20153.215%2085.7337%20153.774%2085.7337C154.494%2085.7337%20155.238%2085.5465%20156.008%2085.1721L156.191%2086.0996C155.564%2086.4951%20154.717%2086.6928%20153.648%2086.6928C152.946%2086.6928%20152.315%2086.5771%20151.755%2086.3457C151.2%2086.1102%20150.739%2085.7799%20150.373%2085.3551C150.011%2084.926%20149.736%2084.417%20149.547%2083.8281C149.357%2083.235%20149.263%2082.5766%20149.263%2081.8531C149.263%2081.1548%20149.366%2080.5112%20149.572%2079.9223C149.778%2079.3333%20150.068%2078.8285%20150.443%2078.4079C150.821%2077.983%20151.292%2077.6528%20151.856%2077.4172C152.42%2077.1817%20153.047%2077.0639%20153.736%2077.0639C154.784%2077.0639%20155.667%2077.2952%20156.387%2077.758L155.957%2078.6477C155.268%2078.2312%20154.531%2078.023%20153.749%2078.023ZM164.646%2086.554H163.309L159.737%2082.0992L158.885%2082.85V86.554H157.787V77.2216H158.885V81.8026L162.987%2077.2216H164.356L160.57%2081.424L164.646%2086.554ZM165.075%2083.4179V82.4904H168.23V83.4179H165.075ZM171.013%2086.554H169.921V77.2216H171.013V86.554ZM180.648%2086.554H179.411L174.565%2079.2092L174.25%2078.7739C174.284%2079.6572%20174.3%2080.446%20174.3%2081.1401V86.554H173.278V77.2216H174.496L179.355%2084.5663L179.676%2085.0017C179.647%2083.6598%20179.632%2082.8837%20179.632%2082.6734V77.2216H180.648V86.554ZM182.667%2085.0143C183.639%2085.4939%20184.68%2085.7337%20185.791%2085.7337C187.158%2085.7337%20187.841%2085.1111%20187.841%2083.8659C187.841%2083.4621%20187.732%2083.1361%20187.513%2082.8879C187.299%2082.6355%20186.905%2082.4378%20186.333%2082.2948L184.478%2081.8278C183.061%2081.4703%20182.352%2080.7131%20182.352%2079.5563C182.352%2078.6687%20182.657%2078.0104%20183.267%2077.5813C183.877%2077.148%20184.72%2076.9314%20185.797%2076.9314C186.361%2076.9314%20186.889%2076.9924%20187.381%2077.1144C187.873%2077.2363%20188.285%2077.4004%20188.617%2077.6065L188.302%2078.4962C188.02%2078.3406%20187.646%2078.2018%20187.179%2078.0798C186.716%2077.9578%20186.247%2077.8968%20185.772%2077.8968C184.249%2077.8968%20183.488%2078.4247%20183.488%2079.4806C183.488%2079.8381%20183.603%2080.1263%20183.835%2080.345C184.07%2080.5596%20184.421%2080.7236%20184.888%2080.8372L186.661%2081.2663C187.419%2081.4472%20187.993%2081.7374%20188.384%2082.137C188.775%2082.5325%20188.971%2083.0961%20188.971%2083.8281C188.971%2084.7788%20188.678%2085.496%20188.094%2085.9798C187.513%2086.4593%20186.722%2086.6991%20185.721%2086.6991C184.972%2086.6991%20184.306%2086.6234%20183.721%2086.4719C183.14%2086.3163%20182.68%2086.1333%20182.339%2085.923L182.667%2085.0143Z'%20fill='white'%20/%3e%3cpath%20d='M506.02%2076.349H507.109L503.948%2085.054H502.889L499.74%2076.349H500.829L502.765%2081.8698C503.016%2082.5878%20503.234%2083.2647%20503.419%2083.9004C503.478%2083.6061%20503.697%2082.9233%20504.078%2081.8521C504.69%2080.0982%20505.337%2078.2638%20506.02%2076.349ZM509.169%2085.054H508.151V76.349H509.169V85.054ZM511.117%2083.6178C512.024%2084.0652%20512.995%2084.2888%20514.031%2084.2888C515.306%2084.2888%20515.943%2083.7081%20515.943%2082.5466C515.943%2082.17%20515.841%2081.8659%20515.637%2081.6344C515.437%2081.3989%20515.07%2081.2145%20514.537%2081.0811L512.806%2080.6456C511.484%2080.312%20510.823%2079.6058%20510.823%2078.5267C510.823%2077.6988%20511.107%2077.0847%20511.676%2076.6845C512.245%2076.2803%20513.032%2076.0783%20514.036%2076.0783C514.562%2076.0783%20515.055%2076.1352%20515.514%2076.249C515.973%2076.3627%20516.357%2076.5158%20516.667%2076.708L516.373%2077.5379C516.11%2077.3927%20515.761%2077.2633%20515.325%2077.1495C514.894%2077.0357%20514.456%2076.9788%20514.013%2076.9788C512.593%2076.9788%20511.882%2077.4712%20511.882%2078.4561C511.882%2078.7896%20511.99%2079.0584%20512.206%2079.2624C512.426%2079.4625%20512.753%2079.6156%20513.189%2079.7215L514.843%2080.1217C515.549%2080.2905%20516.085%2080.5612%20516.45%2080.934C516.815%2081.3028%20516.997%2081.8286%20516.997%2082.5113C516.997%2083.3981%20516.724%2084.0671%20516.179%2084.5184C515.637%2084.9657%20514.9%2085.1893%20513.966%2085.1893C513.267%2085.1893%20512.645%2085.1187%20512.1%2084.9774C511.559%2084.8323%20511.129%2084.6616%20510.811%2084.4654L511.117%2083.6178ZM519.575%2085.054H518.557V76.349H519.575V85.054ZM524.407%2085.054H523.383V77.2495H520.705V76.349H527.085V77.2495H524.407V85.054ZM528.786%2080.7044C528.786%2081.8227%20529.043%2082.7016%20529.557%2083.3412C530.071%2083.9769%20530.83%2084.2947%20531.835%2084.2947C532.839%2084.2947%20533.595%2083.9769%20534.101%2083.3412C534.611%2082.7056%20534.866%2081.8266%20534.866%2080.7044C534.866%2079.5587%20534.609%2078.6699%20534.095%2078.0382C533.585%2077.4065%20532.833%2077.0906%20531.841%2077.0906C530.848%2077.0906%20530.091%2077.4065%20529.569%2078.0382C529.047%2078.6699%20528.786%2079.5587%20528.786%2080.7044ZM535.955%2080.7044C535.955%2081.3675%20535.863%2081.9738%20535.678%2082.5231C535.498%2083.0724%20535.235%2083.5453%20534.889%2083.9416C534.548%2084.3339%20534.116%2084.64%20533.595%2084.8597C533.073%2085.0755%20532.486%2085.1834%20531.835%2085.1834C530.956%2085.1834%20530.203%2084.9971%20529.575%2084.6243C528.951%2084.2476%20528.482%2083.7257%20528.168%2083.0587C527.858%2082.3877%20527.703%2081.601%20527.703%2080.6985C527.703%2079.3056%20528.066%2078.2069%20528.792%2077.4025C529.518%2076.5982%20530.534%2076.196%20531.841%2076.196C533.128%2076.196%20534.134%2076.6021%20534.86%2077.4143C535.59%2078.2226%20535.955%2079.3193%20535.955%2080.7044ZM538.521%2077.1612V80.1041C538.682%2080.1041%20539.013%2080.108%20539.516%2080.1159C540.022%2080.1237%20540.412%2080.1276%20540.687%2080.1276C541.436%2080.1276%20541.958%2080.004%20542.252%2079.7568C542.547%2079.5057%20542.694%2079.1094%20542.694%2078.5679C542.694%2078.0931%20542.553%2077.74%20542.27%2077.5085C541.988%2077.277%20541.515%2077.1612%20540.852%2077.1612H538.521ZM544.101%2085.054H542.923L541.723%2082.323C541.397%2081.5892%20541.189%2081.1478%20541.099%2080.9987C540.812%2081.0183%20540.473%2081.0281%20540.081%2081.0281L538.521%2080.9811V85.054H537.479V76.249H540.263C540.585%2076.249%20540.869%2076.2568%20541.117%2076.2725C541.364%2076.2882%20541.609%2076.3176%20541.852%2076.3608C542.099%2076.4%20542.313%2076.4569%20542.494%2076.5315C542.674%2076.6021%20542.843%2076.6963%20543%2076.814C543.157%2076.9278%20543.282%2077.0651%20543.377%2077.226C543.475%2077.3869%20543.551%2077.5791%20543.606%2077.8028C543.661%2078.0225%20543.689%2078.2717%20543.689%2078.5503C543.689%2079.0996%20543.543%2079.5724%20543.253%2079.9687C542.967%2080.365%20542.559%2080.6397%20542.029%2080.7927C542.029%2080.8006%20542.068%2080.8712%20542.147%2081.0046C542.225%2081.138%20542.317%2081.3028%20542.423%2081.499C542.533%2081.6913%20542.617%2081.8521%20542.676%2081.9816L544.101%2085.054ZM545.36%2083.6178C546.267%2084.0652%20547.238%2084.2888%20548.274%2084.2888C549.549%2084.2888%20550.186%2083.7081%20550.186%2082.5466C550.186%2082.17%20550.084%2081.8659%20549.88%2081.6344C549.68%2081.3989%20549.313%2081.2145%20548.78%2081.0811L547.049%2080.6456C545.727%2080.312%20545.066%2079.6058%20545.066%2078.5267C545.066%2077.6988%20545.35%2077.0847%20545.919%2076.6845C546.488%2076.2803%20547.275%2076.0783%20548.279%2076.0783C548.805%2076.0783%20549.298%2076.1352%20549.757%2076.249C550.216%2076.3627%20550.6%2076.5158%20550.91%2076.708L550.616%2077.5379C550.353%2077.3927%20550.004%2077.2633%20549.568%2077.1495C549.137%2077.0357%20548.699%2076.9788%20548.256%2076.9788C546.835%2076.9788%20546.125%2077.4712%20546.125%2078.4561C546.125%2078.7896%20546.233%2079.0584%20546.449%2079.2624C546.669%2079.4625%20546.996%2079.6156%20547.432%2079.7215L549.086%2080.1217C549.792%2080.2905%20550.328%2080.5612%20550.693%2080.934C551.057%2081.3028%20551.24%2081.8286%20551.24%2082.5113C551.24%2083.3981%20550.967%2084.0671%20550.422%2084.5184C549.88%2084.9657%20549.143%2085.1893%20548.209%2085.1893C547.51%2085.1893%20546.888%2085.1187%20546.343%2084.9774C545.802%2084.8323%20545.372%2084.6616%20545.054%2084.4654L545.36%2083.6178Z'%20fill='white'%20/%3e%3cg%20clip-path='url(%23clip6_12_1053)'%3e%3cpath%20d='M522.079%20104.063L522.036%20102.492L525.404%2098.6797C525.821%2098.2335%20526.124%2097.8236%20526.314%2097.4501C526.508%2097.0718%20526.605%2096.6741%20526.605%2096.257C526.605%2095.7962%20526.454%2095.43%20526.154%2095.1584C525.853%2094.8819%20525.458%2094.7437%20524.968%2094.7437C524.517%2094.7437%20524.07%2094.8286%20523.629%2094.9983C523.192%2095.1632%20522.834%2095.3718%20522.552%2095.624L522.007%2094.1835C522.734%2093.5433%20523.758%2093.2231%20525.077%2093.2231C526.124%2093.2231%20526.966%2093.4875%20527.601%2094.0162C528.242%2094.54%20528.562%2095.2821%20528.562%2096.2424C528.562%2096.9215%20528.38%2097.569%20528.016%2098.185C527.657%2098.8009%20527.165%2099.4339%20526.539%20100.084L524.138%20102.63H528.438L528.307%20104.063H522.079ZM529.595%20106.122C529.871%20104.779%20530.099%20103.53%20530.279%20102.376H532.054L532.032%20102.732C531.717%20103.828%20531.334%20104.958%20530.883%20106.122H529.595ZM534.549%20104.063L537.765%2094.911H533.371L533.385%2093.4487H539.933V94.5909L536.499%20104.063H534.549ZM540.981%20104.063L540.937%20102.492L544.306%2098.6797C544.723%2098.2335%20545.026%2097.8236%20545.215%2097.4501C545.409%2097.0718%20545.506%2096.6741%20545.506%2096.257C545.506%2095.7962%20545.356%2095.43%20545.055%2095.1584C544.754%2094.8819%20544.359%2094.7437%20543.869%2094.7437C543.418%2094.7437%20542.972%2094.8286%20542.53%2094.9983C542.094%2095.1632%20541.735%2095.3718%20541.454%2095.624L540.908%2094.1835C541.636%2093.5433%20542.659%2093.2231%20543.978%2093.2231C545.026%2093.2231%20545.867%2093.4875%20546.503%2094.0162C547.143%2094.54%20547.463%2095.2821%20547.463%2096.2424C547.463%2096.9215%20547.281%2097.569%20546.918%2098.185C546.559%2098.8009%20546.066%2099.4339%20545.441%20100.084L543.04%20102.63H547.34L547.209%20104.063H540.981ZM553.509%20104.063V101.699H548.7V100.404L553.014%2093.456H555.437V100.258H556.747L556.652%20101.699H555.437V104.063H553.509ZM550.592%20100.266H553.509V95.3185L550.592%20100.266Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip7_12_1053)'%3e%3cpath%20d='M465.472%2097.7294C465.089%2097.7294%20464.76%2097.8222%20464.483%2098.0077C464.208%2098.1932%20464.003%2098.4429%20463.868%2098.7567C463.732%2099.0704%20463.665%2099.4312%20463.665%2099.8389C463.665%20100.143%20463.702%20100.422%20463.775%20100.674C463.848%20100.923%20463.958%20101.143%20464.105%20101.333C464.251%20101.521%20464.441%20101.668%20464.675%20101.773C464.911%20101.876%20465.181%20101.928%20465.486%20101.928C465.877%20101.928%20466.283%20101.826%20466.702%20101.622L466.802%20102.127C466.46%20102.342%20465.999%20102.45%20465.417%20102.45C465.035%20102.45%20464.691%20102.387%20464.386%20102.261C464.084%20102.133%20463.833%20101.953%20463.634%20101.722C463.437%20101.488%20463.287%20101.211%20463.184%20100.89C463.081%20100.567%20463.029%20100.209%20463.029%2099.8148C463.029%2099.4346%20463.085%2099.0842%20463.198%2098.7635C463.31%2098.4429%20463.468%2098.1681%20463.672%2097.939C463.878%2097.7077%20464.134%2097.5279%20464.441%2097.3996C464.748%2097.2714%20465.089%2097.2073%20465.465%2097.2073C466.035%2097.2073%20466.516%2097.3332%20466.908%2097.5852L466.674%2098.0696C466.299%2097.8428%20465.898%2097.7294%20465.472%2097.7294ZM471.464%2097.2931V100.591C471.464%20101.175%20471.303%20101.631%20470.983%20101.959C470.664%20102.286%20470.179%20102.45%20469.526%20102.45C468.873%20102.45%20468.391%20102.286%20468.08%20101.959C467.768%20101.631%20467.612%20101.173%20467.612%20100.584V97.2931H468.21V100.595C468.21%20101.055%20468.319%20101.394%20468.536%20101.612C468.754%20101.829%20469.091%20101.938%20469.546%20101.938C469.991%20101.938%20470.322%20101.828%20470.539%20101.608C470.759%20101.388%20470.869%20101.049%20470.869%20100.591V97.2931H471.464ZM473.13%2097.7672V99.485C473.224%2099.485%20473.417%2099.4873%20473.71%2099.4919C474.006%2099.4964%20474.234%2099.4987%20474.394%2099.4987C474.831%2099.4987%20475.136%2099.4266%20475.308%2099.2823C475.48%2099.1357%20475.566%2098.9044%20475.566%2098.5883C475.566%2098.3112%20475.483%2098.1051%20475.318%2097.9699C475.153%2097.8348%20474.877%2097.7672%20474.49%2097.7672H473.13ZM476.387%20102.374H475.699L474.999%20100.78C474.809%20100.352%20474.687%20100.094%20474.634%20100.007C474.467%20100.019%20474.269%20100.024%20474.04%20100.024L473.13%2099.9969V102.374H472.522V97.2347H474.147C474.334%2097.2347%20474.5%2097.2393%20474.645%2097.2485C474.789%2097.2576%20474.932%2097.2748%20475.074%2097.3C475.219%2097.3229%20475.343%2097.3561%20475.449%2097.3996C475.554%2097.4409%20475.653%2097.4958%20475.744%2097.5645C475.836%2097.631%20475.909%2097.7111%20475.964%2097.805C476.021%2097.8989%20476.066%2098.0112%20476.098%2098.1417C476.13%2098.27%20476.146%2098.4154%20476.146%2098.578C476.146%2098.8987%20476.061%2099.1747%20475.892%2099.406C475.725%2099.6373%20475.486%2099.7976%20475.177%2099.887C475.177%2099.8915%20475.2%2099.9328%20475.246%20100.011C475.292%20100.089%20475.346%20100.185%20475.407%20100.299C475.472%20100.411%20475.521%20100.505%20475.555%20100.581L476.387%20102.374ZM477.733%2097.7672V99.485C477.827%2099.485%20478.021%2099.4873%20478.314%2099.4919C478.609%2099.4964%20478.837%2099.4987%20478.998%2099.4987C479.435%2099.4987%20479.74%2099.4266%20479.911%2099.2823C480.083%2099.1357%20480.169%2098.9044%20480.169%2098.5883C480.169%2098.3112%20480.087%2098.1051%20479.922%2097.9699C479.757%2097.8348%20479.481%2097.7672%20479.094%2097.7672H477.733ZM480.99%20102.374H480.303L479.602%20100.78C479.412%20100.352%20479.291%20100.094%20479.238%20100.007C479.071%20100.019%20478.873%20100.024%20478.644%20100.024L477.733%2099.9969V102.374H477.125V97.2347H478.75C478.938%2097.2347%20479.104%2097.2393%20479.248%2097.2485C479.393%2097.2576%20479.536%2097.2748%20479.678%2097.3C479.822%2097.3229%20479.947%2097.3561%20480.052%2097.3996C480.158%2097.4409%20480.256%2097.4958%20480.348%2097.5645C480.439%2097.631%20480.513%2097.7111%20480.568%2097.805C480.625%2097.8989%20480.67%2098.0112%20480.702%2098.1417C480.734%2098.27%20480.75%2098.4154%20480.75%2098.578C480.75%2098.8987%20480.665%2099.1747%20480.495%2099.406C480.328%2099.6373%20480.09%2099.7976%20479.781%2099.887C479.781%2099.8915%20479.804%2099.9328%20479.85%20100.011C479.895%20100.089%20479.949%20100.185%20480.011%20100.299C480.075%20100.411%20480.124%20100.505%20480.159%20100.581L480.99%20102.374ZM481.822%20102.374V97.2931H484.735L484.711%2097.8188H482.416V99.4816H484.597V100H482.416V101.849H484.786L484.759%20102.374H481.822ZM489.764%20102.374H489.091L486.453%2098.3753L486.281%2098.1383C486.299%2098.6192%20486.308%2099.0487%20486.308%2099.4266V102.374H485.752V97.2931H486.415L489.06%20101.292L489.235%20101.529C489.219%20100.799%20489.211%20100.376%20489.211%20100.261V97.2931H489.764V102.374ZM492.547%20102.374H491.949V97.8188H490.386V97.2931H494.11V97.8188H492.547V102.374Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M468.175%20110.73H467.514V105.143H469.314C469.588%20105.143%20469.836%20105.172%20470.057%20105.229C470.279%20105.286%20470.476%20105.373%20470.647%20105.49C470.819%20105.607%20470.952%20105.764%20471.047%20105.961C471.142%20106.158%20471.189%20106.387%20471.189%20106.648C471.189%20106.865%20471.169%20107.059%20471.129%20107.231C471.089%20107.4%20471.021%20107.559%20470.924%20107.709C470.827%20107.858%20470.7%20107.983%20470.543%20108.082C470.386%20108.179%20470.184%20108.256%20469.938%20108.314C469.694%20108.368%20469.41%20108.396%20469.086%20108.396C468.83%20108.396%20468.526%20108.38%20468.175%20108.347V110.73ZM469.15%20107.824C469.394%20107.824%20469.603%20107.801%20469.777%20107.754C469.951%20107.706%20470.085%20107.648%20470.177%20107.578C470.271%20107.508%20470.345%20107.417%20470.397%20107.305C470.452%20107.193%20470.485%20107.091%20470.498%20106.999C470.51%20106.905%20470.517%20106.791%20470.517%20106.659C470.517%20106.343%20470.41%20106.11%20470.195%20105.961C469.984%20105.812%20469.695%20105.737%20469.329%20105.737H468.175V107.817C468.656%20107.822%20468.98%20107.824%20469.15%20107.824ZM471.951%20110.73V105.207H475.118L475.091%20105.778H472.597V107.585H474.968V108.149H472.597V110.159H475.174L475.144%20110.73H471.951ZM476.783%20105.722V107.589C476.885%20107.589%20477.096%20107.592%20477.414%20107.597C477.736%20107.602%20477.983%20107.604%20478.158%20107.604C478.633%20107.604%20478.964%20107.526%20479.151%20107.369C479.338%20107.21%20479.431%20106.958%20479.431%20106.614C479.431%20106.313%20479.341%20106.089%20479.162%20105.942C478.983%20105.795%20478.683%20105.722%20478.262%20105.722H476.783ZM480.324%20110.73H479.577L478.815%20108.997C478.608%20108.532%20478.476%20108.251%20478.419%20108.157C478.237%20108.169%20478.022%20108.176%20477.773%20108.176L476.783%20108.146V110.73H476.122V105.143H477.889C478.093%20105.143%20478.273%20105.148%20478.43%20105.158C478.587%20105.168%20478.743%20105.187%20478.897%20105.214C479.054%20105.239%20479.19%20105.275%20479.304%20105.322C479.419%20105.367%20479.526%20105.427%20479.625%20105.502C479.725%20105.574%20479.805%20105.661%20479.864%20105.763C479.927%20105.865%20479.975%20105.987%20480.01%20106.129C480.045%20106.268%20480.062%20106.426%20480.062%20106.603C480.062%20106.952%20479.97%20107.252%20479.786%20107.503C479.604%20107.755%20479.345%20107.929%20479.009%20108.026C479.009%20108.031%20479.034%20108.076%20479.084%20108.161C479.134%20108.245%20479.192%20108.35%20479.259%20108.474C479.329%20108.596%20479.383%20108.698%20479.42%20108.781L480.324%20110.73ZM481.903%20110.73H481.257V105.207H481.903V110.73ZM483.7%20107.97C483.7%20108.68%20483.863%20109.237%20484.189%20109.643C484.515%20110.047%20484.997%20110.248%20485.634%20110.248C486.272%20110.248%20486.751%20110.047%20487.072%20109.643C487.396%20109.24%20487.558%20108.682%20487.558%20107.97C487.558%20107.243%20487.394%20106.679%20487.068%20106.278C486.745%20105.878%20486.268%20105.677%20485.638%20105.677C485.008%20105.677%20484.528%20105.878%20484.196%20106.278C483.865%20106.679%20483.7%20107.243%20483.7%20107.97ZM488.248%20107.97C488.248%20108.391%20488.19%20108.776%20488.073%20109.124C487.958%20109.473%20487.792%20109.773%20487.572%20110.024C487.356%20110.273%20487.082%20110.467%20486.751%20110.607C486.42%20110.744%20486.048%20110.812%20485.634%20110.812C485.077%20110.812%20484.598%20110.694%20484.2%20110.457C483.804%20110.218%20483.507%20109.887%20483.308%20109.464C483.111%20109.038%20483.013%20108.539%20483.013%20107.966C483.013%20107.083%20483.243%20106.385%20483.703%20105.875C484.164%20105.365%20484.809%20105.109%20485.638%20105.109C486.455%20105.109%20487.093%20105.367%20487.554%20105.882C488.017%20106.395%20488.248%20107.091%20488.248%20107.97ZM493.167%20107.981C493.167%20107.21%20492.968%20106.648%20492.569%20106.297C492.171%20105.946%20491.591%20105.77%20490.829%20105.77H489.963V110.166H490.937C491.664%20110.166%20492.217%20109.983%20492.595%20109.617C492.976%20109.249%20493.167%20108.703%20493.167%20107.981ZM493.858%20107.963C493.858%20108.861%20493.603%20109.547%20493.092%20110.02C492.582%20110.493%20491.87%20110.73%20490.956%20110.73H489.317V105.207H490.848C491.308%20105.207%20491.72%20105.261%20492.084%20105.371C492.447%20105.478%20492.762%20105.642%20493.029%20105.864C493.298%20106.083%20493.503%20106.37%20493.645%20106.727C493.787%20107.08%20493.858%20107.492%20493.858%20107.963Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip8_12_1053)'%3e%3cpath%20d='M593.339%20103.385L593.307%20102.236L595.771%2099.4468C596.077%2099.1203%20596.298%2098.8205%20596.437%2098.5473C596.579%2098.2706%20596.65%2097.9796%20596.65%2097.6745C596.65%2097.3374%20596.54%2097.0695%20596.32%2096.8708C596.1%2096.6686%20595.81%2096.5674%20595.452%2096.5674C595.122%2096.5674%20594.796%2096.6295%20594.473%2096.7537C594.153%2096.8743%20593.891%2097.0269%20593.685%2097.2114L593.286%2096.1576C593.818%2095.6893%20594.567%2095.4551%20595.532%2095.4551C596.298%2095.4551%20596.914%2095.6485%20597.379%2096.0352C597.847%2096.4184%20598.081%2096.9613%20598.081%2097.6638C598.081%2098.1606%20597.948%2098.6342%20597.682%2099.0849C597.42%2099.5355%20597.059%2099.9985%20596.602%20100.474L594.845%20102.337H597.991L597.895%20103.385H593.339ZM601.221%20102.145C601.424%20102.308%20601.667%20102.39%20601.951%20102.39C602.234%20102.39%20602.476%20102.308%20602.674%20102.145C602.877%20101.982%20603.029%20101.757%20603.132%20101.469C603.239%20101.178%20603.315%20100.87%20603.361%20100.543C603.407%20100.213%20603.43%2099.8477%20603.43%2099.4468C603.43%2097.5237%20602.937%2096.5621%20601.951%2096.5621C600.971%2096.5621%20600.474%2097.5166%20600.46%2099.4255C600.46%2099.83%20600.483%20100.197%20600.529%20100.527C600.576%20100.857%20600.652%20101.169%20600.758%20101.464C600.865%20101.755%20601.019%20101.982%20601.221%20102.145ZM603.084%20103.284C602.751%20103.426%20602.373%20103.497%20601.951%20103.497C601.528%20103.497%20601.149%20103.426%20600.812%20103.284C600.474%20103.139%20600.196%20102.944%20599.976%20102.699C599.756%20102.45%20599.571%20102.154%20599.422%20101.81C599.277%20101.466%20599.172%20101.102%20599.108%20100.719C599.048%20100.336%20599.018%2099.9258%20599.018%2099.4894C599.018%2099.0458%20599.05%2098.6307%20599.114%2098.2439C599.178%2097.8536%20599.284%2097.4864%20599.433%2097.1422C599.582%2096.7945%20599.767%2096.4982%20599.987%2096.2534C600.21%2096.0086%20600.489%2095.8152%20600.822%2095.6733C601.156%2095.5278%20601.532%2095.4551%20601.951%2095.4551C602.369%2095.4551%20602.745%2095.5278%20603.079%2095.6733C603.412%2095.8152%20603.689%2096.0104%20603.909%2096.2587C604.129%2096.5036%20604.312%2096.7998%20604.457%2097.1476C604.606%2097.4917%20604.713%2097.8572%20604.777%2098.2439C604.841%2098.6307%20604.872%2099.0458%20604.872%2099.4894C604.872%2099.9258%20604.841%20100.336%20604.777%20100.719C604.716%20101.102%20604.613%20101.467%20604.468%20101.815C604.322%20102.159%20604.14%20102.454%20603.92%20102.699C603.7%20102.944%20603.421%20103.139%20603.084%20103.284ZM606.698%20103.481C606.467%20103.481%20606.272%20103.401%20606.113%20103.242C605.953%20103.082%20605.873%20102.892%20605.873%20102.672C605.873%20102.449%20605.951%20102.255%20606.107%20102.092C606.267%20101.929%20606.464%20101.847%20606.698%20101.847C606.925%20101.847%20607.117%20101.929%20607.273%20102.092C607.429%20102.255%20607.507%20102.449%20607.507%20102.672C607.507%20102.892%20607.429%20103.082%20607.273%20103.242C607.117%20103.401%20606.925%20103.481%20606.698%20103.481ZM610.801%20103.497C610.45%20103.497%20610.088%20103.44%20609.716%20103.327C609.343%20103.21%20609.059%20103.1%20608.864%20102.997C608.669%20102.89%20608.54%20102.809%20608.476%20102.752L608.901%20101.751C608.969%20101.805%20609.066%20101.872%20609.194%20101.954C609.325%20102.032%20609.535%20102.122%20609.822%20102.225C610.113%20102.328%20610.392%20102.379%20610.658%20102.379C611.155%20102.379%20611.531%20102.241%20611.786%20101.964C612.042%20101.687%20612.169%20101.326%20612.169%20100.878C612.169%20100.456%20612.052%20100.117%20611.818%2099.8619C611.587%2099.6064%20611.288%2099.4787%20610.919%2099.4787C610.479%2099.4787%20610.085%2099.6703%20609.737%20100.054L608.806%2099.8726L609.008%2095.6254H613.244L613.165%2096.7218H610.243C610.243%2096.7856%20610.23%2097.1068%20610.205%2097.6851C610.184%2098.2599%20610.172%2098.581%20610.168%2098.6484C610.48%2098.4817%20610.809%2098.3983%20611.153%2098.3983C611.869%2098.3983%20612.446%2098.6289%20612.882%2099.0902C613.322%2099.5514%20613.542%20100.153%20613.542%20100.894C613.542%20101.682%20613.301%20102.314%20612.819%20102.789C612.34%20103.261%20611.667%20103.497%20610.801%20103.497ZM616.14%2098.9358C616.448%2098.9358%20616.681%2098.8205%20616.837%2098.5899C616.997%2098.3593%20617.076%2098.0612%20617.076%2097.6958C617.076%2097.3232%20616.997%2097.0216%20616.837%2096.791C616.681%2096.5603%20616.45%2096.445%20616.145%2096.445C615.84%2096.445%20615.609%2096.5621%20615.453%2096.7963C615.297%2097.0305%20615.219%2097.3338%20615.219%2097.7064C615.219%2098.079%20615.295%2098.377%20615.448%2098.6005C615.604%2098.8241%20615.835%2098.9358%20616.14%2098.9358ZM616.124%2099.7821C615.545%2099.7821%20615.089%2099.5869%20614.756%2099.1966C614.426%2098.8063%20614.261%2098.3096%20614.261%2097.7064C614.261%2097.1032%20614.431%2096.6029%20614.772%2096.2055C615.116%2095.8081%20615.576%2095.6094%20616.15%2095.6094C616.75%2095.6094%20617.222%2095.8046%20617.566%2096.1949C617.91%2096.5852%20618.082%2097.0837%20618.082%2097.6904C618.082%2098.2901%20617.903%2098.7886%20617.545%2099.186C617.186%2099.5834%20616.713%2099.7821%20616.124%2099.7821ZM615.607%20103.556L620.403%2095.668L621.574%2095.6733L616.741%20103.556H615.607ZM621.329%20102.629C621.648%20102.629%20621.888%20102.514%20622.047%20102.284C622.211%20102.049%20622.292%20101.748%20622.292%20101.379C622.292%20101.01%20622.205%20100.713%20622.031%20100.49C621.861%20100.263%20621.606%20100.149%20621.265%20100.149C620.924%20100.149%20620.687%20100.261%20620.552%20100.485C620.417%20100.708%20620.35%20101.015%20620.35%20101.405C620.35%20101.774%20620.431%20102.071%20620.594%20102.294C620.761%20102.518%20621.006%20102.629%20621.329%20102.629ZM621.313%20103.476C620.703%20103.476%20620.22%20103.281%20619.865%20102.89C619.514%20102.496%20619.338%20102.001%20619.338%20101.405C619.338%20100.007%20619.982%2099.3084%20621.27%2099.3084C621.905%2099.3084%20622.392%2099.5018%20622.729%2099.8885C623.069%20100.272%20623.24%20100.77%20623.24%20101.384C623.24%20101.984%20623.066%20102.482%20622.718%20102.88C622.374%20103.277%20621.905%20103.476%20621.313%20103.476Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip9_12_1053)'%3e%3cpath%20d='M522.279%20130.313L522.235%20128.742L525.603%20124.93C526.021%20124.483%20526.324%20124.074%20526.513%20123.7C526.707%20123.322%20526.804%20122.924%20526.804%20122.507C526.804%20122.046%20526.653%20121.68%20526.353%20121.408C526.052%20121.132%20525.657%20120.994%20525.167%20120.994C524.716%20120.994%20524.27%20121.079%20523.828%20121.248C523.392%20121.413%20523.033%20121.622%20522.751%20121.874L522.206%20120.433C522.933%20119.793%20523.957%20119.473%20525.276%20119.473C526.324%20119.473%20527.165%20119.737%20527.801%20120.266C528.441%20120.79%20528.761%20121.532%20528.761%20122.492C528.761%20123.171%20528.579%20123.819%20528.215%20124.435C527.856%20125.051%20527.364%20125.684%20526.738%20126.334L524.337%20128.88H528.637L528.506%20130.313H522.279ZM533.803%20130.466C532.619%20130.466%20531.657%20130.144%20530.914%20129.499C530.172%20128.854%20529.801%20128.002%20529.801%20126.945C529.801%20126.605%20529.838%20126.28%20529.91%20125.97C529.983%20125.66%20530.095%20125.357%20530.245%20125.061C530.395%20124.765%20530.546%20124.503%20530.696%20124.275C530.847%20124.047%20531.041%20123.775%20531.278%20123.46L534.305%20119.64H536.56L533.257%20123.809C533.611%20123.688%20533.907%20123.627%20534.145%20123.627C535.188%20123.627%20536.041%20123.94%20536.706%20124.566C537.37%20125.187%20537.702%20125.997%20537.702%20126.996C537.702%20128.034%20537.339%20128.873%20536.611%20129.513C535.884%20130.149%20534.947%20130.466%20533.803%20130.466ZM533.715%20129.011C534.356%20129.011%20534.855%20128.829%20535.214%20128.466C535.578%20128.097%20535.76%20127.614%20535.76%20127.018C535.76%20126.392%20535.59%20125.9%20535.251%20125.541C534.911%20125.177%20534.407%20124.995%20533.737%20124.995C533.058%20124.995%20532.559%20125.177%20532.239%20125.541C531.918%20125.905%20531.758%20126.402%20531.758%20127.032C531.758%20127.629%20531.928%20128.109%20532.268%20128.473C532.607%20128.832%20533.09%20129.011%20533.715%20129.011ZM539.885%20130.444C539.57%20130.444%20539.303%20130.335%20539.085%20130.117C538.866%20129.899%20538.757%20129.639%20538.757%20129.339C538.757%20129.033%20538.864%20128.769%20539.077%20128.546C539.296%20128.322%20539.565%20128.211%20539.885%20128.211C540.195%20128.211%20540.457%20128.322%20540.671%20128.546C540.884%20128.769%20540.991%20129.033%20540.991%20129.339C540.991%20129.639%20540.884%20129.899%20540.671%20130.117C540.457%20130.335%20540.195%20130.444%20539.885%20130.444ZM543.319%20130.313L546.549%20126.108C546.224%20126.22%20545.936%20126.276%20545.683%20126.276C544.641%20126.276%20543.789%20125.963%20543.13%20125.337C542.475%20124.707%20542.148%20123.892%20542.148%20122.893C542.148%20121.855%20542.507%20121.025%20543.224%20120.404C543.947%20119.784%20544.883%20119.473%20546.033%20119.473C547.221%20119.473%20548.184%20119.793%20548.921%20120.433C549.658%20121.069%20550.027%20121.915%20550.027%20122.973C550.027%20123.584%20549.91%20124.139%20549.678%20124.639C549.445%20125.138%20549.103%20125.696%20548.652%20126.312L545.64%20130.313H543.319ZM546.091%20124.937C546.765%20124.937%20547.262%20124.75%20547.582%20124.377C547.907%20124.003%20548.07%20123.499%20548.07%20122.863C548.07%20122.267%20547.902%20121.794%20547.568%20121.445C547.233%20121.096%20546.753%20120.921%20546.127%20120.921C545.482%20120.921%20544.975%20121.103%20544.607%20121.467C544.243%20121.83%20544.061%20122.308%20544.061%20122.9C544.061%20123.53%20544.231%20124.028%20544.57%20124.391C544.915%20124.755%20545.422%20124.937%20546.091%20124.937ZM551.54%20130.313V119.655H553.519V124.457C553.863%20124.001%20554.567%20123.15%20555.629%20121.903C556.696%20120.657%20557.331%20119.907%20557.535%20119.655H559.871L555.84%20124.45L560.125%20130.313H557.812L554.334%20125.534L553.519%20126.217V130.313H551.54Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip10_12_1053)'%3e%3cpath%20d='M467.219%20124.098V125.786C467.311%20125.786%20467.501%20125.788%20467.789%20125.792C468.079%20125.797%20468.303%20125.799%20468.461%20125.799C468.89%20125.799%20469.19%20125.728%20469.358%20125.587C469.527%20125.443%20469.612%20125.215%20469.612%20124.905C469.612%20124.632%20469.531%20124.43%20469.369%20124.297C469.207%20124.164%20468.935%20124.098%20468.555%20124.098H467.219ZM470.418%20128.624H469.743L469.055%20127.058C468.868%20126.637%20468.749%20126.384%20468.697%20126.299C468.533%20126.31%20468.338%20126.316%20468.113%20126.316L467.219%20126.289V128.624H466.621V123.575H468.218C468.402%20123.575%20468.565%20123.579%20468.707%20123.588C468.849%20123.597%20468.989%20123.614%20469.129%20123.639C469.271%20123.662%20469.393%20123.694%20469.497%20123.737C469.6%20123.777%20469.697%20123.831%20469.787%20123.899C469.877%20123.964%20469.949%20124.043%20470.003%20124.135C470.059%20124.227%20470.103%20124.338%20470.135%20124.466C470.166%20124.592%20470.182%20124.735%20470.182%20124.895C470.182%20125.21%20470.099%20125.481%20469.932%20125.708C469.768%20125.935%20469.534%20126.093%20469.23%20126.181C469.23%20126.185%20469.253%20126.226%20469.298%20126.302C469.343%20126.379%20469.396%20126.473%20469.456%20126.586C469.519%20126.696%20469.568%20126.788%20469.602%20126.862L470.418%20128.624ZM471.647%20126.13C471.647%20126.771%20471.794%20127.275%20472.089%20127.642C472.384%20128.007%20472.819%20128.189%20473.395%20128.189C473.971%20128.189%20474.404%20128.007%20474.695%20127.642C474.987%20127.278%20475.134%20126.774%20475.134%20126.13C475.134%20125.473%20474.986%20124.963%20474.691%20124.601C474.399%20124.239%20473.968%20124.058%20473.399%20124.058C472.829%20124.058%20472.395%20124.239%20472.096%20124.601C471.797%20124.963%20471.647%20125.473%20471.647%20126.13ZM475.758%20126.13C475.758%20126.51%20475.705%20126.858%20475.599%20127.173C475.496%20127.488%20475.345%20127.759%20475.147%20127.986C474.951%20128.211%20474.704%20128.387%20474.404%20128.513C474.105%20128.637%20473.769%20128.699%20473.395%20128.699C472.891%20128.699%20472.459%20128.592%20472.099%20128.378C471.741%20128.162%20471.473%20127.863%20471.292%20127.48C471.115%20127.095%20471.026%20126.644%20471.026%20126.127C471.026%20125.328%20471.234%20124.698%20471.65%20124.236C472.067%20123.775%20472.649%20123.545%20473.399%20123.545C474.137%20123.545%20474.714%20123.777%20475.13%20124.243C475.549%20124.707%20475.758%20125.336%20475.758%20126.13ZM476.723%20128.624V123.632H477.311V128.104H479.508L479.488%20128.624H476.723ZM480.173%20128.624V123.632H480.76V128.104H482.957L482.937%20128.624H480.173ZM484.233%20128.624H483.649V123.632H484.233V128.624ZM489.387%20128.624H488.726L486.133%20124.695L485.965%20124.463C485.983%20124.935%20485.992%20125.357%20485.992%20125.728V128.624H485.445V123.632H486.096L488.695%20127.561L488.867%20127.794C488.852%20127.076%20488.844%20126.661%20488.844%20126.548V123.632H489.387V128.624ZM492.739%20128.699C492.359%20128.699%20492.016%20128.636%20491.713%20128.51C491.411%20128.381%20491.161%20128.203%20490.963%20127.976C490.768%20127.747%20490.617%20127.476%20490.511%20127.163C490.408%20126.85%20490.356%20126.507%20490.356%20126.133C490.356%20125.629%20490.452%20125.184%20490.643%20124.797C490.834%20124.41%20491.119%20124.105%20491.497%20123.882C491.875%20123.659%20492.323%20123.548%20492.84%20123.548C493.414%20123.548%20493.918%20123.678%20494.352%20123.939L494.129%20124.422C493.711%20124.181%20493.283%20124.061%20492.847%20124.061C492.543%20124.061%20492.271%20124.114%20492.03%20124.22C491.791%20124.323%20491.596%20124.468%20491.443%20124.655C491.292%20124.839%20491.176%20125.058%20491.095%20125.31C491.016%20125.56%20490.977%20125.834%20490.977%20126.133C490.977%20126.768%20491.134%20127.27%20491.449%20127.639C491.767%20128.005%20492.234%20128.189%20492.85%20128.189C493.201%20128.189%20493.558%20128.118%20493.92%20127.976V126.552H492.742L492.762%20126.042H494.467V128.324C494.183%20128.459%20493.909%20128.556%20493.643%20128.614C493.38%20128.67%20493.079%20128.699%20492.739%20128.699Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M453.642%20131.19H454.257V136.98H453.572V131.906C453.311%20132.076%20452.993%20132.222%20452.616%20132.343V131.697C452.657%20131.679%20452.741%20131.643%20452.867%20131.589C452.994%20131.534%20453.088%20131.493%20453.15%20131.465C453.214%20131.436%20453.294%20131.396%20453.39%20131.345C453.485%20131.293%20453.569%20131.241%20453.642%20131.19ZM455.333%20136.98L455.244%20136.345L457.245%20134.124C457.379%20133.974%20457.508%20133.78%20457.632%20133.543C457.758%20133.306%20457.85%20133.104%20457.907%20132.939L457.996%20132.695C457.996%20132.376%20457.907%20132.128%20457.729%20131.952C457.551%20131.774%20457.298%20131.685%20456.97%20131.685C456.423%20131.685%20455.992%20131.844%20455.677%20132.161L455.453%20131.581C455.809%20131.245%20456.33%20131.078%20457.016%20131.078C457.543%20131.078%20457.962%20131.221%20458.274%20131.507C458.587%20131.791%20458.743%20132.172%20458.743%20132.649C458.732%20132.685%20458.717%20132.734%20458.696%20132.796C458.676%20132.855%20458.63%20132.973%20458.561%20133.148C458.494%20133.324%20458.423%20133.49%20458.348%20133.648C458.273%20133.805%20458.178%20133.978%20458.062%20134.166C457.948%20134.355%20457.832%20134.512%20457.713%20134.638L456.08%20136.384H458.762L458.719%20136.98H455.333ZM464.378%20136.628L462.621%20132.541L462.474%20132.15L462.501%20133.551V136.98H461.874V131.256H462.741L464.734%20135.815L466.708%20131.256H467.552V136.98H466.901V133.535L466.929%20132.165L466.785%20132.556L465.032%20136.628H464.378ZM469.379%20134.12C469.379%20134.855%20469.548%20135.433%20469.886%20135.854C470.224%20136.272%20470.723%20136.481%20471.383%20136.481C472.044%20136.481%20472.541%20136.272%20472.873%20135.854C473.209%20135.436%20473.377%20134.858%20473.377%20134.12C473.377%20133.366%20473.208%20132.782%20472.87%20132.366C472.534%20131.951%20472.04%20131.743%20471.387%20131.743C470.734%20131.743%20470.236%20131.951%20469.893%20132.366C469.55%20132.782%20469.379%20133.366%20469.379%20134.12ZM474.093%20134.12C474.093%20134.556%20474.032%20134.954%20473.911%20135.316C473.792%20135.677%20473.619%20135.988%20473.392%20136.248C473.168%20136.507%20472.884%20136.708%20472.541%20136.852C472.197%20136.994%20471.812%20137.065%20471.383%20137.065C470.805%20137.065%20470.31%20136.943%20469.897%20136.697C469.487%20136.45%20469.179%20136.107%20468.972%20135.668C468.768%20135.227%20468.666%20134.709%20468.666%20134.116C468.666%20133.2%20468.905%20132.477%20469.382%20131.948C469.86%20131.42%20470.528%20131.155%20471.387%20131.155C472.234%20131.155%20472.895%20131.422%20473.373%20131.956C473.853%20132.488%20474.093%20133.209%20474.093%20134.12ZM479.72%20136.98H478.962L475.989%20132.475L475.796%20132.208C475.816%20132.75%20475.827%20133.233%20475.827%20133.659V136.98H475.2V131.256H475.947L478.927%20135.761L479.124%20136.028C479.106%20135.205%20479.097%20134.729%20479.097%20134.6V131.256H479.72V136.98ZM482.855%20136.98H482.182V131.848H480.421V131.256H484.616V131.848H482.855V136.98ZM489.737%20136.98H489.067V134.302H485.994V136.98H485.325V131.256H485.994V133.713H489.067V131.256H489.737V136.98ZM490.975%20136.036C491.571%20136.33%20492.21%20136.477%20492.891%20136.477C493.73%20136.477%20494.149%20136.095%20494.149%20135.331C494.149%20135.083%20494.082%20134.884%20493.948%20134.731C493.816%20134.576%20493.575%20134.455%20493.224%20134.367L492.086%20134.081C491.217%20133.862%20490.782%20133.397%20490.782%20132.688C490.782%20132.143%20490.969%20131.739%20491.343%20131.476C491.717%20131.211%20492.234%20131.078%20492.895%20131.078C493.241%20131.078%20493.565%20131.115%20493.866%20131.19C494.168%20131.265%20494.421%20131.365%20494.625%20131.492L494.432%20132.037C494.259%20131.942%20494.029%20131.857%20493.743%20131.782C493.459%20131.707%20493.171%20131.67%20492.88%20131.67C491.945%20131.67%20491.478%20131.994%20491.478%20132.641C491.478%20132.861%20491.549%20133.037%20491.691%20133.172C491.836%20133.303%20492.051%20133.404%20492.338%20133.473L493.425%20133.737C493.89%20133.848%20494.242%20134.026%20494.482%20134.271C494.722%20134.513%20494.842%20134.859%20494.842%20135.308C494.842%20135.891%20494.663%20136.331%20494.304%20136.628C493.948%20136.922%20493.463%20137.069%20492.849%20137.069C492.389%20137.069%20491.98%20137.023%20491.622%20136.93C491.266%20136.834%20490.983%20136.722%20490.774%20136.593L490.975%20136.036Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip11_12_1053)'%3e%3cpath%20d='M596.218%20129.747C595.76%20129.747%20595.329%20129.688%20594.925%20129.571C594.524%20129.451%20594.206%20129.289%20593.972%20129.087L594.355%20128.081C594.55%20128.244%20594.82%20128.379%20595.164%20128.486C595.508%20128.589%20595.861%20128.64%20596.223%20128.64C596.631%20128.64%20596.96%20128.53%20597.208%20128.31C597.46%20128.09%20597.586%20127.803%20597.586%20127.448C597.586%20127.228%20597.55%20127.038%20597.479%20126.878C597.412%20126.719%20597.322%20126.591%20597.208%20126.495C597.094%20126.399%20596.942%20126.323%20596.75%20126.266C596.562%20126.206%20596.369%20126.165%20596.17%20126.144C595.971%20126.123%20595.732%20126.11%20595.452%20126.107C595.441%20126.107%20595.39%20126.107%20595.297%20126.107C595.205%20126.103%20595.154%20126.101%20595.143%20126.101V125.026H595.441C595.75%20125.026%20596.014%20125.01%20596.234%20124.978C596.458%20124.946%20596.663%20124.891%20596.851%20124.813C597.043%20124.735%20597.187%20124.62%20597.282%20124.467C597.382%20124.315%20597.431%20124.127%20597.431%20123.903C597.431%20123.602%20597.318%20123.344%20597.091%20123.131C596.864%20122.919%20596.544%20122.812%20596.133%20122.812C595.466%20122.812%20594.871%20122.979%20594.35%20123.312L593.967%20122.301C594.612%20121.904%20595.379%20121.705%20596.266%20121.705C597.007%20121.705%20597.612%20121.9%20598.081%20122.291C598.553%20122.681%20598.789%20123.181%20598.789%20123.791C598.789%20124.217%20598.679%20124.581%20598.459%20124.882C598.242%20125.181%20597.926%20125.399%20597.511%20125.537C597.987%20125.629%20598.354%20125.858%20598.613%20126.224C598.876%20126.589%20599.007%20127.02%20599.007%20127.517C599.007%20127.989%20598.881%20128.397%20598.629%20128.741C598.377%20129.082%20598.044%20129.335%20597.628%20129.502C597.213%20129.665%20596.743%20129.747%20596.218%20129.747ZM602.647%20129.747C601.782%20129.747%20601.077%20129.511%20600.534%20129.039C599.992%20128.567%20599.72%20127.945%20599.72%20127.171C599.72%20126.923%20599.747%20126.685%20599.8%20126.458C599.853%20126.231%20599.935%20126.009%20600.045%20125.793C600.155%20125.576%20600.265%20125.385%20600.375%20125.218C600.485%20125.051%20600.627%20124.852%20600.8%20124.622L603.015%20121.827H604.664L602.248%20124.877C602.507%20124.788%20602.724%20124.744%20602.897%20124.744C603.66%20124.744%20604.285%20124.973%20604.771%20125.431C605.257%20125.885%20605.5%20126.477%20605.5%20127.208C605.5%20127.968%20605.234%20128.581%20604.702%20129.05C604.169%20129.515%20603.485%20129.747%20602.647%20129.747ZM602.583%20128.683C603.052%20128.683%20603.417%20128.55%20603.68%20128.283C603.946%20128.014%20604.079%20127.661%20604.079%20127.224C604.079%20126.767%20603.955%20126.406%20603.706%20126.144C603.458%20125.878%20603.089%20125.745%20602.599%20125.745C602.103%20125.745%20601.737%20125.878%20601.503%20126.144C601.269%20126.41%20601.152%20126.774%20601.152%20127.235C601.152%20127.671%20601.276%20128.023%20601.524%20128.289C601.773%20128.551%20602.126%20128.683%20602.583%20128.683ZM607.097%20129.731C606.866%20129.731%20606.671%20129.651%20606.511%20129.492C606.352%20129.332%20606.272%20129.142%20606.272%20128.922C606.272%20128.699%20606.35%20128.505%20606.506%20128.342C606.666%20128.179%20606.863%20128.097%20607.097%20128.097C607.324%20128.097%20607.515%20128.179%20607.672%20128.342C607.828%20128.505%20607.906%20128.699%20607.906%20128.922C607.906%20129.142%20607.828%20129.332%20607.672%20129.492C607.515%20129.651%20607.324%20129.731%20607.097%20129.731ZM609.609%20129.635L611.972%20126.559C611.734%20126.641%20611.523%20126.681%20611.339%20126.681C610.576%20126.681%20609.953%20126.453%20609.47%20125.995C608.991%20125.534%20608.752%20124.937%20608.752%20124.207C608.752%20123.447%20609.015%20122.84%20609.54%20122.386C610.068%20121.932%20610.753%20121.705%20611.594%20121.705C612.463%20121.705%20613.168%20121.939%20613.707%20122.408C614.246%20122.872%20614.516%20123.492%20614.516%20124.265C614.516%20124.712%20614.431%20125.118%20614.26%20125.484C614.09%20125.849%20613.84%20126.257%20613.51%20126.708L611.307%20129.635H609.609ZM611.637%20125.702C612.13%20125.702%20612.494%20125.565%20612.728%20125.292C612.965%20125.019%20613.084%20124.65%20613.084%20124.185C613.084%20123.749%20612.962%20123.403%20612.717%20123.147C612.472%20122.892%20612.121%20122.764%20611.663%20122.764C611.191%20122.764%20610.821%20122.897%20610.551%20123.163C610.285%20123.429%20610.152%20123.779%20610.152%20124.212C610.152%20124.673%20610.276%20125.037%20610.524%20125.303C610.776%20125.569%20611.147%20125.702%20611.637%20125.702ZM616.954%20125.186C617.262%20125.186%20617.495%20125.071%20617.651%20124.84C617.81%20124.609%20617.89%20124.311%20617.89%20123.946C617.89%20123.573%20617.81%20123.272%20617.651%20123.041C617.495%20122.81%20617.264%20122.695%20616.959%20122.695C616.654%20122.695%20616.423%20122.812%20616.267%20123.046C616.111%20123.28%20616.033%20123.584%20616.033%20123.956C616.033%20124.329%20616.109%20124.627%20616.262%20124.851C616.418%20125.074%20616.648%20125.186%20616.954%20125.186ZM616.938%20126.032C616.359%20126.032%20615.903%20125.837%20615.57%20125.447C615.24%20125.056%20615.075%20124.56%20615.075%20123.956C615.075%20123.353%20615.245%20122.853%20615.586%20122.456C615.93%20122.058%20616.389%20121.859%20616.964%20121.859C617.564%20121.859%20618.036%20122.055%20618.38%20122.445C618.724%20122.835%20618.896%20123.334%20618.896%20123.94C618.896%20124.54%20618.717%20125.039%20618.359%20125.436C618%20125.833%20617.527%20126.032%20616.938%20126.032ZM616.421%20129.806L621.217%20121.918L622.388%20121.923L617.555%20129.806H616.421ZM622.143%20128.879C622.462%20128.879%20622.702%20128.764%20622.861%20128.534C623.024%20128.299%20623.106%20127.998%20623.106%20127.629C623.106%20127.26%20623.019%20126.963%20622.845%20126.74C622.675%20126.513%20622.42%20126.399%20622.079%20126.399C621.738%20126.399%20621.501%20126.511%20621.366%20126.735C621.231%20126.958%20621.163%20127.265%20621.163%20127.655C621.163%20128.024%20621.245%20128.321%20621.408%20128.544C621.575%20128.768%20621.82%20128.879%20622.143%20128.879ZM622.127%20129.726C621.517%20129.726%20621.034%20129.531%20620.679%20129.14C620.328%20128.746%20620.152%20128.251%20620.152%20127.655C620.152%20126.257%20620.796%20125.558%20622.084%20125.558C622.719%20125.558%20623.205%20125.752%20623.543%20126.139C623.883%20126.522%20624.053%20127.02%20624.053%20127.634C624.053%20128.234%20623.88%20128.732%20623.532%20129.13C623.188%20129.527%20622.719%20129.726%20622.127%20129.726Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip12_12_1053)'%3e%3cpath%20d='M677.302%20378.919V371.48H678.927L681.177%20376.853L683.442%20371.48H685.046V378.919H683.777V375.243L683.818%20373.135L683.63%20373.694L681.725%20378.412H680.547L678.684%20373.669L678.496%20373.11L678.541%20375.263V378.919H677.302ZM688.352%20377.198C688.721%20377.669%20689.266%20377.904%20689.987%20377.904C690.709%20377.904%20691.252%20377.67%20691.618%20377.203C691.987%20376.732%20692.171%20376.069%20692.171%20375.212C692.171%20374.346%20691.987%20373.674%20691.618%20373.196C691.252%20372.719%20690.71%20372.48%20689.993%20372.48C689.271%20372.48%20688.725%20372.721%20688.352%20373.201C687.983%20373.679%20687.799%20374.349%20687.799%20375.212C687.799%20376.066%20687.983%20376.727%20688.352%20377.198ZM689.982%20379.026C688.862%20379.026%20687.977%20378.688%20687.327%20378.01C686.68%20377.33%20686.357%20376.392%20686.357%20375.197C686.357%20373.995%20686.682%20373.058%20687.332%20372.384C687.982%20371.71%20688.867%20371.373%20689.987%20371.373C691.108%20371.373%20691.992%20371.712%20692.638%20372.389C693.285%20373.063%20693.608%20374%20693.608%20375.202C693.608%20376.391%20693.283%20377.325%20692.633%20378.005C691.983%20378.686%20691.1%20379.026%20689.982%20379.026ZM694.913%20378.919V371.48H696.376C696.64%20371.893%20697.176%20372.726%20697.986%20373.978C698.795%20375.231%20699.287%20375.993%20699.463%20376.264C699.514%20376.341%20699.6%20376.473%20699.722%20376.66C699.848%20376.842%20699.936%20376.973%20699.986%20377.051C699.963%20375.889%20699.951%20375.287%20699.951%20375.243V371.48H701.205V378.919H699.722L696.366%20373.689L696.122%20373.288C696.149%20374.182%20696.162%20374.81%20696.162%20375.172V378.919H694.913ZM704.242%20378.919V372.582H702.073V371.48H707.781V372.582H705.623V378.919H704.242ZM708.584%20378.919V371.48H709.96V374.522H713.321V371.48H714.698V378.919H713.321V375.608H709.96V378.919H708.584ZM716.302%20378.919V371.48H717.679V377.823H720.791L720.751%20378.919H716.302ZM722.802%20378.919V375.969L720.228%20371.48H721.721L723.493%20374.7L725.275%20371.48H726.748L724.184%20375.944V378.919H722.802ZM730.237%20378.919V371.48H734.746L734.69%20372.572H731.613V374.491H734.538V375.583H731.613V377.823H734.802L734.756%20378.919H730.237ZM735.269%20378.919L738.006%20371.475H739.504L742.201%20378.919H740.789L740.053%20376.817H737.448L736.706%20378.919H735.269ZM737.793%20375.791H739.702C739.093%20373.838%20738.78%20372.829%20738.763%20372.765L737.793%20375.791ZM742.907%20378.919V371.46H745.664C746.04%20371.46%20746.365%20371.477%20746.639%20371.51C746.917%20371.544%20747.179%20371.607%20747.426%20371.698C747.677%20371.786%20747.878%20371.907%20748.03%20372.059C748.186%20372.211%20748.308%20372.411%20748.396%20372.658C748.487%20372.902%20748.533%20373.191%20748.533%20373.526C748.533%20374.515%20748.085%20375.165%20747.187%20375.476C747.37%20375.683%20747.597%20376.066%20747.868%20376.624L748.975%20378.919H747.472L746.604%20376.975C746.275%20376.277%20746.072%20375.864%20745.994%20375.735C745.937%20375.732%20745.745%20375.73%20745.42%20375.73L744.268%20375.72V378.919H742.907ZM745.786%20374.735C746.314%20374.735%20746.693%20374.642%20746.923%20374.456C747.154%20374.266%20747.269%20373.963%20747.269%20373.547C747.269%20373.181%20747.152%20372.912%20746.918%20372.739C746.685%20372.567%20746.328%20372.48%20745.847%20372.48H744.268V374.73C744.318%20374.73%20744.571%20374.732%20745.024%20374.735C745.478%20374.735%20745.732%20374.735%20745.786%20374.735ZM749.96%20378.919V371.48H751.423C751.687%20371.893%20752.223%20372.726%20753.032%20373.978C753.842%20375.231%20754.334%20375.993%20754.51%20376.264C754.561%20376.341%20754.647%20376.473%20754.769%20376.66C754.894%20376.842%20754.982%20376.973%20755.033%20377.051C755.009%20375.889%20754.998%20375.287%20754.998%20375.243V371.48H756.252V378.919H754.769L751.412%20373.689L751.169%20373.288C751.196%20374.182%20751.209%20374.81%20751.209%20375.172V378.919H749.96ZM757.887%20378.919V371.48H759.263V378.919H757.887ZM760.909%20378.919V371.48H762.371C762.635%20371.893%20763.172%20372.726%20763.981%20373.978C764.79%20375.231%20765.283%20375.993%20765.459%20376.264C765.509%20376.341%20765.596%20376.473%20765.718%20376.66C765.843%20376.842%20765.931%20376.973%20765.982%20377.051C765.958%20375.889%20765.946%20375.287%20765.946%20375.243V371.48H767.2V378.919H765.718L762.361%20373.689L762.117%20373.288C762.144%20374.182%20762.158%20374.81%20762.158%20375.172V378.919H760.909ZM772.121%20379.026C770.987%20379.026%20770.1%20378.684%20769.46%20378C768.824%20377.316%20768.505%20376.38%20768.505%20375.192C768.505%20374.437%20768.654%20373.774%20768.952%20373.201C769.25%20372.626%20769.689%20372.177%20770.268%20371.856C770.846%20371.534%20771.53%20371.373%20772.319%20371.373C773.223%20371.373%20773.998%20371.568%20774.645%20371.957L774.198%20372.983C773.582%20372.651%20772.964%20372.485%20772.345%20372.485C771.593%20372.485%20771.002%20372.729%20770.572%20373.217C770.142%20373.704%20769.927%20374.368%20769.927%20375.207C769.927%20376.04%20770.119%20376.699%20770.501%20377.183C770.884%20377.667%20771.444%20377.909%20772.182%20377.909C772.656%20377.909%20773.086%20377.834%20773.472%20377.685V375.959H771.913L771.923%20374.877H774.767V378.467C774.306%20378.657%20773.87%20378.798%20773.457%20378.889C773.047%20378.98%20772.602%20379.026%20772.121%20379.026ZM778.332%20379.021C777.435%20379.021%20776.63%20378.814%20775.92%20378.401L776.255%20377.31C776.573%20377.486%20776.918%20377.628%20777.291%20377.736C777.666%20377.845%20778.032%20377.899%20778.387%20377.899C778.824%20377.899%20779.154%20377.806%20779.378%20377.619C779.601%20377.43%20779.713%20377.159%20779.713%20376.807C779.713%20376.34%20779.401%20376.016%20778.779%20375.837C778.735%20375.823%20778.611%20375.788%20778.408%20375.73C778.205%20375.669%20778.013%20375.612%20777.834%20375.558C777.658%20375.5%20777.531%20375.456%20777.453%20375.426C776.454%20375.074%20775.955%20374.417%20775.955%20373.455C775.955%20372.782%20776.194%20372.262%20776.671%20371.896C777.152%20371.531%20777.788%20371.348%20778.58%20371.348C779.478%20371.348%20780.251%20371.532%20780.901%20371.901L780.485%20372.907C779.821%20372.609%20779.205%20372.46%20778.636%20372.46C778.227%20372.46%20777.917%20372.533%20777.707%20372.678C777.501%20372.821%20777.39%20373.059%20777.377%20373.394C777.377%20373.807%20777.582%20374.077%20777.991%20374.202C778.073%20374.232%20778.272%20374.298%20778.591%20374.4C778.909%20374.501%20779.115%20374.567%20779.21%20374.598C779.891%20374.821%20780.376%20375.099%20780.668%20375.431C780.962%20375.763%20781.109%20376.225%20781.109%20376.817C781.109%20377.525%20780.859%20378.07%20780.358%20378.452C779.857%20378.831%20779.181%20379.021%20778.332%20379.021ZM785.004%20378.919V371.46H787.482C788.068%20371.46%20788.569%20371.536%20788.986%20371.688C789.402%20371.837%20789.73%20372.081%20789.971%20372.419C790.214%20372.758%20790.336%20373.183%20790.336%20373.694C790.336%20374.05%20790.291%20374.366%20790.199%20374.644C790.108%20374.918%20789.957%20375.168%20789.747%20375.395C789.537%20375.619%20789.241%20375.791%20788.859%20375.913C788.479%20376.035%20788.021%20376.096%20787.482%20376.096C787.022%20376.096%20786.648%20376.082%20786.36%20376.055V378.919H785.004ZM787.335%20375.101C787.616%20375.101%20787.86%20375.074%20788.066%20375.019C788.276%20374.965%20788.439%20374.896%20788.554%20374.811C788.672%20374.727%20788.765%20374.622%20788.833%20374.496C788.904%20374.371%20788.95%20374.251%20788.97%20374.136C788.994%20374.017%20789.006%20373.885%20789.006%20373.74C789.006%20373.33%20788.874%20373.019%20788.61%20372.805C788.346%20372.592%20787.973%20372.485%20787.493%20372.485H786.36V375.091C786.401%20375.097%20786.726%20375.101%20787.335%20375.101ZM791.367%20378.919V371.48H795.877L795.821%20372.572H792.743V374.491H795.668V375.583H792.743V377.823H795.932L795.887%20378.919H791.367ZM797.182%20378.919V371.46H799.939C800.315%20371.46%20800.64%20371.477%20800.914%20371.51C801.192%20371.544%20801.454%20371.607%20801.701%20371.698C801.952%20371.786%20802.153%20371.907%20802.305%20372.059C802.461%20372.211%20802.583%20372.411%20802.671%20372.658C802.762%20372.902%20802.808%20373.191%20802.808%20373.526C802.808%20374.515%20802.36%20375.165%20801.462%20375.476C801.645%20375.683%20801.872%20376.066%20802.143%20376.624L803.25%20378.919H801.747L800.879%20376.975C800.55%20376.277%20800.347%20375.864%20800.269%20375.735C800.212%20375.732%20800.02%20375.73%20799.695%20375.73L798.543%20375.72V378.919H797.182ZM800.061%20374.735C800.589%20374.735%20800.968%20374.642%20801.198%20374.456C801.429%20374.266%20801.544%20373.963%20801.544%20373.547C801.544%20373.181%20801.427%20372.912%20801.193%20372.739C800.96%20372.567%20800.603%20372.48%20800.122%20372.48H798.543V374.73C798.593%20374.73%20798.846%20374.732%20799.299%20374.735C799.753%20374.735%20800.007%20374.735%20800.061%20374.735ZM808.922%20378.919L806.216%20371.48H807.632L809.207%20376.076C809.268%20376.235%20809.408%20376.7%20809.628%20377.472C809.642%20377.418%20809.704%20377.196%20809.816%20376.807C809.928%20376.414%20810.001%20376.174%20810.034%20376.086C810.075%20375.971%20810.332%20375.207%20810.806%20373.796C811.28%20372.381%20811.539%20371.609%20811.583%20371.48H812.985L810.314%20378.919H808.922ZM813.797%20378.919V371.48H815.173V378.919H813.797ZM818.906%20379.021C818.009%20379.021%20817.205%20378.814%20816.494%20378.401L816.829%20377.31C817.147%20377.486%20817.492%20377.628%20817.865%20377.736C818.241%20377.845%20818.606%20377.899%20818.962%20377.899C819.398%20377.899%20819.729%20377.806%20819.952%20377.619C820.175%20377.43%20820.287%20377.159%20820.287%20376.807C820.287%20376.34%20819.976%20376.016%20819.353%20375.837C819.309%20375.823%20819.185%20375.788%20818.982%20375.73C818.779%20375.669%20818.588%20375.612%20818.408%20375.558C818.232%20375.5%20818.105%20375.456%20818.027%20375.426C817.029%20375.074%20816.529%20374.417%20816.529%20373.455C816.529%20372.782%20816.768%20372.262%20817.245%20371.896C817.726%20371.531%20818.362%20371.348%20819.155%20371.348C820.052%20371.348%20820.825%20371.532%20821.475%20371.901L821.059%20372.907C820.395%20372.609%20819.779%20372.46%20819.211%20372.46C818.801%20372.46%20818.491%20372.533%20818.281%20372.678C818.075%20372.821%20817.965%20373.059%20817.951%20373.394C817.951%20373.807%20818.156%20374.077%20818.566%20374.202C818.647%20374.232%20818.847%20374.298%20819.165%20374.4C819.483%20374.501%20819.69%20374.567%20819.784%20374.598C820.465%20374.821%20820.951%20375.099%20821.242%20375.431C821.536%20375.763%20821.684%20376.225%20821.684%20376.817C821.684%20377.525%20821.433%20378.07%20820.932%20378.452C820.431%20378.831%20819.756%20379.021%20818.906%20379.021ZM822.897%20378.919V371.48H824.273V378.919H822.897ZM827.356%20378.919V372.582H825.187V371.48H830.895V372.582H828.737V378.919H827.356ZM833.434%20377.198C833.803%20377.669%20834.348%20377.904%20835.07%20377.904C835.791%20377.904%20836.334%20377.67%20836.7%20377.203C837.069%20376.732%20837.253%20376.069%20837.253%20375.212C837.253%20374.346%20837.069%20373.674%20836.7%20373.196C836.334%20372.719%20835.792%20372.48%20835.075%20372.48C834.354%20372.48%20833.807%20372.721%20833.434%20373.201C833.065%20373.679%20832.881%20374.349%20832.881%20375.212C832.881%20376.066%20833.065%20376.727%20833.434%20377.198ZM835.064%20379.026C833.944%20379.026%20833.059%20378.688%20832.409%20378.01C831.762%20377.33%20831.439%20376.392%20831.439%20375.197C831.439%20373.995%20831.764%20373.058%20832.414%20372.384C833.064%20371.71%20833.949%20371.373%20835.07%20371.373C836.19%20371.373%20837.074%20371.712%20837.72%20372.389C838.367%20373.063%20838.69%20374%20838.69%20375.202C838.69%20376.391%20838.365%20377.325%20837.715%20378.005C837.065%20378.686%20836.182%20379.026%20835.064%20379.026ZM839.96%20378.919V371.46H842.717C843.093%20371.46%20843.418%20371.477%20843.692%20371.51C843.97%20371.544%20844.232%20371.607%20844.479%20371.698C844.73%20371.786%20844.931%20371.907%20845.084%20372.059C845.239%20372.211%20845.361%20372.411%20845.449%20372.658C845.541%20372.902%20845.586%20373.191%20845.586%20373.526C845.586%20374.515%20845.138%20375.165%20844.241%20375.476C844.423%20375.683%20844.65%20376.066%20844.921%20376.624L846.028%20378.919H844.525L843.657%20376.975C843.328%20376.277%20843.125%20375.864%20843.047%20375.735C842.99%20375.732%20842.798%20375.73%20842.473%20375.73L841.321%20375.72V378.919H839.96ZM842.839%20374.735C843.367%20374.735%20843.746%20374.642%20843.977%20374.456C844.207%20374.266%20844.322%20373.963%20844.322%20373.547C844.322%20373.181%20844.205%20372.912%20843.971%20372.739C843.738%20372.567%20843.381%20372.48%20842.9%20372.48H841.321V374.73C841.371%20374.73%20841.624%20374.732%20842.077%20374.735C842.531%20374.735%20842.785%20374.735%20842.839%20374.735Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip13_12_1053)'%3e%3cpath%20d='M156.633%20104.215C155.945%20104.215%20155.324%20104.107%20154.771%20103.89C154.222%20103.669%20153.777%20103.332%20153.435%20102.88C153.094%20102.422%20152.923%20101.881%20152.923%20101.255C152.923%2099.9898%20153.546%2099.0803%20154.793%2098.5268C153.681%2097.9975%20153.125%2097.1698%20153.125%2096.0437C153.125%2095.6009%20153.216%2095.2039%20153.399%2094.8526C153.582%2094.5013%20153.832%2094.215%20154.15%2093.9936C154.473%2093.7674%20154.843%2093.5966%20155.262%2093.4811C155.685%2093.3656%20156.142%2093.3078%20156.633%2093.3078C157.653%2093.3078%20158.491%2093.546%20159.145%2094.0225C159.805%2094.4989%20160.134%2095.1726%20160.134%2096.0437C160.134%2097.1553%20159.619%2097.9831%20158.589%2098.5268C159.749%2099.0899%20160.329%20100.002%20160.329%20101.263C160.329%20101.888%20160.158%20102.43%20159.817%20102.887C159.48%20103.339%20159.035%20103.674%20158.481%20103.89C157.933%20104.107%20157.317%20104.215%20156.633%20104.215ZM155.204%20102.461C155.55%20102.755%20156.027%20102.901%20156.633%20102.901C157.24%20102.901%20157.714%20102.755%20158.055%20102.461C158.397%20102.167%20158.568%20101.754%20158.568%20101.219C158.568%20100.69%20158.39%20100.252%20158.034%2099.9056C157.678%2099.5591%20157.211%2099.3113%20156.633%2099.1621C156.041%2099.3113%20155.567%2099.5591%20155.211%2099.9056C154.86%20100.252%20154.684%20100.692%20154.684%20101.227C154.684%20101.756%20154.857%20102.167%20155.204%20102.461ZM156.633%2098.036C157.225%2097.9012%20157.68%2097.6678%20157.998%2097.3358C158.315%2096.9989%20158.474%2096.5706%20158.474%2096.0509C158.474%2095.6178%20158.301%2095.2689%20157.954%2095.0042C157.608%2094.7395%20157.167%2094.6072%20156.633%2094.6072C156.104%2094.6072%20155.664%2094.7395%20155.312%2095.0042C154.961%2095.2689%20154.785%2095.6178%20154.785%2096.0509C154.785%2096.5706%20154.949%2096.9989%20155.276%2097.3358C155.603%2097.6727%20156.056%2097.9061%20156.633%2098.036ZM161.239%20106.106C161.513%20104.773%20161.739%20103.534%20161.917%20102.389H163.679L163.657%20102.742C163.344%20103.83%20162.964%20104.951%20162.516%20106.106H161.239ZM168.356%20104.215C167.88%20104.215%20167.389%20104.138%20166.884%20103.984C166.378%20103.825%20165.993%20103.676%20165.729%20103.537C165.464%20103.392%20165.288%20103.281%20165.202%20103.204L165.779%20101.847C165.871%20101.92%20166.003%20102.011%20166.176%20102.122C166.354%20102.228%20166.638%20102.35%20167.028%20102.49C167.423%20102.629%20167.8%20102.699%20168.161%20102.699C168.835%20102.699%20169.345%20102.511%20169.692%20102.136C170.038%20101.761%20170.211%20101.27%20170.211%20100.664C170.211%20100.091%20170.053%2099.6313%20169.735%2099.2848C169.422%2098.9383%20169.015%2098.7651%20168.515%2098.7651C167.918%2098.7651%20167.384%2099.0249%20166.912%2099.5447L165.649%2099.2992L165.924%2093.5388H171.67L171.561%2095.0259H167.598C167.598%2095.1125%20167.581%2095.548%20167.548%2096.3324C167.519%2097.112%20167.502%2097.5475%20167.497%2097.639C167.921%2097.4128%20168.366%2097.2997%20168.833%2097.2997C169.805%2097.2997%20170.587%2097.6125%20171.179%2098.2381C171.775%2098.8637%20172.074%2099.6794%20172.074%20100.685C172.074%20101.754%20171.747%20102.61%20171.092%20103.255C170.442%20103.895%20169.53%20104.215%20168.356%20104.215ZM178.094%20104.063V101.717H173.323V100.433L177.603%2093.5388H180.007V100.288H181.306L181.212%20101.717H180.007V104.063H178.094ZM175.199%20100.295H178.094V95.3868L175.199%20100.295ZM185.406%20102.382C185.681%20102.603%20186.01%20102.714%20186.395%20102.714C186.78%20102.714%20187.108%20102.603%20187.377%20102.382C187.651%20102.16%20187.858%20101.855%20187.998%20101.465C188.142%20101.07%20188.246%20100.652%20188.308%20100.209C188.371%2099.7612%20188.402%2099.2655%20188.402%2098.7217C188.402%2096.1134%20187.733%2094.8093%20186.395%2094.8093C185.067%2094.8093%20184.393%2096.1038%20184.374%2098.6929C184.374%2099.2415%20184.405%2099.7396%20184.468%20100.187C184.531%20100.635%20184.634%20101.058%20184.778%20101.458C184.923%20101.852%20185.132%20102.16%20185.406%20102.382ZM187.933%20103.926C187.481%20104.119%20186.968%20104.215%20186.395%20104.215C185.823%20104.215%20185.308%20104.119%20184.851%20103.926C184.393%20103.729%20184.016%20103.464%20183.717%20103.132C183.419%20102.795%20183.169%20102.394%20182.967%20101.927C182.769%20101.46%20182.627%20100.967%20182.541%20100.447C182.459%2099.9272%20182.418%2099.3714%20182.418%2098.7795C182.418%2098.178%20182.461%2097.6149%20182.548%2097.0904C182.634%2096.561%20182.779%2096.0629%20182.981%2095.5961C183.183%2095.1245%20183.433%2094.7227%20183.732%2094.3906C184.035%2094.0586%20184.413%2093.7963%20184.865%2093.6038C185.317%2093.4065%20185.827%2093.3078%20186.395%2093.3078C186.963%2093.3078%20187.473%2093.4065%20187.926%2093.6038C188.378%2093.7963%20188.753%2094.061%20189.052%2094.3978C189.35%2094.7299%20189.598%2095.1317%20189.795%2095.6033C189.997%2096.0701%20190.142%2096.5658%20190.228%2097.0904C190.315%2097.6149%20190.358%2098.178%20190.358%2098.7795C190.358%2099.3714%20190.315%2099.9272%20190.228%20100.447C190.147%20100.967%20190.007%20101.462%20189.81%20101.934C189.612%20102.401%20189.365%20102.8%20189.066%20103.132C188.768%20103.464%20188.39%20103.729%20187.933%20103.926Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip14_12_1053)'%3e%3cpath%20d='M96.472%2097.7294C96.0895%2097.7294%2095.7597%2097.8222%2095.4825%2098.0077C95.2077%2098.1932%2095.0027%2098.4429%2094.8676%2098.7567C94.7324%2099.0704%2094.6649%2099.4312%2094.6649%2099.8389C94.6649%20100.143%2094.7015%20100.422%2094.7748%20100.674C94.8481%20100.923%2094.958%20101.143%2095.1046%20101.333C95.2512%20101.521%2095.4413%20101.668%2095.6749%20101.773C95.9108%20101.876%2096.1811%20101.928%2096.4857%20101.928C96.8774%20101.928%2097.2827%20101.826%2097.7019%20101.622L97.8015%20102.127C97.4602%20102.342%2096.9987%20102.45%2096.417%20102.45C96.0345%20102.45%2095.691%20102.387%2095.3863%20102.261C95.084%20102.133%2094.8332%20101.953%2094.634%20101.722C94.437%20101.488%2094.287%20101.211%2094.1839%20100.89C94.0808%20100.567%2094.0293%20100.209%2094.0293%2099.8148C94.0293%2099.4346%2094.0854%2099.0842%2094.1976%2098.7635C94.3099%2098.4429%2094.4679%2098.1681%2094.6718%2097.939C94.8779%2097.7077%2095.1344%2097.5279%2095.4413%2097.3996C95.7482%2097.2714%2096.0895%2097.2073%2096.4651%2097.2073C97.0354%2097.2073%2097.5164%2097.3332%2097.908%2097.5852L97.6744%2098.0696C97.2988%2097.8428%2096.898%2097.7294%2096.472%2097.7294ZM102.464%2097.2931V100.591C102.464%20101.175%20102.303%20101.631%20101.983%20101.959C101.664%20102.286%20101.179%20102.45%20100.526%20102.45C99.8731%20102.45%2099.391%20102.286%2099.0795%20101.959C98.768%20101.631%2098.6123%20101.173%2098.6123%20100.584V97.2931H99.2101V100.595C99.2101%20101.055%2099.3189%20101.394%2099.5364%20101.612C99.754%20101.829%20100.091%20101.938%20100.546%20101.938C100.991%20101.938%20101.322%20101.828%20101.539%20101.608C101.759%20101.388%20101.869%20101.049%20101.869%20100.591V97.2931H102.464ZM104.13%2097.7672V99.485C104.224%2099.485%20104.417%2099.4873%20104.71%2099.4919C105.006%2099.4964%20105.234%2099.4987%20105.394%2099.4987C105.831%2099.4987%20106.136%2099.4266%20106.308%2099.2823C106.48%2099.1357%20106.566%2098.9044%20106.566%2098.5883C106.566%2098.3112%20106.483%2098.1051%20106.318%2097.9699C106.153%2097.8348%20105.877%2097.7672%20105.49%2097.7672H104.13ZM107.387%20102.374H106.699L105.999%20100.78C105.809%20100.352%20105.687%20100.094%20105.634%20100.007C105.467%20100.019%20105.269%20100.024%20105.04%20100.024L104.13%2099.9969V102.374H103.522V97.2347H105.147C105.334%2097.2347%20105.5%2097.2393%20105.645%2097.2485C105.789%2097.2576%20105.932%2097.2748%20106.074%2097.3C106.219%2097.3229%20106.343%2097.3561%20106.449%2097.3996C106.554%2097.4409%20106.653%2097.4958%20106.744%2097.5645C106.836%2097.631%20106.909%2097.7111%20106.964%2097.805C107.021%2097.8989%20107.066%2098.0112%20107.098%2098.1417C107.13%2098.27%20107.146%2098.4154%20107.146%2098.578C107.146%2098.8987%20107.061%2099.1747%20106.892%2099.406C106.725%2099.6373%20106.486%2099.7976%20106.177%2099.887C106.177%2099.8915%20106.2%2099.9328%20106.246%20100.011C106.292%20100.089%20106.346%20100.185%20106.407%20100.299C106.472%20100.411%20106.521%20100.505%20106.555%20100.581L107.387%20102.374ZM108.733%2097.7672V99.485C108.827%2099.485%20109.021%2099.4873%20109.314%2099.4919C109.609%2099.4964%20109.837%2099.4987%20109.998%2099.4987C110.435%2099.4987%20110.74%2099.4266%20110.911%2099.2823C111.083%2099.1357%20111.169%2098.9044%20111.169%2098.5883C111.169%2098.3112%20111.087%2098.1051%20110.922%2097.9699C110.757%2097.8348%20110.481%2097.7672%20110.094%2097.7672H108.733ZM111.99%20102.374H111.303L110.602%20100.78C110.412%20100.352%20110.291%20100.094%20110.238%20100.007C110.071%20100.019%20109.873%20100.024%20109.644%20100.024L108.733%2099.9969V102.374H108.125V97.2347H109.75C109.938%2097.2347%20110.104%2097.2393%20110.248%2097.2485C110.393%2097.2576%20110.536%2097.2748%20110.678%2097.3C110.822%2097.3229%20110.947%2097.3561%20111.052%2097.3996C111.158%2097.4409%20111.256%2097.4958%20111.348%2097.5645C111.439%2097.631%20111.513%2097.7111%20111.568%2097.805C111.625%2097.8989%20111.67%2098.0112%20111.702%2098.1417C111.734%2098.27%20111.75%2098.4154%20111.75%2098.578C111.75%2098.8987%20111.665%2099.1747%20111.495%2099.406C111.328%2099.6373%20111.09%2099.7976%20110.781%2099.887C110.781%2099.8915%20110.804%2099.9328%20110.85%20100.011C110.895%20100.089%20110.949%20100.185%20111.011%20100.299C111.075%20100.411%20111.124%20100.505%20111.159%20100.581L111.99%20102.374ZM112.822%20102.374V97.2931H115.735L115.711%2097.8188H113.416V99.4816H115.597V100H113.416V101.849H115.786L115.759%20102.374H112.822ZM120.764%20102.374H120.091L117.453%2098.3753L117.281%2098.1383C117.299%2098.6192%20117.308%2099.0487%20117.308%2099.4266V102.374H116.752V97.2931H117.415L120.06%20101.292L120.235%20101.529C120.219%20100.799%20120.211%20100.376%20120.211%20100.261V97.2931H120.764V102.374ZM123.547%20102.374H122.949V97.8188H121.386V97.2931H125.11V97.8188H123.547V102.374Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M99.175%20110.73H98.514V105.143H100.314C100.588%20105.143%20100.836%20105.172%20101.057%20105.229C101.279%20105.286%20101.476%20105.373%20101.647%20105.49C101.819%20105.607%20101.952%20105.764%20102.047%20105.961C102.142%20106.158%20102.189%20106.387%20102.189%20106.648C102.189%20106.865%20102.169%20107.059%20102.129%20107.231C102.089%20107.4%20102.021%20107.559%20101.924%20107.709C101.827%20107.858%20101.7%20107.983%20101.543%20108.082C101.386%20108.179%20101.184%20108.256%20100.938%20108.314C100.694%20108.368%20100.41%20108.396%20100.086%20108.396C99.8298%20108.396%2099.5261%20108.38%2099.175%20108.347V110.73ZM100.15%20107.824C100.394%20107.824%20100.603%20107.801%20100.777%20107.754C100.951%20107.706%20101.085%20107.648%20101.177%20107.578C101.271%20107.508%20101.345%20107.417%20101.397%20107.305C101.452%20107.193%20101.485%20107.091%20101.498%20106.999C101.51%20106.905%20101.517%20106.791%20101.517%20106.659C101.517%20106.343%20101.41%20106.11%20101.195%20105.961C100.984%20105.812%20100.695%20105.737%20100.329%20105.737H99.175V107.817C99.6555%20107.822%2099.9804%20107.824%20100.15%20107.824ZM102.951%20110.73V105.207H106.118L106.091%20105.778H103.597V107.585H105.968V108.149H103.597V110.159H106.174L106.144%20110.73H102.951ZM107.783%20105.722V107.589C107.885%20107.589%20108.096%20107.592%20108.414%20107.597C108.736%20107.602%20108.983%20107.604%20109.158%20107.604C109.633%20107.604%20109.964%20107.526%20110.151%20107.369C110.338%20107.21%20110.431%20106.958%20110.431%20106.614C110.431%20106.313%20110.341%20106.089%20110.162%20105.942C109.983%20105.795%20109.683%20105.722%20109.262%20105.722H107.783ZM111.324%20110.73H110.577L109.815%20108.997C109.608%20108.532%20109.476%20108.251%20109.419%20108.157C109.237%20108.169%20109.022%20108.176%20108.773%20108.176L107.783%20108.146V110.73H107.122V105.143H108.889C109.093%20105.143%20109.273%20105.148%20109.43%20105.158C109.587%20105.168%20109.743%20105.187%20109.897%20105.214C110.054%20105.239%20110.19%20105.275%20110.304%20105.322C110.419%20105.367%20110.526%20105.427%20110.625%20105.502C110.725%20105.574%20110.805%20105.661%20110.864%20105.763C110.927%20105.865%20110.975%20105.987%20111.01%20106.129C111.045%20106.268%20111.062%20106.426%20111.062%20106.603C111.062%20106.952%20110.97%20107.252%20110.786%20107.503C110.604%20107.755%20110.345%20107.929%20110.009%20108.026C110.009%20108.031%20110.034%20108.076%20110.084%20108.161C110.134%20108.245%20110.192%20108.35%20110.259%20108.474C110.329%20108.596%20110.383%20108.698%20110.42%20108.781L111.324%20110.73ZM112.903%20110.73H112.257V105.207H112.903V110.73ZM114.7%20107.97C114.7%20108.68%20114.863%20109.237%20115.189%20109.643C115.515%20110.047%20115.997%20110.248%20116.634%20110.248C117.272%20110.248%20117.751%20110.047%20118.072%20109.643C118.396%20109.24%20118.558%20108.682%20118.558%20107.97C118.558%20107.243%20118.394%20106.679%20118.068%20106.278C117.745%20105.878%20117.268%20105.677%20116.638%20105.677C116.008%20105.677%20115.528%20105.878%20115.196%20106.278C114.865%20106.679%20114.7%20107.243%20114.7%20107.97ZM119.248%20107.97C119.248%20108.391%20119.19%20108.776%20119.073%20109.124C118.958%20109.473%20118.792%20109.773%20118.572%20110.024C118.356%20110.273%20118.082%20110.467%20117.751%20110.607C117.42%20110.744%20117.048%20110.812%20116.634%20110.812C116.077%20110.812%20115.598%20110.694%20115.2%20110.457C114.804%20110.218%20114.507%20109.887%20114.308%20109.464C114.111%20109.038%20114.013%20108.539%20114.013%20107.966C114.013%20107.083%20114.243%20106.385%20114.703%20105.875C115.164%20105.365%20115.809%20105.109%20116.638%20105.109C117.455%20105.109%20118.093%20105.367%20118.554%20105.882C119.017%20106.395%20119.248%20107.091%20119.248%20107.97ZM124.167%20107.981C124.167%20107.21%20123.968%20106.648%20123.569%20106.297C123.171%20105.946%20122.591%20105.77%20121.829%20105.77H120.963V110.166H121.937C122.664%20110.166%20123.217%20109.983%20123.595%20109.617C123.976%20109.249%20124.167%20108.703%20124.167%20107.981ZM124.858%20107.963C124.858%20108.861%20124.603%20109.547%20124.092%20110.02C123.582%20110.493%20122.87%20110.73%20121.956%20110.73H120.317V105.207H121.848C122.308%20105.207%20122.72%20105.261%20123.084%20105.371C123.447%20105.478%20123.762%20105.642%20124.029%20105.864C124.298%20106.083%20124.503%20106.37%20124.645%20106.727C124.787%20107.08%20124.858%20107.492%20124.858%20107.963Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip15_12_1053)'%3e%3cpath%20d='M225.499%20103.38V96.8921C225.45%2096.924%20225.219%2097.0269%20224.807%2097.2008C224.399%2097.3711%20224.169%2097.4633%20224.116%2097.4775V96.4131C224.201%2096.3741%20224.47%2096.241%20224.925%2096.0139C225.379%2095.7833%20225.629%2095.652%20225.675%2095.6201H226.846V103.38H225.499ZM230.119%20103.497C229.661%20103.497%20229.23%20103.438%20228.826%20103.321C228.425%20103.201%20228.107%20103.039%20227.873%20102.837L228.256%20101.831C228.451%20101.994%20228.721%20102.129%20229.065%20102.236C229.409%20102.339%20229.762%20102.39%20230.124%20102.39C230.532%20102.39%20230.861%20102.28%20231.109%20102.06C231.361%20101.84%20231.487%20101.553%20231.487%20101.198C231.487%20100.978%20231.451%20100.788%20231.38%20100.628C231.313%20100.469%20231.223%20100.341%20231.109%20100.245C230.995%20100.149%20230.843%20100.073%20230.651%20100.016C230.463%2099.9559%20230.27%2099.9151%20230.071%2099.8938C229.872%2099.8726%20229.633%2099.8601%20229.353%2099.8566C229.342%2099.8566%20229.291%2099.8566%20229.198%2099.8566C229.106%2099.853%20229.055%2099.8513%20229.044%2099.8513V98.7762H229.342C229.651%2098.7762%20229.915%2098.7602%20230.135%2098.7283C230.359%2098.6963%20230.564%2098.6413%20230.752%2098.5633C230.944%2098.4852%20231.088%2098.3699%20231.184%2098.2173C231.283%2098.0648%20231.333%2097.8767%20231.333%2097.6532C231.333%2097.3516%20231.219%2097.0943%20230.992%2096.8814C230.765%2096.6686%20230.446%2096.5621%20230.034%2096.5621C229.367%2096.5621%20228.773%2096.7289%20228.251%2097.0624L227.868%2096.0512C228.514%2095.6538%20229.28%2095.4551%20230.167%2095.4551C230.909%2095.4551%20231.514%2095.6502%20231.982%2096.0405C232.454%2096.4308%20232.69%2096.9311%20232.69%2097.5414C232.69%2097.9672%20232.58%2098.3309%20232.36%2098.6325C232.143%2098.9305%20231.828%2099.1487%20231.412%2099.2871C231.888%2099.3794%20232.255%2099.6082%20232.514%2099.9737C232.777%20100.339%20232.908%20100.77%20232.908%20101.267C232.908%20101.739%20232.782%20102.147%20232.53%20102.491C232.278%20102.832%20231.945%20103.085%20231.529%20103.252C231.114%20103.415%20230.644%20103.497%20230.119%20103.497ZM234.579%20103.481C234.349%20103.481%20234.153%20103.401%20233.994%20103.242C233.834%20103.082%20233.754%20102.892%20233.754%20102.672C233.754%20102.449%20233.832%20102.255%20233.988%20102.092C234.148%20101.929%20234.345%20101.847%20234.579%20101.847C234.806%20101.847%20234.998%20101.929%20235.154%20102.092C235.31%20102.255%20235.388%20102.449%20235.388%20102.672C235.388%20102.892%20235.31%20103.082%20235.154%20103.242C234.998%20103.401%20234.806%20103.481%20234.579%20103.481ZM238.874%20103.497C238.367%20103.497%20237.909%20103.417%20237.501%20103.258C237.097%20103.094%20236.768%20102.846%20236.516%20102.512C236.265%20102.175%20236.139%20101.776%20236.139%20101.315C236.139%20100.382%20236.598%2099.7111%20237.517%2099.3031C236.697%2098.9128%20236.288%2098.3025%20236.288%2097.4722C236.288%2097.1458%20236.355%2096.8531%20236.49%2096.594C236.625%2096.335%20236.809%2096.1239%20237.043%2095.9607C237.281%2095.7939%20237.554%2095.668%20237.863%2095.5828C238.175%2095.4977%20238.512%2095.4551%20238.874%2095.4551C239.626%2095.4551%20240.244%2095.6307%20240.726%2095.982C241.212%2096.3333%20241.456%2096.83%20241.456%2097.4722C241.456%2098.2918%20241.076%2098.9021%20240.317%2099.3031C241.172%2099.7182%20241.599%20100.391%20241.599%20101.32C241.599%20101.781%20241.473%20102.181%20241.221%20102.518C240.973%20102.851%20240.645%20103.098%20240.237%20103.258C239.832%20103.417%20239.378%20103.497%20238.874%20103.497ZM237.82%20102.204C238.076%20102.42%20238.427%20102.528%20238.874%20102.528C239.321%20102.528%20239.671%20102.42%20239.923%20102.204C240.175%20101.987%20240.301%20101.682%20240.301%20101.288C240.301%20100.898%20240.169%20100.575%20239.907%20100.32C239.644%20100.064%20239.3%2099.8814%20238.874%2099.7714C238.438%2099.8814%20238.088%20100.064%20237.826%20100.32C237.567%20100.575%20237.437%20100.9%20237.437%20101.294C237.437%20101.684%20237.565%20101.987%20237.82%20102.204ZM238.874%2098.9412C239.311%2098.8418%20239.646%2098.6697%20239.88%2098.4249C240.114%2098.1765%20240.231%2097.8607%20240.231%2097.4775C240.231%2097.1582%20240.104%2096.901%20239.848%2096.7058C239.593%2096.5107%20239.268%2096.4131%20238.874%2096.4131C238.484%2096.4131%20238.159%2096.5107%20237.9%2096.7058C237.641%2096.901%20237.512%2097.1582%20237.512%2097.4775C237.512%2097.8607%20237.632%2098.1765%20237.874%2098.4249C238.115%2098.6733%20238.448%2098.8454%20238.874%2098.9412ZM244.095%2098.9358C244.404%2098.9358%20244.636%2098.8205%20244.793%2098.5899C244.952%2098.3593%20245.032%2098.0612%20245.032%2097.6958C245.032%2097.3232%20244.952%2097.0216%20244.793%2096.791C244.636%2096.5603%20244.406%2096.445%20244.101%2096.445C243.796%2096.445%20243.565%2096.5621%20243.409%2096.7963C243.253%2097.0305%20243.175%2097.3338%20243.175%2097.7064C243.175%2098.079%20243.251%2098.377%20243.403%2098.6005C243.56%2098.8241%20243.79%2098.9358%20244.095%2098.9358ZM244.079%2099.7821C243.501%2099.7821%20243.045%2099.5869%20242.712%2099.1966C242.382%2098.8063%20242.217%2098.3096%20242.217%2097.7064C242.217%2097.1032%20242.387%2096.6029%20242.728%2096.2055C243.072%2095.8081%20243.531%2095.6094%20244.106%2095.6094C244.706%2095.6094%20245.178%2095.8046%20245.522%2096.1949C245.866%2096.5852%20246.038%2097.0837%20246.038%2097.6904C246.038%2098.2901%20245.859%2098.7886%20245.5%2099.186C245.142%2099.5834%20244.668%2099.7821%20244.079%2099.7821ZM243.563%20103.556L248.358%2095.668L249.529%2095.6733L244.697%20103.556H243.563ZM249.285%20102.629C249.604%20102.629%20249.843%20102.514%20250.003%20102.284C250.166%20102.049%20250.248%20101.748%20250.248%20101.379C250.248%20101.01%20250.161%20100.713%20249.987%20100.49C249.817%20100.263%20249.561%20100.149%20249.221%20100.149C248.88%20100.149%20248.642%20100.261%20248.508%20100.485C248.373%20100.708%20248.305%20101.015%20248.305%20101.405C248.305%20101.774%20248.387%20102.071%20248.55%20102.294C248.717%20102.518%20248.962%20102.629%20249.285%20102.629ZM249.269%20103.476C248.658%20103.476%20248.176%20103.281%20247.821%20102.89C247.47%20102.496%20247.294%20102.001%20247.294%20101.405C247.294%20100.007%20247.938%2099.3084%20249.226%2099.3084C249.861%2099.3084%20250.347%2099.5018%20250.684%2099.8885C251.025%20100.272%20251.195%20100.77%20251.195%20101.384C251.195%20101.984%20251.021%20102.482%20250.674%20102.88C250.33%20103.277%20249.861%20103.476%20249.269%20103.476Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip16_12_1053)'%3e%3cpath%20d='M156.115%20130.466C155.422%20130.466%20154.796%20130.357%20154.238%20130.139C153.685%20129.916%20153.237%20129.576%20152.892%20129.12C152.548%20128.66%20152.376%20128.114%20152.376%20127.483C152.376%20126.208%20153.004%20125.291%20154.26%20124.733C153.14%20124.2%20152.579%20123.365%20152.579%20122.231C152.579%20121.784%20152.672%20121.384%20152.856%20121.03C153.04%20120.676%20153.292%20120.387%20153.613%20120.164C153.938%20119.936%20154.311%20119.764%20154.733%20119.648C155.16%20119.531%20155.621%20119.473%20156.115%20119.473C157.144%20119.473%20157.988%20119.713%20158.647%20120.193C159.312%20120.674%20159.644%20121.353%20159.644%20122.231C159.644%20123.351%20159.125%20124.185%20158.087%20124.733C159.256%20125.301%20159.84%20126.22%20159.84%20127.491C159.84%20128.121%20159.668%20128.667%20159.324%20129.128C158.984%20129.584%20158.536%20129.921%20157.978%20130.139C157.425%20130.357%20156.804%20130.466%20156.115%20130.466ZM154.675%20128.698C155.024%20128.994%20155.504%20129.142%20156.115%20129.142C156.726%20129.142%20157.204%20128.994%20157.549%20128.698C157.893%20128.402%20158.065%20127.985%20158.065%20127.447C158.065%20126.913%20157.886%20126.472%20157.527%20126.123C157.168%20125.774%20156.697%20125.524%20156.115%20125.373C155.519%20125.524%20155.041%20125.774%20154.682%20126.123C154.328%20126.472%20154.151%20126.916%20154.151%20127.454C154.151%20127.988%20154.326%20128.402%20154.675%20128.698ZM156.115%20124.239C156.712%20124.103%20157.17%20123.867%20157.49%20123.533C157.81%20123.193%20157.971%20122.762%20157.971%20122.238C157.971%20121.801%20157.796%20121.45%20157.447%20121.183C157.098%20120.916%20156.654%20120.783%20156.115%20120.783C155.582%20120.783%20155.138%20120.916%20154.784%20121.183C154.43%20121.45%20154.253%20121.801%20154.253%20122.238C154.253%20122.762%20154.418%20123.193%20154.748%20123.533C155.077%20123.872%20155.533%20124.108%20156.115%20124.239ZM162.059%20130.313L165.29%20126.108C164.965%20126.22%20164.676%20126.276%20164.424%20126.276C163.381%20126.276%20162.53%20125.963%20161.87%20125.337C161.215%20124.707%20160.888%20123.892%20160.888%20122.893C160.888%20121.855%20161.247%20121.025%20161.965%20120.404C162.687%20119.784%20163.624%20119.473%20164.773%20119.473C165.961%20119.473%20166.924%20119.793%20167.661%20120.433C168.399%20121.069%20168.767%20121.915%20168.767%20122.973C168.767%20123.584%20168.651%20124.139%20168.418%20124.639C168.185%20125.138%20167.843%20125.696%20167.392%20126.312L164.38%20130.313H162.059ZM164.831%20124.937C165.505%20124.937%20166.003%20124.75%20166.323%20124.377C166.648%20124.003%20166.81%20123.499%20166.81%20122.863C166.81%20122.267%20166.643%20121.794%20166.308%20121.445C165.973%20121.096%20165.493%20120.921%20164.868%20120.921C164.223%20120.921%20163.716%20121.103%20163.347%20121.467C162.983%20121.83%20162.801%20122.308%20162.801%20122.9C162.801%20123.53%20162.971%20124.028%20163.311%20124.391C163.655%20124.755%20164.162%20124.937%20164.831%20124.937ZM170.921%20130.444C170.605%20130.444%20170.339%20130.335%20170.12%20130.117C169.902%20129.899%20169.793%20129.639%20169.793%20129.339C169.793%20129.033%20169.9%20128.769%20170.113%20128.546C170.331%20128.322%20170.601%20128.211%20170.921%20128.211C171.231%20128.211%20171.493%20128.322%20171.706%20128.546C171.92%20128.769%20172.027%20129.033%20172.027%20129.339C172.027%20129.639%20171.92%20129.899%20171.706%20130.117C171.493%20130.335%20171.231%20130.444%20170.921%20130.444ZM176.115%20130.466C175.49%20130.466%20174.9%20130.386%20174.347%20130.226C173.799%20130.061%20173.365%20129.841%20173.045%20129.564L173.569%20128.189C173.836%20128.412%20174.204%20128.596%20174.675%20128.742C175.145%20128.883%20175.628%20128.953%20176.123%20128.953C176.68%20128.953%20177.129%20128.803%20177.469%20128.502C177.813%20128.201%20177.985%20127.808%20177.985%20127.323C177.985%20127.023%20177.937%20126.763%20177.84%20126.545C177.747%20126.327%20177.624%20126.152%20177.469%20126.021C177.313%20125.89%20177.105%20125.786%20176.843%20125.708C176.586%20125.626%20176.322%20125.57%20176.05%20125.541C175.778%20125.512%20175.451%20125.495%20175.068%20125.49C175.053%20125.49%20174.983%20125.49%20174.857%20125.49C174.731%20125.485%20174.66%20125.483%20174.646%20125.483V124.013H175.053C175.475%20124.013%20175.836%20123.991%20176.137%20123.948C176.443%20123.904%20176.724%20123.829%20176.981%20123.722C177.243%20123.615%20177.44%20123.458%20177.57%20123.249C177.706%20123.041%20177.774%20122.783%20177.774%20122.478C177.774%20122.066%20177.619%20121.714%20177.309%20121.423C176.998%20121.132%20176.562%20120.986%20175.999%20120.986C175.087%20120.986%20174.275%20121.214%20173.562%20121.67L173.038%20120.288C173.921%20119.745%20174.968%20119.473%20176.181%20119.473C177.195%20119.473%20178.022%20119.74%20178.662%20120.273C179.307%20120.807%20179.629%20121.491%20179.629%20122.325C179.629%20122.907%20179.479%20123.404%20179.178%20123.817C178.882%20124.224%20178.451%20124.522%20177.883%20124.711C178.533%20124.838%20179.035%20125.15%20179.389%20125.65C179.748%20126.15%20179.928%20126.739%20179.928%20127.418C179.928%20128.063%20179.755%20128.621%20179.411%20129.091C179.067%20129.557%20178.611%20129.904%20178.043%20130.132C177.476%20130.355%20176.833%20130.466%20176.115%20130.466ZM181.572%20130.313V119.655H183.551V124.457C183.895%20124.001%20184.598%20123.15%20185.661%20121.903C186.728%20120.657%20187.363%20119.907%20187.567%20119.655H189.902L185.872%20124.45L190.157%20130.313H187.843L184.366%20125.534L183.551%20126.217V130.313H181.572Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip17_12_1053)'%3e%3cpath%20d='M97.4686%20124.098V125.786C97.5608%20125.786%2097.751%20125.788%2098.039%20125.792C98.3293%20125.797%2098.5532%20125.799%2098.7107%20125.799C99.1404%20125.799%2099.4397%20125.728%2099.6085%20125.587C99.7772%20125.443%2099.8616%20125.215%2099.8616%20124.905C99.8616%20124.632%2099.7806%20124.43%2099.6186%20124.297C99.4566%20124.164%2099.1855%20124.098%2098.8052%20124.098H97.4686ZM100.668%20128.624H99.9933L99.3047%20127.058C99.1179%20126.637%2098.9987%20126.384%2098.9469%20126.299C98.7827%20126.31%2098.588%20126.316%2098.363%20126.316L97.4686%20126.289V128.624H96.8712V123.575H98.4677C98.6522%20123.575%2098.8153%20123.579%2098.9571%20123.588C99.0988%20123.597%2099.2395%20123.614%2099.379%20123.639C99.5207%20123.662%2099.6434%20123.694%2099.7469%20123.737C99.8504%20123.777%2099.9471%20123.831%20100.037%20123.899C100.127%20123.964%20100.199%20124.043%20100.253%20124.135C100.309%20124.227%20100.353%20124.338%20100.385%20124.466C100.416%20124.592%20100.432%20124.735%20100.432%20124.895C100.432%20125.21%20100.349%20125.481%20100.182%20125.708C100.018%20125.935%2099.784%20126.093%2099.4802%20126.181C99.4802%20126.185%2099.5027%20126.226%2099.5477%20126.302C99.5927%20126.379%2099.6456%20126.473%2099.7064%20126.586C99.7694%20126.696%2099.8177%20126.788%2099.8515%20126.862L100.668%20128.624ZM101.897%20126.13C101.897%20126.771%20102.044%20127.275%20102.339%20127.642C102.634%20128.007%20103.069%20128.189%20103.645%20128.189C104.221%20128.189%20104.654%20128.007%20104.945%20127.642C105.237%20127.278%20105.384%20126.774%20105.384%20126.13C105.384%20125.473%20105.236%20124.963%20104.941%20124.601C104.649%20124.239%20104.218%20124.058%20103.649%20124.058C103.079%20124.058%20102.645%20124.239%20102.346%20124.601C102.047%20124.963%20101.897%20125.473%20101.897%20126.13ZM106.008%20126.13C106.008%20126.51%20105.955%20126.858%20105.849%20127.173C105.746%20127.488%20105.595%20127.759%20105.397%20127.986C105.201%20128.211%20104.954%20128.387%20104.654%20128.513C104.355%20128.637%20104.019%20128.699%20103.645%20128.699C103.141%20128.699%20102.709%20128.592%20102.349%20128.378C101.991%20128.162%20101.723%20127.863%20101.542%20127.48C101.365%20127.095%20101.276%20126.644%20101.276%20126.127C101.276%20125.328%20101.484%20124.698%20101.9%20124.236C102.317%20123.775%20102.899%20123.545%20103.649%20123.545C104.387%20123.545%20104.964%20123.777%20105.38%20124.243C105.799%20124.707%20106.008%20125.336%20106.008%20126.13ZM106.973%20128.624V123.632H107.561V128.104H109.758L109.738%20128.624H106.973ZM110.423%20128.624V123.632H111.01V128.104H113.207L113.187%20128.624H110.423ZM114.483%20128.624H113.899V123.632H114.483V128.624ZM119.637%20128.624H118.976L116.383%20124.695L116.215%20124.463C116.233%20124.935%20116.242%20125.357%20116.242%20125.728V128.624H115.695V123.632H116.346L118.945%20127.561L119.117%20127.794C119.102%20127.076%20119.094%20126.661%20119.094%20126.548V123.632H119.637V128.624ZM122.989%20128.699C122.609%20128.699%20122.266%20128.636%20121.963%20128.51C121.661%20128.381%20121.411%20128.203%20121.213%20127.976C121.018%20127.747%20120.867%20127.476%20120.761%20127.163C120.658%20126.85%20120.606%20126.507%20120.606%20126.133C120.606%20125.629%20120.702%20125.184%20120.893%20124.797C121.084%20124.41%20121.369%20124.105%20121.747%20123.882C122.125%20123.659%20122.573%20123.548%20123.09%20123.548C123.664%20123.548%20124.168%20123.678%20124.602%20123.939L124.379%20124.422C123.961%20124.181%20123.533%20124.061%20123.097%20124.061C122.793%20124.061%20122.521%20124.114%20122.28%20124.22C122.041%20124.323%20121.846%20124.468%20121.693%20124.655C121.542%20124.839%20121.426%20125.058%20121.345%20125.31C121.266%20125.56%20121.227%20125.834%20121.227%20126.133C121.227%20126.768%20121.384%20127.27%20121.699%20127.639C122.017%20128.005%20122.484%20128.189%20123.1%20128.189C123.451%20128.189%20123.808%20128.118%20124.17%20127.976V126.552H122.992L123.012%20126.042H124.717V128.324C124.433%20128.459%20124.159%20128.556%20123.893%20128.614C123.63%20128.67%20123.329%20128.699%20122.989%20128.699Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M83.8915%20131.19H84.5069V136.98H83.8218V131.906C83.5612%20132.076%2083.2426%20132.222%2082.8659%20132.343V131.697C82.9071%20131.679%2082.991%20131.643%2083.1174%20131.589C83.2439%20131.534%2083.338%20131.493%2083.4%20131.465C83.4645%20131.436%2083.5445%20131.396%2083.6399%20131.345C83.7354%20131.293%2083.8193%20131.241%2083.8915%20131.19ZM85.5829%20136.98L85.4939%20136.345L87.4948%20134.124C87.629%20133.974%2087.758%20133.78%2087.8819%20133.543C88.0083%20133.306%2088.0999%20133.104%2088.1567%20132.939L88.2457%20132.695C88.2457%20132.376%2088.1567%20132.128%2087.9786%20131.952C87.8006%20131.774%2087.5477%20131.685%2087.2201%20131.685C86.673%20131.685%2086.2421%20131.844%2085.9273%20132.161L85.7029%20131.581C86.0589%20131.245%2086.5801%20131.078%2087.2665%20131.078C87.7929%20131.078%2088.2122%20131.221%2088.5244%20131.507C88.8366%20131.791%2088.9927%20132.172%2088.9927%20132.649C88.9824%20132.685%2088.9669%20132.734%2088.9462%20132.796C88.9256%20132.855%2088.8804%20132.973%2088.8108%20133.148C88.7437%20133.324%2088.6727%20133.49%2088.5979%20133.648C88.5231%20133.805%2088.4276%20133.978%2088.3115%20134.166C88.198%20134.355%2088.0819%20134.512%2087.9632%20134.638L86.3299%20136.384H89.012L88.9695%20136.98H85.5829ZM94.628%20136.628L92.8708%20132.541L92.7237%20132.15L92.7508%20133.551V136.98H92.1238V131.256H92.9908L94.9841%20135.815L96.958%20131.256H97.8017V136.98H97.1515V133.535L97.1786%20132.165L97.0354%20132.556L95.2821%20136.628H94.628ZM99.6285%20134.12C99.6285%20134.855%2099.7975%20135.433%20100.136%20135.854C100.474%20136.272%20100.973%20136.481%20101.633%20136.481C102.294%20136.481%20102.791%20136.272%20103.123%20135.854C103.459%20135.436%20103.627%20134.858%20103.627%20134.12C103.627%20133.366%20103.458%20132.782%20103.12%20132.366C102.784%20131.951%20102.29%20131.743%20101.637%20131.743C100.984%20131.743%20100.486%20131.951%20100.143%20132.366C99.8001%20132.782%2099.6285%20133.366%2099.6285%20134.12ZM104.343%20134.12C104.343%20134.556%20104.282%20134.954%20104.161%20135.316C104.042%20135.677%20103.869%20135.988%20103.642%20136.248C103.418%20136.507%20103.134%20136.708%20102.791%20136.852C102.447%20136.994%20102.062%20137.065%20101.633%20137.065C101.055%20137.065%20100.56%20136.943%20100.147%20136.697C99.7369%20136.45%2099.4286%20136.107%2099.2221%20135.668C99.0183%20135.227%2098.9164%20134.709%2098.9164%20134.116C98.9164%20133.2%2099.155%20132.477%2099.6324%20131.948C100.11%20131.42%20100.778%20131.155%20101.637%20131.155C102.484%20131.155%20103.145%20131.422%20103.623%20131.956C104.103%20132.488%20104.343%20133.209%20104.343%20134.12ZM109.97%20136.98H109.212L106.239%20132.475L106.046%20132.208C106.066%20132.75%20106.077%20133.233%20106.077%20133.659V136.98H105.45V131.256H106.197L109.177%20135.761L109.374%20136.028C109.356%20135.205%20109.347%20134.729%20109.347%20134.6V131.256H109.97V136.98ZM113.105%20136.98H112.432V131.848H110.671V131.256H114.866V131.848H113.105V136.98ZM119.987%20136.98H119.317V134.302H116.244V136.98H115.575V131.256H116.244V133.713H119.317V131.256H119.987V136.98ZM121.225%20136.036C121.821%20136.33%20122.46%20136.477%20123.141%20136.477C123.98%20136.477%20124.399%20136.095%20124.399%20135.331C124.399%20135.083%20124.332%20134.884%20124.198%20134.731C124.066%20134.576%20123.825%20134.455%20123.474%20134.367L122.336%20134.081C121.467%20133.862%20121.032%20133.397%20121.032%20132.688C121.032%20132.143%20121.219%20131.739%20121.593%20131.476C121.967%20131.211%20122.484%20131.078%20123.145%20131.078C123.491%20131.078%20123.815%20131.115%20124.116%20131.19C124.418%20131.265%20124.671%20131.365%20124.875%20131.492L124.682%20132.037C124.509%20131.942%20124.279%20131.857%20123.993%20131.782C123.709%20131.707%20123.421%20131.67%20123.13%20131.67C122.195%20131.67%20121.728%20131.994%20121.728%20132.641C121.728%20132.861%20121.799%20133.037%20121.941%20133.172C122.086%20133.303%20122.301%20133.404%20122.588%20133.473L123.675%20133.737C124.14%20133.848%20124.492%20134.026%20124.732%20134.271C124.972%20134.513%20125.092%20134.859%20125.092%20135.308C125.092%20135.891%20124.913%20136.331%20124.554%20136.628C124.198%20136.922%20123.713%20137.069%20123.099%20137.069C122.639%20137.069%20122.23%20137.023%20121.872%20136.93C121.516%20136.834%20121.233%20136.722%20121.024%20136.593L121.225%20136.036Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip18_12_1053)'%3e%3cpath%20d='M226.468%20129.747C226.01%20129.747%20225.579%20129.688%20225.175%20129.571C224.774%20129.451%20224.456%20129.289%20224.222%20129.087L224.605%20128.081C224.8%20128.244%20225.07%20128.379%20225.414%20128.486C225.758%20128.589%20226.111%20128.64%20226.473%20128.64C226.881%20128.64%20227.21%20128.53%20227.458%20128.31C227.71%20128.09%20227.836%20127.803%20227.836%20127.448C227.836%20127.228%20227.8%20127.038%20227.729%20126.878C227.662%20126.719%20227.572%20126.591%20227.458%20126.495C227.344%20126.399%20227.192%20126.323%20227%20126.266C226.812%20126.206%20226.619%20126.165%20226.42%20126.144C226.221%20126.123%20225.982%20126.11%20225.702%20126.107C225.691%20126.107%20225.64%20126.107%20225.547%20126.107C225.455%20126.103%20225.404%20126.101%20225.393%20126.101V125.026H225.691C226%20125.026%20226.264%20125.01%20226.484%20124.978C226.708%20124.946%20226.913%20124.891%20227.101%20124.813C227.293%20124.735%20227.437%20124.62%20227.532%20124.467C227.632%20124.315%20227.681%20124.127%20227.681%20123.903C227.681%20123.602%20227.568%20123.344%20227.341%20123.131C227.114%20122.919%20226.794%20122.812%20226.383%20122.812C225.716%20122.812%20225.121%20122.979%20224.6%20123.312L224.217%20122.301C224.862%20121.904%20225.629%20121.705%20226.516%20121.705C227.257%20121.705%20227.862%20121.9%20228.331%20122.291C228.803%20122.681%20229.039%20123.181%20229.039%20123.791C229.039%20124.217%20228.929%20124.581%20228.709%20124.882C228.492%20125.181%20228.176%20125.399%20227.761%20125.537C228.237%20125.629%20228.604%20125.858%20228.863%20126.224C229.126%20126.589%20229.257%20127.02%20229.257%20127.517C229.257%20127.989%20229.131%20128.397%20228.879%20128.741C228.627%20129.082%20228.294%20129.335%20227.878%20129.502C227.463%20129.665%20226.993%20129.747%20226.468%20129.747ZM232.205%20129.747C231.748%20129.747%20231.317%20129.688%20230.912%20129.571C230.511%20129.451%20230.194%20129.289%20229.959%20129.087L230.343%20128.081C230.538%20128.244%20230.807%20128.379%20231.152%20128.486C231.496%20128.589%20231.849%20128.64%20232.211%20128.64C232.619%20128.64%20232.947%20128.53%20233.195%20128.31C233.447%20128.09%20233.573%20127.803%20233.573%20127.448C233.573%20127.228%20233.538%20127.038%20233.467%20126.878C233.399%20126.719%20233.309%20126.591%20233.195%20126.495C233.082%20126.399%20232.929%20126.323%20232.738%20126.266C232.55%20126.206%20232.356%20126.165%20232.158%20126.144C231.959%20126.123%20231.719%20126.11%20231.439%20126.107C231.428%20126.107%20231.377%20126.107%20231.285%20126.107C231.192%20126.103%20231.141%20126.101%20231.13%20126.101V125.026H231.428C231.737%20125.026%20232.001%20125.01%20232.221%20124.978C232.445%20124.946%20232.651%20124.891%20232.839%20124.813C233.03%20124.735%20233.174%20124.62%20233.27%20124.467C233.369%20124.315%20233.419%20124.127%20233.419%20123.903C233.419%20123.602%20233.305%20123.344%20233.078%20123.131C232.851%20122.919%20232.532%20122.812%20232.12%20122.812C231.453%20122.812%20230.859%20122.979%20230.337%20123.312L229.954%20122.301C230.6%20121.904%20231.366%20121.705%20232.253%20121.705C232.995%20121.705%20233.6%20121.9%20234.068%20122.291C234.54%20122.681%20234.776%20123.181%20234.776%20123.791C234.776%20124.217%20234.666%20124.581%20234.446%20124.882C234.23%20125.181%20233.914%20125.399%20233.499%20125.537C233.974%20125.629%20234.341%20125.858%20234.6%20126.224C234.863%20126.589%20234.994%20127.02%20234.994%20127.517C234.994%20127.989%20234.868%20128.397%20234.616%20128.741C234.364%20129.082%20234.031%20129.335%20233.616%20129.502C233.201%20129.665%20232.731%20129.747%20232.205%20129.747ZM236.665%20129.731C236.435%20129.731%20236.24%20129.651%20236.08%20129.492C235.92%20129.332%20235.841%20129.142%20235.841%20128.922C235.841%20128.699%20235.919%20128.505%20236.075%20128.342C236.234%20128.179%20236.431%20128.097%20236.665%20128.097C236.893%20128.097%20237.084%20128.179%20237.24%20128.342C237.396%20128.505%20237.474%20128.699%20237.474%20128.922C237.474%20129.142%20237.396%20129.332%20237.24%20129.492C237.084%20129.651%20236.893%20129.731%20236.665%20129.731ZM239.178%20129.635L241.541%20126.559C241.303%20126.641%20241.092%20126.681%20240.907%20126.681C240.144%20126.681%20239.522%20126.453%20239.039%20125.995C238.56%20125.534%20238.321%20124.937%20238.321%20124.207C238.321%20123.447%20238.583%20122.84%20239.108%20122.386C239.637%20121.932%20240.322%20121.705%20241.163%20121.705C242.032%20121.705%20242.736%20121.939%20243.276%20122.408C243.815%20122.872%20244.085%20123.492%20244.085%20124.265C244.085%20124.712%20244%20125.118%20243.829%20125.484C243.659%20125.849%20243.409%20126.257%20243.079%20126.708L240.875%20129.635H239.178ZM241.205%20125.702C241.699%20125.702%20242.062%20125.565%20242.296%20125.292C242.534%20125.019%20242.653%20124.65%20242.653%20124.185C242.653%20123.749%20242.531%20123.403%20242.286%20123.147C242.041%20122.892%20241.69%20122.764%20241.232%20122.764C240.76%20122.764%20240.389%20122.897%20240.12%20123.163C239.854%20123.429%20239.72%20123.779%20239.72%20124.212C239.72%20124.673%20239.845%20125.037%20240.093%20125.303C240.345%20125.569%20240.716%20125.702%20241.205%20125.702ZM246.522%20125.186C246.831%20125.186%20247.063%20125.071%20247.22%20124.84C247.379%20124.609%20247.459%20124.311%20247.459%20123.946C247.459%20123.573%20247.379%20123.272%20247.22%20123.041C247.063%20122.81%20246.833%20122.695%20246.528%20122.695C246.222%20122.695%20245.992%20122.812%20245.836%20123.046C245.68%20123.28%20245.602%20123.584%20245.602%20123.956C245.602%20124.329%20245.678%20124.627%20245.83%20124.851C245.987%20125.074%20246.217%20125.186%20246.522%20125.186ZM246.506%20126.032C245.928%20126.032%20245.472%20125.837%20245.139%20125.447C244.809%20125.056%20244.644%20124.56%20244.644%20123.956C244.644%20123.353%20244.814%20122.853%20245.154%20122.456C245.499%20122.058%20245.958%20121.859%20246.533%20121.859C247.133%20121.859%20247.605%20122.055%20247.949%20122.445C248.293%20122.835%20248.465%20123.334%20248.465%20123.94C248.465%20124.54%20248.286%20125.039%20247.927%20125.436C247.569%20125.833%20247.095%20126.032%20246.506%20126.032ZM245.99%20129.806L250.785%20121.918L251.956%20121.923L247.124%20129.806H245.99ZM251.712%20128.879C252.031%20128.879%20252.27%20128.764%20252.43%20128.534C252.593%20128.299%20252.675%20127.998%20252.675%20127.629C252.675%20127.26%20252.588%20126.963%20252.414%20126.74C252.244%20126.513%20251.988%20126.399%20251.648%20126.399C251.307%20126.399%20251.069%20126.511%20250.934%20126.735C250.8%20126.958%20250.732%20127.265%20250.732%20127.655C250.732%20128.024%20250.814%20128.321%20250.977%20128.544C251.144%20128.768%20251.389%20128.879%20251.712%20128.879ZM251.696%20129.726C251.085%20129.726%20250.603%20129.531%20250.248%20129.14C249.897%20128.746%20249.721%20128.251%20249.721%20127.655C249.721%20126.257%20250.365%20125.558%20251.653%20125.558C252.288%20125.558%20252.774%20125.752%20253.111%20126.139C253.452%20126.522%20253.622%20127.02%20253.622%20127.634C253.622%20128.234%20253.448%20128.732%20253.101%20129.13C252.756%20129.527%20252.288%20129.726%20251.696%20129.726Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cpath%20d='M829.151%2085.054V76.2706H834.187L834.145%2077.1792H830.178V80.0536H833.949V80.9503H830.178V84.1453H834.276L834.228%2085.054H829.151ZM840.208%2081.4076C839.373%2078.9806%20838.912%2077.6167%20838.825%2077.3158C838.825%2077.3158%20838.344%2078.6797%20837.382%2081.4076H840.208ZM841.568%2085.054L840.541%2082.2687H837.037L835.974%2085.054H834.929L838.302%2076.2528H839.353L842.625%2085.054H841.568ZM844.567%2077.0901V80.0595C844.73%2080.0595%20845.064%2080.0635%20845.571%2080.0714C846.082%2080.0793%20846.476%2080.0832%20846.753%2080.0832C847.509%2080.0832%20848.036%2079.9585%20848.333%2079.7091C848.63%2079.4557%20848.778%2079.0558%20848.778%2078.5095C848.778%2078.0304%20848.635%2077.6741%20848.35%2077.4405C848.065%2077.2069%20847.588%2077.0901%20846.919%2077.0901H844.567ZM850.197%2085.054H849.01L847.798%2082.2984C847.469%2081.558%20847.26%2081.1126%20847.169%2080.9622C846.88%2080.982%20846.537%2080.9919%20846.141%2080.9919L844.567%2080.9444V85.054H843.516V76.1696H846.325C846.65%2076.1696%20846.937%2076.1775%20847.186%2076.1934C847.436%2076.2092%20847.683%2076.2389%20847.929%2076.2825C848.178%2076.3221%20848.394%2076.3795%20848.576%2076.4547C848.758%2076.526%20848.928%2076.621%20849.087%2076.7397C849.245%2076.8546%20849.372%2076.9931%20849.467%2077.1555C849.566%2077.3178%20849.643%2077.5118%20849.698%2077.7375C849.754%2077.9592%20849.782%2078.2106%20849.782%2078.4917C849.782%2079.0459%20849.635%2079.523%20849.342%2079.9229C849.053%2080.3228%20848.641%2080.5999%20848.107%2080.7543C848.107%2080.7622%20848.147%2080.8335%20848.226%2080.9681C848.305%2081.1027%20848.398%2081.269%20848.505%2081.467C848.616%2081.661%20848.701%2081.8233%20848.76%2081.9539L850.197%2085.054ZM858.571%2085.054H857.407L852.846%2078.1413L852.549%2077.7315C852.581%2078.5629%20852.597%2079.3053%20852.597%2079.9585V85.054H851.635V76.2706H852.781L857.354%2083.1833L857.656%2083.593C857.629%2082.3301%20857.615%2081.5996%20857.615%2081.4016V76.2706H858.571V85.054ZM861.713%2085.054H860.685V76.2706H861.713V85.054ZM870.781%2085.054H869.617L865.056%2078.1413L864.759%2077.7315C864.791%2078.5629%20864.807%2079.3053%20864.807%2079.9585V85.054H863.845V76.2706H864.991L869.564%2083.1833L869.866%2083.593C869.839%2082.3301%20869.825%2081.5996%20869.825%2081.4016V76.2706H870.781V85.054ZM876.678%2085.1846C876.009%2085.1846%20875.407%2085.0738%20874.873%2084.852C874.342%2084.6264%20873.903%2084.3136%20873.554%2083.9137C873.21%2083.5099%20872.945%2083.0328%20872.759%2082.4825C872.576%2081.9322%20872.485%2081.3284%20872.485%2080.6712C872.485%2079.7843%20872.654%2079.0004%20872.99%2078.3194C873.327%2077.6385%20873.828%2077.102%20874.493%2076.7101C875.158%2076.3181%20875.946%2076.1221%20876.856%2076.1221C877.866%2076.1221%20878.753%2076.3518%20879.517%2076.811L879.125%2077.6602C878.388%2077.2366%20877.636%2077.0248%20876.868%2077.0248C876.334%2077.0248%20875.855%2077.1178%20875.431%2077.3039C875.011%2077.486%20874.667%2077.7414%20874.398%2078.07C874.132%2078.3947%20873.928%2078.7787%20873.786%2079.2221C873.647%2079.6616%20873.578%2080.1446%20873.578%2080.6712C873.578%2081.7877%20873.855%2082.6705%20874.41%2083.3198C874.968%2083.9652%20875.789%2084.2879%20876.874%2084.2879C877.492%2084.2879%20878.119%2084.1631%20878.757%2083.9137V81.4076H876.684L876.72%2080.5108H879.719V84.5254C879.22%2084.763%20878.737%2084.9332%20878.27%2085.0361C877.806%2085.1351%20877.276%2085.1846%20876.678%2085.1846ZM881.364%2083.6049C882.278%2084.0563%20883.258%2084.2819%20884.303%2084.2819C885.59%2084.2819%20886.234%2083.696%20886.234%2082.5241C886.234%2082.144%20886.131%2081.8371%20885.925%2081.6036C885.723%2081.366%20885.353%2081.1799%20884.814%2081.0453L883.068%2080.6059C881.734%2080.2693%20881.067%2079.5567%20881.067%2078.4679C881.067%2077.6325%20881.354%2077.0129%20881.928%2076.6091C882.502%2076.2013%20883.296%2075.9974%20884.309%2075.9974C884.84%2075.9974%20885.337%2076.0548%20885.8%2076.1696C886.263%2076.2844%20886.651%2076.4389%20886.964%2076.6328L886.667%2077.4702C886.402%2077.3237%20886.049%2077.1931%20885.61%2077.0783C885.174%2076.9634%20884.733%2076.906%20884.286%2076.906C882.852%2076.906%20882.136%2077.4029%20882.136%2078.3966C882.136%2078.7332%20882.245%2079.0044%20882.462%2079.2103C882.684%2079.4122%20883.015%2079.5666%20883.454%2079.6735L885.123%2080.0773C885.836%2080.2476%20886.376%2080.5207%20886.744%2080.8969C887.112%2081.269%20887.297%2081.7995%20887.297%2082.4884C887.297%2083.3832%20887.021%2084.0582%20886.471%2084.5135C885.925%2084.9649%20885.18%2085.1905%20884.238%2085.1905C883.533%2085.1905%20882.906%2085.1193%20882.356%2084.9768C881.809%2084.8303%20881.376%2084.658%20881.055%2084.4601L881.364%2083.6049Z'%20fill='white'%20/%3e%3cg%20filter='url(%23filter0_f_12_1053)'%3e%3cpath%20d='M854.407%20103.606L854.393%20102.209C853.156%20102.194%20852.036%20101.899%20851.032%20101.321L851.512%2099.7572C852.472%20100.286%20853.437%20100.565%20854.407%20100.594V97.4363C853.825%2097.2666%20853.432%2097.1405%20853.229%2097.058C851.798%2096.5536%20851.082%2095.6126%20851.082%2094.2352C851.082%2093.3379%20851.383%2092.6297%20851.985%2092.1107C852.586%2091.5918%20853.394%2091.2983%20854.407%2091.2304V90.11H855.12V91.2159C856.284%2091.2498%20857.301%2091.5142%20858.169%2092.0089L857.572%2093.4494C856.699%2093.0565%20855.882%2092.8456%20855.12%2092.8165V95.6757C855.159%2095.6902%20855.217%2095.7096%20855.295%2095.7339C855.373%2095.7581%20855.457%2095.7848%20855.55%2095.8139C855.647%2095.843%20855.712%2095.8624%20855.746%2095.8721C856.721%2096.1922%20857.417%2096.59%20857.834%2097.0653C858.256%2097.5406%20858.467%2098.2027%20858.467%2099.0515C858.467%2099.9682%20858.169%20100.696%20857.572%20101.234C856.976%20101.772%20856.158%20102.088%20855.12%20102.18V103.606H854.407ZM854.407%2095.4356V92.8456C853.995%2092.8989%20853.682%2093.0299%20853.469%2093.2384C853.255%2093.447%20853.139%2093.7501%20853.12%2094.1479C853.12%2094.7396%20853.413%2095.1252%20854%2095.3046C854.068%2095.3289%20854.204%2095.3725%20854.407%2095.4356ZM855.12%20100.55C856.018%20100.405%20856.466%2099.9003%20856.466%2099.0369C856.466%2098.4161%20856.09%2097.9796%20855.339%2097.7273C855.324%2097.7176%20855.285%2097.7055%20855.222%2097.691C855.164%2097.6716%20855.13%2097.6594%20855.12%2097.6546V100.55ZM863.24%20102.216C862.546%20102.216%20861.92%20102.107%20861.363%20101.889C860.81%20101.666%20860.361%20101.326%20860.017%20100.87C859.672%20100.41%20859.5%2099.8639%20859.5%2099.2333C859.5%2097.9577%20860.128%2097.041%20861.384%2096.4833C860.264%2095.9497%20859.704%2095.1155%20859.704%2093.9805C859.704%2093.5343%20859.796%2093.1341%20859.98%2092.7801C860.165%2092.426%20860.417%2092.1374%20860.737%2091.9143C861.062%2091.6863%20861.435%2091.5142%20861.857%2091.3978C862.284%2091.2813%20862.745%2091.2231%20863.24%2091.2231C864.268%2091.2231%20865.112%2091.4632%20865.771%2091.9434C866.436%2092.4236%20866.768%2093.1026%20866.768%2093.9805C866.768%2095.1009%20866.249%2095.9352%20865.211%2096.4833C866.38%2097.0507%20866.965%2097.9699%20866.965%2099.2406C866.965%2099.8712%20866.792%20100.417%20866.448%20100.878C866.109%20101.334%20865.66%20101.671%20865.102%20101.889C864.549%20102.107%20863.928%20102.216%20863.24%20102.216ZM861.799%20100.448C862.148%20100.744%20862.629%20100.892%20863.24%20100.892C863.851%20100.892%20864.329%20100.744%20864.673%20100.448C865.017%20100.152%20865.189%2099.7354%20865.189%2099.197C865.189%2098.6634%20865.01%2098.2221%20864.651%2097.8729C864.292%2097.5236%20863.822%2097.2738%20863.24%2097.1235C862.643%2097.2738%20862.165%2097.5236%20861.806%2097.8729C861.452%2098.2221%20861.275%2098.6659%20861.275%2099.2042C861.275%2099.7378%20861.45%20100.152%20861.799%20100.448ZM863.24%2095.9885C863.836%2095.8527%20864.295%2095.6175%20864.615%2095.2828C864.935%2094.9433%20865.095%2094.5116%20865.095%2093.9878C865.095%2093.5513%20864.92%2093.1996%20864.571%2092.9329C864.222%2092.6661%20863.778%2092.5327%20863.24%2092.5327C862.706%2092.5327%20862.262%2092.6661%20861.908%2092.9329C861.554%2093.1996%20861.377%2093.5513%20861.377%2093.9878C861.377%2094.5116%20861.542%2094.9433%20861.872%2095.2828C862.202%2095.6223%20862.658%2095.8576%20863.24%2095.9885ZM872.894%20102.063V99.699H868.085V98.404L872.399%2091.456H874.822V98.2584H876.132L876.037%2099.699H874.822V102.063H872.894ZM869.977%2098.2657H872.894V93.3185L869.977%2098.2657ZM878.322%20102.194C878.006%20102.194%20877.74%20102.085%20877.521%20101.867C877.303%20101.649%20877.194%20101.389%20877.194%20101.089C877.194%20100.783%20877.301%20100.519%20877.514%20100.296C877.732%20100.072%20878.001%2099.9609%20878.322%2099.9609C878.632%2099.9609%20878.894%20100.072%20879.107%20100.296C879.321%20100.519%20879.427%20100.783%20879.427%20101.089C879.427%20101.389%20879.321%20101.649%20879.107%20101.867C878.894%20102.085%20878.632%20102.194%20878.322%20102.194ZM881.756%20102.063L884.986%2097.8583C884.661%2097.9699%20884.372%2098.0256%20884.12%2098.0256C883.077%2098.0256%20882.226%2097.7128%20881.566%2097.0871C880.912%2096.4566%20880.584%2095.6417%20880.584%2094.6426C880.584%2093.6046%20880.943%2092.7752%20881.661%2092.1544C882.384%2091.5336%20883.32%2091.2231%20884.469%2091.2231C885.658%2091.2231%20886.62%2091.5433%20887.358%2092.1835C888.095%2092.8189%20888.463%2093.6653%20888.463%2094.7226C888.463%2095.3337%20888.347%2095.8891%20888.114%2096.3887C887.881%2096.8882%20887.539%2097.446%20887.088%2098.062L884.076%20102.063H881.756ZM884.527%2096.687C885.202%2096.687%20885.699%2096.5002%20886.019%2096.1268C886.344%2095.7533%20886.506%2095.2489%20886.506%2094.6135C886.506%2094.0169%20886.339%2093.544%20886.004%2093.1948C885.67%2092.8456%20885.19%2092.6709%20884.564%2092.6709C883.919%2092.6709%20883.412%2092.8528%20883.043%2093.2166C882.679%2093.5804%20882.498%2094.0581%20882.498%2094.6499C882.498%2095.2804%20882.667%2095.7775%20883.007%2096.1413C883.351%2096.5051%20883.858%2096.687%20884.527%2096.687ZM889.977%20102.063V91.405H891.956V96.2068C892.3%2095.7509%20893.003%2094.8996%20894.065%2093.6531C895.133%2092.4066%20895.768%2091.6572%20895.972%2091.405H898.307L894.276%2096.1995L898.562%20102.063H896.248L892.77%2097.2835L891.956%2097.9674V102.063H889.977Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip19_12_1053)'%3e%3cpath%20d='M799.222%2097.7294C798.839%2097.7294%20798.51%2097.8222%20798.233%2098.0077C797.958%2098.1932%20797.753%2098.4429%20797.618%2098.7567C797.482%2099.0704%20797.415%2099.4312%20797.415%2099.8389C797.415%20100.143%20797.452%20100.422%20797.525%20100.674C797.598%20100.923%20797.708%20101.143%20797.855%20101.333C798.001%20101.521%20798.191%20101.668%20798.425%20101.773C798.661%20101.876%20798.931%20101.928%20799.236%20101.928C799.627%20101.928%20800.033%20101.826%20800.452%20101.622L800.552%20102.127C800.21%20102.342%20799.749%20102.45%20799.167%20102.45C798.785%20102.45%20798.441%20102.387%20798.136%20102.261C797.834%20102.133%20797.583%20101.953%20797.384%20101.722C797.187%20101.488%20797.037%20101.211%20796.934%20100.89C796.831%20100.567%20796.779%20100.209%20796.779%2099.8148C796.779%2099.4346%20796.835%2099.0842%20796.948%2098.7635C797.06%2098.4429%20797.218%2098.1681%20797.422%2097.939C797.628%2097.7077%20797.884%2097.5279%20798.191%2097.3996C798.498%2097.2714%20798.839%2097.2073%20799.215%2097.2073C799.785%2097.2073%20800.266%2097.3332%20800.658%2097.5852L800.424%2098.0696C800.049%2097.8428%20799.648%2097.7294%20799.222%2097.7294ZM805.214%2097.2931V100.591C805.214%20101.175%20805.053%20101.631%20804.733%20101.959C804.414%20102.286%20803.929%20102.45%20803.276%20102.45C802.623%20102.45%20802.141%20102.286%20801.83%20101.959C801.518%20101.631%20801.362%20101.173%20801.362%20100.584V97.2931H801.96V100.595C801.96%20101.055%20802.069%20101.394%20802.286%20101.612C802.504%20101.829%20802.841%20101.938%20803.296%20101.938C803.741%20101.938%20804.072%20101.828%20804.289%20101.608C804.509%20101.388%20804.619%20101.049%20804.619%20100.591V97.2931H805.214ZM806.88%2097.7672V99.485C806.974%2099.485%20807.167%2099.4873%20807.46%2099.4919C807.756%2099.4964%20807.984%2099.4987%20808.144%2099.4987C808.581%2099.4987%20808.886%2099.4266%20809.058%2099.2823C809.23%2099.1357%20809.316%2098.9044%20809.316%2098.5883C809.316%2098.3112%20809.233%2098.1051%20809.068%2097.9699C808.903%2097.8348%20808.627%2097.7672%20808.24%2097.7672H806.88ZM810.137%20102.374H809.449L808.749%20100.78C808.559%20100.352%20808.437%20100.094%20808.384%20100.007C808.217%20100.019%20808.019%20100.024%20807.79%20100.024L806.88%2099.9969V102.374H806.272V97.2347H807.897C808.084%2097.2347%20808.25%2097.2393%20808.395%2097.2485C808.539%2097.2576%20808.682%2097.2748%20808.824%2097.3C808.969%2097.3229%20809.093%2097.3561%20809.199%2097.3996C809.304%2097.4409%20809.403%2097.4958%20809.494%2097.5645C809.586%2097.631%20809.659%2097.7111%20809.714%2097.805C809.771%2097.8989%20809.816%2098.0112%20809.848%2098.1417C809.88%2098.27%20809.896%2098.4154%20809.896%2098.578C809.896%2098.8987%20809.811%2099.1747%20809.642%2099.406C809.475%2099.6373%20809.236%2099.7976%20808.927%2099.887C808.927%2099.8915%20808.95%2099.9328%20808.996%20100.011C809.042%20100.089%20809.096%20100.185%20809.157%20100.299C809.222%20100.411%20809.271%20100.505%20809.305%20100.581L810.137%20102.374ZM811.483%2097.7672V99.485C811.577%2099.485%20811.771%2099.4873%20812.064%2099.4919C812.359%2099.4964%20812.587%2099.4987%20812.748%2099.4987C813.185%2099.4987%20813.49%2099.4266%20813.661%2099.2823C813.833%2099.1357%20813.919%2098.9044%20813.919%2098.5883C813.919%2098.3112%20813.837%2098.1051%20813.672%2097.9699C813.507%2097.8348%20813.231%2097.7672%20812.844%2097.7672H811.483ZM814.74%20102.374H814.053L813.352%20100.78C813.162%20100.352%20813.041%20100.094%20812.988%20100.007C812.821%20100.019%20812.623%20100.024%20812.394%20100.024L811.483%2099.9969V102.374H810.875V97.2347H812.5C812.688%2097.2347%20812.854%2097.2393%20812.998%2097.2485C813.143%2097.2576%20813.286%2097.2748%20813.428%2097.3C813.572%2097.3229%20813.697%2097.3561%20813.802%2097.3996C813.908%2097.4409%20814.006%2097.4958%20814.098%2097.5645C814.189%2097.631%20814.263%2097.7111%20814.318%2097.805C814.375%2097.8989%20814.42%2098.0112%20814.452%2098.1417C814.484%2098.27%20814.5%2098.4154%20814.5%2098.578C814.5%2098.8987%20814.415%2099.1747%20814.245%2099.406C814.078%2099.6373%20813.84%2099.7976%20813.531%2099.887C813.531%2099.8915%20813.554%2099.9328%20813.6%20100.011C813.645%20100.089%20813.699%20100.185%20813.761%20100.299C813.825%20100.411%20813.874%20100.505%20813.909%20100.581L814.74%20102.374ZM815.572%20102.374V97.2931H818.485L818.461%2097.8188H816.166V99.4816H818.347V100H816.166V101.849H818.536L818.509%20102.374H815.572ZM823.514%20102.374H822.841L820.203%2098.3753L820.031%2098.1383C820.049%2098.6192%20820.058%2099.0487%20820.058%2099.4266V102.374H819.502V97.2931H820.165L822.81%20101.292L822.985%20101.529C822.969%20100.799%20822.961%20100.376%20822.961%20100.261V97.2931H823.514V102.374ZM826.297%20102.374H825.699V97.8188H824.136V97.2931H827.86V97.8188H826.297V102.374Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M801.925%20110.73H801.264V105.143H803.064C803.338%20105.143%20803.586%20105.172%20803.807%20105.229C804.029%20105.286%20804.226%20105.373%20804.397%20105.49C804.569%20105.607%20804.702%20105.764%20804.797%20105.961C804.892%20106.158%20804.939%20106.387%20804.939%20106.648C804.939%20106.865%20804.919%20107.059%20804.879%20107.231C804.839%20107.4%20804.771%20107.559%20804.674%20107.709C804.577%20107.858%20804.45%20107.983%20804.293%20108.082C804.136%20108.179%20803.934%20108.256%20803.688%20108.314C803.444%20108.368%20803.16%20108.396%20802.836%20108.396C802.58%20108.396%20802.276%20108.38%20801.925%20108.347V110.73ZM802.9%20107.824C803.144%20107.824%20803.353%20107.801%20803.527%20107.754C803.701%20107.706%20803.835%20107.648%20803.927%20107.578C804.021%20107.508%20804.095%20107.417%20804.147%20107.305C804.202%20107.193%20804.235%20107.091%20804.248%20106.999C804.26%20106.905%20804.267%20106.791%20804.267%20106.659C804.267%20106.343%20804.16%20106.11%20803.945%20105.961C803.734%20105.812%20803.445%20105.737%20803.079%20105.737H801.925V107.817C802.406%20107.822%20802.73%20107.824%20802.9%20107.824ZM805.701%20110.73V105.207H808.868L808.841%20105.778H806.347V107.585H808.718V108.149H806.347V110.159H808.924L808.894%20110.73H805.701ZM810.533%20105.722V107.589C810.635%20107.589%20810.846%20107.592%20811.164%20107.597C811.486%20107.602%20811.733%20107.604%20811.908%20107.604C812.383%20107.604%20812.714%20107.526%20812.901%20107.369C813.088%20107.21%20813.181%20106.958%20813.181%20106.614C813.181%20106.313%20813.091%20106.089%20812.912%20105.942C812.733%20105.795%20812.433%20105.722%20812.012%20105.722H810.533ZM814.074%20110.73H813.327L812.565%20108.997C812.358%20108.532%20812.226%20108.251%20812.169%20108.157C811.987%20108.169%20811.772%20108.176%20811.523%20108.176L810.533%20108.146V110.73H809.872V105.143H811.639C811.843%20105.143%20812.023%20105.148%20812.18%20105.158C812.337%20105.168%20812.493%20105.187%20812.647%20105.214C812.804%20105.239%20812.94%20105.275%20813.054%20105.322C813.169%20105.367%20813.276%20105.427%20813.375%20105.502C813.475%20105.574%20813.555%20105.661%20813.614%20105.763C813.677%20105.865%20813.725%20105.987%20813.76%20106.129C813.795%20106.268%20813.812%20106.426%20813.812%20106.603C813.812%20106.952%20813.72%20107.252%20813.536%20107.503C813.354%20107.755%20813.095%20107.929%20812.759%20108.026C812.759%20108.031%20812.784%20108.076%20812.834%20108.161C812.884%20108.245%20812.942%20108.35%20813.009%20108.474C813.079%20108.596%20813.133%20108.698%20813.17%20108.781L814.074%20110.73ZM815.653%20110.73H815.007V105.207H815.653V110.73ZM817.45%20107.97C817.45%20108.68%20817.613%20109.237%20817.939%20109.643C818.265%20110.047%20818.747%20110.248%20819.384%20110.248C820.022%20110.248%20820.501%20110.047%20820.822%20109.643C821.146%20109.24%20821.308%20108.682%20821.308%20107.97C821.308%20107.243%20821.144%20106.679%20820.818%20106.278C820.495%20105.878%20820.018%20105.677%20819.388%20105.677C818.758%20105.677%20818.278%20105.878%20817.946%20106.278C817.615%20106.679%20817.45%20107.243%20817.45%20107.97ZM821.998%20107.97C821.998%20108.391%20821.94%20108.776%20821.823%20109.124C821.708%20109.473%20821.542%20109.773%20821.322%20110.024C821.106%20110.273%20820.832%20110.467%20820.501%20110.607C820.17%20110.744%20819.798%20110.812%20819.384%20110.812C818.827%20110.812%20818.348%20110.694%20817.95%20110.457C817.554%20110.218%20817.257%20109.887%20817.058%20109.464C816.861%20109.038%20816.763%20108.539%20816.763%20107.966C816.763%20107.083%20816.993%20106.385%20817.453%20105.875C817.914%20105.365%20818.559%20105.109%20819.388%20105.109C820.205%20105.109%20820.843%20105.367%20821.304%20105.882C821.767%20106.395%20821.998%20107.091%20821.998%20107.97ZM826.917%20107.981C826.917%20107.21%20826.718%20106.648%20826.319%20106.297C825.921%20105.946%20825.341%20105.77%20824.579%20105.77H823.713V110.166H824.687C825.414%20110.166%20825.967%20109.983%20826.345%20109.617C826.726%20109.249%20826.917%20108.703%20826.917%20107.981ZM827.608%20107.963C827.608%20108.861%20827.353%20109.547%20826.842%20110.02C826.332%20110.493%20825.62%20110.73%20824.706%20110.73H823.067V105.207H824.598C825.058%20105.207%20825.47%20105.261%20825.834%20105.371C826.197%20105.478%20826.512%20105.642%20826.779%20105.864C827.048%20106.083%20827.253%20106.37%20827.395%20106.727C827.537%20107.08%20827.608%20107.492%20827.608%20107.963Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip20_12_1053)'%3e%3cpath%20d='M928.249%20103.38V96.8921C928.2%2096.924%20927.969%2097.0269%20927.557%2097.2008C927.149%2097.3711%20926.919%2097.4633%20926.866%2097.4775V96.4131C926.951%2096.3741%20927.22%2096.241%20927.675%2096.0139C928.129%2095.7833%20928.379%2095.652%20928.425%2095.6201H929.596V103.38H928.249ZM933.172%20103.497C932.821%20103.497%20932.459%20103.44%20932.087%20103.327C931.714%20103.21%20931.43%20103.1%20931.235%20102.997C931.04%20102.89%20930.91%20102.809%20930.847%20102.752L931.272%20101.751C931.34%20101.805%20931.437%20101.872%20931.565%20101.954C931.696%20102.032%20931.906%20102.122%20932.193%20102.225C932.484%20102.328%20932.763%20102.379%20933.029%20102.379C933.526%20102.379%20933.902%20102.241%20934.157%20101.964C934.413%20101.687%20934.54%20101.326%20934.54%20100.878C934.54%20100.456%20934.423%20100.117%20934.189%2099.8619C933.958%2099.6064%20933.659%2099.4787%20933.29%2099.4787C932.85%2099.4787%20932.456%2099.6703%20932.108%20100.054L931.177%2099.8726L931.379%2095.6254H935.615L935.536%2096.7218H932.614C932.614%2096.7856%20932.601%2097.1068%20932.576%2097.6851C932.555%2098.2599%20932.543%2098.581%20932.539%2098.6484C932.851%2098.4817%20933.18%2098.3983%20933.524%2098.3983C934.24%2098.3983%20934.817%2098.6289%20935.253%2099.0902C935.693%2099.5514%20935.913%20100.153%20935.913%20100.894C935.913%20101.682%20935.672%20102.314%20935.19%20102.789C934.711%20103.261%20934.038%20103.497%20933.172%20103.497ZM937.648%20103.481C937.418%20103.481%20937.223%20103.401%20937.063%20103.242C936.903%20103.082%20936.824%20102.892%20936.824%20102.672C936.824%20102.449%20936.902%20102.255%20937.058%20102.092C937.217%20101.929%20937.414%20101.847%20937.648%20101.847C937.876%20101.847%20938.067%20101.929%20938.223%20102.092C938.379%20102.255%20938.457%20102.449%20938.457%20102.672C938.457%20102.892%20938.379%20103.082%20938.223%20103.242C938.067%20103.401%20937.876%20103.481%20937.648%20103.481ZM941.944%20103.497C941.436%20103.497%20940.978%20103.417%20940.57%20103.258C940.166%20103.094%20939.838%20102.846%20939.586%20102.512C939.334%20102.175%20939.208%20101.776%20939.208%20101.315C939.208%20100.382%20939.667%2099.7111%20940.586%2099.3031C939.767%2098.9128%20939.357%2098.3025%20939.357%2097.4722C939.357%2097.1458%20939.424%2096.8531%20939.559%2096.594C939.694%2096.335%20939.879%2096.1239%20940.113%2095.9607C940.35%2095.7939%20940.624%2095.668%20940.932%2095.5828C941.245%2095.4977%20941.582%2095.4551%20941.944%2095.4551C942.696%2095.4551%20943.313%2095.6307%20943.796%2095.982C944.282%2096.3333%20944.525%2096.83%20944.525%2097.4722C944.525%2098.2918%20944.145%2098.9021%20943.386%2099.3031C944.241%2099.7182%20944.669%20100.391%20944.669%20101.32C944.669%20101.781%20944.543%20102.181%20944.291%20102.518C944.042%20102.851%20943.714%20103.098%20943.306%20103.258C942.902%20103.417%20942.447%20103.497%20941.944%20103.497ZM940.89%20102.204C941.145%20102.42%20941.496%20102.528%20941.944%20102.528C942.391%20102.528%20942.74%20102.42%20942.992%20102.204C943.244%20101.987%20943.37%20101.682%20943.37%20101.288C943.37%20100.898%20943.239%20100.575%20942.976%20100.32C942.714%20100.064%20942.369%2099.8814%20941.944%2099.7714C941.507%2099.8814%20941.158%20100.064%20940.895%20100.32C940.636%20100.575%20940.507%20100.9%20940.507%20101.294C940.507%20101.684%20940.634%20101.987%20940.89%20102.204ZM941.944%2098.9412C942.38%2098.8418%20942.715%2098.6697%20942.949%2098.4249C943.184%2098.1765%20943.301%2097.8607%20943.301%2097.4775C943.301%2097.1582%20943.173%2096.901%20942.918%2096.7058C942.662%2096.5107%20942.337%2096.4131%20941.944%2096.4131C941.553%2096.4131%20941.229%2096.5107%20940.97%2096.7058C940.711%2096.901%20940.581%2097.1582%20940.581%2097.4775C940.581%2097.8607%20940.702%2098.1765%20940.943%2098.4249C941.184%2098.6733%20941.518%2098.8454%20941.944%2098.9412ZM947.165%2098.9358C947.473%2098.9358%20947.706%2098.8205%20947.862%2098.5899C948.022%2098.3593%20948.101%2098.0612%20948.101%2097.6958C948.101%2097.3232%20948.022%2097.0216%20947.862%2096.791C947.706%2096.5603%20947.475%2096.445%20947.17%2096.445C946.865%2096.445%20946.634%2096.5621%20946.478%2096.7963C946.322%2097.0305%20946.244%2097.3338%20946.244%2097.7064C946.244%2098.079%20946.32%2098.377%20946.473%2098.6005C946.629%2098.8241%20946.86%2098.9358%20947.165%2098.9358ZM947.149%2099.7821C946.57%2099.7821%20946.114%2099.5869%20945.781%2099.1966C945.451%2098.8063%20945.286%2098.3096%20945.286%2097.7064C945.286%2097.1032%20945.456%2096.6029%20945.797%2096.2055C946.141%2095.8081%20946.601%2095.6094%20947.175%2095.6094C947.775%2095.6094%20948.247%2095.8046%20948.591%2096.1949C948.935%2096.5852%20949.107%2097.0837%20949.107%2097.6904C949.107%2098.2901%20948.928%2098.7886%20948.57%2099.186C948.211%2099.5834%20947.738%2099.7821%20947.149%2099.7821ZM946.632%20103.556L951.428%2095.668L952.599%2095.6733L947.766%20103.556H946.632ZM952.354%20102.629C952.673%20102.629%20952.913%20102.514%20953.072%20102.284C953.236%20102.049%20953.317%20101.748%20953.317%20101.379C953.317%20101.01%20953.23%20100.713%20953.056%20100.49C952.886%20100.263%20952.631%20100.149%20952.29%20100.149C951.949%20100.149%20951.712%20100.261%20951.577%20100.485C951.442%20100.708%20951.375%20101.015%20951.375%20101.405C951.375%20101.774%20951.456%20102.071%20951.619%20102.294C951.786%20102.518%20952.031%20102.629%20952.354%20102.629ZM952.338%20103.476C951.728%20103.476%20951.245%20103.281%20950.89%20102.89C950.539%20102.496%20950.363%20102.001%20950.363%20101.405C950.363%20100.007%20951.007%2099.3084%20952.295%2099.3084C952.93%2099.3084%20953.417%2099.5018%20953.754%2099.8885C954.094%20100.272%20954.265%20100.77%20954.265%20101.384C954.265%20101.984%20954.091%20102.482%20953.743%20102.88C953.399%20103.277%20952.93%20103.476%20952.338%20103.476Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter1_f_12_1053)'%3e%3cpath%20d='M850.095%20129.856L850.08%20128.459C848.843%20128.444%20847.723%20128.149%20846.719%20127.571L847.199%20126.007C848.16%20126.536%20849.125%20126.815%20850.095%20126.844V123.686C849.513%20123.517%20849.12%20123.39%20848.916%20123.308C847.485%20122.804%20846.77%20121.863%20846.77%20120.485C846.77%20119.588%20847.071%20118.88%20847.672%20118.361C848.274%20117.842%20849.081%20117.548%20850.095%20117.48V116.36H850.808V117.466C851.972%20117.5%20852.988%20117.764%20853.856%20118.259L853.26%20119.699C852.387%20119.307%20851.569%20119.096%20850.808%20119.066V121.926C850.847%20121.94%20850.905%20121.96%20850.982%20121.984C851.06%20122.008%20851.145%20122.035%20851.237%20122.064C851.334%20122.093%20851.4%20122.112%20851.433%20122.122C852.408%20122.442%20853.104%20122.84%20853.522%20123.315C853.944%20123.791%20854.154%20124.453%20854.154%20125.301C854.154%20126.218%20853.856%20126.946%20853.26%20127.484C852.663%20128.022%20851.846%20128.338%20850.808%20128.43V129.856H850.095ZM850.095%20121.686V119.096C849.683%20119.149%20849.37%20119.28%20849.156%20119.488C848.943%20119.697%20848.826%20120%20848.807%20120.398C848.807%20120.99%20849.101%20121.375%20849.687%20121.555C849.755%20121.579%20849.891%20121.623%20850.095%20121.686ZM850.808%20126.8C851.705%20126.655%20852.154%20126.15%20852.154%20125.287C852.154%20124.666%20851.778%20124.23%20851.026%20123.977C851.012%20123.968%20850.973%20123.956%20850.91%20123.941C850.851%20123.922%20850.818%20123.909%20850.808%20123.905V126.8ZM858.927%20128.466C858.234%20128.466%20857.608%20128.357%20857.05%20128.139C856.497%20127.916%20856.049%20127.576%20855.704%20127.12C855.36%20126.66%20855.188%20126.114%20855.188%20125.483C855.188%20124.208%20855.816%20123.291%20857.072%20122.733C855.952%20122.2%20855.391%20121.365%20855.391%20120.231C855.391%20119.784%20855.483%20119.384%20855.668%20119.03C855.852%20118.676%20856.104%20118.387%20856.424%20118.164C856.749%20117.936%20857.123%20117.764%20857.545%20117.648C857.972%20117.531%20858.432%20117.473%20858.927%20117.473C859.955%20117.473%20860.799%20117.713%20861.459%20118.193C862.123%20118.674%20862.456%20119.353%20862.456%20120.231C862.456%20121.351%20861.937%20122.185%20860.899%20122.733C862.068%20123.301%20862.652%20124.22%20862.652%20125.491C862.652%20126.121%20862.48%20126.667%20862.136%20127.128C861.796%20127.584%20861.347%20127.921%20860.79%20128.139C860.237%20128.357%20859.616%20128.466%20858.927%20128.466ZM857.487%20126.698C857.836%20126.994%20858.316%20127.142%20858.927%20127.142C859.538%20127.142%20860.016%20126.994%20860.36%20126.698C860.705%20126.402%20860.877%20125.985%20860.877%20125.447C860.877%20124.913%20860.697%20124.472%20860.339%20124.123C859.98%20123.774%20859.509%20123.524%20858.927%20123.373C858.331%20123.524%20857.853%20123.774%20857.494%20124.123C857.14%20124.472%20856.963%20124.916%20856.963%20125.454C856.963%20125.988%20857.137%20126.402%20857.487%20126.698ZM858.927%20122.239C859.524%20122.103%20859.982%20121.867%20860.302%20121.533C860.622%20121.193%20860.782%20120.762%20860.782%20120.238C860.782%20119.801%20860.608%20119.45%20860.259%20119.183C859.909%20118.916%20859.466%20118.783%20858.927%20118.783C858.394%20118.783%20857.95%20118.916%20857.596%20119.183C857.242%20119.45%20857.065%20119.801%20857.065%20120.238C857.065%20120.762%20857.23%20121.193%20857.559%20121.533C857.889%20121.872%20858.345%20122.108%20858.927%20122.239ZM864.871%20128.313L868.101%20124.108C867.776%20124.22%20867.488%20124.276%20867.236%20124.276C866.193%20124.276%20865.342%20123.963%20864.682%20123.337C864.027%20122.707%20863.7%20121.892%20863.7%20120.893C863.7%20119.855%20864.059%20119.025%20864.777%20118.404C865.499%20117.784%20866.435%20117.473%20867.585%20117.473C868.773%20117.473%20869.736%20117.793%20870.473%20118.433C871.21%20119.069%20871.579%20119.915%20871.579%20120.973C871.579%20121.584%20871.463%20122.139%20871.23%20122.639C870.997%20123.138%20870.655%20123.696%20870.204%20124.312L867.192%20128.313H864.871ZM867.643%20122.937C868.317%20122.937%20868.814%20122.75%20869.135%20122.377C869.459%20122.003%20869.622%20121.499%20869.622%20120.863C869.622%20120.267%20869.455%20119.794%20869.12%20119.445C868.785%20119.096%20868.305%20118.921%20867.679%20118.921C867.034%20118.921%20866.528%20119.103%20866.159%20119.467C865.795%20119.83%20865.613%20120.308%20865.613%20120.9C865.613%20121.53%20865.783%20122.028%20866.123%20122.391C866.467%20122.755%20866.974%20122.937%20867.643%20122.937ZM875.479%20128.466C874.853%20128.466%20874.264%20128.386%20873.711%20128.226C873.163%20128.061%20872.729%20127.841%20872.408%20127.564L872.932%20126.189C873.199%20126.412%20873.568%20126.596%20874.038%20126.742C874.509%20126.883%20874.991%20126.953%20875.486%20126.953C876.044%20126.953%20876.492%20126.803%20876.832%20126.502C877.176%20126.201%20877.348%20125.808%20877.348%20125.323C877.348%20125.023%20877.3%20124.763%20877.203%20124.545C877.111%20124.327%20876.987%20124.152%20876.832%20124.021C876.677%20123.89%20876.468%20123.786%20876.206%20123.708C875.949%20123.626%20875.685%20123.57%20875.413%20123.541C875.142%20123.512%20874.814%20123.495%20874.431%20123.49C874.416%20123.49%20874.346%20123.49%20874.22%20123.49C874.094%20123.485%20874.024%20123.483%20874.009%20123.483V122.013H874.416C874.838%20122.013%20875.2%20121.991%20875.5%20121.948C875.806%20121.904%20876.087%20121.829%20876.344%20121.722C876.606%20121.615%20876.803%20121.458%20876.934%20121.249C877.07%20121.041%20877.137%20120.783%20877.137%20120.478C877.137%20120.066%20876.982%20119.714%20876.672%20119.423C876.361%20119.132%20875.925%20118.986%20875.362%20118.986C874.45%20118.986%20873.638%20119.214%20872.925%20119.67L872.401%20118.288C873.284%20117.745%20874.332%20117.473%20875.544%20117.473C876.558%20117.473%20877.385%20117.74%20878.025%20118.273C878.67%20118.807%20878.993%20119.491%20878.993%20120.325C878.993%20120.907%20878.842%20121.404%20878.542%20121.817C878.246%20122.224%20877.814%20122.522%20877.247%20122.711C877.897%20122.838%20878.399%20123.15%20878.753%20123.65C879.112%20124.15%20879.291%20124.739%20879.291%20125.418C879.291%20126.063%20879.119%20126.621%20878.774%20127.091C878.43%20127.557%20877.974%20127.904%20877.407%20128.132C876.839%20128.355%20876.196%20128.466%20875.479%20128.466ZM881.575%20128.444C881.26%20128.444%20880.993%20128.335%20880.775%20128.117C880.557%20127.899%20880.448%20127.639%20880.448%20127.339C880.448%20127.033%20880.554%20126.769%20880.768%20126.546C880.986%20126.322%20881.255%20126.211%20881.575%20126.211C881.886%20126.211%20882.148%20126.322%20882.361%20126.546C882.575%20126.769%20882.681%20127.033%20882.681%20127.339C882.681%20127.639%20882.575%20127.899%20882.361%20128.117C882.148%20128.335%20881.886%20128.444%20881.575%20128.444ZM883.86%20128.313L883.816%20126.742L887.185%20122.93C887.602%20122.483%20887.905%20122.074%20888.094%20121.7C888.288%20121.322%20888.385%20120.924%20888.385%20120.507C888.385%20120.046%20888.235%20119.68%20887.934%20119.408C887.633%20119.132%20887.238%20118.994%20886.748%20118.994C886.297%20118.994%20885.851%20119.079%20885.41%20119.248C884.973%20119.413%20884.614%20119.622%20884.333%20119.874L883.787%20118.433C884.515%20117.793%20885.538%20117.473%20886.857%20117.473C887.905%20117.473%20888.747%20117.737%20889.382%20118.266C890.022%20118.79%20890.342%20119.532%20890.342%20120.492C890.342%20121.171%20890.16%20121.819%20889.797%20122.435C889.438%20123.051%20888.945%20123.684%20888.32%20124.334L885.919%20126.88H890.219L890.088%20128.313H883.86ZM892.052%20128.313V117.655H894.031V122.457C894.375%20122.001%20895.079%20121.15%20896.141%20119.903C897.208%20118.657%20897.843%20117.907%20898.047%20117.655H900.382L896.352%20122.45L900.637%20128.313H898.323L894.846%20123.534L894.031%20124.217V128.313H892.052Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip21_12_1053)'%3e%3cpath%20d='M800.219%20124.098V125.786C800.311%20125.786%20800.501%20125.788%20800.789%20125.792C801.079%20125.797%20801.303%20125.799%20801.461%20125.799C801.89%20125.799%20802.19%20125.728%20802.358%20125.587C802.527%20125.443%20802.612%20125.215%20802.612%20124.905C802.612%20124.632%20802.531%20124.43%20802.369%20124.297C802.207%20124.164%20801.935%20124.098%20801.555%20124.098H800.219ZM803.418%20128.624H802.743L802.055%20127.058C801.868%20126.637%20801.749%20126.384%20801.697%20126.299C801.533%20126.31%20801.338%20126.316%20801.113%20126.316L800.219%20126.289V128.624H799.621V123.575H801.218C801.402%20123.575%20801.565%20123.579%20801.707%20123.588C801.849%20123.597%20801.989%20123.614%20802.129%20123.639C802.271%20123.662%20802.393%20123.694%20802.497%20123.737C802.6%20123.777%20802.697%20123.831%20802.787%20123.899C802.877%20123.964%20802.949%20124.043%20803.003%20124.135C803.059%20124.227%20803.103%20124.338%20803.135%20124.466C803.166%20124.592%20803.182%20124.735%20803.182%20124.895C803.182%20125.21%20803.099%20125.481%20802.932%20125.708C802.768%20125.935%20802.534%20126.093%20802.23%20126.181C802.23%20126.185%20802.253%20126.226%20802.298%20126.302C802.343%20126.379%20802.396%20126.473%20802.456%20126.586C802.519%20126.696%20802.568%20126.788%20802.602%20126.862L803.418%20128.624ZM804.647%20126.13C804.647%20126.771%20804.794%20127.275%20805.089%20127.642C805.384%20128.007%20805.819%20128.189%20806.395%20128.189C806.971%20128.189%20807.404%20128.007%20807.695%20127.642C807.987%20127.278%20808.134%20126.774%20808.134%20126.13C808.134%20125.473%20807.986%20124.963%20807.691%20124.601C807.399%20124.239%20806.968%20124.058%20806.399%20124.058C805.829%20124.058%20805.395%20124.239%20805.096%20124.601C804.797%20124.963%20804.647%20125.473%20804.647%20126.13ZM808.758%20126.13C808.758%20126.51%20808.705%20126.858%20808.599%20127.173C808.496%20127.488%20808.345%20127.759%20808.147%20127.986C807.951%20128.211%20807.704%20128.387%20807.404%20128.513C807.105%20128.637%20806.769%20128.699%20806.395%20128.699C805.891%20128.699%20805.459%20128.592%20805.099%20128.378C804.741%20128.162%20804.473%20127.863%20804.292%20127.48C804.115%20127.095%20804.026%20126.644%20804.026%20126.127C804.026%20125.328%20804.234%20124.698%20804.65%20124.236C805.067%20123.775%20805.649%20123.545%20806.399%20123.545C807.137%20123.545%20807.714%20123.777%20808.13%20124.243C808.549%20124.707%20808.758%20125.336%20808.758%20126.13ZM809.723%20128.624V123.632H810.311V128.104H812.508L812.488%20128.624H809.723ZM813.173%20128.624V123.632H813.76V128.104H815.957L815.937%20128.624H813.173ZM817.233%20128.624H816.649V123.632H817.233V128.624ZM822.387%20128.624H821.726L819.133%20124.695L818.965%20124.463C818.983%20124.935%20818.992%20125.357%20818.992%20125.728V128.624H818.445V123.632H819.096L821.695%20127.561L821.867%20127.794C821.852%20127.076%20821.844%20126.661%20821.844%20126.548V123.632H822.387V128.624ZM825.739%20128.699C825.359%20128.699%20825.016%20128.636%20824.713%20128.51C824.411%20128.381%20824.161%20128.203%20823.963%20127.976C823.768%20127.747%20823.617%20127.476%20823.511%20127.163C823.408%20126.85%20823.356%20126.507%20823.356%20126.133C823.356%20125.629%20823.452%20125.184%20823.643%20124.797C823.834%20124.41%20824.119%20124.105%20824.497%20123.882C824.875%20123.659%20825.323%20123.548%20825.84%20123.548C826.414%20123.548%20826.918%20123.678%20827.352%20123.939L827.129%20124.422C826.711%20124.181%20826.283%20124.061%20825.847%20124.061C825.543%20124.061%20825.271%20124.114%20825.03%20124.22C824.791%20124.323%20824.596%20124.468%20824.443%20124.655C824.292%20124.839%20824.176%20125.058%20824.095%20125.31C824.016%20125.56%20823.977%20125.834%20823.977%20126.133C823.977%20126.768%20824.134%20127.27%20824.449%20127.639C824.767%20128.005%20825.234%20128.189%20825.85%20128.189C826.201%20128.189%20826.558%20128.118%20826.92%20127.976V126.552H825.742L825.762%20126.042H827.467V128.324C827.183%20128.459%20826.909%20128.556%20826.643%20128.614C826.38%20128.67%20826.079%20128.699%20825.739%20128.699Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M786.642%20131.19H787.257V136.98H786.572V131.906C786.311%20132.076%20785.993%20132.222%20785.616%20132.343V131.697C785.657%20131.679%20785.741%20131.643%20785.867%20131.589C785.994%20131.534%20786.088%20131.493%20786.15%20131.465C786.214%20131.436%20786.294%20131.396%20786.39%20131.345C786.485%20131.293%20786.569%20131.241%20786.642%20131.19ZM788.333%20136.98L788.244%20136.345L790.245%20134.124C790.379%20133.974%20790.508%20133.78%20790.632%20133.543C790.758%20133.306%20790.85%20133.104%20790.907%20132.939L790.996%20132.695C790.996%20132.376%20790.907%20132.128%20790.729%20131.952C790.551%20131.774%20790.298%20131.685%20789.97%20131.685C789.423%20131.685%20788.992%20131.844%20788.677%20132.161L788.453%20131.581C788.809%20131.245%20789.33%20131.078%20790.016%20131.078C790.543%20131.078%20790.962%20131.221%20791.274%20131.507C791.587%20131.791%20791.743%20132.172%20791.743%20132.649C791.732%20132.685%20791.717%20132.734%20791.696%20132.796C791.676%20132.855%20791.63%20132.973%20791.561%20133.148C791.494%20133.324%20791.423%20133.49%20791.348%20133.648C791.273%20133.805%20791.178%20133.978%20791.062%20134.166C790.948%20134.355%20790.832%20134.512%20790.713%20134.638L789.08%20136.384H791.762L791.719%20136.98H788.333ZM797.378%20136.628L795.621%20132.541L795.474%20132.15L795.501%20133.551V136.98H794.874V131.256H795.741L797.734%20135.815L799.708%20131.256H800.552V136.98H799.901V133.535L799.929%20132.165L799.785%20132.556L798.032%20136.628H797.378ZM802.379%20134.12C802.379%20134.855%20802.548%20135.433%20802.886%20135.854C803.224%20136.272%20803.723%20136.481%20804.383%20136.481C805.044%20136.481%20805.541%20136.272%20805.873%20135.854C806.209%20135.436%20806.377%20134.858%20806.377%20134.12C806.377%20133.366%20806.208%20132.782%20805.87%20132.366C805.534%20131.951%20805.04%20131.743%20804.387%20131.743C803.734%20131.743%20803.236%20131.951%20802.893%20132.366C802.55%20132.782%20802.379%20133.366%20802.379%20134.12ZM807.093%20134.12C807.093%20134.556%20807.032%20134.954%20806.911%20135.316C806.792%20135.677%20806.619%20135.988%20806.392%20136.248C806.168%20136.507%20805.884%20136.708%20805.541%20136.852C805.197%20136.994%20804.812%20137.065%20804.383%20137.065C803.805%20137.065%20803.31%20136.943%20802.897%20136.697C802.487%20136.45%20802.179%20136.107%20801.972%20135.668C801.768%20135.227%20801.666%20134.709%20801.666%20134.116C801.666%20133.2%20801.905%20132.477%20802.382%20131.948C802.86%20131.42%20803.528%20131.155%20804.387%20131.155C805.234%20131.155%20805.895%20131.422%20806.373%20131.956C806.853%20132.488%20807.093%20133.209%20807.093%20134.12ZM812.72%20136.98H811.962L808.989%20132.475L808.796%20132.208C808.816%20132.75%20808.827%20133.233%20808.827%20133.659V136.98H808.2V131.256H808.947L811.927%20135.761L812.124%20136.028C812.106%20135.205%20812.097%20134.729%20812.097%20134.6V131.256H812.72V136.98ZM815.855%20136.98H815.182V131.848H813.421V131.256H817.616V131.848H815.855V136.98ZM822.737%20136.98H822.067V134.302H818.994V136.98H818.325V131.256H818.994V133.713H822.067V131.256H822.737V136.98ZM823.975%20136.036C824.571%20136.33%20825.21%20136.477%20825.891%20136.477C826.73%20136.477%20827.149%20136.095%20827.149%20135.331C827.149%20135.083%20827.082%20134.884%20826.948%20134.731C826.816%20134.576%20826.575%20134.455%20826.224%20134.367L825.086%20134.081C824.217%20133.862%20823.782%20133.397%20823.782%20132.688C823.782%20132.143%20823.969%20131.739%20824.343%20131.476C824.717%20131.211%20825.234%20131.078%20825.895%20131.078C826.241%20131.078%20826.565%20131.115%20826.866%20131.19C827.168%20131.265%20827.421%20131.365%20827.625%20131.492L827.432%20132.037C827.259%20131.942%20827.029%20131.857%20826.743%20131.782C826.459%20131.707%20826.171%20131.67%20825.88%20131.67C824.945%20131.67%20824.478%20131.994%20824.478%20132.641C824.478%20132.861%20824.549%20133.037%20824.691%20133.172C824.836%20133.303%20825.051%20133.404%20825.338%20133.473L826.425%20133.737C826.89%20133.848%20827.242%20134.026%20827.482%20134.271C827.722%20134.513%20827.842%20134.859%20827.842%20135.308C827.842%20135.891%20827.663%20136.331%20827.304%20136.628C826.948%20136.922%20826.463%20137.069%20825.849%20137.069C825.389%20137.069%20824.98%20137.023%20824.622%20136.93C824.266%20136.834%20823.983%20136.722%20823.774%20136.593L823.975%20136.036Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip22_12_1053)'%3e%3cpath%20d='M929.218%20129.747C928.76%20129.747%20928.329%20129.688%20927.925%20129.571C927.524%20129.451%20927.206%20129.289%20926.972%20129.087L927.355%20128.081C927.55%20128.244%20927.82%20128.379%20928.164%20128.486C928.508%20128.589%20928.861%20128.64%20929.223%20128.64C929.631%20128.64%20929.96%20128.53%20930.208%20128.31C930.46%20128.09%20930.586%20127.803%20930.586%20127.448C930.586%20127.228%20930.55%20127.038%20930.479%20126.878C930.412%20126.719%20930.322%20126.591%20930.208%20126.495C930.094%20126.399%20929.942%20126.323%20929.75%20126.266C929.562%20126.206%20929.369%20126.165%20929.17%20126.144C928.971%20126.123%20928.732%20126.11%20928.452%20126.107C928.441%20126.107%20928.39%20126.107%20928.297%20126.107C928.205%20126.103%20928.154%20126.101%20928.143%20126.101V125.026H928.441C928.75%20125.026%20929.014%20125.01%20929.234%20124.978C929.458%20124.946%20929.663%20124.891%20929.851%20124.813C930.043%20124.735%20930.187%20124.62%20930.282%20124.467C930.382%20124.315%20930.431%20124.127%20930.431%20123.903C930.431%20123.602%20930.318%20123.344%20930.091%20123.131C929.864%20122.919%20929.544%20122.812%20929.133%20122.812C928.466%20122.812%20927.871%20122.979%20927.35%20123.312L926.967%20122.301C927.612%20121.904%20928.379%20121.705%20929.266%20121.705C930.007%20121.705%20930.612%20121.9%20931.081%20122.291C931.553%20122.681%20931.789%20123.181%20931.789%20123.791C931.789%20124.217%20931.679%20124.581%20931.459%20124.882C931.242%20125.181%20930.926%20125.399%20930.511%20125.537C930.987%20125.629%20931.354%20125.858%20931.613%20126.224C931.876%20126.589%20932.007%20127.02%20932.007%20127.517C932.007%20127.989%20931.881%20128.397%20931.629%20128.741C931.377%20129.082%20931.044%20129.335%20930.628%20129.502C930.213%20129.665%20929.743%20129.747%20929.218%20129.747ZM933.635%20129.635L935.988%20122.94H932.773L932.784%20121.87H937.574V122.706L935.062%20129.635H933.635ZM939.192%20129.731C938.961%20129.731%20938.766%20129.651%20938.606%20129.492C938.447%20129.332%20938.367%20129.142%20938.367%20128.922C938.367%20128.699%20938.445%20128.505%20938.601%20128.342C938.761%20128.179%20938.958%20128.097%20939.192%20128.097C939.419%20128.097%20939.611%20128.179%20939.767%20128.342C939.923%20128.505%20940.001%20128.699%20940.001%20128.922C940.001%20129.142%20939.923%20129.332%20939.767%20129.492C939.611%20129.651%20939.419%20129.731%20939.192%20129.731ZM941.704%20129.635L944.067%20126.559C943.829%20126.641%20943.618%20126.681%20943.434%20126.681C942.671%20126.681%20942.048%20126.453%20941.566%20125.995C941.087%20125.534%20940.847%20124.937%20940.847%20124.207C940.847%20123.447%20941.11%20122.84%20941.635%20122.386C942.164%20121.932%20942.848%20121.705%20943.689%20121.705C944.559%20121.705%20945.263%20121.939%20945.802%20122.408C946.342%20122.872%20946.611%20123.492%20946.611%20124.265C946.611%20124.712%20946.526%20125.118%20946.356%20125.484C946.185%20125.849%20945.935%20126.257%20945.605%20126.708L943.402%20129.635H941.704ZM943.732%20125.702C944.225%20125.702%20944.589%20125.565%20944.823%20125.292C945.061%20125.019%20945.179%20124.65%20945.179%20124.185C945.179%20123.749%20945.057%20123.403%20944.812%20123.147C944.567%20122.892%20944.216%20122.764%20943.758%20122.764C943.287%20122.764%20942.916%20122.897%20942.646%20123.163C942.38%20123.429%20942.247%20123.779%20942.247%20124.212C942.247%20124.673%20942.371%20125.037%20942.619%20125.303C942.871%20125.569%20943.242%20125.702%20943.732%20125.702ZM949.049%20125.186C949.357%20125.186%20949.59%20125.071%20949.746%20124.84C949.906%20124.609%20949.985%20124.311%20949.985%20123.946C949.985%20123.573%20949.906%20123.272%20949.746%20123.041C949.59%20122.81%20949.359%20122.695%20949.054%20122.695C948.749%20122.695%20948.518%20122.812%20948.362%20123.046C948.206%20123.28%20948.128%20123.584%20948.128%20123.956C948.128%20124.329%20948.204%20124.627%20948.357%20124.851C948.513%20125.074%20948.744%20125.186%20949.049%20125.186ZM949.033%20126.032C948.454%20126.032%20947.999%20125.837%20947.665%20125.447C947.335%20125.056%20947.17%20124.56%20947.17%20123.956C947.17%20123.353%20947.34%20122.853%20947.681%20122.456C948.025%20122.058%20948.485%20121.859%20949.059%20121.859C949.659%20121.859%20950.131%20122.055%20950.475%20122.445C950.819%20122.835%20950.991%20123.334%20950.991%20123.94C950.991%20124.54%20950.812%20125.039%20950.454%20125.436C950.095%20125.833%20949.622%20126.032%20949.033%20126.032ZM948.517%20129.806L953.312%20121.918L954.483%20121.923L949.65%20129.806H948.517ZM954.238%20128.879C954.557%20128.879%20954.797%20128.764%20954.956%20128.534C955.12%20128.299%20955.201%20127.998%20955.201%20127.629C955.201%20127.26%20955.114%20126.963%20954.941%20126.74C954.77%20126.513%20954.515%20126.399%20954.174%20126.399C953.833%20126.399%20953.596%20126.511%20953.461%20126.735C953.326%20126.958%20953.259%20127.265%20953.259%20127.655C953.259%20128.024%20953.34%20128.321%20953.504%20128.544C953.67%20128.768%20953.915%20128.879%20954.238%20128.879ZM954.222%20129.726C953.612%20129.726%20953.129%20129.531%20952.774%20129.14C952.423%20128.746%20952.247%20128.251%20952.247%20127.655C952.247%20126.257%20952.891%20125.558%20954.179%20125.558C954.815%20125.558%20955.301%20125.752%20955.638%20126.139C955.978%20126.522%20956.149%20127.02%20956.149%20127.634C956.149%20128.234%20955.975%20128.732%20955.627%20129.13C955.283%20129.527%20954.815%20129.726%20954.222%20129.726Z'%20fill='%230BA168'%20/%3e%3c/g%3e%3cmask%20id='mask6_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='23'%20y='153'%20width='641'%20height='200'%3e%3cg%20clip-path='url(%23clip23_12_1053)'%3e%3cpath%20d='M23.2002%20153.7H660C661%20153.7%20661.9%20154.1%20662.7%20154.8C663.4%20155.6%20663.7%20156.5%20663.7%20157.5V348.7C663.7%20349.8%20663.4%20350.7%20662.7%20351.4C661.9%20352.1%20661%20352.5%20660%20352.5H27.0002C26.0002%20352.5%2025.1002%20352.1%2024.3002%20351.4C23.6002%20350.7%2023.2002%20349.8%2023.2002%20348.7V157.5C23.2002%20156.5%2023.6002%20155.6%2024.3002%20154.8C25.1002%20154.1%2026.0002%20153.7%2027.0002%20153.7'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask6_12_1053)'%3e%3cpath%20d='M23.25%20153.75H660C660.497%20153.75%20660.976%20153.845%20661.435%20154.035C661.894%20154.226%20662.3%20154.497%20662.652%20154.848C663.003%20155.2%20663.274%20155.606%20663.464%20156.065C663.655%20156.524%20663.75%20157.003%20663.75%20157.5V348.75C663.75%20349.247%20663.655%20349.726%20663.464%20350.185C663.274%20350.644%20663.003%20351.05%20662.652%20351.402C662.3%20351.753%20661.894%20352.024%20661.435%20352.214C660.976%20352.405%20660.497%20352.5%20660%20352.5H27C26.5027%20352.5%2026.0244%20352.405%2025.5649%20352.214C25.1055%20352.024%2024.7%20351.753%2024.3483%20351.402C23.9967%20351.05%2023.7258%20350.644%2023.5355%20350.185C23.3452%20349.726%2023.25%20349.247%2023.25%20348.75V157.5C23.25%20157.003%2023.3452%20156.524%2023.5355%20156.065C23.7258%20155.606%2023.9967%20155.2%2024.3483%20154.848C24.7%20154.497%2025.1055%20154.226%2025.5649%20154.035C26.0244%20153.845%2026.5027%20153.75%2027%20153.75'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip24_12_1053)'%3e%3cpath%20d='M43.9262%20170.419L41.2195%20162.98H42.6363L44.2105%20167.576C44.2715%20167.735%2044.412%20168.2%2044.632%20168.972C44.6456%20168.918%2044.7082%20168.696%2044.8199%20168.307C44.9316%20167.914%2045.0044%20167.674%2045.0383%20167.586C45.0789%20167.471%2045.3362%20166.707%2045.8102%20165.296C46.2841%20163.881%2046.5431%20163.109%2046.5871%20162.98H47.9887L45.3176%20170.419H43.9262ZM48.8012%20170.419V162.98H50.1773V170.419H48.8012ZM53.9098%20170.521C53.0126%20170.521%2052.2086%20170.314%2051.4977%20169.901L51.8328%20168.81C52.151%20168.986%2052.4964%20169.128%2052.8687%20169.236C53.2445%20169.345%2053.6102%20169.399%2053.9656%20169.399C54.4023%20169.399%2054.7324%20169.306%2054.9559%20169.119C55.1793%20168.93%2055.291%20168.659%2055.291%20168.307C55.291%20167.84%2054.9796%20167.516%2054.3566%20167.337C54.3126%20167.323%2054.1891%20167.288%2053.9859%20167.23C53.7828%20167.169%2053.5915%20167.112%2053.4121%20167.058C53.2361%20167%2053.1091%20166.956%2053.0312%20166.926C52.0326%20166.574%2051.5332%20165.917%2051.5332%20164.955C51.5332%20164.282%2051.7719%20163.762%2052.2492%20163.396C52.7299%20163.031%2053.3664%20162.848%2054.1586%20162.848C55.0557%20162.848%2055.8293%20163.032%2056.4793%20163.401L56.0629%20164.407C55.3993%20164.109%2054.7832%20163.96%2054.2145%20163.96C53.8048%20163.96%2053.4951%20164.033%2053.2852%20164.178C53.0786%20164.321%2052.9686%20164.559%2052.9551%20164.894C52.9551%20165.307%2053.1599%20165.577%2053.5695%20165.702C53.6508%20165.732%2053.8505%20165.798%2054.1687%20165.9C54.487%20166.001%2054.6935%20166.067%2054.7883%20166.098C55.4687%20166.321%2055.9546%20166.599%2056.2457%20166.931C56.5402%20167.263%2056.6875%20167.725%2056.6875%20168.317C56.6875%20169.025%2056.437%20169.57%2055.9359%20169.952C55.4349%20170.331%2054.7595%20170.521%2053.9098%20170.521ZM57.9012%20170.419V162.98H59.2773V170.419H57.9012ZM62.3598%20170.419V164.082H60.1914V162.98H65.8992V164.082H63.741V170.419H62.3598ZM65.823%20170.419L68.5602%20162.975H70.0582L72.7547%20170.419H71.343L70.6066%20168.317H68.0016L67.2602%20170.419H65.823ZM68.3469%20167.291H70.2562C69.6469%20165.338%2069.3337%20164.329%2069.3168%20164.265L68.3469%20167.291ZM74.527%20170.419V164.082H72.3586V162.98H78.0664V164.082H75.9082V170.419H74.527ZM78.9754%20170.419V162.98H80.3516V170.419H78.9754ZM83.693%20168.698C84.062%20169.169%2084.607%20169.404%2085.3281%20169.404C86.0492%20169.404%2086.5926%20169.17%2086.9582%20168.703C87.3272%20168.232%2087.5117%20167.569%2087.5117%20166.712C87.5117%20165.846%2087.3272%20165.174%2086.9582%20164.696C86.5926%20164.219%2086.0509%20163.98%2085.3332%20163.98C84.6121%20163.98%2084.0654%20164.221%2083.693%20164.701C83.324%20165.179%2083.1395%20165.849%2083.1395%20166.712C83.1395%20167.566%2083.324%20168.227%2083.693%20168.698ZM85.323%20170.526C84.2025%20170.526%2083.3172%20170.188%2082.6672%20169.51C82.0206%20168.83%2081.6973%20167.892%2081.6973%20166.697C81.6973%20165.495%2082.0223%20164.558%2082.6723%20163.884C83.3223%20163.21%2084.2076%20162.873%2085.3281%20162.873C86.4487%20162.873%2087.3323%20163.212%2087.9789%20163.889C88.6255%20164.563%2088.9488%20165.5%2088.9488%20166.702C88.9488%20167.891%2088.6238%20168.825%2087.9738%20169.505C87.3238%20170.186%2086.4402%20170.526%2085.323%20170.526ZM90.2539%20170.419V162.98H91.7164C91.9805%20163.393%2092.5171%20164.226%2093.3262%20165.478C94.1353%20166.731%2094.6279%20167.493%2094.8039%20167.764C94.8547%20167.841%2094.941%20167.973%2095.0629%20168.16C95.1881%20168.342%2095.2762%20168.473%2095.327%20168.551C95.3033%20167.389%2095.2914%20166.787%2095.2914%20166.743V162.98H96.5457V170.419H95.0629L91.7062%20165.189L91.4625%20164.788C91.4896%20165.682%2091.5031%20166.31%2091.5031%20166.672V170.419H90.2539ZM102.335%20170.419V164.082H100.166V162.98H105.874V164.082H103.716V170.419H102.335ZM106.641%20170.419V162.96H109.398C109.774%20162.96%20110.099%20162.977%20110.373%20163.01C110.651%20163.044%20110.913%20163.107%20111.161%20163.198C111.411%20163.286%20111.612%20163.407%20111.765%20163.559C111.921%20163.711%20112.042%20163.911%20112.13%20164.158C112.222%20164.402%20112.268%20164.691%20112.268%20165.026C112.268%20166.015%20111.819%20166.665%20110.922%20166.976C111.105%20167.183%20111.332%20167.566%20111.602%20168.124L112.709%20170.419H111.206L110.338%20168.475C110.01%20167.777%20109.806%20167.364%20109.729%20167.235C109.671%20167.232%20109.48%20167.23%20109.155%20167.23L108.002%20167.22V170.419H106.641ZM109.52%20166.235C110.048%20166.235%20110.428%20166.142%20110.658%20165.956C110.888%20165.766%20111.003%20165.463%20111.003%20165.047C111.003%20164.681%20110.886%20164.412%20110.653%20164.239C110.419%20164.067%20110.062%20163.98%20109.581%20163.98H108.002V166.23C108.053%20166.23%20108.305%20166.232%20108.759%20166.235C109.212%20166.235%20109.466%20166.235%20109.52%20166.235ZM113.695%20170.419V162.98H118.204L118.148%20164.072H115.071V165.991H117.996V167.083H115.071V169.323H118.26L118.214%20170.419H113.695ZM119.545%20170.419V162.98H121.007C121.271%20163.393%20121.808%20164.226%20122.617%20165.478C123.426%20166.731%20123.918%20167.493%20124.095%20167.764C124.145%20167.841%20124.232%20167.973%20124.354%20168.16C124.479%20168.342%20124.567%20168.473%20124.618%20168.551C124.594%20167.389%20124.582%20166.787%20124.582%20166.743V162.98H125.836V170.419H124.354L120.997%20165.189L120.753%20164.788C120.78%20165.682%20120.794%20166.31%20120.794%20166.672V170.419H119.545ZM128.817%20169.317H129.802C130.652%20169.317%20131.299%20169.096%20131.742%20168.652C132.186%20168.205%20132.407%20167.555%20132.407%20166.702C132.407%20165.788%20132.179%20165.125%20131.722%20164.712C131.265%20164.295%20130.576%20164.087%20129.655%20164.087H128.817V169.317ZM127.441%20170.419V162.98H129.594C130.244%20162.98%20130.826%20163.054%20131.341%20163.203C131.856%20163.352%20132.297%20163.578%20132.666%20163.879C133.039%20164.177%20133.323%20164.563%20133.52%20165.037C133.719%20165.507%20133.819%20166.052%20133.819%20166.672C133.819%20167.874%20133.457%20168.8%20132.732%20169.45C132.008%20170.096%20131.004%20170.419%20129.721%20170.419H127.441Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip25_12_1053)'%3e%3cpath%20d='M61.875%20322.075C61.875%20322.179%2061.8384%20322.267%2061.7652%20322.34C61.6919%20322.413%2061.6036%20322.45%2061.5%20322.45C61.3964%20322.45%2061.3081%20322.413%2061.2348%20322.34C61.1616%20322.267%2061.125%20322.179%2061.125%20322.075C61.125%20321.971%2061.1616%20321.883%2061.2348%20321.81C61.3081%20321.737%2061.3964%20321.7%2061.5%20321.7C61.6036%20321.7%2061.6919%20321.737%2061.7652%20321.81C61.8384%20321.883%2061.875%20321.971%2061.875%20322.075ZM65.625%20322.075C65.625%20322.179%2065.5884%20322.267%2065.5152%20322.34C65.4419%20322.413%2065.3536%20322.45%2065.25%20322.45C65.1464%20322.45%2065.0581%20322.413%2064.9848%20322.34C64.9116%20322.267%2064.875%20322.179%2064.875%20322.075C64.875%20321.971%2064.9116%20321.883%2064.9848%20321.81C65.0581%20321.737%2065.1464%20321.7%2065.25%20321.7C65.3536%20321.7%2065.4419%20321.737%2065.5152%20321.81C65.5884%20321.883%2065.625%20321.971%2065.625%20322.075ZM69.375%20322.075C69.375%20322.179%2069.3384%20322.267%2069.2652%20322.34C69.1919%20322.413%2069.1036%20322.45%2069%20322.45C68.8964%20322.45%2068.8081%20322.413%2068.7348%20322.34C68.6616%20322.267%2068.625%20322.179%2068.625%20322.075C68.625%20321.971%2068.6616%20321.883%2068.7348%20321.81C68.8081%20321.737%2068.8964%20321.7%2069%20321.7C69.1036%20321.7%2069.1919%20321.737%2069.2652%20321.81C69.3384%20321.883%2069.375%20321.971%2069.375%20322.075ZM73.125%20322.075C73.125%20322.179%2073.0884%20322.267%2073.0152%20322.34C72.9419%20322.413%2072.8536%20322.45%2072.75%20322.45C72.6464%20322.45%2072.5581%20322.413%2072.4848%20322.34C72.4116%20322.267%2072.375%20322.179%2072.375%20322.075C72.375%20321.971%2072.4116%20321.883%2072.4848%20321.81C72.5581%20321.737%2072.6464%20321.7%2072.75%20321.7C72.8536%20321.7%2072.9419%20321.737%2073.0152%20321.81C73.0884%20321.883%2073.125%20321.971%2073.125%20322.075ZM76.875%20322.075C76.875%20322.179%2076.8384%20322.267%2076.7652%20322.34C76.6919%20322.413%2076.6036%20322.45%2076.5%20322.45C76.3964%20322.45%2076.3081%20322.413%2076.2348%20322.34C76.1616%20322.267%2076.125%20322.179%2076.125%20322.075C76.125%20321.971%2076.1616%20321.883%2076.2348%20321.81C76.3081%20321.737%2076.3964%20321.7%2076.5%20321.7C76.6036%20321.7%2076.6919%20321.737%2076.7652%20321.81C76.8384%20321.883%2076.875%20321.971%2076.875%20322.075ZM80.625%20322.075C80.625%20322.179%2080.5884%20322.267%2080.5152%20322.34C80.4419%20322.413%2080.3536%20322.45%2080.25%20322.45C80.1464%20322.45%2080.0581%20322.413%2079.9848%20322.34C79.9116%20322.267%2079.875%20322.179%2079.875%20322.075C79.875%20321.971%2079.9116%20321.883%2079.9848%20321.81C80.0581%20321.737%2080.1464%20321.7%2080.25%20321.7C80.3536%20321.7%2080.4419%20321.737%2080.5152%20321.81C80.5884%20321.883%2080.625%20321.971%2080.625%20322.075ZM84.375%20322.075C84.375%20322.179%2084.3384%20322.267%2084.2652%20322.34C84.1919%20322.413%2084.1036%20322.45%2084%20322.45C83.8964%20322.45%2083.8081%20322.413%2083.7348%20322.34C83.6616%20322.267%2083.625%20322.179%2083.625%20322.075C83.625%20321.971%2083.6616%20321.883%2083.7348%20321.81C83.8081%20321.737%2083.8964%20321.7%2084%20321.7C84.1036%20321.7%2084.1919%20321.737%2084.2652%20321.81C84.3384%20321.883%2084.375%20321.971%2084.375%20322.075ZM88.125%20322.075C88.125%20322.179%2088.0884%20322.267%2088.0152%20322.34C87.9419%20322.413%2087.8536%20322.45%2087.75%20322.45C87.6464%20322.45%2087.5581%20322.413%2087.4848%20322.34C87.4116%20322.267%2087.375%20322.179%2087.375%20322.075C87.375%20321.971%2087.4116%20321.883%2087.4848%20321.81C87.5581%20321.737%2087.6464%20321.7%2087.75%20321.7C87.8536%20321.7%2087.9419%20321.737%2088.0152%20321.81C88.0884%20321.883%2088.125%20321.971%2088.125%20322.075ZM91.875%20322.075C91.875%20322.179%2091.8384%20322.267%2091.7652%20322.34C91.6919%20322.413%2091.6036%20322.45%2091.5%20322.45C91.3964%20322.45%2091.3081%20322.413%2091.2348%20322.34C91.1616%20322.267%2091.125%20322.179%2091.125%20322.075C91.125%20321.971%2091.1616%20321.883%2091.2348%20321.81C91.3081%20321.737%2091.3964%20321.7%2091.5%20321.7C91.6036%20321.7%2091.6919%20321.737%2091.7652%20321.81C91.8384%20321.883%2091.875%20321.971%2091.875%20322.075ZM95.625%20322.075C95.625%20322.179%2095.5884%20322.267%2095.5152%20322.34C95.4419%20322.413%2095.3535%20322.45%2095.25%20322.45C95.1464%20322.45%2095.0581%20322.413%2094.9848%20322.34C94.9116%20322.267%2094.875%20322.179%2094.875%20322.075C94.875%20321.971%2094.9116%20321.883%2094.9848%20321.81C95.0581%20321.737%2095.1464%20321.7%2095.25%20321.7C95.3535%20321.7%2095.4419%20321.737%2095.5152%20321.81C95.5884%20321.883%2095.625%20321.971%2095.625%20322.075ZM99.375%20322.075C99.375%20322.179%2099.3384%20322.267%2099.2652%20322.34C99.1919%20322.413%2099.1035%20322.45%2099%20322.45C98.8964%20322.45%2098.8081%20322.413%2098.7348%20322.34C98.6616%20322.267%2098.625%20322.179%2098.625%20322.075C98.625%20321.971%2098.6616%20321.883%2098.7348%20321.81C98.8081%20321.737%2098.8964%20321.7%2099%20321.7C99.1035%20321.7%2099.1919%20321.737%2099.2652%20321.81C99.3384%20321.883%2099.375%20321.971%2099.375%20322.075ZM103.125%20322.075C103.125%20322.179%20103.088%20322.267%20103.015%20322.34C102.942%20322.413%20102.854%20322.45%20102.75%20322.45C102.646%20322.45%20102.558%20322.413%20102.485%20322.34C102.412%20322.267%20102.375%20322.179%20102.375%20322.075C102.375%20321.971%20102.412%20321.883%20102.485%20321.81C102.558%20321.737%20102.646%20321.7%20102.75%20321.7C102.854%20321.7%20102.942%20321.737%20103.015%20321.81C103.088%20321.883%20103.125%20321.971%20103.125%20322.075ZM106.875%20322.075C106.875%20322.179%20106.838%20322.267%20106.765%20322.34C106.692%20322.413%20106.604%20322.45%20106.5%20322.45C106.396%20322.45%20106.308%20322.413%20106.235%20322.34C106.162%20322.267%20106.125%20322.179%20106.125%20322.075C106.125%20321.971%20106.162%20321.883%20106.235%20321.81C106.308%20321.737%20106.396%20321.7%20106.5%20321.7C106.604%20321.7%20106.692%20321.737%20106.765%20321.81C106.838%20321.883%20106.875%20321.971%20106.875%20322.075ZM110.625%20322.075C110.625%20322.179%20110.588%20322.267%20110.515%20322.34C110.442%20322.413%20110.354%20322.45%20110.25%20322.45C110.146%20322.45%20110.058%20322.413%20109.985%20322.34C109.912%20322.267%20109.875%20322.179%20109.875%20322.075C109.875%20321.971%20109.912%20321.883%20109.985%20321.81C110.058%20321.737%20110.146%20321.7%20110.25%20321.7C110.354%20321.7%20110.442%20321.737%20110.515%20321.81C110.588%20321.883%20110.625%20321.971%20110.625%20322.075ZM114.375%20322.075C114.375%20322.179%20114.338%20322.267%20114.265%20322.34C114.192%20322.413%20114.104%20322.45%20114%20322.45C113.896%20322.45%20113.808%20322.413%20113.735%20322.34C113.662%20322.267%20113.625%20322.179%20113.625%20322.075C113.625%20321.971%20113.662%20321.883%20113.735%20321.81C113.808%20321.737%20113.896%20321.7%20114%20321.7C114.104%20321.7%20114.192%20321.737%20114.265%20321.81C114.338%20321.883%20114.375%20321.971%20114.375%20322.075ZM118.125%20322.075C118.125%20322.179%20118.088%20322.267%20118.015%20322.34C117.942%20322.413%20117.854%20322.45%20117.75%20322.45C117.646%20322.45%20117.558%20322.413%20117.485%20322.34C117.412%20322.267%20117.375%20322.179%20117.375%20322.075C117.375%20321.971%20117.412%20321.883%20117.485%20321.81C117.558%20321.737%20117.646%20321.7%20117.75%20321.7C117.854%20321.7%20117.942%20321.737%20118.015%20321.81C118.088%20321.883%20118.125%20321.971%20118.125%20322.075ZM121.875%20322.075C121.875%20322.179%20121.838%20322.267%20121.765%20322.34C121.692%20322.413%20121.604%20322.45%20121.5%20322.45C121.396%20322.45%20121.308%20322.413%20121.235%20322.34C121.162%20322.267%20121.125%20322.179%20121.125%20322.075C121.125%20321.971%20121.162%20321.883%20121.235%20321.81C121.308%20321.737%20121.396%20321.7%20121.5%20321.7C121.604%20321.7%20121.692%20321.737%20121.765%20321.81C121.838%20321.883%20121.875%20321.971%20121.875%20322.075ZM125.625%20322.075C125.625%20322.179%20125.588%20322.267%20125.515%20322.34C125.442%20322.413%20125.354%20322.45%20125.25%20322.45C125.146%20322.45%20125.058%20322.413%20124.985%20322.34C124.912%20322.267%20124.875%20322.179%20124.875%20322.075C124.875%20321.971%20124.912%20321.883%20124.985%20321.81C125.058%20321.737%20125.146%20321.7%20125.25%20321.7C125.354%20321.7%20125.442%20321.737%20125.515%20321.81C125.588%20321.883%20125.625%20321.971%20125.625%20322.075ZM129.375%20322.075C129.375%20322.179%20129.338%20322.267%20129.265%20322.34C129.192%20322.413%20129.104%20322.45%20129%20322.45C128.896%20322.45%20128.808%20322.413%20128.735%20322.34C128.662%20322.267%20128.625%20322.179%20128.625%20322.075C128.625%20321.971%20128.662%20321.883%20128.735%20321.81C128.808%20321.737%20128.896%20321.7%20129%20321.7C129.104%20321.7%20129.192%20321.737%20129.265%20321.81C129.338%20321.883%20129.375%20321.971%20129.375%20322.075ZM133.125%20322.075C133.125%20322.179%20133.088%20322.267%20133.015%20322.34C132.942%20322.413%20132.854%20322.45%20132.75%20322.45C132.646%20322.45%20132.558%20322.413%20132.485%20322.34C132.412%20322.267%20132.375%20322.179%20132.375%20322.075C132.375%20321.971%20132.412%20321.883%20132.485%20321.81C132.558%20321.737%20132.646%20321.7%20132.75%20321.7C132.854%20321.7%20132.942%20321.737%20133.015%20321.81C133.088%20321.883%20133.125%20321.971%20133.125%20322.075ZM136.875%20322.075C136.875%20322.179%20136.838%20322.267%20136.765%20322.34C136.692%20322.413%20136.604%20322.45%20136.5%20322.45C136.396%20322.45%20136.308%20322.413%20136.235%20322.34C136.162%20322.267%20136.125%20322.179%20136.125%20322.075C136.125%20321.971%20136.162%20321.883%20136.235%20321.81C136.308%20321.737%20136.396%20321.7%20136.5%20321.7C136.604%20321.7%20136.692%20321.737%20136.765%20321.81C136.838%20321.883%20136.875%20321.971%20136.875%20322.075ZM140.625%20322.075C140.625%20322.179%20140.588%20322.267%20140.515%20322.34C140.442%20322.413%20140.354%20322.45%20140.25%20322.45C140.146%20322.45%20140.058%20322.413%20139.985%20322.34C139.912%20322.267%20139.875%20322.179%20139.875%20322.075C139.875%20321.971%20139.912%20321.883%20139.985%20321.81C140.058%20321.737%20140.146%20321.7%20140.25%20321.7C140.354%20321.7%20140.442%20321.737%20140.515%20321.81C140.588%20321.883%20140.625%20321.971%20140.625%20322.075ZM144.375%20322.075C144.375%20322.179%20144.338%20322.267%20144.265%20322.34C144.192%20322.413%20144.104%20322.45%20144%20322.45C143.896%20322.45%20143.808%20322.413%20143.735%20322.34C143.662%20322.267%20143.625%20322.179%20143.625%20322.075C143.625%20321.971%20143.662%20321.883%20143.735%20321.81C143.808%20321.737%20143.896%20321.7%20144%20321.7C144.104%20321.7%20144.192%20321.737%20144.265%20321.81C144.338%20321.883%20144.375%20321.971%20144.375%20322.075ZM148.125%20322.075C148.125%20322.179%20148.088%20322.267%20148.015%20322.34C147.942%20322.413%20147.854%20322.45%20147.75%20322.45C147.646%20322.45%20147.558%20322.413%20147.485%20322.34C147.412%20322.267%20147.375%20322.179%20147.375%20322.075C147.375%20321.971%20147.412%20321.883%20147.485%20321.81C147.558%20321.737%20147.646%20321.7%20147.75%20321.7C147.854%20321.7%20147.942%20321.737%20148.015%20321.81C148.088%20321.883%20148.125%20321.971%20148.125%20322.075ZM151.875%20322.075C151.875%20322.179%20151.838%20322.267%20151.765%20322.34C151.692%20322.413%20151.604%20322.45%20151.5%20322.45C151.396%20322.45%20151.308%20322.413%20151.235%20322.34C151.162%20322.267%20151.125%20322.179%20151.125%20322.075C151.125%20321.971%20151.162%20321.883%20151.235%20321.81C151.308%20321.737%20151.396%20321.7%20151.5%20321.7C151.604%20321.7%20151.692%20321.737%20151.765%20321.81C151.838%20321.883%20151.875%20321.971%20151.875%20322.075ZM155.625%20322.075C155.625%20322.179%20155.588%20322.267%20155.515%20322.34C155.442%20322.413%20155.354%20322.45%20155.25%20322.45C155.146%20322.45%20155.058%20322.413%20154.985%20322.34C154.912%20322.267%20154.875%20322.179%20154.875%20322.075C154.875%20321.971%20154.912%20321.883%20154.985%20321.81C155.058%20321.737%20155.146%20321.7%20155.25%20321.7C155.354%20321.7%20155.442%20321.737%20155.515%20321.81C155.588%20321.883%20155.625%20321.971%20155.625%20322.075ZM159.375%20322.075C159.375%20322.179%20159.338%20322.267%20159.265%20322.34C159.192%20322.413%20159.104%20322.45%20159%20322.45C158.896%20322.45%20158.808%20322.413%20158.735%20322.34C158.662%20322.267%20158.625%20322.179%20158.625%20322.075C158.625%20321.971%20158.662%20321.883%20158.735%20321.81C158.808%20321.737%20158.896%20321.7%20159%20321.7C159.104%20321.7%20159.192%20321.737%20159.265%20321.81C159.338%20321.883%20159.375%20321.971%20159.375%20322.075ZM163.125%20322.075C163.125%20322.179%20163.088%20322.267%20163.015%20322.34C162.942%20322.413%20162.854%20322.45%20162.75%20322.45C162.646%20322.45%20162.558%20322.413%20162.485%20322.34C162.412%20322.267%20162.375%20322.179%20162.375%20322.075C162.375%20321.971%20162.412%20321.883%20162.485%20321.81C162.558%20321.737%20162.646%20321.7%20162.75%20321.7C162.854%20321.7%20162.942%20321.737%20163.015%20321.81C163.088%20321.883%20163.125%20321.971%20163.125%20322.075ZM166.875%20322.075C166.875%20322.179%20166.838%20322.267%20166.765%20322.34C166.692%20322.413%20166.604%20322.45%20166.5%20322.45C166.396%20322.45%20166.308%20322.413%20166.235%20322.34C166.162%20322.267%20166.125%20322.179%20166.125%20322.075C166.125%20321.971%20166.162%20321.883%20166.235%20321.81C166.308%20321.737%20166.396%20321.7%20166.5%20321.7C166.604%20321.7%20166.692%20321.737%20166.765%20321.81C166.838%20321.883%20166.875%20321.971%20166.875%20322.075ZM170.625%20322.075C170.625%20322.179%20170.588%20322.267%20170.515%20322.34C170.442%20322.413%20170.354%20322.45%20170.25%20322.45C170.146%20322.45%20170.058%20322.413%20169.985%20322.34C169.912%20322.267%20169.875%20322.179%20169.875%20322.075C169.875%20321.971%20169.912%20321.883%20169.985%20321.81C170.058%20321.737%20170.146%20321.7%20170.25%20321.7C170.354%20321.7%20170.442%20321.737%20170.515%20321.81C170.588%20321.883%20170.625%20321.971%20170.625%20322.075ZM174.375%20322.075C174.375%20322.179%20174.338%20322.267%20174.265%20322.34C174.192%20322.413%20174.104%20322.45%20174%20322.45C173.896%20322.45%20173.808%20322.413%20173.735%20322.34C173.662%20322.267%20173.625%20322.179%20173.625%20322.075C173.625%20321.971%20173.662%20321.883%20173.735%20321.81C173.808%20321.737%20173.896%20321.7%20174%20321.7C174.104%20321.7%20174.192%20321.737%20174.265%20321.81C174.338%20321.883%20174.375%20321.971%20174.375%20322.075ZM178.125%20322.075C178.125%20322.179%20178.088%20322.267%20178.015%20322.34C177.942%20322.413%20177.854%20322.45%20177.75%20322.45C177.646%20322.45%20177.558%20322.413%20177.485%20322.34C177.412%20322.267%20177.375%20322.179%20177.375%20322.075C177.375%20321.971%20177.412%20321.883%20177.485%20321.81C177.558%20321.737%20177.646%20321.7%20177.75%20321.7C177.854%20321.7%20177.942%20321.737%20178.015%20321.81C178.088%20321.883%20178.125%20321.971%20178.125%20322.075ZM181.875%20322.075C181.875%20322.179%20181.838%20322.267%20181.765%20322.34C181.692%20322.413%20181.604%20322.45%20181.5%20322.45C181.396%20322.45%20181.308%20322.413%20181.235%20322.34C181.162%20322.267%20181.125%20322.179%20181.125%20322.075C181.125%20321.971%20181.162%20321.883%20181.235%20321.81C181.308%20321.737%20181.396%20321.7%20181.5%20321.7C181.604%20321.7%20181.692%20321.737%20181.765%20321.81C181.838%20321.883%20181.875%20321.971%20181.875%20322.075ZM185.625%20322.075C185.625%20322.179%20185.588%20322.267%20185.515%20322.34C185.442%20322.413%20185.354%20322.45%20185.25%20322.45C185.146%20322.45%20185.058%20322.413%20184.985%20322.34C184.912%20322.267%20184.875%20322.179%20184.875%20322.075C184.875%20321.971%20184.912%20321.883%20184.985%20321.81C185.058%20321.737%20185.146%20321.7%20185.25%20321.7C185.354%20321.7%20185.442%20321.737%20185.515%20321.81C185.588%20321.883%20185.625%20321.971%20185.625%20322.075ZM189.375%20322.075C189.375%20322.179%20189.338%20322.267%20189.265%20322.34C189.192%20322.413%20189.104%20322.45%20189%20322.45C188.896%20322.45%20188.808%20322.413%20188.735%20322.34C188.662%20322.267%20188.625%20322.179%20188.625%20322.075C188.625%20321.971%20188.662%20321.883%20188.735%20321.81C188.808%20321.737%20188.896%20321.7%20189%20321.7C189.104%20321.7%20189.192%20321.737%20189.265%20321.81C189.338%20321.883%20189.375%20321.971%20189.375%20322.075ZM193.125%20322.075C193.125%20322.179%20193.088%20322.267%20193.015%20322.34C192.942%20322.413%20192.854%20322.45%20192.75%20322.45C192.646%20322.45%20192.558%20322.413%20192.485%20322.34C192.412%20322.267%20192.375%20322.179%20192.375%20322.075C192.375%20321.971%20192.412%20321.883%20192.485%20321.81C192.558%20321.737%20192.646%20321.7%20192.75%20321.7C192.854%20321.7%20192.942%20321.737%20193.015%20321.81C193.088%20321.883%20193.125%20321.971%20193.125%20322.075ZM196.875%20322.075C196.875%20322.179%20196.838%20322.267%20196.765%20322.34C196.692%20322.413%20196.604%20322.45%20196.5%20322.45C196.396%20322.45%20196.308%20322.413%20196.235%20322.34C196.162%20322.267%20196.125%20322.179%20196.125%20322.075C196.125%20321.971%20196.162%20321.883%20196.235%20321.81C196.308%20321.737%20196.396%20321.7%20196.5%20321.7C196.604%20321.7%20196.692%20321.737%20196.765%20321.81C196.838%20321.883%20196.875%20321.971%20196.875%20322.075ZM200.625%20322.075C200.625%20322.179%20200.588%20322.267%20200.515%20322.34C200.442%20322.413%20200.354%20322.45%20200.25%20322.45C200.146%20322.45%20200.058%20322.413%20199.985%20322.34C199.912%20322.267%20199.875%20322.179%20199.875%20322.075C199.875%20321.971%20199.912%20321.883%20199.985%20321.81C200.058%20321.737%20200.146%20321.7%20200.25%20321.7C200.354%20321.7%20200.442%20321.737%20200.515%20321.81C200.588%20321.883%20200.625%20321.971%20200.625%20322.075ZM204.375%20322.075C204.375%20322.179%20204.338%20322.267%20204.265%20322.34C204.192%20322.413%20204.104%20322.45%20204%20322.45C203.896%20322.45%20203.808%20322.413%20203.735%20322.34C203.662%20322.267%20203.625%20322.179%20203.625%20322.075C203.625%20321.971%20203.662%20321.883%20203.735%20321.81C203.808%20321.737%20203.896%20321.7%20204%20321.7C204.104%20321.7%20204.192%20321.737%20204.265%20321.81C204.338%20321.883%20204.375%20321.971%20204.375%20322.075ZM208.125%20322.075C208.125%20322.179%20208.088%20322.267%20208.015%20322.34C207.942%20322.413%20207.854%20322.45%20207.75%20322.45C207.646%20322.45%20207.558%20322.413%20207.485%20322.34C207.412%20322.267%20207.375%20322.179%20207.375%20322.075C207.375%20321.971%20207.412%20321.883%20207.485%20321.81C207.558%20321.737%20207.646%20321.7%20207.75%20321.7C207.854%20321.7%20207.942%20321.737%20208.015%20321.81C208.088%20321.883%20208.125%20321.971%20208.125%20322.075ZM211.875%20322.075C211.875%20322.179%20211.838%20322.267%20211.765%20322.34C211.692%20322.413%20211.604%20322.45%20211.5%20322.45C211.396%20322.45%20211.308%20322.413%20211.235%20322.34C211.162%20322.267%20211.125%20322.179%20211.125%20322.075C211.125%20321.971%20211.162%20321.883%20211.235%20321.81C211.308%20321.737%20211.396%20321.7%20211.5%20321.7C211.604%20321.7%20211.692%20321.737%20211.765%20321.81C211.838%20321.883%20211.875%20321.971%20211.875%20322.075ZM215.625%20322.075C215.625%20322.179%20215.588%20322.267%20215.515%20322.34C215.442%20322.413%20215.354%20322.45%20215.25%20322.45C215.146%20322.45%20215.058%20322.413%20214.985%20322.34C214.912%20322.267%20214.875%20322.179%20214.875%20322.075C214.875%20321.971%20214.912%20321.883%20214.985%20321.81C215.058%20321.737%20215.146%20321.7%20215.25%20321.7C215.354%20321.7%20215.442%20321.737%20215.515%20321.81C215.588%20321.883%20215.625%20321.971%20215.625%20322.075ZM219.375%20322.075C219.375%20322.179%20219.338%20322.267%20219.265%20322.34C219.192%20322.413%20219.104%20322.45%20219%20322.45C218.896%20322.45%20218.808%20322.413%20218.735%20322.34C218.662%20322.267%20218.625%20322.179%20218.625%20322.075C218.625%20321.971%20218.662%20321.883%20218.735%20321.81C218.808%20321.737%20218.896%20321.7%20219%20321.7C219.104%20321.7%20219.192%20321.737%20219.265%20321.81C219.338%20321.883%20219.375%20321.971%20219.375%20322.075ZM223.125%20322.075C223.125%20322.179%20223.088%20322.267%20223.015%20322.34C222.942%20322.413%20222.854%20322.45%20222.75%20322.45C222.646%20322.45%20222.558%20322.413%20222.485%20322.34C222.412%20322.267%20222.375%20322.179%20222.375%20322.075C222.375%20321.971%20222.412%20321.883%20222.485%20321.81C222.558%20321.737%20222.646%20321.7%20222.75%20321.7C222.854%20321.7%20222.942%20321.737%20223.015%20321.81C223.088%20321.883%20223.125%20321.971%20223.125%20322.075ZM226.875%20322.075C226.875%20322.179%20226.838%20322.267%20226.765%20322.34C226.692%20322.413%20226.604%20322.45%20226.5%20322.45C226.396%20322.45%20226.308%20322.413%20226.235%20322.34C226.162%20322.267%20226.125%20322.179%20226.125%20322.075C226.125%20321.971%20226.162%20321.883%20226.235%20321.81C226.308%20321.737%20226.396%20321.7%20226.5%20321.7C226.604%20321.7%20226.692%20321.737%20226.765%20321.81C226.838%20321.883%20226.875%20321.971%20226.875%20322.075ZM230.625%20322.075C230.625%20322.179%20230.588%20322.267%20230.515%20322.34C230.442%20322.413%20230.354%20322.45%20230.25%20322.45C230.146%20322.45%20230.058%20322.413%20229.985%20322.34C229.912%20322.267%20229.875%20322.179%20229.875%20322.075C229.875%20321.971%20229.912%20321.883%20229.985%20321.81C230.058%20321.737%20230.146%20321.7%20230.25%20321.7C230.354%20321.7%20230.442%20321.737%20230.515%20321.81C230.588%20321.883%20230.625%20321.971%20230.625%20322.075ZM234.375%20322.075C234.375%20322.179%20234.338%20322.267%20234.265%20322.34C234.192%20322.413%20234.104%20322.45%20234%20322.45C233.896%20322.45%20233.808%20322.413%20233.735%20322.34C233.662%20322.267%20233.625%20322.179%20233.625%20322.075C233.625%20321.971%20233.662%20321.883%20233.735%20321.81C233.808%20321.737%20233.896%20321.7%20234%20321.7C234.104%20321.7%20234.192%20321.737%20234.265%20321.81C234.338%20321.883%20234.375%20321.971%20234.375%20322.075ZM238.125%20322.075C238.125%20322.179%20238.088%20322.267%20238.015%20322.34C237.942%20322.413%20237.854%20322.45%20237.75%20322.45C237.646%20322.45%20237.558%20322.413%20237.485%20322.34C237.412%20322.267%20237.375%20322.179%20237.375%20322.075C237.375%20321.971%20237.412%20321.883%20237.485%20321.81C237.558%20321.737%20237.646%20321.7%20237.75%20321.7C237.854%20321.7%20237.942%20321.737%20238.015%20321.81C238.088%20321.883%20238.125%20321.971%20238.125%20322.075ZM241.875%20322.075C241.875%20322.179%20241.838%20322.267%20241.765%20322.34C241.692%20322.413%20241.604%20322.45%20241.5%20322.45C241.396%20322.45%20241.308%20322.413%20241.235%20322.34C241.162%20322.267%20241.125%20322.179%20241.125%20322.075C241.125%20321.971%20241.162%20321.883%20241.235%20321.81C241.308%20321.737%20241.396%20321.7%20241.5%20321.7C241.604%20321.7%20241.692%20321.737%20241.765%20321.81C241.838%20321.883%20241.875%20321.971%20241.875%20322.075ZM245.625%20322.075C245.625%20322.179%20245.588%20322.267%20245.515%20322.34C245.442%20322.413%20245.354%20322.45%20245.25%20322.45C245.146%20322.45%20245.058%20322.413%20244.985%20322.34C244.912%20322.267%20244.875%20322.179%20244.875%20322.075C244.875%20321.971%20244.912%20321.883%20244.985%20321.81C245.058%20321.737%20245.146%20321.7%20245.25%20321.7C245.354%20321.7%20245.442%20321.737%20245.515%20321.81C245.588%20321.883%20245.625%20321.971%20245.625%20322.075ZM249.375%20322.075C249.375%20322.179%20249.338%20322.267%20249.265%20322.34C249.192%20322.413%20249.104%20322.45%20249%20322.45C248.896%20322.45%20248.808%20322.413%20248.735%20322.34C248.662%20322.267%20248.625%20322.179%20248.625%20322.075C248.625%20321.971%20248.662%20321.883%20248.735%20321.81C248.808%20321.737%20248.896%20321.7%20249%20321.7C249.104%20321.7%20249.192%20321.737%20249.265%20321.81C249.338%20321.883%20249.375%20321.971%20249.375%20322.075ZM253.125%20322.075C253.125%20322.179%20253.088%20322.267%20253.015%20322.34C252.942%20322.413%20252.854%20322.45%20252.75%20322.45C252.646%20322.45%20252.558%20322.413%20252.485%20322.34C252.412%20322.267%20252.375%20322.179%20252.375%20322.075C252.375%20321.971%20252.412%20321.883%20252.485%20321.81C252.558%20321.737%20252.646%20321.7%20252.75%20321.7C252.854%20321.7%20252.942%20321.737%20253.015%20321.81C253.088%20321.883%20253.125%20321.971%20253.125%20322.075ZM256.875%20322.075C256.875%20322.179%20256.838%20322.267%20256.765%20322.34C256.692%20322.413%20256.604%20322.45%20256.5%20322.45C256.396%20322.45%20256.308%20322.413%20256.235%20322.34C256.162%20322.267%20256.125%20322.179%20256.125%20322.075C256.125%20321.971%20256.162%20321.883%20256.235%20321.81C256.308%20321.737%20256.396%20321.7%20256.5%20321.7C256.604%20321.7%20256.692%20321.737%20256.765%20321.81C256.838%20321.883%20256.875%20321.971%20256.875%20322.075ZM260.625%20322.075C260.625%20322.179%20260.588%20322.267%20260.515%20322.34C260.442%20322.413%20260.354%20322.45%20260.25%20322.45C260.146%20322.45%20260.058%20322.413%20259.985%20322.34C259.912%20322.267%20259.875%20322.179%20259.875%20322.075C259.875%20321.971%20259.912%20321.883%20259.985%20321.81C260.058%20321.737%20260.146%20321.7%20260.25%20321.7C260.354%20321.7%20260.442%20321.737%20260.515%20321.81C260.588%20321.883%20260.625%20321.971%20260.625%20322.075ZM264.375%20322.075C264.375%20322.179%20264.338%20322.267%20264.265%20322.34C264.192%20322.413%20264.104%20322.45%20264%20322.45C263.896%20322.45%20263.808%20322.413%20263.735%20322.34C263.662%20322.267%20263.625%20322.179%20263.625%20322.075C263.625%20321.971%20263.662%20321.883%20263.735%20321.81C263.808%20321.737%20263.896%20321.7%20264%20321.7C264.104%20321.7%20264.192%20321.737%20264.265%20321.81C264.338%20321.883%20264.375%20321.971%20264.375%20322.075ZM268.125%20322.075C268.125%20322.179%20268.088%20322.267%20268.015%20322.34C267.942%20322.413%20267.854%20322.45%20267.75%20322.45C267.646%20322.45%20267.558%20322.413%20267.485%20322.34C267.412%20322.267%20267.375%20322.179%20267.375%20322.075C267.375%20321.971%20267.412%20321.883%20267.485%20321.81C267.558%20321.737%20267.646%20321.7%20267.75%20321.7C267.854%20321.7%20267.942%20321.737%20268.015%20321.81C268.088%20321.883%20268.125%20321.971%20268.125%20322.075ZM271.875%20322.075C271.875%20322.179%20271.838%20322.267%20271.765%20322.34C271.692%20322.413%20271.604%20322.45%20271.5%20322.45C271.396%20322.45%20271.308%20322.413%20271.235%20322.34C271.162%20322.267%20271.125%20322.179%20271.125%20322.075C271.125%20321.971%20271.162%20321.883%20271.235%20321.81C271.308%20321.737%20271.396%20321.7%20271.5%20321.7C271.604%20321.7%20271.692%20321.737%20271.765%20321.81C271.838%20321.883%20271.875%20321.971%20271.875%20322.075ZM275.625%20322.075C275.625%20322.179%20275.588%20322.267%20275.515%20322.34C275.442%20322.413%20275.354%20322.45%20275.25%20322.45C275.146%20322.45%20275.058%20322.413%20274.985%20322.34C274.912%20322.267%20274.875%20322.179%20274.875%20322.075C274.875%20321.971%20274.912%20321.883%20274.985%20321.81C275.058%20321.737%20275.146%20321.7%20275.25%20321.7C275.354%20321.7%20275.442%20321.737%20275.515%20321.81C275.588%20321.883%20275.625%20321.971%20275.625%20322.075ZM279.375%20322.075C279.375%20322.179%20279.338%20322.267%20279.265%20322.34C279.192%20322.413%20279.104%20322.45%20279%20322.45C278.896%20322.45%20278.808%20322.413%20278.735%20322.34C278.662%20322.267%20278.625%20322.179%20278.625%20322.075C278.625%20321.971%20278.662%20321.883%20278.735%20321.81C278.808%20321.737%20278.896%20321.7%20279%20321.7C279.104%20321.7%20279.192%20321.737%20279.265%20321.81C279.338%20321.883%20279.375%20321.971%20279.375%20322.075ZM283.125%20322.075C283.125%20322.179%20283.088%20322.267%20283.015%20322.34C282.942%20322.413%20282.854%20322.45%20282.75%20322.45C282.646%20322.45%20282.558%20322.413%20282.485%20322.34C282.412%20322.267%20282.375%20322.179%20282.375%20322.075C282.375%20321.971%20282.412%20321.883%20282.485%20321.81C282.558%20321.737%20282.646%20321.7%20282.75%20321.7C282.854%20321.7%20282.942%20321.737%20283.015%20321.81C283.088%20321.883%20283.125%20321.971%20283.125%20322.075ZM286.875%20322.075C286.875%20322.179%20286.838%20322.267%20286.765%20322.34C286.692%20322.413%20286.604%20322.45%20286.5%20322.45C286.396%20322.45%20286.308%20322.413%20286.235%20322.34C286.162%20322.267%20286.125%20322.179%20286.125%20322.075C286.125%20321.971%20286.162%20321.883%20286.235%20321.81C286.308%20321.737%20286.396%20321.7%20286.5%20321.7C286.604%20321.7%20286.692%20321.737%20286.765%20321.81C286.838%20321.883%20286.875%20321.971%20286.875%20322.075ZM290.625%20322.075C290.625%20322.179%20290.588%20322.267%20290.515%20322.34C290.442%20322.413%20290.354%20322.45%20290.25%20322.45C290.146%20322.45%20290.058%20322.413%20289.985%20322.34C289.912%20322.267%20289.875%20322.179%20289.875%20322.075C289.875%20321.971%20289.912%20321.883%20289.985%20321.81C290.058%20321.737%20290.146%20321.7%20290.25%20321.7C290.354%20321.7%20290.442%20321.737%20290.515%20321.81C290.588%20321.883%20290.625%20321.971%20290.625%20322.075ZM294.375%20322.075C294.375%20322.179%20294.338%20322.267%20294.265%20322.34C294.192%20322.413%20294.104%20322.45%20294%20322.45C293.896%20322.45%20293.808%20322.413%20293.735%20322.34C293.662%20322.267%20293.625%20322.179%20293.625%20322.075C293.625%20321.971%20293.662%20321.883%20293.735%20321.81C293.808%20321.737%20293.896%20321.7%20294%20321.7C294.104%20321.7%20294.192%20321.737%20294.265%20321.81C294.338%20321.883%20294.375%20321.971%20294.375%20322.075ZM298.125%20322.075C298.125%20322.179%20298.088%20322.267%20298.015%20322.34C297.942%20322.413%20297.854%20322.45%20297.75%20322.45C297.646%20322.45%20297.558%20322.413%20297.485%20322.34C297.412%20322.267%20297.375%20322.179%20297.375%20322.075C297.375%20321.971%20297.412%20321.883%20297.485%20321.81C297.558%20321.737%20297.646%20321.7%20297.75%20321.7C297.854%20321.7%20297.942%20321.737%20298.015%20321.81C298.088%20321.883%20298.125%20321.971%20298.125%20322.075ZM301.875%20322.075C301.875%20322.179%20301.838%20322.267%20301.765%20322.34C301.692%20322.413%20301.604%20322.45%20301.5%20322.45C301.396%20322.45%20301.308%20322.413%20301.235%20322.34C301.162%20322.267%20301.125%20322.179%20301.125%20322.075C301.125%20321.971%20301.162%20321.883%20301.235%20321.81C301.308%20321.737%20301.396%20321.7%20301.5%20321.7C301.604%20321.7%20301.692%20321.737%20301.765%20321.81C301.838%20321.883%20301.875%20321.971%20301.875%20322.075ZM305.625%20322.075C305.625%20322.179%20305.588%20322.267%20305.515%20322.34C305.442%20322.413%20305.354%20322.45%20305.25%20322.45C305.146%20322.45%20305.058%20322.413%20304.985%20322.34C304.912%20322.267%20304.875%20322.179%20304.875%20322.075C304.875%20321.971%20304.912%20321.883%20304.985%20321.81C305.058%20321.737%20305.146%20321.7%20305.25%20321.7C305.354%20321.7%20305.442%20321.737%20305.515%20321.81C305.588%20321.883%20305.625%20321.971%20305.625%20322.075ZM309.375%20322.075C309.375%20322.179%20309.338%20322.267%20309.265%20322.34C309.192%20322.413%20309.104%20322.45%20309%20322.45C308.896%20322.45%20308.808%20322.413%20308.735%20322.34C308.662%20322.267%20308.625%20322.179%20308.625%20322.075C308.625%20321.971%20308.662%20321.883%20308.735%20321.81C308.808%20321.737%20308.896%20321.7%20309%20321.7C309.104%20321.7%20309.192%20321.737%20309.265%20321.81C309.338%20321.883%20309.375%20321.971%20309.375%20322.075ZM313.125%20322.075C313.125%20322.179%20313.088%20322.267%20313.015%20322.34C312.942%20322.413%20312.854%20322.45%20312.75%20322.45C312.646%20322.45%20312.558%20322.413%20312.485%20322.34C312.412%20322.267%20312.375%20322.179%20312.375%20322.075C312.375%20321.971%20312.412%20321.883%20312.485%20321.81C312.558%20321.737%20312.646%20321.7%20312.75%20321.7C312.854%20321.7%20312.942%20321.737%20313.015%20321.81C313.088%20321.883%20313.125%20321.971%20313.125%20322.075ZM316.875%20322.075C316.875%20322.179%20316.838%20322.267%20316.765%20322.34C316.692%20322.413%20316.604%20322.45%20316.5%20322.45C316.396%20322.45%20316.308%20322.413%20316.235%20322.34C316.162%20322.267%20316.125%20322.179%20316.125%20322.075C316.125%20321.971%20316.162%20321.883%20316.235%20321.81C316.308%20321.737%20316.396%20321.7%20316.5%20321.7C316.604%20321.7%20316.692%20321.737%20316.765%20321.81C316.838%20321.883%20316.875%20321.971%20316.875%20322.075ZM320.625%20322.075C320.625%20322.179%20320.588%20322.267%20320.515%20322.34C320.442%20322.413%20320.354%20322.45%20320.25%20322.45C320.146%20322.45%20320.058%20322.413%20319.985%20322.34C319.912%20322.267%20319.875%20322.179%20319.875%20322.075C319.875%20321.971%20319.912%20321.883%20319.985%20321.81C320.058%20321.737%20320.146%20321.7%20320.25%20321.7C320.354%20321.7%20320.442%20321.737%20320.515%20321.81C320.588%20321.883%20320.625%20321.971%20320.625%20322.075ZM324.375%20322.075C324.375%20322.179%20324.338%20322.267%20324.265%20322.34C324.192%20322.413%20324.104%20322.45%20324%20322.45C323.896%20322.45%20323.808%20322.413%20323.735%20322.34C323.662%20322.267%20323.625%20322.179%20323.625%20322.075C323.625%20321.971%20323.662%20321.883%20323.735%20321.81C323.808%20321.737%20323.896%20321.7%20324%20321.7C324.104%20321.7%20324.192%20321.737%20324.265%20321.81C324.338%20321.883%20324.375%20321.971%20324.375%20322.075ZM328.125%20322.075C328.125%20322.179%20328.088%20322.267%20328.015%20322.34C327.942%20322.413%20327.854%20322.45%20327.75%20322.45C327.646%20322.45%20327.558%20322.413%20327.485%20322.34C327.412%20322.267%20327.375%20322.179%20327.375%20322.075C327.375%20321.971%20327.412%20321.883%20327.485%20321.81C327.558%20321.737%20327.646%20321.7%20327.75%20321.7C327.854%20321.7%20327.942%20321.737%20328.015%20321.81C328.088%20321.883%20328.125%20321.971%20328.125%20322.075ZM331.875%20322.075C331.875%20322.179%20331.838%20322.267%20331.765%20322.34C331.692%20322.413%20331.604%20322.45%20331.5%20322.45C331.396%20322.45%20331.308%20322.413%20331.235%20322.34C331.162%20322.267%20331.125%20322.179%20331.125%20322.075C331.125%20321.971%20331.162%20321.883%20331.235%20321.81C331.308%20321.737%20331.396%20321.7%20331.5%20321.7C331.604%20321.7%20331.692%20321.737%20331.765%20321.81C331.838%20321.883%20331.875%20321.971%20331.875%20322.075ZM335.625%20322.075C335.625%20322.179%20335.588%20322.267%20335.515%20322.34C335.442%20322.413%20335.354%20322.45%20335.25%20322.45C335.146%20322.45%20335.058%20322.413%20334.985%20322.34C334.912%20322.267%20334.875%20322.179%20334.875%20322.075C334.875%20321.971%20334.912%20321.883%20334.985%20321.81C335.058%20321.737%20335.146%20321.7%20335.25%20321.7C335.354%20321.7%20335.442%20321.737%20335.515%20321.81C335.588%20321.883%20335.625%20321.971%20335.625%20322.075ZM339.375%20322.075C339.375%20322.179%20339.338%20322.267%20339.265%20322.34C339.192%20322.413%20339.104%20322.45%20339%20322.45C338.896%20322.45%20338.808%20322.413%20338.735%20322.34C338.662%20322.267%20338.625%20322.179%20338.625%20322.075C338.625%20321.971%20338.662%20321.883%20338.735%20321.81C338.808%20321.737%20338.896%20321.7%20339%20321.7C339.104%20321.7%20339.192%20321.737%20339.265%20321.81C339.338%20321.883%20339.375%20321.971%20339.375%20322.075ZM343.125%20322.075C343.125%20322.179%20343.088%20322.267%20343.015%20322.34C342.942%20322.413%20342.854%20322.45%20342.75%20322.45C342.646%20322.45%20342.558%20322.413%20342.485%20322.34C342.412%20322.267%20342.375%20322.179%20342.375%20322.075C342.375%20321.971%20342.412%20321.883%20342.485%20321.81C342.558%20321.737%20342.646%20321.7%20342.75%20321.7C342.854%20321.7%20342.942%20321.737%20343.015%20321.81C343.088%20321.883%20343.125%20321.971%20343.125%20322.075ZM346.875%20322.075C346.875%20322.179%20346.838%20322.267%20346.765%20322.34C346.692%20322.413%20346.604%20322.45%20346.5%20322.45C346.396%20322.45%20346.308%20322.413%20346.235%20322.34C346.162%20322.267%20346.125%20322.179%20346.125%20322.075C346.125%20321.971%20346.162%20321.883%20346.235%20321.81C346.308%20321.737%20346.396%20321.7%20346.5%20321.7C346.604%20321.7%20346.692%20321.737%20346.765%20321.81C346.838%20321.883%20346.875%20321.971%20346.875%20322.075ZM350.625%20322.075C350.625%20322.179%20350.588%20322.267%20350.515%20322.34C350.442%20322.413%20350.353%20322.45%20350.25%20322.45C350.146%20322.45%20350.058%20322.413%20349.985%20322.34C349.912%20322.267%20349.875%20322.179%20349.875%20322.075C349.875%20321.971%20349.912%20321.883%20349.985%20321.81C350.058%20321.737%20350.146%20321.7%20350.25%20321.7C350.353%20321.7%20350.442%20321.737%20350.515%20321.81C350.588%20321.883%20350.625%20321.971%20350.625%20322.075ZM354.375%20322.075C354.375%20322.179%20354.338%20322.267%20354.265%20322.34C354.192%20322.413%20354.104%20322.45%20354%20322.45C353.896%20322.45%20353.808%20322.413%20353.735%20322.34C353.662%20322.267%20353.625%20322.179%20353.625%20322.075C353.625%20321.971%20353.662%20321.883%20353.735%20321.81C353.808%20321.737%20353.896%20321.7%20354%20321.7C354.104%20321.7%20354.192%20321.737%20354.265%20321.81C354.338%20321.883%20354.375%20321.971%20354.375%20322.075ZM358.125%20322.075C358.125%20322.179%20358.088%20322.267%20358.015%20322.34C357.942%20322.413%20357.854%20322.45%20357.75%20322.45C357.646%20322.45%20357.558%20322.413%20357.485%20322.34C357.412%20322.267%20357.375%20322.179%20357.375%20322.075C357.375%20321.971%20357.412%20321.883%20357.485%20321.81C357.558%20321.737%20357.646%20321.7%20357.75%20321.7C357.854%20321.7%20357.942%20321.737%20358.015%20321.81C358.088%20321.883%20358.125%20321.971%20358.125%20322.075ZM361.875%20322.075C361.875%20322.179%20361.838%20322.267%20361.765%20322.34C361.692%20322.413%20361.603%20322.45%20361.5%20322.45C361.396%20322.45%20361.308%20322.413%20361.235%20322.34C361.162%20322.267%20361.125%20322.179%20361.125%20322.075C361.125%20321.971%20361.162%20321.883%20361.235%20321.81C361.308%20321.737%20361.396%20321.7%20361.5%20321.7C361.603%20321.7%20361.692%20321.737%20361.765%20321.81C361.838%20321.883%20361.875%20321.971%20361.875%20322.075ZM365.625%20322.075C365.625%20322.179%20365.588%20322.267%20365.515%20322.34C365.442%20322.413%20365.354%20322.45%20365.25%20322.45C365.146%20322.45%20365.058%20322.413%20364.985%20322.34C364.912%20322.267%20364.875%20322.179%20364.875%20322.075C364.875%20321.971%20364.912%20321.883%20364.985%20321.81C365.058%20321.737%20365.146%20321.7%20365.25%20321.7C365.354%20321.7%20365.442%20321.737%20365.515%20321.81C365.588%20321.883%20365.625%20321.971%20365.625%20322.075ZM369.375%20322.075C369.375%20322.179%20369.338%20322.267%20369.265%20322.34C369.192%20322.413%20369.104%20322.45%20369%20322.45C368.896%20322.45%20368.808%20322.413%20368.735%20322.34C368.662%20322.267%20368.625%20322.179%20368.625%20322.075C368.625%20321.971%20368.662%20321.883%20368.735%20321.81C368.808%20321.737%20368.896%20321.7%20369%20321.7C369.104%20321.7%20369.192%20321.737%20369.265%20321.81C369.338%20321.883%20369.375%20321.971%20369.375%20322.075ZM373.125%20322.075C373.125%20322.179%20373.088%20322.267%20373.015%20322.34C372.942%20322.413%20372.854%20322.45%20372.75%20322.45C372.646%20322.45%20372.558%20322.413%20372.485%20322.34C372.412%20322.267%20372.375%20322.179%20372.375%20322.075C372.375%20321.971%20372.412%20321.883%20372.485%20321.81C372.558%20321.737%20372.646%20321.7%20372.75%20321.7C372.854%20321.7%20372.942%20321.737%20373.015%20321.81C373.088%20321.883%20373.125%20321.971%20373.125%20322.075ZM376.875%20322.075C376.875%20322.179%20376.838%20322.267%20376.765%20322.34C376.692%20322.413%20376.604%20322.45%20376.5%20322.45C376.396%20322.45%20376.308%20322.413%20376.235%20322.34C376.162%20322.267%20376.125%20322.179%20376.125%20322.075C376.125%20321.971%20376.162%20321.883%20376.235%20321.81C376.308%20321.737%20376.396%20321.7%20376.5%20321.7C376.604%20321.7%20376.692%20321.737%20376.765%20321.81C376.838%20321.883%20376.875%20321.971%20376.875%20322.075ZM380.625%20322.075C380.625%20322.179%20380.588%20322.267%20380.515%20322.34C380.442%20322.413%20380.354%20322.45%20380.25%20322.45C380.146%20322.45%20380.058%20322.413%20379.985%20322.34C379.912%20322.267%20379.875%20322.179%20379.875%20322.075C379.875%20321.971%20379.912%20321.883%20379.985%20321.81C380.058%20321.737%20380.146%20321.7%20380.25%20321.7C380.354%20321.7%20380.442%20321.737%20380.515%20321.81C380.588%20321.883%20380.625%20321.971%20380.625%20322.075ZM384.375%20322.075C384.375%20322.179%20384.338%20322.267%20384.265%20322.34C384.192%20322.413%20384.104%20322.45%20384%20322.45C383.896%20322.45%20383.808%20322.413%20383.735%20322.34C383.662%20322.267%20383.625%20322.179%20383.625%20322.075C383.625%20321.971%20383.662%20321.883%20383.735%20321.81C383.808%20321.737%20383.896%20321.7%20384%20321.7C384.104%20321.7%20384.192%20321.737%20384.265%20321.81C384.338%20321.883%20384.375%20321.971%20384.375%20322.075ZM388.125%20322.075C388.125%20322.179%20388.088%20322.267%20388.015%20322.34C387.942%20322.413%20387.854%20322.45%20387.75%20322.45C387.646%20322.45%20387.558%20322.413%20387.485%20322.34C387.412%20322.267%20387.375%20322.179%20387.375%20322.075C387.375%20321.971%20387.412%20321.883%20387.485%20321.81C387.558%20321.737%20387.646%20321.7%20387.75%20321.7C387.854%20321.7%20387.942%20321.737%20388.015%20321.81C388.088%20321.883%20388.125%20321.971%20388.125%20322.075ZM391.875%20322.075C391.875%20322.179%20391.838%20322.267%20391.765%20322.34C391.692%20322.413%20391.603%20322.45%20391.5%20322.45C391.396%20322.45%20391.308%20322.413%20391.235%20322.34C391.162%20322.267%20391.125%20322.179%20391.125%20322.075C391.125%20321.971%20391.162%20321.883%20391.235%20321.81C391.308%20321.737%20391.396%20321.7%20391.5%20321.7C391.603%20321.7%20391.692%20321.737%20391.765%20321.81C391.838%20321.883%20391.875%20321.971%20391.875%20322.075ZM395.625%20322.075C395.625%20322.179%20395.588%20322.267%20395.515%20322.34C395.442%20322.413%20395.354%20322.45%20395.25%20322.45C395.146%20322.45%20395.058%20322.413%20394.985%20322.34C394.912%20322.267%20394.875%20322.179%20394.875%20322.075C394.875%20321.971%20394.912%20321.883%20394.985%20321.81C395.058%20321.737%20395.146%20321.7%20395.25%20321.7C395.354%20321.7%20395.442%20321.737%20395.515%20321.81C395.588%20321.883%20395.625%20321.971%20395.625%20322.075ZM399.375%20322.075C399.375%20322.179%20399.338%20322.267%20399.265%20322.34C399.192%20322.413%20399.104%20322.45%20399%20322.45C398.896%20322.45%20398.808%20322.413%20398.735%20322.34C398.662%20322.267%20398.625%20322.179%20398.625%20322.075C398.625%20321.971%20398.662%20321.883%20398.735%20321.81C398.808%20321.737%20398.896%20321.7%20399%20321.7C399.104%20321.7%20399.192%20321.737%20399.265%20321.81C399.338%20321.883%20399.375%20321.971%20399.375%20322.075ZM403.125%20322.075C403.125%20322.179%20403.088%20322.267%20403.015%20322.34C402.942%20322.413%20402.854%20322.45%20402.75%20322.45C402.646%20322.45%20402.558%20322.413%20402.485%20322.34C402.412%20322.267%20402.375%20322.179%20402.375%20322.075C402.375%20321.971%20402.412%20321.883%20402.485%20321.81C402.558%20321.737%20402.646%20321.7%20402.75%20321.7C402.854%20321.7%20402.942%20321.737%20403.015%20321.81C403.088%20321.883%20403.125%20321.971%20403.125%20322.075ZM406.875%20322.075C406.875%20322.179%20406.838%20322.267%20406.765%20322.34C406.692%20322.413%20406.604%20322.45%20406.5%20322.45C406.396%20322.45%20406.308%20322.413%20406.235%20322.34C406.162%20322.267%20406.125%20322.179%20406.125%20322.075C406.125%20321.971%20406.162%20321.883%20406.235%20321.81C406.308%20321.737%20406.396%20321.7%20406.5%20321.7C406.604%20321.7%20406.692%20321.737%20406.765%20321.81C406.838%20321.883%20406.875%20321.971%20406.875%20322.075ZM410.625%20322.075C410.625%20322.179%20410.588%20322.267%20410.515%20322.34C410.442%20322.413%20410.354%20322.45%20410.25%20322.45C410.146%20322.45%20410.058%20322.413%20409.985%20322.34C409.912%20322.267%20409.875%20322.179%20409.875%20322.075C409.875%20321.971%20409.912%20321.883%20409.985%20321.81C410.058%20321.737%20410.146%20321.7%20410.25%20321.7C410.354%20321.7%20410.442%20321.737%20410.515%20321.81C410.588%20321.883%20410.625%20321.971%20410.625%20322.075ZM414.375%20322.075C414.375%20322.179%20414.338%20322.267%20414.265%20322.34C414.192%20322.413%20414.104%20322.45%20414%20322.45C413.896%20322.45%20413.808%20322.413%20413.735%20322.34C413.662%20322.267%20413.625%20322.179%20413.625%20322.075C413.625%20321.971%20413.662%20321.883%20413.735%20321.81C413.808%20321.737%20413.896%20321.7%20414%20321.7C414.104%20321.7%20414.192%20321.737%20414.265%20321.81C414.338%20321.883%20414.375%20321.971%20414.375%20322.075ZM418.125%20322.075C418.125%20322.179%20418.088%20322.267%20418.015%20322.34C417.942%20322.413%20417.854%20322.45%20417.75%20322.45C417.646%20322.45%20417.558%20322.413%20417.485%20322.34C417.412%20322.267%20417.375%20322.179%20417.375%20322.075C417.375%20321.971%20417.412%20321.883%20417.485%20321.81C417.558%20321.737%20417.646%20321.7%20417.75%20321.7C417.854%20321.7%20417.942%20321.737%20418.015%20321.81C418.088%20321.883%20418.125%20321.971%20418.125%20322.075ZM421.875%20322.075C421.875%20322.179%20421.838%20322.267%20421.765%20322.34C421.692%20322.413%20421.604%20322.45%20421.5%20322.45C421.396%20322.45%20421.308%20322.413%20421.235%20322.34C421.162%20322.267%20421.125%20322.179%20421.125%20322.075C421.125%20321.971%20421.162%20321.883%20421.235%20321.81C421.308%20321.737%20421.396%20321.7%20421.5%20321.7C421.604%20321.7%20421.692%20321.737%20421.765%20321.81C421.838%20321.883%20421.875%20321.971%20421.875%20322.075ZM425.625%20322.075C425.625%20322.179%20425.588%20322.267%20425.515%20322.34C425.442%20322.413%20425.354%20322.45%20425.25%20322.45C425.146%20322.45%20425.058%20322.413%20424.985%20322.34C424.912%20322.267%20424.875%20322.179%20424.875%20322.075C424.875%20321.971%20424.912%20321.883%20424.985%20321.81C425.058%20321.737%20425.146%20321.7%20425.25%20321.7C425.354%20321.7%20425.442%20321.737%20425.515%20321.81C425.588%20321.883%20425.625%20321.971%20425.625%20322.075ZM429.375%20322.075C429.375%20322.179%20429.338%20322.267%20429.265%20322.34C429.192%20322.413%20429.104%20322.45%20429%20322.45C428.896%20322.45%20428.808%20322.413%20428.735%20322.34C428.662%20322.267%20428.625%20322.179%20428.625%20322.075C428.625%20321.971%20428.662%20321.883%20428.735%20321.81C428.808%20321.737%20428.896%20321.7%20429%20321.7C429.104%20321.7%20429.192%20321.737%20429.265%20321.81C429.338%20321.883%20429.375%20321.971%20429.375%20322.075ZM433.125%20322.075C433.125%20322.179%20433.088%20322.267%20433.015%20322.34C432.942%20322.413%20432.854%20322.45%20432.75%20322.45C432.646%20322.45%20432.558%20322.413%20432.485%20322.34C432.412%20322.267%20432.375%20322.179%20432.375%20322.075C432.375%20321.971%20432.412%20321.883%20432.485%20321.81C432.558%20321.737%20432.646%20321.7%20432.75%20321.7C432.854%20321.7%20432.942%20321.737%20433.015%20321.81C433.088%20321.883%20433.125%20321.971%20433.125%20322.075ZM436.875%20322.075C436.875%20322.179%20436.838%20322.267%20436.765%20322.34C436.692%20322.413%20436.604%20322.45%20436.5%20322.45C436.396%20322.45%20436.308%20322.413%20436.235%20322.34C436.162%20322.267%20436.125%20322.179%20436.125%20322.075C436.125%20321.971%20436.162%20321.883%20436.235%20321.81C436.308%20321.737%20436.396%20321.7%20436.5%20321.7C436.604%20321.7%20436.692%20321.737%20436.765%20321.81C436.838%20321.883%20436.875%20321.971%20436.875%20322.075ZM440.625%20322.075C440.625%20322.179%20440.588%20322.267%20440.515%20322.34C440.442%20322.413%20440.354%20322.45%20440.25%20322.45C440.146%20322.45%20440.058%20322.413%20439.985%20322.34C439.912%20322.267%20439.875%20322.179%20439.875%20322.075C439.875%20321.971%20439.912%20321.883%20439.985%20321.81C440.058%20321.737%20440.146%20321.7%20440.25%20321.7C440.354%20321.7%20440.442%20321.737%20440.515%20321.81C440.588%20321.883%20440.625%20321.971%20440.625%20322.075ZM444.375%20322.075C444.375%20322.179%20444.338%20322.267%20444.265%20322.34C444.192%20322.413%20444.104%20322.45%20444%20322.45C443.896%20322.45%20443.808%20322.413%20443.735%20322.34C443.662%20322.267%20443.625%20322.179%20443.625%20322.075C443.625%20321.971%20443.662%20321.883%20443.735%20321.81C443.808%20321.737%20443.896%20321.7%20444%20321.7C444.104%20321.7%20444.192%20321.737%20444.265%20321.81C444.338%20321.883%20444.375%20321.971%20444.375%20322.075ZM448.125%20322.075C448.125%20322.179%20448.088%20322.267%20448.015%20322.34C447.942%20322.413%20447.854%20322.45%20447.75%20322.45C447.646%20322.45%20447.558%20322.413%20447.485%20322.34C447.412%20322.267%20447.375%20322.179%20447.375%20322.075C447.375%20321.971%20447.412%20321.883%20447.485%20321.81C447.558%20321.737%20447.646%20321.7%20447.75%20321.7C447.854%20321.7%20447.942%20321.737%20448.015%20321.81C448.088%20321.883%20448.125%20321.971%20448.125%20322.075ZM451.875%20322.075C451.875%20322.179%20451.838%20322.267%20451.765%20322.34C451.692%20322.413%20451.604%20322.45%20451.5%20322.45C451.396%20322.45%20451.308%20322.413%20451.235%20322.34C451.162%20322.267%20451.125%20322.179%20451.125%20322.075C451.125%20321.971%20451.162%20321.883%20451.235%20321.81C451.308%20321.737%20451.396%20321.7%20451.5%20321.7C451.604%20321.7%20451.692%20321.737%20451.765%20321.81C451.838%20321.883%20451.875%20321.971%20451.875%20322.075ZM455.625%20322.075C455.625%20322.179%20455.588%20322.267%20455.515%20322.34C455.442%20322.413%20455.354%20322.45%20455.25%20322.45C455.146%20322.45%20455.058%20322.413%20454.985%20322.34C454.912%20322.267%20454.875%20322.179%20454.875%20322.075C454.875%20321.971%20454.912%20321.883%20454.985%20321.81C455.058%20321.737%20455.146%20321.7%20455.25%20321.7C455.354%20321.7%20455.442%20321.737%20455.515%20321.81C455.588%20321.883%20455.625%20321.971%20455.625%20322.075ZM459.375%20322.075C459.375%20322.179%20459.338%20322.267%20459.265%20322.34C459.192%20322.413%20459.103%20322.45%20459%20322.45C458.896%20322.45%20458.808%20322.413%20458.735%20322.34C458.662%20322.267%20458.625%20322.179%20458.625%20322.075C458.625%20321.971%20458.662%20321.883%20458.735%20321.81C458.808%20321.737%20458.896%20321.7%20459%20321.7C459.103%20321.7%20459.192%20321.737%20459.265%20321.81C459.338%20321.883%20459.375%20321.971%20459.375%20322.075ZM463.125%20322.075C463.125%20322.179%20463.088%20322.267%20463.015%20322.34C462.942%20322.413%20462.853%20322.45%20462.75%20322.45C462.646%20322.45%20462.558%20322.413%20462.485%20322.34C462.412%20322.267%20462.375%20322.179%20462.375%20322.075C462.375%20321.971%20462.412%20321.883%20462.485%20321.81C462.558%20321.737%20462.646%20321.7%20462.75%20321.7C462.853%20321.7%20462.942%20321.737%20463.015%20321.81C463.088%20321.883%20463.125%20321.971%20463.125%20322.075ZM466.875%20322.075C466.875%20322.179%20466.838%20322.267%20466.765%20322.34C466.692%20322.413%20466.604%20322.45%20466.5%20322.45C466.396%20322.45%20466.308%20322.413%20466.235%20322.34C466.162%20322.267%20466.125%20322.179%20466.125%20322.075C466.125%20321.971%20466.162%20321.883%20466.235%20321.81C466.308%20321.737%20466.396%20321.7%20466.5%20321.7C466.604%20321.7%20466.692%20321.737%20466.765%20321.81C466.838%20321.883%20466.875%20321.971%20466.875%20322.075ZM470.625%20322.075C470.625%20322.179%20470.588%20322.267%20470.515%20322.34C470.442%20322.413%20470.354%20322.45%20470.25%20322.45C470.146%20322.45%20470.058%20322.413%20469.985%20322.34C469.912%20322.267%20469.875%20322.179%20469.875%20322.075C469.875%20321.971%20469.912%20321.883%20469.985%20321.81C470.058%20321.737%20470.146%20321.7%20470.25%20321.7C470.354%20321.7%20470.442%20321.737%20470.515%20321.81C470.588%20321.883%20470.625%20321.971%20470.625%20322.075ZM474.375%20322.075C474.375%20322.179%20474.338%20322.267%20474.265%20322.34C474.192%20322.413%20474.104%20322.45%20474%20322.45C473.896%20322.45%20473.808%20322.413%20473.735%20322.34C473.662%20322.267%20473.625%20322.179%20473.625%20322.075C473.625%20321.971%20473.662%20321.883%20473.735%20321.81C473.808%20321.737%20473.896%20321.7%20474%20321.7C474.104%20321.7%20474.192%20321.737%20474.265%20321.81C474.338%20321.883%20474.375%20321.971%20474.375%20322.075ZM478.125%20322.075C478.125%20322.179%20478.088%20322.267%20478.015%20322.34C477.942%20322.413%20477.854%20322.45%20477.75%20322.45C477.646%20322.45%20477.558%20322.413%20477.485%20322.34C477.412%20322.267%20477.375%20322.179%20477.375%20322.075C477.375%20321.971%20477.412%20321.883%20477.485%20321.81C477.558%20321.737%20477.646%20321.7%20477.75%20321.7C477.854%20321.7%20477.942%20321.737%20478.015%20321.81C478.088%20321.883%20478.125%20321.971%20478.125%20322.075ZM481.875%20322.075C481.875%20322.179%20481.838%20322.267%20481.765%20322.34C481.692%20322.413%20481.604%20322.45%20481.5%20322.45C481.396%20322.45%20481.308%20322.413%20481.235%20322.34C481.162%20322.267%20481.125%20322.179%20481.125%20322.075C481.125%20321.971%20481.162%20321.883%20481.235%20321.81C481.308%20321.737%20481.396%20321.7%20481.5%20321.7C481.604%20321.7%20481.692%20321.737%20481.765%20321.81C481.838%20321.883%20481.875%20321.971%20481.875%20322.075ZM485.625%20322.075C485.625%20322.179%20485.588%20322.267%20485.515%20322.34C485.442%20322.413%20485.354%20322.45%20485.25%20322.45C485.146%20322.45%20485.058%20322.413%20484.985%20322.34C484.912%20322.267%20484.875%20322.179%20484.875%20322.075C484.875%20321.971%20484.912%20321.883%20484.985%20321.81C485.058%20321.737%20485.146%20321.7%20485.25%20321.7C485.354%20321.7%20485.442%20321.737%20485.515%20321.81C485.588%20321.883%20485.625%20321.971%20485.625%20322.075ZM489.375%20322.075C489.375%20322.179%20489.338%20322.267%20489.265%20322.34C489.192%20322.413%20489.104%20322.45%20489%20322.45C488.896%20322.45%20488.808%20322.413%20488.735%20322.34C488.662%20322.267%20488.625%20322.179%20488.625%20322.075C488.625%20321.971%20488.662%20321.883%20488.735%20321.81C488.808%20321.737%20488.896%20321.7%20489%20321.7C489.104%20321.7%20489.192%20321.737%20489.265%20321.81C489.338%20321.883%20489.375%20321.971%20489.375%20322.075ZM493.125%20322.075C493.125%20322.179%20493.088%20322.267%20493.015%20322.34C492.942%20322.413%20492.854%20322.45%20492.75%20322.45C492.646%20322.45%20492.558%20322.413%20492.485%20322.34C492.412%20322.267%20492.375%20322.179%20492.375%20322.075C492.375%20321.971%20492.412%20321.883%20492.485%20321.81C492.558%20321.737%20492.646%20321.7%20492.75%20321.7C492.854%20321.7%20492.942%20321.737%20493.015%20321.81C493.088%20321.883%20493.125%20321.971%20493.125%20322.075ZM496.875%20322.075C496.875%20322.179%20496.838%20322.267%20496.765%20322.34C496.692%20322.413%20496.603%20322.45%20496.5%20322.45C496.396%20322.45%20496.308%20322.413%20496.235%20322.34C496.162%20322.267%20496.125%20322.179%20496.125%20322.075C496.125%20321.971%20496.162%20321.883%20496.235%20321.81C496.308%20321.737%20496.396%20321.7%20496.5%20321.7C496.603%20321.7%20496.692%20321.737%20496.765%20321.81C496.838%20321.883%20496.875%20321.971%20496.875%20322.075ZM500.625%20322.075C500.625%20322.179%20500.588%20322.267%20500.515%20322.34C500.442%20322.413%20500.353%20322.45%20500.25%20322.45C500.146%20322.45%20500.058%20322.413%20499.985%20322.34C499.912%20322.267%20499.875%20322.179%20499.875%20322.075C499.875%20321.971%20499.912%20321.883%20499.985%20321.81C500.058%20321.737%20500.146%20321.7%20500.25%20321.7C500.353%20321.7%20500.442%20321.737%20500.515%20321.81C500.588%20321.883%20500.625%20321.971%20500.625%20322.075ZM504.375%20322.075C504.375%20322.179%20504.338%20322.267%20504.265%20322.34C504.192%20322.413%20504.103%20322.45%20504%20322.45C503.896%20322.45%20503.808%20322.413%20503.735%20322.34C503.662%20322.267%20503.625%20322.179%20503.625%20322.075C503.625%20321.971%20503.662%20321.883%20503.735%20321.81C503.808%20321.737%20503.896%20321.7%20504%20321.7C504.103%20321.7%20504.192%20321.737%20504.265%20321.81C504.338%20321.883%20504.375%20321.971%20504.375%20322.075ZM508.125%20322.075C508.125%20322.179%20508.088%20322.267%20508.015%20322.34C507.942%20322.413%20507.854%20322.45%20507.75%20322.45C507.646%20322.45%20507.558%20322.413%20507.485%20322.34C507.412%20322.267%20507.375%20322.179%20507.375%20322.075C507.375%20321.971%20507.412%20321.883%20507.485%20321.81C507.558%20321.737%20507.646%20321.7%20507.75%20321.7C507.854%20321.7%20507.942%20321.737%20508.015%20321.81C508.088%20321.883%20508.125%20321.971%20508.125%20322.075ZM511.875%20322.075C511.875%20322.179%20511.838%20322.267%20511.765%20322.34C511.692%20322.413%20511.604%20322.45%20511.5%20322.45C511.396%20322.45%20511.308%20322.413%20511.235%20322.34C511.162%20322.267%20511.125%20322.179%20511.125%20322.075C511.125%20321.971%20511.162%20321.883%20511.235%20321.81C511.308%20321.737%20511.396%20321.7%20511.5%20321.7C511.604%20321.7%20511.692%20321.737%20511.765%20321.81C511.838%20321.883%20511.875%20321.971%20511.875%20322.075ZM515.625%20322.075C515.625%20322.179%20515.588%20322.267%20515.515%20322.34C515.442%20322.413%20515.353%20322.45%20515.25%20322.45C515.146%20322.45%20515.058%20322.413%20514.985%20322.34C514.912%20322.267%20514.875%20322.179%20514.875%20322.075C514.875%20321.971%20514.912%20321.883%20514.985%20321.81C515.058%20321.737%20515.146%20321.7%20515.25%20321.7C515.353%20321.7%20515.442%20321.737%20515.515%20321.81C515.588%20321.883%20515.625%20321.971%20515.625%20322.075ZM519.375%20322.075C519.375%20322.179%20519.338%20322.267%20519.265%20322.34C519.192%20322.413%20519.104%20322.45%20519%20322.45C518.896%20322.45%20518.808%20322.413%20518.735%20322.34C518.662%20322.267%20518.625%20322.179%20518.625%20322.075C518.625%20321.971%20518.662%20321.883%20518.735%20321.81C518.808%20321.737%20518.896%20321.7%20519%20321.7C519.104%20321.7%20519.192%20321.737%20519.265%20321.81C519.338%20321.883%20519.375%20321.971%20519.375%20322.075ZM523.125%20322.075C523.125%20322.179%20523.088%20322.267%20523.015%20322.34C522.942%20322.413%20522.854%20322.45%20522.75%20322.45C522.646%20322.45%20522.558%20322.413%20522.485%20322.34C522.412%20322.267%20522.375%20322.179%20522.375%20322.075C522.375%20321.971%20522.412%20321.883%20522.485%20321.81C522.558%20321.737%20522.646%20321.7%20522.75%20321.7C522.854%20321.7%20522.942%20321.737%20523.015%20321.81C523.088%20321.883%20523.125%20321.971%20523.125%20322.075ZM526.875%20322.075C526.875%20322.179%20526.838%20322.267%20526.765%20322.34C526.692%20322.413%20526.604%20322.45%20526.5%20322.45C526.396%20322.45%20526.308%20322.413%20526.235%20322.34C526.162%20322.267%20526.125%20322.179%20526.125%20322.075C526.125%20321.971%20526.162%20321.883%20526.235%20321.81C526.308%20321.737%20526.396%20321.7%20526.5%20321.7C526.604%20321.7%20526.692%20321.737%20526.765%20321.81C526.838%20321.883%20526.875%20321.971%20526.875%20322.075ZM530.625%20322.075C530.625%20322.179%20530.588%20322.267%20530.515%20322.34C530.442%20322.413%20530.354%20322.45%20530.25%20322.45C530.146%20322.45%20530.058%20322.413%20529.985%20322.34C529.912%20322.267%20529.875%20322.179%20529.875%20322.075C529.875%20321.971%20529.912%20321.883%20529.985%20321.81C530.058%20321.737%20530.146%20321.7%20530.25%20321.7C530.354%20321.7%20530.442%20321.737%20530.515%20321.81C530.588%20321.883%20530.625%20321.971%20530.625%20322.075ZM534.375%20322.075C534.375%20322.179%20534.338%20322.267%20534.265%20322.34C534.192%20322.413%20534.103%20322.45%20534%20322.45C533.896%20322.45%20533.808%20322.413%20533.735%20322.34C533.662%20322.267%20533.625%20322.179%20533.625%20322.075C533.625%20321.971%20533.662%20321.883%20533.735%20321.81C533.808%20321.737%20533.896%20321.7%20534%20321.7C534.103%20321.7%20534.192%20321.737%20534.265%20321.81C534.338%20321.883%20534.375%20321.971%20534.375%20322.075ZM538.125%20322.075C538.125%20322.179%20538.088%20322.267%20538.015%20322.34C537.942%20322.413%20537.853%20322.45%20537.75%20322.45C537.646%20322.45%20537.558%20322.413%20537.485%20322.34C537.412%20322.267%20537.375%20322.179%20537.375%20322.075C537.375%20321.971%20537.412%20321.883%20537.485%20321.81C537.558%20321.737%20537.646%20321.7%20537.75%20321.7C537.853%20321.7%20537.942%20321.737%20538.015%20321.81C538.088%20321.883%20538.125%20321.971%20538.125%20322.075ZM541.875%20322.075C541.875%20322.179%20541.838%20322.267%20541.765%20322.34C541.692%20322.413%20541.603%20322.45%20541.5%20322.45C541.396%20322.45%20541.308%20322.413%20541.235%20322.34C541.162%20322.267%20541.125%20322.179%20541.125%20322.075C541.125%20321.971%20541.162%20321.883%20541.235%20321.81C541.308%20321.737%20541.396%20321.7%20541.5%20321.7C541.603%20321.7%20541.692%20321.737%20541.765%20321.81C541.838%20321.883%20541.875%20321.971%20541.875%20322.075ZM545.625%20322.075C545.625%20322.179%20545.588%20322.267%20545.515%20322.34C545.442%20322.413%20545.353%20322.45%20545.25%20322.45C545.146%20322.45%20545.058%20322.413%20544.985%20322.34C544.912%20322.267%20544.875%20322.179%20544.875%20322.075C544.875%20321.971%20544.912%20321.883%20544.985%20321.81C545.058%20321.737%20545.146%20321.7%20545.25%20321.7C545.353%20321.7%20545.442%20321.737%20545.515%20321.81C545.588%20321.883%20545.625%20321.971%20545.625%20322.075ZM549.375%20322.075C549.375%20322.179%20549.338%20322.267%20549.265%20322.34C549.192%20322.413%20549.103%20322.45%20549%20322.45C548.896%20322.45%20548.808%20322.413%20548.735%20322.34C548.662%20322.267%20548.625%20322.179%20548.625%20322.075C548.625%20321.971%20548.662%20321.883%20548.735%20321.81C548.808%20321.737%20548.896%20321.7%20549%20321.7C549.103%20321.7%20549.192%20321.737%20549.265%20321.81C549.338%20321.883%20549.375%20321.971%20549.375%20322.075ZM553.125%20322.075C553.125%20322.179%20553.088%20322.267%20553.015%20322.34C552.942%20322.413%20552.854%20322.45%20552.75%20322.45C552.646%20322.45%20552.558%20322.413%20552.485%20322.34C552.412%20322.267%20552.375%20322.179%20552.375%20322.075C552.375%20321.971%20552.412%20321.883%20552.485%20321.81C552.558%20321.737%20552.646%20321.7%20552.75%20321.7C552.854%20321.7%20552.942%20321.737%20553.015%20321.81C553.088%20321.883%20553.125%20321.971%20553.125%20322.075ZM556.875%20322.075C556.875%20322.179%20556.838%20322.267%20556.765%20322.34C556.692%20322.413%20556.603%20322.45%20556.5%20322.45C556.396%20322.45%20556.308%20322.413%20556.235%20322.34C556.162%20322.267%20556.125%20322.179%20556.125%20322.075C556.125%20321.971%20556.162%20321.883%20556.235%20321.81C556.308%20321.737%20556.396%20321.7%20556.5%20321.7C556.603%20321.7%20556.692%20321.737%20556.765%20321.81C556.838%20321.883%20556.875%20321.971%20556.875%20322.075ZM560.625%20322.075C560.625%20322.179%20560.588%20322.267%20560.515%20322.34C560.442%20322.413%20560.354%20322.45%20560.25%20322.45C560.146%20322.45%20560.058%20322.413%20559.985%20322.34C559.912%20322.267%20559.875%20322.179%20559.875%20322.075C559.875%20321.971%20559.912%20321.883%20559.985%20321.81C560.058%20321.737%20560.146%20321.7%20560.25%20321.7C560.354%20321.7%20560.442%20321.737%20560.515%20321.81C560.588%20321.883%20560.625%20321.971%20560.625%20322.075ZM564.375%20322.075C564.375%20322.179%20564.338%20322.267%20564.265%20322.34C564.192%20322.413%20564.104%20322.45%20564%20322.45C563.896%20322.45%20563.808%20322.413%20563.735%20322.34C563.662%20322.267%20563.625%20322.179%20563.625%20322.075C563.625%20321.971%20563.662%20321.883%20563.735%20321.81C563.808%20321.737%20563.896%20321.7%20564%20321.7C564.104%20321.7%20564.192%20321.737%20564.265%20321.81C564.338%20321.883%20564.375%20321.971%20564.375%20322.075ZM568.125%20322.075C568.125%20322.179%20568.088%20322.267%20568.015%20322.34C567.942%20322.413%20567.854%20322.45%20567.75%20322.45C567.646%20322.45%20567.558%20322.413%20567.485%20322.34C567.412%20322.267%20567.375%20322.179%20567.375%20322.075C567.375%20321.971%20567.412%20321.883%20567.485%20321.81C567.558%20321.737%20567.646%20321.7%20567.75%20321.7C567.854%20321.7%20567.942%20321.737%20568.015%20321.81C568.088%20321.883%20568.125%20321.971%20568.125%20322.075ZM571.875%20322.075C571.875%20322.179%20571.838%20322.267%20571.765%20322.34C571.692%20322.413%20571.603%20322.45%20571.5%20322.45C571.396%20322.45%20571.308%20322.413%20571.235%20322.34C571.162%20322.267%20571.125%20322.179%20571.125%20322.075C571.125%20321.971%20571.162%20321.883%20571.235%20321.81C571.308%20321.737%20571.396%20321.7%20571.5%20321.7C571.603%20321.7%20571.692%20321.737%20571.765%20321.81C571.838%20321.883%20571.875%20321.971%20571.875%20322.075ZM575.625%20322.075C575.625%20322.179%20575.588%20322.267%20575.515%20322.34C575.442%20322.413%20575.354%20322.45%20575.25%20322.45C575.146%20322.45%20575.058%20322.413%20574.985%20322.34C574.912%20322.267%20574.875%20322.179%20574.875%20322.075C574.875%20321.971%20574.912%20321.883%20574.985%20321.81C575.058%20321.737%20575.146%20321.7%20575.25%20321.7C575.354%20321.7%20575.442%20321.737%20575.515%20321.81C575.588%20321.883%20575.625%20321.971%20575.625%20322.075ZM579.375%20322.075C579.375%20322.179%20579.338%20322.267%20579.265%20322.34C579.192%20322.413%20579.104%20322.45%20579%20322.45C578.896%20322.45%20578.808%20322.413%20578.735%20322.34C578.662%20322.267%20578.625%20322.179%20578.625%20322.075C578.625%20321.971%20578.662%20321.883%20578.735%20321.81C578.808%20321.737%20578.896%20321.7%20579%20321.7C579.104%20321.7%20579.192%20321.737%20579.265%20321.81C579.338%20321.883%20579.375%20321.971%20579.375%20322.075ZM583.125%20322.075C583.125%20322.179%20583.088%20322.267%20583.015%20322.34C582.942%20322.413%20582.854%20322.45%20582.75%20322.45C582.646%20322.45%20582.558%20322.413%20582.485%20322.34C582.412%20322.267%20582.375%20322.179%20582.375%20322.075C582.375%20321.971%20582.412%20321.883%20582.485%20321.81C582.558%20321.737%20582.646%20321.7%20582.75%20321.7C582.854%20321.7%20582.942%20321.737%20583.015%20321.81C583.088%20321.883%20583.125%20321.971%20583.125%20322.075ZM586.875%20322.075C586.875%20322.179%20586.838%20322.267%20586.765%20322.34C586.692%20322.413%20586.604%20322.45%20586.5%20322.45C586.396%20322.45%20586.308%20322.413%20586.235%20322.34C586.162%20322.267%20586.125%20322.179%20586.125%20322.075C586.125%20321.971%20586.162%20321.883%20586.235%20321.81C586.308%20321.737%20586.396%20321.7%20586.5%20321.7C586.604%20321.7%20586.692%20321.737%20586.765%20321.81C586.838%20321.883%20586.875%20321.971%20586.875%20322.075ZM590.625%20322.075C590.625%20322.179%20590.588%20322.267%20590.515%20322.34C590.442%20322.413%20590.354%20322.45%20590.25%20322.45C590.146%20322.45%20590.058%20322.413%20589.985%20322.34C589.912%20322.267%20589.875%20322.179%20589.875%20322.075C589.875%20321.971%20589.912%20321.883%20589.985%20321.81C590.058%20321.737%20590.146%20321.7%20590.25%20321.7C590.354%20321.7%20590.442%20321.737%20590.515%20321.81C590.588%20321.883%20590.625%20321.971%20590.625%20322.075ZM594.375%20322.075C594.375%20322.179%20594.338%20322.267%20594.265%20322.34C594.192%20322.413%20594.104%20322.45%20594%20322.45C593.896%20322.45%20593.808%20322.413%20593.735%20322.34C593.662%20322.267%20593.625%20322.179%20593.625%20322.075C593.625%20321.971%20593.662%20321.883%20593.735%20321.81C593.808%20321.737%20593.896%20321.7%20594%20321.7C594.104%20321.7%20594.192%20321.737%20594.265%20321.81C594.338%20321.883%20594.375%20321.971%20594.375%20322.075ZM598.125%20322.075C598.125%20322.179%20598.088%20322.267%20598.015%20322.34C597.942%20322.413%20597.854%20322.45%20597.75%20322.45C597.646%20322.45%20597.558%20322.413%20597.485%20322.34C597.412%20322.267%20597.375%20322.179%20597.375%20322.075C597.375%20321.971%20597.412%20321.883%20597.485%20321.81C597.558%20321.737%20597.646%20321.7%20597.75%20321.7C597.854%20321.7%20597.942%20321.737%20598.015%20321.81C598.088%20321.883%20598.125%20321.971%20598.125%20322.075ZM601.875%20322.075C601.875%20322.179%20601.838%20322.267%20601.765%20322.34C601.692%20322.413%20601.604%20322.45%20601.5%20322.45C601.396%20322.45%20601.308%20322.413%20601.235%20322.34C601.162%20322.267%20601.125%20322.179%20601.125%20322.075C601.125%20321.971%20601.162%20321.883%20601.235%20321.81C601.308%20321.737%20601.396%20321.7%20601.5%20321.7C601.604%20321.7%20601.692%20321.737%20601.765%20321.81C601.838%20321.883%20601.875%20321.971%20601.875%20322.075ZM605.625%20322.075C605.625%20322.179%20605.588%20322.267%20605.515%20322.34C605.442%20322.413%20605.354%20322.45%20605.25%20322.45C605.146%20322.45%20605.058%20322.413%20604.985%20322.34C604.912%20322.267%20604.875%20322.179%20604.875%20322.075C604.875%20321.971%20604.912%20321.883%20604.985%20321.81C605.058%20321.737%20605.146%20321.7%20605.25%20321.7C605.354%20321.7%20605.442%20321.737%20605.515%20321.81C605.588%20321.883%20605.625%20321.971%20605.625%20322.075ZM609.375%20322.075C609.375%20322.179%20609.338%20322.267%20609.265%20322.34C609.192%20322.413%20609.104%20322.45%20609%20322.45C608.896%20322.45%20608.808%20322.413%20608.735%20322.34C608.662%20322.267%20608.625%20322.179%20608.625%20322.075C608.625%20321.971%20608.662%20321.883%20608.735%20321.81C608.808%20321.737%20608.896%20321.7%20609%20321.7C609.104%20321.7%20609.192%20321.737%20609.265%20321.81C609.338%20321.883%20609.375%20321.971%20609.375%20322.075ZM613.125%20322.075C613.125%20322.179%20613.088%20322.267%20613.015%20322.34C612.942%20322.413%20612.854%20322.45%20612.75%20322.45C612.646%20322.45%20612.558%20322.413%20612.485%20322.34C612.412%20322.267%20612.375%20322.179%20612.375%20322.075C612.375%20321.971%20612.412%20321.883%20612.485%20321.81C612.558%20321.737%20612.646%20321.7%20612.75%20321.7C612.854%20321.7%20612.942%20321.737%20613.015%20321.81C613.088%20321.883%20613.125%20321.971%20613.125%20322.075ZM616.875%20322.075C616.875%20322.179%20616.838%20322.267%20616.765%20322.34C616.692%20322.413%20616.604%20322.45%20616.5%20322.45C616.396%20322.45%20616.308%20322.413%20616.235%20322.34C616.162%20322.267%20616.125%20322.179%20616.125%20322.075C616.125%20321.971%20616.162%20321.883%20616.235%20321.81C616.308%20321.737%20616.396%20321.7%20616.5%20321.7C616.604%20321.7%20616.692%20321.737%20616.765%20321.81C616.838%20321.883%20616.875%20321.971%20616.875%20322.075ZM620.625%20322.075C620.625%20322.179%20620.588%20322.267%20620.515%20322.34C620.442%20322.413%20620.354%20322.45%20620.25%20322.45C620.146%20322.45%20620.058%20322.413%20619.985%20322.34C619.912%20322.267%20619.875%20322.179%20619.875%20322.075C619.875%20321.971%20619.912%20321.883%20619.985%20321.81C620.058%20321.737%20620.146%20321.7%20620.25%20321.7C620.354%20321.7%20620.442%20321.737%20620.515%20321.81C620.588%20321.883%20620.625%20321.971%20620.625%20322.075ZM624.375%20322.075C624.375%20322.179%20624.338%20322.267%20624.265%20322.34C624.192%20322.413%20624.104%20322.45%20624%20322.45C623.896%20322.45%20623.808%20322.413%20623.735%20322.34C623.662%20322.267%20623.625%20322.179%20623.625%20322.075C623.625%20321.971%20623.662%20321.883%20623.735%20321.81C623.808%20321.737%20623.896%20321.7%20624%20321.7C624.104%20321.7%20624.192%20321.737%20624.265%20321.81C624.338%20321.883%20624.375%20321.971%20624.375%20322.075ZM628.125%20322.075C628.125%20322.179%20628.088%20322.267%20628.015%20322.34C627.942%20322.413%20627.854%20322.45%20627.75%20322.45C627.646%20322.45%20627.558%20322.413%20627.485%20322.34C627.412%20322.267%20627.375%20322.179%20627.375%20322.075C627.375%20321.971%20627.412%20321.883%20627.485%20321.81C627.558%20321.737%20627.646%20321.7%20627.75%20321.7C627.854%20321.7%20627.942%20321.737%20628.015%20321.81C628.088%20321.883%20628.125%20321.971%20628.125%20322.075ZM631.875%20322.075C631.875%20322.179%20631.838%20322.267%20631.765%20322.34C631.692%20322.413%20631.604%20322.45%20631.5%20322.45C631.396%20322.45%20631.308%20322.413%20631.235%20322.34C631.162%20322.267%20631.125%20322.179%20631.125%20322.075C631.125%20321.971%20631.162%20321.883%20631.235%20321.81C631.308%20321.737%20631.396%20321.7%20631.5%20321.7C631.604%20321.7%20631.692%20321.737%20631.765%20321.81C631.838%20321.883%20631.875%20321.971%20631.875%20322.075ZM635.625%20322.075C635.625%20322.179%20635.588%20322.267%20635.515%20322.34C635.442%20322.413%20635.354%20322.45%20635.25%20322.45C635.146%20322.45%20635.058%20322.413%20634.985%20322.34C634.912%20322.267%20634.875%20322.179%20634.875%20322.075C634.875%20321.971%20634.912%20321.883%20634.985%20321.81C635.058%20321.737%20635.146%20321.7%20635.25%20321.7C635.354%20321.7%20635.442%20321.737%20635.515%20321.81C635.588%20321.883%20635.625%20321.971%20635.625%20322.075Z'%20fill='%23B4BAC3'%20/%3e%3cpath%20d='M48.3487%20326.393C48.118%20326.528%2047.8476%20326.596%2047.5377%20326.596C47.2277%20326.596%2046.9562%20326.528%2046.7231%20326.393C46.4901%20326.256%2046.3025%20326.064%2046.1603%20325.816C46.0205%20325.569%2045.9156%20325.285%2045.8457%20324.963C45.7781%20324.642%2045.7443%20324.284%2045.7443%20323.89C45.7443%20323.566%2045.7665%20323.267%2045.8107%20322.992C45.8574%20322.717%2045.9284%20322.468%2046.024%20322.244C46.1195%20322.02%2046.2372%20321.83%2046.3771%20321.674C46.5192%20321.518%2046.6882%20321.398%2046.8839%20321.314C47.0797%20321.228%2047.2976%20321.185%2047.5377%20321.185C47.836%20321.185%2048.0993%20321.25%2048.3277%20321.38C48.5584%20321.511%2048.7449%20321.697%2048.887%20321.94C49.0315%20322.18%2049.1399%20322.464%2049.2121%20322.793C49.2844%20323.119%2049.3205%20323.485%2049.3205%20323.89C49.3205%20324.284%2049.2867%20324.642%2049.2191%20324.963C49.1516%20325.285%2049.0478%20325.569%2048.908%20325.816C48.7682%20326.064%2048.5817%20326.256%2048.3487%20326.393ZM48.1494%20321.999C47.9793%20321.81%2047.7754%20321.716%2047.5377%20321.716C47.2999%20321.716%2047.096%20321.81%2046.9259%20321.999C46.7558%20322.186%2046.6276%20322.44%2046.5414%20322.761C46.4575%20323.08%2046.4155%20323.45%2046.4155%20323.869C46.4155%20324.296%2046.4575%20324.673%2046.5414%20325.002C46.6276%20325.328%2046.7558%20325.587%2046.9259%20325.778C47.096%20325.969%2047.2999%20326.065%2047.5377%20326.065C47.7754%20326.065%2047.9793%20325.969%2048.1494%20325.778C48.3196%20325.587%2048.4466%20325.328%2048.5305%20325.002C48.6167%20324.673%2048.6598%20324.296%2048.6598%20323.869C48.6598%20323.45%2048.6167%20323.08%2048.5305%20322.761C48.4466%20322.44%2048.3196%20322.186%2048.1494%20321.999ZM54.1097%20326.516H53.3686L51.39%20324.048L50.9181%20324.464V326.516H50.3098V321.345H50.9181V323.883L53.1904%20321.345H53.9489L51.8515%20323.674L54.1097%20326.516Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M61.875%20265.475C61.875%20265.579%2061.8384%20265.667%2061.7652%20265.74C61.6919%20265.813%2061.6036%20265.85%2061.5%20265.85C61.3964%20265.85%2061.3081%20265.813%2061.2348%20265.74C61.1616%20265.667%2061.125%20265.579%2061.125%20265.475C61.125%20265.371%2061.1616%20265.283%2061.2348%20265.21C61.3081%20265.137%2061.3964%20265.1%2061.5%20265.1C61.6036%20265.1%2061.6919%20265.137%2061.7652%20265.21C61.8384%20265.283%2061.875%20265.371%2061.875%20265.475ZM65.625%20265.475C65.625%20265.579%2065.5884%20265.667%2065.5152%20265.74C65.4419%20265.813%2065.3536%20265.85%2065.25%20265.85C65.1464%20265.85%2065.0581%20265.813%2064.9848%20265.74C64.9116%20265.667%2064.875%20265.579%2064.875%20265.475C64.875%20265.371%2064.9116%20265.283%2064.9848%20265.21C65.0581%20265.137%2065.1464%20265.1%2065.25%20265.1C65.3536%20265.1%2065.4419%20265.137%2065.5152%20265.21C65.5884%20265.283%2065.625%20265.371%2065.625%20265.475ZM69.375%20265.475C69.375%20265.579%2069.3384%20265.667%2069.2652%20265.74C69.1919%20265.813%2069.1036%20265.85%2069%20265.85C68.8964%20265.85%2068.8081%20265.813%2068.7348%20265.74C68.6616%20265.667%2068.625%20265.579%2068.625%20265.475C68.625%20265.371%2068.6616%20265.283%2068.7348%20265.21C68.8081%20265.137%2068.8964%20265.1%2069%20265.1C69.1036%20265.1%2069.1919%20265.137%2069.2652%20265.21C69.3384%20265.283%2069.375%20265.371%2069.375%20265.475ZM73.125%20265.475C73.125%20265.579%2073.0884%20265.667%2073.0152%20265.74C72.9419%20265.813%2072.8536%20265.85%2072.75%20265.85C72.6464%20265.85%2072.5581%20265.813%2072.4848%20265.74C72.4116%20265.667%2072.375%20265.579%2072.375%20265.475C72.375%20265.371%2072.4116%20265.283%2072.4848%20265.21C72.5581%20265.137%2072.6464%20265.1%2072.75%20265.1C72.8536%20265.1%2072.9419%20265.137%2073.0152%20265.21C73.0884%20265.283%2073.125%20265.371%2073.125%20265.475ZM76.875%20265.475C76.875%20265.579%2076.8384%20265.667%2076.7652%20265.74C76.6919%20265.813%2076.6036%20265.85%2076.5%20265.85C76.3964%20265.85%2076.3081%20265.813%2076.2348%20265.74C76.1616%20265.667%2076.125%20265.579%2076.125%20265.475C76.125%20265.371%2076.1616%20265.283%2076.2348%20265.21C76.3081%20265.137%2076.3964%20265.1%2076.5%20265.1C76.6036%20265.1%2076.6919%20265.137%2076.7652%20265.21C76.8384%20265.283%2076.875%20265.371%2076.875%20265.475ZM80.625%20265.475C80.625%20265.579%2080.5884%20265.667%2080.5152%20265.74C80.4419%20265.813%2080.3536%20265.85%2080.25%20265.85C80.1464%20265.85%2080.0581%20265.813%2079.9848%20265.74C79.9116%20265.667%2079.875%20265.579%2079.875%20265.475C79.875%20265.371%2079.9116%20265.283%2079.9848%20265.21C80.0581%20265.137%2080.1464%20265.1%2080.25%20265.1C80.3536%20265.1%2080.4419%20265.137%2080.5152%20265.21C80.5884%20265.283%2080.625%20265.371%2080.625%20265.475ZM84.375%20265.475C84.375%20265.579%2084.3384%20265.667%2084.2652%20265.74C84.1919%20265.813%2084.1036%20265.85%2084%20265.85C83.8964%20265.85%2083.8081%20265.813%2083.7348%20265.74C83.6616%20265.667%2083.625%20265.579%2083.625%20265.475C83.625%20265.371%2083.6616%20265.283%2083.7348%20265.21C83.8081%20265.137%2083.8964%20265.1%2084%20265.1C84.1036%20265.1%2084.1919%20265.137%2084.2652%20265.21C84.3384%20265.283%2084.375%20265.371%2084.375%20265.475ZM88.125%20265.475C88.125%20265.579%2088.0884%20265.667%2088.0152%20265.74C87.9419%20265.813%2087.8536%20265.85%2087.75%20265.85C87.6464%20265.85%2087.5581%20265.813%2087.4848%20265.74C87.4116%20265.667%2087.375%20265.579%2087.375%20265.475C87.375%20265.371%2087.4116%20265.283%2087.4848%20265.21C87.5581%20265.137%2087.6464%20265.1%2087.75%20265.1C87.8536%20265.1%2087.9419%20265.137%2088.0152%20265.21C88.0884%20265.283%2088.125%20265.371%2088.125%20265.475ZM91.875%20265.475C91.875%20265.579%2091.8384%20265.667%2091.7652%20265.74C91.6919%20265.813%2091.6036%20265.85%2091.5%20265.85C91.3964%20265.85%2091.3081%20265.813%2091.2348%20265.74C91.1616%20265.667%2091.125%20265.579%2091.125%20265.475C91.125%20265.371%2091.1616%20265.283%2091.2348%20265.21C91.3081%20265.137%2091.3964%20265.1%2091.5%20265.1C91.6036%20265.1%2091.6919%20265.137%2091.7652%20265.21C91.8384%20265.283%2091.875%20265.371%2091.875%20265.475ZM95.625%20265.475C95.625%20265.579%2095.5884%20265.667%2095.5152%20265.74C95.4419%20265.813%2095.3535%20265.85%2095.25%20265.85C95.1464%20265.85%2095.0581%20265.813%2094.9848%20265.74C94.9116%20265.667%2094.875%20265.579%2094.875%20265.475C94.875%20265.371%2094.9116%20265.283%2094.9848%20265.21C95.0581%20265.137%2095.1464%20265.1%2095.25%20265.1C95.3535%20265.1%2095.4419%20265.137%2095.5152%20265.21C95.5884%20265.283%2095.625%20265.371%2095.625%20265.475ZM99.375%20265.475C99.375%20265.579%2099.3384%20265.667%2099.2652%20265.74C99.1919%20265.813%2099.1035%20265.85%2099%20265.85C98.8964%20265.85%2098.8081%20265.813%2098.7348%20265.74C98.6616%20265.667%2098.625%20265.579%2098.625%20265.475C98.625%20265.371%2098.6616%20265.283%2098.7348%20265.21C98.8081%20265.137%2098.8964%20265.1%2099%20265.1C99.1035%20265.1%2099.1919%20265.137%2099.2652%20265.21C99.3384%20265.283%2099.375%20265.371%2099.375%20265.475ZM103.125%20265.475C103.125%20265.579%20103.088%20265.667%20103.015%20265.74C102.942%20265.813%20102.854%20265.85%20102.75%20265.85C102.646%20265.85%20102.558%20265.813%20102.485%20265.74C102.412%20265.667%20102.375%20265.579%20102.375%20265.475C102.375%20265.371%20102.412%20265.283%20102.485%20265.21C102.558%20265.137%20102.646%20265.1%20102.75%20265.1C102.854%20265.1%20102.942%20265.137%20103.015%20265.21C103.088%20265.283%20103.125%20265.371%20103.125%20265.475ZM106.875%20265.475C106.875%20265.579%20106.838%20265.667%20106.765%20265.74C106.692%20265.813%20106.604%20265.85%20106.5%20265.85C106.396%20265.85%20106.308%20265.813%20106.235%20265.74C106.162%20265.667%20106.125%20265.579%20106.125%20265.475C106.125%20265.371%20106.162%20265.283%20106.235%20265.21C106.308%20265.137%20106.396%20265.1%20106.5%20265.1C106.604%20265.1%20106.692%20265.137%20106.765%20265.21C106.838%20265.283%20106.875%20265.371%20106.875%20265.475ZM110.625%20265.475C110.625%20265.579%20110.588%20265.667%20110.515%20265.74C110.442%20265.813%20110.354%20265.85%20110.25%20265.85C110.146%20265.85%20110.058%20265.813%20109.985%20265.74C109.912%20265.667%20109.875%20265.579%20109.875%20265.475C109.875%20265.371%20109.912%20265.283%20109.985%20265.21C110.058%20265.137%20110.146%20265.1%20110.25%20265.1C110.354%20265.1%20110.442%20265.137%20110.515%20265.21C110.588%20265.283%20110.625%20265.371%20110.625%20265.475ZM114.375%20265.475C114.375%20265.579%20114.338%20265.667%20114.265%20265.74C114.192%20265.813%20114.104%20265.85%20114%20265.85C113.896%20265.85%20113.808%20265.813%20113.735%20265.74C113.662%20265.667%20113.625%20265.579%20113.625%20265.475C113.625%20265.371%20113.662%20265.283%20113.735%20265.21C113.808%20265.137%20113.896%20265.1%20114%20265.1C114.104%20265.1%20114.192%20265.137%20114.265%20265.21C114.338%20265.283%20114.375%20265.371%20114.375%20265.475ZM118.125%20265.475C118.125%20265.579%20118.088%20265.667%20118.015%20265.74C117.942%20265.813%20117.854%20265.85%20117.75%20265.85C117.646%20265.85%20117.558%20265.813%20117.485%20265.74C117.412%20265.667%20117.375%20265.579%20117.375%20265.475C117.375%20265.371%20117.412%20265.283%20117.485%20265.21C117.558%20265.137%20117.646%20265.1%20117.75%20265.1C117.854%20265.1%20117.942%20265.137%20118.015%20265.21C118.088%20265.283%20118.125%20265.371%20118.125%20265.475ZM121.875%20265.475C121.875%20265.579%20121.838%20265.667%20121.765%20265.74C121.692%20265.813%20121.604%20265.85%20121.5%20265.85C121.396%20265.85%20121.308%20265.813%20121.235%20265.74C121.162%20265.667%20121.125%20265.579%20121.125%20265.475C121.125%20265.371%20121.162%20265.283%20121.235%20265.21C121.308%20265.137%20121.396%20265.1%20121.5%20265.1C121.604%20265.1%20121.692%20265.137%20121.765%20265.21C121.838%20265.283%20121.875%20265.371%20121.875%20265.475ZM125.625%20265.475C125.625%20265.579%20125.588%20265.667%20125.515%20265.74C125.442%20265.813%20125.354%20265.85%20125.25%20265.85C125.146%20265.85%20125.058%20265.813%20124.985%20265.74C124.912%20265.667%20124.875%20265.579%20124.875%20265.475C124.875%20265.371%20124.912%20265.283%20124.985%20265.21C125.058%20265.137%20125.146%20265.1%20125.25%20265.1C125.354%20265.1%20125.442%20265.137%20125.515%20265.21C125.588%20265.283%20125.625%20265.371%20125.625%20265.475ZM129.375%20265.475C129.375%20265.579%20129.338%20265.667%20129.265%20265.74C129.192%20265.813%20129.104%20265.85%20129%20265.85C128.896%20265.85%20128.808%20265.813%20128.735%20265.74C128.662%20265.667%20128.625%20265.579%20128.625%20265.475C128.625%20265.371%20128.662%20265.283%20128.735%20265.21C128.808%20265.137%20128.896%20265.1%20129%20265.1C129.104%20265.1%20129.192%20265.137%20129.265%20265.21C129.338%20265.283%20129.375%20265.371%20129.375%20265.475ZM133.125%20265.475C133.125%20265.579%20133.088%20265.667%20133.015%20265.74C132.942%20265.813%20132.854%20265.85%20132.75%20265.85C132.646%20265.85%20132.558%20265.813%20132.485%20265.74C132.412%20265.667%20132.375%20265.579%20132.375%20265.475C132.375%20265.371%20132.412%20265.283%20132.485%20265.21C132.558%20265.137%20132.646%20265.1%20132.75%20265.1C132.854%20265.1%20132.942%20265.137%20133.015%20265.21C133.088%20265.283%20133.125%20265.371%20133.125%20265.475ZM136.875%20265.475C136.875%20265.579%20136.838%20265.667%20136.765%20265.74C136.692%20265.813%20136.604%20265.85%20136.5%20265.85C136.396%20265.85%20136.308%20265.813%20136.235%20265.74C136.162%20265.667%20136.125%20265.579%20136.125%20265.475C136.125%20265.371%20136.162%20265.283%20136.235%20265.21C136.308%20265.137%20136.396%20265.1%20136.5%20265.1C136.604%20265.1%20136.692%20265.137%20136.765%20265.21C136.838%20265.283%20136.875%20265.371%20136.875%20265.475ZM140.625%20265.475C140.625%20265.579%20140.588%20265.667%20140.515%20265.74C140.442%20265.813%20140.354%20265.85%20140.25%20265.85C140.146%20265.85%20140.058%20265.813%20139.985%20265.74C139.912%20265.667%20139.875%20265.579%20139.875%20265.475C139.875%20265.371%20139.912%20265.283%20139.985%20265.21C140.058%20265.137%20140.146%20265.1%20140.25%20265.1C140.354%20265.1%20140.442%20265.137%20140.515%20265.21C140.588%20265.283%20140.625%20265.371%20140.625%20265.475ZM144.375%20265.475C144.375%20265.579%20144.338%20265.667%20144.265%20265.74C144.192%20265.813%20144.104%20265.85%20144%20265.85C143.896%20265.85%20143.808%20265.813%20143.735%20265.74C143.662%20265.667%20143.625%20265.579%20143.625%20265.475C143.625%20265.371%20143.662%20265.283%20143.735%20265.21C143.808%20265.137%20143.896%20265.1%20144%20265.1C144.104%20265.1%20144.192%20265.137%20144.265%20265.21C144.338%20265.283%20144.375%20265.371%20144.375%20265.475ZM148.125%20265.475C148.125%20265.579%20148.088%20265.667%20148.015%20265.74C147.942%20265.813%20147.854%20265.85%20147.75%20265.85C147.646%20265.85%20147.558%20265.813%20147.485%20265.74C147.412%20265.667%20147.375%20265.579%20147.375%20265.475C147.375%20265.371%20147.412%20265.283%20147.485%20265.21C147.558%20265.137%20147.646%20265.1%20147.75%20265.1C147.854%20265.1%20147.942%20265.137%20148.015%20265.21C148.088%20265.283%20148.125%20265.371%20148.125%20265.475ZM151.875%20265.475C151.875%20265.579%20151.838%20265.667%20151.765%20265.74C151.692%20265.813%20151.604%20265.85%20151.5%20265.85C151.396%20265.85%20151.308%20265.813%20151.235%20265.74C151.162%20265.667%20151.125%20265.579%20151.125%20265.475C151.125%20265.371%20151.162%20265.283%20151.235%20265.21C151.308%20265.137%20151.396%20265.1%20151.5%20265.1C151.604%20265.1%20151.692%20265.137%20151.765%20265.21C151.838%20265.283%20151.875%20265.371%20151.875%20265.475ZM155.625%20265.475C155.625%20265.579%20155.588%20265.667%20155.515%20265.74C155.442%20265.813%20155.354%20265.85%20155.25%20265.85C155.146%20265.85%20155.058%20265.813%20154.985%20265.74C154.912%20265.667%20154.875%20265.579%20154.875%20265.475C154.875%20265.371%20154.912%20265.283%20154.985%20265.21C155.058%20265.137%20155.146%20265.1%20155.25%20265.1C155.354%20265.1%20155.442%20265.137%20155.515%20265.21C155.588%20265.283%20155.625%20265.371%20155.625%20265.475ZM159.375%20265.475C159.375%20265.579%20159.338%20265.667%20159.265%20265.74C159.192%20265.813%20159.104%20265.85%20159%20265.85C158.896%20265.85%20158.808%20265.813%20158.735%20265.74C158.662%20265.667%20158.625%20265.579%20158.625%20265.475C158.625%20265.371%20158.662%20265.283%20158.735%20265.21C158.808%20265.137%20158.896%20265.1%20159%20265.1C159.104%20265.1%20159.192%20265.137%20159.265%20265.21C159.338%20265.283%20159.375%20265.371%20159.375%20265.475ZM163.125%20265.475C163.125%20265.579%20163.088%20265.667%20163.015%20265.74C162.942%20265.813%20162.854%20265.85%20162.75%20265.85C162.646%20265.85%20162.558%20265.813%20162.485%20265.74C162.412%20265.667%20162.375%20265.579%20162.375%20265.475C162.375%20265.371%20162.412%20265.283%20162.485%20265.21C162.558%20265.137%20162.646%20265.1%20162.75%20265.1C162.854%20265.1%20162.942%20265.137%20163.015%20265.21C163.088%20265.283%20163.125%20265.371%20163.125%20265.475ZM166.875%20265.475C166.875%20265.579%20166.838%20265.667%20166.765%20265.74C166.692%20265.813%20166.604%20265.85%20166.5%20265.85C166.396%20265.85%20166.308%20265.813%20166.235%20265.74C166.162%20265.667%20166.125%20265.579%20166.125%20265.475C166.125%20265.371%20166.162%20265.283%20166.235%20265.21C166.308%20265.137%20166.396%20265.1%20166.5%20265.1C166.604%20265.1%20166.692%20265.137%20166.765%20265.21C166.838%20265.283%20166.875%20265.371%20166.875%20265.475ZM170.625%20265.475C170.625%20265.579%20170.588%20265.667%20170.515%20265.74C170.442%20265.813%20170.354%20265.85%20170.25%20265.85C170.146%20265.85%20170.058%20265.813%20169.985%20265.74C169.912%20265.667%20169.875%20265.579%20169.875%20265.475C169.875%20265.371%20169.912%20265.283%20169.985%20265.21C170.058%20265.137%20170.146%20265.1%20170.25%20265.1C170.354%20265.1%20170.442%20265.137%20170.515%20265.21C170.588%20265.283%20170.625%20265.371%20170.625%20265.475ZM174.375%20265.475C174.375%20265.579%20174.338%20265.667%20174.265%20265.74C174.192%20265.813%20174.104%20265.85%20174%20265.85C173.896%20265.85%20173.808%20265.813%20173.735%20265.74C173.662%20265.667%20173.625%20265.579%20173.625%20265.475C173.625%20265.371%20173.662%20265.283%20173.735%20265.21C173.808%20265.137%20173.896%20265.1%20174%20265.1C174.104%20265.1%20174.192%20265.137%20174.265%20265.21C174.338%20265.283%20174.375%20265.371%20174.375%20265.475ZM178.125%20265.475C178.125%20265.579%20178.088%20265.667%20178.015%20265.74C177.942%20265.813%20177.854%20265.85%20177.75%20265.85C177.646%20265.85%20177.558%20265.813%20177.485%20265.74C177.412%20265.667%20177.375%20265.579%20177.375%20265.475C177.375%20265.371%20177.412%20265.283%20177.485%20265.21C177.558%20265.137%20177.646%20265.1%20177.75%20265.1C177.854%20265.1%20177.942%20265.137%20178.015%20265.21C178.088%20265.283%20178.125%20265.371%20178.125%20265.475ZM181.875%20265.475C181.875%20265.579%20181.838%20265.667%20181.765%20265.74C181.692%20265.813%20181.604%20265.85%20181.5%20265.85C181.396%20265.85%20181.308%20265.813%20181.235%20265.74C181.162%20265.667%20181.125%20265.579%20181.125%20265.475C181.125%20265.371%20181.162%20265.283%20181.235%20265.21C181.308%20265.137%20181.396%20265.1%20181.5%20265.1C181.604%20265.1%20181.692%20265.137%20181.765%20265.21C181.838%20265.283%20181.875%20265.371%20181.875%20265.475ZM185.625%20265.475C185.625%20265.579%20185.588%20265.667%20185.515%20265.74C185.442%20265.813%20185.354%20265.85%20185.25%20265.85C185.146%20265.85%20185.058%20265.813%20184.985%20265.74C184.912%20265.667%20184.875%20265.579%20184.875%20265.475C184.875%20265.371%20184.912%20265.283%20184.985%20265.21C185.058%20265.137%20185.146%20265.1%20185.25%20265.1C185.354%20265.1%20185.442%20265.137%20185.515%20265.21C185.588%20265.283%20185.625%20265.371%20185.625%20265.475ZM189.375%20265.475C189.375%20265.579%20189.338%20265.667%20189.265%20265.74C189.192%20265.813%20189.104%20265.85%20189%20265.85C188.896%20265.85%20188.808%20265.813%20188.735%20265.74C188.662%20265.667%20188.625%20265.579%20188.625%20265.475C188.625%20265.371%20188.662%20265.283%20188.735%20265.21C188.808%20265.137%20188.896%20265.1%20189%20265.1C189.104%20265.1%20189.192%20265.137%20189.265%20265.21C189.338%20265.283%20189.375%20265.371%20189.375%20265.475ZM193.125%20265.475C193.125%20265.579%20193.088%20265.667%20193.015%20265.74C192.942%20265.813%20192.854%20265.85%20192.75%20265.85C192.646%20265.85%20192.558%20265.813%20192.485%20265.74C192.412%20265.667%20192.375%20265.579%20192.375%20265.475C192.375%20265.371%20192.412%20265.283%20192.485%20265.21C192.558%20265.137%20192.646%20265.1%20192.75%20265.1C192.854%20265.1%20192.942%20265.137%20193.015%20265.21C193.088%20265.283%20193.125%20265.371%20193.125%20265.475ZM196.875%20265.475C196.875%20265.579%20196.838%20265.667%20196.765%20265.74C196.692%20265.813%20196.604%20265.85%20196.5%20265.85C196.396%20265.85%20196.308%20265.813%20196.235%20265.74C196.162%20265.667%20196.125%20265.579%20196.125%20265.475C196.125%20265.371%20196.162%20265.283%20196.235%20265.21C196.308%20265.137%20196.396%20265.1%20196.5%20265.1C196.604%20265.1%20196.692%20265.137%20196.765%20265.21C196.838%20265.283%20196.875%20265.371%20196.875%20265.475ZM200.625%20265.475C200.625%20265.579%20200.588%20265.667%20200.515%20265.74C200.442%20265.813%20200.354%20265.85%20200.25%20265.85C200.146%20265.85%20200.058%20265.813%20199.985%20265.74C199.912%20265.667%20199.875%20265.579%20199.875%20265.475C199.875%20265.371%20199.912%20265.283%20199.985%20265.21C200.058%20265.137%20200.146%20265.1%20200.25%20265.1C200.354%20265.1%20200.442%20265.137%20200.515%20265.21C200.588%20265.283%20200.625%20265.371%20200.625%20265.475ZM204.375%20265.475C204.375%20265.579%20204.338%20265.667%20204.265%20265.74C204.192%20265.813%20204.104%20265.85%20204%20265.85C203.896%20265.85%20203.808%20265.813%20203.735%20265.74C203.662%20265.667%20203.625%20265.579%20203.625%20265.475C203.625%20265.371%20203.662%20265.283%20203.735%20265.21C203.808%20265.137%20203.896%20265.1%20204%20265.1C204.104%20265.1%20204.192%20265.137%20204.265%20265.21C204.338%20265.283%20204.375%20265.371%20204.375%20265.475ZM208.125%20265.475C208.125%20265.579%20208.088%20265.667%20208.015%20265.74C207.942%20265.813%20207.854%20265.85%20207.75%20265.85C207.646%20265.85%20207.558%20265.813%20207.485%20265.74C207.412%20265.667%20207.375%20265.579%20207.375%20265.475C207.375%20265.371%20207.412%20265.283%20207.485%20265.21C207.558%20265.137%20207.646%20265.1%20207.75%20265.1C207.854%20265.1%20207.942%20265.137%20208.015%20265.21C208.088%20265.283%20208.125%20265.371%20208.125%20265.475ZM211.875%20265.475C211.875%20265.579%20211.838%20265.667%20211.765%20265.74C211.692%20265.813%20211.604%20265.85%20211.5%20265.85C211.396%20265.85%20211.308%20265.813%20211.235%20265.74C211.162%20265.667%20211.125%20265.579%20211.125%20265.475C211.125%20265.371%20211.162%20265.283%20211.235%20265.21C211.308%20265.137%20211.396%20265.1%20211.5%20265.1C211.604%20265.1%20211.692%20265.137%20211.765%20265.21C211.838%20265.283%20211.875%20265.371%20211.875%20265.475ZM215.625%20265.475C215.625%20265.579%20215.588%20265.667%20215.515%20265.74C215.442%20265.813%20215.354%20265.85%20215.25%20265.85C215.146%20265.85%20215.058%20265.813%20214.985%20265.74C214.912%20265.667%20214.875%20265.579%20214.875%20265.475C214.875%20265.371%20214.912%20265.283%20214.985%20265.21C215.058%20265.137%20215.146%20265.1%20215.25%20265.1C215.354%20265.1%20215.442%20265.137%20215.515%20265.21C215.588%20265.283%20215.625%20265.371%20215.625%20265.475ZM219.375%20265.475C219.375%20265.579%20219.338%20265.667%20219.265%20265.74C219.192%20265.813%20219.104%20265.85%20219%20265.85C218.896%20265.85%20218.808%20265.813%20218.735%20265.74C218.662%20265.667%20218.625%20265.579%20218.625%20265.475C218.625%20265.371%20218.662%20265.283%20218.735%20265.21C218.808%20265.137%20218.896%20265.1%20219%20265.1C219.104%20265.1%20219.192%20265.137%20219.265%20265.21C219.338%20265.283%20219.375%20265.371%20219.375%20265.475ZM223.125%20265.475C223.125%20265.579%20223.088%20265.667%20223.015%20265.74C222.942%20265.813%20222.854%20265.85%20222.75%20265.85C222.646%20265.85%20222.558%20265.813%20222.485%20265.74C222.412%20265.667%20222.375%20265.579%20222.375%20265.475C222.375%20265.371%20222.412%20265.283%20222.485%20265.21C222.558%20265.137%20222.646%20265.1%20222.75%20265.1C222.854%20265.1%20222.942%20265.137%20223.015%20265.21C223.088%20265.283%20223.125%20265.371%20223.125%20265.475ZM226.875%20265.475C226.875%20265.579%20226.838%20265.667%20226.765%20265.74C226.692%20265.813%20226.604%20265.85%20226.5%20265.85C226.396%20265.85%20226.308%20265.813%20226.235%20265.74C226.162%20265.667%20226.125%20265.579%20226.125%20265.475C226.125%20265.371%20226.162%20265.283%20226.235%20265.21C226.308%20265.137%20226.396%20265.1%20226.5%20265.1C226.604%20265.1%20226.692%20265.137%20226.765%20265.21C226.838%20265.283%20226.875%20265.371%20226.875%20265.475ZM230.625%20265.475C230.625%20265.579%20230.588%20265.667%20230.515%20265.74C230.442%20265.813%20230.354%20265.85%20230.25%20265.85C230.146%20265.85%20230.058%20265.813%20229.985%20265.74C229.912%20265.667%20229.875%20265.579%20229.875%20265.475C229.875%20265.371%20229.912%20265.283%20229.985%20265.21C230.058%20265.137%20230.146%20265.1%20230.25%20265.1C230.354%20265.1%20230.442%20265.137%20230.515%20265.21C230.588%20265.283%20230.625%20265.371%20230.625%20265.475ZM234.375%20265.475C234.375%20265.579%20234.338%20265.667%20234.265%20265.74C234.192%20265.813%20234.104%20265.85%20234%20265.85C233.896%20265.85%20233.808%20265.813%20233.735%20265.74C233.662%20265.667%20233.625%20265.579%20233.625%20265.475C233.625%20265.371%20233.662%20265.283%20233.735%20265.21C233.808%20265.137%20233.896%20265.1%20234%20265.1C234.104%20265.1%20234.192%20265.137%20234.265%20265.21C234.338%20265.283%20234.375%20265.371%20234.375%20265.475ZM238.125%20265.475C238.125%20265.579%20238.088%20265.667%20238.015%20265.74C237.942%20265.813%20237.854%20265.85%20237.75%20265.85C237.646%20265.85%20237.558%20265.813%20237.485%20265.74C237.412%20265.667%20237.375%20265.579%20237.375%20265.475C237.375%20265.371%20237.412%20265.283%20237.485%20265.21C237.558%20265.137%20237.646%20265.1%20237.75%20265.1C237.854%20265.1%20237.942%20265.137%20238.015%20265.21C238.088%20265.283%20238.125%20265.371%20238.125%20265.475ZM241.875%20265.475C241.875%20265.579%20241.838%20265.667%20241.765%20265.74C241.692%20265.813%20241.604%20265.85%20241.5%20265.85C241.396%20265.85%20241.308%20265.813%20241.235%20265.74C241.162%20265.667%20241.125%20265.579%20241.125%20265.475C241.125%20265.371%20241.162%20265.283%20241.235%20265.21C241.308%20265.137%20241.396%20265.1%20241.5%20265.1C241.604%20265.1%20241.692%20265.137%20241.765%20265.21C241.838%20265.283%20241.875%20265.371%20241.875%20265.475ZM245.625%20265.475C245.625%20265.579%20245.588%20265.667%20245.515%20265.74C245.442%20265.813%20245.354%20265.85%20245.25%20265.85C245.146%20265.85%20245.058%20265.813%20244.985%20265.74C244.912%20265.667%20244.875%20265.579%20244.875%20265.475C244.875%20265.371%20244.912%20265.283%20244.985%20265.21C245.058%20265.137%20245.146%20265.1%20245.25%20265.1C245.354%20265.1%20245.442%20265.137%20245.515%20265.21C245.588%20265.283%20245.625%20265.371%20245.625%20265.475ZM249.375%20265.475C249.375%20265.579%20249.338%20265.667%20249.265%20265.74C249.192%20265.813%20249.104%20265.85%20249%20265.85C248.896%20265.85%20248.808%20265.813%20248.735%20265.74C248.662%20265.667%20248.625%20265.579%20248.625%20265.475C248.625%20265.371%20248.662%20265.283%20248.735%20265.21C248.808%20265.137%20248.896%20265.1%20249%20265.1C249.104%20265.1%20249.192%20265.137%20249.265%20265.21C249.338%20265.283%20249.375%20265.371%20249.375%20265.475ZM253.125%20265.475C253.125%20265.579%20253.088%20265.667%20253.015%20265.74C252.942%20265.813%20252.854%20265.85%20252.75%20265.85C252.646%20265.85%20252.558%20265.813%20252.485%20265.74C252.412%20265.667%20252.375%20265.579%20252.375%20265.475C252.375%20265.371%20252.412%20265.283%20252.485%20265.21C252.558%20265.137%20252.646%20265.1%20252.75%20265.1C252.854%20265.1%20252.942%20265.137%20253.015%20265.21C253.088%20265.283%20253.125%20265.371%20253.125%20265.475ZM256.875%20265.475C256.875%20265.579%20256.838%20265.667%20256.765%20265.74C256.692%20265.813%20256.604%20265.85%20256.5%20265.85C256.396%20265.85%20256.308%20265.813%20256.235%20265.74C256.162%20265.667%20256.125%20265.579%20256.125%20265.475C256.125%20265.371%20256.162%20265.283%20256.235%20265.21C256.308%20265.137%20256.396%20265.1%20256.5%20265.1C256.604%20265.1%20256.692%20265.137%20256.765%20265.21C256.838%20265.283%20256.875%20265.371%20256.875%20265.475ZM260.625%20265.475C260.625%20265.579%20260.588%20265.667%20260.515%20265.74C260.442%20265.813%20260.354%20265.85%20260.25%20265.85C260.146%20265.85%20260.058%20265.813%20259.985%20265.74C259.912%20265.667%20259.875%20265.579%20259.875%20265.475C259.875%20265.371%20259.912%20265.283%20259.985%20265.21C260.058%20265.137%20260.146%20265.1%20260.25%20265.1C260.354%20265.1%20260.442%20265.137%20260.515%20265.21C260.588%20265.283%20260.625%20265.371%20260.625%20265.475ZM264.375%20265.475C264.375%20265.579%20264.338%20265.667%20264.265%20265.74C264.192%20265.813%20264.104%20265.85%20264%20265.85C263.896%20265.85%20263.808%20265.813%20263.735%20265.74C263.662%20265.667%20263.625%20265.579%20263.625%20265.475C263.625%20265.371%20263.662%20265.283%20263.735%20265.21C263.808%20265.137%20263.896%20265.1%20264%20265.1C264.104%20265.1%20264.192%20265.137%20264.265%20265.21C264.338%20265.283%20264.375%20265.371%20264.375%20265.475ZM268.125%20265.475C268.125%20265.579%20268.088%20265.667%20268.015%20265.74C267.942%20265.813%20267.854%20265.85%20267.75%20265.85C267.646%20265.85%20267.558%20265.813%20267.485%20265.74C267.412%20265.667%20267.375%20265.579%20267.375%20265.475C267.375%20265.371%20267.412%20265.283%20267.485%20265.21C267.558%20265.137%20267.646%20265.1%20267.75%20265.1C267.854%20265.1%20267.942%20265.137%20268.015%20265.21C268.088%20265.283%20268.125%20265.371%20268.125%20265.475ZM271.875%20265.475C271.875%20265.579%20271.838%20265.667%20271.765%20265.74C271.692%20265.813%20271.604%20265.85%20271.5%20265.85C271.396%20265.85%20271.308%20265.813%20271.235%20265.74C271.162%20265.667%20271.125%20265.579%20271.125%20265.475C271.125%20265.371%20271.162%20265.283%20271.235%20265.21C271.308%20265.137%20271.396%20265.1%20271.5%20265.1C271.604%20265.1%20271.692%20265.137%20271.765%20265.21C271.838%20265.283%20271.875%20265.371%20271.875%20265.475ZM275.625%20265.475C275.625%20265.579%20275.588%20265.667%20275.515%20265.74C275.442%20265.813%20275.354%20265.85%20275.25%20265.85C275.146%20265.85%20275.058%20265.813%20274.985%20265.74C274.912%20265.667%20274.875%20265.579%20274.875%20265.475C274.875%20265.371%20274.912%20265.283%20274.985%20265.21C275.058%20265.137%20275.146%20265.1%20275.25%20265.1C275.354%20265.1%20275.442%20265.137%20275.515%20265.21C275.588%20265.283%20275.625%20265.371%20275.625%20265.475ZM279.375%20265.475C279.375%20265.579%20279.338%20265.667%20279.265%20265.74C279.192%20265.813%20279.104%20265.85%20279%20265.85C278.896%20265.85%20278.808%20265.813%20278.735%20265.74C278.662%20265.667%20278.625%20265.579%20278.625%20265.475C278.625%20265.371%20278.662%20265.283%20278.735%20265.21C278.808%20265.137%20278.896%20265.1%20279%20265.1C279.104%20265.1%20279.192%20265.137%20279.265%20265.21C279.338%20265.283%20279.375%20265.371%20279.375%20265.475ZM283.125%20265.475C283.125%20265.579%20283.088%20265.667%20283.015%20265.74C282.942%20265.813%20282.854%20265.85%20282.75%20265.85C282.646%20265.85%20282.558%20265.813%20282.485%20265.74C282.412%20265.667%20282.375%20265.579%20282.375%20265.475C282.375%20265.371%20282.412%20265.283%20282.485%20265.21C282.558%20265.137%20282.646%20265.1%20282.75%20265.1C282.854%20265.1%20282.942%20265.137%20283.015%20265.21C283.088%20265.283%20283.125%20265.371%20283.125%20265.475ZM286.875%20265.475C286.875%20265.579%20286.838%20265.667%20286.765%20265.74C286.692%20265.813%20286.604%20265.85%20286.5%20265.85C286.396%20265.85%20286.308%20265.813%20286.235%20265.74C286.162%20265.667%20286.125%20265.579%20286.125%20265.475C286.125%20265.371%20286.162%20265.283%20286.235%20265.21C286.308%20265.137%20286.396%20265.1%20286.5%20265.1C286.604%20265.1%20286.692%20265.137%20286.765%20265.21C286.838%20265.283%20286.875%20265.371%20286.875%20265.475ZM290.625%20265.475C290.625%20265.579%20290.588%20265.667%20290.515%20265.74C290.442%20265.813%20290.354%20265.85%20290.25%20265.85C290.146%20265.85%20290.058%20265.813%20289.985%20265.74C289.912%20265.667%20289.875%20265.579%20289.875%20265.475C289.875%20265.371%20289.912%20265.283%20289.985%20265.21C290.058%20265.137%20290.146%20265.1%20290.25%20265.1C290.354%20265.1%20290.442%20265.137%20290.515%20265.21C290.588%20265.283%20290.625%20265.371%20290.625%20265.475ZM294.375%20265.475C294.375%20265.579%20294.338%20265.667%20294.265%20265.74C294.192%20265.813%20294.104%20265.85%20294%20265.85C293.896%20265.85%20293.808%20265.813%20293.735%20265.74C293.662%20265.667%20293.625%20265.579%20293.625%20265.475C293.625%20265.371%20293.662%20265.283%20293.735%20265.21C293.808%20265.137%20293.896%20265.1%20294%20265.1C294.104%20265.1%20294.192%20265.137%20294.265%20265.21C294.338%20265.283%20294.375%20265.371%20294.375%20265.475ZM298.125%20265.475C298.125%20265.579%20298.088%20265.667%20298.015%20265.74C297.942%20265.813%20297.854%20265.85%20297.75%20265.85C297.646%20265.85%20297.558%20265.813%20297.485%20265.74C297.412%20265.667%20297.375%20265.579%20297.375%20265.475C297.375%20265.371%20297.412%20265.283%20297.485%20265.21C297.558%20265.137%20297.646%20265.1%20297.75%20265.1C297.854%20265.1%20297.942%20265.137%20298.015%20265.21C298.088%20265.283%20298.125%20265.371%20298.125%20265.475ZM301.875%20265.475C301.875%20265.579%20301.838%20265.667%20301.765%20265.74C301.692%20265.813%20301.604%20265.85%20301.5%20265.85C301.396%20265.85%20301.308%20265.813%20301.235%20265.74C301.162%20265.667%20301.125%20265.579%20301.125%20265.475C301.125%20265.371%20301.162%20265.283%20301.235%20265.21C301.308%20265.137%20301.396%20265.1%20301.5%20265.1C301.604%20265.1%20301.692%20265.137%20301.765%20265.21C301.838%20265.283%20301.875%20265.371%20301.875%20265.475ZM305.625%20265.475C305.625%20265.579%20305.588%20265.667%20305.515%20265.74C305.442%20265.813%20305.354%20265.85%20305.25%20265.85C305.146%20265.85%20305.058%20265.813%20304.985%20265.74C304.912%20265.667%20304.875%20265.579%20304.875%20265.475C304.875%20265.371%20304.912%20265.283%20304.985%20265.21C305.058%20265.137%20305.146%20265.1%20305.25%20265.1C305.354%20265.1%20305.442%20265.137%20305.515%20265.21C305.588%20265.283%20305.625%20265.371%20305.625%20265.475ZM309.375%20265.475C309.375%20265.579%20309.338%20265.667%20309.265%20265.74C309.192%20265.813%20309.104%20265.85%20309%20265.85C308.896%20265.85%20308.808%20265.813%20308.735%20265.74C308.662%20265.667%20308.625%20265.579%20308.625%20265.475C308.625%20265.371%20308.662%20265.283%20308.735%20265.21C308.808%20265.137%20308.896%20265.1%20309%20265.1C309.104%20265.1%20309.192%20265.137%20309.265%20265.21C309.338%20265.283%20309.375%20265.371%20309.375%20265.475ZM313.125%20265.475C313.125%20265.579%20313.088%20265.667%20313.015%20265.74C312.942%20265.813%20312.854%20265.85%20312.75%20265.85C312.646%20265.85%20312.558%20265.813%20312.485%20265.74C312.412%20265.667%20312.375%20265.579%20312.375%20265.475C312.375%20265.371%20312.412%20265.283%20312.485%20265.21C312.558%20265.137%20312.646%20265.1%20312.75%20265.1C312.854%20265.1%20312.942%20265.137%20313.015%20265.21C313.088%20265.283%20313.125%20265.371%20313.125%20265.475ZM316.875%20265.475C316.875%20265.579%20316.838%20265.667%20316.765%20265.74C316.692%20265.813%20316.604%20265.85%20316.5%20265.85C316.396%20265.85%20316.308%20265.813%20316.235%20265.74C316.162%20265.667%20316.125%20265.579%20316.125%20265.475C316.125%20265.371%20316.162%20265.283%20316.235%20265.21C316.308%20265.137%20316.396%20265.1%20316.5%20265.1C316.604%20265.1%20316.692%20265.137%20316.765%20265.21C316.838%20265.283%20316.875%20265.371%20316.875%20265.475ZM320.625%20265.475C320.625%20265.579%20320.588%20265.667%20320.515%20265.74C320.442%20265.813%20320.354%20265.85%20320.25%20265.85C320.146%20265.85%20320.058%20265.813%20319.985%20265.74C319.912%20265.667%20319.875%20265.579%20319.875%20265.475C319.875%20265.371%20319.912%20265.283%20319.985%20265.21C320.058%20265.137%20320.146%20265.1%20320.25%20265.1C320.354%20265.1%20320.442%20265.137%20320.515%20265.21C320.588%20265.283%20320.625%20265.371%20320.625%20265.475ZM324.375%20265.475C324.375%20265.579%20324.338%20265.667%20324.265%20265.74C324.192%20265.813%20324.104%20265.85%20324%20265.85C323.896%20265.85%20323.808%20265.813%20323.735%20265.74C323.662%20265.667%20323.625%20265.579%20323.625%20265.475C323.625%20265.371%20323.662%20265.283%20323.735%20265.21C323.808%20265.137%20323.896%20265.1%20324%20265.1C324.104%20265.1%20324.192%20265.137%20324.265%20265.21C324.338%20265.283%20324.375%20265.371%20324.375%20265.475ZM328.125%20265.475C328.125%20265.579%20328.088%20265.667%20328.015%20265.74C327.942%20265.813%20327.854%20265.85%20327.75%20265.85C327.646%20265.85%20327.558%20265.813%20327.485%20265.74C327.412%20265.667%20327.375%20265.579%20327.375%20265.475C327.375%20265.371%20327.412%20265.283%20327.485%20265.21C327.558%20265.137%20327.646%20265.1%20327.75%20265.1C327.854%20265.1%20327.942%20265.137%20328.015%20265.21C328.088%20265.283%20328.125%20265.371%20328.125%20265.475ZM331.875%20265.475C331.875%20265.579%20331.838%20265.667%20331.765%20265.74C331.692%20265.813%20331.604%20265.85%20331.5%20265.85C331.396%20265.85%20331.308%20265.813%20331.235%20265.74C331.162%20265.667%20331.125%20265.579%20331.125%20265.475C331.125%20265.371%20331.162%20265.283%20331.235%20265.21C331.308%20265.137%20331.396%20265.1%20331.5%20265.1C331.604%20265.1%20331.692%20265.137%20331.765%20265.21C331.838%20265.283%20331.875%20265.371%20331.875%20265.475ZM335.625%20265.475C335.625%20265.579%20335.588%20265.667%20335.515%20265.74C335.442%20265.813%20335.354%20265.85%20335.25%20265.85C335.146%20265.85%20335.058%20265.813%20334.985%20265.74C334.912%20265.667%20334.875%20265.579%20334.875%20265.475C334.875%20265.371%20334.912%20265.283%20334.985%20265.21C335.058%20265.137%20335.146%20265.1%20335.25%20265.1C335.354%20265.1%20335.442%20265.137%20335.515%20265.21C335.588%20265.283%20335.625%20265.371%20335.625%20265.475ZM339.375%20265.475C339.375%20265.579%20339.338%20265.667%20339.265%20265.74C339.192%20265.813%20339.104%20265.85%20339%20265.85C338.896%20265.85%20338.808%20265.813%20338.735%20265.74C338.662%20265.667%20338.625%20265.579%20338.625%20265.475C338.625%20265.371%20338.662%20265.283%20338.735%20265.21C338.808%20265.137%20338.896%20265.1%20339%20265.1C339.104%20265.1%20339.192%20265.137%20339.265%20265.21C339.338%20265.283%20339.375%20265.371%20339.375%20265.475ZM343.125%20265.475C343.125%20265.579%20343.088%20265.667%20343.015%20265.74C342.942%20265.813%20342.854%20265.85%20342.75%20265.85C342.646%20265.85%20342.558%20265.813%20342.485%20265.74C342.412%20265.667%20342.375%20265.579%20342.375%20265.475C342.375%20265.371%20342.412%20265.283%20342.485%20265.21C342.558%20265.137%20342.646%20265.1%20342.75%20265.1C342.854%20265.1%20342.942%20265.137%20343.015%20265.21C343.088%20265.283%20343.125%20265.371%20343.125%20265.475ZM346.875%20265.475C346.875%20265.579%20346.838%20265.667%20346.765%20265.74C346.692%20265.813%20346.604%20265.85%20346.5%20265.85C346.396%20265.85%20346.308%20265.813%20346.235%20265.74C346.162%20265.667%20346.125%20265.579%20346.125%20265.475C346.125%20265.371%20346.162%20265.283%20346.235%20265.21C346.308%20265.137%20346.396%20265.1%20346.5%20265.1C346.604%20265.1%20346.692%20265.137%20346.765%20265.21C346.838%20265.283%20346.875%20265.371%20346.875%20265.475ZM350.625%20265.475C350.625%20265.579%20350.588%20265.667%20350.515%20265.74C350.442%20265.813%20350.353%20265.85%20350.25%20265.85C350.146%20265.85%20350.058%20265.813%20349.985%20265.74C349.912%20265.667%20349.875%20265.579%20349.875%20265.475C349.875%20265.371%20349.912%20265.283%20349.985%20265.21C350.058%20265.137%20350.146%20265.1%20350.25%20265.1C350.353%20265.1%20350.442%20265.137%20350.515%20265.21C350.588%20265.283%20350.625%20265.371%20350.625%20265.475ZM354.375%20265.475C354.375%20265.579%20354.338%20265.667%20354.265%20265.74C354.192%20265.813%20354.104%20265.85%20354%20265.85C353.896%20265.85%20353.808%20265.813%20353.735%20265.74C353.662%20265.667%20353.625%20265.579%20353.625%20265.475C353.625%20265.371%20353.662%20265.283%20353.735%20265.21C353.808%20265.137%20353.896%20265.1%20354%20265.1C354.104%20265.1%20354.192%20265.137%20354.265%20265.21C354.338%20265.283%20354.375%20265.371%20354.375%20265.475ZM358.125%20265.475C358.125%20265.579%20358.088%20265.667%20358.015%20265.74C357.942%20265.813%20357.854%20265.85%20357.75%20265.85C357.646%20265.85%20357.558%20265.813%20357.485%20265.74C357.412%20265.667%20357.375%20265.579%20357.375%20265.475C357.375%20265.371%20357.412%20265.283%20357.485%20265.21C357.558%20265.137%20357.646%20265.1%20357.75%20265.1C357.854%20265.1%20357.942%20265.137%20358.015%20265.21C358.088%20265.283%20358.125%20265.371%20358.125%20265.475ZM361.875%20265.475C361.875%20265.579%20361.838%20265.667%20361.765%20265.74C361.692%20265.813%20361.603%20265.85%20361.5%20265.85C361.396%20265.85%20361.308%20265.813%20361.235%20265.74C361.162%20265.667%20361.125%20265.579%20361.125%20265.475C361.125%20265.371%20361.162%20265.283%20361.235%20265.21C361.308%20265.137%20361.396%20265.1%20361.5%20265.1C361.603%20265.1%20361.692%20265.137%20361.765%20265.21C361.838%20265.283%20361.875%20265.371%20361.875%20265.475ZM365.625%20265.475C365.625%20265.579%20365.588%20265.667%20365.515%20265.74C365.442%20265.813%20365.354%20265.85%20365.25%20265.85C365.146%20265.85%20365.058%20265.813%20364.985%20265.74C364.912%20265.667%20364.875%20265.579%20364.875%20265.475C364.875%20265.371%20364.912%20265.283%20364.985%20265.21C365.058%20265.137%20365.146%20265.1%20365.25%20265.1C365.354%20265.1%20365.442%20265.137%20365.515%20265.21C365.588%20265.283%20365.625%20265.371%20365.625%20265.475ZM369.375%20265.475C369.375%20265.579%20369.338%20265.667%20369.265%20265.74C369.192%20265.813%20369.104%20265.85%20369%20265.85C368.896%20265.85%20368.808%20265.813%20368.735%20265.74C368.662%20265.667%20368.625%20265.579%20368.625%20265.475C368.625%20265.371%20368.662%20265.283%20368.735%20265.21C368.808%20265.137%20368.896%20265.1%20369%20265.1C369.104%20265.1%20369.192%20265.137%20369.265%20265.21C369.338%20265.283%20369.375%20265.371%20369.375%20265.475ZM373.125%20265.475C373.125%20265.579%20373.088%20265.667%20373.015%20265.74C372.942%20265.813%20372.854%20265.85%20372.75%20265.85C372.646%20265.85%20372.558%20265.813%20372.485%20265.74C372.412%20265.667%20372.375%20265.579%20372.375%20265.475C372.375%20265.371%20372.412%20265.283%20372.485%20265.21C372.558%20265.137%20372.646%20265.1%20372.75%20265.1C372.854%20265.1%20372.942%20265.137%20373.015%20265.21C373.088%20265.283%20373.125%20265.371%20373.125%20265.475ZM376.875%20265.475C376.875%20265.579%20376.838%20265.667%20376.765%20265.74C376.692%20265.813%20376.604%20265.85%20376.5%20265.85C376.396%20265.85%20376.308%20265.813%20376.235%20265.74C376.162%20265.667%20376.125%20265.579%20376.125%20265.475C376.125%20265.371%20376.162%20265.283%20376.235%20265.21C376.308%20265.137%20376.396%20265.1%20376.5%20265.1C376.604%20265.1%20376.692%20265.137%20376.765%20265.21C376.838%20265.283%20376.875%20265.371%20376.875%20265.475ZM380.625%20265.475C380.625%20265.579%20380.588%20265.667%20380.515%20265.74C380.442%20265.813%20380.354%20265.85%20380.25%20265.85C380.146%20265.85%20380.058%20265.813%20379.985%20265.74C379.912%20265.667%20379.875%20265.579%20379.875%20265.475C379.875%20265.371%20379.912%20265.283%20379.985%20265.21C380.058%20265.137%20380.146%20265.1%20380.25%20265.1C380.354%20265.1%20380.442%20265.137%20380.515%20265.21C380.588%20265.283%20380.625%20265.371%20380.625%20265.475ZM384.375%20265.475C384.375%20265.579%20384.338%20265.667%20384.265%20265.74C384.192%20265.813%20384.104%20265.85%20384%20265.85C383.896%20265.85%20383.808%20265.813%20383.735%20265.74C383.662%20265.667%20383.625%20265.579%20383.625%20265.475C383.625%20265.371%20383.662%20265.283%20383.735%20265.21C383.808%20265.137%20383.896%20265.1%20384%20265.1C384.104%20265.1%20384.192%20265.137%20384.265%20265.21C384.338%20265.283%20384.375%20265.371%20384.375%20265.475ZM388.125%20265.475C388.125%20265.579%20388.088%20265.667%20388.015%20265.74C387.942%20265.813%20387.854%20265.85%20387.75%20265.85C387.646%20265.85%20387.558%20265.813%20387.485%20265.74C387.412%20265.667%20387.375%20265.579%20387.375%20265.475C387.375%20265.371%20387.412%20265.283%20387.485%20265.21C387.558%20265.137%20387.646%20265.1%20387.75%20265.1C387.854%20265.1%20387.942%20265.137%20388.015%20265.21C388.088%20265.283%20388.125%20265.371%20388.125%20265.475ZM391.875%20265.475C391.875%20265.579%20391.838%20265.667%20391.765%20265.74C391.692%20265.813%20391.603%20265.85%20391.5%20265.85C391.396%20265.85%20391.308%20265.813%20391.235%20265.74C391.162%20265.667%20391.125%20265.579%20391.125%20265.475C391.125%20265.371%20391.162%20265.283%20391.235%20265.21C391.308%20265.137%20391.396%20265.1%20391.5%20265.1C391.603%20265.1%20391.692%20265.137%20391.765%20265.21C391.838%20265.283%20391.875%20265.371%20391.875%20265.475ZM395.625%20265.475C395.625%20265.579%20395.588%20265.667%20395.515%20265.74C395.442%20265.813%20395.354%20265.85%20395.25%20265.85C395.146%20265.85%20395.058%20265.813%20394.985%20265.74C394.912%20265.667%20394.875%20265.579%20394.875%20265.475C394.875%20265.371%20394.912%20265.283%20394.985%20265.21C395.058%20265.137%20395.146%20265.1%20395.25%20265.1C395.354%20265.1%20395.442%20265.137%20395.515%20265.21C395.588%20265.283%20395.625%20265.371%20395.625%20265.475ZM399.375%20265.475C399.375%20265.579%20399.338%20265.667%20399.265%20265.74C399.192%20265.813%20399.104%20265.85%20399%20265.85C398.896%20265.85%20398.808%20265.813%20398.735%20265.74C398.662%20265.667%20398.625%20265.579%20398.625%20265.475C398.625%20265.371%20398.662%20265.283%20398.735%20265.21C398.808%20265.137%20398.896%20265.1%20399%20265.1C399.104%20265.1%20399.192%20265.137%20399.265%20265.21C399.338%20265.283%20399.375%20265.371%20399.375%20265.475ZM403.125%20265.475C403.125%20265.579%20403.088%20265.667%20403.015%20265.74C402.942%20265.813%20402.854%20265.85%20402.75%20265.85C402.646%20265.85%20402.558%20265.813%20402.485%20265.74C402.412%20265.667%20402.375%20265.579%20402.375%20265.475C402.375%20265.371%20402.412%20265.283%20402.485%20265.21C402.558%20265.137%20402.646%20265.1%20402.75%20265.1C402.854%20265.1%20402.942%20265.137%20403.015%20265.21C403.088%20265.283%20403.125%20265.371%20403.125%20265.475ZM406.875%20265.475C406.875%20265.579%20406.838%20265.667%20406.765%20265.74C406.692%20265.813%20406.604%20265.85%20406.5%20265.85C406.396%20265.85%20406.308%20265.813%20406.235%20265.74C406.162%20265.667%20406.125%20265.579%20406.125%20265.475C406.125%20265.371%20406.162%20265.283%20406.235%20265.21C406.308%20265.137%20406.396%20265.1%20406.5%20265.1C406.604%20265.1%20406.692%20265.137%20406.765%20265.21C406.838%20265.283%20406.875%20265.371%20406.875%20265.475ZM410.625%20265.475C410.625%20265.579%20410.588%20265.667%20410.515%20265.74C410.442%20265.813%20410.354%20265.85%20410.25%20265.85C410.146%20265.85%20410.058%20265.813%20409.985%20265.74C409.912%20265.667%20409.875%20265.579%20409.875%20265.475C409.875%20265.371%20409.912%20265.283%20409.985%20265.21C410.058%20265.137%20410.146%20265.1%20410.25%20265.1C410.354%20265.1%20410.442%20265.137%20410.515%20265.21C410.588%20265.283%20410.625%20265.371%20410.625%20265.475ZM414.375%20265.475C414.375%20265.579%20414.338%20265.667%20414.265%20265.74C414.192%20265.813%20414.104%20265.85%20414%20265.85C413.896%20265.85%20413.808%20265.813%20413.735%20265.74C413.662%20265.667%20413.625%20265.579%20413.625%20265.475C413.625%20265.371%20413.662%20265.283%20413.735%20265.21C413.808%20265.137%20413.896%20265.1%20414%20265.1C414.104%20265.1%20414.192%20265.137%20414.265%20265.21C414.338%20265.283%20414.375%20265.371%20414.375%20265.475ZM418.125%20265.475C418.125%20265.579%20418.088%20265.667%20418.015%20265.74C417.942%20265.813%20417.854%20265.85%20417.75%20265.85C417.646%20265.85%20417.558%20265.813%20417.485%20265.74C417.412%20265.667%20417.375%20265.579%20417.375%20265.475C417.375%20265.371%20417.412%20265.283%20417.485%20265.21C417.558%20265.137%20417.646%20265.1%20417.75%20265.1C417.854%20265.1%20417.942%20265.137%20418.015%20265.21C418.088%20265.283%20418.125%20265.371%20418.125%20265.475ZM421.875%20265.475C421.875%20265.579%20421.838%20265.667%20421.765%20265.74C421.692%20265.813%20421.604%20265.85%20421.5%20265.85C421.396%20265.85%20421.308%20265.813%20421.235%20265.74C421.162%20265.667%20421.125%20265.579%20421.125%20265.475C421.125%20265.371%20421.162%20265.283%20421.235%20265.21C421.308%20265.137%20421.396%20265.1%20421.5%20265.1C421.604%20265.1%20421.692%20265.137%20421.765%20265.21C421.838%20265.283%20421.875%20265.371%20421.875%20265.475ZM425.625%20265.475C425.625%20265.579%20425.588%20265.667%20425.515%20265.74C425.442%20265.813%20425.354%20265.85%20425.25%20265.85C425.146%20265.85%20425.058%20265.813%20424.985%20265.74C424.912%20265.667%20424.875%20265.579%20424.875%20265.475C424.875%20265.371%20424.912%20265.283%20424.985%20265.21C425.058%20265.137%20425.146%20265.1%20425.25%20265.1C425.354%20265.1%20425.442%20265.137%20425.515%20265.21C425.588%20265.283%20425.625%20265.371%20425.625%20265.475ZM429.375%20265.475C429.375%20265.579%20429.338%20265.667%20429.265%20265.74C429.192%20265.813%20429.104%20265.85%20429%20265.85C428.896%20265.85%20428.808%20265.813%20428.735%20265.74C428.662%20265.667%20428.625%20265.579%20428.625%20265.475C428.625%20265.371%20428.662%20265.283%20428.735%20265.21C428.808%20265.137%20428.896%20265.1%20429%20265.1C429.104%20265.1%20429.192%20265.137%20429.265%20265.21C429.338%20265.283%20429.375%20265.371%20429.375%20265.475ZM433.125%20265.475C433.125%20265.579%20433.088%20265.667%20433.015%20265.74C432.942%20265.813%20432.854%20265.85%20432.75%20265.85C432.646%20265.85%20432.558%20265.813%20432.485%20265.74C432.412%20265.667%20432.375%20265.579%20432.375%20265.475C432.375%20265.371%20432.412%20265.283%20432.485%20265.21C432.558%20265.137%20432.646%20265.1%20432.75%20265.1C432.854%20265.1%20432.942%20265.137%20433.015%20265.21C433.088%20265.283%20433.125%20265.371%20433.125%20265.475ZM436.875%20265.475C436.875%20265.579%20436.838%20265.667%20436.765%20265.74C436.692%20265.813%20436.604%20265.85%20436.5%20265.85C436.396%20265.85%20436.308%20265.813%20436.235%20265.74C436.162%20265.667%20436.125%20265.579%20436.125%20265.475C436.125%20265.371%20436.162%20265.283%20436.235%20265.21C436.308%20265.137%20436.396%20265.1%20436.5%20265.1C436.604%20265.1%20436.692%20265.137%20436.765%20265.21C436.838%20265.283%20436.875%20265.371%20436.875%20265.475ZM440.625%20265.475C440.625%20265.579%20440.588%20265.667%20440.515%20265.74C440.442%20265.813%20440.354%20265.85%20440.25%20265.85C440.146%20265.85%20440.058%20265.813%20439.985%20265.74C439.912%20265.667%20439.875%20265.579%20439.875%20265.475C439.875%20265.371%20439.912%20265.283%20439.985%20265.21C440.058%20265.137%20440.146%20265.1%20440.25%20265.1C440.354%20265.1%20440.442%20265.137%20440.515%20265.21C440.588%20265.283%20440.625%20265.371%20440.625%20265.475ZM444.375%20265.475C444.375%20265.579%20444.338%20265.667%20444.265%20265.74C444.192%20265.813%20444.104%20265.85%20444%20265.85C443.896%20265.85%20443.808%20265.813%20443.735%20265.74C443.662%20265.667%20443.625%20265.579%20443.625%20265.475C443.625%20265.371%20443.662%20265.283%20443.735%20265.21C443.808%20265.137%20443.896%20265.1%20444%20265.1C444.104%20265.1%20444.192%20265.137%20444.265%20265.21C444.338%20265.283%20444.375%20265.371%20444.375%20265.475ZM448.125%20265.475C448.125%20265.579%20448.088%20265.667%20448.015%20265.74C447.942%20265.813%20447.854%20265.85%20447.75%20265.85C447.646%20265.85%20447.558%20265.813%20447.485%20265.74C447.412%20265.667%20447.375%20265.579%20447.375%20265.475C447.375%20265.371%20447.412%20265.283%20447.485%20265.21C447.558%20265.137%20447.646%20265.1%20447.75%20265.1C447.854%20265.1%20447.942%20265.137%20448.015%20265.21C448.088%20265.283%20448.125%20265.371%20448.125%20265.475ZM451.875%20265.475C451.875%20265.579%20451.838%20265.667%20451.765%20265.74C451.692%20265.813%20451.604%20265.85%20451.5%20265.85C451.396%20265.85%20451.308%20265.813%20451.235%20265.74C451.162%20265.667%20451.125%20265.579%20451.125%20265.475C451.125%20265.371%20451.162%20265.283%20451.235%20265.21C451.308%20265.137%20451.396%20265.1%20451.5%20265.1C451.604%20265.1%20451.692%20265.137%20451.765%20265.21C451.838%20265.283%20451.875%20265.371%20451.875%20265.475ZM455.625%20265.475C455.625%20265.579%20455.588%20265.667%20455.515%20265.74C455.442%20265.813%20455.354%20265.85%20455.25%20265.85C455.146%20265.85%20455.058%20265.813%20454.985%20265.74C454.912%20265.667%20454.875%20265.579%20454.875%20265.475C454.875%20265.371%20454.912%20265.283%20454.985%20265.21C455.058%20265.137%20455.146%20265.1%20455.25%20265.1C455.354%20265.1%20455.442%20265.137%20455.515%20265.21C455.588%20265.283%20455.625%20265.371%20455.625%20265.475ZM459.375%20265.475C459.375%20265.579%20459.338%20265.667%20459.265%20265.74C459.192%20265.813%20459.103%20265.85%20459%20265.85C458.896%20265.85%20458.808%20265.813%20458.735%20265.74C458.662%20265.667%20458.625%20265.579%20458.625%20265.475C458.625%20265.371%20458.662%20265.283%20458.735%20265.21C458.808%20265.137%20458.896%20265.1%20459%20265.1C459.103%20265.1%20459.192%20265.137%20459.265%20265.21C459.338%20265.283%20459.375%20265.371%20459.375%20265.475ZM463.125%20265.475C463.125%20265.579%20463.088%20265.667%20463.015%20265.74C462.942%20265.813%20462.853%20265.85%20462.75%20265.85C462.646%20265.85%20462.558%20265.813%20462.485%20265.74C462.412%20265.667%20462.375%20265.579%20462.375%20265.475C462.375%20265.371%20462.412%20265.283%20462.485%20265.21C462.558%20265.137%20462.646%20265.1%20462.75%20265.1C462.853%20265.1%20462.942%20265.137%20463.015%20265.21C463.088%20265.283%20463.125%20265.371%20463.125%20265.475ZM466.875%20265.475C466.875%20265.579%20466.838%20265.667%20466.765%20265.74C466.692%20265.813%20466.604%20265.85%20466.5%20265.85C466.396%20265.85%20466.308%20265.813%20466.235%20265.74C466.162%20265.667%20466.125%20265.579%20466.125%20265.475C466.125%20265.371%20466.162%20265.283%20466.235%20265.21C466.308%20265.137%20466.396%20265.1%20466.5%20265.1C466.604%20265.1%20466.692%20265.137%20466.765%20265.21C466.838%20265.283%20466.875%20265.371%20466.875%20265.475ZM470.625%20265.475C470.625%20265.579%20470.588%20265.667%20470.515%20265.74C470.442%20265.813%20470.354%20265.85%20470.25%20265.85C470.146%20265.85%20470.058%20265.813%20469.985%20265.74C469.912%20265.667%20469.875%20265.579%20469.875%20265.475C469.875%20265.371%20469.912%20265.283%20469.985%20265.21C470.058%20265.137%20470.146%20265.1%20470.25%20265.1C470.354%20265.1%20470.442%20265.137%20470.515%20265.21C470.588%20265.283%20470.625%20265.371%20470.625%20265.475ZM474.375%20265.475C474.375%20265.579%20474.338%20265.667%20474.265%20265.74C474.192%20265.813%20474.104%20265.85%20474%20265.85C473.896%20265.85%20473.808%20265.813%20473.735%20265.74C473.662%20265.667%20473.625%20265.579%20473.625%20265.475C473.625%20265.371%20473.662%20265.283%20473.735%20265.21C473.808%20265.137%20473.896%20265.1%20474%20265.1C474.104%20265.1%20474.192%20265.137%20474.265%20265.21C474.338%20265.283%20474.375%20265.371%20474.375%20265.475ZM478.125%20265.475C478.125%20265.579%20478.088%20265.667%20478.015%20265.74C477.942%20265.813%20477.854%20265.85%20477.75%20265.85C477.646%20265.85%20477.558%20265.813%20477.485%20265.74C477.412%20265.667%20477.375%20265.579%20477.375%20265.475C477.375%20265.371%20477.412%20265.283%20477.485%20265.21C477.558%20265.137%20477.646%20265.1%20477.75%20265.1C477.854%20265.1%20477.942%20265.137%20478.015%20265.21C478.088%20265.283%20478.125%20265.371%20478.125%20265.475ZM481.875%20265.475C481.875%20265.579%20481.838%20265.667%20481.765%20265.74C481.692%20265.813%20481.604%20265.85%20481.5%20265.85C481.396%20265.85%20481.308%20265.813%20481.235%20265.74C481.162%20265.667%20481.125%20265.579%20481.125%20265.475C481.125%20265.371%20481.162%20265.283%20481.235%20265.21C481.308%20265.137%20481.396%20265.1%20481.5%20265.1C481.604%20265.1%20481.692%20265.137%20481.765%20265.21C481.838%20265.283%20481.875%20265.371%20481.875%20265.475ZM485.625%20265.475C485.625%20265.579%20485.588%20265.667%20485.515%20265.74C485.442%20265.813%20485.354%20265.85%20485.25%20265.85C485.146%20265.85%20485.058%20265.813%20484.985%20265.74C484.912%20265.667%20484.875%20265.579%20484.875%20265.475C484.875%20265.371%20484.912%20265.283%20484.985%20265.21C485.058%20265.137%20485.146%20265.1%20485.25%20265.1C485.354%20265.1%20485.442%20265.137%20485.515%20265.21C485.588%20265.283%20485.625%20265.371%20485.625%20265.475ZM489.375%20265.475C489.375%20265.579%20489.338%20265.667%20489.265%20265.74C489.192%20265.813%20489.104%20265.85%20489%20265.85C488.896%20265.85%20488.808%20265.813%20488.735%20265.74C488.662%20265.667%20488.625%20265.579%20488.625%20265.475C488.625%20265.371%20488.662%20265.283%20488.735%20265.21C488.808%20265.137%20488.896%20265.1%20489%20265.1C489.104%20265.1%20489.192%20265.137%20489.265%20265.21C489.338%20265.283%20489.375%20265.371%20489.375%20265.475ZM493.125%20265.475C493.125%20265.579%20493.088%20265.667%20493.015%20265.74C492.942%20265.813%20492.854%20265.85%20492.75%20265.85C492.646%20265.85%20492.558%20265.813%20492.485%20265.74C492.412%20265.667%20492.375%20265.579%20492.375%20265.475C492.375%20265.371%20492.412%20265.283%20492.485%20265.21C492.558%20265.137%20492.646%20265.1%20492.75%20265.1C492.854%20265.1%20492.942%20265.137%20493.015%20265.21C493.088%20265.283%20493.125%20265.371%20493.125%20265.475ZM496.875%20265.475C496.875%20265.579%20496.838%20265.667%20496.765%20265.74C496.692%20265.813%20496.603%20265.85%20496.5%20265.85C496.396%20265.85%20496.308%20265.813%20496.235%20265.74C496.162%20265.667%20496.125%20265.579%20496.125%20265.475C496.125%20265.371%20496.162%20265.283%20496.235%20265.21C496.308%20265.137%20496.396%20265.1%20496.5%20265.1C496.603%20265.1%20496.692%20265.137%20496.765%20265.21C496.838%20265.283%20496.875%20265.371%20496.875%20265.475ZM500.625%20265.475C500.625%20265.579%20500.588%20265.667%20500.515%20265.74C500.442%20265.813%20500.353%20265.85%20500.25%20265.85C500.146%20265.85%20500.058%20265.813%20499.985%20265.74C499.912%20265.667%20499.875%20265.579%20499.875%20265.475C499.875%20265.371%20499.912%20265.283%20499.985%20265.21C500.058%20265.137%20500.146%20265.1%20500.25%20265.1C500.353%20265.1%20500.442%20265.137%20500.515%20265.21C500.588%20265.283%20500.625%20265.371%20500.625%20265.475ZM504.375%20265.475C504.375%20265.579%20504.338%20265.667%20504.265%20265.74C504.192%20265.813%20504.103%20265.85%20504%20265.85C503.896%20265.85%20503.808%20265.813%20503.735%20265.74C503.662%20265.667%20503.625%20265.579%20503.625%20265.475C503.625%20265.371%20503.662%20265.283%20503.735%20265.21C503.808%20265.137%20503.896%20265.1%20504%20265.1C504.103%20265.1%20504.192%20265.137%20504.265%20265.21C504.338%20265.283%20504.375%20265.371%20504.375%20265.475ZM508.125%20265.475C508.125%20265.579%20508.088%20265.667%20508.015%20265.74C507.942%20265.813%20507.854%20265.85%20507.75%20265.85C507.646%20265.85%20507.558%20265.813%20507.485%20265.74C507.412%20265.667%20507.375%20265.579%20507.375%20265.475C507.375%20265.371%20507.412%20265.283%20507.485%20265.21C507.558%20265.137%20507.646%20265.1%20507.75%20265.1C507.854%20265.1%20507.942%20265.137%20508.015%20265.21C508.088%20265.283%20508.125%20265.371%20508.125%20265.475ZM511.875%20265.475C511.875%20265.579%20511.838%20265.667%20511.765%20265.74C511.692%20265.813%20511.604%20265.85%20511.5%20265.85C511.396%20265.85%20511.308%20265.813%20511.235%20265.74C511.162%20265.667%20511.125%20265.579%20511.125%20265.475C511.125%20265.371%20511.162%20265.283%20511.235%20265.21C511.308%20265.137%20511.396%20265.1%20511.5%20265.1C511.604%20265.1%20511.692%20265.137%20511.765%20265.21C511.838%20265.283%20511.875%20265.371%20511.875%20265.475ZM515.625%20265.475C515.625%20265.579%20515.588%20265.667%20515.515%20265.74C515.442%20265.813%20515.353%20265.85%20515.25%20265.85C515.146%20265.85%20515.058%20265.813%20514.985%20265.74C514.912%20265.667%20514.875%20265.579%20514.875%20265.475C514.875%20265.371%20514.912%20265.283%20514.985%20265.21C515.058%20265.137%20515.146%20265.1%20515.25%20265.1C515.353%20265.1%20515.442%20265.137%20515.515%20265.21C515.588%20265.283%20515.625%20265.371%20515.625%20265.475ZM519.375%20265.475C519.375%20265.579%20519.338%20265.667%20519.265%20265.74C519.192%20265.813%20519.104%20265.85%20519%20265.85C518.896%20265.85%20518.808%20265.813%20518.735%20265.74C518.662%20265.667%20518.625%20265.579%20518.625%20265.475C518.625%20265.371%20518.662%20265.283%20518.735%20265.21C518.808%20265.137%20518.896%20265.1%20519%20265.1C519.104%20265.1%20519.192%20265.137%20519.265%20265.21C519.338%20265.283%20519.375%20265.371%20519.375%20265.475ZM523.125%20265.475C523.125%20265.579%20523.088%20265.667%20523.015%20265.74C522.942%20265.813%20522.854%20265.85%20522.75%20265.85C522.646%20265.85%20522.558%20265.813%20522.485%20265.74C522.412%20265.667%20522.375%20265.579%20522.375%20265.475C522.375%20265.371%20522.412%20265.283%20522.485%20265.21C522.558%20265.137%20522.646%20265.1%20522.75%20265.1C522.854%20265.1%20522.942%20265.137%20523.015%20265.21C523.088%20265.283%20523.125%20265.371%20523.125%20265.475ZM526.875%20265.475C526.875%20265.579%20526.838%20265.667%20526.765%20265.74C526.692%20265.813%20526.604%20265.85%20526.5%20265.85C526.396%20265.85%20526.308%20265.813%20526.235%20265.74C526.162%20265.667%20526.125%20265.579%20526.125%20265.475C526.125%20265.371%20526.162%20265.283%20526.235%20265.21C526.308%20265.137%20526.396%20265.1%20526.5%20265.1C526.604%20265.1%20526.692%20265.137%20526.765%20265.21C526.838%20265.283%20526.875%20265.371%20526.875%20265.475ZM530.625%20265.475C530.625%20265.579%20530.588%20265.667%20530.515%20265.74C530.442%20265.813%20530.354%20265.85%20530.25%20265.85C530.146%20265.85%20530.058%20265.813%20529.985%20265.74C529.912%20265.667%20529.875%20265.579%20529.875%20265.475C529.875%20265.371%20529.912%20265.283%20529.985%20265.21C530.058%20265.137%20530.146%20265.1%20530.25%20265.1C530.354%20265.1%20530.442%20265.137%20530.515%20265.21C530.588%20265.283%20530.625%20265.371%20530.625%20265.475ZM534.375%20265.475C534.375%20265.579%20534.338%20265.667%20534.265%20265.74C534.192%20265.813%20534.103%20265.85%20534%20265.85C533.896%20265.85%20533.808%20265.813%20533.735%20265.74C533.662%20265.667%20533.625%20265.579%20533.625%20265.475C533.625%20265.371%20533.662%20265.283%20533.735%20265.21C533.808%20265.137%20533.896%20265.1%20534%20265.1C534.103%20265.1%20534.192%20265.137%20534.265%20265.21C534.338%20265.283%20534.375%20265.371%20534.375%20265.475ZM538.125%20265.475C538.125%20265.579%20538.088%20265.667%20538.015%20265.74C537.942%20265.813%20537.853%20265.85%20537.75%20265.85C537.646%20265.85%20537.558%20265.813%20537.485%20265.74C537.412%20265.667%20537.375%20265.579%20537.375%20265.475C537.375%20265.371%20537.412%20265.283%20537.485%20265.21C537.558%20265.137%20537.646%20265.1%20537.75%20265.1C537.853%20265.1%20537.942%20265.137%20538.015%20265.21C538.088%20265.283%20538.125%20265.371%20538.125%20265.475ZM541.875%20265.475C541.875%20265.579%20541.838%20265.667%20541.765%20265.74C541.692%20265.813%20541.603%20265.85%20541.5%20265.85C541.396%20265.85%20541.308%20265.813%20541.235%20265.74C541.162%20265.667%20541.125%20265.579%20541.125%20265.475C541.125%20265.371%20541.162%20265.283%20541.235%20265.21C541.308%20265.137%20541.396%20265.1%20541.5%20265.1C541.603%20265.1%20541.692%20265.137%20541.765%20265.21C541.838%20265.283%20541.875%20265.371%20541.875%20265.475ZM545.625%20265.475C545.625%20265.579%20545.588%20265.667%20545.515%20265.74C545.442%20265.813%20545.353%20265.85%20545.25%20265.85C545.146%20265.85%20545.058%20265.813%20544.985%20265.74C544.912%20265.667%20544.875%20265.579%20544.875%20265.475C544.875%20265.371%20544.912%20265.283%20544.985%20265.21C545.058%20265.137%20545.146%20265.1%20545.25%20265.1C545.353%20265.1%20545.442%20265.137%20545.515%20265.21C545.588%20265.283%20545.625%20265.371%20545.625%20265.475ZM549.375%20265.475C549.375%20265.579%20549.338%20265.667%20549.265%20265.74C549.192%20265.813%20549.103%20265.85%20549%20265.85C548.896%20265.85%20548.808%20265.813%20548.735%20265.74C548.662%20265.667%20548.625%20265.579%20548.625%20265.475C548.625%20265.371%20548.662%20265.283%20548.735%20265.21C548.808%20265.137%20548.896%20265.1%20549%20265.1C549.103%20265.1%20549.192%20265.137%20549.265%20265.21C549.338%20265.283%20549.375%20265.371%20549.375%20265.475ZM553.125%20265.475C553.125%20265.579%20553.088%20265.667%20553.015%20265.74C552.942%20265.813%20552.854%20265.85%20552.75%20265.85C552.646%20265.85%20552.558%20265.813%20552.485%20265.74C552.412%20265.667%20552.375%20265.579%20552.375%20265.475C552.375%20265.371%20552.412%20265.283%20552.485%20265.21C552.558%20265.137%20552.646%20265.1%20552.75%20265.1C552.854%20265.1%20552.942%20265.137%20553.015%20265.21C553.088%20265.283%20553.125%20265.371%20553.125%20265.475ZM556.875%20265.475C556.875%20265.579%20556.838%20265.667%20556.765%20265.74C556.692%20265.813%20556.603%20265.85%20556.5%20265.85C556.396%20265.85%20556.308%20265.813%20556.235%20265.74C556.162%20265.667%20556.125%20265.579%20556.125%20265.475C556.125%20265.371%20556.162%20265.283%20556.235%20265.21C556.308%20265.137%20556.396%20265.1%20556.5%20265.1C556.603%20265.1%20556.692%20265.137%20556.765%20265.21C556.838%20265.283%20556.875%20265.371%20556.875%20265.475ZM560.625%20265.475C560.625%20265.579%20560.588%20265.667%20560.515%20265.74C560.442%20265.813%20560.354%20265.85%20560.25%20265.85C560.146%20265.85%20560.058%20265.813%20559.985%20265.74C559.912%20265.667%20559.875%20265.579%20559.875%20265.475C559.875%20265.371%20559.912%20265.283%20559.985%20265.21C560.058%20265.137%20560.146%20265.1%20560.25%20265.1C560.354%20265.1%20560.442%20265.137%20560.515%20265.21C560.588%20265.283%20560.625%20265.371%20560.625%20265.475ZM564.375%20265.475C564.375%20265.579%20564.338%20265.667%20564.265%20265.74C564.192%20265.813%20564.104%20265.85%20564%20265.85C563.896%20265.85%20563.808%20265.813%20563.735%20265.74C563.662%20265.667%20563.625%20265.579%20563.625%20265.475C563.625%20265.371%20563.662%20265.283%20563.735%20265.21C563.808%20265.137%20563.896%20265.1%20564%20265.1C564.104%20265.1%20564.192%20265.137%20564.265%20265.21C564.338%20265.283%20564.375%20265.371%20564.375%20265.475ZM568.125%20265.475C568.125%20265.579%20568.088%20265.667%20568.015%20265.74C567.942%20265.813%20567.854%20265.85%20567.75%20265.85C567.646%20265.85%20567.558%20265.813%20567.485%20265.74C567.412%20265.667%20567.375%20265.579%20567.375%20265.475C567.375%20265.371%20567.412%20265.283%20567.485%20265.21C567.558%20265.137%20567.646%20265.1%20567.75%20265.1C567.854%20265.1%20567.942%20265.137%20568.015%20265.21C568.088%20265.283%20568.125%20265.371%20568.125%20265.475ZM571.875%20265.475C571.875%20265.579%20571.838%20265.667%20571.765%20265.74C571.692%20265.813%20571.603%20265.85%20571.5%20265.85C571.396%20265.85%20571.308%20265.813%20571.235%20265.74C571.162%20265.667%20571.125%20265.579%20571.125%20265.475C571.125%20265.371%20571.162%20265.283%20571.235%20265.21C571.308%20265.137%20571.396%20265.1%20571.5%20265.1C571.603%20265.1%20571.692%20265.137%20571.765%20265.21C571.838%20265.283%20571.875%20265.371%20571.875%20265.475ZM575.625%20265.475C575.625%20265.579%20575.588%20265.667%20575.515%20265.74C575.442%20265.813%20575.354%20265.85%20575.25%20265.85C575.146%20265.85%20575.058%20265.813%20574.985%20265.74C574.912%20265.667%20574.875%20265.579%20574.875%20265.475C574.875%20265.371%20574.912%20265.283%20574.985%20265.21C575.058%20265.137%20575.146%20265.1%20575.25%20265.1C575.354%20265.1%20575.442%20265.137%20575.515%20265.21C575.588%20265.283%20575.625%20265.371%20575.625%20265.475ZM579.375%20265.475C579.375%20265.579%20579.338%20265.667%20579.265%20265.74C579.192%20265.813%20579.104%20265.85%20579%20265.85C578.896%20265.85%20578.808%20265.813%20578.735%20265.74C578.662%20265.667%20578.625%20265.579%20578.625%20265.475C578.625%20265.371%20578.662%20265.283%20578.735%20265.21C578.808%20265.137%20578.896%20265.1%20579%20265.1C579.104%20265.1%20579.192%20265.137%20579.265%20265.21C579.338%20265.283%20579.375%20265.371%20579.375%20265.475ZM583.125%20265.475C583.125%20265.579%20583.088%20265.667%20583.015%20265.74C582.942%20265.813%20582.854%20265.85%20582.75%20265.85C582.646%20265.85%20582.558%20265.813%20582.485%20265.74C582.412%20265.667%20582.375%20265.579%20582.375%20265.475C582.375%20265.371%20582.412%20265.283%20582.485%20265.21C582.558%20265.137%20582.646%20265.1%20582.75%20265.1C582.854%20265.1%20582.942%20265.137%20583.015%20265.21C583.088%20265.283%20583.125%20265.371%20583.125%20265.475ZM586.875%20265.475C586.875%20265.579%20586.838%20265.667%20586.765%20265.74C586.692%20265.813%20586.604%20265.85%20586.5%20265.85C586.396%20265.85%20586.308%20265.813%20586.235%20265.74C586.162%20265.667%20586.125%20265.579%20586.125%20265.475C586.125%20265.371%20586.162%20265.283%20586.235%20265.21C586.308%20265.137%20586.396%20265.1%20586.5%20265.1C586.604%20265.1%20586.692%20265.137%20586.765%20265.21C586.838%20265.283%20586.875%20265.371%20586.875%20265.475ZM590.625%20265.475C590.625%20265.579%20590.588%20265.667%20590.515%20265.74C590.442%20265.813%20590.354%20265.85%20590.25%20265.85C590.146%20265.85%20590.058%20265.813%20589.985%20265.74C589.912%20265.667%20589.875%20265.579%20589.875%20265.475C589.875%20265.371%20589.912%20265.283%20589.985%20265.21C590.058%20265.137%20590.146%20265.1%20590.25%20265.1C590.354%20265.1%20590.442%20265.137%20590.515%20265.21C590.588%20265.283%20590.625%20265.371%20590.625%20265.475ZM594.375%20265.475C594.375%20265.579%20594.338%20265.667%20594.265%20265.74C594.192%20265.813%20594.104%20265.85%20594%20265.85C593.896%20265.85%20593.808%20265.813%20593.735%20265.74C593.662%20265.667%20593.625%20265.579%20593.625%20265.475C593.625%20265.371%20593.662%20265.283%20593.735%20265.21C593.808%20265.137%20593.896%20265.1%20594%20265.1C594.104%20265.1%20594.192%20265.137%20594.265%20265.21C594.338%20265.283%20594.375%20265.371%20594.375%20265.475ZM598.125%20265.475C598.125%20265.579%20598.088%20265.667%20598.015%20265.74C597.942%20265.813%20597.854%20265.85%20597.75%20265.85C597.646%20265.85%20597.558%20265.813%20597.485%20265.74C597.412%20265.667%20597.375%20265.579%20597.375%20265.475C597.375%20265.371%20597.412%20265.283%20597.485%20265.21C597.558%20265.137%20597.646%20265.1%20597.75%20265.1C597.854%20265.1%20597.942%20265.137%20598.015%20265.21C598.088%20265.283%20598.125%20265.371%20598.125%20265.475ZM601.875%20265.475C601.875%20265.579%20601.838%20265.667%20601.765%20265.74C601.692%20265.813%20601.604%20265.85%20601.5%20265.85C601.396%20265.85%20601.308%20265.813%20601.235%20265.74C601.162%20265.667%20601.125%20265.579%20601.125%20265.475C601.125%20265.371%20601.162%20265.283%20601.235%20265.21C601.308%20265.137%20601.396%20265.1%20601.5%20265.1C601.604%20265.1%20601.692%20265.137%20601.765%20265.21C601.838%20265.283%20601.875%20265.371%20601.875%20265.475ZM605.625%20265.475C605.625%20265.579%20605.588%20265.667%20605.515%20265.74C605.442%20265.813%20605.354%20265.85%20605.25%20265.85C605.146%20265.85%20605.058%20265.813%20604.985%20265.74C604.912%20265.667%20604.875%20265.579%20604.875%20265.475C604.875%20265.371%20604.912%20265.283%20604.985%20265.21C605.058%20265.137%20605.146%20265.1%20605.25%20265.1C605.354%20265.1%20605.442%20265.137%20605.515%20265.21C605.588%20265.283%20605.625%20265.371%20605.625%20265.475ZM609.375%20265.475C609.375%20265.579%20609.338%20265.667%20609.265%20265.74C609.192%20265.813%20609.104%20265.85%20609%20265.85C608.896%20265.85%20608.808%20265.813%20608.735%20265.74C608.662%20265.667%20608.625%20265.579%20608.625%20265.475C608.625%20265.371%20608.662%20265.283%20608.735%20265.21C608.808%20265.137%20608.896%20265.1%20609%20265.1C609.104%20265.1%20609.192%20265.137%20609.265%20265.21C609.338%20265.283%20609.375%20265.371%20609.375%20265.475ZM613.125%20265.475C613.125%20265.579%20613.088%20265.667%20613.015%20265.74C612.942%20265.813%20612.854%20265.85%20612.75%20265.85C612.646%20265.85%20612.558%20265.813%20612.485%20265.74C612.412%20265.667%20612.375%20265.579%20612.375%20265.475C612.375%20265.371%20612.412%20265.283%20612.485%20265.21C612.558%20265.137%20612.646%20265.1%20612.75%20265.1C612.854%20265.1%20612.942%20265.137%20613.015%20265.21C613.088%20265.283%20613.125%20265.371%20613.125%20265.475ZM616.875%20265.475C616.875%20265.579%20616.838%20265.667%20616.765%20265.74C616.692%20265.813%20616.604%20265.85%20616.5%20265.85C616.396%20265.85%20616.308%20265.813%20616.235%20265.74C616.162%20265.667%20616.125%20265.579%20616.125%20265.475C616.125%20265.371%20616.162%20265.283%20616.235%20265.21C616.308%20265.137%20616.396%20265.1%20616.5%20265.1C616.604%20265.1%20616.692%20265.137%20616.765%20265.21C616.838%20265.283%20616.875%20265.371%20616.875%20265.475ZM620.625%20265.475C620.625%20265.579%20620.588%20265.667%20620.515%20265.74C620.442%20265.813%20620.354%20265.85%20620.25%20265.85C620.146%20265.85%20620.058%20265.813%20619.985%20265.74C619.912%20265.667%20619.875%20265.579%20619.875%20265.475C619.875%20265.371%20619.912%20265.283%20619.985%20265.21C620.058%20265.137%20620.146%20265.1%20620.25%20265.1C620.354%20265.1%20620.442%20265.137%20620.515%20265.21C620.588%20265.283%20620.625%20265.371%20620.625%20265.475ZM624.375%20265.475C624.375%20265.579%20624.338%20265.667%20624.265%20265.74C624.192%20265.813%20624.104%20265.85%20624%20265.85C623.896%20265.85%20623.808%20265.813%20623.735%20265.74C623.662%20265.667%20623.625%20265.579%20623.625%20265.475C623.625%20265.371%20623.662%20265.283%20623.735%20265.21C623.808%20265.137%20623.896%20265.1%20624%20265.1C624.104%20265.1%20624.192%20265.137%20624.265%20265.21C624.338%20265.283%20624.375%20265.371%20624.375%20265.475ZM628.125%20265.475C628.125%20265.579%20628.088%20265.667%20628.015%20265.74C627.942%20265.813%20627.854%20265.85%20627.75%20265.85C627.646%20265.85%20627.558%20265.813%20627.485%20265.74C627.412%20265.667%20627.375%20265.579%20627.375%20265.475C627.375%20265.371%20627.412%20265.283%20627.485%20265.21C627.558%20265.137%20627.646%20265.1%20627.75%20265.1C627.854%20265.1%20627.942%20265.137%20628.015%20265.21C628.088%20265.283%20628.125%20265.371%20628.125%20265.475ZM631.875%20265.475C631.875%20265.579%20631.838%20265.667%20631.765%20265.74C631.692%20265.813%20631.604%20265.85%20631.5%20265.85C631.396%20265.85%20631.308%20265.813%20631.235%20265.74C631.162%20265.667%20631.125%20265.579%20631.125%20265.475C631.125%20265.371%20631.162%20265.283%20631.235%20265.21C631.308%20265.137%20631.396%20265.1%20631.5%20265.1C631.604%20265.1%20631.692%20265.137%20631.765%20265.21C631.838%20265.283%20631.875%20265.371%20631.875%20265.475ZM635.625%20265.475C635.625%20265.579%20635.588%20265.667%20635.515%20265.74C635.442%20265.813%20635.354%20265.85%20635.25%20265.85C635.146%20265.85%20635.058%20265.813%20634.985%20265.74C634.912%20265.667%20634.875%20265.579%20634.875%20265.475C634.875%20265.371%20634.912%20265.283%20634.985%20265.21C635.058%20265.137%20635.146%20265.1%20635.25%20265.1C635.354%20265.1%20635.442%20265.137%20635.515%20265.21C635.588%20265.283%20635.625%20265.371%20635.625%20265.475Z'%20fill='%23B4BAC3'%20/%3e%3cpath%20d='M48.7772%20264.235L48.724%20264.858H46.404C46.3786%20265.594%2046.3597%20266.191%2046.347%20266.646C46.6331%20266.464%2046.9432%20266.373%2047.2773%20266.373C47.5583%20266.373%2047.8089%20266.418%2048.0291%20266.51C48.2519%20266.598%2048.4329%20266.721%2048.5721%20266.878C48.7139%20267.035%2048.8215%20267.218%2048.8949%20267.429C48.9683%20267.636%2049.005%20267.861%2049.005%20268.104C49.005%20268.679%2048.8202%20269.14%2048.4506%20269.487C48.0836%20269.831%2047.5836%20270.003%2046.9508%20270.003C46.3154%20270.003%2045.8065%20269.83%2045.4243%20269.483L45.6711%20268.947C46.0458%20269.241%2046.4799%20269.388%2046.9735%20269.388C47.3887%20269.388%2047.7165%20269.27%2047.957%20269.035C48.1975%20268.799%2048.3177%20268.492%2048.3177%20268.112C48.3177%20267.773%2048.2165%20267.498%2048.014%20267.288C47.8114%20267.075%2047.5229%20266.969%2047.1482%20266.969C46.7736%20266.969%2046.4723%20267.094%2046.2445%20267.345L45.7167%20267.273L45.8648%20264.235H48.7772ZM54.2223%20269.916H53.4173L51.2681%20267.235L50.7555%20267.687V269.916H50.0948V264.3H50.7555V267.056L53.2236%20264.3H54.0476L51.7693%20266.829L54.2223%20269.916Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M61.875%20208.875C61.875%20208.979%2061.8384%20209.067%2061.7652%20209.14C61.6919%20209.213%2061.6036%20209.25%2061.5%20209.25C61.3964%20209.25%2061.3081%20209.213%2061.2348%20209.14C61.1616%20209.067%2061.125%20208.979%2061.125%20208.875C61.125%20208.771%2061.1616%20208.683%2061.2348%20208.61C61.3081%20208.537%2061.3964%20208.5%2061.5%20208.5C61.6036%20208.5%2061.6919%20208.537%2061.7652%20208.61C61.8384%20208.683%2061.875%20208.771%2061.875%20208.875ZM65.625%20208.875C65.625%20208.979%2065.5884%20209.067%2065.5152%20209.14C65.4419%20209.213%2065.3536%20209.25%2065.25%20209.25C65.1464%20209.25%2065.0581%20209.213%2064.9848%20209.14C64.9116%20209.067%2064.875%20208.979%2064.875%20208.875C64.875%20208.771%2064.9116%20208.683%2064.9848%20208.61C65.0581%20208.537%2065.1464%20208.5%2065.25%20208.5C65.3536%20208.5%2065.4419%20208.537%2065.5152%20208.61C65.5884%20208.683%2065.625%20208.771%2065.625%20208.875ZM69.375%20208.875C69.375%20208.979%2069.3384%20209.067%2069.2652%20209.14C69.1919%20209.213%2069.1036%20209.25%2069%20209.25C68.8964%20209.25%2068.8081%20209.213%2068.7348%20209.14C68.6616%20209.067%2068.625%20208.979%2068.625%20208.875C68.625%20208.771%2068.6616%20208.683%2068.7348%20208.61C68.8081%20208.537%2068.8964%20208.5%2069%20208.5C69.1036%20208.5%2069.1919%20208.537%2069.2652%20208.61C69.3384%20208.683%2069.375%20208.771%2069.375%20208.875ZM73.125%20208.875C73.125%20208.979%2073.0884%20209.067%2073.0152%20209.14C72.9419%20209.213%2072.8536%20209.25%2072.75%20209.25C72.6464%20209.25%2072.5581%20209.213%2072.4848%20209.14C72.4116%20209.067%2072.375%20208.979%2072.375%20208.875C72.375%20208.771%2072.4116%20208.683%2072.4848%20208.61C72.5581%20208.537%2072.6464%20208.5%2072.75%20208.5C72.8536%20208.5%2072.9419%20208.537%2073.0152%20208.61C73.0884%20208.683%2073.125%20208.771%2073.125%20208.875ZM76.875%20208.875C76.875%20208.979%2076.8384%20209.067%2076.7652%20209.14C76.6919%20209.213%2076.6036%20209.25%2076.5%20209.25C76.3964%20209.25%2076.3081%20209.213%2076.2348%20209.14C76.1616%20209.067%2076.125%20208.979%2076.125%20208.875C76.125%20208.771%2076.1616%20208.683%2076.2348%20208.61C76.3081%20208.537%2076.3964%20208.5%2076.5%20208.5C76.6036%20208.5%2076.6919%20208.537%2076.7652%20208.61C76.8384%20208.683%2076.875%20208.771%2076.875%20208.875ZM80.625%20208.875C80.625%20208.979%2080.5884%20209.067%2080.5152%20209.14C80.4419%20209.213%2080.3536%20209.25%2080.25%20209.25C80.1464%20209.25%2080.0581%20209.213%2079.9848%20209.14C79.9116%20209.067%2079.875%20208.979%2079.875%20208.875C79.875%20208.771%2079.9116%20208.683%2079.9848%20208.61C80.0581%20208.537%2080.1464%20208.5%2080.25%20208.5C80.3536%20208.5%2080.4419%20208.537%2080.5152%20208.61C80.5884%20208.683%2080.625%20208.771%2080.625%20208.875ZM84.375%20208.875C84.375%20208.979%2084.3384%20209.067%2084.2652%20209.14C84.1919%20209.213%2084.1036%20209.25%2084%20209.25C83.8964%20209.25%2083.8081%20209.213%2083.7348%20209.14C83.6616%20209.067%2083.625%20208.979%2083.625%20208.875C83.625%20208.771%2083.6616%20208.683%2083.7348%20208.61C83.8081%20208.537%2083.8964%20208.5%2084%20208.5C84.1036%20208.5%2084.1919%20208.537%2084.2652%20208.61C84.3384%20208.683%2084.375%20208.771%2084.375%20208.875ZM88.125%20208.875C88.125%20208.979%2088.0884%20209.067%2088.0152%20209.14C87.9419%20209.213%2087.8536%20209.25%2087.75%20209.25C87.6464%20209.25%2087.5581%20209.213%2087.4848%20209.14C87.4116%20209.067%2087.375%20208.979%2087.375%20208.875C87.375%20208.771%2087.4116%20208.683%2087.4848%20208.61C87.5581%20208.537%2087.6464%20208.5%2087.75%20208.5C87.8536%20208.5%2087.9419%20208.537%2088.0152%20208.61C88.0884%20208.683%2088.125%20208.771%2088.125%20208.875ZM91.875%20208.875C91.875%20208.979%2091.8384%20209.067%2091.7652%20209.14C91.6919%20209.213%2091.6036%20209.25%2091.5%20209.25C91.3964%20209.25%2091.3081%20209.213%2091.2348%20209.14C91.1616%20209.067%2091.125%20208.979%2091.125%20208.875C91.125%20208.771%2091.1616%20208.683%2091.2348%20208.61C91.3081%20208.537%2091.3964%20208.5%2091.5%20208.5C91.6036%20208.5%2091.6919%20208.537%2091.7652%20208.61C91.8384%20208.683%2091.875%20208.771%2091.875%20208.875ZM95.625%20208.875C95.625%20208.979%2095.5884%20209.067%2095.5152%20209.14C95.4419%20209.213%2095.3535%20209.25%2095.25%20209.25C95.1464%20209.25%2095.0581%20209.213%2094.9848%20209.14C94.9116%20209.067%2094.875%20208.979%2094.875%20208.875C94.875%20208.771%2094.9116%20208.683%2094.9848%20208.61C95.0581%20208.537%2095.1464%20208.5%2095.25%20208.5C95.3535%20208.5%2095.4419%20208.537%2095.5152%20208.61C95.5884%20208.683%2095.625%20208.771%2095.625%20208.875ZM99.375%20208.875C99.375%20208.979%2099.3384%20209.067%2099.2652%20209.14C99.1919%20209.213%2099.1035%20209.25%2099%20209.25C98.8964%20209.25%2098.8081%20209.213%2098.7348%20209.14C98.6616%20209.067%2098.625%20208.979%2098.625%20208.875C98.625%20208.771%2098.6616%20208.683%2098.7348%20208.61C98.8081%20208.537%2098.8964%20208.5%2099%20208.5C99.1035%20208.5%2099.1919%20208.537%2099.2652%20208.61C99.3384%20208.683%2099.375%20208.771%2099.375%20208.875ZM103.125%20208.875C103.125%20208.979%20103.088%20209.067%20103.015%20209.14C102.942%20209.213%20102.854%20209.25%20102.75%20209.25C102.646%20209.25%20102.558%20209.213%20102.485%20209.14C102.412%20209.067%20102.375%20208.979%20102.375%20208.875C102.375%20208.771%20102.412%20208.683%20102.485%20208.61C102.558%20208.537%20102.646%20208.5%20102.75%20208.5C102.854%20208.5%20102.942%20208.537%20103.015%20208.61C103.088%20208.683%20103.125%20208.771%20103.125%20208.875ZM106.875%20208.875C106.875%20208.979%20106.838%20209.067%20106.765%20209.14C106.692%20209.213%20106.604%20209.25%20106.5%20209.25C106.396%20209.25%20106.308%20209.213%20106.235%20209.14C106.162%20209.067%20106.125%20208.979%20106.125%20208.875C106.125%20208.771%20106.162%20208.683%20106.235%20208.61C106.308%20208.537%20106.396%20208.5%20106.5%20208.5C106.604%20208.5%20106.692%20208.537%20106.765%20208.61C106.838%20208.683%20106.875%20208.771%20106.875%20208.875ZM110.625%20208.875C110.625%20208.979%20110.588%20209.067%20110.515%20209.14C110.442%20209.213%20110.354%20209.25%20110.25%20209.25C110.146%20209.25%20110.058%20209.213%20109.985%20209.14C109.912%20209.067%20109.875%20208.979%20109.875%20208.875C109.875%20208.771%20109.912%20208.683%20109.985%20208.61C110.058%20208.537%20110.146%20208.5%20110.25%20208.5C110.354%20208.5%20110.442%20208.537%20110.515%20208.61C110.588%20208.683%20110.625%20208.771%20110.625%20208.875ZM114.375%20208.875C114.375%20208.979%20114.338%20209.067%20114.265%20209.14C114.192%20209.213%20114.104%20209.25%20114%20209.25C113.896%20209.25%20113.808%20209.213%20113.735%20209.14C113.662%20209.067%20113.625%20208.979%20113.625%20208.875C113.625%20208.771%20113.662%20208.683%20113.735%20208.61C113.808%20208.537%20113.896%20208.5%20114%20208.5C114.104%20208.5%20114.192%20208.537%20114.265%20208.61C114.338%20208.683%20114.375%20208.771%20114.375%20208.875ZM118.125%20208.875C118.125%20208.979%20118.088%20209.067%20118.015%20209.14C117.942%20209.213%20117.854%20209.25%20117.75%20209.25C117.646%20209.25%20117.558%20209.213%20117.485%20209.14C117.412%20209.067%20117.375%20208.979%20117.375%20208.875C117.375%20208.771%20117.412%20208.683%20117.485%20208.61C117.558%20208.537%20117.646%20208.5%20117.75%20208.5C117.854%20208.5%20117.942%20208.537%20118.015%20208.61C118.088%20208.683%20118.125%20208.771%20118.125%20208.875ZM121.875%20208.875C121.875%20208.979%20121.838%20209.067%20121.765%20209.14C121.692%20209.213%20121.604%20209.25%20121.5%20209.25C121.396%20209.25%20121.308%20209.213%20121.235%20209.14C121.162%20209.067%20121.125%20208.979%20121.125%20208.875C121.125%20208.771%20121.162%20208.683%20121.235%20208.61C121.308%20208.537%20121.396%20208.5%20121.5%20208.5C121.604%20208.5%20121.692%20208.537%20121.765%20208.61C121.838%20208.683%20121.875%20208.771%20121.875%20208.875ZM125.625%20208.875C125.625%20208.979%20125.588%20209.067%20125.515%20209.14C125.442%20209.213%20125.354%20209.25%20125.25%20209.25C125.146%20209.25%20125.058%20209.213%20124.985%20209.14C124.912%20209.067%20124.875%20208.979%20124.875%20208.875C124.875%20208.771%20124.912%20208.683%20124.985%20208.61C125.058%20208.537%20125.146%20208.5%20125.25%20208.5C125.354%20208.5%20125.442%20208.537%20125.515%20208.61C125.588%20208.683%20125.625%20208.771%20125.625%20208.875ZM129.375%20208.875C129.375%20208.979%20129.338%20209.067%20129.265%20209.14C129.192%20209.213%20129.104%20209.25%20129%20209.25C128.896%20209.25%20128.808%20209.213%20128.735%20209.14C128.662%20209.067%20128.625%20208.979%20128.625%20208.875C128.625%20208.771%20128.662%20208.683%20128.735%20208.61C128.808%20208.537%20128.896%20208.5%20129%20208.5C129.104%20208.5%20129.192%20208.537%20129.265%20208.61C129.338%20208.683%20129.375%20208.771%20129.375%20208.875ZM133.125%20208.875C133.125%20208.979%20133.088%20209.067%20133.015%20209.14C132.942%20209.213%20132.854%20209.25%20132.75%20209.25C132.646%20209.25%20132.558%20209.213%20132.485%20209.14C132.412%20209.067%20132.375%20208.979%20132.375%20208.875C132.375%20208.771%20132.412%20208.683%20132.485%20208.61C132.558%20208.537%20132.646%20208.5%20132.75%20208.5C132.854%20208.5%20132.942%20208.537%20133.015%20208.61C133.088%20208.683%20133.125%20208.771%20133.125%20208.875ZM136.875%20208.875C136.875%20208.979%20136.838%20209.067%20136.765%20209.14C136.692%20209.213%20136.604%20209.25%20136.5%20209.25C136.396%20209.25%20136.308%20209.213%20136.235%20209.14C136.162%20209.067%20136.125%20208.979%20136.125%20208.875C136.125%20208.771%20136.162%20208.683%20136.235%20208.61C136.308%20208.537%20136.396%20208.5%20136.5%20208.5C136.604%20208.5%20136.692%20208.537%20136.765%20208.61C136.838%20208.683%20136.875%20208.771%20136.875%20208.875ZM140.625%20208.875C140.625%20208.979%20140.588%20209.067%20140.515%20209.14C140.442%20209.213%20140.354%20209.25%20140.25%20209.25C140.146%20209.25%20140.058%20209.213%20139.985%20209.14C139.912%20209.067%20139.875%20208.979%20139.875%20208.875C139.875%20208.771%20139.912%20208.683%20139.985%20208.61C140.058%20208.537%20140.146%20208.5%20140.25%20208.5C140.354%20208.5%20140.442%20208.537%20140.515%20208.61C140.588%20208.683%20140.625%20208.771%20140.625%20208.875ZM144.375%20208.875C144.375%20208.979%20144.338%20209.067%20144.265%20209.14C144.192%20209.213%20144.104%20209.25%20144%20209.25C143.896%20209.25%20143.808%20209.213%20143.735%20209.14C143.662%20209.067%20143.625%20208.979%20143.625%20208.875C143.625%20208.771%20143.662%20208.683%20143.735%20208.61C143.808%20208.537%20143.896%20208.5%20144%20208.5C144.104%20208.5%20144.192%20208.537%20144.265%20208.61C144.338%20208.683%20144.375%20208.771%20144.375%20208.875ZM148.125%20208.875C148.125%20208.979%20148.088%20209.067%20148.015%20209.14C147.942%20209.213%20147.854%20209.25%20147.75%20209.25C147.646%20209.25%20147.558%20209.213%20147.485%20209.14C147.412%20209.067%20147.375%20208.979%20147.375%20208.875C147.375%20208.771%20147.412%20208.683%20147.485%20208.61C147.558%20208.537%20147.646%20208.5%20147.75%20208.5C147.854%20208.5%20147.942%20208.537%20148.015%20208.61C148.088%20208.683%20148.125%20208.771%20148.125%20208.875ZM151.875%20208.875C151.875%20208.979%20151.838%20209.067%20151.765%20209.14C151.692%20209.213%20151.604%20209.25%20151.5%20209.25C151.396%20209.25%20151.308%20209.213%20151.235%20209.14C151.162%20209.067%20151.125%20208.979%20151.125%20208.875C151.125%20208.771%20151.162%20208.683%20151.235%20208.61C151.308%20208.537%20151.396%20208.5%20151.5%20208.5C151.604%20208.5%20151.692%20208.537%20151.765%20208.61C151.838%20208.683%20151.875%20208.771%20151.875%20208.875ZM155.625%20208.875C155.625%20208.979%20155.588%20209.067%20155.515%20209.14C155.442%20209.213%20155.354%20209.25%20155.25%20209.25C155.146%20209.25%20155.058%20209.213%20154.985%20209.14C154.912%20209.067%20154.875%20208.979%20154.875%20208.875C154.875%20208.771%20154.912%20208.683%20154.985%20208.61C155.058%20208.537%20155.146%20208.5%20155.25%20208.5C155.354%20208.5%20155.442%20208.537%20155.515%20208.61C155.588%20208.683%20155.625%20208.771%20155.625%20208.875ZM159.375%20208.875C159.375%20208.979%20159.338%20209.067%20159.265%20209.14C159.192%20209.213%20159.104%20209.25%20159%20209.25C158.896%20209.25%20158.808%20209.213%20158.735%20209.14C158.662%20209.067%20158.625%20208.979%20158.625%20208.875C158.625%20208.771%20158.662%20208.683%20158.735%20208.61C158.808%20208.537%20158.896%20208.5%20159%20208.5C159.104%20208.5%20159.192%20208.537%20159.265%20208.61C159.338%20208.683%20159.375%20208.771%20159.375%20208.875ZM163.125%20208.875C163.125%20208.979%20163.088%20209.067%20163.015%20209.14C162.942%20209.213%20162.854%20209.25%20162.75%20209.25C162.646%20209.25%20162.558%20209.213%20162.485%20209.14C162.412%20209.067%20162.375%20208.979%20162.375%20208.875C162.375%20208.771%20162.412%20208.683%20162.485%20208.61C162.558%20208.537%20162.646%20208.5%20162.75%20208.5C162.854%20208.5%20162.942%20208.537%20163.015%20208.61C163.088%20208.683%20163.125%20208.771%20163.125%20208.875ZM166.875%20208.875C166.875%20208.979%20166.838%20209.067%20166.765%20209.14C166.692%20209.213%20166.604%20209.25%20166.5%20209.25C166.396%20209.25%20166.308%20209.213%20166.235%20209.14C166.162%20209.067%20166.125%20208.979%20166.125%20208.875C166.125%20208.771%20166.162%20208.683%20166.235%20208.61C166.308%20208.537%20166.396%20208.5%20166.5%20208.5C166.604%20208.5%20166.692%20208.537%20166.765%20208.61C166.838%20208.683%20166.875%20208.771%20166.875%20208.875ZM170.625%20208.875C170.625%20208.979%20170.588%20209.067%20170.515%20209.14C170.442%20209.213%20170.354%20209.25%20170.25%20209.25C170.146%20209.25%20170.058%20209.213%20169.985%20209.14C169.912%20209.067%20169.875%20208.979%20169.875%20208.875C169.875%20208.771%20169.912%20208.683%20169.985%20208.61C170.058%20208.537%20170.146%20208.5%20170.25%20208.5C170.354%20208.5%20170.442%20208.537%20170.515%20208.61C170.588%20208.683%20170.625%20208.771%20170.625%20208.875ZM174.375%20208.875C174.375%20208.979%20174.338%20209.067%20174.265%20209.14C174.192%20209.213%20174.104%20209.25%20174%20209.25C173.896%20209.25%20173.808%20209.213%20173.735%20209.14C173.662%20209.067%20173.625%20208.979%20173.625%20208.875C173.625%20208.771%20173.662%20208.683%20173.735%20208.61C173.808%20208.537%20173.896%20208.5%20174%20208.5C174.104%20208.5%20174.192%20208.537%20174.265%20208.61C174.338%20208.683%20174.375%20208.771%20174.375%20208.875ZM178.125%20208.875C178.125%20208.979%20178.088%20209.067%20178.015%20209.14C177.942%20209.213%20177.854%20209.25%20177.75%20209.25C177.646%20209.25%20177.558%20209.213%20177.485%20209.14C177.412%20209.067%20177.375%20208.979%20177.375%20208.875C177.375%20208.771%20177.412%20208.683%20177.485%20208.61C177.558%20208.537%20177.646%20208.5%20177.75%20208.5C177.854%20208.5%20177.942%20208.537%20178.015%20208.61C178.088%20208.683%20178.125%20208.771%20178.125%20208.875ZM181.875%20208.875C181.875%20208.979%20181.838%20209.067%20181.765%20209.14C181.692%20209.213%20181.604%20209.25%20181.5%20209.25C181.396%20209.25%20181.308%20209.213%20181.235%20209.14C181.162%20209.067%20181.125%20208.979%20181.125%20208.875C181.125%20208.771%20181.162%20208.683%20181.235%20208.61C181.308%20208.537%20181.396%20208.5%20181.5%20208.5C181.604%20208.5%20181.692%20208.537%20181.765%20208.61C181.838%20208.683%20181.875%20208.771%20181.875%20208.875ZM185.625%20208.875C185.625%20208.979%20185.588%20209.067%20185.515%20209.14C185.442%20209.213%20185.354%20209.25%20185.25%20209.25C185.146%20209.25%20185.058%20209.213%20184.985%20209.14C184.912%20209.067%20184.875%20208.979%20184.875%20208.875C184.875%20208.771%20184.912%20208.683%20184.985%20208.61C185.058%20208.537%20185.146%20208.5%20185.25%20208.5C185.354%20208.5%20185.442%20208.537%20185.515%20208.61C185.588%20208.683%20185.625%20208.771%20185.625%20208.875ZM189.375%20208.875C189.375%20208.979%20189.338%20209.067%20189.265%20209.14C189.192%20209.213%20189.104%20209.25%20189%20209.25C188.896%20209.25%20188.808%20209.213%20188.735%20209.14C188.662%20209.067%20188.625%20208.979%20188.625%20208.875C188.625%20208.771%20188.662%20208.683%20188.735%20208.61C188.808%20208.537%20188.896%20208.5%20189%20208.5C189.104%20208.5%20189.192%20208.537%20189.265%20208.61C189.338%20208.683%20189.375%20208.771%20189.375%20208.875ZM193.125%20208.875C193.125%20208.979%20193.088%20209.067%20193.015%20209.14C192.942%20209.213%20192.854%20209.25%20192.75%20209.25C192.646%20209.25%20192.558%20209.213%20192.485%20209.14C192.412%20209.067%20192.375%20208.979%20192.375%20208.875C192.375%20208.771%20192.412%20208.683%20192.485%20208.61C192.558%20208.537%20192.646%20208.5%20192.75%20208.5C192.854%20208.5%20192.942%20208.537%20193.015%20208.61C193.088%20208.683%20193.125%20208.771%20193.125%20208.875ZM196.875%20208.875C196.875%20208.979%20196.838%20209.067%20196.765%20209.14C196.692%20209.213%20196.604%20209.25%20196.5%20209.25C196.396%20209.25%20196.308%20209.213%20196.235%20209.14C196.162%20209.067%20196.125%20208.979%20196.125%20208.875C196.125%20208.771%20196.162%20208.683%20196.235%20208.61C196.308%20208.537%20196.396%20208.5%20196.5%20208.5C196.604%20208.5%20196.692%20208.537%20196.765%20208.61C196.838%20208.683%20196.875%20208.771%20196.875%20208.875ZM200.625%20208.875C200.625%20208.979%20200.588%20209.067%20200.515%20209.14C200.442%20209.213%20200.354%20209.25%20200.25%20209.25C200.146%20209.25%20200.058%20209.213%20199.985%20209.14C199.912%20209.067%20199.875%20208.979%20199.875%20208.875C199.875%20208.771%20199.912%20208.683%20199.985%20208.61C200.058%20208.537%20200.146%20208.5%20200.25%20208.5C200.354%20208.5%20200.442%20208.537%20200.515%20208.61C200.588%20208.683%20200.625%20208.771%20200.625%20208.875ZM204.375%20208.875C204.375%20208.979%20204.338%20209.067%20204.265%20209.14C204.192%20209.213%20204.104%20209.25%20204%20209.25C203.896%20209.25%20203.808%20209.213%20203.735%20209.14C203.662%20209.067%20203.625%20208.979%20203.625%20208.875C203.625%20208.771%20203.662%20208.683%20203.735%20208.61C203.808%20208.537%20203.896%20208.5%20204%20208.5C204.104%20208.5%20204.192%20208.537%20204.265%20208.61C204.338%20208.683%20204.375%20208.771%20204.375%20208.875ZM208.125%20208.875C208.125%20208.979%20208.088%20209.067%20208.015%20209.14C207.942%20209.213%20207.854%20209.25%20207.75%20209.25C207.646%20209.25%20207.558%20209.213%20207.485%20209.14C207.412%20209.067%20207.375%20208.979%20207.375%20208.875C207.375%20208.771%20207.412%20208.683%20207.485%20208.61C207.558%20208.537%20207.646%20208.5%20207.75%20208.5C207.854%20208.5%20207.942%20208.537%20208.015%20208.61C208.088%20208.683%20208.125%20208.771%20208.125%20208.875ZM211.875%20208.875C211.875%20208.979%20211.838%20209.067%20211.765%20209.14C211.692%20209.213%20211.604%20209.25%20211.5%20209.25C211.396%20209.25%20211.308%20209.213%20211.235%20209.14C211.162%20209.067%20211.125%20208.979%20211.125%20208.875C211.125%20208.771%20211.162%20208.683%20211.235%20208.61C211.308%20208.537%20211.396%20208.5%20211.5%20208.5C211.604%20208.5%20211.692%20208.537%20211.765%20208.61C211.838%20208.683%20211.875%20208.771%20211.875%20208.875ZM215.625%20208.875C215.625%20208.979%20215.588%20209.067%20215.515%20209.14C215.442%20209.213%20215.354%20209.25%20215.25%20209.25C215.146%20209.25%20215.058%20209.213%20214.985%20209.14C214.912%20209.067%20214.875%20208.979%20214.875%20208.875C214.875%20208.771%20214.912%20208.683%20214.985%20208.61C215.058%20208.537%20215.146%20208.5%20215.25%20208.5C215.354%20208.5%20215.442%20208.537%20215.515%20208.61C215.588%20208.683%20215.625%20208.771%20215.625%20208.875ZM219.375%20208.875C219.375%20208.979%20219.338%20209.067%20219.265%20209.14C219.192%20209.213%20219.104%20209.25%20219%20209.25C218.896%20209.25%20218.808%20209.213%20218.735%20209.14C218.662%20209.067%20218.625%20208.979%20218.625%20208.875C218.625%20208.771%20218.662%20208.683%20218.735%20208.61C218.808%20208.537%20218.896%20208.5%20219%20208.5C219.104%20208.5%20219.192%20208.537%20219.265%20208.61C219.338%20208.683%20219.375%20208.771%20219.375%20208.875ZM223.125%20208.875C223.125%20208.979%20223.088%20209.067%20223.015%20209.14C222.942%20209.213%20222.854%20209.25%20222.75%20209.25C222.646%20209.25%20222.558%20209.213%20222.485%20209.14C222.412%20209.067%20222.375%20208.979%20222.375%20208.875C222.375%20208.771%20222.412%20208.683%20222.485%20208.61C222.558%20208.537%20222.646%20208.5%20222.75%20208.5C222.854%20208.5%20222.942%20208.537%20223.015%20208.61C223.088%20208.683%20223.125%20208.771%20223.125%20208.875ZM226.875%20208.875C226.875%20208.979%20226.838%20209.067%20226.765%20209.14C226.692%20209.213%20226.604%20209.25%20226.5%20209.25C226.396%20209.25%20226.308%20209.213%20226.235%20209.14C226.162%20209.067%20226.125%20208.979%20226.125%20208.875C226.125%20208.771%20226.162%20208.683%20226.235%20208.61C226.308%20208.537%20226.396%20208.5%20226.5%20208.5C226.604%20208.5%20226.692%20208.537%20226.765%20208.61C226.838%20208.683%20226.875%20208.771%20226.875%20208.875ZM230.625%20208.875C230.625%20208.979%20230.588%20209.067%20230.515%20209.14C230.442%20209.213%20230.354%20209.25%20230.25%20209.25C230.146%20209.25%20230.058%20209.213%20229.985%20209.14C229.912%20209.067%20229.875%20208.979%20229.875%20208.875C229.875%20208.771%20229.912%20208.683%20229.985%20208.61C230.058%20208.537%20230.146%20208.5%20230.25%20208.5C230.354%20208.5%20230.442%20208.537%20230.515%20208.61C230.588%20208.683%20230.625%20208.771%20230.625%20208.875ZM234.375%20208.875C234.375%20208.979%20234.338%20209.067%20234.265%20209.14C234.192%20209.213%20234.104%20209.25%20234%20209.25C233.896%20209.25%20233.808%20209.213%20233.735%20209.14C233.662%20209.067%20233.625%20208.979%20233.625%20208.875C233.625%20208.771%20233.662%20208.683%20233.735%20208.61C233.808%20208.537%20233.896%20208.5%20234%20208.5C234.104%20208.5%20234.192%20208.537%20234.265%20208.61C234.338%20208.683%20234.375%20208.771%20234.375%20208.875ZM238.125%20208.875C238.125%20208.979%20238.088%20209.067%20238.015%20209.14C237.942%20209.213%20237.854%20209.25%20237.75%20209.25C237.646%20209.25%20237.558%20209.213%20237.485%20209.14C237.412%20209.067%20237.375%20208.979%20237.375%20208.875C237.375%20208.771%20237.412%20208.683%20237.485%20208.61C237.558%20208.537%20237.646%20208.5%20237.75%20208.5C237.854%20208.5%20237.942%20208.537%20238.015%20208.61C238.088%20208.683%20238.125%20208.771%20238.125%20208.875ZM241.875%20208.875C241.875%20208.979%20241.838%20209.067%20241.765%20209.14C241.692%20209.213%20241.604%20209.25%20241.5%20209.25C241.396%20209.25%20241.308%20209.213%20241.235%20209.14C241.162%20209.067%20241.125%20208.979%20241.125%20208.875C241.125%20208.771%20241.162%20208.683%20241.235%20208.61C241.308%20208.537%20241.396%20208.5%20241.5%20208.5C241.604%20208.5%20241.692%20208.537%20241.765%20208.61C241.838%20208.683%20241.875%20208.771%20241.875%20208.875ZM245.625%20208.875C245.625%20208.979%20245.588%20209.067%20245.515%20209.14C245.442%20209.213%20245.354%20209.25%20245.25%20209.25C245.146%20209.25%20245.058%20209.213%20244.985%20209.14C244.912%20209.067%20244.875%20208.979%20244.875%20208.875C244.875%20208.771%20244.912%20208.683%20244.985%20208.61C245.058%20208.537%20245.146%20208.5%20245.25%20208.5C245.354%20208.5%20245.442%20208.537%20245.515%20208.61C245.588%20208.683%20245.625%20208.771%20245.625%20208.875ZM249.375%20208.875C249.375%20208.979%20249.338%20209.067%20249.265%20209.14C249.192%20209.213%20249.104%20209.25%20249%20209.25C248.896%20209.25%20248.808%20209.213%20248.735%20209.14C248.662%20209.067%20248.625%20208.979%20248.625%20208.875C248.625%20208.771%20248.662%20208.683%20248.735%20208.61C248.808%20208.537%20248.896%20208.5%20249%20208.5C249.104%20208.5%20249.192%20208.537%20249.265%20208.61C249.338%20208.683%20249.375%20208.771%20249.375%20208.875ZM253.125%20208.875C253.125%20208.979%20253.088%20209.067%20253.015%20209.14C252.942%20209.213%20252.854%20209.25%20252.75%20209.25C252.646%20209.25%20252.558%20209.213%20252.485%20209.14C252.412%20209.067%20252.375%20208.979%20252.375%20208.875C252.375%20208.771%20252.412%20208.683%20252.485%20208.61C252.558%20208.537%20252.646%20208.5%20252.75%20208.5C252.854%20208.5%20252.942%20208.537%20253.015%20208.61C253.088%20208.683%20253.125%20208.771%20253.125%20208.875ZM256.875%20208.875C256.875%20208.979%20256.838%20209.067%20256.765%20209.14C256.692%20209.213%20256.604%20209.25%20256.5%20209.25C256.396%20209.25%20256.308%20209.213%20256.235%20209.14C256.162%20209.067%20256.125%20208.979%20256.125%20208.875C256.125%20208.771%20256.162%20208.683%20256.235%20208.61C256.308%20208.537%20256.396%20208.5%20256.5%20208.5C256.604%20208.5%20256.692%20208.537%20256.765%20208.61C256.838%20208.683%20256.875%20208.771%20256.875%20208.875ZM260.625%20208.875C260.625%20208.979%20260.588%20209.067%20260.515%20209.14C260.442%20209.213%20260.354%20209.25%20260.25%20209.25C260.146%20209.25%20260.058%20209.213%20259.985%20209.14C259.912%20209.067%20259.875%20208.979%20259.875%20208.875C259.875%20208.771%20259.912%20208.683%20259.985%20208.61C260.058%20208.537%20260.146%20208.5%20260.25%20208.5C260.354%20208.5%20260.442%20208.537%20260.515%20208.61C260.588%20208.683%20260.625%20208.771%20260.625%20208.875ZM264.375%20208.875C264.375%20208.979%20264.338%20209.067%20264.265%20209.14C264.192%20209.213%20264.104%20209.25%20264%20209.25C263.896%20209.25%20263.808%20209.213%20263.735%20209.14C263.662%20209.067%20263.625%20208.979%20263.625%20208.875C263.625%20208.771%20263.662%20208.683%20263.735%20208.61C263.808%20208.537%20263.896%20208.5%20264%20208.5C264.104%20208.5%20264.192%20208.537%20264.265%20208.61C264.338%20208.683%20264.375%20208.771%20264.375%20208.875ZM268.125%20208.875C268.125%20208.979%20268.088%20209.067%20268.015%20209.14C267.942%20209.213%20267.854%20209.25%20267.75%20209.25C267.646%20209.25%20267.558%20209.213%20267.485%20209.14C267.412%20209.067%20267.375%20208.979%20267.375%20208.875C267.375%20208.771%20267.412%20208.683%20267.485%20208.61C267.558%20208.537%20267.646%20208.5%20267.75%20208.5C267.854%20208.5%20267.942%20208.537%20268.015%20208.61C268.088%20208.683%20268.125%20208.771%20268.125%20208.875ZM271.875%20208.875C271.875%20208.979%20271.838%20209.067%20271.765%20209.14C271.692%20209.213%20271.604%20209.25%20271.5%20209.25C271.396%20209.25%20271.308%20209.213%20271.235%20209.14C271.162%20209.067%20271.125%20208.979%20271.125%20208.875C271.125%20208.771%20271.162%20208.683%20271.235%20208.61C271.308%20208.537%20271.396%20208.5%20271.5%20208.5C271.604%20208.5%20271.692%20208.537%20271.765%20208.61C271.838%20208.683%20271.875%20208.771%20271.875%20208.875ZM275.625%20208.875C275.625%20208.979%20275.588%20209.067%20275.515%20209.14C275.442%20209.213%20275.354%20209.25%20275.25%20209.25C275.146%20209.25%20275.058%20209.213%20274.985%20209.14C274.912%20209.067%20274.875%20208.979%20274.875%20208.875C274.875%20208.771%20274.912%20208.683%20274.985%20208.61C275.058%20208.537%20275.146%20208.5%20275.25%20208.5C275.354%20208.5%20275.442%20208.537%20275.515%20208.61C275.588%20208.683%20275.625%20208.771%20275.625%20208.875ZM279.375%20208.875C279.375%20208.979%20279.338%20209.067%20279.265%20209.14C279.192%20209.213%20279.104%20209.25%20279%20209.25C278.896%20209.25%20278.808%20209.213%20278.735%20209.14C278.662%20209.067%20278.625%20208.979%20278.625%20208.875C278.625%20208.771%20278.662%20208.683%20278.735%20208.61C278.808%20208.537%20278.896%20208.5%20279%20208.5C279.104%20208.5%20279.192%20208.537%20279.265%20208.61C279.338%20208.683%20279.375%20208.771%20279.375%20208.875ZM283.125%20208.875C283.125%20208.979%20283.088%20209.067%20283.015%20209.14C282.942%20209.213%20282.854%20209.25%20282.75%20209.25C282.646%20209.25%20282.558%20209.213%20282.485%20209.14C282.412%20209.067%20282.375%20208.979%20282.375%20208.875C282.375%20208.771%20282.412%20208.683%20282.485%20208.61C282.558%20208.537%20282.646%20208.5%20282.75%20208.5C282.854%20208.5%20282.942%20208.537%20283.015%20208.61C283.088%20208.683%20283.125%20208.771%20283.125%20208.875ZM286.875%20208.875C286.875%20208.979%20286.838%20209.067%20286.765%20209.14C286.692%20209.213%20286.604%20209.25%20286.5%20209.25C286.396%20209.25%20286.308%20209.213%20286.235%20209.14C286.162%20209.067%20286.125%20208.979%20286.125%20208.875C286.125%20208.771%20286.162%20208.683%20286.235%20208.61C286.308%20208.537%20286.396%20208.5%20286.5%20208.5C286.604%20208.5%20286.692%20208.537%20286.765%20208.61C286.838%20208.683%20286.875%20208.771%20286.875%20208.875ZM290.625%20208.875C290.625%20208.979%20290.588%20209.067%20290.515%20209.14C290.442%20209.213%20290.354%20209.25%20290.25%20209.25C290.146%20209.25%20290.058%20209.213%20289.985%20209.14C289.912%20209.067%20289.875%20208.979%20289.875%20208.875C289.875%20208.771%20289.912%20208.683%20289.985%20208.61C290.058%20208.537%20290.146%20208.5%20290.25%20208.5C290.354%20208.5%20290.442%20208.537%20290.515%20208.61C290.588%20208.683%20290.625%20208.771%20290.625%20208.875ZM294.375%20208.875C294.375%20208.979%20294.338%20209.067%20294.265%20209.14C294.192%20209.213%20294.104%20209.25%20294%20209.25C293.896%20209.25%20293.808%20209.213%20293.735%20209.14C293.662%20209.067%20293.625%20208.979%20293.625%20208.875C293.625%20208.771%20293.662%20208.683%20293.735%20208.61C293.808%20208.537%20293.896%20208.5%20294%20208.5C294.104%20208.5%20294.192%20208.537%20294.265%20208.61C294.338%20208.683%20294.375%20208.771%20294.375%20208.875ZM298.125%20208.875C298.125%20208.979%20298.088%20209.067%20298.015%20209.14C297.942%20209.213%20297.854%20209.25%20297.75%20209.25C297.646%20209.25%20297.558%20209.213%20297.485%20209.14C297.412%20209.067%20297.375%20208.979%20297.375%20208.875C297.375%20208.771%20297.412%20208.683%20297.485%20208.61C297.558%20208.537%20297.646%20208.5%20297.75%20208.5C297.854%20208.5%20297.942%20208.537%20298.015%20208.61C298.088%20208.683%20298.125%20208.771%20298.125%20208.875ZM301.875%20208.875C301.875%20208.979%20301.838%20209.067%20301.765%20209.14C301.692%20209.213%20301.604%20209.25%20301.5%20209.25C301.396%20209.25%20301.308%20209.213%20301.235%20209.14C301.162%20209.067%20301.125%20208.979%20301.125%20208.875C301.125%20208.771%20301.162%20208.683%20301.235%20208.61C301.308%20208.537%20301.396%20208.5%20301.5%20208.5C301.604%20208.5%20301.692%20208.537%20301.765%20208.61C301.838%20208.683%20301.875%20208.771%20301.875%20208.875ZM305.625%20208.875C305.625%20208.979%20305.588%20209.067%20305.515%20209.14C305.442%20209.213%20305.354%20209.25%20305.25%20209.25C305.146%20209.25%20305.058%20209.213%20304.985%20209.14C304.912%20209.067%20304.875%20208.979%20304.875%20208.875C304.875%20208.771%20304.912%20208.683%20304.985%20208.61C305.058%20208.537%20305.146%20208.5%20305.25%20208.5C305.354%20208.5%20305.442%20208.537%20305.515%20208.61C305.588%20208.683%20305.625%20208.771%20305.625%20208.875ZM309.375%20208.875C309.375%20208.979%20309.338%20209.067%20309.265%20209.14C309.192%20209.213%20309.104%20209.25%20309%20209.25C308.896%20209.25%20308.808%20209.213%20308.735%20209.14C308.662%20209.067%20308.625%20208.979%20308.625%20208.875C308.625%20208.771%20308.662%20208.683%20308.735%20208.61C308.808%20208.537%20308.896%20208.5%20309%20208.5C309.104%20208.5%20309.192%20208.537%20309.265%20208.61C309.338%20208.683%20309.375%20208.771%20309.375%20208.875ZM313.125%20208.875C313.125%20208.979%20313.088%20209.067%20313.015%20209.14C312.942%20209.213%20312.854%20209.25%20312.75%20209.25C312.646%20209.25%20312.558%20209.213%20312.485%20209.14C312.412%20209.067%20312.375%20208.979%20312.375%20208.875C312.375%20208.771%20312.412%20208.683%20312.485%20208.61C312.558%20208.537%20312.646%20208.5%20312.75%20208.5C312.854%20208.5%20312.942%20208.537%20313.015%20208.61C313.088%20208.683%20313.125%20208.771%20313.125%20208.875ZM316.875%20208.875C316.875%20208.979%20316.838%20209.067%20316.765%20209.14C316.692%20209.213%20316.604%20209.25%20316.5%20209.25C316.396%20209.25%20316.308%20209.213%20316.235%20209.14C316.162%20209.067%20316.125%20208.979%20316.125%20208.875C316.125%20208.771%20316.162%20208.683%20316.235%20208.61C316.308%20208.537%20316.396%20208.5%20316.5%20208.5C316.604%20208.5%20316.692%20208.537%20316.765%20208.61C316.838%20208.683%20316.875%20208.771%20316.875%20208.875ZM320.625%20208.875C320.625%20208.979%20320.588%20209.067%20320.515%20209.14C320.442%20209.213%20320.354%20209.25%20320.25%20209.25C320.146%20209.25%20320.058%20209.213%20319.985%20209.14C319.912%20209.067%20319.875%20208.979%20319.875%20208.875C319.875%20208.771%20319.912%20208.683%20319.985%20208.61C320.058%20208.537%20320.146%20208.5%20320.25%20208.5C320.354%20208.5%20320.442%20208.537%20320.515%20208.61C320.588%20208.683%20320.625%20208.771%20320.625%20208.875ZM324.375%20208.875C324.375%20208.979%20324.338%20209.067%20324.265%20209.14C324.192%20209.213%20324.104%20209.25%20324%20209.25C323.896%20209.25%20323.808%20209.213%20323.735%20209.14C323.662%20209.067%20323.625%20208.979%20323.625%20208.875C323.625%20208.771%20323.662%20208.683%20323.735%20208.61C323.808%20208.537%20323.896%20208.5%20324%20208.5C324.104%20208.5%20324.192%20208.537%20324.265%20208.61C324.338%20208.683%20324.375%20208.771%20324.375%20208.875ZM328.125%20208.875C328.125%20208.979%20328.088%20209.067%20328.015%20209.14C327.942%20209.213%20327.854%20209.25%20327.75%20209.25C327.646%20209.25%20327.558%20209.213%20327.485%20209.14C327.412%20209.067%20327.375%20208.979%20327.375%20208.875C327.375%20208.771%20327.412%20208.683%20327.485%20208.61C327.558%20208.537%20327.646%20208.5%20327.75%20208.5C327.854%20208.5%20327.942%20208.537%20328.015%20208.61C328.088%20208.683%20328.125%20208.771%20328.125%20208.875ZM331.875%20208.875C331.875%20208.979%20331.838%20209.067%20331.765%20209.14C331.692%20209.213%20331.604%20209.25%20331.5%20209.25C331.396%20209.25%20331.308%20209.213%20331.235%20209.14C331.162%20209.067%20331.125%20208.979%20331.125%20208.875C331.125%20208.771%20331.162%20208.683%20331.235%20208.61C331.308%20208.537%20331.396%20208.5%20331.5%20208.5C331.604%20208.5%20331.692%20208.537%20331.765%20208.61C331.838%20208.683%20331.875%20208.771%20331.875%20208.875ZM335.625%20208.875C335.625%20208.979%20335.588%20209.067%20335.515%20209.14C335.442%20209.213%20335.354%20209.25%20335.25%20209.25C335.146%20209.25%20335.058%20209.213%20334.985%20209.14C334.912%20209.067%20334.875%20208.979%20334.875%20208.875C334.875%20208.771%20334.912%20208.683%20334.985%20208.61C335.058%20208.537%20335.146%20208.5%20335.25%20208.5C335.354%20208.5%20335.442%20208.537%20335.515%20208.61C335.588%20208.683%20335.625%20208.771%20335.625%20208.875ZM339.375%20208.875C339.375%20208.979%20339.338%20209.067%20339.265%20209.14C339.192%20209.213%20339.104%20209.25%20339%20209.25C338.896%20209.25%20338.808%20209.213%20338.735%20209.14C338.662%20209.067%20338.625%20208.979%20338.625%20208.875C338.625%20208.771%20338.662%20208.683%20338.735%20208.61C338.808%20208.537%20338.896%20208.5%20339%20208.5C339.104%20208.5%20339.192%20208.537%20339.265%20208.61C339.338%20208.683%20339.375%20208.771%20339.375%20208.875ZM343.125%20208.875C343.125%20208.979%20343.088%20209.067%20343.015%20209.14C342.942%20209.213%20342.854%20209.25%20342.75%20209.25C342.646%20209.25%20342.558%20209.213%20342.485%20209.14C342.412%20209.067%20342.375%20208.979%20342.375%20208.875C342.375%20208.771%20342.412%20208.683%20342.485%20208.61C342.558%20208.537%20342.646%20208.5%20342.75%20208.5C342.854%20208.5%20342.942%20208.537%20343.015%20208.61C343.088%20208.683%20343.125%20208.771%20343.125%20208.875ZM346.875%20208.875C346.875%20208.979%20346.838%20209.067%20346.765%20209.14C346.692%20209.213%20346.604%20209.25%20346.5%20209.25C346.396%20209.25%20346.308%20209.213%20346.235%20209.14C346.162%20209.067%20346.125%20208.979%20346.125%20208.875C346.125%20208.771%20346.162%20208.683%20346.235%20208.61C346.308%20208.537%20346.396%20208.5%20346.5%20208.5C346.604%20208.5%20346.692%20208.537%20346.765%20208.61C346.838%20208.683%20346.875%20208.771%20346.875%20208.875ZM350.625%20208.875C350.625%20208.979%20350.588%20209.067%20350.515%20209.14C350.442%20209.213%20350.353%20209.25%20350.25%20209.25C350.146%20209.25%20350.058%20209.213%20349.985%20209.14C349.912%20209.067%20349.875%20208.979%20349.875%20208.875C349.875%20208.771%20349.912%20208.683%20349.985%20208.61C350.058%20208.537%20350.146%20208.5%20350.25%20208.5C350.353%20208.5%20350.442%20208.537%20350.515%20208.61C350.588%20208.683%20350.625%20208.771%20350.625%20208.875ZM354.375%20208.875C354.375%20208.979%20354.338%20209.067%20354.265%20209.14C354.192%20209.213%20354.104%20209.25%20354%20209.25C353.896%20209.25%20353.808%20209.213%20353.735%20209.14C353.662%20209.067%20353.625%20208.979%20353.625%20208.875C353.625%20208.771%20353.662%20208.683%20353.735%20208.61C353.808%20208.537%20353.896%20208.5%20354%20208.5C354.104%20208.5%20354.192%20208.537%20354.265%20208.61C354.338%20208.683%20354.375%20208.771%20354.375%20208.875ZM358.125%20208.875C358.125%20208.979%20358.088%20209.067%20358.015%20209.14C357.942%20209.213%20357.854%20209.25%20357.75%20209.25C357.646%20209.25%20357.558%20209.213%20357.485%20209.14C357.412%20209.067%20357.375%20208.979%20357.375%20208.875C357.375%20208.771%20357.412%20208.683%20357.485%20208.61C357.558%20208.537%20357.646%20208.5%20357.75%20208.5C357.854%20208.5%20357.942%20208.537%20358.015%20208.61C358.088%20208.683%20358.125%20208.771%20358.125%20208.875ZM361.875%20208.875C361.875%20208.979%20361.838%20209.067%20361.765%20209.14C361.692%20209.213%20361.603%20209.25%20361.5%20209.25C361.396%20209.25%20361.308%20209.213%20361.235%20209.14C361.162%20209.067%20361.125%20208.979%20361.125%20208.875C361.125%20208.771%20361.162%20208.683%20361.235%20208.61C361.308%20208.537%20361.396%20208.5%20361.5%20208.5C361.603%20208.5%20361.692%20208.537%20361.765%20208.61C361.838%20208.683%20361.875%20208.771%20361.875%20208.875ZM365.625%20208.875C365.625%20208.979%20365.588%20209.067%20365.515%20209.14C365.442%20209.213%20365.354%20209.25%20365.25%20209.25C365.146%20209.25%20365.058%20209.213%20364.985%20209.14C364.912%20209.067%20364.875%20208.979%20364.875%20208.875C364.875%20208.771%20364.912%20208.683%20364.985%20208.61C365.058%20208.537%20365.146%20208.5%20365.25%20208.5C365.354%20208.5%20365.442%20208.537%20365.515%20208.61C365.588%20208.683%20365.625%20208.771%20365.625%20208.875ZM369.375%20208.875C369.375%20208.979%20369.338%20209.067%20369.265%20209.14C369.192%20209.213%20369.104%20209.25%20369%20209.25C368.896%20209.25%20368.808%20209.213%20368.735%20209.14C368.662%20209.067%20368.625%20208.979%20368.625%20208.875C368.625%20208.771%20368.662%20208.683%20368.735%20208.61C368.808%20208.537%20368.896%20208.5%20369%20208.5C369.104%20208.5%20369.192%20208.537%20369.265%20208.61C369.338%20208.683%20369.375%20208.771%20369.375%20208.875ZM373.125%20208.875C373.125%20208.979%20373.088%20209.067%20373.015%20209.14C372.942%20209.213%20372.854%20209.25%20372.75%20209.25C372.646%20209.25%20372.558%20209.213%20372.485%20209.14C372.412%20209.067%20372.375%20208.979%20372.375%20208.875C372.375%20208.771%20372.412%20208.683%20372.485%20208.61C372.558%20208.537%20372.646%20208.5%20372.75%20208.5C372.854%20208.5%20372.942%20208.537%20373.015%20208.61C373.088%20208.683%20373.125%20208.771%20373.125%20208.875ZM376.875%20208.875C376.875%20208.979%20376.838%20209.067%20376.765%20209.14C376.692%20209.213%20376.604%20209.25%20376.5%20209.25C376.396%20209.25%20376.308%20209.213%20376.235%20209.14C376.162%20209.067%20376.125%20208.979%20376.125%20208.875C376.125%20208.771%20376.162%20208.683%20376.235%20208.61C376.308%20208.537%20376.396%20208.5%20376.5%20208.5C376.604%20208.5%20376.692%20208.537%20376.765%20208.61C376.838%20208.683%20376.875%20208.771%20376.875%20208.875ZM380.625%20208.875C380.625%20208.979%20380.588%20209.067%20380.515%20209.14C380.442%20209.213%20380.354%20209.25%20380.25%20209.25C380.146%20209.25%20380.058%20209.213%20379.985%20209.14C379.912%20209.067%20379.875%20208.979%20379.875%20208.875C379.875%20208.771%20379.912%20208.683%20379.985%20208.61C380.058%20208.537%20380.146%20208.5%20380.25%20208.5C380.354%20208.5%20380.442%20208.537%20380.515%20208.61C380.588%20208.683%20380.625%20208.771%20380.625%20208.875ZM384.375%20208.875C384.375%20208.979%20384.338%20209.067%20384.265%20209.14C384.192%20209.213%20384.104%20209.25%20384%20209.25C383.896%20209.25%20383.808%20209.213%20383.735%20209.14C383.662%20209.067%20383.625%20208.979%20383.625%20208.875C383.625%20208.771%20383.662%20208.683%20383.735%20208.61C383.808%20208.537%20383.896%20208.5%20384%20208.5C384.104%20208.5%20384.192%20208.537%20384.265%20208.61C384.338%20208.683%20384.375%20208.771%20384.375%20208.875ZM388.125%20208.875C388.125%20208.979%20388.088%20209.067%20388.015%20209.14C387.942%20209.213%20387.854%20209.25%20387.75%20209.25C387.646%20209.25%20387.558%20209.213%20387.485%20209.14C387.412%20209.067%20387.375%20208.979%20387.375%20208.875C387.375%20208.771%20387.412%20208.683%20387.485%20208.61C387.558%20208.537%20387.646%20208.5%20387.75%20208.5C387.854%20208.5%20387.942%20208.537%20388.015%20208.61C388.088%20208.683%20388.125%20208.771%20388.125%20208.875ZM391.875%20208.875C391.875%20208.979%20391.838%20209.067%20391.765%20209.14C391.692%20209.213%20391.603%20209.25%20391.5%20209.25C391.396%20209.25%20391.308%20209.213%20391.235%20209.14C391.162%20209.067%20391.125%20208.979%20391.125%20208.875C391.125%20208.771%20391.162%20208.683%20391.235%20208.61C391.308%20208.537%20391.396%20208.5%20391.5%20208.5C391.603%20208.5%20391.692%20208.537%20391.765%20208.61C391.838%20208.683%20391.875%20208.771%20391.875%20208.875ZM395.625%20208.875C395.625%20208.979%20395.588%20209.067%20395.515%20209.14C395.442%20209.213%20395.354%20209.25%20395.25%20209.25C395.146%20209.25%20395.058%20209.213%20394.985%20209.14C394.912%20209.067%20394.875%20208.979%20394.875%20208.875C394.875%20208.771%20394.912%20208.683%20394.985%20208.61C395.058%20208.537%20395.146%20208.5%20395.25%20208.5C395.354%20208.5%20395.442%20208.537%20395.515%20208.61C395.588%20208.683%20395.625%20208.771%20395.625%20208.875ZM399.375%20208.875C399.375%20208.979%20399.338%20209.067%20399.265%20209.14C399.192%20209.213%20399.104%20209.25%20399%20209.25C398.896%20209.25%20398.808%20209.213%20398.735%20209.14C398.662%20209.067%20398.625%20208.979%20398.625%20208.875C398.625%20208.771%20398.662%20208.683%20398.735%20208.61C398.808%20208.537%20398.896%20208.5%20399%20208.5C399.104%20208.5%20399.192%20208.537%20399.265%20208.61C399.338%20208.683%20399.375%20208.771%20399.375%20208.875ZM403.125%20208.875C403.125%20208.979%20403.088%20209.067%20403.015%20209.14C402.942%20209.213%20402.854%20209.25%20402.75%20209.25C402.646%20209.25%20402.558%20209.213%20402.485%20209.14C402.412%20209.067%20402.375%20208.979%20402.375%20208.875C402.375%20208.771%20402.412%20208.683%20402.485%20208.61C402.558%20208.537%20402.646%20208.5%20402.75%20208.5C402.854%20208.5%20402.942%20208.537%20403.015%20208.61C403.088%20208.683%20403.125%20208.771%20403.125%20208.875ZM406.875%20208.875C406.875%20208.979%20406.838%20209.067%20406.765%20209.14C406.692%20209.213%20406.604%20209.25%20406.5%20209.25C406.396%20209.25%20406.308%20209.213%20406.235%20209.14C406.162%20209.067%20406.125%20208.979%20406.125%20208.875C406.125%20208.771%20406.162%20208.683%20406.235%20208.61C406.308%20208.537%20406.396%20208.5%20406.5%20208.5C406.604%20208.5%20406.692%20208.537%20406.765%20208.61C406.838%20208.683%20406.875%20208.771%20406.875%20208.875ZM410.625%20208.875C410.625%20208.979%20410.588%20209.067%20410.515%20209.14C410.442%20209.213%20410.354%20209.25%20410.25%20209.25C410.146%20209.25%20410.058%20209.213%20409.985%20209.14C409.912%20209.067%20409.875%20208.979%20409.875%20208.875C409.875%20208.771%20409.912%20208.683%20409.985%20208.61C410.058%20208.537%20410.146%20208.5%20410.25%20208.5C410.354%20208.5%20410.442%20208.537%20410.515%20208.61C410.588%20208.683%20410.625%20208.771%20410.625%20208.875ZM414.375%20208.875C414.375%20208.979%20414.338%20209.067%20414.265%20209.14C414.192%20209.213%20414.104%20209.25%20414%20209.25C413.896%20209.25%20413.808%20209.213%20413.735%20209.14C413.662%20209.067%20413.625%20208.979%20413.625%20208.875C413.625%20208.771%20413.662%20208.683%20413.735%20208.61C413.808%20208.537%20413.896%20208.5%20414%20208.5C414.104%20208.5%20414.192%20208.537%20414.265%20208.61C414.338%20208.683%20414.375%20208.771%20414.375%20208.875ZM418.125%20208.875C418.125%20208.979%20418.088%20209.067%20418.015%20209.14C417.942%20209.213%20417.854%20209.25%20417.75%20209.25C417.646%20209.25%20417.558%20209.213%20417.485%20209.14C417.412%20209.067%20417.375%20208.979%20417.375%20208.875C417.375%20208.771%20417.412%20208.683%20417.485%20208.61C417.558%20208.537%20417.646%20208.5%20417.75%20208.5C417.854%20208.5%20417.942%20208.537%20418.015%20208.61C418.088%20208.683%20418.125%20208.771%20418.125%20208.875ZM421.875%20208.875C421.875%20208.979%20421.838%20209.067%20421.765%20209.14C421.692%20209.213%20421.604%20209.25%20421.5%20209.25C421.396%20209.25%20421.308%20209.213%20421.235%20209.14C421.162%20209.067%20421.125%20208.979%20421.125%20208.875C421.125%20208.771%20421.162%20208.683%20421.235%20208.61C421.308%20208.537%20421.396%20208.5%20421.5%20208.5C421.604%20208.5%20421.692%20208.537%20421.765%20208.61C421.838%20208.683%20421.875%20208.771%20421.875%20208.875ZM425.625%20208.875C425.625%20208.979%20425.588%20209.067%20425.515%20209.14C425.442%20209.213%20425.354%20209.25%20425.25%20209.25C425.146%20209.25%20425.058%20209.213%20424.985%20209.14C424.912%20209.067%20424.875%20208.979%20424.875%20208.875C424.875%20208.771%20424.912%20208.683%20424.985%20208.61C425.058%20208.537%20425.146%20208.5%20425.25%20208.5C425.354%20208.5%20425.442%20208.537%20425.515%20208.61C425.588%20208.683%20425.625%20208.771%20425.625%20208.875ZM429.375%20208.875C429.375%20208.979%20429.338%20209.067%20429.265%20209.14C429.192%20209.213%20429.104%20209.25%20429%20209.25C428.896%20209.25%20428.808%20209.213%20428.735%20209.14C428.662%20209.067%20428.625%20208.979%20428.625%20208.875C428.625%20208.771%20428.662%20208.683%20428.735%20208.61C428.808%20208.537%20428.896%20208.5%20429%20208.5C429.104%20208.5%20429.192%20208.537%20429.265%20208.61C429.338%20208.683%20429.375%20208.771%20429.375%20208.875ZM433.125%20208.875C433.125%20208.979%20433.088%20209.067%20433.015%20209.14C432.942%20209.213%20432.854%20209.25%20432.75%20209.25C432.646%20209.25%20432.558%20209.213%20432.485%20209.14C432.412%20209.067%20432.375%20208.979%20432.375%20208.875C432.375%20208.771%20432.412%20208.683%20432.485%20208.61C432.558%20208.537%20432.646%20208.5%20432.75%20208.5C432.854%20208.5%20432.942%20208.537%20433.015%20208.61C433.088%20208.683%20433.125%20208.771%20433.125%20208.875ZM436.875%20208.875C436.875%20208.979%20436.838%20209.067%20436.765%20209.14C436.692%20209.213%20436.604%20209.25%20436.5%20209.25C436.396%20209.25%20436.308%20209.213%20436.235%20209.14C436.162%20209.067%20436.125%20208.979%20436.125%20208.875C436.125%20208.771%20436.162%20208.683%20436.235%20208.61C436.308%20208.537%20436.396%20208.5%20436.5%20208.5C436.604%20208.5%20436.692%20208.537%20436.765%20208.61C436.838%20208.683%20436.875%20208.771%20436.875%20208.875ZM440.625%20208.875C440.625%20208.979%20440.588%20209.067%20440.515%20209.14C440.442%20209.213%20440.354%20209.25%20440.25%20209.25C440.146%20209.25%20440.058%20209.213%20439.985%20209.14C439.912%20209.067%20439.875%20208.979%20439.875%20208.875C439.875%20208.771%20439.912%20208.683%20439.985%20208.61C440.058%20208.537%20440.146%20208.5%20440.25%20208.5C440.354%20208.5%20440.442%20208.537%20440.515%20208.61C440.588%20208.683%20440.625%20208.771%20440.625%20208.875ZM444.375%20208.875C444.375%20208.979%20444.338%20209.067%20444.265%20209.14C444.192%20209.213%20444.104%20209.25%20444%20209.25C443.896%20209.25%20443.808%20209.213%20443.735%20209.14C443.662%20209.067%20443.625%20208.979%20443.625%20208.875C443.625%20208.771%20443.662%20208.683%20443.735%20208.61C443.808%20208.537%20443.896%20208.5%20444%20208.5C444.104%20208.5%20444.192%20208.537%20444.265%20208.61C444.338%20208.683%20444.375%20208.771%20444.375%20208.875ZM448.125%20208.875C448.125%20208.979%20448.088%20209.067%20448.015%20209.14C447.942%20209.213%20447.854%20209.25%20447.75%20209.25C447.646%20209.25%20447.558%20209.213%20447.485%20209.14C447.412%20209.067%20447.375%20208.979%20447.375%20208.875C447.375%20208.771%20447.412%20208.683%20447.485%20208.61C447.558%20208.537%20447.646%20208.5%20447.75%20208.5C447.854%20208.5%20447.942%20208.537%20448.015%20208.61C448.088%20208.683%20448.125%20208.771%20448.125%20208.875ZM451.875%20208.875C451.875%20208.979%20451.838%20209.067%20451.765%20209.14C451.692%20209.213%20451.604%20209.25%20451.5%20209.25C451.396%20209.25%20451.308%20209.213%20451.235%20209.14C451.162%20209.067%20451.125%20208.979%20451.125%20208.875C451.125%20208.771%20451.162%20208.683%20451.235%20208.61C451.308%20208.537%20451.396%20208.5%20451.5%20208.5C451.604%20208.5%20451.692%20208.537%20451.765%20208.61C451.838%20208.683%20451.875%20208.771%20451.875%20208.875ZM455.625%20208.875C455.625%20208.979%20455.588%20209.067%20455.515%20209.14C455.442%20209.213%20455.354%20209.25%20455.25%20209.25C455.146%20209.25%20455.058%20209.213%20454.985%20209.14C454.912%20209.067%20454.875%20208.979%20454.875%20208.875C454.875%20208.771%20454.912%20208.683%20454.985%20208.61C455.058%20208.537%20455.146%20208.5%20455.25%20208.5C455.354%20208.5%20455.442%20208.537%20455.515%20208.61C455.588%20208.683%20455.625%20208.771%20455.625%20208.875ZM459.375%20208.875C459.375%20208.979%20459.338%20209.067%20459.265%20209.14C459.192%20209.213%20459.103%20209.25%20459%20209.25C458.896%20209.25%20458.808%20209.213%20458.735%20209.14C458.662%20209.067%20458.625%20208.979%20458.625%20208.875C458.625%20208.771%20458.662%20208.683%20458.735%20208.61C458.808%20208.537%20458.896%20208.5%20459%20208.5C459.103%20208.5%20459.192%20208.537%20459.265%20208.61C459.338%20208.683%20459.375%20208.771%20459.375%20208.875ZM463.125%20208.875C463.125%20208.979%20463.088%20209.067%20463.015%20209.14C462.942%20209.213%20462.853%20209.25%20462.75%20209.25C462.646%20209.25%20462.558%20209.213%20462.485%20209.14C462.412%20209.067%20462.375%20208.979%20462.375%20208.875C462.375%20208.771%20462.412%20208.683%20462.485%20208.61C462.558%20208.537%20462.646%20208.5%20462.75%20208.5C462.853%20208.5%20462.942%20208.537%20463.015%20208.61C463.088%20208.683%20463.125%20208.771%20463.125%20208.875ZM466.875%20208.875C466.875%20208.979%20466.838%20209.067%20466.765%20209.14C466.692%20209.213%20466.604%20209.25%20466.5%20209.25C466.396%20209.25%20466.308%20209.213%20466.235%20209.14C466.162%20209.067%20466.125%20208.979%20466.125%20208.875C466.125%20208.771%20466.162%20208.683%20466.235%20208.61C466.308%20208.537%20466.396%20208.5%20466.5%20208.5C466.604%20208.5%20466.692%20208.537%20466.765%20208.61C466.838%20208.683%20466.875%20208.771%20466.875%20208.875ZM470.625%20208.875C470.625%20208.979%20470.588%20209.067%20470.515%20209.14C470.442%20209.213%20470.354%20209.25%20470.25%20209.25C470.146%20209.25%20470.058%20209.213%20469.985%20209.14C469.912%20209.067%20469.875%20208.979%20469.875%20208.875C469.875%20208.771%20469.912%20208.683%20469.985%20208.61C470.058%20208.537%20470.146%20208.5%20470.25%20208.5C470.354%20208.5%20470.442%20208.537%20470.515%20208.61C470.588%20208.683%20470.625%20208.771%20470.625%20208.875ZM474.375%20208.875C474.375%20208.979%20474.338%20209.067%20474.265%20209.14C474.192%20209.213%20474.104%20209.25%20474%20209.25C473.896%20209.25%20473.808%20209.213%20473.735%20209.14C473.662%20209.067%20473.625%20208.979%20473.625%20208.875C473.625%20208.771%20473.662%20208.683%20473.735%20208.61C473.808%20208.537%20473.896%20208.5%20474%20208.5C474.104%20208.5%20474.192%20208.537%20474.265%20208.61C474.338%20208.683%20474.375%20208.771%20474.375%20208.875ZM478.125%20208.875C478.125%20208.979%20478.088%20209.067%20478.015%20209.14C477.942%20209.213%20477.854%20209.25%20477.75%20209.25C477.646%20209.25%20477.558%20209.213%20477.485%20209.14C477.412%20209.067%20477.375%20208.979%20477.375%20208.875C477.375%20208.771%20477.412%20208.683%20477.485%20208.61C477.558%20208.537%20477.646%20208.5%20477.75%20208.5C477.854%20208.5%20477.942%20208.537%20478.015%20208.61C478.088%20208.683%20478.125%20208.771%20478.125%20208.875ZM481.875%20208.875C481.875%20208.979%20481.838%20209.067%20481.765%20209.14C481.692%20209.213%20481.604%20209.25%20481.5%20209.25C481.396%20209.25%20481.308%20209.213%20481.235%20209.14C481.162%20209.067%20481.125%20208.979%20481.125%20208.875C481.125%20208.771%20481.162%20208.683%20481.235%20208.61C481.308%20208.537%20481.396%20208.5%20481.5%20208.5C481.604%20208.5%20481.692%20208.537%20481.765%20208.61C481.838%20208.683%20481.875%20208.771%20481.875%20208.875ZM485.625%20208.875C485.625%20208.979%20485.588%20209.067%20485.515%20209.14C485.442%20209.213%20485.354%20209.25%20485.25%20209.25C485.146%20209.25%20485.058%20209.213%20484.985%20209.14C484.912%20209.067%20484.875%20208.979%20484.875%20208.875C484.875%20208.771%20484.912%20208.683%20484.985%20208.61C485.058%20208.537%20485.146%20208.5%20485.25%20208.5C485.354%20208.5%20485.442%20208.537%20485.515%20208.61C485.588%20208.683%20485.625%20208.771%20485.625%20208.875ZM489.375%20208.875C489.375%20208.979%20489.338%20209.067%20489.265%20209.14C489.192%20209.213%20489.104%20209.25%20489%20209.25C488.896%20209.25%20488.808%20209.213%20488.735%20209.14C488.662%20209.067%20488.625%20208.979%20488.625%20208.875C488.625%20208.771%20488.662%20208.683%20488.735%20208.61C488.808%20208.537%20488.896%20208.5%20489%20208.5C489.104%20208.5%20489.192%20208.537%20489.265%20208.61C489.338%20208.683%20489.375%20208.771%20489.375%20208.875ZM493.125%20208.875C493.125%20208.979%20493.088%20209.067%20493.015%20209.14C492.942%20209.213%20492.854%20209.25%20492.75%20209.25C492.646%20209.25%20492.558%20209.213%20492.485%20209.14C492.412%20209.067%20492.375%20208.979%20492.375%20208.875C492.375%20208.771%20492.412%20208.683%20492.485%20208.61C492.558%20208.537%20492.646%20208.5%20492.75%20208.5C492.854%20208.5%20492.942%20208.537%20493.015%20208.61C493.088%20208.683%20493.125%20208.771%20493.125%20208.875ZM496.875%20208.875C496.875%20208.979%20496.838%20209.067%20496.765%20209.14C496.692%20209.213%20496.603%20209.25%20496.5%20209.25C496.396%20209.25%20496.308%20209.213%20496.235%20209.14C496.162%20209.067%20496.125%20208.979%20496.125%20208.875C496.125%20208.771%20496.162%20208.683%20496.235%20208.61C496.308%20208.537%20496.396%20208.5%20496.5%20208.5C496.603%20208.5%20496.692%20208.537%20496.765%20208.61C496.838%20208.683%20496.875%20208.771%20496.875%20208.875ZM500.625%20208.875C500.625%20208.979%20500.588%20209.067%20500.515%20209.14C500.442%20209.213%20500.353%20209.25%20500.25%20209.25C500.146%20209.25%20500.058%20209.213%20499.985%20209.14C499.912%20209.067%20499.875%20208.979%20499.875%20208.875C499.875%20208.771%20499.912%20208.683%20499.985%20208.61C500.058%20208.537%20500.146%20208.5%20500.25%20208.5C500.353%20208.5%20500.442%20208.537%20500.515%20208.61C500.588%20208.683%20500.625%20208.771%20500.625%20208.875ZM504.375%20208.875C504.375%20208.979%20504.338%20209.067%20504.265%20209.14C504.192%20209.213%20504.103%20209.25%20504%20209.25C503.896%20209.25%20503.808%20209.213%20503.735%20209.14C503.662%20209.067%20503.625%20208.979%20503.625%20208.875C503.625%20208.771%20503.662%20208.683%20503.735%20208.61C503.808%20208.537%20503.896%20208.5%20504%20208.5C504.103%20208.5%20504.192%20208.537%20504.265%20208.61C504.338%20208.683%20504.375%20208.771%20504.375%20208.875ZM508.125%20208.875C508.125%20208.979%20508.088%20209.067%20508.015%20209.14C507.942%20209.213%20507.854%20209.25%20507.75%20209.25C507.646%20209.25%20507.558%20209.213%20507.485%20209.14C507.412%20209.067%20507.375%20208.979%20507.375%20208.875C507.375%20208.771%20507.412%20208.683%20507.485%20208.61C507.558%20208.537%20507.646%20208.5%20507.75%20208.5C507.854%20208.5%20507.942%20208.537%20508.015%20208.61C508.088%20208.683%20508.125%20208.771%20508.125%20208.875ZM511.875%20208.875C511.875%20208.979%20511.838%20209.067%20511.765%20209.14C511.692%20209.213%20511.604%20209.25%20511.5%20209.25C511.396%20209.25%20511.308%20209.213%20511.235%20209.14C511.162%20209.067%20511.125%20208.979%20511.125%20208.875C511.125%20208.771%20511.162%20208.683%20511.235%20208.61C511.308%20208.537%20511.396%20208.5%20511.5%20208.5C511.604%20208.5%20511.692%20208.537%20511.765%20208.61C511.838%20208.683%20511.875%20208.771%20511.875%20208.875ZM515.625%20208.875C515.625%20208.979%20515.588%20209.067%20515.515%20209.14C515.442%20209.213%20515.353%20209.25%20515.25%20209.25C515.146%20209.25%20515.058%20209.213%20514.985%20209.14C514.912%20209.067%20514.875%20208.979%20514.875%20208.875C514.875%20208.771%20514.912%20208.683%20514.985%20208.61C515.058%20208.537%20515.146%20208.5%20515.25%20208.5C515.353%20208.5%20515.442%20208.537%20515.515%20208.61C515.588%20208.683%20515.625%20208.771%20515.625%20208.875ZM519.375%20208.875C519.375%20208.979%20519.338%20209.067%20519.265%20209.14C519.192%20209.213%20519.104%20209.25%20519%20209.25C518.896%20209.25%20518.808%20209.213%20518.735%20209.14C518.662%20209.067%20518.625%20208.979%20518.625%20208.875C518.625%20208.771%20518.662%20208.683%20518.735%20208.61C518.808%20208.537%20518.896%20208.5%20519%20208.5C519.104%20208.5%20519.192%20208.537%20519.265%20208.61C519.338%20208.683%20519.375%20208.771%20519.375%20208.875ZM523.125%20208.875C523.125%20208.979%20523.088%20209.067%20523.015%20209.14C522.942%20209.213%20522.854%20209.25%20522.75%20209.25C522.646%20209.25%20522.558%20209.213%20522.485%20209.14C522.412%20209.067%20522.375%20208.979%20522.375%20208.875C522.375%20208.771%20522.412%20208.683%20522.485%20208.61C522.558%20208.537%20522.646%20208.5%20522.75%20208.5C522.854%20208.5%20522.942%20208.537%20523.015%20208.61C523.088%20208.683%20523.125%20208.771%20523.125%20208.875ZM526.875%20208.875C526.875%20208.979%20526.838%20209.067%20526.765%20209.14C526.692%20209.213%20526.604%20209.25%20526.5%20209.25C526.396%20209.25%20526.308%20209.213%20526.235%20209.14C526.162%20209.067%20526.125%20208.979%20526.125%20208.875C526.125%20208.771%20526.162%20208.683%20526.235%20208.61C526.308%20208.537%20526.396%20208.5%20526.5%20208.5C526.604%20208.5%20526.692%20208.537%20526.765%20208.61C526.838%20208.683%20526.875%20208.771%20526.875%20208.875ZM530.625%20208.875C530.625%20208.979%20530.588%20209.067%20530.515%20209.14C530.442%20209.213%20530.354%20209.25%20530.25%20209.25C530.146%20209.25%20530.058%20209.213%20529.985%20209.14C529.912%20209.067%20529.875%20208.979%20529.875%20208.875C529.875%20208.771%20529.912%20208.683%20529.985%20208.61C530.058%20208.537%20530.146%20208.5%20530.25%20208.5C530.354%20208.5%20530.442%20208.537%20530.515%20208.61C530.588%20208.683%20530.625%20208.771%20530.625%20208.875ZM534.375%20208.875C534.375%20208.979%20534.338%20209.067%20534.265%20209.14C534.192%20209.213%20534.103%20209.25%20534%20209.25C533.896%20209.25%20533.808%20209.213%20533.735%20209.14C533.662%20209.067%20533.625%20208.979%20533.625%20208.875C533.625%20208.771%20533.662%20208.683%20533.735%20208.61C533.808%20208.537%20533.896%20208.5%20534%20208.5C534.103%20208.5%20534.192%20208.537%20534.265%20208.61C534.338%20208.683%20534.375%20208.771%20534.375%20208.875ZM538.125%20208.875C538.125%20208.979%20538.088%20209.067%20538.015%20209.14C537.942%20209.213%20537.853%20209.25%20537.75%20209.25C537.646%20209.25%20537.558%20209.213%20537.485%20209.14C537.412%20209.067%20537.375%20208.979%20537.375%20208.875C537.375%20208.771%20537.412%20208.683%20537.485%20208.61C537.558%20208.537%20537.646%20208.5%20537.75%20208.5C537.853%20208.5%20537.942%20208.537%20538.015%20208.61C538.088%20208.683%20538.125%20208.771%20538.125%20208.875ZM541.875%20208.875C541.875%20208.979%20541.838%20209.067%20541.765%20209.14C541.692%20209.213%20541.603%20209.25%20541.5%20209.25C541.396%20209.25%20541.308%20209.213%20541.235%20209.14C541.162%20209.067%20541.125%20208.979%20541.125%20208.875C541.125%20208.771%20541.162%20208.683%20541.235%20208.61C541.308%20208.537%20541.396%20208.5%20541.5%20208.5C541.603%20208.5%20541.692%20208.537%20541.765%20208.61C541.838%20208.683%20541.875%20208.771%20541.875%20208.875ZM545.625%20208.875C545.625%20208.979%20545.588%20209.067%20545.515%20209.14C545.442%20209.213%20545.353%20209.25%20545.25%20209.25C545.146%20209.25%20545.058%20209.213%20544.985%20209.14C544.912%20209.067%20544.875%20208.979%20544.875%20208.875C544.875%20208.771%20544.912%20208.683%20544.985%20208.61C545.058%20208.537%20545.146%20208.5%20545.25%20208.5C545.353%20208.5%20545.442%20208.537%20545.515%20208.61C545.588%20208.683%20545.625%20208.771%20545.625%20208.875ZM549.375%20208.875C549.375%20208.979%20549.338%20209.067%20549.265%20209.14C549.192%20209.213%20549.103%20209.25%20549%20209.25C548.896%20209.25%20548.808%20209.213%20548.735%20209.14C548.662%20209.067%20548.625%20208.979%20548.625%20208.875C548.625%20208.771%20548.662%20208.683%20548.735%20208.61C548.808%20208.537%20548.896%20208.5%20549%20208.5C549.103%20208.5%20549.192%20208.537%20549.265%20208.61C549.338%20208.683%20549.375%20208.771%20549.375%20208.875ZM553.125%20208.875C553.125%20208.979%20553.088%20209.067%20553.015%20209.14C552.942%20209.213%20552.854%20209.25%20552.75%20209.25C552.646%20209.25%20552.558%20209.213%20552.485%20209.14C552.412%20209.067%20552.375%20208.979%20552.375%20208.875C552.375%20208.771%20552.412%20208.683%20552.485%20208.61C552.558%20208.537%20552.646%20208.5%20552.75%20208.5C552.854%20208.5%20552.942%20208.537%20553.015%20208.61C553.088%20208.683%20553.125%20208.771%20553.125%20208.875ZM556.875%20208.875C556.875%20208.979%20556.838%20209.067%20556.765%20209.14C556.692%20209.213%20556.603%20209.25%20556.5%20209.25C556.396%20209.25%20556.308%20209.213%20556.235%20209.14C556.162%20209.067%20556.125%20208.979%20556.125%20208.875C556.125%20208.771%20556.162%20208.683%20556.235%20208.61C556.308%20208.537%20556.396%20208.5%20556.5%20208.5C556.603%20208.5%20556.692%20208.537%20556.765%20208.61C556.838%20208.683%20556.875%20208.771%20556.875%20208.875ZM560.625%20208.875C560.625%20208.979%20560.588%20209.067%20560.515%20209.14C560.442%20209.213%20560.354%20209.25%20560.25%20209.25C560.146%20209.25%20560.058%20209.213%20559.985%20209.14C559.912%20209.067%20559.875%20208.979%20559.875%20208.875C559.875%20208.771%20559.912%20208.683%20559.985%20208.61C560.058%20208.537%20560.146%20208.5%20560.25%20208.5C560.354%20208.5%20560.442%20208.537%20560.515%20208.61C560.588%20208.683%20560.625%20208.771%20560.625%20208.875ZM564.375%20208.875C564.375%20208.979%20564.338%20209.067%20564.265%20209.14C564.192%20209.213%20564.104%20209.25%20564%20209.25C563.896%20209.25%20563.808%20209.213%20563.735%20209.14C563.662%20209.067%20563.625%20208.979%20563.625%20208.875C563.625%20208.771%20563.662%20208.683%20563.735%20208.61C563.808%20208.537%20563.896%20208.5%20564%20208.5C564.104%20208.5%20564.192%20208.537%20564.265%20208.61C564.338%20208.683%20564.375%20208.771%20564.375%20208.875ZM568.125%20208.875C568.125%20208.979%20568.088%20209.067%20568.015%20209.14C567.942%20209.213%20567.854%20209.25%20567.75%20209.25C567.646%20209.25%20567.558%20209.213%20567.485%20209.14C567.412%20209.067%20567.375%20208.979%20567.375%20208.875C567.375%20208.771%20567.412%20208.683%20567.485%20208.61C567.558%20208.537%20567.646%20208.5%20567.75%20208.5C567.854%20208.5%20567.942%20208.537%20568.015%20208.61C568.088%20208.683%20568.125%20208.771%20568.125%20208.875ZM571.875%20208.875C571.875%20208.979%20571.838%20209.067%20571.765%20209.14C571.692%20209.213%20571.603%20209.25%20571.5%20209.25C571.396%20209.25%20571.308%20209.213%20571.235%20209.14C571.162%20209.067%20571.125%20208.979%20571.125%20208.875C571.125%20208.771%20571.162%20208.683%20571.235%20208.61C571.308%20208.537%20571.396%20208.5%20571.5%20208.5C571.603%20208.5%20571.692%20208.537%20571.765%20208.61C571.838%20208.683%20571.875%20208.771%20571.875%20208.875ZM575.625%20208.875C575.625%20208.979%20575.588%20209.067%20575.515%20209.14C575.442%20209.213%20575.354%20209.25%20575.25%20209.25C575.146%20209.25%20575.058%20209.213%20574.985%20209.14C574.912%20209.067%20574.875%20208.979%20574.875%20208.875C574.875%20208.771%20574.912%20208.683%20574.985%20208.61C575.058%20208.537%20575.146%20208.5%20575.25%20208.5C575.354%20208.5%20575.442%20208.537%20575.515%20208.61C575.588%20208.683%20575.625%20208.771%20575.625%20208.875ZM579.375%20208.875C579.375%20208.979%20579.338%20209.067%20579.265%20209.14C579.192%20209.213%20579.104%20209.25%20579%20209.25C578.896%20209.25%20578.808%20209.213%20578.735%20209.14C578.662%20209.067%20578.625%20208.979%20578.625%20208.875C578.625%20208.771%20578.662%20208.683%20578.735%20208.61C578.808%20208.537%20578.896%20208.5%20579%20208.5C579.104%20208.5%20579.192%20208.537%20579.265%20208.61C579.338%20208.683%20579.375%20208.771%20579.375%20208.875ZM583.125%20208.875C583.125%20208.979%20583.088%20209.067%20583.015%20209.14C582.942%20209.213%20582.854%20209.25%20582.75%20209.25C582.646%20209.25%20582.558%20209.213%20582.485%20209.14C582.412%20209.067%20582.375%20208.979%20582.375%20208.875C582.375%20208.771%20582.412%20208.683%20582.485%20208.61C582.558%20208.537%20582.646%20208.5%20582.75%20208.5C582.854%20208.5%20582.942%20208.537%20583.015%20208.61C583.088%20208.683%20583.125%20208.771%20583.125%20208.875ZM586.875%20208.875C586.875%20208.979%20586.838%20209.067%20586.765%20209.14C586.692%20209.213%20586.604%20209.25%20586.5%20209.25C586.396%20209.25%20586.308%20209.213%20586.235%20209.14C586.162%20209.067%20586.125%20208.979%20586.125%20208.875C586.125%20208.771%20586.162%20208.683%20586.235%20208.61C586.308%20208.537%20586.396%20208.5%20586.5%20208.5C586.604%20208.5%20586.692%20208.537%20586.765%20208.61C586.838%20208.683%20586.875%20208.771%20586.875%20208.875ZM590.625%20208.875C590.625%20208.979%20590.588%20209.067%20590.515%20209.14C590.442%20209.213%20590.354%20209.25%20590.25%20209.25C590.146%20209.25%20590.058%20209.213%20589.985%20209.14C589.912%20209.067%20589.875%20208.979%20589.875%20208.875C589.875%20208.771%20589.912%20208.683%20589.985%20208.61C590.058%20208.537%20590.146%20208.5%20590.25%20208.5C590.354%20208.5%20590.442%20208.537%20590.515%20208.61C590.588%20208.683%20590.625%20208.771%20590.625%20208.875ZM594.375%20208.875C594.375%20208.979%20594.338%20209.067%20594.265%20209.14C594.192%20209.213%20594.104%20209.25%20594%20209.25C593.896%20209.25%20593.808%20209.213%20593.735%20209.14C593.662%20209.067%20593.625%20208.979%20593.625%20208.875C593.625%20208.771%20593.662%20208.683%20593.735%20208.61C593.808%20208.537%20593.896%20208.5%20594%20208.5C594.104%20208.5%20594.192%20208.537%20594.265%20208.61C594.338%20208.683%20594.375%20208.771%20594.375%20208.875ZM598.125%20208.875C598.125%20208.979%20598.088%20209.067%20598.015%20209.14C597.942%20209.213%20597.854%20209.25%20597.75%20209.25C597.646%20209.25%20597.558%20209.213%20597.485%20209.14C597.412%20209.067%20597.375%20208.979%20597.375%20208.875C597.375%20208.771%20597.412%20208.683%20597.485%20208.61C597.558%20208.537%20597.646%20208.5%20597.75%20208.5C597.854%20208.5%20597.942%20208.537%20598.015%20208.61C598.088%20208.683%20598.125%20208.771%20598.125%20208.875ZM601.875%20208.875C601.875%20208.979%20601.838%20209.067%20601.765%20209.14C601.692%20209.213%20601.604%20209.25%20601.5%20209.25C601.396%20209.25%20601.308%20209.213%20601.235%20209.14C601.162%20209.067%20601.125%20208.979%20601.125%20208.875C601.125%20208.771%20601.162%20208.683%20601.235%20208.61C601.308%20208.537%20601.396%20208.5%20601.5%20208.5C601.604%20208.5%20601.692%20208.537%20601.765%20208.61C601.838%20208.683%20601.875%20208.771%20601.875%20208.875ZM605.625%20208.875C605.625%20208.979%20605.588%20209.067%20605.515%20209.14C605.442%20209.213%20605.354%20209.25%20605.25%20209.25C605.146%20209.25%20605.058%20209.213%20604.985%20209.14C604.912%20209.067%20604.875%20208.979%20604.875%20208.875C604.875%20208.771%20604.912%20208.683%20604.985%20208.61C605.058%20208.537%20605.146%20208.5%20605.25%20208.5C605.354%20208.5%20605.442%20208.537%20605.515%20208.61C605.588%20208.683%20605.625%20208.771%20605.625%20208.875ZM609.375%20208.875C609.375%20208.979%20609.338%20209.067%20609.265%20209.14C609.192%20209.213%20609.104%20209.25%20609%20209.25C608.896%20209.25%20608.808%20209.213%20608.735%20209.14C608.662%20209.067%20608.625%20208.979%20608.625%20208.875C608.625%20208.771%20608.662%20208.683%20608.735%20208.61C608.808%20208.537%20608.896%20208.5%20609%20208.5C609.104%20208.5%20609.192%20208.537%20609.265%20208.61C609.338%20208.683%20609.375%20208.771%20609.375%20208.875ZM613.125%20208.875C613.125%20208.979%20613.088%20209.067%20613.015%20209.14C612.942%20209.213%20612.854%20209.25%20612.75%20209.25C612.646%20209.25%20612.558%20209.213%20612.485%20209.14C612.412%20209.067%20612.375%20208.979%20612.375%20208.875C612.375%20208.771%20612.412%20208.683%20612.485%20208.61C612.558%20208.537%20612.646%20208.5%20612.75%20208.5C612.854%20208.5%20612.942%20208.537%20613.015%20208.61C613.088%20208.683%20613.125%20208.771%20613.125%20208.875ZM616.875%20208.875C616.875%20208.979%20616.838%20209.067%20616.765%20209.14C616.692%20209.213%20616.604%20209.25%20616.5%20209.25C616.396%20209.25%20616.308%20209.213%20616.235%20209.14C616.162%20209.067%20616.125%20208.979%20616.125%20208.875C616.125%20208.771%20616.162%20208.683%20616.235%20208.61C616.308%20208.537%20616.396%20208.5%20616.5%20208.5C616.604%20208.5%20616.692%20208.537%20616.765%20208.61C616.838%20208.683%20616.875%20208.771%20616.875%20208.875ZM620.625%20208.875C620.625%20208.979%20620.588%20209.067%20620.515%20209.14C620.442%20209.213%20620.354%20209.25%20620.25%20209.25C620.146%20209.25%20620.058%20209.213%20619.985%20209.14C619.912%20209.067%20619.875%20208.979%20619.875%20208.875C619.875%20208.771%20619.912%20208.683%20619.985%20208.61C620.058%20208.537%20620.146%20208.5%20620.25%20208.5C620.354%20208.5%20620.442%20208.537%20620.515%20208.61C620.588%20208.683%20620.625%20208.771%20620.625%20208.875ZM624.375%20208.875C624.375%20208.979%20624.338%20209.067%20624.265%20209.14C624.192%20209.213%20624.104%20209.25%20624%20209.25C623.896%20209.25%20623.808%20209.213%20623.735%20209.14C623.662%20209.067%20623.625%20208.979%20623.625%20208.875C623.625%20208.771%20623.662%20208.683%20623.735%20208.61C623.808%20208.537%20623.896%20208.5%20624%20208.5C624.104%20208.5%20624.192%20208.537%20624.265%20208.61C624.338%20208.683%20624.375%20208.771%20624.375%20208.875ZM628.125%20208.875C628.125%20208.979%20628.088%20209.067%20628.015%20209.14C627.942%20209.213%20627.854%20209.25%20627.75%20209.25C627.646%20209.25%20627.558%20209.213%20627.485%20209.14C627.412%20209.067%20627.375%20208.979%20627.375%20208.875C627.375%20208.771%20627.412%20208.683%20627.485%20208.61C627.558%20208.537%20627.646%20208.5%20627.75%20208.5C627.854%20208.5%20627.942%20208.537%20628.015%20208.61C628.088%20208.683%20628.125%20208.771%20628.125%20208.875ZM631.875%20208.875C631.875%20208.979%20631.838%20209.067%20631.765%20209.14C631.692%20209.213%20631.604%20209.25%20631.5%20209.25C631.396%20209.25%20631.308%20209.213%20631.235%20209.14C631.162%20209.067%20631.125%20208.979%20631.125%20208.875C631.125%20208.771%20631.162%20208.683%20631.235%20208.61C631.308%20208.537%20631.396%20208.5%20631.5%20208.5C631.604%20208.5%20631.692%20208.537%20631.765%20208.61C631.838%20208.683%20631.875%20208.771%20631.875%20208.875ZM635.625%20208.875C635.625%20208.979%20635.588%20209.067%20635.515%20209.14C635.442%20209.213%20635.354%20209.25%20635.25%20209.25C635.146%20209.25%20635.058%20209.213%20634.985%20209.14C634.912%20209.067%20634.875%20208.979%20634.875%20208.875C634.875%20208.771%20634.912%20208.683%20634.985%20208.61C635.058%20208.537%20635.146%20208.5%20635.25%20208.5C635.354%20208.5%20635.442%20208.537%20635.515%20208.61C635.588%20208.683%20635.625%20208.771%20635.625%20208.875Z'%20fill='%23B4BAC3'%20/%3e%3cpath%20d='M42.6259%20207.545H43.2392V213.316H42.5564V208.259C42.2967%20208.428%2041.9791%20208.574%2041.6037%20208.694V208.05C41.6448%20208.032%2041.7284%20207.996%2041.8544%20207.942C41.9804%20207.888%2042.0743%20207.847%2042.136%20207.819C42.2003%20207.791%2042.28%20207.751%2042.3751%20207.699C42.4703%20207.648%2042.5539%20207.596%2042.6259%20207.545ZM47.1699%20213.181C46.9153%20213.33%2046.617%20213.404%2046.275%20213.404C45.933%20213.404%2045.6334%20213.33%2045.3762%20213.181C45.1191%20213.029%2044.912%20212.817%2044.7552%20212.544C44.6009%20212.272%2044.4852%20211.958%2044.408%20211.603C44.3334%20211.248%2044.2961%20210.853%2044.2961%20210.419C44.2961%20210.061%2044.3206%20209.731%2044.3694%20209.427C44.4209%20209.124%2044.4993%20208.849%2044.6047%20208.602C44.7102%20208.355%2044.84%20208.145%2044.9943%20207.973C45.1512%20207.801%2045.3376%20207.668%2045.5537%20207.576C45.7697%20207.481%2046.0101%20207.433%2046.275%20207.433C46.6042%20207.433%2046.8948%20207.505%2047.1468%20207.649C47.4014%20207.793%2047.6071%20207.999%2047.764%20208.266C47.9234%20208.531%2048.043%20208.845%2048.1227%20209.208C48.2024%20209.568%2048.2423%20209.971%2048.2423%20210.419C48.2423%20210.853%2048.205%20211.248%2048.1304%20211.603C48.0558%20211.958%2047.9414%20212.272%2047.7871%20212.544C47.6328%20212.817%2047.4271%20213.029%2047.1699%20213.181ZM46.95%20208.332C46.7623%20208.124%2046.5373%20208.019%2046.275%20208.019C46.0127%20208.019%2045.7877%20208.124%2045.6%20208.332C45.4122%20208.538%2045.2708%20208.818%2045.1756%20209.173C45.0831%20209.525%2045.0368%20209.933%2045.0368%20210.396C45.0368%20210.866%2045.0831%20211.283%2045.1756%20211.645C45.2708%20212.005%2045.4122%20212.291%2045.6%20212.502C45.7877%20212.713%2046.0127%20212.818%2046.275%20212.818C46.5373%20212.818%2046.7623%20212.713%2046.95%20212.502C47.1378%20212.291%2047.2779%20212.005%2047.3705%20211.645C47.4657%20211.283%2047.5132%20210.866%2047.5132%20210.396C47.5132%20209.933%2047.4657%20209.525%2047.3705%20209.173C47.2779%20208.818%2047.1378%20208.538%2046.95%20208.332ZM53.527%20213.316H52.7092L50.5259%20210.592L50.0051%20211.051V213.316H49.3339V207.611H50.0051V210.411L52.5125%20207.611H53.3495L51.0351%20210.18L53.527%20213.316Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M154.193%20333.901V329.066H154.844V333.68C154.844%20333.859%20154.84%20334.01%20154.833%20334.133C154.826%20334.255%20154.811%20334.38%20154.789%20334.508C154.767%20334.633%20154.734%20334.736%20154.69%20334.816C154.648%20334.897%20154.593%20334.975%20154.524%20335.048C154.455%20335.124%20154.37%20335.182%20154.267%20335.221C154.166%20335.263%20154.046%20335.294%20153.906%20335.316C153.767%20335.341%20153.605%20335.353%20153.421%20335.353H153.292L153.215%20334.831H153.487C153.617%20334.831%20153.726%20334.815%20153.815%20334.783C153.905%20334.751%20153.975%20334.711%20154.024%20334.662C154.073%20334.615%20154.11%20334.548%20154.134%20334.46C154.161%20334.372%20154.177%20334.289%20154.182%20334.213C154.19%20334.135%20154.193%20334.031%20154.193%20333.901ZM155.77%20333.221V330.533H156.388V333.228C156.388%20333.405%20156.413%20333.554%20156.462%20333.677C156.513%20333.799%20156.585%20333.895%20156.679%20333.963C156.774%20334.03%20156.881%20334.077%20156.998%20334.107C157.119%20334.136%20157.256%20334.151%20157.41%20334.151C157.729%20334.151%20157.976%20334.081%20158.153%20333.941C158.332%20333.802%20158.421%20333.564%20158.421%20333.228V330.533H159.039V333.221C159.039%20333.427%20159.01%20333.612%20158.951%20333.776C158.892%20333.94%20158.812%20334.077%20158.712%20334.188C158.614%20334.296%20158.495%20334.385%20158.355%20334.456C158.215%20334.527%20158.067%20334.579%20157.91%20334.611C157.756%20334.642%20157.589%20334.658%20157.41%20334.658C157.234%20334.658%20157.067%20334.642%20156.91%20334.611C156.753%20334.579%20156.604%20334.527%20156.462%20334.456C156.322%20334.383%20156.201%20334.292%20156.098%20334.184C155.997%20334.074%20155.918%20333.936%20155.859%20333.772C155.8%20333.608%20155.77%20333.424%20155.77%20333.221ZM161.039%20334.64C160.647%20334.64%20160.369%20334.535%20160.204%20334.324C160.043%20334.113%20159.962%20333.747%20159.962%20333.224V328.967L160.572%20328.93V332.982C160.572%20333.148%20160.573%20333.282%20160.576%20333.383C160.581%20333.483%20160.591%20333.582%20160.605%20333.68C160.62%20333.776%20160.64%20333.848%20160.664%20333.897C160.689%20333.946%20160.724%20333.992%20160.771%20334.033C160.817%20334.073%20160.872%20334.099%20160.936%20334.114C161.002%20334.126%20161.083%20334.133%20161.179%20334.133C161.257%20334.133%20161.412%20334.118%20161.642%20334.088L161.675%20334.577C161.423%20334.619%20161.211%20334.64%20161.039%20334.64ZM163.822%20334.566L163.738%20333.963L165.638%20331.853C165.766%20331.711%20165.888%20331.527%20166.006%20331.302C166.126%20331.076%20166.213%20330.885%20166.267%20330.728L166.352%20330.496C166.352%20330.192%20166.267%20329.957%20166.098%20329.79C165.929%20329.621%20165.689%20329.537%20165.377%20329.537C164.858%20329.537%20164.448%20329.688%20164.149%20329.989L163.936%20329.438C164.274%20329.119%20164.77%20328.96%20165.422%20328.96C165.922%20328.96%20166.32%20329.096%20166.616%20329.368C166.913%20329.637%20167.061%20329.999%20167.061%20330.452C167.052%20330.487%20167.037%20330.533%20167.017%20330.592C166.998%20330.648%20166.955%20330.76%20166.889%20330.927C166.825%20331.093%20166.757%20331.251%20166.686%20331.401C166.615%20331.55%20166.525%20331.715%20166.414%20331.894C166.306%20332.072%20166.196%20332.222%20166.083%20332.342L164.532%20334H167.08L167.039%20334.566H163.822ZM170.65%20334.438C170.407%20334.58%20170.123%20334.651%20169.797%20334.651C169.471%20334.651%20169.185%20334.58%20168.94%20334.438C168.695%20334.293%20168.498%20334.091%20168.348%20333.831C168.201%20333.571%20168.091%20333.272%20168.017%20332.934C167.946%20332.596%20167.911%20332.22%20167.911%20331.805C167.911%20331.465%20167.934%20331.15%20167.98%20330.86C168.03%20330.571%20168.104%20330.309%20168.205%20330.074C168.305%20329.838%20168.429%20329.639%20168.576%20329.474C168.726%20329.31%20168.903%20329.184%20169.109%20329.096C169.315%20329.005%20169.544%20328.96%20169.797%20328.96C170.11%20328.96%20170.387%20329.028%20170.628%20329.165C170.87%20329.303%20171.066%20329.499%20171.216%20329.754C171.368%20330.006%20171.482%20330.305%20171.558%20330.651C171.634%20330.994%20171.672%20331.379%20171.672%20331.805C171.672%20332.22%20171.636%20332.596%20171.565%20332.934C171.494%20333.272%20171.385%20333.571%20171.238%20333.831C171.091%20334.091%20170.895%20334.293%20170.65%20334.438ZM170.44%20329.816C170.261%20329.618%20170.047%20329.518%20169.797%20329.518C169.547%20329.518%20169.332%20329.618%20169.153%20329.816C168.974%20330.012%20168.84%20330.279%20168.749%20330.618C168.661%20330.954%20168.617%20331.342%20168.617%20331.783C168.617%20332.232%20168.661%20332.629%20168.749%20332.974C168.84%20333.318%20168.974%20333.59%20169.153%20333.791C169.332%20333.992%20169.547%20334.092%20169.797%20334.092C170.047%20334.092%20170.261%20333.992%20170.44%20333.791C170.619%20333.59%20170.753%20333.318%20170.841%20332.974C170.932%20332.629%20170.977%20332.232%20170.977%20331.783C170.977%20331.342%20170.932%20330.954%20170.841%20330.618C170.753%20330.279%20170.619%20330.012%20170.44%20329.816ZM172.492%20334.566L172.407%20333.963L174.308%20331.853C174.435%20331.711%20174.558%20331.527%20174.676%20331.302C174.796%20331.076%20174.883%20330.885%20174.937%20330.728L175.021%20330.496C175.021%20330.192%20174.937%20329.957%20174.768%20329.79C174.598%20329.621%20174.358%20329.537%20174.047%20329.537C173.527%20329.537%20173.118%20329.688%20172.819%20329.989L172.606%20329.438C172.944%20329.119%20173.439%20328.96%20174.091%20328.96C174.591%20328.96%20174.989%20329.096%20175.286%20329.368C175.582%20329.637%20175.731%20329.999%20175.731%20330.452C175.721%20330.487%20175.706%20330.533%20175.687%20330.592C175.667%20330.648%20175.624%20330.76%20175.558%20330.927C175.494%20331.093%20175.427%20331.251%20175.356%20331.401C175.285%20331.55%20175.194%20331.715%20175.084%20331.894C174.976%20332.072%20174.866%20332.222%20174.753%20332.342L173.201%20334H175.749L175.709%20334.566H172.492ZM178.003%20334.651C177.674%20334.651%20177.382%20334.608%20177.124%20334.522C176.869%20334.436%20176.683%20334.337%20176.565%20334.224L176.771%20333.684C177.117%20333.956%20177.529%20334.092%20178.007%20334.092C178.374%20334.092%20178.666%20334.001%20178.882%20333.82C179.1%20333.636%20179.209%20333.38%20179.209%20333.052C179.209%20332.873%20179.181%20332.717%20179.124%20332.585C179.07%20332.45%20178.997%20332.342%20178.904%20332.261C178.813%20332.178%20178.695%20332.112%20178.551%20332.063C178.409%20332.011%20178.261%20331.976%20178.11%20331.956C177.96%20331.934%20177.786%20331.92%20177.587%20331.916C177.563%20331.916%20177.526%20331.916%20177.477%20331.916C177.428%20331.913%20177.391%20331.912%20177.367%20331.912V331.364H177.551C177.722%20331.362%20177.873%20331.353%20178.003%20331.338C178.135%20331.321%20178.266%20331.292%20178.396%20331.25C178.529%20331.208%20178.638%20331.153%20178.724%20331.085C178.809%20331.016%20178.879%20330.924%20178.933%20330.809C178.987%20330.694%20179.014%20330.558%20179.014%20330.401C179.014%20329.813%20178.677%20329.518%20178.003%20329.518C177.76%20329.518%20177.532%20329.554%20177.319%20329.625C177.106%20329.696%20176.923%20329.792%20176.771%20329.912L176.565%20329.375C176.931%20329.098%20177.456%20328.96%20178.143%20328.96C178.42%20328.96%20178.676%20329.011%20178.911%20329.114C179.146%20329.214%20179.34%20329.37%20179.492%20329.581C179.644%20329.789%20179.72%20330.034%20179.72%20330.316C179.72%20330.659%20179.635%20330.941%20179.466%20331.162C179.297%20331.382%20179.059%20331.541%20178.753%20331.636C179.096%20331.71%20179.364%20331.87%20179.558%20332.118C179.754%20332.365%20179.852%20332.679%20179.852%20333.059C179.852%20333.542%20179.679%20333.928%20179.334%20334.217C178.988%20334.506%20178.545%20334.651%20178.003%20334.651Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M300.352%20333.923V329.247H300.981V333.709C300.981%20333.882%20300.978%20334.028%20300.971%20334.147C300.964%20334.265%20300.949%20334.386%20300.928%20334.51C300.907%20334.63%20300.875%20334.73%20300.832%20334.808C300.792%20334.886%20300.738%20334.961%20300.672%20335.032C300.606%20335.106%20300.523%20335.161%20300.423%20335.199C300.326%20335.24%20300.21%20335.271%20300.075%20335.292C299.94%20335.316%20299.783%20335.327%20299.605%20335.327H299.481L299.406%20334.822H299.669C299.795%20334.822%20299.9%20334.807%20299.986%20334.776C300.073%20334.745%20300.141%20334.706%20300.188%20334.659C300.236%20334.614%20300.271%20334.549%20300.295%20334.463C300.321%20334.378%20300.337%20334.299%20300.341%20334.225C300.348%20334.149%20300.352%20334.048%20300.352%20333.923ZM303.14%20334.168C303.422%20334.168%20303.67%20334.091%20303.883%20333.937C304.099%20333.781%20304.238%20333.571%20304.299%20333.308V332.65C304.287%20332.65%20304.215%20332.656%20304.082%20332.667C303.952%20332.679%20303.867%20332.686%20303.826%20332.689C303.312%20332.734%20302.953%20332.818%20302.749%20332.941C302.547%20333.065%20302.447%20333.263%20302.447%20333.535C302.447%20333.744%20302.508%20333.901%20302.631%20334.008C302.755%20334.115%20302.924%20334.168%20303.14%20334.168ZM304.431%20334.566C304.395%20334.415%20304.361%20334.251%20304.328%20334.076C304.112%20334.291%20303.909%20334.441%20303.72%20334.524C303.53%20334.607%20303.307%20334.648%20303.051%20334.648C302.686%20334.648%20302.392%20334.553%20302.169%20334.364C301.949%20334.172%20301.838%20333.897%20301.838%20333.539C301.838%20333.14%20301.989%20332.845%20302.29%20332.653C302.594%20332.461%20303.03%20332.341%20303.599%20332.294C303.677%20332.287%20303.794%20332.277%20303.951%20332.266C304.11%20332.251%20304.228%20332.241%20304.306%20332.234V331.889C304.306%20331.614%20304.242%20331.41%20304.114%20331.277C303.986%20331.144%20303.785%20331.078%20303.51%20331.078C303.126%20331.078%20302.738%20331.173%20302.347%20331.362C302.335%20331.334%20302.304%20331.252%20302.255%20331.117C302.205%20330.98%20302.179%20330.908%20302.176%20330.904C302.349%20330.806%20302.554%20330.729%20302.791%20330.673C303.031%20330.613%20303.274%20330.584%20303.52%20330.584C304.006%20330.584%20304.356%20330.69%20304.569%20330.904C304.785%20331.115%20304.893%20331.475%20304.893%20331.985V334.566H304.431ZM305.917%20334.566V330.665H306.415L306.49%20331.224C306.644%20331.032%20306.836%20330.878%20307.066%20330.761C307.298%20330.643%20307.548%20330.584%20307.816%20330.584C308.267%20330.584%20308.6%20330.71%20308.815%20330.964C309.031%20331.215%20309.139%20331.603%20309.139%20332.127V334.566H308.545C308.545%20333.002%20308.544%20332.164%20308.542%20332.052C308.532%20331.72%20308.465%20331.477%20308.339%20331.323C308.216%20331.169%20308.008%20331.092%20307.717%20331.092C307.411%20331.092%20307.156%20331.166%20306.952%20331.313C306.748%20331.46%20306.615%20331.65%20306.554%20331.885C306.53%20332.044%20306.518%20332.227%20306.518%20332.433V334.566H305.917ZM311.842%20334.566L311.76%20333.983L313.598%20331.942C313.722%20331.805%20313.84%20331.627%20313.954%20331.409C314.07%20331.191%20314.154%20331.006%20314.206%20330.854L314.288%20330.63C314.288%20330.336%20314.206%20330.108%20314.043%20329.947C313.879%20329.784%20313.647%20329.702%20313.346%20329.702C312.843%20329.702%20312.447%20329.848%20312.158%20330.139L311.952%20329.606C312.279%20329.298%20312.758%20329.143%20313.389%20329.143C313.872%20329.143%20314.257%20329.275%20314.544%20329.538C314.831%20329.799%20314.975%20330.149%20314.975%20330.587C314.965%20330.62%20314.951%20330.665%20314.932%20330.722C314.913%20330.777%20314.871%20330.885%20314.807%20331.046C314.746%20331.207%20314.681%20331.36%20314.612%20331.505C314.543%20331.649%20314.455%20331.808%20314.349%20331.981C314.244%20332.154%20314.138%20332.299%20314.029%20332.415L312.528%20334.019H314.992L314.953%20334.566H311.842ZM318.445%20334.442C318.211%20334.579%20317.936%20334.648%20317.62%20334.648C317.305%20334.648%20317.029%20334.579%20316.792%20334.442C316.555%20334.302%20316.364%20334.106%20316.219%20333.855C316.077%20333.604%20315.97%20333.315%20315.899%20332.988C315.83%20332.66%20315.796%20332.296%20315.796%20331.896C315.796%20331.566%20315.819%20331.262%20315.864%20330.982C315.911%20330.702%20315.983%20330.448%20316.08%20330.221C316.178%20329.993%20316.297%20329.8%20316.44%20329.641C316.584%20329.482%20316.756%20329.36%20316.955%20329.275C317.154%20329.187%20317.376%20329.143%20317.62%20329.143C317.924%20329.143%20318.192%20329.21%20318.424%20329.343C318.659%20329.475%20318.848%20329.665%20318.993%20329.912C319.14%20330.156%20319.25%20330.445%20319.324%20330.779C319.397%20331.111%20319.434%20331.483%20319.434%20331.896C319.434%20332.296%20319.399%20332.66%20319.331%20332.988C319.262%20333.315%20319.156%20333.604%20319.014%20333.855C318.872%20334.106%20318.682%20334.302%20318.445%20334.442ZM318.243%20329.972C318.069%20329.78%20317.862%20329.684%20317.62%20329.684C317.378%20329.684%20317.171%20329.78%20316.998%20329.972C316.825%20330.162%20316.694%20330.42%20316.607%20330.747C316.521%20331.072%20316.479%20331.448%20316.479%20331.874C316.479%20332.308%20316.521%20332.692%20316.607%20333.027C316.694%20333.359%20316.825%20333.622%20316.998%20333.816C317.171%20334.01%20317.378%20334.108%20317.62%20334.108C317.862%20334.108%20318.069%20334.01%20318.243%20333.816C318.416%20333.622%20318.545%20333.359%20318.63%20333.027C318.718%20332.692%20318.762%20332.308%20318.762%20331.874C318.762%20331.448%20318.718%20331.072%20318.63%20330.747C318.545%20330.42%20318.416%20330.162%20318.243%20329.972ZM320.227%20334.566L320.145%20333.983L321.984%20331.942C322.107%20331.805%20322.225%20331.627%20322.339%20331.409C322.455%20331.191%20322.539%20331.006%20322.592%20330.854L322.673%20330.63C322.673%20330.336%20322.592%20330.108%20322.428%20329.947C322.264%20329.784%20322.032%20329.702%20321.731%20329.702C321.228%20329.702%20320.833%20329.848%20320.543%20330.139L320.337%20329.606C320.664%20329.298%20321.143%20329.143%20321.774%20329.143C322.257%20329.143%20322.643%20329.275%20322.929%20329.538C323.216%20329.799%20323.36%20330.149%20323.36%20330.587C323.35%20330.62%20323.336%20330.665%20323.317%20330.722C323.298%20330.777%20323.257%20330.885%20323.193%20331.046C323.131%20331.207%20323.066%20331.36%20322.997%20331.505C322.928%20331.649%20322.841%20331.808%20322.734%20331.981C322.63%20332.154%20322.523%20332.299%20322.414%20332.415L320.913%20334.019H323.378L323.338%20334.566H320.227ZM327.783%20333.247H327.179V334.566H326.582V333.247H324.178V332.703L326.514%20329.247H327.179V332.731H327.833L327.783%20333.247ZM326.582%20330.054L324.803%20332.731H326.582V330.054Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M446.642%20333.912V329.156H447.282V333.695C447.282%20333.871%20447.278%20334.019%20447.271%20334.14C447.264%20334.26%20447.249%20334.383%20447.227%20334.509C447.206%20334.632%20447.173%20334.733%20447.13%20334.812C447.089%20334.892%20447.034%20334.968%20446.967%20335.04C446.899%20335.115%20446.815%20335.172%20446.714%20335.21C446.615%20335.251%20446.497%20335.282%20446.359%20335.304C446.222%20335.328%20446.063%20335.34%20445.882%20335.34H445.756L445.68%20334.827H445.947C446.075%20334.827%20446.182%20334.811%20446.269%20334.78C446.358%20334.748%20446.427%20334.709%20446.475%20334.66C446.523%20334.615%20446.56%20334.548%20446.584%20334.462C446.61%20334.375%20446.626%20334.294%20446.631%20334.219C446.638%20334.142%20446.642%20334.04%20446.642%20333.912ZM448.193%20333.243V330.599H448.8V333.25C448.8%20333.424%20448.825%20333.571%20448.873%20333.691C448.923%20333.812%20448.995%20333.906%20449.086%20333.973C449.18%20334.038%20449.285%20334.085%20449.401%20334.114C449.519%20334.143%20449.654%20334.158%20449.806%20334.158C450.119%20334.158%20450.363%20334.089%20450.536%20333.952C450.712%20333.814%20450.8%20333.58%20450.8%20333.25V330.599H451.408V333.243C451.408%20333.445%20451.379%20333.627%20451.321%20333.789C451.263%20333.95%20451.185%20334.085%20451.086%20334.194C450.99%20334.3%20450.873%20334.388%20450.735%20334.458C450.598%20334.528%20450.452%20334.578%20450.298%20334.61C450.146%20334.641%20449.982%20334.657%20449.806%20334.657C449.632%20334.657%20449.468%20334.641%20449.314%20334.61C449.16%20334.578%20449.013%20334.528%20448.873%20334.458C448.735%20334.386%20448.616%20334.296%20448.515%20334.19C448.416%20334.082%20448.338%20333.947%20448.28%20333.785C448.222%20333.624%20448.193%20333.443%20448.193%20333.243ZM453.375%20334.639C452.989%20334.639%20452.716%20334.535%20452.554%20334.328C452.395%20334.12%20452.316%20333.76%20452.316%20333.246V329.059L452.916%20329.023V333.008C452.916%20333.172%20452.917%20333.303%20452.919%20333.402C452.924%20333.501%20452.934%20333.598%20452.948%20333.695C452.963%20333.789%20452.982%20333.86%20453.006%20333.908C453.03%20333.956%20453.065%20334.001%20453.111%20334.042C453.157%20334.081%20453.211%20334.107%20453.274%20334.122C453.339%20334.134%20453.419%20334.14%20453.513%20334.14C453.59%20334.14%20453.742%20334.125%20453.968%20334.096L454.001%20334.577C453.752%20334.618%20453.544%20334.639%20453.375%20334.639ZM456.113%20334.566L456.03%20333.973L457.899%20331.898C458.025%20331.758%20458.145%20331.577%20458.261%20331.355C458.379%20331.133%20458.465%20330.945%20458.518%20330.791L458.601%20330.563C458.601%20330.264%20458.518%20330.033%20458.351%20329.869C458.185%20329.702%20457.949%20329.619%20457.642%20329.619C457.131%20329.619%20456.729%20329.768%20456.435%20330.064L456.225%20329.522C456.557%20329.208%20457.044%20329.051%20457.686%20329.051C458.178%20329.051%20458.569%20329.185%20458.861%20329.453C459.153%20329.718%20459.299%20330.074%20459.299%20330.52C459.289%20330.553%20459.275%20330.599%20459.255%20330.657C459.236%20330.713%20459.194%20330.822%20459.129%20330.986C459.066%20331.15%20459%20331.306%20458.93%20331.453C458.86%20331.6%20458.771%20331.761%20458.662%20331.937C458.556%20332.113%20458.448%20332.26%20458.337%20332.379L456.811%20334.009H459.317L459.277%20334.566H456.113ZM462.828%20334.44C462.59%20334.58%20462.31%20334.65%20461.989%20334.65C461.669%20334.65%20461.388%20334.58%20461.147%20334.44C460.906%20334.298%20460.711%20334.099%20460.564%20333.843C460.42%20333.588%20460.311%20333.293%20460.239%20332.961C460.169%20332.628%20460.134%20332.258%20460.134%20331.851C460.134%20331.515%20460.157%20331.206%20460.203%20330.921C460.251%20330.637%20460.325%20330.379%20460.423%20330.147C460.522%20329.916%20460.644%20329.719%20460.789%20329.558C460.936%20329.396%20461.11%20329.272%20461.313%20329.185C461.515%20329.096%20461.741%20329.051%20461.989%20329.051C462.298%20329.051%20462.57%20329.119%20462.807%20329.254C463.045%20329.389%20463.238%20329.582%20463.385%20329.833C463.535%20330.081%20463.647%20330.375%20463.721%20330.715C463.796%20331.053%20463.834%20331.431%20463.834%20331.851C463.834%20332.258%20463.799%20332.628%20463.729%20332.961C463.659%20333.293%20463.551%20333.588%20463.407%20333.843C463.262%20334.099%20463.069%20334.298%20462.828%20334.44ZM462.622%20329.894C462.446%20329.699%20462.235%20329.601%20461.989%20329.601C461.743%20329.601%20461.532%20329.699%20461.356%20329.894C461.18%20330.087%20461.048%20330.35%20460.959%20330.682C460.872%20331.013%20460.828%20331.395%20460.828%20331.829C460.828%20332.27%20460.872%20332.661%20460.959%20333.001C461.048%20333.338%20461.18%20333.606%20461.356%20333.803C461.532%20334.001%20461.743%20334.1%20461.989%20334.1C462.235%20334.1%20462.446%20334.001%20462.622%20333.803C462.798%20333.606%20462.929%20333.338%20463.016%20333.001C463.105%20332.661%20463.15%20332.27%20463.15%20331.829C463.15%20331.395%20463.105%20331.013%20463.016%20330.682C462.929%20330.35%20462.798%20330.087%20462.622%20329.894ZM464.64%20334.566L464.557%20333.973L466.426%20331.898C466.552%20331.758%20466.672%20331.577%20466.788%20331.355C466.906%20331.133%20466.992%20330.945%20467.045%20330.791L467.128%20330.563C467.128%20330.264%20467.045%20330.033%20466.879%20329.869C466.712%20329.702%20466.476%20329.619%20466.17%20329.619C465.659%20329.619%20465.256%20329.768%20464.962%20330.064L464.752%20329.522C465.085%20329.208%20465.572%20329.051%20466.213%20329.051C466.705%20329.051%20467.097%20329.185%20467.388%20329.453C467.68%20329.718%20467.826%20330.074%20467.826%20330.52C467.816%20330.553%20467.802%20330.599%20467.783%20330.657C467.763%20330.713%20467.721%20330.822%20467.656%20330.986C467.593%20331.15%20467.527%20331.306%20467.457%20331.453C467.387%20331.6%20467.298%20331.761%20467.19%20331.937C467.083%20332.113%20466.975%20332.26%20466.864%20332.379L465.338%20334.009H467.844L467.804%20334.566H464.64ZM472.325%20333.225H471.71V334.566H471.102V333.225H468.658V332.671L471.034%20329.156H471.71V332.7H472.375L472.325%20333.225ZM471.102%20329.977L469.294%20332.7H471.102V329.977Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M592.617%20333.912V329.156H593.257V333.695C593.257%20333.871%20593.253%20334.019%20593.246%20334.14C593.239%20334.26%20593.224%20334.383%20593.202%20334.509C593.181%20334.632%20593.148%20334.733%20593.105%20334.812C593.064%20334.892%20593.01%20334.968%20592.942%20335.04C592.875%20335.115%20592.79%20335.172%20592.689%20335.21C592.59%20335.251%20592.472%20335.282%20592.335%20335.304C592.197%20335.328%20592.038%20335.34%20591.857%20335.34H591.731L591.655%20334.827H591.922C592.05%20334.827%20592.157%20334.811%20592.244%20334.78C592.333%20334.748%20592.402%20334.709%20592.45%20334.66C592.498%20334.615%20592.535%20334.548%20592.559%20334.462C592.585%20334.375%20592.601%20334.294%20592.606%20334.219C592.613%20334.142%20592.617%20334.04%20592.617%20333.912ZM595.452%20334.161C595.739%20334.161%20595.991%20334.083%20596.208%20333.926C596.427%20333.767%20596.568%20333.554%20596.631%20333.286V332.617C596.619%20332.617%20596.545%20332.623%20596.41%20332.635C596.278%20332.647%20596.191%20332.655%20596.15%20332.657C595.627%20332.703%20595.261%20332.788%20595.054%20332.914C594.849%20333.039%20594.747%20333.24%20594.747%20333.518C594.747%20333.73%20594.809%20333.89%20594.935%20333.999C595.06%20334.107%20595.232%20334.161%20595.452%20334.161ZM596.765%20334.566C596.728%20334.412%20596.693%20334.246%20596.66%20334.067C596.44%20334.287%20596.234%20334.439%20596.041%20334.523C595.848%20334.607%20595.622%20334.65%20595.361%20334.65C594.99%20334.65%20594.691%20334.553%20594.465%20334.36C594.24%20334.165%20594.128%20333.885%20594.128%20333.521C594.128%20333.116%20594.281%20332.816%20594.588%20332.621C594.896%20332.426%20595.34%20332.304%20595.918%20332.256C595.998%20332.248%20596.117%20332.239%20596.276%20332.227C596.438%20332.212%20596.558%20332.201%20596.638%20332.194V331.843C596.638%20331.564%20596.573%20331.356%20596.443%20331.221C596.312%20331.086%20596.108%20331.019%20595.828%20331.019C595.437%20331.019%20595.043%20331.115%20594.645%20331.308C594.633%20331.279%20594.602%20331.196%20594.551%20331.059C594.501%20330.919%20594.474%20330.846%20594.472%20330.842C594.648%20330.743%20594.856%20330.664%20595.097%20330.607C595.341%20330.546%20595.588%20330.516%20595.839%20330.516C596.333%20330.516%20596.689%20330.625%20596.906%20330.842C597.125%20331.056%20597.235%20331.423%20597.235%20331.941V334.566H596.765ZM598.276%20334.566V330.599H598.782L598.858%20331.167C599.015%20330.972%20599.21%20330.815%20599.444%20330.697C599.681%20330.576%20599.935%20330.516%20600.207%20330.516C600.665%20330.516%20601.004%20330.645%20601.223%20330.903C601.443%20331.159%20601.553%20331.553%20601.553%20332.086V334.566H600.949C600.949%20332.975%20600.947%20332.123%20600.945%20332.01C600.935%20331.672%20600.867%20331.425%20600.739%20331.268C600.614%20331.112%20600.403%20331.033%20600.106%20331.033C599.795%20331.033%20599.536%20331.108%20599.329%20331.257C599.121%20331.407%20598.986%20331.601%20598.923%20331.84C598.899%20332.001%20598.887%20332.187%20598.887%20332.397V334.566H598.276ZM604.301%20334.566L604.218%20333.973L606.087%20331.898C606.213%20331.758%20606.333%20331.577%20606.449%20331.355C606.567%20331.133%20606.653%20330.945%20606.706%20330.791L606.789%20330.563C606.789%20330.264%20606.706%20330.033%20606.539%20329.869C606.373%20329.702%20606.137%20329.619%20605.831%20329.619C605.32%20329.619%20604.917%20329.768%20604.623%20330.064L604.413%20329.522C604.746%20329.208%20605.233%20329.051%20605.874%20329.051C606.366%20329.051%20606.758%20329.185%20607.049%20329.453C607.341%20329.718%20607.487%20330.074%20607.487%20330.52C607.477%20330.553%20607.463%20330.599%20607.444%20330.657C607.424%20330.713%20607.382%20330.822%20607.317%20330.986C607.254%20331.15%20607.188%20331.306%20607.118%20331.453C607.048%20331.6%20606.959%20331.761%20606.85%20331.937C606.744%20332.113%20606.636%20332.26%20606.525%20332.379L604.999%20334.009H607.505L607.465%20334.566H604.301ZM611.017%20334.44C610.778%20334.58%20610.498%20334.65%20610.178%20334.65C609.857%20334.65%20609.576%20334.58%20609.335%20334.44C609.094%20334.298%20608.9%20334.099%20608.753%20333.843C608.608%20333.588%20608.5%20333.293%20608.427%20332.961C608.357%20332.628%20608.322%20332.258%20608.322%20331.851C608.322%20331.515%20608.345%20331.206%20608.391%20330.921C608.439%20330.637%20608.513%20330.379%20608.612%20330.147C608.71%20329.916%20608.832%20329.719%20608.977%20329.558C609.124%20329.396%20609.299%20329.272%20609.501%20329.185C609.704%20329.096%20609.929%20329.051%20610.178%20329.051C610.486%20329.051%20610.759%20329.119%20610.995%20329.254C611.233%20329.389%20611.426%20329.582%20611.573%20329.833C611.723%20330.081%20611.835%20330.375%20611.91%20330.715C611.984%20331.053%20612.022%20331.431%20612.022%20331.851C612.022%20332.258%20611.987%20332.628%20611.917%20332.961C611.847%20333.293%20611.74%20333.588%20611.595%20333.843C611.45%20334.099%20611.258%20334.298%20611.017%20334.44ZM610.81%20329.894C610.634%20329.699%20610.423%20329.601%20610.178%20329.601C609.932%20329.601%20609.721%20329.699%20609.545%20329.894C609.369%20330.087%20609.236%20330.35%20609.147%20330.682C609.06%20331.013%20609.017%20331.395%20609.017%20331.829C609.017%20332.27%20609.06%20332.661%20609.147%20333.001C609.236%20333.338%20609.369%20333.606%20609.545%20333.803C609.721%20334.001%20609.932%20334.1%20610.178%20334.1C610.423%20334.1%20610.634%20334.001%20610.81%20333.803C610.986%20333.606%20611.118%20333.338%20611.205%20333.001C611.294%20332.661%20611.338%20332.27%20611.338%20331.829C611.338%20331.395%20611.294%20331.013%20611.205%20330.682C611.118%20330.35%20610.986%20330.087%20610.81%20329.894ZM612.828%20334.566L612.745%20333.973L614.615%20331.898C614.74%20331.758%20614.861%20331.577%20614.976%20331.355C615.095%20331.133%20615.18%20330.945%20615.233%20330.791L615.316%20330.563C615.316%20330.264%20615.233%20330.033%20615.067%20329.869C614.9%20329.702%20614.664%20329.619%20614.358%20329.619C613.847%20329.619%20613.444%20329.768%20613.15%20330.064L612.94%20329.522C613.273%20329.208%20613.76%20329.051%20614.401%20329.051C614.893%20329.051%20615.285%20329.185%20615.577%20329.453C615.868%20329.718%20616.014%20330.074%20616.014%20330.52C616.005%20330.553%20615.99%20330.599%20615.971%20330.657C615.952%20330.713%20615.909%20330.822%20615.844%20330.986C615.782%20331.15%20615.715%20331.306%20615.645%20331.453C615.576%20331.6%20615.486%20331.761%20615.378%20331.937C615.272%20332.113%20615.163%20332.26%20615.052%20332.379L613.526%20334.009H616.032L615.993%20334.566H612.828ZM620.086%20329.156L620.036%20329.749H617.826C617.802%20330.451%20617.784%20331.019%20617.772%20331.453C618.044%20331.279%20618.34%20331.192%20618.658%20331.192C618.925%20331.192%20619.164%20331.236%20619.374%20331.323C619.586%20331.407%20619.758%20331.524%20619.891%20331.673C620.026%20331.823%20620.128%20331.998%20620.198%20332.198C620.268%20332.395%20620.303%20332.61%20620.303%20332.841C620.303%20333.389%20620.127%20333.827%20619.775%20334.158C619.426%20334.486%20618.95%20334.65%20618.347%20334.65C617.742%20334.65%20617.257%20334.484%20616.893%20334.154L617.128%20333.644C617.485%20333.924%20617.898%20334.064%20618.369%20334.064C618.764%20334.064%20619.076%20333.952%20619.305%20333.727C619.534%20333.503%20619.649%20333.21%20619.649%20332.849C619.649%20332.526%20619.552%20332.264%20619.359%20332.064C619.167%20331.861%20618.892%20331.76%20618.535%20331.76C618.178%20331.76%20617.891%20331.879%20617.674%20332.118L617.172%20332.049L617.313%20329.156H620.086Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cpath%20d='M69%20283.699L93.7713%20288.125L117.744%20283.076L142.515%20285.623L166.487%20282.906L191.259%20279.397L216.03%20281.469L240.002%20279.216L264.773%20279.635L288.746%20281.763L313.517%20272.367L338.288%20269.198L361.462%20274.36L386.233%20274.552L410.205%20271.632L434.977%20276.261L458.949%20272.277L483.72%20270.59L508.491%20272.458L532.464%20269.866L557.235%20265.915L581.207%20272.175L605.979%20260.572L630.75%20261.591V321.7H605.979H581.207H557.235H532.464H508.491H483.72H458.949H434.977H410.205H386.233H361.462H338.288H313.517H288.746H264.773H240.002H216.03H191.259H166.487H142.515H117.744H93.7713H69V283.699Z'%20fill='%230F9ED5'%20fill-opacity='0.4'%20/%3e%3cpath%20d='M69%20261.534L93.7713%20273.737L117.744%20268.27L142.515%20272.13L166.487%20267.749L191.259%20264.194L216.03%20260.402L240.002%20255.897L264.773%20258.342L288.746%20251.38L313.517%20234.762L338.288%20236.732L361.462%20248.663L386.233%20252.388L410.205%20251.256L434.977%20259.078L458.949%20255.048L483.72%20249.693L508.491%20250.599L532.464%20244.95L557.235%20236.098L581.207%20238.566L605.979%20222.99L630.75%20225.027V261.591L605.979%20260.572L581.207%20272.175L557.235%20265.915L532.464%20269.866L508.491%20272.458L483.72%20270.59L458.949%20272.277L434.977%20276.261L410.205%20271.632L386.233%20274.552L361.462%20274.36L338.288%20269.198L313.517%20272.367L288.746%20281.763L264.773%20279.635L240.002%20279.216L216.03%20281.469L191.259%20279.397L166.487%20282.906L142.515%20285.623L117.744%20283.076L93.7713%20288.125L69%20283.699V261.534Z'%20fill='%230FD78A'%20fill-opacity='0.4'%20/%3e%3cpath%20d='M69%20283.699L93.7713%20288.125L117.744%20283.076L142.515%20285.623L166.487%20282.906L191.259%20279.397L216.03%20281.469L240.002%20279.216L264.773%20279.635L288.746%20281.763L313.517%20272.367L338.288%20269.198L361.462%20274.36L386.233%20274.552L410.205%20271.632L434.977%20276.261L458.949%20272.277L483.72%20270.59L508.491%20272.458L532.464%20269.866L557.235%20265.915L581.207%20272.175L605.979%20260.572L630.75%20261.591'%20stroke='%230F9ED5'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M69%20261.534L93.7713%20273.737L117.744%20268.27L142.515%20272.13L166.487%20267.749L191.259%20264.194L216.03%20260.402L240.002%20255.897L264.773%20258.342L288.746%20251.38L313.517%20234.762L338.288%20236.732L361.462%20248.663L386.233%20252.388L410.205%20251.256L434.977%20259.078L458.949%20255.048L483.72%20249.693L508.491%20250.599L532.464%20244.95L557.235%20236.098L581.207%20238.566L605.979%20222.99L630.75%20225.027'%20stroke='%230FD78A'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M65.875%20283.699C65.875%20284.113%2065.9543%20284.512%2066.1129%20284.895C66.2715%20285.277%2066.4973%20285.615%2066.7903%20285.908C67.0833%20286.201%2067.4213%20286.427%2067.8041%20286.586C68.187%20286.744%2068.5856%20286.824%2069%20286.824C69.4144%20286.824%2069.813%20286.744%2070.1959%20286.586C70.5787%20286.427%2070.9167%20286.201%2071.2097%20285.908C71.5027%20285.615%2071.7285%20285.277%2071.8871%20284.895C72.0457%20284.512%2072.125%20284.113%2072.125%20283.699C72.125%20283.284%2072.0457%20282.886%2071.8871%20282.503C71.7285%20282.12%2071.5027%20281.782%2071.2097%20281.489C70.9167%20281.196%2070.5787%20280.97%2070.1959%20280.812C69.813%20280.653%2069.4144%20280.574%2069%20280.574C68.5856%20280.574%2068.187%20280.653%2067.8041%20280.812C67.4213%20280.97%2067.0833%20281.196%2066.7903%20281.489C66.4973%20281.782%2066.2715%20282.12%2066.1129%20282.503C65.9543%20282.886%2065.875%20283.284%2065.875%20283.699Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M90.646%20288.125C90.646%20288.539%2090.7253%20288.938%2090.8839%20289.321C91.0425%20289.703%2091.2683%20290.041%2091.5613%20290.334C91.8543%20290.627%2092.1923%20290.853%2092.5751%20291.012C92.958%20291.17%2093.3566%20291.25%2093.771%20291.25C94.1854%20291.25%2094.584%20291.17%2094.9669%20291.012C95.3497%20290.853%2095.6877%20290.627%2095.9807%20290.334C96.2737%20290.041%2096.4995%20289.703%2096.6581%20289.321C96.8167%20288.938%2096.896%20288.539%2096.896%20288.125C96.896%20287.71%2096.8167%20287.312%2096.6581%20286.929C96.4995%20286.546%2096.2737%20286.208%2095.9807%20285.915C95.6877%20285.622%2095.3497%20285.396%2094.9669%20285.238C94.584%20285.079%2094.1854%20285%2093.771%20285C93.3566%20285%2092.958%20285.079%2092.5751%20285.238C92.1923%20285.396%2091.8543%20285.622%2091.5613%20285.915C91.2683%20286.208%2091.0425%20286.546%2090.8839%20286.929C90.7253%20287.312%2090.646%20287.71%2090.646%20288.125Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M114.619%20283.076C114.619%20283.491%20114.698%20283.889%20114.857%20284.272C115.015%20284.655%20115.241%20284.993%20115.534%20285.286C115.827%20285.579%20116.165%20285.805%20116.548%20285.963C116.931%20286.122%20117.329%20286.201%20117.744%20286.201C118.158%20286.201%20118.557%20286.122%20118.94%20285.963C119.322%20285.805%20119.66%20285.579%20119.953%20285.286C120.246%20284.993%20120.472%20284.655%20120.631%20284.272C120.789%20283.889%20120.869%20283.491%20120.869%20283.076C120.869%20282.662%20120.789%20282.263%20120.631%20281.88C120.472%20281.497%20120.246%20281.159%20119.953%20280.866C119.66%20280.573%20119.322%20280.348%20118.94%20280.189C118.557%20280.03%20118.158%20279.951%20117.744%20279.951C117.329%20279.951%20116.931%20280.03%20116.548%20280.189C116.165%20280.348%20115.827%20280.573%20115.534%20280.866C115.241%20281.159%20115.015%20281.497%20114.857%20281.88C114.698%20282.263%20114.619%20282.662%20114.619%20283.076Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M139.39%20285.623C139.39%20286.037%20139.469%20286.436%20139.628%20286.819C139.787%20287.202%20140.012%20287.54%20140.305%20287.833C140.598%20288.126%20140.936%20288.352%20141.319%20288.51C141.702%20288.669%20142.101%20288.748%20142.515%20288.748C142.93%20288.748%20143.328%20288.669%20143.711%20288.51C144.094%20288.352%20144.432%20288.126%20144.725%20287.833C145.018%20287.54%20145.244%20287.202%20145.402%20286.819C145.561%20286.436%20145.64%20286.037%20145.64%20285.623C145.64%20285.209%20145.561%20284.81%20145.402%20284.427C145.244%20284.044%20145.018%20283.706%20144.725%20283.413C144.432%20283.12%20144.094%20282.895%20143.711%20282.736C143.328%20282.577%20142.93%20282.498%20142.515%20282.498C142.101%20282.498%20141.702%20282.577%20141.319%20282.736C140.936%20282.895%20140.598%20283.12%20140.305%20283.413C140.012%20283.706%20139.787%20284.044%20139.628%20284.427C139.469%20284.81%20139.39%20285.209%20139.39%20285.623Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M163.362%20282.906C163.362%20283.321%20163.442%20283.719%20163.6%20284.102C163.759%20284.485%20163.985%20284.823%20164.278%20285.116C164.571%20285.409%20164.909%20285.635%20165.291%20285.793C165.674%20285.952%20166.073%20286.031%20166.487%20286.031C166.902%20286.031%20167.3%20285.952%20167.683%20285.793C168.066%20285.635%20168.404%20285.409%20168.697%20285.116C168.99%20284.823%20169.216%20284.485%20169.374%20284.102C169.533%20283.719%20169.612%20283.321%20169.612%20282.906C169.612%20282.492%20169.533%20282.093%20169.374%20281.71C169.216%20281.328%20168.99%20280.99%20168.697%20280.697C168.404%20280.404%20168.066%20280.178%20167.683%20280.019C167.3%20279.861%20166.902%20279.781%20166.487%20279.781C166.073%20279.781%20165.674%20279.861%20165.291%20280.019C164.909%20280.178%20164.571%20280.404%20164.278%20280.697C163.985%20280.99%20163.759%20281.328%20163.6%20281.71C163.442%20282.093%20163.362%20282.492%20163.362%20282.906Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M188.133%20279.397C188.133%20279.812%20188.213%20280.21%20188.371%20280.593C188.53%20280.976%20188.756%20281.314%20189.049%20281.607C189.342%20281.9%20189.68%20282.126%20190.062%20282.284C190.445%20282.443%20190.844%20282.522%20191.258%20282.522C191.673%20282.522%20192.071%20282.443%20192.454%20282.284C192.837%20282.126%20193.175%20281.9%20193.468%20281.607C193.761%20281.314%20193.987%20280.976%20194.145%20280.593C194.304%20280.21%20194.383%20279.812%20194.383%20279.397C194.383%20278.983%20194.304%20278.584%20194.145%20278.201C193.987%20277.818%20193.761%20277.481%20193.468%20277.188C193.175%20276.894%20192.837%20276.669%20192.454%20276.51C192.071%20276.352%20191.673%20276.272%20191.258%20276.272C190.844%20276.272%20190.445%20276.352%20190.062%20276.51C189.68%20276.669%20189.342%20276.894%20189.049%20277.188C188.756%20277.481%20188.53%20277.818%20188.371%20278.201C188.213%20278.584%20188.133%20278.983%20188.133%20279.397Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M212.905%20281.469C212.905%20281.883%20212.984%20282.282%20213.143%20282.665C213.301%20283.047%20213.527%20283.385%20213.82%20283.678C214.113%20283.971%20214.451%20284.197%20214.834%20284.356C215.217%20284.514%20215.615%20284.594%20216.03%20284.594C216.444%20284.594%20216.843%20284.514%20217.226%20284.356C217.609%20284.197%20217.946%20283.971%20218.239%20283.678C218.533%20283.385%20218.758%20283.047%20218.917%20282.665C219.075%20282.282%20219.155%20281.883%20219.155%20281.469C219.155%20281.054%20219.075%20280.656%20218.917%20280.273C218.758%20279.89%20218.533%20279.552%20218.239%20279.259C217.946%20278.966%20217.609%20278.74%20217.226%20278.582C216.843%20278.423%20216.444%20278.344%20216.03%20278.344C215.615%20278.344%20215.217%20278.423%20214.834%20278.582C214.451%20278.74%20214.113%20278.966%20213.82%20279.259C213.527%20279.552%20213.301%20279.89%20213.143%20280.273C212.984%20280.656%20212.905%20281.054%20212.905%20281.469Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M236.877%20279.216C236.877%20279.63%20236.956%20280.029%20237.115%20280.412C237.273%20280.795%20237.499%20281.133%20237.792%20281.426C238.085%20281.719%20238.423%20281.944%20238.806%20282.103C239.189%20282.262%20239.588%20282.341%20240.002%20282.341C240.416%20282.341%20240.815%20282.262%20241.198%20282.103C241.581%20281.944%20241.919%20281.719%20242.212%20281.426C242.505%20281.133%20242.73%20280.795%20242.889%20280.412C243.048%20280.029%20243.127%20279.63%20243.127%20279.216C243.127%20278.802%20243.048%20278.403%20242.889%20278.02C242.73%20277.637%20242.505%20277.299%20242.212%20277.006C241.919%20276.713%20241.581%20276.487%20241.198%20276.329C240.815%20276.17%20240.416%20276.091%20240.002%20276.091C239.588%20276.091%20239.189%20276.17%20238.806%20276.329C238.423%20276.487%20238.085%20276.713%20237.792%20277.006C237.499%20277.299%20237.273%20277.637%20237.115%20278.02C236.956%20278.403%20236.877%20278.802%20236.877%20279.216Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M261.648%20279.635C261.648%20280.049%20261.728%20280.448%20261.886%20280.831C262.045%20281.214%20262.271%20281.551%20262.564%20281.844C262.857%20282.137%20263.195%20282.363%20263.578%20282.522C263.96%20282.68%20264.359%20282.76%20264.773%20282.76C265.188%20282.76%20265.586%20282.68%20265.969%20282.522C266.352%20282.363%20266.69%20282.137%20266.983%20281.844C267.276%20281.551%20267.502%20281.214%20267.661%20280.831C267.819%20280.448%20267.898%20280.049%20267.898%20279.635C267.898%20279.22%20267.819%20278.822%20267.661%20278.439C267.502%20278.056%20267.276%20277.718%20266.983%20277.425C266.69%20277.132%20266.352%20276.906%20265.969%20276.748C265.586%20276.589%20265.188%20276.51%20264.773%20276.51C264.359%20276.51%20263.96%20276.589%20263.578%20276.748C263.195%20276.906%20262.857%20277.132%20262.564%20277.425C262.271%20277.718%20262.045%20278.056%20261.886%20278.439C261.728%20278.822%20261.648%20279.22%20261.648%20279.635Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M285.621%20281.763C285.621%20282.177%20285.7%20282.576%20285.859%20282.959C286.018%20283.342%20286.243%20283.68%20286.536%20283.973C286.829%20284.266%20287.167%20284.492%20287.55%20284.65C287.933%20284.809%20288.332%20284.888%20288.746%20284.888C289.16%20284.888%20289.559%20284.809%20289.942%20284.65C290.325%20284.492%20290.663%20284.266%20290.956%20283.973C291.249%20283.68%20291.475%20283.342%20291.633%20282.959C291.792%20282.576%20291.871%20282.177%20291.871%20281.763C291.871%20281.349%20291.792%20280.95%20291.633%20280.567C291.475%20280.184%20291.249%20279.846%20290.956%20279.553C290.663%20279.26%20290.325%20279.035%20289.942%20278.876C289.559%20278.717%20289.16%20278.638%20288.746%20278.638C288.332%20278.638%20287.933%20278.717%20287.55%20278.876C287.167%20279.035%20286.829%20279.26%20286.536%20279.553C286.243%20279.846%20286.018%20280.184%20285.859%20280.567C285.7%20280.95%20285.621%20281.349%20285.621%20281.763Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M310.392%20272.367C310.392%20272.782%20310.471%20273.18%20310.63%20273.563C310.789%20273.946%20311.014%20274.284%20311.307%20274.577C311.6%20274.87%20311.938%20275.096%20312.321%20275.255C312.704%20275.413%20313.103%20275.492%20313.517%20275.492C313.931%20275.492%20314.33%20275.413%20314.713%20275.255C315.096%20275.096%20315.434%20274.87%20315.727%20274.577C316.02%20274.284%20316.246%20273.946%20316.404%20273.563C316.563%20273.18%20316.642%20272.782%20316.642%20272.367C316.642%20271.953%20316.563%20271.554%20316.404%20271.172C316.246%20270.789%20316.02%20270.451%20315.727%20270.158C315.434%20269.865%20315.096%20269.639%20314.713%20269.48C314.33%20269.322%20313.931%20269.242%20313.517%20269.242C313.103%20269.242%20312.704%20269.322%20312.321%20269.48C311.938%20269.639%20311.6%20269.865%20311.307%20270.158C311.014%20270.451%20310.789%20270.789%20310.63%20271.172C310.471%20271.554%20310.392%20271.953%20310.392%20272.367Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M335.163%20269.198C335.163%20269.612%20335.242%20270.011%20335.401%20270.394C335.56%20270.776%20335.785%20271.114%20336.078%20271.407C336.371%20271.7%20336.709%20271.926%20337.092%20272.085C337.475%20272.243%20337.874%20272.323%20338.288%20272.323C338.702%20272.323%20339.101%20272.243%20339.484%20272.085C339.867%20271.926%20340.205%20271.7%20340.498%20271.407C340.791%20271.114%20341.017%20270.776%20341.175%20270.394C341.334%20270.011%20341.413%20269.612%20341.413%20269.198C341.413%20268.783%20341.334%20268.385%20341.175%20268.002C341.017%20267.619%20340.791%20267.281%20340.498%20266.988C340.205%20266.695%20339.867%20266.469%20339.484%20266.311C339.101%20266.152%20338.702%20266.073%20338.288%20266.073C337.874%20266.073%20337.475%20266.152%20337.092%20266.311C336.709%20266.469%20336.371%20266.695%20336.078%20266.988C335.785%20267.281%20335.56%20267.619%20335.401%20268.002C335.242%20268.385%20335.163%20268.783%20335.163%20269.198Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M358.336%20274.36C358.336%20274.774%20358.416%20275.173%20358.574%20275.556C358.733%20275.938%20358.959%20276.276%20359.252%20276.569C359.545%20276.862%20359.883%20277.088%20360.266%20277.247C360.648%20277.405%20361.047%20277.485%20361.461%20277.485C361.876%20277.485%20362.274%20277.405%20362.657%20277.247C363.04%20277.088%20363.378%20276.862%20363.671%20276.569C363.964%20276.276%20364.19%20275.938%20364.349%20275.556C364.507%20275.173%20364.586%20274.774%20364.586%20274.36C364.586%20273.945%20364.507%20273.547%20364.349%20273.164C364.19%20272.781%20363.964%20272.443%20363.671%20272.15C363.378%20271.857%20363.04%20271.631%20362.657%20271.473C362.274%20271.314%20361.876%20271.235%20361.461%20271.235C361.047%20271.235%20360.648%20271.314%20360.266%20271.473C359.883%20271.631%20359.545%20271.857%20359.252%20272.15C358.959%20272.443%20358.733%20272.781%20358.574%20273.164C358.416%20273.547%20358.336%20273.945%20358.336%20274.36Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M383.108%20274.552C383.108%20274.967%20383.187%20275.365%20383.346%20275.748C383.504%20276.131%20383.73%20276.469%20384.023%20276.762C384.316%20277.055%20384.654%20277.281%20385.037%20277.439C385.42%20277.598%20385.819%20277.677%20386.233%20277.677C386.647%20277.677%20387.046%20277.598%20387.429%20277.439C387.812%20277.281%20388.15%20277.055%20388.443%20276.762C388.736%20276.469%20388.961%20276.131%20389.12%20275.748C389.279%20275.365%20389.358%20274.967%20389.358%20274.552C389.358%20274.138%20389.279%20273.739%20389.12%20273.356C388.961%20272.973%20388.736%20272.635%20388.443%20272.342C388.15%20272.049%20387.812%20271.824%20387.429%20271.665C387.046%20271.506%20386.647%20271.427%20386.233%20271.427C385.819%20271.427%20385.42%20271.506%20385.037%20271.665C384.654%20271.824%20384.316%20272.049%20384.023%20272.342C383.73%20272.635%20383.504%20272.973%20383.346%20273.356C383.187%20273.739%20383.108%20274.138%20383.108%20274.552Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M407.08%20271.632C407.08%20272.046%20407.159%20272.445%20407.318%20272.827C407.477%20273.21%20407.702%20273.548%20407.995%20273.841C408.288%20274.134%20408.626%20274.36%20409.009%20274.519C409.392%20274.677%20409.791%20274.757%20410.205%20274.757C410.619%20274.757%20411.018%20274.677%20411.401%20274.519C411.784%20274.36%20412.122%20274.134%20412.415%20273.841C412.708%20273.548%20412.934%20273.21%20413.092%20272.827C413.251%20272.445%20413.33%20272.046%20413.33%20271.632C413.33%20271.217%20413.251%20270.819%20413.092%20270.436C412.934%20270.053%20412.708%20269.715%20412.415%20269.422C412.122%20269.129%20411.784%20268.903%20411.401%20268.744C411.018%20268.586%20410.619%20268.507%20410.205%20268.507C409.791%20268.507%20409.392%20268.586%20409.009%20268.744C408.626%20268.903%20408.288%20269.129%20407.995%20269.422C407.702%20269.715%20407.477%20270.053%20407.318%20270.436C407.159%20270.819%20407.08%20271.217%20407.08%20271.632Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M431.852%20276.262C431.852%20276.676%20431.931%20277.075%20432.089%20277.457C432.248%20277.84%20432.474%20278.178%20432.767%20278.471C433.06%20278.764%20433.398%20278.99%20433.781%20279.149C434.164%20279.307%20434.562%20279.387%20434.977%20279.387C435.391%20279.387%20435.79%20279.307%20436.172%20279.149C436.555%20278.99%20436.893%20278.764%20437.186%20278.471C437.479%20278.178%20437.705%20277.84%20437.864%20277.457C438.022%20277.075%20438.102%20276.676%20438.102%20276.262C438.102%20275.847%20438.022%20275.449%20437.864%20275.066C437.705%20274.683%20437.479%20274.345%20437.186%20274.052C436.893%20273.759%20436.555%20273.533%20436.172%20273.374C435.79%20273.216%20435.391%20273.137%20434.977%20273.137C434.562%20273.137%20434.164%20273.216%20433.781%20273.374C433.398%20273.533%20433.06%20273.759%20432.767%20274.052C432.474%20274.345%20432.248%20274.683%20432.089%20275.066C431.931%20275.449%20431.852%20275.847%20431.852%20276.262Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M455.824%20272.277C455.824%20272.691%20455.903%20273.09%20456.062%20273.473C456.22%20273.856%20456.446%20274.194%20456.739%20274.487C457.032%20274.78%20457.37%20275.006%20457.753%20275.164C458.136%20275.323%20458.534%20275.402%20458.949%20275.402C459.363%20275.402%20459.762%20275.323%20460.145%20275.164C460.527%20275.006%20460.865%20274.78%20461.158%20274.487C461.451%20274.194%20461.677%20273.856%20461.836%20273.473C461.994%20273.09%20462.074%20272.691%20462.074%20272.277C462.074%20271.863%20461.994%20271.464%20461.836%20271.081C461.677%20270.698%20461.451%20270.36%20461.158%20270.067C460.865%20269.774%20460.527%20269.548%20460.145%20269.39C459.762%20269.231%20459.363%20269.152%20458.949%20269.152C458.534%20269.152%20458.136%20269.231%20457.753%20269.39C457.37%20269.548%20457.032%20269.774%20456.739%20270.067C456.446%20270.36%20456.22%20270.698%20456.062%20271.081C455.903%20271.464%20455.824%20271.863%20455.824%20272.277Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M480.595%20270.59C480.595%20271.005%20480.675%20271.403%20480.833%20271.786C480.992%20272.169%20481.217%20272.507%20481.511%20272.8C481.804%20273.093%20482.141%20273.319%20482.524%20273.477C482.907%20273.636%20483.306%20273.715%20483.72%20273.715C484.135%20273.715%20484.533%20273.636%20484.916%20273.477C485.299%20273.319%20485.637%20273.093%20485.93%20272.8C486.223%20272.507%20486.449%20272.169%20486.607%20271.786C486.766%20271.403%20486.845%20271.005%20486.845%20270.59C486.845%20270.176%20486.766%20269.777%20486.607%20269.394C486.449%20269.011%20486.223%20268.674%20485.93%20268.381C485.637%20268.087%20485.299%20267.862%20484.916%20267.703C484.533%20267.545%20484.135%20267.465%20483.72%20267.465C483.306%20267.465%20482.907%20267.545%20482.524%20267.703C482.141%20267.862%20481.804%20268.087%20481.511%20268.381C481.217%20268.674%20480.992%20269.011%20480.833%20269.394C480.675%20269.777%20480.595%20270.176%20480.595%20270.59Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M505.366%20272.458C505.366%20272.872%20505.446%20273.271%20505.604%20273.654C505.763%20274.037%20505.988%20274.375%20506.282%20274.668C506.575%20274.961%20506.912%20275.187%20507.295%20275.345C507.678%20275.504%20508.077%20275.583%20508.491%20275.583C508.906%20275.583%20509.304%20275.504%20509.687%20275.345C510.07%20275.187%20510.408%20274.961%20510.701%20274.668C510.994%20274.375%20511.22%20274.037%20511.378%20273.654C511.537%20273.271%20511.616%20272.872%20511.616%20272.458C511.616%20272.044%20511.537%20271.645%20511.378%20271.262C511.22%20270.879%20510.994%20270.541%20510.701%20270.248C510.408%20269.955%20510.07%20269.729%20509.687%20269.571C509.304%20269.412%20508.906%20269.333%20508.491%20269.333C508.077%20269.333%20507.678%20269.412%20507.295%20269.571C506.912%20269.729%20506.575%20269.955%20506.282%20270.248C505.988%20270.541%20505.763%20270.879%20505.604%20271.262C505.446%20271.645%20505.366%20272.044%20505.366%20272.458Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M529.339%20269.866C529.339%20270.28%20529.418%20270.679%20529.577%20271.062C529.735%20271.444%20529.961%20271.782%20530.254%20272.075C530.547%20272.368%20530.885%20272.594%20531.268%20272.753C531.651%20272.911%20532.049%20272.991%20532.464%20272.991C532.878%20272.991%20533.277%20272.911%20533.66%20272.753C534.043%20272.594%20534.381%20272.368%20534.674%20272.075C534.967%20271.782%20535.192%20271.444%20535.351%20271.062C535.51%20270.679%20535.589%20270.28%20535.589%20269.866C535.589%20269.451%20535.51%20269.053%20535.351%20268.67C535.192%20268.287%20534.967%20267.949%20534.674%20267.656C534.381%20267.363%20534.043%20267.137%20533.66%20266.979C533.277%20266.82%20532.878%20266.741%20532.464%20266.741C532.049%20266.741%20531.651%20266.82%20531.268%20266.979C530.885%20267.137%20530.547%20267.363%20530.254%20267.656C529.961%20267.949%20529.735%20268.287%20529.577%20268.67C529.418%20269.053%20529.339%20269.451%20529.339%20269.866Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M554.11%20265.915C554.11%20266.329%20554.19%20266.728%20554.348%20267.111C554.507%20267.494%20554.733%20267.832%20555.026%20268.125C555.319%20268.418%20555.657%20268.644%20556.039%20268.802C556.422%20268.961%20556.821%20269.04%20557.235%20269.04C557.65%20269.04%20558.048%20268.961%20558.431%20268.802C558.814%20268.644%20559.152%20268.418%20559.445%20268.125C559.738%20267.832%20559.964%20267.494%20560.122%20267.111C560.281%20266.728%20560.36%20266.329%20560.36%20265.915C560.36%20265.501%20560.281%20265.102%20560.122%20264.719C559.964%20264.336%20559.738%20263.998%20559.445%20263.705C559.152%20263.412%20558.814%20263.187%20558.431%20263.028C558.048%20262.869%20557.65%20262.79%20557.235%20262.79C556.821%20262.79%20556.422%20262.869%20556.039%20263.028C555.657%20263.187%20555.319%20263.412%20555.026%20263.705C554.733%20263.998%20554.507%20264.336%20554.348%20264.719C554.19%20265.102%20554.11%20265.501%20554.11%20265.915Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M578.083%20272.175C578.083%20272.589%20578.162%20272.988%20578.32%20273.371C578.479%20273.754%20578.705%20274.092%20578.998%20274.385C579.291%20274.678%20579.629%20274.903%20580.012%20275.062C580.394%20275.221%20580.793%20275.3%20581.208%20275.3C581.622%20275.3%20582.021%20275.221%20582.403%20275.062C582.786%20274.903%20583.124%20274.678%20583.417%20274.385C583.71%20274.092%20583.936%20273.754%20584.095%20273.371C584.253%20272.988%20584.333%20272.589%20584.333%20272.175C584.333%20271.761%20584.253%20271.362%20584.095%20270.979C583.936%20270.596%20583.71%20270.258%20583.417%20269.965C583.124%20269.672%20582.786%20269.446%20582.403%20269.288C582.021%20269.129%20581.622%20269.05%20581.208%20269.05C580.793%20269.05%20580.394%20269.129%20580.012%20269.288C579.629%20269.446%20579.291%20269.672%20578.998%20269.965C578.705%20270.258%20578.479%20270.596%20578.32%20270.979C578.162%20271.362%20578.083%20271.761%20578.083%20272.175Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M602.854%20260.572C602.854%20260.986%20602.933%20261.385%20603.091%20261.768C603.25%20262.151%20603.476%20262.489%20603.769%20262.782C604.062%20263.075%20604.4%20263.301%20604.783%20263.459C605.165%20263.618%20605.564%20263.697%20605.979%20263.697C606.393%20263.697%20606.792%20263.618%20607.174%20263.459C607.557%20263.301%20607.895%20263.075%20608.188%20262.782C608.481%20262.489%20608.707%20262.151%20608.866%20261.768C609.024%20261.385%20609.104%20260.986%20609.104%20260.572C609.104%20260.158%20609.024%20259.759%20608.866%20259.376C608.707%20258.993%20608.481%20258.655%20608.188%20258.362C607.895%20258.069%20607.557%20257.843%20607.174%20257.685C606.792%20257.526%20606.393%20257.447%20605.979%20257.447C605.564%20257.447%20605.165%20257.526%20604.783%20257.685C604.4%20257.843%20604.062%20258.069%20603.769%20258.362C603.476%20258.655%20603.25%20258.993%20603.091%20259.376C602.933%20259.759%20602.854%20260.158%20602.854%20260.572Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M627.625%20261.591C627.625%20262.005%20627.704%20262.404%20627.863%20262.787C628.021%20263.17%20628.247%20263.508%20628.54%20263.801C628.833%20264.094%20629.171%20264.319%20629.554%20264.478C629.937%20264.637%20630.336%20264.716%20630.75%20264.716C631.164%20264.716%20631.563%20264.637%20631.946%20264.478C632.329%20264.319%20632.667%20264.094%20632.96%20263.801C633.253%20263.508%20633.479%20263.17%20633.637%20262.787C633.796%20262.404%20633.875%20262.005%20633.875%20261.591C633.875%20261.176%20633.796%20260.778%20633.637%20260.395C633.479%20260.012%20633.253%20259.674%20632.96%20259.381C632.667%20259.088%20632.329%20258.862%20631.946%20258.704C631.563%20258.545%20631.164%20258.466%20630.75%20258.466C630.336%20258.466%20629.937%20258.545%20629.554%20258.704C629.171%20258.862%20628.833%20259.088%20628.54%20259.381C628.247%20259.674%20628.021%20260.012%20627.863%20260.395C627.704%20260.778%20627.625%20261.176%20627.625%20261.591Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M65.875%20261.534C65.875%20261.949%2065.9543%20262.347%2066.1129%20262.73C66.2715%20263.113%2066.4973%20263.451%2066.7903%20263.744C67.0833%20264.037%2067.4213%20264.263%2067.8041%20264.421C68.187%20264.58%2068.5856%20264.659%2069%20264.659C69.4144%20264.659%2069.813%20264.58%2070.1959%20264.421C70.5787%20264.263%2070.9167%20264.037%2071.2097%20263.744C71.5027%20263.451%2071.7285%20263.113%2071.8871%20262.73C72.0457%20262.347%2072.125%20261.949%2072.125%20261.534C72.125%20261.12%2072.0457%20260.721%2071.8871%20260.338C71.7285%20259.955%2071.5027%20259.617%2071.2097%20259.324C70.9167%20259.031%2070.5787%20258.806%2070.1959%20258.647C69.813%20258.488%2069.4144%20258.409%2069%20258.409C68.5856%20258.409%2068.187%20258.488%2067.8041%20258.647C67.4213%20258.806%2067.0833%20259.031%2066.7903%20259.324C66.4973%20259.617%2066.2715%20259.955%2066.1129%20260.338C65.9543%20260.721%2065.875%20261.12%2065.875%20261.534Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M90.646%20273.737C90.646%20274.151%2090.7253%20274.55%2090.8839%20274.933C91.0425%20275.316%2091.2683%20275.654%2091.5613%20275.947C91.8543%20276.24%2092.1923%20276.466%2092.5751%20276.624C92.958%20276.783%2093.3566%20276.862%2093.771%20276.862C94.1854%20276.862%2094.584%20276.783%2094.9669%20276.624C95.3497%20276.466%2095.6877%20276.24%2095.9807%20275.947C96.2737%20275.654%2096.4995%20275.316%2096.6581%20274.933C96.8167%20274.55%2096.896%20274.151%2096.896%20273.737C96.896%20273.323%2096.8167%20272.924%2096.6581%20272.541C96.4995%20272.158%2096.2737%20271.82%2095.9807%20271.527C95.6877%20271.234%2095.3497%20271.009%2094.9669%20270.85C94.584%20270.691%2094.1854%20270.612%2093.771%20270.612C93.3566%20270.612%2092.958%20270.691%2092.5751%20270.85C92.1923%20271.009%2091.8543%20271.234%2091.5613%20271.527C91.2683%20271.82%2091.0425%20272.158%2090.8839%20272.541C90.7253%20272.924%2090.646%20273.323%2090.646%20273.737Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M114.619%20268.27C114.619%20268.684%20114.698%20269.083%20114.857%20269.466C115.015%20269.848%20115.241%20270.186%20115.534%20270.479C115.827%20270.772%20116.165%20270.998%20116.548%20271.157C116.931%20271.315%20117.329%20271.395%20117.744%20271.395C118.158%20271.395%20118.557%20271.315%20118.94%20271.157C119.322%20270.998%20119.66%20270.772%20119.953%20270.479C120.246%20270.186%20120.472%20269.848%20120.631%20269.466C120.789%20269.083%20120.869%20268.684%20120.869%20268.27C120.869%20267.855%20120.789%20267.457%20120.631%20267.074C120.472%20266.691%20120.246%20266.353%20119.953%20266.06C119.66%20265.767%20119.322%20265.541%20118.94%20265.383C118.557%20265.224%20118.158%20265.145%20117.744%20265.145C117.329%20265.145%20116.931%20265.224%20116.548%20265.383C116.165%20265.541%20115.827%20265.767%20115.534%20266.06C115.241%20266.353%20115.015%20266.691%20114.857%20267.074C114.698%20267.457%20114.619%20267.855%20114.619%20268.27Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M139.39%20272.13C139.39%20272.544%20139.469%20272.943%20139.628%20273.326C139.787%20273.708%20140.012%20274.046%20140.305%20274.339C140.598%20274.632%20140.936%20274.858%20141.319%20275.017C141.702%20275.175%20142.101%20275.255%20142.515%20275.255C142.93%20275.255%20143.328%20275.175%20143.711%20275.017C144.094%20274.858%20144.432%20274.632%20144.725%20274.339C145.018%20274.046%20145.244%20273.708%20145.402%20273.326C145.561%20272.943%20145.64%20272.544%20145.64%20272.13C145.64%20271.715%20145.561%20271.317%20145.402%20270.934C145.244%20270.551%20145.018%20270.213%20144.725%20269.92C144.432%20269.627%20144.094%20269.401%20143.711%20269.243C143.328%20269.084%20142.93%20269.005%20142.515%20269.005C142.101%20269.005%20141.702%20269.084%20141.319%20269.243C140.936%20269.401%20140.598%20269.627%20140.305%20269.92C140.012%20270.213%20139.787%20270.551%20139.628%20270.934C139.469%20271.317%20139.39%20271.715%20139.39%20272.13Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M163.362%20267.749C163.362%20268.163%20163.442%20268.562%20163.6%20268.945C163.759%20269.328%20163.985%20269.665%20164.278%20269.958C164.571%20270.252%20164.909%20270.477%20165.291%20270.636C165.674%20270.794%20166.073%20270.874%20166.487%20270.874C166.902%20270.874%20167.3%20270.794%20167.683%20270.636C168.066%20270.477%20168.404%20270.252%20168.697%20269.958C168.99%20269.665%20169.216%20269.328%20169.374%20268.945C169.533%20268.562%20169.612%20268.163%20169.612%20267.749C169.612%20267.334%20169.533%20266.936%20169.374%20266.553C169.216%20266.17%20168.99%20265.832%20168.697%20265.539C168.404%20265.246%20168.066%20265.02%20167.683%20264.862C167.3%20264.703%20166.902%20264.624%20166.487%20264.624C166.073%20264.624%20165.674%20264.703%20165.291%20264.862C164.909%20265.02%20164.571%20265.246%20164.278%20265.539C163.985%20265.832%20163.759%20266.17%20163.6%20266.553C163.442%20266.936%20163.362%20267.334%20163.362%20267.749Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M188.133%20264.194C188.133%20264.609%20188.213%20265.007%20188.371%20265.39C188.53%20265.773%20188.756%20266.111%20189.049%20266.404C189.342%20266.697%20189.68%20266.923%20190.062%20267.081C190.445%20267.24%20190.844%20267.319%20191.258%20267.319C191.673%20267.319%20192.071%20267.24%20192.454%20267.081C192.837%20266.923%20193.175%20266.697%20193.468%20266.404C193.761%20266.111%20193.987%20265.773%20194.145%20265.39C194.304%20265.007%20194.383%20264.609%20194.383%20264.194C194.383%20263.78%20194.304%20263.381%20194.145%20262.998C193.987%20262.616%20193.761%20262.278%20193.468%20261.985C193.175%20261.692%20192.837%20261.466%20192.454%20261.307C192.071%20261.149%20191.673%20261.069%20191.258%20261.069C190.844%20261.069%20190.445%20261.149%20190.062%20261.307C189.68%20261.466%20189.342%20261.692%20189.049%20261.985C188.756%20262.278%20188.53%20262.616%20188.371%20262.998C188.213%20263.381%20188.133%20263.78%20188.133%20264.194Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M212.905%20260.402C212.905%20260.817%20212.984%20261.215%20213.143%20261.598C213.301%20261.981%20213.527%20262.319%20213.82%20262.612C214.113%20262.905%20214.451%20263.131%20214.834%20263.289C215.217%20263.448%20215.615%20263.527%20216.03%20263.527C216.444%20263.527%20216.843%20263.448%20217.226%20263.289C217.609%20263.131%20217.946%20262.905%20218.239%20262.612C218.533%20262.319%20218.758%20261.981%20218.917%20261.598C219.075%20261.215%20219.155%20260.817%20219.155%20260.402C219.155%20259.988%20219.075%20259.589%20218.917%20259.206C218.758%20258.823%20218.533%20258.486%20218.239%20258.193C217.946%20257.899%20217.609%20257.674%20217.226%20257.515C216.843%20257.357%20216.444%20257.277%20216.03%20257.277C215.615%20257.277%20215.217%20257.357%20214.834%20257.515C214.451%20257.674%20214.113%20257.899%20213.82%20258.193C213.527%20258.486%20213.301%20258.823%20213.143%20259.206C212.984%20259.589%20212.905%20259.988%20212.905%20260.402Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M236.877%20255.897C236.877%20256.311%20236.956%20256.71%20237.115%20257.093C237.273%20257.476%20237.499%20257.814%20237.792%20258.107C238.085%20258.4%20238.423%20258.625%20238.806%20258.784C239.189%20258.943%20239.588%20259.022%20240.002%20259.022C240.416%20259.022%20240.815%20258.943%20241.198%20258.784C241.581%20258.625%20241.919%20258.4%20242.212%20258.107C242.505%20257.814%20242.73%20257.476%20242.889%20257.093C243.048%20256.71%20243.127%20256.311%20243.127%20255.897C243.127%20255.482%20243.048%20255.084%20242.889%20254.701C242.73%20254.318%20242.505%20253.98%20242.212%20253.687C241.919%20253.394%20241.581%20253.168%20241.198%20253.01C240.815%20252.851%20240.416%20252.772%20240.002%20252.772C239.588%20252.772%20239.189%20252.851%20238.806%20253.01C238.423%20253.168%20238.085%20253.394%20237.792%20253.687C237.499%20253.98%20237.273%20254.318%20237.115%20254.701C236.956%20255.084%20236.877%20255.482%20236.877%20255.897Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M261.648%20258.342C261.648%20258.756%20261.728%20259.155%20261.886%20259.538C262.045%20259.921%20262.271%20260.259%20262.564%20260.552C262.857%20260.845%20263.195%20261.071%20263.578%20261.229C263.96%20261.388%20264.359%20261.467%20264.773%20261.467C265.188%20261.467%20265.586%20261.388%20265.969%20261.229C266.352%20261.071%20266.69%20260.845%20266.983%20260.552C267.276%20260.259%20267.502%20259.921%20267.661%20259.538C267.819%20259.155%20267.898%20258.756%20267.898%20258.342C267.898%20257.928%20267.819%20257.529%20267.661%20257.146C267.502%20256.763%20267.276%20256.425%20266.983%20256.132C266.69%20255.839%20266.352%20255.614%20265.969%20255.455C265.586%20255.296%20265.188%20255.217%20264.773%20255.217C264.359%20255.217%20263.96%20255.296%20263.578%20255.455C263.195%20255.614%20262.857%20255.839%20262.564%20256.132C262.271%20256.425%20262.045%20256.763%20261.886%20257.146C261.728%20257.529%20261.648%20257.928%20261.648%20258.342Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M285.621%20251.38C285.621%20251.795%20285.7%20252.193%20285.859%20252.576C286.018%20252.959%20286.243%20253.297%20286.536%20253.59C286.829%20253.883%20287.167%20254.109%20287.55%20254.267C287.933%20254.426%20288.332%20254.505%20288.746%20254.505C289.16%20254.505%20289.559%20254.426%20289.942%20254.267C290.325%20254.109%20290.663%20253.883%20290.956%20253.59C291.249%20253.297%20291.475%20252.959%20291.633%20252.576C291.792%20252.193%20291.871%20251.795%20291.871%20251.38C291.871%20250.966%20291.792%20250.567%20291.633%20250.184C291.475%20249.801%20291.249%20249.463%20290.956%20249.17C290.663%20248.877%20290.325%20248.652%20289.942%20248.493C289.559%20248.334%20289.16%20248.255%20288.746%20248.255C288.332%20248.255%20287.933%20248.334%20287.55%20248.493C287.167%20248.652%20286.829%20248.877%20286.536%20249.17C286.243%20249.463%20286.018%20249.801%20285.859%20250.184C285.7%20250.567%20285.621%20250.966%20285.621%20251.38Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M310.392%20234.762C310.392%20235.177%20310.471%20235.575%20310.63%20235.958C310.789%20236.341%20311.014%20236.679%20311.307%20236.972C311.6%20237.265%20311.938%20237.491%20312.321%20237.65C312.704%20237.808%20313.103%20237.887%20313.517%20237.887C313.931%20237.887%20314.33%20237.808%20314.713%20237.65C315.096%20237.491%20315.434%20237.265%20315.727%20236.972C316.02%20236.679%20316.246%20236.341%20316.404%20235.958C316.563%20235.575%20316.642%20235.177%20316.642%20234.762C316.642%20234.348%20316.563%20233.949%20316.404%20233.567C316.246%20233.184%20316.02%20232.846%20315.727%20232.553C315.434%20232.26%20315.096%20232.034%20314.713%20231.875C314.33%20231.717%20313.931%20231.637%20313.517%20231.637C313.103%20231.637%20312.704%20231.717%20312.321%20231.875C311.938%20232.034%20311.6%20232.26%20311.307%20232.553C311.014%20232.846%20310.789%20233.184%20310.63%20233.567C310.471%20233.949%20310.392%20234.348%20310.392%20234.762Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M335.163%20236.732C335.163%20237.146%20335.242%20237.545%20335.401%20237.928C335.56%20238.311%20335.785%20238.649%20336.078%20238.942C336.371%20239.235%20336.709%20239.461%20337.092%20239.619C337.475%20239.778%20337.874%20239.857%20338.288%20239.857C338.702%20239.857%20339.101%20239.778%20339.484%20239.619C339.867%20239.461%20340.205%20239.235%20340.498%20238.942C340.791%20238.649%20341.017%20238.311%20341.175%20237.928C341.334%20237.545%20341.413%20237.146%20341.413%20236.732C341.413%20236.318%20341.334%20235.919%20341.175%20235.536C341.017%20235.153%20340.791%20234.815%20340.498%20234.522C340.205%20234.229%20339.867%20234.004%20339.484%20233.845C339.101%20233.686%20338.702%20233.607%20338.288%20233.607C337.874%20233.607%20337.475%20233.686%20337.092%20233.845C336.709%20234.004%20336.371%20234.229%20336.078%20234.522C335.785%20234.815%20335.56%20235.153%20335.401%20235.536C335.242%20235.919%20335.163%20236.318%20335.163%20236.732Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M358.336%20248.663C358.336%20249.078%20358.416%20249.476%20358.574%20249.859C358.733%20250.242%20358.959%20250.58%20359.252%20250.873C359.545%20251.166%20359.883%20251.392%20360.266%20251.55C360.648%20251.709%20361.047%20251.788%20361.461%20251.788C361.876%20251.788%20362.274%20251.709%20362.657%20251.55C363.04%20251.392%20363.378%20251.166%20363.671%20250.873C363.964%20250.58%20364.19%20250.242%20364.349%20249.859C364.507%20249.476%20364.586%20249.078%20364.586%20248.663C364.586%20248.249%20364.507%20247.85%20364.349%20247.467C364.19%20247.085%20363.964%20246.747%20363.671%20246.454C363.378%20246.161%20363.04%20245.935%20362.657%20245.776C362.274%20245.618%20361.876%20245.538%20361.461%20245.538C361.047%20245.538%20360.648%20245.618%20360.266%20245.776C359.883%20245.935%20359.545%20246.161%20359.252%20246.454C358.959%20246.747%20358.733%20247.085%20358.574%20247.467C358.416%20247.85%20358.336%20248.249%20358.336%20248.663Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M383.108%20252.388C383.108%20252.802%20383.187%20253.201%20383.346%20253.584C383.504%20253.966%20383.73%20254.304%20384.023%20254.597C384.316%20254.89%20384.654%20255.116%20385.037%20255.275C385.42%20255.433%20385.819%20255.513%20386.233%20255.513C386.647%20255.513%20387.046%20255.433%20387.429%20255.275C387.812%20255.116%20388.15%20254.89%20388.443%20254.597C388.736%20254.304%20388.961%20253.966%20389.12%20253.584C389.279%20253.201%20389.358%20252.802%20389.358%20252.388C389.358%20251.973%20389.279%20251.575%20389.12%20251.192C388.961%20250.809%20388.736%20250.471%20388.443%20250.178C388.15%20249.885%20387.812%20249.659%20387.429%20249.501C387.046%20249.342%20386.647%20249.263%20386.233%20249.263C385.819%20249.263%20385.42%20249.342%20385.037%20249.501C384.654%20249.659%20384.316%20249.885%20384.023%20250.178C383.73%20250.471%20383.504%20250.809%20383.346%20251.192C383.187%20251.575%20383.108%20251.973%20383.108%20252.388Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M407.08%20251.256C407.08%20251.67%20407.159%20252.069%20407.318%20252.452C407.477%20252.834%20407.702%20253.172%20407.995%20253.465C408.288%20253.758%20408.626%20253.984%20409.009%20254.143C409.392%20254.301%20409.791%20254.381%20410.205%20254.381C410.619%20254.381%20411.018%20254.301%20411.401%20254.143C411.784%20253.984%20412.122%20253.758%20412.415%20253.465C412.708%20253.172%20412.934%20252.834%20413.092%20252.452C413.251%20252.069%20413.33%20251.67%20413.33%20251.256C413.33%20250.841%20413.251%20250.443%20413.092%20250.06C412.934%20249.677%20412.708%20249.339%20412.415%20249.046C412.122%20248.753%20411.784%20248.527%20411.401%20248.368C411.018%20248.21%20410.619%20248.131%20410.205%20248.131C409.791%20248.131%20409.392%20248.21%20409.009%20248.368C408.626%20248.527%20408.288%20248.753%20407.995%20249.046C407.702%20249.339%20407.477%20249.677%20407.318%20250.06C407.159%20250.443%20407.08%20250.841%20407.08%20251.256Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M431.852%20259.078C431.852%20259.492%20431.931%20259.891%20432.089%20260.274C432.248%20260.657%20432.474%20260.994%20432.767%20261.287C433.06%20261.58%20433.398%20261.806%20433.781%20261.965C434.164%20262.123%20434.562%20262.203%20434.977%20262.203C435.391%20262.203%20435.79%20262.123%20436.172%20261.965C436.555%20261.806%20436.893%20261.58%20437.186%20261.287C437.479%20260.994%20437.705%20260.657%20437.864%20260.274C438.022%20259.891%20438.102%20259.492%20438.102%20259.078C438.102%20258.663%20438.022%20258.265%20437.864%20257.882C437.705%20257.499%20437.479%20257.161%20437.186%20256.868C436.893%20256.575%20436.555%20256.349%20436.172%20256.191C435.79%20256.032%20435.391%20255.953%20434.977%20255.953C434.562%20255.953%20434.164%20256.032%20433.781%20256.191C433.398%20256.349%20433.06%20256.575%20432.767%20256.868C432.474%20257.161%20432.248%20257.499%20432.089%20257.882C431.931%20258.265%20431.852%20258.663%20431.852%20259.078Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M455.824%20255.048C455.824%20255.462%20455.903%20255.861%20456.062%20256.244C456.22%20256.627%20456.446%20256.965%20456.739%20257.258C457.032%20257.551%20457.37%20257.776%20457.753%20257.935C458.136%20258.094%20458.534%20258.173%20458.949%20258.173C459.363%20258.173%20459.762%20258.094%20460.145%20257.935C460.527%20257.776%20460.865%20257.551%20461.158%20257.258C461.451%20256.965%20461.677%20256.627%20461.836%20256.244C461.994%20255.861%20462.074%20255.462%20462.074%20255.048C462.074%20254.633%20461.994%20254.235%20461.836%20253.852C461.677%20253.469%20461.451%20253.131%20461.158%20252.838C460.865%20252.545%20460.527%20252.319%20460.145%20252.161C459.762%20252.002%20459.363%20251.923%20458.949%20251.923C458.534%20251.923%20458.136%20252.002%20457.753%20252.161C457.37%20252.319%20457.032%20252.545%20456.739%20252.838C456.446%20253.131%20456.22%20253.469%20456.062%20253.852C455.903%20254.235%20455.824%20254.633%20455.824%20255.048Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M480.595%20249.693C480.595%20250.108%20480.675%20250.507%20480.833%20250.889C480.992%20251.272%20481.217%20251.61%20481.511%20251.903C481.804%20252.196%20482.141%20252.422%20482.524%20252.581C482.907%20252.739%20483.306%20252.818%20483.72%20252.818C484.135%20252.818%20484.533%20252.739%20484.916%20252.581C485.299%20252.422%20485.637%20252.196%20485.93%20251.903C486.223%20251.61%20486.449%20251.272%20486.607%20250.889C486.766%20250.507%20486.845%20250.108%20486.845%20249.693C486.845%20249.279%20486.766%20248.88%20486.607%20248.498C486.449%20248.115%20486.223%20247.777%20485.93%20247.484C485.637%20247.191%20485.299%20246.965%20484.916%20246.806C484.533%20246.648%20484.135%20246.568%20483.72%20246.568C483.306%20246.568%20482.907%20246.648%20482.524%20246.806C482.141%20246.965%20481.804%20247.191%20481.511%20247.484C481.217%20247.777%20480.992%20248.115%20480.833%20248.498C480.675%20248.88%20480.595%20249.279%20480.595%20249.693Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M505.366%20250.599C505.366%20251.013%20505.446%20251.412%20505.604%20251.795C505.763%20252.178%20505.988%20252.516%20506.282%20252.809C506.575%20253.102%20506.912%20253.328%20507.295%20253.486C507.678%20253.645%20508.077%20253.724%20508.491%20253.724C508.906%20253.724%20509.304%20253.645%20509.687%20253.486C510.07%20253.328%20510.408%20253.102%20510.701%20252.809C510.994%20252.516%20511.22%20252.178%20511.378%20251.795C511.537%20251.412%20511.616%20251.013%20511.616%20250.599C511.616%20250.185%20511.537%20249.786%20511.378%20249.403C511.22%20249.02%20510.994%20248.682%20510.701%20248.389C510.408%20248.096%20510.07%20247.87%20509.687%20247.712C509.304%20247.553%20508.906%20247.474%20508.491%20247.474C508.077%20247.474%20507.678%20247.553%20507.295%20247.712C506.912%20247.87%20506.575%20248.096%20506.282%20248.389C505.988%20248.682%20505.763%20249.02%20505.604%20249.403C505.446%20249.786%20505.366%20250.185%20505.366%20250.599Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M529.339%20244.95C529.339%20245.365%20529.418%20245.763%20529.577%20246.146C529.735%20246.529%20529.961%20246.867%20530.254%20247.16C530.547%20247.453%20530.885%20247.679%20531.268%20247.838C531.651%20247.996%20532.049%20248.075%20532.464%20248.075C532.878%20248.075%20533.277%20247.996%20533.66%20247.838C534.043%20247.679%20534.381%20247.453%20534.674%20247.16C534.967%20246.867%20535.192%20246.529%20535.351%20246.146C535.51%20245.763%20535.589%20245.365%20535.589%20244.95C535.589%20244.536%20535.51%20244.137%20535.351%20243.755C535.192%20243.372%20534.967%20243.034%20534.674%20242.741C534.381%20242.448%20534.043%20242.222%20533.66%20242.063C533.277%20241.905%20532.878%20241.825%20532.464%20241.825C532.049%20241.825%20531.651%20241.905%20531.268%20242.063C530.885%20242.222%20530.547%20242.448%20530.254%20242.741C529.961%20243.034%20529.735%20243.372%20529.577%20243.755C529.418%20244.137%20529.339%20244.536%20529.339%20244.95Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M554.11%20236.098C554.11%20236.513%20554.19%20236.911%20554.348%20237.294C554.507%20237.677%20554.733%20238.015%20555.026%20238.308C555.319%20238.601%20555.657%20238.827%20556.039%20238.985C556.422%20239.144%20556.821%20239.223%20557.235%20239.223C557.65%20239.223%20558.048%20239.144%20558.431%20238.985C558.814%20238.827%20559.152%20238.601%20559.445%20238.308C559.738%20238.015%20559.964%20237.677%20560.122%20237.294C560.281%20236.911%20560.36%20236.513%20560.36%20236.098C560.36%20235.684%20560.281%20235.285%20560.122%20234.902C559.964%20234.519%20559.738%20234.181%20559.445%20233.888C559.152%20233.595%20558.814%20233.37%20558.431%20233.211C558.048%20233.052%20557.65%20232.973%20557.235%20232.973C556.821%20232.973%20556.422%20233.052%20556.039%20233.211C555.657%20233.37%20555.319%20233.595%20555.026%20233.888C554.733%20234.181%20554.507%20234.519%20554.348%20234.902C554.19%20235.285%20554.11%20235.684%20554.11%20236.098Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M578.083%20238.566C578.083%20238.98%20578.162%20239.379%20578.32%20239.762C578.479%20240.145%20578.705%20240.483%20578.998%20240.776C579.291%20241.069%20579.629%20241.294%20580.012%20241.453C580.394%20241.612%20580.793%20241.691%20581.208%20241.691C581.622%20241.691%20582.021%20241.612%20582.403%20241.453C582.786%20241.294%20583.124%20241.069%20583.417%20240.776C583.71%20240.483%20583.936%20240.145%20584.095%20239.762C584.253%20239.379%20584.333%20238.98%20584.333%20238.566C584.333%20238.152%20584.253%20237.753%20584.095%20237.37C583.936%20236.987%20583.71%20236.649%20583.417%20236.356C583.124%20236.063%20582.786%20235.837%20582.403%20235.679C582.021%20235.52%20581.622%20235.441%20581.208%20235.441C580.793%20235.441%20580.394%20235.52%20580.012%20235.679C579.629%20235.837%20579.291%20236.063%20578.998%20236.356C578.705%20236.649%20578.479%20236.987%20578.32%20237.37C578.162%20237.753%20578.083%20238.152%20578.083%20238.566Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M602.854%20222.99C602.854%20223.404%20602.933%20223.803%20603.091%20224.186C603.25%20224.568%20603.476%20224.906%20603.769%20225.199C604.062%20225.492%20604.4%20225.718%20604.783%20225.877C605.165%20226.035%20605.564%20226.115%20605.979%20226.115C606.393%20226.115%20606.792%20226.035%20607.174%20225.877C607.557%20225.718%20607.895%20225.492%20608.188%20225.199C608.481%20224.906%20608.707%20224.568%20608.866%20224.186C609.024%20223.803%20609.104%20223.404%20609.104%20222.99C609.104%20222.575%20609.024%20222.177%20608.866%20221.794C608.707%20221.411%20608.481%20221.073%20608.188%20220.78C607.895%20220.487%20607.557%20220.261%20607.174%20220.103C606.792%20219.944%20606.393%20219.865%20605.979%20219.865C605.564%20219.865%20605.165%20219.944%20604.783%20220.103C604.4%20220.261%20604.062%20220.487%20603.769%20220.78C603.476%20221.073%20603.25%20221.411%20603.091%20221.794C602.933%20222.177%20602.854%20222.575%20602.854%20222.99Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M627.625%20225.027C627.625%20225.442%20627.704%20225.84%20627.863%20226.223C628.021%20226.606%20628.247%20226.944%20628.54%20227.237C628.833%20227.53%20629.171%20227.756%20629.554%20227.914C629.937%20228.073%20630.336%20228.152%20630.75%20228.152C631.164%20228.152%20631.563%20228.073%20631.946%20227.914C632.329%20227.756%20632.667%20227.53%20632.96%20227.237C633.253%20226.944%20633.479%20226.606%20633.637%20226.223C633.796%20225.84%20633.875%20225.442%20633.875%20225.027C633.875%20224.613%20633.796%20224.214%20633.637%20223.831C633.479%20223.448%20633.253%20223.111%20632.96%20222.818C632.667%20222.524%20632.329%20222.299%20631.946%20222.14C631.563%20221.982%20631.164%20221.902%20630.75%20221.902C630.336%20221.902%20629.937%20221.982%20629.554%20222.14C629.171%20222.299%20628.833%20222.524%20628.54%20222.818C628.247%20223.111%20628.021%20223.448%20627.863%20223.831C627.704%20224.214%20627.625%20224.613%20627.625%20225.027Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M41.6499%20191.9C41.6499%20192.397%2041.7451%20192.876%2041.9354%20193.335C42.1257%20193.795%2042.3966%20194.2%2042.7483%20194.552C43.0999%20194.903%2043.5054%20195.174%2043.9648%20195.365C44.4243%20195.555%2044.9026%20195.65%2045.3999%20195.65C45.8972%20195.65%2046.3755%20195.555%2046.835%20195.365C47.2944%20195.174%2047.6999%20194.903%2048.0516%20194.552C48.4032%20194.2%2048.6741%20193.795%2048.8644%20193.335C49.0548%20192.876%2049.1499%20192.397%2049.1499%20191.9C49.1499%20191.403%2049.0548%20190.924%2048.8644%20190.465C48.6741%20190.006%2048.4032%20189.6%2048.0516%20189.248C47.6999%20188.897%2047.2944%20188.626%2046.835%20188.435C46.3755%20188.245%2045.8972%20188.15%2045.3999%20188.15C44.9026%20188.15%2044.4243%20188.245%2043.9648%20188.435C43.5054%20188.626%2043.0999%20188.897%2042.7483%20189.248C42.3966%20189.6%2042.1257%20190.006%2041.9354%20190.465C41.7451%20190.924%2041.6499%20191.403%2041.6499%20191.9Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M53.0612%20196.199C52.6809%20196.199%2052.3389%20196.136%2052.0351%20196.01C51.7336%20195.881%2051.4838%20195.703%2051.2858%20195.476C51.0901%20195.247%2050.9393%20194.976%2050.8335%20194.663C50.73%20194.35%2050.6783%20194.007%2050.6783%20193.633C50.6783%20193.129%2050.7739%20192.684%2050.9652%20192.297C51.1564%20191.91%2051.4411%20191.605%2051.8191%20191.382C52.1971%20191.159%2052.6449%20191.048%2053.1625%20191.048C53.7362%20191.048%2054.2403%20191.178%2054.6746%20191.439L54.4518%20191.922C54.0333%20191.681%2053.6057%20191.561%2053.1692%20191.561C52.8654%20191.561%2052.5932%20191.614%2052.3524%20191.72C52.1139%20191.823%2051.9181%20191.968%2051.7651%20192.155C51.6143%20192.339%2051.4985%20192.558%2051.4175%20192.81C51.3387%20193.06%2051.2993%20193.334%2051.2993%20193.633C51.2993%20194.268%2051.4568%20194.77%2051.7719%20195.139C52.0891%20195.505%2052.556%20195.689%2053.1726%20195.689C53.5236%20195.689%2053.8803%20195.618%2054.2425%20195.476V194.052H53.0646L53.0848%20193.542H54.7893V195.824C54.5058%20195.959%2054.2313%20196.056%2053.9658%20196.114C53.7025%20196.17%2053.401%20196.199%2053.0612%20196.199ZM55.2416%20192.422H55.839L57.0069%20195.503L58.0464%20192.422H58.6439C57.6448%20195.171%2057.1284%20196.589%2057.0946%20196.674C56.9394%20197.064%2056.7515%20197.348%2056.531%20197.528C56.3104%20197.711%2056.0202%20197.802%2055.6601%20197.802C55.5521%20197.802%2055.4385%20197.793%2055.3192%20197.775L55.2855%20197.295C55.4115%20197.304%2055.506%20197.309%2055.569%20197.309C55.8233%20197.309%2056.0157%20197.262%2056.1462%20197.167C56.2789%20197.075%2056.3971%20196.901%2056.5006%20196.644C56.5928%20196.408%2056.6615%20196.226%2056.7065%20196.097L55.2416%20192.422ZM63.8654%20196.124V194.197C63.8654%20194.017%2063.8609%20193.866%2063.8519%20193.745C63.8451%20193.623%2063.8271%20193.499%2063.7979%20193.373C63.7708%20193.247%2063.7315%20193.148%2063.6797%20193.076C63.6302%20193.002%2063.5605%20192.943%2063.4705%20192.898C63.3804%20192.85%2063.2724%20192.827%2063.1464%20192.827C62.8989%20192.827%2062.6874%20192.893%2062.5119%20193.026C62.3386%20193.159%2062.2149%20193.345%2062.1406%20193.586C62.1204%20193.748%2062.1102%20193.921%2062.1102%20194.106V196.124H61.5466V194.136C61.5466%20193.97%2061.5409%20193.826%2061.5297%20193.704C61.5184%20193.58%2061.4971%20193.461%2061.4656%20193.346C61.4341%20193.229%2061.3913%20193.135%2061.3373%20193.063C61.2855%20192.991%2061.2158%20192.934%2061.128%20192.891C61.0403%20192.848%2060.9356%20192.827%2060.8141%20192.827C60.5441%20192.827%2060.3168%20192.895%2060.1323%20193.033C59.9501%20193.17%2059.8274%20193.352%2059.7644%20193.579C59.7442%20193.753%2059.7341%20193.94%2059.7341%20194.143V196.124H59.1704C59.1659%20193.809%2059.1636%20192.575%2059.1636%20192.422H59.6362L59.7071%20192.952C59.8196%20192.781%2059.9793%20192.637%2060.1863%20192.52C60.3934%20192.402%2060.6285%20192.344%2060.8918%20192.344C61.029%20192.344%2061.155%20192.359%2061.2698%20192.388C61.3868%20192.415%2061.4836%20192.45%2061.5601%20192.493C61.6388%20192.535%2061.7086%20192.587%2061.7693%20192.648C61.8301%20192.706%2061.8773%20192.765%2061.9111%20192.823C61.9448%20192.88%2061.973%20192.939%2061.9955%20193.002C62.2655%20192.563%2062.6784%20192.344%2063.2342%20192.344C63.646%20192.344%2063.9475%20192.462%2064.1388%20192.698C64.3323%20192.932%2064.429%20193.28%2064.429%20193.741V196.124H63.8654Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M68.6499%20191.9C68.6499%20192.397%2068.7451%20192.876%2068.9354%20193.335C69.1257%20193.795%2069.3966%20194.2%2069.7483%20194.552C70.0999%20194.903%2070.5054%20195.174%2070.9648%20195.365C71.4243%20195.555%2071.9026%20195.65%2072.3999%20195.65C72.8972%20195.65%2073.3755%20195.555%2073.835%20195.365C74.2944%20195.174%2074.6999%20194.903%2075.0516%20194.552C75.4032%20194.2%2075.6741%20193.795%2075.8644%20193.335C76.0548%20192.876%2076.1499%20192.397%2076.1499%20191.9C76.1499%20191.403%2076.0548%20190.924%2075.8644%20190.465C75.6741%20190.006%2075.4032%20189.6%2075.0516%20189.248C74.6999%20188.897%2074.2944%20188.626%2073.835%20188.435C73.3755%20188.245%2072.8972%20188.15%2072.3999%20188.15C71.9026%20188.15%2071.4243%20188.245%2070.9648%20188.435C70.5054%20188.626%2070.0999%20188.897%2069.7483%20189.248C69.3966%20189.6%2069.1257%20190.006%2068.9354%20190.465C68.7451%20190.924%2068.6499%20191.403%2068.6499%20191.9Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M78.219%20196.124H77.611V190.985H79.2669C79.5188%20190.985%2079.7467%20191.011%2079.9505%20191.064C80.1544%20191.116%2080.3353%20191.197%2080.4934%20191.304C80.6514%20191.412%2080.7739%20191.556%2080.861%20191.737C80.948%20191.918%2080.9915%20192.129%2080.9915%20192.369C80.9915%20192.569%2080.9732%20192.747%2080.9365%20192.905C80.8999%20193.061%2080.8369%20193.208%2080.7476%20193.345C80.6583%20193.482%2080.5415%20193.597%2080.3972%20193.688C80.2529%20193.778%2080.0674%20193.849%2079.8406%20193.901C79.6162%20193.952%2079.3551%20193.977%2079.0573%20193.977C78.8214%20193.977%2078.542%20193.962%2078.219%20193.932V196.124ZM79.1157%20193.451C79.3402%20193.451%2079.5326%20193.43%2079.6929%20193.386C79.8532%20193.343%2079.9757%20193.289%2080.0605%20193.225C80.1475%20193.161%2080.2151%20193.077%2080.2632%20192.974C80.3136%20192.871%2080.3445%20192.777%2080.3559%20192.692C80.3674%20192.605%2080.3731%20192.501%2080.3731%20192.38C80.3731%20192.089%2080.2746%20191.875%2080.0777%20191.737C79.883%20191.6%2079.6173%20191.531%2079.2806%20191.531H78.219V193.445C78.6611%20193.449%2078.96%20193.451%2079.1157%20193.451ZM81.9706%20194.248C81.9706%20194.695%2082.0691%20195.054%2082.2661%20195.324C82.4653%20195.592%2082.7551%20195.726%2083.1353%20195.726C83.5109%20195.726%2083.7937%20195.592%2083.9838%20195.324C84.1762%20195.056%2084.2724%20194.695%2084.2724%20194.242C84.2724%20193.781%2084.1774%20193.419%2083.9873%20193.156C83.7995%20192.89%2083.512%20192.757%2083.125%20192.757C82.7493%20192.757%2082.4631%20192.893%2082.2661%20193.163C82.0691%20193.433%2081.9706%20193.795%2081.9706%20194.248ZM84.8668%20194.238C84.8668%20194.822%2084.711%20195.296%2084.3995%20195.66C84.0881%20196.022%2083.6575%20196.203%2083.1078%20196.203C82.5787%20196.203%2082.1573%20196.02%2081.8435%20195.654C81.532%20195.287%2081.3763%20194.816%2081.3763%20194.242C81.3763%20193.655%2081.5332%20193.181%2081.847%20192.819C82.1607%20192.457%2082.5913%20192.276%2083.1387%20192.276C83.6769%20192.276%2084.0995%20192.459%2084.4064%20192.823C84.7133%20193.185%2084.8668%20193.656%2084.8668%20194.238ZM86.1001%20194.248C86.1001%20194.695%2086.1986%20195.054%2086.3956%20195.324C86.5948%20195.592%2086.8846%20195.726%2087.2648%20195.726C87.6404%20195.726%2087.9232%20195.592%2088.1133%20195.324C88.3057%20195.056%2088.4019%20194.695%2088.4019%20194.242C88.4019%20193.781%2088.3069%20193.419%2088.1168%20193.156C87.929%20192.89%2087.6415%20192.757%2087.2545%20192.757C86.8788%20192.757%2086.5925%20192.893%2086.3956%20193.163C86.1986%20193.433%2086.1001%20193.795%2086.1001%20194.248ZM88.9963%20194.238C88.9963%20194.822%2088.8405%20195.296%2088.529%20195.66C88.2175%20196.022%2087.787%20196.203%2087.2373%20196.203C86.7082%20196.203%2086.2868%20196.02%2085.973%20195.654C85.6615%20195.287%2085.5058%20194.816%2085.5058%20194.242C85.5058%20193.655%2085.6627%20193.181%2085.9764%20192.819C86.2902%20192.457%2086.7208%20192.276%2087.2682%20192.276C87.8064%20192.276%2088.229%20192.459%2088.5359%20192.823C88.8428%20193.185%2088.9963%20193.656%2088.9963%20194.238ZM90.824%20196.193C90.4575%20196.193%2090.1975%20196.094%2090.0441%20195.898C89.8929%20195.701%2089.8174%20195.358%2089.8174%20194.87V190.892L90.3876%20190.858V194.644C90.3876%20194.799%2090.3888%20194.924%2090.3911%20195.018C90.3957%20195.112%2090.4048%20195.205%2090.4186%20195.296C90.4323%20195.386%2090.4506%20195.453%2090.4735%20195.499C90.4964%20195.545%2090.5296%20195.587%2090.5732%20195.626C90.6167%20195.663%2090.6682%20195.688%2090.7278%20195.702C90.7896%20195.713%2090.8652%20195.719%2090.9545%20195.719C91.0278%20195.719%2091.1721%20195.705%2091.3874%20195.678L91.4183%20196.135C91.1824%20196.174%2090.9843%20196.193%2090.824%20196.193Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M470.25%20447.75H583.5V524.25H470.25V447.75Z'%20fill='%23262F3D'%20/%3e%3cg%20clip-path='url(%23clip26_12_1053)'%3e%3cpath%20d='M474.79%20457.669V450.346H479.124L479.074%20451.421H476.134V453.5H478.929V454.565H476.134V457.669H474.79ZM479.204%20457.669L481.898%20450.341H483.373L486.027%20457.669H484.637L483.913%20455.6H481.348L480.618%20457.669H479.204ZM481.688%20454.59H483.568C482.968%20452.667%20482.66%20451.674%20482.643%20451.611L481.688%20454.59ZM489.941%20457.774C488.871%20457.774%20488.023%20457.438%20487.397%20456.765C486.77%20456.091%20486.457%20455.162%20486.457%20453.975C486.457%20452.849%20486.784%20451.946%20487.437%20451.266C488.093%20450.583%20488.951%20450.241%20490.011%20450.241C490.868%20450.241%20491.592%20450.439%20492.186%20450.836L491.761%20451.861C491.191%20451.511%20490.618%20451.336%20490.041%20451.336C489.368%20451.336%20488.835%20451.579%20488.441%20452.066C488.052%20452.549%20487.857%20453.199%20487.857%20454.015C487.857%20454.862%20488.045%20455.517%20488.421%20455.98C488.801%20456.443%20489.341%20456.675%20490.041%20456.675C490.654%20456.675%20491.262%20456.521%20491.866%20456.215L492.046%20457.274C491.486%20457.608%20490.784%20457.774%20489.941%20457.774ZM493.29%20457.669V450.346H494.645V457.669H493.29ZM496.265%20457.669V450.346H497.619V456.59H500.683L500.643%20457.669H496.265ZM501.658%20457.669V450.346H503.013V457.669H501.658ZM506.047%20457.669V451.431H503.913V450.346H509.531V451.431H507.407V457.669H506.047ZM512.061%20457.669V454.765L509.526%20450.346H510.996L512.741%20453.515L514.495%20450.346H515.945L513.42%20454.74V457.669H512.061ZM516.24%20459.259V458.389H521.308V459.259H516.24ZM525.642%20457.774C524.573%20457.774%20523.725%20457.438%20523.098%20456.765C522.471%20456.091%20522.158%20455.162%20522.158%20453.975C522.158%20452.849%20522.485%20451.946%20523.138%20451.266C523.795%20450.583%20524.653%20450.241%20525.712%20450.241C526.569%20450.241%20527.294%20450.439%20527.887%20450.836L527.462%20451.861C526.892%20451.511%20526.319%20451.336%20525.742%20451.336C525.069%20451.336%20524.536%20451.579%20524.143%20452.066C523.753%20452.549%20523.558%20453.199%20523.558%20454.015C523.558%20454.862%20523.746%20455.517%20524.123%20455.98C524.503%20456.443%20525.043%20456.675%20525.742%20456.675C526.356%20456.675%20526.964%20456.521%20527.567%20456.215L527.747%20457.274C527.187%20457.608%20526.486%20457.774%20525.642%20457.774ZM530.626%20455.975C530.989%20456.438%20531.526%20456.67%20532.236%20456.67C532.946%20456.67%20533.48%20456.44%20533.84%20455.98C534.204%20455.517%20534.385%20454.863%20534.385%20454.02C534.385%20453.167%20534.204%20452.506%20533.84%20452.036C533.48%20451.566%20532.947%20451.331%20532.241%20451.331C531.531%20451.331%20530.993%20451.567%20530.626%20452.041C530.263%20452.511%20530.081%20453.17%20530.081%20454.02C530.081%20454.86%20530.263%20455.512%20530.626%20455.975ZM532.231%20457.774C531.128%20457.774%20530.256%20457.441%20529.616%20456.775C528.98%20456.105%20528.662%20455.182%20528.662%20454.005C528.662%20452.822%20528.982%20451.899%20529.621%20451.236C530.261%20450.573%20531.133%20450.241%20532.236%20450.241C533.339%20450.241%20534.209%20450.574%20534.845%20451.241C535.482%20451.904%20535.8%20452.827%20535.8%20454.01C535.8%20455.18%20535.48%20456.1%20534.84%20456.77C534.2%20457.439%20533.331%20457.774%20532.231%20457.774ZM538.444%20456.585H539.414C540.25%20456.585%20540.887%20456.366%20541.324%20455.93C541.76%20455.49%20541.978%20454.85%20541.978%20454.01C541.978%20453.11%20541.753%20452.457%20541.304%20452.051C540.854%20451.641%20540.176%20451.436%20539.269%20451.436H538.444V456.585ZM537.09%20457.669V450.346H539.209C539.849%20450.346%20540.422%20450.419%20540.929%20450.566C541.435%20450.713%20541.87%20450.934%20542.233%20451.231C542.6%20451.524%20542.88%20451.904%20543.073%20452.371C543.27%20452.834%20543.368%20453.37%20543.368%20453.98C543.368%20455.163%20543.011%20456.075%20542.298%20456.715C541.585%20457.351%20540.597%20457.669%20539.334%20457.669H537.09ZM544.653%20457.669V450.346H549.092L549.037%20451.421H546.007V453.31H548.887V454.385H546.007V456.59H549.147L549.102%20457.669H544.653Z'%20fill='white'%20/%3e%3c/g%3e%3cpath%20d='M474%20465H579.75V480.75H474V465Z'%20fill='white'%20/%3e%3cpath%20d='M474%20480H579.75V480.75H474V480Z'%20fill='%23C8C8C8'%20/%3e%3cg%20clip-path='url(%23clip27_12_1053)'%3e%3cpath%20d='M498%20468.75H579.75V477H498V468.75Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip28_12_1053)'%3e%3cpath%20d='M499.305%20477.374H498.669V471.937H499.305V477.374ZM503.011%20472.403C502.602%20472.403%20502.249%20472.503%20501.952%20472.701C501.658%20472.9%20501.439%20473.167%20501.294%20473.503C501.15%20473.839%20501.077%20474.225%20501.077%20474.661C501.077%20474.987%20501.117%20475.285%20501.195%20475.554C501.273%20475.822%20501.391%20476.057%20501.548%20476.26C501.705%20476.461%20501.908%20476.618%20502.158%20476.731C502.411%20476.841%20502.7%20476.896%20503.026%20476.896C503.445%20476.896%20503.879%20476.787%20504.327%20476.569L504.434%20477.11C504.069%20477.34%20503.575%20477.455%20502.952%20477.455C502.543%20477.455%20502.175%20477.388%20501.849%20477.253C501.526%20477.116%20501.257%20476.923%20501.044%20476.676C500.833%20476.426%20500.673%20476.129%20500.563%20475.786C500.452%20475.44%20500.397%20475.057%20500.397%20474.635C500.397%20474.228%20500.457%20473.853%20500.577%20473.51C500.697%20473.167%20500.867%20472.873%20501.085%20472.628C501.305%20472.38%20501.58%20472.188%20501.908%20472.051C502.237%20471.913%20502.602%20471.845%20503.004%20471.845C503.614%20471.845%20504.129%20471.979%20504.548%20472.249L504.298%20472.767C503.896%20472.525%20503.467%20472.403%20503.011%20472.403ZM505.368%20477.374V471.937H508.486L508.46%20472.499H506.004V474.279H508.339V474.834H506.004V476.812H508.541L508.511%20477.374H505.368ZM513.059%20476.01H512.434V477.374H511.817V476.01H509.331V475.448L511.747%20471.874H512.434V475.477H513.111L513.059%20476.01ZM511.817%20472.709L509.978%20475.477H511.817V472.709ZM516.53%20477.246C516.287%20477.388%20516.003%20477.459%20515.677%20477.459C515.351%20477.459%20515.066%20477.388%20514.82%20477.246C514.575%20477.101%20514.378%20476.899%20514.229%20476.639C514.081%20476.379%20513.971%20476.08%20513.898%20475.742C513.827%20475.404%20513.791%20475.027%20513.791%20474.613C513.791%20474.272%20513.814%20473.957%20513.861%20473.668C513.91%20473.379%20513.985%20473.117%20514.085%20472.881C514.186%20472.646%20514.309%20472.446%20514.456%20472.282C514.606%20472.118%20514.784%20471.992%20514.99%20471.903C515.195%20471.813%20515.425%20471.767%20515.677%20471.767C515.991%20471.767%20516.268%20471.836%20516.508%20471.973C516.751%20472.111%20516.947%20472.307%20517.096%20472.562C517.248%20472.814%20517.362%20473.113%20517.438%20473.459C517.514%20473.802%20517.552%20474.187%20517.552%20474.613C517.552%20475.027%20517.517%20475.404%20517.446%20475.742C517.374%20476.08%20517.265%20476.379%20517.118%20476.639C516.971%20476.899%20516.775%20477.101%20516.53%20477.246ZM516.321%20472.624C516.142%20472.426%20515.927%20472.326%20515.677%20472.326C515.427%20472.326%20515.213%20472.426%20515.034%20472.624C514.855%20472.82%20514.72%20473.087%20514.629%20473.426C514.541%20473.761%20514.497%20474.15%20514.497%20474.591C514.497%20475.04%20514.541%20475.437%20514.629%20475.782C514.72%20476.125%20514.855%20476.398%20515.034%20476.599C515.213%20476.799%20515.427%20476.9%20515.677%20476.9C515.927%20476.9%20516.142%20476.799%20516.321%20476.599C516.499%20476.398%20516.633%20476.125%20516.721%20475.782C516.812%20475.437%20516.857%20475.04%20516.857%20474.591C516.857%20474.15%20516.812%20473.761%20516.721%20473.426C516.633%20473.087%20516.499%20472.82%20516.321%20472.624ZM519.067%20471.874H519.652V477.374H519.001V472.554C518.753%20472.716%20518.451%20472.854%20518.093%20472.97V472.356C518.132%20472.339%20518.212%20472.304%20518.332%20472.253C518.452%20472.201%20518.541%20472.162%20518.6%20472.135C518.661%20472.108%20518.737%20472.07%20518.828%20472.021C518.919%20471.972%20518.998%20471.923%20519.067%20471.874Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip29_12_1053)'%3e%3cpath%20d='M474%20480.75H579.75V519.75H474V480.75Z'%20fill='%233C4859'%20/%3e%3cpath%20d='M474%20480.75H579.75V519.75H474V480.75Z'%20stroke='%234F73B8'%20stroke-width='1.5'%20/%3e%3c/g%3e%3cpath%20d='M484.467%20502.288V495.922H485.645V502.288H484.467ZM489.83%20502.379C488.9%20502.379%20488.162%20502.087%20487.618%20501.501C487.073%20500.916%20486.801%20500.108%20486.801%20499.076C486.801%20498.097%20487.085%20497.312%20487.652%20496.721C488.223%20496.127%20488.969%20495.83%20489.89%20495.83C490.635%20495.83%20491.265%20496.003%20491.781%20496.347L491.411%20497.238C490.916%20496.934%20490.418%20496.782%20489.917%20496.782C489.331%20496.782%20488.868%20496.993%20488.526%20497.416C488.187%20497.837%20488.017%20498.401%20488.017%20499.111C488.017%20499.847%20488.181%20500.416%20488.509%20500.819C488.839%20501.222%20489.308%20501.423%20489.917%20501.423C490.45%20501.423%20490.978%20501.29%20491.503%20501.023L491.659%20501.945C491.172%20502.234%20490.563%20502.379%20489.83%20502.379ZM492.711%20502.288V495.922H496.57L496.522%20496.856H493.889V498.499H496.392V499.433H493.889V501.349H496.618L496.579%20502.288H492.711ZM500.303%20502.288V500.876H497.43V500.102L500.007%20495.952H501.454V500.015H502.237L502.18%20500.876H501.454V502.288H500.303ZM498.56%20500.02H500.303V497.064L498.56%20500.02ZM504.705%20501.275C504.87%20501.409%20505.069%20501.475%20505.3%20501.475C505.532%20501.475%20505.729%20501.409%20505.891%20501.275C506.056%20501.142%20506.181%20500.958%20506.265%20500.724C506.352%20500.486%20506.414%20500.234%20506.452%20499.967C506.49%20499.698%20506.508%20499.4%20506.508%20499.072C506.508%20497.502%20506.106%20496.717%20505.3%20496.717C504.501%20496.717%20504.095%20497.496%20504.084%20499.055C504.084%20499.385%20504.102%20499.685%20504.14%20499.954C504.178%20500.224%20504.24%20500.479%20504.327%20500.719C504.414%20500.957%20504.54%20501.142%20504.705%20501.275ZM506.226%20502.205C505.954%20502.321%20505.645%20502.379%20505.3%20502.379C504.956%20502.379%20504.646%20502.321%20504.37%20502.205C504.095%20502.087%20503.868%20501.927%20503.688%20501.727C503.508%20501.525%20503.358%20501.283%20503.236%20501.002C503.117%20500.721%20503.032%20500.424%20502.98%20500.111C502.93%20499.798%20502.906%20499.463%20502.906%20499.107C502.906%20498.745%20502.932%20498.406%20502.984%20498.09C503.036%20497.771%20503.123%20497.471%20503.245%20497.19C503.367%20496.907%20503.517%20496.665%20503.697%20496.465C503.879%20496.265%20504.107%20496.107%20504.379%20495.991C504.651%20495.872%20504.958%20495.813%20505.3%20495.813C505.642%20495.813%20505.949%20495.872%20506.222%20495.991C506.494%20496.107%20506.72%20496.266%20506.9%20496.469C507.079%20496.669%20507.228%20496.911%20507.347%20497.195C507.469%20497.476%20507.556%20497.774%20507.608%20498.09C507.66%20498.406%20507.686%20498.745%20507.686%20499.107C507.686%20499.463%20507.66%20499.798%20507.608%20500.111C507.559%20500.424%20507.475%20500.722%20507.356%20501.006C507.237%20501.287%20507.088%20501.527%20506.908%20501.727C506.729%20501.927%20506.501%20502.087%20506.226%20502.205ZM509.429%20502.284V496.986C509.388%20497.012%20509.2%20497.096%20508.864%20497.238C508.531%20497.377%20508.342%20497.453%20508.299%20497.464V496.595C508.368%20496.563%20508.589%20496.455%20508.959%20496.269C509.33%20496.081%20509.535%20495.974%20509.572%20495.948H510.528V502.284H509.429Z'%20fill='white'%20/%3e%3cg%20filter='url(%23filter2_f_12_1053)'%3e%3cpath%20d='M697.068%20489.462L697.055%20488.159C695.901%20488.145%20694.856%20487.869%20693.919%20487.331L694.367%20485.871C695.263%20486.365%20696.164%20486.625%20697.068%20486.652V483.706C696.525%20483.548%20696.159%20483.43%20695.969%20483.353C694.634%20482.883%20693.967%20482.005%20693.967%20480.72C693.967%20479.883%20694.247%20479.222%20694.808%20478.738C695.369%20478.254%20696.123%20477.98%20697.068%20477.917V476.872H697.734V477.903C698.82%20477.935%20699.767%20478.182%20700.577%20478.643L700.021%20479.987C699.206%20479.621%20698.444%20479.424%20697.734%20479.397V482.064C697.77%20482.077%20697.824%20482.096%20697.896%20482.118C697.969%20482.141%20698.048%20482.166%20698.134%20482.193C698.225%20482.22%20698.286%20482.238%20698.317%20482.247C699.227%20482.546%20699.876%20482.917%20700.265%20483.36C700.659%20483.804%20700.856%20484.421%20700.856%20485.213C700.856%20486.068%20700.577%20486.747%20700.021%20487.249C699.464%20487.751%20698.702%20488.046%20697.734%20488.132V489.462H697.068ZM697.068%20481.84V479.424C696.684%20479.473%20696.392%20479.596%20696.193%20479.79C695.994%20479.985%20695.885%20480.268%20695.867%20480.639C695.867%20481.191%20696.141%20481.55%20696.688%20481.718C696.752%20481.74%20696.878%20481.781%20697.068%20481.84ZM697.734%20486.611C698.571%20486.475%20698.989%20486.005%20698.989%20485.2C698.989%20484.62%20698.639%20484.213%20697.937%20483.978C697.924%20483.969%20697.887%20483.957%20697.829%20483.944C697.774%20483.926%20697.743%20483.914%20697.734%20483.91V486.611ZM703.034%20488.023L706.048%20484.1C705.745%20484.204%20705.475%20484.256%20705.24%20484.256C704.267%20484.256%20703.473%20483.964%20702.858%20483.381C702.247%20482.792%20701.942%20482.032%20701.942%20481.1C701.942%20480.132%20702.276%20479.358%20702.946%20478.779C703.62%20478.2%20704.494%20477.91%20705.566%20477.91C706.674%20477.91%20707.573%20478.209%20708.26%20478.806C708.948%20479.399%20709.292%20480.188%20709.292%20481.175C709.292%20481.745%20709.183%20482.263%20708.966%20482.729C708.749%20483.195%20708.43%20483.715%20708.009%20484.29L705.199%20488.023H703.034ZM705.62%20483.007C706.249%20483.007%20706.713%20482.833%20707.012%20482.485C707.315%20482.136%20707.466%20481.666%20707.466%20481.073C707.466%20480.516%20707.31%20480.075%20706.998%20479.749C706.686%20479.424%20706.238%20479.261%20705.654%20479.261C705.052%20479.261%20704.58%20479.43%20704.236%20479.77C703.896%20480.109%20703.727%20480.555%20703.727%20481.107C703.727%20481.695%20703.885%20482.159%20704.202%20482.498C704.523%20482.838%20704.996%20483.007%20705.62%20483.007ZM711.301%20488.145C711.007%20488.145%20710.758%20488.043%20710.554%20487.84C710.351%20487.636%20710.249%20487.394%20710.249%20487.113C710.249%20486.828%20710.349%20486.582%20710.548%20486.374C710.751%20486.166%20711.002%20486.061%20711.301%20486.061C711.591%20486.061%20711.835%20486.166%20712.034%20486.374C712.233%20486.582%20712.333%20486.828%20712.333%20487.113C712.333%20487.394%20712.233%20487.636%20712.034%20487.84C711.835%20488.043%20711.591%20488.145%20711.301%20488.145ZM714.505%20488.023L717.518%20484.1C717.215%20484.204%20716.946%20484.256%20716.71%20484.256C715.738%20484.256%20714.943%20483.964%20714.328%20483.381C713.717%20482.792%20713.412%20482.032%20713.412%20481.1C713.412%20480.132%20713.747%20479.358%20714.416%20478.779C715.09%20478.2%20715.964%20477.91%20717.036%20477.91C718.145%20477.91%20719.043%20478.209%20719.731%20478.806C720.418%20479.399%20720.762%20480.188%20720.762%20481.175C720.762%20481.745%20720.654%20482.263%20720.436%20482.729C720.219%20483.195%20719.9%20483.715%20719.479%20484.29L716.67%20488.023H714.505ZM717.09%20483.007C717.719%20483.007%20718.183%20482.833%20718.482%20482.485C718.785%20482.136%20718.937%20481.666%20718.937%20481.073C718.937%20480.516%20718.78%20480.075%20718.468%20479.749C718.156%20479.424%20717.708%20479.261%20717.124%20479.261C716.523%20479.261%20716.05%20479.43%20715.706%20479.77C715.367%20480.109%20715.197%20480.555%20715.197%20481.107C715.197%20481.695%20715.355%20482.159%20715.672%20482.498C715.993%20482.838%20716.466%20483.007%20717.09%20483.007Z'%20fill='%23AB0FD7'%20/%3e%3c/g%3e%3cpath%20d='M690.763%20511.874V506.882H693.625L693.602%20507.399H691.347V509.032H693.49V509.542H691.347V511.358H693.676L693.649%20511.874H690.763ZM697.048%20509.802C696.573%20508.423%20696.311%20507.647%20696.261%20507.476C696.261%20507.476%20695.988%20508.252%20695.441%20509.802H697.048ZM697.821%20511.874L697.237%20510.291H695.245L694.641%20511.874H694.047L695.964%20506.872H696.562L698.422%20511.874H697.821ZM699.525%20507.348V509.036C699.617%20509.036%20699.808%20509.038%20700.096%20509.042C700.386%20509.047%20700.61%20509.049%20700.767%20509.049C701.197%20509.049%20701.496%20508.978%20701.665%20508.837C701.834%20508.693%20701.918%20508.465%20701.918%20508.155C701.918%20507.882%20701.837%20507.68%20701.675%20507.547C701.513%20507.414%20701.242%20507.348%20700.862%20507.348H699.525ZM702.725%20511.874H702.05L701.361%20510.308C701.175%20509.887%20701.055%20509.634%20701.004%20509.549C700.839%20509.56%20700.645%20509.566%20700.42%20509.566L699.525%20509.539V511.874H698.928V506.825H700.524C700.709%20506.825%20700.872%20506.829%20701.014%20506.838C701.155%20506.847%20701.296%20506.864%20701.436%20506.889C701.577%20506.912%20701.7%20506.944%20701.803%20506.987C701.907%20507.027%20702.004%20507.081%20702.094%20507.149C702.184%20507.214%20702.256%20507.293%20702.31%20507.385C702.366%20507.477%20702.41%20507.588%20702.441%20507.716C702.473%20507.842%20702.489%20507.985%20702.489%20508.145C702.489%20508.46%20702.405%20508.731%20702.239%20508.958C702.075%20509.185%20701.841%20509.343%20701.537%20509.431C701.537%20509.435%20701.559%20509.476%20701.604%20509.552C701.649%20509.629%20701.702%20509.723%20701.763%20509.836C701.826%20509.946%20701.874%20510.038%20701.908%20510.112L702.725%20511.874ZM707.484%20511.874H706.822L704.23%20507.945L704.062%20507.713C704.08%20508.185%20704.089%20508.607%20704.089%20508.978V511.874H703.542V506.882H704.193L706.792%20510.811L706.964%20511.044C706.948%20510.326%20706.941%20509.911%20706.941%20509.798V506.882H707.484V511.874ZM709.27%20511.874H708.686V506.882H709.27V511.874ZM714.424%20511.874H713.762L711.17%20507.945L711.001%20507.713C711.019%20508.185%20711.028%20508.607%20711.028%20508.978V511.874H710.481V506.882H711.133L713.732%20510.811L713.904%20511.044C713.888%20510.326%20713.88%20509.911%20713.88%20509.798V506.882H714.424V511.874ZM717.775%20511.949C717.395%20511.949%20717.053%20511.886%20716.749%20511.76C716.448%20511.631%20716.198%20511.453%20716%20511.226C715.804%20510.997%20715.653%20510.726%20715.547%20510.413C715.444%20510.1%20715.392%20509.757%20715.392%20509.383C715.392%20508.879%20715.488%20508.434%20715.679%20508.047C715.87%20507.66%20716.155%20507.355%20716.533%20507.132C716.911%20506.909%20717.359%20506.798%20717.876%20506.798C718.45%20506.798%20718.954%20506.928%20719.389%20507.189L719.166%20507.672C718.747%20507.431%20718.32%20507.311%20717.883%20507.311C717.579%20507.311%20717.307%20507.364%20717.066%20507.47C716.828%20507.573%20716.632%20507.718%20716.479%20507.905C716.328%20508.089%20716.212%20508.308%20716.131%20508.56C716.053%20508.81%20716.013%20509.084%20716.013%20509.383C716.013%20510.018%20716.171%20510.52%20716.486%20510.889C716.803%20511.255%20717.27%20511.439%20717.887%20511.439C718.238%20511.439%20718.594%20511.368%20718.956%20511.226V509.802H717.779L717.799%20509.292H719.503V511.574C719.22%20511.709%20718.945%20511.806%20718.68%20511.864C718.416%20511.92%20718.115%20511.949%20717.775%20511.949ZM720.438%20511.051C720.958%20511.307%20721.515%20511.435%20722.109%20511.435C722.84%20511.435%20723.206%20511.102%20723.206%20510.436C723.206%20510.22%20723.147%20510.046%20723.03%20509.913C722.916%20509.778%20722.705%20509.672%20722.399%20509.596L721.407%20509.346C720.649%20509.155%20720.269%20508.75%20720.269%20508.131C720.269%20507.656%20720.433%20507.304%20720.759%20507.075C721.085%20506.843%20721.536%20506.727%20722.112%20506.727C722.414%20506.727%20722.696%20506.76%20722.96%20506.825C723.223%20506.89%20723.443%20506.978%20723.621%20507.088L723.452%20507.564C723.302%20507.481%20723.101%20507.407%20722.852%20507.341C722.604%20507.276%20722.353%20507.243%20722.099%20507.243C721.284%20507.243%20720.877%20507.526%20720.877%20508.091C720.877%20508.282%20720.939%20508.436%20721.063%20508.553C721.189%20508.668%20721.377%20508.756%20721.626%20508.816L722.575%20509.046C722.98%20509.143%20723.287%20509.298%20723.496%20509.512C723.705%20509.723%20723.81%20510.025%20723.81%20510.416C723.81%20510.925%20723.654%20511.308%20723.341%20511.567C723.03%20511.824%20722.607%20511.952%20722.072%20511.952C721.671%20511.952%20721.315%20511.911%20721.002%20511.83C720.691%20511.747%20720.445%20511.649%20720.263%20511.537L720.438%20511.051Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M684.172%20520.124H683.532V514.714H685.275C685.54%20514.714%20685.78%20514.742%20685.995%20514.797C686.209%20514.853%20686.4%20514.937%20686.566%20515.051C686.732%20515.164%20686.861%20515.316%20686.953%20515.506C687.045%20515.697%20687.09%20515.918%20687.09%20516.172C687.09%20516.381%20687.071%20516.569%20687.033%20516.736C686.994%20516.9%20686.928%20517.054%20686.834%20517.199C686.74%20517.343%20686.617%20517.464%20686.465%20517.56C686.313%20517.654%20686.118%20517.729%20685.879%20517.785C685.643%20517.838%20685.368%20517.864%20685.054%20517.864C684.806%20517.864%20684.512%20517.848%20684.172%20517.817V520.124ZM685.116%20517.311C685.352%20517.311%20685.555%20517.288%20685.723%20517.242C685.892%20517.196%20686.021%20517.14%20686.11%20517.072C686.202%20517.005%20686.273%20516.917%20686.324%20516.808C686.377%20516.7%20686.409%20516.601%20686.421%20516.512C686.433%20516.42%20686.439%20516.31%20686.439%20516.182C686.439%20515.876%20686.336%20515.651%20686.128%20515.506C685.923%20515.362%20685.644%20515.289%20685.289%20515.289H684.172V517.304C684.637%20517.308%20684.952%20517.311%20685.116%20517.311ZM687.828%20520.124V514.776H690.895L690.869%20515.329H688.454V517.079H690.75V517.625H688.454V519.571H690.949L690.92%20520.124H687.828ZM692.508%20515.275V517.083C692.606%20517.083%20692.81%20517.085%20693.119%20517.09C693.43%20517.095%20693.67%20517.097%20693.838%20517.097C694.299%20517.097%20694.62%20517.021%20694.8%20516.87C694.981%20516.715%20695.072%20516.472%20695.072%20516.139C695.072%20515.847%20694.985%20515.63%20694.811%20515.488C694.638%20515.346%20694.347%20515.275%20693.94%20515.275H692.508ZM695.936%20520.124H695.213L694.475%20518.446C694.275%20517.995%20694.147%20517.724%20694.092%20517.633C693.916%20517.645%20693.707%20517.651%20693.466%20517.651L692.508%20517.622V520.124H691.868V514.714H693.578C693.776%20514.714%20693.951%20514.719%20694.102%20514.729C694.254%20514.738%20694.405%20514.756%20694.554%20514.783C694.706%20514.807%20694.838%20514.842%20694.949%20514.888C695.06%20514.931%20695.163%20514.989%20695.26%20515.061C695.356%20515.131%20695.433%20515.216%20695.491%20515.315C695.551%20515.413%20695.598%20515.532%20695.632%20515.669C695.666%20515.804%20695.683%20515.957%20695.683%20516.128C695.683%20516.466%20695.594%20516.756%20695.415%20517C695.239%20517.243%20694.988%20517.412%20694.663%20517.506C694.663%20517.511%20694.687%20517.554%20694.735%20517.636C694.784%20517.718%20694.84%20517.819%20694.905%20517.94C694.973%20518.058%20695.025%20518.157%20695.061%20518.237L695.936%20520.124ZM701.01%20515.235C700.607%20515.235%20700.26%20515.333%20699.968%20515.528C699.679%20515.723%20699.463%20515.986%20699.321%20516.316C699.179%20516.647%20699.107%20517.026%20699.107%20517.455C699.107%20517.776%20699.146%20518.069%20699.223%20518.334C699.3%20518.597%20699.416%20518.828%20699.57%20519.029C699.725%20519.226%20699.925%20519.381%20700.171%20519.491C700.419%20519.6%20700.703%20519.654%20701.024%20519.654C701.436%20519.654%20701.863%20519.547%20702.304%20519.332L702.409%20519.864C702.05%20520.091%20701.564%20520.204%20700.952%20520.204C700.549%20520.204%20700.188%20520.138%20699.867%20520.005C699.549%20519.87%20699.285%20519.681%20699.075%20519.437C698.868%20519.191%20698.71%20518.9%20698.601%20518.562C698.493%20518.222%20698.438%20517.845%20698.438%20517.43C698.438%20517.03%20698.497%20516.661%20698.616%20516.324C698.734%20515.986%20698.9%20515.697%20699.115%20515.456C699.332%20515.212%20699.602%20515.023%20699.925%20514.888C700.248%20514.753%20700.607%20514.685%20701.002%20514.685C701.603%20514.685%20702.109%20514.818%20702.521%20515.083L702.275%20515.593C701.88%20515.354%20701.458%20515.235%20701.01%20515.235ZM707.45%20520.124H706.825V517.622H703.953V520.124H703.328V514.776H703.953V517.072H706.825V514.776H707.45V520.124ZM708.709%20520.124V514.776H711.775L711.75%20515.329H709.334V517.079H711.631V517.625H709.334V519.571H711.83L711.801%20520.124H708.709ZM715.193%20515.235C714.79%20515.235%20714.443%20515.333%20714.151%20515.528C713.862%20515.723%20713.646%20515.986%20713.504%20516.316C713.362%20516.647%20713.291%20517.026%20713.291%20517.455C713.291%20517.776%20713.329%20518.069%20713.406%20518.334C713.484%20518.597%20713.599%20518.828%20713.754%20519.029C713.908%20519.226%20714.108%20519.381%20714.354%20519.491C714.602%20519.6%20714.887%20519.654%20715.207%20519.654C715.62%20519.654%20716.046%20519.547%20716.488%20519.332L716.592%20519.864C716.233%20520.091%20715.747%20520.204%20715.135%20520.204C714.732%20520.204%20714.371%20520.138%20714.05%20520.005C713.732%20519.87%20713.468%20519.681%20713.258%20519.437C713.051%20519.191%20712.893%20518.9%20712.784%20518.562C712.676%20518.222%20712.622%20517.845%20712.622%20517.43C712.622%20517.03%20712.681%20516.661%20712.799%20516.324C712.917%20515.986%20713.083%20515.697%20713.298%20515.456C713.515%20515.212%20713.785%20515.023%20714.108%20514.888C714.431%20514.753%20714.79%20514.685%20715.186%20514.685C715.786%20514.685%20716.292%20514.818%20716.705%20515.083L716.459%20515.593C716.063%20515.354%20715.641%20515.235%20715.193%20515.235ZM721.438%20520.124H720.672L718.625%20517.571L718.137%20518.001V520.124H717.507V514.776H718.137V517.401L720.487%20514.776H721.272L719.102%20517.184L721.438%20520.124ZM721.684%20518.327V517.795H723.492V518.327H721.684ZM725.087%20520.124H724.462V514.776H725.087V520.124ZM730.609%20520.124H729.901L727.123%20515.915L726.942%20515.665C726.962%20516.172%20726.971%20516.624%20726.971%20517.021V520.124H726.385V514.776H727.083L729.868%20518.985L730.052%20519.235C730.036%20518.466%20730.027%20518.021%20730.027%20517.9V514.776H730.609V520.124Z'%20fill='%23B5B7BA'%20/%3e%3cmask%20id='mask7_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='23'%20y='357'%20width='642'%20height='198'%3e%3cg%20clip-path='url(%23clip30_12_1053)'%3e%3cpath%20d='M23.2002%20357H660.7C661.8%20357%20662.7%20357.4%20663.4%20358.1C664.1%20358.8%20664.5%20359.7%20664.5%20360.7V551.2C664.5%20552.3%20664.1%20553.2%20663.4%20553.9C662.7%20554.6%20661.8%20555%20660.7%20555H27.0002C26.0002%20555%2025.1002%20554.6%2024.3002%20553.9C23.6002%20553.2%2023.2002%20552.3%2023.2002%20551.2V360.7C23.2002%20359.7%2023.6002%20358.8%2024.3002%20358.1C25.1002%20357.4%2026.0002%20357%2027.0002%20357'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask7_12_1053)'%3e%3cpath%20d='M23.25%20357H660.75C661.247%20357%20661.726%20357.095%20662.185%20357.285C662.644%20357.476%20663.05%20357.747%20663.402%20358.098C663.753%20358.45%20664.024%20358.856%20664.214%20359.315C664.405%20359.774%20664.5%20360.253%20664.5%20360.75V551.25C664.5%20551.747%20664.405%20552.226%20664.214%20552.685C664.024%20553.144%20663.753%20553.55%20663.402%20553.902C663.05%20554.253%20662.644%20554.524%20662.185%20554.715C661.726%20554.905%20661.247%20555%20660.75%20555H27C26.5027%20555%2026.0244%20554.905%2025.5649%20554.715C25.1055%20554.524%2024.7%20554.253%2024.3483%20553.902C23.9967%20553.55%2023.7258%20553.144%2023.5355%20552.685C23.3452%20552.226%2023.25%20551.747%2023.25%20551.25V360.75C23.25%20360.253%2023.3452%20359.774%2023.5355%20359.315C23.7258%20358.856%2023.9967%20358.45%2024.3483%20358.098C24.7%20357.747%2025.1055%20357.476%2025.5649%20357.285C26.0244%20357.095%2026.5027%20357%2027%20357'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip31_12_1053)'%3e%3cpath%20d='M42.0523%20373.669V366.23H46.5617L46.5059%20367.322H43.4285V369.241H46.3535V370.333H43.4285V372.573H46.6176L46.5719%20373.669H42.0523ZM47.0848%20373.669L49.8219%20366.225H51.3199L54.0164%20373.669H52.6047L51.8684%20371.567H49.2633L48.5219%20373.669H47.0848ZM49.6086%20370.541H51.518C50.9086%20368.588%2050.5954%20367.579%2050.5785%20367.515L49.6086%20370.541ZM54.7223%20373.669V366.21H57.4797C57.8555%20366.21%2058.1805%20366.227%2058.4547%20366.26C58.7323%20366.294%2058.9947%20366.357%2059.2418%20366.448C59.4923%20366.536%2059.6937%20366.657%2059.8461%20366.809C60.0018%20366.961%2060.1237%20367.161%2060.2117%20367.408C60.3031%20367.652%2060.3488%20367.941%2060.3488%20368.276C60.3488%20369.265%2059.9003%20369.915%2059.0031%20370.226C59.1859%20370.433%2059.4128%20370.816%2059.6836%20371.374L60.7906%20373.669H59.2875L58.4191%20371.725C58.0908%20371.027%2057.8876%20370.614%2057.8098%20370.485C57.7522%20370.482%2057.5609%20370.48%2057.2359%20370.48L56.0832%20370.47V373.669H54.7223ZM57.6016%20369.485C58.1297%20369.485%2058.5089%20369.392%2058.7391%20369.206C58.9693%20369.016%2059.0844%20368.713%2059.0844%20368.297C59.0844%20367.931%2058.9676%20367.662%2058.734%20367.489C58.5004%20367.317%2058.1432%20367.23%2057.6625%20367.23H56.0832V369.48C56.134%20369.48%2056.3862%20369.482%2056.8398%20369.485C57.2935%20369.485%2057.5474%20369.485%2057.6016%20369.485ZM61.7758%20373.669V366.23H63.2383C63.5023%20366.643%2064.0389%20367.476%2064.848%20368.728C65.6572%20369.981%2066.1497%20370.743%2066.3258%20371.014C66.3766%20371.091%2066.4629%20371.223%2066.5848%20371.41C66.71%20371.592%2066.798%20371.723%2066.8488%20371.801C66.8251%20370.639%2066.8133%20370.037%2066.8133%20369.993V366.23H68.0676V373.669H66.5848L63.2281%20368.439L62.9844%20368.038C63.0115%20368.932%2063.025%20369.56%2063.025%20369.922V373.669H61.7758ZM69.7027%20373.669V366.23H71.0789V373.669H69.7027ZM72.7242%20373.669V366.23H74.1867C74.4508%20366.643%2074.9874%20367.476%2075.7965%20368.728C76.6056%20369.981%2077.0982%20370.743%2077.2742%20371.014C77.325%20371.091%2077.4113%20371.223%2077.5332%20371.41C77.6585%20371.592%2077.7465%20371.723%2077.7973%20371.801C77.7736%20370.639%2077.7617%20370.037%2077.7617%20369.993V366.23H79.016V373.669H77.5332L74.1766%20368.439L73.9328%20368.038C73.9599%20368.932%2073.9734%20369.56%2073.9734%20369.922V373.669H72.7242ZM83.9367%20373.776C82.8026%20373.776%2081.9156%20373.434%2081.2758%20372.75C80.6393%20372.066%2080.3211%20371.13%2080.3211%20369.942C80.3211%20369.187%2080.47%20368.524%2080.768%20367.951C81.0659%20367.376%2081.5043%20366.927%2082.0832%20366.606C82.6621%20366.284%2083.346%20366.123%2084.1348%20366.123C85.0387%20366.123%2085.8139%20366.318%2086.4605%20366.707L86.0137%20367.733C85.3975%20367.401%2084.7797%20367.235%2084.1602%20367.235C83.4086%20367.235%2082.8178%20367.479%2082.3879%20367.967C81.9579%20368.454%2081.743%20369.118%2081.743%20369.957C81.743%20370.79%2081.9342%20371.449%2082.3168%20371.933C82.6993%20372.417%2083.2596%20372.659%2083.9977%20372.659C84.4716%20372.659%2084.9016%20372.584%2085.2875%20372.435V370.709H83.7285L83.7387%20369.627H86.5824V373.217C86.122%20373.407%2085.6853%20373.548%2085.2723%20373.639C84.8626%20373.73%2084.4174%20373.776%2083.9367%20373.776ZM90.1473%20373.771C89.2501%20373.771%2088.4461%20373.564%2087.7352%20373.151L88.0703%20372.06C88.3885%20372.236%2088.7339%20372.378%2089.1062%20372.486C89.482%20372.595%2089.8477%20372.649%2090.2031%20372.649C90.6398%20372.649%2090.9699%20372.556%2091.1934%20372.369C91.4168%20372.18%2091.5285%20371.909%2091.5285%20371.557C91.5285%20371.09%2091.2171%20370.766%2090.5941%20370.587C90.5501%20370.573%2090.4266%20370.538%2090.2234%20370.48C90.0203%20370.419%2089.829%20370.362%2089.6496%20370.308C89.4736%20370.25%2089.3466%20370.206%2089.2687%20370.176C88.2701%20369.824%2087.7707%20369.167%2087.7707%20368.205C87.7707%20367.532%2088.0094%20367.012%2088.4867%20366.646C88.9674%20366.281%2089.6039%20366.098%2090.3961%20366.098C91.2932%20366.098%2092.0668%20366.282%2092.7168%20366.651L92.3004%20367.657C91.6368%20367.359%2091.0207%20367.21%2090.452%20367.21C90.0423%20367.21%2089.7326%20367.283%2089.5227%20367.428C89.3161%20367.571%2089.2061%20367.809%2089.1926%20368.144C89.1926%20368.557%2089.3974%20368.827%2089.807%20368.952C89.8883%20368.982%2090.088%20369.048%2090.4062%20369.15C90.7245%20369.251%2090.931%20369.317%2091.0258%20369.348C91.7062%20369.571%2092.1921%20369.849%2092.4832%20370.181C92.7777%20370.513%2092.925%20370.975%2092.925%20371.567C92.925%20372.275%2092.6745%20372.82%2092.1734%20373.202C91.6724%20373.581%2090.997%20373.771%2090.1473%20373.771Z'%20fill='white'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip32_12_1053)'%3e%3cpath%20d='M70.125%20524.575C70.125%20524.679%2070.0884%20524.767%2070.0152%20524.84C69.9419%20524.913%2069.8536%20524.95%2069.75%20524.95C69.6464%20524.95%2069.5581%20524.913%2069.4848%20524.84C69.4116%20524.767%2069.375%20524.679%2069.375%20524.575C69.375%20524.471%2069.4116%20524.383%2069.4848%20524.31C69.5581%20524.237%2069.6464%20524.2%2069.75%20524.2C69.8536%20524.2%2069.9419%20524.237%2070.0152%20524.31C70.0884%20524.383%2070.125%20524.471%2070.125%20524.575ZM73.875%20524.575C73.875%20524.679%2073.8384%20524.767%2073.7652%20524.84C73.6919%20524.913%2073.6036%20524.95%2073.5%20524.95C73.3964%20524.95%2073.3081%20524.913%2073.2348%20524.84C73.1616%20524.767%2073.125%20524.679%2073.125%20524.575C73.125%20524.471%2073.1616%20524.383%2073.2348%20524.31C73.3081%20524.237%2073.3964%20524.2%2073.5%20524.2C73.6036%20524.2%2073.6919%20524.237%2073.7652%20524.31C73.8384%20524.383%2073.875%20524.471%2073.875%20524.575ZM77.625%20524.575C77.625%20524.679%2077.5884%20524.767%2077.5152%20524.84C77.4419%20524.913%2077.3536%20524.95%2077.25%20524.95C77.1464%20524.95%2077.0581%20524.913%2076.9848%20524.84C76.9116%20524.767%2076.875%20524.679%2076.875%20524.575C76.875%20524.471%2076.9116%20524.383%2076.9848%20524.31C77.0581%20524.237%2077.1464%20524.2%2077.25%20524.2C77.3536%20524.2%2077.4419%20524.237%2077.5152%20524.31C77.5884%20524.383%2077.625%20524.471%2077.625%20524.575ZM81.375%20524.575C81.375%20524.679%2081.3384%20524.767%2081.2652%20524.84C81.1919%20524.913%2081.1036%20524.95%2081%20524.95C80.8964%20524.95%2080.8081%20524.913%2080.7348%20524.84C80.6616%20524.767%2080.625%20524.679%2080.625%20524.575C80.625%20524.471%2080.6616%20524.383%2080.7348%20524.31C80.8081%20524.237%2080.8964%20524.2%2081%20524.2C81.1036%20524.2%2081.1919%20524.237%2081.2652%20524.31C81.3384%20524.383%2081.375%20524.471%2081.375%20524.575ZM85.125%20524.575C85.125%20524.679%2085.0884%20524.767%2085.0152%20524.84C84.9419%20524.913%2084.8536%20524.95%2084.75%20524.95C84.6464%20524.95%2084.5581%20524.913%2084.4848%20524.84C84.4116%20524.767%2084.375%20524.679%2084.375%20524.575C84.375%20524.471%2084.4116%20524.383%2084.4848%20524.31C84.5581%20524.237%2084.6464%20524.2%2084.75%20524.2C84.8536%20524.2%2084.9419%20524.237%2085.0152%20524.31C85.0884%20524.383%2085.125%20524.471%2085.125%20524.575ZM88.875%20524.575C88.875%20524.679%2088.8384%20524.767%2088.7652%20524.84C88.6919%20524.913%2088.6036%20524.95%2088.5%20524.95C88.3964%20524.95%2088.3081%20524.913%2088.2348%20524.84C88.1616%20524.767%2088.125%20524.679%2088.125%20524.575C88.125%20524.471%2088.1616%20524.383%2088.2348%20524.31C88.3081%20524.237%2088.3964%20524.2%2088.5%20524.2C88.6036%20524.2%2088.6919%20524.237%2088.7652%20524.31C88.8384%20524.383%2088.875%20524.471%2088.875%20524.575ZM92.625%20524.575C92.625%20524.679%2092.5884%20524.767%2092.5152%20524.84C92.4419%20524.913%2092.3536%20524.95%2092.25%20524.95C92.1464%20524.95%2092.0581%20524.913%2091.9848%20524.84C91.9116%20524.767%2091.875%20524.679%2091.875%20524.575C91.875%20524.471%2091.9116%20524.383%2091.9848%20524.31C92.0581%20524.237%2092.1464%20524.2%2092.25%20524.2C92.3536%20524.2%2092.4419%20524.237%2092.5152%20524.31C92.5884%20524.383%2092.625%20524.471%2092.625%20524.575ZM96.375%20524.575C96.375%20524.679%2096.3384%20524.767%2096.2652%20524.84C96.1919%20524.913%2096.1036%20524.95%2096%20524.95C95.8964%20524.95%2095.8081%20524.913%2095.7348%20524.84C95.6616%20524.767%2095.625%20524.679%2095.625%20524.575C95.625%20524.471%2095.6616%20524.383%2095.7348%20524.31C95.8081%20524.237%2095.8964%20524.2%2096%20524.2C96.1036%20524.2%2096.1919%20524.237%2096.2652%20524.31C96.3384%20524.383%2096.375%20524.471%2096.375%20524.575ZM100.125%20524.575C100.125%20524.679%20100.088%20524.767%20100.015%20524.84C99.9419%20524.913%2099.8536%20524.95%2099.75%20524.95C99.6464%20524.95%2099.5581%20524.913%2099.4848%20524.84C99.4116%20524.767%2099.375%20524.679%2099.375%20524.575C99.375%20524.471%2099.4116%20524.383%2099.4848%20524.31C99.5581%20524.237%2099.6464%20524.2%2099.75%20524.2C99.8536%20524.2%2099.9419%20524.237%20100.015%20524.31C100.088%20524.383%20100.125%20524.471%20100.125%20524.575ZM103.875%20524.575C103.875%20524.679%20103.838%20524.767%20103.765%20524.84C103.692%20524.913%20103.604%20524.95%20103.5%20524.95C103.396%20524.95%20103.308%20524.913%20103.235%20524.84C103.162%20524.767%20103.125%20524.679%20103.125%20524.575C103.125%20524.471%20103.162%20524.383%20103.235%20524.31C103.308%20524.237%20103.396%20524.2%20103.5%20524.2C103.604%20524.2%20103.692%20524.237%20103.765%20524.31C103.838%20524.383%20103.875%20524.471%20103.875%20524.575ZM107.625%20524.575C107.625%20524.679%20107.588%20524.767%20107.515%20524.84C107.442%20524.913%20107.354%20524.95%20107.25%20524.95C107.146%20524.95%20107.058%20524.913%20106.985%20524.84C106.912%20524.767%20106.875%20524.679%20106.875%20524.575C106.875%20524.471%20106.912%20524.383%20106.985%20524.31C107.058%20524.237%20107.146%20524.2%20107.25%20524.2C107.354%20524.2%20107.442%20524.237%20107.515%20524.31C107.588%20524.383%20107.625%20524.471%20107.625%20524.575ZM111.375%20524.575C111.375%20524.679%20111.338%20524.767%20111.265%20524.84C111.192%20524.913%20111.104%20524.95%20111%20524.95C110.896%20524.95%20110.808%20524.913%20110.735%20524.84C110.662%20524.767%20110.625%20524.679%20110.625%20524.575C110.625%20524.471%20110.662%20524.383%20110.735%20524.31C110.808%20524.237%20110.896%20524.2%20111%20524.2C111.104%20524.2%20111.192%20524.237%20111.265%20524.31C111.338%20524.383%20111.375%20524.471%20111.375%20524.575ZM115.125%20524.575C115.125%20524.679%20115.088%20524.767%20115.015%20524.84C114.942%20524.913%20114.854%20524.95%20114.75%20524.95C114.646%20524.95%20114.558%20524.913%20114.485%20524.84C114.412%20524.767%20114.375%20524.679%20114.375%20524.575C114.375%20524.471%20114.412%20524.383%20114.485%20524.31C114.558%20524.237%20114.646%20524.2%20114.75%20524.2C114.854%20524.2%20114.942%20524.237%20115.015%20524.31C115.088%20524.383%20115.125%20524.471%20115.125%20524.575ZM118.875%20524.575C118.875%20524.679%20118.838%20524.767%20118.765%20524.84C118.692%20524.913%20118.604%20524.95%20118.5%20524.95C118.396%20524.95%20118.308%20524.913%20118.235%20524.84C118.162%20524.767%20118.125%20524.679%20118.125%20524.575C118.125%20524.471%20118.162%20524.383%20118.235%20524.31C118.308%20524.237%20118.396%20524.2%20118.5%20524.2C118.604%20524.2%20118.692%20524.237%20118.765%20524.31C118.838%20524.383%20118.875%20524.471%20118.875%20524.575ZM122.625%20524.575C122.625%20524.679%20122.588%20524.767%20122.515%20524.84C122.442%20524.913%20122.354%20524.95%20122.25%20524.95C122.146%20524.95%20122.058%20524.913%20121.985%20524.84C121.912%20524.767%20121.875%20524.679%20121.875%20524.575C121.875%20524.471%20121.912%20524.383%20121.985%20524.31C122.058%20524.237%20122.146%20524.2%20122.25%20524.2C122.354%20524.2%20122.442%20524.237%20122.515%20524.31C122.588%20524.383%20122.625%20524.471%20122.625%20524.575ZM126.375%20524.575C126.375%20524.679%20126.338%20524.767%20126.265%20524.84C126.192%20524.913%20126.104%20524.95%20126%20524.95C125.896%20524.95%20125.808%20524.913%20125.735%20524.84C125.662%20524.767%20125.625%20524.679%20125.625%20524.575C125.625%20524.471%20125.662%20524.383%20125.735%20524.31C125.808%20524.237%20125.896%20524.2%20126%20524.2C126.104%20524.2%20126.192%20524.237%20126.265%20524.31C126.338%20524.383%20126.375%20524.471%20126.375%20524.575ZM130.125%20524.575C130.125%20524.679%20130.088%20524.767%20130.015%20524.84C129.942%20524.913%20129.854%20524.95%20129.75%20524.95C129.646%20524.95%20129.558%20524.913%20129.485%20524.84C129.412%20524.767%20129.375%20524.679%20129.375%20524.575C129.375%20524.471%20129.412%20524.383%20129.485%20524.31C129.558%20524.237%20129.646%20524.2%20129.75%20524.2C129.854%20524.2%20129.942%20524.237%20130.015%20524.31C130.088%20524.383%20130.125%20524.471%20130.125%20524.575ZM133.875%20524.575C133.875%20524.679%20133.838%20524.767%20133.765%20524.84C133.692%20524.913%20133.604%20524.95%20133.5%20524.95C133.396%20524.95%20133.308%20524.913%20133.235%20524.84C133.162%20524.767%20133.125%20524.679%20133.125%20524.575C133.125%20524.471%20133.162%20524.383%20133.235%20524.31C133.308%20524.237%20133.396%20524.2%20133.5%20524.2C133.604%20524.2%20133.692%20524.237%20133.765%20524.31C133.838%20524.383%20133.875%20524.471%20133.875%20524.575ZM137.625%20524.575C137.625%20524.679%20137.588%20524.767%20137.515%20524.84C137.442%20524.913%20137.354%20524.95%20137.25%20524.95C137.146%20524.95%20137.058%20524.913%20136.985%20524.84C136.912%20524.767%20136.875%20524.679%20136.875%20524.575C136.875%20524.471%20136.912%20524.383%20136.985%20524.31C137.058%20524.237%20137.146%20524.2%20137.25%20524.2C137.354%20524.2%20137.442%20524.237%20137.515%20524.31C137.588%20524.383%20137.625%20524.471%20137.625%20524.575ZM141.375%20524.575C141.375%20524.679%20141.338%20524.767%20141.265%20524.84C141.192%20524.913%20141.104%20524.95%20141%20524.95C140.896%20524.95%20140.808%20524.913%20140.735%20524.84C140.662%20524.767%20140.625%20524.679%20140.625%20524.575C140.625%20524.471%20140.662%20524.383%20140.735%20524.31C140.808%20524.237%20140.896%20524.2%20141%20524.2C141.104%20524.2%20141.192%20524.237%20141.265%20524.31C141.338%20524.383%20141.375%20524.471%20141.375%20524.575ZM145.125%20524.575C145.125%20524.679%20145.088%20524.767%20145.015%20524.84C144.942%20524.913%20144.854%20524.95%20144.75%20524.95C144.646%20524.95%20144.558%20524.913%20144.485%20524.84C144.412%20524.767%20144.375%20524.679%20144.375%20524.575C144.375%20524.471%20144.412%20524.383%20144.485%20524.31C144.558%20524.237%20144.646%20524.2%20144.75%20524.2C144.854%20524.2%20144.942%20524.237%20145.015%20524.31C145.088%20524.383%20145.125%20524.471%20145.125%20524.575ZM148.875%20524.575C148.875%20524.679%20148.838%20524.767%20148.765%20524.84C148.692%20524.913%20148.604%20524.95%20148.5%20524.95C148.396%20524.95%20148.308%20524.913%20148.235%20524.84C148.162%20524.767%20148.125%20524.679%20148.125%20524.575C148.125%20524.471%20148.162%20524.383%20148.235%20524.31C148.308%20524.237%20148.396%20524.2%20148.5%20524.2C148.604%20524.2%20148.692%20524.237%20148.765%20524.31C148.838%20524.383%20148.875%20524.471%20148.875%20524.575ZM152.625%20524.575C152.625%20524.679%20152.588%20524.767%20152.515%20524.84C152.442%20524.913%20152.354%20524.95%20152.25%20524.95C152.146%20524.95%20152.058%20524.913%20151.985%20524.84C151.912%20524.767%20151.875%20524.679%20151.875%20524.575C151.875%20524.471%20151.912%20524.383%20151.985%20524.31C152.058%20524.237%20152.146%20524.2%20152.25%20524.2C152.354%20524.2%20152.442%20524.237%20152.515%20524.31C152.588%20524.383%20152.625%20524.471%20152.625%20524.575ZM156.375%20524.575C156.375%20524.679%20156.338%20524.767%20156.265%20524.84C156.192%20524.913%20156.104%20524.95%20156%20524.95C155.896%20524.95%20155.808%20524.913%20155.735%20524.84C155.662%20524.767%20155.625%20524.679%20155.625%20524.575C155.625%20524.471%20155.662%20524.383%20155.735%20524.31C155.808%20524.237%20155.896%20524.2%20156%20524.2C156.104%20524.2%20156.192%20524.237%20156.265%20524.31C156.338%20524.383%20156.375%20524.471%20156.375%20524.575ZM160.125%20524.575C160.125%20524.679%20160.088%20524.767%20160.015%20524.84C159.942%20524.913%20159.854%20524.95%20159.75%20524.95C159.646%20524.95%20159.558%20524.913%20159.485%20524.84C159.412%20524.767%20159.375%20524.679%20159.375%20524.575C159.375%20524.471%20159.412%20524.383%20159.485%20524.31C159.558%20524.237%20159.646%20524.2%20159.75%20524.2C159.854%20524.2%20159.942%20524.237%20160.015%20524.31C160.088%20524.383%20160.125%20524.471%20160.125%20524.575ZM163.875%20524.575C163.875%20524.679%20163.838%20524.767%20163.765%20524.84C163.692%20524.913%20163.604%20524.95%20163.5%20524.95C163.396%20524.95%20163.308%20524.913%20163.235%20524.84C163.162%20524.767%20163.125%20524.679%20163.125%20524.575C163.125%20524.471%20163.162%20524.383%20163.235%20524.31C163.308%20524.237%20163.396%20524.2%20163.5%20524.2C163.604%20524.2%20163.692%20524.237%20163.765%20524.31C163.838%20524.383%20163.875%20524.471%20163.875%20524.575ZM167.625%20524.575C167.625%20524.679%20167.588%20524.767%20167.515%20524.84C167.442%20524.913%20167.354%20524.95%20167.25%20524.95C167.146%20524.95%20167.058%20524.913%20166.985%20524.84C166.912%20524.767%20166.875%20524.679%20166.875%20524.575C166.875%20524.471%20166.912%20524.383%20166.985%20524.31C167.058%20524.237%20167.146%20524.2%20167.25%20524.2C167.354%20524.2%20167.442%20524.237%20167.515%20524.31C167.588%20524.383%20167.625%20524.471%20167.625%20524.575ZM171.375%20524.575C171.375%20524.679%20171.338%20524.767%20171.265%20524.84C171.192%20524.913%20171.104%20524.95%20171%20524.95C170.896%20524.95%20170.808%20524.913%20170.735%20524.84C170.662%20524.767%20170.625%20524.679%20170.625%20524.575C170.625%20524.471%20170.662%20524.383%20170.735%20524.31C170.808%20524.237%20170.896%20524.2%20171%20524.2C171.104%20524.2%20171.192%20524.237%20171.265%20524.31C171.338%20524.383%20171.375%20524.471%20171.375%20524.575ZM175.125%20524.575C175.125%20524.679%20175.088%20524.767%20175.015%20524.84C174.942%20524.913%20174.854%20524.95%20174.75%20524.95C174.646%20524.95%20174.558%20524.913%20174.485%20524.84C174.412%20524.767%20174.375%20524.679%20174.375%20524.575C174.375%20524.471%20174.412%20524.383%20174.485%20524.31C174.558%20524.237%20174.646%20524.2%20174.75%20524.2C174.854%20524.2%20174.942%20524.237%20175.015%20524.31C175.088%20524.383%20175.125%20524.471%20175.125%20524.575ZM178.875%20524.575C178.875%20524.679%20178.838%20524.767%20178.765%20524.84C178.692%20524.913%20178.604%20524.95%20178.5%20524.95C178.396%20524.95%20178.308%20524.913%20178.235%20524.84C178.162%20524.767%20178.125%20524.679%20178.125%20524.575C178.125%20524.471%20178.162%20524.383%20178.235%20524.31C178.308%20524.237%20178.396%20524.2%20178.5%20524.2C178.604%20524.2%20178.692%20524.237%20178.765%20524.31C178.838%20524.383%20178.875%20524.471%20178.875%20524.575ZM182.625%20524.575C182.625%20524.679%20182.588%20524.767%20182.515%20524.84C182.442%20524.913%20182.354%20524.95%20182.25%20524.95C182.146%20524.95%20182.058%20524.913%20181.985%20524.84C181.912%20524.767%20181.875%20524.679%20181.875%20524.575C181.875%20524.471%20181.912%20524.383%20181.985%20524.31C182.058%20524.237%20182.146%20524.2%20182.25%20524.2C182.354%20524.2%20182.442%20524.237%20182.515%20524.31C182.588%20524.383%20182.625%20524.471%20182.625%20524.575ZM186.375%20524.575C186.375%20524.679%20186.338%20524.767%20186.265%20524.84C186.192%20524.913%20186.104%20524.95%20186%20524.95C185.896%20524.95%20185.808%20524.913%20185.735%20524.84C185.662%20524.767%20185.625%20524.679%20185.625%20524.575C185.625%20524.471%20185.662%20524.383%20185.735%20524.31C185.808%20524.237%20185.896%20524.2%20186%20524.2C186.104%20524.2%20186.192%20524.237%20186.265%20524.31C186.338%20524.383%20186.375%20524.471%20186.375%20524.575ZM190.125%20524.575C190.125%20524.679%20190.088%20524.767%20190.015%20524.84C189.942%20524.913%20189.854%20524.95%20189.75%20524.95C189.646%20524.95%20189.558%20524.913%20189.485%20524.84C189.412%20524.767%20189.375%20524.679%20189.375%20524.575C189.375%20524.471%20189.412%20524.383%20189.485%20524.31C189.558%20524.237%20189.646%20524.2%20189.75%20524.2C189.854%20524.2%20189.942%20524.237%20190.015%20524.31C190.088%20524.383%20190.125%20524.471%20190.125%20524.575ZM193.875%20524.575C193.875%20524.679%20193.838%20524.767%20193.765%20524.84C193.692%20524.913%20193.604%20524.95%20193.5%20524.95C193.396%20524.95%20193.308%20524.913%20193.235%20524.84C193.162%20524.767%20193.125%20524.679%20193.125%20524.575C193.125%20524.471%20193.162%20524.383%20193.235%20524.31C193.308%20524.237%20193.396%20524.2%20193.5%20524.2C193.604%20524.2%20193.692%20524.237%20193.765%20524.31C193.838%20524.383%20193.875%20524.471%20193.875%20524.575ZM197.625%20524.575C197.625%20524.679%20197.588%20524.767%20197.515%20524.84C197.442%20524.913%20197.354%20524.95%20197.25%20524.95C197.146%20524.95%20197.058%20524.913%20196.985%20524.84C196.912%20524.767%20196.875%20524.679%20196.875%20524.575C196.875%20524.471%20196.912%20524.383%20196.985%20524.31C197.058%20524.237%20197.146%20524.2%20197.25%20524.2C197.354%20524.2%20197.442%20524.237%20197.515%20524.31C197.588%20524.383%20197.625%20524.471%20197.625%20524.575ZM201.375%20524.575C201.375%20524.679%20201.338%20524.767%20201.265%20524.84C201.192%20524.913%20201.104%20524.95%20201%20524.95C200.896%20524.95%20200.808%20524.913%20200.735%20524.84C200.662%20524.767%20200.625%20524.679%20200.625%20524.575C200.625%20524.471%20200.662%20524.383%20200.735%20524.31C200.808%20524.237%20200.896%20524.2%20201%20524.2C201.104%20524.2%20201.192%20524.237%20201.265%20524.31C201.338%20524.383%20201.375%20524.471%20201.375%20524.575ZM205.125%20524.575C205.125%20524.679%20205.088%20524.767%20205.015%20524.84C204.942%20524.913%20204.854%20524.95%20204.75%20524.95C204.646%20524.95%20204.558%20524.913%20204.485%20524.84C204.412%20524.767%20204.375%20524.679%20204.375%20524.575C204.375%20524.471%20204.412%20524.383%20204.485%20524.31C204.558%20524.237%20204.646%20524.2%20204.75%20524.2C204.854%20524.2%20204.942%20524.237%20205.015%20524.31C205.088%20524.383%20205.125%20524.471%20205.125%20524.575ZM208.875%20524.575C208.875%20524.679%20208.838%20524.767%20208.765%20524.84C208.692%20524.913%20208.604%20524.95%20208.5%20524.95C208.396%20524.95%20208.308%20524.913%20208.235%20524.84C208.162%20524.767%20208.125%20524.679%20208.125%20524.575C208.125%20524.471%20208.162%20524.383%20208.235%20524.31C208.308%20524.237%20208.396%20524.2%20208.5%20524.2C208.604%20524.2%20208.692%20524.237%20208.765%20524.31C208.838%20524.383%20208.875%20524.471%20208.875%20524.575ZM212.625%20524.575C212.625%20524.679%20212.588%20524.767%20212.515%20524.84C212.442%20524.913%20212.354%20524.95%20212.25%20524.95C212.146%20524.95%20212.058%20524.913%20211.985%20524.84C211.912%20524.767%20211.875%20524.679%20211.875%20524.575C211.875%20524.471%20211.912%20524.383%20211.985%20524.31C212.058%20524.237%20212.146%20524.2%20212.25%20524.2C212.354%20524.2%20212.442%20524.237%20212.515%20524.31C212.588%20524.383%20212.625%20524.471%20212.625%20524.575ZM216.375%20524.575C216.375%20524.679%20216.338%20524.767%20216.265%20524.84C216.192%20524.913%20216.104%20524.95%20216%20524.95C215.896%20524.95%20215.808%20524.913%20215.735%20524.84C215.662%20524.767%20215.625%20524.679%20215.625%20524.575C215.625%20524.471%20215.662%20524.383%20215.735%20524.31C215.808%20524.237%20215.896%20524.2%20216%20524.2C216.104%20524.2%20216.192%20524.237%20216.265%20524.31C216.338%20524.383%20216.375%20524.471%20216.375%20524.575ZM220.125%20524.575C220.125%20524.679%20220.088%20524.767%20220.015%20524.84C219.942%20524.913%20219.854%20524.95%20219.75%20524.95C219.646%20524.95%20219.558%20524.913%20219.485%20524.84C219.412%20524.767%20219.375%20524.679%20219.375%20524.575C219.375%20524.471%20219.412%20524.383%20219.485%20524.31C219.558%20524.237%20219.646%20524.2%20219.75%20524.2C219.854%20524.2%20219.942%20524.237%20220.015%20524.31C220.088%20524.383%20220.125%20524.471%20220.125%20524.575ZM223.875%20524.575C223.875%20524.679%20223.838%20524.767%20223.765%20524.84C223.692%20524.913%20223.604%20524.95%20223.5%20524.95C223.396%20524.95%20223.308%20524.913%20223.235%20524.84C223.162%20524.767%20223.125%20524.679%20223.125%20524.575C223.125%20524.471%20223.162%20524.383%20223.235%20524.31C223.308%20524.237%20223.396%20524.2%20223.5%20524.2C223.604%20524.2%20223.692%20524.237%20223.765%20524.31C223.838%20524.383%20223.875%20524.471%20223.875%20524.575ZM227.625%20524.575C227.625%20524.679%20227.588%20524.767%20227.515%20524.84C227.442%20524.913%20227.354%20524.95%20227.25%20524.95C227.146%20524.95%20227.058%20524.913%20226.985%20524.84C226.912%20524.767%20226.875%20524.679%20226.875%20524.575C226.875%20524.471%20226.912%20524.383%20226.985%20524.31C227.058%20524.237%20227.146%20524.2%20227.25%20524.2C227.354%20524.2%20227.442%20524.237%20227.515%20524.31C227.588%20524.383%20227.625%20524.471%20227.625%20524.575ZM231.375%20524.575C231.375%20524.679%20231.338%20524.767%20231.265%20524.84C231.192%20524.913%20231.104%20524.95%20231%20524.95C230.896%20524.95%20230.808%20524.913%20230.735%20524.84C230.662%20524.767%20230.625%20524.679%20230.625%20524.575C230.625%20524.471%20230.662%20524.383%20230.735%20524.31C230.808%20524.237%20230.896%20524.2%20231%20524.2C231.104%20524.2%20231.192%20524.237%20231.265%20524.31C231.338%20524.383%20231.375%20524.471%20231.375%20524.575ZM235.125%20524.575C235.125%20524.679%20235.088%20524.767%20235.015%20524.84C234.942%20524.913%20234.854%20524.95%20234.75%20524.95C234.646%20524.95%20234.558%20524.913%20234.485%20524.84C234.412%20524.767%20234.375%20524.679%20234.375%20524.575C234.375%20524.471%20234.412%20524.383%20234.485%20524.31C234.558%20524.237%20234.646%20524.2%20234.75%20524.2C234.854%20524.2%20234.942%20524.237%20235.015%20524.31C235.088%20524.383%20235.125%20524.471%20235.125%20524.575ZM238.875%20524.575C238.875%20524.679%20238.838%20524.767%20238.765%20524.84C238.692%20524.913%20238.604%20524.95%20238.5%20524.95C238.396%20524.95%20238.308%20524.913%20238.235%20524.84C238.162%20524.767%20238.125%20524.679%20238.125%20524.575C238.125%20524.471%20238.162%20524.383%20238.235%20524.31C238.308%20524.237%20238.396%20524.2%20238.5%20524.2C238.604%20524.2%20238.692%20524.237%20238.765%20524.31C238.838%20524.383%20238.875%20524.471%20238.875%20524.575ZM242.625%20524.575C242.625%20524.679%20242.588%20524.767%20242.515%20524.84C242.442%20524.913%20242.354%20524.95%20242.25%20524.95C242.146%20524.95%20242.058%20524.913%20241.985%20524.84C241.912%20524.767%20241.875%20524.679%20241.875%20524.575C241.875%20524.471%20241.912%20524.383%20241.985%20524.31C242.058%20524.237%20242.146%20524.2%20242.25%20524.2C242.354%20524.2%20242.442%20524.237%20242.515%20524.31C242.588%20524.383%20242.625%20524.471%20242.625%20524.575ZM246.375%20524.575C246.375%20524.679%20246.338%20524.767%20246.265%20524.84C246.192%20524.913%20246.104%20524.95%20246%20524.95C245.896%20524.95%20245.808%20524.913%20245.735%20524.84C245.662%20524.767%20245.625%20524.679%20245.625%20524.575C245.625%20524.471%20245.662%20524.383%20245.735%20524.31C245.808%20524.237%20245.896%20524.2%20246%20524.2C246.104%20524.2%20246.192%20524.237%20246.265%20524.31C246.338%20524.383%20246.375%20524.471%20246.375%20524.575ZM250.125%20524.575C250.125%20524.679%20250.088%20524.767%20250.015%20524.84C249.942%20524.913%20249.854%20524.95%20249.75%20524.95C249.646%20524.95%20249.558%20524.913%20249.485%20524.84C249.412%20524.767%20249.375%20524.679%20249.375%20524.575C249.375%20524.471%20249.412%20524.383%20249.485%20524.31C249.558%20524.237%20249.646%20524.2%20249.75%20524.2C249.854%20524.2%20249.942%20524.237%20250.015%20524.31C250.088%20524.383%20250.125%20524.471%20250.125%20524.575ZM253.875%20524.575C253.875%20524.679%20253.838%20524.767%20253.765%20524.84C253.692%20524.913%20253.604%20524.95%20253.5%20524.95C253.396%20524.95%20253.308%20524.913%20253.235%20524.84C253.162%20524.767%20253.125%20524.679%20253.125%20524.575C253.125%20524.471%20253.162%20524.383%20253.235%20524.31C253.308%20524.237%20253.396%20524.2%20253.5%20524.2C253.604%20524.2%20253.692%20524.237%20253.765%20524.31C253.838%20524.383%20253.875%20524.471%20253.875%20524.575ZM257.625%20524.575C257.625%20524.679%20257.588%20524.767%20257.515%20524.84C257.442%20524.913%20257.354%20524.95%20257.25%20524.95C257.146%20524.95%20257.058%20524.913%20256.985%20524.84C256.912%20524.767%20256.875%20524.679%20256.875%20524.575C256.875%20524.471%20256.912%20524.383%20256.985%20524.31C257.058%20524.237%20257.146%20524.2%20257.25%20524.2C257.354%20524.2%20257.442%20524.237%20257.515%20524.31C257.588%20524.383%20257.625%20524.471%20257.625%20524.575ZM261.375%20524.575C261.375%20524.679%20261.338%20524.767%20261.265%20524.84C261.192%20524.913%20261.104%20524.95%20261%20524.95C260.896%20524.95%20260.808%20524.913%20260.735%20524.84C260.662%20524.767%20260.625%20524.679%20260.625%20524.575C260.625%20524.471%20260.662%20524.383%20260.735%20524.31C260.808%20524.237%20260.896%20524.2%20261%20524.2C261.104%20524.2%20261.192%20524.237%20261.265%20524.31C261.338%20524.383%20261.375%20524.471%20261.375%20524.575ZM265.125%20524.575C265.125%20524.679%20265.088%20524.767%20265.015%20524.84C264.942%20524.913%20264.854%20524.95%20264.75%20524.95C264.646%20524.95%20264.558%20524.913%20264.485%20524.84C264.412%20524.767%20264.375%20524.679%20264.375%20524.575C264.375%20524.471%20264.412%20524.383%20264.485%20524.31C264.558%20524.237%20264.646%20524.2%20264.75%20524.2C264.854%20524.2%20264.942%20524.237%20265.015%20524.31C265.088%20524.383%20265.125%20524.471%20265.125%20524.575ZM268.875%20524.575C268.875%20524.679%20268.838%20524.767%20268.765%20524.84C268.692%20524.913%20268.604%20524.95%20268.5%20524.95C268.396%20524.95%20268.308%20524.913%20268.235%20524.84C268.162%20524.767%20268.125%20524.679%20268.125%20524.575C268.125%20524.471%20268.162%20524.383%20268.235%20524.31C268.308%20524.237%20268.396%20524.2%20268.5%20524.2C268.604%20524.2%20268.692%20524.237%20268.765%20524.31C268.838%20524.383%20268.875%20524.471%20268.875%20524.575ZM272.625%20524.575C272.625%20524.679%20272.588%20524.767%20272.515%20524.84C272.442%20524.913%20272.354%20524.95%20272.25%20524.95C272.146%20524.95%20272.058%20524.913%20271.985%20524.84C271.912%20524.767%20271.875%20524.679%20271.875%20524.575C271.875%20524.471%20271.912%20524.383%20271.985%20524.31C272.058%20524.237%20272.146%20524.2%20272.25%20524.2C272.354%20524.2%20272.442%20524.237%20272.515%20524.31C272.588%20524.383%20272.625%20524.471%20272.625%20524.575ZM276.375%20524.575C276.375%20524.679%20276.338%20524.767%20276.265%20524.84C276.192%20524.913%20276.104%20524.95%20276%20524.95C275.896%20524.95%20275.808%20524.913%20275.735%20524.84C275.662%20524.767%20275.625%20524.679%20275.625%20524.575C275.625%20524.471%20275.662%20524.383%20275.735%20524.31C275.808%20524.237%20275.896%20524.2%20276%20524.2C276.104%20524.2%20276.192%20524.237%20276.265%20524.31C276.338%20524.383%20276.375%20524.471%20276.375%20524.575ZM280.125%20524.575C280.125%20524.679%20280.088%20524.767%20280.015%20524.84C279.942%20524.913%20279.854%20524.95%20279.75%20524.95C279.646%20524.95%20279.558%20524.913%20279.485%20524.84C279.412%20524.767%20279.375%20524.679%20279.375%20524.575C279.375%20524.471%20279.412%20524.383%20279.485%20524.31C279.558%20524.237%20279.646%20524.2%20279.75%20524.2C279.854%20524.2%20279.942%20524.237%20280.015%20524.31C280.088%20524.383%20280.125%20524.471%20280.125%20524.575ZM283.875%20524.575C283.875%20524.679%20283.838%20524.767%20283.765%20524.84C283.692%20524.913%20283.604%20524.95%20283.5%20524.95C283.396%20524.95%20283.308%20524.913%20283.235%20524.84C283.162%20524.767%20283.125%20524.679%20283.125%20524.575C283.125%20524.471%20283.162%20524.383%20283.235%20524.31C283.308%20524.237%20283.396%20524.2%20283.5%20524.2C283.604%20524.2%20283.692%20524.237%20283.765%20524.31C283.838%20524.383%20283.875%20524.471%20283.875%20524.575ZM287.625%20524.575C287.625%20524.679%20287.588%20524.767%20287.515%20524.84C287.442%20524.913%20287.354%20524.95%20287.25%20524.95C287.146%20524.95%20287.058%20524.913%20286.985%20524.84C286.912%20524.767%20286.875%20524.679%20286.875%20524.575C286.875%20524.471%20286.912%20524.383%20286.985%20524.31C287.058%20524.237%20287.146%20524.2%20287.25%20524.2C287.354%20524.2%20287.442%20524.237%20287.515%20524.31C287.588%20524.383%20287.625%20524.471%20287.625%20524.575ZM291.375%20524.575C291.375%20524.679%20291.338%20524.767%20291.265%20524.84C291.192%20524.913%20291.104%20524.95%20291%20524.95C290.896%20524.95%20290.808%20524.913%20290.735%20524.84C290.662%20524.767%20290.625%20524.679%20290.625%20524.575C290.625%20524.471%20290.662%20524.383%20290.735%20524.31C290.808%20524.237%20290.896%20524.2%20291%20524.2C291.104%20524.2%20291.192%20524.237%20291.265%20524.31C291.338%20524.383%20291.375%20524.471%20291.375%20524.575ZM295.125%20524.575C295.125%20524.679%20295.088%20524.767%20295.015%20524.84C294.942%20524.913%20294.854%20524.95%20294.75%20524.95C294.646%20524.95%20294.558%20524.913%20294.485%20524.84C294.412%20524.767%20294.375%20524.679%20294.375%20524.575C294.375%20524.471%20294.412%20524.383%20294.485%20524.31C294.558%20524.237%20294.646%20524.2%20294.75%20524.2C294.854%20524.2%20294.942%20524.237%20295.015%20524.31C295.088%20524.383%20295.125%20524.471%20295.125%20524.575ZM298.875%20524.575C298.875%20524.679%20298.838%20524.767%20298.765%20524.84C298.692%20524.913%20298.604%20524.95%20298.5%20524.95C298.396%20524.95%20298.308%20524.913%20298.235%20524.84C298.162%20524.767%20298.125%20524.679%20298.125%20524.575C298.125%20524.471%20298.162%20524.383%20298.235%20524.31C298.308%20524.237%20298.396%20524.2%20298.5%20524.2C298.604%20524.2%20298.692%20524.237%20298.765%20524.31C298.838%20524.383%20298.875%20524.471%20298.875%20524.575ZM302.625%20524.575C302.625%20524.679%20302.588%20524.767%20302.515%20524.84C302.442%20524.913%20302.354%20524.95%20302.25%20524.95C302.146%20524.95%20302.058%20524.913%20301.985%20524.84C301.912%20524.767%20301.875%20524.679%20301.875%20524.575C301.875%20524.471%20301.912%20524.383%20301.985%20524.31C302.058%20524.237%20302.146%20524.2%20302.25%20524.2C302.354%20524.2%20302.442%20524.237%20302.515%20524.31C302.588%20524.383%20302.625%20524.471%20302.625%20524.575ZM306.375%20524.575C306.375%20524.679%20306.338%20524.767%20306.265%20524.84C306.192%20524.913%20306.104%20524.95%20306%20524.95C305.896%20524.95%20305.808%20524.913%20305.735%20524.84C305.662%20524.767%20305.625%20524.679%20305.625%20524.575C305.625%20524.471%20305.662%20524.383%20305.735%20524.31C305.808%20524.237%20305.896%20524.2%20306%20524.2C306.104%20524.2%20306.192%20524.237%20306.265%20524.31C306.338%20524.383%20306.375%20524.471%20306.375%20524.575ZM310.125%20524.575C310.125%20524.679%20310.088%20524.767%20310.015%20524.84C309.942%20524.913%20309.854%20524.95%20309.75%20524.95C309.646%20524.95%20309.558%20524.913%20309.485%20524.84C309.412%20524.767%20309.375%20524.679%20309.375%20524.575C309.375%20524.471%20309.412%20524.383%20309.485%20524.31C309.558%20524.237%20309.646%20524.2%20309.75%20524.2C309.854%20524.2%20309.942%20524.237%20310.015%20524.31C310.088%20524.383%20310.125%20524.471%20310.125%20524.575ZM313.875%20524.575C313.875%20524.679%20313.838%20524.767%20313.765%20524.84C313.692%20524.913%20313.604%20524.95%20313.5%20524.95C313.396%20524.95%20313.308%20524.913%20313.235%20524.84C313.162%20524.767%20313.125%20524.679%20313.125%20524.575C313.125%20524.471%20313.162%20524.383%20313.235%20524.31C313.308%20524.237%20313.396%20524.2%20313.5%20524.2C313.604%20524.2%20313.692%20524.237%20313.765%20524.31C313.838%20524.383%20313.875%20524.471%20313.875%20524.575ZM317.625%20524.575C317.625%20524.679%20317.588%20524.767%20317.515%20524.84C317.442%20524.913%20317.354%20524.95%20317.25%20524.95C317.146%20524.95%20317.058%20524.913%20316.985%20524.84C316.912%20524.767%20316.875%20524.679%20316.875%20524.575C316.875%20524.471%20316.912%20524.383%20316.985%20524.31C317.058%20524.237%20317.146%20524.2%20317.25%20524.2C317.354%20524.2%20317.442%20524.237%20317.515%20524.31C317.588%20524.383%20317.625%20524.471%20317.625%20524.575ZM321.375%20524.575C321.375%20524.679%20321.338%20524.767%20321.265%20524.84C321.192%20524.913%20321.104%20524.95%20321%20524.95C320.896%20524.95%20320.808%20524.913%20320.735%20524.84C320.662%20524.767%20320.625%20524.679%20320.625%20524.575C320.625%20524.471%20320.662%20524.383%20320.735%20524.31C320.808%20524.237%20320.896%20524.2%20321%20524.2C321.104%20524.2%20321.192%20524.237%20321.265%20524.31C321.338%20524.383%20321.375%20524.471%20321.375%20524.575ZM325.125%20524.575C325.125%20524.679%20325.088%20524.767%20325.015%20524.84C324.942%20524.913%20324.854%20524.95%20324.75%20524.95C324.646%20524.95%20324.558%20524.913%20324.485%20524.84C324.412%20524.767%20324.375%20524.679%20324.375%20524.575C324.375%20524.471%20324.412%20524.383%20324.485%20524.31C324.558%20524.237%20324.646%20524.2%20324.75%20524.2C324.854%20524.2%20324.942%20524.237%20325.015%20524.31C325.088%20524.383%20325.125%20524.471%20325.125%20524.575ZM328.875%20524.575C328.875%20524.679%20328.838%20524.767%20328.765%20524.84C328.692%20524.913%20328.604%20524.95%20328.5%20524.95C328.396%20524.95%20328.308%20524.913%20328.235%20524.84C328.162%20524.767%20328.125%20524.679%20328.125%20524.575C328.125%20524.471%20328.162%20524.383%20328.235%20524.31C328.308%20524.237%20328.396%20524.2%20328.5%20524.2C328.604%20524.2%20328.692%20524.237%20328.765%20524.31C328.838%20524.383%20328.875%20524.471%20328.875%20524.575ZM332.625%20524.575C332.625%20524.679%20332.588%20524.767%20332.515%20524.84C332.442%20524.913%20332.354%20524.95%20332.25%20524.95C332.146%20524.95%20332.058%20524.913%20331.985%20524.84C331.912%20524.767%20331.875%20524.679%20331.875%20524.575C331.875%20524.471%20331.912%20524.383%20331.985%20524.31C332.058%20524.237%20332.146%20524.2%20332.25%20524.2C332.354%20524.2%20332.442%20524.237%20332.515%20524.31C332.588%20524.383%20332.625%20524.471%20332.625%20524.575ZM336.375%20524.575C336.375%20524.679%20336.338%20524.767%20336.265%20524.84C336.192%20524.913%20336.104%20524.95%20336%20524.95C335.896%20524.95%20335.808%20524.913%20335.735%20524.84C335.662%20524.767%20335.625%20524.679%20335.625%20524.575C335.625%20524.471%20335.662%20524.383%20335.735%20524.31C335.808%20524.237%20335.896%20524.2%20336%20524.2C336.104%20524.2%20336.192%20524.237%20336.265%20524.31C336.338%20524.383%20336.375%20524.471%20336.375%20524.575ZM340.125%20524.575C340.125%20524.679%20340.088%20524.767%20340.015%20524.84C339.942%20524.913%20339.854%20524.95%20339.75%20524.95C339.646%20524.95%20339.558%20524.913%20339.485%20524.84C339.412%20524.767%20339.375%20524.679%20339.375%20524.575C339.375%20524.471%20339.412%20524.383%20339.485%20524.31C339.558%20524.237%20339.646%20524.2%20339.75%20524.2C339.854%20524.2%20339.942%20524.237%20340.015%20524.31C340.088%20524.383%20340.125%20524.471%20340.125%20524.575ZM343.875%20524.575C343.875%20524.679%20343.838%20524.767%20343.765%20524.84C343.692%20524.913%20343.604%20524.95%20343.5%20524.95C343.396%20524.95%20343.308%20524.913%20343.235%20524.84C343.162%20524.767%20343.125%20524.679%20343.125%20524.575C343.125%20524.471%20343.162%20524.383%20343.235%20524.31C343.308%20524.237%20343.396%20524.2%20343.5%20524.2C343.604%20524.2%20343.692%20524.237%20343.765%20524.31C343.838%20524.383%20343.875%20524.471%20343.875%20524.575ZM347.625%20524.575C347.625%20524.679%20347.588%20524.767%20347.515%20524.84C347.442%20524.913%20347.354%20524.95%20347.25%20524.95C347.146%20524.95%20347.058%20524.913%20346.985%20524.84C346.912%20524.767%20346.875%20524.679%20346.875%20524.575C346.875%20524.471%20346.912%20524.383%20346.985%20524.31C347.058%20524.237%20347.146%20524.2%20347.25%20524.2C347.354%20524.2%20347.442%20524.237%20347.515%20524.31C347.588%20524.383%20347.625%20524.471%20347.625%20524.575ZM351.375%20524.575C351.375%20524.679%20351.338%20524.767%20351.265%20524.84C351.192%20524.913%20351.104%20524.95%20351%20524.95C350.896%20524.95%20350.808%20524.913%20350.735%20524.84C350.662%20524.767%20350.625%20524.679%20350.625%20524.575C350.625%20524.471%20350.662%20524.383%20350.735%20524.31C350.808%20524.237%20350.896%20524.2%20351%20524.2C351.104%20524.2%20351.192%20524.237%20351.265%20524.31C351.338%20524.383%20351.375%20524.471%20351.375%20524.575ZM355.125%20524.575C355.125%20524.679%20355.088%20524.767%20355.015%20524.84C354.942%20524.913%20354.854%20524.95%20354.75%20524.95C354.646%20524.95%20354.558%20524.913%20354.485%20524.84C354.412%20524.767%20354.375%20524.679%20354.375%20524.575C354.375%20524.471%20354.412%20524.383%20354.485%20524.31C354.558%20524.237%20354.646%20524.2%20354.75%20524.2C354.854%20524.2%20354.942%20524.237%20355.015%20524.31C355.088%20524.383%20355.125%20524.471%20355.125%20524.575ZM358.875%20524.575C358.875%20524.679%20358.838%20524.767%20358.765%20524.84C358.692%20524.913%20358.604%20524.95%20358.5%20524.95C358.396%20524.95%20358.308%20524.913%20358.235%20524.84C358.162%20524.767%20358.125%20524.679%20358.125%20524.575C358.125%20524.471%20358.162%20524.383%20358.235%20524.31C358.308%20524.237%20358.396%20524.2%20358.5%20524.2C358.604%20524.2%20358.692%20524.237%20358.765%20524.31C358.838%20524.383%20358.875%20524.471%20358.875%20524.575ZM362.625%20524.575C362.625%20524.679%20362.588%20524.767%20362.515%20524.84C362.442%20524.913%20362.354%20524.95%20362.25%20524.95C362.146%20524.95%20362.058%20524.913%20361.985%20524.84C361.912%20524.767%20361.875%20524.679%20361.875%20524.575C361.875%20524.471%20361.912%20524.383%20361.985%20524.31C362.058%20524.237%20362.146%20524.2%20362.25%20524.2C362.354%20524.2%20362.442%20524.237%20362.515%20524.31C362.588%20524.383%20362.625%20524.471%20362.625%20524.575ZM366.375%20524.575C366.375%20524.679%20366.338%20524.767%20366.265%20524.84C366.192%20524.913%20366.104%20524.95%20366%20524.95C365.896%20524.95%20365.808%20524.913%20365.735%20524.84C365.662%20524.767%20365.625%20524.679%20365.625%20524.575C365.625%20524.471%20365.662%20524.383%20365.735%20524.31C365.808%20524.237%20365.896%20524.2%20366%20524.2C366.104%20524.2%20366.192%20524.237%20366.265%20524.31C366.338%20524.383%20366.375%20524.471%20366.375%20524.575ZM370.125%20524.575C370.125%20524.679%20370.088%20524.767%20370.015%20524.84C369.942%20524.913%20369.854%20524.95%20369.75%20524.95C369.646%20524.95%20369.558%20524.913%20369.485%20524.84C369.412%20524.767%20369.375%20524.679%20369.375%20524.575C369.375%20524.471%20369.412%20524.383%20369.485%20524.31C369.558%20524.237%20369.646%20524.2%20369.75%20524.2C369.854%20524.2%20369.942%20524.237%20370.015%20524.31C370.088%20524.383%20370.125%20524.471%20370.125%20524.575ZM373.875%20524.575C373.875%20524.679%20373.838%20524.767%20373.765%20524.84C373.692%20524.913%20373.604%20524.95%20373.5%20524.95C373.396%20524.95%20373.308%20524.913%20373.235%20524.84C373.162%20524.767%20373.125%20524.679%20373.125%20524.575C373.125%20524.471%20373.162%20524.383%20373.235%20524.31C373.308%20524.237%20373.396%20524.2%20373.5%20524.2C373.604%20524.2%20373.692%20524.237%20373.765%20524.31C373.838%20524.383%20373.875%20524.471%20373.875%20524.575ZM377.625%20524.575C377.625%20524.679%20377.588%20524.767%20377.515%20524.84C377.442%20524.913%20377.354%20524.95%20377.25%20524.95C377.146%20524.95%20377.058%20524.913%20376.985%20524.84C376.912%20524.767%20376.875%20524.679%20376.875%20524.575C376.875%20524.471%20376.912%20524.383%20376.985%20524.31C377.058%20524.237%20377.146%20524.2%20377.25%20524.2C377.354%20524.2%20377.442%20524.237%20377.515%20524.31C377.588%20524.383%20377.625%20524.471%20377.625%20524.575ZM381.375%20524.575C381.375%20524.679%20381.338%20524.767%20381.265%20524.84C381.192%20524.913%20381.104%20524.95%20381%20524.95C380.896%20524.95%20380.808%20524.913%20380.735%20524.84C380.662%20524.767%20380.625%20524.679%20380.625%20524.575C380.625%20524.471%20380.662%20524.383%20380.735%20524.31C380.808%20524.237%20380.896%20524.2%20381%20524.2C381.104%20524.2%20381.192%20524.237%20381.265%20524.31C381.338%20524.383%20381.375%20524.471%20381.375%20524.575ZM385.125%20524.575C385.125%20524.679%20385.088%20524.767%20385.015%20524.84C384.942%20524.913%20384.854%20524.95%20384.75%20524.95C384.646%20524.95%20384.558%20524.913%20384.485%20524.84C384.412%20524.767%20384.375%20524.679%20384.375%20524.575C384.375%20524.471%20384.412%20524.383%20384.485%20524.31C384.558%20524.237%20384.646%20524.2%20384.75%20524.2C384.854%20524.2%20384.942%20524.237%20385.015%20524.31C385.088%20524.383%20385.125%20524.471%20385.125%20524.575ZM388.875%20524.575C388.875%20524.679%20388.838%20524.767%20388.765%20524.84C388.692%20524.913%20388.604%20524.95%20388.5%20524.95C388.396%20524.95%20388.308%20524.913%20388.235%20524.84C388.162%20524.767%20388.125%20524.679%20388.125%20524.575C388.125%20524.471%20388.162%20524.383%20388.235%20524.31C388.308%20524.237%20388.396%20524.2%20388.5%20524.2C388.604%20524.2%20388.692%20524.237%20388.765%20524.31C388.838%20524.383%20388.875%20524.471%20388.875%20524.575ZM392.625%20524.575C392.625%20524.679%20392.588%20524.767%20392.515%20524.84C392.442%20524.913%20392.354%20524.95%20392.25%20524.95C392.146%20524.95%20392.058%20524.913%20391.985%20524.84C391.912%20524.767%20391.875%20524.679%20391.875%20524.575C391.875%20524.471%20391.912%20524.383%20391.985%20524.31C392.058%20524.237%20392.146%20524.2%20392.25%20524.2C392.354%20524.2%20392.442%20524.237%20392.515%20524.31C392.588%20524.383%20392.625%20524.471%20392.625%20524.575ZM396.375%20524.575C396.375%20524.679%20396.338%20524.767%20396.265%20524.84C396.192%20524.913%20396.104%20524.95%20396%20524.95C395.896%20524.95%20395.808%20524.913%20395.735%20524.84C395.662%20524.767%20395.625%20524.679%20395.625%20524.575C395.625%20524.471%20395.662%20524.383%20395.735%20524.31C395.808%20524.237%20395.896%20524.2%20396%20524.2C396.104%20524.2%20396.192%20524.237%20396.265%20524.31C396.338%20524.383%20396.375%20524.471%20396.375%20524.575ZM400.125%20524.575C400.125%20524.679%20400.088%20524.767%20400.015%20524.84C399.942%20524.913%20399.854%20524.95%20399.75%20524.95C399.646%20524.95%20399.558%20524.913%20399.485%20524.84C399.412%20524.767%20399.375%20524.679%20399.375%20524.575C399.375%20524.471%20399.412%20524.383%20399.485%20524.31C399.558%20524.237%20399.646%20524.2%20399.75%20524.2C399.854%20524.2%20399.942%20524.237%20400.015%20524.31C400.088%20524.383%20400.125%20524.471%20400.125%20524.575ZM403.875%20524.575C403.875%20524.679%20403.838%20524.767%20403.765%20524.84C403.692%20524.913%20403.604%20524.95%20403.5%20524.95C403.396%20524.95%20403.308%20524.913%20403.235%20524.84C403.162%20524.767%20403.125%20524.679%20403.125%20524.575C403.125%20524.471%20403.162%20524.383%20403.235%20524.31C403.308%20524.237%20403.396%20524.2%20403.5%20524.2C403.604%20524.2%20403.692%20524.237%20403.765%20524.31C403.838%20524.383%20403.875%20524.471%20403.875%20524.575ZM407.625%20524.575C407.625%20524.679%20407.588%20524.767%20407.515%20524.84C407.442%20524.913%20407.354%20524.95%20407.25%20524.95C407.146%20524.95%20407.058%20524.913%20406.985%20524.84C406.912%20524.767%20406.875%20524.679%20406.875%20524.575C406.875%20524.471%20406.912%20524.383%20406.985%20524.31C407.058%20524.237%20407.146%20524.2%20407.25%20524.2C407.354%20524.2%20407.442%20524.237%20407.515%20524.31C407.588%20524.383%20407.625%20524.471%20407.625%20524.575ZM411.375%20524.575C411.375%20524.679%20411.338%20524.767%20411.265%20524.84C411.192%20524.913%20411.104%20524.95%20411%20524.95C410.896%20524.95%20410.808%20524.913%20410.735%20524.84C410.662%20524.767%20410.625%20524.679%20410.625%20524.575C410.625%20524.471%20410.662%20524.383%20410.735%20524.31C410.808%20524.237%20410.896%20524.2%20411%20524.2C411.104%20524.2%20411.192%20524.237%20411.265%20524.31C411.338%20524.383%20411.375%20524.471%20411.375%20524.575ZM415.125%20524.575C415.125%20524.679%20415.088%20524.767%20415.015%20524.84C414.942%20524.913%20414.854%20524.95%20414.75%20524.95C414.646%20524.95%20414.558%20524.913%20414.485%20524.84C414.412%20524.767%20414.375%20524.679%20414.375%20524.575C414.375%20524.471%20414.412%20524.383%20414.485%20524.31C414.558%20524.237%20414.646%20524.2%20414.75%20524.2C414.854%20524.2%20414.942%20524.237%20415.015%20524.31C415.088%20524.383%20415.125%20524.471%20415.125%20524.575ZM418.875%20524.575C418.875%20524.679%20418.838%20524.767%20418.765%20524.84C418.692%20524.913%20418.604%20524.95%20418.5%20524.95C418.396%20524.95%20418.308%20524.913%20418.235%20524.84C418.162%20524.767%20418.125%20524.679%20418.125%20524.575C418.125%20524.471%20418.162%20524.383%20418.235%20524.31C418.308%20524.237%20418.396%20524.2%20418.5%20524.2C418.604%20524.2%20418.692%20524.237%20418.765%20524.31C418.838%20524.383%20418.875%20524.471%20418.875%20524.575ZM422.625%20524.575C422.625%20524.679%20422.588%20524.767%20422.515%20524.84C422.442%20524.913%20422.354%20524.95%20422.25%20524.95C422.146%20524.95%20422.058%20524.913%20421.985%20524.84C421.912%20524.767%20421.875%20524.679%20421.875%20524.575C421.875%20524.471%20421.912%20524.383%20421.985%20524.31C422.058%20524.237%20422.146%20524.2%20422.25%20524.2C422.354%20524.2%20422.442%20524.237%20422.515%20524.31C422.588%20524.383%20422.625%20524.471%20422.625%20524.575ZM426.375%20524.575C426.375%20524.679%20426.338%20524.767%20426.265%20524.84C426.192%20524.913%20426.104%20524.95%20426%20524.95C425.896%20524.95%20425.808%20524.913%20425.735%20524.84C425.662%20524.767%20425.625%20524.679%20425.625%20524.575C425.625%20524.471%20425.662%20524.383%20425.735%20524.31C425.808%20524.237%20425.896%20524.2%20426%20524.2C426.104%20524.2%20426.192%20524.237%20426.265%20524.31C426.338%20524.383%20426.375%20524.471%20426.375%20524.575ZM430.125%20524.575C430.125%20524.679%20430.088%20524.767%20430.015%20524.84C429.942%20524.913%20429.854%20524.95%20429.75%20524.95C429.646%20524.95%20429.558%20524.913%20429.485%20524.84C429.412%20524.767%20429.375%20524.679%20429.375%20524.575C429.375%20524.471%20429.412%20524.383%20429.485%20524.31C429.558%20524.237%20429.646%20524.2%20429.75%20524.2C429.854%20524.2%20429.942%20524.237%20430.015%20524.31C430.088%20524.383%20430.125%20524.471%20430.125%20524.575ZM433.875%20524.575C433.875%20524.679%20433.838%20524.767%20433.765%20524.84C433.692%20524.913%20433.604%20524.95%20433.5%20524.95C433.396%20524.95%20433.308%20524.913%20433.235%20524.84C433.162%20524.767%20433.125%20524.679%20433.125%20524.575C433.125%20524.471%20433.162%20524.383%20433.235%20524.31C433.308%20524.237%20433.396%20524.2%20433.5%20524.2C433.604%20524.2%20433.692%20524.237%20433.765%20524.31C433.838%20524.383%20433.875%20524.471%20433.875%20524.575ZM437.625%20524.575C437.625%20524.679%20437.588%20524.767%20437.515%20524.84C437.442%20524.913%20437.354%20524.95%20437.25%20524.95C437.146%20524.95%20437.058%20524.913%20436.985%20524.84C436.912%20524.767%20436.875%20524.679%20436.875%20524.575C436.875%20524.471%20436.912%20524.383%20436.985%20524.31C437.058%20524.237%20437.146%20524.2%20437.25%20524.2C437.354%20524.2%20437.442%20524.237%20437.515%20524.31C437.588%20524.383%20437.625%20524.471%20437.625%20524.575ZM441.375%20524.575C441.375%20524.679%20441.338%20524.767%20441.265%20524.84C441.192%20524.913%20441.104%20524.95%20441%20524.95C440.896%20524.95%20440.808%20524.913%20440.735%20524.84C440.662%20524.767%20440.625%20524.679%20440.625%20524.575C440.625%20524.471%20440.662%20524.383%20440.735%20524.31C440.808%20524.237%20440.896%20524.2%20441%20524.2C441.104%20524.2%20441.192%20524.237%20441.265%20524.31C441.338%20524.383%20441.375%20524.471%20441.375%20524.575ZM445.125%20524.575C445.125%20524.679%20445.088%20524.767%20445.015%20524.84C444.942%20524.913%20444.853%20524.95%20444.75%20524.95C444.646%20524.95%20444.558%20524.913%20444.485%20524.84C444.412%20524.767%20444.375%20524.679%20444.375%20524.575C444.375%20524.471%20444.412%20524.383%20444.485%20524.31C444.558%20524.237%20444.646%20524.2%20444.75%20524.2C444.853%20524.2%20444.942%20524.237%20445.015%20524.31C445.088%20524.383%20445.125%20524.471%20445.125%20524.575ZM448.875%20524.575C448.875%20524.679%20448.838%20524.767%20448.765%20524.84C448.692%20524.913%20448.604%20524.95%20448.5%20524.95C448.396%20524.95%20448.308%20524.913%20448.235%20524.84C448.162%20524.767%20448.125%20524.679%20448.125%20524.575C448.125%20524.471%20448.162%20524.383%20448.235%20524.31C448.308%20524.237%20448.396%20524.2%20448.5%20524.2C448.604%20524.2%20448.692%20524.237%20448.765%20524.31C448.838%20524.383%20448.875%20524.471%20448.875%20524.575ZM452.625%20524.575C452.625%20524.679%20452.588%20524.767%20452.515%20524.84C452.442%20524.913%20452.354%20524.95%20452.25%20524.95C452.146%20524.95%20452.058%20524.913%20451.985%20524.84C451.912%20524.767%20451.875%20524.679%20451.875%20524.575C451.875%20524.471%20451.912%20524.383%20451.985%20524.31C452.058%20524.237%20452.146%20524.2%20452.25%20524.2C452.354%20524.2%20452.442%20524.237%20452.515%20524.31C452.588%20524.383%20452.625%20524.471%20452.625%20524.575ZM456.375%20524.575C456.375%20524.679%20456.338%20524.767%20456.265%20524.84C456.192%20524.913%20456.104%20524.95%20456%20524.95C455.896%20524.95%20455.808%20524.913%20455.735%20524.84C455.662%20524.767%20455.625%20524.679%20455.625%20524.575C455.625%20524.471%20455.662%20524.383%20455.735%20524.31C455.808%20524.237%20455.896%20524.2%20456%20524.2C456.104%20524.2%20456.192%20524.237%20456.265%20524.31C456.338%20524.383%20456.375%20524.471%20456.375%20524.575ZM460.125%20524.575C460.125%20524.679%20460.088%20524.767%20460.015%20524.84C459.942%20524.913%20459.854%20524.95%20459.75%20524.95C459.646%20524.95%20459.558%20524.913%20459.485%20524.84C459.412%20524.767%20459.375%20524.679%20459.375%20524.575C459.375%20524.471%20459.412%20524.383%20459.485%20524.31C459.558%20524.237%20459.646%20524.2%20459.75%20524.2C459.854%20524.2%20459.942%20524.237%20460.015%20524.31C460.088%20524.383%20460.125%20524.471%20460.125%20524.575ZM463.875%20524.575C463.875%20524.679%20463.838%20524.767%20463.765%20524.84C463.692%20524.913%20463.604%20524.95%20463.5%20524.95C463.396%20524.95%20463.308%20524.913%20463.235%20524.84C463.162%20524.767%20463.125%20524.679%20463.125%20524.575C463.125%20524.471%20463.162%20524.383%20463.235%20524.31C463.308%20524.237%20463.396%20524.2%20463.5%20524.2C463.604%20524.2%20463.692%20524.237%20463.765%20524.31C463.838%20524.383%20463.875%20524.471%20463.875%20524.575ZM467.625%20524.575C467.625%20524.679%20467.588%20524.767%20467.515%20524.84C467.442%20524.913%20467.353%20524.95%20467.25%20524.95C467.146%20524.95%20467.058%20524.913%20466.985%20524.84C466.912%20524.767%20466.875%20524.679%20466.875%20524.575C466.875%20524.471%20466.912%20524.383%20466.985%20524.31C467.058%20524.237%20467.146%20524.2%20467.25%20524.2C467.353%20524.2%20467.442%20524.237%20467.515%20524.31C467.588%20524.383%20467.625%20524.471%20467.625%20524.575ZM471.375%20524.575C471.375%20524.679%20471.338%20524.767%20471.265%20524.84C471.192%20524.913%20471.103%20524.95%20471%20524.95C470.896%20524.95%20470.808%20524.913%20470.735%20524.84C470.662%20524.767%20470.625%20524.679%20470.625%20524.575C470.625%20524.471%20470.662%20524.383%20470.735%20524.31C470.808%20524.237%20470.896%20524.2%20471%20524.2C471.103%20524.2%20471.192%20524.237%20471.265%20524.31C471.338%20524.383%20471.375%20524.471%20471.375%20524.575ZM475.125%20524.575C475.125%20524.679%20475.088%20524.767%20475.015%20524.84C474.942%20524.913%20474.854%20524.95%20474.75%20524.95C474.646%20524.95%20474.558%20524.913%20474.485%20524.84C474.412%20524.767%20474.375%20524.679%20474.375%20524.575C474.375%20524.471%20474.412%20524.383%20474.485%20524.31C474.558%20524.237%20474.646%20524.2%20474.75%20524.2C474.854%20524.2%20474.942%20524.237%20475.015%20524.31C475.088%20524.383%20475.125%20524.471%20475.125%20524.575ZM478.875%20524.575C478.875%20524.679%20478.838%20524.767%20478.765%20524.84C478.692%20524.913%20478.604%20524.95%20478.5%20524.95C478.396%20524.95%20478.308%20524.913%20478.235%20524.84C478.162%20524.767%20478.125%20524.679%20478.125%20524.575C478.125%20524.471%20478.162%20524.383%20478.235%20524.31C478.308%20524.237%20478.396%20524.2%20478.5%20524.2C478.604%20524.2%20478.692%20524.237%20478.765%20524.31C478.838%20524.383%20478.875%20524.471%20478.875%20524.575ZM482.625%20524.575C482.625%20524.679%20482.588%20524.767%20482.515%20524.84C482.442%20524.913%20482.354%20524.95%20482.25%20524.95C482.146%20524.95%20482.058%20524.913%20481.985%20524.84C481.912%20524.767%20481.875%20524.679%20481.875%20524.575C481.875%20524.471%20481.912%20524.383%20481.985%20524.31C482.058%20524.237%20482.146%20524.2%20482.25%20524.2C482.354%20524.2%20482.442%20524.237%20482.515%20524.31C482.588%20524.383%20482.625%20524.471%20482.625%20524.575ZM486.375%20524.575C486.375%20524.679%20486.338%20524.767%20486.265%20524.84C486.192%20524.913%20486.104%20524.95%20486%20524.95C485.896%20524.95%20485.808%20524.913%20485.735%20524.84C485.662%20524.767%20485.625%20524.679%20485.625%20524.575C485.625%20524.471%20485.662%20524.383%20485.735%20524.31C485.808%20524.237%20485.896%20524.2%20486%20524.2C486.104%20524.2%20486.192%20524.237%20486.265%20524.31C486.338%20524.383%20486.375%20524.471%20486.375%20524.575ZM490.125%20524.575C490.125%20524.679%20490.088%20524.767%20490.015%20524.84C489.942%20524.913%20489.854%20524.95%20489.75%20524.95C489.646%20524.95%20489.558%20524.913%20489.485%20524.84C489.412%20524.767%20489.375%20524.679%20489.375%20524.575C489.375%20524.471%20489.412%20524.383%20489.485%20524.31C489.558%20524.237%20489.646%20524.2%20489.75%20524.2C489.854%20524.2%20489.942%20524.237%20490.015%20524.31C490.088%20524.383%20490.125%20524.471%20490.125%20524.575ZM493.875%20524.575C493.875%20524.679%20493.838%20524.767%20493.765%20524.84C493.692%20524.913%20493.604%20524.95%20493.5%20524.95C493.396%20524.95%20493.308%20524.913%20493.235%20524.84C493.162%20524.767%20493.125%20524.679%20493.125%20524.575C493.125%20524.471%20493.162%20524.383%20493.235%20524.31C493.308%20524.237%20493.396%20524.2%20493.5%20524.2C493.604%20524.2%20493.692%20524.237%20493.765%20524.31C493.838%20524.383%20493.875%20524.471%20493.875%20524.575ZM497.625%20524.575C497.625%20524.679%20497.588%20524.767%20497.515%20524.84C497.442%20524.913%20497.354%20524.95%20497.25%20524.95C497.146%20524.95%20497.058%20524.913%20496.985%20524.84C496.912%20524.767%20496.875%20524.679%20496.875%20524.575C496.875%20524.471%20496.912%20524.383%20496.985%20524.31C497.058%20524.237%20497.146%20524.2%20497.25%20524.2C497.354%20524.2%20497.442%20524.237%20497.515%20524.31C497.588%20524.383%20497.625%20524.471%20497.625%20524.575ZM501.375%20524.575C501.375%20524.679%20501.338%20524.767%20501.265%20524.84C501.192%20524.913%20501.104%20524.95%20501%20524.95C500.896%20524.95%20500.808%20524.913%20500.735%20524.84C500.662%20524.767%20500.625%20524.679%20500.625%20524.575C500.625%20524.471%20500.662%20524.383%20500.735%20524.31C500.808%20524.237%20500.896%20524.2%20501%20524.2C501.104%20524.2%20501.192%20524.237%20501.265%20524.31C501.338%20524.383%20501.375%20524.471%20501.375%20524.575ZM505.125%20524.575C505.125%20524.679%20505.088%20524.767%20505.015%20524.84C504.942%20524.913%20504.853%20524.95%20504.75%20524.95C504.646%20524.95%20504.558%20524.913%20504.485%20524.84C504.412%20524.767%20504.375%20524.679%20504.375%20524.575C504.375%20524.471%20504.412%20524.383%20504.485%20524.31C504.558%20524.237%20504.646%20524.2%20504.75%20524.2C504.853%20524.2%20504.942%20524.237%20505.015%20524.31C505.088%20524.383%20505.125%20524.471%20505.125%20524.575ZM508.875%20524.575C508.875%20524.679%20508.838%20524.767%20508.765%20524.84C508.692%20524.913%20508.603%20524.95%20508.5%20524.95C508.396%20524.95%20508.308%20524.913%20508.235%20524.84C508.162%20524.767%20508.125%20524.679%20508.125%20524.575C508.125%20524.471%20508.162%20524.383%20508.235%20524.31C508.308%20524.237%20508.396%20524.2%20508.5%20524.2C508.603%20524.2%20508.692%20524.237%20508.765%20524.31C508.838%20524.383%20508.875%20524.471%20508.875%20524.575ZM512.625%20524.575C512.625%20524.679%20512.588%20524.767%20512.515%20524.84C512.442%20524.913%20512.353%20524.95%20512.25%20524.95C512.146%20524.95%20512.058%20524.913%20511.985%20524.84C511.912%20524.767%20511.875%20524.679%20511.875%20524.575C511.875%20524.471%20511.912%20524.383%20511.985%20524.31C512.058%20524.237%20512.146%20524.2%20512.25%20524.2C512.353%20524.2%20512.442%20524.237%20512.515%20524.31C512.588%20524.383%20512.625%20524.471%20512.625%20524.575ZM516.375%20524.575C516.375%20524.679%20516.338%20524.767%20516.265%20524.84C516.192%20524.913%20516.104%20524.95%20516%20524.95C515.896%20524.95%20515.808%20524.913%20515.735%20524.84C515.662%20524.767%20515.625%20524.679%20515.625%20524.575C515.625%20524.471%20515.662%20524.383%20515.735%20524.31C515.808%20524.237%20515.896%20524.2%20516%20524.2C516.104%20524.2%20516.192%20524.237%20516.265%20524.31C516.338%20524.383%20516.375%20524.471%20516.375%20524.575ZM520.125%20524.575C520.125%20524.679%20520.088%20524.767%20520.015%20524.84C519.942%20524.913%20519.854%20524.95%20519.75%20524.95C519.646%20524.95%20519.558%20524.913%20519.485%20524.84C519.412%20524.767%20519.375%20524.679%20519.375%20524.575C519.375%20524.471%20519.412%20524.383%20519.485%20524.31C519.558%20524.237%20519.646%20524.2%20519.75%20524.2C519.854%20524.2%20519.942%20524.237%20520.015%20524.31C520.088%20524.383%20520.125%20524.471%20520.125%20524.575ZM523.875%20524.575C523.875%20524.679%20523.838%20524.767%20523.765%20524.84C523.692%20524.913%20523.603%20524.95%20523.5%20524.95C523.396%20524.95%20523.308%20524.913%20523.235%20524.84C523.162%20524.767%20523.125%20524.679%20523.125%20524.575C523.125%20524.471%20523.162%20524.383%20523.235%20524.31C523.308%20524.237%20523.396%20524.2%20523.5%20524.2C523.603%20524.2%20523.692%20524.237%20523.765%20524.31C523.838%20524.383%20523.875%20524.471%20523.875%20524.575ZM527.625%20524.575C527.625%20524.679%20527.588%20524.767%20527.515%20524.84C527.442%20524.913%20527.354%20524.95%20527.25%20524.95C527.146%20524.95%20527.058%20524.913%20526.985%20524.84C526.912%20524.767%20526.875%20524.679%20526.875%20524.575C526.875%20524.471%20526.912%20524.383%20526.985%20524.31C527.058%20524.237%20527.146%20524.2%20527.25%20524.2C527.354%20524.2%20527.442%20524.237%20527.515%20524.31C527.588%20524.383%20527.625%20524.471%20527.625%20524.575ZM531.375%20524.575C531.375%20524.679%20531.338%20524.767%20531.265%20524.84C531.192%20524.913%20531.104%20524.95%20531%20524.95C530.896%20524.95%20530.808%20524.913%20530.735%20524.84C530.662%20524.767%20530.625%20524.679%20530.625%20524.575C530.625%20524.471%20530.662%20524.383%20530.735%20524.31C530.808%20524.237%20530.896%20524.2%20531%20524.2C531.104%20524.2%20531.192%20524.237%20531.265%20524.31C531.338%20524.383%20531.375%20524.471%20531.375%20524.575ZM535.125%20524.575C535.125%20524.679%20535.088%20524.767%20535.015%20524.84C534.942%20524.913%20534.854%20524.95%20534.75%20524.95C534.646%20524.95%20534.558%20524.913%20534.485%20524.84C534.412%20524.767%20534.375%20524.679%20534.375%20524.575C534.375%20524.471%20534.412%20524.383%20534.485%20524.31C534.558%20524.237%20534.646%20524.2%20534.75%20524.2C534.854%20524.2%20534.942%20524.237%20535.015%20524.31C535.088%20524.383%20535.125%20524.471%20535.125%20524.575ZM538.875%20524.575C538.875%20524.679%20538.838%20524.767%20538.765%20524.84C538.692%20524.913%20538.604%20524.95%20538.5%20524.95C538.396%20524.95%20538.308%20524.913%20538.235%20524.84C538.162%20524.767%20538.125%20524.679%20538.125%20524.575C538.125%20524.471%20538.162%20524.383%20538.235%20524.31C538.308%20524.237%20538.396%20524.2%20538.5%20524.2C538.604%20524.2%20538.692%20524.237%20538.765%20524.31C538.838%20524.383%20538.875%20524.471%20538.875%20524.575ZM542.625%20524.575C542.625%20524.679%20542.588%20524.767%20542.515%20524.84C542.442%20524.913%20542.353%20524.95%20542.25%20524.95C542.146%20524.95%20542.058%20524.913%20541.985%20524.84C541.912%20524.767%20541.875%20524.679%20541.875%20524.575C541.875%20524.471%20541.912%20524.383%20541.985%20524.31C542.058%20524.237%20542.146%20524.2%20542.25%20524.2C542.353%20524.2%20542.442%20524.237%20542.515%20524.31C542.588%20524.383%20542.625%20524.471%20542.625%20524.575ZM546.375%20524.575C546.375%20524.679%20546.338%20524.767%20546.265%20524.84C546.192%20524.913%20546.103%20524.95%20546%20524.95C545.896%20524.95%20545.808%20524.913%20545.735%20524.84C545.662%20524.767%20545.625%20524.679%20545.625%20524.575C545.625%20524.471%20545.662%20524.383%20545.735%20524.31C545.808%20524.237%20545.896%20524.2%20546%20524.2C546.103%20524.2%20546.192%20524.237%20546.265%20524.31C546.338%20524.383%20546.375%20524.471%20546.375%20524.575ZM550.125%20524.575C550.125%20524.679%20550.088%20524.767%20550.015%20524.84C549.942%20524.913%20549.853%20524.95%20549.75%20524.95C549.646%20524.95%20549.558%20524.913%20549.485%20524.84C549.412%20524.767%20549.375%20524.679%20549.375%20524.575C549.375%20524.471%20549.412%20524.383%20549.485%20524.31C549.558%20524.237%20549.646%20524.2%20549.75%20524.2C549.853%20524.2%20549.942%20524.237%20550.015%20524.31C550.088%20524.383%20550.125%20524.471%20550.125%20524.575ZM553.875%20524.575C553.875%20524.679%20553.838%20524.767%20553.765%20524.84C553.692%20524.913%20553.603%20524.95%20553.5%20524.95C553.396%20524.95%20553.308%20524.913%20553.235%20524.84C553.162%20524.767%20553.125%20524.679%20553.125%20524.575C553.125%20524.471%20553.162%20524.383%20553.235%20524.31C553.308%20524.237%20553.396%20524.2%20553.5%20524.2C553.603%20524.2%20553.692%20524.237%20553.765%20524.31C553.838%20524.383%20553.875%20524.471%20553.875%20524.575ZM557.625%20524.575C557.625%20524.679%20557.588%20524.767%20557.515%20524.84C557.442%20524.913%20557.353%20524.95%20557.25%20524.95C557.146%20524.95%20557.058%20524.913%20556.985%20524.84C556.912%20524.767%20556.875%20524.679%20556.875%20524.575C556.875%20524.471%20556.912%20524.383%20556.985%20524.31C557.058%20524.237%20557.146%20524.2%20557.25%20524.2C557.353%20524.2%20557.442%20524.237%20557.515%20524.31C557.588%20524.383%20557.625%20524.471%20557.625%20524.575ZM561.375%20524.575C561.375%20524.679%20561.338%20524.767%20561.265%20524.84C561.192%20524.913%20561.104%20524.95%20561%20524.95C560.896%20524.95%20560.808%20524.913%20560.735%20524.84C560.662%20524.767%20560.625%20524.679%20560.625%20524.575C560.625%20524.471%20560.662%20524.383%20560.735%20524.31C560.808%20524.237%20560.896%20524.2%20561%20524.2C561.104%20524.2%20561.192%20524.237%20561.265%20524.31C561.338%20524.383%20561.375%20524.471%20561.375%20524.575ZM565.125%20524.575C565.125%20524.679%20565.088%20524.767%20565.015%20524.84C564.942%20524.913%20564.853%20524.95%20564.75%20524.95C564.646%20524.95%20564.558%20524.913%20564.485%20524.84C564.412%20524.767%20564.375%20524.679%20564.375%20524.575C564.375%20524.471%20564.412%20524.383%20564.485%20524.31C564.558%20524.237%20564.646%20524.2%20564.75%20524.2C564.853%20524.2%20564.942%20524.237%20565.015%20524.31C565.088%20524.383%20565.125%20524.471%20565.125%20524.575ZM568.875%20524.575C568.875%20524.679%20568.838%20524.767%20568.765%20524.84C568.692%20524.913%20568.604%20524.95%20568.5%20524.95C568.396%20524.95%20568.308%20524.913%20568.235%20524.84C568.162%20524.767%20568.125%20524.679%20568.125%20524.575C568.125%20524.471%20568.162%20524.383%20568.235%20524.31C568.308%20524.237%20568.396%20524.2%20568.5%20524.2C568.604%20524.2%20568.692%20524.237%20568.765%20524.31C568.838%20524.383%20568.875%20524.471%20568.875%20524.575ZM572.625%20524.575C572.625%20524.679%20572.588%20524.767%20572.515%20524.84C572.442%20524.913%20572.354%20524.95%20572.25%20524.95C572.146%20524.95%20572.058%20524.913%20571.985%20524.84C571.912%20524.767%20571.875%20524.679%20571.875%20524.575C571.875%20524.471%20571.912%20524.383%20571.985%20524.31C572.058%20524.237%20572.146%20524.2%20572.25%20524.2C572.354%20524.2%20572.442%20524.237%20572.515%20524.31C572.588%20524.383%20572.625%20524.471%20572.625%20524.575ZM576.375%20524.575C576.375%20524.679%20576.338%20524.767%20576.265%20524.84C576.192%20524.913%20576.104%20524.95%20576%20524.95C575.896%20524.95%20575.808%20524.913%20575.735%20524.84C575.662%20524.767%20575.625%20524.679%20575.625%20524.575C575.625%20524.471%20575.662%20524.383%20575.735%20524.31C575.808%20524.237%20575.896%20524.2%20576%20524.2C576.104%20524.2%20576.192%20524.237%20576.265%20524.31C576.338%20524.383%20576.375%20524.471%20576.375%20524.575ZM580.125%20524.575C580.125%20524.679%20580.088%20524.767%20580.015%20524.84C579.942%20524.913%20579.853%20524.95%20579.75%20524.95C579.646%20524.95%20579.558%20524.913%20579.485%20524.84C579.412%20524.767%20579.375%20524.679%20579.375%20524.575C579.375%20524.471%20579.412%20524.383%20579.485%20524.31C579.558%20524.237%20579.646%20524.2%20579.75%20524.2C579.853%20524.2%20579.942%20524.237%20580.015%20524.31C580.088%20524.383%20580.125%20524.471%20580.125%20524.575ZM583.875%20524.575C583.875%20524.679%20583.838%20524.767%20583.765%20524.84C583.692%20524.913%20583.604%20524.95%20583.5%20524.95C583.396%20524.95%20583.308%20524.913%20583.235%20524.84C583.162%20524.767%20583.125%20524.679%20583.125%20524.575C583.125%20524.471%20583.162%20524.383%20583.235%20524.31C583.308%20524.237%20583.396%20524.2%20583.5%20524.2C583.604%20524.2%20583.692%20524.237%20583.765%20524.31C583.838%20524.383%20583.875%20524.471%20583.875%20524.575ZM587.625%20524.575C587.625%20524.679%20587.588%20524.767%20587.515%20524.84C587.442%20524.913%20587.354%20524.95%20587.25%20524.95C587.146%20524.95%20587.058%20524.913%20586.985%20524.84C586.912%20524.767%20586.875%20524.679%20586.875%20524.575C586.875%20524.471%20586.912%20524.383%20586.985%20524.31C587.058%20524.237%20587.146%20524.2%20587.25%20524.2C587.354%20524.2%20587.442%20524.237%20587.515%20524.31C587.588%20524.383%20587.625%20524.471%20587.625%20524.575ZM591.375%20524.575C591.375%20524.679%20591.338%20524.767%20591.265%20524.84C591.192%20524.913%20591.104%20524.95%20591%20524.95C590.896%20524.95%20590.808%20524.913%20590.735%20524.84C590.662%20524.767%20590.625%20524.679%20590.625%20524.575C590.625%20524.471%20590.662%20524.383%20590.735%20524.31C590.808%20524.237%20590.896%20524.2%20591%20524.2C591.104%20524.2%20591.192%20524.237%20591.265%20524.31C591.338%20524.383%20591.375%20524.471%20591.375%20524.575ZM595.125%20524.575C595.125%20524.679%20595.088%20524.767%20595.015%20524.84C594.942%20524.913%20594.854%20524.95%20594.75%20524.95C594.646%20524.95%20594.558%20524.913%20594.485%20524.84C594.412%20524.767%20594.375%20524.679%20594.375%20524.575C594.375%20524.471%20594.412%20524.383%20594.485%20524.31C594.558%20524.237%20594.646%20524.2%20594.75%20524.2C594.854%20524.2%20594.942%20524.237%20595.015%20524.31C595.088%20524.383%20595.125%20524.471%20595.125%20524.575ZM598.875%20524.575C598.875%20524.679%20598.838%20524.767%20598.765%20524.84C598.692%20524.913%20598.604%20524.95%20598.5%20524.95C598.396%20524.95%20598.308%20524.913%20598.235%20524.84C598.162%20524.767%20598.125%20524.679%20598.125%20524.575C598.125%20524.471%20598.162%20524.383%20598.235%20524.31C598.308%20524.237%20598.396%20524.2%20598.5%20524.2C598.604%20524.2%20598.692%20524.237%20598.765%20524.31C598.838%20524.383%20598.875%20524.471%20598.875%20524.575ZM602.625%20524.575C602.625%20524.679%20602.588%20524.767%20602.515%20524.84C602.442%20524.913%20602.354%20524.95%20602.25%20524.95C602.146%20524.95%20602.058%20524.913%20601.985%20524.84C601.912%20524.767%20601.875%20524.679%20601.875%20524.575C601.875%20524.471%20601.912%20524.383%20601.985%20524.31C602.058%20524.237%20602.146%20524.2%20602.25%20524.2C602.354%20524.2%20602.442%20524.237%20602.515%20524.31C602.588%20524.383%20602.625%20524.471%20602.625%20524.575ZM606.375%20524.575C606.375%20524.679%20606.338%20524.767%20606.265%20524.84C606.192%20524.913%20606.104%20524.95%20606%20524.95C605.896%20524.95%20605.808%20524.913%20605.735%20524.84C605.662%20524.767%20605.625%20524.679%20605.625%20524.575C605.625%20524.471%20605.662%20524.383%20605.735%20524.31C605.808%20524.237%20605.896%20524.2%20606%20524.2C606.104%20524.2%20606.192%20524.237%20606.265%20524.31C606.338%20524.383%20606.375%20524.471%20606.375%20524.575ZM610.125%20524.575C610.125%20524.679%20610.088%20524.767%20610.015%20524.84C609.942%20524.913%20609.854%20524.95%20609.75%20524.95C609.646%20524.95%20609.558%20524.913%20609.485%20524.84C609.412%20524.767%20609.375%20524.679%20609.375%20524.575C609.375%20524.471%20609.412%20524.383%20609.485%20524.31C609.558%20524.237%20609.646%20524.2%20609.75%20524.2C609.854%20524.2%20609.942%20524.237%20610.015%20524.31C610.088%20524.383%20610.125%20524.471%20610.125%20524.575ZM613.875%20524.575C613.875%20524.679%20613.838%20524.767%20613.765%20524.84C613.692%20524.913%20613.604%20524.95%20613.5%20524.95C613.396%20524.95%20613.308%20524.913%20613.235%20524.84C613.162%20524.767%20613.125%20524.679%20613.125%20524.575C613.125%20524.471%20613.162%20524.383%20613.235%20524.31C613.308%20524.237%20613.396%20524.2%20613.5%20524.2C613.604%20524.2%20613.692%20524.237%20613.765%20524.31C613.838%20524.383%20613.875%20524.471%20613.875%20524.575ZM617.625%20524.575C617.625%20524.679%20617.588%20524.767%20617.515%20524.84C617.442%20524.913%20617.354%20524.95%20617.25%20524.95C617.146%20524.95%20617.058%20524.913%20616.985%20524.84C616.912%20524.767%20616.875%20524.679%20616.875%20524.575C616.875%20524.471%20616.912%20524.383%20616.985%20524.31C617.058%20524.237%20617.146%20524.2%20617.25%20524.2C617.354%20524.2%20617.442%20524.237%20617.515%20524.31C617.588%20524.383%20617.625%20524.471%20617.625%20524.575ZM621.375%20524.575C621.375%20524.679%20621.338%20524.767%20621.265%20524.84C621.192%20524.913%20621.104%20524.95%20621%20524.95C620.896%20524.95%20620.808%20524.913%20620.735%20524.84C620.662%20524.767%20620.625%20524.679%20620.625%20524.575C620.625%20524.471%20620.662%20524.383%20620.735%20524.31C620.808%20524.237%20620.896%20524.2%20621%20524.2C621.104%20524.2%20621.192%20524.237%20621.265%20524.31C621.338%20524.383%20621.375%20524.471%20621.375%20524.575ZM625.125%20524.575C625.125%20524.679%20625.088%20524.767%20625.015%20524.84C624.942%20524.913%20624.854%20524.95%20624.75%20524.95C624.646%20524.95%20624.558%20524.913%20624.485%20524.84C624.412%20524.767%20624.375%20524.679%20624.375%20524.575C624.375%20524.471%20624.412%20524.383%20624.485%20524.31C624.558%20524.237%20624.646%20524.2%20624.75%20524.2C624.854%20524.2%20624.942%20524.237%20625.015%20524.31C625.088%20524.383%20625.125%20524.471%20625.125%20524.575ZM628.875%20524.575C628.875%20524.679%20628.838%20524.767%20628.765%20524.84C628.692%20524.913%20628.604%20524.95%20628.5%20524.95C628.396%20524.95%20628.308%20524.913%20628.235%20524.84C628.162%20524.767%20628.125%20524.679%20628.125%20524.575C628.125%20524.471%20628.162%20524.383%20628.235%20524.31C628.308%20524.237%20628.396%20524.2%20628.5%20524.2C628.604%20524.2%20628.692%20524.237%20628.765%20524.31C628.838%20524.383%20628.875%20524.471%20628.875%20524.575ZM632.625%20524.575C632.625%20524.679%20632.588%20524.767%20632.515%20524.84C632.442%20524.913%20632.354%20524.95%20632.25%20524.95C632.146%20524.95%20632.058%20524.913%20631.985%20524.84C631.912%20524.767%20631.875%20524.679%20631.875%20524.575C631.875%20524.471%20631.912%20524.383%20631.985%20524.31C632.058%20524.237%20632.146%20524.2%20632.25%20524.2C632.354%20524.2%20632.442%20524.237%20632.515%20524.31C632.588%20524.383%20632.625%20524.471%20632.625%20524.575ZM636.375%20524.575C636.375%20524.679%20636.338%20524.767%20636.265%20524.84C636.192%20524.913%20636.104%20524.95%20636%20524.95C635.896%20524.95%20635.808%20524.913%20635.735%20524.84C635.662%20524.767%20635.625%20524.679%20635.625%20524.575C635.625%20524.471%20635.662%20524.383%20635.735%20524.31C635.808%20524.237%20635.896%20524.2%20636%20524.2C636.104%20524.2%20636.192%20524.237%20636.265%20524.31C636.338%20524.383%20636.375%20524.471%20636.375%20524.575Z'%20fill='%23B4BAC3'%20/%3e%3cg%20filter='url(%23filter3_f_12_1053)'%3e%3cpath%20d='M51.6686%20523.301H51.9892V523.868C52.563%20523.886%2053.0288%20524.007%2053.3866%20524.23L53.2178%20524.705C53.0806%20524.629%2052.8994%20524.56%2052.6744%20524.5C52.4516%20524.437%2052.2232%20524.399%2051.9892%20524.388V526.103L52.3403%20526.187C52.7453%20526.284%2053.0524%20526.439%2053.2617%20526.653C53.471%20526.864%2053.5756%20527.166%2053.5756%20527.558C53.5756%20528.041%2053.4338%20528.411%2053.1503%20528.668C52.869%20528.924%2052.482%20529.065%2051.9892%20529.09V529.674H51.6686V529.09C51.3086%20529.079%2050.9868%20529.034%2050.7033%20528.955C50.422%20528.874%2050.197%20528.782%2050.0282%20528.678L50.2037%20528.192C50.6583%20528.415%2051.1465%20528.541%2051.6686%20528.57V526.612L51.1724%20526.488C50.4141%20526.296%2050.035%20525.891%2050.035%20525.272C50.035%20524.829%2050.179%20524.493%2050.467%20524.263C50.755%20524.032%2051.1555%20523.902%2051.6686%20523.875V523.301ZM51.6686%20526.025V524.392C50.9845%20524.432%2050.6425%20524.712%2050.6425%20525.232C50.6425%20525.423%2050.7044%20525.577%2050.8281%20525.694C50.9542%20525.809%2051.142%20525.897%2051.3918%20525.958L51.6686%20526.025ZM51.9892%20526.693V528.573C52.644%20528.54%2052.9714%20528.208%2052.9714%20527.578C52.9714%20527.362%2052.9129%20527.187%2052.7959%20527.055C52.6812%20526.92%2052.4708%20526.814%2052.1647%20526.737L51.9892%20526.693ZM56.7854%20528.897C56.5627%20529.028%2056.3017%20529.093%2056.0024%20529.093C55.7031%20529.093%2055.441%20529.028%2055.216%20528.897C54.9909%20528.765%2054.8098%20528.579%2054.6725%20528.341C54.5375%20528.102%2054.4363%20527.828%2054.3688%20527.517C54.3035%20527.206%2054.2709%20526.861%2054.2709%20526.481C54.2709%20526.168%2054.2923%20525.879%2054.335%20525.613C54.38%20525.348%2054.4487%20525.107%2054.5409%20524.891C54.6332%20524.675%2054.7468%20524.492%2054.8818%20524.341C55.0191%20524.19%2055.1822%20524.074%2055.3712%20523.993C55.5602%20523.91%2055.7706%20523.868%2056.0024%20523.868C56.2904%20523.868%2056.5447%20523.931%2056.7652%20524.057C56.988%20524.183%2057.168%20524.363%2057.3052%20524.597C57.4447%20524.829%2057.5494%20525.104%2057.6191%20525.421C57.6889%20525.736%2057.7238%20526.089%2057.7238%20526.481C57.7238%20526.861%2057.6911%20527.206%2057.6259%20527.517C57.5606%20527.828%2057.4605%20528.102%2057.3255%20528.341C57.1905%20528.579%2057.0105%20528.765%2056.7854%20528.897ZM56.5931%20524.655C56.4288%20524.473%2056.2319%20524.381%2056.0024%20524.381C55.7729%20524.381%2055.576%20524.473%2055.4117%20524.655C55.2475%20524.835%2055.1237%20525.08%2055.0404%20525.391C54.9594%20525.699%2054.9189%20526.056%2054.9189%20526.461C54.9189%20526.872%2054.9594%20527.237%2055.0404%20527.554C55.1237%20527.869%2055.2475%20528.119%2055.4117%20528.303C55.576%20528.488%2055.7729%20528.58%2056.0024%20528.58C56.2319%20528.58%2056.4288%20528.488%2056.5931%20528.303C56.7573%20528.119%2056.88%20527.869%2056.961%20527.554C57.0442%20527.237%2057.0858%20526.872%2057.0858%20526.461C57.0858%20526.056%2057.0442%20525.699%2056.961%20525.391C56.88%20525.08%2056.7573%20524.835%2056.5931%20524.655ZM62.3479%20529.016H61.6323L59.7219%20526.633L59.2663%20527.034V529.016H58.679V524.024H59.2663V526.474L61.4602%20524.024H62.1926L60.1674%20526.272L62.3479%20529.016Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cpath%20d='M70.125%20468.35C70.125%20468.454%2070.0884%20468.542%2070.0152%20468.615C69.9419%20468.688%2069.8536%20468.725%2069.75%20468.725C69.6464%20468.725%2069.5581%20468.688%2069.4848%20468.615C69.4116%20468.542%2069.375%20468.454%2069.375%20468.35C69.375%20468.247%2069.4116%20468.158%2069.4848%20468.085C69.5581%20468.012%2069.6464%20467.975%2069.75%20467.975C69.8536%20467.975%2069.9419%20468.012%2070.0152%20468.085C70.0884%20468.158%2070.125%20468.247%2070.125%20468.35ZM73.875%20468.35C73.875%20468.454%2073.8384%20468.542%2073.7652%20468.615C73.6919%20468.688%2073.6036%20468.725%2073.5%20468.725C73.3964%20468.725%2073.3081%20468.688%2073.2348%20468.615C73.1616%20468.542%2073.125%20468.454%2073.125%20468.35C73.125%20468.247%2073.1616%20468.158%2073.2348%20468.085C73.3081%20468.012%2073.3964%20467.975%2073.5%20467.975C73.6036%20467.975%2073.6919%20468.012%2073.7652%20468.085C73.8384%20468.158%2073.875%20468.247%2073.875%20468.35ZM77.625%20468.35C77.625%20468.454%2077.5884%20468.542%2077.5152%20468.615C77.4419%20468.688%2077.3536%20468.725%2077.25%20468.725C77.1464%20468.725%2077.0581%20468.688%2076.9848%20468.615C76.9116%20468.542%2076.875%20468.454%2076.875%20468.35C76.875%20468.247%2076.9116%20468.158%2076.9848%20468.085C77.0581%20468.012%2077.1464%20467.975%2077.25%20467.975C77.3536%20467.975%2077.4419%20468.012%2077.5152%20468.085C77.5884%20468.158%2077.625%20468.247%2077.625%20468.35ZM81.375%20468.35C81.375%20468.454%2081.3384%20468.542%2081.2652%20468.615C81.1919%20468.688%2081.1036%20468.725%2081%20468.725C80.8964%20468.725%2080.8081%20468.688%2080.7348%20468.615C80.6616%20468.542%2080.625%20468.454%2080.625%20468.35C80.625%20468.247%2080.6616%20468.158%2080.7348%20468.085C80.8081%20468.012%2080.8964%20467.975%2081%20467.975C81.1036%20467.975%2081.1919%20468.012%2081.2652%20468.085C81.3384%20468.158%2081.375%20468.247%2081.375%20468.35ZM85.125%20468.35C85.125%20468.454%2085.0884%20468.542%2085.0152%20468.615C84.9419%20468.688%2084.8536%20468.725%2084.75%20468.725C84.6464%20468.725%2084.5581%20468.688%2084.4848%20468.615C84.4116%20468.542%2084.375%20468.454%2084.375%20468.35C84.375%20468.247%2084.4116%20468.158%2084.4848%20468.085C84.5581%20468.012%2084.6464%20467.975%2084.75%20467.975C84.8536%20467.975%2084.9419%20468.012%2085.0152%20468.085C85.0884%20468.158%2085.125%20468.247%2085.125%20468.35ZM88.875%20468.35C88.875%20468.454%2088.8384%20468.542%2088.7652%20468.615C88.6919%20468.688%2088.6036%20468.725%2088.5%20468.725C88.3964%20468.725%2088.3081%20468.688%2088.2348%20468.615C88.1616%20468.542%2088.125%20468.454%2088.125%20468.35C88.125%20468.247%2088.1616%20468.158%2088.2348%20468.085C88.3081%20468.012%2088.3964%20467.975%2088.5%20467.975C88.6036%20467.975%2088.6919%20468.012%2088.7652%20468.085C88.8384%20468.158%2088.875%20468.247%2088.875%20468.35ZM92.625%20468.35C92.625%20468.454%2092.5884%20468.542%2092.5152%20468.615C92.4419%20468.688%2092.3536%20468.725%2092.25%20468.725C92.1464%20468.725%2092.0581%20468.688%2091.9848%20468.615C91.9116%20468.542%2091.875%20468.454%2091.875%20468.35C91.875%20468.247%2091.9116%20468.158%2091.9848%20468.085C92.0581%20468.012%2092.1464%20467.975%2092.25%20467.975C92.3536%20467.975%2092.4419%20468.012%2092.5152%20468.085C92.5884%20468.158%2092.625%20468.247%2092.625%20468.35ZM96.375%20468.35C96.375%20468.454%2096.3384%20468.542%2096.2652%20468.615C96.1919%20468.688%2096.1036%20468.725%2096%20468.725C95.8964%20468.725%2095.8081%20468.688%2095.7348%20468.615C95.6616%20468.542%2095.625%20468.454%2095.625%20468.35C95.625%20468.247%2095.6616%20468.158%2095.7348%20468.085C95.8081%20468.012%2095.8964%20467.975%2096%20467.975C96.1036%20467.975%2096.1919%20468.012%2096.2652%20468.085C96.3384%20468.158%2096.375%20468.247%2096.375%20468.35ZM100.125%20468.35C100.125%20468.454%20100.088%20468.542%20100.015%20468.615C99.9419%20468.688%2099.8536%20468.725%2099.75%20468.725C99.6464%20468.725%2099.5581%20468.688%2099.4848%20468.615C99.4116%20468.542%2099.375%20468.454%2099.375%20468.35C99.375%20468.247%2099.4116%20468.158%2099.4848%20468.085C99.5581%20468.012%2099.6464%20467.975%2099.75%20467.975C99.8536%20467.975%2099.9419%20468.012%20100.015%20468.085C100.088%20468.158%20100.125%20468.247%20100.125%20468.35ZM103.875%20468.35C103.875%20468.454%20103.838%20468.542%20103.765%20468.615C103.692%20468.688%20103.604%20468.725%20103.5%20468.725C103.396%20468.725%20103.308%20468.688%20103.235%20468.615C103.162%20468.542%20103.125%20468.454%20103.125%20468.35C103.125%20468.247%20103.162%20468.158%20103.235%20468.085C103.308%20468.012%20103.396%20467.975%20103.5%20467.975C103.604%20467.975%20103.692%20468.012%20103.765%20468.085C103.838%20468.158%20103.875%20468.247%20103.875%20468.35ZM107.625%20468.35C107.625%20468.454%20107.588%20468.542%20107.515%20468.615C107.442%20468.688%20107.354%20468.725%20107.25%20468.725C107.146%20468.725%20107.058%20468.688%20106.985%20468.615C106.912%20468.542%20106.875%20468.454%20106.875%20468.35C106.875%20468.247%20106.912%20468.158%20106.985%20468.085C107.058%20468.012%20107.146%20467.975%20107.25%20467.975C107.354%20467.975%20107.442%20468.012%20107.515%20468.085C107.588%20468.158%20107.625%20468.247%20107.625%20468.35ZM111.375%20468.35C111.375%20468.454%20111.338%20468.542%20111.265%20468.615C111.192%20468.688%20111.104%20468.725%20111%20468.725C110.896%20468.725%20110.808%20468.688%20110.735%20468.615C110.662%20468.542%20110.625%20468.454%20110.625%20468.35C110.625%20468.247%20110.662%20468.158%20110.735%20468.085C110.808%20468.012%20110.896%20467.975%20111%20467.975C111.104%20467.975%20111.192%20468.012%20111.265%20468.085C111.338%20468.158%20111.375%20468.247%20111.375%20468.35ZM115.125%20468.35C115.125%20468.454%20115.088%20468.542%20115.015%20468.615C114.942%20468.688%20114.854%20468.725%20114.75%20468.725C114.646%20468.725%20114.558%20468.688%20114.485%20468.615C114.412%20468.542%20114.375%20468.454%20114.375%20468.35C114.375%20468.247%20114.412%20468.158%20114.485%20468.085C114.558%20468.012%20114.646%20467.975%20114.75%20467.975C114.854%20467.975%20114.942%20468.012%20115.015%20468.085C115.088%20468.158%20115.125%20468.247%20115.125%20468.35ZM118.875%20468.35C118.875%20468.454%20118.838%20468.542%20118.765%20468.615C118.692%20468.688%20118.604%20468.725%20118.5%20468.725C118.396%20468.725%20118.308%20468.688%20118.235%20468.615C118.162%20468.542%20118.125%20468.454%20118.125%20468.35C118.125%20468.247%20118.162%20468.158%20118.235%20468.085C118.308%20468.012%20118.396%20467.975%20118.5%20467.975C118.604%20467.975%20118.692%20468.012%20118.765%20468.085C118.838%20468.158%20118.875%20468.247%20118.875%20468.35ZM122.625%20468.35C122.625%20468.454%20122.588%20468.542%20122.515%20468.615C122.442%20468.688%20122.354%20468.725%20122.25%20468.725C122.146%20468.725%20122.058%20468.688%20121.985%20468.615C121.912%20468.542%20121.875%20468.454%20121.875%20468.35C121.875%20468.247%20121.912%20468.158%20121.985%20468.085C122.058%20468.012%20122.146%20467.975%20122.25%20467.975C122.354%20467.975%20122.442%20468.012%20122.515%20468.085C122.588%20468.158%20122.625%20468.247%20122.625%20468.35ZM126.375%20468.35C126.375%20468.454%20126.338%20468.542%20126.265%20468.615C126.192%20468.688%20126.104%20468.725%20126%20468.725C125.896%20468.725%20125.808%20468.688%20125.735%20468.615C125.662%20468.542%20125.625%20468.454%20125.625%20468.35C125.625%20468.247%20125.662%20468.158%20125.735%20468.085C125.808%20468.012%20125.896%20467.975%20126%20467.975C126.104%20467.975%20126.192%20468.012%20126.265%20468.085C126.338%20468.158%20126.375%20468.247%20126.375%20468.35ZM130.125%20468.35C130.125%20468.454%20130.088%20468.542%20130.015%20468.615C129.942%20468.688%20129.854%20468.725%20129.75%20468.725C129.646%20468.725%20129.558%20468.688%20129.485%20468.615C129.412%20468.542%20129.375%20468.454%20129.375%20468.35C129.375%20468.247%20129.412%20468.158%20129.485%20468.085C129.558%20468.012%20129.646%20467.975%20129.75%20467.975C129.854%20467.975%20129.942%20468.012%20130.015%20468.085C130.088%20468.158%20130.125%20468.247%20130.125%20468.35ZM133.875%20468.35C133.875%20468.454%20133.838%20468.542%20133.765%20468.615C133.692%20468.688%20133.604%20468.725%20133.5%20468.725C133.396%20468.725%20133.308%20468.688%20133.235%20468.615C133.162%20468.542%20133.125%20468.454%20133.125%20468.35C133.125%20468.247%20133.162%20468.158%20133.235%20468.085C133.308%20468.012%20133.396%20467.975%20133.5%20467.975C133.604%20467.975%20133.692%20468.012%20133.765%20468.085C133.838%20468.158%20133.875%20468.247%20133.875%20468.35ZM137.625%20468.35C137.625%20468.454%20137.588%20468.542%20137.515%20468.615C137.442%20468.688%20137.354%20468.725%20137.25%20468.725C137.146%20468.725%20137.058%20468.688%20136.985%20468.615C136.912%20468.542%20136.875%20468.454%20136.875%20468.35C136.875%20468.247%20136.912%20468.158%20136.985%20468.085C137.058%20468.012%20137.146%20467.975%20137.25%20467.975C137.354%20467.975%20137.442%20468.012%20137.515%20468.085C137.588%20468.158%20137.625%20468.247%20137.625%20468.35ZM141.375%20468.35C141.375%20468.454%20141.338%20468.542%20141.265%20468.615C141.192%20468.688%20141.104%20468.725%20141%20468.725C140.896%20468.725%20140.808%20468.688%20140.735%20468.615C140.662%20468.542%20140.625%20468.454%20140.625%20468.35C140.625%20468.247%20140.662%20468.158%20140.735%20468.085C140.808%20468.012%20140.896%20467.975%20141%20467.975C141.104%20467.975%20141.192%20468.012%20141.265%20468.085C141.338%20468.158%20141.375%20468.247%20141.375%20468.35ZM145.125%20468.35C145.125%20468.454%20145.088%20468.542%20145.015%20468.615C144.942%20468.688%20144.854%20468.725%20144.75%20468.725C144.646%20468.725%20144.558%20468.688%20144.485%20468.615C144.412%20468.542%20144.375%20468.454%20144.375%20468.35C144.375%20468.247%20144.412%20468.158%20144.485%20468.085C144.558%20468.012%20144.646%20467.975%20144.75%20467.975C144.854%20467.975%20144.942%20468.012%20145.015%20468.085C145.088%20468.158%20145.125%20468.247%20145.125%20468.35ZM148.875%20468.35C148.875%20468.454%20148.838%20468.542%20148.765%20468.615C148.692%20468.688%20148.604%20468.725%20148.5%20468.725C148.396%20468.725%20148.308%20468.688%20148.235%20468.615C148.162%20468.542%20148.125%20468.454%20148.125%20468.35C148.125%20468.247%20148.162%20468.158%20148.235%20468.085C148.308%20468.012%20148.396%20467.975%20148.5%20467.975C148.604%20467.975%20148.692%20468.012%20148.765%20468.085C148.838%20468.158%20148.875%20468.247%20148.875%20468.35ZM152.625%20468.35C152.625%20468.454%20152.588%20468.542%20152.515%20468.615C152.442%20468.688%20152.354%20468.725%20152.25%20468.725C152.146%20468.725%20152.058%20468.688%20151.985%20468.615C151.912%20468.542%20151.875%20468.454%20151.875%20468.35C151.875%20468.247%20151.912%20468.158%20151.985%20468.085C152.058%20468.012%20152.146%20467.975%20152.25%20467.975C152.354%20467.975%20152.442%20468.012%20152.515%20468.085C152.588%20468.158%20152.625%20468.247%20152.625%20468.35ZM156.375%20468.35C156.375%20468.454%20156.338%20468.542%20156.265%20468.615C156.192%20468.688%20156.104%20468.725%20156%20468.725C155.896%20468.725%20155.808%20468.688%20155.735%20468.615C155.662%20468.542%20155.625%20468.454%20155.625%20468.35C155.625%20468.247%20155.662%20468.158%20155.735%20468.085C155.808%20468.012%20155.896%20467.975%20156%20467.975C156.104%20467.975%20156.192%20468.012%20156.265%20468.085C156.338%20468.158%20156.375%20468.247%20156.375%20468.35ZM160.125%20468.35C160.125%20468.454%20160.088%20468.542%20160.015%20468.615C159.942%20468.688%20159.854%20468.725%20159.75%20468.725C159.646%20468.725%20159.558%20468.688%20159.485%20468.615C159.412%20468.542%20159.375%20468.454%20159.375%20468.35C159.375%20468.247%20159.412%20468.158%20159.485%20468.085C159.558%20468.012%20159.646%20467.975%20159.75%20467.975C159.854%20467.975%20159.942%20468.012%20160.015%20468.085C160.088%20468.158%20160.125%20468.247%20160.125%20468.35ZM163.875%20468.35C163.875%20468.454%20163.838%20468.542%20163.765%20468.615C163.692%20468.688%20163.604%20468.725%20163.5%20468.725C163.396%20468.725%20163.308%20468.688%20163.235%20468.615C163.162%20468.542%20163.125%20468.454%20163.125%20468.35C163.125%20468.247%20163.162%20468.158%20163.235%20468.085C163.308%20468.012%20163.396%20467.975%20163.5%20467.975C163.604%20467.975%20163.692%20468.012%20163.765%20468.085C163.838%20468.158%20163.875%20468.247%20163.875%20468.35ZM167.625%20468.35C167.625%20468.454%20167.588%20468.542%20167.515%20468.615C167.442%20468.688%20167.354%20468.725%20167.25%20468.725C167.146%20468.725%20167.058%20468.688%20166.985%20468.615C166.912%20468.542%20166.875%20468.454%20166.875%20468.35C166.875%20468.247%20166.912%20468.158%20166.985%20468.085C167.058%20468.012%20167.146%20467.975%20167.25%20467.975C167.354%20467.975%20167.442%20468.012%20167.515%20468.085C167.588%20468.158%20167.625%20468.247%20167.625%20468.35ZM171.375%20468.35C171.375%20468.454%20171.338%20468.542%20171.265%20468.615C171.192%20468.688%20171.104%20468.725%20171%20468.725C170.896%20468.725%20170.808%20468.688%20170.735%20468.615C170.662%20468.542%20170.625%20468.454%20170.625%20468.35C170.625%20468.247%20170.662%20468.158%20170.735%20468.085C170.808%20468.012%20170.896%20467.975%20171%20467.975C171.104%20467.975%20171.192%20468.012%20171.265%20468.085C171.338%20468.158%20171.375%20468.247%20171.375%20468.35ZM175.125%20468.35C175.125%20468.454%20175.088%20468.542%20175.015%20468.615C174.942%20468.688%20174.854%20468.725%20174.75%20468.725C174.646%20468.725%20174.558%20468.688%20174.485%20468.615C174.412%20468.542%20174.375%20468.454%20174.375%20468.35C174.375%20468.247%20174.412%20468.158%20174.485%20468.085C174.558%20468.012%20174.646%20467.975%20174.75%20467.975C174.854%20467.975%20174.942%20468.012%20175.015%20468.085C175.088%20468.158%20175.125%20468.247%20175.125%20468.35ZM178.875%20468.35C178.875%20468.454%20178.838%20468.542%20178.765%20468.615C178.692%20468.688%20178.604%20468.725%20178.5%20468.725C178.396%20468.725%20178.308%20468.688%20178.235%20468.615C178.162%20468.542%20178.125%20468.454%20178.125%20468.35C178.125%20468.247%20178.162%20468.158%20178.235%20468.085C178.308%20468.012%20178.396%20467.975%20178.5%20467.975C178.604%20467.975%20178.692%20468.012%20178.765%20468.085C178.838%20468.158%20178.875%20468.247%20178.875%20468.35ZM182.625%20468.35C182.625%20468.454%20182.588%20468.542%20182.515%20468.615C182.442%20468.688%20182.354%20468.725%20182.25%20468.725C182.146%20468.725%20182.058%20468.688%20181.985%20468.615C181.912%20468.542%20181.875%20468.454%20181.875%20468.35C181.875%20468.247%20181.912%20468.158%20181.985%20468.085C182.058%20468.012%20182.146%20467.975%20182.25%20467.975C182.354%20467.975%20182.442%20468.012%20182.515%20468.085C182.588%20468.158%20182.625%20468.247%20182.625%20468.35ZM186.375%20468.35C186.375%20468.454%20186.338%20468.542%20186.265%20468.615C186.192%20468.688%20186.104%20468.725%20186%20468.725C185.896%20468.725%20185.808%20468.688%20185.735%20468.615C185.662%20468.542%20185.625%20468.454%20185.625%20468.35C185.625%20468.247%20185.662%20468.158%20185.735%20468.085C185.808%20468.012%20185.896%20467.975%20186%20467.975C186.104%20467.975%20186.192%20468.012%20186.265%20468.085C186.338%20468.158%20186.375%20468.247%20186.375%20468.35ZM190.125%20468.35C190.125%20468.454%20190.088%20468.542%20190.015%20468.615C189.942%20468.688%20189.854%20468.725%20189.75%20468.725C189.646%20468.725%20189.558%20468.688%20189.485%20468.615C189.412%20468.542%20189.375%20468.454%20189.375%20468.35C189.375%20468.247%20189.412%20468.158%20189.485%20468.085C189.558%20468.012%20189.646%20467.975%20189.75%20467.975C189.854%20467.975%20189.942%20468.012%20190.015%20468.085C190.088%20468.158%20190.125%20468.247%20190.125%20468.35ZM193.875%20468.35C193.875%20468.454%20193.838%20468.542%20193.765%20468.615C193.692%20468.688%20193.604%20468.725%20193.5%20468.725C193.396%20468.725%20193.308%20468.688%20193.235%20468.615C193.162%20468.542%20193.125%20468.454%20193.125%20468.35C193.125%20468.247%20193.162%20468.158%20193.235%20468.085C193.308%20468.012%20193.396%20467.975%20193.5%20467.975C193.604%20467.975%20193.692%20468.012%20193.765%20468.085C193.838%20468.158%20193.875%20468.247%20193.875%20468.35ZM197.625%20468.35C197.625%20468.454%20197.588%20468.542%20197.515%20468.615C197.442%20468.688%20197.354%20468.725%20197.25%20468.725C197.146%20468.725%20197.058%20468.688%20196.985%20468.615C196.912%20468.542%20196.875%20468.454%20196.875%20468.35C196.875%20468.247%20196.912%20468.158%20196.985%20468.085C197.058%20468.012%20197.146%20467.975%20197.25%20467.975C197.354%20467.975%20197.442%20468.012%20197.515%20468.085C197.588%20468.158%20197.625%20468.247%20197.625%20468.35ZM201.375%20468.35C201.375%20468.454%20201.338%20468.542%20201.265%20468.615C201.192%20468.688%20201.104%20468.725%20201%20468.725C200.896%20468.725%20200.808%20468.688%20200.735%20468.615C200.662%20468.542%20200.625%20468.454%20200.625%20468.35C200.625%20468.247%20200.662%20468.158%20200.735%20468.085C200.808%20468.012%20200.896%20467.975%20201%20467.975C201.104%20467.975%20201.192%20468.012%20201.265%20468.085C201.338%20468.158%20201.375%20468.247%20201.375%20468.35ZM205.125%20468.35C205.125%20468.454%20205.088%20468.542%20205.015%20468.615C204.942%20468.688%20204.854%20468.725%20204.75%20468.725C204.646%20468.725%20204.558%20468.688%20204.485%20468.615C204.412%20468.542%20204.375%20468.454%20204.375%20468.35C204.375%20468.247%20204.412%20468.158%20204.485%20468.085C204.558%20468.012%20204.646%20467.975%20204.75%20467.975C204.854%20467.975%20204.942%20468.012%20205.015%20468.085C205.088%20468.158%20205.125%20468.247%20205.125%20468.35ZM208.875%20468.35C208.875%20468.454%20208.838%20468.542%20208.765%20468.615C208.692%20468.688%20208.604%20468.725%20208.5%20468.725C208.396%20468.725%20208.308%20468.688%20208.235%20468.615C208.162%20468.542%20208.125%20468.454%20208.125%20468.35C208.125%20468.247%20208.162%20468.158%20208.235%20468.085C208.308%20468.012%20208.396%20467.975%20208.5%20467.975C208.604%20467.975%20208.692%20468.012%20208.765%20468.085C208.838%20468.158%20208.875%20468.247%20208.875%20468.35ZM212.625%20468.35C212.625%20468.454%20212.588%20468.542%20212.515%20468.615C212.442%20468.688%20212.354%20468.725%20212.25%20468.725C212.146%20468.725%20212.058%20468.688%20211.985%20468.615C211.912%20468.542%20211.875%20468.454%20211.875%20468.35C211.875%20468.247%20211.912%20468.158%20211.985%20468.085C212.058%20468.012%20212.146%20467.975%20212.25%20467.975C212.354%20467.975%20212.442%20468.012%20212.515%20468.085C212.588%20468.158%20212.625%20468.247%20212.625%20468.35ZM216.375%20468.35C216.375%20468.454%20216.338%20468.542%20216.265%20468.615C216.192%20468.688%20216.104%20468.725%20216%20468.725C215.896%20468.725%20215.808%20468.688%20215.735%20468.615C215.662%20468.542%20215.625%20468.454%20215.625%20468.35C215.625%20468.247%20215.662%20468.158%20215.735%20468.085C215.808%20468.012%20215.896%20467.975%20216%20467.975C216.104%20467.975%20216.192%20468.012%20216.265%20468.085C216.338%20468.158%20216.375%20468.247%20216.375%20468.35ZM220.125%20468.35C220.125%20468.454%20220.088%20468.542%20220.015%20468.615C219.942%20468.688%20219.854%20468.725%20219.75%20468.725C219.646%20468.725%20219.558%20468.688%20219.485%20468.615C219.412%20468.542%20219.375%20468.454%20219.375%20468.35C219.375%20468.247%20219.412%20468.158%20219.485%20468.085C219.558%20468.012%20219.646%20467.975%20219.75%20467.975C219.854%20467.975%20219.942%20468.012%20220.015%20468.085C220.088%20468.158%20220.125%20468.247%20220.125%20468.35ZM223.875%20468.35C223.875%20468.454%20223.838%20468.542%20223.765%20468.615C223.692%20468.688%20223.604%20468.725%20223.5%20468.725C223.396%20468.725%20223.308%20468.688%20223.235%20468.615C223.162%20468.542%20223.125%20468.454%20223.125%20468.35C223.125%20468.247%20223.162%20468.158%20223.235%20468.085C223.308%20468.012%20223.396%20467.975%20223.5%20467.975C223.604%20467.975%20223.692%20468.012%20223.765%20468.085C223.838%20468.158%20223.875%20468.247%20223.875%20468.35ZM227.625%20468.35C227.625%20468.454%20227.588%20468.542%20227.515%20468.615C227.442%20468.688%20227.354%20468.725%20227.25%20468.725C227.146%20468.725%20227.058%20468.688%20226.985%20468.615C226.912%20468.542%20226.875%20468.454%20226.875%20468.35C226.875%20468.247%20226.912%20468.158%20226.985%20468.085C227.058%20468.012%20227.146%20467.975%20227.25%20467.975C227.354%20467.975%20227.442%20468.012%20227.515%20468.085C227.588%20468.158%20227.625%20468.247%20227.625%20468.35ZM231.375%20468.35C231.375%20468.454%20231.338%20468.542%20231.265%20468.615C231.192%20468.688%20231.104%20468.725%20231%20468.725C230.896%20468.725%20230.808%20468.688%20230.735%20468.615C230.662%20468.542%20230.625%20468.454%20230.625%20468.35C230.625%20468.247%20230.662%20468.158%20230.735%20468.085C230.808%20468.012%20230.896%20467.975%20231%20467.975C231.104%20467.975%20231.192%20468.012%20231.265%20468.085C231.338%20468.158%20231.375%20468.247%20231.375%20468.35ZM235.125%20468.35C235.125%20468.454%20235.088%20468.542%20235.015%20468.615C234.942%20468.688%20234.854%20468.725%20234.75%20468.725C234.646%20468.725%20234.558%20468.688%20234.485%20468.615C234.412%20468.542%20234.375%20468.454%20234.375%20468.35C234.375%20468.247%20234.412%20468.158%20234.485%20468.085C234.558%20468.012%20234.646%20467.975%20234.75%20467.975C234.854%20467.975%20234.942%20468.012%20235.015%20468.085C235.088%20468.158%20235.125%20468.247%20235.125%20468.35ZM238.875%20468.35C238.875%20468.454%20238.838%20468.542%20238.765%20468.615C238.692%20468.688%20238.604%20468.725%20238.5%20468.725C238.396%20468.725%20238.308%20468.688%20238.235%20468.615C238.162%20468.542%20238.125%20468.454%20238.125%20468.35C238.125%20468.247%20238.162%20468.158%20238.235%20468.085C238.308%20468.012%20238.396%20467.975%20238.5%20467.975C238.604%20467.975%20238.692%20468.012%20238.765%20468.085C238.838%20468.158%20238.875%20468.247%20238.875%20468.35ZM242.625%20468.35C242.625%20468.454%20242.588%20468.542%20242.515%20468.615C242.442%20468.688%20242.354%20468.725%20242.25%20468.725C242.146%20468.725%20242.058%20468.688%20241.985%20468.615C241.912%20468.542%20241.875%20468.454%20241.875%20468.35C241.875%20468.247%20241.912%20468.158%20241.985%20468.085C242.058%20468.012%20242.146%20467.975%20242.25%20467.975C242.354%20467.975%20242.442%20468.012%20242.515%20468.085C242.588%20468.158%20242.625%20468.247%20242.625%20468.35ZM246.375%20468.35C246.375%20468.454%20246.338%20468.542%20246.265%20468.615C246.192%20468.688%20246.104%20468.725%20246%20468.725C245.896%20468.725%20245.808%20468.688%20245.735%20468.615C245.662%20468.542%20245.625%20468.454%20245.625%20468.35C245.625%20468.247%20245.662%20468.158%20245.735%20468.085C245.808%20468.012%20245.896%20467.975%20246%20467.975C246.104%20467.975%20246.192%20468.012%20246.265%20468.085C246.338%20468.158%20246.375%20468.247%20246.375%20468.35ZM250.125%20468.35C250.125%20468.454%20250.088%20468.542%20250.015%20468.615C249.942%20468.688%20249.854%20468.725%20249.75%20468.725C249.646%20468.725%20249.558%20468.688%20249.485%20468.615C249.412%20468.542%20249.375%20468.454%20249.375%20468.35C249.375%20468.247%20249.412%20468.158%20249.485%20468.085C249.558%20468.012%20249.646%20467.975%20249.75%20467.975C249.854%20467.975%20249.942%20468.012%20250.015%20468.085C250.088%20468.158%20250.125%20468.247%20250.125%20468.35ZM253.875%20468.35C253.875%20468.454%20253.838%20468.542%20253.765%20468.615C253.692%20468.688%20253.604%20468.725%20253.5%20468.725C253.396%20468.725%20253.308%20468.688%20253.235%20468.615C253.162%20468.542%20253.125%20468.454%20253.125%20468.35C253.125%20468.247%20253.162%20468.158%20253.235%20468.085C253.308%20468.012%20253.396%20467.975%20253.5%20467.975C253.604%20467.975%20253.692%20468.012%20253.765%20468.085C253.838%20468.158%20253.875%20468.247%20253.875%20468.35ZM257.625%20468.35C257.625%20468.454%20257.588%20468.542%20257.515%20468.615C257.442%20468.688%20257.354%20468.725%20257.25%20468.725C257.146%20468.725%20257.058%20468.688%20256.985%20468.615C256.912%20468.542%20256.875%20468.454%20256.875%20468.35C256.875%20468.247%20256.912%20468.158%20256.985%20468.085C257.058%20468.012%20257.146%20467.975%20257.25%20467.975C257.354%20467.975%20257.442%20468.012%20257.515%20468.085C257.588%20468.158%20257.625%20468.247%20257.625%20468.35ZM261.375%20468.35C261.375%20468.454%20261.338%20468.542%20261.265%20468.615C261.192%20468.688%20261.104%20468.725%20261%20468.725C260.896%20468.725%20260.808%20468.688%20260.735%20468.615C260.662%20468.542%20260.625%20468.454%20260.625%20468.35C260.625%20468.247%20260.662%20468.158%20260.735%20468.085C260.808%20468.012%20260.896%20467.975%20261%20467.975C261.104%20467.975%20261.192%20468.012%20261.265%20468.085C261.338%20468.158%20261.375%20468.247%20261.375%20468.35ZM265.125%20468.35C265.125%20468.454%20265.088%20468.542%20265.015%20468.615C264.942%20468.688%20264.854%20468.725%20264.75%20468.725C264.646%20468.725%20264.558%20468.688%20264.485%20468.615C264.412%20468.542%20264.375%20468.454%20264.375%20468.35C264.375%20468.247%20264.412%20468.158%20264.485%20468.085C264.558%20468.012%20264.646%20467.975%20264.75%20467.975C264.854%20467.975%20264.942%20468.012%20265.015%20468.085C265.088%20468.158%20265.125%20468.247%20265.125%20468.35ZM268.875%20468.35C268.875%20468.454%20268.838%20468.542%20268.765%20468.615C268.692%20468.688%20268.604%20468.725%20268.5%20468.725C268.396%20468.725%20268.308%20468.688%20268.235%20468.615C268.162%20468.542%20268.125%20468.454%20268.125%20468.35C268.125%20468.247%20268.162%20468.158%20268.235%20468.085C268.308%20468.012%20268.396%20467.975%20268.5%20467.975C268.604%20467.975%20268.692%20468.012%20268.765%20468.085C268.838%20468.158%20268.875%20468.247%20268.875%20468.35ZM272.625%20468.35C272.625%20468.454%20272.588%20468.542%20272.515%20468.615C272.442%20468.688%20272.354%20468.725%20272.25%20468.725C272.146%20468.725%20272.058%20468.688%20271.985%20468.615C271.912%20468.542%20271.875%20468.454%20271.875%20468.35C271.875%20468.247%20271.912%20468.158%20271.985%20468.085C272.058%20468.012%20272.146%20467.975%20272.25%20467.975C272.354%20467.975%20272.442%20468.012%20272.515%20468.085C272.588%20468.158%20272.625%20468.247%20272.625%20468.35ZM276.375%20468.35C276.375%20468.454%20276.338%20468.542%20276.265%20468.615C276.192%20468.688%20276.104%20468.725%20276%20468.725C275.896%20468.725%20275.808%20468.688%20275.735%20468.615C275.662%20468.542%20275.625%20468.454%20275.625%20468.35C275.625%20468.247%20275.662%20468.158%20275.735%20468.085C275.808%20468.012%20275.896%20467.975%20276%20467.975C276.104%20467.975%20276.192%20468.012%20276.265%20468.085C276.338%20468.158%20276.375%20468.247%20276.375%20468.35ZM280.125%20468.35C280.125%20468.454%20280.088%20468.542%20280.015%20468.615C279.942%20468.688%20279.854%20468.725%20279.75%20468.725C279.646%20468.725%20279.558%20468.688%20279.485%20468.615C279.412%20468.542%20279.375%20468.454%20279.375%20468.35C279.375%20468.247%20279.412%20468.158%20279.485%20468.085C279.558%20468.012%20279.646%20467.975%20279.75%20467.975C279.854%20467.975%20279.942%20468.012%20280.015%20468.085C280.088%20468.158%20280.125%20468.247%20280.125%20468.35ZM283.875%20468.35C283.875%20468.454%20283.838%20468.542%20283.765%20468.615C283.692%20468.688%20283.604%20468.725%20283.5%20468.725C283.396%20468.725%20283.308%20468.688%20283.235%20468.615C283.162%20468.542%20283.125%20468.454%20283.125%20468.35C283.125%20468.247%20283.162%20468.158%20283.235%20468.085C283.308%20468.012%20283.396%20467.975%20283.5%20467.975C283.604%20467.975%20283.692%20468.012%20283.765%20468.085C283.838%20468.158%20283.875%20468.247%20283.875%20468.35ZM287.625%20468.35C287.625%20468.454%20287.588%20468.542%20287.515%20468.615C287.442%20468.688%20287.354%20468.725%20287.25%20468.725C287.146%20468.725%20287.058%20468.688%20286.985%20468.615C286.912%20468.542%20286.875%20468.454%20286.875%20468.35C286.875%20468.247%20286.912%20468.158%20286.985%20468.085C287.058%20468.012%20287.146%20467.975%20287.25%20467.975C287.354%20467.975%20287.442%20468.012%20287.515%20468.085C287.588%20468.158%20287.625%20468.247%20287.625%20468.35ZM291.375%20468.35C291.375%20468.454%20291.338%20468.542%20291.265%20468.615C291.192%20468.688%20291.104%20468.725%20291%20468.725C290.896%20468.725%20290.808%20468.688%20290.735%20468.615C290.662%20468.542%20290.625%20468.454%20290.625%20468.35C290.625%20468.247%20290.662%20468.158%20290.735%20468.085C290.808%20468.012%20290.896%20467.975%20291%20467.975C291.104%20467.975%20291.192%20468.012%20291.265%20468.085C291.338%20468.158%20291.375%20468.247%20291.375%20468.35ZM295.125%20468.35C295.125%20468.454%20295.088%20468.542%20295.015%20468.615C294.942%20468.688%20294.854%20468.725%20294.75%20468.725C294.646%20468.725%20294.558%20468.688%20294.485%20468.615C294.412%20468.542%20294.375%20468.454%20294.375%20468.35C294.375%20468.247%20294.412%20468.158%20294.485%20468.085C294.558%20468.012%20294.646%20467.975%20294.75%20467.975C294.854%20467.975%20294.942%20468.012%20295.015%20468.085C295.088%20468.158%20295.125%20468.247%20295.125%20468.35ZM298.875%20468.35C298.875%20468.454%20298.838%20468.542%20298.765%20468.615C298.692%20468.688%20298.604%20468.725%20298.5%20468.725C298.396%20468.725%20298.308%20468.688%20298.235%20468.615C298.162%20468.542%20298.125%20468.454%20298.125%20468.35C298.125%20468.247%20298.162%20468.158%20298.235%20468.085C298.308%20468.012%20298.396%20467.975%20298.5%20467.975C298.604%20467.975%20298.692%20468.012%20298.765%20468.085C298.838%20468.158%20298.875%20468.247%20298.875%20468.35ZM302.625%20468.35C302.625%20468.454%20302.588%20468.542%20302.515%20468.615C302.442%20468.688%20302.354%20468.725%20302.25%20468.725C302.146%20468.725%20302.058%20468.688%20301.985%20468.615C301.912%20468.542%20301.875%20468.454%20301.875%20468.35C301.875%20468.247%20301.912%20468.158%20301.985%20468.085C302.058%20468.012%20302.146%20467.975%20302.25%20467.975C302.354%20467.975%20302.442%20468.012%20302.515%20468.085C302.588%20468.158%20302.625%20468.247%20302.625%20468.35ZM306.375%20468.35C306.375%20468.454%20306.338%20468.542%20306.265%20468.615C306.192%20468.688%20306.104%20468.725%20306%20468.725C305.896%20468.725%20305.808%20468.688%20305.735%20468.615C305.662%20468.542%20305.625%20468.454%20305.625%20468.35C305.625%20468.247%20305.662%20468.158%20305.735%20468.085C305.808%20468.012%20305.896%20467.975%20306%20467.975C306.104%20467.975%20306.192%20468.012%20306.265%20468.085C306.338%20468.158%20306.375%20468.247%20306.375%20468.35ZM310.125%20468.35C310.125%20468.454%20310.088%20468.542%20310.015%20468.615C309.942%20468.688%20309.854%20468.725%20309.75%20468.725C309.646%20468.725%20309.558%20468.688%20309.485%20468.615C309.412%20468.542%20309.375%20468.454%20309.375%20468.35C309.375%20468.247%20309.412%20468.158%20309.485%20468.085C309.558%20468.012%20309.646%20467.975%20309.75%20467.975C309.854%20467.975%20309.942%20468.012%20310.015%20468.085C310.088%20468.158%20310.125%20468.247%20310.125%20468.35ZM313.875%20468.35C313.875%20468.454%20313.838%20468.542%20313.765%20468.615C313.692%20468.688%20313.604%20468.725%20313.5%20468.725C313.396%20468.725%20313.308%20468.688%20313.235%20468.615C313.162%20468.542%20313.125%20468.454%20313.125%20468.35C313.125%20468.247%20313.162%20468.158%20313.235%20468.085C313.308%20468.012%20313.396%20467.975%20313.5%20467.975C313.604%20467.975%20313.692%20468.012%20313.765%20468.085C313.838%20468.158%20313.875%20468.247%20313.875%20468.35ZM317.625%20468.35C317.625%20468.454%20317.588%20468.542%20317.515%20468.615C317.442%20468.688%20317.354%20468.725%20317.25%20468.725C317.146%20468.725%20317.058%20468.688%20316.985%20468.615C316.912%20468.542%20316.875%20468.454%20316.875%20468.35C316.875%20468.247%20316.912%20468.158%20316.985%20468.085C317.058%20468.012%20317.146%20467.975%20317.25%20467.975C317.354%20467.975%20317.442%20468.012%20317.515%20468.085C317.588%20468.158%20317.625%20468.247%20317.625%20468.35ZM321.375%20468.35C321.375%20468.454%20321.338%20468.542%20321.265%20468.615C321.192%20468.688%20321.104%20468.725%20321%20468.725C320.896%20468.725%20320.808%20468.688%20320.735%20468.615C320.662%20468.542%20320.625%20468.454%20320.625%20468.35C320.625%20468.247%20320.662%20468.158%20320.735%20468.085C320.808%20468.012%20320.896%20467.975%20321%20467.975C321.104%20467.975%20321.192%20468.012%20321.265%20468.085C321.338%20468.158%20321.375%20468.247%20321.375%20468.35ZM325.125%20468.35C325.125%20468.454%20325.088%20468.542%20325.015%20468.615C324.942%20468.688%20324.854%20468.725%20324.75%20468.725C324.646%20468.725%20324.558%20468.688%20324.485%20468.615C324.412%20468.542%20324.375%20468.454%20324.375%20468.35C324.375%20468.247%20324.412%20468.158%20324.485%20468.085C324.558%20468.012%20324.646%20467.975%20324.75%20467.975C324.854%20467.975%20324.942%20468.012%20325.015%20468.085C325.088%20468.158%20325.125%20468.247%20325.125%20468.35ZM328.875%20468.35C328.875%20468.454%20328.838%20468.542%20328.765%20468.615C328.692%20468.688%20328.604%20468.725%20328.5%20468.725C328.396%20468.725%20328.308%20468.688%20328.235%20468.615C328.162%20468.542%20328.125%20468.454%20328.125%20468.35C328.125%20468.247%20328.162%20468.158%20328.235%20468.085C328.308%20468.012%20328.396%20467.975%20328.5%20467.975C328.604%20467.975%20328.692%20468.012%20328.765%20468.085C328.838%20468.158%20328.875%20468.247%20328.875%20468.35ZM332.625%20468.35C332.625%20468.454%20332.588%20468.542%20332.515%20468.615C332.442%20468.688%20332.354%20468.725%20332.25%20468.725C332.146%20468.725%20332.058%20468.688%20331.985%20468.615C331.912%20468.542%20331.875%20468.454%20331.875%20468.35C331.875%20468.247%20331.912%20468.158%20331.985%20468.085C332.058%20468.012%20332.146%20467.975%20332.25%20467.975C332.354%20467.975%20332.442%20468.012%20332.515%20468.085C332.588%20468.158%20332.625%20468.247%20332.625%20468.35ZM336.375%20468.35C336.375%20468.454%20336.338%20468.542%20336.265%20468.615C336.192%20468.688%20336.104%20468.725%20336%20468.725C335.896%20468.725%20335.808%20468.688%20335.735%20468.615C335.662%20468.542%20335.625%20468.454%20335.625%20468.35C335.625%20468.247%20335.662%20468.158%20335.735%20468.085C335.808%20468.012%20335.896%20467.975%20336%20467.975C336.104%20467.975%20336.192%20468.012%20336.265%20468.085C336.338%20468.158%20336.375%20468.247%20336.375%20468.35ZM340.125%20468.35C340.125%20468.454%20340.088%20468.542%20340.015%20468.615C339.942%20468.688%20339.854%20468.725%20339.75%20468.725C339.646%20468.725%20339.558%20468.688%20339.485%20468.615C339.412%20468.542%20339.375%20468.454%20339.375%20468.35C339.375%20468.247%20339.412%20468.158%20339.485%20468.085C339.558%20468.012%20339.646%20467.975%20339.75%20467.975C339.854%20467.975%20339.942%20468.012%20340.015%20468.085C340.088%20468.158%20340.125%20468.247%20340.125%20468.35ZM343.875%20468.35C343.875%20468.454%20343.838%20468.542%20343.765%20468.615C343.692%20468.688%20343.604%20468.725%20343.5%20468.725C343.396%20468.725%20343.308%20468.688%20343.235%20468.615C343.162%20468.542%20343.125%20468.454%20343.125%20468.35C343.125%20468.247%20343.162%20468.158%20343.235%20468.085C343.308%20468.012%20343.396%20467.975%20343.5%20467.975C343.604%20467.975%20343.692%20468.012%20343.765%20468.085C343.838%20468.158%20343.875%20468.247%20343.875%20468.35ZM347.625%20468.35C347.625%20468.454%20347.588%20468.542%20347.515%20468.615C347.442%20468.688%20347.354%20468.725%20347.25%20468.725C347.146%20468.725%20347.058%20468.688%20346.985%20468.615C346.912%20468.542%20346.875%20468.454%20346.875%20468.35C346.875%20468.247%20346.912%20468.158%20346.985%20468.085C347.058%20468.012%20347.146%20467.975%20347.25%20467.975C347.354%20467.975%20347.442%20468.012%20347.515%20468.085C347.588%20468.158%20347.625%20468.247%20347.625%20468.35ZM351.375%20468.35C351.375%20468.454%20351.338%20468.542%20351.265%20468.615C351.192%20468.688%20351.104%20468.725%20351%20468.725C350.896%20468.725%20350.808%20468.688%20350.735%20468.615C350.662%20468.542%20350.625%20468.454%20350.625%20468.35C350.625%20468.247%20350.662%20468.158%20350.735%20468.085C350.808%20468.012%20350.896%20467.975%20351%20467.975C351.104%20467.975%20351.192%20468.012%20351.265%20468.085C351.338%20468.158%20351.375%20468.247%20351.375%20468.35ZM355.125%20468.35C355.125%20468.454%20355.088%20468.542%20355.015%20468.615C354.942%20468.688%20354.854%20468.725%20354.75%20468.725C354.646%20468.725%20354.558%20468.688%20354.485%20468.615C354.412%20468.542%20354.375%20468.454%20354.375%20468.35C354.375%20468.247%20354.412%20468.158%20354.485%20468.085C354.558%20468.012%20354.646%20467.975%20354.75%20467.975C354.854%20467.975%20354.942%20468.012%20355.015%20468.085C355.088%20468.158%20355.125%20468.247%20355.125%20468.35ZM358.875%20468.35C358.875%20468.454%20358.838%20468.542%20358.765%20468.615C358.692%20468.688%20358.604%20468.725%20358.5%20468.725C358.396%20468.725%20358.308%20468.688%20358.235%20468.615C358.162%20468.542%20358.125%20468.454%20358.125%20468.35C358.125%20468.247%20358.162%20468.158%20358.235%20468.085C358.308%20468.012%20358.396%20467.975%20358.5%20467.975C358.604%20467.975%20358.692%20468.012%20358.765%20468.085C358.838%20468.158%20358.875%20468.247%20358.875%20468.35ZM362.625%20468.35C362.625%20468.454%20362.588%20468.542%20362.515%20468.615C362.442%20468.688%20362.354%20468.725%20362.25%20468.725C362.146%20468.725%20362.058%20468.688%20361.985%20468.615C361.912%20468.542%20361.875%20468.454%20361.875%20468.35C361.875%20468.247%20361.912%20468.158%20361.985%20468.085C362.058%20468.012%20362.146%20467.975%20362.25%20467.975C362.354%20467.975%20362.442%20468.012%20362.515%20468.085C362.588%20468.158%20362.625%20468.247%20362.625%20468.35ZM366.375%20468.35C366.375%20468.454%20366.338%20468.542%20366.265%20468.615C366.192%20468.688%20366.104%20468.725%20366%20468.725C365.896%20468.725%20365.808%20468.688%20365.735%20468.615C365.662%20468.542%20365.625%20468.454%20365.625%20468.35C365.625%20468.247%20365.662%20468.158%20365.735%20468.085C365.808%20468.012%20365.896%20467.975%20366%20467.975C366.104%20467.975%20366.192%20468.012%20366.265%20468.085C366.338%20468.158%20366.375%20468.247%20366.375%20468.35ZM370.125%20468.35C370.125%20468.454%20370.088%20468.542%20370.015%20468.615C369.942%20468.688%20369.854%20468.725%20369.75%20468.725C369.646%20468.725%20369.558%20468.688%20369.485%20468.615C369.412%20468.542%20369.375%20468.454%20369.375%20468.35C369.375%20468.247%20369.412%20468.158%20369.485%20468.085C369.558%20468.012%20369.646%20467.975%20369.75%20467.975C369.854%20467.975%20369.942%20468.012%20370.015%20468.085C370.088%20468.158%20370.125%20468.247%20370.125%20468.35ZM373.875%20468.35C373.875%20468.454%20373.838%20468.542%20373.765%20468.615C373.692%20468.688%20373.604%20468.725%20373.5%20468.725C373.396%20468.725%20373.308%20468.688%20373.235%20468.615C373.162%20468.542%20373.125%20468.454%20373.125%20468.35C373.125%20468.247%20373.162%20468.158%20373.235%20468.085C373.308%20468.012%20373.396%20467.975%20373.5%20467.975C373.604%20467.975%20373.692%20468.012%20373.765%20468.085C373.838%20468.158%20373.875%20468.247%20373.875%20468.35ZM377.625%20468.35C377.625%20468.454%20377.588%20468.542%20377.515%20468.615C377.442%20468.688%20377.354%20468.725%20377.25%20468.725C377.146%20468.725%20377.058%20468.688%20376.985%20468.615C376.912%20468.542%20376.875%20468.454%20376.875%20468.35C376.875%20468.247%20376.912%20468.158%20376.985%20468.085C377.058%20468.012%20377.146%20467.975%20377.25%20467.975C377.354%20467.975%20377.442%20468.012%20377.515%20468.085C377.588%20468.158%20377.625%20468.247%20377.625%20468.35ZM381.375%20468.35C381.375%20468.454%20381.338%20468.542%20381.265%20468.615C381.192%20468.688%20381.104%20468.725%20381%20468.725C380.896%20468.725%20380.808%20468.688%20380.735%20468.615C380.662%20468.542%20380.625%20468.454%20380.625%20468.35C380.625%20468.247%20380.662%20468.158%20380.735%20468.085C380.808%20468.012%20380.896%20467.975%20381%20467.975C381.104%20467.975%20381.192%20468.012%20381.265%20468.085C381.338%20468.158%20381.375%20468.247%20381.375%20468.35ZM385.125%20468.35C385.125%20468.454%20385.088%20468.542%20385.015%20468.615C384.942%20468.688%20384.854%20468.725%20384.75%20468.725C384.646%20468.725%20384.558%20468.688%20384.485%20468.615C384.412%20468.542%20384.375%20468.454%20384.375%20468.35C384.375%20468.247%20384.412%20468.158%20384.485%20468.085C384.558%20468.012%20384.646%20467.975%20384.75%20467.975C384.854%20467.975%20384.942%20468.012%20385.015%20468.085C385.088%20468.158%20385.125%20468.247%20385.125%20468.35ZM388.875%20468.35C388.875%20468.454%20388.838%20468.542%20388.765%20468.615C388.692%20468.688%20388.604%20468.725%20388.5%20468.725C388.396%20468.725%20388.308%20468.688%20388.235%20468.615C388.162%20468.542%20388.125%20468.454%20388.125%20468.35C388.125%20468.247%20388.162%20468.158%20388.235%20468.085C388.308%20468.012%20388.396%20467.975%20388.5%20467.975C388.604%20467.975%20388.692%20468.012%20388.765%20468.085C388.838%20468.158%20388.875%20468.247%20388.875%20468.35ZM392.625%20468.35C392.625%20468.454%20392.588%20468.542%20392.515%20468.615C392.442%20468.688%20392.354%20468.725%20392.25%20468.725C392.146%20468.725%20392.058%20468.688%20391.985%20468.615C391.912%20468.542%20391.875%20468.454%20391.875%20468.35C391.875%20468.247%20391.912%20468.158%20391.985%20468.085C392.058%20468.012%20392.146%20467.975%20392.25%20467.975C392.354%20467.975%20392.442%20468.012%20392.515%20468.085C392.588%20468.158%20392.625%20468.247%20392.625%20468.35ZM396.375%20468.35C396.375%20468.454%20396.338%20468.542%20396.265%20468.615C396.192%20468.688%20396.104%20468.725%20396%20468.725C395.896%20468.725%20395.808%20468.688%20395.735%20468.615C395.662%20468.542%20395.625%20468.454%20395.625%20468.35C395.625%20468.247%20395.662%20468.158%20395.735%20468.085C395.808%20468.012%20395.896%20467.975%20396%20467.975C396.104%20467.975%20396.192%20468.012%20396.265%20468.085C396.338%20468.158%20396.375%20468.247%20396.375%20468.35ZM400.125%20468.35C400.125%20468.454%20400.088%20468.542%20400.015%20468.615C399.942%20468.688%20399.854%20468.725%20399.75%20468.725C399.646%20468.725%20399.558%20468.688%20399.485%20468.615C399.412%20468.542%20399.375%20468.454%20399.375%20468.35C399.375%20468.247%20399.412%20468.158%20399.485%20468.085C399.558%20468.012%20399.646%20467.975%20399.75%20467.975C399.854%20467.975%20399.942%20468.012%20400.015%20468.085C400.088%20468.158%20400.125%20468.247%20400.125%20468.35ZM403.875%20468.35C403.875%20468.454%20403.838%20468.542%20403.765%20468.615C403.692%20468.688%20403.604%20468.725%20403.5%20468.725C403.396%20468.725%20403.308%20468.688%20403.235%20468.615C403.162%20468.542%20403.125%20468.454%20403.125%20468.35C403.125%20468.247%20403.162%20468.158%20403.235%20468.085C403.308%20468.012%20403.396%20467.975%20403.5%20467.975C403.604%20467.975%20403.692%20468.012%20403.765%20468.085C403.838%20468.158%20403.875%20468.247%20403.875%20468.35ZM407.625%20468.35C407.625%20468.454%20407.588%20468.542%20407.515%20468.615C407.442%20468.688%20407.354%20468.725%20407.25%20468.725C407.146%20468.725%20407.058%20468.688%20406.985%20468.615C406.912%20468.542%20406.875%20468.454%20406.875%20468.35C406.875%20468.247%20406.912%20468.158%20406.985%20468.085C407.058%20468.012%20407.146%20467.975%20407.25%20467.975C407.354%20467.975%20407.442%20468.012%20407.515%20468.085C407.588%20468.158%20407.625%20468.247%20407.625%20468.35ZM411.375%20468.35C411.375%20468.454%20411.338%20468.542%20411.265%20468.615C411.192%20468.688%20411.104%20468.725%20411%20468.725C410.896%20468.725%20410.808%20468.688%20410.735%20468.615C410.662%20468.542%20410.625%20468.454%20410.625%20468.35C410.625%20468.247%20410.662%20468.158%20410.735%20468.085C410.808%20468.012%20410.896%20467.975%20411%20467.975C411.104%20467.975%20411.192%20468.012%20411.265%20468.085C411.338%20468.158%20411.375%20468.247%20411.375%20468.35ZM415.125%20468.35C415.125%20468.454%20415.088%20468.542%20415.015%20468.615C414.942%20468.688%20414.854%20468.725%20414.75%20468.725C414.646%20468.725%20414.558%20468.688%20414.485%20468.615C414.412%20468.542%20414.375%20468.454%20414.375%20468.35C414.375%20468.247%20414.412%20468.158%20414.485%20468.085C414.558%20468.012%20414.646%20467.975%20414.75%20467.975C414.854%20467.975%20414.942%20468.012%20415.015%20468.085C415.088%20468.158%20415.125%20468.247%20415.125%20468.35ZM418.875%20468.35C418.875%20468.454%20418.838%20468.542%20418.765%20468.615C418.692%20468.688%20418.604%20468.725%20418.5%20468.725C418.396%20468.725%20418.308%20468.688%20418.235%20468.615C418.162%20468.542%20418.125%20468.454%20418.125%20468.35C418.125%20468.247%20418.162%20468.158%20418.235%20468.085C418.308%20468.012%20418.396%20467.975%20418.5%20467.975C418.604%20467.975%20418.692%20468.012%20418.765%20468.085C418.838%20468.158%20418.875%20468.247%20418.875%20468.35ZM422.625%20468.35C422.625%20468.454%20422.588%20468.542%20422.515%20468.615C422.442%20468.688%20422.354%20468.725%20422.25%20468.725C422.146%20468.725%20422.058%20468.688%20421.985%20468.615C421.912%20468.542%20421.875%20468.454%20421.875%20468.35C421.875%20468.247%20421.912%20468.158%20421.985%20468.085C422.058%20468.012%20422.146%20467.975%20422.25%20467.975C422.354%20467.975%20422.442%20468.012%20422.515%20468.085C422.588%20468.158%20422.625%20468.247%20422.625%20468.35ZM426.375%20468.35C426.375%20468.454%20426.338%20468.542%20426.265%20468.615C426.192%20468.688%20426.104%20468.725%20426%20468.725C425.896%20468.725%20425.808%20468.688%20425.735%20468.615C425.662%20468.542%20425.625%20468.454%20425.625%20468.35C425.625%20468.247%20425.662%20468.158%20425.735%20468.085C425.808%20468.012%20425.896%20467.975%20426%20467.975C426.104%20467.975%20426.192%20468.012%20426.265%20468.085C426.338%20468.158%20426.375%20468.247%20426.375%20468.35ZM430.125%20468.35C430.125%20468.454%20430.088%20468.542%20430.015%20468.615C429.942%20468.688%20429.854%20468.725%20429.75%20468.725C429.646%20468.725%20429.558%20468.688%20429.485%20468.615C429.412%20468.542%20429.375%20468.454%20429.375%20468.35C429.375%20468.247%20429.412%20468.158%20429.485%20468.085C429.558%20468.012%20429.646%20467.975%20429.75%20467.975C429.854%20467.975%20429.942%20468.012%20430.015%20468.085C430.088%20468.158%20430.125%20468.247%20430.125%20468.35ZM433.875%20468.35C433.875%20468.454%20433.838%20468.542%20433.765%20468.615C433.692%20468.688%20433.604%20468.725%20433.5%20468.725C433.396%20468.725%20433.308%20468.688%20433.235%20468.615C433.162%20468.542%20433.125%20468.454%20433.125%20468.35C433.125%20468.247%20433.162%20468.158%20433.235%20468.085C433.308%20468.012%20433.396%20467.975%20433.5%20467.975C433.604%20467.975%20433.692%20468.012%20433.765%20468.085C433.838%20468.158%20433.875%20468.247%20433.875%20468.35ZM437.625%20468.35C437.625%20468.454%20437.588%20468.542%20437.515%20468.615C437.442%20468.688%20437.354%20468.725%20437.25%20468.725C437.146%20468.725%20437.058%20468.688%20436.985%20468.615C436.912%20468.542%20436.875%20468.454%20436.875%20468.35C436.875%20468.247%20436.912%20468.158%20436.985%20468.085C437.058%20468.012%20437.146%20467.975%20437.25%20467.975C437.354%20467.975%20437.442%20468.012%20437.515%20468.085C437.588%20468.158%20437.625%20468.247%20437.625%20468.35ZM441.375%20468.35C441.375%20468.454%20441.338%20468.542%20441.265%20468.615C441.192%20468.688%20441.104%20468.725%20441%20468.725C440.896%20468.725%20440.808%20468.688%20440.735%20468.615C440.662%20468.542%20440.625%20468.454%20440.625%20468.35C440.625%20468.247%20440.662%20468.158%20440.735%20468.085C440.808%20468.012%20440.896%20467.975%20441%20467.975C441.104%20467.975%20441.192%20468.012%20441.265%20468.085C441.338%20468.158%20441.375%20468.247%20441.375%20468.35ZM445.125%20468.35C445.125%20468.454%20445.088%20468.542%20445.015%20468.615C444.942%20468.688%20444.853%20468.725%20444.75%20468.725C444.646%20468.725%20444.558%20468.688%20444.485%20468.615C444.412%20468.542%20444.375%20468.454%20444.375%20468.35C444.375%20468.247%20444.412%20468.158%20444.485%20468.085C444.558%20468.012%20444.646%20467.975%20444.75%20467.975C444.853%20467.975%20444.942%20468.012%20445.015%20468.085C445.088%20468.158%20445.125%20468.247%20445.125%20468.35ZM448.875%20468.35C448.875%20468.454%20448.838%20468.542%20448.765%20468.615C448.692%20468.688%20448.604%20468.725%20448.5%20468.725C448.396%20468.725%20448.308%20468.688%20448.235%20468.615C448.162%20468.542%20448.125%20468.454%20448.125%20468.35C448.125%20468.247%20448.162%20468.158%20448.235%20468.085C448.308%20468.012%20448.396%20467.975%20448.5%20467.975C448.604%20467.975%20448.692%20468.012%20448.765%20468.085C448.838%20468.158%20448.875%20468.247%20448.875%20468.35ZM452.625%20468.35C452.625%20468.454%20452.588%20468.542%20452.515%20468.615C452.442%20468.688%20452.354%20468.725%20452.25%20468.725C452.146%20468.725%20452.058%20468.688%20451.985%20468.615C451.912%20468.542%20451.875%20468.454%20451.875%20468.35C451.875%20468.247%20451.912%20468.158%20451.985%20468.085C452.058%20468.012%20452.146%20467.975%20452.25%20467.975C452.354%20467.975%20452.442%20468.012%20452.515%20468.085C452.588%20468.158%20452.625%20468.247%20452.625%20468.35ZM456.375%20468.35C456.375%20468.454%20456.338%20468.542%20456.265%20468.615C456.192%20468.688%20456.104%20468.725%20456%20468.725C455.896%20468.725%20455.808%20468.688%20455.735%20468.615C455.662%20468.542%20455.625%20468.454%20455.625%20468.35C455.625%20468.247%20455.662%20468.158%20455.735%20468.085C455.808%20468.012%20455.896%20467.975%20456%20467.975C456.104%20467.975%20456.192%20468.012%20456.265%20468.085C456.338%20468.158%20456.375%20468.247%20456.375%20468.35ZM460.125%20468.35C460.125%20468.454%20460.088%20468.542%20460.015%20468.615C459.942%20468.688%20459.854%20468.725%20459.75%20468.725C459.646%20468.725%20459.558%20468.688%20459.485%20468.615C459.412%20468.542%20459.375%20468.454%20459.375%20468.35C459.375%20468.247%20459.412%20468.158%20459.485%20468.085C459.558%20468.012%20459.646%20467.975%20459.75%20467.975C459.854%20467.975%20459.942%20468.012%20460.015%20468.085C460.088%20468.158%20460.125%20468.247%20460.125%20468.35ZM463.875%20468.35C463.875%20468.454%20463.838%20468.542%20463.765%20468.615C463.692%20468.688%20463.604%20468.725%20463.5%20468.725C463.396%20468.725%20463.308%20468.688%20463.235%20468.615C463.162%20468.542%20463.125%20468.454%20463.125%20468.35C463.125%20468.247%20463.162%20468.158%20463.235%20468.085C463.308%20468.012%20463.396%20467.975%20463.5%20467.975C463.604%20467.975%20463.692%20468.012%20463.765%20468.085C463.838%20468.158%20463.875%20468.247%20463.875%20468.35ZM467.625%20468.35C467.625%20468.454%20467.588%20468.542%20467.515%20468.615C467.442%20468.688%20467.353%20468.725%20467.25%20468.725C467.146%20468.725%20467.058%20468.688%20466.985%20468.615C466.912%20468.542%20466.875%20468.454%20466.875%20468.35C466.875%20468.247%20466.912%20468.158%20466.985%20468.085C467.058%20468.012%20467.146%20467.975%20467.25%20467.975C467.353%20467.975%20467.442%20468.012%20467.515%20468.085C467.588%20468.158%20467.625%20468.247%20467.625%20468.35ZM471.375%20468.35C471.375%20468.454%20471.338%20468.542%20471.265%20468.615C471.192%20468.688%20471.103%20468.725%20471%20468.725C470.896%20468.725%20470.808%20468.688%20470.735%20468.615C470.662%20468.542%20470.625%20468.454%20470.625%20468.35C470.625%20468.247%20470.662%20468.158%20470.735%20468.085C470.808%20468.012%20470.896%20467.975%20471%20467.975C471.103%20467.975%20471.192%20468.012%20471.265%20468.085C471.338%20468.158%20471.375%20468.247%20471.375%20468.35ZM475.125%20468.35C475.125%20468.454%20475.088%20468.542%20475.015%20468.615C474.942%20468.688%20474.854%20468.725%20474.75%20468.725C474.646%20468.725%20474.558%20468.688%20474.485%20468.615C474.412%20468.542%20474.375%20468.454%20474.375%20468.35C474.375%20468.247%20474.412%20468.158%20474.485%20468.085C474.558%20468.012%20474.646%20467.975%20474.75%20467.975C474.854%20467.975%20474.942%20468.012%20475.015%20468.085C475.088%20468.158%20475.125%20468.247%20475.125%20468.35ZM478.875%20468.35C478.875%20468.454%20478.838%20468.542%20478.765%20468.615C478.692%20468.688%20478.604%20468.725%20478.5%20468.725C478.396%20468.725%20478.308%20468.688%20478.235%20468.615C478.162%20468.542%20478.125%20468.454%20478.125%20468.35C478.125%20468.247%20478.162%20468.158%20478.235%20468.085C478.308%20468.012%20478.396%20467.975%20478.5%20467.975C478.604%20467.975%20478.692%20468.012%20478.765%20468.085C478.838%20468.158%20478.875%20468.247%20478.875%20468.35ZM482.625%20468.35C482.625%20468.454%20482.588%20468.542%20482.515%20468.615C482.442%20468.688%20482.354%20468.725%20482.25%20468.725C482.146%20468.725%20482.058%20468.688%20481.985%20468.615C481.912%20468.542%20481.875%20468.454%20481.875%20468.35C481.875%20468.247%20481.912%20468.158%20481.985%20468.085C482.058%20468.012%20482.146%20467.975%20482.25%20467.975C482.354%20467.975%20482.442%20468.012%20482.515%20468.085C482.588%20468.158%20482.625%20468.247%20482.625%20468.35ZM486.375%20468.35C486.375%20468.454%20486.338%20468.542%20486.265%20468.615C486.192%20468.688%20486.104%20468.725%20486%20468.725C485.896%20468.725%20485.808%20468.688%20485.735%20468.615C485.662%20468.542%20485.625%20468.454%20485.625%20468.35C485.625%20468.247%20485.662%20468.158%20485.735%20468.085C485.808%20468.012%20485.896%20467.975%20486%20467.975C486.104%20467.975%20486.192%20468.012%20486.265%20468.085C486.338%20468.158%20486.375%20468.247%20486.375%20468.35ZM490.125%20468.35C490.125%20468.454%20490.088%20468.542%20490.015%20468.615C489.942%20468.688%20489.854%20468.725%20489.75%20468.725C489.646%20468.725%20489.558%20468.688%20489.485%20468.615C489.412%20468.542%20489.375%20468.454%20489.375%20468.35C489.375%20468.247%20489.412%20468.158%20489.485%20468.085C489.558%20468.012%20489.646%20467.975%20489.75%20467.975C489.854%20467.975%20489.942%20468.012%20490.015%20468.085C490.088%20468.158%20490.125%20468.247%20490.125%20468.35ZM493.875%20468.35C493.875%20468.454%20493.838%20468.542%20493.765%20468.615C493.692%20468.688%20493.604%20468.725%20493.5%20468.725C493.396%20468.725%20493.308%20468.688%20493.235%20468.615C493.162%20468.542%20493.125%20468.454%20493.125%20468.35C493.125%20468.247%20493.162%20468.158%20493.235%20468.085C493.308%20468.012%20493.396%20467.975%20493.5%20467.975C493.604%20467.975%20493.692%20468.012%20493.765%20468.085C493.838%20468.158%20493.875%20468.247%20493.875%20468.35ZM497.625%20468.35C497.625%20468.454%20497.588%20468.542%20497.515%20468.615C497.442%20468.688%20497.354%20468.725%20497.25%20468.725C497.146%20468.725%20497.058%20468.688%20496.985%20468.615C496.912%20468.542%20496.875%20468.454%20496.875%20468.35C496.875%20468.247%20496.912%20468.158%20496.985%20468.085C497.058%20468.012%20497.146%20467.975%20497.25%20467.975C497.354%20467.975%20497.442%20468.012%20497.515%20468.085C497.588%20468.158%20497.625%20468.247%20497.625%20468.35ZM501.375%20468.35C501.375%20468.454%20501.338%20468.542%20501.265%20468.615C501.192%20468.688%20501.104%20468.725%20501%20468.725C500.896%20468.725%20500.808%20468.688%20500.735%20468.615C500.662%20468.542%20500.625%20468.454%20500.625%20468.35C500.625%20468.247%20500.662%20468.158%20500.735%20468.085C500.808%20468.012%20500.896%20467.975%20501%20467.975C501.104%20467.975%20501.192%20468.012%20501.265%20468.085C501.338%20468.158%20501.375%20468.247%20501.375%20468.35ZM505.125%20468.35C505.125%20468.454%20505.088%20468.542%20505.015%20468.615C504.942%20468.688%20504.853%20468.725%20504.75%20468.725C504.646%20468.725%20504.558%20468.688%20504.485%20468.615C504.412%20468.542%20504.375%20468.454%20504.375%20468.35C504.375%20468.247%20504.412%20468.158%20504.485%20468.085C504.558%20468.012%20504.646%20467.975%20504.75%20467.975C504.853%20467.975%20504.942%20468.012%20505.015%20468.085C505.088%20468.158%20505.125%20468.247%20505.125%20468.35ZM508.875%20468.35C508.875%20468.454%20508.838%20468.542%20508.765%20468.615C508.692%20468.688%20508.603%20468.725%20508.5%20468.725C508.396%20468.725%20508.308%20468.688%20508.235%20468.615C508.162%20468.542%20508.125%20468.454%20508.125%20468.35C508.125%20468.247%20508.162%20468.158%20508.235%20468.085C508.308%20468.012%20508.396%20467.975%20508.5%20467.975C508.603%20467.975%20508.692%20468.012%20508.765%20468.085C508.838%20468.158%20508.875%20468.247%20508.875%20468.35ZM512.625%20468.35C512.625%20468.454%20512.588%20468.542%20512.515%20468.615C512.442%20468.688%20512.353%20468.725%20512.25%20468.725C512.146%20468.725%20512.058%20468.688%20511.985%20468.615C511.912%20468.542%20511.875%20468.454%20511.875%20468.35C511.875%20468.247%20511.912%20468.158%20511.985%20468.085C512.058%20468.012%20512.146%20467.975%20512.25%20467.975C512.353%20467.975%20512.442%20468.012%20512.515%20468.085C512.588%20468.158%20512.625%20468.247%20512.625%20468.35ZM516.375%20468.35C516.375%20468.454%20516.338%20468.542%20516.265%20468.615C516.192%20468.688%20516.104%20468.725%20516%20468.725C515.896%20468.725%20515.808%20468.688%20515.735%20468.615C515.662%20468.542%20515.625%20468.454%20515.625%20468.35C515.625%20468.247%20515.662%20468.158%20515.735%20468.085C515.808%20468.012%20515.896%20467.975%20516%20467.975C516.104%20467.975%20516.192%20468.012%20516.265%20468.085C516.338%20468.158%20516.375%20468.247%20516.375%20468.35ZM520.125%20468.35C520.125%20468.454%20520.088%20468.542%20520.015%20468.615C519.942%20468.688%20519.854%20468.725%20519.75%20468.725C519.646%20468.725%20519.558%20468.688%20519.485%20468.615C519.412%20468.542%20519.375%20468.454%20519.375%20468.35C519.375%20468.247%20519.412%20468.158%20519.485%20468.085C519.558%20468.012%20519.646%20467.975%20519.75%20467.975C519.854%20467.975%20519.942%20468.012%20520.015%20468.085C520.088%20468.158%20520.125%20468.247%20520.125%20468.35ZM523.875%20468.35C523.875%20468.454%20523.838%20468.542%20523.765%20468.615C523.692%20468.688%20523.603%20468.725%20523.5%20468.725C523.396%20468.725%20523.308%20468.688%20523.235%20468.615C523.162%20468.542%20523.125%20468.454%20523.125%20468.35C523.125%20468.247%20523.162%20468.158%20523.235%20468.085C523.308%20468.012%20523.396%20467.975%20523.5%20467.975C523.603%20467.975%20523.692%20468.012%20523.765%20468.085C523.838%20468.158%20523.875%20468.247%20523.875%20468.35ZM527.625%20468.35C527.625%20468.454%20527.588%20468.542%20527.515%20468.615C527.442%20468.688%20527.354%20468.725%20527.25%20468.725C527.146%20468.725%20527.058%20468.688%20526.985%20468.615C526.912%20468.542%20526.875%20468.454%20526.875%20468.35C526.875%20468.247%20526.912%20468.158%20526.985%20468.085C527.058%20468.012%20527.146%20467.975%20527.25%20467.975C527.354%20467.975%20527.442%20468.012%20527.515%20468.085C527.588%20468.158%20527.625%20468.247%20527.625%20468.35ZM531.375%20468.35C531.375%20468.454%20531.338%20468.542%20531.265%20468.615C531.192%20468.688%20531.104%20468.725%20531%20468.725C530.896%20468.725%20530.808%20468.688%20530.735%20468.615C530.662%20468.542%20530.625%20468.454%20530.625%20468.35C530.625%20468.247%20530.662%20468.158%20530.735%20468.085C530.808%20468.012%20530.896%20467.975%20531%20467.975C531.104%20467.975%20531.192%20468.012%20531.265%20468.085C531.338%20468.158%20531.375%20468.247%20531.375%20468.35ZM535.125%20468.35C535.125%20468.454%20535.088%20468.542%20535.015%20468.615C534.942%20468.688%20534.854%20468.725%20534.75%20468.725C534.646%20468.725%20534.558%20468.688%20534.485%20468.615C534.412%20468.542%20534.375%20468.454%20534.375%20468.35C534.375%20468.247%20534.412%20468.158%20534.485%20468.085C534.558%20468.012%20534.646%20467.975%20534.75%20467.975C534.854%20467.975%20534.942%20468.012%20535.015%20468.085C535.088%20468.158%20535.125%20468.247%20535.125%20468.35ZM538.875%20468.35C538.875%20468.454%20538.838%20468.542%20538.765%20468.615C538.692%20468.688%20538.604%20468.725%20538.5%20468.725C538.396%20468.725%20538.308%20468.688%20538.235%20468.615C538.162%20468.542%20538.125%20468.454%20538.125%20468.35C538.125%20468.247%20538.162%20468.158%20538.235%20468.085C538.308%20468.012%20538.396%20467.975%20538.5%20467.975C538.604%20467.975%20538.692%20468.012%20538.765%20468.085C538.838%20468.158%20538.875%20468.247%20538.875%20468.35ZM542.625%20468.35C542.625%20468.454%20542.588%20468.542%20542.515%20468.615C542.442%20468.688%20542.353%20468.725%20542.25%20468.725C542.146%20468.725%20542.058%20468.688%20541.985%20468.615C541.912%20468.542%20541.875%20468.454%20541.875%20468.35C541.875%20468.247%20541.912%20468.158%20541.985%20468.085C542.058%20468.012%20542.146%20467.975%20542.25%20467.975C542.353%20467.975%20542.442%20468.012%20542.515%20468.085C542.588%20468.158%20542.625%20468.247%20542.625%20468.35ZM546.375%20468.35C546.375%20468.454%20546.338%20468.542%20546.265%20468.615C546.192%20468.688%20546.103%20468.725%20546%20468.725C545.896%20468.725%20545.808%20468.688%20545.735%20468.615C545.662%20468.542%20545.625%20468.454%20545.625%20468.35C545.625%20468.247%20545.662%20468.158%20545.735%20468.085C545.808%20468.012%20545.896%20467.975%20546%20467.975C546.103%20467.975%20546.192%20468.012%20546.265%20468.085C546.338%20468.158%20546.375%20468.247%20546.375%20468.35ZM550.125%20468.35C550.125%20468.454%20550.088%20468.542%20550.015%20468.615C549.942%20468.688%20549.853%20468.725%20549.75%20468.725C549.646%20468.725%20549.558%20468.688%20549.485%20468.615C549.412%20468.542%20549.375%20468.454%20549.375%20468.35C549.375%20468.247%20549.412%20468.158%20549.485%20468.085C549.558%20468.012%20549.646%20467.975%20549.75%20467.975C549.853%20467.975%20549.942%20468.012%20550.015%20468.085C550.088%20468.158%20550.125%20468.247%20550.125%20468.35ZM553.875%20468.35C553.875%20468.454%20553.838%20468.542%20553.765%20468.615C553.692%20468.688%20553.603%20468.725%20553.5%20468.725C553.396%20468.725%20553.308%20468.688%20553.235%20468.615C553.162%20468.542%20553.125%20468.454%20553.125%20468.35C553.125%20468.247%20553.162%20468.158%20553.235%20468.085C553.308%20468.012%20553.396%20467.975%20553.5%20467.975C553.603%20467.975%20553.692%20468.012%20553.765%20468.085C553.838%20468.158%20553.875%20468.247%20553.875%20468.35ZM557.625%20468.35C557.625%20468.454%20557.588%20468.542%20557.515%20468.615C557.442%20468.688%20557.353%20468.725%20557.25%20468.725C557.146%20468.725%20557.058%20468.688%20556.985%20468.615C556.912%20468.542%20556.875%20468.454%20556.875%20468.35C556.875%20468.247%20556.912%20468.158%20556.985%20468.085C557.058%20468.012%20557.146%20467.975%20557.25%20467.975C557.353%20467.975%20557.442%20468.012%20557.515%20468.085C557.588%20468.158%20557.625%20468.247%20557.625%20468.35ZM561.375%20468.35C561.375%20468.454%20561.338%20468.542%20561.265%20468.615C561.192%20468.688%20561.104%20468.725%20561%20468.725C560.896%20468.725%20560.808%20468.688%20560.735%20468.615C560.662%20468.542%20560.625%20468.454%20560.625%20468.35C560.625%20468.247%20560.662%20468.158%20560.735%20468.085C560.808%20468.012%20560.896%20467.975%20561%20467.975C561.104%20467.975%20561.192%20468.012%20561.265%20468.085C561.338%20468.158%20561.375%20468.247%20561.375%20468.35ZM565.125%20468.35C565.125%20468.454%20565.088%20468.542%20565.015%20468.615C564.942%20468.688%20564.853%20468.725%20564.75%20468.725C564.646%20468.725%20564.558%20468.688%20564.485%20468.615C564.412%20468.542%20564.375%20468.454%20564.375%20468.35C564.375%20468.247%20564.412%20468.158%20564.485%20468.085C564.558%20468.012%20564.646%20467.975%20564.75%20467.975C564.853%20467.975%20564.942%20468.012%20565.015%20468.085C565.088%20468.158%20565.125%20468.247%20565.125%20468.35ZM568.875%20468.35C568.875%20468.454%20568.838%20468.542%20568.765%20468.615C568.692%20468.688%20568.604%20468.725%20568.5%20468.725C568.396%20468.725%20568.308%20468.688%20568.235%20468.615C568.162%20468.542%20568.125%20468.454%20568.125%20468.35C568.125%20468.247%20568.162%20468.158%20568.235%20468.085C568.308%20468.012%20568.396%20467.975%20568.5%20467.975C568.604%20467.975%20568.692%20468.012%20568.765%20468.085C568.838%20468.158%20568.875%20468.247%20568.875%20468.35ZM572.625%20468.35C572.625%20468.454%20572.588%20468.542%20572.515%20468.615C572.442%20468.688%20572.354%20468.725%20572.25%20468.725C572.146%20468.725%20572.058%20468.688%20571.985%20468.615C571.912%20468.542%20571.875%20468.454%20571.875%20468.35C571.875%20468.247%20571.912%20468.158%20571.985%20468.085C572.058%20468.012%20572.146%20467.975%20572.25%20467.975C572.354%20467.975%20572.442%20468.012%20572.515%20468.085C572.588%20468.158%20572.625%20468.247%20572.625%20468.35ZM576.375%20468.35C576.375%20468.454%20576.338%20468.542%20576.265%20468.615C576.192%20468.688%20576.104%20468.725%20576%20468.725C575.896%20468.725%20575.808%20468.688%20575.735%20468.615C575.662%20468.542%20575.625%20468.454%20575.625%20468.35C575.625%20468.247%20575.662%20468.158%20575.735%20468.085C575.808%20468.012%20575.896%20467.975%20576%20467.975C576.104%20467.975%20576.192%20468.012%20576.265%20468.085C576.338%20468.158%20576.375%20468.247%20576.375%20468.35ZM580.125%20468.35C580.125%20468.454%20580.088%20468.542%20580.015%20468.615C579.942%20468.688%20579.853%20468.725%20579.75%20468.725C579.646%20468.725%20579.558%20468.688%20579.485%20468.615C579.412%20468.542%20579.375%20468.454%20579.375%20468.35C579.375%20468.247%20579.412%20468.158%20579.485%20468.085C579.558%20468.012%20579.646%20467.975%20579.75%20467.975C579.853%20467.975%20579.942%20468.012%20580.015%20468.085C580.088%20468.158%20580.125%20468.247%20580.125%20468.35ZM583.875%20468.35C583.875%20468.454%20583.838%20468.542%20583.765%20468.615C583.692%20468.688%20583.604%20468.725%20583.5%20468.725C583.396%20468.725%20583.308%20468.688%20583.235%20468.615C583.162%20468.542%20583.125%20468.454%20583.125%20468.35C583.125%20468.247%20583.162%20468.158%20583.235%20468.085C583.308%20468.012%20583.396%20467.975%20583.5%20467.975C583.604%20467.975%20583.692%20468.012%20583.765%20468.085C583.838%20468.158%20583.875%20468.247%20583.875%20468.35ZM587.625%20468.35C587.625%20468.454%20587.588%20468.542%20587.515%20468.615C587.442%20468.688%20587.354%20468.725%20587.25%20468.725C587.146%20468.725%20587.058%20468.688%20586.985%20468.615C586.912%20468.542%20586.875%20468.454%20586.875%20468.35C586.875%20468.247%20586.912%20468.158%20586.985%20468.085C587.058%20468.012%20587.146%20467.975%20587.25%20467.975C587.354%20467.975%20587.442%20468.012%20587.515%20468.085C587.588%20468.158%20587.625%20468.247%20587.625%20468.35ZM591.375%20468.35C591.375%20468.454%20591.338%20468.542%20591.265%20468.615C591.192%20468.688%20591.104%20468.725%20591%20468.725C590.896%20468.725%20590.808%20468.688%20590.735%20468.615C590.662%20468.542%20590.625%20468.454%20590.625%20468.35C590.625%20468.247%20590.662%20468.158%20590.735%20468.085C590.808%20468.012%20590.896%20467.975%20591%20467.975C591.104%20467.975%20591.192%20468.012%20591.265%20468.085C591.338%20468.158%20591.375%20468.247%20591.375%20468.35ZM595.125%20468.35C595.125%20468.454%20595.088%20468.542%20595.015%20468.615C594.942%20468.688%20594.854%20468.725%20594.75%20468.725C594.646%20468.725%20594.558%20468.688%20594.485%20468.615C594.412%20468.542%20594.375%20468.454%20594.375%20468.35C594.375%20468.247%20594.412%20468.158%20594.485%20468.085C594.558%20468.012%20594.646%20467.975%20594.75%20467.975C594.854%20467.975%20594.942%20468.012%20595.015%20468.085C595.088%20468.158%20595.125%20468.247%20595.125%20468.35ZM598.875%20468.35C598.875%20468.454%20598.838%20468.542%20598.765%20468.615C598.692%20468.688%20598.604%20468.725%20598.5%20468.725C598.396%20468.725%20598.308%20468.688%20598.235%20468.615C598.162%20468.542%20598.125%20468.454%20598.125%20468.35C598.125%20468.247%20598.162%20468.158%20598.235%20468.085C598.308%20468.012%20598.396%20467.975%20598.5%20467.975C598.604%20467.975%20598.692%20468.012%20598.765%20468.085C598.838%20468.158%20598.875%20468.247%20598.875%20468.35ZM602.625%20468.35C602.625%20468.454%20602.588%20468.542%20602.515%20468.615C602.442%20468.688%20602.354%20468.725%20602.25%20468.725C602.146%20468.725%20602.058%20468.688%20601.985%20468.615C601.912%20468.542%20601.875%20468.454%20601.875%20468.35C601.875%20468.247%20601.912%20468.158%20601.985%20468.085C602.058%20468.012%20602.146%20467.975%20602.25%20467.975C602.354%20467.975%20602.442%20468.012%20602.515%20468.085C602.588%20468.158%20602.625%20468.247%20602.625%20468.35ZM606.375%20468.35C606.375%20468.454%20606.338%20468.542%20606.265%20468.615C606.192%20468.688%20606.104%20468.725%20606%20468.725C605.896%20468.725%20605.808%20468.688%20605.735%20468.615C605.662%20468.542%20605.625%20468.454%20605.625%20468.35C605.625%20468.247%20605.662%20468.158%20605.735%20468.085C605.808%20468.012%20605.896%20467.975%20606%20467.975C606.104%20467.975%20606.192%20468.012%20606.265%20468.085C606.338%20468.158%20606.375%20468.247%20606.375%20468.35ZM610.125%20468.35C610.125%20468.454%20610.088%20468.542%20610.015%20468.615C609.942%20468.688%20609.854%20468.725%20609.75%20468.725C609.646%20468.725%20609.558%20468.688%20609.485%20468.615C609.412%20468.542%20609.375%20468.454%20609.375%20468.35C609.375%20468.247%20609.412%20468.158%20609.485%20468.085C609.558%20468.012%20609.646%20467.975%20609.75%20467.975C609.854%20467.975%20609.942%20468.012%20610.015%20468.085C610.088%20468.158%20610.125%20468.247%20610.125%20468.35ZM613.875%20468.35C613.875%20468.454%20613.838%20468.542%20613.765%20468.615C613.692%20468.688%20613.604%20468.725%20613.5%20468.725C613.396%20468.725%20613.308%20468.688%20613.235%20468.615C613.162%20468.542%20613.125%20468.454%20613.125%20468.35C613.125%20468.247%20613.162%20468.158%20613.235%20468.085C613.308%20468.012%20613.396%20467.975%20613.5%20467.975C613.604%20467.975%20613.692%20468.012%20613.765%20468.085C613.838%20468.158%20613.875%20468.247%20613.875%20468.35ZM617.625%20468.35C617.625%20468.454%20617.588%20468.542%20617.515%20468.615C617.442%20468.688%20617.354%20468.725%20617.25%20468.725C617.146%20468.725%20617.058%20468.688%20616.985%20468.615C616.912%20468.542%20616.875%20468.454%20616.875%20468.35C616.875%20468.247%20616.912%20468.158%20616.985%20468.085C617.058%20468.012%20617.146%20467.975%20617.25%20467.975C617.354%20467.975%20617.442%20468.012%20617.515%20468.085C617.588%20468.158%20617.625%20468.247%20617.625%20468.35ZM621.375%20468.35C621.375%20468.454%20621.338%20468.542%20621.265%20468.615C621.192%20468.688%20621.104%20468.725%20621%20468.725C620.896%20468.725%20620.808%20468.688%20620.735%20468.615C620.662%20468.542%20620.625%20468.454%20620.625%20468.35C620.625%20468.247%20620.662%20468.158%20620.735%20468.085C620.808%20468.012%20620.896%20467.975%20621%20467.975C621.104%20467.975%20621.192%20468.012%20621.265%20468.085C621.338%20468.158%20621.375%20468.247%20621.375%20468.35ZM625.125%20468.35C625.125%20468.454%20625.088%20468.542%20625.015%20468.615C624.942%20468.688%20624.854%20468.725%20624.75%20468.725C624.646%20468.725%20624.558%20468.688%20624.485%20468.615C624.412%20468.542%20624.375%20468.454%20624.375%20468.35C624.375%20468.247%20624.412%20468.158%20624.485%20468.085C624.558%20468.012%20624.646%20467.975%20624.75%20467.975C624.854%20467.975%20624.942%20468.012%20625.015%20468.085C625.088%20468.158%20625.125%20468.247%20625.125%20468.35ZM628.875%20468.35C628.875%20468.454%20628.838%20468.542%20628.765%20468.615C628.692%20468.688%20628.604%20468.725%20628.5%20468.725C628.396%20468.725%20628.308%20468.688%20628.235%20468.615C628.162%20468.542%20628.125%20468.454%20628.125%20468.35C628.125%20468.247%20628.162%20468.158%20628.235%20468.085C628.308%20468.012%20628.396%20467.975%20628.5%20467.975C628.604%20467.975%20628.692%20468.012%20628.765%20468.085C628.838%20468.158%20628.875%20468.247%20628.875%20468.35ZM632.625%20468.35C632.625%20468.454%20632.588%20468.542%20632.515%20468.615C632.442%20468.688%20632.354%20468.725%20632.25%20468.725C632.146%20468.725%20632.058%20468.688%20631.985%20468.615C631.912%20468.542%20631.875%20468.454%20631.875%20468.35C631.875%20468.247%20631.912%20468.158%20631.985%20468.085C632.058%20468.012%20632.146%20467.975%20632.25%20467.975C632.354%20467.975%20632.442%20468.012%20632.515%20468.085C632.588%20468.158%20632.625%20468.247%20632.625%20468.35ZM636.375%20468.35C636.375%20468.454%20636.338%20468.542%20636.265%20468.615C636.192%20468.688%20636.104%20468.725%20636%20468.725C635.896%20468.725%20635.808%20468.688%20635.735%20468.615C635.662%20468.542%20635.625%20468.454%20635.625%20468.35C635.625%20468.247%20635.662%20468.158%20635.735%20468.085C635.808%20468.012%20635.896%20467.975%20636%20467.975C636.104%20467.975%20636.192%20468.012%20636.265%20468.085C636.338%20468.158%20636.375%20468.247%20636.375%20468.35Z'%20fill='%23B4BAC3'%20/%3e%3cg%20filter='url(%23filter4_f_12_1053)'%3e%3cpath%20d='M47.391%20466.974H47.7174V467.552C48.3014%20467.57%2048.7756%20467.692%2049.1397%20467.919L48.9679%20468.404C48.8282%20468.326%2048.6439%20468.256%2048.4148%20468.194C48.1881%20468.13%2047.9556%20468.092%2047.7174%20468.081V469.826L48.0747%20469.912C48.487%20470.01%2048.7996%20470.168%2049.0126%20470.386C49.2256%20470.601%2049.3321%20470.908%2049.3321%20471.307C49.3321%20471.799%2049.1878%20472.176%2048.8992%20472.437C48.6129%20472.698%2048.219%20472.841%2047.7174%20472.866V473.461H47.391V472.866C47.0246%20472.855%2046.6971%20472.809%2046.4085%20472.729C46.1222%20472.646%2045.8932%20472.553%2045.7214%20472.447L45.9%20471.953C46.3627%20472.179%2046.8597%20472.308%2047.391%20472.337V470.345L46.886%20470.218C46.1142%20470.023%2045.7282%20469.611%2045.7282%20468.981C45.7282%20468.53%2045.8748%20468.187%2046.168%20467.954C46.4612%20467.718%2046.8688%20467.586%2047.391%20467.558V466.974ZM47.391%20469.747V468.084C46.6948%20468.125%2046.3466%20468.41%2046.3466%20468.94C46.3466%20469.134%2046.4096%20469.291%2046.5356%20469.41C46.6639%20469.527%2046.8551%20469.616%2047.1093%20469.678L47.391%20469.747ZM47.7174%20470.427V472.341C48.3839%20472.306%2048.7171%20471.969%2048.7171%20471.327C48.7171%20471.107%2048.6576%20470.93%2048.5385%20470.795C48.4217%20470.657%2048.2075%20470.55%2047.8961%20470.472L47.7174%20470.427ZM53.1146%20467.651L53.0665%20468.215H50.9674C50.9445%20468.881%2050.9273%20469.421%2050.9159%20469.833C51.1747%20469.668%2051.4553%20469.585%2051.7576%20469.585C52.0118%20469.585%2052.2386%20469.627%2052.4378%20469.709C52.6394%20469.789%2052.8031%20469.9%2052.9291%20470.042C53.0573%20470.184%2053.1547%20470.35%2053.2211%20470.541C53.2875%20470.728%2053.3207%20470.932%2053.3207%20471.152C53.3207%20471.672%2053.1535%20472.089%2052.8192%20472.403C52.4871%20472.714%2052.0347%20472.87%2051.4621%20472.87C50.8872%20472.87%2050.4269%20472.713%2050.081%20472.399L50.3044%20471.915C50.6433%20472.18%2051.0361%20472.313%2051.4827%20472.313C51.8584%20472.313%2052.155%20472.207%2052.3725%20471.994C52.5901%20471.781%2052.6989%20471.502%2052.6989%20471.159C52.6989%20470.852%2052.6073%20470.603%2052.4241%20470.413C52.2408%20470.221%2051.9797%20470.125%2051.6408%20470.125C51.3018%20470.125%2051.0292%20470.238%2050.8231%20470.465L50.3456%20470.4L50.4796%20467.651H53.1146ZM56.6463%20472.671C56.4196%20472.803%2056.1539%20472.87%2055.8493%20472.87C55.5447%20472.87%2055.2778%20472.803%2055.0488%20472.671C54.8198%20472.535%2054.6354%20472.346%2054.4957%20472.104C54.3583%20471.861%2054.2552%20471.581%2054.1865%20471.265C54.1201%20470.949%2054.0869%20470.598%2054.0869%20470.211C54.0869%20469.892%2054.1086%20469.598%2054.1521%20469.328C54.1979%20469.058%2054.2678%20468.812%2054.3617%20468.593C54.4556%20468.373%2054.5713%20468.186%2054.7087%20468.033C54.8484%20467.879%2055.0144%20467.761%2055.2068%20467.679C55.3992%20467.594%2055.6134%20467.552%2055.8493%20467.552C56.1424%20467.552%2056.4013%20467.616%2056.6257%20467.744C56.8524%20467.872%2057.0357%20468.055%2057.1754%20468.294C57.3174%20468.53%2057.4239%20468.809%2057.4949%20469.132C57.5659%20469.453%2057.6014%20469.812%2057.6014%20470.211C57.6014%20470.598%2057.5682%20470.949%2057.5018%20471.265C57.4353%20471.581%2057.3334%20471.861%2057.196%20472.104C57.0586%20472.346%2056.8754%20472.535%2056.6463%20472.671ZM56.4505%20468.352C56.2833%20468.167%2056.0829%20468.074%2055.8493%20468.074C55.6157%20468.074%2055.4153%20468.167%2055.2481%20468.352C55.0809%20468.535%2054.9549%20468.785%2054.8702%20469.101C54.7877%20469.415%2054.7465%20469.778%2054.7465%20470.19C54.7465%20470.609%2054.7877%20470.98%2054.8702%20471.303C54.9549%20471.624%2055.0809%20471.878%2055.2481%20472.066C55.4153%20472.254%2055.6157%20472.348%2055.8493%20472.348C56.0829%20472.348%2056.2833%20472.254%2056.4505%20472.066C56.6177%20471.878%2056.7425%20471.624%2056.825%20471.303C56.9097%20470.98%2056.9521%20470.609%2056.9521%20470.19C56.9521%20469.778%2056.9097%20469.415%2056.825%20469.101C56.7425%20468.785%2056.6177%20468.535%2056.4505%20468.352ZM62.3081%20472.791H61.5797L59.6352%20470.365L59.1714%20470.774V472.791H58.5736V467.71H59.1714V470.204L61.4045%20467.71H62.15L60.0887%20469.998L62.3081%20472.791Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cpath%20d='M70.125%20412.125C70.125%20412.229%2070.0884%20412.317%2070.0152%20412.39C69.9419%20412.463%2069.8536%20412.5%2069.75%20412.5C69.6464%20412.5%2069.5581%20412.463%2069.4848%20412.39C69.4116%20412.317%2069.375%20412.229%2069.375%20412.125C69.375%20412.021%2069.4116%20411.933%2069.4848%20411.86C69.5581%20411.787%2069.6464%20411.75%2069.75%20411.75C69.8536%20411.75%2069.9419%20411.787%2070.0152%20411.86C70.0884%20411.933%2070.125%20412.021%2070.125%20412.125ZM73.875%20412.125C73.875%20412.229%2073.8384%20412.317%2073.7652%20412.39C73.6919%20412.463%2073.6036%20412.5%2073.5%20412.5C73.3964%20412.5%2073.3081%20412.463%2073.2348%20412.39C73.1616%20412.317%2073.125%20412.229%2073.125%20412.125C73.125%20412.021%2073.1616%20411.933%2073.2348%20411.86C73.3081%20411.787%2073.3964%20411.75%2073.5%20411.75C73.6036%20411.75%2073.6919%20411.787%2073.7652%20411.86C73.8384%20411.933%2073.875%20412.021%2073.875%20412.125ZM77.625%20412.125C77.625%20412.229%2077.5884%20412.317%2077.5152%20412.39C77.4419%20412.463%2077.3536%20412.5%2077.25%20412.5C77.1464%20412.5%2077.0581%20412.463%2076.9848%20412.39C76.9116%20412.317%2076.875%20412.229%2076.875%20412.125C76.875%20412.021%2076.9116%20411.933%2076.9848%20411.86C77.0581%20411.787%2077.1464%20411.75%2077.25%20411.75C77.3536%20411.75%2077.4419%20411.787%2077.5152%20411.86C77.5884%20411.933%2077.625%20412.021%2077.625%20412.125ZM81.375%20412.125C81.375%20412.229%2081.3384%20412.317%2081.2652%20412.39C81.1919%20412.463%2081.1036%20412.5%2081%20412.5C80.8964%20412.5%2080.8081%20412.463%2080.7348%20412.39C80.6616%20412.317%2080.625%20412.229%2080.625%20412.125C80.625%20412.021%2080.6616%20411.933%2080.7348%20411.86C80.8081%20411.787%2080.8964%20411.75%2081%20411.75C81.1036%20411.75%2081.1919%20411.787%2081.2652%20411.86C81.3384%20411.933%2081.375%20412.021%2081.375%20412.125ZM85.125%20412.125C85.125%20412.229%2085.0884%20412.317%2085.0152%20412.39C84.9419%20412.463%2084.8536%20412.5%2084.75%20412.5C84.6464%20412.5%2084.5581%20412.463%2084.4848%20412.39C84.4116%20412.317%2084.375%20412.229%2084.375%20412.125C84.375%20412.021%2084.4116%20411.933%2084.4848%20411.86C84.5581%20411.787%2084.6464%20411.75%2084.75%20411.75C84.8536%20411.75%2084.9419%20411.787%2085.0152%20411.86C85.0884%20411.933%2085.125%20412.021%2085.125%20412.125ZM88.875%20412.125C88.875%20412.229%2088.8384%20412.317%2088.7652%20412.39C88.6919%20412.463%2088.6036%20412.5%2088.5%20412.5C88.3964%20412.5%2088.3081%20412.463%2088.2348%20412.39C88.1616%20412.317%2088.125%20412.229%2088.125%20412.125C88.125%20412.021%2088.1616%20411.933%2088.2348%20411.86C88.3081%20411.787%2088.3964%20411.75%2088.5%20411.75C88.6036%20411.75%2088.6919%20411.787%2088.7652%20411.86C88.8384%20411.933%2088.875%20412.021%2088.875%20412.125ZM92.625%20412.125C92.625%20412.229%2092.5884%20412.317%2092.5152%20412.39C92.4419%20412.463%2092.3536%20412.5%2092.25%20412.5C92.1464%20412.5%2092.0581%20412.463%2091.9848%20412.39C91.9116%20412.317%2091.875%20412.229%2091.875%20412.125C91.875%20412.021%2091.9116%20411.933%2091.9848%20411.86C92.0581%20411.787%2092.1464%20411.75%2092.25%20411.75C92.3536%20411.75%2092.4419%20411.787%2092.5152%20411.86C92.5884%20411.933%2092.625%20412.021%2092.625%20412.125ZM96.375%20412.125C96.375%20412.229%2096.3384%20412.317%2096.2652%20412.39C96.1919%20412.463%2096.1036%20412.5%2096%20412.5C95.8964%20412.5%2095.8081%20412.463%2095.7348%20412.39C95.6616%20412.317%2095.625%20412.229%2095.625%20412.125C95.625%20412.021%2095.6616%20411.933%2095.7348%20411.86C95.8081%20411.787%2095.8964%20411.75%2096%20411.75C96.1036%20411.75%2096.1919%20411.787%2096.2652%20411.86C96.3384%20411.933%2096.375%20412.021%2096.375%20412.125ZM100.125%20412.125C100.125%20412.229%20100.088%20412.317%20100.015%20412.39C99.9419%20412.463%2099.8536%20412.5%2099.75%20412.5C99.6464%20412.5%2099.5581%20412.463%2099.4848%20412.39C99.4116%20412.317%2099.375%20412.229%2099.375%20412.125C99.375%20412.021%2099.4116%20411.933%2099.4848%20411.86C99.5581%20411.787%2099.6464%20411.75%2099.75%20411.75C99.8536%20411.75%2099.9419%20411.787%20100.015%20411.86C100.088%20411.933%20100.125%20412.021%20100.125%20412.125ZM103.875%20412.125C103.875%20412.229%20103.838%20412.317%20103.765%20412.39C103.692%20412.463%20103.604%20412.5%20103.5%20412.5C103.396%20412.5%20103.308%20412.463%20103.235%20412.39C103.162%20412.317%20103.125%20412.229%20103.125%20412.125C103.125%20412.021%20103.162%20411.933%20103.235%20411.86C103.308%20411.787%20103.396%20411.75%20103.5%20411.75C103.604%20411.75%20103.692%20411.787%20103.765%20411.86C103.838%20411.933%20103.875%20412.021%20103.875%20412.125ZM107.625%20412.125C107.625%20412.229%20107.588%20412.317%20107.515%20412.39C107.442%20412.463%20107.354%20412.5%20107.25%20412.5C107.146%20412.5%20107.058%20412.463%20106.985%20412.39C106.912%20412.317%20106.875%20412.229%20106.875%20412.125C106.875%20412.021%20106.912%20411.933%20106.985%20411.86C107.058%20411.787%20107.146%20411.75%20107.25%20411.75C107.354%20411.75%20107.442%20411.787%20107.515%20411.86C107.588%20411.933%20107.625%20412.021%20107.625%20412.125ZM111.375%20412.125C111.375%20412.229%20111.338%20412.317%20111.265%20412.39C111.192%20412.463%20111.104%20412.5%20111%20412.5C110.896%20412.5%20110.808%20412.463%20110.735%20412.39C110.662%20412.317%20110.625%20412.229%20110.625%20412.125C110.625%20412.021%20110.662%20411.933%20110.735%20411.86C110.808%20411.787%20110.896%20411.75%20111%20411.75C111.104%20411.75%20111.192%20411.787%20111.265%20411.86C111.338%20411.933%20111.375%20412.021%20111.375%20412.125ZM115.125%20412.125C115.125%20412.229%20115.088%20412.317%20115.015%20412.39C114.942%20412.463%20114.854%20412.5%20114.75%20412.5C114.646%20412.5%20114.558%20412.463%20114.485%20412.39C114.412%20412.317%20114.375%20412.229%20114.375%20412.125C114.375%20412.021%20114.412%20411.933%20114.485%20411.86C114.558%20411.787%20114.646%20411.75%20114.75%20411.75C114.854%20411.75%20114.942%20411.787%20115.015%20411.86C115.088%20411.933%20115.125%20412.021%20115.125%20412.125ZM118.875%20412.125C118.875%20412.229%20118.838%20412.317%20118.765%20412.39C118.692%20412.463%20118.604%20412.5%20118.5%20412.5C118.396%20412.5%20118.308%20412.463%20118.235%20412.39C118.162%20412.317%20118.125%20412.229%20118.125%20412.125C118.125%20412.021%20118.162%20411.933%20118.235%20411.86C118.308%20411.787%20118.396%20411.75%20118.5%20411.75C118.604%20411.75%20118.692%20411.787%20118.765%20411.86C118.838%20411.933%20118.875%20412.021%20118.875%20412.125ZM122.625%20412.125C122.625%20412.229%20122.588%20412.317%20122.515%20412.39C122.442%20412.463%20122.354%20412.5%20122.25%20412.5C122.146%20412.5%20122.058%20412.463%20121.985%20412.39C121.912%20412.317%20121.875%20412.229%20121.875%20412.125C121.875%20412.021%20121.912%20411.933%20121.985%20411.86C122.058%20411.787%20122.146%20411.75%20122.25%20411.75C122.354%20411.75%20122.442%20411.787%20122.515%20411.86C122.588%20411.933%20122.625%20412.021%20122.625%20412.125ZM126.375%20412.125C126.375%20412.229%20126.338%20412.317%20126.265%20412.39C126.192%20412.463%20126.104%20412.5%20126%20412.5C125.896%20412.5%20125.808%20412.463%20125.735%20412.39C125.662%20412.317%20125.625%20412.229%20125.625%20412.125C125.625%20412.021%20125.662%20411.933%20125.735%20411.86C125.808%20411.787%20125.896%20411.75%20126%20411.75C126.104%20411.75%20126.192%20411.787%20126.265%20411.86C126.338%20411.933%20126.375%20412.021%20126.375%20412.125ZM130.125%20412.125C130.125%20412.229%20130.088%20412.317%20130.015%20412.39C129.942%20412.463%20129.854%20412.5%20129.75%20412.5C129.646%20412.5%20129.558%20412.463%20129.485%20412.39C129.412%20412.317%20129.375%20412.229%20129.375%20412.125C129.375%20412.021%20129.412%20411.933%20129.485%20411.86C129.558%20411.787%20129.646%20411.75%20129.75%20411.75C129.854%20411.75%20129.942%20411.787%20130.015%20411.86C130.088%20411.933%20130.125%20412.021%20130.125%20412.125ZM133.875%20412.125C133.875%20412.229%20133.838%20412.317%20133.765%20412.39C133.692%20412.463%20133.604%20412.5%20133.5%20412.5C133.396%20412.5%20133.308%20412.463%20133.235%20412.39C133.162%20412.317%20133.125%20412.229%20133.125%20412.125C133.125%20412.021%20133.162%20411.933%20133.235%20411.86C133.308%20411.787%20133.396%20411.75%20133.5%20411.75C133.604%20411.75%20133.692%20411.787%20133.765%20411.86C133.838%20411.933%20133.875%20412.021%20133.875%20412.125ZM137.625%20412.125C137.625%20412.229%20137.588%20412.317%20137.515%20412.39C137.442%20412.463%20137.354%20412.5%20137.25%20412.5C137.146%20412.5%20137.058%20412.463%20136.985%20412.39C136.912%20412.317%20136.875%20412.229%20136.875%20412.125C136.875%20412.021%20136.912%20411.933%20136.985%20411.86C137.058%20411.787%20137.146%20411.75%20137.25%20411.75C137.354%20411.75%20137.442%20411.787%20137.515%20411.86C137.588%20411.933%20137.625%20412.021%20137.625%20412.125ZM141.375%20412.125C141.375%20412.229%20141.338%20412.317%20141.265%20412.39C141.192%20412.463%20141.104%20412.5%20141%20412.5C140.896%20412.5%20140.808%20412.463%20140.735%20412.39C140.662%20412.317%20140.625%20412.229%20140.625%20412.125C140.625%20412.021%20140.662%20411.933%20140.735%20411.86C140.808%20411.787%20140.896%20411.75%20141%20411.75C141.104%20411.75%20141.192%20411.787%20141.265%20411.86C141.338%20411.933%20141.375%20412.021%20141.375%20412.125ZM145.125%20412.125C145.125%20412.229%20145.088%20412.317%20145.015%20412.39C144.942%20412.463%20144.854%20412.5%20144.75%20412.5C144.646%20412.5%20144.558%20412.463%20144.485%20412.39C144.412%20412.317%20144.375%20412.229%20144.375%20412.125C144.375%20412.021%20144.412%20411.933%20144.485%20411.86C144.558%20411.787%20144.646%20411.75%20144.75%20411.75C144.854%20411.75%20144.942%20411.787%20145.015%20411.86C145.088%20411.933%20145.125%20412.021%20145.125%20412.125ZM148.875%20412.125C148.875%20412.229%20148.838%20412.317%20148.765%20412.39C148.692%20412.463%20148.604%20412.5%20148.5%20412.5C148.396%20412.5%20148.308%20412.463%20148.235%20412.39C148.162%20412.317%20148.125%20412.229%20148.125%20412.125C148.125%20412.021%20148.162%20411.933%20148.235%20411.86C148.308%20411.787%20148.396%20411.75%20148.5%20411.75C148.604%20411.75%20148.692%20411.787%20148.765%20411.86C148.838%20411.933%20148.875%20412.021%20148.875%20412.125ZM152.625%20412.125C152.625%20412.229%20152.588%20412.317%20152.515%20412.39C152.442%20412.463%20152.354%20412.5%20152.25%20412.5C152.146%20412.5%20152.058%20412.463%20151.985%20412.39C151.912%20412.317%20151.875%20412.229%20151.875%20412.125C151.875%20412.021%20151.912%20411.933%20151.985%20411.86C152.058%20411.787%20152.146%20411.75%20152.25%20411.75C152.354%20411.75%20152.442%20411.787%20152.515%20411.86C152.588%20411.933%20152.625%20412.021%20152.625%20412.125ZM156.375%20412.125C156.375%20412.229%20156.338%20412.317%20156.265%20412.39C156.192%20412.463%20156.104%20412.5%20156%20412.5C155.896%20412.5%20155.808%20412.463%20155.735%20412.39C155.662%20412.317%20155.625%20412.229%20155.625%20412.125C155.625%20412.021%20155.662%20411.933%20155.735%20411.86C155.808%20411.787%20155.896%20411.75%20156%20411.75C156.104%20411.75%20156.192%20411.787%20156.265%20411.86C156.338%20411.933%20156.375%20412.021%20156.375%20412.125ZM160.125%20412.125C160.125%20412.229%20160.088%20412.317%20160.015%20412.39C159.942%20412.463%20159.854%20412.5%20159.75%20412.5C159.646%20412.5%20159.558%20412.463%20159.485%20412.39C159.412%20412.317%20159.375%20412.229%20159.375%20412.125C159.375%20412.021%20159.412%20411.933%20159.485%20411.86C159.558%20411.787%20159.646%20411.75%20159.75%20411.75C159.854%20411.75%20159.942%20411.787%20160.015%20411.86C160.088%20411.933%20160.125%20412.021%20160.125%20412.125ZM163.875%20412.125C163.875%20412.229%20163.838%20412.317%20163.765%20412.39C163.692%20412.463%20163.604%20412.5%20163.5%20412.5C163.396%20412.5%20163.308%20412.463%20163.235%20412.39C163.162%20412.317%20163.125%20412.229%20163.125%20412.125C163.125%20412.021%20163.162%20411.933%20163.235%20411.86C163.308%20411.787%20163.396%20411.75%20163.5%20411.75C163.604%20411.75%20163.692%20411.787%20163.765%20411.86C163.838%20411.933%20163.875%20412.021%20163.875%20412.125ZM167.625%20412.125C167.625%20412.229%20167.588%20412.317%20167.515%20412.39C167.442%20412.463%20167.354%20412.5%20167.25%20412.5C167.146%20412.5%20167.058%20412.463%20166.985%20412.39C166.912%20412.317%20166.875%20412.229%20166.875%20412.125C166.875%20412.021%20166.912%20411.933%20166.985%20411.86C167.058%20411.787%20167.146%20411.75%20167.25%20411.75C167.354%20411.75%20167.442%20411.787%20167.515%20411.86C167.588%20411.933%20167.625%20412.021%20167.625%20412.125ZM171.375%20412.125C171.375%20412.229%20171.338%20412.317%20171.265%20412.39C171.192%20412.463%20171.104%20412.5%20171%20412.5C170.896%20412.5%20170.808%20412.463%20170.735%20412.39C170.662%20412.317%20170.625%20412.229%20170.625%20412.125C170.625%20412.021%20170.662%20411.933%20170.735%20411.86C170.808%20411.787%20170.896%20411.75%20171%20411.75C171.104%20411.75%20171.192%20411.787%20171.265%20411.86C171.338%20411.933%20171.375%20412.021%20171.375%20412.125ZM175.125%20412.125C175.125%20412.229%20175.088%20412.317%20175.015%20412.39C174.942%20412.463%20174.854%20412.5%20174.75%20412.5C174.646%20412.5%20174.558%20412.463%20174.485%20412.39C174.412%20412.317%20174.375%20412.229%20174.375%20412.125C174.375%20412.021%20174.412%20411.933%20174.485%20411.86C174.558%20411.787%20174.646%20411.75%20174.75%20411.75C174.854%20411.75%20174.942%20411.787%20175.015%20411.86C175.088%20411.933%20175.125%20412.021%20175.125%20412.125ZM178.875%20412.125C178.875%20412.229%20178.838%20412.317%20178.765%20412.39C178.692%20412.463%20178.604%20412.5%20178.5%20412.5C178.396%20412.5%20178.308%20412.463%20178.235%20412.39C178.162%20412.317%20178.125%20412.229%20178.125%20412.125C178.125%20412.021%20178.162%20411.933%20178.235%20411.86C178.308%20411.787%20178.396%20411.75%20178.5%20411.75C178.604%20411.75%20178.692%20411.787%20178.765%20411.86C178.838%20411.933%20178.875%20412.021%20178.875%20412.125ZM182.625%20412.125C182.625%20412.229%20182.588%20412.317%20182.515%20412.39C182.442%20412.463%20182.354%20412.5%20182.25%20412.5C182.146%20412.5%20182.058%20412.463%20181.985%20412.39C181.912%20412.317%20181.875%20412.229%20181.875%20412.125C181.875%20412.021%20181.912%20411.933%20181.985%20411.86C182.058%20411.787%20182.146%20411.75%20182.25%20411.75C182.354%20411.75%20182.442%20411.787%20182.515%20411.86C182.588%20411.933%20182.625%20412.021%20182.625%20412.125ZM186.375%20412.125C186.375%20412.229%20186.338%20412.317%20186.265%20412.39C186.192%20412.463%20186.104%20412.5%20186%20412.5C185.896%20412.5%20185.808%20412.463%20185.735%20412.39C185.662%20412.317%20185.625%20412.229%20185.625%20412.125C185.625%20412.021%20185.662%20411.933%20185.735%20411.86C185.808%20411.787%20185.896%20411.75%20186%20411.75C186.104%20411.75%20186.192%20411.787%20186.265%20411.86C186.338%20411.933%20186.375%20412.021%20186.375%20412.125ZM190.125%20412.125C190.125%20412.229%20190.088%20412.317%20190.015%20412.39C189.942%20412.463%20189.854%20412.5%20189.75%20412.5C189.646%20412.5%20189.558%20412.463%20189.485%20412.39C189.412%20412.317%20189.375%20412.229%20189.375%20412.125C189.375%20412.021%20189.412%20411.933%20189.485%20411.86C189.558%20411.787%20189.646%20411.75%20189.75%20411.75C189.854%20411.75%20189.942%20411.787%20190.015%20411.86C190.088%20411.933%20190.125%20412.021%20190.125%20412.125ZM193.875%20412.125C193.875%20412.229%20193.838%20412.317%20193.765%20412.39C193.692%20412.463%20193.604%20412.5%20193.5%20412.5C193.396%20412.5%20193.308%20412.463%20193.235%20412.39C193.162%20412.317%20193.125%20412.229%20193.125%20412.125C193.125%20412.021%20193.162%20411.933%20193.235%20411.86C193.308%20411.787%20193.396%20411.75%20193.5%20411.75C193.604%20411.75%20193.692%20411.787%20193.765%20411.86C193.838%20411.933%20193.875%20412.021%20193.875%20412.125ZM197.625%20412.125C197.625%20412.229%20197.588%20412.317%20197.515%20412.39C197.442%20412.463%20197.354%20412.5%20197.25%20412.5C197.146%20412.5%20197.058%20412.463%20196.985%20412.39C196.912%20412.317%20196.875%20412.229%20196.875%20412.125C196.875%20412.021%20196.912%20411.933%20196.985%20411.86C197.058%20411.787%20197.146%20411.75%20197.25%20411.75C197.354%20411.75%20197.442%20411.787%20197.515%20411.86C197.588%20411.933%20197.625%20412.021%20197.625%20412.125ZM201.375%20412.125C201.375%20412.229%20201.338%20412.317%20201.265%20412.39C201.192%20412.463%20201.104%20412.5%20201%20412.5C200.896%20412.5%20200.808%20412.463%20200.735%20412.39C200.662%20412.317%20200.625%20412.229%20200.625%20412.125C200.625%20412.021%20200.662%20411.933%20200.735%20411.86C200.808%20411.787%20200.896%20411.75%20201%20411.75C201.104%20411.75%20201.192%20411.787%20201.265%20411.86C201.338%20411.933%20201.375%20412.021%20201.375%20412.125ZM205.125%20412.125C205.125%20412.229%20205.088%20412.317%20205.015%20412.39C204.942%20412.463%20204.854%20412.5%20204.75%20412.5C204.646%20412.5%20204.558%20412.463%20204.485%20412.39C204.412%20412.317%20204.375%20412.229%20204.375%20412.125C204.375%20412.021%20204.412%20411.933%20204.485%20411.86C204.558%20411.787%20204.646%20411.75%20204.75%20411.75C204.854%20411.75%20204.942%20411.787%20205.015%20411.86C205.088%20411.933%20205.125%20412.021%20205.125%20412.125ZM208.875%20412.125C208.875%20412.229%20208.838%20412.317%20208.765%20412.39C208.692%20412.463%20208.604%20412.5%20208.5%20412.5C208.396%20412.5%20208.308%20412.463%20208.235%20412.39C208.162%20412.317%20208.125%20412.229%20208.125%20412.125C208.125%20412.021%20208.162%20411.933%20208.235%20411.86C208.308%20411.787%20208.396%20411.75%20208.5%20411.75C208.604%20411.75%20208.692%20411.787%20208.765%20411.86C208.838%20411.933%20208.875%20412.021%20208.875%20412.125ZM212.625%20412.125C212.625%20412.229%20212.588%20412.317%20212.515%20412.39C212.442%20412.463%20212.354%20412.5%20212.25%20412.5C212.146%20412.5%20212.058%20412.463%20211.985%20412.39C211.912%20412.317%20211.875%20412.229%20211.875%20412.125C211.875%20412.021%20211.912%20411.933%20211.985%20411.86C212.058%20411.787%20212.146%20411.75%20212.25%20411.75C212.354%20411.75%20212.442%20411.787%20212.515%20411.86C212.588%20411.933%20212.625%20412.021%20212.625%20412.125ZM216.375%20412.125C216.375%20412.229%20216.338%20412.317%20216.265%20412.39C216.192%20412.463%20216.104%20412.5%20216%20412.5C215.896%20412.5%20215.808%20412.463%20215.735%20412.39C215.662%20412.317%20215.625%20412.229%20215.625%20412.125C215.625%20412.021%20215.662%20411.933%20215.735%20411.86C215.808%20411.787%20215.896%20411.75%20216%20411.75C216.104%20411.75%20216.192%20411.787%20216.265%20411.86C216.338%20411.933%20216.375%20412.021%20216.375%20412.125ZM220.125%20412.125C220.125%20412.229%20220.088%20412.317%20220.015%20412.39C219.942%20412.463%20219.854%20412.5%20219.75%20412.5C219.646%20412.5%20219.558%20412.463%20219.485%20412.39C219.412%20412.317%20219.375%20412.229%20219.375%20412.125C219.375%20412.021%20219.412%20411.933%20219.485%20411.86C219.558%20411.787%20219.646%20411.75%20219.75%20411.75C219.854%20411.75%20219.942%20411.787%20220.015%20411.86C220.088%20411.933%20220.125%20412.021%20220.125%20412.125ZM223.875%20412.125C223.875%20412.229%20223.838%20412.317%20223.765%20412.39C223.692%20412.463%20223.604%20412.5%20223.5%20412.5C223.396%20412.5%20223.308%20412.463%20223.235%20412.39C223.162%20412.317%20223.125%20412.229%20223.125%20412.125C223.125%20412.021%20223.162%20411.933%20223.235%20411.86C223.308%20411.787%20223.396%20411.75%20223.5%20411.75C223.604%20411.75%20223.692%20411.787%20223.765%20411.86C223.838%20411.933%20223.875%20412.021%20223.875%20412.125ZM227.625%20412.125C227.625%20412.229%20227.588%20412.317%20227.515%20412.39C227.442%20412.463%20227.354%20412.5%20227.25%20412.5C227.146%20412.5%20227.058%20412.463%20226.985%20412.39C226.912%20412.317%20226.875%20412.229%20226.875%20412.125C226.875%20412.021%20226.912%20411.933%20226.985%20411.86C227.058%20411.787%20227.146%20411.75%20227.25%20411.75C227.354%20411.75%20227.442%20411.787%20227.515%20411.86C227.588%20411.933%20227.625%20412.021%20227.625%20412.125ZM231.375%20412.125C231.375%20412.229%20231.338%20412.317%20231.265%20412.39C231.192%20412.463%20231.104%20412.5%20231%20412.5C230.896%20412.5%20230.808%20412.463%20230.735%20412.39C230.662%20412.317%20230.625%20412.229%20230.625%20412.125C230.625%20412.021%20230.662%20411.933%20230.735%20411.86C230.808%20411.787%20230.896%20411.75%20231%20411.75C231.104%20411.75%20231.192%20411.787%20231.265%20411.86C231.338%20411.933%20231.375%20412.021%20231.375%20412.125ZM235.125%20412.125C235.125%20412.229%20235.088%20412.317%20235.015%20412.39C234.942%20412.463%20234.854%20412.5%20234.75%20412.5C234.646%20412.5%20234.558%20412.463%20234.485%20412.39C234.412%20412.317%20234.375%20412.229%20234.375%20412.125C234.375%20412.021%20234.412%20411.933%20234.485%20411.86C234.558%20411.787%20234.646%20411.75%20234.75%20411.75C234.854%20411.75%20234.942%20411.787%20235.015%20411.86C235.088%20411.933%20235.125%20412.021%20235.125%20412.125ZM238.875%20412.125C238.875%20412.229%20238.838%20412.317%20238.765%20412.39C238.692%20412.463%20238.604%20412.5%20238.5%20412.5C238.396%20412.5%20238.308%20412.463%20238.235%20412.39C238.162%20412.317%20238.125%20412.229%20238.125%20412.125C238.125%20412.021%20238.162%20411.933%20238.235%20411.86C238.308%20411.787%20238.396%20411.75%20238.5%20411.75C238.604%20411.75%20238.692%20411.787%20238.765%20411.86C238.838%20411.933%20238.875%20412.021%20238.875%20412.125ZM242.625%20412.125C242.625%20412.229%20242.588%20412.317%20242.515%20412.39C242.442%20412.463%20242.354%20412.5%20242.25%20412.5C242.146%20412.5%20242.058%20412.463%20241.985%20412.39C241.912%20412.317%20241.875%20412.229%20241.875%20412.125C241.875%20412.021%20241.912%20411.933%20241.985%20411.86C242.058%20411.787%20242.146%20411.75%20242.25%20411.75C242.354%20411.75%20242.442%20411.787%20242.515%20411.86C242.588%20411.933%20242.625%20412.021%20242.625%20412.125ZM246.375%20412.125C246.375%20412.229%20246.338%20412.317%20246.265%20412.39C246.192%20412.463%20246.104%20412.5%20246%20412.5C245.896%20412.5%20245.808%20412.463%20245.735%20412.39C245.662%20412.317%20245.625%20412.229%20245.625%20412.125C245.625%20412.021%20245.662%20411.933%20245.735%20411.86C245.808%20411.787%20245.896%20411.75%20246%20411.75C246.104%20411.75%20246.192%20411.787%20246.265%20411.86C246.338%20411.933%20246.375%20412.021%20246.375%20412.125ZM250.125%20412.125C250.125%20412.229%20250.088%20412.317%20250.015%20412.39C249.942%20412.463%20249.854%20412.5%20249.75%20412.5C249.646%20412.5%20249.558%20412.463%20249.485%20412.39C249.412%20412.317%20249.375%20412.229%20249.375%20412.125C249.375%20412.021%20249.412%20411.933%20249.485%20411.86C249.558%20411.787%20249.646%20411.75%20249.75%20411.75C249.854%20411.75%20249.942%20411.787%20250.015%20411.86C250.088%20411.933%20250.125%20412.021%20250.125%20412.125ZM253.875%20412.125C253.875%20412.229%20253.838%20412.317%20253.765%20412.39C253.692%20412.463%20253.604%20412.5%20253.5%20412.5C253.396%20412.5%20253.308%20412.463%20253.235%20412.39C253.162%20412.317%20253.125%20412.229%20253.125%20412.125C253.125%20412.021%20253.162%20411.933%20253.235%20411.86C253.308%20411.787%20253.396%20411.75%20253.5%20411.75C253.604%20411.75%20253.692%20411.787%20253.765%20411.86C253.838%20411.933%20253.875%20412.021%20253.875%20412.125ZM257.625%20412.125C257.625%20412.229%20257.588%20412.317%20257.515%20412.39C257.442%20412.463%20257.354%20412.5%20257.25%20412.5C257.146%20412.5%20257.058%20412.463%20256.985%20412.39C256.912%20412.317%20256.875%20412.229%20256.875%20412.125C256.875%20412.021%20256.912%20411.933%20256.985%20411.86C257.058%20411.787%20257.146%20411.75%20257.25%20411.75C257.354%20411.75%20257.442%20411.787%20257.515%20411.86C257.588%20411.933%20257.625%20412.021%20257.625%20412.125ZM261.375%20412.125C261.375%20412.229%20261.338%20412.317%20261.265%20412.39C261.192%20412.463%20261.104%20412.5%20261%20412.5C260.896%20412.5%20260.808%20412.463%20260.735%20412.39C260.662%20412.317%20260.625%20412.229%20260.625%20412.125C260.625%20412.021%20260.662%20411.933%20260.735%20411.86C260.808%20411.787%20260.896%20411.75%20261%20411.75C261.104%20411.75%20261.192%20411.787%20261.265%20411.86C261.338%20411.933%20261.375%20412.021%20261.375%20412.125ZM265.125%20412.125C265.125%20412.229%20265.088%20412.317%20265.015%20412.39C264.942%20412.463%20264.854%20412.5%20264.75%20412.5C264.646%20412.5%20264.558%20412.463%20264.485%20412.39C264.412%20412.317%20264.375%20412.229%20264.375%20412.125C264.375%20412.021%20264.412%20411.933%20264.485%20411.86C264.558%20411.787%20264.646%20411.75%20264.75%20411.75C264.854%20411.75%20264.942%20411.787%20265.015%20411.86C265.088%20411.933%20265.125%20412.021%20265.125%20412.125ZM268.875%20412.125C268.875%20412.229%20268.838%20412.317%20268.765%20412.39C268.692%20412.463%20268.604%20412.5%20268.5%20412.5C268.396%20412.5%20268.308%20412.463%20268.235%20412.39C268.162%20412.317%20268.125%20412.229%20268.125%20412.125C268.125%20412.021%20268.162%20411.933%20268.235%20411.86C268.308%20411.787%20268.396%20411.75%20268.5%20411.75C268.604%20411.75%20268.692%20411.787%20268.765%20411.86C268.838%20411.933%20268.875%20412.021%20268.875%20412.125ZM272.625%20412.125C272.625%20412.229%20272.588%20412.317%20272.515%20412.39C272.442%20412.463%20272.354%20412.5%20272.25%20412.5C272.146%20412.5%20272.058%20412.463%20271.985%20412.39C271.912%20412.317%20271.875%20412.229%20271.875%20412.125C271.875%20412.021%20271.912%20411.933%20271.985%20411.86C272.058%20411.787%20272.146%20411.75%20272.25%20411.75C272.354%20411.75%20272.442%20411.787%20272.515%20411.86C272.588%20411.933%20272.625%20412.021%20272.625%20412.125ZM276.375%20412.125C276.375%20412.229%20276.338%20412.317%20276.265%20412.39C276.192%20412.463%20276.104%20412.5%20276%20412.5C275.896%20412.5%20275.808%20412.463%20275.735%20412.39C275.662%20412.317%20275.625%20412.229%20275.625%20412.125C275.625%20412.021%20275.662%20411.933%20275.735%20411.86C275.808%20411.787%20275.896%20411.75%20276%20411.75C276.104%20411.75%20276.192%20411.787%20276.265%20411.86C276.338%20411.933%20276.375%20412.021%20276.375%20412.125ZM280.125%20412.125C280.125%20412.229%20280.088%20412.317%20280.015%20412.39C279.942%20412.463%20279.854%20412.5%20279.75%20412.5C279.646%20412.5%20279.558%20412.463%20279.485%20412.39C279.412%20412.317%20279.375%20412.229%20279.375%20412.125C279.375%20412.021%20279.412%20411.933%20279.485%20411.86C279.558%20411.787%20279.646%20411.75%20279.75%20411.75C279.854%20411.75%20279.942%20411.787%20280.015%20411.86C280.088%20411.933%20280.125%20412.021%20280.125%20412.125ZM283.875%20412.125C283.875%20412.229%20283.838%20412.317%20283.765%20412.39C283.692%20412.463%20283.604%20412.5%20283.5%20412.5C283.396%20412.5%20283.308%20412.463%20283.235%20412.39C283.162%20412.317%20283.125%20412.229%20283.125%20412.125C283.125%20412.021%20283.162%20411.933%20283.235%20411.86C283.308%20411.787%20283.396%20411.75%20283.5%20411.75C283.604%20411.75%20283.692%20411.787%20283.765%20411.86C283.838%20411.933%20283.875%20412.021%20283.875%20412.125ZM287.625%20412.125C287.625%20412.229%20287.588%20412.317%20287.515%20412.39C287.442%20412.463%20287.354%20412.5%20287.25%20412.5C287.146%20412.5%20287.058%20412.463%20286.985%20412.39C286.912%20412.317%20286.875%20412.229%20286.875%20412.125C286.875%20412.021%20286.912%20411.933%20286.985%20411.86C287.058%20411.787%20287.146%20411.75%20287.25%20411.75C287.354%20411.75%20287.442%20411.787%20287.515%20411.86C287.588%20411.933%20287.625%20412.021%20287.625%20412.125ZM291.375%20412.125C291.375%20412.229%20291.338%20412.317%20291.265%20412.39C291.192%20412.463%20291.104%20412.5%20291%20412.5C290.896%20412.5%20290.808%20412.463%20290.735%20412.39C290.662%20412.317%20290.625%20412.229%20290.625%20412.125C290.625%20412.021%20290.662%20411.933%20290.735%20411.86C290.808%20411.787%20290.896%20411.75%20291%20411.75C291.104%20411.75%20291.192%20411.787%20291.265%20411.86C291.338%20411.933%20291.375%20412.021%20291.375%20412.125ZM295.125%20412.125C295.125%20412.229%20295.088%20412.317%20295.015%20412.39C294.942%20412.463%20294.854%20412.5%20294.75%20412.5C294.646%20412.5%20294.558%20412.463%20294.485%20412.39C294.412%20412.317%20294.375%20412.229%20294.375%20412.125C294.375%20412.021%20294.412%20411.933%20294.485%20411.86C294.558%20411.787%20294.646%20411.75%20294.75%20411.75C294.854%20411.75%20294.942%20411.787%20295.015%20411.86C295.088%20411.933%20295.125%20412.021%20295.125%20412.125ZM298.875%20412.125C298.875%20412.229%20298.838%20412.317%20298.765%20412.39C298.692%20412.463%20298.604%20412.5%20298.5%20412.5C298.396%20412.5%20298.308%20412.463%20298.235%20412.39C298.162%20412.317%20298.125%20412.229%20298.125%20412.125C298.125%20412.021%20298.162%20411.933%20298.235%20411.86C298.308%20411.787%20298.396%20411.75%20298.5%20411.75C298.604%20411.75%20298.692%20411.787%20298.765%20411.86C298.838%20411.933%20298.875%20412.021%20298.875%20412.125ZM302.625%20412.125C302.625%20412.229%20302.588%20412.317%20302.515%20412.39C302.442%20412.463%20302.354%20412.5%20302.25%20412.5C302.146%20412.5%20302.058%20412.463%20301.985%20412.39C301.912%20412.317%20301.875%20412.229%20301.875%20412.125C301.875%20412.021%20301.912%20411.933%20301.985%20411.86C302.058%20411.787%20302.146%20411.75%20302.25%20411.75C302.354%20411.75%20302.442%20411.787%20302.515%20411.86C302.588%20411.933%20302.625%20412.021%20302.625%20412.125ZM306.375%20412.125C306.375%20412.229%20306.338%20412.317%20306.265%20412.39C306.192%20412.463%20306.104%20412.5%20306%20412.5C305.896%20412.5%20305.808%20412.463%20305.735%20412.39C305.662%20412.317%20305.625%20412.229%20305.625%20412.125C305.625%20412.021%20305.662%20411.933%20305.735%20411.86C305.808%20411.787%20305.896%20411.75%20306%20411.75C306.104%20411.75%20306.192%20411.787%20306.265%20411.86C306.338%20411.933%20306.375%20412.021%20306.375%20412.125ZM310.125%20412.125C310.125%20412.229%20310.088%20412.317%20310.015%20412.39C309.942%20412.463%20309.854%20412.5%20309.75%20412.5C309.646%20412.5%20309.558%20412.463%20309.485%20412.39C309.412%20412.317%20309.375%20412.229%20309.375%20412.125C309.375%20412.021%20309.412%20411.933%20309.485%20411.86C309.558%20411.787%20309.646%20411.75%20309.75%20411.75C309.854%20411.75%20309.942%20411.787%20310.015%20411.86C310.088%20411.933%20310.125%20412.021%20310.125%20412.125ZM313.875%20412.125C313.875%20412.229%20313.838%20412.317%20313.765%20412.39C313.692%20412.463%20313.604%20412.5%20313.5%20412.5C313.396%20412.5%20313.308%20412.463%20313.235%20412.39C313.162%20412.317%20313.125%20412.229%20313.125%20412.125C313.125%20412.021%20313.162%20411.933%20313.235%20411.86C313.308%20411.787%20313.396%20411.75%20313.5%20411.75C313.604%20411.75%20313.692%20411.787%20313.765%20411.86C313.838%20411.933%20313.875%20412.021%20313.875%20412.125ZM317.625%20412.125C317.625%20412.229%20317.588%20412.317%20317.515%20412.39C317.442%20412.463%20317.354%20412.5%20317.25%20412.5C317.146%20412.5%20317.058%20412.463%20316.985%20412.39C316.912%20412.317%20316.875%20412.229%20316.875%20412.125C316.875%20412.021%20316.912%20411.933%20316.985%20411.86C317.058%20411.787%20317.146%20411.75%20317.25%20411.75C317.354%20411.75%20317.442%20411.787%20317.515%20411.86C317.588%20411.933%20317.625%20412.021%20317.625%20412.125ZM321.375%20412.125C321.375%20412.229%20321.338%20412.317%20321.265%20412.39C321.192%20412.463%20321.104%20412.5%20321%20412.5C320.896%20412.5%20320.808%20412.463%20320.735%20412.39C320.662%20412.317%20320.625%20412.229%20320.625%20412.125C320.625%20412.021%20320.662%20411.933%20320.735%20411.86C320.808%20411.787%20320.896%20411.75%20321%20411.75C321.104%20411.75%20321.192%20411.787%20321.265%20411.86C321.338%20411.933%20321.375%20412.021%20321.375%20412.125ZM325.125%20412.125C325.125%20412.229%20325.088%20412.317%20325.015%20412.39C324.942%20412.463%20324.854%20412.5%20324.75%20412.5C324.646%20412.5%20324.558%20412.463%20324.485%20412.39C324.412%20412.317%20324.375%20412.229%20324.375%20412.125C324.375%20412.021%20324.412%20411.933%20324.485%20411.86C324.558%20411.787%20324.646%20411.75%20324.75%20411.75C324.854%20411.75%20324.942%20411.787%20325.015%20411.86C325.088%20411.933%20325.125%20412.021%20325.125%20412.125ZM328.875%20412.125C328.875%20412.229%20328.838%20412.317%20328.765%20412.39C328.692%20412.463%20328.604%20412.5%20328.5%20412.5C328.396%20412.5%20328.308%20412.463%20328.235%20412.39C328.162%20412.317%20328.125%20412.229%20328.125%20412.125C328.125%20412.021%20328.162%20411.933%20328.235%20411.86C328.308%20411.787%20328.396%20411.75%20328.5%20411.75C328.604%20411.75%20328.692%20411.787%20328.765%20411.86C328.838%20411.933%20328.875%20412.021%20328.875%20412.125ZM332.625%20412.125C332.625%20412.229%20332.588%20412.317%20332.515%20412.39C332.442%20412.463%20332.354%20412.5%20332.25%20412.5C332.146%20412.5%20332.058%20412.463%20331.985%20412.39C331.912%20412.317%20331.875%20412.229%20331.875%20412.125C331.875%20412.021%20331.912%20411.933%20331.985%20411.86C332.058%20411.787%20332.146%20411.75%20332.25%20411.75C332.354%20411.75%20332.442%20411.787%20332.515%20411.86C332.588%20411.933%20332.625%20412.021%20332.625%20412.125ZM336.375%20412.125C336.375%20412.229%20336.338%20412.317%20336.265%20412.39C336.192%20412.463%20336.104%20412.5%20336%20412.5C335.896%20412.5%20335.808%20412.463%20335.735%20412.39C335.662%20412.317%20335.625%20412.229%20335.625%20412.125C335.625%20412.021%20335.662%20411.933%20335.735%20411.86C335.808%20411.787%20335.896%20411.75%20336%20411.75C336.104%20411.75%20336.192%20411.787%20336.265%20411.86C336.338%20411.933%20336.375%20412.021%20336.375%20412.125ZM340.125%20412.125C340.125%20412.229%20340.088%20412.317%20340.015%20412.39C339.942%20412.463%20339.854%20412.5%20339.75%20412.5C339.646%20412.5%20339.558%20412.463%20339.485%20412.39C339.412%20412.317%20339.375%20412.229%20339.375%20412.125C339.375%20412.021%20339.412%20411.933%20339.485%20411.86C339.558%20411.787%20339.646%20411.75%20339.75%20411.75C339.854%20411.75%20339.942%20411.787%20340.015%20411.86C340.088%20411.933%20340.125%20412.021%20340.125%20412.125ZM343.875%20412.125C343.875%20412.229%20343.838%20412.317%20343.765%20412.39C343.692%20412.463%20343.604%20412.5%20343.5%20412.5C343.396%20412.5%20343.308%20412.463%20343.235%20412.39C343.162%20412.317%20343.125%20412.229%20343.125%20412.125C343.125%20412.021%20343.162%20411.933%20343.235%20411.86C343.308%20411.787%20343.396%20411.75%20343.5%20411.75C343.604%20411.75%20343.692%20411.787%20343.765%20411.86C343.838%20411.933%20343.875%20412.021%20343.875%20412.125ZM347.625%20412.125C347.625%20412.229%20347.588%20412.317%20347.515%20412.39C347.442%20412.463%20347.354%20412.5%20347.25%20412.5C347.146%20412.5%20347.058%20412.463%20346.985%20412.39C346.912%20412.317%20346.875%20412.229%20346.875%20412.125C346.875%20412.021%20346.912%20411.933%20346.985%20411.86C347.058%20411.787%20347.146%20411.75%20347.25%20411.75C347.354%20411.75%20347.442%20411.787%20347.515%20411.86C347.588%20411.933%20347.625%20412.021%20347.625%20412.125ZM351.375%20412.125C351.375%20412.229%20351.338%20412.317%20351.265%20412.39C351.192%20412.463%20351.104%20412.5%20351%20412.5C350.896%20412.5%20350.808%20412.463%20350.735%20412.39C350.662%20412.317%20350.625%20412.229%20350.625%20412.125C350.625%20412.021%20350.662%20411.933%20350.735%20411.86C350.808%20411.787%20350.896%20411.75%20351%20411.75C351.104%20411.75%20351.192%20411.787%20351.265%20411.86C351.338%20411.933%20351.375%20412.021%20351.375%20412.125ZM355.125%20412.125C355.125%20412.229%20355.088%20412.317%20355.015%20412.39C354.942%20412.463%20354.854%20412.5%20354.75%20412.5C354.646%20412.5%20354.558%20412.463%20354.485%20412.39C354.412%20412.317%20354.375%20412.229%20354.375%20412.125C354.375%20412.021%20354.412%20411.933%20354.485%20411.86C354.558%20411.787%20354.646%20411.75%20354.75%20411.75C354.854%20411.75%20354.942%20411.787%20355.015%20411.86C355.088%20411.933%20355.125%20412.021%20355.125%20412.125ZM358.875%20412.125C358.875%20412.229%20358.838%20412.317%20358.765%20412.39C358.692%20412.463%20358.604%20412.5%20358.5%20412.5C358.396%20412.5%20358.308%20412.463%20358.235%20412.39C358.162%20412.317%20358.125%20412.229%20358.125%20412.125C358.125%20412.021%20358.162%20411.933%20358.235%20411.86C358.308%20411.787%20358.396%20411.75%20358.5%20411.75C358.604%20411.75%20358.692%20411.787%20358.765%20411.86C358.838%20411.933%20358.875%20412.021%20358.875%20412.125ZM362.625%20412.125C362.625%20412.229%20362.588%20412.317%20362.515%20412.39C362.442%20412.463%20362.354%20412.5%20362.25%20412.5C362.146%20412.5%20362.058%20412.463%20361.985%20412.39C361.912%20412.317%20361.875%20412.229%20361.875%20412.125C361.875%20412.021%20361.912%20411.933%20361.985%20411.86C362.058%20411.787%20362.146%20411.75%20362.25%20411.75C362.354%20411.75%20362.442%20411.787%20362.515%20411.86C362.588%20411.933%20362.625%20412.021%20362.625%20412.125ZM366.375%20412.125C366.375%20412.229%20366.338%20412.317%20366.265%20412.39C366.192%20412.463%20366.104%20412.5%20366%20412.5C365.896%20412.5%20365.808%20412.463%20365.735%20412.39C365.662%20412.317%20365.625%20412.229%20365.625%20412.125C365.625%20412.021%20365.662%20411.933%20365.735%20411.86C365.808%20411.787%20365.896%20411.75%20366%20411.75C366.104%20411.75%20366.192%20411.787%20366.265%20411.86C366.338%20411.933%20366.375%20412.021%20366.375%20412.125ZM370.125%20412.125C370.125%20412.229%20370.088%20412.317%20370.015%20412.39C369.942%20412.463%20369.854%20412.5%20369.75%20412.5C369.646%20412.5%20369.558%20412.463%20369.485%20412.39C369.412%20412.317%20369.375%20412.229%20369.375%20412.125C369.375%20412.021%20369.412%20411.933%20369.485%20411.86C369.558%20411.787%20369.646%20411.75%20369.75%20411.75C369.854%20411.75%20369.942%20411.787%20370.015%20411.86C370.088%20411.933%20370.125%20412.021%20370.125%20412.125ZM373.875%20412.125C373.875%20412.229%20373.838%20412.317%20373.765%20412.39C373.692%20412.463%20373.604%20412.5%20373.5%20412.5C373.396%20412.5%20373.308%20412.463%20373.235%20412.39C373.162%20412.317%20373.125%20412.229%20373.125%20412.125C373.125%20412.021%20373.162%20411.933%20373.235%20411.86C373.308%20411.787%20373.396%20411.75%20373.5%20411.75C373.604%20411.75%20373.692%20411.787%20373.765%20411.86C373.838%20411.933%20373.875%20412.021%20373.875%20412.125ZM377.625%20412.125C377.625%20412.229%20377.588%20412.317%20377.515%20412.39C377.442%20412.463%20377.354%20412.5%20377.25%20412.5C377.146%20412.5%20377.058%20412.463%20376.985%20412.39C376.912%20412.317%20376.875%20412.229%20376.875%20412.125C376.875%20412.021%20376.912%20411.933%20376.985%20411.86C377.058%20411.787%20377.146%20411.75%20377.25%20411.75C377.354%20411.75%20377.442%20411.787%20377.515%20411.86C377.588%20411.933%20377.625%20412.021%20377.625%20412.125ZM381.375%20412.125C381.375%20412.229%20381.338%20412.317%20381.265%20412.39C381.192%20412.463%20381.104%20412.5%20381%20412.5C380.896%20412.5%20380.808%20412.463%20380.735%20412.39C380.662%20412.317%20380.625%20412.229%20380.625%20412.125C380.625%20412.021%20380.662%20411.933%20380.735%20411.86C380.808%20411.787%20380.896%20411.75%20381%20411.75C381.104%20411.75%20381.192%20411.787%20381.265%20411.86C381.338%20411.933%20381.375%20412.021%20381.375%20412.125ZM385.125%20412.125C385.125%20412.229%20385.088%20412.317%20385.015%20412.39C384.942%20412.463%20384.854%20412.5%20384.75%20412.5C384.646%20412.5%20384.558%20412.463%20384.485%20412.39C384.412%20412.317%20384.375%20412.229%20384.375%20412.125C384.375%20412.021%20384.412%20411.933%20384.485%20411.86C384.558%20411.787%20384.646%20411.75%20384.75%20411.75C384.854%20411.75%20384.942%20411.787%20385.015%20411.86C385.088%20411.933%20385.125%20412.021%20385.125%20412.125ZM388.875%20412.125C388.875%20412.229%20388.838%20412.317%20388.765%20412.39C388.692%20412.463%20388.604%20412.5%20388.5%20412.5C388.396%20412.5%20388.308%20412.463%20388.235%20412.39C388.162%20412.317%20388.125%20412.229%20388.125%20412.125C388.125%20412.021%20388.162%20411.933%20388.235%20411.86C388.308%20411.787%20388.396%20411.75%20388.5%20411.75C388.604%20411.75%20388.692%20411.787%20388.765%20411.86C388.838%20411.933%20388.875%20412.021%20388.875%20412.125ZM392.625%20412.125C392.625%20412.229%20392.588%20412.317%20392.515%20412.39C392.442%20412.463%20392.354%20412.5%20392.25%20412.5C392.146%20412.5%20392.058%20412.463%20391.985%20412.39C391.912%20412.317%20391.875%20412.229%20391.875%20412.125C391.875%20412.021%20391.912%20411.933%20391.985%20411.86C392.058%20411.787%20392.146%20411.75%20392.25%20411.75C392.354%20411.75%20392.442%20411.787%20392.515%20411.86C392.588%20411.933%20392.625%20412.021%20392.625%20412.125ZM396.375%20412.125C396.375%20412.229%20396.338%20412.317%20396.265%20412.39C396.192%20412.463%20396.104%20412.5%20396%20412.5C395.896%20412.5%20395.808%20412.463%20395.735%20412.39C395.662%20412.317%20395.625%20412.229%20395.625%20412.125C395.625%20412.021%20395.662%20411.933%20395.735%20411.86C395.808%20411.787%20395.896%20411.75%20396%20411.75C396.104%20411.75%20396.192%20411.787%20396.265%20411.86C396.338%20411.933%20396.375%20412.021%20396.375%20412.125ZM400.125%20412.125C400.125%20412.229%20400.088%20412.317%20400.015%20412.39C399.942%20412.463%20399.854%20412.5%20399.75%20412.5C399.646%20412.5%20399.558%20412.463%20399.485%20412.39C399.412%20412.317%20399.375%20412.229%20399.375%20412.125C399.375%20412.021%20399.412%20411.933%20399.485%20411.86C399.558%20411.787%20399.646%20411.75%20399.75%20411.75C399.854%20411.75%20399.942%20411.787%20400.015%20411.86C400.088%20411.933%20400.125%20412.021%20400.125%20412.125ZM403.875%20412.125C403.875%20412.229%20403.838%20412.317%20403.765%20412.39C403.692%20412.463%20403.604%20412.5%20403.5%20412.5C403.396%20412.5%20403.308%20412.463%20403.235%20412.39C403.162%20412.317%20403.125%20412.229%20403.125%20412.125C403.125%20412.021%20403.162%20411.933%20403.235%20411.86C403.308%20411.787%20403.396%20411.75%20403.5%20411.75C403.604%20411.75%20403.692%20411.787%20403.765%20411.86C403.838%20411.933%20403.875%20412.021%20403.875%20412.125ZM407.625%20412.125C407.625%20412.229%20407.588%20412.317%20407.515%20412.39C407.442%20412.463%20407.354%20412.5%20407.25%20412.5C407.146%20412.5%20407.058%20412.463%20406.985%20412.39C406.912%20412.317%20406.875%20412.229%20406.875%20412.125C406.875%20412.021%20406.912%20411.933%20406.985%20411.86C407.058%20411.787%20407.146%20411.75%20407.25%20411.75C407.354%20411.75%20407.442%20411.787%20407.515%20411.86C407.588%20411.933%20407.625%20412.021%20407.625%20412.125ZM411.375%20412.125C411.375%20412.229%20411.338%20412.317%20411.265%20412.39C411.192%20412.463%20411.104%20412.5%20411%20412.5C410.896%20412.5%20410.808%20412.463%20410.735%20412.39C410.662%20412.317%20410.625%20412.229%20410.625%20412.125C410.625%20412.021%20410.662%20411.933%20410.735%20411.86C410.808%20411.787%20410.896%20411.75%20411%20411.75C411.104%20411.75%20411.192%20411.787%20411.265%20411.86C411.338%20411.933%20411.375%20412.021%20411.375%20412.125ZM415.125%20412.125C415.125%20412.229%20415.088%20412.317%20415.015%20412.39C414.942%20412.463%20414.854%20412.5%20414.75%20412.5C414.646%20412.5%20414.558%20412.463%20414.485%20412.39C414.412%20412.317%20414.375%20412.229%20414.375%20412.125C414.375%20412.021%20414.412%20411.933%20414.485%20411.86C414.558%20411.787%20414.646%20411.75%20414.75%20411.75C414.854%20411.75%20414.942%20411.787%20415.015%20411.86C415.088%20411.933%20415.125%20412.021%20415.125%20412.125ZM418.875%20412.125C418.875%20412.229%20418.838%20412.317%20418.765%20412.39C418.692%20412.463%20418.604%20412.5%20418.5%20412.5C418.396%20412.5%20418.308%20412.463%20418.235%20412.39C418.162%20412.317%20418.125%20412.229%20418.125%20412.125C418.125%20412.021%20418.162%20411.933%20418.235%20411.86C418.308%20411.787%20418.396%20411.75%20418.5%20411.75C418.604%20411.75%20418.692%20411.787%20418.765%20411.86C418.838%20411.933%20418.875%20412.021%20418.875%20412.125ZM422.625%20412.125C422.625%20412.229%20422.588%20412.317%20422.515%20412.39C422.442%20412.463%20422.354%20412.5%20422.25%20412.5C422.146%20412.5%20422.058%20412.463%20421.985%20412.39C421.912%20412.317%20421.875%20412.229%20421.875%20412.125C421.875%20412.021%20421.912%20411.933%20421.985%20411.86C422.058%20411.787%20422.146%20411.75%20422.25%20411.75C422.354%20411.75%20422.442%20411.787%20422.515%20411.86C422.588%20411.933%20422.625%20412.021%20422.625%20412.125ZM426.375%20412.125C426.375%20412.229%20426.338%20412.317%20426.265%20412.39C426.192%20412.463%20426.104%20412.5%20426%20412.5C425.896%20412.5%20425.808%20412.463%20425.735%20412.39C425.662%20412.317%20425.625%20412.229%20425.625%20412.125C425.625%20412.021%20425.662%20411.933%20425.735%20411.86C425.808%20411.787%20425.896%20411.75%20426%20411.75C426.104%20411.75%20426.192%20411.787%20426.265%20411.86C426.338%20411.933%20426.375%20412.021%20426.375%20412.125ZM430.125%20412.125C430.125%20412.229%20430.088%20412.317%20430.015%20412.39C429.942%20412.463%20429.854%20412.5%20429.75%20412.5C429.646%20412.5%20429.558%20412.463%20429.485%20412.39C429.412%20412.317%20429.375%20412.229%20429.375%20412.125C429.375%20412.021%20429.412%20411.933%20429.485%20411.86C429.558%20411.787%20429.646%20411.75%20429.75%20411.75C429.854%20411.75%20429.942%20411.787%20430.015%20411.86C430.088%20411.933%20430.125%20412.021%20430.125%20412.125ZM433.875%20412.125C433.875%20412.229%20433.838%20412.317%20433.765%20412.39C433.692%20412.463%20433.604%20412.5%20433.5%20412.5C433.396%20412.5%20433.308%20412.463%20433.235%20412.39C433.162%20412.317%20433.125%20412.229%20433.125%20412.125C433.125%20412.021%20433.162%20411.933%20433.235%20411.86C433.308%20411.787%20433.396%20411.75%20433.5%20411.75C433.604%20411.75%20433.692%20411.787%20433.765%20411.86C433.838%20411.933%20433.875%20412.021%20433.875%20412.125ZM437.625%20412.125C437.625%20412.229%20437.588%20412.317%20437.515%20412.39C437.442%20412.463%20437.354%20412.5%20437.25%20412.5C437.146%20412.5%20437.058%20412.463%20436.985%20412.39C436.912%20412.317%20436.875%20412.229%20436.875%20412.125C436.875%20412.021%20436.912%20411.933%20436.985%20411.86C437.058%20411.787%20437.146%20411.75%20437.25%20411.75C437.354%20411.75%20437.442%20411.787%20437.515%20411.86C437.588%20411.933%20437.625%20412.021%20437.625%20412.125ZM441.375%20412.125C441.375%20412.229%20441.338%20412.317%20441.265%20412.39C441.192%20412.463%20441.104%20412.5%20441%20412.5C440.896%20412.5%20440.808%20412.463%20440.735%20412.39C440.662%20412.317%20440.625%20412.229%20440.625%20412.125C440.625%20412.021%20440.662%20411.933%20440.735%20411.86C440.808%20411.787%20440.896%20411.75%20441%20411.75C441.104%20411.75%20441.192%20411.787%20441.265%20411.86C441.338%20411.933%20441.375%20412.021%20441.375%20412.125ZM445.125%20412.125C445.125%20412.229%20445.088%20412.317%20445.015%20412.39C444.942%20412.463%20444.853%20412.5%20444.75%20412.5C444.646%20412.5%20444.558%20412.463%20444.485%20412.39C444.412%20412.317%20444.375%20412.229%20444.375%20412.125C444.375%20412.021%20444.412%20411.933%20444.485%20411.86C444.558%20411.787%20444.646%20411.75%20444.75%20411.75C444.853%20411.75%20444.942%20411.787%20445.015%20411.86C445.088%20411.933%20445.125%20412.021%20445.125%20412.125ZM448.875%20412.125C448.875%20412.229%20448.838%20412.317%20448.765%20412.39C448.692%20412.463%20448.604%20412.5%20448.5%20412.5C448.396%20412.5%20448.308%20412.463%20448.235%20412.39C448.162%20412.317%20448.125%20412.229%20448.125%20412.125C448.125%20412.021%20448.162%20411.933%20448.235%20411.86C448.308%20411.787%20448.396%20411.75%20448.5%20411.75C448.604%20411.75%20448.692%20411.787%20448.765%20411.86C448.838%20411.933%20448.875%20412.021%20448.875%20412.125ZM452.625%20412.125C452.625%20412.229%20452.588%20412.317%20452.515%20412.39C452.442%20412.463%20452.354%20412.5%20452.25%20412.5C452.146%20412.5%20452.058%20412.463%20451.985%20412.39C451.912%20412.317%20451.875%20412.229%20451.875%20412.125C451.875%20412.021%20451.912%20411.933%20451.985%20411.86C452.058%20411.787%20452.146%20411.75%20452.25%20411.75C452.354%20411.75%20452.442%20411.787%20452.515%20411.86C452.588%20411.933%20452.625%20412.021%20452.625%20412.125ZM456.375%20412.125C456.375%20412.229%20456.338%20412.317%20456.265%20412.39C456.192%20412.463%20456.104%20412.5%20456%20412.5C455.896%20412.5%20455.808%20412.463%20455.735%20412.39C455.662%20412.317%20455.625%20412.229%20455.625%20412.125C455.625%20412.021%20455.662%20411.933%20455.735%20411.86C455.808%20411.787%20455.896%20411.75%20456%20411.75C456.104%20411.75%20456.192%20411.787%20456.265%20411.86C456.338%20411.933%20456.375%20412.021%20456.375%20412.125ZM460.125%20412.125C460.125%20412.229%20460.088%20412.317%20460.015%20412.39C459.942%20412.463%20459.854%20412.5%20459.75%20412.5C459.646%20412.5%20459.558%20412.463%20459.485%20412.39C459.412%20412.317%20459.375%20412.229%20459.375%20412.125C459.375%20412.021%20459.412%20411.933%20459.485%20411.86C459.558%20411.787%20459.646%20411.75%20459.75%20411.75C459.854%20411.75%20459.942%20411.787%20460.015%20411.86C460.088%20411.933%20460.125%20412.021%20460.125%20412.125ZM463.875%20412.125C463.875%20412.229%20463.838%20412.317%20463.765%20412.39C463.692%20412.463%20463.604%20412.5%20463.5%20412.5C463.396%20412.5%20463.308%20412.463%20463.235%20412.39C463.162%20412.317%20463.125%20412.229%20463.125%20412.125C463.125%20412.021%20463.162%20411.933%20463.235%20411.86C463.308%20411.787%20463.396%20411.75%20463.5%20411.75C463.604%20411.75%20463.692%20411.787%20463.765%20411.86C463.838%20411.933%20463.875%20412.021%20463.875%20412.125ZM467.625%20412.125C467.625%20412.229%20467.588%20412.317%20467.515%20412.39C467.442%20412.463%20467.353%20412.5%20467.25%20412.5C467.146%20412.5%20467.058%20412.463%20466.985%20412.39C466.912%20412.317%20466.875%20412.229%20466.875%20412.125C466.875%20412.021%20466.912%20411.933%20466.985%20411.86C467.058%20411.787%20467.146%20411.75%20467.25%20411.75C467.353%20411.75%20467.442%20411.787%20467.515%20411.86C467.588%20411.933%20467.625%20412.021%20467.625%20412.125ZM471.375%20412.125C471.375%20412.229%20471.338%20412.317%20471.265%20412.39C471.192%20412.463%20471.103%20412.5%20471%20412.5C470.896%20412.5%20470.808%20412.463%20470.735%20412.39C470.662%20412.317%20470.625%20412.229%20470.625%20412.125C470.625%20412.021%20470.662%20411.933%20470.735%20411.86C470.808%20411.787%20470.896%20411.75%20471%20411.75C471.103%20411.75%20471.192%20411.787%20471.265%20411.86C471.338%20411.933%20471.375%20412.021%20471.375%20412.125ZM475.125%20412.125C475.125%20412.229%20475.088%20412.317%20475.015%20412.39C474.942%20412.463%20474.854%20412.5%20474.75%20412.5C474.646%20412.5%20474.558%20412.463%20474.485%20412.39C474.412%20412.317%20474.375%20412.229%20474.375%20412.125C474.375%20412.021%20474.412%20411.933%20474.485%20411.86C474.558%20411.787%20474.646%20411.75%20474.75%20411.75C474.854%20411.75%20474.942%20411.787%20475.015%20411.86C475.088%20411.933%20475.125%20412.021%20475.125%20412.125ZM478.875%20412.125C478.875%20412.229%20478.838%20412.317%20478.765%20412.39C478.692%20412.463%20478.604%20412.5%20478.5%20412.5C478.396%20412.5%20478.308%20412.463%20478.235%20412.39C478.162%20412.317%20478.125%20412.229%20478.125%20412.125C478.125%20412.021%20478.162%20411.933%20478.235%20411.86C478.308%20411.787%20478.396%20411.75%20478.5%20411.75C478.604%20411.75%20478.692%20411.787%20478.765%20411.86C478.838%20411.933%20478.875%20412.021%20478.875%20412.125ZM482.625%20412.125C482.625%20412.229%20482.588%20412.317%20482.515%20412.39C482.442%20412.463%20482.354%20412.5%20482.25%20412.5C482.146%20412.5%20482.058%20412.463%20481.985%20412.39C481.912%20412.317%20481.875%20412.229%20481.875%20412.125C481.875%20412.021%20481.912%20411.933%20481.985%20411.86C482.058%20411.787%20482.146%20411.75%20482.25%20411.75C482.354%20411.75%20482.442%20411.787%20482.515%20411.86C482.588%20411.933%20482.625%20412.021%20482.625%20412.125ZM486.375%20412.125C486.375%20412.229%20486.338%20412.317%20486.265%20412.39C486.192%20412.463%20486.104%20412.5%20486%20412.5C485.896%20412.5%20485.808%20412.463%20485.735%20412.39C485.662%20412.317%20485.625%20412.229%20485.625%20412.125C485.625%20412.021%20485.662%20411.933%20485.735%20411.86C485.808%20411.787%20485.896%20411.75%20486%20411.75C486.104%20411.75%20486.192%20411.787%20486.265%20411.86C486.338%20411.933%20486.375%20412.021%20486.375%20412.125ZM490.125%20412.125C490.125%20412.229%20490.088%20412.317%20490.015%20412.39C489.942%20412.463%20489.854%20412.5%20489.75%20412.5C489.646%20412.5%20489.558%20412.463%20489.485%20412.39C489.412%20412.317%20489.375%20412.229%20489.375%20412.125C489.375%20412.021%20489.412%20411.933%20489.485%20411.86C489.558%20411.787%20489.646%20411.75%20489.75%20411.75C489.854%20411.75%20489.942%20411.787%20490.015%20411.86C490.088%20411.933%20490.125%20412.021%20490.125%20412.125ZM493.875%20412.125C493.875%20412.229%20493.838%20412.317%20493.765%20412.39C493.692%20412.463%20493.604%20412.5%20493.5%20412.5C493.396%20412.5%20493.308%20412.463%20493.235%20412.39C493.162%20412.317%20493.125%20412.229%20493.125%20412.125C493.125%20412.021%20493.162%20411.933%20493.235%20411.86C493.308%20411.787%20493.396%20411.75%20493.5%20411.75C493.604%20411.75%20493.692%20411.787%20493.765%20411.86C493.838%20411.933%20493.875%20412.021%20493.875%20412.125ZM497.625%20412.125C497.625%20412.229%20497.588%20412.317%20497.515%20412.39C497.442%20412.463%20497.354%20412.5%20497.25%20412.5C497.146%20412.5%20497.058%20412.463%20496.985%20412.39C496.912%20412.317%20496.875%20412.229%20496.875%20412.125C496.875%20412.021%20496.912%20411.933%20496.985%20411.86C497.058%20411.787%20497.146%20411.75%20497.25%20411.75C497.354%20411.75%20497.442%20411.787%20497.515%20411.86C497.588%20411.933%20497.625%20412.021%20497.625%20412.125ZM501.375%20412.125C501.375%20412.229%20501.338%20412.317%20501.265%20412.39C501.192%20412.463%20501.104%20412.5%20501%20412.5C500.896%20412.5%20500.808%20412.463%20500.735%20412.39C500.662%20412.317%20500.625%20412.229%20500.625%20412.125C500.625%20412.021%20500.662%20411.933%20500.735%20411.86C500.808%20411.787%20500.896%20411.75%20501%20411.75C501.104%20411.75%20501.192%20411.787%20501.265%20411.86C501.338%20411.933%20501.375%20412.021%20501.375%20412.125ZM505.125%20412.125C505.125%20412.229%20505.088%20412.317%20505.015%20412.39C504.942%20412.463%20504.853%20412.5%20504.75%20412.5C504.646%20412.5%20504.558%20412.463%20504.485%20412.39C504.412%20412.317%20504.375%20412.229%20504.375%20412.125C504.375%20412.021%20504.412%20411.933%20504.485%20411.86C504.558%20411.787%20504.646%20411.75%20504.75%20411.75C504.853%20411.75%20504.942%20411.787%20505.015%20411.86C505.088%20411.933%20505.125%20412.021%20505.125%20412.125ZM508.875%20412.125C508.875%20412.229%20508.838%20412.317%20508.765%20412.39C508.692%20412.463%20508.603%20412.5%20508.5%20412.5C508.396%20412.5%20508.308%20412.463%20508.235%20412.39C508.162%20412.317%20508.125%20412.229%20508.125%20412.125C508.125%20412.021%20508.162%20411.933%20508.235%20411.86C508.308%20411.787%20508.396%20411.75%20508.5%20411.75C508.603%20411.75%20508.692%20411.787%20508.765%20411.86C508.838%20411.933%20508.875%20412.021%20508.875%20412.125ZM512.625%20412.125C512.625%20412.229%20512.588%20412.317%20512.515%20412.39C512.442%20412.463%20512.353%20412.5%20512.25%20412.5C512.146%20412.5%20512.058%20412.463%20511.985%20412.39C511.912%20412.317%20511.875%20412.229%20511.875%20412.125C511.875%20412.021%20511.912%20411.933%20511.985%20411.86C512.058%20411.787%20512.146%20411.75%20512.25%20411.75C512.353%20411.75%20512.442%20411.787%20512.515%20411.86C512.588%20411.933%20512.625%20412.021%20512.625%20412.125ZM516.375%20412.125C516.375%20412.229%20516.338%20412.317%20516.265%20412.39C516.192%20412.463%20516.104%20412.5%20516%20412.5C515.896%20412.5%20515.808%20412.463%20515.735%20412.39C515.662%20412.317%20515.625%20412.229%20515.625%20412.125C515.625%20412.021%20515.662%20411.933%20515.735%20411.86C515.808%20411.787%20515.896%20411.75%20516%20411.75C516.104%20411.75%20516.192%20411.787%20516.265%20411.86C516.338%20411.933%20516.375%20412.021%20516.375%20412.125ZM520.125%20412.125C520.125%20412.229%20520.088%20412.317%20520.015%20412.39C519.942%20412.463%20519.854%20412.5%20519.75%20412.5C519.646%20412.5%20519.558%20412.463%20519.485%20412.39C519.412%20412.317%20519.375%20412.229%20519.375%20412.125C519.375%20412.021%20519.412%20411.933%20519.485%20411.86C519.558%20411.787%20519.646%20411.75%20519.75%20411.75C519.854%20411.75%20519.942%20411.787%20520.015%20411.86C520.088%20411.933%20520.125%20412.021%20520.125%20412.125ZM523.875%20412.125C523.875%20412.229%20523.838%20412.317%20523.765%20412.39C523.692%20412.463%20523.603%20412.5%20523.5%20412.5C523.396%20412.5%20523.308%20412.463%20523.235%20412.39C523.162%20412.317%20523.125%20412.229%20523.125%20412.125C523.125%20412.021%20523.162%20411.933%20523.235%20411.86C523.308%20411.787%20523.396%20411.75%20523.5%20411.75C523.603%20411.75%20523.692%20411.787%20523.765%20411.86C523.838%20411.933%20523.875%20412.021%20523.875%20412.125ZM527.625%20412.125C527.625%20412.229%20527.588%20412.317%20527.515%20412.39C527.442%20412.463%20527.354%20412.5%20527.25%20412.5C527.146%20412.5%20527.058%20412.463%20526.985%20412.39C526.912%20412.317%20526.875%20412.229%20526.875%20412.125C526.875%20412.021%20526.912%20411.933%20526.985%20411.86C527.058%20411.787%20527.146%20411.75%20527.25%20411.75C527.354%20411.75%20527.442%20411.787%20527.515%20411.86C527.588%20411.933%20527.625%20412.021%20527.625%20412.125ZM531.375%20412.125C531.375%20412.229%20531.338%20412.317%20531.265%20412.39C531.192%20412.463%20531.104%20412.5%20531%20412.5C530.896%20412.5%20530.808%20412.463%20530.735%20412.39C530.662%20412.317%20530.625%20412.229%20530.625%20412.125C530.625%20412.021%20530.662%20411.933%20530.735%20411.86C530.808%20411.787%20530.896%20411.75%20531%20411.75C531.104%20411.75%20531.192%20411.787%20531.265%20411.86C531.338%20411.933%20531.375%20412.021%20531.375%20412.125ZM535.125%20412.125C535.125%20412.229%20535.088%20412.317%20535.015%20412.39C534.942%20412.463%20534.854%20412.5%20534.75%20412.5C534.646%20412.5%20534.558%20412.463%20534.485%20412.39C534.412%20412.317%20534.375%20412.229%20534.375%20412.125C534.375%20412.021%20534.412%20411.933%20534.485%20411.86C534.558%20411.787%20534.646%20411.75%20534.75%20411.75C534.854%20411.75%20534.942%20411.787%20535.015%20411.86C535.088%20411.933%20535.125%20412.021%20535.125%20412.125ZM538.875%20412.125C538.875%20412.229%20538.838%20412.317%20538.765%20412.39C538.692%20412.463%20538.604%20412.5%20538.5%20412.5C538.396%20412.5%20538.308%20412.463%20538.235%20412.39C538.162%20412.317%20538.125%20412.229%20538.125%20412.125C538.125%20412.021%20538.162%20411.933%20538.235%20411.86C538.308%20411.787%20538.396%20411.75%20538.5%20411.75C538.604%20411.75%20538.692%20411.787%20538.765%20411.86C538.838%20411.933%20538.875%20412.021%20538.875%20412.125ZM542.625%20412.125C542.625%20412.229%20542.588%20412.317%20542.515%20412.39C542.442%20412.463%20542.353%20412.5%20542.25%20412.5C542.146%20412.5%20542.058%20412.463%20541.985%20412.39C541.912%20412.317%20541.875%20412.229%20541.875%20412.125C541.875%20412.021%20541.912%20411.933%20541.985%20411.86C542.058%20411.787%20542.146%20411.75%20542.25%20411.75C542.353%20411.75%20542.442%20411.787%20542.515%20411.86C542.588%20411.933%20542.625%20412.021%20542.625%20412.125ZM546.375%20412.125C546.375%20412.229%20546.338%20412.317%20546.265%20412.39C546.192%20412.463%20546.103%20412.5%20546%20412.5C545.896%20412.5%20545.808%20412.463%20545.735%20412.39C545.662%20412.317%20545.625%20412.229%20545.625%20412.125C545.625%20412.021%20545.662%20411.933%20545.735%20411.86C545.808%20411.787%20545.896%20411.75%20546%20411.75C546.103%20411.75%20546.192%20411.787%20546.265%20411.86C546.338%20411.933%20546.375%20412.021%20546.375%20412.125ZM550.125%20412.125C550.125%20412.229%20550.088%20412.317%20550.015%20412.39C549.942%20412.463%20549.853%20412.5%20549.75%20412.5C549.646%20412.5%20549.558%20412.463%20549.485%20412.39C549.412%20412.317%20549.375%20412.229%20549.375%20412.125C549.375%20412.021%20549.412%20411.933%20549.485%20411.86C549.558%20411.787%20549.646%20411.75%20549.75%20411.75C549.853%20411.75%20549.942%20411.787%20550.015%20411.86C550.088%20411.933%20550.125%20412.021%20550.125%20412.125ZM553.875%20412.125C553.875%20412.229%20553.838%20412.317%20553.765%20412.39C553.692%20412.463%20553.603%20412.5%20553.5%20412.5C553.396%20412.5%20553.308%20412.463%20553.235%20412.39C553.162%20412.317%20553.125%20412.229%20553.125%20412.125C553.125%20412.021%20553.162%20411.933%20553.235%20411.86C553.308%20411.787%20553.396%20411.75%20553.5%20411.75C553.603%20411.75%20553.692%20411.787%20553.765%20411.86C553.838%20411.933%20553.875%20412.021%20553.875%20412.125ZM557.625%20412.125C557.625%20412.229%20557.588%20412.317%20557.515%20412.39C557.442%20412.463%20557.353%20412.5%20557.25%20412.5C557.146%20412.5%20557.058%20412.463%20556.985%20412.39C556.912%20412.317%20556.875%20412.229%20556.875%20412.125C556.875%20412.021%20556.912%20411.933%20556.985%20411.86C557.058%20411.787%20557.146%20411.75%20557.25%20411.75C557.353%20411.75%20557.442%20411.787%20557.515%20411.86C557.588%20411.933%20557.625%20412.021%20557.625%20412.125ZM561.375%20412.125C561.375%20412.229%20561.338%20412.317%20561.265%20412.39C561.192%20412.463%20561.104%20412.5%20561%20412.5C560.896%20412.5%20560.808%20412.463%20560.735%20412.39C560.662%20412.317%20560.625%20412.229%20560.625%20412.125C560.625%20412.021%20560.662%20411.933%20560.735%20411.86C560.808%20411.787%20560.896%20411.75%20561%20411.75C561.104%20411.75%20561.192%20411.787%20561.265%20411.86C561.338%20411.933%20561.375%20412.021%20561.375%20412.125ZM565.125%20412.125C565.125%20412.229%20565.088%20412.317%20565.015%20412.39C564.942%20412.463%20564.853%20412.5%20564.75%20412.5C564.646%20412.5%20564.558%20412.463%20564.485%20412.39C564.412%20412.317%20564.375%20412.229%20564.375%20412.125C564.375%20412.021%20564.412%20411.933%20564.485%20411.86C564.558%20411.787%20564.646%20411.75%20564.75%20411.75C564.853%20411.75%20564.942%20411.787%20565.015%20411.86C565.088%20411.933%20565.125%20412.021%20565.125%20412.125ZM568.875%20412.125C568.875%20412.229%20568.838%20412.317%20568.765%20412.39C568.692%20412.463%20568.604%20412.5%20568.5%20412.5C568.396%20412.5%20568.308%20412.463%20568.235%20412.39C568.162%20412.317%20568.125%20412.229%20568.125%20412.125C568.125%20412.021%20568.162%20411.933%20568.235%20411.86C568.308%20411.787%20568.396%20411.75%20568.5%20411.75C568.604%20411.75%20568.692%20411.787%20568.765%20411.86C568.838%20411.933%20568.875%20412.021%20568.875%20412.125ZM572.625%20412.125C572.625%20412.229%20572.588%20412.317%20572.515%20412.39C572.442%20412.463%20572.354%20412.5%20572.25%20412.5C572.146%20412.5%20572.058%20412.463%20571.985%20412.39C571.912%20412.317%20571.875%20412.229%20571.875%20412.125C571.875%20412.021%20571.912%20411.933%20571.985%20411.86C572.058%20411.787%20572.146%20411.75%20572.25%20411.75C572.354%20411.75%20572.442%20411.787%20572.515%20411.86C572.588%20411.933%20572.625%20412.021%20572.625%20412.125ZM576.375%20412.125C576.375%20412.229%20576.338%20412.317%20576.265%20412.39C576.192%20412.463%20576.104%20412.5%20576%20412.5C575.896%20412.5%20575.808%20412.463%20575.735%20412.39C575.662%20412.317%20575.625%20412.229%20575.625%20412.125C575.625%20412.021%20575.662%20411.933%20575.735%20411.86C575.808%20411.787%20575.896%20411.75%20576%20411.75C576.104%20411.75%20576.192%20411.787%20576.265%20411.86C576.338%20411.933%20576.375%20412.021%20576.375%20412.125ZM580.125%20412.125C580.125%20412.229%20580.088%20412.317%20580.015%20412.39C579.942%20412.463%20579.853%20412.5%20579.75%20412.5C579.646%20412.5%20579.558%20412.463%20579.485%20412.39C579.412%20412.317%20579.375%20412.229%20579.375%20412.125C579.375%20412.021%20579.412%20411.933%20579.485%20411.86C579.558%20411.787%20579.646%20411.75%20579.75%20411.75C579.853%20411.75%20579.942%20411.787%20580.015%20411.86C580.088%20411.933%20580.125%20412.021%20580.125%20412.125ZM583.875%20412.125C583.875%20412.229%20583.838%20412.317%20583.765%20412.39C583.692%20412.463%20583.604%20412.5%20583.5%20412.5C583.396%20412.5%20583.308%20412.463%20583.235%20412.39C583.162%20412.317%20583.125%20412.229%20583.125%20412.125C583.125%20412.021%20583.162%20411.933%20583.235%20411.86C583.308%20411.787%20583.396%20411.75%20583.5%20411.75C583.604%20411.75%20583.692%20411.787%20583.765%20411.86C583.838%20411.933%20583.875%20412.021%20583.875%20412.125ZM587.625%20412.125C587.625%20412.229%20587.588%20412.317%20587.515%20412.39C587.442%20412.463%20587.354%20412.5%20587.25%20412.5C587.146%20412.5%20587.058%20412.463%20586.985%20412.39C586.912%20412.317%20586.875%20412.229%20586.875%20412.125C586.875%20412.021%20586.912%20411.933%20586.985%20411.86C587.058%20411.787%20587.146%20411.75%20587.25%20411.75C587.354%20411.75%20587.442%20411.787%20587.515%20411.86C587.588%20411.933%20587.625%20412.021%20587.625%20412.125ZM591.375%20412.125C591.375%20412.229%20591.338%20412.317%20591.265%20412.39C591.192%20412.463%20591.104%20412.5%20591%20412.5C590.896%20412.5%20590.808%20412.463%20590.735%20412.39C590.662%20412.317%20590.625%20412.229%20590.625%20412.125C590.625%20412.021%20590.662%20411.933%20590.735%20411.86C590.808%20411.787%20590.896%20411.75%20591%20411.75C591.104%20411.75%20591.192%20411.787%20591.265%20411.86C591.338%20411.933%20591.375%20412.021%20591.375%20412.125ZM595.125%20412.125C595.125%20412.229%20595.088%20412.317%20595.015%20412.39C594.942%20412.463%20594.854%20412.5%20594.75%20412.5C594.646%20412.5%20594.558%20412.463%20594.485%20412.39C594.412%20412.317%20594.375%20412.229%20594.375%20412.125C594.375%20412.021%20594.412%20411.933%20594.485%20411.86C594.558%20411.787%20594.646%20411.75%20594.75%20411.75C594.854%20411.75%20594.942%20411.787%20595.015%20411.86C595.088%20411.933%20595.125%20412.021%20595.125%20412.125ZM598.875%20412.125C598.875%20412.229%20598.838%20412.317%20598.765%20412.39C598.692%20412.463%20598.604%20412.5%20598.5%20412.5C598.396%20412.5%20598.308%20412.463%20598.235%20412.39C598.162%20412.317%20598.125%20412.229%20598.125%20412.125C598.125%20412.021%20598.162%20411.933%20598.235%20411.86C598.308%20411.787%20598.396%20411.75%20598.5%20411.75C598.604%20411.75%20598.692%20411.787%20598.765%20411.86C598.838%20411.933%20598.875%20412.021%20598.875%20412.125ZM602.625%20412.125C602.625%20412.229%20602.588%20412.317%20602.515%20412.39C602.442%20412.463%20602.354%20412.5%20602.25%20412.5C602.146%20412.5%20602.058%20412.463%20601.985%20412.39C601.912%20412.317%20601.875%20412.229%20601.875%20412.125C601.875%20412.021%20601.912%20411.933%20601.985%20411.86C602.058%20411.787%20602.146%20411.75%20602.25%20411.75C602.354%20411.75%20602.442%20411.787%20602.515%20411.86C602.588%20411.933%20602.625%20412.021%20602.625%20412.125ZM606.375%20412.125C606.375%20412.229%20606.338%20412.317%20606.265%20412.39C606.192%20412.463%20606.104%20412.5%20606%20412.5C605.896%20412.5%20605.808%20412.463%20605.735%20412.39C605.662%20412.317%20605.625%20412.229%20605.625%20412.125C605.625%20412.021%20605.662%20411.933%20605.735%20411.86C605.808%20411.787%20605.896%20411.75%20606%20411.75C606.104%20411.75%20606.192%20411.787%20606.265%20411.86C606.338%20411.933%20606.375%20412.021%20606.375%20412.125ZM610.125%20412.125C610.125%20412.229%20610.088%20412.317%20610.015%20412.39C609.942%20412.463%20609.854%20412.5%20609.75%20412.5C609.646%20412.5%20609.558%20412.463%20609.485%20412.39C609.412%20412.317%20609.375%20412.229%20609.375%20412.125C609.375%20412.021%20609.412%20411.933%20609.485%20411.86C609.558%20411.787%20609.646%20411.75%20609.75%20411.75C609.854%20411.75%20609.942%20411.787%20610.015%20411.86C610.088%20411.933%20610.125%20412.021%20610.125%20412.125ZM613.875%20412.125C613.875%20412.229%20613.838%20412.317%20613.765%20412.39C613.692%20412.463%20613.604%20412.5%20613.5%20412.5C613.396%20412.5%20613.308%20412.463%20613.235%20412.39C613.162%20412.317%20613.125%20412.229%20613.125%20412.125C613.125%20412.021%20613.162%20411.933%20613.235%20411.86C613.308%20411.787%20613.396%20411.75%20613.5%20411.75C613.604%20411.75%20613.692%20411.787%20613.765%20411.86C613.838%20411.933%20613.875%20412.021%20613.875%20412.125ZM617.625%20412.125C617.625%20412.229%20617.588%20412.317%20617.515%20412.39C617.442%20412.463%20617.354%20412.5%20617.25%20412.5C617.146%20412.5%20617.058%20412.463%20616.985%20412.39C616.912%20412.317%20616.875%20412.229%20616.875%20412.125C616.875%20412.021%20616.912%20411.933%20616.985%20411.86C617.058%20411.787%20617.146%20411.75%20617.25%20411.75C617.354%20411.75%20617.442%20411.787%20617.515%20411.86C617.588%20411.933%20617.625%20412.021%20617.625%20412.125ZM621.375%20412.125C621.375%20412.229%20621.338%20412.317%20621.265%20412.39C621.192%20412.463%20621.104%20412.5%20621%20412.5C620.896%20412.5%20620.808%20412.463%20620.735%20412.39C620.662%20412.317%20620.625%20412.229%20620.625%20412.125C620.625%20412.021%20620.662%20411.933%20620.735%20411.86C620.808%20411.787%20620.896%20411.75%20621%20411.75C621.104%20411.75%20621.192%20411.787%20621.265%20411.86C621.338%20411.933%20621.375%20412.021%20621.375%20412.125ZM625.125%20412.125C625.125%20412.229%20625.088%20412.317%20625.015%20412.39C624.942%20412.463%20624.854%20412.5%20624.75%20412.5C624.646%20412.5%20624.558%20412.463%20624.485%20412.39C624.412%20412.317%20624.375%20412.229%20624.375%20412.125C624.375%20412.021%20624.412%20411.933%20624.485%20411.86C624.558%20411.787%20624.646%20411.75%20624.75%20411.75C624.854%20411.75%20624.942%20411.787%20625.015%20411.86C625.088%20411.933%20625.125%20412.021%20625.125%20412.125ZM628.875%20412.125C628.875%20412.229%20628.838%20412.317%20628.765%20412.39C628.692%20412.463%20628.604%20412.5%20628.5%20412.5C628.396%20412.5%20628.308%20412.463%20628.235%20412.39C628.162%20412.317%20628.125%20412.229%20628.125%20412.125C628.125%20412.021%20628.162%20411.933%20628.235%20411.86C628.308%20411.787%20628.396%20411.75%20628.5%20411.75C628.604%20411.75%20628.692%20411.787%20628.765%20411.86C628.838%20411.933%20628.875%20412.021%20628.875%20412.125ZM632.625%20412.125C632.625%20412.229%20632.588%20412.317%20632.515%20412.39C632.442%20412.463%20632.354%20412.5%20632.25%20412.5C632.146%20412.5%20632.058%20412.463%20631.985%20412.39C631.912%20412.317%20631.875%20412.229%20631.875%20412.125C631.875%20412.021%20631.912%20411.933%20631.985%20411.86C632.058%20411.787%20632.146%20411.75%20632.25%20411.75C632.354%20411.75%20632.442%20411.787%20632.515%20411.86C632.588%20411.933%20632.625%20412.021%20632.625%20412.125ZM636.375%20412.125C636.375%20412.229%20636.338%20412.317%20636.265%20412.39C636.192%20412.463%20636.104%20412.5%20636%20412.5C635.896%20412.5%20635.808%20412.463%20635.735%20412.39C635.662%20412.317%20635.625%20412.229%20635.625%20412.125C635.625%20412.021%20635.662%20411.933%20635.735%20411.86C635.808%20411.787%20635.896%20411.75%20636%20411.75C636.104%20411.75%20636.192%20411.787%20636.265%20411.86C636.338%20411.933%20636.375%20412.021%20636.375%20412.125Z'%20fill='%23B4BAC3'%20/%3e%3cg%20filter='url(%23filter5_f_12_1053)'%3e%3cpath%20d='M44.0037%20410.443H44.3473V411.051C44.9621%20411.07%2045.4611%20411.199%2045.8444%20411.438L45.6636%20411.948C45.5166%20411.866%2045.3225%20411.792%2045.0814%20411.727C44.8427%20411.66%2044.598%20411.62%2044.3473%20411.608V413.445L44.7234%20413.535C45.1573%20413.639%2045.4864%20413.805%2045.7106%20414.034C45.9348%20414.261%2046.047%20414.584%2046.047%20415.003C46.047%20415.522%2045.8951%20415.918%2045.5913%20416.193C45.2899%20416.468%2044.8753%20416.619%2044.3473%20416.645V417.271H44.0037V416.645C43.618%20416.633%2043.2732%20416.585%2042.9695%20416.501C42.6681%20416.414%2042.427%20416.315%2042.2462%20416.204L42.4342%20415.683C42.9212%20415.922%2043.4444%20416.057%2044.0037%20416.088V413.991L43.4721%20413.857C42.6597%20413.652%2042.2534%20413.218%2042.2534%20412.555C42.2534%20412.08%2042.4077%20411.72%2042.7163%20411.474C43.0249%20411.226%2043.454%20411.087%2044.0037%20411.058V410.443ZM44.0037%20413.362V411.611C43.2708%20411.655%2042.9044%20411.955%2042.9044%20412.512C42.9044%20412.717%2042.9707%20412.882%2043.1033%20413.007C43.2383%20413.13%2043.4396%20413.224%2043.7072%20413.289L44.0037%20413.362ZM44.3473%20414.078V416.092C45.0488%20416.056%2045.3996%20415.7%2045.3996%20415.025C45.3996%20414.794%2045.3369%20414.607%2045.2116%20414.465C45.0886%20414.32%2044.8632%20414.207%2044.5353%20414.125L44.3473%20414.078ZM47.4899%20411.156H48.0649V416.566H47.4248V411.825C47.1813%20411.984%2046.8835%20412.12%2046.5315%20412.233V411.629C46.5701%20411.613%2046.6485%20411.579%2046.7666%20411.528C46.8847%20411.477%2046.9727%20411.439%2047.0306%20411.412C47.0909%20411.386%2047.1656%20411.349%2047.2548%20411.3C47.344%20411.252%2047.4224%20411.204%2047.4899%20411.156ZM51.7499%20416.439C51.5112%20416.579%2051.2316%20416.649%2050.9109%20416.649C50.5903%20416.649%2050.3094%20416.579%2050.0683%20416.439C49.8272%20416.297%2049.6331%20416.098%2049.4861%20415.842C49.3414%20415.587%2049.2329%20415.293%2049.1606%20414.96C49.0907%20414.627%2049.0557%20414.257%2049.0557%20413.85C49.0557%20413.515%2049.0786%20413.205%2049.1245%20412.92C49.1727%20412.636%2049.2462%20412.378%2049.345%20412.147C49.4439%20411.915%2049.5656%20411.719%2049.7103%20411.557C49.8574%20411.396%2050.0322%20411.271%2050.2347%20411.185C50.4372%20411.095%2050.6626%20411.051%2050.9109%20411.051C51.2195%20411.051%2051.4919%20411.118%2051.7282%20411.253C51.9669%20411.388%2052.1598%20411.581%2052.3068%20411.832C52.4563%20412.08%2052.5684%20412.374%2052.6431%20412.714C52.7179%20413.052%2052.7552%20413.43%2052.7552%20413.85C52.7552%20414.257%2052.7203%20414.627%2052.6504%20414.96C52.5805%20415.293%2052.4732%20415.587%2052.3285%20415.842C52.1839%20416.098%2051.991%20416.297%2051.7499%20416.439ZM51.5438%20411.893C51.3678%20411.698%2051.1568%20411.6%2050.9109%20411.6C50.665%20411.6%2050.4541%20411.698%2050.2781%20411.893C50.1021%20412.086%2049.9695%20412.349%2049.8803%20412.682C49.7935%20413.012%2049.7501%20413.394%2049.7501%20413.828C49.7501%20414.269%2049.7935%20414.66%2049.8803%20415C49.9695%20415.337%2050.1021%20415.605%2050.2781%20415.803C50.4541%20416%2050.665%20416.099%2050.9109%20416.099C51.1568%20416.099%2051.3678%20416%2051.5438%20415.803C51.7198%20415.605%2051.8512%20415.337%2051.938%20415C52.0272%20414.66%2052.0718%20414.269%2052.0718%20413.828C52.0718%20413.394%2052.0272%20413.012%2051.938%20412.682C51.8512%20412.349%2051.7198%20412.086%2051.5438%20411.893ZM56.2414%20416.439C56.0027%20416.579%2055.7231%20416.649%2055.4024%20416.649C55.0818%20416.649%2054.8009%20416.579%2054.5598%20416.439C54.3187%20416.297%2054.1246%20416.098%2053.9776%20415.842C53.8329%20415.587%2053.7244%20415.293%2053.6521%20414.96C53.5822%20414.627%2053.5472%20414.257%2053.5472%20413.85C53.5472%20413.515%2053.5701%20413.205%2053.6159%20412.92C53.6642%20412.636%2053.7377%20412.378%2053.8365%20412.147C53.9354%20411.915%2054.0571%20411.719%2054.2018%20411.557C54.3488%20411.396%2054.5236%20411.271%2054.7262%20411.185C54.9287%20411.095%2055.1541%20411.051%2055.4024%20411.051C55.711%20411.051%2055.9834%20411.118%2056.2197%20411.253C56.4584%20411.388%2056.6512%20411.581%2056.7983%20411.832C56.9478%20412.08%2057.0599%20412.374%2057.1346%20412.714C57.2094%20413.052%2057.2467%20413.43%2057.2467%20413.85C57.2467%20414.257%2057.2118%20414.627%2057.1419%20414.96C57.0719%20415.293%2056.9647%20415.587%2056.82%20415.842C56.6754%20416.098%2056.4825%20416.297%2056.2414%20416.439ZM56.0353%20411.893C55.8593%20411.698%2055.6483%20411.6%2055.4024%20411.6C55.1565%20411.6%2054.9455%20411.698%2054.7695%20411.893C54.5936%20412.086%2054.461%20412.349%2054.3717%20412.682C54.285%20413.012%2054.2416%20413.394%2054.2416%20413.828C54.2416%20414.269%2054.285%20414.66%2054.3717%20415C54.461%20415.337%2054.5936%20415.605%2054.7695%20415.803C54.9455%20416%2055.1565%20416.099%2055.4024%20416.099C55.6483%20416.099%2055.8593%20416%2056.0353%20415.803C56.2113%20415.605%2056.3427%20415.337%2056.4294%20415C56.5186%20414.66%2056.5632%20414.269%2056.5632%20413.828C56.5632%20413.394%2056.5186%20413.012%2056.4294%20412.682C56.3427%20412.349%2056.2113%20412.086%2056.0353%20411.893ZM62.2011%20416.566H61.4344L59.3876%20414.013L58.8994%20414.443V416.566H58.2702V411.217H58.8994V413.843L61.25%20411.217H62.0348L59.865%20413.626L62.2011%20416.566Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cpath%20d='M161.142%20536.401V531.566H161.793V536.18C161.793%20536.359%20161.789%20536.51%20161.782%20536.633C161.774%20536.755%20161.76%20536.88%20161.738%20537.008C161.715%20537.133%20161.682%20537.236%20161.638%20537.316C161.597%20537.397%20161.541%20537.475%20161.473%20537.548C161.404%20537.624%20161.318%20537.682%20161.215%20537.721C161.115%20537.763%20160.995%20537.794%20160.855%20537.816C160.715%20537.841%20160.554%20537.853%20160.37%20537.853H160.241L160.164%20537.331H160.436C160.566%20537.331%20160.675%20537.315%20160.763%20537.283C160.854%20537.251%20160.924%20537.211%20160.973%20537.162C161.022%20537.115%20161.059%20537.048%20161.083%20536.96C161.11%20536.872%20161.126%20536.789%20161.131%20536.713C161.138%20536.635%20161.142%20536.531%20161.142%20536.401ZM162.719%20535.721V533.033H163.337V535.728C163.337%20535.905%20163.361%20536.054%20163.41%20536.177C163.462%20536.299%20163.534%20536.395%20163.627%20536.463C163.723%20536.53%20163.83%20536.577%20163.947%20536.607C164.067%20536.636%20164.205%20536.651%20164.359%20536.651C164.678%20536.651%20164.925%20536.581%20165.102%20536.441C165.281%20536.302%20165.37%20536.064%20165.37%20535.728V533.033H165.988V535.721C165.988%20535.927%20165.958%20536.112%20165.899%20536.276C165.841%20536.44%20165.761%20536.577%20165.66%20536.688C165.562%20536.796%20165.444%20536.885%20165.304%20536.956C165.164%20537.027%20165.016%20537.079%20164.859%20537.111C164.705%20537.142%20164.538%20537.158%20164.359%20537.158C164.183%20537.158%20164.016%20537.142%20163.859%20537.111C163.702%20537.079%20163.553%20537.027%20163.41%20536.956C163.271%20536.883%20163.149%20536.792%20163.046%20536.684C162.946%20536.574%20162.866%20536.436%20162.807%20536.272C162.749%20536.108%20162.719%20535.924%20162.719%20535.721ZM167.988%20537.14C167.596%20537.14%20167.317%20537.035%20167.153%20536.824C166.991%20536.613%20166.911%20536.247%20166.911%20535.724V531.467L167.521%20531.43V535.482C167.521%20535.648%20167.522%20535.782%20167.525%20535.883C167.529%20535.983%20167.539%20536.082%20167.554%20536.18C167.569%20536.276%20167.588%20536.348%20167.613%20536.397C167.637%20536.446%20167.673%20536.492%20167.719%20536.533C167.766%20536.573%20167.821%20536.599%20167.885%20536.614C167.951%20536.626%20168.032%20536.633%20168.127%20536.633C168.206%20536.633%20168.36%20536.618%20168.591%20536.588L168.624%20537.077C168.371%20537.119%20168.159%20537.14%20167.988%20537.14ZM170.771%20537.066L170.686%20536.463L172.587%20534.353C172.715%20534.211%20172.837%20534.027%20172.955%20533.802C173.075%20533.576%20173.162%20533.385%20173.216%20533.228L173.3%20532.996C173.3%20532.692%20173.216%20532.457%20173.047%20532.29C172.878%20532.121%20172.637%20532.037%20172.326%20532.037C171.807%20532.037%20171.397%20532.188%20171.098%20532.489L170.885%20531.938C171.223%20531.619%20171.718%20531.46%20172.37%20531.46C172.87%20531.46%20173.269%20531.596%20173.565%20531.868C173.862%20532.137%20174.01%20532.499%20174.01%20532.952C174%20532.987%20173.986%20533.033%20173.966%20533.092C173.946%20533.148%20173.903%20533.26%20173.837%20533.427C173.774%20533.593%20173.706%20533.751%20173.635%20533.901C173.564%20534.05%20173.473%20534.215%20173.363%20534.394C173.255%20534.572%20173.145%20534.722%20173.032%20534.842L171.481%20536.5H174.028L173.988%20537.066H170.771ZM177.598%20536.938C177.356%20537.08%20177.071%20537.151%20176.745%20537.151C176.419%20537.151%20176.134%20537.08%20175.889%20536.938C175.644%20536.793%20175.446%20536.591%20175.297%20536.331C175.15%20536.071%20175.04%20535.772%20174.966%20535.434C174.895%20535.096%20174.859%20534.72%20174.859%20534.305C174.859%20533.965%20174.883%20533.65%20174.929%20533.36C174.978%20533.071%20175.053%20532.809%20175.153%20532.574C175.254%20532.338%20175.378%20532.139%20175.525%20531.974C175.674%20531.81%20175.852%20531.684%20176.058%20531.596C176.264%20531.505%20176.493%20531.46%20176.745%20531.46C177.059%20531.46%20177.336%20531.528%20177.576%20531.665C177.819%20531.803%20178.015%20531.999%20178.165%20532.254C178.317%20532.506%20178.431%20532.805%20178.507%20533.151C178.583%20533.494%20178.621%20533.879%20178.621%20534.305C178.621%20534.72%20178.585%20535.096%20178.514%20535.434C178.443%20535.772%20178.334%20536.071%20178.187%20536.331C178.04%20536.591%20177.844%20536.793%20177.598%20536.938ZM177.389%20532.316C177.21%20532.118%20176.995%20532.018%20176.745%20532.018C176.495%20532.018%20176.281%20532.118%20176.102%20532.316C175.923%20532.512%20175.788%20532.779%20175.698%20533.118C175.609%20533.454%20175.565%20533.842%20175.565%20534.283C175.565%20534.732%20175.609%20535.129%20175.698%20535.474C175.788%20535.818%20175.923%20536.09%20176.102%20536.291C176.281%20536.492%20176.495%20536.592%20176.745%20536.592C176.995%20536.592%20177.21%20536.492%20177.389%20536.291C177.568%20536.09%20177.701%20535.818%20177.79%20535.474C177.88%20535.129%20177.926%20534.732%20177.926%20534.283C177.926%20533.842%20177.88%20533.454%20177.79%20533.118C177.701%20532.779%20177.568%20532.512%20177.389%20532.316ZM179.44%20537.066L179.356%20536.463L181.257%20534.353C181.384%20534.211%20181.507%20534.027%20181.624%20533.802C181.744%20533.576%20181.831%20533.385%20181.885%20533.228L181.97%20532.996C181.97%20532.692%20181.885%20532.457%20181.716%20532.29C181.547%20532.121%20181.307%20532.037%20180.996%20532.037C180.476%20532.037%20180.067%20532.188%20179.768%20532.489L179.554%20531.938C179.893%20531.619%20180.388%20531.46%20181.04%20531.46C181.54%20531.46%20181.938%20531.596%20182.235%20531.868C182.531%20532.137%20182.68%20532.499%20182.68%20532.952C182.67%20532.987%20182.655%20533.033%20182.635%20533.092C182.616%20533.148%20182.573%20533.26%20182.507%20533.427C182.443%20533.593%20182.376%20533.751%20182.304%20533.901C182.233%20534.05%20182.143%20534.215%20182.032%20534.394C181.925%20534.572%20181.814%20534.722%20181.702%20534.842L180.15%20536.5H182.698L182.657%20537.066H179.44ZM184.952%20537.151C184.623%20537.151%20184.33%20537.108%20184.073%20537.022C183.818%20536.936%20183.632%20536.837%20183.514%20536.724L183.72%20536.184C184.066%20536.456%20184.477%20536.592%20184.955%20536.592C185.323%20536.592%20185.615%20536.501%20185.83%20536.32C186.048%20536.136%20186.158%20535.88%20186.158%20535.552C186.158%20535.373%20186.129%20535.217%20186.073%20535.085C186.019%20534.95%20185.946%20534.842%20185.852%20534.761C185.762%20534.678%20185.644%20534.612%20185.499%20534.563C185.357%20534.511%20185.21%20534.476%20185.058%20534.456C184.909%20534.434%20184.735%20534.42%20184.536%20534.416C184.512%20534.416%20184.475%20534.416%20184.426%20534.416C184.377%20534.413%20184.34%20534.412%20184.316%20534.412V533.864H184.499C184.671%20533.862%20184.822%20533.853%20184.952%20533.838C185.084%20533.821%20185.215%20533.792%20185.345%20533.75C185.477%20533.708%20185.586%20533.653%20185.672%20533.585C185.758%20533.516%20185.828%20533.424%20185.882%20533.309C185.936%20533.194%20185.963%20533.058%20185.963%20532.901C185.963%20532.313%20185.626%20532.018%20184.952%20532.018C184.709%20532.018%20184.481%20532.054%20184.268%20532.125C184.055%20532.196%20183.872%20532.292%20183.72%20532.412L183.514%20531.875C183.879%20531.598%20184.405%20531.46%20185.091%20531.46C185.368%20531.46%20185.624%20531.511%20185.86%20531.614C186.095%20531.714%20186.289%20531.87%20186.441%20532.081C186.593%20532.289%20186.669%20532.534%20186.669%20532.816C186.669%20533.159%20186.584%20533.441%20186.415%20533.662C186.246%20533.882%20186.008%20534.041%20185.702%20534.136C186.045%20534.21%20186.313%20534.37%20186.507%20534.618C186.703%20534.865%20186.801%20535.179%20186.801%20535.559C186.801%20536.042%20186.628%20536.428%20186.283%20536.717C185.937%20537.006%20185.493%20537.151%20184.952%20537.151Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M305.338%20536.423V531.747H305.967V536.209C305.967%20536.382%20305.964%20536.528%20305.957%20536.647C305.949%20536.765%20305.935%20536.886%20305.914%20537.01C305.893%20537.13%20305.861%20537.23%20305.818%20537.308C305.778%20537.386%20305.724%20537.461%20305.658%20537.532C305.592%20537.606%20305.509%20537.661%20305.409%20537.699C305.312%20537.74%20305.196%20537.771%20305.06%20537.792C304.925%20537.816%20304.769%20537.827%20304.591%20537.827H304.467L304.392%20537.322H304.655C304.781%20537.322%20304.886%20537.307%20304.972%20537.276C305.059%20537.245%20305.127%20537.206%20305.174%20537.159C305.222%20537.114%20305.257%20537.049%20305.281%20536.963C305.307%20536.878%20305.322%20536.799%20305.327%20536.725C305.334%20536.649%20305.338%20536.548%20305.338%20536.423ZM308.126%20536.668C308.408%20536.668%20308.656%20536.591%20308.869%20536.437C309.085%20536.281%20309.223%20536.071%20309.285%20535.808V535.15C309.273%20535.15%20309.201%20535.156%20309.068%20535.167C308.938%20535.179%20308.852%20535.186%20308.812%20535.189C308.298%20535.234%20307.939%20535.318%20307.735%20535.441C307.533%20535.565%20307.432%20535.763%20307.432%20536.035C307.432%20536.244%20307.494%20536.401%20307.617%20536.508C307.741%20536.615%20307.91%20536.668%20308.126%20536.668ZM309.417%20537.066C309.381%20536.915%20309.347%20536.751%20309.314%20536.576C309.098%20536.791%20308.895%20536.941%20308.705%20537.024C308.516%20537.107%20308.293%20537.148%20308.037%20537.148C307.672%20537.148%20307.378%20537.053%20307.155%20536.864C306.935%20536.672%20306.824%20536.397%20306.824%20536.039C306.824%20535.64%20306.975%20535.345%20307.276%20535.153C307.579%20534.961%20308.016%20534.841%20308.585%20534.794C308.663%20534.787%20308.78%20534.777%20308.937%20534.766C309.095%20534.751%20309.214%20534.741%20309.292%20534.734V534.389C309.292%20534.114%20309.228%20533.91%20309.1%20533.777C308.972%20533.644%20308.771%20533.578%20308.496%20533.578C308.112%20533.578%20307.724%20533.673%20307.333%20533.862C307.321%20533.834%20307.29%20533.752%20307.24%20533.617C307.191%20533.48%20307.164%20533.408%20307.162%20533.404C307.335%20533.306%20307.54%20533.229%20307.777%20533.173C308.017%20533.113%20308.26%20533.084%20308.506%20533.084C308.992%20533.084%20309.342%20533.19%20309.555%20533.404C309.771%20533.615%20309.879%20533.975%20309.879%20534.485V537.066H309.417ZM310.903%20537.066V533.165H311.401L311.476%20533.724C311.63%20533.532%20311.822%20533.378%20312.052%20533.261C312.284%20533.143%20312.534%20533.084%20312.802%20533.084C313.252%20533.084%20313.586%20533.21%20313.801%20533.464C314.017%20533.715%20314.125%20534.103%20314.125%20534.627V537.066H313.531C313.531%20535.502%20313.53%20534.664%20313.527%20534.552C313.518%20534.22%20313.45%20533.977%20313.325%20533.823C313.201%20533.669%20312.994%20533.592%20312.702%20533.592C312.397%20533.592%20312.142%20533.666%20311.938%20533.813C311.734%20533.96%20311.601%20534.15%20311.54%20534.385C311.516%20534.544%20311.504%20534.727%20311.504%20534.933V537.066H310.903ZM316.827%20537.066L316.746%20536.483L318.584%20534.442C318.707%20534.305%20318.826%20534.127%20318.94%20533.909C319.056%20533.691%20319.14%20533.506%20319.192%20533.354L319.274%20533.13C319.274%20532.836%20319.192%20532.608%20319.029%20532.447C318.865%20532.284%20318.633%20532.202%20318.332%20532.202C317.829%20532.202%20317.433%20532.348%20317.144%20532.639L316.938%20532.106C317.265%20531.798%20317.744%20531.643%20318.374%20531.643C318.858%20531.643%20319.243%20531.775%20319.53%20532.038C319.817%20532.299%20319.96%20532.649%20319.96%20533.087C319.951%20533.12%20319.937%20533.165%20319.918%20533.222C319.899%20533.277%20319.857%20533.385%20319.793%20533.546C319.732%20533.707%20319.666%20533.86%20319.598%20534.005C319.529%20534.149%20319.441%20534.308%20319.335%20534.481C319.23%20534.654%20319.124%20534.799%20319.014%20534.915L317.514%20536.519H319.978L319.939%20537.066H316.827ZM323.431%20536.942C323.196%20537.079%20322.921%20537.148%20322.606%20537.148C322.291%20537.148%20322.015%20537.079%20321.778%20536.942C321.54%20536.802%20321.35%20536.606%20321.205%20536.355C321.063%20536.104%20320.956%20535.815%20320.885%20535.488C320.816%20535.16%20320.782%20534.796%20320.782%20534.396C320.782%20534.066%20320.804%20533.762%20320.849%20533.482C320.897%20533.202%20320.969%20532.948%20321.066%20532.721C321.164%20532.493%20321.283%20532.3%20321.425%20532.141C321.57%20531.982%20321.742%20531.86%20321.941%20531.775C322.14%20531.687%20322.362%20531.643%20322.606%20531.643C322.91%20531.643%20323.177%20531.71%20323.41%20531.843C323.644%20531.975%20323.834%20532.165%20323.979%20532.412C324.126%20532.656%20324.236%20532.945%20324.309%20533.279C324.383%20533.611%20324.42%20533.983%20324.42%20534.396C324.42%20534.796%20324.385%20535.16%20324.317%20535.488C324.248%20535.815%20324.142%20536.104%20324%20536.355C323.858%20536.606%20323.668%20536.802%20323.431%20536.942ZM323.228%20532.472C323.055%20532.28%20322.848%20532.184%20322.606%20532.184C322.364%20532.184%20322.157%20532.28%20321.984%20532.472C321.811%20532.662%20321.68%20532.92%20321.593%20533.247C321.507%20533.572%20321.465%20533.948%20321.465%20534.374C321.465%20534.808%20321.507%20535.192%20321.593%20535.527C321.68%20535.859%20321.811%20536.122%20321.984%20536.316C322.157%20536.51%20322.364%20536.608%20322.606%20536.608C322.848%20536.608%20323.055%20536.51%20323.228%20536.316C323.401%20536.122%20323.531%20535.859%20323.616%20535.527C323.704%20535.192%20323.748%20534.808%20323.748%20534.374C323.748%20533.948%20323.704%20533.572%20323.616%20533.247C323.531%20532.92%20323.401%20532.662%20323.228%20532.472ZM325.213%20537.066L325.131%20536.483L326.969%20534.442C327.093%20534.305%20327.211%20534.127%20327.325%20533.909C327.441%20533.691%20327.525%20533.506%20327.577%20533.354L327.659%20533.13C327.659%20532.836%20327.577%20532.608%20327.414%20532.447C327.25%20532.284%20327.018%20532.202%20326.717%20532.202C326.214%20532.202%20325.818%20532.348%20325.529%20532.639L325.323%20532.106C325.65%20531.798%20326.129%20531.643%20326.76%20531.643C327.243%20531.643%20327.628%20531.775%20327.915%20532.038C328.202%20532.299%20328.346%20532.649%20328.346%20533.087C328.336%20533.12%20328.322%20533.165%20328.303%20533.222C328.284%20533.277%20328.242%20533.385%20328.178%20533.546C328.117%20533.707%20328.052%20533.86%20327.983%20534.005C327.914%20534.149%20327.826%20534.308%20327.72%20534.481C327.615%20534.654%20327.509%20534.799%20327.4%20534.915L325.899%20536.519H328.363L328.324%20537.066H325.213ZM332.769%20535.747H332.165V537.066H331.567V535.747H329.163V535.203L331.5%20531.747H332.165V535.231H332.819L332.769%20535.747ZM331.567%20532.554L329.789%20535.231H331.567V532.554Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M449.685%20536.412V531.656H450.325V536.195C450.325%20536.371%20450.321%20536.519%20450.314%20536.64C450.307%20536.76%20450.293%20536.883%20450.271%20537.009C450.249%20537.132%20450.217%20537.233%20450.173%20537.312C450.132%20537.392%20450.078%20537.468%20450.01%20537.54C449.943%20537.615%20449.859%20537.672%20449.757%20537.71C449.658%20537.751%20449.54%20537.782%20449.403%20537.804C449.265%20537.828%20449.106%20537.84%20448.926%20537.84H448.799L448.723%20537.327H448.991C449.118%20537.327%20449.226%20537.311%20449.312%20537.28C449.402%20537.248%20449.47%20537.209%20449.519%20537.16C449.567%20537.115%20449.603%20537.048%20449.627%20536.962C449.654%20536.875%20449.669%20536.794%20449.674%20536.719C449.681%20536.642%20449.685%20536.54%20449.685%20536.412ZM451.236%20535.743V533.099H451.844V535.75C451.844%20535.924%20451.868%20536.071%20451.916%20536.191C451.967%20536.312%20452.038%20536.406%20452.13%20536.473C452.224%20536.538%20452.329%20536.585%20452.444%20536.614C452.562%20536.643%20452.697%20536.658%20452.849%20536.658C453.163%20536.658%20453.406%20536.589%20453.58%20536.452C453.756%20536.314%20453.844%20536.08%20453.844%20535.75V533.099H454.451V535.743C454.451%20535.945%20454.422%20536.127%20454.365%20536.289C454.307%20536.45%20454.228%20536.585%20454.129%20536.694C454.033%20536.8%20453.916%20536.888%20453.779%20536.958C453.641%20537.028%20453.495%20537.078%20453.341%20537.11C453.189%20537.141%20453.025%20537.157%20452.849%20537.157C452.676%20537.157%20452.512%20537.141%20452.357%20537.11C452.203%20537.078%20452.056%20537.028%20451.916%20536.958C451.779%20536.886%20451.659%20536.796%20451.558%20536.69C451.459%20536.582%20451.381%20536.447%20451.323%20536.285C451.265%20536.124%20451.236%20535.943%20451.236%20535.743ZM456.419%20537.139C456.033%20537.139%20455.759%20537.035%20455.598%20536.828C455.439%20536.62%20455.359%20536.26%20455.359%20535.746V531.559L455.959%20531.523V535.508C455.959%20535.672%20455.961%20535.803%20455.963%20535.902C455.968%20536.001%20455.977%20536.098%20455.992%20536.195C456.006%20536.289%20456.026%20536.36%20456.05%20536.408C456.074%20536.456%20456.109%20536.501%20456.155%20536.542C456.2%20536.581%20456.255%20536.607%20456.317%20536.622C456.382%20536.634%20456.462%20536.64%20456.556%20536.64C456.633%20536.64%20456.785%20536.625%20457.012%20536.596L457.044%20537.077C456.796%20537.118%20456.587%20537.139%20456.419%20537.139ZM459.156%20537.066L459.073%20536.473L460.943%20534.398C461.068%20534.258%20461.189%20534.077%20461.304%20533.855C461.422%20533.633%20461.508%20533.445%20461.561%20533.291L461.644%20533.063C461.644%20532.764%20461.561%20532.533%20461.395%20532.369C461.228%20532.202%20460.992%20532.119%20460.686%20532.119C460.175%20532.119%20459.772%20532.268%20459.478%20532.564L459.268%20532.022C459.601%20531.708%20460.088%20531.551%20460.729%20531.551C461.221%20531.551%20461.613%20531.685%20461.905%20531.953C462.196%20532.218%20462.342%20532.574%20462.342%20533.02C462.332%20533.053%20462.318%20533.099%20462.299%20533.157C462.279%20533.213%20462.237%20533.322%20462.172%20533.486C462.109%20533.65%20462.043%20533.806%20461.973%20533.953C461.903%20534.1%20461.814%20534.261%20461.706%20534.437C461.6%20534.613%20461.491%20534.76%20461.38%20534.879L459.854%20536.509H462.36L462.32%20537.066H459.156ZM465.872%20536.94C465.633%20537.08%20465.353%20537.15%20465.033%20537.15C464.712%20537.15%20464.431%20537.08%20464.19%20536.94C463.949%20536.798%20463.755%20536.599%20463.608%20536.343C463.463%20536.088%20463.355%20535.793%20463.282%20535.461C463.212%20535.128%20463.178%20534.758%20463.178%20534.351C463.178%20534.015%20463.2%20533.706%20463.246%20533.421C463.294%20533.137%20463.368%20532.879%20463.467%20532.647C463.566%20532.416%20463.687%20532.219%20463.832%20532.058C463.979%20531.896%20464.154%20531.772%20464.356%20531.685C464.559%20531.596%20464.784%20531.551%20465.033%20531.551C465.341%20531.551%20465.614%20531.619%20465.85%20531.754C466.089%20531.889%20466.282%20532.082%20466.429%20532.333C466.578%20532.581%20466.69%20532.875%20466.765%20533.215C466.84%20533.553%20466.877%20533.931%20466.877%20534.351C466.877%20534.758%20466.842%20535.128%20466.772%20535.461C466.702%20535.793%20466.595%20536.088%20466.45%20536.343C466.306%20536.599%20466.113%20536.798%20465.872%20536.94ZM465.666%20532.394C465.49%20532.199%20465.279%20532.101%20465.033%20532.101C464.787%20532.101%20464.576%20532.199%20464.4%20532.394C464.224%20532.587%20464.091%20532.85%20464.002%20533.182C463.915%20533.513%20463.872%20533.895%20463.872%20534.329C463.872%20534.77%20463.915%20535.161%20464.002%20535.501C464.091%20535.838%20464.224%20536.106%20464.4%20536.303C464.576%20536.501%20464.787%20536.6%20465.033%20536.6C465.279%20536.6%20465.49%20536.501%20465.666%20536.303C465.842%20536.106%20465.973%20535.838%20466.06%20535.501C466.149%20535.161%20466.194%20534.77%20466.194%20534.329C466.194%20533.895%20466.149%20533.513%20466.06%20533.182C465.973%20532.85%20465.842%20532.587%20465.666%20532.394ZM467.683%20537.066L467.6%20536.473L469.47%20534.398C469.595%20534.258%20469.716%20534.077%20469.832%20533.855C469.95%20533.633%20470.035%20533.445%20470.088%20533.291L470.171%20533.063C470.171%20532.764%20470.088%20532.533%20469.922%20532.369C469.756%20532.202%20469.519%20532.119%20469.213%20532.119C468.702%20532.119%20468.299%20532.268%20468.005%20532.564L467.796%20532.022C468.128%20531.708%20468.615%20531.551%20469.257%20531.551C469.748%20531.551%20470.14%20531.685%20470.432%20531.953C470.724%20532.218%20470.869%20532.574%20470.869%20533.02C470.86%20533.053%20470.845%20533.099%20470.826%20533.157C470.807%20533.213%20470.765%20533.322%20470.699%20533.486C470.637%20533.65%20470.57%20533.806%20470.501%20533.953C470.431%20534.1%20470.341%20534.261%20470.233%20534.437C470.127%20534.613%20470.018%20534.76%20469.908%20534.879L468.381%20536.509H470.888L470.848%20537.066H467.683ZM475.368%20535.725H474.753V537.066H474.146V535.725H471.701V535.171L474.077%20531.656H474.753V535.2H475.419L475.368%20535.725ZM474.146%20532.477L472.338%20535.2H474.146V532.477Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M593.697%20536.412V531.656H594.337V536.195C594.337%20536.371%20594.334%20536.519%20594.326%20536.64C594.319%20536.76%20594.305%20536.883%20594.283%20537.009C594.261%20537.132%20594.229%20537.233%20594.185%20537.312C594.144%20537.392%20594.09%20537.468%20594.023%20537.54C593.955%20537.615%20593.871%20537.672%20593.77%20537.71C593.671%20537.751%20593.553%20537.782%20593.415%20537.804C593.278%20537.828%20593.119%20537.84%20592.938%20537.84H592.811L592.735%20537.327H593.003C593.131%20537.327%20593.238%20537.311%20593.325%20537.28C593.414%20537.248%20593.483%20537.209%20593.531%20537.16C593.579%20537.115%20593.615%20537.048%20593.639%20536.962C593.666%20536.875%20593.682%20536.794%20593.686%20536.719C593.694%20536.642%20593.697%20536.54%20593.697%20536.412ZM596.532%20536.661C596.819%20536.661%20597.071%20536.583%20597.288%20536.426C597.508%20536.267%20597.649%20536.054%20597.711%20535.786V535.117C597.699%20535.117%20597.626%20535.123%20597.491%20535.135C597.358%20535.147%20597.271%20535.155%20597.23%20535.157C596.707%20535.203%20596.342%20535.288%20596.135%20535.414C595.93%20535.539%20595.827%20535.74%20595.827%20536.018C595.827%20536.23%20595.89%20536.39%20596.015%20536.499C596.141%20536.607%20596.313%20536.661%20596.532%20536.661ZM597.845%20537.066C597.809%20536.912%20597.774%20536.746%20597.74%20536.567C597.521%20536.787%20597.315%20536.939%20597.122%20537.023C596.929%20537.107%20596.702%20537.15%20596.442%20537.15C596.071%20537.15%20595.772%20537.053%20595.545%20536.86C595.321%20536.665%20595.209%20536.385%20595.209%20536.021C595.209%20535.616%20595.362%20535.316%20595.668%20535.121C595.977%20534.926%20596.42%20534.804%20596.999%20534.756C597.078%20534.748%20597.198%20534.739%20597.357%20534.727C597.518%20534.712%20597.639%20534.701%20597.719%20534.694V534.343C597.719%20534.064%20597.653%20533.856%20597.523%20533.721C597.393%20533.586%20597.188%20533.519%20596.908%20533.519C596.518%20533.519%20596.124%20533.615%20595.726%20533.808C595.714%20533.779%20595.683%20533.696%20595.632%20533.559C595.581%20533.419%20595.555%20533.346%20595.552%20533.342C595.728%20533.243%20595.937%20533.164%20596.178%20533.107C596.421%20533.046%20596.669%20533.016%20596.919%20533.016C597.414%20533.016%20597.769%20533.125%20597.986%20533.342C598.206%20533.556%20598.315%20533.923%20598.315%20534.441V537.066H597.845ZM599.357%20537.066V533.099H599.863L599.939%20533.667C600.096%20533.472%20600.291%20533.315%20600.525%20533.197C600.761%20533.076%20601.015%20533.016%20601.288%20533.016C601.746%20533.016%20602.085%20533.145%20602.304%20533.403C602.523%20533.659%20602.633%20534.053%20602.633%20534.586V537.066H602.029C602.029%20535.475%20602.028%20534.623%20602.026%20534.51C602.016%20534.172%20601.947%20533.925%20601.819%20533.768C601.694%20533.612%20601.483%20533.533%20601.187%20533.533C600.876%20533.533%20600.616%20533.608%20600.409%20533.757C600.202%20533.907%20600.067%20534.101%20600.004%20534.34C599.98%20534.501%20599.968%20534.687%20599.968%20534.897V537.066H599.357ZM605.382%20537.066L605.298%20536.473L607.168%20534.398C607.293%20534.258%20607.414%20534.077%20607.53%20533.855C607.648%20533.633%20607.733%20533.445%20607.786%20533.291L607.87%20533.063C607.87%20532.764%20607.786%20532.533%20607.62%20532.369C607.454%20532.202%20607.217%20532.119%20606.911%20532.119C606.4%20532.119%20605.998%20532.268%20605.703%20532.564L605.494%20532.022C605.826%20531.708%20606.313%20531.551%20606.955%20531.551C607.446%20531.551%20607.838%20531.685%20608.13%20531.953C608.422%20532.218%20608.568%20532.574%20608.568%20533.02C608.558%20533.053%20608.543%20533.099%20608.524%20533.157C608.505%20533.213%20608.463%20533.322%20608.398%20533.486C608.335%20533.65%20608.269%20533.806%20608.199%20533.953C608.129%20534.1%20608.04%20534.261%20607.931%20534.437C607.825%20534.613%20607.716%20534.76%20607.606%20534.879L606.079%20536.509H608.586L608.546%20537.066H605.382ZM612.097%20536.94C611.858%20537.08%20611.579%20537.15%20611.258%20537.15C610.937%20537.15%20610.657%20537.08%20610.415%20536.94C610.174%20536.798%20609.98%20536.599%20609.833%20536.343C609.689%20536.088%20609.58%20535.793%20609.508%20535.461C609.438%20535.128%20609.403%20534.758%20609.403%20534.351C609.403%20534.015%20609.426%20533.706%20609.472%20533.421C609.52%20533.137%20609.593%20532.879%20609.692%20532.647C609.791%20532.416%20609.913%20532.219%20610.057%20532.058C610.205%20531.896%20610.379%20531.772%20610.582%20531.685C610.784%20531.596%20611.01%20531.551%20611.258%20531.551C611.567%20531.551%20611.839%20531.619%20612.075%20531.754C612.314%20531.889%20612.507%20532.082%20612.654%20532.333C612.803%20532.581%20612.916%20532.875%20612.99%20533.215C613.065%20533.553%20613.102%20533.931%20613.102%20534.351C613.102%20534.758%20613.067%20535.128%20612.998%20535.461C612.928%20535.793%20612.82%20536.088%20612.676%20536.343C612.531%20536.599%20612.338%20536.798%20612.097%20536.94ZM611.891%20532.394C611.715%20532.199%20611.504%20532.101%20611.258%20532.101C611.012%20532.101%20610.801%20532.199%20610.625%20532.394C610.449%20532.587%20610.317%20532.85%20610.227%20533.182C610.141%20533.513%20610.097%20533.895%20610.097%20534.329C610.097%20534.77%20610.141%20535.161%20610.227%20535.501C610.317%20535.838%20610.449%20536.106%20610.625%20536.303C610.801%20536.501%20611.012%20536.6%20611.258%20536.6C611.504%20536.6%20611.715%20536.501%20611.891%20536.303C612.067%20536.106%20612.198%20535.838%20612.285%20535.501C612.374%20535.161%20612.419%20534.77%20612.419%20534.329C612.419%20533.895%20612.374%20533.513%20612.285%20533.182C612.198%20532.85%20612.067%20532.587%20611.891%20532.394ZM613.909%20537.066L613.826%20536.473L615.695%20534.398C615.821%20534.258%20615.941%20534.077%20616.057%20533.855C616.175%20533.633%20616.261%20533.445%20616.314%20533.291L616.397%20533.063C616.397%20532.764%20616.314%20532.533%20616.147%20532.369C615.981%20532.202%20615.745%20532.119%20615.439%20532.119C614.927%20532.119%20614.525%20532.268%20614.231%20532.564L614.021%20532.022C614.354%20531.708%20614.841%20531.551%20615.482%20531.551C615.974%20531.551%20616.366%20531.685%20616.657%20531.953C616.949%20532.218%20617.095%20532.574%20617.095%20533.02C617.085%20533.053%20617.071%20533.099%20617.051%20533.157C617.032%20533.213%20616.99%20533.322%20616.925%20533.486C616.862%20533.65%20616.796%20533.806%20616.726%20533.953C616.656%20534.1%20616.567%20534.261%20616.458%20534.437C616.352%20534.613%20616.244%20534.76%20616.133%20534.879L614.607%20536.509H617.113L617.073%20537.066H613.909ZM621.167%20531.656L621.116%20532.249H618.907C618.883%20532.951%20618.864%20533.519%20618.852%20533.953C619.125%20533.779%20619.42%20533.692%20619.738%20533.692C620.006%20533.692%20620.245%20533.736%20620.454%20533.823C620.667%20533.907%20620.839%20534.024%20620.972%20534.173C621.107%20534.323%20621.209%20534.498%20621.279%20534.698C621.349%20534.895%20621.384%20535.11%20621.384%20535.341C621.384%20535.889%20621.208%20536.327%20620.856%20536.658C620.506%20536.986%20620.03%20537.15%20619.427%20537.15C618.822%20537.15%20618.338%20536.984%20617.974%20536.654L618.209%20536.144C618.565%20536.424%20618.979%20536.564%20619.449%20536.564C619.844%20536.564%20620.157%20536.452%20620.386%20536.227C620.615%20536.003%20620.729%20535.71%20620.729%20535.349C620.729%20535.026%20620.633%20534.764%20620.44%20534.564C620.247%20534.361%20619.972%20534.26%20619.615%20534.26C619.259%20534.26%20618.972%20534.379%20618.755%20534.618L618.252%20534.549L618.393%20531.656H621.167Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip33_12_1053)'%3e%3cpath%20d='M77.25%20484.563L101.691%20489.045L125.343%20483.821L149.783%20486.678L173.436%20483.702L197.876%20479.889L222.317%20479.781L245.969%20477.259L270.41%20477.601L294.062%20479.87L318.502%20469.857L342.943%20466.207L365.807%20472L390.247%20472.253L413.9%20470.72L438.34%20474.876L461.993%20470.276L486.433%20466.413L510.874%20468.009L534.526%20465.331L558.967%20461.704L582.619%20468.418L607.059%20455.689L631.5%20456.89V524.2H607.059H582.619H558.967H534.526H510.874H486.433H461.993H438.34H413.9H390.247H365.807H342.943H318.502H294.062H270.41H245.969H222.317H197.876H173.436H149.783H125.343H101.691H77.25V484.563Z'%20fill='%230F9ED5'%20fill-opacity='0.4'%20/%3e%3cpath%20d='M77.25%20468.12L101.691%20478.31L125.343%20472.763L149.783%20476.593L173.436%20472.31L197.876%20468.506L222.317%20464.056L245.969%20459.615L270.41%20461.466L294.062%20456.955L318.502%20441.525L342.943%20441.749L365.807%20452.596L390.247%20455.511L413.9%20455.747L438.34%20462.096L461.993%20457.427L486.433%20450.833L510.874%20451.024L534.526%20446.161L558.967%20438.849L582.619%20442.656L607.059%20426.884L631.5%20428.716V456.89L607.059%20455.689L582.619%20468.418L558.967%20461.704L534.526%20465.331L510.874%20468.009L486.433%20466.413L461.993%20470.276L438.34%20474.876L413.9%20470.72L390.247%20472.253L365.807%20472L342.943%20466.207L318.502%20469.857L294.062%20479.87L270.41%20477.601L245.969%20477.259L222.317%20479.781L197.876%20479.889L173.436%20483.702L149.783%20486.678L125.343%20483.821L101.691%20489.045L77.25%20484.563V468.12Z'%20fill='%230FD78A'%20fill-opacity='0.4'%20/%3e%3cpath%20d='M77.25%20484.563L101.691%20489.045L125.343%20483.821L149.783%20486.678L173.436%20483.702L197.876%20479.889L222.317%20479.781L245.969%20477.259L270.41%20477.601L294.062%20479.87L318.502%20469.857L342.943%20466.207L365.807%20472L390.248%20472.253L413.9%20470.72L438.34%20474.876L461.993%20470.276L486.433%20466.413L510.874%20468.009L534.526%20465.331L558.967%20461.704L582.619%20468.418L607.059%20455.689L631.5%20456.89'%20stroke='%230F9ED5'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M77.25%20468.12L101.691%20478.31L125.343%20472.763L149.783%20476.593L173.436%20472.31L197.876%20468.506L222.317%20464.056L245.969%20459.615L270.41%20461.466L294.062%20456.955L318.502%20441.525L342.943%20441.749L365.807%20452.596L390.248%20455.511L413.9%20455.747L438.34%20462.096L461.993%20457.427L486.433%20450.833L510.874%20451.024L534.526%20446.161L558.967%20438.849L582.619%20442.656L607.059%20426.884L631.5%20428.716'%20stroke='%230FD78A'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3c/g%3e%3cpath%20d='M74.125%20484.562C74.125%20484.977%2074.2043%20485.376%2074.3629%20485.758C74.5215%20486.141%2074.7473%20486.479%2075.0403%20486.772C75.3333%20487.065%2075.6713%20487.291%2076.0541%20487.45C76.437%20487.608%2076.8356%20487.687%2077.25%20487.687C77.6644%20487.687%2078.063%20487.608%2078.4459%20487.45C78.8287%20487.291%2079.1667%20487.065%2079.4597%20486.772C79.7527%20486.479%2079.9785%20486.141%2080.1371%20485.758C80.2957%20485.376%2080.375%20484.977%2080.375%20484.562C80.375%20484.148%2080.2957%20483.749%2080.1371%20483.367C79.9785%20482.984%2079.7527%20482.646%2079.4597%20482.353C79.1667%20482.06%2078.8287%20481.834%2078.4459%20481.675C78.063%20481.517%2077.6644%20481.438%2077.25%20481.438C76.8356%20481.438%2076.437%20481.517%2076.0541%20481.675C75.6713%20481.834%2075.3333%20482.06%2075.0403%20482.353C74.7473%20482.646%2074.5215%20482.984%2074.3629%20483.367C74.2043%20483.749%2074.125%20484.148%2074.125%20484.562Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M98.5659%20489.045C98.5659%20489.459%2098.6452%20489.858%2098.8038%20490.241C98.9624%20490.623%2099.1882%20490.961%2099.4812%20491.254C99.7742%20491.547%20100.112%20491.773%20100.495%20491.932C100.878%20492.09%20101.277%20492.17%20101.691%20492.17C102.105%20492.17%20102.504%20492.09%20102.887%20491.932C103.27%20491.773%20103.608%20491.547%20103.901%20491.254C104.194%20490.961%20104.419%20490.623%20104.578%20490.241C104.737%20489.858%20104.816%20489.459%20104.816%20489.045C104.816%20488.63%20104.737%20488.232%20104.578%20487.849C104.419%20487.466%20104.194%20487.128%20103.901%20486.835C103.608%20486.542%20103.27%20486.316%20102.887%20486.158C102.504%20485.999%20102.105%20485.92%20101.691%20485.92C101.277%20485.92%20100.878%20485.999%20100.495%20486.158C100.112%20486.316%2099.7742%20486.542%2099.4812%20486.835C99.1882%20487.128%2098.9624%20487.466%2098.8038%20487.849C98.6452%20488.232%2098.5659%20488.63%2098.5659%20489.045Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M122.218%20483.822C122.218%20484.236%20122.297%20484.635%20122.456%20485.017C122.614%20485.4%20122.84%20485.738%20123.133%20486.031C123.426%20486.324%20123.764%20486.55%20124.147%20486.709C124.53%20486.867%20124.928%20486.947%20125.343%20486.947C125.757%20486.947%20126.156%20486.867%20126.539%20486.709C126.922%20486.55%20127.259%20486.324%20127.552%20486.031C127.846%20485.738%20128.071%20485.4%20128.23%20485.017C128.388%20484.635%20128.468%20484.236%20128.468%20483.822C128.468%20483.407%20128.388%20483.009%20128.23%20482.626C128.071%20482.243%20127.846%20481.905%20127.552%20481.612C127.259%20481.319%20126.922%20481.093%20126.539%20480.934C126.156%20480.776%20125.757%20480.697%20125.343%20480.697C124.928%20480.697%20124.53%20480.776%20124.147%20480.934C123.764%20481.093%20123.426%20481.319%20123.133%20481.612C122.84%20481.905%20122.614%20482.243%20122.456%20482.626C122.297%20483.009%20122.218%20483.407%20122.218%20483.822Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M146.658%20486.678C146.658%20487.092%20146.737%20487.491%20146.896%20487.873C147.055%20488.256%20147.28%20488.594%20147.573%20488.887C147.867%20489.18%20148.204%20489.406%20148.587%20489.565C148.97%20489.723%20149.369%20489.803%20149.783%20489.803C150.198%20489.803%20150.596%20489.723%20150.979%20489.565C151.362%20489.406%20151.7%20489.18%20151.993%20488.887C152.286%20488.594%20152.512%20488.256%20152.67%20487.873C152.829%20487.491%20152.908%20487.092%20152.908%20486.678C152.908%20486.263%20152.829%20485.865%20152.67%20485.482C152.512%20485.099%20152.286%20484.761%20151.993%20484.468C151.7%20484.175%20151.362%20483.949%20150.979%20483.79C150.596%20483.632%20150.198%20483.553%20149.783%20483.553C149.369%20483.553%20148.97%20483.632%20148.587%20483.79C148.204%20483.949%20147.867%20484.175%20147.573%20484.468C147.28%20484.761%20147.055%20485.099%20146.896%20485.482C146.737%20485.865%20146.658%20486.263%20146.658%20486.678Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M170.311%20483.702C170.311%20484.117%20170.39%20484.515%20170.548%20484.898C170.707%20485.281%20170.933%20485.619%20171.226%20485.912C171.519%20486.205%20171.857%20486.431%20172.24%20486.589C172.623%20486.748%20173.021%20486.827%20173.436%20486.827C173.85%20486.827%20174.249%20486.748%20174.631%20486.589C175.014%20486.431%20175.352%20486.205%20175.645%20485.912C175.938%20485.619%20176.164%20485.281%20176.323%20484.898C176.481%20484.515%20176.561%20484.117%20176.561%20483.702C176.561%20483.288%20176.481%20482.889%20176.323%20482.506C176.164%20482.123%20175.938%20481.785%20175.645%20481.492C175.352%20481.199%20175.014%20480.974%20174.631%20480.815C174.249%20480.656%20173.85%20480.577%20173.436%20480.577C173.021%20480.577%20172.623%20480.656%20172.24%20480.815C171.857%20480.974%20171.519%20481.199%20171.226%20481.492C170.933%20481.785%20170.707%20482.123%20170.548%20482.506C170.39%20482.889%20170.311%20483.288%20170.311%20483.702Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M194.751%20479.889C194.751%20480.303%20194.83%20480.702%20194.989%20481.085C195.147%20481.468%20195.373%20481.806%20195.666%20482.099C195.959%20482.392%20196.297%20482.618%20196.68%20482.776C197.063%20482.935%20197.462%20483.014%20197.876%20483.014C198.29%20483.014%20198.689%20482.935%20199.072%20482.776C199.455%20482.618%20199.793%20482.392%20200.086%20482.099C200.379%20481.806%20200.605%20481.468%20200.763%20481.085C200.922%20480.702%20201.001%20480.303%20201.001%20479.889C201.001%20479.475%20200.922%20479.076%20200.763%20478.693C200.605%20478.31%20200.379%20477.972%20200.086%20477.679C199.793%20477.386%20199.455%20477.16%20199.072%20477.002C198.689%20476.843%20198.29%20476.764%20197.876%20476.764C197.462%20476.764%20197.063%20476.843%20196.68%20477.002C196.297%20477.16%20195.959%20477.386%20195.666%20477.679C195.373%20477.972%20195.147%20478.31%20194.989%20478.693C194.83%20479.076%20194.751%20479.475%20194.751%20479.889Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M219.191%20479.781C219.191%20480.196%20219.271%20480.594%20219.429%20480.977C219.588%20481.36%20219.814%20481.698%20220.107%20481.991C220.4%20482.284%20220.738%20482.51%20221.121%20482.668C221.503%20482.827%20221.902%20482.906%20222.316%20482.906C222.731%20482.906%20223.129%20482.827%20223.512%20482.668C223.895%20482.51%20224.233%20482.284%20224.526%20481.991C224.819%20481.698%20225.045%20481.36%20225.204%20480.977C225.362%20480.594%20225.441%20480.196%20225.441%20479.781C225.441%20479.367%20225.362%20478.968%20225.204%20478.585C225.045%20478.202%20224.819%20477.864%20224.526%20477.571C224.233%20477.278%20223.895%20477.053%20223.512%20476.894C223.129%20476.735%20222.731%20476.656%20222.316%20476.656C221.902%20476.656%20221.503%20476.735%20221.121%20476.894C220.738%20477.053%20220.4%20477.278%20220.107%20477.571C219.814%20477.864%20219.588%20478.202%20219.429%20478.585C219.271%20478.968%20219.191%20479.367%20219.191%20479.781Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M242.844%20477.259C242.844%20477.673%20242.924%20478.072%20243.082%20478.455C243.241%20478.838%20243.467%20479.176%20243.76%20479.469C244.053%20479.762%20244.39%20479.987%20244.773%20480.146C245.156%20480.305%20245.555%20480.384%20245.969%20480.384C246.384%20480.384%20246.782%20480.305%20247.165%20480.146C247.548%20479.987%20247.886%20479.762%20248.179%20479.469C248.472%20479.176%20248.698%20478.838%20248.856%20478.455C249.015%20478.072%20249.094%20477.673%20249.094%20477.259C249.094%20476.845%20249.015%20476.446%20248.856%20476.063C248.698%20475.68%20248.472%20475.342%20248.179%20475.049C247.886%20474.756%20247.548%20474.53%20247.165%20474.372C246.782%20474.213%20246.384%20474.134%20245.969%20474.134C245.555%20474.134%20245.156%20474.213%20244.773%20474.372C244.39%20474.53%20244.053%20474.756%20243.76%20475.049C243.467%20475.342%20243.241%20475.68%20243.082%20476.063C242.924%20476.446%20242.844%20476.845%20242.844%20477.259Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M267.285%20477.601C267.285%20478.015%20267.364%20478.414%20267.523%20478.796C267.681%20479.179%20267.907%20479.517%20268.2%20479.81C268.493%20480.103%20268.831%20480.329%20269.214%20480.488C269.597%20480.646%20269.995%20480.726%20270.41%20480.726C270.824%20480.726%20271.223%20480.646%20271.606%20480.488C271.988%20480.329%20272.326%20480.103%20272.619%20479.81C272.912%20479.517%20273.138%20479.179%20273.297%20478.796C273.455%20478.414%20273.535%20478.015%20273.535%20477.601C273.535%20477.186%20273.455%20476.788%20273.297%20476.405C273.138%20476.022%20272.912%20475.684%20272.619%20475.391C272.326%20475.098%20271.988%20474.872%20271.606%20474.713C271.223%20474.555%20270.824%20474.476%20270.41%20474.476C269.995%20474.476%20269.597%20474.555%20269.214%20474.713C268.831%20474.872%20268.493%20475.098%20268.2%20475.391C267.907%20475.684%20267.681%20476.022%20267.523%20476.405C267.364%20476.788%20267.285%20477.186%20267.285%20477.601Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M290.937%20479.87C290.937%20480.284%20291.016%20480.683%20291.175%20481.066C291.333%20481.449%20291.559%20481.787%20291.852%20482.08C292.145%20482.373%20292.483%20482.599%20292.866%20482.757C293.249%20482.916%20293.648%20482.995%20294.062%20482.995C294.476%20482.995%20294.875%20482.916%20295.258%20482.757C295.641%20482.599%20295.979%20482.373%20296.272%20482.08C296.565%20481.787%20296.791%20481.449%20296.949%20481.066C297.108%20480.683%20297.187%20480.284%20297.187%20479.87C297.187%20479.456%20297.108%20479.057%20296.949%20478.674C296.791%20478.291%20296.565%20477.953%20296.272%20477.66C295.979%20477.367%20295.641%20477.141%20295.258%20476.983C294.875%20476.824%20294.476%20476.745%20294.062%20476.745C293.648%20476.745%20293.249%20476.824%20292.866%20476.983C292.483%20477.141%20292.145%20477.367%20291.852%20477.66C291.559%20477.953%20291.333%20478.291%20291.175%20478.674C291.016%20479.057%20290.937%20479.456%20290.937%20479.87Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M315.377%20469.857C315.377%20470.272%20315.457%20470.67%20315.615%20471.053C315.774%20471.436%20316%20471.774%20316.293%20472.067C316.586%20472.36%20316.924%20472.586%20317.307%20472.745C317.689%20472.903%20318.088%20472.982%20318.502%20472.982C318.917%20472.982%20319.315%20472.903%20319.698%20472.745C320.081%20472.586%20320.419%20472.36%20320.712%20472.067C321.005%20471.774%20321.231%20471.436%20321.39%20471.053C321.548%20470.67%20321.627%20470.272%20321.627%20469.857C321.627%20469.443%20321.548%20469.044%20321.39%20468.662C321.231%20468.279%20321.005%20467.941%20320.712%20467.648C320.419%20467.355%20320.081%20467.129%20319.698%20466.97C319.315%20466.812%20318.917%20466.732%20318.502%20466.732C318.088%20466.732%20317.689%20466.812%20317.307%20466.97C316.924%20467.129%20316.586%20467.355%20316.293%20467.648C316%20467.941%20315.774%20468.279%20315.615%20468.662C315.457%20469.044%20315.377%20469.443%20315.377%20469.857Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M339.818%20466.207C339.818%20466.622%20339.897%20467.02%20340.056%20467.403C340.214%20467.786%20340.44%20468.124%20340.733%20468.417C341.026%20468.71%20341.364%20468.936%20341.747%20469.094C342.13%20469.253%20342.528%20469.332%20342.943%20469.332C343.357%20469.332%20343.756%20469.253%20344.139%20469.094C344.522%20468.936%20344.86%20468.71%20345.153%20468.417C345.446%20468.124%20345.671%20467.786%20345.83%20467.403C345.989%20467.02%20346.068%20466.622%20346.068%20466.207C346.068%20465.793%20345.989%20465.394%20345.83%20465.011C345.671%20464.629%20345.446%20464.291%20345.153%20463.998C344.86%20463.705%20344.522%20463.479%20344.139%20463.32C343.756%20463.162%20343.357%20463.082%20342.943%20463.082C342.528%20463.082%20342.13%20463.162%20341.747%20463.32C341.364%20463.479%20341.026%20463.705%20340.733%20463.998C340.44%20464.291%20340.214%20464.629%20340.056%20465.011C339.897%20465.394%20339.818%20465.793%20339.818%20466.207Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M362.682%20472C362.682%20472.414%20362.761%20472.813%20362.92%20473.195C363.078%20473.578%20363.304%20473.916%20363.597%20474.209C363.89%20474.502%20364.228%20474.728%20364.611%20474.887C364.994%20475.045%20365.392%20475.125%20365.807%20475.125C366.221%20475.125%20366.62%20475.045%20367.003%20474.887C367.385%20474.728%20367.723%20474.502%20368.016%20474.209C368.309%20473.916%20368.535%20473.578%20368.694%20473.195C368.852%20472.813%20368.932%20472.414%20368.932%20472C368.932%20471.585%20368.852%20471.186%20368.694%20470.804C368.535%20470.421%20368.309%20470.083%20368.016%20469.79C367.723%20469.497%20367.385%20469.271%20367.003%20469.112C366.62%20468.954%20366.221%20468.875%20365.807%20468.875C365.392%20468.875%20364.994%20468.954%20364.611%20469.112C364.228%20469.271%20363.89%20469.497%20363.597%20469.79C363.304%20470.083%20363.078%20470.421%20362.92%20470.804C362.761%20471.186%20362.682%20471.585%20362.682%20472Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M387.123%20472.253C387.123%20472.667%20387.202%20473.066%20387.36%20473.449C387.519%20473.831%20387.745%20474.169%20388.038%20474.462C388.331%20474.755%20388.669%20474.981%20389.052%20475.14C389.435%20475.298%20389.833%20475.378%20390.248%20475.378C390.662%20475.378%20391.061%20475.298%20391.443%20475.14C391.826%20474.981%20392.164%20474.755%20392.457%20474.462C392.75%20474.169%20392.976%20473.831%20393.135%20473.449C393.293%20473.066%20393.373%20472.667%20393.373%20472.253C393.373%20471.838%20393.293%20471.44%20393.135%20471.057C392.976%20470.674%20392.75%20470.336%20392.457%20470.043C392.164%20469.75%20391.826%20469.524%20391.443%20469.366C391.061%20469.207%20390.662%20469.128%20390.248%20469.128C389.833%20469.128%20389.435%20469.207%20389.052%20469.366C388.669%20469.524%20388.331%20469.75%20388.038%20470.043C387.745%20470.336%20387.519%20470.674%20387.36%20471.057C387.202%20471.44%20387.123%20471.838%20387.123%20472.253Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M410.774%20470.72C410.774%20471.134%20410.854%20471.533%20411.012%20471.916C411.171%20472.299%20411.397%20472.637%20411.69%20472.93C411.983%20473.223%20412.321%20473.448%20412.704%20473.607C413.086%20473.766%20413.485%20473.845%20413.899%20473.845C414.314%20473.845%20414.712%20473.766%20415.095%20473.607C415.478%20473.448%20415.816%20473.223%20416.109%20472.93C416.402%20472.637%20416.628%20472.299%20416.787%20471.916C416.945%20471.533%20417.024%20471.134%20417.024%20470.72C417.024%20470.305%20416.945%20469.907%20416.787%20469.524C416.628%20469.141%20416.402%20468.803%20416.109%20468.51C415.816%20468.217%20415.478%20467.991%20415.095%20467.833C414.712%20467.674%20414.314%20467.595%20413.899%20467.595C413.485%20467.595%20413.086%20467.674%20412.704%20467.833C412.321%20467.991%20411.983%20468.217%20411.69%20468.51C411.397%20468.803%20411.171%20469.141%20411.012%20469.524C410.854%20469.907%20410.774%20470.305%20410.774%20470.72Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M435.215%20474.876C435.215%20475.29%20435.295%20475.689%20435.453%20476.072C435.612%20476.455%20435.838%20476.793%20436.131%20477.086C436.424%20477.379%20436.762%20477.605%20437.144%20477.763C437.527%20477.922%20437.926%20478.001%20438.34%20478.001C438.755%20478.001%20439.153%20477.922%20439.536%20477.763C439.919%20477.605%20440.257%20477.379%20440.55%20477.086C440.843%20476.793%20441.069%20476.455%20441.227%20476.072C441.386%20475.689%20441.465%20475.29%20441.465%20474.876C441.465%20474.462%20441.386%20474.063%20441.227%20473.68C441.069%20473.297%20440.843%20472.959%20440.55%20472.666C440.257%20472.373%20439.919%20472.148%20439.536%20471.989C439.153%20471.83%20438.755%20471.751%20438.34%20471.751C437.926%20471.751%20437.527%20471.83%20437.144%20471.989C436.762%20472.148%20436.424%20472.373%20436.131%20472.666C435.838%20472.959%20435.612%20473.297%20435.453%20473.68C435.295%20474.063%20435.215%20474.462%20435.215%20474.876Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M458.868%20470.276C458.868%20470.69%20458.947%20471.089%20459.106%20471.472C459.264%20471.854%20459.49%20472.192%20459.783%20472.485C460.076%20472.778%20460.414%20473.004%20460.797%20473.163C461.18%20473.321%20461.578%20473.401%20461.993%20473.401C462.407%20473.401%20462.806%20473.321%20463.189%20473.163C463.571%20473.004%20463.909%20472.778%20464.202%20472.485C464.495%20472.192%20464.721%20471.854%20464.88%20471.472C465.038%20471.089%20465.118%20470.69%20465.118%20470.276C465.118%20469.861%20465.038%20469.463%20464.88%20469.08C464.721%20468.697%20464.495%20468.359%20464.202%20468.066C463.909%20467.773%20463.571%20467.547%20463.189%20467.389C462.806%20467.23%20462.407%20467.151%20461.993%20467.151C461.578%20467.151%20461.18%20467.23%20460.797%20467.389C460.414%20467.547%20460.076%20467.773%20459.783%20468.066C459.49%20468.359%20459.264%20468.697%20459.106%20469.08C458.947%20469.463%20458.868%20469.861%20458.868%20470.276Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M483.308%20466.413C483.308%20466.827%20483.387%20467.226%20483.546%20467.609C483.705%20467.992%20483.93%20468.33%20484.223%20468.623C484.516%20468.916%20484.854%20469.142%20485.237%20469.3C485.62%20469.459%20486.019%20469.538%20486.433%20469.538C486.848%20469.538%20487.246%20469.459%20487.629%20469.3C488.012%20469.142%20488.35%20468.916%20488.643%20468.623C488.936%20468.33%20489.162%20467.992%20489.32%20467.609C489.479%20467.226%20489.558%20466.827%20489.558%20466.413C489.558%20465.999%20489.479%20465.6%20489.32%20465.217C489.162%20464.834%20488.936%20464.496%20488.643%20464.203C488.35%20463.91%20488.012%20463.685%20487.629%20463.526C487.246%20463.367%20486.848%20463.288%20486.433%20463.288C486.019%20463.288%20485.62%20463.367%20485.237%20463.526C484.854%20463.685%20484.516%20463.91%20484.223%20464.203C483.93%20464.496%20483.705%20464.834%20483.546%20465.217C483.387%20465.6%20483.308%20465.999%20483.308%20466.413Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M507.749%20468.009C507.749%20468.423%20507.828%20468.822%20507.986%20469.205C508.145%20469.588%20508.371%20469.925%20508.664%20470.218C508.957%20470.512%20509.295%20470.737%20509.678%20470.896C510.061%20471.054%20510.459%20471.134%20510.874%20471.134C511.288%20471.134%20511.687%20471.054%20512.069%20470.896C512.452%20470.737%20512.79%20470.512%20513.083%20470.218C513.376%20469.925%20513.602%20469.588%20513.761%20469.205C513.919%20468.822%20513.999%20468.423%20513.999%20468.009C513.999%20467.594%20513.919%20467.196%20513.761%20466.813C513.602%20466.43%20513.376%20466.092%20513.083%20465.799C512.79%20465.506%20512.452%20465.28%20512.069%20465.122C511.687%20464.963%20511.288%20464.884%20510.874%20464.884C510.459%20464.884%20510.061%20464.963%20509.678%20465.122C509.295%20465.28%20508.957%20465.506%20508.664%20465.799C508.371%20466.092%20508.145%20466.43%20507.986%20466.813C507.828%20467.196%20507.749%20467.594%20507.749%20468.009Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M531.401%20465.331C531.401%20465.746%20531.48%20466.144%20531.639%20466.527C531.797%20466.91%20532.023%20467.248%20532.316%20467.541C532.609%20467.834%20532.947%20468.06%20533.33%20468.218C533.713%20468.377%20534.111%20468.456%20534.526%20468.456C534.94%20468.456%20535.339%20468.377%20535.722%20468.218C536.105%20468.06%20536.443%20467.834%20536.736%20467.541C537.029%20467.248%20537.254%20466.91%20537.413%20466.527C537.572%20466.144%20537.651%20465.746%20537.651%20465.331C537.651%20464.917%20537.572%20464.518%20537.413%20464.135C537.254%20463.753%20537.029%20463.415%20536.736%20463.122C536.443%20462.829%20536.105%20462.603%20535.722%20462.444C535.339%20462.286%20534.94%20462.206%20534.526%20462.206C534.111%20462.206%20533.713%20462.286%20533.33%20462.444C532.947%20462.603%20532.609%20462.829%20532.316%20463.122C532.023%20463.415%20531.797%20463.753%20531.639%20464.135C531.48%20464.518%20531.401%20464.917%20531.401%20465.331Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M555.842%20461.704C555.842%20462.118%20555.921%20462.517%20556.08%20462.899C556.238%20463.282%20556.464%20463.62%20556.757%20463.913C557.05%20464.206%20557.388%20464.432%20557.771%20464.591C558.154%20464.749%20558.552%20464.829%20558.967%20464.829C559.381%20464.829%20559.78%20464.749%20560.163%20464.591C560.546%20464.432%20560.883%20464.206%20561.177%20463.913C561.47%20463.62%20561.695%20463.282%20561.854%20462.899C562.013%20462.517%20562.092%20462.118%20562.092%20461.704C562.092%20461.289%20562.013%20460.891%20561.854%20460.508C561.695%20460.125%20561.47%20459.787%20561.177%20459.494C560.883%20459.201%20560.546%20458.975%20560.163%20458.816C559.78%20458.658%20559.381%20458.579%20558.967%20458.579C558.552%20458.579%20558.154%20458.658%20557.771%20458.816C557.388%20458.975%20557.05%20459.201%20556.757%20459.494C556.464%20459.787%20556.238%20460.125%20556.08%20460.508C555.921%20460.891%20555.842%20461.289%20555.842%20461.704Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M579.494%20468.418C579.494%20468.832%20579.573%20469.231%20579.732%20469.614C579.89%20469.997%20580.116%20470.335%20580.409%20470.628C580.702%20470.921%20581.04%20471.147%20581.423%20471.305C581.806%20471.464%20582.204%20471.543%20582.619%20471.543C583.033%20471.543%20583.432%20471.464%20583.815%20471.305C584.197%20471.147%20584.535%20470.921%20584.828%20470.628C585.121%20470.335%20585.347%20469.997%20585.506%20469.614C585.664%20469.231%20585.744%20468.832%20585.744%20468.418C585.744%20468.004%20585.664%20467.605%20585.506%20467.222C585.347%20466.839%20585.121%20466.501%20584.828%20466.208C584.535%20465.915%20584.197%20465.69%20583.815%20465.531C583.432%20465.372%20583.033%20465.293%20582.619%20465.293C582.204%20465.293%20581.806%20465.372%20581.423%20465.531C581.04%20465.69%20580.702%20465.915%20580.409%20466.208C580.116%20466.501%20579.89%20466.839%20579.732%20467.222C579.573%20467.605%20579.494%20468.004%20579.494%20468.418Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M603.935%20455.689C603.935%20456.103%20604.014%20456.502%20604.172%20456.884C604.331%20457.267%20604.557%20457.605%20604.85%20457.898C605.143%20458.191%20605.481%20458.417%20605.864%20458.576C606.247%20458.734%20606.645%20458.814%20607.06%20458.814C607.474%20458.814%20607.873%20458.734%20608.255%20458.576C608.638%20458.417%20608.976%20458.191%20609.269%20457.898C609.562%20457.605%20609.788%20457.267%20609.947%20456.884C610.105%20456.502%20610.185%20456.103%20610.185%20455.689C610.185%20455.274%20610.105%20454.876%20609.947%20454.493C609.788%20454.11%20609.562%20453.772%20609.269%20453.479C608.976%20453.186%20608.638%20452.96%20608.255%20452.801C607.873%20452.643%20607.474%20452.564%20607.06%20452.564C606.645%20452.564%20606.247%20452.643%20605.864%20452.801C605.481%20452.96%20605.143%20453.186%20604.85%20453.479C604.557%20453.772%20604.331%20454.11%20604.172%20454.493C604.014%20454.876%20603.935%20455.274%20603.935%20455.689Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M628.375%20456.89C628.375%20457.304%20628.454%20457.703%20628.613%20458.086C628.771%20458.468%20628.997%20458.806%20629.29%20459.099C629.583%20459.392%20629.921%20459.618%20630.304%20459.777C630.687%20459.935%20631.086%20460.015%20631.5%20460.015C631.914%20460.015%20632.313%20459.935%20632.696%20459.777C633.079%20459.618%20633.417%20459.392%20633.71%20459.099C634.003%20458.806%20634.229%20458.468%20634.387%20458.086C634.546%20457.703%20634.625%20457.304%20634.625%20456.89C634.625%20456.475%20634.546%20456.077%20634.387%20455.694C634.229%20455.311%20634.003%20454.973%20633.71%20454.68C633.417%20454.387%20633.079%20454.161%20632.696%20454.003C632.313%20453.844%20631.914%20453.765%20631.5%20453.765C631.086%20453.765%20630.687%20453.844%20630.304%20454.003C629.921%20454.161%20629.583%20454.387%20629.29%20454.68C628.997%20454.973%20628.771%20455.311%20628.613%20455.694C628.454%20456.077%20628.375%20456.475%20628.375%20456.89Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M74.125%20468.12C74.125%20468.534%2074.2043%20468.933%2074.3629%20469.316C74.5215%20469.699%2074.7473%20470.037%2075.0403%20470.33C75.3333%20470.623%2075.6713%20470.849%2076.0541%20471.007C76.437%20471.166%2076.8356%20471.245%2077.25%20471.245C77.6644%20471.245%2078.063%20471.166%2078.4459%20471.007C78.8287%20470.849%2079.1667%20470.623%2079.4597%20470.33C79.7527%20470.037%2079.9785%20469.699%2080.1371%20469.316C80.2957%20468.933%2080.375%20468.534%2080.375%20468.12C80.375%20467.706%2080.2957%20467.307%2080.1371%20466.924C79.9785%20466.541%2079.7527%20466.203%2079.4597%20465.91C79.1667%20465.617%2078.8287%20465.391%2078.4459%20465.233C78.063%20465.074%2077.6644%20464.995%2077.25%20464.995C76.8356%20464.995%2076.437%20465.074%2076.0541%20465.233C75.6713%20465.391%2075.3333%20465.617%2075.0403%20465.91C74.7473%20466.203%2074.5215%20466.541%2074.3629%20466.924C74.2043%20467.307%2074.125%20467.706%2074.125%20468.12Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M98.5659%20478.31C98.5659%20478.725%2098.6452%20479.123%2098.8038%20479.506C98.9624%20479.889%2099.1882%20480.227%2099.4812%20480.52C99.7742%20480.813%20100.112%20481.039%20100.495%20481.197C100.878%20481.356%20101.277%20481.435%20101.691%20481.435C102.105%20481.435%20102.504%20481.356%20102.887%20481.197C103.27%20481.039%20103.608%20480.813%20103.901%20480.52C104.194%20480.227%20104.419%20479.889%20104.578%20479.506C104.737%20479.123%20104.816%20478.725%20104.816%20478.31C104.816%20477.896%20104.737%20477.497%20104.578%20477.114C104.419%20476.732%20104.194%20476.394%20103.901%20476.101C103.608%20475.808%20103.27%20475.582%20102.887%20475.423C102.504%20475.265%20102.105%20475.185%20101.691%20475.185C101.277%20475.185%20100.878%20475.265%20100.495%20475.423C100.112%20475.582%2099.7742%20475.808%2099.4812%20476.101C99.1882%20476.394%2098.9624%20476.732%2098.8038%20477.114C98.6452%20477.497%2098.5659%20477.896%2098.5659%20478.31Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M122.218%20472.763C122.218%20473.178%20122.297%20473.576%20122.456%20473.959C122.614%20474.342%20122.84%20474.68%20123.133%20474.973C123.426%20475.266%20123.764%20475.492%20124.147%20475.65C124.53%20475.809%20124.928%20475.888%20125.343%20475.888C125.757%20475.888%20126.156%20475.809%20126.539%20475.65C126.922%20475.492%20127.259%20475.266%20127.552%20474.973C127.846%20474.68%20128.071%20474.342%20128.23%20473.959C128.388%20473.576%20128.468%20473.178%20128.468%20472.763C128.468%20472.349%20128.388%20471.95%20128.23%20471.567C128.071%20471.184%20127.846%20470.847%20127.552%20470.553C127.259%20470.26%20126.922%20470.035%20126.539%20469.876C126.156%20469.717%20125.757%20469.638%20125.343%20469.638C124.928%20469.638%20124.53%20469.717%20124.147%20469.876C123.764%20470.035%20123.426%20470.26%20123.133%20470.553C122.84%20470.847%20122.614%20471.184%20122.456%20471.567C122.297%20471.95%20122.218%20472.349%20122.218%20472.763Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M146.658%20476.593C146.658%20477.008%20146.737%20477.406%20146.896%20477.789C147.055%20478.172%20147.28%20478.51%20147.573%20478.803C147.867%20479.096%20148.204%20479.322%20148.587%20479.48C148.97%20479.639%20149.369%20479.718%20149.783%20479.718C150.198%20479.718%20150.596%20479.639%20150.979%20479.48C151.362%20479.322%20151.7%20479.096%20151.993%20478.803C152.286%20478.51%20152.512%20478.172%20152.67%20477.789C152.829%20477.406%20152.908%20477.008%20152.908%20476.593C152.908%20476.179%20152.829%20475.78%20152.67%20475.397C152.512%20475.014%20152.286%20474.676%20151.993%20474.383C151.7%20474.09%20151.362%20473.865%20150.979%20473.706C150.596%20473.547%20150.198%20473.468%20149.783%20473.468C149.369%20473.468%20148.97%20473.547%20148.587%20473.706C148.204%20473.865%20147.867%20474.09%20147.573%20474.383C147.28%20474.676%20147.055%20475.014%20146.896%20475.397C146.737%20475.78%20146.658%20476.179%20146.658%20476.593Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M170.311%20472.31C170.311%20472.724%20170.39%20473.123%20170.548%20473.506C170.707%20473.889%20170.933%20474.227%20171.226%20474.52C171.519%20474.813%20171.857%20475.039%20172.24%20475.197C172.623%20475.356%20173.021%20475.435%20173.436%20475.435C173.85%20475.435%20174.249%20475.356%20174.631%20475.197C175.014%20475.039%20175.352%20474.813%20175.645%20474.52C175.938%20474.227%20176.164%20473.889%20176.323%20473.506C176.481%20473.123%20176.561%20472.724%20176.561%20472.31C176.561%20471.896%20176.481%20471.497%20176.323%20471.114C176.164%20470.731%20175.938%20470.393%20175.645%20470.1C175.352%20469.807%20175.014%20469.582%20174.631%20469.423C174.249%20469.264%20173.85%20469.185%20173.436%20469.185C173.021%20469.185%20172.623%20469.264%20172.24%20469.423C171.857%20469.582%20171.519%20469.807%20171.226%20470.1C170.933%20470.393%20170.707%20470.731%20170.548%20471.114C170.39%20471.497%20170.311%20471.896%20170.311%20472.31Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M194.751%20468.506C194.751%20468.92%20194.83%20469.319%20194.989%20469.702C195.147%20470.084%20195.373%20470.422%20195.666%20470.715C195.959%20471.008%20196.297%20471.234%20196.68%20471.393C197.063%20471.551%20197.462%20471.631%20197.876%20471.631C198.29%20471.631%20198.689%20471.551%20199.072%20471.393C199.455%20471.234%20199.793%20471.008%20200.086%20470.715C200.379%20470.422%20200.605%20470.084%20200.763%20469.702C200.922%20469.319%20201.001%20468.92%20201.001%20468.506C201.001%20468.091%20200.922%20467.693%20200.763%20467.31C200.605%20466.927%20200.379%20466.589%20200.086%20466.296C199.793%20466.003%20199.455%20465.777%20199.072%20465.619C198.689%20465.46%20198.29%20465.381%20197.876%20465.381C197.462%20465.381%20197.063%20465.46%20196.68%20465.619C196.297%20465.777%20195.959%20466.003%20195.666%20466.296C195.373%20466.589%20195.147%20466.927%20194.989%20467.31C194.83%20467.693%20194.751%20468.091%20194.751%20468.506Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M219.191%20464.056C219.191%20464.47%20219.271%20464.869%20219.429%20465.252C219.588%20465.635%20219.814%20465.973%20220.107%20466.266C220.4%20466.559%20220.738%20466.785%20221.121%20466.943C221.503%20467.102%20221.902%20467.181%20222.316%20467.181C222.731%20467.181%20223.129%20467.102%20223.512%20466.943C223.895%20466.785%20224.233%20466.559%20224.526%20466.266C224.819%20465.973%20225.045%20465.635%20225.204%20465.252C225.362%20464.869%20225.441%20464.47%20225.441%20464.056C225.441%20463.642%20225.362%20463.243%20225.204%20462.86C225.045%20462.477%20224.819%20462.139%20224.526%20461.846C224.233%20461.553%20223.895%20461.327%20223.512%20461.169C223.129%20461.01%20222.731%20460.931%20222.316%20460.931C221.902%20460.931%20221.503%20461.01%20221.121%20461.169C220.738%20461.327%20220.4%20461.553%20220.107%20461.846C219.814%20462.139%20219.588%20462.477%20219.429%20462.86C219.271%20463.243%20219.191%20463.642%20219.191%20464.056Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M242.844%20459.615C242.844%20460.03%20242.924%20460.429%20243.082%20460.811C243.241%20461.194%20243.467%20461.532%20243.76%20461.825C244.053%20462.118%20244.39%20462.344%20244.773%20462.503C245.156%20462.661%20245.555%20462.74%20245.969%20462.74C246.384%20462.74%20246.782%20462.661%20247.165%20462.503C247.548%20462.344%20247.886%20462.118%20248.179%20461.825C248.472%20461.532%20248.698%20461.194%20248.856%20460.811C249.015%20460.429%20249.094%20460.03%20249.094%20459.615C249.094%20459.201%20249.015%20458.802%20248.856%20458.42C248.698%20458.037%20248.472%20457.699%20248.179%20457.406C247.886%20457.113%20247.548%20456.887%20247.165%20456.728C246.782%20456.57%20246.384%20456.49%20245.969%20456.49C245.555%20456.49%20245.156%20456.57%20244.773%20456.728C244.39%20456.887%20244.053%20457.113%20243.76%20457.406C243.467%20457.699%20243.241%20458.037%20243.082%20458.42C242.924%20458.802%20242.844%20459.201%20242.844%20459.615Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M267.285%20461.466C267.285%20461.881%20267.364%20462.279%20267.523%20462.662C267.681%20463.045%20267.907%20463.383%20268.2%20463.676C268.493%20463.969%20268.831%20464.195%20269.214%20464.353C269.597%20464.512%20269.995%20464.591%20270.41%20464.591C270.824%20464.591%20271.223%20464.512%20271.606%20464.353C271.988%20464.195%20272.326%20463.969%20272.619%20463.676C272.912%20463.383%20273.138%20463.045%20273.297%20462.662C273.455%20462.279%20273.535%20461.881%20273.535%20461.466C273.535%20461.052%20273.455%20460.653%20273.297%20460.27C273.138%20459.888%20272.912%20459.55%20272.619%20459.257C272.326%20458.964%20271.988%20458.738%20271.606%20458.579C271.223%20458.421%20270.824%20458.341%20270.41%20458.341C269.995%20458.341%20269.597%20458.421%20269.214%20458.579C268.831%20458.738%20268.493%20458.964%20268.2%20459.257C267.907%20459.55%20267.681%20459.888%20267.523%20460.27C267.364%20460.653%20267.285%20461.052%20267.285%20461.466Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M290.937%20456.955C290.937%20457.369%20291.016%20457.768%20291.175%20458.151C291.333%20458.534%20291.559%20458.872%20291.852%20459.165C292.145%20459.458%20292.483%20459.683%20292.866%20459.842C293.249%20460.001%20293.648%20460.08%20294.062%20460.08C294.476%20460.08%20294.875%20460.001%20295.258%20459.842C295.641%20459.683%20295.979%20459.458%20296.272%20459.165C296.565%20458.872%20296.791%20458.534%20296.949%20458.151C297.108%20457.768%20297.187%20457.369%20297.187%20456.955C297.187%20456.54%20297.108%20456.142%20296.949%20455.759C296.791%20455.376%20296.565%20455.038%20296.272%20454.745C295.979%20454.452%20295.641%20454.226%20295.258%20454.068C294.875%20453.909%20294.476%20453.83%20294.062%20453.83C293.648%20453.83%20293.249%20453.909%20292.866%20454.068C292.483%20454.226%20292.145%20454.452%20291.852%20454.745C291.559%20455.038%20291.333%20455.376%20291.175%20455.759C291.016%20456.142%20290.937%20456.54%20290.937%20456.955Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M315.377%20441.524C315.377%20441.939%20315.457%20442.337%20315.615%20442.72C315.774%20443.103%20316%20443.441%20316.293%20443.734C316.586%20444.027%20316.924%20444.253%20317.307%20444.412C317.689%20444.57%20318.088%20444.649%20318.502%20444.649C318.917%20444.649%20319.315%20444.57%20319.698%20444.412C320.081%20444.253%20320.419%20444.027%20320.712%20443.734C321.005%20443.441%20321.231%20443.103%20321.39%20442.72C321.548%20442.337%20321.627%20441.939%20321.627%20441.524C321.627%20441.11%20321.548%20440.711%20321.39%20440.329C321.231%20439.946%20321.005%20439.608%20320.712%20439.315C320.419%20439.022%20320.081%20438.796%20319.698%20438.637C319.315%20438.479%20318.917%20438.399%20318.502%20438.399C318.088%20438.399%20317.689%20438.479%20317.307%20438.637C316.924%20438.796%20316.586%20439.022%20316.293%20439.315C316%20439.608%20315.774%20439.946%20315.615%20440.329C315.457%20440.711%20315.377%20441.11%20315.377%20441.524Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M339.818%20441.749C339.818%20442.164%20339.897%20442.562%20340.056%20442.945C340.214%20443.328%20340.44%20443.666%20340.733%20443.959C341.026%20444.252%20341.364%20444.478%20341.747%20444.637C342.13%20444.795%20342.528%20444.874%20342.943%20444.874C343.357%20444.874%20343.756%20444.795%20344.139%20444.637C344.522%20444.478%20344.86%20444.252%20345.153%20443.959C345.446%20443.666%20345.671%20443.328%20345.83%20442.945C345.989%20442.562%20346.068%20442.164%20346.068%20441.749C346.068%20441.335%20345.989%20440.936%20345.83%20440.554C345.671%20440.171%20345.446%20439.833%20345.153%20439.54C344.86%20439.247%20344.522%20439.021%20344.139%20438.862C343.756%20438.704%20343.357%20438.624%20342.943%20438.624C342.528%20438.624%20342.13%20438.704%20341.747%20438.862C341.364%20439.021%20341.026%20439.247%20340.733%20439.54C340.44%20439.833%20340.214%20440.171%20340.056%20440.554C339.897%20440.936%20339.818%20441.335%20339.818%20441.749Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M362.682%20452.596C362.682%20453.011%20362.761%20453.409%20362.92%20453.792C363.078%20454.175%20363.304%20454.513%20363.597%20454.806C363.89%20455.099%20364.228%20455.325%20364.611%20455.483C364.994%20455.642%20365.392%20455.721%20365.807%20455.721C366.221%20455.721%20366.62%20455.642%20367.003%20455.483C367.385%20455.325%20367.723%20455.099%20368.016%20454.806C368.309%20454.513%20368.535%20454.175%20368.694%20453.792C368.852%20453.409%20368.932%20453.011%20368.932%20452.596C368.932%20452.182%20368.852%20451.783%20368.694%20451.4C368.535%20451.018%20368.309%20450.68%20368.016%20450.387C367.723%20450.094%20367.385%20449.868%20367.003%20449.709C366.62%20449.551%20366.221%20449.471%20365.807%20449.471C365.392%20449.471%20364.994%20449.551%20364.611%20449.709C364.228%20449.868%20363.89%20450.094%20363.597%20450.387C363.304%20450.68%20363.078%20451.018%20362.92%20451.4C362.761%20451.783%20362.682%20452.182%20362.682%20452.596Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M387.123%20455.511C387.123%20455.925%20387.202%20456.324%20387.36%20456.707C387.519%20457.09%20387.745%20457.428%20388.038%20457.721C388.331%20458.014%20388.669%20458.24%20389.052%20458.398C389.435%20458.557%20389.833%20458.636%20390.248%20458.636C390.662%20458.636%20391.061%20458.557%20391.443%20458.398C391.826%20458.24%20392.164%20458.014%20392.457%20457.721C392.75%20457.428%20392.976%20457.09%20393.135%20456.707C393.293%20456.324%20393.373%20455.925%20393.373%20455.511C393.373%20455.097%20393.293%20454.698%20393.135%20454.315C392.976%20453.932%20392.75%20453.594%20392.457%20453.301C392.164%20453.008%20391.826%20452.782%20391.443%20452.624C391.061%20452.465%20390.662%20452.386%20390.248%20452.386C389.833%20452.386%20389.435%20452.465%20389.052%20452.624C388.669%20452.782%20388.331%20453.008%20388.038%20453.301C387.745%20453.594%20387.519%20453.932%20387.36%20454.315C387.202%20454.698%20387.123%20455.097%20387.123%20455.511Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M410.774%20455.747C410.774%20456.161%20410.854%20456.56%20411.012%20456.943C411.171%20457.326%20411.397%20457.664%20411.69%20457.957C411.983%20458.25%20412.321%20458.476%20412.704%20458.634C413.086%20458.793%20413.485%20458.872%20413.899%20458.872C414.314%20458.872%20414.712%20458.793%20415.095%20458.634C415.478%20458.476%20415.816%20458.25%20416.109%20457.957C416.402%20457.664%20416.628%20457.326%20416.787%20456.943C416.945%20456.56%20417.024%20456.161%20417.024%20455.747C417.024%20455.333%20416.945%20454.934%20416.787%20454.551C416.628%20454.168%20416.402%20453.83%20416.109%20453.537C415.816%20453.244%20415.478%20453.019%20415.095%20452.86C414.712%20452.701%20414.314%20452.622%20413.899%20452.622C413.485%20452.622%20413.086%20452.701%20412.704%20452.86C412.321%20453.019%20411.983%20453.244%20411.69%20453.537C411.397%20453.83%20411.171%20454.168%20411.012%20454.551C410.854%20454.934%20410.774%20455.333%20410.774%20455.747Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M435.215%20462.096C435.215%20462.51%20435.295%20462.909%20435.453%20463.292C435.612%20463.675%20435.838%20464.013%20436.131%20464.306C436.424%20464.599%20436.762%20464.825%20437.144%20464.983C437.527%20465.142%20437.926%20465.221%20438.34%20465.221C438.755%20465.221%20439.153%20465.142%20439.536%20464.983C439.919%20464.825%20440.257%20464.599%20440.55%20464.306C440.843%20464.013%20441.069%20463.675%20441.227%20463.292C441.386%20462.909%20441.465%20462.51%20441.465%20462.096C441.465%20461.682%20441.386%20461.283%20441.227%20460.9C441.069%20460.517%20440.843%20460.179%20440.55%20459.886C440.257%20459.593%20439.919%20459.368%20439.536%20459.209C439.153%20459.05%20438.755%20458.971%20438.34%20458.971C437.926%20458.971%20437.527%20459.05%20437.144%20459.209C436.762%20459.368%20436.424%20459.593%20436.131%20459.886C435.838%20460.179%20435.612%20460.517%20435.453%20460.9C435.295%20461.283%20435.215%20461.682%20435.215%20462.096Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M458.868%20457.427C458.868%20457.842%20458.947%20458.24%20459.106%20458.623C459.264%20459.006%20459.49%20459.344%20459.783%20459.637C460.076%20459.93%20460.414%20460.156%20460.797%20460.314C461.18%20460.473%20461.578%20460.552%20461.993%20460.552C462.407%20460.552%20462.806%20460.473%20463.189%20460.314C463.571%20460.156%20463.909%20459.93%20464.202%20459.637C464.495%20459.344%20464.721%20459.006%20464.88%20458.623C465.038%20458.24%20465.118%20457.842%20465.118%20457.427C465.118%20457.013%20465.038%20456.614%20464.88%20456.231C464.721%20455.849%20464.495%20455.511%20464.202%20455.218C463.909%20454.925%20463.571%20454.699%20463.189%20454.54C462.806%20454.382%20462.407%20454.302%20461.993%20454.302C461.578%20454.302%20461.18%20454.382%20460.797%20454.54C460.414%20454.699%20460.076%20454.925%20459.783%20455.218C459.49%20455.511%20459.264%20455.849%20459.106%20456.231C458.947%20456.614%20458.868%20457.013%20458.868%20457.427Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M483.308%20450.833C483.308%20451.248%20483.387%20451.646%20483.546%20452.029C483.705%20452.412%20483.93%20452.75%20484.223%20453.043C484.516%20453.336%20484.854%20453.562%20485.237%20453.72C485.62%20453.879%20486.019%20453.958%20486.433%20453.958C486.848%20453.958%20487.246%20453.879%20487.629%20453.72C488.012%20453.562%20488.35%20453.336%20488.643%20453.043C488.936%20452.75%20489.162%20452.412%20489.32%20452.029C489.479%20451.646%20489.558%20451.248%20489.558%20450.833C489.558%20450.419%20489.479%20450.02%20489.32%20449.637C489.162%20449.254%20488.936%20448.916%20488.643%20448.623C488.35%20448.33%20488.012%20448.105%20487.629%20447.946C487.246%20447.787%20486.848%20447.708%20486.433%20447.708C486.019%20447.708%20485.62%20447.787%20485.237%20447.946C484.854%20448.105%20484.516%20448.33%20484.223%20448.623C483.93%20448.916%20483.705%20449.254%20483.546%20449.637C483.387%20450.02%20483.308%20450.419%20483.308%20450.833Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M507.749%20451.024C507.749%20451.439%20507.828%20451.837%20507.986%20452.22C508.145%20452.603%20508.371%20452.941%20508.664%20453.234C508.957%20453.527%20509.295%20453.753%20509.678%20453.911C510.061%20454.07%20510.459%20454.149%20510.874%20454.149C511.288%20454.149%20511.687%20454.07%20512.069%20453.911C512.452%20453.753%20512.79%20453.527%20513.083%20453.234C513.376%20452.941%20513.602%20452.603%20513.761%20452.22C513.919%20451.837%20513.999%20451.439%20513.999%20451.024C513.999%20450.61%20513.919%20450.211%20513.761%20449.828C513.602%20449.446%20513.376%20449.108%20513.083%20448.815C512.79%20448.522%20512.452%20448.296%20512.069%20448.137C511.687%20447.979%20511.288%20447.899%20510.874%20447.899C510.459%20447.899%20510.061%20447.979%20509.678%20448.137C509.295%20448.296%20508.957%20448.522%20508.664%20448.815C508.371%20449.108%20508.145%20449.446%20507.986%20449.828C507.828%20450.211%20507.749%20450.61%20507.749%20451.024Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M531.401%20446.161C531.401%20446.575%20531.48%20446.974%20531.639%20447.357C531.797%20447.74%20532.023%20448.077%20532.316%20448.37C532.609%20448.664%20532.947%20448.889%20533.33%20449.048C533.713%20449.206%20534.111%20449.286%20534.526%20449.286C534.94%20449.286%20535.339%20449.206%20535.722%20449.048C536.105%20448.889%20536.443%20448.664%20536.736%20448.37C537.029%20448.077%20537.254%20447.74%20537.413%20447.357C537.572%20446.974%20537.651%20446.575%20537.651%20446.161C537.651%20445.746%20537.572%20445.348%20537.413%20444.965C537.254%20444.582%20537.029%20444.244%20536.736%20443.951C536.443%20443.658%20536.105%20443.432%20535.722%20443.274C535.339%20443.115%20534.94%20443.036%20534.526%20443.036C534.111%20443.036%20533.713%20443.115%20533.33%20443.274C532.947%20443.432%20532.609%20443.658%20532.316%20443.951C532.023%20444.244%20531.797%20444.582%20531.639%20444.965C531.48%20445.348%20531.401%20445.746%20531.401%20446.161Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M555.842%20438.849C555.842%20439.264%20555.921%20439.662%20556.08%20440.045C556.238%20440.428%20556.464%20440.766%20556.757%20441.059C557.05%20441.352%20557.388%20441.578%20557.771%20441.736C558.154%20441.895%20558.552%20441.974%20558.967%20441.974C559.381%20441.974%20559.78%20441.895%20560.163%20441.736C560.546%20441.578%20560.883%20441.352%20561.177%20441.059C561.47%20440.766%20561.695%20440.428%20561.854%20440.045C562.013%20439.662%20562.092%20439.264%20562.092%20438.849C562.092%20438.435%20562.013%20438.036%20561.854%20437.653C561.695%20437.271%20561.47%20436.933%20561.177%20436.64C560.883%20436.347%20560.546%20436.121%20560.163%20435.962C559.78%20435.804%20559.381%20435.724%20558.967%20435.724C558.552%20435.724%20558.154%20435.804%20557.771%20435.962C557.388%20436.121%20557.05%20436.347%20556.757%20436.64C556.464%20436.933%20556.238%20437.271%20556.08%20437.653C555.921%20438.036%20555.842%20438.435%20555.842%20438.849Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M579.494%20442.656C579.494%20443.07%20579.573%20443.469%20579.732%20443.852C579.89%20444.234%20580.116%20444.572%20580.409%20444.865C580.702%20445.158%20581.04%20445.384%20581.423%20445.543C581.806%20445.701%20582.204%20445.781%20582.619%20445.781C583.033%20445.781%20583.432%20445.701%20583.815%20445.543C584.197%20445.384%20584.535%20445.158%20584.828%20444.865C585.121%20444.572%20585.347%20444.234%20585.506%20443.852C585.664%20443.469%20585.744%20443.07%20585.744%20442.656C585.744%20442.241%20585.664%20441.843%20585.506%20441.46C585.347%20441.077%20585.121%20440.739%20584.828%20440.446C584.535%20440.153%20584.197%20439.927%20583.815%20439.769C583.432%20439.61%20583.033%20439.531%20582.619%20439.531C582.204%20439.531%20581.806%20439.61%20581.423%20439.769C581.04%20439.927%20580.702%20440.153%20580.409%20440.446C580.116%20440.739%20579.89%20441.077%20579.732%20441.46C579.573%20441.843%20579.494%20442.241%20579.494%20442.656Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M603.935%20426.884C603.935%20427.298%20604.014%20427.697%20604.172%20428.079C604.331%20428.462%20604.557%20428.8%20604.85%20429.093C605.143%20429.386%20605.481%20429.612%20605.864%20429.771C606.247%20429.929%20606.645%20430.009%20607.06%20430.009C607.474%20430.009%20607.873%20429.929%20608.255%20429.771C608.638%20429.612%20608.976%20429.386%20609.269%20429.093C609.562%20428.8%20609.788%20428.462%20609.947%20428.079C610.105%20427.697%20610.185%20427.298%20610.185%20426.884C610.185%20426.469%20610.105%20426.071%20609.947%20425.688C609.788%20425.305%20609.562%20424.967%20609.269%20424.674C608.976%20424.381%20608.638%20424.155%20608.255%20423.996C607.873%20423.838%20607.474%20423.759%20607.06%20423.759C606.645%20423.759%20606.247%20423.838%20605.864%20423.996C605.481%20424.155%20605.143%20424.381%20604.85%20424.674C604.557%20424.967%20604.331%20425.305%20604.172%20425.688C604.014%20426.071%20603.935%20426.469%20603.935%20426.884Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M628.375%20428.716C628.375%20429.131%20628.454%20429.529%20628.613%20429.912C628.771%20430.295%20628.997%20430.633%20629.29%20430.926C629.583%20431.219%20629.921%20431.445%20630.304%20431.604C630.687%20431.762%20631.086%20431.841%20631.5%20431.841C631.914%20431.841%20632.313%20431.762%20632.696%20431.604C633.079%20431.445%20633.417%20431.219%20633.71%20430.926C634.003%20430.633%20634.229%20430.295%20634.387%20429.912C634.546%20429.529%20634.625%20429.131%20634.625%20428.716C634.625%20428.302%20634.546%20427.903%20634.387%20427.521C634.229%20427.138%20634.003%20426.8%20633.71%20426.507C633.417%20426.214%20633.079%20425.988%20632.696%20425.829C632.313%20425.671%20631.914%20425.591%20631.5%20425.591C631.086%20425.591%20630.687%20425.671%20630.304%20425.829C629.921%20425.988%20629.583%20426.214%20629.29%20426.507C628.997%20426.8%20628.771%20427.138%20628.613%20427.521C628.454%20427.903%20628.375%20428.302%20628.375%20428.716Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M41.6499%20395.15C41.6499%20395.647%2041.7451%20396.126%2041.9354%20396.585C42.1257%20397.044%2042.3966%20397.45%2042.7483%20397.802C43.0999%20398.153%2043.5054%20398.424%2043.9648%20398.614C44.4243%20398.805%2044.9026%20398.9%2045.3999%20398.9C45.8972%20398.9%2046.3755%20398.805%2046.835%20398.614C47.2944%20398.424%2047.6999%20398.153%2048.0516%20397.802C48.4032%20397.45%2048.6741%20397.044%2048.8644%20396.585C49.0548%20396.126%2049.1499%20395.647%2049.1499%20395.15C49.1499%20394.653%2049.0548%20394.174%2048.8644%20393.715C48.6741%20393.255%2048.4032%20392.85%2048.0516%20392.498C47.6999%20392.147%2047.2944%20391.876%2046.835%20391.685C46.3755%20391.495%2045.8972%20391.4%2045.3999%20391.4C44.9026%20391.4%2044.4243%20391.495%2043.9648%20391.685C43.5054%20391.876%2043.0999%20392.147%2042.7483%20392.498C42.3966%20392.85%2042.1257%20393.255%2041.9354%20393.715C41.7451%20394.174%2041.6499%20394.653%2041.6499%20395.15Z'%20fill='%230F9ED5'%20/%3e%3cpath%20d='M53.0612%20399.449C52.6809%20399.449%2052.3389%20399.386%2052.0351%20399.26C51.7336%20399.131%2051.4838%20398.953%2051.2858%20398.726C51.0901%20398.497%2050.9393%20398.226%2050.8335%20397.913C50.73%20397.6%2050.6783%20397.257%2050.6783%20396.883C50.6783%20396.379%2050.7739%20395.934%2050.9652%20395.547C51.1564%20395.16%2051.4411%20394.855%2051.8191%20394.632C52.1971%20394.409%2052.6449%20394.298%2053.1625%20394.298C53.7362%20394.298%2054.2403%20394.428%2054.6746%20394.689L54.4518%20395.172C54.0333%20394.931%2053.6057%20394.811%2053.1692%20394.811C52.8654%20394.811%2052.5932%20394.864%2052.3524%20394.97C52.1139%20395.073%2051.9181%20395.218%2051.7651%20395.405C51.6143%20395.589%2051.4985%20395.808%2051.4175%20396.06C51.3387%20396.31%2051.2993%20396.584%2051.2993%20396.883C51.2993%20397.518%2051.4568%20398.02%2051.7719%20398.389C52.0891%20398.755%2052.556%20398.939%2053.1726%20398.939C53.5236%20398.939%2053.8803%20398.868%2054.2425%20398.726V397.302H53.0646L53.0848%20396.792H54.7893V399.074C54.5058%20399.209%2054.2313%20399.306%2053.9658%20399.364C53.7025%20399.42%2053.401%20399.449%2053.0612%20399.449ZM55.2416%20395.672H55.839L57.0069%20398.753L58.0464%20395.672H58.6439C57.6448%20398.421%2057.1284%20399.839%2057.0946%20399.924C56.9394%20400.314%2056.7515%20400.598%2056.531%20400.778C56.3104%20400.961%2056.0202%20401.052%2055.6601%20401.052C55.5521%20401.052%2055.4385%20401.043%2055.3192%20401.025L55.2855%20400.545C55.4115%20400.554%2055.506%20400.559%2055.569%20400.559C55.8233%20400.559%2056.0157%20400.512%2056.1462%20400.417C56.2789%20400.325%2056.3971%20400.151%2056.5006%20399.894C56.5928%20399.658%2056.6615%20399.476%2056.7065%20399.347L55.2416%20395.672ZM63.8654%20399.374V397.447C63.8654%20397.267%2063.8609%20397.116%2063.8519%20396.995C63.8451%20396.873%2063.8271%20396.749%2063.7979%20396.623C63.7708%20396.497%2063.7315%20396.398%2063.6797%20396.326C63.6302%20396.252%2063.5605%20396.193%2063.4705%20396.148C63.3804%20396.1%2063.2724%20396.077%2063.1464%20396.077C62.8989%20396.077%2062.6874%20396.143%2062.5119%20396.276C62.3386%20396.409%2062.2149%20396.595%2062.1406%20396.836C62.1204%20396.998%2062.1102%20397.171%2062.1102%20397.356V399.374H61.5466V397.386C61.5466%20397.22%2061.5409%20397.076%2061.5297%20396.954C61.5184%20396.83%2061.4971%20396.711%2061.4656%20396.596C61.4341%20396.479%2061.3913%20396.385%2061.3373%20396.313C61.2855%20396.241%2061.2158%20396.184%2061.128%20396.141C61.0403%20396.098%2060.9356%20396.077%2060.8141%20396.077C60.5441%20396.077%2060.3168%20396.145%2060.1323%20396.283C59.9501%20396.42%2059.8274%20396.602%2059.7644%20396.829C59.7442%20397.003%2059.7341%20397.19%2059.7341%20397.393V399.374H59.1704C59.1659%20397.059%2059.1636%20395.825%2059.1636%20395.672H59.6362L59.7071%20396.202C59.8196%20396.031%2059.9793%20395.887%2060.1863%20395.77C60.3934%20395.652%2060.6285%20395.594%2060.8918%20395.594C61.029%20395.594%2061.155%20395.609%2061.2698%20395.638C61.3868%20395.665%2061.4836%20395.7%2061.5601%20395.743C61.6388%20395.785%2061.7086%20395.837%2061.7693%20395.898C61.8301%20395.956%2061.8773%20396.015%2061.9111%20396.073C61.9448%20396.13%2061.973%20396.189%2061.9955%20396.252C62.2655%20395.813%2062.6784%20395.594%2063.2342%20395.594C63.646%20395.594%2063.9475%20395.712%2064.1388%20395.948C64.3323%20396.182%2064.429%20396.53%2064.429%20396.991V399.374H63.8654Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M68.6499%20395.15C68.6499%20395.647%2068.7451%20396.126%2068.9354%20396.585C69.1257%20397.044%2069.3966%20397.45%2069.7483%20397.802C70.0999%20398.153%2070.5054%20398.424%2070.9648%20398.614C71.4243%20398.805%2071.9026%20398.9%2072.3999%20398.9C72.8972%20398.9%2073.3755%20398.805%2073.835%20398.614C74.2944%20398.424%2074.6999%20398.153%2075.0516%20397.802C75.4032%20397.45%2075.6741%20397.044%2075.8644%20396.585C76.0548%20396.126%2076.1499%20395.647%2076.1499%20395.15C76.1499%20394.653%2076.0548%20394.174%2075.8644%20393.715C75.6741%20393.255%2075.4032%20392.85%2075.0516%20392.498C74.6999%20392.147%2074.2944%20391.876%2073.835%20391.685C73.3755%20391.495%2072.8972%20391.4%2072.3999%20391.4C71.9026%20391.4%2071.4243%20391.495%2070.9648%20391.685C70.5054%20391.876%2070.0999%20392.147%2069.7483%20392.498C69.3966%20392.85%2069.1257%20393.255%2068.9354%20393.715C68.7451%20394.174%2068.6499%20394.653%2068.6499%20395.15Z'%20fill='%230FD78A'%20/%3e%3cpath%20d='M78.219%20399.374H77.611V394.235H79.2669C79.5188%20394.235%2079.7467%20394.261%2079.9505%20394.314C80.1544%20394.366%2080.3353%20394.447%2080.4934%20394.554C80.6514%20394.662%2080.7739%20394.806%2080.861%20394.987C80.948%20395.168%2080.9915%20395.379%2080.9915%20395.619C80.9915%20395.819%2080.9732%20395.997%2080.9365%20396.155C80.8999%20396.311%2080.8369%20396.458%2080.7476%20396.595C80.6583%20396.732%2080.5415%20396.847%2080.3972%20396.938C80.2529%20397.028%2080.0674%20397.099%2079.8406%20397.151C79.6162%20397.202%2079.3551%20397.227%2079.0573%20397.227C78.8214%20397.227%2078.542%20397.212%2078.219%20397.182V399.374ZM79.1157%20396.701C79.3402%20396.701%2079.5326%20396.68%2079.6929%20396.636C79.8532%20396.593%2079.9757%20396.539%2080.0605%20396.475C80.1475%20396.411%2080.2151%20396.327%2080.2632%20396.224C80.3136%20396.121%2080.3445%20396.027%2080.3559%20395.942C80.3674%20395.855%2080.3731%20395.751%2080.3731%20395.63C80.3731%20395.339%2080.2746%20395.125%2080.0777%20394.987C79.883%20394.85%2079.6173%20394.781%2079.2806%20394.781H78.219V396.695C78.6611%20396.699%2078.96%20396.701%2079.1157%20396.701ZM81.9706%20397.498C81.9706%20397.945%2082.0691%20398.304%2082.2661%20398.574C82.4653%20398.842%2082.7551%20398.976%2083.1353%20398.976C83.5109%20398.976%2083.7937%20398.842%2083.9838%20398.574C84.1762%20398.306%2084.2724%20397.945%2084.2724%20397.492C84.2724%20397.031%2084.1774%20396.669%2083.9873%20396.406C83.7995%20396.14%2083.512%20396.007%2083.125%20396.007C82.7493%20396.007%2082.4631%20396.143%2082.2661%20396.413C82.0691%20396.683%2081.9706%20397.045%2081.9706%20397.498ZM84.8668%20397.488C84.8668%20398.072%2084.711%20398.546%2084.3995%20398.91C84.0881%20399.272%2083.6575%20399.453%2083.1078%20399.453C82.5787%20399.453%2082.1573%20399.27%2081.8435%20398.904C81.532%20398.537%2081.3763%20398.066%2081.3763%20397.492C81.3763%20396.905%2081.5332%20396.431%2081.847%20396.069C82.1607%20395.707%2082.5913%20395.526%2083.1387%20395.526C83.6769%20395.526%2084.0995%20395.709%2084.4064%20396.073C84.7133%20396.435%2084.8668%20396.906%2084.8668%20397.488ZM86.1001%20397.498C86.1001%20397.945%2086.1986%20398.304%2086.3956%20398.574C86.5948%20398.842%2086.8846%20398.976%2087.2648%20398.976C87.6404%20398.976%2087.9232%20398.842%2088.1133%20398.574C88.3057%20398.306%2088.4019%20397.945%2088.4019%20397.492C88.4019%20397.031%2088.3069%20396.669%2088.1168%20396.406C87.929%20396.14%2087.6415%20396.007%2087.2545%20396.007C86.8788%20396.007%2086.5925%20396.143%2086.3956%20396.413C86.1986%20396.683%2086.1001%20397.045%2086.1001%20397.498ZM88.9963%20397.488C88.9963%20398.072%2088.8405%20398.546%2088.529%20398.91C88.2175%20399.272%2087.787%20399.453%2087.2373%20399.453C86.7082%20399.453%2086.2868%20399.27%2085.973%20398.904C85.6615%20398.537%2085.5058%20398.066%2085.5058%20397.492C85.5058%20396.905%2085.6627%20396.431%2085.9764%20396.069C86.2902%20395.707%2086.7208%20395.526%2087.2682%20395.526C87.8064%20395.526%2088.229%20395.709%2088.5359%20396.073C88.8428%20396.435%2088.9963%20396.906%2088.9963%20397.488ZM90.824%20399.443C90.4575%20399.443%2090.1975%20399.344%2090.0441%20399.148C89.8929%20398.951%2089.8174%20398.608%2089.8174%20398.12V394.142L90.3876%20394.108V397.894C90.3876%20398.049%2090.3888%20398.174%2090.3911%20398.268C90.3957%20398.362%2090.4048%20398.455%2090.4186%20398.546C90.4323%20398.636%2090.4506%20398.703%2090.4735%20398.749C90.4964%20398.795%2090.5296%20398.837%2090.5732%20398.876C90.6167%20398.913%2090.6682%20398.938%2090.7278%20398.952C90.7896%20398.963%2090.8652%20398.969%2090.9545%20398.969C91.0278%20398.969%2091.1721%20398.955%2091.3874%20398.928L91.4183%20399.385C91.1824%20399.424%2090.9843%20399.443%2090.824%20399.443Z'%20fill='%23B5B7BA'%20/%3e%3cg%20filter='url(%23filter6_f_12_1053)'%3e%3cpath%20d='M693.31%20416.315L693.295%20414.918C692.058%20414.904%20690.938%20414.608%20689.934%20414.031L690.414%20412.467C691.374%20412.995%20692.34%20413.274%20693.31%20413.303V410.146C692.728%20409.976%20692.335%20409.85%20692.131%20409.767C690.7%20409.263%20689.985%20408.322%20689.985%20406.945C689.985%20406.047%20690.286%20405.339%20690.887%20404.82C691.488%20404.301%20692.296%20404.008%20693.31%20403.94V402.819H694.023V403.925C695.187%20403.959%20696.203%20404.224%20697.071%20404.718L696.474%20406.159C695.601%20405.766%20694.784%20405.555%20694.023%20405.526V408.385C694.061%20408.4%20694.12%20408.419%20694.197%20408.443C694.275%20408.468%20694.36%20408.494%20694.452%20408.523C694.549%20408.552%20694.614%20408.572%20694.648%20408.582C695.623%20408.902%20696.319%20409.299%20696.736%20409.775C697.158%20410.25%20697.369%20410.912%20697.369%20411.761C697.369%20412.678%20697.071%20413.405%20696.474%20413.944C695.878%20414.482%20695.061%20414.797%20694.023%20414.889V416.315H693.31ZM693.31%20408.145V405.555C692.897%20405.608%20692.585%20405.739%20692.371%20405.948C692.158%20406.156%20692.041%20406.46%20692.022%20406.857C692.022%20407.449%20692.315%20407.835%20692.902%20408.014C692.97%20408.038%20693.106%20408.082%20693.31%20408.145ZM694.023%20413.26C694.92%20413.114%20695.369%20412.61%20695.369%20411.746C695.369%20411.126%20694.993%20410.689%20694.241%20410.437C694.226%20410.427%20694.188%20410.415%20694.125%20410.4C694.066%20410.381%20694.032%20410.369%20694.023%20410.364V413.26ZM701.465%20414.926C700.84%20414.926%20700.25%20414.846%20699.697%20414.686C699.149%20414.521%20698.715%20414.3%20698.395%20414.024L698.919%20412.649C699.186%20412.872%20699.554%20413.056%20700.025%20413.201C700.495%20413.342%20700.978%20413.412%20701.473%20413.412C702.03%20413.412%20702.479%20413.262%20702.819%20412.961C703.163%20412.661%20703.335%20412.268%20703.335%20411.783C703.335%20411.482%20703.287%20411.223%20703.19%20411.004C703.097%20410.786%20702.974%20410.611%20702.819%20410.48C702.663%20410.35%20702.455%20410.245%20702.193%20410.168C701.936%20410.085%20701.672%20410.029%20701.4%20410C701.128%20409.971%20700.801%20409.954%20700.418%20409.949C700.403%20409.949%20700.333%20409.949%20700.207%20409.949C700.081%20409.945%20700.01%20409.942%20699.996%20409.942V408.472H700.403C700.825%20408.472%20701.186%20408.451%20701.487%20408.407C701.793%20408.363%20702.074%20408.288%20702.331%20408.181C702.593%20408.075%20702.79%20407.917%20702.92%20407.709C703.056%20407.5%20703.124%20407.243%20703.124%20406.937C703.124%20406.525%20702.969%20406.173%20702.659%20405.882C702.348%20405.591%20701.912%20405.446%20701.349%20405.446C700.437%20405.446%20699.625%20405.674%20698.912%20406.13L698.388%20404.747C699.271%20404.204%20700.318%20403.933%20701.531%20403.933C702.545%20403.933%20703.372%20404.199%20704.012%20404.733C704.657%20405.266%20704.979%20405.95%20704.979%20406.785C704.979%20407.367%20704.829%20407.864%20704.528%20408.276C704.232%20408.683%20703.801%20408.982%20703.233%20409.171C703.883%20409.297%20704.385%20409.61%20704.739%20410.109C705.098%20410.609%20705.278%20411.198%20705.278%20411.877C705.278%20412.522%20705.106%20413.08%20704.761%20413.551C704.417%20414.016%20703.961%20414.363%20703.393%20414.591C702.826%20414.814%20702.183%20414.926%20701.465%20414.926ZM707.984%20414.766V405.897C707.916%20405.941%20707.601%20406.081%20707.038%20406.319C706.481%20406.552%20706.165%20406.678%20706.093%20406.697V405.242C706.209%20405.189%20706.578%20405.007%20707.198%20404.697C707.819%20404.381%20708.161%20404.202%20708.224%20404.158H709.825V414.766H707.984ZM712.553%20414.904C712.238%20414.904%20711.971%20414.795%20711.753%20414.577C711.535%20414.358%20711.425%20414.099%20711.425%20413.798C711.425%20413.492%20711.532%20413.228%20711.746%20413.005C711.964%20412.782%20712.233%20412.67%20712.553%20412.67C712.863%20412.67%20713.125%20412.782%20713.339%20413.005C713.552%20413.228%20713.659%20413.492%20713.659%20413.798C713.659%20414.099%20713.552%20414.358%20713.339%20414.577C713.125%20414.795%20712.863%20414.904%20712.553%20414.904ZM714.838%20414.773L714.794%20413.201L718.162%20409.389C718.58%20408.943%20718.883%20408.533%20719.072%20408.16C719.266%20407.781%20719.363%20407.384%20719.363%20406.966C719.363%20406.506%20719.212%20406.139%20718.912%20405.868C718.611%20405.591%20718.216%20405.453%20717.726%20405.453C717.275%20405.453%20716.829%20405.538%20716.387%20405.708C715.951%20405.873%20715.592%20406.081%20715.31%20406.333L714.765%20404.893C715.492%20404.253%20716.516%20403.933%20717.835%20403.933C718.883%20403.933%20719.724%20404.197%20720.36%20404.726C721%20405.249%20721.32%20405.992%20721.32%20406.952C721.32%20407.631%20721.138%20408.278%20720.774%20408.894C720.415%20409.51%20719.923%20410.143%20719.297%20410.793L716.896%20413.34H721.196L721.065%20414.773H714.838Z'%20fill='white'%20/%3e%3c/g%3e%3cpath%20d='M683.215%20440.624V435.543H686.128L686.104%20436.069H683.809V437.732H685.991V438.25H683.809V440.099H686.18L686.152%20440.624H683.215ZM689.612%20438.515C689.129%20437.111%20688.862%20436.322%20688.811%20436.148C688.811%20436.148%20688.533%20436.937%20687.977%20438.515H689.612ZM690.399%20440.624L689.804%20439.013H687.777L687.162%20440.624H686.558L688.509%20435.533H689.117L691.01%20440.624H690.399ZM692.134%20436.017V437.735C692.227%20437.735%20692.421%20437.737%20692.714%20437.742C693.01%20437.746%20693.238%20437.749%20693.398%20437.749C693.835%20437.749%20694.14%20437.677%20694.312%20437.532C694.483%20437.386%20694.569%20437.154%20694.569%20436.838C694.569%20436.561%20694.487%20436.355%20694.322%20436.22C694.157%20436.085%20693.881%20436.017%20693.494%20436.017H692.134ZM695.39%20440.624H694.703L694.002%20439.03C693.812%20438.602%20693.691%20438.344%20693.638%20438.257C693.471%20438.269%20693.273%20438.274%20693.044%20438.274L692.134%20438.247V440.624H691.525V435.485H693.15C693.338%20435.485%20693.504%20435.489%20693.649%20435.498C693.793%20435.508%20693.936%20435.525%20694.078%20435.55C694.222%20435.573%20694.347%20435.606%20694.453%20435.65C694.558%20435.691%20694.656%20435.746%20694.748%20435.815C694.84%20435.881%20694.913%20435.961%20694.968%20436.055C695.025%20436.149%20695.07%20436.261%20695.102%20436.392C695.134%20436.52%20695.15%20436.665%20695.15%20436.828C695.15%20437.149%20695.065%20437.425%20694.896%20437.656C694.729%20437.887%20694.49%20438.048%20694.181%20438.137C694.181%20438.142%20694.204%20438.183%20694.25%20438.261C694.296%20438.339%20694.349%20438.435%20694.411%20438.549C694.475%20438.661%20694.525%20438.755%20694.559%20438.831L695.39%20440.624ZM700.235%20440.624H699.561L696.923%20436.625L696.751%20436.388C696.769%20436.869%20696.778%20437.299%20696.778%20437.677V440.624H696.222V435.543H696.885L699.53%20439.542L699.705%20439.779C699.689%20439.049%20699.681%20438.626%20699.681%20438.511V435.543H700.235V440.624ZM702.052%20440.624H701.458V435.543H702.052V440.624ZM707.298%20440.624H706.625L703.986%20436.625L703.814%20436.388C703.833%20436.869%20703.842%20437.299%20703.842%20437.677V440.624H703.285V435.543H703.948L706.594%20439.542L706.769%20439.779C706.753%20439.049%20706.745%20438.626%20706.745%20438.511V435.543H707.298V440.624ZM710.709%20440.7C710.322%20440.7%20709.974%20440.636%20709.665%20440.507C709.358%20440.377%20709.104%20440.196%20708.902%20439.965C708.703%20439.731%20708.55%20439.455%20708.442%20439.137C708.337%20438.818%20708.284%20438.469%20708.284%20438.089C708.284%20437.576%20708.381%20437.122%20708.576%20436.728C708.771%20436.334%20709.06%20436.024%20709.445%20435.797C709.83%20435.571%20710.286%20435.457%20710.812%20435.457C711.397%20435.457%20711.91%20435.59%20712.352%20435.856L712.125%20436.347C711.699%20436.102%20711.264%20435.979%20710.819%20435.979C710.51%20435.979%20710.233%20436.033%20709.988%20436.141C709.745%20436.246%20709.546%20436.394%20709.39%20436.584C709.237%20436.772%20709.119%20436.994%20709.036%20437.251C708.956%20437.505%20708.916%20437.784%20708.916%20438.089C708.916%20438.735%20709.076%20439.245%20709.397%20439.621C709.72%20439.994%20710.195%20440.181%20710.823%20440.181C711.18%20440.181%20711.543%20440.109%20711.912%20439.965V438.515H710.713L710.733%20437.996H712.468V440.319C712.18%20440.456%20711.9%20440.554%20711.63%20440.614C711.362%20440.671%20711.055%20440.7%20710.709%20440.7ZM713.42%20439.786C713.949%20440.047%20714.516%20440.178%20715.121%20440.178C715.865%20440.178%20716.237%20439.839%20716.237%20439.161C716.237%20438.941%20716.178%20438.763%20716.059%20438.628C715.942%20438.491%20715.728%20438.383%20715.416%20438.305L714.406%20438.051C713.634%20437.856%20713.248%20437.444%20713.248%20436.814C713.248%20436.331%20713.414%20435.973%20713.746%20435.739C714.079%20435.503%20714.538%20435.385%20715.124%20435.385C715.431%20435.385%20715.718%20435.418%20715.986%20435.485C716.254%20435.551%20716.479%20435.64%20716.66%20435.753L716.488%20436.237C716.334%20436.152%20716.131%20436.077%20715.876%20436.01C715.624%20435.944%20715.369%20435.911%20715.11%20435.911C714.281%20435.911%20713.867%20436.198%20713.867%20436.773C713.867%20436.968%20713.93%20437.125%20714.056%20437.244C714.184%20437.361%20714.375%20437.45%20714.629%20437.512L715.595%20437.745C716.007%20437.844%20716.32%20438.002%20716.533%20438.219C716.746%20438.435%20716.852%20438.742%20716.852%20439.14C716.852%20439.658%20716.693%20440.048%20716.375%20440.312C716.059%20440.573%20715.628%20440.703%20715.083%20440.703C714.675%20440.703%20714.312%20440.662%20713.994%20440.58C713.678%20440.495%20713.427%20440.395%20713.241%20440.281L713.42%20439.786ZM720.006%20440.624H719.398V435.485H721.054C721.306%20435.485%20721.534%20435.511%20721.737%20435.564C721.941%20435.616%20722.122%20435.697%20722.28%20435.804C722.438%20435.912%20722.561%20436.056%20722.648%20436.237C722.735%20436.418%20722.778%20436.629%20722.778%20436.869C722.778%20437.069%20722.76%20437.247%20722.723%20437.405C722.687%20437.561%20722.624%20437.708%20722.534%20437.845C722.445%20437.982%20722.328%20438.097%20722.184%20438.188C722.04%20438.278%20721.854%20438.349%20721.627%20438.401C721.403%20438.452%20721.142%20438.477%20720.844%20438.477C720.608%20438.477%20720.329%20438.462%20720.006%20438.432V440.624ZM720.903%20437.951C721.127%20437.951%20721.319%20437.93%20721.48%20437.886C721.64%20437.843%20721.763%20437.789%20721.847%20437.725C721.934%20437.661%20722.002%20437.577%20722.05%20437.474C722.1%20437.371%20722.131%20437.277%20722.143%20437.192C722.154%20437.105%20722.16%20437.001%20722.16%20436.88C722.16%20436.589%20722.061%20436.375%20721.865%20436.237C721.67%20436.1%20721.404%20436.031%20721.067%20436.031H720.006V437.945C720.448%20437.949%20720.747%20437.951%20720.903%20437.951ZM723.479%20440.624V435.543H726.393L726.368%20436.069H724.074V437.732H726.255V438.25H724.074V440.099H726.444L726.417%20440.624H723.479ZM727.925%20436.017V437.735C728.019%20437.735%20728.212%20437.737%20728.505%20437.742C728.801%20437.746%20729.029%20437.749%20729.189%20437.749C729.627%20437.749%20729.931%20437.677%20730.103%20437.532C730.275%20437.386%20730.361%20437.154%20730.361%20436.838C730.361%20436.561%20730.278%20436.355%20730.113%20436.22C729.948%20436.085%20729.672%20436.017%20729.285%20436.017H727.925ZM731.182%20440.624H730.495L729.794%20439.03C729.604%20438.602%20729.482%20438.344%20729.43%20438.257C729.262%20438.269%20729.064%20438.274%20728.835%20438.274L727.925%20438.247V440.624H727.317V435.485H728.942C729.13%20435.485%20729.296%20435.489%20729.44%20435.498C729.584%20435.508%20729.727%20435.525%20729.869%20435.55C730.014%20435.573%20730.138%20435.606%20730.244%20435.65C730.349%20435.691%20730.448%20435.746%20730.539%20435.815C730.631%20435.881%20730.704%20435.961%20730.759%20436.055C730.816%20436.149%20730.861%20436.261%20730.893%20436.392C730.925%20436.52%20730.941%20436.665%20730.941%20436.828C730.941%20437.149%20730.856%20437.425%20730.687%20437.656C730.52%20437.887%20730.282%20438.048%20729.972%20438.137C729.972%20438.142%20729.995%20438.183%20730.041%20438.261C730.087%20438.339%20730.141%20438.435%20730.203%20438.549C730.267%20438.661%20730.316%20438.755%20730.35%20438.831L731.182%20440.624Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M698.067%20443.971H698.681L696.901%20448.874H696.304L694.53%20443.971H695.144L696.234%20447.081C696.376%20447.485%20696.498%20447.867%20696.602%20448.225C696.635%20448.059%20696.759%20447.674%20696.973%20447.071C697.318%20446.083%20697.683%20445.05%20698.067%20443.971ZM699.841%20448.874H699.267V443.971H699.841V448.874ZM700.938%20448.065C701.449%20448.317%20701.996%20448.443%20702.579%20448.443C703.297%20448.443%20703.656%20448.116%20703.656%20447.462C703.656%20447.25%20703.599%20447.079%20703.484%20446.948C703.371%20446.816%20703.165%20446.712%20702.864%20446.637L701.89%20446.391C701.145%20446.204%20700.772%20445.806%20700.772%20445.198C700.772%20444.732%20700.933%20444.386%20701.253%20444.16C701.574%20443.933%20702.017%20443.819%20702.582%20443.819C702.879%20443.819%20703.156%20443.851%20703.414%20443.915C703.673%20443.979%20703.89%20444.065%20704.064%20444.174L703.898%20444.641C703.75%20444.559%20703.554%20444.486%20703.308%20444.422C703.065%20444.358%20702.819%20444.326%20702.569%20444.326C701.769%20444.326%20701.369%20444.603%20701.369%20445.158C701.369%20445.346%20701.43%20445.497%20701.551%20445.612C701.675%20445.725%20701.86%20445.811%20702.105%20445.871L703.037%20446.096C703.434%20446.191%20703.736%20446.344%20703.942%20446.554C704.147%20446.762%20704.25%20447.058%20704.25%20447.442C704.25%20447.942%20704.096%20448.318%20703.789%20448.573C703.484%20448.825%20703.069%20448.951%20702.543%20448.951C702.149%20448.951%20701.799%20448.911%20701.492%20448.831C701.187%20448.749%20700.945%20448.653%20700.766%20448.543L700.938%20448.065ZM705.702%20448.874H705.128V443.971H705.702V448.874ZM708.423%20448.874H707.847V444.479H706.338V443.971H709.932V444.479H708.423V448.874ZM710.89%20446.425C710.89%20447.054%20711.034%20447.549%20711.324%20447.91C711.613%20448.268%20712.041%20448.447%20712.607%20448.447C713.173%20448.447%20713.598%20448.268%20713.883%20447.91C714.17%20447.552%20714.314%20447.057%20714.314%20446.425C714.314%20445.779%20714.169%20445.279%20713.88%20444.923C713.592%20444.567%20713.169%20444.389%20712.61%20444.389C712.051%20444.389%20711.625%20444.567%20711.331%20444.923C711.037%20445.279%20710.89%20445.779%20710.89%20446.425ZM714.927%20446.425C714.927%20446.798%20714.875%20447.139%20714.772%20447.449C714.67%20447.758%20714.522%20448.025%20714.327%20448.248C714.135%20448.469%20713.892%20448.641%20713.598%20448.765C713.304%20448.886%20712.974%20448.947%20712.607%20448.947C712.112%20448.947%20711.687%20448.842%20711.334%20448.632C710.983%20448.42%20710.718%20448.126%20710.542%20447.75C710.367%20447.373%20710.28%20446.929%20710.28%20446.421C710.28%20445.637%20710.484%20445.018%20710.893%20444.565C711.302%20444.112%20711.874%20443.885%20712.61%20443.885C713.335%20443.885%20713.902%20444.114%20714.311%20444.571C714.722%20445.027%20714.927%20445.644%20714.927%20446.425ZM716.373%20444.429V446.086C716.463%20446.086%20716.65%20446.089%20716.933%20446.093C717.218%20446.097%20717.438%20446.1%20717.593%20446.1C718.015%20446.1%20718.309%20446.03%20718.474%20445.891C718.64%20445.749%20718.723%20445.526%20718.723%20445.221C718.723%20444.954%20718.643%20444.755%20718.484%20444.624C718.325%20444.494%20718.059%20444.429%20717.685%20444.429H716.373ZM719.515%20448.874H718.852L718.176%20447.336C717.993%20446.923%20717.875%20446.674%20717.825%20446.59C717.663%20446.601%20717.472%20446.607%20717.251%20446.607L716.373%20446.58V448.874H715.786V443.915H717.354C717.535%20443.915%20717.695%20443.919%20717.835%20443.928C717.974%20443.937%20718.112%20443.954%20718.249%20443.978C718.388%20444%20718.509%20444.032%20718.61%20444.074C718.712%20444.114%20718.807%20444.167%20718.895%20444.233C718.984%20444.297%20719.054%20444.375%20719.108%20444.465C719.163%20444.556%20719.206%20444.664%20719.237%20444.79C719.268%20444.914%20719.283%20445.054%20719.283%20445.211C719.283%20445.521%20719.201%20445.787%20719.038%20446.01C718.877%20446.233%20718.647%20446.388%20718.348%20446.474C718.348%20446.479%20718.37%20446.518%20718.415%20446.594C718.459%20446.669%20718.511%20446.762%20718.57%20446.872C718.632%20446.98%20718.68%20447.071%20718.713%20447.144L719.515%20448.874Z'%20fill='%23B5B7BA'%20/%3e%3cmask%20id='mask8_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='24'%20y='24'%20width='945'%20height='32'%3e%3cg%20clip-path='url(%23clip34_12_1053)'%3e%3cpath%20d='M24%2024H965.2C966.3%2024%20967.2%2024.4%20967.9%2025.1C968.6%2025.8%20969%2026.7%20969%2027.7V51.7C969%2052.8%20968.6%2053.7%20967.9%2054.4C967.2%2055.1%20966.3%2055.5%20965.2%2055.5H27.7C26.7%2055.5%2025.8%2055.1%2025.1%2054.4C24.4%2053.7%2024%2052.8%2024%2051.7V27.7C24%2026.7%2024.4%2025.8%2025.1%2025.1C25.8%2024.4%2026.7%2024%2027.7%2024'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask8_12_1053)'%3e%3cpath%20d='M24%2024H965.25C965.747%2024%20966.226%2024.0952%20966.685%2024.2855C967.144%2024.4758%20967.55%2024.7467%20967.902%2025.0983C968.253%2025.45%20968.524%2025.8555%20968.714%2026.3149C968.905%2026.7744%20969%2027.2527%20969%2027.75V51.75C969%2052.2473%20968.905%2052.7256%20968.714%2053.1851C968.524%2053.6445%20968.253%2054.05%20967.902%2054.4017C967.55%2054.7533%20967.145%2055.0242%20966.685%2055.2145C966.226%2055.4048%20965.747%2055.5%20965.25%2055.5H27.75C27.2527%2055.5%2026.7744%2055.4048%2026.3149%2055.2145C25.8555%2055.0242%2025.45%2054.7533%2025.0983%2054.4016C24.7467%2054.05%2024.4758%2053.6445%2024.2855%2053.1851C24.0952%2052.7256%2024%2052.2473%2024%2051.75V27.75C24%2027.2527%2024.0952%2026.7744%2024.2855%2026.3149C24.4758%2025.8555%2024.7467%2025.45%2025.0983%2025.0983C25.45%2024.7467%2025.8555%2024.4758%2026.3149%2024.2855C26.7744%2024.0952%2027.2527%2024%2027.75%2024'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cpath%20d='M95.7455%2047.6133H94.0421V33.0503H95.7455V47.6133ZM98.9752%2047.6133V36.8117H100.354L100.56%2038.3576C100.987%2037.8259%20101.519%2037.3992%20102.156%2037.0775C102.799%2036.7493%20103.491%2036.5852%20104.233%2036.5852C105.48%2036.5852%20106.403%2036.9364%20107%2037.6388C107.597%2038.3346%20107.896%2039.4079%20107.896%2040.8586V47.6133H106.252C106.252%2043.2808%20106.248%2040.9603%20106.242%2040.6518C106.216%2039.7328%20106.029%2039.06%20105.681%2038.6333C105.339%2038.2066%20104.765%2037.9933%20103.957%2037.9933C103.111%2037.9933%20102.405%2038.1967%20101.84%2038.6037C101.276%2039.0107%20100.908%2039.5392%20100.738%2040.189C100.672%2040.6288%20100.639%2041.1343%20100.639%2041.7054V47.6133H98.9752ZM113.853%2047.8398C113.118%2047.8398%20112.439%2047.761%20111.815%2047.6034C111.198%2047.4459%20110.696%2047.2424%20110.308%2046.993L110.515%2045.6046C111.611%2046.1888%20112.688%2046.4809%20113.745%2046.4809C115.347%2046.4809%20116.17%2045.9164%20116.216%2044.7873C116.216%2044.3081%20116.046%2043.9307%20115.704%2043.655C115.363%2043.3793%20114.693%2043.0708%20113.696%2042.7294L112.878%2042.4439C111.933%2042.1288%20111.257%2041.7382%20110.85%2041.2721C110.45%2040.8061%20110.246%2040.2251%20110.24%2039.5293C110.24%2038.6825%20110.578%2037.9801%20111.254%2037.4222C111.936%2036.8642%20112.869%2036.5852%20114.05%2036.5852C115.271%2036.5852%20116.384%2036.8215%20117.388%2037.2942L116.906%2038.5545C115.888%2038.1344%20114.936%2037.9243%20114.05%2037.9243C113.361%2037.9243%20112.819%2038.0622%20112.425%2038.3379C112.038%2038.607%20111.845%2038.9878%20111.845%2039.4801C111.845%2039.9002%20111.986%2040.2218%20112.268%2040.445C112.55%2040.6682%20113.115%2040.9242%20113.962%2041.2131C114.178%2041.2918%20114.451%2041.3837%20114.779%2041.4888C115.868%2041.8432%20116.64%2042.2634%20117.093%2042.7491C117.546%2043.2283%20117.772%2043.8782%20117.772%2044.6987C117.759%2045.6965%20117.401%2046.4711%20116.699%2047.0225C115.996%2047.5673%20115.048%2047.8398%20113.853%2047.8398ZM121.967%2036.8117V47.6133H120.313V36.8117H121.967ZM121.967%2032.8829V34.8325H120.313V32.8829H121.967ZM129.263%2046.2052C129.821%2046.2052%20130.31%2046.1068%20130.73%2045.9098C131.15%2045.7129%20131.478%2045.4405%20131.715%2045.0926C131.951%2044.7447%20132.125%2044.3574%20132.237%2043.9307C132.355%2043.504%20132.414%2043.0379%20132.414%2042.5325V41.7349C132.414%2041.2098%20132.355%2040.7273%20132.237%2040.2875C132.118%2039.8411%20131.935%2039.444%20131.685%2039.0961C131.442%2038.7416%20131.114%2038.4659%20130.701%2038.269C130.294%2038.072%20129.818%2037.9736%20129.273%2037.9736C128.82%2037.9736%20128.406%2038.0589%20128.032%2038.2296C127.665%2038.4002%20127.359%2038.6267%20127.116%2038.909C126.88%2039.1847%20126.677%2039.5096%20126.506%2039.8838C126.342%2040.2514%20126.224%2040.6256%20126.151%2041.0063C126.079%2041.387%20126.043%2041.771%20126.043%2042.1583C126.043%2042.5391%20126.083%2042.9165%20126.161%2043.2907C126.24%2043.6648%20126.365%2044.0292%20126.536%2044.3836C126.706%2044.7381%20126.913%2045.0499%20127.156%2045.319C127.399%2045.5816%20127.701%2045.795%20128.062%2045.9591C128.429%2046.1232%20128.83%2046.2052%20129.263%2046.2052ZM126.732%2052.5562L126.585%2051.0694H128.593C129.151%2051.0694%20129.637%2051.03%20130.051%2050.9512C130.464%2050.8725%20130.809%2050.7412%20131.085%2050.5574C131.36%2050.3801%20131.583%2050.1799%20131.754%2049.9567C131.925%2049.7401%20132.053%2049.4546%20132.138%2049.1001C132.23%2048.7522%20132.289%2048.4043%20132.315%2048.0564C132.348%2047.715%20132.365%2047.2949%20132.365%2046.796V45.8409C131.971%2046.4054%20131.515%2046.842%20130.996%2047.1505C130.477%2047.4525%20129.818%2047.6034%20129.017%2047.6034C128.4%2047.6034%20127.829%2047.4984%20127.304%2047.2883C126.785%2047.0717%20126.345%2046.7862%20125.984%2046.4317C125.63%2046.0772%20125.324%2045.667%20125.068%2045.2009C124.819%2044.7348%20124.635%2044.2523%20124.517%2043.7535C124.405%2043.2546%20124.35%2042.7524%20124.35%2042.2469C124.35%2041.4592%20124.445%2040.7306%20124.635%2040.061C124.832%2039.3915%20125.121%2038.7941%20125.502%2038.269C125.882%2037.7438%20126.381%2037.3335%20126.998%2037.0381C127.622%2036.7362%20128.334%2036.5852%20129.135%2036.5852C129.844%2036.5852%20130.461%2036.7231%20130.986%2036.9988C131.518%2037.2679%20131.994%2037.6847%20132.414%2038.2493V36.8117H134.019V46.8354C134.019%2047.2949%20134.006%2047.6953%20133.979%2048.0367C133.96%2048.3846%20133.904%2048.7686%20133.812%2049.1887C133.727%2049.6088%20133.609%2049.9699%20133.458%2050.2718C133.307%2050.5738%20133.093%2050.8758%20132.818%2051.1777C132.548%2051.4862%20132.223%2051.7324%20131.843%2051.9162C131.469%2052.1066%20131.003%2052.2608%20130.445%2052.379C129.887%2052.4971%20129.256%2052.5562%20128.554%2052.5562H126.732ZM144.043%2047.6133V41.0851C144.043%2040.0019%20143.869%2039.2142%20143.521%2038.7219C143.179%2038.2296%20142.579%2037.9834%20141.719%2037.9834C140.892%2037.9834%20140.193%2038.1902%20139.621%2038.6037C139.057%2039.0173%20138.689%2039.5523%20138.519%2040.2087C138.46%2040.701%20138.43%2041.2492%20138.43%2041.8531V47.6133H136.786V32.6171L138.43%2032.5186V36.9101C138.43%2037.2843%20138.417%2037.7471%20138.391%2038.2985C139.316%2037.1563%20140.544%2036.5852%20142.073%2036.5852C144.482%2036.5852%20145.687%2037.9998%20145.687%2040.829V47.6133H144.043ZM151.162%2047.8102C150.098%2047.8102%20149.343%2047.5509%20148.897%2047.0323C148.451%2046.5138%20148.214%2045.6768%20148.188%2044.5215V38.0326H146.583L146.652%2036.9495L148.178%2036.8117L148.739%2034.3402L149.822%2034.3008V36.8117H152.826V38.0326H149.822V44.2261C149.822%2045.0466%20149.947%2045.6243%20150.197%2045.9591C150.446%2046.2939%20150.873%2046.4612%20151.477%2046.4612C151.693%2046.4612%20152.163%2046.4087%20152.885%2046.3037L152.954%2047.6034C152.172%2047.7413%20151.575%2047.8102%20151.162%2047.8102ZM157.926%2047.8398C157.191%2047.8398%20156.512%2047.761%20155.888%2047.6034C155.271%2047.4459%20154.769%2047.2424%20154.381%2046.993L154.588%2045.6046C155.684%2046.1888%20156.761%2046.4809%20157.818%2046.4809C159.42%2046.4809%20160.243%2045.9164%20160.289%2044.7873C160.289%2044.3081%20160.119%2043.9307%20159.777%2043.655C159.436%2043.3793%20158.766%2043.0708%20157.769%2042.7294L156.951%2042.4439C156.006%2042.1288%20155.33%2041.7382%20154.923%2041.2721C154.523%2040.8061%20154.319%2040.2251%20154.312%2039.5293C154.312%2038.6825%20154.651%2037.9801%20155.327%2037.4222C156.009%2036.8642%20156.941%2036.5852%20158.123%2036.5852C159.344%2036.5852%20160.457%2036.8215%20161.461%2037.2942L160.979%2038.5545C159.961%2038.1344%20159.009%2037.9243%20158.123%2037.9243C157.434%2037.9243%20156.892%2038.0622%20156.498%2038.3379C156.111%2038.607%20155.917%2038.9878%20155.917%2039.4801C155.917%2039.9002%20156.059%2040.2218%20156.341%2040.445C156.623%2040.6682%20157.188%2040.9242%20158.034%2041.2131C158.251%2041.2918%20158.523%2041.3837%20158.852%2041.4888C159.941%2041.8432%20160.713%2042.2634%20161.166%2042.7491C161.619%2043.2283%20161.845%2043.8782%20161.845%2044.6987C161.832%2045.6965%20161.474%2046.4711%20160.772%2047.0225C160.069%2047.5673%20159.121%2047.8398%20157.926%2047.8398ZM179.598%2040.3663C179.598%2038.3313%20179.073%2036.8511%20178.023%2035.9255C176.973%2034.9999%20175.443%2034.5371%20173.434%2034.5371H171.15V46.1265H173.72C175.637%2046.1265%20177.094%2045.644%20178.092%2044.679C179.096%2043.7075%20179.598%2042.2699%20179.598%2040.3663ZM181.42%2040.317C181.42%2042.6868%20180.747%2044.4952%20179.401%2045.7424C178.056%2046.9897%20176.178%2047.6133%20173.769%2047.6133H169.447V33.0503H173.484C174.698%2033.0503%20175.784%2033.1947%20176.743%2033.4836C177.701%2033.7658%20178.532%2034.1991%20179.234%2034.7833C179.943%2035.361%20180.484%2036.1191%20180.859%2037.0578C181.233%2037.99%20181.42%2039.0764%20181.42%2040.317ZM187.052%2046.5105C187.833%2046.5105%20188.519%2046.2971%20189.11%2045.8705C189.707%2045.4372%20190.091%2044.8563%20190.262%2044.1276V42.306C190.229%2042.306%20190.029%2042.3224%20189.661%2042.3553C189.3%2042.3881%20189.064%2042.4078%20188.952%2042.4143C187.528%2042.5391%20186.533%2042.7721%20185.969%2043.1134C185.411%2043.4548%20185.132%2044.0029%20185.132%2044.7578C185.132%2045.3355%20185.303%2045.772%20185.644%2046.0674C185.985%2046.3628%20186.455%2046.5105%20187.052%2046.5105ZM190.626%2047.6133C190.528%2047.1932%20190.433%2046.7402%20190.341%2046.2545C189.743%2046.8518%20189.182%2047.2654%20188.657%2047.4951C188.132%2047.7249%20187.515%2047.8398%20186.806%2047.8398C185.795%2047.8398%20184.981%2047.5772%20184.364%2047.052C183.753%2046.5203%20183.448%2045.7589%20183.448%2044.7676C183.448%2043.6648%20183.865%2042.8476%20184.699%2042.3159C185.539%2041.7842%20186.747%2041.4527%20188.322%2041.3214C188.539%2041.3017%20188.864%2041.2754%20189.297%2041.2426C189.737%2041.2032%20190.065%2041.1737%20190.282%2041.154V40.1989C190.282%2039.4374%20190.104%2038.8729%20189.75%2038.5053C189.396%2038.1377%20188.838%2037.9539%20188.076%2037.9539C187.013%2037.9539%20185.939%2038.2164%20184.856%2038.7416C184.823%2038.6628%20184.738%2038.4363%20184.6%2038.0622C184.462%2037.6814%20184.39%2037.4845%20184.384%2037.4714C184.863%2037.2023%20185.431%2036.9889%20186.087%2036.8314C186.75%2036.6673%20187.423%2036.5852%20188.106%2036.5852C189.451%2036.5852%20190.42%2036.8806%20191.01%2037.4714C191.608%2038.0556%20191.906%2039.0534%20191.906%2040.4647V47.6133H190.626ZM197.962%2047.8398C197.227%2047.8398%20196.547%2047.761%20195.924%2047.6034C195.307%2047.4459%20194.805%2047.2424%20194.417%2046.993L194.624%2045.6046C195.72%2046.1888%20196.797%2046.4809%20197.854%2046.4809C199.455%2046.4809%20200.279%2045.9164%20200.325%2044.7873C200.325%2044.3081%20200.154%2043.9307%20199.813%2043.655C199.472%2043.3793%20198.802%2043.0708%20197.804%2042.7294L196.987%2042.4439C196.042%2042.1288%20195.366%2041.7382%20194.959%2041.2721C194.558%2040.8061%20194.355%2040.2251%20194.348%2039.5293C194.348%2038.6825%20194.686%2037.9801%20195.363%2037.4222C196.045%2036.8642%20196.977%2036.5852%20198.159%2036.5852C199.38%2036.5852%20200.493%2036.8215%20201.497%2037.2942L201.014%2038.5545C199.997%2038.1344%20199.045%2037.9243%20198.159%2037.9243C197.47%2037.9243%20196.928%2038.0622%20196.534%2038.3379C196.147%2038.607%20195.953%2038.9878%20195.953%2039.4801C195.953%2039.9002%20196.094%2040.2218%20196.377%2040.445C196.659%2040.6682%20197.223%2040.9242%20198.07%2041.2131C198.287%2041.2918%20198.559%2041.3837%20198.888%2041.4888C199.977%2041.8432%20200.749%2042.2634%20201.201%2042.7491C201.654%2043.2283%20201.881%2043.8782%20201.881%2044.6987C201.868%2045.6965%20201.51%2046.4711%20200.808%2047.0225C200.105%2047.5673%20199.157%2047.8398%20197.962%2047.8398ZM211.412%2047.6133V41.0851C211.412%2040.0019%20211.238%2039.2142%20210.89%2038.7219C210.549%2038.2296%20209.948%2037.9834%20209.089%2037.9834C208.261%2037.9834%20207.562%2038.1902%20206.991%2038.6037C206.427%2039.0173%20206.059%2039.5523%20205.888%2040.2087C205.829%2040.701%20205.8%2041.2492%20205.8%2041.8531V47.6133H204.155V32.6171L205.8%2032.5186V36.9101C205.8%2037.2843%20205.787%2037.7471%20205.76%2038.2985C206.686%2037.1563%20207.914%2036.5852%20209.443%2036.5852C211.852%2036.5852%20213.057%2037.9998%20213.057%2040.829V47.6133H211.412ZM219.998%2037.9539C218.955%2037.9539%20218.154%2038.3149%20217.596%2039.037C217.044%2039.7525%20216.769%2040.8061%20216.769%2042.1977C216.769%2045.0466%20217.842%2046.4711%20219.989%2046.4711C220.52%2046.4711%20220.986%2046.3628%20221.387%2046.1462C221.794%2045.923%20222.112%2045.6144%20222.342%2045.2206C222.578%2044.8202%20222.752%2044.3705%20222.864%2043.8716C222.982%2043.3727%20223.041%2042.818%20223.041%2042.2076C223.041%2041.3804%20222.943%2040.6584%20222.746%2040.0413C222.555%2039.4243%20222.227%2038.9221%20221.761%2038.5348C221.295%2038.1475%20220.707%2037.9539%20219.998%2037.9539ZM220.166%2036.5852C221.124%2036.5852%20221.951%2036.8281%20222.647%2037.3138C223.343%2037.7996%20223.865%2038.4593%20224.213%2039.293C224.561%2040.1267%20224.735%2041.0818%20224.735%2042.1583C224.735%2043.2743%20224.561%2044.2556%20224.213%2045.1024C223.871%2045.9492%20223.35%2046.6188%20222.647%2047.1111C221.951%2047.5969%20221.118%2047.8398%20220.146%2047.8398C219.431%2047.8398%20218.777%2047.6855%20218.187%2047.377C217.596%2047.0684%20217.104%2046.6483%20216.71%2046.1166L216.542%2047.6133H215.134V32.6171L216.779%2032.5186V36.0929C216.779%2036.9725%20216.766%2037.7274%20216.739%2038.3576C217.12%2037.8127%20217.612%2037.3828%20218.216%2037.0677C218.827%2036.746%20219.477%2036.5852%20220.166%2036.5852ZM228.26%2042.2371C228.26%2043.5171%20228.542%2044.5445%20229.106%2045.319C229.678%2046.0871%20230.508%2046.4711%20231.598%2046.4711C232.674%2046.4711%20233.485%2046.0871%20234.03%2045.319C234.581%2044.551%20234.857%2043.5171%20234.857%2042.2174C234.857%2040.898%20234.584%2039.8608%20234.04%2039.1059C233.501%2038.3444%20232.677%2037.9637%20231.568%2037.9637C230.492%2037.9637%20229.671%2038.351%20229.106%2039.1256C228.542%2039.9002%20228.26%2040.9374%20228.26%2042.2371ZM236.56%2042.2076C236.56%2043.8815%20236.114%2045.2403%20235.221%2046.284C234.328%2047.3212%20233.094%2047.8398%20231.519%2047.8398C230.002%2047.8398%20228.795%2047.3146%20227.895%2046.2643C227.003%2045.214%20226.556%2043.865%20226.556%2042.2174C226.556%2040.5369%20227.006%2039.1781%20227.905%2038.141C228.804%2037.1038%20230.039%2036.5852%20231.607%2036.5852C233.15%2036.5852%20234.361%2037.1071%20235.241%2038.1508C236.12%2039.188%20236.56%2040.5402%20236.56%2042.2076ZM241.858%2046.5105C242.639%2046.5105%20243.325%2046.2971%20243.916%2045.8705C244.513%2045.4372%20244.897%2044.8563%20245.068%2044.1276V42.306C245.035%2042.306%20244.835%2042.3224%20244.467%2042.3553C244.106%2042.3881%20243.87%2042.4078%20243.758%2042.4143C242.334%2042.5391%20241.339%2042.7721%20240.775%2043.1134C240.217%2043.4548%20239.938%2044.0029%20239.938%2044.7578C239.938%2045.3355%20240.108%2045.772%20240.45%2046.0674C240.791%2046.3628%20241.26%2046.5105%20241.858%2046.5105ZM245.432%2047.6133C245.333%2047.1932%20245.238%2046.7402%20245.146%2046.2545C244.549%2046.8518%20243.988%2047.2654%20243.463%2047.4951C242.937%2047.7249%20242.32%2047.8398%20241.612%2047.8398C240.601%2047.8398%20239.787%2047.5772%20239.17%2047.052C238.559%2046.5203%20238.254%2045.7589%20238.254%2044.7676C238.254%2043.6648%20238.671%2042.8476%20239.504%2042.3159C240.345%2041.7842%20241.552%2041.4527%20243.128%2041.3214C243.344%2041.3017%20243.669%2041.2754%20244.103%2041.2426C244.542%2041.2032%20244.871%2041.1737%20245.087%2041.154V40.1989C245.087%2039.4374%20244.91%2038.8729%20244.556%2038.5053C244.201%2038.1377%20243.643%2037.9539%20242.882%2037.9539C241.818%2037.9539%20240.745%2038.2164%20239.662%2038.7416C239.629%2038.6628%20239.544%2038.4363%20239.406%2038.0622C239.268%2037.6814%20239.196%2037.4845%20239.189%2037.4714C239.668%2037.2023%20240.236%2036.9889%20240.893%2036.8314C241.556%2036.6673%20242.229%2036.5852%20242.911%2036.5852C244.257%2036.5852%20245.225%2036.8806%20245.816%2037.4714C246.413%2038.0556%20246.712%2039.0534%20246.712%2040.4647V47.6133H245.432ZM254.392%2036.7132C254.688%2036.7132%20254.957%2036.7329%20255.2%2036.7723L255.141%2038.2886C254.839%2038.2361%20254.576%2038.2099%20254.353%2038.2099C253.434%2038.2099%20252.686%2038.5315%20252.108%2039.1748C251.537%2039.8116%20251.251%2040.6026%20251.251%2041.5478V47.6133H249.607C249.6%2040.9833%20249.597%2037.3828%20249.597%2036.8117H250.966L251.123%2038.7514C251.497%2038.141%20251.973%2037.6486%20252.551%2037.2745C253.129%2036.9003%20253.742%2036.7132%20254.392%2036.7132ZM260.911%2046.4219C261.994%2046.4219%20262.798%2046.0739%20263.323%2045.3781C263.855%2044.6823%20264.121%2043.6878%20264.121%2042.3946C264.121%2040.9374%20263.865%2039.8411%20263.353%2039.1059C262.847%2038.3641%20262.027%2037.9933%20260.891%2037.9933C260.385%2037.9933%20259.939%2038.1016%20259.552%2038.3182C259.165%2038.5348%20258.853%2038.8368%20258.616%2039.2241C258.38%2039.6114%20258.2%2040.0577%20258.075%2040.5632C257.957%2041.0621%20257.898%2041.6102%20257.898%2042.2076C257.898%2043.0478%20257.999%2043.7764%20258.203%2044.3935C258.413%2045.0105%20258.748%2045.5028%20259.207%2045.8705C259.667%2046.2381%20260.235%2046.4219%20260.911%2046.4219ZM264.15%2046.0477C263.796%2046.5925%20263.323%2047.0258%20262.732%2047.3474C262.141%2047.6691%20261.482%2047.8299%20260.753%2047.8299C259.329%2047.8299%20258.213%2047.3245%20257.405%2046.3135C256.598%2045.2961%20256.194%2043.9143%20256.194%2042.1682C256.194%2040.5008%20256.604%2039.1551%20257.425%2038.1311C258.246%2037.1005%20259.345%2036.5852%20260.724%2036.5852C261.439%2036.5852%20262.112%2036.7427%20262.742%2037.0578C263.379%2037.3664%20263.855%2037.7832%20264.17%2038.3083L264.14%2037.3729V32.6171L265.765%2032.5186V47.6133H264.367L264.15%2046.0477Z'%20fill='white'%20/%3e%3cmask%20id='mask9_12_1053'%20style='mask-type:luminance'%20maskUnits='userSpaceOnUse'%20x='668'%20y='154'%20width='301'%20height='199'%3e%3cg%20clip-path='url(%23clip35_12_1053)'%3e%3cpath%20d='M668.2%20154.5H965.2C966.3%20154.5%20967.2%20154.9%20967.9%20155.6C968.6%20156.3%20969%20157.2%20969%20158.2V348.7C969%20349.8%20968.6%20350.7%20967.9%20351.4C967.2%20352.1%20966.3%20352.5%20965.2%20352.5H672C671%20352.5%20670.1%20352.1%20669.3%20351.4C668.6%20350.7%20668.2%20349.8%20668.2%20348.7V158.2C668.2%20157.2%20668.6%20156.3%20669.3%20155.6C670.1%20154.9%20671%20154.5%20672%20154.5'%20fill='white'%20/%3e%3c/g%3e%3c/mask%3e%3cg%20mask='url(%23mask9_12_1053)'%3e%3cpath%20d='M668.25%20154.5H965.25C965.747%20154.5%20966.226%20154.595%20966.685%20154.785C967.144%20154.976%20967.55%20155.247%20967.902%20155.598C968.253%20155.95%20968.524%20156.356%20968.714%20156.815C968.905%20157.274%20969%20157.753%20969%20158.25V348.75C969%20349.247%20968.905%20349.726%20968.715%20350.185C968.524%20350.644%20968.253%20351.05%20967.902%20351.402C967.55%20351.753%20967.144%20352.024%20966.685%20352.215C966.226%20352.405%20965.747%20352.5%20965.25%20352.5H672C671.503%20352.5%20671.024%20352.405%20670.565%20352.215C670.106%20352.024%20669.7%20351.753%20669.348%20351.402C668.997%20351.05%20668.726%20350.644%20668.535%20350.185C668.345%20349.726%20668.25%20349.247%20668.25%20348.75V158.25C668.25%20157.753%20668.345%20157.274%20668.535%20156.815C668.726%20156.356%20668.997%20155.95%20669.348%20155.598C669.7%20155.247%20670.106%20154.976%20670.565%20154.785C671.024%20154.595%20671.503%20154.5%20672%20154.5'%20fill='%23262F3D'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip36_12_1053)'%3e%3cpath%20d='M678.802%20177.919V170.48H680.427L682.677%20175.853L684.942%20170.48H686.546V177.919H685.277V174.243L685.318%20172.135L685.13%20172.694L683.225%20177.412H682.047L680.184%20172.669L679.996%20172.11L680.041%20174.263V177.919H678.802ZM689.852%20176.198C690.221%20176.669%20690.766%20176.904%20691.487%20176.904C692.209%20176.904%20692.752%20176.67%20693.118%20176.203C693.487%20175.732%20693.671%20175.069%20693.671%20174.212C693.671%20173.346%20693.487%20172.674%20693.118%20172.196C692.752%20171.719%20692.21%20171.48%20691.493%20171.48C690.771%20171.48%20690.225%20171.721%20689.852%20172.201C689.483%20172.679%20689.299%20173.349%20689.299%20174.212C689.299%20175.066%20689.483%20175.727%20689.852%20176.198ZM691.482%20178.026C690.362%20178.026%20689.477%20177.688%20688.827%20177.01C688.18%20176.33%20687.857%20175.392%20687.857%20174.197C687.857%20172.995%20688.182%20172.058%20688.832%20171.384C689.482%20170.71%20690.367%20170.373%20691.487%20170.373C692.608%20170.373%20693.492%20170.712%20694.138%20171.389C694.785%20172.063%20695.108%20173%20695.108%20174.202C695.108%20175.391%20694.783%20176.325%20694.133%20177.005C693.483%20177.686%20692.6%20178.026%20691.482%20178.026ZM696.413%20177.919V170.48H697.876C698.14%20170.893%20698.676%20171.726%20699.486%20172.978C700.295%20174.231%20700.787%20174.993%20700.963%20175.264C701.014%20175.341%20701.1%20175.473%20701.222%20175.66C701.348%20175.842%20701.436%20175.973%20701.486%20176.051C701.463%20174.889%20701.451%20174.287%20701.451%20174.243V170.48H702.705V177.919H701.222L697.866%20172.689L697.622%20172.288C697.649%20173.182%20697.662%20173.81%20697.662%20174.172V177.919H696.413ZM705.742%20177.919V171.582H703.573V170.48H709.281V171.582H707.123V177.919H705.742ZM710.084%20177.919V170.48H711.46V173.522H714.821V170.48H716.198V177.919H714.821V174.608H711.46V177.919H710.084ZM717.802%20177.919V170.48H719.179V176.823H722.291L722.251%20177.919H717.802ZM724.302%20177.919V174.969L721.728%20170.48H723.221L724.993%20173.7L726.775%20170.48H728.248L725.684%20174.944V177.919H724.302ZM734.982%20178.026C733.895%20178.026%20733.033%20177.684%20732.397%20177C731.76%20176.316%20731.442%20175.372%20731.442%20174.167C731.442%20173.022%20731.774%20172.105%20732.437%20171.414C733.104%20170.72%20733.976%20170.373%20735.053%20170.373C735.923%20170.373%20736.659%20170.575%20737.262%20170.978L736.83%20172.019C736.251%20171.663%20735.669%20171.485%20735.083%20171.485C734.399%20171.485%20733.858%20171.733%20733.458%20172.227C733.062%20172.718%20732.864%20173.378%20732.864%20174.207C732.864%20175.067%20733.055%20175.732%20733.438%20176.203C733.824%20176.674%20734.372%20176.909%20735.083%20176.909C735.706%20176.909%20736.324%20176.753%20736.937%20176.442L737.12%20177.518C736.551%20177.857%20735.838%20178.026%20734.982%20178.026ZM738.348%20177.919V170.48H739.725V173.522H743.086V170.48H744.462V177.919H743.086V174.608H739.725V177.919H738.348ZM746.067%20177.919V170.48H750.577L750.521%20171.572H747.443V173.491H750.368V174.583H747.443V176.823H750.632L750.587%20177.919H746.067ZM755.162%20178.026C754.075%20178.026%20753.214%20177.684%20752.577%20177C751.941%20176.316%20751.623%20175.372%20751.623%20174.167C751.623%20173.022%20751.954%20172.105%20752.618%20171.414C753.285%20170.72%20754.157%20170.373%20755.233%20170.373C756.103%20170.373%20756.84%20170.575%20757.442%20170.978L757.011%20172.019C756.432%20171.663%20755.849%20171.485%20755.264%20171.485C754.58%20171.485%20754.038%20171.733%20753.639%20172.227C753.243%20172.718%20753.045%20173.378%20753.045%20174.207C753.045%20175.067%20753.236%20175.732%20753.618%20176.203C754.004%20176.674%20754.553%20176.909%20755.264%20176.909C755.887%20176.909%20756.504%20176.753%20757.117%20176.442L757.3%20177.518C756.731%20177.857%20756.019%20178.026%20755.162%20178.026ZM758.524%20177.919V170.48H759.905V173.832C760.145%20173.513%20760.636%20172.919%20761.378%20172.049C762.123%20171.179%20762.566%20170.656%20762.708%20170.48H764.338L761.525%20173.826L764.516%20177.919H762.901L760.474%20174.583L759.905%20175.06V177.919H758.524ZM764.927%20175.66V174.624H767.649V175.66H764.927ZM768.853%20177.919V170.48H770.229V177.919H768.853ZM771.874%20177.919V170.48H773.337C773.601%20170.893%20774.137%20171.726%20774.946%20172.978C775.756%20174.231%20776.248%20174.993%20776.424%20175.264C776.475%20175.341%20776.561%20175.473%20776.683%20175.66C776.808%20175.842%20776.896%20175.973%20776.947%20176.051C776.924%20174.889%20776.912%20174.287%20776.912%20174.243V170.48H778.166V177.919H776.683L773.327%20172.689L773.083%20172.288C773.11%20173.182%20773.123%20173.81%20773.123%20174.172V177.919H771.874ZM781.853%20178.021C780.956%20178.021%20780.152%20177.814%20779.441%20177.401L779.776%20176.31C780.094%20176.486%20780.439%20176.628%20780.812%20176.736C781.187%20176.845%20781.553%20176.899%20781.909%20176.899C782.345%20176.899%20782.675%20176.806%20782.899%20176.619C783.122%20176.43%20783.234%20176.159%20783.234%20175.807C783.234%20175.34%20782.923%20175.016%20782.3%20174.837C782.256%20174.823%20782.132%20174.788%20781.929%20174.73C781.726%20174.669%20781.535%20174.612%20781.355%20174.558C781.179%20174.5%20781.052%20174.456%20780.974%20174.426C779.976%20174.074%20779.476%20173.417%20779.476%20172.455C779.476%20171.782%20779.715%20171.262%20780.192%20170.896C780.673%20170.531%20781.309%20170.348%20782.102%20170.348C782.999%20170.348%20783.772%20170.532%20784.422%20170.901L784.006%20171.907C783.342%20171.609%20782.726%20171.46%20782.157%20171.46C781.748%20171.46%20781.438%20171.533%20781.228%20171.678C781.022%20171.821%20780.912%20172.059%20780.898%20172.394C780.898%20172.807%20781.103%20173.077%20781.512%20173.202C781.594%20173.232%20781.793%20173.298%20782.112%20173.4C782.43%20173.501%20782.636%20173.567%20782.731%20173.598C783.412%20173.821%20783.898%20174.099%20784.189%20174.431C784.483%20174.763%20784.63%20175.225%20784.63%20175.817C784.63%20176.525%20784.38%20177.07%20783.879%20177.452C783.378%20177.831%20782.702%20178.021%20781.853%20178.021ZM788.525%20177.919V170.46H791.004C791.589%20170.46%20792.09%20170.536%20792.507%20170.688C792.923%20170.837%20793.251%20171.081%20793.492%20171.419C793.736%20171.758%20793.857%20172.183%20793.857%20172.694C793.857%20173.05%20793.812%20173.366%20793.72%20173.644C793.629%20173.918%20793.478%20174.168%20793.268%20174.395C793.058%20174.619%20792.762%20174.791%20792.38%20174.913C792.001%20175.035%20791.542%20175.096%20791.004%20175.096C790.543%20175.096%20790.169%20175.082%20789.881%20175.055V177.919H788.525ZM790.856%20174.101C791.137%20174.101%20791.381%20174.074%20791.587%20174.019C791.797%20173.965%20791.96%20173.896%20792.075%20173.811C792.193%20173.727%20792.287%20173.622%20792.354%20173.496C792.425%20173.371%20792.471%20173.251%20792.491%20173.136C792.515%20173.017%20792.527%20172.885%20792.527%20172.74C792.527%20172.33%20792.395%20172.019%20792.131%20171.805C791.867%20171.592%20791.494%20171.485%20791.014%20171.485H789.881V174.091C789.922%20174.097%20790.247%20174.101%20790.856%20174.101ZM794.888%20177.919V170.48H799.398L799.342%20171.572H796.264V173.491H799.189V174.583H796.264V176.823H799.454L799.408%20177.919H794.888ZM800.703%20177.919V170.46H803.46C803.836%20170.46%20804.161%20170.477%20804.435%20170.51C804.713%20170.544%20804.975%20170.607%20805.222%20170.698C805.473%20170.786%20805.674%20170.907%20805.827%20171.059C805.982%20171.211%20806.104%20171.411%20806.192%20171.658C806.284%20171.902%20806.329%20172.191%20806.329%20172.526C806.329%20173.515%20805.881%20174.165%20804.984%20174.476C805.166%20174.683%20805.393%20175.066%20805.664%20175.624L806.771%20177.919H805.268L804.4%20175.975C804.071%20175.277%20803.868%20174.864%20803.79%20174.735C803.733%20174.732%20803.541%20174.73%20803.216%20174.73L802.064%20174.72V177.919H800.703ZM803.582%20173.735C804.11%20173.735%20804.489%20173.642%20804.72%20173.456C804.95%20173.266%20805.065%20172.963%20805.065%20172.547C805.065%20172.181%20804.948%20171.912%20804.714%20171.739C804.481%20171.567%20804.124%20171.48%20803.643%20171.48H802.064V173.73C802.114%20173.73%20802.367%20173.732%20802.82%20173.735C803.274%20173.735%20803.528%20173.735%20803.582%20173.735ZM812.443%20177.919L809.737%20170.48H811.154L812.728%20175.076C812.789%20175.235%20812.929%20175.7%20813.149%20176.472C813.163%20176.418%20813.225%20176.196%20813.337%20175.807C813.449%20175.414%20813.522%20175.174%20813.555%20175.086C813.596%20174.971%20813.853%20174.207%20814.327%20172.796C814.801%20171.381%20815.06%20170.609%20815.104%20170.48H816.506L813.835%20177.919H812.443ZM817.318%20177.919V170.48H818.695V177.919H817.318ZM822.427%20178.021C821.53%20178.021%20820.726%20177.814%20820.015%20177.401L820.35%20176.31C820.668%20176.486%20821.014%20176.628%20821.386%20176.736C821.762%20176.845%20822.127%20176.899%20822.483%20176.899C822.92%20176.899%20823.25%20176.806%20823.473%20176.619C823.696%20176.43%20823.808%20176.159%20823.808%20175.807C823.808%20175.34%20823.497%20175.016%20822.874%20174.837C822.83%20174.823%20822.706%20174.788%20822.503%20174.73C822.3%20174.669%20822.109%20174.612%20821.929%20174.558C821.753%20174.5%20821.626%20174.456%20821.548%20174.426C820.55%20174.074%20820.05%20173.417%20820.05%20172.455C820.05%20171.782%20820.289%20171.262%20820.766%20170.896C821.247%20170.531%20821.884%20170.348%20822.676%20170.348C823.573%20170.348%20824.346%20170.532%20824.996%20170.901L824.58%20171.907C823.917%20171.609%20823.3%20171.46%20822.732%20171.46C822.322%20171.46%20822.012%20171.533%20821.802%20171.678C821.596%20171.821%20821.486%20172.059%20821.472%20172.394C821.472%20172.807%20821.677%20173.077%20822.087%20173.202C822.168%20173.232%20822.368%20173.298%20822.686%20173.4C823.004%20173.501%20823.211%20173.567%20823.305%20173.598C823.986%20173.821%20824.472%20174.099%20824.763%20174.431C825.057%20174.763%20825.205%20175.225%20825.205%20175.817C825.205%20176.525%20824.954%20177.07%20824.453%20177.452C823.952%20177.831%20823.277%20178.021%20822.427%20178.021ZM826.418%20177.919V170.48H827.795V177.919H826.418ZM830.877%20177.919V171.582H828.709V170.48H834.416V171.582H832.258V177.919H830.877ZM836.955%20176.198C837.324%20176.669%20837.87%20176.904%20838.591%20176.904C839.312%20176.904%20839.855%20176.67%20840.221%20176.203C840.59%20175.732%20840.774%20175.069%20840.774%20174.212C840.774%20173.346%20840.59%20172.674%20840.221%20172.196C839.855%20171.719%20839.313%20171.48%20838.596%20171.48C837.875%20171.48%20837.328%20171.721%20836.955%20172.201C836.586%20172.679%20836.402%20173.349%20836.402%20174.212C836.402%20175.066%20836.586%20175.727%20836.955%20176.198ZM838.586%20178.026C837.465%20178.026%20836.58%20177.688%20835.93%20177.01C835.283%20176.33%20834.96%20175.392%20834.96%20174.197C834.96%20172.995%20835.285%20172.058%20835.935%20171.384C836.585%20170.71%20837.47%20170.373%20838.591%20170.373C839.711%20170.373%20840.595%20170.712%20841.241%20171.389C841.888%20172.063%20842.211%20173%20842.211%20174.202C842.211%20175.391%20841.886%20176.325%20841.236%20177.005C840.586%20177.686%20839.703%20178.026%20838.586%20178.026ZM843.481%20177.919V170.46H846.238C846.614%20170.46%20846.939%20170.477%20847.213%20170.51C847.491%20170.544%20847.753%20170.607%20848%20170.698C848.251%20170.786%20848.452%20170.907%20848.605%20171.059C848.76%20171.211%20848.882%20171.411%20848.97%20171.658C849.062%20171.902%20849.107%20172.191%20849.107%20172.526C849.107%20173.515%20848.659%20174.165%20847.762%20174.476C847.945%20174.683%20848.171%20175.066%20848.442%20175.624L849.549%20177.919H848.046L847.178%20175.975C846.849%20175.277%20846.646%20174.864%20846.568%20174.735C846.511%20174.732%20846.32%20174.73%20845.995%20174.73L844.842%20174.72V177.919H843.481ZM846.36%20173.735C846.888%20173.735%20847.267%20173.642%20847.498%20173.456C847.728%20173.266%20847.843%20172.963%20847.843%20172.547C847.843%20172.181%20847.726%20171.912%20847.493%20171.739C847.259%20171.567%20846.902%20171.48%20846.421%20171.48H844.842V173.73C844.893%20173.73%20845.145%20173.732%20845.598%20173.735C846.052%20173.735%20846.306%20173.735%20846.36%20173.735Z'%20fill='white'%20/%3e%3c/g%3e%3cpath%20d='M694.649%20218.773L697.663%20214.85C697.36%20214.954%20697.09%20215.006%20696.855%20215.006C695.882%20215.006%20695.088%20214.714%20694.473%20214.131C693.862%20213.542%20693.557%20212.782%20693.557%20211.85C693.557%20210.882%20693.891%20210.108%20694.561%20209.529C695.235%20208.95%20696.108%20208.66%20697.181%20208.66C698.289%20208.66%20699.188%20208.959%20699.875%20209.556C700.563%20210.149%20700.907%20210.938%20700.907%20211.925C700.907%20212.495%20700.798%20213.013%20700.581%20213.479C700.364%20213.945%20700.045%20214.465%20699.624%20215.04L696.814%20218.773H694.649ZM697.235%20213.757C697.864%20213.757%20698.328%20213.583%20698.627%20213.235C698.93%20212.886%20699.081%20212.416%20699.081%20211.823C699.081%20211.266%20698.925%20210.825%20698.613%20210.499C698.301%20210.174%20697.853%20210.011%20697.269%20210.011C696.667%20210.011%20696.194%20210.18%20695.851%20210.52C695.511%20210.859%20695.342%20211.305%20695.342%20211.857C695.342%20212.445%20695.5%20212.909%20695.817%20213.248C696.138%20213.588%20696.611%20213.757%20697.235%20213.757ZM701.83%20218.773L701.789%20217.307L704.932%20213.75C705.321%20213.334%20705.604%20212.952%20705.78%20212.603C705.961%20212.251%20706.052%20211.88%20706.052%20211.49C706.052%20211.061%20705.911%20210.719%20705.631%20210.466C705.35%20210.208%20704.982%20210.079%20704.525%20210.079C704.104%20210.079%20703.687%20210.158%20703.276%20210.316C702.868%20210.47%20702.534%20210.665%20702.271%20210.9L701.762%20209.556C702.441%20208.959%20703.396%20208.66%20704.626%20208.66C705.604%20208.66%20706.389%20208.907%20706.981%20209.4C707.579%20209.889%20707.877%20210.581%20707.877%20211.477C707.877%20212.11%20707.708%20212.714%20707.368%20213.289C707.033%20213.864%20706.574%20214.454%20705.991%20215.06L703.751%20217.436H707.762L707.64%20218.773H701.83ZM708.984%20218.773L708.943%20217.307L712.085%20213.75C712.474%20213.334%20712.757%20212.952%20712.934%20212.603C713.115%20212.251%20713.205%20211.88%20713.205%20211.49C713.205%20211.061%20713.065%20210.719%20712.784%20210.466C712.504%20210.208%20712.135%20210.079%20711.678%20210.079C711.257%20210.079%20710.841%20210.158%20710.429%20210.316C710.022%20210.47%20709.687%20210.665%20709.425%20210.9L708.916%20209.556C709.594%20208.959%20710.549%20208.66%20711.78%20208.66C712.757%20208.66%20713.542%20208.907%20714.135%20209.4C714.732%20209.889%20715.031%20210.581%20715.031%20211.477C715.031%20212.11%20714.861%20212.714%20714.522%20213.289C714.187%20213.864%20713.728%20214.454%20713.144%20215.06L710.904%20217.436H714.916L714.793%20218.773H708.984ZM717.223%20218.895C716.929%20218.895%20716.68%20218.793%20716.477%20218.59C716.273%20218.386%20716.171%20218.144%20716.171%20217.863C716.171%20217.578%20716.271%20217.332%20716.47%20217.124C716.673%20216.916%20716.925%20216.811%20717.223%20216.811C717.513%20216.811%20717.757%20216.916%20717.956%20217.124C718.155%20217.332%20718.255%20217.578%20718.255%20217.863C718.255%20218.144%20718.155%20218.386%20717.956%20218.59C717.757%20218.793%20717.513%20218.895%20717.223%20218.895ZM722.7%20218.915C722.053%20218.915%20721.47%20218.814%20720.949%20218.61C720.433%20218.402%20720.015%20218.085%20719.694%20217.66C719.372%20217.23%20719.212%20216.721%20719.212%20216.133C719.212%20214.943%20719.798%20214.088%20720.97%20213.567C719.924%20213.07%20719.402%20212.291%20719.402%20211.232C719.402%20210.816%20719.488%20210.443%20719.66%20210.113C719.832%20209.782%20720.067%20209.513%20720.366%20209.305C720.669%20209.092%20721.017%20208.932%20721.411%20208.823C721.809%20208.714%20722.239%20208.66%20722.7%20208.66C723.66%20208.66%20724.447%20208.884%20725.062%20209.332C725.682%20209.78%20725.992%20210.413%20725.992%20211.232C725.992%20212.278%20725.508%20213.056%20724.54%20213.567C725.63%20214.097%20726.175%20214.954%20726.175%20216.14C726.175%20216.728%20726.015%20217.237%20725.694%20217.667C725.377%20218.092%20724.958%20218.406%20724.438%20218.61C723.922%20218.814%20723.343%20218.915%20722.7%20218.915ZM721.357%20217.266C721.682%20217.542%20722.13%20217.68%20722.7%20217.68C723.271%20217.68%20723.716%20217.542%20724.037%20217.266C724.359%20216.99%20724.519%20216.601%20724.519%20216.099C724.519%20215.601%20724.352%20215.189%20724.017%20214.864C723.682%20214.538%20723.243%20214.305%20722.7%20214.165C722.144%20214.305%20721.698%20214.538%20721.363%20214.864C721.033%20215.189%20720.868%20215.603%20720.868%20216.106C720.868%20216.603%20721.031%20216.99%20721.357%20217.266ZM722.7%20213.106C723.257%20212.979%20723.685%20212.76%20723.983%20212.447C724.282%20212.131%20724.431%20211.728%20724.431%20211.239C724.431%20210.832%20724.268%20210.504%20723.942%20210.255C723.617%20210.006%20723.203%20209.882%20722.7%20209.882C722.203%20209.882%20721.789%20210.006%20721.458%20210.255C721.128%20210.504%20720.963%20210.832%20720.963%20211.239C720.963%20211.728%20721.117%20212.131%20721.424%20212.447C721.732%20212.764%20722.157%20212.984%20722.7%20213.106Z'%20fill='%23D78A0F'%20/%3e%3cpath%20d='M698.374%20242.273L696.623%20238.2L696.476%20237.81L696.503%20239.207V242.624H695.878V236.919H696.742L698.729%20241.463L700.696%20236.919H701.537V242.624H700.889V239.191L700.916%20237.826L700.773%20238.215L699.026%20242.273H698.374ZM703.358%20239.774C703.358%20240.507%20703.526%20241.083%20703.863%20241.502C704.2%20241.918%20704.698%20242.127%20705.356%20242.127C706.014%20242.127%20706.509%20241.918%20706.841%20241.502C707.175%20241.085%20707.342%20240.509%20707.342%20239.774C707.342%20239.023%20707.174%20238.44%20706.837%20238.026C706.503%20237.612%20706.01%20237.405%20705.36%20237.405C704.709%20237.405%20704.213%20237.612%20703.871%20238.026C703.529%20238.44%20703.358%20239.023%20703.358%20239.774ZM708.056%20239.774C708.056%20240.208%20707.996%20240.606%20707.875%20240.966C707.756%20241.326%20707.584%20241.635%20707.358%20241.895C707.134%20242.152%20706.851%20242.353%20706.509%20242.497C706.167%20242.638%20705.783%20242.709%20705.356%20242.709C704.78%20242.709%20704.286%20242.587%20703.875%20242.343C703.466%20242.096%20703.158%20241.754%20702.953%20241.317C702.75%20240.877%20702.648%20240.361%20702.648%20239.77C702.648%20238.857%20702.886%20238.137%20703.362%20237.61C703.837%20237.082%20704.503%20236.819%20705.36%20236.819C706.203%20236.819%20706.863%20237.085%20707.339%20237.617C707.817%20238.147%20708.056%20238.866%20708.056%20239.774ZM713.665%20242.624H712.909L709.946%20238.134L709.753%20237.868C709.774%20238.408%20709.784%20238.89%20709.784%20239.315V242.624H709.159V236.919H709.904L712.874%20241.409L713.071%20241.675C713.053%20240.855%20713.044%20240.381%20713.044%20240.252V236.919H713.665V242.624ZM716.789%20242.624H716.118V237.509H714.363V236.919H718.544V237.509H716.789V242.624ZM723.648%20242.624H722.98V239.955H719.918V242.624H719.25V236.919H719.918V239.369H722.98V236.919H723.648V242.624ZM724.99%20242.624V236.919H725.661V242.03H728.173L728.149%20242.624H724.99ZM729.97%20239.716L731.575%20236.919H732.3L730.286%20240.348V242.624H729.611V240.364L727.686%20236.919H728.408L729.97%20239.716ZM699.3%20244.919H700.013L697.942%20250.624H697.248L695.184%20244.919H695.897L697.167%20248.537C697.331%20249.008%20697.474%20249.452%20697.595%20249.868C697.633%20249.675%20697.777%20249.228%20698.027%20248.526C698.428%20247.376%20698.852%20246.174%20699.3%20244.919ZM701.363%20250.624H700.696V244.919H701.363V250.624ZM702.64%20249.683C703.234%20249.976%20703.871%20250.123%20704.55%20250.123C705.385%20250.123%20705.803%20249.742%20705.803%20248.981C705.803%20248.734%20705.736%20248.535%20705.603%20248.383C705.472%20248.229%20705.231%20248.108%20704.881%20248.021L703.747%20247.735C702.881%20247.516%20702.447%20247.054%20702.447%20246.346C702.447%20245.804%20702.634%20245.401%20703.007%20245.139C703.38%20244.874%20703.895%20244.742%20704.554%20244.742C704.898%20244.742%20705.221%20244.779%20705.522%20244.854C705.823%20244.928%20706.075%20245.028%20706.278%20245.154L706.085%20245.698C705.913%20245.603%20705.684%20245.518%20705.398%20245.444C705.115%20245.369%20704.829%20245.332%20704.538%20245.332C703.607%20245.332%20703.142%20245.655%20703.142%20246.3C703.142%20246.519%20703.212%20246.695%20703.354%20246.829C703.498%20246.96%20703.713%20247.06%20703.998%20247.129L705.082%20247.392C705.545%20247.502%20705.896%20247.68%20706.135%20247.924C706.374%20248.166%20706.494%20248.51%20706.494%20248.958C706.494%20249.539%20706.315%20249.978%20705.958%20250.273C705.603%20250.566%20705.119%20250.713%20704.507%20250.713C704.049%20250.713%20703.642%20250.667%20703.284%20250.574C702.93%20250.479%20702.648%20250.367%20702.44%20250.239L702.64%20249.683ZM708.183%20250.624H707.516V244.919H708.183V250.624ZM711.35%20250.624H710.679V245.509H708.924V244.919H713.105V245.509H711.35V250.624ZM714.22%20247.774C714.22%20248.507%20714.389%20249.083%20714.726%20249.502C715.062%20249.918%20715.56%20250.127%20716.218%20250.127C716.877%20250.127%20717.372%20249.918%20717.703%20249.502C718.038%20249.085%20718.205%20248.509%20718.205%20247.774C718.205%20247.023%20718.036%20246.44%20717.7%20246.026C717.365%20245.612%20716.873%20245.405%20716.222%20245.405C715.572%20245.405%20715.075%20245.612%20714.733%20246.026C714.391%20246.44%20714.22%20247.023%20714.22%20247.774ZM718.919%20247.774C718.919%20248.208%20718.858%20248.606%20718.737%20248.966C718.619%20249.326%20718.447%20249.635%20718.22%20249.895C717.997%20250.152%20717.714%20250.353%20717.372%20250.497C717.03%20250.638%20716.645%20250.709%20716.218%20250.709C715.642%20250.709%20715.149%20250.587%20714.737%20250.343C714.328%20250.096%20714.021%20249.754%20713.815%20249.317C713.612%20248.877%20713.51%20248.361%20713.51%20247.77C713.51%20246.857%20713.748%20246.137%20714.224%20245.61C714.7%20245.082%20715.366%20244.819%20716.222%20244.819C717.066%20244.819%20717.725%20245.085%20718.201%20245.617C718.679%20246.147%20718.919%20246.866%20718.919%20247.774ZM720.6%20245.451V247.38C720.706%20247.38%20720.923%20247.383%20721.252%20247.388C721.584%20247.393%20721.84%20247.396%20722.02%20247.396C722.511%20247.396%20722.853%20247.315%20723.046%20247.153C723.239%20246.988%20723.335%20246.728%20723.335%20246.373C723.335%20246.062%20723.243%20245.831%20723.058%20245.679C722.872%20245.527%20722.563%20245.451%20722.128%20245.451H720.6ZM724.257%20250.624H723.486L722.699%20248.834C722.485%20248.354%20722.349%20248.064%20722.29%20247.967C722.102%20247.979%20721.88%20247.986%20721.623%20247.986L720.6%20247.955V250.624H719.918V244.854H721.742C721.953%20244.854%20722.14%20244.859%20722.302%20244.869C722.464%20244.879%20722.624%20244.899%20722.784%20244.927C722.946%20244.953%20723.086%20244.99%20723.204%20245.039C723.322%20245.085%20723.433%20245.147%20723.536%20245.224C723.639%20245.298%20723.721%20245.388%20723.783%20245.494C723.847%20245.599%20723.897%20245.725%20723.933%20245.872C723.969%20246.016%20723.987%20246.179%20723.987%20246.362C723.987%20246.722%20723.892%20247.032%20723.702%20247.291C723.514%20247.551%20723.247%20247.731%20722.899%20247.831C722.899%20247.837%20722.925%20247.883%20722.977%20247.97C723.028%20248.058%20723.088%20248.166%20723.158%20248.294C723.23%20248.42%20723.285%20248.526%20723.324%20248.611L724.257%20250.624ZM725.083%20249.683C725.677%20249.976%20726.313%20250.123%20726.992%20250.123C727.828%20250.123%20728.246%20249.742%20728.246%20248.981C728.246%20248.734%20728.179%20248.535%20728.045%20248.383C727.914%20248.229%20727.674%20248.108%20727.324%20248.021L726.19%20247.735C725.323%20247.516%20724.89%20247.054%20724.89%20246.346C724.89%20245.804%20725.076%20245.401%20725.449%20245.139C725.822%20244.874%20726.338%20244.742%20726.996%20244.742C727.341%20244.742%20727.663%20244.779%20727.964%20244.854C728.265%20244.928%20728.517%20245.028%20728.72%20245.154L728.527%20245.698C728.355%20245.603%20728.126%20245.518%20727.841%20245.444C727.558%20245.369%20727.271%20245.332%20726.981%20245.332C726.05%20245.332%20725.584%20245.655%20725.584%20246.3C725.584%20246.519%20725.655%20246.695%20725.796%20246.829C725.94%20246.96%20726.155%20247.06%20726.441%20247.129L727.524%20247.392C727.987%20247.502%20728.338%20247.68%20728.578%20247.924C728.817%20248.166%20728.936%20248.51%20728.936%20248.958C728.936%20249.539%20728.758%20249.978%20728.4%20250.273C728.045%20250.566%20727.562%20250.713%20726.95%20250.713C726.492%20250.713%20726.084%20250.667%20725.727%20250.574C725.372%20250.479%20725.09%20250.367%20724.882%20250.239L725.083%20249.683Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M704.343%20289.415C703.759%20289.415%20703.209%20289.341%20702.693%20289.192C702.182%20289.038%20701.777%20288.832%20701.478%20288.574L701.967%20287.291C702.216%20287.499%20702.56%20287.671%20702.999%20287.807C703.438%20287.938%20703.888%20288.004%20704.349%20288.004C704.87%20288.004%20705.288%20287.863%20705.605%20287.583C705.926%20287.302%20706.087%20286.936%20706.087%20286.483C706.087%20286.203%20706.042%20285.961%20705.951%20285.757C705.865%20285.554%20705.75%20285.391%20705.605%20285.269C705.46%20285.146%20705.266%20285.049%20705.021%20284.977C704.781%20284.9%20704.535%20284.848%20704.281%20284.821C704.028%20284.793%20703.723%20284.778%20703.365%20284.773C703.352%20284.773%20703.286%20284.773%20703.168%20284.773C703.051%20284.769%20702.985%20284.766%20702.972%20284.766V283.395H703.352C703.745%20283.395%20704.082%20283.375%20704.363%20283.334C704.648%20283.294%20704.91%20283.223%20705.15%20283.124C705.395%20283.024%20705.578%20282.877%20705.7%20282.683C705.827%20282.488%20705.89%20282.248%20705.89%20281.963C705.89%20281.579%20705.745%20281.251%20705.456%20280.979C705.166%20280.708%20704.759%20280.572%20704.234%20280.572C703.383%20280.572%20702.625%20280.785%20701.96%20281.21L701.472%20279.92C702.295%20279.414%20703.272%20279.16%20704.404%20279.16C705.349%20279.16%20706.121%20279.409%20706.718%20279.907C707.32%20280.404%20707.621%20281.042%20707.621%20281.821C707.621%20282.364%20707.48%20282.827%20707.2%20283.212C706.924%20283.592%20706.521%20283.87%20705.992%20284.047C706.598%20284.165%20707.066%20284.456%20707.397%20284.922C707.732%20285.388%20707.899%20285.938%20707.899%20286.572C707.899%20287.173%20707.738%20287.694%20707.417%20288.133C707.096%20288.567%20706.671%20288.891%20706.141%20289.103C705.612%20289.311%20705.012%20289.415%20704.343%20289.415ZM710.03%20289.395C709.736%20289.395%20709.487%20289.293%20709.284%20289.09C709.08%20288.886%20708.978%20288.644%20708.978%20288.363C708.978%20288.078%20709.078%20287.832%20709.277%20287.624C709.48%20287.416%20709.731%20287.311%20710.03%20287.311C710.32%20287.311%20710.564%20287.416%20710.763%20287.624C710.962%20287.832%20711.062%20288.078%20711.062%20288.363C711.062%20288.644%20710.962%20288.886%20710.763%20289.09C710.564%20289.293%20710.32%20289.395%20710.03%20289.395ZM714.876%20289.415C714.292%20289.415%20713.743%20289.341%20713.227%20289.192C712.716%20289.038%20712.311%20288.832%20712.012%20288.574L712.501%20287.291C712.749%20287.499%20713.093%20287.671%20713.532%20287.807C713.971%20287.938%20714.421%20288.004%20714.883%20288.004C715.403%20288.004%20715.822%20287.863%20716.139%20287.583C716.46%20287.302%20716.62%20286.936%20716.62%20286.483C716.62%20286.203%20716.575%20285.961%20716.485%20285.757C716.399%20285.554%20716.283%20285.391%20716.139%20285.269C715.994%20285.146%20715.799%20285.049%20715.555%20284.977C715.315%20284.9%20715.068%20284.848%20714.815%20284.821C714.562%20284.793%20714.256%20284.778%20713.899%20284.773C713.885%20284.773%20713.82%20284.773%20713.702%20284.773C713.584%20284.769%20713.519%20284.766%20713.505%20284.766V283.395H713.885C714.279%20283.395%20714.616%20283.375%20714.896%20283.334C715.182%20283.294%20715.444%20283.223%20715.684%20283.124C715.928%20283.024%20716.111%20282.877%20716.234%20282.683C716.36%20282.488%20716.424%20282.248%20716.424%20281.963C716.424%20281.579%20716.279%20281.251%20715.989%20280.979C715.7%20280.708%20715.292%20280.572%20714.768%20280.572C713.917%20280.572%20713.159%20280.785%20712.494%20281.21L712.005%20279.92C712.829%20279.414%20713.806%20279.16%20714.937%20279.16C715.883%20279.16%20716.654%20279.409%20717.252%20279.907C717.853%20280.404%20718.154%20281.042%20718.154%20281.821C718.154%20282.364%20718.014%20282.827%20717.733%20283.212C717.457%20283.592%20717.055%20283.87%20716.525%20284.047C717.132%20284.165%20717.6%20284.456%20717.93%20284.922C718.265%20285.388%20718.433%20285.938%20718.433%20286.572C718.433%20287.173%20718.272%20287.694%20717.951%20288.133C717.629%20288.567%20717.204%20288.891%20716.675%20289.103C716.145%20289.311%20715.546%20289.415%20714.876%20289.415Z'%20fill='%23AB0FD7'%20/%3e%3cpath%20d='M695.354%20307.909C694.925%20307.909%20694.555%20308.013%20694.243%20308.221C693.935%20308.43%20693.705%20308.71%20693.553%20309.062C693.401%20309.415%20693.325%20309.82%20693.325%20310.277C693.325%20310.62%20693.366%20310.932%20693.449%20311.215C693.531%20311.495%20693.655%20311.742%20693.819%20311.955C693.984%20312.166%20694.197%20312.331%20694.459%20312.449C694.724%20312.565%20695.028%20312.623%20695.37%20312.623C695.81%20312.623%20696.265%20312.508%20696.735%20312.279L696.847%20312.847C696.464%20313.088%20695.946%20313.209%20695.293%20313.209C694.863%20313.209%20694.477%20313.138%20694.135%20312.997C693.796%20312.853%20693.514%20312.651%20693.291%20312.391C693.069%20312.129%20692.901%20311.818%20692.785%20311.458C692.67%20311.095%20692.612%20310.693%20692.612%20310.25C692.612%20309.824%20692.675%20309.43%20692.801%20309.07C692.927%20308.71%20693.104%20308.401%20693.333%20308.144C693.565%20307.885%20693.853%20307.683%20694.197%20307.539C694.542%20307.395%20694.925%20307.323%20695.347%20307.323C695.987%20307.323%20696.527%20307.464%20696.967%20307.747L696.704%20308.291C696.283%20308.036%20695.833%20307.909%20695.354%20307.909ZM702.224%20313.124H701.557V310.455H698.494V313.124H697.827V307.419H698.494V309.869H701.557V307.419H702.224V313.124ZM703.567%20313.124V307.419H706.838L706.811%20308.009H704.234V309.876H706.684V310.459H704.234V312.534H706.896L706.865%20313.124H703.567ZM710.483%20307.909C710.054%20307.909%20709.683%20308.013%20709.372%20308.221C709.064%20308.43%20708.833%20308.71%20708.682%20309.062C708.53%20309.415%20708.454%20309.82%20708.454%20310.277C708.454%20310.62%20708.495%20310.932%20708.578%20311.215C708.66%20311.495%20708.783%20311.742%20708.948%20311.955C709.112%20312.166%20709.326%20312.331%20709.588%20312.449C709.853%20312.565%20710.157%20312.623%20710.499%20312.623C710.938%20312.623%20711.394%20312.508%20711.864%20312.279L711.976%20312.847C711.593%20313.088%20711.075%20313.209%20710.421%20313.209C709.992%20313.209%20709.606%20313.138%20709.264%20312.997C708.925%20312.853%20708.643%20312.651%20708.419%20312.391C708.198%20312.129%20708.03%20311.818%20707.914%20311.458C707.798%20311.095%20707.741%20310.693%20707.741%20310.25C707.741%20309.824%20707.804%20309.43%20707.93%20309.07C708.056%20308.71%20708.233%20308.401%20708.462%20308.144C708.693%20307.885%20708.981%20307.683%20709.326%20307.539C709.671%20307.395%20710.054%20307.323%20710.475%20307.323C711.116%20307.323%20711.656%20307.464%20712.096%20307.747L711.833%20308.291C711.412%20308.036%20710.961%20307.909%20710.483%20307.909ZM717.145%20313.124H716.327L714.144%20310.401L713.623%20310.86V313.124H712.952V307.419H713.623V310.22L716.13%20307.419H716.967L714.653%20309.988L717.145%20313.124ZM717.407%20311.207V310.64H719.336V311.207H717.407ZM721.037%20313.124H720.37V307.419H721.037V313.124ZM726.927%20313.124H726.171L723.209%20308.634L723.016%20308.368C723.036%20308.908%20723.047%20309.39%20723.047%20309.815V313.124H722.422V307.419H723.166L726.137%20311.909L726.333%20312.175C726.315%20311.355%20726.306%20310.881%20726.306%20310.752V307.419H726.927V313.124ZM728.162%20312.183C728.756%20312.476%20729.392%20312.623%20730.071%20312.623C730.907%20312.623%20731.325%20312.242%20731.325%20311.481C731.325%20311.234%20731.258%20311.035%20731.124%20310.883C730.993%20310.729%20730.753%20310.608%20730.403%20310.521L729.269%20310.235C728.402%20310.016%20727.969%20309.554%20727.969%20308.846C727.969%20308.304%20728.155%20307.901%20728.528%20307.639C728.901%20307.374%20729.417%20307.242%20730.075%20307.242C730.42%20307.242%20730.742%20307.279%20731.043%20307.354C731.344%20307.428%20731.596%20307.528%20731.799%20307.654L731.606%20308.198C731.434%20308.103%20731.205%20308.018%20730.92%20307.944C730.637%20307.869%20730.35%20307.832%20730.06%20307.832C729.129%20307.832%20728.663%20308.155%20728.663%20308.8C728.663%20309.019%20728.734%20309.195%20728.875%20309.329C729.019%20309.46%20729.234%20309.56%20729.52%20309.629L730.603%20309.892C731.066%20310.002%20731.417%20310.18%20731.657%20310.424C731.896%20310.666%20732.015%20311.01%20732.015%20311.458C732.015%20312.039%20731.837%20312.478%20731.479%20312.773C731.124%20313.066%20730.641%20313.213%20730.029%20313.213C729.571%20313.213%20729.163%20313.167%20728.806%20313.074C728.451%20312.979%20728.169%20312.867%20727.961%20312.739L728.162%20312.183ZM693.426%20321.124H692.743V315.354H694.602C694.885%20315.354%20695.141%20315.383%20695.37%20315.442C695.599%20315.501%20695.802%20315.591%20695.979%20315.712C696.157%20315.833%20696.294%20315.995%20696.392%20316.198C696.49%20316.401%20696.539%20316.638%20696.539%20316.908C696.539%20317.132%20696.518%20317.332%20696.477%20317.51C696.436%20317.685%20696.365%20317.849%20696.265%20318.004C696.164%20318.158%20696.033%20318.286%20695.871%20318.389C695.709%20318.49%20695.501%20318.569%20695.246%20318.629C694.994%20318.685%20694.701%20318.713%20694.367%20318.713C694.102%20318.713%20693.788%20318.697%20693.426%20318.663V321.124ZM694.432%20318.123C694.684%20318.123%20694.9%20318.099%20695.08%20318.05C695.26%20318.001%20695.398%20317.941%20695.493%20317.869C695.591%20317.797%20695.667%20317.703%20695.721%20317.587C695.777%20317.471%20695.812%20317.366%20695.825%20317.271C695.838%20317.173%20695.844%20317.056%20695.844%20316.92C695.844%20316.593%20695.734%20316.353%20695.513%20316.198C695.294%20316.044%20694.996%20315.967%20694.618%20315.967H693.426V318.115C693.922%20318.121%20694.258%20318.123%20694.432%20318.123ZM697.325%20321.124V315.419H700.597L700.57%20316.009H697.993V317.876H700.442V318.459H697.993V320.534H700.654L700.624%20321.124H697.325ZM702.317%20315.951V317.88C702.422%20317.88%20702.64%20317.883%20702.969%20317.888C703.301%20317.893%20703.557%20317.896%20703.737%20317.896C704.228%20317.896%20704.57%20317.815%20704.763%20317.653C704.955%20317.488%20705.052%20317.228%20705.052%20316.873C705.052%20316.562%20704.959%20316.331%20704.774%20316.179C704.589%20316.027%20704.279%20315.951%20703.845%20315.951H702.317ZM705.974%20321.124H705.202L704.415%20319.334C704.202%20318.854%20704.066%20318.564%20704.007%20318.467C703.819%20318.479%20703.596%20318.486%20703.339%20318.486L702.317%20318.455V321.124H701.634V315.354H703.459C703.67%20315.354%20703.856%20315.359%20704.018%20315.369C704.18%20315.379%20704.341%20315.399%20704.5%20315.427C704.662%20315.453%20704.802%20315.49%20704.921%20315.539C705.039%20315.585%20705.15%20315.647%20705.252%20315.724C705.355%20315.798%20705.438%20315.888%20705.499%20315.994C705.564%20316.099%20705.614%20316.225%20705.65%20316.372C705.686%20316.516%20705.704%20316.679%20705.704%20316.862C705.704%20317.222%20705.609%20317.532%20705.418%20317.791C705.231%20318.051%20704.963%20318.231%20704.616%20318.331C704.616%20318.337%20704.642%20318.383%20704.693%20318.47C704.745%20318.558%20704.805%20318.666%20704.874%20318.794C704.946%20318.92%20705.002%20319.026%20705.04%20319.111L705.974%20321.124ZM712.308%20315.419H713.021L710.95%20321.124H710.256L708.192%20315.419H708.905L710.175%20319.037C710.339%20319.508%20710.482%20319.952%20710.603%20320.368C710.641%20320.175%20710.785%20319.728%20711.035%20319.026C711.436%20317.876%20711.86%20316.674%20712.308%20315.419ZM714.371%20321.124H713.704V315.419H714.371V321.124ZM715.648%20320.183C716.242%20320.476%20716.879%20320.623%20717.558%20320.623C718.393%20320.623%20718.811%20320.242%20718.811%20319.481C718.811%20319.234%20718.744%20319.035%20718.611%20318.883C718.48%20318.729%20718.239%20318.608%20717.889%20318.521L716.755%20318.235C715.889%20318.016%20715.455%20317.554%20715.455%20316.846C715.455%20316.304%20715.642%20315.901%20716.015%20315.639C716.388%20315.374%20716.903%20315.242%20717.562%20315.242C717.906%20315.242%20718.229%20315.279%20718.53%20315.354C718.831%20315.428%20719.083%20315.528%20719.286%20315.654L719.093%20316.198C718.921%20316.103%20718.692%20316.018%20718.406%20315.944C718.123%20315.869%20717.837%20315.832%20717.546%20315.832C716.615%20315.832%20716.15%20316.155%20716.15%20316.8C716.15%20317.019%20716.22%20317.195%20716.362%20317.329C716.506%20317.46%20716.721%20317.56%20717.006%20317.629L718.09%20317.892C718.553%20318.002%20718.904%20318.18%20719.143%20318.424C719.382%20318.666%20719.502%20319.01%20719.502%20319.458C719.502%20320.039%20719.323%20320.478%20718.966%20320.773C718.611%20321.066%20718.127%20321.213%20717.515%20321.213C717.057%20321.213%20716.65%20321.167%20716.292%20321.074C715.938%20320.979%20715.656%20320.867%20715.448%20320.739L715.648%20320.183ZM721.191%20321.124H720.524V315.419H721.191V321.124ZM724.358%20321.124H723.687V316.009H721.932V315.419H726.113V316.009H724.358V321.124ZM727.228%20318.274C727.228%20319.007%20727.397%20319.583%20727.734%20320.002C728.07%20320.418%20728.568%20320.627%20729.226%20320.627C729.885%20320.627%20730.38%20320.418%20730.711%20320.002C731.046%20319.585%20731.213%20319.009%20731.213%20318.274C731.213%20317.523%20731.044%20316.94%20730.708%20316.526C730.373%20316.112%20729.881%20315.905%20729.23%20315.905C728.58%20315.905%20728.083%20316.112%20727.741%20316.526C727.399%20316.94%20727.228%20317.523%20727.228%20318.274ZM731.927%20318.274C731.927%20318.708%20731.866%20319.106%20731.745%20319.466C731.627%20319.826%20731.455%20320.135%20731.228%20320.395C731.005%20320.652%20730.722%20320.853%20730.38%20320.997C730.038%20321.138%20729.653%20321.209%20729.226%20321.209C728.65%20321.209%20728.157%20321.087%20727.745%20320.843C727.336%20320.596%20727.029%20320.254%20726.823%20319.817C726.62%20319.377%20726.518%20318.861%20726.518%20318.27C726.518%20317.357%20726.756%20316.637%20727.232%20316.11C727.708%20315.582%20728.374%20315.319%20729.23%20315.319C730.074%20315.319%20730.733%20315.585%20731.209%20316.117C731.687%20316.647%20731.927%20317.366%20731.927%20318.274ZM733.608%20315.951V317.88C733.714%20317.88%20733.931%20317.883%20734.26%20317.888C734.592%20317.893%20734.848%20317.896%20735.028%20317.896C735.519%20317.896%20735.861%20317.815%20736.054%20317.653C736.247%20317.488%20736.343%20317.228%20736.343%20316.873C736.343%20316.562%20736.251%20316.331%20736.066%20316.179C735.88%20316.027%20735.571%20315.951%20735.136%20315.951H733.608ZM737.265%20321.124H736.494L735.707%20319.334C735.493%20318.854%20735.357%20318.564%20735.298%20318.467C735.11%20318.479%20734.888%20318.486%20734.631%20318.486L733.608%20318.455V321.124H732.926V315.354H734.75C734.961%20315.354%20735.148%20315.359%20735.31%20315.369C735.472%20315.379%20735.632%20315.399%20735.792%20315.427C735.954%20315.453%20736.094%20315.49%20736.212%20315.539C736.33%20315.585%20736.441%20315.647%20736.544%20315.724C736.647%20315.798%20736.729%20315.888%20736.791%20315.994C736.855%20316.099%20736.905%20316.225%20736.941%20316.372C736.977%20316.516%20736.995%20316.679%20736.995%20316.862C736.995%20317.222%20736.9%20317.532%20736.71%20317.791C736.522%20318.051%20736.255%20318.231%20735.907%20318.331C735.907%20318.337%20735.933%20318.383%20735.985%20318.47C736.036%20318.558%20736.096%20318.666%20736.166%20318.794C736.238%20318.92%20736.293%20319.026%20736.332%20319.111L737.265%20321.124Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M769.5%20287.656L777.57%20287.053L785.379%20207.225L793.449%20220.781L801.258%20230.305L809.328%20199.515L817.398%20283.669L825.207%20287.895L833.277%20266.812L841.086%20316.751L849.156%20300.36L857.225%20279.876L864.775%20289.212L872.844%20269.489L880.654%20234.746L888.723%20239.749L896.533%20224.926L904.602%20246.018L912.672%20281.739L920.481%20267.242L928.551%20290.185L936.361%20330.768L944.43%20312.334L952.5%20302.329'%20stroke='%23AB0FD7'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M769.5%20297.009L777.57%20321.11L785.379%20328.058L793.449%20331.966L801.258%20322.702L809.328%20322.919L817.398%20295.996L825.207%20285.863L833.277%20297.009L841.086%20266.032L849.156%20238.747L857.225%20251.557L864.775%20271.171L872.844%20285.067L880.654%20293.245L888.723%20305.549L896.533%20302.292L904.602%20287.311L912.672%20277.612L920.481%20271.895L928.551%20245.985L936.361%20231.799L944.43%20208.35L952.5%20217.975'%20stroke='%23D78A0F'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cg%20clip-path='url(%23clip37_12_1053)'%3e%3cpath%20d='M766.906%20285.622C766.631%20285.622%20766.385%20285.586%20766.169%20285.514C765.954%20285.442%20765.798%20285.358%20765.699%20285.264L765.872%20284.81C766.162%20285.038%20766.508%20285.153%20766.91%20285.153C767.218%20285.153%20767.463%20285.076%20767.644%20284.924C767.828%20284.77%20767.919%20284.555%20767.919%20284.279C767.919%20284.129%20767.896%20283.998%20767.848%20283.887C767.803%20283.773%20767.741%20283.683%20767.663%20283.615C767.587%20283.545%20767.488%20283.489%20767.367%20283.448C767.247%20283.405%20767.124%20283.375%20766.996%20283.359C766.87%20283.34%20766.724%20283.329%20766.558%20283.325C766.537%20283.325%20766.506%20283.325%20766.465%20283.325C766.424%20283.323%20766.393%20283.322%20766.372%20283.322V282.862H766.527C766.671%20282.86%20766.797%20282.852%20766.906%20282.84C767.018%20282.826%20767.128%20282.801%20767.237%20282.766C767.348%20282.731%20767.44%20282.685%20767.512%20282.627C767.584%20282.569%20767.642%20282.492%20767.688%20282.395C767.733%20282.299%20767.756%20282.184%20767.756%20282.053C767.756%20281.559%20767.473%20281.312%20766.906%20281.312C766.703%20281.312%20766.511%20281.341%20766.332%20281.401C766.153%20281.461%20766%20281.541%20765.872%20281.642L765.699%20281.191C766.006%20280.959%20766.447%20280.842%20767.024%20280.842C767.256%20280.842%20767.471%20280.886%20767.669%20280.972C767.867%20281.056%20768.029%20281.187%20768.157%20281.364C768.285%20281.539%20768.348%20281.745%20768.348%20281.982C768.348%20282.27%20768.277%20282.507%20768.135%20282.692C767.993%20282.877%20767.794%20283.01%20767.536%20283.09C767.825%20283.152%20768.05%20283.287%20768.213%20283.495C768.377%20283.702%20768.46%20283.966%20768.46%20284.285C768.46%20284.69%20768.314%20285.015%20768.024%20285.258C767.734%20285.5%20767.361%20285.622%20766.906%20285.622ZM769.59%20285.588C769.462%20285.588%20769.361%20285.548%20769.287%20285.468C769.215%20285.385%20769.179%20285.289%20769.179%20285.18C769.179%20285.069%20769.215%20284.974%20769.287%20284.893C769.359%20284.813%20769.46%20284.773%20769.59%20284.773C769.719%20284.773%20769.82%20284.813%20769.892%20284.893C769.964%20284.974%20770%20285.069%20770%20285.18C770%20285.292%20769.964%20285.387%20769.892%20285.468C769.82%20285.548%20769.719%20285.588%20769.59%20285.588ZM771.84%20285.622C771.565%20285.622%20771.319%20285.586%20771.103%20285.514C770.888%20285.442%20770.732%20285.358%20770.633%20285.264L770.806%20284.81C771.096%20285.038%20771.442%20285.153%20771.844%20285.153C772.152%20285.153%20772.397%20285.076%20772.578%20284.924C772.762%20284.77%20772.853%20284.555%20772.853%20284.279C772.853%20284.129%20772.83%20283.998%20772.782%20283.887C772.737%20283.773%20772.675%20283.683%20772.597%20283.615C772.521%20283.545%20772.422%20283.489%20772.301%20283.448C772.181%20283.405%20772.058%20283.375%20771.93%20283.359C771.804%20283.34%20771.658%20283.329%20771.492%20283.325C771.471%20283.325%20771.44%20283.325%20771.399%20283.325C771.358%20283.323%20771.327%20283.322%20771.306%20283.322V282.862H771.461C771.605%20282.86%20771.731%20282.852%20771.84%20282.84C771.952%20282.826%20772.062%20282.801%20772.171%20282.766C772.282%20282.731%20772.374%20282.685%20772.446%20282.627C772.518%20282.569%20772.576%20282.492%20772.622%20282.395C772.667%20282.299%20772.69%20282.184%20772.69%20282.053C772.69%20281.559%20772.407%20281.312%20771.84%20281.312C771.637%20281.312%20771.445%20281.341%20771.266%20281.401C771.087%20281.461%20770.934%20281.541%20770.806%20281.642L770.633%20281.191C770.94%20280.959%20771.381%20280.842%20771.958%20280.842C772.19%20280.842%20772.406%20280.886%20772.603%20280.972C772.801%20281.056%20772.963%20281.187%20773.091%20281.364C773.219%20281.539%20773.282%20281.745%20773.282%20281.982C773.282%20282.27%20773.211%20282.507%20773.069%20282.692C772.927%20282.877%20772.728%20283.01%20772.47%20283.09C772.759%20283.152%20772.984%20283.287%20773.147%20283.495C773.311%20283.702%20773.394%20283.966%20773.394%20284.285C773.394%20284.69%20773.248%20285.015%20772.958%20285.258C772.668%20285.5%20772.295%20285.622%20771.84%20285.622Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M950.095%20300.304C949.785%20300.304%20949.509%20300.264%20949.266%20300.183C949.026%20300.102%20948.85%20300.008%20948.739%20299.902L948.933%20299.392C949.259%20299.649%20949.647%20299.777%20950.098%20299.777C950.445%20299.777%20950.72%20299.692%20950.923%20299.52C951.129%20299.347%20951.232%20299.106%20951.232%20298.796C951.232%20298.627%20951.205%20298.48%20951.152%20298.356C951.101%20298.229%20951.032%20298.127%20950.944%20298.051C950.858%20297.972%20950.747%20297.91%20950.611%20297.863C950.477%20297.815%20950.338%20297.781%20950.195%20297.763C950.054%20297.742%20949.89%20297.729%20949.703%20297.725C949.68%20297.725%20949.645%20297.725%20949.599%20297.725C949.553%20297.722%20949.518%20297.721%20949.495%20297.721V297.205H949.668C949.83%20297.202%20949.972%20297.194%20950.095%20297.18C950.219%20297.164%20950.343%20297.136%20950.465%20297.097C950.59%20297.058%20950.693%20297.006%20950.774%20296.941C950.855%20296.876%20950.921%20296.79%20950.972%20296.681C951.022%20296.573%20951.048%20296.444%20951.048%20296.296C951.048%20295.742%20950.73%20295.464%20950.095%20295.464C949.866%20295.464%20949.651%20295.498%20949.45%20295.565C949.249%20295.632%20949.076%20295.722%20948.933%20295.835L948.739%20295.329C949.083%20295.068%20949.579%20294.937%20950.226%20294.937C950.487%20294.937%20950.729%20294.986%20950.951%20295.083C951.173%20295.178%20951.355%20295.325%20951.499%20295.523C951.642%20295.72%20951.714%20295.951%20951.714%20296.217C951.714%20296.54%20951.634%20296.806%20951.474%20297.014C951.315%20297.222%20951.091%20297.371%20950.802%20297.461C951.125%20297.531%20951.378%20297.682%20951.561%20297.915C951.746%20298.149%20951.838%20298.445%20951.838%20298.803C951.838%20299.258%20951.675%20299.622%20951.35%20299.895C951.024%20300.168%20950.605%20300.304%20950.095%20300.304ZM953.107%20300.266C952.964%20300.266%20952.851%20300.221%20952.767%20300.131C952.687%20300.038%20952.646%20299.931%20952.646%20299.808C952.646%20299.683%20952.687%20299.576%20952.767%20299.486C952.848%20299.396%20952.962%20299.351%20953.107%20299.351C953.253%20299.351%20953.366%20299.396%20953.447%20299.486C953.528%20299.576%20953.568%20299.683%20953.568%20299.808C953.568%20299.933%20953.528%20300.041%20953.447%20300.131C953.366%20300.221%20953.253%20300.266%20953.107%20300.266ZM954.962%20295.038H955.513V300.224H954.9V295.679C954.666%20295.832%20954.381%20295.962%20954.043%20296.071V295.492C954.08%20295.476%20954.155%20295.444%20954.269%20295.395C954.382%20295.346%20954.466%20295.309%20954.522%20295.284C954.579%20295.259%20954.651%20295.223%20954.737%20295.177C954.822%20295.13%20954.897%20295.084%20954.962%20295.038Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M808.364%20202.64H807.885V203.685H807.411V202.64H805.507V202.209L807.358%20199.471H807.885V202.232H808.403L808.364%20202.64ZM807.411%20200.111L806.003%20202.232H807.411V200.111ZM809.352%20203.719C809.236%20203.719%20809.144%20203.682%20809.076%20203.609C809.01%20203.534%20808.978%20203.447%20808.978%20203.347C808.978%20203.246%20809.01%20203.158%20809.076%20203.085C809.142%20203.012%20809.234%20202.975%20809.352%20202.975C809.471%20202.975%20809.563%20203.012%20809.628%20203.085C809.694%20203.158%20809.727%20203.246%20809.727%20203.347C809.727%20203.449%20809.694%20203.536%20809.628%20203.609C809.563%20203.682%20809.471%20203.719%20809.352%20203.719ZM812.414%20203.587C812.228%20203.696%20812.01%20203.75%20811.761%20203.75C811.511%20203.75%20811.292%20203.696%20811.104%20203.587C810.916%20203.476%20810.765%20203.321%20810.651%20203.122C810.538%20202.923%20810.454%20202.694%20810.397%20202.435C810.343%20202.175%20810.316%20201.887%20810.316%20201.57C810.316%20201.309%20810.333%20201.067%20810.369%20200.846C810.407%20200.624%20810.464%20200.423%20810.541%20200.243C810.618%20200.063%20810.713%20199.91%20810.825%20199.784C810.94%20199.658%20811.076%20199.561%20811.234%20199.494C811.392%20199.424%20811.567%20199.39%20811.761%20199.39C812.001%20199.39%20812.213%20199.442%20812.397%20199.547C812.583%20199.653%20812.733%20199.803%20812.848%20199.998C812.964%20200.191%20813.052%20200.421%20813.11%20200.685C813.168%20200.948%20813.197%20201.243%20813.197%20201.57C813.197%20201.887%20813.17%20202.175%20813.115%20202.435C813.061%20202.694%20812.977%20202.923%20812.865%20203.122C812.752%20203.321%20812.602%20203.476%20812.414%20203.587ZM812.254%20200.046C812.116%20199.894%20811.952%20199.818%20811.761%20199.818C811.569%20199.818%20811.405%20199.894%20811.268%20200.046C811.131%20200.196%20811.027%20200.401%20810.958%20200.66C810.89%20200.917%20810.856%20201.215%20810.856%20201.553C810.856%20201.897%20810.89%20202.201%20810.958%20202.466C811.027%20202.728%20811.131%20202.937%20811.268%20203.091C811.405%20203.245%20811.569%20203.322%20811.761%20203.322C811.952%20203.322%20812.116%20203.245%20812.254%20203.091C812.391%20202.937%20812.493%20202.728%20812.561%20202.466C812.63%20202.201%20812.665%20201.897%20812.665%20201.553C812.665%20201.215%20812.63%20200.917%20812.561%20200.66C812.493%20200.401%20812.391%20200.196%20812.254%20200.046Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M932.578%20328.664L932.508%20328.166L934.077%20326.425C934.182%20326.308%20934.283%20326.156%20934.38%20325.97C934.479%20325.784%20934.551%20325.626%20934.595%20325.497L934.665%20325.306C934.665%20325.055%20934.595%20324.861%20934.456%20324.723C934.316%20324.584%20934.118%20324.514%20933.861%20324.514C933.433%20324.514%20933.095%20324.638%20932.848%20324.887L932.672%20324.432C932.951%20324.169%20933.36%20324.038%20933.898%20324.038C934.31%20324.038%20934.639%20324.15%20934.884%20324.374C935.128%20324.597%20935.251%20324.895%20935.251%20325.269C935.243%20325.297%20935.23%20325.336%20935.214%20325.384C935.198%20325.431%20935.163%20325.523%20935.108%20325.66C935.055%20325.798%20935%20325.928%20934.941%20326.052C934.883%20326.175%20934.808%20326.311%20934.717%20326.458C934.628%20326.606%20934.537%20326.729%20934.444%20326.828L933.164%20328.196H935.266L935.232%20328.664H932.578ZM936.412%20328.7C936.287%20328.7%20936.188%20328.661%20936.115%20328.582C936.044%20328.501%20936.009%20328.407%20936.009%20328.3C936.009%20328.19%20936.044%20328.096%20936.115%20328.017C936.186%20327.939%20936.285%20327.899%20936.412%20327.899C936.54%20327.899%20936.639%20327.939%20936.71%20328.017C936.78%20328.096%20936.816%20328.19%20936.816%20328.3C936.816%20328.409%20936.78%20328.503%20936.71%20328.582C936.639%20328.661%20936.54%20328.7%20936.412%20328.7ZM938.806%20326.85C938.549%20326.85%20938.312%20326.794%20938.096%20326.683C937.882%20326.569%20937.709%20326.407%20937.577%20326.194C937.446%20325.982%20937.38%20325.74%20937.38%20325.469C937.38%20325.057%20937.522%20324.715%20937.805%20324.444C938.088%20324.173%20938.458%20324.038%20938.915%20324.038C939.152%20324.038%20939.366%20324.076%20939.558%20324.153C939.752%20324.228%20939.911%20324.332%20940.034%20324.465C940.16%20324.597%20940.256%20324.751%20940.323%20324.929C940.391%20325.105%20940.426%20325.296%20940.426%20325.503C940.426%20325.792%20940.376%20326.054%20940.277%20326.288C940.178%20326.523%20940.007%20326.805%20939.764%20327.135C939.677%20327.25%20939.532%20327.435%20939.328%20327.69C939.125%20327.945%20938.944%20328.17%20938.785%20328.366L938.545%20328.664H937.878L939.488%20326.668C939.26%20326.789%20939.032%20326.85%20938.806%20326.85ZM939.852%20325.445C939.852%20325.168%20939.773%20324.942%20939.616%20324.766C939.46%20324.588%20939.233%20324.499%20938.933%20324.499C938.632%20324.499%20938.393%20324.592%20938.217%20324.778C938.041%20324.962%20937.953%20325.189%20937.953%20325.46C937.953%20325.743%20938.038%20325.97%20938.208%20326.14C938.378%20326.31%20938.614%20326.395%20938.915%20326.395C939.235%20326.395%20939.47%20326.307%20939.622%20326.131C939.775%20325.955%20939.852%20325.726%20939.852%20325.445Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M763.017%20288.88H763.551V293.904H762.956V289.501C762.73%20289.649%20762.454%20289.776%20762.127%20289.881V289.32C762.163%20289.304%20762.235%20289.273%20762.345%20289.226C762.455%20289.179%20762.536%20289.143%20762.59%20289.118C762.646%20289.094%20762.716%20289.059%20762.798%20289.014C762.881%20288.969%20762.954%20288.925%20763.017%20288.88ZM764.471%20294.838C764.478%20294.773%20764.497%20294.6%20764.528%20294.321C764.562%20294.043%20764.587%20293.809%20764.605%20293.619C764.623%20293.428%20764.637%20293.262%20764.646%20293.118H765.307V293.266C765.197%20293.709%20765.036%20294.233%20764.824%20294.838H764.471ZM767.944%20290.811C768.226%20290.811%20768.487%20290.878%20768.726%20291.013C768.966%20291.145%20769.158%20291.334%20769.304%20291.58C769.449%20291.824%20769.522%20292.096%20769.522%20292.396C769.522%20292.853%20769.368%20293.231%20769.059%20293.531C768.752%20293.831%20768.347%20293.981%20767.843%20293.981C767.581%20293.981%20767.341%20293.938%20767.124%20293.85C766.909%20293.761%20766.731%20293.641%20766.59%20293.491C766.451%20293.339%20766.343%20293.163%20766.264%20292.964C766.188%20292.762%20766.15%20292.547%20766.15%20292.319C766.15%20291.954%20766.216%20291.628%20766.348%20291.342C766.483%20291.053%20766.724%20290.688%20767.074%20290.247C767.159%20290.139%20767.293%20289.974%20767.477%20289.75C767.66%20289.526%20767.824%20289.329%20767.967%20289.159L768.179%20288.903H768.954L767.188%20291.013C767.441%20290.878%20767.693%20290.811%20767.944%20290.811ZM766.785%20292.383C766.785%20292.582%20766.822%20292.762%20766.896%20292.924C766.972%20293.085%20767.089%20293.217%20767.248%20293.32C767.41%20293.421%20767.601%20293.471%20767.823%20293.471C768.154%20293.471%20768.414%20293.369%20768.602%20293.165C768.792%20292.962%20768.887%20292.709%20768.887%20292.406C768.887%20292.088%20768.792%20291.828%20768.602%20291.624C768.414%20291.418%20768.154%20291.315%20767.823%20291.315C767.471%20291.315%20767.21%20291.414%20767.04%20291.614C766.87%20291.813%20766.785%20292.069%20766.785%20292.383ZM771.5%20293.981C771.2%20293.981%20770.933%20293.942%20770.697%20293.864C770.465%20293.786%20770.294%20293.695%20770.187%20293.592L770.375%20293.098C770.691%20293.347%20771.067%20293.471%20771.504%20293.471C771.839%20293.471%20772.106%20293.388%20772.303%20293.222C772.502%20293.054%20772.602%20292.821%20772.602%20292.52C772.602%20292.357%20772.576%20292.215%20772.524%20292.094C772.475%20291.971%20772.408%20291.872%20772.323%20291.798C772.24%20291.722%20772.133%20291.662%20772.001%20291.617C771.871%20291.57%20771.736%20291.538%20771.598%20291.52C771.461%20291.5%20771.302%20291.487%20771.121%20291.483C771.098%20291.483%20771.065%20291.483%20771.02%20291.483C770.975%20291.48%20770.942%20291.479%20770.919%20291.479V290.979H771.087C771.244%20290.977%20771.381%20290.969%20771.5%20290.955C771.621%20290.94%20771.741%20290.913%20771.86%20290.875C771.98%20290.837%20772.08%20290.786%20772.158%20290.724C772.237%20290.661%20772.301%20290.577%20772.35%20290.472C772.399%20290.367%20772.424%20290.242%20772.424%20290.099C772.424%20289.562%20772.116%20289.293%20771.5%20289.293C771.279%20289.293%20771.07%20289.325%20770.875%20289.39C770.681%20289.455%20770.514%20289.543%20770.375%20289.652L770.187%20289.162C770.521%20288.909%20771.001%20288.783%20771.628%20288.783C771.881%20288.783%20772.115%20288.83%20772.33%20288.924C772.545%20289.015%20772.722%20289.158%20772.86%20289.35C772.999%20289.54%20773.069%20289.764%20773.069%20290.022C773.069%20290.335%20772.991%20290.593%20772.837%20290.794C772.682%20290.996%20772.465%20291.14%20772.185%20291.227C772.499%20291.295%20772.744%20291.441%20772.921%20291.667C773.1%20291.894%20773.189%20292.18%20773.189%20292.527C773.189%20292.968%20773.032%20293.321%20772.716%20293.585C772.4%20293.849%20771.995%20293.981%20771.5%20293.981ZM773.922%20293.904L773.844%20293.353L775.581%20291.426C775.697%20291.296%20775.809%20291.128%20775.917%20290.922C776.026%20290.716%20776.106%20290.541%20776.155%20290.398L776.232%20290.186C776.232%20289.909%20776.155%20289.694%20776%20289.542C775.846%20289.387%20775.627%20289.31%20775.342%20289.31C774.868%20289.31%20774.494%20289.447%20774.221%20289.723L774.026%20289.219C774.335%20288.928%20774.787%20288.783%20775.383%20288.783C775.839%20288.783%20776.203%20288.907%20776.474%20289.155C776.745%20289.402%20776.88%20289.732%20776.88%20290.146C776.871%20290.177%20776.858%20290.22%20776.84%20290.274C776.822%20290.325%20776.783%20290.427%20776.723%20290.579C776.664%20290.732%20776.603%20290.876%20776.538%20291.013C776.473%20291.149%20776.39%20291.299%20776.289%20291.463C776.191%20291.626%20776.09%20291.763%20775.987%20291.872L774.57%20293.387H776.897L776.86%20293.904H773.922Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M945.065%20215.871L944.994%20215.364L946.59%20213.592C946.698%20213.473%20946.8%20213.318%20946.899%20213.129C947%20212.939%20947.073%20212.779%20947.118%20212.647L947.189%20212.453C947.189%20212.197%20947.118%20212%20946.976%20211.86C946.834%20211.718%20946.633%20211.647%20946.371%20211.647C945.935%20211.647%20945.591%20211.773%20945.34%20212.027L945.161%20211.563C945.445%20211.296%20945.861%20211.162%20946.408%20211.162C946.828%20211.162%20947.163%20211.276%20947.412%20211.505C947.661%20211.731%20947.785%20212.035%20947.785%20212.416C947.777%20212.444%20947.765%20212.483%20947.748%20212.533C947.732%20212.58%20947.696%20212.674%20947.64%20212.814C947.587%20212.954%20947.53%20213.087%20947.47%20213.212C947.411%20213.338%20947.335%20213.476%20947.242%20213.626C947.151%20213.776%20947.059%20213.902%20946.964%20214.003L945.661%20215.395H947.801L947.767%20215.871H945.065ZM948.499%20216.729C948.505%20216.669%20948.522%20216.511%20948.551%20216.253C948.582%20215.998%20948.606%20215.783%20948.622%20215.608C948.639%20215.433%20948.651%20215.28%20948.659%20215.148H949.267V215.284C949.167%20215.692%20949.018%20216.173%20948.823%20216.729H948.499ZM950.53%20215.871L952.117%20211.73H950.033L950.067%20211.252H952.744V211.671L951.092%20215.871H950.53ZM953.321%20215.871L953.25%20215.364L954.847%20213.592C954.954%20213.473%20955.057%20213.318%20955.156%20213.129C955.256%20212.939%20955.329%20212.779%20955.375%20212.647L955.446%20212.453C955.446%20212.197%20955.375%20212%20955.233%20211.86C955.091%20211.718%20954.889%20211.647%20954.628%20211.647C954.191%20211.647%20953.847%20211.773%20953.596%20212.027L953.417%20211.563C953.701%20211.296%20954.117%20211.162%20954.665%20211.162C955.085%20211.162%20955.419%20211.276%20955.668%20211.505C955.917%20211.731%20956.042%20212.035%20956.042%20212.416C956.033%20212.444%20956.021%20212.483%20956.005%20212.533C955.988%20212.58%20955.952%20212.674%20955.897%20212.814C955.843%20212.954%20955.786%20213.087%20955.727%20213.212C955.667%20213.338%20955.591%20213.476%20955.498%20213.626C955.408%20213.776%20955.315%20213.902%20955.22%20214.003L953.917%20215.395H956.057L956.023%20215.871H953.321ZM959.883%20214.725H959.358V215.871H958.839V214.725H956.752V214.253L958.78%20211.252H959.358V214.277H959.926L959.883%20214.725ZM958.839%20211.952L957.295%20214.277H958.839V211.952Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M936.969%20206.245L936.897%20205.73L938.521%20203.926C938.63%20203.805%20938.734%20203.648%20938.835%20203.455C938.938%20203.262%20939.012%20203.099%20939.058%20202.965L939.13%20202.767C939.13%20202.507%20939.058%20202.306%20938.914%20202.164C938.769%20202.019%20938.564%20201.947%20938.298%20201.947C937.854%20201.947%20937.504%20202.076%20937.248%20202.333L937.066%20201.862C937.355%20201.59%20937.778%20201.454%20938.335%20201.454C938.763%20201.454%20939.103%20201.57%20939.357%20201.802C939.61%20202.033%20939.737%20202.342%20939.737%20202.729C939.728%20202.759%20939.716%20202.798%20939.699%20202.849C939.682%20202.897%20939.646%20202.992%20939.589%20203.135C939.535%20203.277%20939.477%20203.412%20939.416%20203.54C939.356%20203.668%20939.278%20203.808%20939.184%20203.961C939.092%20204.114%20938.997%20204.241%20938.901%20204.344L937.575%20205.761H939.752L939.718%20206.245H936.969ZM940.462%20207.118C940.469%20207.058%20940.487%20206.896%20940.516%20206.634C940.547%20206.375%20940.571%20206.156%20940.588%20205.978C940.605%20205.8%20940.617%20205.644%20940.626%20205.51H941.245V205.648C941.142%20206.063%20940.991%20206.553%20940.792%20207.118H940.462ZM943.576%20206.317C943.291%20206.317%20943.033%20206.27%20942.803%20206.176C942.575%20206.079%20942.389%20205.933%20942.247%20205.736C942.105%20205.539%20942.033%20205.305%20942.033%20205.035C942.033%20204.736%20942.119%20204.475%20942.291%20204.253C942.463%20204.031%20942.703%20203.87%20943.01%20203.769C942.424%20203.562%20942.131%20203.185%20942.131%20202.638C942.131%20202.267%20942.265%20201.977%20942.533%20201.768C942.801%20201.558%20943.149%20201.454%20943.576%20201.454C944.001%20201.454%20944.346%20201.558%20944.61%20201.768C944.874%20201.977%20945.005%20202.267%20945.005%20202.638C945.005%20202.915%20944.934%20203.147%20944.792%20203.336C944.649%20203.524%20944.45%20203.669%20944.195%20203.769C944.478%20203.87%20944.7%20204.031%20944.861%20204.253C945.022%20204.475%20945.103%20204.736%20945.103%20205.035C945.103%20205.437%20944.957%20205.752%20944.666%20205.978C944.377%20206.204%20944.014%20206.317%20943.576%20206.317ZM943.576%20204.036C943.276%20204.105%20943.037%20204.222%20942.856%20204.385C942.676%20204.546%20942.586%20204.75%20942.586%20204.998C942.586%20205.255%20942.68%20205.46%20942.866%20205.613C943.052%20205.764%20943.289%20205.84%20943.576%20205.84C943.863%20205.84%20944.096%20205.764%20944.277%20205.613C944.459%20205.46%20944.55%20205.255%20944.55%20204.998C944.55%20204.748%20944.462%20204.543%20944.286%20204.382C944.11%20204.218%20943.873%20204.103%20943.576%20204.036ZM943.576%20201.931C943.329%20201.931%20943.118%20201.993%20942.944%20202.117C942.773%20202.24%20942.687%20202.41%20942.687%20202.626C942.687%20203.12%20942.983%20203.433%20943.576%20203.565C944.16%20203.433%20944.453%20203.12%20944.453%20202.626C944.453%20202.41%20944.368%20202.24%20944.198%20202.117C944.028%20201.993%20943.821%20201.931%20943.576%20201.931ZM948.578%20201.545L948.534%20202.06H946.614C946.593%20202.67%20946.577%20203.163%20946.567%20203.54C946.804%20203.389%20947.06%20203.314%20947.337%20203.314C947.569%20203.314%20947.777%20203.351%20947.959%20203.427C948.143%20203.5%20948.293%20203.602%20948.408%20203.731C948.525%20203.861%20948.614%20204.013%20948.675%20204.187C948.736%20204.359%20948.766%20204.545%20948.766%20204.746C948.766%20205.222%20948.613%20205.603%20948.307%20205.89C948.004%20206.175%20947.59%20206.317%20947.066%20206.317C946.541%20206.317%20946.12%20206.174%20945.803%20205.887L946.008%20205.444C946.318%20205.687%20946.677%20205.808%20947.085%20205.808C947.429%20205.808%20947.7%20205.711%20947.899%20205.516C948.098%20205.321%20948.198%20205.067%20948.198%20204.753C948.198%20204.472%20948.114%20204.245%20947.946%20204.071C947.779%20203.895%20947.54%20203.807%20947.23%20203.807C946.92%20203.807%20946.671%20203.911%20946.482%20204.118L946.045%20204.058L946.168%20201.545H948.578ZM949.944%20206.245L951.559%20202.032H949.439L949.473%20201.545H952.197V201.972L950.516%20206.245H949.944Z'%20fill='%23B5B7BA'%20/%3e%3cpath%20d='M786.855%20324.675H787.406V329.861H786.793V325.316C786.559%20325.469%20786.274%20325.599%20785.936%20325.708V325.129C785.973%20325.113%20786.048%20325.081%20786.162%20325.032C786.275%20324.984%20786.359%20324.947%20786.415%20324.921C786.473%20324.896%20786.544%20324.86%20786.63%20324.814C786.715%20324.767%20786.79%20324.721%20786.855%20324.675ZM788.356%20330.825C788.363%20330.758%20788.383%20330.58%20788.415%20330.291C788.45%20330.005%20788.476%20329.763%20788.495%20329.567C788.513%20329.37%20788.527%20329.198%20788.536%20329.05H789.219V329.203C789.106%20329.66%20788.94%20330.201%20788.72%20330.825H788.356ZM790.779%20324.675H791.331V329.861H790.717V325.316C790.484%20325.469%20790.198%20325.599%20789.861%20325.708V325.129C789.898%20325.113%20789.973%20325.081%20790.086%20325.032C790.199%20324.984%20790.284%20324.947%20790.339%20324.921C790.397%20324.896%20790.469%20324.86%20790.554%20324.814C790.64%20324.767%20790.715%20324.721%20790.779%20324.675ZM795.792%20328.575H795.203V329.861H794.621V328.575H792.277V328.045L794.555%20324.675H795.203V328.072H795.841L795.792%20328.575ZM794.621%20325.462L792.887%20328.072H794.621V325.462ZM798.032%20327.788C797.739%20327.788%20797.468%20327.725%20797.221%20327.598C796.976%20327.468%20796.778%20327.282%20796.628%20327.039C796.478%20326.797%20796.403%20326.52%20796.403%20326.211C796.403%20325.739%20796.564%20325.349%20796.888%20325.039C797.212%20324.729%20797.635%20324.574%20798.157%20324.574C798.427%20324.574%20798.672%20324.618%20798.892%20324.706C799.114%20324.792%20799.295%20324.911%20799.436%20325.063C799.579%20325.214%20799.689%20325.39%20799.765%20325.594C799.844%20325.795%20799.883%20326.013%20799.883%20326.249C799.883%20326.579%20799.827%20326.879%20799.713%20327.147C799.6%20327.415%20799.405%20327.737%20799.128%20328.114C799.028%20328.246%20798.862%20328.457%20798.628%20328.748C798.397%20329.04%20798.19%20329.297%20798.008%20329.522L797.734%20329.861H796.971L798.812%20327.58C798.551%20327.719%20798.291%20327.788%20798.032%20327.788ZM799.228%20326.183C799.228%20325.866%20799.138%20325.608%20798.958%20325.406C798.78%20325.203%20798.52%20325.101%20798.178%20325.101C797.833%20325.101%20797.561%20325.208%20797.359%20325.42C797.158%20325.631%20797.058%20325.891%20797.058%20326.2C797.058%20326.524%20797.155%20326.783%20797.349%20326.977C797.543%20327.171%20797.812%20327.268%20798.157%20327.268C798.522%20327.268%20798.791%20327.168%20798.965%20326.967C799.14%20326.765%20799.228%20326.504%20799.228%20326.183Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip38_12_1053)'%3e%3cpath%20d='M767.25%20516.583L775.32%20487.849L783.129%20480.966L791.199%20483.642L799.008%20482.004L807.078%20474.202L815.148%20459.449L822.957%20459.094L831.027%20449.01L838.836%20488.432L846.906%20494.601L854.975%20472.023L862.525%20460.375L870.594%20448.007L878.404%20470.445L886.473%20447.173L894.283%20435.431L902.352%20415.548L910.422%20403.573L918.231%20417.981L926.301%20440.953L934.111%20459.798L942.18%20453.975L950.25%20451.857'%20stroke='%23AB0FD7'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3cpath%20d='M767.25%20427.942L775.32%20424.958L783.129%20401.967L791.199%20406.063L799.008%20408.536L807.078%20399L815.148%20421.206L822.957%20422.376L831.027%20415.326L838.836%20433.262L846.906%20429.296L854.975%20421.382L862.525%20422.876L870.594%20415.993L878.404%20408.49L886.473%20407.343L894.283%20401.74L902.352%20405.721L910.422%20415.098L918.231%20412.251L926.301%20421.262L934.111%20434.656L942.18%20428.871L950.25%20425.807'%20stroke='%23D78A0F'%20stroke-width='2.25'%20stroke-linecap='round'%20stroke-linejoin='round'%20/%3e%3c/g%3e%3cg%20clip-path='url(%23clip39_12_1053)'%3e%3cg%20filter='url(%23filter7_f_12_1053)'%3e%3cpath%20d='M763.032%20509.618H763.305V510.1C763.793%20510.115%20764.189%20510.218%20764.494%20510.407L764.35%20510.812C764.233%20510.747%20764.079%20510.689%20763.888%20510.637C763.698%20510.583%20763.504%20510.552%20763.305%20510.542V512.001L763.604%20512.072C763.948%20512.155%20764.209%20512.287%20764.387%20512.468C764.565%20512.648%20764.654%20512.905%20764.654%20513.238C764.654%20513.649%20764.534%20513.964%20764.293%20514.182C764.053%20514.401%20763.724%20514.52%20763.305%20514.541V515.038H763.032V514.541C762.726%20514.532%20762.452%20514.493%20762.211%20514.426C761.972%20514.358%20761.781%20514.279%20761.637%20514.191L761.786%20513.778C762.173%20513.967%20762.588%20514.074%20763.032%20514.099V512.434L762.61%20512.328C761.965%20512.165%20761.643%20511.821%20761.643%20511.294C761.643%20510.917%20761.765%20510.631%20762.01%20510.436C762.255%20510.239%20762.596%20510.129%20763.032%20510.106V509.618ZM763.032%20511.934V510.545C762.45%20510.579%20762.16%20510.818%20762.16%20511.26C762.16%20511.423%20762.212%20511.554%20762.317%20511.653C762.425%20511.751%20762.584%20511.825%20762.797%20511.877L763.032%20511.934ZM763.305%20512.503V514.102C763.862%20514.073%20764.141%20513.791%20764.141%20513.255C764.141%20513.071%20764.091%20512.923%20763.991%20512.81C763.894%20512.695%20763.715%20512.605%20763.454%20512.54L763.305%20512.503ZM766.529%20512.761C766.286%20512.761%20766.062%20512.709%20765.857%20512.603C765.654%20512.496%20765.491%20512.342%20765.366%20512.141C765.242%20511.94%20765.18%20511.712%20765.18%20511.455C765.18%20511.065%20765.314%20510.741%20765.582%20510.485C765.85%20510.228%20766.2%20510.1%20766.632%20510.1C766.856%20510.1%20767.059%20510.136%20767.241%20510.209C767.425%20510.28%20767.575%20510.378%20767.692%20510.505C767.811%20510.629%20767.901%20510.776%20767.965%20510.944C768.03%20511.111%20768.062%20511.291%20768.062%20511.487C768.062%20511.76%20768.015%20512.008%20767.922%20512.23C767.828%20512.452%20767.666%20512.719%20767.436%20513.031C767.354%20513.14%20767.216%20513.315%20767.023%20513.557C766.832%20513.798%20766.66%20514.011%20766.509%20514.197L766.282%20514.478H765.651L767.175%20512.589C766.959%20512.704%20766.744%20512.761%20766.529%20512.761ZM767.52%20511.432C767.52%20511.17%20767.445%20510.956%20767.296%20510.789C767.148%20510.621%20766.933%20510.536%20766.65%20510.536C766.365%20510.536%20766.139%20510.624%20765.972%20510.8C765.806%20510.975%20765.722%20511.19%20765.722%20511.446C765.722%20511.714%20765.803%20511.929%20765.964%20512.09C766.124%20512.25%20766.347%20512.331%20766.632%20512.331C766.935%20512.331%20767.158%20512.247%20767.301%20512.081C767.447%20511.914%20767.52%20511.698%20767.52%20511.432ZM769.03%20514.513C768.911%20514.513%20768.817%20514.475%20768.748%20514.401C768.681%20514.324%20768.648%20514.235%20768.648%20514.134C768.648%20514.03%20768.681%20513.941%20768.748%20513.867C768.815%20513.792%20768.909%20513.755%20769.03%20513.755C769.15%20513.755%20769.244%20513.792%20769.311%20513.867C769.378%20513.941%20769.412%20514.03%20769.412%20514.134C769.412%20514.237%20769.378%20514.326%20769.311%20514.401C769.244%20514.475%20769.15%20514.513%20769.03%20514.513ZM772.92%20513.413H772.432V514.478H771.949V513.413H770.009V512.974L771.895%20510.183H772.432V512.997H772.96L772.92%20513.413ZM771.949%20510.835L770.514%20512.997H771.949V510.835Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter8_f_12_1053)'%3e%3cpath%20d='M946.064%20444.8H946.342V445.292C946.839%20445.307%20947.243%20445.411%20947.553%20445.605L947.406%20446.017C947.287%20445.951%20947.13%20445.891%20946.935%20445.839C946.742%20445.784%20946.544%20445.752%20946.342%20445.742V447.228L946.646%20447.301C946.997%20447.385%20947.263%20447.519%20947.444%20447.705C947.626%20447.888%20947.716%20448.149%20947.716%20448.489C947.716%20448.908%20947.594%20449.229%20947.348%20449.451C947.104%20449.673%20946.769%20449.795%20946.342%20449.817V450.323H946.064V449.817C945.752%20449.807%20945.473%20449.768%20945.227%20449.7C944.983%20449.629%20944.788%20449.55%20944.642%20449.46L944.794%20449.039C945.188%20449.232%20945.611%20449.341%20946.064%20449.366V447.67L945.634%20447.561C944.977%20447.396%20944.648%20447.045%20944.648%20446.508C944.648%20446.124%20944.773%20445.833%20945.022%20445.634C945.272%20445.433%20945.619%20445.321%20946.064%20445.297V444.8ZM946.064%20447.161V445.745C945.471%20445.78%20945.175%20446.023%20945.175%20446.473C945.175%20446.639%20945.228%20446.773%20945.335%20446.874C945.445%20446.973%20945.607%20447.05%20945.824%20447.102L946.064%20447.161ZM946.342%20447.74V449.369C946.909%20449.34%20947.193%20449.052%20947.193%20448.506C947.193%20448.319%20947.142%20448.168%20947.041%20448.053C946.941%20447.936%20946.759%20447.844%20946.494%20447.778L946.342%20447.74ZM949.627%20448.003C949.379%20448.003%20949.151%20447.949%20948.942%20447.842C948.735%20447.733%20948.569%20447.576%20948.442%20447.371C948.315%20447.167%20948.252%20446.933%20948.252%20446.672C948.252%20446.274%20948.388%20445.945%20948.661%20445.683C948.934%20445.422%20949.291%20445.292%20949.732%20445.292C949.96%20445.292%20950.167%20445.329%20950.352%20445.403C950.539%20445.475%20950.692%20445.575%20950.811%20445.704C950.932%20445.831%20951.025%20445.98%20951.089%20446.152C951.155%20446.321%20951.189%20446.505%20951.189%20446.704C951.189%20446.983%20951.141%20447.236%20951.045%20447.462C950.95%20447.688%20950.785%20447.96%20950.551%20448.278C950.467%20448.389%20950.327%20448.568%20950.13%20448.813C949.935%20449.059%20949.76%20449.277%20949.606%20449.466L949.375%20449.752H948.731L950.285%20447.828C950.064%20447.945%20949.845%20448.003%20949.627%20448.003ZM950.636%20446.649C950.636%20446.382%20950.56%20446.163%20950.408%20445.994C950.257%20445.822%20950.038%20445.736%20949.749%20445.736C949.459%20445.736%20949.229%20445.826%20949.059%20446.005C948.889%20446.183%20948.805%20446.402%20948.805%20446.663C948.805%20446.936%20948.886%20447.155%20949.05%20447.319C949.214%20447.482%20949.441%20447.564%20949.732%20447.564C950.04%20447.564%20950.267%20447.48%20950.413%20447.31C950.562%20447.14%20950.636%20446.92%20950.636%20446.649ZM952.174%20449.787C952.053%20449.787%20951.958%20449.749%20951.888%20449.673C951.819%20449.595%20951.785%20449.505%20951.785%20449.401C951.785%20449.296%20951.819%20449.205%20951.888%20449.129C951.956%20449.053%20952.051%20449.015%20952.174%20449.015C952.297%20449.015%20952.393%20449.053%20952.461%20449.129C952.529%20449.205%20952.563%20449.296%20952.563%20449.401C952.563%20449.507%20952.529%20449.597%20952.461%20449.673C952.393%20449.749%20952.297%20449.787%20952.174%20449.787ZM954.482%20448.003C954.235%20448.003%20954.006%20447.949%20953.798%20447.842C953.591%20447.733%20953.424%20447.576%20953.298%20447.371C953.171%20447.167%20953.107%20446.933%20953.107%20446.672C953.107%20446.274%20953.244%20445.945%20953.517%20445.683C953.79%20445.422%20954.147%20445.292%20954.588%20445.292C954.816%20445.292%20955.022%20445.329%20955.208%20445.403C955.395%20445.475%20955.548%20445.575%20955.667%20445.704C955.788%20445.831%20955.88%20445.98%20955.945%20446.152C956.011%20446.321%20956.044%20446.505%20956.044%20446.704C956.044%20446.983%20955.996%20447.236%20955.901%20447.462C955.805%20447.688%20955.641%20447.96%20955.407%20448.278C955.323%20448.389%20955.182%20448.568%20954.985%20448.813C954.79%20449.059%20954.616%20449.277%20954.462%20449.466L954.231%20449.752H953.587L955.14%20447.828C954.92%20447.945%20954.701%20448.003%20954.482%20448.003ZM955.491%20446.649C955.491%20446.382%20955.415%20446.163%20955.263%20445.994C955.113%20445.822%20954.894%20445.736%20954.605%20445.736C954.315%20445.736%20954.084%20445.826%20953.915%20446.005C953.745%20446.183%20953.66%20446.402%20953.66%20446.663C953.66%20446.936%20953.742%20447.155%20953.906%20447.319C954.07%20447.482%20954.297%20447.564%20954.588%20447.564C954.896%20447.564%20955.123%20447.48%20955.269%20447.31C955.417%20447.14%20955.491%20446.92%20955.491%20446.649Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter9_f_12_1053)'%3e%3cpath%20d='M904.635%20399.274H904.939V399.811C905.482%20399.828%20905.923%20399.942%20906.262%20400.153L906.102%20400.604C905.972%20400.532%20905.801%20400.467%20905.588%20400.409C905.377%20400.349%20905.161%20400.314%20904.939%20400.304V401.927L905.271%20402.007C905.655%20402.099%20905.946%20402.246%20906.144%20402.448C906.342%20402.648%20906.441%20402.934%20906.441%20403.305C906.441%20403.763%20906.307%20404.113%20906.038%20404.356C905.772%20404.599%20905.406%20404.732%20904.939%20404.755V405.308H904.635V404.755C904.294%20404.745%20903.99%20404.702%20903.721%20404.628C903.455%20404.551%20903.242%20404.464%20903.082%20404.366L903.248%20403.905C903.679%20404.116%20904.141%20404.236%20904.635%20404.263V402.41L904.166%20402.291C903.448%20402.11%20903.089%20401.727%20903.089%20401.141C903.089%20400.721%20903.225%20400.403%20903.498%20400.185C903.77%20399.966%20904.15%20399.843%20904.635%20399.818V399.274ZM904.635%20401.854V400.307C903.988%20400.345%20903.664%20400.61%20903.664%20401.103C903.664%20401.284%20903.722%20401.43%20903.84%20401.54C903.959%20401.649%20904.137%20401.732%20904.373%20401.79L904.635%20401.854ZM904.939%20402.486V404.267C905.559%20404.235%20905.869%20403.92%20905.869%20403.324C905.869%20403.119%20905.814%20402.954%20905.703%20402.828C905.594%20402.7%20905.395%20402.6%20905.105%20402.528L904.939%20402.486ZM907.716%20399.904H908.224V404.685H907.659V400.495C907.444%20400.636%20907.18%20400.756%20906.869%20400.856V400.323C906.903%20400.308%20906.973%20400.278%20907.077%20400.233C907.182%20400.188%20907.259%20400.154%20907.31%20400.131C907.364%20400.108%20907.43%20400.074%20907.509%20400.032C907.587%20399.989%20907.657%20399.947%20907.716%20399.904ZM911.481%20404.573C911.27%20404.697%20911.023%20404.759%20910.74%20404.759C910.456%20404.759%20910.208%20404.697%20909.995%20404.573C909.782%20404.448%20909.61%20404.272%20909.48%20404.046C909.353%20403.82%20909.257%20403.56%20909.193%20403.266C909.131%20402.972%20909.1%20402.645%20909.1%20402.285C909.1%20401.989%20909.12%20401.715%20909.161%20401.464C909.203%20401.212%20909.268%20400.984%20909.356%20400.78C909.443%20400.575%20909.551%20400.402%20909.679%20400.259C909.809%20400.116%20909.963%20400.006%20910.142%20399.93C910.321%20399.851%20910.52%20399.811%20910.74%20399.811C911.012%20399.811%20911.253%20399.871%20911.462%20399.99C911.673%20400.11%20911.843%20400.28%20911.973%20400.502C912.105%20400.721%20912.204%20400.981%20912.271%20401.281C912.337%20401.58%20912.37%20401.914%20912.37%20402.285C912.37%20402.645%20912.339%20402.972%20912.277%20403.266C912.215%20403.56%20912.12%20403.82%20911.992%20404.046C911.865%20404.272%20911.694%20404.448%20911.481%20404.573ZM911.299%20400.556C911.143%20400.383%20910.957%20400.297%20910.74%20400.297C910.522%20400.297%20910.336%20400.383%20910.18%20400.556C910.025%20400.726%20909.908%20400.959%20909.829%20401.253C909.752%20401.545%20909.714%20401.882%20909.714%20402.266C909.714%20402.656%20909.752%20403.001%20909.829%20403.301C909.908%20403.6%20910.025%20403.836%20910.18%20404.011C910.336%20404.186%20910.522%20404.273%20910.74%20404.273C910.957%20404.273%20911.143%20404.186%20911.299%20404.011C911.454%20403.836%20911.571%20403.6%20911.647%20403.301C911.726%20403.001%20911.766%20402.656%20911.766%20402.266C911.766%20401.882%20911.726%20401.545%20911.647%20401.253C911.571%20400.959%20911.454%20400.726%20911.299%20400.556ZM913.555%20404.724C913.423%20404.724%20913.319%20404.682%20913.242%20404.599C913.168%20404.514%20913.13%20404.415%20913.13%20404.302C913.13%20404.187%20913.168%20404.088%20913.242%20404.004C913.317%20403.921%20913.421%20403.88%20913.555%20403.88C913.69%20403.88%20913.794%20403.921%20913.869%20404.004C913.943%20404.088%20913.98%20404.187%20913.98%20404.302C913.98%20404.417%20913.943%20404.516%20913.869%20404.599C913.794%20404.682%20913.69%20404.724%20913.555%20404.724ZM917.886%20403.499H917.343V404.685H916.806V403.499H914.645V403.011L916.745%20399.904H917.343V403.036H917.931L917.886%20403.499ZM916.806%20400.63L915.208%20403.036H916.806V400.63Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter10_f_12_1053)'%3e%3cpath%20d='M842.688%20487.636H842.961V488.118C843.449%20488.134%20843.845%20488.236%20844.149%20488.426L844.006%20488.83C843.889%20488.765%20843.735%20488.707%20843.544%20488.655C843.354%20488.602%20843.16%20488.57%20842.961%20488.561V490.019L843.259%20490.091C843.604%20490.173%20843.865%20490.305%20844.043%20490.487C844.221%20490.667%20844.31%20490.923%20844.31%20491.256C844.31%20491.668%20844.19%20491.983%20843.948%20492.201C843.709%20492.419%20843.38%20492.539%20842.961%20492.56V493.056H842.688V492.56C842.382%20492.55%20842.108%20492.512%20841.867%20492.445C841.628%20492.376%20841.436%20492.298%20841.293%20492.209L841.442%20491.796C841.829%20491.986%20842.244%20492.093%20842.688%20492.118V490.452L842.266%20490.346C841.621%20490.184%20841.299%20489.839%20841.299%20489.313C841.299%20488.936%20841.421%20488.65%20841.666%20488.454C841.911%20488.257%20842.252%20488.147%20842.688%20488.124V487.636ZM842.688%20489.953V488.563C842.106%20488.598%20841.815%20488.836%20841.815%20489.278C841.815%20489.441%20841.868%20489.572%20841.973%20489.672C842.08%20489.769%20842.24%20489.844%20842.453%20489.896L842.688%20489.953ZM842.961%20490.521V492.12C843.518%20492.092%20843.796%20491.809%20843.796%20491.274C843.796%20491.09%20843.747%20490.941%20843.647%20490.829C843.549%20490.714%20843.37%20490.624%20843.11%20490.559L842.961%20490.521ZM846.185%20490.78C845.942%20490.78%20845.718%20490.727%20845.513%20490.622C845.31%20490.515%20845.147%20490.361%20845.022%20490.16C844.898%20489.959%20844.836%20489.73%20844.836%20489.473C844.836%20489.083%20844.97%20488.76%20845.237%20488.503C845.505%20488.247%20845.856%20488.118%20846.288%20488.118C846.512%20488.118%20846.715%20488.155%20846.897%20488.227C847.081%20488.298%20847.231%20488.397%20847.348%20488.523C847.466%20488.648%20847.557%20488.794%20847.62%20488.962C847.685%20489.129%20847.718%20489.31%20847.718%20489.505C847.718%20489.779%20847.671%20490.027%20847.577%20490.249C847.484%20490.471%20847.322%20490.738%20847.092%20491.05C847.01%20491.159%20846.872%20491.334%20846.679%20491.575C846.487%20491.816%20846.316%20492.03%20846.165%20492.215L845.938%20492.497H845.306L846.831%20490.608C846.615%20490.722%20846.399%20490.78%20846.185%20490.78ZM847.175%20489.451C847.175%20489.188%20847.101%20488.974%20846.951%20488.807C846.804%20488.639%20846.589%20488.555%20846.305%20488.555C846.02%20488.555%20845.794%20488.643%20845.628%20488.819C845.461%20488.993%20845.378%20489.208%20845.378%20489.465C845.378%20489.733%20845.459%20489.947%20845.619%20490.108C845.78%20490.269%20846.003%20490.349%20846.288%20490.349C846.591%20490.349%20846.814%20490.266%20846.957%20490.099C847.103%20489.933%20847.175%20489.717%20847.175%20489.451ZM848.685%20492.531C848.567%20492.531%20848.473%20492.494%20848.404%20492.419C848.337%20492.343%20848.304%20492.254%20848.304%20492.152C848.304%20492.049%20848.337%20491.96%20848.404%20491.885C848.471%20491.81%20848.565%20491.773%20848.685%20491.773C848.806%20491.773%20848.9%20491.81%20848.967%20491.885C849.034%20491.96%20849.067%20492.049%20849.067%20492.152C849.067%20492.255%20849.034%20492.344%20848.967%20492.419C848.9%20492.494%20848.806%20492.531%20848.685%20492.531ZM851.183%20489.852C851.424%20489.852%20851.647%20489.91%20851.852%20490.025C852.057%20490.138%20852.222%20490.299%20852.346%20490.51C852.47%20490.719%20852.533%20490.951%20852.533%20491.208C852.533%20491.598%20852.4%20491.921%20852.136%20492.178C851.874%20492.434%20851.528%20492.563%20851.097%20492.563C850.873%20492.563%20850.668%20492.525%20850.483%20492.451C850.299%20492.374%20850.147%20492.272%20850.026%20492.143C849.908%20492.013%20849.815%20491.863%20849.748%20491.693C849.683%20491.52%20849.65%20491.337%20849.65%20491.141C849.65%20490.83%20849.707%20490.551%20849.82%20490.306C849.934%20490.059%20850.141%20489.747%20850.44%20489.37C850.512%20489.278%20850.627%20489.137%20850.784%20488.945C850.941%20488.754%20851.081%20488.585%20851.203%20488.44L851.384%20488.222H852.047L850.537%20490.025C850.754%20489.91%20850.969%20489.852%20851.183%20489.852ZM850.193%20491.196C850.193%20491.366%20850.224%20491.52%20850.287%20491.658C850.353%20491.796%20850.453%20491.909%20850.589%20491.997C850.727%20492.083%20850.89%20492.126%20851.08%20492.126C851.363%20492.126%20851.585%20492.039%20851.746%20491.865C851.909%20491.691%20851.99%20491.475%20851.99%20491.216C851.99%20490.944%20851.909%20490.721%20851.746%20490.547C851.585%20490.371%20851.363%20490.283%20851.08%20490.283C850.779%20490.283%20850.556%20490.368%20850.411%20490.539C850.265%20490.709%20850.193%20490.928%20850.193%20491.196Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter11_f_12_1053)'%3e%3cpath%20d='M761.449%20420.885H761.727V421.376C762.224%20421.392%20762.628%20421.496%20762.938%20421.689L762.792%20422.102C762.673%20422.035%20762.516%20421.976%20762.321%20421.923C762.128%20421.869%20761.93%20421.837%20761.727%20421.827V423.313L762.031%20423.386C762.382%20423.47%20762.648%20423.604%20762.83%20423.79C763.011%20423.973%20763.102%20424.234%20763.102%20424.574C763.102%20424.993%20762.979%20425.314%20762.733%20425.536C762.489%20425.758%20762.154%20425.88%20761.727%20425.902V426.408H761.449V425.902C761.137%20425.892%20760.858%20425.853%20760.612%20425.785C760.369%20425.714%20760.174%20425.634%20760.027%20425.545L760.18%20425.123C760.573%20425.316%20760.997%20425.426%20761.449%20425.451V423.754L761.019%20423.646C760.362%20423.48%20760.033%20423.129%20760.033%20422.593C760.033%20422.209%20760.158%20421.918%20760.408%20421.719C760.657%20421.518%20761.004%20421.406%20761.449%20421.382V420.885ZM761.449%20423.246V421.83C760.856%20421.865%20760.56%20422.108%20760.56%20422.558C760.56%20422.724%20760.613%20422.857%20760.721%20422.959C760.83%20423.058%20760.993%20423.134%20761.209%20423.187L761.449%20423.246ZM761.727%20423.825V425.454C762.294%20425.425%20762.578%20425.137%20762.578%20424.591C762.578%20424.404%20762.527%20424.253%20762.426%20424.138C762.327%20424.021%20762.144%20423.929%20761.879%20423.863L761.727%20423.825ZM764.836%20425.904C764.575%20425.904%20764.342%20425.87%20764.137%20425.802C763.934%20425.734%20763.786%20425.655%20763.693%20425.565L763.856%20425.135C764.131%20425.352%20764.459%20425.46%20764.839%20425.46C765.132%20425.46%20765.364%20425.388%20765.535%20425.243C765.709%20425.097%20765.796%20424.893%20765.796%20424.632C765.796%20424.49%20765.773%20424.366%20765.728%20424.261C765.686%20424.153%20765.627%20424.067%20765.553%20424.003C765.481%20423.937%20765.387%20423.884%20765.272%20423.845C765.159%20423.804%20765.042%20423.776%20764.921%20423.76C764.802%20423.743%20764.664%20423.732%20764.506%20423.728C764.486%20423.728%20764.457%20423.728%20764.418%20423.728C764.379%20423.726%20764.35%20423.725%20764.33%20423.725V423.289H764.476C764.613%20423.287%20764.733%20423.281%20764.836%20423.269C764.942%20423.255%20765.046%20423.232%20765.149%20423.199C765.255%20423.166%20765.341%20423.122%20765.41%20423.067C765.478%20423.012%20765.533%20422.939%20765.576%20422.848C765.619%20422.756%20765.641%20422.648%20765.641%20422.523C765.641%20422.055%20765.373%20421.821%20764.836%20421.821C764.643%20421.821%20764.462%20421.849%20764.292%20421.906C764.123%20421.962%20763.977%20422.038%20763.856%20422.134L763.693%20421.707C763.983%20421.487%20764.401%20421.376%20764.947%20421.376C765.168%20421.376%20765.372%20421.417%20765.559%20421.499C765.746%20421.579%20765.9%20421.703%20766.021%20421.871C766.142%20422.036%20766.202%20422.231%20766.202%20422.456C766.202%20422.729%20766.135%20422.953%20766%20423.129C765.866%20423.304%20765.677%20423.43%20765.433%20423.506C765.706%20423.564%20765.92%20423.692%20766.074%20423.889C766.23%20424.086%20766.308%20424.336%20766.308%20424.638C766.308%20425.022%20766.17%20425.329%20765.895%20425.559C765.62%20425.789%20765.267%20425.904%20764.836%20425.904ZM769.113%20425.735C768.92%20425.848%20768.694%20425.904%20768.434%20425.904C768.175%20425.904%20767.948%20425.848%20767.753%20425.735C767.558%20425.62%20767.401%20425.459%20767.282%20425.252C767.165%20425.045%20767.077%20424.808%20767.018%20424.538C766.962%20424.269%20766.934%20423.97%20766.934%20423.64C766.934%20423.369%20766.952%20423.119%20766.989%20422.889C767.028%20422.659%20767.088%20422.45%20767.168%20422.263C767.248%20422.075%20767.346%20421.917%20767.463%20421.786C767.582%20421.655%20767.723%20421.555%20767.887%20421.485C768.051%20421.412%20768.233%20421.376%20768.434%20421.376C768.684%20421.376%20768.904%20421.431%20769.095%20421.54C769.288%20421.649%20769.444%20421.805%20769.563%20422.008C769.684%20422.209%20769.775%20422.447%20769.835%20422.722C769.896%20422.995%20769.926%20423.301%20769.926%20423.64C769.926%20423.97%20769.898%20424.269%20769.841%20424.538C769.785%20424.808%20769.698%20425.045%20769.581%20425.252C769.464%20425.459%20769.308%20425.62%20769.113%20425.735ZM768.946%20422.058C768.804%20421.9%20768.633%20421.821%20768.434%20421.821C768.235%20421.821%20768.065%20421.9%20767.922%20422.058C767.78%20422.214%20767.673%20422.426%20767.601%20422.696C767.53%20422.963%20767.495%20423.272%20767.495%20423.623C767.495%20423.98%20767.53%20424.296%20767.601%20424.571C767.673%20424.844%20767.78%20425.06%20767.922%20425.22C768.065%20425.38%20768.235%20425.46%20768.434%20425.46C768.633%20425.46%20768.804%20425.38%20768.946%20425.22C769.088%20425.06%20769.195%20424.844%20769.265%20424.571C769.337%20424.296%20769.373%20423.98%20769.373%20423.623C769.373%20423.272%20769.337%20422.963%20769.265%20422.696C769.195%20422.426%20769.088%20422.214%20768.946%20422.058ZM771.011%20425.872C770.89%20425.872%20770.795%20425.834%20770.725%20425.758C770.656%20425.68%20770.622%20425.589%20770.622%20425.486C770.622%20425.381%20770.656%20425.29%20770.725%20425.214C770.793%20425.138%20770.888%20425.1%20771.011%20425.1C771.134%20425.1%20771.23%20425.138%20771.298%20425.214C771.366%20425.29%20771.4%20425.381%20771.4%20425.486C771.4%20425.591%20771.366%20425.682%20771.298%20425.758C771.23%20425.834%20771.134%20425.872%20771.011%20425.872ZM773.556%20423.143C773.802%20423.143%20774.029%20423.202%20774.238%20423.319C774.446%20423.434%20774.614%20423.598%20774.741%20423.813C774.867%20424.026%20774.931%20424.262%20774.931%20424.524C774.931%20424.922%20774.796%20425.251%20774.527%20425.512C774.26%20425.774%20773.907%20425.904%20773.468%20425.904C773.24%20425.904%20773.031%20425.866%20772.842%20425.79C772.655%20425.712%20772.5%20425.608%20772.377%20425.477C772.256%20425.345%20772.162%20425.192%20772.093%20425.018C772.027%20424.843%20771.994%20424.655%20771.994%20424.457C771.994%20424.139%20772.052%20423.855%20772.167%20423.605C772.284%20423.354%20772.494%20423.036%20772.798%20422.652C772.873%20422.558%20772.99%20422.414%20773.149%20422.219C773.309%20422.024%20773.452%20421.852%20773.577%20421.704L773.761%20421.482H774.436L772.898%20423.319C773.118%20423.202%20773.338%20423.143%20773.556%20423.143ZM772.547%20424.512C772.547%20424.686%20772.579%20424.843%20772.643%20424.983C772.71%20425.123%20772.812%20425.238%20772.951%20425.328C773.091%20425.416%20773.258%20425.46%20773.451%20425.46C773.739%20425.46%20773.966%20425.371%20774.129%20425.194C774.295%20425.016%20774.378%20424.796%20774.378%20424.533C774.378%20424.256%20774.295%20424.028%20774.129%20423.851C773.966%20423.672%20773.739%20423.582%20773.451%20423.582C773.145%20423.582%20772.917%20423.669%20772.769%20423.842C772.621%20424.016%20772.547%20424.239%20772.547%20424.512Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter12_f_12_1053)'%3e%3cpath%20d='M944.415%20417.016H944.734V417.58C945.305%20417.598%20945.768%20417.718%20946.124%20417.94L945.956%20418.413C945.82%20418.337%20945.639%20418.269%20945.416%20418.209C945.194%20418.146%20944.967%20418.109%20944.734%20418.098V419.804L945.083%20419.888C945.486%20419.984%20945.792%20420.139%20946%20420.351C946.208%20420.562%20946.312%20420.862%20946.312%20421.251C946.312%20421.733%20946.171%20422.101%20945.889%20422.356C945.609%20422.611%20945.224%20422.751%20944.734%20422.776V423.357H944.415V422.776C944.056%20422.765%20943.736%20422.72%20943.454%20422.642C943.174%20422.561%20942.95%20422.469%20942.782%20422.366L942.957%20421.883C943.409%20422.104%20943.895%20422.23%20944.415%20422.259V420.311L943.921%20420.187C943.166%20419.996%20942.789%20419.593%20942.789%20418.978C942.789%20418.537%20942.933%20418.202%20943.219%20417.973C943.506%20417.743%20943.904%20417.614%20944.415%20417.587V417.016ZM944.415%20419.727V418.101C943.734%20418.141%20943.394%20418.42%20943.394%20418.937C943.394%20419.128%20943.455%20419.281%20943.578%20419.397C943.704%20419.512%20943.891%20419.599%20944.139%20419.659L944.415%20419.727ZM944.734%20420.392V422.262C945.385%20422.229%20945.711%20421.898%20945.711%20421.271C945.711%20421.057%20945.653%20420.883%20945.536%20420.751C945.422%20420.617%20945.213%20420.511%20944.908%20420.435L944.734%20420.392ZM948.304%20422.779C948.004%20422.779%20947.736%20422.74%20947.501%20422.662C947.268%20422.583%20947.098%20422.493%20946.991%20422.39L947.179%20421.896C947.494%20422.145%20947.871%20422.269%20948.307%20422.269C948.643%20422.269%20948.909%20422.186%20949.106%20422.02C949.306%20421.852%20949.405%20421.618%20949.405%20421.318C949.405%20421.155%20949.38%20421.013%20949.328%20420.892C949.279%20420.769%20949.212%20420.67%20949.127%20420.596C949.044%20420.52%20948.936%20420.46%20948.804%20420.415C948.674%20420.368%20948.54%20420.336%20948.401%20420.318C948.265%20420.297%20948.106%20420.285%20947.924%20420.281C947.902%20420.281%20947.868%20420.281%20947.824%20420.281C947.779%20420.278%20947.745%20420.277%20947.723%20420.277V419.777H947.891C948.047%20419.775%20948.185%20419.767%20948.304%20419.753C948.425%20419.738%20948.544%20419.711%20948.663%20419.673C948.784%20419.635%20948.884%20419.584%20948.962%20419.522C949.04%20419.459%20949.104%20419.375%20949.153%20419.27C949.203%20419.165%20949.227%20419.04%20949.227%20418.897C949.227%20418.36%20948.92%20418.091%20948.304%20418.091C948.082%20418.091%20947.874%20418.123%20947.679%20418.188C947.484%20418.253%20947.318%20418.341%20947.179%20418.45L946.991%20417.96C947.324%20417.707%20947.805%20417.58%20948.431%20417.58C948.684%20417.58%20948.918%20417.628%20949.133%20417.722C949.348%20417.813%20949.525%20417.956%20949.664%20418.148C949.803%20418.338%20949.872%20418.562%20949.872%20418.82C949.872%20419.133%20949.795%20419.391%20949.64%20419.592C949.486%20419.794%20949.269%20419.938%20948.989%20420.025C949.302%20420.093%20949.548%20420.239%20949.724%20420.465C949.904%20420.692%20949.993%20420.978%20949.993%20421.325C949.993%20421.766%20949.835%20422.119%20949.52%20422.383C949.204%20422.647%20948.799%20422.779%20948.304%20422.779ZM951.36%20417.678H951.894V422.702H951.3V418.299C951.073%20418.447%20950.797%20418.573%20950.47%20418.679V418.118C950.506%20418.102%20950.579%20418.071%20950.688%20418.024C950.798%20417.977%20950.88%20417.941%20950.933%20417.916C950.989%20417.892%20951.059%20417.857%20951.142%20417.812C951.225%20417.767%20951.297%20417.723%20951.36%20417.678ZM953.325%20422.742C953.186%20422.742%20953.076%20422.699%20952.996%20422.611C952.917%20422.522%20952.878%20422.418%20952.878%20422.299C952.878%20422.178%20952.917%20422.074%20952.996%20421.987C953.074%20421.899%20953.184%20421.856%20953.325%20421.856C953.466%20421.856%20953.575%20421.899%20953.654%20421.987C953.732%20422.074%20953.771%20422.178%20953.771%20422.299C953.771%20422.42%20953.732%20422.524%20953.654%20422.611C953.575%20422.699%20953.466%20422.742%20953.325%20422.742ZM954.487%20422.702L954.409%20422.151L956.146%20420.224C956.262%20420.094%20956.374%20419.926%20956.482%20419.72C956.591%20419.514%20956.671%20419.339%20956.72%20419.196L956.797%20418.984C956.797%20418.707%20956.72%20418.492%20956.566%20418.34C956.411%20418.185%20956.192%20418.108%20955.907%20418.108C955.433%20418.108%20955.059%20418.245%20954.786%20418.521L954.591%20418.017C954.9%20417.726%20955.352%20417.58%20955.948%20417.58C956.404%20417.58%20956.768%20417.705%20957.039%20417.953C957.31%20418.2%20957.446%20418.53%20957.446%20418.944C957.437%20418.975%20957.423%20419.018%20957.405%20419.072C957.387%20419.123%20957.348%20419.225%20957.288%20419.377C957.229%20419.53%20957.168%20419.674%20957.103%20419.811C957.038%20419.947%20956.955%20420.097%20956.854%20420.261C956.756%20420.424%20956.655%20420.561%20956.552%20420.67L955.135%20422.185H957.462L957.425%20422.702H954.487Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter13_f_12_1053)'%3e%3cpath%20d='M801.165%20400.641H801.449V401.142C801.955%20401.158%20802.366%20401.264%20802.682%20401.461L802.533%20401.881C802.412%20401.813%20802.252%20401.753%20802.053%20401.699C801.857%20401.643%20801.655%20401.611%20801.449%20401.601V403.114L801.758%20403.189C802.116%20403.274%20802.387%20403.411%20802.572%20403.6C802.756%20403.786%20802.849%20404.053%20802.849%20404.398C802.849%20404.825%20802.724%20405.152%20802.473%20405.378C802.225%20405.605%20801.883%20405.729%20801.449%20405.751V406.266H801.165V405.751C800.848%20405.741%20800.564%20405.701%20800.313%20405.632C800.065%20405.56%20799.867%20405.479%20799.718%20405.387L799.872%20404.958C800.274%20405.155%20800.705%20405.266%20801.165%20405.292V403.564L800.728%20403.454C800.058%20403.285%20799.724%20402.927%20799.724%20402.381C799.724%20401.99%20799.851%20401.693%20800.105%20401.49C800.359%20401.286%20800.713%20401.172%20801.165%20401.148V400.641ZM801.165%20403.046V401.604C800.562%20401.639%20800.26%20401.887%20800.26%20402.345C800.26%20402.514%20800.314%20402.65%20800.424%20402.754C800.535%20402.855%20800.701%20402.932%20800.921%20402.986L801.165%20403.046ZM801.449%20403.635V405.295C802.026%20405.265%20802.315%20404.972%20802.315%20404.416C802.315%20404.225%20802.264%20404.071%20802.161%20403.954C802.059%20403.835%20801.874%20403.742%20801.603%20403.674L801.449%20403.635ZM804.615%20405.754C804.349%20405.754%20804.112%20405.719%20803.903%20405.649C803.697%20405.58%20803.546%20405.499%20803.451%20405.408L803.617%20404.97C803.897%20405.191%20804.231%20405.301%20804.618%20405.301C804.916%20405.301%20805.153%20405.227%20805.328%20405.08C805.504%20404.931%20805.593%20404.724%20805.593%20404.458C805.593%20404.313%20805.57%20404.187%20805.524%20404.079C805.48%20403.97%20805.421%20403.883%20805.345%20403.817C805.272%20403.75%20805.177%20403.696%20805.059%20403.656C804.944%20403.615%20804.825%20403.586%20804.702%20403.57C804.581%20403.552%20804.44%20403.541%20804.279%20403.537C804.259%20403.537%20804.229%20403.537%20804.189%20403.537C804.15%20403.535%20804.12%20403.534%20804.1%20403.534V403.09H804.249C804.388%20403.088%20804.51%20403.081%20804.615%20403.069C804.723%20403.055%20804.829%20403.032%20804.934%20402.998C805.042%20402.964%20805.13%20402.919%20805.199%20402.864C805.269%20402.808%20805.326%20402.734%20805.369%20402.64C805.413%20402.547%20805.435%20402.437%20805.435%20402.31C805.435%20401.833%20805.162%20401.595%20804.615%20401.595C804.419%20401.595%20804.234%20401.623%20804.061%20401.681C803.889%20401.739%20803.741%20401.816%20803.617%20401.913L803.451%20401.478C803.747%20401.254%20804.173%20401.142%20804.729%20401.142C804.953%20401.142%20805.161%20401.183%20805.351%20401.267C805.542%20401.348%20805.699%20401.474%20805.822%20401.645C805.945%20401.814%20806.007%20402.013%20806.007%20402.241C806.007%20402.519%20805.938%20402.748%20805.801%20402.926C805.664%20403.105%20805.472%20403.233%20805.223%20403.311C805.501%20403.37%20805.719%20403.5%20805.876%20403.701C806.035%20403.902%20806.114%20404.156%20806.114%20404.464C806.114%20404.855%20805.974%20405.168%20805.694%20405.402C805.414%20405.637%20805.054%20405.754%20804.615%20405.754ZM808.197%20405.754C807.926%20405.754%20807.682%20405.709%20807.464%20405.62C807.247%20405.528%20807.071%20405.389%20806.936%20405.203C806.801%20405.016%20806.734%20404.794%20806.734%20404.538C806.734%20404.254%20806.815%20404.007%20806.978%20403.796C807.141%20403.586%20807.368%20403.433%20807.66%20403.338C807.104%20403.141%20806.826%20402.783%20806.826%20402.265C806.826%20401.913%20806.953%20401.638%20807.207%20401.44C807.462%20401.241%20807.791%20401.142%20808.197%20401.142C808.6%20401.142%20808.927%20401.241%20809.177%20401.44C809.427%20401.638%20809.552%20401.913%20809.552%20402.265C809.552%20402.527%20809.485%20402.748%20809.35%20402.926C809.214%20403.105%20809.026%20403.242%20808.783%20403.338C809.052%20403.433%20809.262%20403.586%20809.415%20403.796C809.568%20404.007%20809.645%20404.254%20809.645%20404.538C809.645%20404.92%20809.506%20405.217%20809.23%20405.432C808.956%20405.646%20808.612%20405.754%20808.197%20405.754ZM808.197%20403.591C807.913%20403.656%20807.685%20403.767%20807.514%20403.921C807.344%20404.074%20807.258%20404.268%20807.258%20404.502C807.258%20404.747%20807.346%20404.941%20807.523%20405.086C807.7%20405.229%20807.924%20405.301%20808.197%20405.301C808.469%20405.301%20808.69%20405.229%20808.861%20405.086C809.034%20404.941%20809.12%20404.747%20809.12%20404.502C809.12%20404.266%20809.037%20404.071%20808.87%20403.918C808.703%20403.764%20808.479%20403.654%20808.197%20403.591ZM808.197%20401.595C807.962%20401.595%20807.763%20401.653%20807.598%20401.77C807.435%20401.888%20807.353%20402.048%20807.353%20402.253C807.353%20402.722%20807.634%20403.019%20808.197%20403.144C808.751%20403.019%20809.028%20402.722%20809.028%20402.253C809.028%20402.048%20808.947%20401.888%20808.786%20401.77C808.626%20401.653%20808.429%20401.595%20808.197%20401.595ZM810.726%20405.721C810.603%20405.721%20810.506%20405.682%20810.434%20405.605C810.365%20405.525%20810.33%20405.433%20810.33%20405.328C810.33%20405.22%20810.365%20405.128%20810.434%20405.051C810.504%20404.973%20810.601%20404.934%20810.726%20404.934C810.851%20404.934%20810.948%20404.973%20811.018%20405.051C811.087%20405.128%20811.122%20405.22%20811.122%20405.328C811.122%20405.435%20811.087%20405.527%20811.018%20405.605C810.948%20405.682%20810.851%20405.721%20810.726%20405.721ZM813.077%20403.904C812.824%20403.904%20812.592%20403.849%20812.379%20403.74C812.169%20403.628%20811.999%20403.469%20811.87%20403.26C811.741%20403.051%20811.676%20402.814%20811.676%20402.548C811.676%20402.143%20811.815%20401.807%20812.093%20401.541C812.372%20401.275%20812.735%20401.142%20813.184%20401.142C813.416%20401.142%20813.627%20401.18%20813.815%20401.255C814.006%20401.328%20814.162%20401.431%20814.283%20401.562C814.406%20401.691%20814.501%20401.843%20814.566%20402.018C814.634%20402.19%20814.668%20402.378%20814.668%20402.581C814.668%20402.865%20814.619%20403.122%20814.522%20403.352C814.424%20403.583%20814.256%20403.86%20814.018%20404.184C813.933%20404.297%20813.79%20404.479%20813.589%20404.729C813.39%20404.979%20813.213%20405.201%20813.056%20405.393L812.82%20405.685H812.165L813.747%20403.725C813.523%20403.844%20813.299%20403.904%20813.077%20403.904ZM814.104%20402.524C814.104%20402.252%20814.027%20402.03%20813.872%20401.857C813.719%20401.682%20813.496%20401.595%20813.202%20401.595C812.906%20401.595%20812.671%20401.686%20812.499%20401.869C812.326%20402.049%20812.239%20402.273%20812.239%20402.539C812.239%20402.817%20812.323%20403.04%20812.49%20403.206C812.657%20403.373%20812.888%20403.457%20813.184%20403.457C813.498%20403.457%20813.729%20403.37%20813.878%20403.197C814.029%20403.025%20814.104%20402.8%20814.104%20402.524Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3cg%20filter='url(%23filter14_f_12_1053)'%3e%3cpath%20d='M928.167%20427.599H928.445V428.091C928.942%20428.106%20929.346%20428.211%20929.656%20428.404L929.509%20428.816C929.39%20428.75%20929.233%20428.69%20929.038%20428.638C928.845%20428.583%20928.647%20428.551%20928.445%20428.541V430.027L928.749%20430.1C929.1%20430.184%20929.366%20430.319%20929.547%20430.504C929.729%20430.687%20929.819%20430.949%20929.819%20431.288C929.819%20431.707%20929.697%20432.028%20929.451%20432.25C929.207%20432.473%20928.872%20432.595%20928.445%20432.616V433.122H928.167V432.616C927.855%20432.606%20927.576%20432.567%20927.33%20432.499C927.086%20432.429%20926.891%20432.349%20926.745%20432.259L926.897%20431.838C927.291%20432.031%20927.714%20432.14%20928.167%20432.166V430.469L927.737%20430.361C927.08%20430.195%20926.751%20429.844%20926.751%20429.308C926.751%20428.924%20926.876%20428.632%20927.125%20428.433C927.375%20428.232%20927.722%20428.12%20928.167%20428.097V427.599ZM928.167%20429.96V428.544C927.574%20428.579%20927.278%20428.822%20927.278%20429.273C927.278%20429.438%20927.331%20429.572%20927.438%20429.673C927.548%20429.773%20927.71%20429.849%20927.927%20429.901L928.167%20429.96ZM928.445%20430.539V432.168C929.012%20432.139%20929.296%20431.852%20929.296%20431.306C929.296%20431.118%20929.245%20430.967%20929.144%20430.852C929.044%20430.735%20928.862%20430.643%20928.597%20430.577L928.445%20430.539ZM930.434%20432.552L930.366%20432.072L931.879%20430.393C931.98%20430.28%20932.078%20430.134%20932.171%20429.954C932.267%20429.775%20932.336%20429.623%20932.379%20429.498L932.446%20429.314C932.446%20429.072%20932.379%20428.885%20932.244%20428.752C932.11%20428.617%20931.919%20428.55%20931.671%20428.55C931.258%20428.55%20930.932%20428.67%20930.694%20428.91L930.524%20428.471C930.794%20428.218%20931.187%20428.091%20931.706%20428.091C932.104%20428.091%20932.421%20428.199%20932.657%20428.416C932.893%20428.63%20933.011%20428.918%20933.011%20429.278C933.003%20429.306%20932.991%20429.343%20932.976%20429.39C932.96%20429.434%20932.926%20429.523%20932.873%20429.656C932.823%20429.788%20932.769%20429.914%20932.712%20430.033C932.656%20430.152%20932.584%20430.283%20932.496%20430.425C932.41%20430.567%20932.322%20430.686%20932.233%20430.782L930.998%20432.101H933.025L932.993%20432.552H930.434ZM935.105%20432.619C934.84%20432.619%20934.6%20432.575%20934.386%20432.487C934.173%20432.398%20934%20432.261%20933.868%20432.078C933.735%20431.894%20933.669%20431.677%20933.669%20431.425C933.669%20431.147%20933.749%20430.904%20933.909%20430.697C934.069%20430.49%20934.292%20430.34%20934.579%20430.247C934.033%20430.054%20933.76%20429.703%20933.76%20429.194C933.76%20428.848%20933.884%20428.578%20934.134%20428.383C934.384%20428.188%20934.707%20428.091%20935.105%20428.091C935.501%20428.091%20935.822%20428.188%20936.068%20428.383C936.313%20428.578%20936.436%20428.848%20936.436%20429.194C936.436%20429.451%20936.37%20429.667%20936.237%20429.843C936.105%20430.018%20935.919%20430.153%20935.681%20430.247C935.945%20430.34%20936.151%20430.49%20936.302%20430.697C936.452%20430.904%20936.527%20431.147%20936.527%20431.425C936.527%20431.8%20936.391%20432.092%20936.12%20432.303C935.851%20432.514%20935.513%20432.619%20935.105%20432.619ZM935.105%20430.495C934.826%20430.56%20934.603%20430.668%20934.435%20430.82C934.268%20430.97%20934.184%20431.16%20934.184%20431.39C934.184%20431.63%20934.271%20431.821%20934.444%20431.964C934.618%20432.104%20934.838%20432.174%20935.105%20432.174C935.372%20432.174%20935.59%20432.104%20935.757%20431.964C935.927%20431.821%20936.012%20431.63%20936.012%20431.39C936.012%20431.158%20935.93%20430.967%20935.766%20430.817C935.602%20430.665%20935.382%20430.558%20935.105%20430.495ZM935.105%20428.535C934.875%20428.535%20934.679%20428.593%20934.517%20428.708C934.357%20428.823%20934.277%20428.981%20934.277%20429.182C934.277%20429.642%20934.553%20429.934%20935.105%20430.057C935.649%20429.934%20935.921%20429.642%20935.921%20429.182C935.921%20428.981%20935.842%20428.823%20935.684%20428.708C935.526%20428.593%20935.333%20428.535%20935.105%20428.535ZM937.589%20432.587C937.468%20432.587%20937.372%20432.549%20937.302%20432.473C937.234%20432.395%20937.2%20432.304%20937.2%20432.201C937.2%20432.095%20937.234%20432.005%20937.302%20431.929C937.37%20431.853%20937.466%20431.815%20937.589%20431.815C937.711%20431.815%20937.807%20431.853%20937.875%20431.929C937.943%20432.005%20937.978%20432.095%20937.978%20432.201C937.978%20432.306%20937.943%20432.397%20937.875%20432.473C937.807%20432.549%20937.711%20432.587%20937.589%20432.587ZM940.133%20429.858C940.379%20429.858%20940.606%20429.916%20940.815%20430.033C941.024%20430.148%20941.191%20430.313%20941.318%20430.527C941.445%20430.74%20941.508%20430.977%20941.508%20431.238C941.508%20431.636%20941.374%20431.966%20941.105%20432.227C940.837%20432.488%20940.484%20432.619%20940.046%20432.619C939.817%20432.619%20939.609%20432.581%20939.42%20432.505C939.232%20432.427%20939.077%20432.323%20938.955%20432.192C938.834%20432.059%20938.739%20431.906%20938.671%20431.733C938.605%20431.557%20938.571%20431.37%20938.571%20431.171C938.571%20430.853%20938.629%20430.569%20938.744%20430.32C938.861%20430.068%20939.072%20429.75%20939.376%20429.366C939.45%20429.273%20939.567%20429.128%20939.727%20428.933C939.887%20428.738%20940.029%20428.567%20940.154%20428.418L940.338%20428.196H941.014L939.475%20430.033C939.696%20429.916%20939.915%20429.858%20940.133%20429.858ZM939.124%20431.227C939.124%20431.4%20939.156%20431.557%20939.221%20431.698C939.287%20431.838%20939.389%20431.953%20939.528%20432.043C939.668%20432.13%20939.835%20432.174%20940.028%20432.174C940.317%20432.174%20940.543%20432.086%20940.707%20431.908C940.872%20431.731%20940.955%20431.51%20940.955%20431.247C940.955%20430.97%20940.872%20430.743%20940.707%20430.565C940.543%20430.386%20940.317%20430.296%20940.028%20430.296C939.722%20430.296%20939.495%20430.383%20939.347%20430.557C939.198%20430.73%20939.124%20430.954%20939.124%20431.227Z'%20fill='%23B5B7BA'%20/%3e%3c/g%3e%3c/g%3e%3crect%20x='30'%20y='21.75'%20width='46.5'%20height='35.25'%20fill='url(%23pattern2_12_1053)'%20/%3e%3c/g%3e%3cdefs%3e%3cpattern%20id='pattern0_12_1053'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_12_1053'%20transform='scale(0.00024975%200.00249377)'%20/%3e%3c/pattern%3e%3cpattern%20id='pattern1_12_1053'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image1_12_1053'%20transform='scale(0.000248756%200.00240385)'%20/%3e%3c/pattern%3e%3cfilter%20id='filter0_f_12_1053'%20x='847.032'%20y='86.11'%20width='55.5298'%20height='21.4958'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='2'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter1_f_12_1053'%20x='842.719'%20y='112.36'%20width='61.9175'%20height='21.4958'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='2'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter2_f_12_1053'%20x='689.919'%20y='472.872'%20width='34.8428'%20height='20.5901'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='2'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter3_f_12_1053'%20x='47.0283'%20y='520.301'%20width='18.3193'%20height='12.3724'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1.5'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter4_f_12_1053'%20x='42.7212'%20y='463.974'%20width='22.5869'%20height='12.4862'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1.5'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter5_f_12_1053'%20x='39.2461'%20y='407.443'%20width='25.9551'%20height='12.8276'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1.5'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter6_f_12_1053'%20x='685.934'%20y='398.819'%20width='39.3857'%20height='21.4958'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='2'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter7_f_12_1053'%20x='759.637'%20y='507.618'%20width='15.3228'%20height='9.42029'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter8_f_12_1053'%20x='942.642'%20y='442.8'%20width='15.4023'%20height='9.52271'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter9_f_12_1053'%20x='901.082'%20y='397.274'%20width='18.8486'%20height='10.0339'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter10_f_12_1053'%20x='839.293'%20y='485.636'%20width='15.2397'%20height='9.42029'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter11_f_12_1053'%20x='758.027'%20y='418.885'%20width='18.9033'%20height='9.52271'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter12_f_12_1053'%20x='940.783'%20y='415.016'%20width='18.6797'%20height='10.3408'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter13_f_12_1053'%20x='797.718'%20y='398.641'%20width='18.9497'%20height='9.62488'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cfilter%20id='filter14_f_12_1053'%20x='924.745'%20y='425.599'%20width='18.7632'%20height='9.52271'%20filterUnits='userSpaceOnUse'%20color-interpolation-filters='sRGB'%3e%3cfeFlood%20flood-opacity='0'%20result='BackgroundImageFix'%20/%3e%3cfeBlend%20mode='normal'%20in='SourceGraphic'%20in2='BackgroundImageFix'%20result='shape'%20/%3e%3cfeGaussianBlur%20stdDeviation='1'%20result='effect1_foregroundBlur_12_1053'%20/%3e%3c/filter%3e%3cpattern%20id='pattern2_12_1053'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image2_12_1053'%20transform='matrix(0.00115912%200%200%200.00152905%200.00389652%200)'%20/%3e%3c/pattern%3e%3cclipPath%20id='clip0_12_1053'%3e%3crect%20width='996'%20height='576'%20fill='white'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip1_12_1053'%3e%3crect%20width='960'%20height='540'%20fill='white'%20transform='translate(18%2018)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip2_12_1053'%3e%3crect%20width='960'%20height='540'%20fill='white'%20transform='translate(18%2018)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip3_12_1053'%3e%3crect%20width='960'%20height='540'%20fill='white'%20transform='translate(18%2018)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip4_12_1053'%3e%3crect%20width='945'%20height='81.8'%20fill='white'%20transform='translate(23.2002%2063.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip5_12_1053'%3e%3crect%20width='300.8'%20height='198'%20fill='white'%20transform='translate(666.7%20357)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip6_12_1053'%3e%3crect%20width='76.5'%20height='18'%20fill='white'%20transform='translate(502.5%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip7_12_1053'%3e%3crect%20width='73.5'%20height='18.8'%20fill='white'%20transform='translate(420.7%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip8_12_1053'%3e%3crect%20width='44.2'%20height='18'%20fill='white'%20transform='translate(586.5%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip9_12_1053'%3e%3crect%20width='76.5'%20height='18'%20fill='white'%20transform='translate(503.2%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip10_12_1053'%3e%3crect%20width='73.5'%20height='18.7'%20fill='white'%20transform='translate(421.5%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip11_12_1053'%3e%3crect%20width='44.3'%20height='18'%20fill='white'%20transform='translate(587.2%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip12_12_1053'%3e%3crect%20width='279'%20height='36.7'%20fill='white'%20transform='translate(676.5%20369)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip13_12_1053'%3e%3crect%20width='76.5'%20height='18'%20fill='white'%20transform='translate(133.5%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip14_12_1053'%3e%3crect%20width='73.5'%20height='18.8'%20fill='white'%20transform='translate(51.7002%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip15_12_1053'%3e%3crect%20width='44.2'%20height='18'%20fill='white'%20transform='translate(217.5%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip16_12_1053'%3e%3crect%20width='76.5'%20height='18'%20fill='white'%20transform='translate(133.5%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip17_12_1053'%3e%3crect%20width='73.5'%20height='18.7'%20fill='white'%20transform='translate(51.7002%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip18_12_1053'%3e%3crect%20width='44.2'%20height='18'%20fill='white'%20transform='translate(217.5%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip19_12_1053'%3e%3crect%20width='73.5'%20height='18.8'%20fill='white'%20transform='translate(754.5%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip20_12_1053'%3e%3crect%20width='44.3'%20height='18'%20fill='white'%20transform='translate(920.2%2093.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip21_12_1053'%3e%3crect%20width='73.5'%20height='18.7'%20fill='white'%20transform='translate(754.5%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip22_12_1053'%3e%3crect%20width='44.3'%20height='18'%20fill='white'%20transform='translate(920.2%20120)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip23_12_1053'%3e%3crect%20width='640.5'%20height='198.8'%20fill='white'%20transform='translate(23.2002%20153.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip24_12_1053'%3e%3crect%20width='604.5'%20height='14.2'%20fill='white'%20transform='translate(41.2002%20160.5)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip25_12_1053'%3e%3crect%20width='604.5'%20height='135'%20fill='white'%20transform='translate(41.2002%20201.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip26_12_1053'%3e%3crect%20width='105.7'%20height='14.3'%20fill='white'%20transform='translate(474%20447.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip27_12_1053'%3e%3crect%20width='105.7'%20height='15'%20fill='white'%20transform='translate(474%20465)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip28_12_1053'%3e%3crect%20width='81.7'%20height='8.29999'%20fill='white'%20transform='translate(498%20468.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip29_12_1053'%3e%3crect%20width='105.7'%20height='39'%20fill='white'%20transform='translate(474%20480.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip30_12_1053'%3e%3crect%20width='641.3'%20height='198'%20fill='white'%20transform='translate(23.2002%20357)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip31_12_1053'%3e%3crect%20width='605.3'%20height='14.3'%20fill='white'%20transform='translate(41.2002%20363.7)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip32_12_1053'%3e%3crect%20width='605.3'%20height='134.2'%20fill='white'%20transform='translate(41.2002%20405)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip33_12_1053'%3e%3crect%20width='569.3'%20height='113.9'%20fill='white'%20transform='translate(69.7002%20411)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip34_12_1053'%3e%3crect%20width='945'%20height='31.5'%20fill='white'%20transform='translate(24%2024)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip35_12_1053'%3e%3crect%20width='300.8'%20height='198'%20fill='white'%20transform='translate(668.2%20154.5)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip36_12_1053'%3e%3crect%20width='279'%20height='18'%20fill='white'%20transform='translate(678%20168)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip37_12_1053'%3e%3crect%20width='198'%20height='152.3'%20fill='white'%20transform='translate(762%20191.2)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip38_12_1053'%3e%3crect%20width='198'%20height='140.3'%20fill='white'%20transform='translate(759.7%20398.2)'%20/%3e%3c/clipPath%3e%3cclipPath%20id='clip39_12_1053'%3e%3crect%20width='198'%20height='146.3'%20fill='white'%20transform='translate(759.7%20392.2)'%20/%3e%3c/clipPath%3e%3cimage%20id='image0_12_1053'%20width='4004'%20height='401'%20preserveAspectRatio='none'%20xlink:href='data:image/png;base64,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'%20/%3e%3cimage%20id='image1_12_1053'%20width='4020'%20height='416'%20preserveAspectRatio='none'%20xlink:href='data:image/png;base64,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'%20/%3e%3cimage%20id='image2_12_1053'%20width='856'%20height='654'%20preserveAspectRatio='none'%20xlink:href='data:image/png;base64,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'%20/%3e%3c/defs%3e%3c/svg%3e", j42 = () => /* @__PURE__ */ K.jsxs("div", { className: "max-w-258 mx-auto pt-6 pb-24 flex flex-col items-center justify-start", children: [
    /* @__PURE__ */ K.jsx("h1", { className: "text-3xl font-bold text-center", children: ne.comingSoon.title }),
    /* @__PURE__ */ K.jsxs("div", { className: "p-2 w-9/10 md:w-7/10 relative border-1 border-primary-600 rounded-3xl mt-18 mb-6", children: [
      /* @__PURE__ */ K.jsx("span", { className: "absolute left-1/2 top-0 px-6 py-5 text-base rounded-2xl border-1 border-primary-600 bg-white -translate-x-1/2 -translate-y-1/2 text-center", children: ne.comingSoon.imageLabel }),
      /* @__PURE__ */ K.jsx("img", { rel: "prefetch", src: H42, alt: "Dashboard Image", className: "w-full h-auto" })
    ] }),
    /* @__PURE__ */ K.jsx("p", { className: "text-sm mb-4", children: ne.comingSoon.description }),
    /* @__PURE__ */ K.jsx(
      "a",
      {
        href: "https://forms.office.com/r/YhQLD6fFDt",
        target: "_blank",
        className: "inline-block text-sm uppercase text-white px-4 py-2 rounded-md bg-primary-600 ",
        children: ne.comingSoon.link
      }
    )
  ] });
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const V42 = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Z42 = (e) => e.replace(
    /^([A-Z])|[\s-_]+(\w)/g,
    (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
  ), fk = (e) => {
    const t = Z42(e);
    return t.charAt(0).toUpperCase() + t.slice(1);
  }, dU = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), z42 = (e) => {
    for (const t in e)
      if (t.startsWith("aria-") || t === "role" || t === "title")
        return !0;
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  var U42 = {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const q42 = q.forwardRef(
    ({
      color: e = "currentColor",
      size: t = 24,
      strokeWidth: r = 2,
      absoluteStrokeWidth: n,
      className: i = "",
      children: o,
      iconNode: u,
      ...c
    }, f) => q.createElement(
      "svg",
      {
        ref: f,
        ...U42,
        width: t,
        height: t,
        stroke: e,
        strokeWidth: n ? Number(r) * 24 / Number(t) : r,
        className: dU("lucide", i),
        ...!o && !z42(c) && { "aria-hidden": "true" },
        ...c
      },
      [
        ...u.map(([d, g]) => q.createElement(d, g)),
        ...Array.isArray(o) ? o : [o]
      ]
    )
  );
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const Wi = (e, t) => {
    const r = q.forwardRef(
      ({ className: n, ...i }, o) => q.createElement(q42, {
        ref: o,
        iconNode: t,
        className: dU(
          `lucide-${V42(fk(e))}`,
          `lucide-${e}`,
          n
        ),
        ...i
      })
    );
    return r.displayName = fk(e), r;
  };
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const W42 = [
    ["path", { d: "M12 5v14", key: "s699le" }],
    ["path", { d: "m19 12-7 7-7-7", key: "1idqje" }]
  ], Y42 = Wi("arrow-down", W42);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const $42 = [
    ["path", { d: "m5 12 7-7 7 7", key: "hav0vg" }],
    ["path", { d: "M12 19V5", key: "x0mq9r" }]
  ], G42 = Wi("arrow-up", $42);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const K42 = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], X42 = Wi("check", K42);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const J42 = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], en2 = Wi("chevron-down", J42);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const tn2 = [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
    ["path", { d: "m9 9 6 6", key: "z0biqf" }]
  ], rn2 = Wi("circle-x", tn2);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const nn2 = [
    ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
    ["path", { d: "M12 16v-4", key: "1dtifu" }],
    ["path", { d: "M12 8h.01", key: "e9boi3" }]
  ], in2 = Wi("info", nn2);
  /**
   * @license lucide-react v0.513.0 - ISC
   *
   * This source code is licensed under the ISC license.
   * See the LICENSE file in the root directory of this source tree.
   */
  const an2 = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], on2 = Wi("loader-circle", an2), Ck = ({ title: e = ne.error.title, message: t = ne.error.message, className: r }) => /* @__PURE__ */ K.jsxs(
    "div",
    {
      className: SS(
        "grid grid-cols-[auto_1fr] grid-rows-[auto] border-0 border-l-4 border-destructive-500 p-4 w-full gap-3 rounded-tr-[8px] rounded-br-[8px] bg-destructive-50",
        r
      ),
      "data-testid": "visitation-report-error",
      children: [
        /* @__PURE__ */ K.jsx(rn2, { "data-testid": "alert-icon", className: "h-5 w-5 self-center stroke-destructive-500" }),
        /* @__PURE__ */ K.jsx("p", { className: "text-base font-bold tracking-[0px] text-destructive-600", children: e }),
        /* @__PURE__ */ K.jsx("div", { className: "col-start-2", children: /* @__PURE__ */ K.jsx("p", { className: "text-sm tracking-0 font-normal text-destructive-600", children: t }) })
      ]
    }
  );
  function $0(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
    return function(i) {
      if (e == null || e(i), r === !1 || !i.defaultPrevented)
        return t == null ? void 0 : t(i);
    };
  }
  function dk(e, t) {
    if (typeof e == "function")
      return e(t);
    e != null && (e.current = t);
  }
  function oh(...e) {
    return (t) => {
      let r = !1;
      const n = e.map((i) => {
        const o = dk(i, t);
        return !r && typeof o == "function" && (r = !0), o;
      });
      if (r)
        return () => {
          for (let i = 0; i < n.length; i++) {
            const o = n[i];
            typeof o == "function" ? o() : dk(e[i], null);
          }
        };
    };
  }
  function H5(...e) {
    return q.useCallback(oh(...e), e);
  }
  function G6(e, t = []) {
    let r = [];
    function n(o, u) {
      const c = q.createContext(u), f = r.length;
      r = [...r, u];
      const d = (h) => {
        var _;
        const { scope: E, children: y, ...I } = h, Q = ((_ = E == null ? void 0 : E[e]) == null ? void 0 : _[f]) || c, B = q.useMemo(() => I, Object.values(I));
        return /* @__PURE__ */ K.jsx(Q.Provider, { value: B, children: y });
      };
      d.displayName = o + "Provider";
      function g(h, E) {
        var Q;
        const y = ((Q = E == null ? void 0 : E[e]) == null ? void 0 : Q[f]) || c, I = q.useContext(y);
        if (I) return I;
        if (u !== void 0) return u;
        throw new Error(`\`${h}\` must be used within \`${o}\``);
      }
      return [d, g];
    }
    const i = () => {
      const o = r.map((u) => q.createContext(u));
      return function(c) {
        const f = (c == null ? void 0 : c[e]) || o;
        return q.useMemo(
          () => ({ [`__scope${e}`]: { ...c, [e]: f } }),
          [c, f]
        );
      };
    };
    return i.scopeName = e, [n, sn2(i, ...t)];
  }
  function sn2(...e) {
    const t = e[0];
    if (e.length === 1) return t;
    const r = () => {
      const n = e.map((i) => ({
        useScope: i(),
        scopeName: i.scopeName
      }));
      return function(o) {
        const u = n.reduce((c, { useScope: f, scopeName: d }) => {
          const h = f(o)[`__scope${d}`];
          return { ...c, ...h };
        }, {});
        return q.useMemo(() => ({ [`__scope${t.scopeName}`]: u }), [u]);
      };
    };
    return r.scopeName = t.scopeName, r;
  }
  var q6 = globalThis != null && globalThis.document ? q.useLayoutEffect : () => {
  }, un2 = wZ[" useInsertionEffect ".trim().toString()] || q6;
  function Yi({
    prop: e,
    defaultProp: t,
    onChange: r = () => {
    },
    caller: n
  }) {
    const [i, o, u] = ln2({
      defaultProp: t,
      onChange: r
    }), c = e !== void 0, f = c ? e : i;
    {
      const g = q.useRef(e !== void 0);
      q.useEffect(() => {
        const h = g.current;
        h !== c && console.warn(
          `${n} is changing from ${h ? "controlled" : "uncontrolled"} to ${c ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
        ), g.current = c;
      }, [c, n]);
    }
    const d = q.useCallback(
      (g) => {
        var h;
        if (c) {
          const E = cn2(g) ? g(e) : g;
          E !== e && ((h = u.current) == null || h.call(u, E));
        } else
          o(g);
      },
      [c, e, o, u]
    );
    return [f, d];
  }
  function ln2({
    defaultProp: e,
    onChange: t
  }) {
    const [r, n] = q.useState(e), i = q.useRef(r), o = q.useRef(t);
    return un2(() => {
      o.current = t;
    }, [t]), q.useEffect(() => {
      var u;
      i.current !== r && ((u = o.current) == null || u.call(o, r), i.current = r);
    }, [r, i]), [r, n, o];
  }
  function cn2(e) {
    return typeof e == "function";
  }
  var MS = MZ();
  const An2 = /* @__PURE__ */ tt(MS);
  // @__NO_SIDE_EFFECTS__
  function Vg(e) {
    const t = /* @__PURE__ */ fn2(e), r = q.forwardRef((n, i) => {
      const { children: o, ...u } = n, c = q.Children.toArray(o), f = c.find(dn2);
      if (f) {
        const d = f.props.children, g = c.map((h) => h === f ? q.Children.count(d) > 1 ? q.Children.only(null) : q.isValidElement(d) ? d.props.children : null : h);
        return /* @__PURE__ */ K.jsx(t, { ...u, ref: i, children: q.isValidElement(d) ? q.cloneElement(d, void 0, g) : null });
      }
      return /* @__PURE__ */ K.jsx(t, { ...u, ref: i, children: o });
    });
    return r.displayName = `${e}.Slot`, r;
  }
  // @__NO_SIDE_EFFECTS__
  function fn2(e) {
    const t = q.forwardRef((r, n) => {
      const { children: i, ...o } = r;
      if (q.isValidElement(i)) {
        const u = pn2(i), c = gn2(o, i.props);
        return i.type !== q.Fragment && (c.ref = n ? oh(n, u) : u), q.cloneElement(i, c);
      }
      return q.Children.count(i) > 1 ? q.Children.only(null) : null;
    });
    return t.displayName = `${e}.SlotClone`, t;
  }
  var gU = Symbol("radix.slottable");
  // @__NO_SIDE_EFFECTS__
  function Cn2(e) {
    const t = ({ children: r }) => /* @__PURE__ */ K.jsx(K.Fragment, { children: r });
    return t.displayName = `${e}.Slottable`, t.__radixId = gU, t;
  }
  function dn2(e) {
    return q.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === gU;
  }
  function gn2(e, t) {
    const r = { ...t };
    for (const n in t) {
      const i = e[n], o = t[n];
      /^on[A-Z]/.test(n) ? i && o ? r[n] = (...c) => {
        const f = o(...c);
        return i(...c), f;
      } : i && (r[n] = i) : n === "style" ? r[n] = { ...i, ...o } : n === "className" && (r[n] = [i, o].filter(Boolean).join(" "));
    }
    return { ...e, ...r };
  }
  function pn2(e) {
    var n, i;
    let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
    return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
  }
  var hn2 = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
  ], Yt = hn2.reduce((e, t) => {
    const r = /* @__PURE__ */ Vg(`Primitive.${t}`), n = q.forwardRef((i, o) => {
      const { asChild: u, ...c } = i, f = u ? r : t;
      return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ K.jsx(f, { ...c, ref: o });
    });
    return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
  }, {});
  function pU(e, t) {
    e && MS.flushSync(() => e.dispatchEvent(t));
  }
  function hU(e) {
    const t = e + "CollectionProvider", [r, n] = G6(t), [i, o] = r(
      t,
      { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
    ), u = (Q) => {
      const { scope: B, children: _ } = Q, M = f2.useRef(null), S = f2.useRef(/* @__PURE__ */ new Map()).current;
      return /* @__PURE__ */ K.jsx(i, { scope: B, itemMap: S, collectionRef: M, children: _ });
    };
    u.displayName = t;
    const c = e + "CollectionSlot", f = /* @__PURE__ */ Vg(c), d = f2.forwardRef(
      (Q, B) => {
        const { scope: _, children: M } = Q, S = o(c, _), O = H5(B, S.collectionRef);
        return /* @__PURE__ */ K.jsx(f, { ref: O, children: M });
      }
    );
    d.displayName = c;
    const g = e + "CollectionItemSlot", h = "data-radix-collection-item", E = /* @__PURE__ */ Vg(g), y = f2.forwardRef(
      (Q, B) => {
        const { scope: _, children: M, ...S } = Q, O = f2.useRef(null), w = H5(B, O), D = o(g, _);
        return f2.useEffect(() => (D.itemMap.set(O, { ref: O, ...S }), () => void D.itemMap.delete(O))), /* @__PURE__ */ K.jsx(E, { [h]: "", ref: w, children: M });
      }
    );
    y.displayName = g;
    function I(Q) {
      const B = o(e + "CollectionConsumer", Q);
      return f2.useCallback(() => {
        const M = B.collectionRef.current;
        if (!M) return [];
        const S = Array.from(M.querySelectorAll(`[${h}]`));
        return Array.from(B.itemMap.values()).sort(
          (D, k) => S.indexOf(D.ref.current) - S.indexOf(k.ref.current)
        );
      }, [B.collectionRef, B.itemMap]);
    }
    return [
      { Provider: u, Slot: d, ItemSlot: y },
      I,
      n
    ];
  }
  var vn2 = q.createContext(void 0);
  function _S(e) {
    const t = q.useContext(vn2);
    return e || t || "ltr";
  }
  function y8(e) {
    const t = q.useRef(e);
    return q.useEffect(() => {
      t.current = e;
    }), q.useMemo(() => (...r) => {
      var n;
      return (n = t.current) == null ? void 0 : n.call(t, ...r);
    }, []);
  }
  function En2(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = y8(e);
    q.useEffect(() => {
      const n = (i) => {
        i.key === "Escape" && r(i);
      };
      return t.addEventListener("keydown", n, { capture: !0 }), () => t.removeEventListener("keydown", n, { capture: !0 });
    }, [r, t]);
  }
  var mn2 = "DismissableLayer", Qb = "dismissableLayer.update", yn2 = "dismissableLayer.pointerDownOutside", In2 = "dismissableLayer.focusOutside", gk, vU = q.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set()
  }), OS = q.forwardRef(
    (e, t) => {
      const {
        disableOutsidePointerEvents: r = !1,
        onEscapeKeyDown: n,
        onPointerDownOutside: i,
        onFocusOutside: o,
        onInteractOutside: u,
        onDismiss: c,
        ...f
      } = e, d = q.useContext(vU), [g, h] = q.useState(null), E = (g == null ? void 0 : g.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = q.useState({}), I = H5(t, (k) => h(k)), Q = Array.from(d.layers), [B] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), _ = Q.indexOf(B), M = g ? Q.indexOf(g) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, O = M >= _, w = xn2((k) => {
        const F = k.target, z = [...d.branches].some((Z) => Z.contains(F));
        !O || z || (i == null || i(k), u == null || u(k), k.defaultPrevented || c == null || c());
      }, E), D = bn2((k) => {
        const F = k.target;
        [...d.branches].some((Z) => Z.contains(F)) || (o == null || o(k), u == null || u(k), k.defaultPrevented || c == null || c());
      }, E);
      return En2((k) => {
        M === d.layers.size - 1 && (n == null || n(k), !k.defaultPrevented && c && (k.preventDefault(), c()));
      }, E), q.useEffect(() => {
        if (g)
          return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (gk = E.body.style.pointerEvents, E.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(g)), d.layers.add(g), pk(), () => {
            r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (E.body.style.pointerEvents = gk);
          };
      }, [g, E, r, d]), q.useEffect(() => () => {
        g && (d.layers.delete(g), d.layersWithOutsidePointerEventsDisabled.delete(g), pk());
      }, [g, d]), q.useEffect(() => {
        const k = () => y({});
        return document.addEventListener(Qb, k), () => document.removeEventListener(Qb, k);
      }, []), /* @__PURE__ */ K.jsx(
        Yt.div,
        {
          ...f,
          ref: I,
          style: {
            pointerEvents: S ? O ? "auto" : "none" : void 0,
            ...e.style
          },
          onFocusCapture: $0(e.onFocusCapture, D.onFocusCapture),
          onBlurCapture: $0(e.onBlurCapture, D.onBlurCapture),
          onPointerDownCapture: $0(
            e.onPointerDownCapture,
            w.onPointerDownCapture
          )
        }
      );
    }
  );
  OS.displayName = mn2;
  var Bn2 = "DismissableLayerBranch", Qn2 = q.forwardRef((e, t) => {
    const r = q.useContext(vU), n = q.useRef(null), i = H5(t, n);
    return q.useEffect(() => {
      const o = n.current;
      if (o)
        return r.branches.add(o), () => {
          r.branches.delete(o);
        };
    }, [r.branches]), /* @__PURE__ */ K.jsx(Yt.div, { ...e, ref: i });
  });
  Qn2.displayName = Bn2;
  function xn2(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = y8(e), n = q.useRef(!1), i = q.useRef(() => {
    });
    return q.useEffect(() => {
      const o = (c) => {
        if (c.target && !n.current) {
          let f = function() {
            EU(
              yn2,
              r,
              d,
              { discrete: !0 }
            );
          };
          const d = { originalEvent: c };
          c.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = f, t.addEventListener("click", i.current, { once: !0 })) : f();
        } else
          t.removeEventListener("click", i.current);
        n.current = !1;
      }, u = window.setTimeout(() => {
        t.addEventListener("pointerdown", o);
      }, 0);
      return () => {
        window.clearTimeout(u), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
      };
    }, [t, r]), {
      // ensures we check React component tree (not just DOM tree)
      onPointerDownCapture: () => n.current = !0
    };
  }
  function bn2(e, t = globalThis == null ? void 0 : globalThis.document) {
    const r = y8(e), n = q.useRef(!1);
    return q.useEffect(() => {
      const i = (o) => {
        o.target && !n.current && EU(In2, r, { originalEvent: o }, {
          discrete: !1
        });
      };
      return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
    }, [t, r]), {
      onFocusCapture: () => n.current = !0,
      onBlurCapture: () => n.current = !1
    };
  }
  function pk() {
    const e = new CustomEvent(Qb);
    document.dispatchEvent(e);
  }
  function EU(e, t, r, { discrete: n }) {
    const i = r.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
    t && i.addEventListener(e, t, { once: !0 }), n ? pU(i, o) : i.dispatchEvent(o);
  }
  var ky = 0;
  function wn2() {
    q.useEffect(() => {
      const e = document.querySelectorAll("[data-radix-focus-guard]");
      return document.body.insertAdjacentElement("afterbegin", e[0] ?? hk()), document.body.insertAdjacentElement("beforeend", e[1] ?? hk()), ky++, () => {
        ky === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ky--;
      };
    }, []);
  }
  function hk() {
    const e = document.createElement("span");
    return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
  }
  var Ry = "focusScope.autoFocusOnMount", Py = "focusScope.autoFocusOnUnmount", vk = { bubbles: !1, cancelable: !0 }, Sn2 = "FocusScope", mU = q.forwardRef((e, t) => {
    const {
      loop: r = !1,
      trapped: n = !1,
      onMountAutoFocus: i,
      onUnmountAutoFocus: o,
      ...u
    } = e, [c, f] = q.useState(null), d = y8(i), g = y8(o), h = q.useRef(null), E = H5(t, (Q) => f(Q)), y = q.useRef({
      paused: !1,
      pause() {
        this.paused = !0;
      },
      resume() {
        this.paused = !1;
      }
    }).current;
    q.useEffect(() => {
      if (n) {
        let Q = function(S) {
          if (y.paused || !c) return;
          const O = S.target;
          c.contains(O) ? h.current = O : T6(h.current, { select: !0 });
        }, B = function(S) {
          if (y.paused || !c) return;
          const O = S.relatedTarget;
          O !== null && (c.contains(O) || T6(h.current, { select: !0 }));
        }, _ = function(S) {
          if (document.activeElement === document.body)
            for (const w of S)
              w.removedNodes.length > 0 && T6(c);
        };
        document.addEventListener("focusin", Q), document.addEventListener("focusout", B);
        const M = new MutationObserver(_);
        return c && M.observe(c, { childList: !0, subtree: !0 }), () => {
          document.removeEventListener("focusin", Q), document.removeEventListener("focusout", B), M.disconnect();
        };
      }
    }, [n, c, y.paused]), q.useEffect(() => {
      if (c) {
        mk.add(y);
        const Q = document.activeElement;
        if (!c.contains(Q)) {
          const _ = new CustomEvent(Ry, vk);
          c.addEventListener(Ry, d), c.dispatchEvent(_), _.defaultPrevented || (Mn2(Ln2(yU(c)), { select: !0 }), document.activeElement === Q && T6(c));
        }
        return () => {
          c.removeEventListener(Ry, d), setTimeout(() => {
            const _ = new CustomEvent(Py, vk);
            c.addEventListener(Py, g), c.dispatchEvent(_), _.defaultPrevented || T6(Q ?? document.body, { select: !0 }), c.removeEventListener(Py, g), mk.remove(y);
          }, 0);
        };
      }
    }, [c, d, g, y]);
    const I = q.useCallback(
      (Q) => {
        if (!r && !n || y.paused) return;
        const B = Q.key === "Tab" && !Q.altKey && !Q.ctrlKey && !Q.metaKey, _ = document.activeElement;
        if (B && _) {
          const M = Q.currentTarget, [S, O] = _n2(M);
          S && O ? !Q.shiftKey && _ === O ? (Q.preventDefault(), r && T6(S, { select: !0 })) : Q.shiftKey && _ === S && (Q.preventDefault(), r && T6(O, { select: !0 })) : _ === M && Q.preventDefault();
        }
      },
      [r, n, y.paused]
    );
    return /* @__PURE__ */ K.jsx(Yt.div, { tabIndex: -1, ...u, ref: E, onKeyDown: I });
  });
  mU.displayName = Sn2;
  function Mn2(e, { select: t = !1 } = {}) {
    const r = document.activeElement;
    for (const n of e)
      if (T6(n, { select: t }), document.activeElement !== r) return;
  }
  function _n2(e) {
    const t = yU(e), r = Ek(t, e), n = Ek(t.reverse(), e);
    return [r, n];
  }
  function yU(e) {
    const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
      acceptNode: (n) => {
        const i = n.tagName === "INPUT" && n.type === "hidden";
        return n.disabled || n.hidden || i ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
      }
    });
    for (; r.nextNode(); ) t.push(r.currentNode);
    return t;
  }
  function Ek(e, t) {
    for (const r of e)
      if (!On2(r, { upTo: t })) return r;
  }
  function On2(e, { upTo: t }) {
    if (getComputedStyle(e).visibility === "hidden") return !0;
    for (; e; ) {
      if (t !== void 0 && e === t) return !1;
      if (getComputedStyle(e).display === "none") return !0;
      e = e.parentElement;
    }
    return !1;
  }
  function Tn2(e) {
    return e instanceof HTMLInputElement && "select" in e;
  }
  function T6(e, { select: t = !1 } = {}) {
    if (e && e.focus) {
      const r = document.activeElement;
      e.focus({ preventScroll: !0 }), e !== r && Tn2(e) && t && e.select();
    }
  }
  var mk = Dn2();
  function Dn2() {
    let e = [];
    return {
      add(t) {
        const r = e[0];
        t !== r && (r == null || r.pause()), e = yk(e, t), e.unshift(t);
      },
      remove(t) {
        var r;
        e = yk(e, t), (r = e[0]) == null || r.resume();
      }
    };
  }
  function yk(e, t) {
    const r = [...e], n = r.indexOf(t);
    return n !== -1 && r.splice(n, 1), r;
  }
  function Ln2(e) {
    return e.filter((t) => t.tagName !== "A");
  }
  var kn2 = wZ[" useId ".trim().toString()] || (() => {
  }), Rn2 = 0;
  function Zg(e) {
    const [t, r] = q.useState(kn2());
    return q6(() => {
      r((n) => n ?? String(Rn2++));
    }, [e]), e || (t ? `radix-${t}` : "");
  }
  const Pn2 = ["top", "right", "bottom", "left"], W6 = Math.min, zr = Math.max, zg = Math.round, yd = Math.floor, l3 = (e) => ({
    x: e,
    y: e
  }), Fn2 = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
  }, Nn2 = {
    start: "end",
    end: "start"
  };
  function xb(e, t, r) {
    return zr(e, W6(t, r));
  }
  function I8(e, t) {
    return typeof e == "function" ? e(t) : e;
  }
  function B8(e) {
    return e.split("-")[0];
  }
  function os(e) {
    return e.split("-")[1];
  }
  function TS(e) {
    return e === "x" ? "y" : "x";
  }
  function DS(e) {
    return e === "y" ? "height" : "width";
  }
  function s3(e) {
    return ["top", "bottom"].includes(B8(e)) ? "y" : "x";
  }
  function LS(e) {
    return TS(s3(e));
  }
  function Hn2(e, t, r) {
    r === void 0 && (r = !1);
    const n = os(e), i = LS(e), o = DS(i);
    let u = i === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
    return t.reference[o] > t.floating[o] && (u = Ug(u)), [u, Ug(u)];
  }
  function jn2(e) {
    const t = Ug(e);
    return [bb(e), t, bb(t)];
  }
  function bb(e) {
    return e.replace(/start|end/g, (t) => Nn2[t]);
  }
  function Vn2(e, t, r) {
    const n = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], u = ["bottom", "top"];
    switch (e) {
      case "top":
      case "bottom":
        return r ? t ? i : n : t ? n : i;
      case "left":
      case "right":
        return t ? o : u;
      default:
        return [];
    }
  }
  function Zn2(e, t, r, n) {
    const i = os(e);
    let o = Vn2(B8(e), r === "start", n);
    return i && (o = o.map((u) => u + "-" + i), t && (o = o.concat(o.map(bb)))), o;
  }
  function Ug(e) {
    return e.replace(/left|right|bottom|top/g, (t) => Fn2[t]);
  }
  function zn2(e) {
    return {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...e
    };
  }
  function IU(e) {
    return typeof e != "number" ? zn2(e) : {
      top: e,
      right: e,
      bottom: e,
      left: e
    };
  }
  function qg(e) {
    const {
      x: t,
      y: r,
      width: n,
      height: i
    } = e;
    return {
      width: n,
      height: i,
      top: r,
      left: t,
      right: t + n,
      bottom: r + i,
      x: t,
      y: r
    };
  }
  function Ik(e, t, r) {
    let {
      reference: n,
      floating: i
    } = e;
    const o = s3(t), u = LS(t), c = DS(u), f = B8(t), d = o === "y", g = n.x + n.width / 2 - i.width / 2, h = n.y + n.height / 2 - i.height / 2, E = n[c] / 2 - i[c] / 2;
    let y;
    switch (f) {
      case "top":
        y = {
          x: g,
          y: n.y - i.height
        };
        break;
      case "bottom":
        y = {
          x: g,
          y: n.y + n.height
        };
        break;
      case "right":
        y = {
          x: n.x + n.width,
          y: h
        };
        break;
      case "left":
        y = {
          x: n.x - i.width,
          y: h
        };
        break;
      default:
        y = {
          x: n.x,
          y: n.y
        };
    }
    switch (os(t)) {
      case "start":
        y[u] -= E * (r && d ? -1 : 1);
        break;
      case "end":
        y[u] += E * (r && d ? -1 : 1);
        break;
    }
    return y;
  }
  const Un2 = async (e, t, r) => {
    const {
      placement: n = "bottom",
      strategy: i = "absolute",
      middleware: o = [],
      platform: u
    } = r, c = o.filter(Boolean), f = await (u.isRTL == null ? void 0 : u.isRTL(t));
    let d = await u.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }), {
      x: g,
      y: h
    } = Ik(d, n, f), E = n, y = {}, I = 0;
    for (let Q = 0; Q < c.length; Q++) {
      const {
        name: B,
        fn: _
      } = c[Q], {
        x: M,
        y: S,
        data: O,
        reset: w
      } = await _({
        x: g,
        y: h,
        initialPlacement: n,
        placement: E,
        strategy: i,
        middlewareData: y,
        rects: d,
        platform: u,
        elements: {
          reference: e,
          floating: t
        }
      });
      g = M ?? g, h = S ?? h, y = {
        ...y,
        [B]: {
          ...y[B],
          ...O
        }
      }, w && I <= 50 && (I++, typeof w == "object" && (w.placement && (E = w.placement), w.rects && (d = w.rects === !0 ? await u.getElementRects({
        reference: e,
        floating: t,
        strategy: i
      }) : w.rects), {
        x: g,
        y: h
      } = Ik(d, E, f)), Q = -1);
    }
    return {
      x: g,
      y: h,
      placement: E,
      strategy: i,
      middlewareData: y
    };
  };
  async function Cc(e, t) {
    var r;
    t === void 0 && (t = {});
    const {
      x: n,
      y: i,
      platform: o,
      rects: u,
      elements: c,
      strategy: f
    } = e, {
      boundary: d = "clippingAncestors",
      rootBoundary: g = "viewport",
      elementContext: h = "floating",
      altBoundary: E = !1,
      padding: y = 0
    } = I8(t, e), I = IU(y), B = c[E ? h === "floating" ? "reference" : "floating" : h], _ = qg(await o.getClippingRect({
      element: (r = await (o.isElement == null ? void 0 : o.isElement(B))) == null || r ? B : B.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(c.floating)),
      boundary: d,
      rootBoundary: g,
      strategy: f
    })), M = h === "floating" ? {
      x: n,
      y: i,
      width: u.floating.width,
      height: u.floating.height
    } : u.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c.floating)), O = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
      x: 1,
      y: 1
    } : {
      x: 1,
      y: 1
    }, w = qg(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
      elements: c,
      rect: M,
      offsetParent: S,
      strategy: f
    }) : M);
    return {
      top: (_.top - w.top + I.top) / O.y,
      bottom: (w.bottom - _.bottom + I.bottom) / O.y,
      left: (_.left - w.left + I.left) / O.x,
      right: (w.right - _.right + I.right) / O.x
    };
  }
  const qn2 = (e) => ({
    name: "arrow",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: i,
        rects: o,
        platform: u,
        elements: c,
        middlewareData: f
      } = t, {
        element: d,
        padding: g = 0
      } = I8(e, t) || {};
      if (d == null)
        return {};
      const h = IU(g), E = {
        x: r,
        y: n
      }, y = LS(i), I = DS(y), Q = await u.getDimensions(d), B = y === "y", _ = B ? "top" : "left", M = B ? "bottom" : "right", S = B ? "clientHeight" : "clientWidth", O = o.reference[I] + o.reference[y] - E[y] - o.floating[I], w = E[y] - o.reference[y], D = await (u.getOffsetParent == null ? void 0 : u.getOffsetParent(d));
      let k = D ? D[S] : 0;
      (!k || !await (u.isElement == null ? void 0 : u.isElement(D))) && (k = c.floating[S] || o.floating[I]);
      const F = O / 2 - w / 2, z = k / 2 - Q[I] / 2 - 1, Z = W6(h[_], z), V = W6(h[M], z), $ = Z, W = k - Q[I] - V, t2 = k / 2 - Q[I] / 2 + F, n2 = xb($, t2, W), s2 = !f.arrow && os(i) != null && t2 !== n2 && o.reference[I] / 2 - (t2 < $ ? Z : V) - Q[I] / 2 < 0, l2 = s2 ? t2 < $ ? t2 - $ : t2 - W : 0;
      return {
        [y]: E[y] + l2,
        data: {
          [y]: n2,
          centerOffset: t2 - n2 - l2,
          ...s2 && {
            alignmentOffset: l2
          }
        },
        reset: s2
      };
    }
  }), Wn2 = function(e) {
    return e === void 0 && (e = {}), {
      name: "flip",
      options: e,
      async fn(t) {
        var r, n;
        const {
          placement: i,
          middlewareData: o,
          rects: u,
          initialPlacement: c,
          platform: f,
          elements: d
        } = t, {
          mainAxis: g = !0,
          crossAxis: h = !0,
          fallbackPlacements: E,
          fallbackStrategy: y = "bestFit",
          fallbackAxisSideDirection: I = "none",
          flipAlignment: Q = !0,
          ...B
        } = I8(e, t);
        if ((r = o.arrow) != null && r.alignmentOffset)
          return {};
        const _ = B8(i), M = s3(c), S = B8(c) === c, O = await (f.isRTL == null ? void 0 : f.isRTL(d.floating)), w = E || (S || !Q ? [Ug(c)] : jn2(c)), D = I !== "none";
        !E && D && w.push(...Zn2(c, Q, I, O));
        const k = [c, ...w], F = await Cc(t, B), z = [];
        let Z = ((n = o.flip) == null ? void 0 : n.overflows) || [];
        if (g && z.push(F[_]), h) {
          const t2 = Hn2(i, u, O);
          z.push(F[t2[0]], F[t2[1]]);
        }
        if (Z = [...Z, {
          placement: i,
          overflows: z
        }], !z.every((t2) => t2 <= 0)) {
          var V, $;
          const t2 = (((V = o.flip) == null ? void 0 : V.index) || 0) + 1, n2 = k[t2];
          if (n2 && (!(h === "alignment" ? M !== s3(n2) : !1) || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          Z.every((X) => X.overflows[0] > 0 && s3(X.placement) === M)))
            return {
              data: {
                index: t2,
                overflows: Z
              },
              reset: {
                placement: n2
              }
            };
          let s2 = ($ = Z.filter((l2) => l2.overflows[0] <= 0).sort((l2, X) => l2.overflows[1] - X.overflows[1])[0]) == null ? void 0 : $.placement;
          if (!s2)
            switch (y) {
              case "bestFit": {
                var W;
                const l2 = (W = Z.filter((X) => {
                  if (D) {
                    const a2 = s3(X.placement);
                    return a2 === M || // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    a2 === "y";
                  }
                  return !0;
                }).map((X) => [X.placement, X.overflows.filter((a2) => a2 > 0).reduce((a2, e2) => a2 + e2, 0)]).sort((X, a2) => X[1] - a2[1])[0]) == null ? void 0 : W[0];
                l2 && (s2 = l2);
                break;
              }
              case "initialPlacement":
                s2 = c;
                break;
            }
          if (i !== s2)
            return {
              reset: {
                placement: s2
              }
            };
        }
        return {};
      }
    };
  };
  function Bk(e, t) {
    return {
      top: e.top - t.height,
      right: e.right - t.width,
      bottom: e.bottom - t.height,
      left: e.left - t.width
    };
  }
  function Qk(e) {
    return Pn2.some((t) => e[t] >= 0);
  }
  const Yn2 = function(e) {
    return e === void 0 && (e = {}), {
      name: "hide",
      options: e,
      async fn(t) {
        const {
          rects: r
        } = t, {
          strategy: n = "referenceHidden",
          ...i
        } = I8(e, t);
        switch (n) {
          case "referenceHidden": {
            const o = await Cc(t, {
              ...i,
              elementContext: "reference"
            }), u = Bk(o, r.reference);
            return {
              data: {
                referenceHiddenOffsets: u,
                referenceHidden: Qk(u)
              }
            };
          }
          case "escaped": {
            const o = await Cc(t, {
              ...i,
              altBoundary: !0
            }), u = Bk(o, r.floating);
            return {
              data: {
                escapedOffsets: u,
                escaped: Qk(u)
              }
            };
          }
          default:
            return {};
        }
      }
    };
  };
  async function $n2(e, t) {
    const {
      placement: r,
      platform: n,
      elements: i
    } = e, o = await (n.isRTL == null ? void 0 : n.isRTL(i.floating)), u = B8(r), c = os(r), f = s3(r) === "y", d = ["left", "top"].includes(u) ? -1 : 1, g = o && f ? -1 : 1, h = I8(t, e);
    let {
      mainAxis: E,
      crossAxis: y,
      alignmentAxis: I
    } = typeof h == "number" ? {
      mainAxis: h,
      crossAxis: 0,
      alignmentAxis: null
    } : {
      mainAxis: h.mainAxis || 0,
      crossAxis: h.crossAxis || 0,
      alignmentAxis: h.alignmentAxis
    };
    return c && typeof I == "number" && (y = c === "end" ? I * -1 : I), f ? {
      x: y * g,
      y: E * d
    } : {
      x: E * d,
      y: y * g
    };
  }
  const Gn2 = function(e) {
    return e === void 0 && (e = 0), {
      name: "offset",
      options: e,
      async fn(t) {
        var r, n;
        const {
          x: i,
          y: o,
          placement: u,
          middlewareData: c
        } = t, f = await $n2(t, e);
        return u === ((r = c.offset) == null ? void 0 : r.placement) && (n = c.arrow) != null && n.alignmentOffset ? {} : {
          x: i + f.x,
          y: o + f.y,
          data: {
            ...f,
            placement: u
          }
        };
      }
    };
  }, Kn2 = function(e) {
    return e === void 0 && (e = {}), {
      name: "shift",
      options: e,
      async fn(t) {
        const {
          x: r,
          y: n,
          placement: i
        } = t, {
          mainAxis: o = !0,
          crossAxis: u = !1,
          limiter: c = {
            fn: (B) => {
              let {
                x: _,
                y: M
              } = B;
              return {
                x: _,
                y: M
              };
            }
          },
          ...f
        } = I8(e, t), d = {
          x: r,
          y: n
        }, g = await Cc(t, f), h = s3(B8(i)), E = TS(h);
        let y = d[E], I = d[h];
        if (o) {
          const B = E === "y" ? "top" : "left", _ = E === "y" ? "bottom" : "right", M = y + g[B], S = y - g[_];
          y = xb(M, y, S);
        }
        if (u) {
          const B = h === "y" ? "top" : "left", _ = h === "y" ? "bottom" : "right", M = I + g[B], S = I - g[_];
          I = xb(M, I, S);
        }
        const Q = c.fn({
          ...t,
          [E]: y,
          [h]: I
        });
        return {
          ...Q,
          data: {
            x: Q.x - r,
            y: Q.y - n,
            enabled: {
              [E]: o,
              [h]: u
            }
          }
        };
      }
    };
  }, Xn2 = function(e) {
    return e === void 0 && (e = {}), {
      options: e,
      fn(t) {
        const {
          x: r,
          y: n,
          placement: i,
          rects: o,
          middlewareData: u
        } = t, {
          offset: c = 0,
          mainAxis: f = !0,
          crossAxis: d = !0
        } = I8(e, t), g = {
          x: r,
          y: n
        }, h = s3(i), E = TS(h);
        let y = g[E], I = g[h];
        const Q = I8(c, t), B = typeof Q == "number" ? {
          mainAxis: Q,
          crossAxis: 0
        } : {
          mainAxis: 0,
          crossAxis: 0,
          ...Q
        };
        if (f) {
          const S = E === "y" ? "height" : "width", O = o.reference[E] - o.floating[S] + B.mainAxis, w = o.reference[E] + o.reference[S] - B.mainAxis;
          y < O ? y = O : y > w && (y = w);
        }
        if (d) {
          var _, M;
          const S = E === "y" ? "width" : "height", O = ["top", "left"].includes(B8(i)), w = o.reference[h] - o.floating[S] + (O && ((_ = u.offset) == null ? void 0 : _[h]) || 0) + (O ? 0 : B.crossAxis), D = o.reference[h] + o.reference[S] + (O ? 0 : ((M = u.offset) == null ? void 0 : M[h]) || 0) - (O ? B.crossAxis : 0);
          I < w ? I = w : I > D && (I = D);
        }
        return {
          [E]: y,
          [h]: I
        };
      }
    };
  }, Jn2 = function(e) {
    return e === void 0 && (e = {}), {
      name: "size",
      options: e,
      async fn(t) {
        var r, n;
        const {
          placement: i,
          rects: o,
          platform: u,
          elements: c
        } = t, {
          apply: f = () => {
          },
          ...d
        } = I8(e, t), g = await Cc(t, d), h = B8(i), E = os(i), y = s3(i) === "y", {
          width: I,
          height: Q
        } = o.floating;
        let B, _;
        h === "top" || h === "bottom" ? (B = h, _ = E === (await (u.isRTL == null ? void 0 : u.isRTL(c.floating)) ? "start" : "end") ? "left" : "right") : (_ = h, B = E === "end" ? "top" : "bottom");
        const M = Q - g.top - g.bottom, S = I - g.left - g.right, O = W6(Q - g[B], M), w = W6(I - g[_], S), D = !t.middlewareData.shift;
        let k = O, F = w;
        if ((r = t.middlewareData.shift) != null && r.enabled.x && (F = S), (n = t.middlewareData.shift) != null && n.enabled.y && (k = M), D && !E) {
          const Z = zr(g.left, 0), V = zr(g.right, 0), $ = zr(g.top, 0), W = zr(g.bottom, 0);
          y ? F = I - 2 * (Z !== 0 || V !== 0 ? Z + V : zr(g.left, g.right)) : k = Q - 2 * ($ !== 0 || W !== 0 ? $ + W : zr(g.top, g.bottom));
        }
        await f({
          ...t,
          availableWidth: F,
          availableHeight: k
        });
        const z = await u.getDimensions(c.floating);
        return I !== z.width || Q !== z.height ? {
          reset: {
            rects: !0
          }
        } : {};
      }
    };
  };
  function sh() {
    return typeof window < "u";
  }
  function ss(e) {
    return BU(e) ? (e.nodeName || "").toLowerCase() : "#document";
  }
  function qr(e) {
    var t;
    return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
  }
  function p3(e) {
    var t;
    return (t = (BU(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
  }
  function BU(e) {
    return sh() ? e instanceof Node || e instanceof qr(e).Node : !1;
  }
  function vn(e) {
    return sh() ? e instanceof Element || e instanceof qr(e).Element : !1;
  }
  function C3(e) {
    return sh() ? e instanceof HTMLElement || e instanceof qr(e).HTMLElement : !1;
  }
  function xk(e) {
    return !sh() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof qr(e).ShadowRoot;
  }
  function tA(e) {
    const {
      overflow: t,
      overflowX: r,
      overflowY: n,
      display: i
    } = En(e);
    return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(i);
  }
  function e32(e) {
    return ["table", "td", "th"].includes(ss(e));
  }
  function uh(e) {
    return [":popover-open", ":modal"].some((t) => {
      try {
        return e.matches(t);
      } catch {
        return !1;
      }
    });
  }
  function kS(e) {
    const t = RS(), r = vn(e) ? En(e) : e;
    return ["transform", "translate", "scale", "rotate", "perspective"].some((n) => r[n] ? r[n] !== "none" : !1) || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
  }
  function t32(e) {
    let t = Y6(e);
    for (; C3(t) && !x9(t); ) {
      if (kS(t))
        return t;
      if (uh(t))
        return null;
      t = Y6(t);
    }
    return null;
  }
  function RS() {
    return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
  }
  function x9(e) {
    return ["html", "body", "#document"].includes(ss(e));
  }
  function En(e) {
    return qr(e).getComputedStyle(e);
  }
  function lh(e) {
    return vn(e) ? {
      scrollLeft: e.scrollLeft,
      scrollTop: e.scrollTop
    } : {
      scrollLeft: e.scrollX,
      scrollTop: e.scrollY
    };
  }
  function Y6(e) {
    if (ss(e) === "html")
      return e;
    const t = (
      // Step into the shadow DOM of the parent of a slotted node.
      e.assignedSlot || // DOM Element detected.
      e.parentNode || // ShadowRoot detected.
      xk(e) && e.host || // Fallback.
      p3(e)
    );
    return xk(t) ? t.host : t;
  }
  function QU(e) {
    const t = Y6(e);
    return x9(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : C3(t) && tA(t) ? t : QU(t);
  }
  function dc(e, t, r) {
    var n;
    t === void 0 && (t = []), r === void 0 && (r = !0);
    const i = QU(e), o = i === ((n = e.ownerDocument) == null ? void 0 : n.body), u = qr(i);
    if (o) {
      const c = wb(u);
      return t.concat(u, u.visualViewport || [], tA(i) ? i : [], c && r ? dc(c) : []);
    }
    return t.concat(i, dc(i, [], r));
  }
  function wb(e) {
    return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
  }
  function xU(e) {
    const t = En(e);
    let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
    const i = C3(e), o = i ? e.offsetWidth : r, u = i ? e.offsetHeight : n, c = zg(r) !== o || zg(n) !== u;
    return c && (r = o, n = u), {
      width: r,
      height: n,
      $: c
    };
  }
  function PS(e) {
    return vn(e) ? e : e.contextElement;
  }
  function g9(e) {
    const t = PS(e);
    if (!C3(t))
      return l3(1);
    const r = t.getBoundingClientRect(), {
      width: n,
      height: i,
      $: o
    } = xU(t);
    let u = (o ? zg(r.width) : r.width) / n, c = (o ? zg(r.height) : r.height) / i;
    return (!u || !Number.isFinite(u)) && (u = 1), (!c || !Number.isFinite(c)) && (c = 1), {
      x: u,
      y: c
    };
  }
  const r32 = /* @__PURE__ */ l3(0);
  function bU(e) {
    const t = qr(e);
    return !RS() || !t.visualViewport ? r32 : {
      x: t.visualViewport.offsetLeft,
      y: t.visualViewport.offsetTop
    };
  }
  function n32(e, t, r) {
    return t === void 0 && (t = !1), !r || t && r !== qr(e) ? !1 : t;
  }
  function ji(e, t, r, n) {
    t === void 0 && (t = !1), r === void 0 && (r = !1);
    const i = e.getBoundingClientRect(), o = PS(e);
    let u = l3(1);
    t && (n ? vn(n) && (u = g9(n)) : u = g9(e));
    const c = n32(o, r, n) ? bU(o) : l3(0);
    let f = (i.left + c.x) / u.x, d = (i.top + c.y) / u.y, g = i.width / u.x, h = i.height / u.y;
    if (o) {
      const E = qr(o), y = n && vn(n) ? qr(n) : n;
      let I = E, Q = wb(I);
      for (; Q && n && y !== I; ) {
        const B = g9(Q), _ = Q.getBoundingClientRect(), M = En(Q), S = _.left + (Q.clientLeft + parseFloat(M.paddingLeft)) * B.x, O = _.top + (Q.clientTop + parseFloat(M.paddingTop)) * B.y;
        f *= B.x, d *= B.y, g *= B.x, h *= B.y, f += S, d += O, I = qr(Q), Q = wb(I);
      }
    }
    return qg({
      width: g,
      height: h,
      x: f,
      y: d
    });
  }
  function FS(e, t) {
    const r = lh(e).scrollLeft;
    return t ? t.left + r : ji(p3(e)).left + r;
  }
  function wU(e, t, r) {
    r === void 0 && (r = !1);
    const n = e.getBoundingClientRect(), i = n.left + t.scrollLeft - (r ? 0 : (
      // RTL <body> scrollbar.
      FS(e, n)
    )), o = n.top + t.scrollTop;
    return {
      x: i,
      y: o
    };
  }
  function i32(e) {
    let {
      elements: t,
      rect: r,
      offsetParent: n,
      strategy: i
    } = e;
    const o = i === "fixed", u = p3(n), c = t ? uh(t.floating) : !1;
    if (n === u || c && o)
      return r;
    let f = {
      scrollLeft: 0,
      scrollTop: 0
    }, d = l3(1);
    const g = l3(0), h = C3(n);
    if ((h || !h && !o) && ((ss(n) !== "body" || tA(u)) && (f = lh(n)), C3(n))) {
      const y = ji(n);
      d = g9(n), g.x = y.x + n.clientLeft, g.y = y.y + n.clientTop;
    }
    const E = u && !h && !o ? wU(u, f, !0) : l3(0);
    return {
      width: r.width * d.x,
      height: r.height * d.y,
      x: r.x * d.x - f.scrollLeft * d.x + g.x + E.x,
      y: r.y * d.y - f.scrollTop * d.y + g.y + E.y
    };
  }
  function a32(e) {
    return Array.from(e.getClientRects());
  }
  function o32(e) {
    const t = p3(e), r = lh(e), n = e.ownerDocument.body, i = zr(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), o = zr(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
    let u = -r.scrollLeft + FS(e);
    const c = -r.scrollTop;
    return En(n).direction === "rtl" && (u += zr(t.clientWidth, n.clientWidth) - i), {
      width: i,
      height: o,
      x: u,
      y: c
    };
  }
  function s32(e, t) {
    const r = qr(e), n = p3(e), i = r.visualViewport;
    let o = n.clientWidth, u = n.clientHeight, c = 0, f = 0;
    if (i) {
      o = i.width, u = i.height;
      const d = RS();
      (!d || d && t === "fixed") && (c = i.offsetLeft, f = i.offsetTop);
    }
    return {
      width: o,
      height: u,
      x: c,
      y: f
    };
  }
  function u32(e, t) {
    const r = ji(e, !0, t === "fixed"), n = r.top + e.clientTop, i = r.left + e.clientLeft, o = C3(e) ? g9(e) : l3(1), u = e.clientWidth * o.x, c = e.clientHeight * o.y, f = i * o.x, d = n * o.y;
    return {
      width: u,
      height: c,
      x: f,
      y: d
    };
  }
  function bk(e, t, r) {
    let n;
    if (t === "viewport")
      n = s32(e, r);
    else if (t === "document")
      n = o32(p3(e));
    else if (vn(t))
      n = u32(t, r);
    else {
      const i = bU(e);
      n = {
        x: t.x - i.x,
        y: t.y - i.y,
        width: t.width,
        height: t.height
      };
    }
    return qg(n);
  }
  function SU(e, t) {
    const r = Y6(e);
    return r === t || !vn(r) || x9(r) ? !1 : En(r).position === "fixed" || SU(r, t);
  }
  function l32(e, t) {
    const r = t.get(e);
    if (r)
      return r;
    let n = dc(e, [], !1).filter((c) => vn(c) && ss(c) !== "body"), i = null;
    const o = En(e).position === "fixed";
    let u = o ? Y6(e) : e;
    for (; vn(u) && !x9(u); ) {
      const c = En(u), f = kS(u);
      !f && c.position === "fixed" && (i = null), (o ? !f && !i : !f && c.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || tA(u) && !f && SU(e, u)) ? n = n.filter((g) => g !== u) : i = c, u = Y6(u);
    }
    return t.set(e, n), n;
  }
  function c32(e) {
    let {
      element: t,
      boundary: r,
      rootBoundary: n,
      strategy: i
    } = e;
    const u = [...r === "clippingAncestors" ? uh(t) ? [] : l32(t, this._c) : [].concat(r), n], c = u[0], f = u.reduce((d, g) => {
      const h = bk(t, g, i);
      return d.top = zr(h.top, d.top), d.right = W6(h.right, d.right), d.bottom = W6(h.bottom, d.bottom), d.left = zr(h.left, d.left), d;
    }, bk(t, c, i));
    return {
      width: f.right - f.left,
      height: f.bottom - f.top,
      x: f.left,
      y: f.top
    };
  }
  function A32(e) {
    const {
      width: t,
      height: r
    } = xU(e);
    return {
      width: t,
      height: r
    };
  }
  function f32(e, t, r) {
    const n = C3(t), i = p3(t), o = r === "fixed", u = ji(e, !0, o, t);
    let c = {
      scrollLeft: 0,
      scrollTop: 0
    };
    const f = l3(0);
    function d() {
      f.x = FS(i);
    }
    if (n || !n && !o)
      if ((ss(t) !== "body" || tA(i)) && (c = lh(t)), n) {
        const y = ji(t, !0, o, t);
        f.x = y.x + t.clientLeft, f.y = y.y + t.clientTop;
      } else i && d();
    o && !n && i && d();
    const g = i && !n && !o ? wU(i, c) : l3(0), h = u.left + c.scrollLeft - f.x - g.x, E = u.top + c.scrollTop - f.y - g.y;
    return {
      x: h,
      y: E,
      width: u.width,
      height: u.height
    };
  }
  function Fy(e) {
    return En(e).position === "static";
  }
  function wk(e, t) {
    if (!C3(e) || En(e).position === "fixed")
      return null;
    if (t)
      return t(e);
    let r = e.offsetParent;
    return p3(e) === r && (r = r.ownerDocument.body), r;
  }
  function MU(e, t) {
    const r = qr(e);
    if (uh(e))
      return r;
    if (!C3(e)) {
      let i = Y6(e);
      for (; i && !x9(i); ) {
        if (vn(i) && !Fy(i))
          return i;
        i = Y6(i);
      }
      return r;
    }
    let n = wk(e, t);
    for (; n && e32(n) && Fy(n); )
      n = wk(n, t);
    return n && x9(n) && Fy(n) && !kS(n) ? r : n || t32(e) || r;
  }
  const C32 = async function(e) {
    const t = this.getOffsetParent || MU, r = this.getDimensions, n = await r(e.floating);
    return {
      reference: f32(e.reference, await t(e.floating), e.strategy),
      floating: {
        x: 0,
        y: 0,
        width: n.width,
        height: n.height
      }
    };
  };
  function d32(e) {
    return En(e).direction === "rtl";
  }
  const g32 = {
    convertOffsetParentRelativeRectToViewportRelativeRect: i32,
    getDocumentElement: p3,
    getClippingRect: c32,
    getOffsetParent: MU,
    getElementRects: C32,
    getClientRects: a32,
    getDimensions: A32,
    getScale: g9,
    isElement: vn,
    isRTL: d32
  };
  function _U(e, t) {
    return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
  }
  function p32(e, t) {
    let r = null, n;
    const i = p3(e);
    function o() {
      var c;
      clearTimeout(n), (c = r) == null || c.disconnect(), r = null;
    }
    function u(c, f) {
      c === void 0 && (c = !1), f === void 0 && (f = 1), o();
      const d = e.getBoundingClientRect(), {
        left: g,
        top: h,
        width: E,
        height: y
      } = d;
      if (c || t(), !E || !y)
        return;
      const I = yd(h), Q = yd(i.clientWidth - (g + E)), B = yd(i.clientHeight - (h + y)), _ = yd(g), S = {
        rootMargin: -I + "px " + -Q + "px " + -B + "px " + -_ + "px",
        threshold: zr(0, W6(1, f)) || 1
      };
      let O = !0;
      function w(D) {
        const k = D[0].intersectionRatio;
        if (k !== f) {
          if (!O)
            return u();
          k ? u(!1, k) : n = setTimeout(() => {
            u(!1, 1e-7);
          }, 1e3);
        }
        k === 1 && !_U(d, e.getBoundingClientRect()) && u(), O = !1;
      }
      try {
        r = new IntersectionObserver(w, {
          ...S,
          // Handle <iframe>s
          root: i.ownerDocument
        });
      } catch {
        r = new IntersectionObserver(w, S);
      }
      r.observe(e);
    }
    return u(!0), o;
  }
  function h32(e, t, r, n) {
    n === void 0 && (n = {});
    const {
      ancestorScroll: i = !0,
      ancestorResize: o = !0,
      elementResize: u = typeof ResizeObserver == "function",
      layoutShift: c = typeof IntersectionObserver == "function",
      animationFrame: f = !1
    } = n, d = PS(e), g = i || o ? [...d ? dc(d) : [], ...dc(t)] : [];
    g.forEach((_) => {
      i && _.addEventListener("scroll", r, {
        passive: !0
      }), o && _.addEventListener("resize", r);
    });
    const h = d && c ? p32(d, r) : null;
    let E = -1, y = null;
    u && (y = new ResizeObserver((_) => {
      let [M] = _;
      M && M.target === d && y && (y.unobserve(t), cancelAnimationFrame(E), E = requestAnimationFrame(() => {
        var S;
        (S = y) == null || S.observe(t);
      })), r();
    }), d && !f && y.observe(d), y.observe(t));
    let I, Q = f ? ji(e) : null;
    f && B();
    function B() {
      const _ = ji(e);
      Q && !_U(Q, _) && r(), Q = _, I = requestAnimationFrame(B);
    }
    return r(), () => {
      var _;
      g.forEach((M) => {
        i && M.removeEventListener("scroll", r), o && M.removeEventListener("resize", r);
      }), h == null || h(), (_ = y) == null || _.disconnect(), y = null, f && cancelAnimationFrame(I);
    };
  }
  const v32 = Gn2, E32 = Kn2, m32 = Wn2, y32 = Jn2, I32 = Yn2, Sk = qn2, B32 = Xn2, Q32 = (e, t, r) => {
    const n = /* @__PURE__ */ new Map(), i = {
      platform: g32,
      ...r
    }, o = {
      ...i.platform,
      _c: n
    };
    return Un2(e, t, {
      ...i,
      platform: o
    });
  };
  var x32 = typeof document < "u", b32 = function() {
  }, Kd = x32 ? q.useLayoutEffect : b32;
  function Wg(e, t) {
    if (e === t)
      return !0;
    if (typeof e != typeof t)
      return !1;
    if (typeof e == "function" && e.toString() === t.toString())
      return !0;
    let r, n, i;
    if (e && t && typeof e == "object") {
      if (Array.isArray(e)) {
        if (r = e.length, r !== t.length) return !1;
        for (n = r; n-- !== 0; )
          if (!Wg(e[n], t[n]))
            return !1;
        return !0;
      }
      if (i = Object.keys(e), r = i.length, r !== Object.keys(t).length)
        return !1;
      for (n = r; n-- !== 0; )
        if (!{}.hasOwnProperty.call(t, i[n]))
          return !1;
      for (n = r; n-- !== 0; ) {
        const o = i[n];
        if (!(o === "_owner" && e.$$typeof) && !Wg(e[o], t[o]))
          return !1;
      }
      return !0;
    }
    return e !== e && t !== t;
  }
  function OU(e) {
    return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
  }
  function Mk(e, t) {
    const r = OU(e);
    return Math.round(t * r) / r;
  }
  function Ny(e) {
    const t = q.useRef(e);
    return Kd(() => {
      t.current = e;
    }), t;
  }
  function w32(e) {
    e === void 0 && (e = {});
    const {
      placement: t = "bottom",
      strategy: r = "absolute",
      middleware: n = [],
      platform: i,
      elements: {
        reference: o,
        floating: u
      } = {},
      transform: c = !0,
      whileElementsMounted: f,
      open: d
    } = e, [g, h] = q.useState({
      x: 0,
      y: 0,
      strategy: r,
      placement: t,
      middlewareData: {},
      isPositioned: !1
    }), [E, y] = q.useState(n);
    Wg(E, n) || y(n);
    const [I, Q] = q.useState(null), [B, _] = q.useState(null), M = q.useCallback((X) => {
      X !== D.current && (D.current = X, Q(X));
    }, []), S = q.useCallback((X) => {
      X !== k.current && (k.current = X, _(X));
    }, []), O = o || I, w = u || B, D = q.useRef(null), k = q.useRef(null), F = q.useRef(g), z = f != null, Z = Ny(f), V = Ny(i), $ = Ny(d), W = q.useCallback(() => {
      if (!D.current || !k.current)
        return;
      const X = {
        placement: t,
        strategy: r,
        middleware: E
      };
      V.current && (X.platform = V.current), Q32(D.current, k.current, X).then((a2) => {
        const e2 = {
          ...a2,
          // The floating element's position may be recomputed while it's closed
          // but still mounted (such as when transitioning out). To ensure
          // `isPositioned` will be `false` initially on the next open, avoid
          // setting it to `true` when `open === false` (must be specified).
          isPositioned: $.current !== !1
        };
        t2.current && !Wg(F.current, e2) && (F.current = e2, MS.flushSync(() => {
          h(e2);
        }));
      });
    }, [E, t, r, V, $]);
    Kd(() => {
      d === !1 && F.current.isPositioned && (F.current.isPositioned = !1, h((X) => ({
        ...X,
        isPositioned: !1
      })));
    }, [d]);
    const t2 = q.useRef(!1);
    Kd(() => (t2.current = !0, () => {
      t2.current = !1;
    }), []), Kd(() => {
      if (O && (D.current = O), w && (k.current = w), O && w) {
        if (Z.current)
          return Z.current(O, w, W);
        W();
      }
    }, [O, w, W, Z, z]);
    const n2 = q.useMemo(() => ({
      reference: D,
      floating: k,
      setReference: M,
      setFloating: S
    }), [M, S]), s2 = q.useMemo(() => ({
      reference: O,
      floating: w
    }), [O, w]), l2 = q.useMemo(() => {
      const X = {
        position: r,
        left: 0,
        top: 0
      };
      if (!s2.floating)
        return X;
      const a2 = Mk(s2.floating, g.x), e2 = Mk(s2.floating, g.y);
      return c ? {
        ...X,
        transform: "translate(" + a2 + "px, " + e2 + "px)",
        ...OU(s2.floating) >= 1.5 && {
          willChange: "transform"
        }
      } : {
        position: r,
        left: a2,
        top: e2
      };
    }, [r, c, s2.floating, g.x, g.y]);
    return q.useMemo(() => ({
      ...g,
      update: W,
      refs: n2,
      elements: s2,
      floatingStyles: l2
    }), [g, W, n2, s2, l2]);
  }
  const S32 = (e) => {
    function t(r) {
      return {}.hasOwnProperty.call(r, "current");
    }
    return {
      name: "arrow",
      options: e,
      fn(r) {
        const {
          element: n,
          padding: i
        } = typeof e == "function" ? e(r) : e;
        return n && t(n) ? n.current != null ? Sk({
          element: n.current,
          padding: i
        }).fn(r) : {} : n ? Sk({
          element: n,
          padding: i
        }).fn(r) : {};
      }
    };
  }, M32 = (e, t) => ({
    ...v32(e),
    options: [e, t]
  }), _32 = (e, t) => ({
    ...E32(e),
    options: [e, t]
  }), O32 = (e, t) => ({
    ...B32(e),
    options: [e, t]
  }), T32 = (e, t) => ({
    ...m32(e),
    options: [e, t]
  }), D32 = (e, t) => ({
    ...y32(e),
    options: [e, t]
  }), L32 = (e, t) => ({
    ...I32(e),
    options: [e, t]
  }), k32 = (e, t) => ({
    ...S32(e),
    options: [e, t]
  });
  var R32 = "Arrow", TU = q.forwardRef((e, t) => {
    const { children: r, width: n = 10, height: i = 5, ...o } = e;
    return /* @__PURE__ */ K.jsx(
      Yt.svg,
      {
        ...o,
        ref: t,
        width: n,
        height: i,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: e.asChild ? r : /* @__PURE__ */ K.jsx("polygon", { points: "0,0 30,0 15,10" })
      }
    );
  });
  TU.displayName = R32;
  var P32 = TU;
  function DU(e) {
    const [t, r] = q.useState(void 0);
    return q6(() => {
      if (e) {
        r({ width: e.offsetWidth, height: e.offsetHeight });
        const n = new ResizeObserver((i) => {
          if (!Array.isArray(i) || !i.length)
            return;
          const o = i[0];
          let u, c;
          if ("borderBoxSize" in o) {
            const f = o.borderBoxSize, d = Array.isArray(f) ? f[0] : f;
            u = d.inlineSize, c = d.blockSize;
          } else
            u = e.offsetWidth, c = e.offsetHeight;
          r({ width: u, height: c });
        });
        return n.observe(e, { box: "border-box" }), () => n.unobserve(e);
      } else
        r(void 0);
    }, [e]), t;
  }
  var NS = "Popper", [LU, ch] = G6(NS), [F32, kU] = LU(NS), RU = (e) => {
    const { __scopePopper: t, children: r } = e, [n, i] = q.useState(null);
    return /* @__PURE__ */ K.jsx(F32, { scope: t, anchor: n, onAnchorChange: i, children: r });
  };
  RU.displayName = NS;
  var PU = "PopperAnchor", FU = q.forwardRef(
    (e, t) => {
      const { __scopePopper: r, virtualRef: n, ...i } = e, o = kU(PU, r), u = q.useRef(null), c = H5(t, u);
      return q.useEffect(() => {
        o.onAnchorChange((n == null ? void 0 : n.current) || u.current);
      }), n ? null : /* @__PURE__ */ K.jsx(Yt.div, { ...i, ref: c });
    }
  );
  FU.displayName = PU;
  var HS = "PopperContent", [N32, H32] = LU(HS), NU = q.forwardRef(
    (e, t) => {
      var M2, w2, v2, L2, W2, d2;
      const {
        __scopePopper: r,
        side: n = "bottom",
        sideOffset: i = 0,
        align: o = "center",
        alignOffset: u = 0,
        arrowPadding: c = 0,
        avoidCollisions: f = !0,
        collisionBoundary: d = [],
        collisionPadding: g = 0,
        sticky: h = "partial",
        hideWhenDetached: E = !1,
        updatePositionStrategy: y = "optimized",
        onPlaced: I,
        ...Q
      } = e, B = kU(HS, r), [_, M] = q.useState(null), S = H5(t, (X2) => M(X2)), [O, w] = q.useState(null), D = DU(O), k = (D == null ? void 0 : D.width) ?? 0, F = (D == null ? void 0 : D.height) ?? 0, z = n + (o !== "center" ? "-" + o : ""), Z = typeof g == "number" ? g : { top: 0, right: 0, bottom: 0, left: 0, ...g }, V = Array.isArray(d) ? d : [d], $ = V.length > 0, W = {
        padding: Z,
        boundary: V.filter(V32),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: $
      }, { refs: t2, floatingStyles: n2, placement: s2, isPositioned: l2, middlewareData: X } = w32({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: z,
        whileElementsMounted: (...X2) => h32(...X2, {
          animationFrame: y === "always"
        }),
        elements: {
          reference: B.anchor
        },
        middleware: [
          M32({ mainAxis: i + F, alignmentAxis: u }),
          f && _32({
            mainAxis: !0,
            crossAxis: !1,
            limiter: h === "partial" ? O32() : void 0,
            ...W
          }),
          f && T32({ ...W }),
          D32({
            ...W,
            apply: ({ elements: X2, rects: k2, availableWidth: b0, availableHeight: S0 }) => {
              const { width: G0, height: $e } = k2.reference, _e = X2.floating.style;
              _e.setProperty("--radix-popper-available-width", `${b0}px`), _e.setProperty("--radix-popper-available-height", `${S0}px`), _e.setProperty("--radix-popper-anchor-width", `${G0}px`), _e.setProperty("--radix-popper-anchor-height", `${$e}px`);
            }
          }),
          O && k32({ element: O, padding: c }),
          Z32({ arrowWidth: k, arrowHeight: F }),
          E && L32({ strategy: "referenceHidden", ...W })
        ]
      }), [a2, e2] = VU(s2), H = y8(I);
      q6(() => {
        l2 && (H == null || H());
      }, [l2, H]);
      const Y = (M2 = X.arrow) == null ? void 0 : M2.x, r2 = (w2 = X.arrow) == null ? void 0 : w2.y, o2 = ((v2 = X.arrow) == null ? void 0 : v2.centerOffset) !== 0, [O2, S2] = q.useState();
      return q6(() => {
        _ && S2(window.getComputedStyle(_).zIndex);
      }, [_]), /* @__PURE__ */ K.jsx(
        "div",
        {
          ref: t2.setFloating,
          "data-radix-popper-content-wrapper": "",
          style: {
            ...n2,
            transform: l2 ? n2.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: O2,
            "--radix-popper-transform-origin": [
              (L2 = X.transformOrigin) == null ? void 0 : L2.x,
              (W2 = X.transformOrigin) == null ? void 0 : W2.y
            ].join(" "),
            // hide the content if using the hide middleware and should be hidden
            // set visibility to hidden and disable pointer events so the UI behaves
            // as if the PopperContent isn't there at all
            ...((d2 = X.hide) == null ? void 0 : d2.referenceHidden) && {
              visibility: "hidden",
              pointerEvents: "none"
            }
          },
          dir: e.dir,
          children: /* @__PURE__ */ K.jsx(
            N32,
            {
              scope: r,
              placedSide: a2,
              onArrowChange: w,
              arrowX: Y,
              arrowY: r2,
              shouldHideArrow: o2,
              children: /* @__PURE__ */ K.jsx(
                Yt.div,
                {
                  "data-side": a2,
                  "data-align": e2,
                  ...Q,
                  ref: S,
                  style: {
                    ...Q.style,
                    // if the PopperContent hasn't been placed yet (not all measurements done)
                    // we prevent animations so that users's animation don't kick in too early referring wrong sides
                    animation: l2 ? void 0 : "none"
                  }
                }
              )
            }
          )
        }
      );
    }
  );
  NU.displayName = HS;
  var HU = "PopperArrow", j32 = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
  }, jU = q.forwardRef(function(t, r) {
    const { __scopePopper: n, ...i } = t, o = H32(HU, n), u = j32[o.placedSide];
    return (
      // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
      // doesn't report size as we'd expect on SVG elements.
      // it reports their bounding box which is effectively the largest path inside the SVG.
      /* @__PURE__ */ K.jsx(
        "span",
        {
          ref: o.onArrowChange,
          style: {
            position: "absolute",
            left: o.arrowX,
            top: o.arrowY,
            [u]: 0,
            transformOrigin: {
              top: "",
              right: "0 0",
              bottom: "center 0",
              left: "100% 0"
            }[o.placedSide],
            transform: {
              top: "translateY(100%)",
              right: "translateY(50%) rotate(90deg) translateX(-50%)",
              bottom: "rotate(180deg)",
              left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[o.placedSide],
            visibility: o.shouldHideArrow ? "hidden" : void 0
          },
          children: /* @__PURE__ */ K.jsx(
            P32,
            {
              ...i,
              ref: r,
              style: {
                ...i.style,
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
              }
            }
          )
        }
      )
    );
  });
  jU.displayName = HU;
  function V32(e) {
    return e !== null;
  }
  var Z32 = (e) => ({
    name: "transformOrigin",
    options: e,
    fn(t) {
      var B, _, M;
      const { placement: r, rects: n, middlewareData: i } = t, u = ((B = i.arrow) == null ? void 0 : B.centerOffset) !== 0, c = u ? 0 : e.arrowWidth, f = u ? 0 : e.arrowHeight, [d, g] = VU(r), h = { start: "0%", center: "50%", end: "100%" }[g], E = (((_ = i.arrow) == null ? void 0 : _.x) ?? 0) + c / 2, y = (((M = i.arrow) == null ? void 0 : M.y) ?? 0) + f / 2;
      let I = "", Q = "";
      return d === "bottom" ? (I = u ? h : `${E}px`, Q = `${-f}px`) : d === "top" ? (I = u ? h : `${E}px`, Q = `${n.floating.height + f}px`) : d === "right" ? (I = `${-f}px`, Q = u ? h : `${y}px`) : d === "left" && (I = `${n.floating.width + f}px`, Q = u ? h : `${y}px`), { data: { x: I, y: Q } };
    }
  });
  function VU(e) {
    const [t, r = "center"] = e.split("-");
    return [t, r];
  }
  var ZU = RU, zU = FU, UU = NU, qU = jU, z32 = "Portal", jS = q.forwardRef((e, t) => {
    var c;
    const { container: r, ...n } = e, [i, o] = q.useState(!1);
    q6(() => o(!0), []);
    const u = r || i && ((c = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : c.body);
    return u ? An2.createPortal(/* @__PURE__ */ K.jsx(Yt.div, { ...n, ref: t }), u) : null;
  });
  jS.displayName = z32;
  function U32(e, t) {
    return q.useReducer((r, n) => t[r][n] ?? r, e);
  }
  var $i = (e) => {
    const { present: t, children: r } = e, n = q32(t), i = typeof r == "function" ? r({ present: n.isPresent }) : q.Children.only(r), o = H5(n.ref, W32(i));
    return typeof r == "function" || n.isPresent ? q.cloneElement(i, { ref: o }) : null;
  };
  $i.displayName = "Presence";
  function q32(e) {
    const [t, r] = q.useState(), n = q.useRef(null), i = q.useRef(e), o = q.useRef("none"), u = e ? "mounted" : "unmounted", [c, f] = U32(u, {
      mounted: {
        UNMOUNT: "unmounted",
        ANIMATION_OUT: "unmountSuspended"
      },
      unmountSuspended: {
        MOUNT: "mounted",
        ANIMATION_END: "unmounted"
      },
      unmounted: {
        MOUNT: "mounted"
      }
    });
    return q.useEffect(() => {
      const d = Id(n.current);
      o.current = c === "mounted" ? d : "none";
    }, [c]), q6(() => {
      const d = n.current, g = i.current;
      if (g !== e) {
        const E = o.current, y = Id(d);
        e ? f("MOUNT") : y === "none" || (d == null ? void 0 : d.display) === "none" ? f("UNMOUNT") : f(g && E !== y ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
      }
    }, [e, f]), q6(() => {
      if (t) {
        let d;
        const g = t.ownerDocument.defaultView ?? window, h = (y) => {
          const Q = Id(n.current).includes(y.animationName);
          if (y.target === t && Q && (f("ANIMATION_END"), !i.current)) {
            const B = t.style.animationFillMode;
            t.style.animationFillMode = "forwards", d = g.setTimeout(() => {
              t.style.animationFillMode === "forwards" && (t.style.animationFillMode = B);
            });
          }
        }, E = (y) => {
          y.target === t && (o.current = Id(n.current));
        };
        return t.addEventListener("animationstart", E), t.addEventListener("animationcancel", h), t.addEventListener("animationend", h), () => {
          g.clearTimeout(d), t.removeEventListener("animationstart", E), t.removeEventListener("animationcancel", h), t.removeEventListener("animationend", h);
        };
      } else
        f("ANIMATION_END");
    }, [t, f]), {
      isPresent: ["mounted", "unmountSuspended"].includes(c),
      ref: q.useCallback((d) => {
        n.current = d ? getComputedStyle(d) : null, r(d);
      }, [])
    };
  }
  function Id(e) {
    return (e == null ? void 0 : e.animationName) || "none";
  }
  function W32(e) {
    var n, i;
    let t = (n = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning;
    return r ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
  }
  var Hy = "rovingFocusGroup.onEntryFocus", Y32 = { bubbles: !1, cancelable: !0 }, rA = "RovingFocusGroup", [Sb, WU, $32] = hU(rA), [G32, Ah] = G6(
    rA,
    [$32]
  ), [K32, X32] = G32(rA), YU = q.forwardRef(
    (e, t) => /* @__PURE__ */ K.jsx(Sb.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ K.jsx(Sb.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ K.jsx(J32, { ...e, ref: t }) }) })
  );
  YU.displayName = rA;
  var J32 = q.forwardRef((e, t) => {
    const {
      __scopeRovingFocusGroup: r,
      orientation: n,
      loop: i = !1,
      dir: o,
      currentTabStopId: u,
      defaultCurrentTabStopId: c,
      onCurrentTabStopIdChange: f,
      onEntryFocus: d,
      preventScrollOnEntryFocus: g = !1,
      ...h
    } = e, E = q.useRef(null), y = H5(t, E), I = _S(o), [Q, B] = Yi({
      prop: u,
      defaultProp: c ?? null,
      onChange: f,
      caller: rA
    }), [_, M] = q.useState(!1), S = y8(d), O = WU(r), w = q.useRef(!1), [D, k] = q.useState(0);
    return q.useEffect(() => {
      const F = E.current;
      if (F)
        return F.addEventListener(Hy, S), () => F.removeEventListener(Hy, S);
    }, [S]), /* @__PURE__ */ K.jsx(
      K32,
      {
        scope: r,
        orientation: n,
        dir: I,
        loop: i,
        currentTabStopId: Q,
        onItemFocus: q.useCallback(
          (F) => B(F),
          [B]
        ),
        onItemShiftTab: q.useCallback(() => M(!0), []),
        onFocusableItemAdd: q.useCallback(
          () => k((F) => F + 1),
          []
        ),
        onFocusableItemRemove: q.useCallback(
          () => k((F) => F - 1),
          []
        ),
        children: /* @__PURE__ */ K.jsx(
          Yt.div,
          {
            tabIndex: _ || D === 0 ? -1 : 0,
            "data-orientation": n,
            ...h,
            ref: y,
            style: { outline: "none", ...e.style },
            onMouseDown: $0(e.onMouseDown, () => {
              w.current = !0;
            }),
            onFocus: $0(e.onFocus, (F) => {
              const z = !w.current;
              if (F.target === F.currentTarget && z && !_) {
                const Z = new CustomEvent(Hy, Y32);
                if (F.currentTarget.dispatchEvent(Z), !Z.defaultPrevented) {
                  const V = O().filter((s2) => s2.focusable), $ = V.find((s2) => s2.active), W = V.find((s2) => s2.id === Q), n2 = [$, W, ...V].filter(
                    Boolean
                  ).map((s2) => s2.ref.current);
                  KU(n2, g);
                }
              }
              w.current = !1;
            }),
            onBlur: $0(e.onBlur, () => M(!1))
          }
        )
      }
    );
  }), $U = "RovingFocusGroupItem", GU = q.forwardRef(
    (e, t) => {
      const {
        __scopeRovingFocusGroup: r,
        focusable: n = !0,
        active: i = !1,
        tabStopId: o,
        children: u,
        ...c
      } = e, f = Zg(), d = o || f, g = X32($U, r), h = g.currentTabStopId === d, E = WU(r), { onFocusableItemAdd: y, onFocusableItemRemove: I, currentTabStopId: Q } = g;
      return q.useEffect(() => {
        if (n)
          return y(), () => I();
      }, [n, y, I]), /* @__PURE__ */ K.jsx(
        Sb.ItemSlot,
        {
          scope: r,
          id: d,
          focusable: n,
          active: i,
          children: /* @__PURE__ */ K.jsx(
            Yt.span,
            {
              tabIndex: h ? 0 : -1,
              "data-orientation": g.orientation,
              ...c,
              ref: t,
              onMouseDown: $0(e.onMouseDown, (B) => {
                n ? g.onItemFocus(d) : B.preventDefault();
              }),
              onFocus: $0(e.onFocus, () => g.onItemFocus(d)),
              onKeyDown: $0(e.onKeyDown, (B) => {
                if (B.key === "Tab" && B.shiftKey) {
                  g.onItemShiftTab();
                  return;
                }
                if (B.target !== B.currentTarget) return;
                const _ = r82(B, g.orientation, g.dir);
                if (_ !== void 0) {
                  if (B.metaKey || B.ctrlKey || B.altKey || B.shiftKey) return;
                  B.preventDefault();
                  let S = E().filter((O) => O.focusable).map((O) => O.ref.current);
                  if (_ === "last") S.reverse();
                  else if (_ === "prev" || _ === "next") {
                    _ === "prev" && S.reverse();
                    const O = S.indexOf(B.currentTarget);
                    S = g.loop ? n82(S, O + 1) : S.slice(O + 1);
                  }
                  setTimeout(() => KU(S));
                }
              }),
              children: typeof u == "function" ? u({ isCurrentTabStop: h, hasTabStop: Q != null }) : u
            }
          )
        }
      );
    }
  );
  GU.displayName = $U;
  var e82 = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
  };
  function t82(e, t) {
    return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
  }
  function r82(e, t, r) {
    const n = t82(e.key, r);
    if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(n)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(n)))
      return e82[n];
  }
  function KU(e, t = !1) {
    const r = document.activeElement;
    for (const n of e)
      if (n === r || (n.focus({ preventScroll: t }), document.activeElement !== r)) return;
  }
  function n82(e, t) {
    return e.map((r, n) => e[(t + n) % e.length]);
  }
  var XU = YU, JU = GU, i82 = function(e) {
    if (typeof document > "u")
      return null;
    var t = Array.isArray(e) ? e[0] : e;
    return t.ownerDocument.body;
  }, Wo = /* @__PURE__ */ new WeakMap(), Bd = /* @__PURE__ */ new WeakMap(), Qd = {}, jy = 0, eq = function(e) {
    return e && (e.host || eq(e.parentNode));
  }, a82 = function(e, t) {
    return t.map(function(r) {
      if (e.contains(r))
        return r;
      var n = eq(r);
      return n && e.contains(n) ? n : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
    }).filter(function(r) {
      return !!r;
    });
  }, o82 = function(e, t, r, n) {
    var i = a82(t, Array.isArray(e) ? e : [e]);
    Qd[r] || (Qd[r] = /* @__PURE__ */ new WeakMap());
    var o = Qd[r], u = [], c = /* @__PURE__ */ new Set(), f = new Set(i), d = function(h) {
      !h || c.has(h) || (c.add(h), d(h.parentNode));
    };
    i.forEach(d);
    var g = function(h) {
      !h || f.has(h) || Array.prototype.forEach.call(h.children, function(E) {
        if (c.has(E))
          g(E);
        else
          try {
            var y = E.getAttribute(n), I = y !== null && y !== "false", Q = (Wo.get(E) || 0) + 1, B = (o.get(E) || 0) + 1;
            Wo.set(E, Q), o.set(E, B), u.push(E), Q === 1 && I && Bd.set(E, !0), B === 1 && E.setAttribute(r, "true"), I || E.setAttribute(n, "true");
          } catch (_) {
            console.error("aria-hidden: cannot operate on ", E, _);
          }
      });
    };
    return g(t), c.clear(), jy++, function() {
      u.forEach(function(h) {
        var E = Wo.get(h) - 1, y = o.get(h) - 1;
        Wo.set(h, E), o.set(h, y), E || (Bd.has(h) || h.removeAttribute(n), Bd.delete(h)), y || h.removeAttribute(r);
      }), jy--, jy || (Wo = /* @__PURE__ */ new WeakMap(), Wo = /* @__PURE__ */ new WeakMap(), Bd = /* @__PURE__ */ new WeakMap(), Qd = {});
    };
  }, s82 = function(e, t, r) {
    r === void 0 && (r = "data-aria-hidden");
    var n = Array.from(Array.isArray(e) ? e : [e]), i = i82(e);
    return i ? (n.push.apply(n, Array.from(i.querySelectorAll("[aria-live], script"))), o82(n, i, r, "aria-hidden")) : function() {
      return null;
    };
  }, Xd = "right-scroll-bar-position", Jd = "width-before-scroll-bar", u82 = "with-scroll-bars-hidden", l82 = "--removed-body-scroll-bar-size";
  function Vy(e, t) {
    return typeof e == "function" ? e(t) : e && (e.current = t), e;
  }
  function c82(e, t) {
    var r = q.useState(function() {
      return {
        // value
        value: e,
        // last callback
        callback: t,
        // "memoized" public interface
        facade: {
          get current() {
            return r.value;
          },
          set current(n) {
            var i = r.value;
            i !== n && (r.value = n, r.callback(n, i));
          }
        }
      };
    })[0];
    return r.callback = t, r.facade;
  }
  var A82 = typeof window < "u" ? q.useLayoutEffect : q.useEffect, _k = /* @__PURE__ */ new WeakMap();
  function f82(e, t) {
    var r = c82(null, function(n) {
      return e.forEach(function(i) {
        return Vy(i, n);
      });
    });
    return A82(function() {
      var n = _k.get(r);
      if (n) {
        var i = new Set(n), o = new Set(e), u = r.current;
        i.forEach(function(c) {
          o.has(c) || Vy(c, null);
        }), o.forEach(function(c) {
          i.has(c) || Vy(c, u);
        });
      }
      _k.set(r, e);
    }, [e]), r;
  }
  function C82(e) {
    return e;
  }
  function d82(e, t) {
    t === void 0 && (t = C82);
    var r = [], n = !1, i = {
      read: function() {
        if (n)
          throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
        return r.length ? r[r.length - 1] : e;
      },
      useMedium: function(o) {
        var u = t(o, n);
        return r.push(u), function() {
          r = r.filter(function(c) {
            return c !== u;
          });
        };
      },
      assignSyncMedium: function(o) {
        for (n = !0; r.length; ) {
          var u = r;
          r = [], u.forEach(o);
        }
        r = {
          push: function(c) {
            return o(c);
          },
          filter: function() {
            return r;
          }
        };
      },
      assignMedium: function(o) {
        n = !0;
        var u = [];
        if (r.length) {
          var c = r;
          r = [], c.forEach(o), u = r;
        }
        var f = function() {
          var g = u;
          u = [], g.forEach(o);
        }, d = function() {
          return Promise.resolve().then(f);
        };
        d(), r = {
          push: function(g) {
            u.push(g), d();
          },
          filter: function(g) {
            return u = u.filter(g), r;
          }
        };
      }
    };
    return i;
  }
  function g82(e) {
    e === void 0 && (e = {});
    var t = d82(null);
    return t.options = C2({ async: !0, ssr: !1 }, e), t;
  }
  var tq = function(e) {
    var t = e.sideCar, r = yr(e, ["sideCar"]);
    if (!t)
      throw new Error("Sidecar: please provide `sideCar` property to import the right car");
    var n = t.read();
    if (!n)
      throw new Error("Sidecar medium not found");
    return q.createElement(n, C2({}, r));
  };
  tq.isSideCarExport = !0;
  function p82(e, t) {
    return e.useMedium(t), tq;
  }
  var rq = g82(), Zy = function() {
  }, fh = q.forwardRef(function(e, t) {
    var r = q.useRef(null), n = q.useState({
      onScrollCapture: Zy,
      onWheelCapture: Zy,
      onTouchMoveCapture: Zy
    }), i = n[0], o = n[1], u = e.forwardProps, c = e.children, f = e.className, d = e.removeScrollBar, g = e.enabled, h = e.shards, E = e.sideCar, y = e.noRelative, I = e.noIsolation, Q = e.inert, B = e.allowPinchZoom, _ = e.as, M = _ === void 0 ? "div" : _, S = e.gapMode, O = yr(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = E, D = f82([r, t]), k = C2(C2({}, O), i);
    return q.createElement(
      q.Fragment,
      null,
      g && q.createElement(w, { sideCar: rq, removeScrollBar: d, shards: h, noRelative: y, noIsolation: I, inert: Q, setCallbacks: o, allowPinchZoom: !!B, lockRef: r, gapMode: S }),
      u ? q.cloneElement(q.Children.only(c), C2(C2({}, k), { ref: D })) : q.createElement(M, C2({}, k, { className: f, ref: D }), c)
    );
  });
  fh.defaultProps = {
    enabled: !0,
    removeScrollBar: !0,
    inert: !1
  };
  fh.classNames = {
    fullWidth: Jd,
    zeroRight: Xd
  };
  var h82 = function() {
    if (typeof __webpack_nonce__ < "u")
      return __webpack_nonce__;
  };
  function v82() {
    if (!document)
      return null;
    var e = document.createElement("style");
    e.type = "text/css";
    var t = h82();
    return t && e.setAttribute("nonce", t), e;
  }
  function E82(e, t) {
    e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
  }
  function m82(e) {
    var t = document.head || document.getElementsByTagName("head")[0];
    t.appendChild(e);
  }
  var y82 = function() {
    var e = 0, t = null;
    return {
      add: function(r) {
        e == 0 && (t = v82()) && (E82(t, r), m82(t)), e++;
      },
      remove: function() {
        e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
      }
    };
  }, I82 = function() {
    var e = y82();
    return function(t, r) {
      q.useEffect(function() {
        return e.add(t), function() {
          e.remove();
        };
      }, [t && r]);
    };
  }, nq = function() {
    var e = I82(), t = function(r) {
      var n = r.styles, i = r.dynamic;
      return e(n, i), null;
    };
    return t;
  }, B82 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
  }, zy = function(e) {
    return parseInt(e || "", 10) || 0;
  }, Q82 = function(e) {
    var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
    return [zy(r), zy(n), zy(i)];
  }, x82 = function(e) {
    if (e === void 0 && (e = "margin"), typeof window > "u")
      return B82;
    var t = Q82(e), r = document.documentElement.clientWidth, n = window.innerWidth;
    return {
      left: t[0],
      top: t[1],
      right: t[2],
      gap: Math.max(0, n - r + t[2] - t[0])
    };
  }, b82 = nq(), p9 = "data-scroll-locked", w82 = function(e, t, r, n) {
    var i = e.left, o = e.top, u = e.right, c = e.gap;
    return r === void 0 && (r = "margin"), `
  .`.concat(u82, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(c, "px ").concat(n, `;
  }
  body[`).concat(p9, `] {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([
      t && "position: relative ".concat(n, ";"),
      r === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(u, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(c, "px ").concat(n, `;
    `),
      r === "padding" && "padding-right: ".concat(c, "px ").concat(n, ";")
    ].filter(Boolean).join(""), `
  }
  
  .`).concat(Xd, ` {
    right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Jd, ` {
    margin-right: `).concat(c, "px ").concat(n, `;
  }
  
  .`).concat(Xd, " .").concat(Xd, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(Jd, " .").concat(Jd, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body[`).concat(p9, `] {
    `).concat(l82, ": ").concat(c, `px;
  }
`);
  }, Ok = function() {
    var e = parseInt(document.body.getAttribute(p9) || "0", 10);
    return isFinite(e) ? e : 0;
  }, S82 = function() {
    q.useEffect(function() {
      return document.body.setAttribute(p9, (Ok() + 1).toString()), function() {
        var e = Ok() - 1;
        e <= 0 ? document.body.removeAttribute(p9) : document.body.setAttribute(p9, e.toString());
      };
    }, []);
  }, M82 = function(e) {
    var t = e.noRelative, r = e.noImportant, n = e.gapMode, i = n === void 0 ? "margin" : n;
    S82();
    var o = q.useMemo(function() {
      return x82(i);
    }, [i]);
    return q.createElement(b82, { styles: w82(o, !t, i, r ? "" : "!important") });
  }, Mb = !1;
  if (typeof window < "u")
    try {
      var xd = Object.defineProperty({}, "passive", {
        get: function() {
          return Mb = !0, !0;
        }
      });
      window.addEventListener("test", xd, xd), window.removeEventListener("test", xd, xd);
    } catch {
      Mb = !1;
    }
  var Yo = Mb ? { passive: !1 } : !1, _82 = function(e) {
    return e.tagName === "TEXTAREA";
  }, iq = function(e, t) {
    if (!(e instanceof Element))
      return !1;
    var r = window.getComputedStyle(e);
    return (
      // not-not-scrollable
      r[t] !== "hidden" && // contains scroll inside self
      !(r.overflowY === r.overflowX && !_82(e) && r[t] === "visible")
    );
  }, O82 = function(e) {
    return iq(e, "overflowY");
  }, T82 = function(e) {
    return iq(e, "overflowX");
  }, Tk = function(e, t) {
    var r = t.ownerDocument, n = t;
    do {
      typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
      var i = aq(e, n);
      if (i) {
        var o = oq(e, n), u = o[1], c = o[2];
        if (u > c)
          return !0;
      }
      n = n.parentNode;
    } while (n && n !== r.body);
    return !1;
  }, D82 = function(e) {
    var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
    return [
      t,
      r,
      n
    ];
  }, L82 = function(e) {
    var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
    return [
      t,
      r,
      n
    ];
  }, aq = function(e, t) {
    return e === "v" ? O82(t) : T82(t);
  }, oq = function(e, t) {
    return e === "v" ? D82(t) : L82(t);
  }, k82 = function(e, t) {
    return e === "h" && t === "rtl" ? -1 : 1;
  }, R82 = function(e, t, r, n, i) {
    var o = k82(e, window.getComputedStyle(t).direction), u = o * n, c = r.target, f = t.contains(c), d = !1, g = u > 0, h = 0, E = 0;
    do {
      if (!c)
        break;
      var y = oq(e, c), I = y[0], Q = y[1], B = y[2], _ = Q - B - o * I;
      (I || _) && aq(e, c) && (h += _, E += I);
      var M = c.parentNode;
      c = M && M.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? M.host : M;
    } while (
      // portaled content
      !f && c !== document.body || // self content
      f && (t.contains(c) || t === c)
    );
    return (g && Math.abs(h) < 1 || !g && Math.abs(E) < 1) && (d = !0), d;
  }, bd = function(e) {
    return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
  }, Dk = function(e) {
    return [e.deltaX, e.deltaY];
  }, Lk = function(e) {
    return e && "current" in e ? e.current : e;
  }, P82 = function(e, t) {
    return e[0] === t[0] && e[1] === t[1];
  }, F82 = function(e) {
    return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
  }, N82 = 0, $o = [];
  function H82(e) {
    var t = q.useRef([]), r = q.useRef([0, 0]), n = q.useRef(), i = q.useState(N82++)[0], o = q.useState(nq)[0], u = q.useRef(e);
    q.useEffect(function() {
      u.current = e;
    }, [e]), q.useEffect(function() {
      if (e.inert) {
        document.body.classList.add("block-interactivity-".concat(i));
        var Q = l1([e.lockRef.current], (e.shards || []).map(Lk), !0).filter(Boolean);
        return Q.forEach(function(B) {
          return B.classList.add("allow-interactivity-".concat(i));
        }), function() {
          document.body.classList.remove("block-interactivity-".concat(i)), Q.forEach(function(B) {
            return B.classList.remove("allow-interactivity-".concat(i));
          });
        };
      }
    }, [e.inert, e.lockRef.current, e.shards]);
    var c = q.useCallback(function(Q, B) {
      if ("touches" in Q && Q.touches.length === 2 || Q.type === "wheel" && Q.ctrlKey)
        return !u.current.allowPinchZoom;
      var _ = bd(Q), M = r.current, S = "deltaX" in Q ? Q.deltaX : M[0] - _[0], O = "deltaY" in Q ? Q.deltaY : M[1] - _[1], w, D = Q.target, k = Math.abs(S) > Math.abs(O) ? "h" : "v";
      if ("touches" in Q && k === "h" && D.type === "range")
        return !1;
      var F = Tk(k, D);
      if (!F)
        return !0;
      if (F ? w = k : (w = k === "v" ? "h" : "v", F = Tk(k, D)), !F)
        return !1;
      if (!n.current && "changedTouches" in Q && (S || O) && (n.current = w), !w)
        return !0;
      var z = n.current || w;
      return R82(z, B, Q, z === "h" ? S : O);
    }, []), f = q.useCallback(function(Q) {
      var B = Q;
      if (!(!$o.length || $o[$o.length - 1] !== o)) {
        var _ = "deltaY" in B ? Dk(B) : bd(B), M = t.current.filter(function(w) {
          return w.name === B.type && (w.target === B.target || B.target === w.shadowParent) && P82(w.delta, _);
        })[0];
        if (M && M.should) {
          B.cancelable && B.preventDefault();
          return;
        }
        if (!M) {
          var S = (u.current.shards || []).map(Lk).filter(Boolean).filter(function(w) {
            return w.contains(B.target);
          }), O = S.length > 0 ? c(B, S[0]) : !u.current.noIsolation;
          O && B.cancelable && B.preventDefault();
        }
      }
    }, []), d = q.useCallback(function(Q, B, _, M) {
      var S = { name: Q, delta: B, target: _, should: M, shadowParent: j82(_) };
      t.current.push(S), setTimeout(function() {
        t.current = t.current.filter(function(O) {
          return O !== S;
        });
      }, 1);
    }, []), g = q.useCallback(function(Q) {
      r.current = bd(Q), n.current = void 0;
    }, []), h = q.useCallback(function(Q) {
      d(Q.type, Dk(Q), Q.target, c(Q, e.lockRef.current));
    }, []), E = q.useCallback(function(Q) {
      d(Q.type, bd(Q), Q.target, c(Q, e.lockRef.current));
    }, []);
    q.useEffect(function() {
      return $o.push(o), e.setCallbacks({
        onScrollCapture: h,
        onWheelCapture: h,
        onTouchMoveCapture: E
      }), document.addEventListener("wheel", f, Yo), document.addEventListener("touchmove", f, Yo), document.addEventListener("touchstart", g, Yo), function() {
        $o = $o.filter(function(Q) {
          return Q !== o;
        }), document.removeEventListener("wheel", f, Yo), document.removeEventListener("touchmove", f, Yo), document.removeEventListener("touchstart", g, Yo);
      };
    }, []);
    var y = e.removeScrollBar, I = e.inert;
    return q.createElement(
      q.Fragment,
      null,
      I ? q.createElement(o, { styles: F82(i) }) : null,
      y ? q.createElement(M82, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
    );
  }
  function j82(e) {
    for (var t = null; e !== null; )
      e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
    return t;
  }
  const V82 = p82(rq, H82);
  var sq = q.forwardRef(function(e, t) {
    return q.createElement(fh, C2({}, e, { ref: t, sideCar: V82 }));
  });
  sq.classNames = fh.classNames;
  var _b = ["Enter", " "], Z82 = ["ArrowDown", "PageUp", "Home"], uq = ["ArrowUp", "PageDown", "End"], z82 = [...Z82, ...uq], U82 = {
    ltr: [..._b, "ArrowRight"],
    rtl: [..._b, "ArrowLeft"]
  }, q82 = {
    ltr: ["ArrowLeft"],
    rtl: ["ArrowRight"]
  }, nA = "Menu", [gc, W82, Y82] = hU(nA), [Gi, lq] = G6(nA, [
    Y82,
    ch,
    Ah
  ]), Ch = ch(), cq = Ah(), [$82, Ki] = Gi(nA), [G82, iA] = Gi(nA), Aq = (e) => {
    const { __scopeMenu: t, open: r = !1, children: n, dir: i, onOpenChange: o, modal: u = !0 } = e, c = Ch(t), [f, d] = q.useState(null), g = q.useRef(!1), h = y8(o), E = _S(i);
    return q.useEffect(() => {
      const y = () => {
        g.current = !0, document.addEventListener("pointerdown", I, { capture: !0, once: !0 }), document.addEventListener("pointermove", I, { capture: !0, once: !0 });
      }, I = () => g.current = !1;
      return document.addEventListener("keydown", y, { capture: !0 }), () => {
        document.removeEventListener("keydown", y, { capture: !0 }), document.removeEventListener("pointerdown", I, { capture: !0 }), document.removeEventListener("pointermove", I, { capture: !0 });
      };
    }, []), /* @__PURE__ */ K.jsx(ZU, { ...c, children: /* @__PURE__ */ K.jsx(
      $82,
      {
        scope: t,
        open: r,
        onOpenChange: h,
        content: f,
        onContentChange: d,
        children: /* @__PURE__ */ K.jsx(
          G82,
          {
            scope: t,
            onClose: q.useCallback(() => h(!1), [h]),
            isUsingKeyboardRef: g,
            dir: E,
            modal: u,
            children: n
          }
        )
      }
    ) });
  };
  Aq.displayName = nA;
  var K82 = "MenuAnchor", VS = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, ...n } = e, i = Ch(r);
      return /* @__PURE__ */ K.jsx(zU, { ...i, ...n, ref: t });
    }
  );
  VS.displayName = K82;
  var ZS = "MenuPortal", [X82, fq] = Gi(ZS, {
    forceMount: void 0
  }), Cq = (e) => {
    const { __scopeMenu: t, forceMount: r, children: n, container: i } = e, o = Ki(ZS, t);
    return /* @__PURE__ */ K.jsx(X82, { scope: t, forceMount: r, children: /* @__PURE__ */ K.jsx($i, { present: r || o.open, children: /* @__PURE__ */ K.jsx(jS, { asChild: !0, container: i, children: n }) }) });
  };
  Cq.displayName = ZS;
  var b4 = "MenuContent", [J82, zS] = Gi(b4), dq = q.forwardRef(
    (e, t) => {
      const r = fq(b4, e.__scopeMenu), { forceMount: n = r.forceMount, ...i } = e, o = Ki(b4, e.__scopeMenu), u = iA(b4, e.__scopeMenu);
      return /* @__PURE__ */ K.jsx(gc.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ K.jsx($i, { present: n || o.open, children: /* @__PURE__ */ K.jsx(gc.Slot, { scope: e.__scopeMenu, children: u.modal ? /* @__PURE__ */ K.jsx(e62, { ...i, ref: t }) : /* @__PURE__ */ K.jsx(t62, { ...i, ref: t }) }) }) });
    }
  ), e62 = q.forwardRef(
    (e, t) => {
      const r = Ki(b4, e.__scopeMenu), n = q.useRef(null), i = H5(t, n);
      return q.useEffect(() => {
        const o = n.current;
        if (o) return s82(o);
      }, []), /* @__PURE__ */ K.jsx(
        US,
        {
          ...e,
          ref: i,
          trapFocus: r.open,
          disableOutsidePointerEvents: r.open,
          disableOutsideScroll: !0,
          onFocusOutside: $0(
            e.onFocusOutside,
            (o) => o.preventDefault(),
            { checkForDefaultPrevented: !1 }
          ),
          onDismiss: () => r.onOpenChange(!1)
        }
      );
    }
  ), t62 = q.forwardRef((e, t) => {
    const r = Ki(b4, e.__scopeMenu);
    return /* @__PURE__ */ K.jsx(
      US,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        onDismiss: () => r.onOpenChange(!1)
      }
    );
  }), r62 = /* @__PURE__ */ Vg("MenuContent.ScrollLock"), US = q.forwardRef(
    (e, t) => {
      const {
        __scopeMenu: r,
        loop: n = !1,
        trapFocus: i,
        onOpenAutoFocus: o,
        onCloseAutoFocus: u,
        disableOutsidePointerEvents: c,
        onEntryFocus: f,
        onEscapeKeyDown: d,
        onPointerDownOutside: g,
        onFocusOutside: h,
        onInteractOutside: E,
        onDismiss: y,
        disableOutsideScroll: I,
        ...Q
      } = e, B = Ki(b4, r), _ = iA(b4, r), M = Ch(r), S = cq(r), O = W82(r), [w, D] = q.useState(null), k = q.useRef(null), F = H5(t, k, B.onContentChange), z = q.useRef(0), Z = q.useRef(""), V = q.useRef(0), $ = q.useRef(null), W = q.useRef("right"), t2 = q.useRef(0), n2 = I ? sq : q.Fragment, s2 = I ? { as: r62, allowPinchZoom: !0 } : void 0, l2 = (a2) => {
        var M2, w2;
        const e2 = Z.current + a2, H = O().filter((v2) => !v2.disabled), Y = document.activeElement, r2 = (M2 = H.find((v2) => v2.ref.current === Y)) == null ? void 0 : M2.textValue, o2 = H.map((v2) => v2.textValue), O2 = d62(o2, e2, r2), S2 = (w2 = H.find((v2) => v2.textValue === O2)) == null ? void 0 : w2.ref.current;
        (function v2(L2) {
          Z.current = L2, window.clearTimeout(z.current), L2 !== "" && (z.current = window.setTimeout(() => v2(""), 1e3));
        })(e2), S2 && setTimeout(() => S2.focus());
      };
      q.useEffect(() => () => window.clearTimeout(z.current), []), wn2();
      const X = q.useCallback((a2) => {
        var H, Y;
        return W.current === ((H = $.current) == null ? void 0 : H.side) && p62(a2, (Y = $.current) == null ? void 0 : Y.area);
      }, []);
      return /* @__PURE__ */ K.jsx(
        J82,
        {
          scope: r,
          searchRef: Z,
          onItemEnter: q.useCallback(
            (a2) => {
              X(a2) && a2.preventDefault();
            },
            [X]
          ),
          onItemLeave: q.useCallback(
            (a2) => {
              var e2;
              X(a2) || ((e2 = k.current) == null || e2.focus(), D(null));
            },
            [X]
          ),
          onTriggerLeave: q.useCallback(
            (a2) => {
              X(a2) && a2.preventDefault();
            },
            [X]
          ),
          pointerGraceTimerRef: V,
          onPointerGraceIntentChange: q.useCallback((a2) => {
            $.current = a2;
          }, []),
          children: /* @__PURE__ */ K.jsx(n2, { ...s2, children: /* @__PURE__ */ K.jsx(
            mU,
            {
              asChild: !0,
              trapped: i,
              onMountAutoFocus: $0(o, (a2) => {
                var e2;
                a2.preventDefault(), (e2 = k.current) == null || e2.focus({ preventScroll: !0 });
              }),
              onUnmountAutoFocus: u,
              children: /* @__PURE__ */ K.jsx(
                OS,
                {
                  asChild: !0,
                  disableOutsidePointerEvents: c,
                  onEscapeKeyDown: d,
                  onPointerDownOutside: g,
                  onFocusOutside: h,
                  onInteractOutside: E,
                  onDismiss: y,
                  children: /* @__PURE__ */ K.jsx(
                    XU,
                    {
                      asChild: !0,
                      ...S,
                      dir: _.dir,
                      orientation: "vertical",
                      loop: n,
                      currentTabStopId: w,
                      onCurrentTabStopIdChange: D,
                      onEntryFocus: $0(f, (a2) => {
                        _.isUsingKeyboardRef.current || a2.preventDefault();
                      }),
                      preventScrollOnEntryFocus: !0,
                      children: /* @__PURE__ */ K.jsx(
                        UU,
                        {
                          role: "menu",
                          "aria-orientation": "vertical",
                          "data-state": _q(B.open),
                          "data-radix-menu-content": "",
                          dir: _.dir,
                          ...M,
                          ...Q,
                          ref: F,
                          style: { outline: "none", ...Q.style },
                          onKeyDown: $0(Q.onKeyDown, (a2) => {
                            const H = a2.target.closest("[data-radix-menu-content]") === a2.currentTarget, Y = a2.ctrlKey || a2.altKey || a2.metaKey, r2 = a2.key.length === 1;
                            H && (a2.key === "Tab" && a2.preventDefault(), !Y && r2 && l2(a2.key));
                            const o2 = k.current;
                            if (a2.target !== o2 || !z82.includes(a2.key)) return;
                            a2.preventDefault();
                            const S2 = O().filter((M2) => !M2.disabled).map((M2) => M2.ref.current);
                            uq.includes(a2.key) && S2.reverse(), f62(S2);
                          }),
                          onBlur: $0(e.onBlur, (a2) => {
                            a2.currentTarget.contains(a2.target) || (window.clearTimeout(z.current), Z.current = "");
                          }),
                          onPointerMove: $0(
                            e.onPointerMove,
                            pc((a2) => {
                              const e2 = a2.target, H = t2.current !== a2.clientX;
                              if (a2.currentTarget.contains(e2) && H) {
                                const Y = a2.clientX > t2.current ? "right" : "left";
                                W.current = Y, t2.current = a2.clientX;
                              }
                            })
                          )
                        }
                      )
                    }
                  )
                }
              )
            }
          ) })
        }
      );
    }
  );
  dq.displayName = b4;
  var n62 = "MenuGroup", qS = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, ...n } = e;
      return /* @__PURE__ */ K.jsx(Yt.div, { role: "group", ...n, ref: t });
    }
  );
  qS.displayName = n62;
  var i62 = "MenuLabel", gq = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, ...n } = e;
      return /* @__PURE__ */ K.jsx(Yt.div, { ...n, ref: t });
    }
  );
  gq.displayName = i62;
  var Yg = "MenuItem", kk = "menu.itemSelect", dh = q.forwardRef(
    (e, t) => {
      const { disabled: r = !1, onSelect: n, ...i } = e, o = q.useRef(null), u = iA(Yg, e.__scopeMenu), c = zS(Yg, e.__scopeMenu), f = H5(t, o), d = q.useRef(!1), g = () => {
        const h = o.current;
        if (!r && h) {
          const E = new CustomEvent(kk, { bubbles: !0, cancelable: !0 });
          h.addEventListener(kk, (y) => n == null ? void 0 : n(y), { once: !0 }), pU(h, E), E.defaultPrevented ? d.current = !1 : u.onClose();
        }
      };
      return /* @__PURE__ */ K.jsx(
        pq,
        {
          ...i,
          ref: f,
          disabled: r,
          onClick: $0(e.onClick, g),
          onPointerDown: (h) => {
            var E;
            (E = e.onPointerDown) == null || E.call(e, h), d.current = !0;
          },
          onPointerUp: $0(e.onPointerUp, (h) => {
            var E;
            d.current || (E = h.currentTarget) == null || E.click();
          }),
          onKeyDown: $0(e.onKeyDown, (h) => {
            const E = c.searchRef.current !== "";
            r || E && h.key === " " || _b.includes(h.key) && (h.currentTarget.click(), h.preventDefault());
          })
        }
      );
    }
  );
  dh.displayName = Yg;
  var pq = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, disabled: n = !1, textValue: i, ...o } = e, u = zS(Yg, r), c = cq(r), f = q.useRef(null), d = H5(t, f), [g, h] = q.useState(!1), [E, y] = q.useState("");
      return q.useEffect(() => {
        const I = f.current;
        I && y((I.textContent ?? "").trim());
      }, [o.children]), /* @__PURE__ */ K.jsx(
        gc.ItemSlot,
        {
          scope: r,
          disabled: n,
          textValue: i ?? E,
          children: /* @__PURE__ */ K.jsx(JU, { asChild: !0, ...c, focusable: !n, children: /* @__PURE__ */ K.jsx(
            Yt.div,
            {
              role: "menuitem",
              "data-highlighted": g ? "" : void 0,
              "aria-disabled": n || void 0,
              "data-disabled": n ? "" : void 0,
              ...o,
              ref: d,
              onPointerMove: $0(
                e.onPointerMove,
                pc((I) => {
                  n ? u.onItemLeave(I) : (u.onItemEnter(I), I.defaultPrevented || I.currentTarget.focus({ preventScroll: !0 }));
                })
              ),
              onPointerLeave: $0(
                e.onPointerLeave,
                pc((I) => u.onItemLeave(I))
              ),
              onFocus: $0(e.onFocus, () => h(!0)),
              onBlur: $0(e.onBlur, () => h(!1))
            }
          ) })
        }
      );
    }
  ), a62 = "MenuCheckboxItem", hq = q.forwardRef(
    (e, t) => {
      const { checked: r = !1, onCheckedChange: n, ...i } = e;
      return /* @__PURE__ */ K.jsx(Iq, { scope: e.__scopeMenu, checked: r, children: /* @__PURE__ */ K.jsx(
        dh,
        {
          role: "menuitemcheckbox",
          "aria-checked": $g(r) ? "mixed" : r,
          ...i,
          ref: t,
          "data-state": YS(r),
          onSelect: $0(
            i.onSelect,
            () => n == null ? void 0 : n($g(r) ? !0 : !r),
            { checkForDefaultPrevented: !1 }
          )
        }
      ) });
    }
  );
  hq.displayName = a62;
  var vq = "MenuRadioGroup", [o62, s62] = Gi(
    vq,
    { value: void 0, onValueChange: () => {
    } }
  ), Eq = q.forwardRef(
    (e, t) => {
      const { value: r, onValueChange: n, ...i } = e, o = y8(n);
      return /* @__PURE__ */ K.jsx(o62, { scope: e.__scopeMenu, value: r, onValueChange: o, children: /* @__PURE__ */ K.jsx(qS, { ...i, ref: t }) });
    }
  );
  Eq.displayName = vq;
  var mq = "MenuRadioItem", yq = q.forwardRef(
    (e, t) => {
      const { value: r, ...n } = e, i = s62(mq, e.__scopeMenu), o = r === i.value;
      return /* @__PURE__ */ K.jsx(Iq, { scope: e.__scopeMenu, checked: o, children: /* @__PURE__ */ K.jsx(
        dh,
        {
          role: "menuitemradio",
          "aria-checked": o,
          ...n,
          ref: t,
          "data-state": YS(o),
          onSelect: $0(
            n.onSelect,
            () => {
              var u;
              return (u = i.onValueChange) == null ? void 0 : u.call(i, r);
            },
            { checkForDefaultPrevented: !1 }
          )
        }
      ) });
    }
  );
  yq.displayName = mq;
  var WS = "MenuItemIndicator", [Iq, u62] = Gi(
    WS,
    { checked: !1 }
  ), Bq = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, forceMount: n, ...i } = e, o = u62(WS, r);
      return /* @__PURE__ */ K.jsx(
        $i,
        {
          present: n || $g(o.checked) || o.checked === !0,
          children: /* @__PURE__ */ K.jsx(
            Yt.span,
            {
              ...i,
              ref: t,
              "data-state": YS(o.checked)
            }
          )
        }
      );
    }
  );
  Bq.displayName = WS;
  var l62 = "MenuSeparator", Qq = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, ...n } = e;
      return /* @__PURE__ */ K.jsx(
        Yt.div,
        {
          role: "separator",
          "aria-orientation": "horizontal",
          ...n,
          ref: t
        }
      );
    }
  );
  Qq.displayName = l62;
  var c62 = "MenuArrow", xq = q.forwardRef(
    (e, t) => {
      const { __scopeMenu: r, ...n } = e, i = Ch(r);
      return /* @__PURE__ */ K.jsx(qU, { ...i, ...n, ref: t });
    }
  );
  xq.displayName = c62;
  var A62 = "MenuSub", [xQ2, bq] = Gi(A62), Wl = "MenuSubTrigger", wq = q.forwardRef(
    (e, t) => {
      const r = Ki(Wl, e.__scopeMenu), n = iA(Wl, e.__scopeMenu), i = bq(Wl, e.__scopeMenu), o = zS(Wl, e.__scopeMenu), u = q.useRef(null), { pointerGraceTimerRef: c, onPointerGraceIntentChange: f } = o, d = { __scopeMenu: e.__scopeMenu }, g = q.useCallback(() => {
        u.current && window.clearTimeout(u.current), u.current = null;
      }, []);
      return q.useEffect(() => g, [g]), q.useEffect(() => {
        const h = c.current;
        return () => {
          window.clearTimeout(h), f(null);
        };
      }, [c, f]), /* @__PURE__ */ K.jsx(VS, { asChild: !0, ...d, children: /* @__PURE__ */ K.jsx(
        pq,
        {
          id: i.triggerId,
          "aria-haspopup": "menu",
          "aria-expanded": r.open,
          "aria-controls": i.contentId,
          "data-state": _q(r.open),
          ...e,
          ref: oh(t, i.onTriggerChange),
          onClick: (h) => {
            var E;
            (E = e.onClick) == null || E.call(e, h), !(e.disabled || h.defaultPrevented) && (h.currentTarget.focus(), r.open || r.onOpenChange(!0));
          },
          onPointerMove: $0(
            e.onPointerMove,
            pc((h) => {
              o.onItemEnter(h), !h.defaultPrevented && !e.disabled && !r.open && !u.current && (o.onPointerGraceIntentChange(null), u.current = window.setTimeout(() => {
                r.onOpenChange(!0), g();
              }, 100));
            })
          ),
          onPointerLeave: $0(
            e.onPointerLeave,
            pc((h) => {
              var y, I;
              g();
              const E = (y = r.content) == null ? void 0 : y.getBoundingClientRect();
              if (E) {
                const Q = (I = r.content) == null ? void 0 : I.dataset.side, B = Q === "right", _ = B ? -5 : 5, M = E[B ? "left" : "right"], S = E[B ? "right" : "left"];
                o.onPointerGraceIntentChange({
                  area: [
                    // Apply a bleed on clientX to ensure that our exit point is
                    // consistently within polygon bounds
                    { x: h.clientX + _, y: h.clientY },
                    { x: M, y: E.top },
                    { x: S, y: E.top },
                    { x: S, y: E.bottom },
                    { x: M, y: E.bottom }
                  ],
                  side: Q
                }), window.clearTimeout(c.current), c.current = window.setTimeout(
                  () => o.onPointerGraceIntentChange(null),
                  300
                );
              } else {
                if (o.onTriggerLeave(h), h.defaultPrevented) return;
                o.onPointerGraceIntentChange(null);
              }
            })
          ),
          onKeyDown: $0(e.onKeyDown, (h) => {
            var y;
            const E = o.searchRef.current !== "";
            e.disabled || E && h.key === " " || U82[n.dir].includes(h.key) && (r.onOpenChange(!0), (y = r.content) == null || y.focus(), h.preventDefault());
          })
        }
      ) });
    }
  );
  wq.displayName = Wl;
  var Sq = "MenuSubContent", Mq = q.forwardRef(
    (e, t) => {
      const r = fq(b4, e.__scopeMenu), { forceMount: n = r.forceMount, ...i } = e, o = Ki(b4, e.__scopeMenu), u = iA(b4, e.__scopeMenu), c = bq(Sq, e.__scopeMenu), f = q.useRef(null), d = H5(t, f);
      return /* @__PURE__ */ K.jsx(gc.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ K.jsx($i, { present: n || o.open, children: /* @__PURE__ */ K.jsx(gc.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ K.jsx(
        US,
        {
          id: c.contentId,
          "aria-labelledby": c.triggerId,
          ...i,
          ref: d,
          align: "start",
          side: u.dir === "rtl" ? "left" : "right",
          disableOutsidePointerEvents: !1,
          disableOutsideScroll: !1,
          trapFocus: !1,
          onOpenAutoFocus: (g) => {
            var h;
            u.isUsingKeyboardRef.current && ((h = f.current) == null || h.focus()), g.preventDefault();
          },
          onCloseAutoFocus: (g) => g.preventDefault(),
          onFocusOutside: $0(e.onFocusOutside, (g) => {
            g.target !== c.trigger && o.onOpenChange(!1);
          }),
          onEscapeKeyDown: $0(e.onEscapeKeyDown, (g) => {
            u.onClose(), g.preventDefault();
          }),
          onKeyDown: $0(e.onKeyDown, (g) => {
            var y;
            const h = g.currentTarget.contains(g.target), E = q82[u.dir].includes(g.key);
            h && E && (o.onOpenChange(!1), (y = c.trigger) == null || y.focus(), g.preventDefault());
          })
        }
      ) }) }) });
    }
  );
  Mq.displayName = Sq;
  function _q(e) {
    return e ? "open" : "closed";
  }
  function $g(e) {
    return e === "indeterminate";
  }
  function YS(e) {
    return $g(e) ? "indeterminate" : e ? "checked" : "unchecked";
  }
  function f62(e) {
    const t = document.activeElement;
    for (const r of e)
      if (r === t || (r.focus(), document.activeElement !== t)) return;
  }
  function C62(e, t) {
    return e.map((r, n) => e[(t + n) % e.length]);
  }
  function d62(e, t, r) {
    const i = t.length > 1 && Array.from(t).every((d) => d === t[0]) ? t[0] : t, o = r ? e.indexOf(r) : -1;
    let u = C62(e, Math.max(o, 0));
    i.length === 1 && (u = u.filter((d) => d !== r));
    const f = u.find(
      (d) => d.toLowerCase().startsWith(i.toLowerCase())
    );
    return f !== r ? f : void 0;
  }
  function g62(e, t) {
    const { x: r, y: n } = e;
    let i = !1;
    for (let o = 0, u = t.length - 1; o < t.length; u = o++) {
      const c = t[o], f = t[u], d = c.x, g = c.y, h = f.x, E = f.y;
      g > n != E > n && r < (h - d) * (n - g) / (E - g) + d && (i = !i);
    }
    return i;
  }
  function p62(e, t) {
    if (!t) return !1;
    const r = { x: e.clientX, y: e.clientY };
    return g62(r, t);
  }
  function pc(e) {
    return (t) => t.pointerType === "mouse" ? e(t) : void 0;
  }
  var h62 = Aq, v62 = VS, E62 = Cq, m62 = dq, y62 = qS, I62 = gq, B62 = dh, Q62 = hq, x62 = Eq, b62 = yq, w62 = Bq, S62 = Qq, M62 = xq, _62 = wq, O62 = Mq, gh = "DropdownMenu", [T62, bQ2] = G6(
    gh,
    [lq]
  ), K1 = lq(), [D62, Oq] = T62(gh), Tq = (e) => {
    const {
      __scopeDropdownMenu: t,
      children: r,
      dir: n,
      open: i,
      defaultOpen: o,
      onOpenChange: u,
      modal: c = !0
    } = e, f = K1(t), d = q.useRef(null), [g, h] = Yi({
      prop: i,
      defaultProp: o ?? !1,
      onChange: u,
      caller: gh
    });
    return /* @__PURE__ */ K.jsx(
      D62,
      {
        scope: t,
        triggerId: Zg(),
        triggerRef: d,
        contentId: Zg(),
        open: g,
        onOpenChange: h,
        onOpenToggle: q.useCallback(() => h((E) => !E), [h]),
        modal: c,
        children: /* @__PURE__ */ K.jsx(h62, { ...f, open: g, onOpenChange: h, dir: n, modal: c, children: r })
      }
    );
  };
  Tq.displayName = gh;
  var Dq = "DropdownMenuTrigger", Lq = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, disabled: n = !1, ...i } = e, o = Oq(Dq, r), u = K1(r);
      return /* @__PURE__ */ K.jsx(v62, { asChild: !0, ...u, children: /* @__PURE__ */ K.jsx(
        Yt.button,
        {
          type: "button",
          id: o.triggerId,
          "aria-haspopup": "menu",
          "aria-expanded": o.open,
          "aria-controls": o.open ? o.contentId : void 0,
          "data-state": o.open ? "open" : "closed",
          "data-disabled": n ? "" : void 0,
          disabled: n,
          ...i,
          ref: oh(t, o.triggerRef),
          onPointerDown: $0(e.onPointerDown, (c) => {
            !n && c.button === 0 && c.ctrlKey === !1 && (o.onOpenToggle(), o.open || c.preventDefault());
          }),
          onKeyDown: $0(e.onKeyDown, (c) => {
            n || (["Enter", " "].includes(c.key) && o.onOpenToggle(), c.key === "ArrowDown" && o.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(c.key) && c.preventDefault());
          })
        }
      ) });
    }
  );
  Lq.displayName = Dq;
  var L62 = "DropdownMenuPortal", kq = (e) => {
    const { __scopeDropdownMenu: t, ...r } = e, n = K1(t);
    return /* @__PURE__ */ K.jsx(E62, { ...n, ...r });
  };
  kq.displayName = L62;
  var Rq = "DropdownMenuContent", Pq = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, ...n } = e, i = Oq(Rq, r), o = K1(r), u = q.useRef(!1);
      return /* @__PURE__ */ K.jsx(
        m62,
        {
          id: i.contentId,
          "aria-labelledby": i.triggerId,
          ...o,
          ...n,
          ref: t,
          onCloseAutoFocus: $0(e.onCloseAutoFocus, (c) => {
            var f;
            u.current || (f = i.triggerRef.current) == null || f.focus(), u.current = !1, c.preventDefault();
          }),
          onInteractOutside: $0(e.onInteractOutside, (c) => {
            const f = c.detail.originalEvent, d = f.button === 0 && f.ctrlKey === !0, g = f.button === 2 || d;
            (!i.modal || g) && (u.current = !0);
          }),
          style: {
            ...e.style,
            "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
            "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
            "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      );
    }
  );
  Pq.displayName = Rq;
  var k62 = "DropdownMenuGroup", R62 = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
      return /* @__PURE__ */ K.jsx(y62, { ...i, ...n, ref: t });
    }
  );
  R62.displayName = k62;
  var P62 = "DropdownMenuLabel", F62 = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
      return /* @__PURE__ */ K.jsx(I62, { ...i, ...n, ref: t });
    }
  );
  F62.displayName = P62;
  var N62 = "DropdownMenuItem", H62 = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
      return /* @__PURE__ */ K.jsx(B62, { ...i, ...n, ref: t });
    }
  );
  H62.displayName = N62;
  var j62 = "DropdownMenuCheckboxItem", V62 = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(Q62, { ...i, ...n, ref: t });
  });
  V62.displayName = j62;
  var Z62 = "DropdownMenuRadioGroup", Fq = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(x62, { ...i, ...n, ref: t });
  });
  Fq.displayName = Z62;
  var z62 = "DropdownMenuRadioItem", Nq = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(b62, { ...i, ...n, ref: t });
  });
  Nq.displayName = z62;
  var U62 = "DropdownMenuItemIndicator", Hq = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(w62, { ...i, ...n, ref: t });
  });
  Hq.displayName = U62;
  var q62 = "DropdownMenuSeparator", W62 = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(S62, { ...i, ...n, ref: t });
  });
  W62.displayName = q62;
  var Y62 = "DropdownMenuArrow", $62 = q.forwardRef(
    (e, t) => {
      const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
      return /* @__PURE__ */ K.jsx(M62, { ...i, ...n, ref: t });
    }
  );
  $62.displayName = Y62;
  var G62 = "DropdownMenuSubTrigger", K62 = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(_62, { ...i, ...n, ref: t });
  });
  K62.displayName = G62;
  var X62 = "DropdownMenuSubContent", J62 = q.forwardRef((e, t) => {
    const { __scopeDropdownMenu: r, ...n } = e, i = K1(r);
    return /* @__PURE__ */ K.jsx(
      O62,
      {
        ...i,
        ...n,
        ref: t,
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  });
  J62.displayName = X62;
  var e72 = Tq, t72 = Lq, r72 = kq, n72 = Pq, i72 = Fq, a72 = Nq, o72 = Hq;
  function T1(...e) {
    return CU(pe(e));
  }
  function s72({ ...e }) {
    return /* @__PURE__ */ K.jsx(e72, { "data-slot": "dropdown-menu", ...e });
  }
  function u72({ ...e }) {
    return /* @__PURE__ */ K.jsx(t72, { "data-slot": "dropdown-menu-trigger", ...e });
  }
  function l72({
    className: e,
    sideOffset: t = 4,
    container: r,
    ...n
  }) {
    return /* @__PURE__ */ K.jsx(r72, { container: r, children: /* @__PURE__ */ K.jsx(
      n72,
      {
        "data-slot": "dropdown-menu-content",
        sideOffset: t,
        className: T1(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-(--radix-dropdown-menu-content-available-height) min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-x-hidden overflow-y-auto rounded-md border p-1 shadow-md",
          e
        ),
        ...n
      }
    ) });
  }
  function c72({ ...e }) {
    return /* @__PURE__ */ K.jsx(i72, { "data-slot": "dropdown-menu-radio-group", ...e });
  }
  function A72({
    className: e,
    children: t,
    ...r
  }) {
    return /* @__PURE__ */ K.jsxs(
      a72,
      {
        "data-slot": "dropdown-menu-radio-item",
        className: T1(
          "focus:bg-accent focus:text-accent-foreground relative flex cursor-default items-center gap-2 rounded-sm py-1.5 pl-2 pr-8 text-sm outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4 data-[state=checked]:font-bold",
          e
        ),
        ...r,
        children: [
          t,
          /* @__PURE__ */ K.jsx("span", { className: "pointer-events-none absolute right-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ K.jsx(o72, { children: /* @__PURE__ */ K.jsx(X42, { className: "size-4" }) }) })
        ]
      }
    );
  }
  const jq = () => {
    const e = q.useRef(null), [t, r] = q.useState(null), n = (o) => {
      getComputedStyle(o).position === "static" && (o.style.position = "relative");
    }, i = () => {
      if (!e.current) return;
      const o = e.current.getRootNode();
      if (o instanceof ShadowRoot) {
        const u = o.host;
        u && n(u), r(o);
      } else
        r(document.body);
    };
    return q.useEffect(() => {
      i();
    }, []), { containerRef: e, portalContainer: t };
  }, f72 = ({
    items: e,
    value: t,
    defaultValue: r,
    onValueChange: n,
    placeholder: i = "Select an option...",
    error: o,
    className: u,
    alignment: c = "start",
    side: f = "bottom",
    disabled: d = !1,
    testId: g,
    id: h,
    label: E
  }) => {
    const y = t !== void 0, [I, Q] = q.useState(r || ""), { containerRef: B, portalContainer: _ } = jq(), M = y ? t : I, S = "w-full text-base font-normal text-neutral-900 bg-white hover:bg-white dark:bg-white dark:hover:bg-white border border-neutral-300 rounded-sm px-3 py-2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary-600 focus-visible:border-primary-600 focus:ring-1 focus:ring-primary-600 focus:border-primary-600 [&_svg]:opacity-100 [&_svg]:stroke-neutral-500", O = o ? "border-destructive-600 focus-visible:border-destructive-600 focus-visible:ring-destructive-600 focus:border-destructive-600 focus:ring-destructive-600" : "", w = d || e.length === 0 ? "opacity-50 cursor-not-allowed" : "", D = (Z, V, $) => {
      V && $ && Z.length > 0 && (Z.some((t2) => t2.value === $) || console.warn(`Dropdown: value "${$}" not found in items`));
    };
    q.useEffect(() => {
      D(e, y, t);
    }, [e, y, t]);
    const k = q.useCallback(
      (Z) => {
        y || Q(Z), n == null || n(Z);
      },
      [y, n]
    ), F = q.useCallback(() => {
      if (!M) return i;
      const Z = e.find((V) => V.value === M);
      return (Z == null ? void 0 : Z.label) || i;
    }, [e, M, i]), z = d || e.length === 0;
    return /* @__PURE__ */ K.jsxs("div", { ref: B, children: [
      E && /* @__PURE__ */ K.jsx("label", { htmlFor: h, className: "text-neutral-900 text-base inline-block mb-2", children: E }),
      /* @__PURE__ */ K.jsxs(s72, { children: [
        /* @__PURE__ */ K.jsx(
          u72,
          {
            className: T1(S, O, w, u),
            disabled: z,
            "data-testid": g,
            children: /* @__PURE__ */ K.jsxs("div", { className: "flex flex-row items-center justify-between text-base gap-2", children: [
              /* @__PURE__ */ K.jsx("span", { className: T1("line-clamp-1 text-left", !M && "text-neutral-500"), children: e.length === 0 ? "No options available" : F() }),
              /* @__PURE__ */ K.jsx(en2, { className: "size-4 opacity-50 flex-shrink-0" })
            ] })
          }
        ),
        e.length > 0 && /* @__PURE__ */ K.jsx(l72, { className: "min-w-full", side: f, align: c, container: _, children: /* @__PURE__ */ K.jsx(c72, { value: M, onValueChange: k, children: e.map(({ label: Z, value: V }) => /* @__PURE__ */ K.jsx(
          A72,
          {
            value: V,
            className: "text-base font-normal text-neutral-900 px-3 py-2 pr-10 truncate data-[state=checked]:font-bold data-[state=checked]:[&_svg]:stroke-primary-600 data-[state=checked]:[&_svg]:stroke-2",
            children: Z
          },
          V
        )) }) })
      ] }),
      o && /* @__PURE__ */ K.jsx("p", { className: "text-xs text-destructive-600 font-normal mt-1", children: o })
    ] });
  }, C72 = ({ facilities: e, selectedFacility: t, onFacilityChange: r }) => {
    const n = e.map(({ id: i, name: o }) => ({
      label: o,
      value: i
    }));
    return /* @__PURE__ */ K.jsxs("div", { className: "w-70", children: [
      /* @__PURE__ */ K.jsx("p", { className: "text-sm mb-1 font-bold", children: ne.facilitySelection.label }),
      /* @__PURE__ */ K.jsx(f72, { items: n, value: t == null ? void 0 : t.id, onValueChange: r, alignment: "end" })
    ] });
  }, Uy = () => /* @__PURE__ */ K.jsxs("div", { className: "flex flex-col w-full items-center justify-center py-20", "data-testid": "visitation-report-loading", children: [
    /* @__PURE__ */ K.jsx(on2, { className: "h-12 w-12 text-neutral-500 animate-spin stroke-1 mb-6" }),
    /* @__PURE__ */ K.jsx("p", { className: "text-base tracking-[0px] font-medium text-neutral-600", children: ne.loading.title })
  ] }), d72 = {
    0: ne.daysOfTheWeek.sunday,
    1: ne.daysOfTheWeek.monday,
    2: ne.daysOfTheWeek.tuesday,
    3: ne.daysOfTheWeek.wednesday,
    4: ne.daysOfTheWeek.thursday,
    5: ne.daysOfTheWeek.friday,
    6: ne.daysOfTheWeek.saturday
  }, g72 = (e) => e.slice().sort((t, r) => {
    const n = (i) => i === 0 ? 7 : i;
    return n(t.dayOfWeekNumber) - n(r.dayOfWeekNumber);
  }), p72 = (e) => g72(e).map(({ dayOfWeekNumber: r, visits: n }) => ({
    day: d72[r] ?? "",
    dayOfWeekNumber: r,
    visits: n
  }));
  var h72 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
  }), v72 = "VisuallyHidden", Vq = q.forwardRef(
    (e, t) => /* @__PURE__ */ K.jsx(
      Yt.span,
      {
        ...e,
        ref: t,
        style: { ...h72, ...e.style }
      }
    )
  );
  Vq.displayName = v72;
  var E72 = Vq, [ph, wQ2] = G6("Tooltip", [
    ch
  ]), hh = ch(), Zq = "TooltipProvider", m72 = 700, Ob = "tooltip.open", [y72, $S] = ph(Zq), zq = (e) => {
    const {
      __scopeTooltip: t,
      delayDuration: r = m72,
      skipDelayDuration: n = 300,
      disableHoverableContent: i = !1,
      children: o
    } = e, u = q.useRef(!0), c = q.useRef(!1), f = q.useRef(0);
    return q.useEffect(() => {
      const d = f.current;
      return () => window.clearTimeout(d);
    }, []), /* @__PURE__ */ K.jsx(
      y72,
      {
        scope: t,
        isOpenDelayedRef: u,
        delayDuration: r,
        onOpen: q.useCallback(() => {
          window.clearTimeout(f.current), u.current = !1;
        }, []),
        onClose: q.useCallback(() => {
          window.clearTimeout(f.current), f.current = window.setTimeout(
            () => u.current = !0,
            n
          );
        }, [n]),
        isPointerInTransitRef: c,
        onPointerInTransitChange: q.useCallback((d) => {
          c.current = d;
        }, []),
        disableHoverableContent: i,
        children: o
      }
    );
  };
  zq.displayName = Zq;
  var hc = "Tooltip", [I72, aA] = ph(hc), Uq = (e) => {
    const {
      __scopeTooltip: t,
      children: r,
      open: n,
      defaultOpen: i,
      onOpenChange: o,
      disableHoverableContent: u,
      delayDuration: c
    } = e, f = $S(hc, e.__scopeTooltip), d = hh(t), [g, h] = q.useState(null), E = Zg(), y = q.useRef(0), I = u ?? f.disableHoverableContent, Q = c ?? f.delayDuration, B = q.useRef(!1), [_, M] = Yi({
      prop: n,
      defaultProp: i ?? !1,
      onChange: (k) => {
        k ? (f.onOpen(), document.dispatchEvent(new CustomEvent(Ob))) : f.onClose(), o == null || o(k);
      },
      caller: hc
    }), S = q.useMemo(() => _ ? B.current ? "delayed-open" : "instant-open" : "closed", [_]), O = q.useCallback(() => {
      window.clearTimeout(y.current), y.current = 0, B.current = !1, M(!0);
    }, [M]), w = q.useCallback(() => {
      window.clearTimeout(y.current), y.current = 0, M(!1);
    }, [M]), D = q.useCallback(() => {
      window.clearTimeout(y.current), y.current = window.setTimeout(() => {
        B.current = !0, M(!0), y.current = 0;
      }, Q);
    }, [Q, M]);
    return q.useEffect(() => () => {
      y.current && (window.clearTimeout(y.current), y.current = 0);
    }, []), /* @__PURE__ */ K.jsx(ZU, { ...d, children: /* @__PURE__ */ K.jsx(
      I72,
      {
        scope: t,
        contentId: E,
        open: _,
        stateAttribute: S,
        trigger: g,
        onTriggerChange: h,
        onTriggerEnter: q.useCallback(() => {
          f.isOpenDelayedRef.current ? D() : O();
        }, [f.isOpenDelayedRef, D, O]),
        onTriggerLeave: q.useCallback(() => {
          I ? w() : (window.clearTimeout(y.current), y.current = 0);
        }, [w, I]),
        onOpen: O,
        onClose: w,
        disableHoverableContent: I,
        children: r
      }
    ) });
  };
  Uq.displayName = hc;
  var Tb = "TooltipTrigger", qq = q.forwardRef(
    (e, t) => {
      const { __scopeTooltip: r, ...n } = e, i = aA(Tb, r), o = $S(Tb, r), u = hh(r), c = q.useRef(null), f = H5(t, c, i.onTriggerChange), d = q.useRef(!1), g = q.useRef(!1), h = q.useCallback(() => d.current = !1, []);
      return q.useEffect(() => () => document.removeEventListener("pointerup", h), [h]), /* @__PURE__ */ K.jsx(zU, { asChild: !0, ...u, children: /* @__PURE__ */ K.jsx(
        Yt.button,
        {
          "aria-describedby": i.open ? i.contentId : void 0,
          "data-state": i.stateAttribute,
          ...n,
          ref: f,
          onPointerMove: $0(e.onPointerMove, (E) => {
            E.pointerType !== "touch" && !g.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), g.current = !0);
          }),
          onPointerLeave: $0(e.onPointerLeave, () => {
            i.onTriggerLeave(), g.current = !1;
          }),
          onPointerDown: $0(e.onPointerDown, () => {
            i.open && i.onClose(), d.current = !0, document.addEventListener("pointerup", h, { once: !0 });
          }),
          onFocus: $0(e.onFocus, () => {
            d.current || i.onOpen();
          }),
          onBlur: $0(e.onBlur, i.onClose),
          onClick: $0(e.onClick, i.onClose)
        }
      ) });
    }
  );
  qq.displayName = Tb;
  var GS = "TooltipPortal", [B72, Q72] = ph(GS, {
    forceMount: void 0
  }), Wq = (e) => {
    const { __scopeTooltip: t, forceMount: r, children: n, container: i } = e, o = aA(GS, t);
    return /* @__PURE__ */ K.jsx(B72, { scope: t, forceMount: r, children: /* @__PURE__ */ K.jsx($i, { present: r || o.open, children: /* @__PURE__ */ K.jsx(jS, { asChild: !0, container: i, children: n }) }) });
  };
  Wq.displayName = GS;
  var b9 = "TooltipContent", Yq = q.forwardRef(
    (e, t) => {
      const r = Q72(b9, e.__scopeTooltip), { forceMount: n = r.forceMount, side: i = "top", ...o } = e, u = aA(b9, e.__scopeTooltip);
      return /* @__PURE__ */ K.jsx($i, { present: n || u.open, children: u.disableHoverableContent ? /* @__PURE__ */ K.jsx($q, { side: i, ...o, ref: t }) : /* @__PURE__ */ K.jsx(x72, { side: i, ...o, ref: t }) });
    }
  ), x72 = q.forwardRef((e, t) => {
    const r = aA(b9, e.__scopeTooltip), n = $S(b9, e.__scopeTooltip), i = q.useRef(null), o = H5(t, i), [u, c] = q.useState(null), { trigger: f, onClose: d } = r, g = i.current, { onPointerInTransitChange: h } = n, E = q.useCallback(() => {
      c(null), h(!1);
    }, [h]), y = q.useCallback(
      (I, Q) => {
        const B = I.currentTarget, _ = { x: I.clientX, y: I.clientY }, M = _72(_, B.getBoundingClientRect()), S = O72(_, M), O = T72(Q.getBoundingClientRect()), w = L72([...S, ...O]);
        c(w), h(!0);
      },
      [h]
    );
    return q.useEffect(() => () => E(), [E]), q.useEffect(() => {
      if (f && g) {
        const I = (B) => y(B, g), Q = (B) => y(B, f);
        return f.addEventListener("pointerleave", I), g.addEventListener("pointerleave", Q), () => {
          f.removeEventListener("pointerleave", I), g.removeEventListener("pointerleave", Q);
        };
      }
    }, [f, g, y, E]), q.useEffect(() => {
      if (u) {
        const I = (Q) => {
          const B = Q.target, _ = { x: Q.clientX, y: Q.clientY }, M = (f == null ? void 0 : f.contains(B)) || (g == null ? void 0 : g.contains(B)), S = !D72(_, u);
          M ? E() : S && (E(), d());
        };
        return document.addEventListener("pointermove", I), () => document.removeEventListener("pointermove", I);
      }
    }, [f, g, u, d, E]), /* @__PURE__ */ K.jsx($q, { ...e, ref: o });
  }), [b72, w72] = ph(hc, { isInside: !1 }), S72 = /* @__PURE__ */ Cn2("TooltipContent"), $q = q.forwardRef(
    (e, t) => {
      const {
        __scopeTooltip: r,
        children: n,
        "aria-label": i,
        onEscapeKeyDown: o,
        onPointerDownOutside: u,
        ...c
      } = e, f = aA(b9, r), d = hh(r), { onClose: g } = f;
      return q.useEffect(() => (document.addEventListener(Ob, g), () => document.removeEventListener(Ob, g)), [g]), q.useEffect(() => {
        if (f.trigger) {
          const h = (E) => {
            const y = E.target;
            y != null && y.contains(f.trigger) && g();
          };
          return window.addEventListener("scroll", h, { capture: !0 }), () => window.removeEventListener("scroll", h, { capture: !0 });
        }
      }, [f.trigger, g]), /* @__PURE__ */ K.jsx(
        OS,
        {
          asChild: !0,
          disableOutsidePointerEvents: !1,
          onEscapeKeyDown: o,
          onPointerDownOutside: u,
          onFocusOutside: (h) => h.preventDefault(),
          onDismiss: g,
          children: /* @__PURE__ */ K.jsxs(
            UU,
            {
              "data-state": f.stateAttribute,
              ...d,
              ...c,
              ref: t,
              style: {
                ...c.style,
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
              },
              children: [
                /* @__PURE__ */ K.jsx(S72, { children: n }),
                /* @__PURE__ */ K.jsx(b72, { scope: r, isInside: !0, children: /* @__PURE__ */ K.jsx(E72, { id: f.contentId, role: "tooltip", children: i || n }) })
              ]
            }
          )
        }
      );
    }
  );
  Yq.displayName = b9;
  var Gq = "TooltipArrow", M72 = q.forwardRef(
    (e, t) => {
      const { __scopeTooltip: r, ...n } = e, i = hh(r);
      return w72(
        Gq,
        r
      ).isInside ? null : /* @__PURE__ */ K.jsx(qU, { ...i, ...n, ref: t });
    }
  );
  M72.displayName = Gq;
  function _72(e, t) {
    const r = Math.abs(t.top - e.y), n = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
    switch (Math.min(r, n, i, o)) {
      case o:
        return "left";
      case i:
        return "right";
      case r:
        return "top";
      case n:
        return "bottom";
      default:
        throw new Error("unreachable");
    }
  }
  function O72(e, t, r = 5) {
    const n = [];
    switch (t) {
      case "top":
        n.push(
          { x: e.x - r, y: e.y + r },
          { x: e.x + r, y: e.y + r }
        );
        break;
      case "bottom":
        n.push(
          { x: e.x - r, y: e.y - r },
          { x: e.x + r, y: e.y - r }
        );
        break;
      case "left":
        n.push(
          { x: e.x + r, y: e.y - r },
          { x: e.x + r, y: e.y + r }
        );
        break;
      case "right":
        n.push(
          { x: e.x - r, y: e.y - r },
          { x: e.x - r, y: e.y + r }
        );
        break;
    }
    return n;
  }
  function T72(e) {
    const { top: t, right: r, bottom: n, left: i } = e;
    return [
      { x: i, y: t },
      { x: r, y: t },
      { x: r, y: n },
      { x: i, y: n }
    ];
  }
  function D72(e, t) {
    const { x: r, y: n } = e;
    let i = !1;
    for (let o = 0, u = t.length - 1; o < t.length; u = o++) {
      const c = t[o], f = t[u], d = c.x, g = c.y, h = f.x, E = f.y;
      g > n != E > n && r < (h - d) * (n - g) / (E - g) + d && (i = !i);
    }
    return i;
  }
  function L72(e) {
    const t = e.slice();
    return t.sort((r, n) => r.x < n.x ? -1 : r.x > n.x ? 1 : r.y < n.y ? -1 : r.y > n.y ? 1 : 0), k72(t);
  }
  function k72(e) {
    if (e.length <= 1) return e.slice();
    const t = [];
    for (let n = 0; n < e.length; n++) {
      const i = e[n];
      for (; t.length >= 2; ) {
        const o = t[t.length - 1], u = t[t.length - 2];
        if ((o.x - u.x) * (i.y - u.y) >= (o.y - u.y) * (i.x - u.x)) t.pop();
        else break;
      }
      t.push(i);
    }
    t.pop();
    const r = [];
    for (let n = e.length - 1; n >= 0; n--) {
      const i = e[n];
      for (; r.length >= 2; ) {
        const o = r[r.length - 1], u = r[r.length - 2];
        if ((o.x - u.x) * (i.y - u.y) >= (o.y - u.y) * (i.x - u.x)) r.pop();
        else break;
      }
      r.push(i);
    }
    return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
  }
  var R72 = zq, P72 = Uq, F72 = qq, N72 = Wq, H72 = Yq;
  function j72({ delayDuration: e = 0, ...t }) {
    return /* @__PURE__ */ K.jsx(R72, { "data-slot": "tooltip-provider", delayDuration: e, ...t });
  }
  function V72({ ...e }) {
    return /* @__PURE__ */ K.jsx(j72, { children: /* @__PURE__ */ K.jsx(P72, { "data-slot": "tooltip", ...e }) });
  }
  function Z72({ ...e }) {
    return /* @__PURE__ */ K.jsx(F72, { "data-slot": "tooltip-trigger", ...e });
  }
  function z72({
    className: e,
    container: t,
    sideOffset: r = 0,
    children: n,
    ...i
  }) {
    return /* @__PURE__ */ K.jsx(N72, { container: t, children: /* @__PURE__ */ K.jsx(
      H72,
      {
        "data-slot": "tooltip-content",
        sideOffset: r,
        className: T1(
          "bg-primary text-primary-foreground animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-fit origin-(--radix-tooltip-content-transform-origin) rounded-md px-3 py-1.5 text-xs text-balance",
          e
        ),
        ...i,
        children: n
      }
    ) });
  }
  const U72 = ({ trigger: e, content: t }) => {
    const { containerRef: r, portalContainer: n } = jq();
    return /* @__PURE__ */ K.jsx("div", { ref: r, className: "contents", children: /* @__PURE__ */ K.jsxs(V72, { children: [
      /* @__PURE__ */ K.jsx(Z72, { children: e }),
      /* @__PURE__ */ K.jsx(
        z72,
        {
          container: n,
          sideOffset: 8,
          collisionPadding: 8,
          className: "max-w-80 rounded-[4px] bg-neutral-700 text-sm text-neutral-50 px-3 py-1 text-pretty",
          children: t
        }
      )
    ] }) });
  };
  function q72({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx(
      "div",
      {
        "data-slot": "card",
        className: T1("bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm", e),
        ...t
      }
    );
  }
  function W72({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx(
      "div",
      {
        "data-slot": "card-header",
        className: T1(
          "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
          e
        ),
        ...t
      }
    );
  }
  function Y72({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx("div", { "data-slot": "card-title", className: T1("leading-none font-semibold", e), ...t });
  }
  function $72({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx("div", { "data-slot": "card-description", className: T1("text-muted-foreground text-sm", e), ...t });
  }
  function G72({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx("div", { "data-slot": "card-content", className: T1("px-6", e), ...t });
  }
  const KS = ({ title: e, description: t, children: r }) => /* @__PURE__ */ K.jsxs(q72, { className: "rounded-2xl border-neutral-300 p-6 gap-6 shadow-none", children: [
    /* @__PURE__ */ K.jsxs(W72, { className: "px-0 gap-1", children: [
      /* @__PURE__ */ K.jsx(Y72, { className: "text-2xl font-normal text-neutral-900", "data-testid": "visits-card-title", children: e }),
      /* @__PURE__ */ K.jsx($72, { className: "text-base text-neutral-700", "data-testid": "visits-card-description", children: t })
    ] }),
    /* @__PURE__ */ K.jsx(G72, { className: "px-0 flex flex-1 flex-column items-end", children: r })
  ] });
  var qy, Rk;
  function Ir() {
    if (Rk) return qy;
    Rk = 1;
    var e = Array.isArray;
    return qy = e, qy;
  }
  var Wy, Pk;
  function Kq() {
    if (Pk) return Wy;
    Pk = 1;
    var e = typeof wi == "object" && wi && wi.Object === Object && wi;
    return Wy = e, Wy;
  }
  var Yy, Fk;
  function h3() {
    if (Fk) return Yy;
    Fk = 1;
    var e = Kq(), t = typeof self == "object" && self && self.Object === Object && self, r = e || t || Function("return this")();
    return Yy = r, Yy;
  }
  var $y, Nk;
  function oA() {
    if (Nk) return $y;
    Nk = 1;
    var e = h3(), t = e.Symbol;
    return $y = t, $y;
  }
  var Gy, Hk;
  function K72() {
    if (Hk) return Gy;
    Hk = 1;
    var e = oA(), t = Object.prototype, r = t.hasOwnProperty, n = t.toString, i = e ? e.toStringTag : void 0;
    function o(u) {
      var c = r.call(u, i), f = u[i];
      try {
        u[i] = void 0;
        var d = !0;
      } catch {
      }
      var g = n.call(u);
      return d && (c ? u[i] = f : delete u[i]), g;
    }
    return Gy = o, Gy;
  }
  var Ky, jk;
  function X72() {
    if (jk) return Ky;
    jk = 1;
    var e = Object.prototype, t = e.toString;
    function r(n) {
      return t.call(n);
    }
    return Ky = r, Ky;
  }
  var Xy, Vk;
  function M8() {
    if (Vk) return Xy;
    Vk = 1;
    var e = oA(), t = K72(), r = X72(), n = "[object Null]", i = "[object Undefined]", o = e ? e.toStringTag : void 0;
    function u(c) {
      return c == null ? c === void 0 ? i : n : o && o in Object(c) ? t(c) : r(c);
    }
    return Xy = u, Xy;
  }
  var Jy, Zk;
  function _8() {
    if (Zk) return Jy;
    Zk = 1;
    function e(t) {
      return t != null && typeof t == "object";
    }
    return Jy = e, Jy;
  }
  var eI, zk;
  function us() {
    if (zk) return eI;
    zk = 1;
    var e = M8(), t = _8(), r = "[object Symbol]";
    function n(i) {
      return typeof i == "symbol" || t(i) && e(i) == r;
    }
    return eI = n, eI;
  }
  var tI, Uk;
  function XS() {
    if (Uk) return tI;
    Uk = 1;
    var e = Ir(), t = us(), r = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, n = /^\w*$/;
    function i(o, u) {
      if (e(o))
        return !1;
      var c = typeof o;
      return c == "number" || c == "symbol" || c == "boolean" || o == null || t(o) ? !0 : n.test(o) || !r.test(o) || u != null && o in Object(u);
    }
    return tI = i, tI;
  }
  var rI, qk;
  function K6() {
    if (qk) return rI;
    qk = 1;
    function e(t) {
      var r = typeof t;
      return t != null && (r == "object" || r == "function");
    }
    return rI = e, rI;
  }
  var nI, Wk;
  function JS() {
    if (Wk) return nI;
    Wk = 1;
    var e = M8(), t = K6(), r = "[object AsyncFunction]", n = "[object Function]", i = "[object GeneratorFunction]", o = "[object Proxy]";
    function u(c) {
      if (!t(c))
        return !1;
      var f = e(c);
      return f == n || f == i || f == r || f == o;
    }
    return nI = u, nI;
  }
  var iI, Yk;
  function J72() {
    if (Yk) return iI;
    Yk = 1;
    var e = h3(), t = e["__core-js_shared__"];
    return iI = t, iI;
  }
  var aI, $k;
  function ei2() {
    if ($k) return aI;
    $k = 1;
    var e = J72(), t = function() {
      var n = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
      return n ? "Symbol(src)_1." + n : "";
    }();
    function r(n) {
      return !!t && t in n;
    }
    return aI = r, aI;
  }
  var oI, Gk;
  function Xq() {
    if (Gk) return oI;
    Gk = 1;
    var e = Function.prototype, t = e.toString;
    function r(n) {
      if (n != null) {
        try {
          return t.call(n);
        } catch {
        }
        try {
          return n + "";
        } catch {
        }
      }
      return "";
    }
    return oI = r, oI;
  }
  var sI, Kk;
  function ti2() {
    if (Kk) return sI;
    Kk = 1;
    var e = JS(), t = ei2(), r = K6(), n = Xq(), i = /[\\^$.*+?()[\]{}|]/g, o = /^\[object .+?Constructor\]$/, u = Function.prototype, c = Object.prototype, f = u.toString, d = c.hasOwnProperty, g = RegExp(
      "^" + f.call(d).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function h(E) {
      if (!r(E) || t(E))
        return !1;
      var y = e(E) ? g : o;
      return y.test(n(E));
    }
    return sI = h, sI;
  }
  var uI, Xk;
  function ri2() {
    if (Xk) return uI;
    Xk = 1;
    function e(t, r) {
      return t == null ? void 0 : t[r];
    }
    return uI = e, uI;
  }
  var lI, Jk;
  function Xi() {
    if (Jk) return lI;
    Jk = 1;
    var e = ti2(), t = ri2();
    function r(n, i) {
      var o = t(n, i);
      return e(o) ? o : void 0;
    }
    return lI = r, lI;
  }
  var cI, eR;
  function vh() {
    if (eR) return cI;
    eR = 1;
    var e = Xi(), t = e(Object, "create");
    return cI = t, cI;
  }
  var AI, tR;
  function ni2() {
    if (tR) return AI;
    tR = 1;
    var e = vh();
    function t() {
      this.__data__ = e ? e(null) : {}, this.size = 0;
    }
    return AI = t, AI;
  }
  var fI, rR;
  function ii2() {
    if (rR) return fI;
    rR = 1;
    function e(t) {
      var r = this.has(t) && delete this.__data__[t];
      return this.size -= r ? 1 : 0, r;
    }
    return fI = e, fI;
  }
  var CI, nR;
  function ai2() {
    if (nR) return CI;
    nR = 1;
    var e = vh(), t = "__lodash_hash_undefined__", r = Object.prototype, n = r.hasOwnProperty;
    function i(o) {
      var u = this.__data__;
      if (e) {
        var c = u[o];
        return c === t ? void 0 : c;
      }
      return n.call(u, o) ? u[o] : void 0;
    }
    return CI = i, CI;
  }
  var dI, iR;
  function oi2() {
    if (iR) return dI;
    iR = 1;
    var e = vh(), t = Object.prototype, r = t.hasOwnProperty;
    function n(i) {
      var o = this.__data__;
      return e ? o[i] !== void 0 : r.call(o, i);
    }
    return dI = n, dI;
  }
  var gI, aR;
  function si2() {
    if (aR) return gI;
    aR = 1;
    var e = vh(), t = "__lodash_hash_undefined__";
    function r(n, i) {
      var o = this.__data__;
      return this.size += this.has(n) ? 0 : 1, o[n] = e && i === void 0 ? t : i, this;
    }
    return gI = r, gI;
  }
  var pI, oR;
  function ui2() {
    if (oR) return pI;
    oR = 1;
    var e = ni2(), t = ii2(), r = ai2(), n = oi2(), i = si2();
    function o(u) {
      var c = -1, f = u == null ? 0 : u.length;
      for (this.clear(); ++c < f; ) {
        var d = u[c];
        this.set(d[0], d[1]);
      }
    }
    return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, pI = o, pI;
  }
  var hI, sR;
  function li2() {
    if (sR) return hI;
    sR = 1;
    function e() {
      this.__data__ = [], this.size = 0;
    }
    return hI = e, hI;
  }
  var vI, uR;
  function eM() {
    if (uR) return vI;
    uR = 1;
    function e(t, r) {
      return t === r || t !== t && r !== r;
    }
    return vI = e, vI;
  }
  var EI, lR;
  function Eh() {
    if (lR) return EI;
    lR = 1;
    var e = eM();
    function t(r, n) {
      for (var i = r.length; i--; )
        if (e(r[i][0], n))
          return i;
      return -1;
    }
    return EI = t, EI;
  }
  var mI, cR;
  function ci2() {
    if (cR) return mI;
    cR = 1;
    var e = Eh(), t = Array.prototype, r = t.splice;
    function n(i) {
      var o = this.__data__, u = e(o, i);
      if (u < 0)
        return !1;
      var c = o.length - 1;
      return u == c ? o.pop() : r.call(o, u, 1), --this.size, !0;
    }
    return mI = n, mI;
  }
  var yI, AR;
  function Ai2() {
    if (AR) return yI;
    AR = 1;
    var e = Eh();
    function t(r) {
      var n = this.__data__, i = e(n, r);
      return i < 0 ? void 0 : n[i][1];
    }
    return yI = t, yI;
  }
  var II, fR;
  function fi2() {
    if (fR) return II;
    fR = 1;
    var e = Eh();
    function t(r) {
      return e(this.__data__, r) > -1;
    }
    return II = t, II;
  }
  var BI, CR;
  function Ci2() {
    if (CR) return BI;
    CR = 1;
    var e = Eh();
    function t(r, n) {
      var i = this.__data__, o = e(i, r);
      return o < 0 ? (++this.size, i.push([r, n])) : i[o][1] = n, this;
    }
    return BI = t, BI;
  }
  var QI, dR;
  function mh() {
    if (dR) return QI;
    dR = 1;
    var e = li2(), t = ci2(), r = Ai2(), n = fi2(), i = Ci2();
    function o(u) {
      var c = -1, f = u == null ? 0 : u.length;
      for (this.clear(); ++c < f; ) {
        var d = u[c];
        this.set(d[0], d[1]);
      }
    }
    return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, QI = o, QI;
  }
  var xI, gR;
  function tM() {
    if (gR) return xI;
    gR = 1;
    var e = Xi(), t = h3(), r = e(t, "Map");
    return xI = r, xI;
  }
  var bI, pR;
  function di2() {
    if (pR) return bI;
    pR = 1;
    var e = ui2(), t = mh(), r = tM();
    function n() {
      this.size = 0, this.__data__ = {
        hash: new e(),
        map: new (r || t)(),
        string: new e()
      };
    }
    return bI = n, bI;
  }
  var wI, hR;
  function gi2() {
    if (hR) return wI;
    hR = 1;
    function e(t) {
      var r = typeof t;
      return r == "string" || r == "number" || r == "symbol" || r == "boolean" ? t !== "__proto__" : t === null;
    }
    return wI = e, wI;
  }
  var SI, vR;
  function yh() {
    if (vR) return SI;
    vR = 1;
    var e = gi2();
    function t(r, n) {
      var i = r.__data__;
      return e(n) ? i[typeof n == "string" ? "string" : "hash"] : i.map;
    }
    return SI = t, SI;
  }
  var MI, ER;
  function pi2() {
    if (ER) return MI;
    ER = 1;
    var e = yh();
    function t(r) {
      var n = e(this, r).delete(r);
      return this.size -= n ? 1 : 0, n;
    }
    return MI = t, MI;
  }
  var _I, mR;
  function hi2() {
    if (mR) return _I;
    mR = 1;
    var e = yh();
    function t(r) {
      return e(this, r).get(r);
    }
    return _I = t, _I;
  }
  var OI, yR;
  function vi2() {
    if (yR) return OI;
    yR = 1;
    var e = yh();
    function t(r) {
      return e(this, r).has(r);
    }
    return OI = t, OI;
  }
  var TI, IR;
  function Ei2() {
    if (IR) return TI;
    IR = 1;
    var e = yh();
    function t(r, n) {
      var i = e(this, r), o = i.size;
      return i.set(r, n), this.size += i.size == o ? 0 : 1, this;
    }
    return TI = t, TI;
  }
  var DI, BR;
  function rM() {
    if (BR) return DI;
    BR = 1;
    var e = di2(), t = pi2(), r = hi2(), n = vi2(), i = Ei2();
    function o(u) {
      var c = -1, f = u == null ? 0 : u.length;
      for (this.clear(); ++c < f; ) {
        var d = u[c];
        this.set(d[0], d[1]);
      }
    }
    return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = n, o.prototype.set = i, DI = o, DI;
  }
  var LI, QR;
  function Jq() {
    if (QR) return LI;
    QR = 1;
    var e = rM(), t = "Expected a function";
    function r(n, i) {
      if (typeof n != "function" || i != null && typeof i != "function")
        throw new TypeError(t);
      var o = function() {
        var u = arguments, c = i ? i.apply(this, u) : u[0], f = o.cache;
        if (f.has(c))
          return f.get(c);
        var d = n.apply(this, u);
        return o.cache = f.set(c, d) || f, d;
      };
      return o.cache = new (r.Cache || e)(), o;
    }
    return r.Cache = e, LI = r, LI;
  }
  var kI, xR;
  function mi2() {
    if (xR) return kI;
    xR = 1;
    var e = Jq(), t = 500;
    function r(n) {
      var i = e(n, function(u) {
        return o.size === t && o.clear(), u;
      }), o = i.cache;
      return i;
    }
    return kI = r, kI;
  }
  var RI, bR;
  function yi2() {
    if (bR) return RI;
    bR = 1;
    var e = mi2(), t = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, r = /\\(\\)?/g, n = e(function(i) {
      var o = [];
      return i.charCodeAt(0) === 46 && o.push(""), i.replace(t, function(u, c, f, d) {
        o.push(f ? d.replace(r, "$1") : c || u);
      }), o;
    });
    return RI = n, RI;
  }
  var PI, wR;
  function nM() {
    if (wR) return PI;
    wR = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length, o = Array(i); ++n < i; )
        o[n] = r(t[n], n, t);
      return o;
    }
    return PI = e, PI;
  }
  var FI, SR;
  function Ii2() {
    if (SR) return FI;
    SR = 1;
    var e = oA(), t = nM(), r = Ir(), n = us(), i = e ? e.prototype : void 0, o = i ? i.toString : void 0;
    function u(c) {
      if (typeof c == "string")
        return c;
      if (r(c))
        return t(c, u) + "";
      if (n(c))
        return o ? o.call(c) : "";
      var f = c + "";
      return f == "0" && 1 / c == -1 / 0 ? "-0" : f;
    }
    return FI = u, FI;
  }
  var NI, MR;
  function eW() {
    if (MR) return NI;
    MR = 1;
    var e = Ii2();
    function t(r) {
      return r == null ? "" : e(r);
    }
    return NI = t, NI;
  }
  var HI, _R;
  function tW() {
    if (_R) return HI;
    _R = 1;
    var e = Ir(), t = XS(), r = yi2(), n = eW();
    function i(o, u) {
      return e(o) ? o : t(o, u) ? [o] : r(n(o));
    }
    return HI = i, HI;
  }
  var jI, OR;
  function Ih() {
    if (OR) return jI;
    OR = 1;
    var e = us();
    function t(r) {
      if (typeof r == "string" || e(r))
        return r;
      var n = r + "";
      return n == "0" && 1 / r == -1 / 0 ? "-0" : n;
    }
    return jI = t, jI;
  }
  var VI, TR;
  function iM() {
    if (TR) return VI;
    TR = 1;
    var e = tW(), t = Ih();
    function r(n, i) {
      i = e(i, n);
      for (var o = 0, u = i.length; n != null && o < u; )
        n = n[t(i[o++])];
      return o && o == u ? n : void 0;
    }
    return VI = r, VI;
  }
  var ZI, DR;
  function rW() {
    if (DR) return ZI;
    DR = 1;
    var e = iM();
    function t(r, n, i) {
      var o = r == null ? void 0 : e(r, n);
      return o === void 0 ? i : o;
    }
    return ZI = t, ZI;
  }
  var Bi2 = rW();
  const w4 = /* @__PURE__ */ tt(Bi2);
  var zI, LR;
  function Qi2() {
    if (LR) return zI;
    LR = 1;
    function e(t) {
      return t == null;
    }
    return zI = e, zI;
  }
  var xi2 = Qi2();
  const Ae = /* @__PURE__ */ tt(xi2);
  var UI, kR;
  function bi2() {
    if (kR) return UI;
    kR = 1;
    var e = M8(), t = Ir(), r = _8(), n = "[object String]";
    function i(o) {
      return typeof o == "string" || !t(o) && r(o) && e(o) == n;
    }
    return UI = i, UI;
  }
  var wi2 = bi2();
  const Vi = /* @__PURE__ */ tt(wi2);
  var Si2 = JS();
  const te = /* @__PURE__ */ tt(Si2);
  var Mi2 = K6();
  const ls = /* @__PURE__ */ tt(Mi2);
  var wd = { exports: {} }, Ze = {};
  /**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var RR;
  function _i2() {
    if (RR) return Ze;
    RR = 1;
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), I;
    I = Symbol.for("react.module.reference");
    function Q(B) {
      if (typeof B == "object" && B !== null) {
        var _ = B.$$typeof;
        switch (_) {
          case e:
            switch (B = B.type, B) {
              case r:
              case i:
              case n:
              case d:
              case g:
                return B;
              default:
                switch (B = B && B.$$typeof, B) {
                  case c:
                  case u:
                  case f:
                  case E:
                  case h:
                  case o:
                    return B;
                  default:
                    return _;
                }
            }
          case t:
            return _;
        }
      }
    }
    return Ze.ContextConsumer = u, Ze.ContextProvider = o, Ze.Element = e, Ze.ForwardRef = f, Ze.Fragment = r, Ze.Lazy = E, Ze.Memo = h, Ze.Portal = t, Ze.Profiler = i, Ze.StrictMode = n, Ze.Suspense = d, Ze.SuspenseList = g, Ze.isAsyncMode = function() {
      return !1;
    }, Ze.isConcurrentMode = function() {
      return !1;
    }, Ze.isContextConsumer = function(B) {
      return Q(B) === u;
    }, Ze.isContextProvider = function(B) {
      return Q(B) === o;
    }, Ze.isElement = function(B) {
      return typeof B == "object" && B !== null && B.$$typeof === e;
    }, Ze.isForwardRef = function(B) {
      return Q(B) === f;
    }, Ze.isFragment = function(B) {
      return Q(B) === r;
    }, Ze.isLazy = function(B) {
      return Q(B) === E;
    }, Ze.isMemo = function(B) {
      return Q(B) === h;
    }, Ze.isPortal = function(B) {
      return Q(B) === t;
    }, Ze.isProfiler = function(B) {
      return Q(B) === i;
    }, Ze.isStrictMode = function(B) {
      return Q(B) === n;
    }, Ze.isSuspense = function(B) {
      return Q(B) === d;
    }, Ze.isSuspenseList = function(B) {
      return Q(B) === g;
    }, Ze.isValidElementType = function(B) {
      return typeof B == "string" || typeof B == "function" || B === r || B === i || B === n || B === d || B === g || B === y || typeof B == "object" && B !== null && (B.$$typeof === E || B.$$typeof === h || B.$$typeof === o || B.$$typeof === u || B.$$typeof === f || B.$$typeof === I || B.getModuleId !== void 0);
    }, Ze.typeOf = Q, Ze;
  }
  var ze = {};
  /**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var PR;
  function Oi2() {
    return PR || (PR = 1, process.env.NODE_ENV !== "production" && function() {
      var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.server_context"), f = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), g = Symbol.for("react.suspense_list"), h = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), y = Symbol.for("react.offscreen"), I = !1, Q = !1, B = !1, _ = !1, M = !1, S;
      S = Symbol.for("react.module.reference");
      function O(k2) {
        return !!(typeof k2 == "string" || typeof k2 == "function" || k2 === r || k2 === i || M || k2 === n || k2 === d || k2 === g || _ || k2 === y || I || Q || B || typeof k2 == "object" && k2 !== null && (k2.$$typeof === E || k2.$$typeof === h || k2.$$typeof === o || k2.$$typeof === u || k2.$$typeof === f || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        k2.$$typeof === S || k2.getModuleId !== void 0));
      }
      function w(k2) {
        if (typeof k2 == "object" && k2 !== null) {
          var b0 = k2.$$typeof;
          switch (b0) {
            case e:
              var S0 = k2.type;
              switch (S0) {
                case r:
                case i:
                case n:
                case d:
                case g:
                  return S0;
                default:
                  var G0 = S0 && S0.$$typeof;
                  switch (G0) {
                    case c:
                    case u:
                    case f:
                    case E:
                    case h:
                    case o:
                      return G0;
                    default:
                      return b0;
                  }
              }
            case t:
              return b0;
          }
        }
      }
      var D = u, k = o, F = e, z = f, Z = r, V = E, $ = h, W = t, t2 = i, n2 = n, s2 = d, l2 = g, X = !1, a2 = !1;
      function e2(k2) {
        return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
      }
      function H(k2) {
        return a2 || (a2 = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
      }
      function Y(k2) {
        return w(k2) === u;
      }
      function r2(k2) {
        return w(k2) === o;
      }
      function o2(k2) {
        return typeof k2 == "object" && k2 !== null && k2.$$typeof === e;
      }
      function O2(k2) {
        return w(k2) === f;
      }
      function S2(k2) {
        return w(k2) === r;
      }
      function M2(k2) {
        return w(k2) === E;
      }
      function w2(k2) {
        return w(k2) === h;
      }
      function v2(k2) {
        return w(k2) === t;
      }
      function L2(k2) {
        return w(k2) === i;
      }
      function W2(k2) {
        return w(k2) === n;
      }
      function d2(k2) {
        return w(k2) === d;
      }
      function X2(k2) {
        return w(k2) === g;
      }
      ze.ContextConsumer = D, ze.ContextProvider = k, ze.Element = F, ze.ForwardRef = z, ze.Fragment = Z, ze.Lazy = V, ze.Memo = $, ze.Portal = W, ze.Profiler = t2, ze.StrictMode = n2, ze.Suspense = s2, ze.SuspenseList = l2, ze.isAsyncMode = e2, ze.isConcurrentMode = H, ze.isContextConsumer = Y, ze.isContextProvider = r2, ze.isElement = o2, ze.isForwardRef = O2, ze.isFragment = S2, ze.isLazy = M2, ze.isMemo = w2, ze.isPortal = v2, ze.isProfiler = L2, ze.isStrictMode = W2, ze.isSuspense = d2, ze.isSuspenseList = X2, ze.isValidElementType = O, ze.typeOf = w;
    }()), ze;
  }
  var FR;
  function Ti2() {
    return FR || (FR = 1, process.env.NODE_ENV === "production" ? wd.exports = _i2() : wd.exports = Oi2()), wd.exports;
  }
  var Di2 = Ti2(), qI, NR;
  function nW() {
    if (NR) return qI;
    NR = 1;
    var e = M8(), t = _8(), r = "[object Number]";
    function n(i) {
      return typeof i == "number" || t(i) && e(i) == r;
    }
    return qI = n, qI;
  }
  var WI, HR;
  function Li2() {
    if (HR) return WI;
    HR = 1;
    var e = nW();
    function t(r) {
      return e(r) && r != +r;
    }
    return WI = t, WI;
  }
  var ki2 = Li2();
  const sA = /* @__PURE__ */ tt(ki2);
  var Ri2 = nW();
  const Pi2 = /* @__PURE__ */ tt(Ri2);
  var pn = function(t) {
    return t === 0 ? 0 : t > 0 ? 1 : -1;
  }, _i = function(t) {
    return Vi(t) && t.indexOf("%") === t.length - 1;
  }, G2 = function(t) {
    return Pi2(t) && !sA(t);
  }, T5 = function(t) {
    return G2(t) || Vi(t);
  }, Fi2 = 0, uA = function(t) {
    var r = ++Fi2;
    return "".concat(t || "").concat(r);
  }, Zi = function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
    if (!G2(t) && !Vi(t))
      return n;
    var o;
    if (_i(t)) {
      var u = t.indexOf("%");
      o = r * parseFloat(t.slice(0, u)) / 100;
    } else
      o = +t;
    return sA(o) && (o = n), i && o > r && (o = r), o;
  }, P6 = function(t) {
    if (!t)
      return null;
    var r = Object.keys(t);
    return r && r.length ? t[r[0]] : null;
  }, Ni2 = function(t) {
    if (!Array.isArray(t))
      return !1;
    for (var r = t.length, n = {}, i = 0; i < r; i++)
      if (!n[t[i]])
        n[t[i]] = !0;
      else
        return !0;
    return !1;
  }, dn = function(t, r) {
    return G2(t) && G2(r) ? function(n) {
      return t + n * (r - t);
    } : function() {
      return r;
    };
  };
  function Gg(e, t, r) {
    return !e || !e.length ? null : e.find(function(n) {
      return n && (typeof t == "function" ? t(n) : w4(n, t)) === r;
    });
  }
  var Hi2 = function(t, r) {
    return G2(t) && G2(r) ? t - r : Vi(t) && Vi(r) ? t.localeCompare(r) : t instanceof Date && r instanceof Date ? t.getTime() - r.getTime() : String(t).localeCompare(String(r));
  };
  function h9(e, t) {
    for (var r in e)
      if ({}.hasOwnProperty.call(e, r) && (!{}.hasOwnProperty.call(t, r) || e[r] !== t[r]))
        return !1;
    for (var n in t)
      if ({}.hasOwnProperty.call(t, n) && !{}.hasOwnProperty.call(e, n))
        return !1;
    return !0;
  }
  function Db(e) {
    "@babel/helpers - typeof";
    return Db = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Db(e);
  }
  var ji2 = ["viewBox", "children"], Vi2 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
     * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
     * that can use it and it conflicts with the recharts prop 'type'
     * https://github.com/recharts/recharts/pull/3327
     * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
     */
    // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
  ], jR = ["points", "pathLength"], YI = {
    svg: ji2,
    polygon: jR,
    polyline: jR
  }, aM = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], Kg = function(t, r) {
    if (!t || typeof t == "function" || typeof t == "boolean")
      return null;
    var n = t;
    if (/* @__PURE__ */ q.isValidElement(t) && (n = t.props), !ls(n))
      return null;
    var i = {};
    return Object.keys(n).forEach(function(o) {
      aM.includes(o) && (i[o] = r || function(u) {
        return n[o](n, u);
      });
    }), i;
  }, Zi2 = function(t, r, n) {
    return function(i) {
      return t(r, n, i), null;
    };
  }, Xg = function(t, r, n) {
    if (!ls(t) || Db(t) !== "object")
      return null;
    var i = null;
    return Object.keys(t).forEach(function(o) {
      var u = t[o];
      aM.includes(o) && typeof u == "function" && (i || (i = {}), i[o] = Zi2(u, r, n));
    }), i;
  }, zi2 = ["children"], Ui2 = ["children"];
  function VR(e, t) {
    if (e == null) return {};
    var r = qi2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function qi2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Lb(e) {
    "@babel/helpers - typeof";
    return Lb = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Lb(e);
  }
  var ZR = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart",
    contextmenu: "onContextMenu",
    dblclick: "onDoubleClick"
  }, h8 = function(t) {
    return typeof t == "string" ? t : t ? t.displayName || t.name || "Component" : "";
  }, zR = null, $I = null, oM = function e(t) {
    if (t === zR && Array.isArray($I))
      return $I;
    var r = [];
    return q.Children.forEach(t, function(n) {
      Ae(n) || (Di2.isFragment(n) ? r = r.concat(e(n.props.children)) : r.push(n));
    }), $I = r, zR = t, r;
  };
  function S4(e, t) {
    var r = [], n = [];
    return Array.isArray(t) ? n = t.map(function(i) {
      return h8(i);
    }) : n = [h8(t)], oM(e).forEach(function(i) {
      var o = w4(i, "type.displayName") || w4(i, "type.name");
      n.indexOf(o) !== -1 && r.push(i);
    }), r;
  }
  function Zr(e, t) {
    var r = S4(e, t);
    return r && r[0];
  }
  var UR = function(t) {
    if (!t || !t.props)
      return !1;
    var r = t.props, n = r.width, i = r.height;
    return !(!G2(n) || n <= 0 || !G2(i) || i <= 0);
  }, Wi2 = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], Yi2 = function(t) {
    return t && t.type && Vi(t.type) && Wi2.indexOf(t.type) >= 0;
  }, $i2 = function(t) {
    return t && Lb(t) === "object" && "clipDot" in t;
  }, Gi2 = function(t, r, n, i) {
    var o, u = (o = YI == null ? void 0 : YI[i]) !== null && o !== void 0 ? o : [];
    return r.startsWith("data-") || !te(t) && (i && u.includes(r) || Vi2.includes(r)) || n && aM.includes(r);
  }, ge = function(t, r, n) {
    if (!t || typeof t == "function" || typeof t == "boolean")
      return null;
    var i = t;
    if (/* @__PURE__ */ q.isValidElement(t) && (i = t.props), !ls(i))
      return null;
    var o = {};
    return Object.keys(i).forEach(function(u) {
      var c;
      Gi2((c = i) === null || c === void 0 ? void 0 : c[u], u, r, n) && (o[u] = i[u]);
    }), o;
  }, kb = function e(t, r) {
    if (t === r)
      return !0;
    var n = q.Children.count(t);
    if (n !== q.Children.count(r))
      return !1;
    if (n === 0)
      return !0;
    if (n === 1)
      return qR(Array.isArray(t) ? t[0] : t, Array.isArray(r) ? r[0] : r);
    for (var i = 0; i < n; i++) {
      var o = t[i], u = r[i];
      if (Array.isArray(o) || Array.isArray(u)) {
        if (!e(o, u))
          return !1;
      } else if (!qR(o, u))
        return !1;
    }
    return !0;
  }, qR = function(t, r) {
    if (Ae(t) && Ae(r))
      return !0;
    if (!Ae(t) && !Ae(r)) {
      var n = t.props || {}, i = n.children, o = VR(n, zi2), u = r.props || {}, c = u.children, f = VR(u, Ui2);
      return i && c ? h9(o, f) && kb(i, c) : !i && !c ? h9(o, f) : !1;
    }
    return !1;
  }, WR = function(t, r) {
    var n = [], i = {};
    return oM(t).forEach(function(o, u) {
      if (Yi2(o))
        n.push(o);
      else if (o) {
        var c = h8(o.type), f = r[c] || {}, d = f.handler, g = f.once;
        if (d && (!g || !i[c])) {
          var h = d(o, c, u);
          n.push(h), i[c] = !0;
        }
      }
    }), n;
  }, Ki2 = function(t) {
    var r = t && t.type;
    return r && ZR[r] ? ZR[r] : null;
  }, Xi2 = function(t, r) {
    return oM(r).indexOf(t);
  }, Ji2 = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
  function Rb() {
    return Rb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Rb.apply(this, arguments);
  }
  function ea2(e, t) {
    if (e == null) return {};
    var r = ta2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function ta2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Pb(e) {
    var t = e.children, r = e.width, n = e.height, i = e.viewBox, o = e.className, u = e.style, c = e.title, f = e.desc, d = ea2(e, Ji2), g = i || {
      width: r,
      height: n,
      x: 0,
      y: 0
    }, h = pe("recharts-surface", o);
    return /* @__PURE__ */ f2.createElement("svg", Rb({}, ge(d, !0, "svg"), {
      className: h,
      width: r,
      height: n,
      style: u,
      viewBox: "".concat(g.x, " ").concat(g.y, " ").concat(g.width, " ").concat(g.height)
    }), /* @__PURE__ */ f2.createElement("title", null, c), /* @__PURE__ */ f2.createElement("desc", null, f), t);
  }
  var ra2 = ["children", "className"];
  function Fb() {
    return Fb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Fb.apply(this, arguments);
  }
  function na2(e, t) {
    if (e == null) return {};
    var r = ia2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function ia2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var n5 = /* @__PURE__ */ f2.forwardRef(function(e, t) {
    var r = e.children, n = e.className, i = na2(e, ra2), o = pe("recharts-layer", n);
    return /* @__PURE__ */ f2.createElement("g", Fb({
      className: o
    }, ge(i, !0), {
      ref: t
    }), r);
  }), aa2 = process.env.NODE_ENV !== "production", v8 = function(t, r) {
    for (var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), o = 2; o < n; o++)
      i[o - 2] = arguments[o];
    if (aa2 && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
      if (r === void 0)
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var u = 0;
        console.warn(r.replace(/%s/g, function() {
          return i[u++];
        }));
      }
  }, GI, YR;
  function oa2() {
    if (YR) return GI;
    YR = 1;
    function e(t, r, n) {
      var i = -1, o = t.length;
      r < 0 && (r = -r > o ? 0 : o + r), n = n > o ? o : n, n < 0 && (n += o), o = r > n ? 0 : n - r >>> 0, r >>>= 0;
      for (var u = Array(o); ++i < o; )
        u[i] = t[i + r];
      return u;
    }
    return GI = e, GI;
  }
  var KI, $R;
  function sa2() {
    if ($R) return KI;
    $R = 1;
    var e = oa2();
    function t(r, n, i) {
      var o = r.length;
      return i = i === void 0 ? o : i, !n && i >= o ? r : e(r, n, i);
    }
    return KI = t, KI;
  }
  var XI, GR;
  function iW() {
    if (GR) return XI;
    GR = 1;
    var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, o = "\\ufe0e\\ufe0f", u = "\\u200d", c = RegExp("[" + u + e + i + o + "]");
    function f(d) {
      return c.test(d);
    }
    return XI = f, XI;
  }
  var JI, KR;
  function ua2() {
    if (KR) return JI;
    KR = 1;
    function e(t) {
      return t.split("");
    }
    return JI = e, JI;
  }
  var eB, XR;
  function la2() {
    if (XR) return eB;
    XR = 1;
    var e = "\\ud800-\\udfff", t = "\\u0300-\\u036f", r = "\\ufe20-\\ufe2f", n = "\\u20d0-\\u20ff", i = t + r + n, o = "\\ufe0e\\ufe0f", u = "[" + e + "]", c = "[" + i + "]", f = "\\ud83c[\\udffb-\\udfff]", d = "(?:" + c + "|" + f + ")", g = "[^" + e + "]", h = "(?:\\ud83c[\\udde6-\\uddff]){2}", E = "[\\ud800-\\udbff][\\udc00-\\udfff]", y = "\\u200d", I = d + "?", Q = "[" + o + "]?", B = "(?:" + y + "(?:" + [g, h, E].join("|") + ")" + Q + I + ")*", _ = Q + I + B, M = "(?:" + [g + c + "?", c, h, E, u].join("|") + ")", S = RegExp(f + "(?=" + f + ")|" + M + _, "g");
    function O(w) {
      return w.match(S) || [];
    }
    return eB = O, eB;
  }
  var tB, JR;
  function ca2() {
    if (JR) return tB;
    JR = 1;
    var e = ua2(), t = iW(), r = la2();
    function n(i) {
      return t(i) ? r(i) : e(i);
    }
    return tB = n, tB;
  }
  var rB, eP;
  function Aa2() {
    if (eP) return rB;
    eP = 1;
    var e = sa2(), t = iW(), r = ca2(), n = eW();
    function i(o) {
      return function(u) {
        u = n(u);
        var c = t(u) ? r(u) : void 0, f = c ? c[0] : u.charAt(0), d = c ? e(c, 1).join("") : u.slice(1);
        return f[o]() + d;
      };
    }
    return rB = i, rB;
  }
  var nB, tP;
  function fa2() {
    if (tP) return nB;
    tP = 1;
    var e = Aa2(), t = e("toUpperCase");
    return nB = t, nB;
  }
  var Ca2 = fa2();
  const Bh = /* @__PURE__ */ tt(Ca2);
  function gt(e) {
    return function() {
      return e;
    };
  }
  const aW = Math.cos, Jg = Math.sin, mn = Math.sqrt, ep = Math.PI, Qh = 2 * ep, Nb = Math.PI, Hb = 2 * Nb, Bi = 1e-6, da2 = Hb - Bi;
  function oW(e) {
    this._ += e[0];
    for (let t = 1, r = e.length; t < r; ++t)
      this._ += arguments[t] + e[t];
  }
  function ga2(e) {
    let t = Math.floor(e);
    if (!(t >= 0)) throw new Error(`invalid digits: ${e}`);
    if (t > 15) return oW;
    const r = 10 ** t;
    return function(n) {
      this._ += n[0];
      for (let i = 1, o = n.length; i < o; ++i)
        this._ += Math.round(arguments[i] * r) / r + n[i];
    };
  }
  class pa2 {
    constructor(t) {
      this._x0 = this._y0 = // start of current subpath
      this._x1 = this._y1 = null, this._ = "", this._append = t == null ? oW : ga2(t);
    }
    moveTo(t, r) {
      this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}`;
    }
    closePath() {
      this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
    }
    lineTo(t, r) {
      this._append`L${this._x1 = +t},${this._y1 = +r}`;
    }
    quadraticCurveTo(t, r, n, i) {
      this._append`Q${+t},${+r},${this._x1 = +n},${this._y1 = +i}`;
    }
    bezierCurveTo(t, r, n, i, o, u) {
      this._append`C${+t},${+r},${+n},${+i},${this._x1 = +o},${this._y1 = +u}`;
    }
    arcTo(t, r, n, i, o) {
      if (t = +t, r = +r, n = +n, i = +i, o = +o, o < 0) throw new Error(`negative radius: ${o}`);
      let u = this._x1, c = this._y1, f = n - t, d = i - r, g = u - t, h = c - r, E = g * g + h * h;
      if (this._x1 === null)
        this._append`M${this._x1 = t},${this._y1 = r}`;
      else if (E > Bi) if (!(Math.abs(h * f - d * g) > Bi) || !o)
        this._append`L${this._x1 = t},${this._y1 = r}`;
      else {
        let y = n - u, I = i - c, Q = f * f + d * d, B = y * y + I * I, _ = Math.sqrt(Q), M = Math.sqrt(E), S = o * Math.tan((Nb - Math.acos((Q + E - B) / (2 * _ * M))) / 2), O = S / M, w = S / _;
        Math.abs(O - 1) > Bi && this._append`L${t + O * g},${r + O * h}`, this._append`A${o},${o},0,0,${+(h * y > g * I)},${this._x1 = t + w * f},${this._y1 = r + w * d}`;
      }
    }
    arc(t, r, n, i, o, u) {
      if (t = +t, r = +r, n = +n, u = !!u, n < 0) throw new Error(`negative radius: ${n}`);
      let c = n * Math.cos(i), f = n * Math.sin(i), d = t + c, g = r + f, h = 1 ^ u, E = u ? i - o : o - i;
      this._x1 === null ? this._append`M${d},${g}` : (Math.abs(this._x1 - d) > Bi || Math.abs(this._y1 - g) > Bi) && this._append`L${d},${g}`, n && (E < 0 && (E = E % Hb + Hb), E > da2 ? this._append`A${n},${n},0,1,${h},${t - c},${r - f}A${n},${n},0,1,${h},${this._x1 = d},${this._y1 = g}` : E > Bi && this._append`A${n},${n},0,${+(E >= Nb)},${h},${this._x1 = t + n * Math.cos(o)},${this._y1 = r + n * Math.sin(o)}`);
    }
    rect(t, r, n, i) {
      this._append`M${this._x0 = this._x1 = +t},${this._y0 = this._y1 = +r}h${n = +n}v${+i}h${-n}Z`;
    }
    toString() {
      return this._;
    }
  }
  function sM(e) {
    let t = 3;
    return e.digits = function(r) {
      if (!arguments.length) return t;
      if (r == null)
        t = null;
      else {
        const n = Math.floor(r);
        if (!(n >= 0)) throw new RangeError(`invalid digits: ${r}`);
        t = n;
      }
      return e;
    }, () => new pa2(t);
  }
  function uM(e) {
    return typeof e == "object" && "length" in e ? e : Array.from(e);
  }
  function sW(e) {
    this._context = e;
  }
  sW.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
        // falls through
        default:
          this._context.lineTo(e, t);
          break;
      }
    }
  };
  function xh(e) {
    return new sW(e);
  }
  function uW(e) {
    return e[0];
  }
  function lW(e) {
    return e[1];
  }
  function cW(e, t) {
    var r = gt(!0), n = null, i = xh, o = null, u = sM(c);
    e = typeof e == "function" ? e : e === void 0 ? uW : gt(e), t = typeof t == "function" ? t : t === void 0 ? lW : gt(t);
    function c(f) {
      var d, g = (f = uM(f)).length, h, E = !1, y;
      for (n == null && (o = i(y = u())), d = 0; d <= g; ++d)
        !(d < g && r(h = f[d], d, f)) === E && ((E = !E) ? o.lineStart() : o.lineEnd()), E && o.point(+e(h, d, f), +t(h, d, f));
      if (y) return o = null, y + "" || null;
    }
    return c.x = function(f) {
      return arguments.length ? (e = typeof f == "function" ? f : gt(+f), c) : e;
    }, c.y = function(f) {
      return arguments.length ? (t = typeof f == "function" ? f : gt(+f), c) : t;
    }, c.defined = function(f) {
      return arguments.length ? (r = typeof f == "function" ? f : gt(!!f), c) : r;
    }, c.curve = function(f) {
      return arguments.length ? (i = f, n != null && (o = i(n)), c) : i;
    }, c.context = function(f) {
      return arguments.length ? (f == null ? n = o = null : o = i(n = f), c) : n;
    }, c;
  }
  function Sd(e, t, r) {
    var n = null, i = gt(!0), o = null, u = xh, c = null, f = sM(d);
    e = typeof e == "function" ? e : e === void 0 ? uW : gt(+e), t = typeof t == "function" ? t : gt(t === void 0 ? 0 : +t), r = typeof r == "function" ? r : r === void 0 ? lW : gt(+r);
    function d(h) {
      var E, y, I, Q = (h = uM(h)).length, B, _ = !1, M, S = new Array(Q), O = new Array(Q);
      for (o == null && (c = u(M = f())), E = 0; E <= Q; ++E) {
        if (!(E < Q && i(B = h[E], E, h)) === _)
          if (_ = !_)
            y = E, c.areaStart(), c.lineStart();
          else {
            for (c.lineEnd(), c.lineStart(), I = E - 1; I >= y; --I)
              c.point(S[I], O[I]);
            c.lineEnd(), c.areaEnd();
          }
        _ && (S[E] = +e(B, E, h), O[E] = +t(B, E, h), c.point(n ? +n(B, E, h) : S[E], r ? +r(B, E, h) : O[E]));
      }
      if (M) return c = null, M + "" || null;
    }
    function g() {
      return cW().defined(i).curve(u).context(o);
    }
    return d.x = function(h) {
      return arguments.length ? (e = typeof h == "function" ? h : gt(+h), n = null, d) : e;
    }, d.x0 = function(h) {
      return arguments.length ? (e = typeof h == "function" ? h : gt(+h), d) : e;
    }, d.x1 = function(h) {
      return arguments.length ? (n = h == null ? null : typeof h == "function" ? h : gt(+h), d) : n;
    }, d.y = function(h) {
      return arguments.length ? (t = typeof h == "function" ? h : gt(+h), r = null, d) : t;
    }, d.y0 = function(h) {
      return arguments.length ? (t = typeof h == "function" ? h : gt(+h), d) : t;
    }, d.y1 = function(h) {
      return arguments.length ? (r = h == null ? null : typeof h == "function" ? h : gt(+h), d) : r;
    }, d.lineX0 = d.lineY0 = function() {
      return g().x(e).y(t);
    }, d.lineY1 = function() {
      return g().x(e).y(r);
    }, d.lineX1 = function() {
      return g().x(n).y(t);
    }, d.defined = function(h) {
      return arguments.length ? (i = typeof h == "function" ? h : gt(!!h), d) : i;
    }, d.curve = function(h) {
      return arguments.length ? (u = h, o != null && (c = u(o)), d) : u;
    }, d.context = function(h) {
      return arguments.length ? (h == null ? o = c = null : c = u(o = h), d) : o;
    }, d;
  }
  class AW {
    constructor(t, r) {
      this._context = t, this._x = r;
    }
    areaStart() {
      this._line = 0;
    }
    areaEnd() {
      this._line = NaN;
    }
    lineStart() {
      this._point = 0;
    }
    lineEnd() {
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    }
    point(t, r) {
      switch (t = +t, r = +r, this._point) {
        case 0: {
          this._point = 1, this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
          break;
        }
        case 1:
          this._point = 2;
        // falls through
        default: {
          this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + t) / 2, this._y0, this._x0, r, t, r) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + r) / 2, t, this._y0, t, r);
          break;
        }
      }
      this._x0 = t, this._y0 = r;
    }
  }
  function ha2(e) {
    return new AW(e, !0);
  }
  function va2(e) {
    return new AW(e, !1);
  }
  const lM = {
    draw(e, t) {
      const r = mn(t / ep);
      e.moveTo(r, 0), e.arc(0, 0, r, 0, Qh);
    }
  }, Ea2 = {
    draw(e, t) {
      const r = mn(t / 5) / 2;
      e.moveTo(-3 * r, -r), e.lineTo(-r, -r), e.lineTo(-r, -3 * r), e.lineTo(r, -3 * r), e.lineTo(r, -r), e.lineTo(3 * r, -r), e.lineTo(3 * r, r), e.lineTo(r, r), e.lineTo(r, 3 * r), e.lineTo(-r, 3 * r), e.lineTo(-r, r), e.lineTo(-3 * r, r), e.closePath();
    }
  }, fW = mn(1 / 3), ma2 = fW * 2, ya2 = {
    draw(e, t) {
      const r = mn(t / ma2), n = r * fW;
      e.moveTo(0, -r), e.lineTo(n, 0), e.lineTo(0, r), e.lineTo(-n, 0), e.closePath();
    }
  }, Ia2 = {
    draw(e, t) {
      const r = mn(t), n = -r / 2;
      e.rect(n, n, r, r);
    }
  }, Ba2 = 0.8908130915292852, CW = Jg(ep / 10) / Jg(7 * ep / 10), Qa2 = Jg(Qh / 10) * CW, xa2 = -aW(Qh / 10) * CW, ba2 = {
    draw(e, t) {
      const r = mn(t * Ba2), n = Qa2 * r, i = xa2 * r;
      e.moveTo(0, -r), e.lineTo(n, i);
      for (let o = 1; o < 5; ++o) {
        const u = Qh * o / 5, c = aW(u), f = Jg(u);
        e.lineTo(f * r, -c * r), e.lineTo(c * n - f * i, f * n + c * i);
      }
      e.closePath();
    }
  }, iB = mn(3), wa2 = {
    draw(e, t) {
      const r = -mn(t / (iB * 3));
      e.moveTo(0, r * 2), e.lineTo(-iB * r, -r), e.lineTo(iB * r, -r), e.closePath();
    }
  }, B4 = -0.5, Q4 = mn(3) / 2, jb = 1 / mn(12), Sa2 = (jb / 2 + 1) * 3, Ma2 = {
    draw(e, t) {
      const r = mn(t / Sa2), n = r / 2, i = r * jb, o = n, u = r * jb + r, c = -o, f = u;
      e.moveTo(n, i), e.lineTo(o, u), e.lineTo(c, f), e.lineTo(B4 * n - Q4 * i, Q4 * n + B4 * i), e.lineTo(B4 * o - Q4 * u, Q4 * o + B4 * u), e.lineTo(B4 * c - Q4 * f, Q4 * c + B4 * f), e.lineTo(B4 * n + Q4 * i, B4 * i - Q4 * n), e.lineTo(B4 * o + Q4 * u, B4 * u - Q4 * o), e.lineTo(B4 * c + Q4 * f, B4 * f - Q4 * c), e.closePath();
    }
  };
  function _a2(e, t) {
    let r = null, n = sM(i);
    e = typeof e == "function" ? e : gt(e || lM), t = typeof t == "function" ? t : gt(t === void 0 ? 64 : +t);
    function i() {
      let o;
      if (r || (r = o = n()), e.apply(this, arguments).draw(r, +t.apply(this, arguments)), o) return r = null, o + "" || null;
    }
    return i.type = function(o) {
      return arguments.length ? (e = typeof o == "function" ? o : gt(o), i) : e;
    }, i.size = function(o) {
      return arguments.length ? (t = typeof o == "function" ? o : gt(+o), i) : t;
    }, i.context = function(o) {
      return arguments.length ? (r = o ?? null, i) : r;
    }, i;
  }
  function tp() {
  }
  function rp(e, t, r) {
    e._context.bezierCurveTo(
      (2 * e._x0 + e._x1) / 3,
      (2 * e._y0 + e._y1) / 3,
      (e._x0 + 2 * e._x1) / 3,
      (e._y0 + 2 * e._y1) / 3,
      (e._x0 + 4 * e._x1 + t) / 6,
      (e._y0 + 4 * e._y1 + r) / 6
    );
  }
  function dW(e) {
    this._context = e;
  }
  dW.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 3:
          rp(this, this._x1, this._y1);
        // falls through
        case 2:
          this._context.lineTo(this._x1, this._y1);
          break;
      }
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
        // falls through
        default:
          rp(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function Oa2(e) {
    return new dW(e);
  }
  function gW(e) {
    this._context = e;
  }
  gW.prototype = {
    areaStart: tp,
    areaEnd: tp,
    lineStart: function() {
      this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 1: {
          this._context.moveTo(this._x2, this._y2), this._context.closePath();
          break;
        }
        case 2: {
          this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
          break;
        }
        case 3: {
          this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
          break;
        }
      }
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._x2 = e, this._y2 = t;
          break;
        case 1:
          this._point = 2, this._x3 = e, this._y3 = t;
          break;
        case 2:
          this._point = 3, this._x4 = e, this._y4 = t, this._context.moveTo((this._x0 + 4 * this._x1 + e) / 6, (this._y0 + 4 * this._y1 + t) / 6);
          break;
        default:
          rp(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function Ta2(e) {
    return new gW(e);
  }
  function pW(e) {
    this._context = e;
  }
  pW.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
    },
    lineEnd: function() {
      (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1;
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3;
          var r = (this._x0 + 4 * this._x1 + e) / 6, n = (this._y0 + 4 * this._y1 + t) / 6;
          this._line ? this._context.lineTo(r, n) : this._context.moveTo(r, n);
          break;
        case 3:
          this._point = 4;
        // falls through
        default:
          rp(this, e, t);
          break;
      }
      this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t;
    }
  };
  function Da2(e) {
    return new pW(e);
  }
  function hW(e) {
    this._context = e;
  }
  hW.prototype = {
    areaStart: tp,
    areaEnd: tp,
    lineStart: function() {
      this._point = 0;
    },
    lineEnd: function() {
      this._point && this._context.closePath();
    },
    point: function(e, t) {
      e = +e, t = +t, this._point ? this._context.lineTo(e, t) : (this._point = 1, this._context.moveTo(e, t));
    }
  };
  function La2(e) {
    return new hW(e);
  }
  function rP(e) {
    return e < 0 ? -1 : 1;
  }
  function nP(e, t, r) {
    var n = e._x1 - e._x0, i = t - e._x1, o = (e._y1 - e._y0) / (n || i < 0 && -0), u = (r - e._y1) / (i || n < 0 && -0), c = (o * i + u * n) / (n + i);
    return (rP(o) + rP(u)) * Math.min(Math.abs(o), Math.abs(u), 0.5 * Math.abs(c)) || 0;
  }
  function iP(e, t) {
    var r = e._x1 - e._x0;
    return r ? (3 * (e._y1 - e._y0) / r - t) / 2 : t;
  }
  function aB(e, t, r) {
    var n = e._x0, i = e._y0, o = e._x1, u = e._y1, c = (o - n) / 3;
    e._context.bezierCurveTo(n + c, i + c * t, o - c, u - c * r, o, u);
  }
  function np(e) {
    this._context = e;
  }
  np.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
    },
    lineEnd: function() {
      switch (this._point) {
        case 2:
          this._context.lineTo(this._x1, this._y1);
          break;
        case 3:
          aB(this, this._t0, iP(this, this._t0));
          break;
      }
      (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
    },
    point: function(e, t) {
      var r = NaN;
      if (e = +e, t = +t, !(e === this._x1 && t === this._y1)) {
        switch (this._point) {
          case 0:
            this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
            break;
          case 1:
            this._point = 2;
            break;
          case 2:
            this._point = 3, aB(this, iP(this, r = nP(this, e, t)), r);
            break;
          default:
            aB(this, this._t0, r = nP(this, e, t));
            break;
        }
        this._x0 = this._x1, this._x1 = e, this._y0 = this._y1, this._y1 = t, this._t0 = r;
      }
    }
  };
  function vW(e) {
    this._context = new EW(e);
  }
  (vW.prototype = Object.create(np.prototype)).point = function(e, t) {
    np.prototype.point.call(this, t, e);
  };
  function EW(e) {
    this._context = e;
  }
  EW.prototype = {
    moveTo: function(e, t) {
      this._context.moveTo(t, e);
    },
    closePath: function() {
      this._context.closePath();
    },
    lineTo: function(e, t) {
      this._context.lineTo(t, e);
    },
    bezierCurveTo: function(e, t, r, n, i, o) {
      this._context.bezierCurveTo(t, e, n, r, o, i);
    }
  };
  function ka2(e) {
    return new np(e);
  }
  function Ra2(e) {
    return new vW(e);
  }
  function mW(e) {
    this._context = e;
  }
  mW.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = [], this._y = [];
    },
    lineEnd: function() {
      var e = this._x, t = this._y, r = e.length;
      if (r)
        if (this._line ? this._context.lineTo(e[0], t[0]) : this._context.moveTo(e[0], t[0]), r === 2)
          this._context.lineTo(e[1], t[1]);
        else
          for (var n = aP(e), i = aP(t), o = 0, u = 1; u < r; ++o, ++u)
            this._context.bezierCurveTo(n[0][o], i[0][o], n[1][o], i[1][o], e[u], t[u]);
      (this._line || this._line !== 0 && r === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
    },
    point: function(e, t) {
      this._x.push(+e), this._y.push(+t);
    }
  };
  function aP(e) {
    var t, r = e.length - 1, n, i = new Array(r), o = new Array(r), u = new Array(r);
    for (i[0] = 0, o[0] = 2, u[0] = e[0] + 2 * e[1], t = 1; t < r - 1; ++t) i[t] = 1, o[t] = 4, u[t] = 4 * e[t] + 2 * e[t + 1];
    for (i[r - 1] = 2, o[r - 1] = 7, u[r - 1] = 8 * e[r - 1] + e[r], t = 1; t < r; ++t) n = i[t] / o[t - 1], o[t] -= n, u[t] -= n * u[t - 1];
    for (i[r - 1] = u[r - 1] / o[r - 1], t = r - 2; t >= 0; --t) i[t] = (u[t] - i[t + 1]) / o[t];
    for (o[r - 1] = (e[r] + i[r - 1]) / 2, t = 0; t < r - 1; ++t) o[t] = 2 * e[t + 1] - i[t + 1];
    return [i, o];
  }
  function Pa2(e) {
    return new mW(e);
  }
  function bh(e, t) {
    this._context = e, this._t = t;
  }
  bh.prototype = {
    areaStart: function() {
      this._line = 0;
    },
    areaEnd: function() {
      this._line = NaN;
    },
    lineStart: function() {
      this._x = this._y = NaN, this._point = 0;
    },
    lineEnd: function() {
      0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
    },
    point: function(e, t) {
      switch (e = +e, t = +t, this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
          break;
        case 1:
          this._point = 2;
        // falls through
        default: {
          if (this._t <= 0)
            this._context.lineTo(this._x, t), this._context.lineTo(e, t);
          else {
            var r = this._x * (1 - this._t) + e * this._t;
            this._context.lineTo(r, this._y), this._context.lineTo(r, t);
          }
          break;
        }
      }
      this._x = e, this._y = t;
    }
  };
  function Fa2(e) {
    return new bh(e, 0.5);
  }
  function Na2(e) {
    return new bh(e, 0);
  }
  function Ha2(e) {
    return new bh(e, 1);
  }
  function w9(e, t) {
    if ((u = e.length) > 1)
      for (var r = 1, n, i, o = e[t[0]], u, c = o.length; r < u; ++r)
        for (i = o, o = e[t[r]], n = 0; n < c; ++n)
          o[n][1] += o[n][0] = isNaN(i[n][1]) ? i[n][0] : i[n][1];
  }
  function Vb(e) {
    for (var t = e.length, r = new Array(t); --t >= 0; ) r[t] = t;
    return r;
  }
  function ja2(e, t) {
    return e[t];
  }
  function Va2(e) {
    const t = [];
    return t.key = e, t;
  }
  function Za2() {
    var e = gt([]), t = Vb, r = w9, n = ja2;
    function i(o) {
      var u = Array.from(e.apply(this, arguments), Va2), c, f = u.length, d = -1, g;
      for (const h of o)
        for (c = 0, ++d; c < f; ++c)
          (u[c][d] = [0, +n(h, u[c].key, d, o)]).data = h;
      for (c = 0, g = uM(t(u)); c < f; ++c)
        u[g[c]].index = c;
      return r(u, g), u;
    }
    return i.keys = function(o) {
      return arguments.length ? (e = typeof o == "function" ? o : gt(Array.from(o)), i) : e;
    }, i.value = function(o) {
      return arguments.length ? (n = typeof o == "function" ? o : gt(+o), i) : n;
    }, i.order = function(o) {
      return arguments.length ? (t = o == null ? Vb : typeof o == "function" ? o : gt(Array.from(o)), i) : t;
    }, i.offset = function(o) {
      return arguments.length ? (r = o ?? w9, i) : r;
    }, i;
  }
  function za2(e, t) {
    if ((n = e.length) > 0) {
      for (var r, n, i = 0, o = e[0].length, u; i < o; ++i) {
        for (u = r = 0; r < n; ++r) u += e[r][i][1] || 0;
        if (u) for (r = 0; r < n; ++r) e[r][i][1] /= u;
      }
      w9(e, t);
    }
  }
  function Ua2(e, t) {
    if ((i = e.length) > 0) {
      for (var r = 0, n = e[t[0]], i, o = n.length; r < o; ++r) {
        for (var u = 0, c = 0; u < i; ++u) c += e[u][r][1] || 0;
        n[r][1] += n[r][0] = -c / 2;
      }
      w9(e, t);
    }
  }
  function qa2(e, t) {
    if (!(!((u = e.length) > 0) || !((o = (i = e[t[0]]).length) > 0))) {
      for (var r = 0, n = 1, i, o, u; n < o; ++n) {
        for (var c = 0, f = 0, d = 0; c < u; ++c) {
          for (var g = e[t[c]], h = g[n][1] || 0, E = g[n - 1][1] || 0, y = (h - E) / 2, I = 0; I < c; ++I) {
            var Q = e[t[I]], B = Q[n][1] || 0, _ = Q[n - 1][1] || 0;
            y += B - _;
          }
          f += h, d += y * h;
        }
        i[n - 1][1] += i[n - 1][0] = r, f && (r -= d / f);
      }
      i[n - 1][1] += i[n - 1][0] = r, w9(e, t);
    }
  }
  function vc(e) {
    "@babel/helpers - typeof";
    return vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, vc(e);
  }
  var Wa2 = ["type", "size", "sizeType"];
  function Zb() {
    return Zb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Zb.apply(this, arguments);
  }
  function oP(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function sP(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? oP(Object(r), !0).forEach(function(n) {
        Ya2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oP(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ya2(e, t, r) {
    return t = $a2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function $a2(e) {
    var t = Ga2(e, "string");
    return vc(t) == "symbol" ? t : t + "";
  }
  function Ga2(e, t) {
    if (vc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (vc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ka2(e, t) {
    if (e == null) return {};
    var r = Xa2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Xa2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var yW = {
    symbolCircle: lM,
    symbolCross: Ea2,
    symbolDiamond: ya2,
    symbolSquare: Ia2,
    symbolStar: ba2,
    symbolTriangle: wa2,
    symbolWye: Ma2
  }, Ja2 = Math.PI / 180, eo2 = function(t) {
    var r = "symbol".concat(Bh(t));
    return yW[r] || lM;
  }, to2 = function(t, r, n) {
    if (r === "area")
      return t;
    switch (n) {
      case "cross":
        return 5 * t * t / 9;
      case "diamond":
        return 0.5 * t * t / Math.sqrt(3);
      case "square":
        return t * t;
      case "star": {
        var i = 18 * Ja2;
        return 1.25 * t * t * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
      }
      case "triangle":
        return Math.sqrt(3) * t * t / 4;
      case "wye":
        return (21 - 10 * Math.sqrt(3)) * t * t / 8;
      default:
        return Math.PI * t * t / 4;
    }
  }, ro2 = function(t, r) {
    yW["symbol".concat(Bh(t))] = r;
  }, cM = function(t) {
    var r = t.type, n = r === void 0 ? "circle" : r, i = t.size, o = i === void 0 ? 64 : i, u = t.sizeType, c = u === void 0 ? "area" : u, f = Ka2(t, Wa2), d = sP(sP({}, f), {}, {
      type: n,
      size: o,
      sizeType: c
    }), g = function() {
      var B = eo2(n), _ = _a2().type(B).size(to2(o, c, n));
      return _();
    }, h = d.className, E = d.cx, y = d.cy, I = ge(d, !0);
    return E === +E && y === +y && o === +o ? /* @__PURE__ */ f2.createElement("path", Zb({}, I, {
      className: pe("recharts-symbols", h),
      transform: "translate(".concat(E, ", ").concat(y, ")"),
      d: g()
    })) : null;
  };
  cM.registerSymbol = ro2;
  function S9(e) {
    "@babel/helpers - typeof";
    return S9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, S9(e);
  }
  function zb() {
    return zb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, zb.apply(this, arguments);
  }
  function uP(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function no2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? uP(Object(r), !0).forEach(function(n) {
        Ec(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : uP(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function io2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function ao2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, BW(n.key), n);
    }
  }
  function oo2(e, t, r) {
    return t && ao2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function so2(e, t, r) {
    return t = ip(t), uo2(e, IW() ? Reflect.construct(t, r || [], ip(e).constructor) : t.apply(e, r));
  }
  function uo2(e, t) {
    if (t && (S9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return lo2(e);
  }
  function lo2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function IW() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (IW = function() {
      return !!e;
    })();
  }
  function ip(e) {
    return ip = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, ip(e);
  }
  function co2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Ub(e, t);
  }
  function Ub(e, t) {
    return Ub = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Ub(e, t);
  }
  function Ec(e, t, r) {
    return t = BW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function BW(e) {
    var t = Ao2(e, "string");
    return S9(t) == "symbol" ? t : t + "";
  }
  function Ao2(e, t) {
    if (S9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (S9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var un = 32, AM = /* @__PURE__ */ function(e) {
    function t() {
      return io2(this, t), so2(this, t, arguments);
    }
    return co2(t, e), oo2(t, [{
      key: "renderIcon",
      value: (
        /**
         * Render the path of icon
         * @param {Object} data Data of each legend item
         * @return {String} Path element
         */
        function(n) {
          var i = this.props.inactiveColor, o = un / 2, u = un / 6, c = un / 3, f = n.inactive ? i : n.color;
          if (n.type === "plainline")
            return /* @__PURE__ */ f2.createElement("line", {
              strokeWidth: 4,
              fill: "none",
              stroke: f,
              strokeDasharray: n.payload.strokeDasharray,
              x1: 0,
              y1: o,
              x2: un,
              y2: o,
              className: "recharts-legend-icon"
            });
          if (n.type === "line")
            return /* @__PURE__ */ f2.createElement("path", {
              strokeWidth: 4,
              fill: "none",
              stroke: f,
              d: "M0,".concat(o, "h").concat(c, `
            A`).concat(u, ",").concat(u, ",0,1,1,").concat(2 * c, ",").concat(o, `
            H`).concat(un, "M").concat(2 * c, ",").concat(o, `
            A`).concat(u, ",").concat(u, ",0,1,1,").concat(c, ",").concat(o),
              className: "recharts-legend-icon"
            });
          if (n.type === "rect")
            return /* @__PURE__ */ f2.createElement("path", {
              stroke: "none",
              fill: f,
              d: "M0,".concat(un / 8, "h").concat(un, "v").concat(un * 3 / 4, "h").concat(-32, "z"),
              className: "recharts-legend-icon"
            });
          if (/* @__PURE__ */ f2.isValidElement(n.legendIcon)) {
            var d = no2({}, n);
            return delete d.legendIcon, /* @__PURE__ */ f2.cloneElement(n.legendIcon, d);
          }
          return /* @__PURE__ */ f2.createElement(cM, {
            fill: f,
            cx: o,
            cy: o,
            size: un,
            sizeType: "diameter",
            type: n.type
          });
        }
      )
      /**
       * Draw items of legend
       * @return {ReactElement} Items
       */
    }, {
      key: "renderItems",
      value: function() {
        var n = this, i = this.props, o = i.payload, u = i.iconSize, c = i.layout, f = i.formatter, d = i.inactiveColor, g = {
          x: 0,
          y: 0,
          width: un,
          height: un
        }, h = {
          display: c === "horizontal" ? "inline-block" : "block",
          marginRight: 10
        }, E = {
          display: "inline-block",
          verticalAlign: "middle",
          marginRight: 4
        };
        return o.map(function(y, I) {
          var Q = y.formatter || f, B = pe(Ec(Ec({
            "recharts-legend-item": !0
          }, "legend-item-".concat(I), !0), "inactive", y.inactive));
          if (y.type === "none")
            return null;
          var _ = te(y.value) ? null : y.value;
          v8(
            !te(y.value),
            `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
            // eslint-disable-line max-len
          );
          var M = y.inactive ? d : y.color;
          return /* @__PURE__ */ f2.createElement("li", zb({
            className: B,
            style: h,
            key: "legend-item-".concat(I)
          }, Xg(n.props, y, I)), /* @__PURE__ */ f2.createElement(Pb, {
            width: u,
            height: u,
            viewBox: g,
            style: E
          }, n.renderIcon(y)), /* @__PURE__ */ f2.createElement("span", {
            className: "recharts-legend-item-text",
            style: {
              color: M
            }
          }, Q ? Q(_, y, I) : _));
        });
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.payload, o = n.layout, u = n.align;
        if (!i || !i.length)
          return null;
        var c = {
          padding: 0,
          margin: 0,
          textAlign: o === "horizontal" ? u : "left"
        };
        return /* @__PURE__ */ f2.createElement("ul", {
          className: "recharts-default-legend",
          style: c
        }, this.renderItems());
      }
    }]);
  }(q.PureComponent);
  Ec(AM, "displayName", "Legend");
  Ec(AM, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
  });
  var oB, lP;
  function fo2() {
    if (lP) return oB;
    lP = 1;
    var e = mh();
    function t() {
      this.__data__ = new e(), this.size = 0;
    }
    return oB = t, oB;
  }
  var sB, cP;
  function Co2() {
    if (cP) return sB;
    cP = 1;
    function e(t) {
      var r = this.__data__, n = r.delete(t);
      return this.size = r.size, n;
    }
    return sB = e, sB;
  }
  var uB, AP;
  function do2() {
    if (AP) return uB;
    AP = 1;
    function e(t) {
      return this.__data__.get(t);
    }
    return uB = e, uB;
  }
  var lB, fP;
  function go2() {
    if (fP) return lB;
    fP = 1;
    function e(t) {
      return this.__data__.has(t);
    }
    return lB = e, lB;
  }
  var cB, CP;
  function po2() {
    if (CP) return cB;
    CP = 1;
    var e = mh(), t = tM(), r = rM(), n = 200;
    function i(o, u) {
      var c = this.__data__;
      if (c instanceof e) {
        var f = c.__data__;
        if (!t || f.length < n - 1)
          return f.push([o, u]), this.size = ++c.size, this;
        c = this.__data__ = new r(f);
      }
      return c.set(o, u), this.size = c.size, this;
    }
    return cB = i, cB;
  }
  var AB, dP;
  function QW() {
    if (dP) return AB;
    dP = 1;
    var e = mh(), t = fo2(), r = Co2(), n = do2(), i = go2(), o = po2();
    function u(c) {
      var f = this.__data__ = new e(c);
      this.size = f.size;
    }
    return u.prototype.clear = t, u.prototype.delete = r, u.prototype.get = n, u.prototype.has = i, u.prototype.set = o, AB = u, AB;
  }
  var fB, gP;
  function ho2() {
    if (gP) return fB;
    gP = 1;
    var e = "__lodash_hash_undefined__";
    function t(r) {
      return this.__data__.set(r, e), this;
    }
    return fB = t, fB;
  }
  var CB, pP;
  function vo2() {
    if (pP) return CB;
    pP = 1;
    function e(t) {
      return this.__data__.has(t);
    }
    return CB = e, CB;
  }
  var dB, hP;
  function xW() {
    if (hP) return dB;
    hP = 1;
    var e = rM(), t = ho2(), r = vo2();
    function n(i) {
      var o = -1, u = i == null ? 0 : i.length;
      for (this.__data__ = new e(); ++o < u; )
        this.add(i[o]);
    }
    return n.prototype.add = n.prototype.push = t, n.prototype.has = r, dB = n, dB;
  }
  var gB, vP;
  function bW() {
    if (vP) return gB;
    vP = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
        if (r(t[n], n, t))
          return !0;
      return !1;
    }
    return gB = e, gB;
  }
  var pB, EP;
  function wW() {
    if (EP) return pB;
    EP = 1;
    function e(t, r) {
      return t.has(r);
    }
    return pB = e, pB;
  }
  var hB, mP;
  function SW() {
    if (mP) return hB;
    mP = 1;
    var e = xW(), t = bW(), r = wW(), n = 1, i = 2;
    function o(u, c, f, d, g, h) {
      var E = f & n, y = u.length, I = c.length;
      if (y != I && !(E && I > y))
        return !1;
      var Q = h.get(u), B = h.get(c);
      if (Q && B)
        return Q == c && B == u;
      var _ = -1, M = !0, S = f & i ? new e() : void 0;
      for (h.set(u, c), h.set(c, u); ++_ < y; ) {
        var O = u[_], w = c[_];
        if (d)
          var D = E ? d(w, O, _, c, u, h) : d(O, w, _, u, c, h);
        if (D !== void 0) {
          if (D)
            continue;
          M = !1;
          break;
        }
        if (S) {
          if (!t(c, function(k, F) {
            if (!r(S, F) && (O === k || g(O, k, f, d, h)))
              return S.push(F);
          })) {
            M = !1;
            break;
          }
        } else if (!(O === w || g(O, w, f, d, h))) {
          M = !1;
          break;
        }
      }
      return h.delete(u), h.delete(c), M;
    }
    return hB = o, hB;
  }
  var vB, yP;
  function Eo2() {
    if (yP) return vB;
    yP = 1;
    var e = h3(), t = e.Uint8Array;
    return vB = t, vB;
  }
  var EB, IP;
  function mo2() {
    if (IP) return EB;
    IP = 1;
    function e(t) {
      var r = -1, n = Array(t.size);
      return t.forEach(function(i, o) {
        n[++r] = [o, i];
      }), n;
    }
    return EB = e, EB;
  }
  var mB, BP;
  function fM() {
    if (BP) return mB;
    BP = 1;
    function e(t) {
      var r = -1, n = Array(t.size);
      return t.forEach(function(i) {
        n[++r] = i;
      }), n;
    }
    return mB = e, mB;
  }
  var yB, QP;
  function yo2() {
    if (QP) return yB;
    QP = 1;
    var e = oA(), t = Eo2(), r = eM(), n = SW(), i = mo2(), o = fM(), u = 1, c = 2, f = "[object Boolean]", d = "[object Date]", g = "[object Error]", h = "[object Map]", E = "[object Number]", y = "[object RegExp]", I = "[object Set]", Q = "[object String]", B = "[object Symbol]", _ = "[object ArrayBuffer]", M = "[object DataView]", S = e ? e.prototype : void 0, O = S ? S.valueOf : void 0;
    function w(D, k, F, z, Z, V, $) {
      switch (F) {
        case M:
          if (D.byteLength != k.byteLength || D.byteOffset != k.byteOffset)
            return !1;
          D = D.buffer, k = k.buffer;
        case _:
          return !(D.byteLength != k.byteLength || !V(new t(D), new t(k)));
        case f:
        case d:
        case E:
          return r(+D, +k);
        case g:
          return D.name == k.name && D.message == k.message;
        case y:
        case Q:
          return D == k + "";
        case h:
          var W = i;
        case I:
          var t2 = z & u;
          if (W || (W = o), D.size != k.size && !t2)
            return !1;
          var n2 = $.get(D);
          if (n2)
            return n2 == k;
          z |= c, $.set(D, k);
          var s2 = n(W(D), W(k), z, Z, V, $);
          return $.delete(D), s2;
        case B:
          if (O)
            return O.call(D) == O.call(k);
      }
      return !1;
    }
    return yB = w, yB;
  }
  var IB, xP;
  function MW() {
    if (xP) return IB;
    xP = 1;
    function e(t, r) {
      for (var n = -1, i = r.length, o = t.length; ++n < i; )
        t[o + n] = r[n];
      return t;
    }
    return IB = e, IB;
  }
  var BB, bP;
  function Io2() {
    if (bP) return BB;
    bP = 1;
    var e = MW(), t = Ir();
    function r(n, i, o) {
      var u = i(n);
      return t(n) ? u : e(u, o(n));
    }
    return BB = r, BB;
  }
  var QB, wP;
  function Bo2() {
    if (wP) return QB;
    wP = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length, o = 0, u = []; ++n < i; ) {
        var c = t[n];
        r(c, n, t) && (u[o++] = c);
      }
      return u;
    }
    return QB = e, QB;
  }
  var xB, SP;
  function Qo2() {
    if (SP) return xB;
    SP = 1;
    function e() {
      return [];
    }
    return xB = e, xB;
  }
  var bB, MP;
  function xo2() {
    if (MP) return bB;
    MP = 1;
    var e = Bo2(), t = Qo2(), r = Object.prototype, n = r.propertyIsEnumerable, i = Object.getOwnPropertySymbols, o = i ? function(u) {
      return u == null ? [] : (u = Object(u), e(i(u), function(c) {
        return n.call(u, c);
      }));
    } : t;
    return bB = o, bB;
  }
  var wB, _P;
  function bo2() {
    if (_P) return wB;
    _P = 1;
    function e(t, r) {
      for (var n = -1, i = Array(t); ++n < t; )
        i[n] = r(n);
      return i;
    }
    return wB = e, wB;
  }
  var SB, OP;
  function wo2() {
    if (OP) return SB;
    OP = 1;
    var e = M8(), t = _8(), r = "[object Arguments]";
    function n(i) {
      return t(i) && e(i) == r;
    }
    return SB = n, SB;
  }
  var MB, TP;
  function CM() {
    if (TP) return MB;
    TP = 1;
    var e = wo2(), t = _8(), r = Object.prototype, n = r.hasOwnProperty, i = r.propertyIsEnumerable, o = e(/* @__PURE__ */ function() {
      return arguments;
    }()) ? e : function(u) {
      return t(u) && n.call(u, "callee") && !i.call(u, "callee");
    };
    return MB = o, MB;
  }
  var Yl = { exports: {} }, _B, DP;
  function So2() {
    if (DP) return _B;
    DP = 1;
    function e() {
      return !1;
    }
    return _B = e, _B;
  }
  Yl.exports;
  var LP;
  function _W() {
    return LP || (LP = 1, function(e, t) {
      var r = h3(), n = So2(), i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, u = o && o.exports === i, c = u ? r.Buffer : void 0, f = c ? c.isBuffer : void 0, d = f || n;
      e.exports = d;
    }(Yl, Yl.exports)), Yl.exports;
  }
  var OB, kP;
  function dM() {
    if (kP) return OB;
    kP = 1;
    var e = 9007199254740991, t = /^(?:0|[1-9]\d*)$/;
    function r(n, i) {
      var o = typeof n;
      return i = i ?? e, !!i && (o == "number" || o != "symbol" && t.test(n)) && n > -1 && n % 1 == 0 && n < i;
    }
    return OB = r, OB;
  }
  var TB, RP;
  function gM() {
    if (RP) return TB;
    RP = 1;
    var e = 9007199254740991;
    function t(r) {
      return typeof r == "number" && r > -1 && r % 1 == 0 && r <= e;
    }
    return TB = t, TB;
  }
  var DB, PP;
  function Mo2() {
    if (PP) return DB;
    PP = 1;
    var e = M8(), t = gM(), r = _8(), n = "[object Arguments]", i = "[object Array]", o = "[object Boolean]", u = "[object Date]", c = "[object Error]", f = "[object Function]", d = "[object Map]", g = "[object Number]", h = "[object Object]", E = "[object RegExp]", y = "[object Set]", I = "[object String]", Q = "[object WeakMap]", B = "[object ArrayBuffer]", _ = "[object DataView]", M = "[object Float32Array]", S = "[object Float64Array]", O = "[object Int8Array]", w = "[object Int16Array]", D = "[object Int32Array]", k = "[object Uint8Array]", F = "[object Uint8ClampedArray]", z = "[object Uint16Array]", Z = "[object Uint32Array]", V = {};
    V[M] = V[S] = V[O] = V[w] = V[D] = V[k] = V[F] = V[z] = V[Z] = !0, V[n] = V[i] = V[B] = V[o] = V[_] = V[u] = V[c] = V[f] = V[d] = V[g] = V[h] = V[E] = V[y] = V[I] = V[Q] = !1;
    function $(W) {
      return r(W) && t(W.length) && !!V[e(W)];
    }
    return DB = $, DB;
  }
  var LB, FP;
  function OW() {
    if (FP) return LB;
    FP = 1;
    function e(t) {
      return function(r) {
        return t(r);
      };
    }
    return LB = e, LB;
  }
  var $l = { exports: {} };
  $l.exports;
  var NP;
  function _o2() {
    return NP || (NP = 1, function(e, t) {
      var r = Kq(), n = t && !t.nodeType && t, i = n && !0 && e && !e.nodeType && e, o = i && i.exports === n, u = o && r.process, c = function() {
        try {
          var f = i && i.require && i.require("util").types;
          return f || u && u.binding && u.binding("util");
        } catch {
        }
      }();
      e.exports = c;
    }($l, $l.exports)), $l.exports;
  }
  var kB, HP;
  function TW() {
    if (HP) return kB;
    HP = 1;
    var e = Mo2(), t = OW(), r = _o2(), n = r && r.isTypedArray, i = n ? t(n) : e;
    return kB = i, kB;
  }
  var RB, jP;
  function Oo2() {
    if (jP) return RB;
    jP = 1;
    var e = bo2(), t = CM(), r = Ir(), n = _W(), i = dM(), o = TW(), u = Object.prototype, c = u.hasOwnProperty;
    function f(d, g) {
      var h = r(d), E = !h && t(d), y = !h && !E && n(d), I = !h && !E && !y && o(d), Q = h || E || y || I, B = Q ? e(d.length, String) : [], _ = B.length;
      for (var M in d)
        (g || c.call(d, M)) && !(Q && // Safari 9 has enumerable `arguments.length` in strict mode.
        (M == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        y && (M == "offset" || M == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        I && (M == "buffer" || M == "byteLength" || M == "byteOffset") || // Skip index properties.
        i(M, _))) && B.push(M);
      return B;
    }
    return RB = f, RB;
  }
  var PB, VP;
  function To2() {
    if (VP) return PB;
    VP = 1;
    var e = Object.prototype;
    function t(r) {
      var n = r && r.constructor, i = typeof n == "function" && n.prototype || e;
      return r === i;
    }
    return PB = t, PB;
  }
  var FB, ZP;
  function DW() {
    if (ZP) return FB;
    ZP = 1;
    function e(t, r) {
      return function(n) {
        return t(r(n));
      };
    }
    return FB = e, FB;
  }
  var NB, zP;
  function Do2() {
    if (zP) return NB;
    zP = 1;
    var e = DW(), t = e(Object.keys, Object);
    return NB = t, NB;
  }
  var HB, UP;
  function Lo2() {
    if (UP) return HB;
    UP = 1;
    var e = To2(), t = Do2(), r = Object.prototype, n = r.hasOwnProperty;
    function i(o) {
      if (!e(o))
        return t(o);
      var u = [];
      for (var c in Object(o))
        n.call(o, c) && c != "constructor" && u.push(c);
      return u;
    }
    return HB = i, HB;
  }
  var jB, qP;
  function lA() {
    if (qP) return jB;
    qP = 1;
    var e = JS(), t = gM();
    function r(n) {
      return n != null && t(n.length) && !e(n);
    }
    return jB = r, jB;
  }
  var VB, WP;
  function wh() {
    if (WP) return VB;
    WP = 1;
    var e = Oo2(), t = Lo2(), r = lA();
    function n(i) {
      return r(i) ? e(i) : t(i);
    }
    return VB = n, VB;
  }
  var ZB, YP;
  function ko2() {
    if (YP) return ZB;
    YP = 1;
    var e = Io2(), t = xo2(), r = wh();
    function n(i) {
      return e(i, r, t);
    }
    return ZB = n, ZB;
  }
  var zB, $P;
  function Ro2() {
    if ($P) return zB;
    $P = 1;
    var e = ko2(), t = 1, r = Object.prototype, n = r.hasOwnProperty;
    function i(o, u, c, f, d, g) {
      var h = c & t, E = e(o), y = E.length, I = e(u), Q = I.length;
      if (y != Q && !h)
        return !1;
      for (var B = y; B--; ) {
        var _ = E[B];
        if (!(h ? _ in u : n.call(u, _)))
          return !1;
      }
      var M = g.get(o), S = g.get(u);
      if (M && S)
        return M == u && S == o;
      var O = !0;
      g.set(o, u), g.set(u, o);
      for (var w = h; ++B < y; ) {
        _ = E[B];
        var D = o[_], k = u[_];
        if (f)
          var F = h ? f(k, D, _, u, o, g) : f(D, k, _, o, u, g);
        if (!(F === void 0 ? D === k || d(D, k, c, f, g) : F)) {
          O = !1;
          break;
        }
        w || (w = _ == "constructor");
      }
      if (O && !w) {
        var z = o.constructor, Z = u.constructor;
        z != Z && "constructor" in o && "constructor" in u && !(typeof z == "function" && z instanceof z && typeof Z == "function" && Z instanceof Z) && (O = !1);
      }
      return g.delete(o), g.delete(u), O;
    }
    return zB = i, zB;
  }
  var UB, GP;
  function Po2() {
    if (GP) return UB;
    GP = 1;
    var e = Xi(), t = h3(), r = e(t, "DataView");
    return UB = r, UB;
  }
  var qB, KP;
  function Fo2() {
    if (KP) return qB;
    KP = 1;
    var e = Xi(), t = h3(), r = e(t, "Promise");
    return qB = r, qB;
  }
  var WB, XP;
  function LW() {
    if (XP) return WB;
    XP = 1;
    var e = Xi(), t = h3(), r = e(t, "Set");
    return WB = r, WB;
  }
  var YB, JP;
  function No2() {
    if (JP) return YB;
    JP = 1;
    var e = Xi(), t = h3(), r = e(t, "WeakMap");
    return YB = r, YB;
  }
  var $B, eF;
  function Ho2() {
    if (eF) return $B;
    eF = 1;
    var e = Po2(), t = tM(), r = Fo2(), n = LW(), i = No2(), o = M8(), u = Xq(), c = "[object Map]", f = "[object Object]", d = "[object Promise]", g = "[object Set]", h = "[object WeakMap]", E = "[object DataView]", y = u(e), I = u(t), Q = u(r), B = u(n), _ = u(i), M = o;
    return (e && M(new e(new ArrayBuffer(1))) != E || t && M(new t()) != c || r && M(r.resolve()) != d || n && M(new n()) != g || i && M(new i()) != h) && (M = function(S) {
      var O = o(S), w = O == f ? S.constructor : void 0, D = w ? u(w) : "";
      if (D)
        switch (D) {
          case y:
            return E;
          case I:
            return c;
          case Q:
            return d;
          case B:
            return g;
          case _:
            return h;
        }
      return O;
    }), $B = M, $B;
  }
  var GB, tF;
  function jo2() {
    if (tF) return GB;
    tF = 1;
    var e = QW(), t = SW(), r = yo2(), n = Ro2(), i = Ho2(), o = Ir(), u = _W(), c = TW(), f = 1, d = "[object Arguments]", g = "[object Array]", h = "[object Object]", E = Object.prototype, y = E.hasOwnProperty;
    function I(Q, B, _, M, S, O) {
      var w = o(Q), D = o(B), k = w ? g : i(Q), F = D ? g : i(B);
      k = k == d ? h : k, F = F == d ? h : F;
      var z = k == h, Z = F == h, V = k == F;
      if (V && u(Q)) {
        if (!u(B))
          return !1;
        w = !0, z = !1;
      }
      if (V && !z)
        return O || (O = new e()), w || c(Q) ? t(Q, B, _, M, S, O) : r(Q, B, k, _, M, S, O);
      if (!(_ & f)) {
        var $ = z && y.call(Q, "__wrapped__"), W = Z && y.call(B, "__wrapped__");
        if ($ || W) {
          var t2 = $ ? Q.value() : Q, n2 = W ? B.value() : B;
          return O || (O = new e()), S(t2, n2, _, M, O);
        }
      }
      return V ? (O || (O = new e()), n(Q, B, _, M, S, O)) : !1;
    }
    return GB = I, GB;
  }
  var KB, rF;
  function pM() {
    if (rF) return KB;
    rF = 1;
    var e = jo2(), t = _8();
    function r(n, i, o, u, c) {
      return n === i ? !0 : n == null || i == null || !t(n) && !t(i) ? n !== n && i !== i : e(n, i, o, u, r, c);
    }
    return KB = r, KB;
  }
  var XB, nF;
  function Vo2() {
    if (nF) return XB;
    nF = 1;
    var e = QW(), t = pM(), r = 1, n = 2;
    function i(o, u, c, f) {
      var d = c.length, g = d, h = !f;
      if (o == null)
        return !g;
      for (o = Object(o); d--; ) {
        var E = c[d];
        if (h && E[2] ? E[1] !== o[E[0]] : !(E[0] in o))
          return !1;
      }
      for (; ++d < g; ) {
        E = c[d];
        var y = E[0], I = o[y], Q = E[1];
        if (h && E[2]) {
          if (I === void 0 && !(y in o))
            return !1;
        } else {
          var B = new e();
          if (f)
            var _ = f(I, Q, y, o, u, B);
          if (!(_ === void 0 ? t(Q, I, r | n, f, B) : _))
            return !1;
        }
      }
      return !0;
    }
    return XB = i, XB;
  }
  var JB, iF;
  function kW() {
    if (iF) return JB;
    iF = 1;
    var e = K6();
    function t(r) {
      return r === r && !e(r);
    }
    return JB = t, JB;
  }
  var eQ, aF;
  function Zo2() {
    if (aF) return eQ;
    aF = 1;
    var e = kW(), t = wh();
    function r(n) {
      for (var i = t(n), o = i.length; o--; ) {
        var u = i[o], c = n[u];
        i[o] = [u, c, e(c)];
      }
      return i;
    }
    return eQ = r, eQ;
  }
  var tQ, oF;
  function RW() {
    if (oF) return tQ;
    oF = 1;
    function e(t, r) {
      return function(n) {
        return n == null ? !1 : n[t] === r && (r !== void 0 || t in Object(n));
      };
    }
    return tQ = e, tQ;
  }
  var rQ, sF;
  function zo2() {
    if (sF) return rQ;
    sF = 1;
    var e = Vo2(), t = Zo2(), r = RW();
    function n(i) {
      var o = t(i);
      return o.length == 1 && o[0][2] ? r(o[0][0], o[0][1]) : function(u) {
        return u === i || e(u, i, o);
      };
    }
    return rQ = n, rQ;
  }
  var nQ, uF;
  function Uo2() {
    if (uF) return nQ;
    uF = 1;
    function e(t, r) {
      return t != null && r in Object(t);
    }
    return nQ = e, nQ;
  }
  var iQ, lF;
  function qo2() {
    if (lF) return iQ;
    lF = 1;
    var e = tW(), t = CM(), r = Ir(), n = dM(), i = gM(), o = Ih();
    function u(c, f, d) {
      f = e(f, c);
      for (var g = -1, h = f.length, E = !1; ++g < h; ) {
        var y = o(f[g]);
        if (!(E = c != null && d(c, y)))
          break;
        c = c[y];
      }
      return E || ++g != h ? E : (h = c == null ? 0 : c.length, !!h && i(h) && n(y, h) && (r(c) || t(c)));
    }
    return iQ = u, iQ;
  }
  var aQ, cF;
  function Wo2() {
    if (cF) return aQ;
    cF = 1;
    var e = Uo2(), t = qo2();
    function r(n, i) {
      return n != null && t(n, i, e);
    }
    return aQ = r, aQ;
  }
  var oQ, AF;
  function Yo2() {
    if (AF) return oQ;
    AF = 1;
    var e = pM(), t = rW(), r = Wo2(), n = XS(), i = kW(), o = RW(), u = Ih(), c = 1, f = 2;
    function d(g, h) {
      return n(g) && i(h) ? o(u(g), h) : function(E) {
        var y = t(E, g);
        return y === void 0 && y === h ? r(E, g) : e(h, y, c | f);
      };
    }
    return oQ = d, oQ;
  }
  var sQ, fF;
  function cs() {
    if (fF) return sQ;
    fF = 1;
    function e(t) {
      return t;
    }
    return sQ = e, sQ;
  }
  var uQ, CF;
  function $o2() {
    if (CF) return uQ;
    CF = 1;
    function e(t) {
      return function(r) {
        return r == null ? void 0 : r[t];
      };
    }
    return uQ = e, uQ;
  }
  var lQ, dF;
  function Go2() {
    if (dF) return lQ;
    dF = 1;
    var e = iM();
    function t(r) {
      return function(n) {
        return e(n, r);
      };
    }
    return lQ = t, lQ;
  }
  var cQ, gF;
  function Ko2() {
    if (gF) return cQ;
    gF = 1;
    var e = $o2(), t = Go2(), r = XS(), n = Ih();
    function i(o) {
      return r(o) ? e(n(o)) : t(o);
    }
    return cQ = i, cQ;
  }
  var AQ, pF;
  function X6() {
    if (pF) return AQ;
    pF = 1;
    var e = zo2(), t = Yo2(), r = cs(), n = Ir(), i = Ko2();
    function o(u) {
      return typeof u == "function" ? u : u == null ? r : typeof u == "object" ? n(u) ? t(u[0], u[1]) : e(u) : i(u);
    }
    return AQ = o, AQ;
  }
  var fQ, hF;
  function PW() {
    if (hF) return fQ;
    hF = 1;
    function e(t, r, n, i) {
      for (var o = t.length, u = n + (i ? 1 : -1); i ? u-- : ++u < o; )
        if (r(t[u], u, t))
          return u;
      return -1;
    }
    return fQ = e, fQ;
  }
  var CQ, vF;
  function Xo2() {
    if (vF) return CQ;
    vF = 1;
    function e(t) {
      return t !== t;
    }
    return CQ = e, CQ;
  }
  var dQ, EF;
  function Jo2() {
    if (EF) return dQ;
    EF = 1;
    function e(t, r, n) {
      for (var i = n - 1, o = t.length; ++i < o; )
        if (t[i] === r)
          return i;
      return -1;
    }
    return dQ = e, dQ;
  }
  var gQ, mF;
  function e92() {
    if (mF) return gQ;
    mF = 1;
    var e = PW(), t = Xo2(), r = Jo2();
    function n(i, o, u) {
      return o === o ? r(i, o, u) : e(i, t, u);
    }
    return gQ = n, gQ;
  }
  var pQ, yF;
  function t92() {
    if (yF) return pQ;
    yF = 1;
    var e = e92();
    function t(r, n) {
      var i = r == null ? 0 : r.length;
      return !!i && e(r, n, 0) > -1;
    }
    return pQ = t, pQ;
  }
  var hQ, IF;
  function r92() {
    if (IF) return hQ;
    IF = 1;
    function e(t, r, n) {
      for (var i = -1, o = t == null ? 0 : t.length; ++i < o; )
        if (n(r, t[i]))
          return !0;
      return !1;
    }
    return hQ = e, hQ;
  }
  var vQ, BF;
  function n92() {
    if (BF) return vQ;
    BF = 1;
    function e() {
    }
    return vQ = e, vQ;
  }
  var EQ, QF;
  function i92() {
    if (QF) return EQ;
    QF = 1;
    var e = LW(), t = n92(), r = fM(), n = 1 / 0, i = e && 1 / r(new e([, -0]))[1] == n ? function(o) {
      return new e(o);
    } : t;
    return EQ = i, EQ;
  }
  var mQ, xF;
  function a92() {
    if (xF) return mQ;
    xF = 1;
    var e = xW(), t = t92(), r = r92(), n = wW(), i = i92(), o = fM(), u = 200;
    function c(f, d, g) {
      var h = -1, E = t, y = f.length, I = !0, Q = [], B = Q;
      if (g)
        I = !1, E = r;
      else if (y >= u) {
        var _ = d ? null : i(f);
        if (_)
          return o(_);
        I = !1, E = n, B = new e();
      } else
        B = d ? [] : Q;
      e:
        for (; ++h < y; ) {
          var M = f[h], S = d ? d(M) : M;
          if (M = g || M !== 0 ? M : 0, I && S === S) {
            for (var O = B.length; O--; )
              if (B[O] === S)
                continue e;
            d && B.push(S), Q.push(M);
          } else E(B, S, g) || (B !== Q && B.push(S), Q.push(M));
        }
      return Q;
    }
    return mQ = c, mQ;
  }
  var yQ, bF;
  function o92() {
    if (bF) return yQ;
    bF = 1;
    var e = X6(), t = a92();
    function r(n, i) {
      return n && n.length ? t(n, e(i, 2)) : [];
    }
    return yQ = r, yQ;
  }
  var s92 = o92();
  const wF = /* @__PURE__ */ tt(s92);
  function FW(e, t, r) {
    return t === !0 ? wF(e, r) : te(t) ? wF(e, t) : e;
  }
  function M9(e) {
    "@babel/helpers - typeof";
    return M9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, M9(e);
  }
  var u92 = ["ref"];
  function SF(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function A8(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? SF(Object(r), !0).forEach(function(n) {
        Sh(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : SF(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function l92(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function MF(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, HW(n.key), n);
    }
  }
  function c92(e, t, r) {
    return t && MF(e.prototype, t), r && MF(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function A92(e, t, r) {
    return t = ap(t), f92(e, NW() ? Reflect.construct(t, r || [], ap(e).constructor) : t.apply(e, r));
  }
  function f92(e, t) {
    if (t && (M9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return C92(e);
  }
  function C92(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function NW() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (NW = function() {
      return !!e;
    })();
  }
  function ap(e) {
    return ap = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, ap(e);
  }
  function d92(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && qb(e, t);
  }
  function qb(e, t) {
    return qb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, qb(e, t);
  }
  function Sh(e, t, r) {
    return t = HW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function HW(e) {
    var t = g92(e, "string");
    return M9(t) == "symbol" ? t : t + "";
  }
  function g92(e, t) {
    if (M9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (M9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function p92(e, t) {
    if (e == null) return {};
    var r = h92(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function h92(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function v92(e) {
    return e.value;
  }
  function E92(e, t) {
    if (/* @__PURE__ */ f2.isValidElement(e))
      return /* @__PURE__ */ f2.cloneElement(e, t);
    if (typeof e == "function")
      return /* @__PURE__ */ f2.createElement(e, t);
    t.ref;
    var r = p92(t, u92);
    return /* @__PURE__ */ f2.createElement(AM, r);
  }
  var _F = 1, v9 = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      l92(this, t);
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      return r = A92(this, t, [].concat(i)), Sh(r, "lastBoundingBox", {
        width: -1,
        height: -1
      }), r;
    }
    return d92(t, e), c92(t, [{
      key: "componentDidMount",
      value: function() {
        this.updateBBox();
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        this.updateBBox();
      }
    }, {
      key: "getBBox",
      value: function() {
        if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
          var n = this.wrapperNode.getBoundingClientRect();
          return n.height = this.wrapperNode.offsetHeight, n.width = this.wrapperNode.offsetWidth, n;
        }
        return null;
      }
    }, {
      key: "updateBBox",
      value: function() {
        var n = this.props.onBBoxUpdate, i = this.getBBox();
        i ? (Math.abs(i.width - this.lastBoundingBox.width) > _F || Math.abs(i.height - this.lastBoundingBox.height) > _F) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, n && n(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, n && n(null));
      }
    }, {
      key: "getBBoxSnapshot",
      value: function() {
        return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? A8({}, this.lastBoundingBox) : {
          width: 0,
          height: 0
        };
      }
    }, {
      key: "getDefaultPosition",
      value: function(n) {
        var i = this.props, o = i.layout, u = i.align, c = i.verticalAlign, f = i.margin, d = i.chartWidth, g = i.chartHeight, h, E;
        if (!n || (n.left === void 0 || n.left === null) && (n.right === void 0 || n.right === null))
          if (u === "center" && o === "vertical") {
            var y = this.getBBoxSnapshot();
            h = {
              left: ((d || 0) - y.width) / 2
            };
          } else
            h = u === "right" ? {
              right: f && f.right || 0
            } : {
              left: f && f.left || 0
            };
        if (!n || (n.top === void 0 || n.top === null) && (n.bottom === void 0 || n.bottom === null))
          if (c === "middle") {
            var I = this.getBBoxSnapshot();
            E = {
              top: ((g || 0) - I.height) / 2
            };
          } else
            E = c === "bottom" ? {
              bottom: f && f.bottom || 0
            } : {
              top: f && f.top || 0
            };
        return A8(A8({}, h), E);
      }
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, o = i.content, u = i.width, c = i.height, f = i.wrapperStyle, d = i.payloadUniqBy, g = i.payload, h = A8(A8({
          position: "absolute",
          width: u || "auto",
          height: c || "auto"
        }, this.getDefaultPosition(f)), f);
        return /* @__PURE__ */ f2.createElement("div", {
          className: "recharts-legend-wrapper",
          style: h,
          ref: function(y) {
            n.wrapperNode = y;
          }
        }, E92(o, A8(A8({}, this.props), {}, {
          payload: FW(g, d, v92)
        })));
      }
    }], [{
      key: "getWithHeight",
      value: function(n, i) {
        var o = A8(A8({}, this.defaultProps), n.props), u = o.layout;
        return u === "vertical" && G2(n.props.height) ? {
          height: n.props.height
        } : u === "horizontal" ? {
          width: n.props.width || i
        } : null;
      }
    }]);
  }(q.PureComponent);
  Sh(v9, "displayName", "Legend");
  Sh(v9, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
  });
  var IQ, OF;
  function m92() {
    if (OF) return IQ;
    OF = 1;
    var e = oA(), t = CM(), r = Ir(), n = e ? e.isConcatSpreadable : void 0;
    function i(o) {
      return r(o) || t(o) || !!(n && o && o[n]);
    }
    return IQ = i, IQ;
  }
  var BQ, TF;
  function jW() {
    if (TF) return BQ;
    TF = 1;
    var e = MW(), t = m92();
    function r(n, i, o, u, c) {
      var f = -1, d = n.length;
      for (o || (o = t), c || (c = []); ++f < d; ) {
        var g = n[f];
        i > 0 && o(g) ? i > 1 ? r(g, i - 1, o, u, c) : e(c, g) : u || (c[c.length] = g);
      }
      return c;
    }
    return BQ = r, BQ;
  }
  var QQ, DF;
  function y92() {
    if (DF) return QQ;
    DF = 1;
    function e(t) {
      return function(r, n, i) {
        for (var o = -1, u = Object(r), c = i(r), f = c.length; f--; ) {
          var d = c[t ? f : ++o];
          if (n(u[d], d, u) === !1)
            break;
        }
        return r;
      };
    }
    return QQ = e, QQ;
  }
  var xQ, LF;
  function I92() {
    if (LF) return xQ;
    LF = 1;
    var e = y92(), t = e();
    return xQ = t, xQ;
  }
  var bQ, kF;
  function VW() {
    if (kF) return bQ;
    kF = 1;
    var e = I92(), t = wh();
    function r(n, i) {
      return n && e(n, i, t);
    }
    return bQ = r, bQ;
  }
  var wQ, RF;
  function B92() {
    if (RF) return wQ;
    RF = 1;
    var e = lA();
    function t(r, n) {
      return function(i, o) {
        if (i == null)
          return i;
        if (!e(i))
          return r(i, o);
        for (var u = i.length, c = n ? u : -1, f = Object(i); (n ? c-- : ++c < u) && o(f[c], c, f) !== !1; )
          ;
        return i;
      };
    }
    return wQ = t, wQ;
  }
  var SQ, PF;
  function hM() {
    if (PF) return SQ;
    PF = 1;
    var e = VW(), t = B92(), r = t(e);
    return SQ = r, SQ;
  }
  var MQ, FF;
  function ZW() {
    if (FF) return MQ;
    FF = 1;
    var e = hM(), t = lA();
    function r(n, i) {
      var o = -1, u = t(n) ? Array(n.length) : [];
      return e(n, function(c, f, d) {
        u[++o] = i(c, f, d);
      }), u;
    }
    return MQ = r, MQ;
  }
  var _Q, NF;
  function Q92() {
    if (NF) return _Q;
    NF = 1;
    function e(t, r) {
      var n = t.length;
      for (t.sort(r); n--; )
        t[n] = t[n].value;
      return t;
    }
    return _Q = e, _Q;
  }
  var OQ, HF;
  function x92() {
    if (HF) return OQ;
    HF = 1;
    var e = us();
    function t(r, n) {
      if (r !== n) {
        var i = r !== void 0, o = r === null, u = r === r, c = e(r), f = n !== void 0, d = n === null, g = n === n, h = e(n);
        if (!d && !h && !c && r > n || c && f && g && !d && !h || o && f && g || !i && g || !u)
          return 1;
        if (!o && !c && !h && r < n || h && i && u && !o && !c || d && i && u || !f && u || !g)
          return -1;
      }
      return 0;
    }
    return OQ = t, OQ;
  }
  var TQ, jF;
  function b92() {
    if (jF) return TQ;
    jF = 1;
    var e = x92();
    function t(r, n, i) {
      for (var o = -1, u = r.criteria, c = n.criteria, f = u.length, d = i.length; ++o < f; ) {
        var g = e(u[o], c[o]);
        if (g) {
          if (o >= d)
            return g;
          var h = i[o];
          return g * (h == "desc" ? -1 : 1);
        }
      }
      return r.index - n.index;
    }
    return TQ = t, TQ;
  }
  var DQ, VF;
  function w92() {
    if (VF) return DQ;
    VF = 1;
    var e = nM(), t = iM(), r = X6(), n = ZW(), i = Q92(), o = OW(), u = b92(), c = cs(), f = Ir();
    function d(g, h, E) {
      h.length ? h = e(h, function(Q) {
        return f(Q) ? function(B) {
          return t(B, Q.length === 1 ? Q[0] : Q);
        } : Q;
      }) : h = [c];
      var y = -1;
      h = e(h, o(r));
      var I = n(g, function(Q, B, _) {
        var M = e(h, function(S) {
          return S(Q);
        });
        return { criteria: M, index: ++y, value: Q };
      });
      return i(I, function(Q, B) {
        return u(Q, B, E);
      });
    }
    return DQ = d, DQ;
  }
  var LQ, ZF;
  function S92() {
    if (ZF) return LQ;
    ZF = 1;
    function e(t, r, n) {
      switch (n.length) {
        case 0:
          return t.call(r);
        case 1:
          return t.call(r, n[0]);
        case 2:
          return t.call(r, n[0], n[1]);
        case 3:
          return t.call(r, n[0], n[1], n[2]);
      }
      return t.apply(r, n);
    }
    return LQ = e, LQ;
  }
  var kQ, zF;
  function M92() {
    if (zF) return kQ;
    zF = 1;
    var e = S92(), t = Math.max;
    function r(n, i, o) {
      return i = t(i === void 0 ? n.length - 1 : i, 0), function() {
        for (var u = arguments, c = -1, f = t(u.length - i, 0), d = Array(f); ++c < f; )
          d[c] = u[i + c];
        c = -1;
        for (var g = Array(i + 1); ++c < i; )
          g[c] = u[c];
        return g[i] = o(d), e(n, this, g);
      };
    }
    return kQ = r, kQ;
  }
  var RQ, UF;
  function _92() {
    if (UF) return RQ;
    UF = 1;
    function e(t) {
      return function() {
        return t;
      };
    }
    return RQ = e, RQ;
  }
  var PQ, qF;
  function zW() {
    if (qF) return PQ;
    qF = 1;
    var e = Xi(), t = function() {
      try {
        var r = e(Object, "defineProperty");
        return r({}, "", {}), r;
      } catch {
      }
    }();
    return PQ = t, PQ;
  }
  var FQ, WF;
  function O92() {
    if (WF) return FQ;
    WF = 1;
    var e = _92(), t = zW(), r = cs(), n = t ? function(i, o) {
      return t(i, "toString", {
        configurable: !0,
        enumerable: !1,
        value: e(o),
        writable: !0
      });
    } : r;
    return FQ = n, FQ;
  }
  var NQ, YF;
  function T92() {
    if (YF) return NQ;
    YF = 1;
    var e = 800, t = 16, r = Date.now;
    function n(i) {
      var o = 0, u = 0;
      return function() {
        var c = r(), f = t - (c - u);
        if (u = c, f > 0) {
          if (++o >= e)
            return arguments[0];
        } else
          o = 0;
        return i.apply(void 0, arguments);
      };
    }
    return NQ = n, NQ;
  }
  var HQ, $F;
  function D92() {
    if ($F) return HQ;
    $F = 1;
    var e = O92(), t = T92(), r = t(e);
    return HQ = r, HQ;
  }
  var jQ, GF;
  function L92() {
    if (GF) return jQ;
    GF = 1;
    var e = cs(), t = M92(), r = D92();
    function n(i, o) {
      return r(t(i, o, e), i + "");
    }
    return jQ = n, jQ;
  }
  var VQ, KF;
  function Mh() {
    if (KF) return VQ;
    KF = 1;
    var e = eM(), t = lA(), r = dM(), n = K6();
    function i(o, u, c) {
      if (!n(c))
        return !1;
      var f = typeof u;
      return (f == "number" ? t(c) && r(u, c.length) : f == "string" && u in c) ? e(c[u], o) : !1;
    }
    return VQ = i, VQ;
  }
  var ZQ, XF;
  function k92() {
    if (XF) return ZQ;
    XF = 1;
    var e = jW(), t = w92(), r = L92(), n = Mh(), i = r(function(o, u) {
      if (o == null)
        return [];
      var c = u.length;
      return c > 1 && n(o, u[0], u[1]) ? u = [] : c > 2 && n(u[0], u[1], u[2]) && (u = [u[0]]), t(o, e(u, 1), []);
    });
    return ZQ = i, ZQ;
  }
  var R92 = k92();
  const vM = /* @__PURE__ */ tt(R92);
  function mc(e) {
    "@babel/helpers - typeof";
    return mc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, mc(e);
  }
  function Wb() {
    return Wb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Wb.apply(this, arguments);
  }
  function P92(e, t) {
    return j92(e) || H92(e, t) || N92(e, t) || F92();
  }
  function F92() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function N92(e, t) {
    if (e) {
      if (typeof e == "string") return JF(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return JF(e, t);
    }
  }
  function JF(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function H92(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function j92(e) {
    if (Array.isArray(e)) return e;
  }
  function eN(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function zQ(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? eN(Object(r), !0).forEach(function(n) {
        V92(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eN(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function V92(e, t, r) {
    return t = Z92(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Z92(e) {
    var t = z92(e, "string");
    return mc(t) == "symbol" ? t : t + "";
  }
  function z92(e, t) {
    if (mc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (mc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function U92(e) {
    return Array.isArray(e) && T5(e[0]) && T5(e[1]) ? e.join(" ~ ") : e;
  }
  var q92 = function(t) {
    var r = t.separator, n = r === void 0 ? " : " : r, i = t.contentStyle, o = i === void 0 ? {} : i, u = t.itemStyle, c = u === void 0 ? {} : u, f = t.labelStyle, d = f === void 0 ? {} : f, g = t.payload, h = t.formatter, E = t.itemSorter, y = t.wrapperClassName, I = t.labelClassName, Q = t.label, B = t.labelFormatter, _ = t.accessibilityLayer, M = _ === void 0 ? !1 : _, S = function() {
      if (g && g.length) {
        var $ = {
          padding: 0,
          margin: 0
        }, W = (E ? vM(g, E) : g).map(function(t2, n2) {
          if (t2.type === "none")
            return null;
          var s2 = zQ({
            display: "block",
            paddingTop: 4,
            paddingBottom: 4,
            color: t2.color || "#000"
          }, c), l2 = t2.formatter || h || U92, X = t2.value, a2 = t2.name, e2 = X, H = a2;
          if (l2 && e2 != null && H != null) {
            var Y = l2(X, a2, t2, n2, g);
            if (Array.isArray(Y)) {
              var r2 = P92(Y, 2);
              e2 = r2[0], H = r2[1];
            } else
              e2 = Y;
          }
          return (
            // eslint-disable-next-line react/no-array-index-key
            /* @__PURE__ */ f2.createElement("li", {
              className: "recharts-tooltip-item",
              key: "tooltip-item-".concat(n2),
              style: s2
            }, T5(H) ? /* @__PURE__ */ f2.createElement("span", {
              className: "recharts-tooltip-item-name"
            }, H) : null, T5(H) ? /* @__PURE__ */ f2.createElement("span", {
              className: "recharts-tooltip-item-separator"
            }, n) : null, /* @__PURE__ */ f2.createElement("span", {
              className: "recharts-tooltip-item-value"
            }, e2), /* @__PURE__ */ f2.createElement("span", {
              className: "recharts-tooltip-item-unit"
            }, t2.unit || ""))
          );
        });
        return /* @__PURE__ */ f2.createElement("ul", {
          className: "recharts-tooltip-item-list",
          style: $
        }, W);
      }
      return null;
    }, O = zQ({
      margin: 0,
      padding: 10,
      backgroundColor: "#fff",
      border: "1px solid #ccc",
      whiteSpace: "nowrap"
    }, o), w = zQ({
      margin: 0
    }, d), D = !Ae(Q), k = D ? Q : "", F = pe("recharts-default-tooltip", y), z = pe("recharts-tooltip-label", I);
    D && B && g !== void 0 && g !== null && (k = B(Q, g));
    var Z = M ? {
      role: "status",
      "aria-live": "assertive"
    } : {};
    return /* @__PURE__ */ f2.createElement("div", Wb({
      className: F,
      style: O
    }, Z), /* @__PURE__ */ f2.createElement("p", {
      className: z,
      style: w
    }, /* @__PURE__ */ f2.isValidElement(k) ? k : "".concat(k)), S());
  };
  function yc(e) {
    "@babel/helpers - typeof";
    return yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, yc(e);
  }
  function Md(e, t, r) {
    return t = W92(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function W92(e) {
    var t = Y92(e, "string");
    return yc(t) == "symbol" ? t : t + "";
  }
  function Y92(e, t) {
    if (yc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (yc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Tl = "recharts-tooltip-wrapper", $92 = {
    visibility: "hidden"
  };
  function G92(e) {
    var t = e.coordinate, r = e.translateX, n = e.translateY;
    return pe(Tl, Md(Md(Md(Md({}, "".concat(Tl, "-right"), G2(r) && t && G2(t.x) && r >= t.x), "".concat(Tl, "-left"), G2(r) && t && G2(t.x) && r < t.x), "".concat(Tl, "-bottom"), G2(n) && t && G2(t.y) && n >= t.y), "".concat(Tl, "-top"), G2(n) && t && G2(t.y) && n < t.y));
  }
  function tN(e) {
    var t = e.allowEscapeViewBox, r = e.coordinate, n = e.key, i = e.offsetTopLeft, o = e.position, u = e.reverseDirection, c = e.tooltipDimension, f = e.viewBox, d = e.viewBoxDimension;
    if (o && G2(o[n]))
      return o[n];
    var g = r[n] - c - i, h = r[n] + i;
    if (t[n])
      return u[n] ? g : h;
    if (u[n]) {
      var E = g, y = f[n];
      return E < y ? Math.max(h, f[n]) : Math.max(g, f[n]);
    }
    var I = h + c, Q = f[n] + d;
    return I > Q ? Math.max(g, f[n]) : Math.max(h, f[n]);
  }
  function K92(e) {
    var t = e.translateX, r = e.translateY, n = e.useTranslate3d;
    return {
      transform: n ? "translate3d(".concat(t, "px, ").concat(r, "px, 0)") : "translate(".concat(t, "px, ").concat(r, "px)")
    };
  }
  function X92(e) {
    var t = e.allowEscapeViewBox, r = e.coordinate, n = e.offsetTopLeft, i = e.position, o = e.reverseDirection, u = e.tooltipBox, c = e.useTranslate3d, f = e.viewBox, d, g, h;
    return u.height > 0 && u.width > 0 && r ? (g = tN({
      allowEscapeViewBox: t,
      coordinate: r,
      key: "x",
      offsetTopLeft: n,
      position: i,
      reverseDirection: o,
      tooltipDimension: u.width,
      viewBox: f,
      viewBoxDimension: f.width
    }), h = tN({
      allowEscapeViewBox: t,
      coordinate: r,
      key: "y",
      offsetTopLeft: n,
      position: i,
      reverseDirection: o,
      tooltipDimension: u.height,
      viewBox: f,
      viewBoxDimension: f.height
    }), d = K92({
      translateX: g,
      translateY: h,
      useTranslate3d: c
    })) : d = $92, {
      cssProperties: d,
      cssClasses: G92({
        translateX: g,
        translateY: h,
        coordinate: r
      })
    };
  }
  function _9(e) {
    "@babel/helpers - typeof";
    return _9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, _9(e);
  }
  function rN(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function nN(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? rN(Object(r), !0).forEach(function(n) {
        $b(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : rN(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function J92(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function es2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, qW(n.key), n);
    }
  }
  function ts2(e, t, r) {
    return t && es2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function rs2(e, t, r) {
    return t = op(t), ns2(e, UW() ? Reflect.construct(t, r || [], op(e).constructor) : t.apply(e, r));
  }
  function ns2(e, t) {
    if (t && (_9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return is2(e);
  }
  function is2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function UW() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (UW = function() {
      return !!e;
    })();
  }
  function op(e) {
    return op = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, op(e);
  }
  function as2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yb(e, t);
  }
  function Yb(e, t) {
    return Yb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Yb(e, t);
  }
  function $b(e, t, r) {
    return t = qW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function qW(e) {
    var t = os2(e, "string");
    return _9(t) == "symbol" ? t : t + "";
  }
  function os2(e, t) {
    if (_9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (_9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var iN = 1, ss2 = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      J92(this, t);
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      return r = rs2(this, t, [].concat(i)), $b(r, "state", {
        dismissed: !1,
        dismissedAtCoordinate: {
          x: 0,
          y: 0
        },
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      }), $b(r, "handleKeyDown", function(u) {
        if (u.key === "Escape") {
          var c, f, d, g;
          r.setState({
            dismissed: !0,
            dismissedAtCoordinate: {
              x: (c = (f = r.props.coordinate) === null || f === void 0 ? void 0 : f.x) !== null && c !== void 0 ? c : 0,
              y: (d = (g = r.props.coordinate) === null || g === void 0 ? void 0 : g.y) !== null && d !== void 0 ? d : 0
            }
          });
        }
      }), r;
    }
    return as2(t, e), ts2(t, [{
      key: "updateBBox",
      value: function() {
        if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
          var n = this.wrapperNode.getBoundingClientRect();
          (Math.abs(n.width - this.state.lastBoundingBox.width) > iN || Math.abs(n.height - this.state.lastBoundingBox.height) > iN) && this.setState({
            lastBoundingBox: {
              width: n.width,
              height: n.height
            }
          });
        } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
          lastBoundingBox: {
            width: -1,
            height: -1
          }
        });
      }
    }, {
      key: "componentDidMount",
      value: function() {
        document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        document.removeEventListener("keydown", this.handleKeyDown);
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        var n, i;
        this.props.active && this.updateBBox(), this.state.dismissed && (((n = this.props.coordinate) === null || n === void 0 ? void 0 : n.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
      }
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, o = i.active, u = i.allowEscapeViewBox, c = i.animationDuration, f = i.animationEasing, d = i.children, g = i.coordinate, h = i.hasPayload, E = i.isAnimationActive, y = i.offset, I = i.position, Q = i.reverseDirection, B = i.useTranslate3d, _ = i.viewBox, M = i.wrapperStyle, S = X92({
          allowEscapeViewBox: u,
          coordinate: g,
          offsetTopLeft: y,
          position: I,
          reverseDirection: Q,
          tooltipBox: this.state.lastBoundingBox,
          useTranslate3d: B,
          viewBox: _
        }), O = S.cssClasses, w = S.cssProperties, D = nN(nN({
          transition: E && o ? "transform ".concat(c, "ms ").concat(f) : void 0
        }, w), {}, {
          pointerEvents: "none",
          visibility: !this.state.dismissed && o && h ? "visible" : "hidden",
          position: "absolute",
          top: 0,
          left: 0
        }, M);
        return (
          // This element allow listening to the `Escape` key.
          // See https://github.com/recharts/recharts/pull/2925
          /* @__PURE__ */ f2.createElement("div", {
            tabIndex: -1,
            className: O,
            style: D,
            ref: function(F) {
              n.wrapperNode = F;
            }
          }, d)
        );
      }
    }]);
  }(q.PureComponent), us2 = function() {
    return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
  }, As = {
    isSsr: us2()
  };
  function O9(e) {
    "@babel/helpers - typeof";
    return O9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, O9(e);
  }
  function aN(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function oN(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? aN(Object(r), !0).forEach(function(n) {
        EM(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : aN(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function ls2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function cs2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, YW(n.key), n);
    }
  }
  function As2(e, t, r) {
    return t && cs2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function fs2(e, t, r) {
    return t = sp(t), Cs2(e, WW() ? Reflect.construct(t, r || [], sp(e).constructor) : t.apply(e, r));
  }
  function Cs2(e, t) {
    if (t && (O9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return ds2(e);
  }
  function ds2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function WW() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (WW = function() {
      return !!e;
    })();
  }
  function sp(e) {
    return sp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, sp(e);
  }
  function gs2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Gb(e, t);
  }
  function Gb(e, t) {
    return Gb = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Gb(e, t);
  }
  function EM(e, t, r) {
    return t = YW(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function YW(e) {
    var t = ps2(e, "string");
    return O9(t) == "symbol" ? t : t + "";
  }
  function ps2(e, t) {
    if (O9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (O9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function hs2(e) {
    return e.dataKey;
  }
  function vs2(e, t) {
    return /* @__PURE__ */ f2.isValidElement(e) ? /* @__PURE__ */ f2.cloneElement(e, t) : typeof e == "function" ? /* @__PURE__ */ f2.createElement(e, t) : /* @__PURE__ */ f2.createElement(q92, t);
  }
  var cn = /* @__PURE__ */ function(e) {
    function t() {
      return ls2(this, t), fs2(this, t, arguments);
    }
    return gs2(t, e), As2(t, [{
      key: "render",
      value: function() {
        var n = this, i = this.props, o = i.active, u = i.allowEscapeViewBox, c = i.animationDuration, f = i.animationEasing, d = i.content, g = i.coordinate, h = i.filterNull, E = i.isAnimationActive, y = i.offset, I = i.payload, Q = i.payloadUniqBy, B = i.position, _ = i.reverseDirection, M = i.useTranslate3d, S = i.viewBox, O = i.wrapperStyle, w = I ?? [];
        h && w.length && (w = FW(I.filter(function(k) {
          return k.value != null && (k.hide !== !0 || n.props.includeHidden);
        }), Q, hs2));
        var D = w.length > 0;
        return /* @__PURE__ */ f2.createElement(ss2, {
          allowEscapeViewBox: u,
          animationDuration: c,
          animationEasing: f,
          isAnimationActive: E,
          active: o,
          coordinate: g,
          hasPayload: D,
          offset: y,
          position: B,
          reverseDirection: _,
          useTranslate3d: M,
          viewBox: S,
          wrapperStyle: O
        }, vs2(d, oN(oN({}, this.props), {}, {
          payload: w
        })));
      }
    }]);
  }(q.PureComponent);
  EM(cn, "displayName", "Tooltip");
  EM(cn, "defaultProps", {
    accessibilityLayer: !1,
    allowEscapeViewBox: {
      x: !1,
      y: !1
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
      x: 0,
      y: 0
    },
    cursor: !0,
    cursorStyle: {},
    filterNull: !0,
    isAnimationActive: !As.isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
      x: !1,
      y: !1
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: !1,
    viewBox: {
      x: 0,
      y: 0,
      height: 0,
      width: 0
    },
    wrapperStyle: {}
  });
  var UQ, sN;
  function Es2() {
    if (sN) return UQ;
    sN = 1;
    var e = h3(), t = function() {
      return e.Date.now();
    };
    return UQ = t, UQ;
  }
  var qQ, uN;
  function ms2() {
    if (uN) return qQ;
    uN = 1;
    var e = /\s/;
    function t(r) {
      for (var n = r.length; n-- && e.test(r.charAt(n)); )
        ;
      return n;
    }
    return qQ = t, qQ;
  }
  var WQ, lN;
  function ys2() {
    if (lN) return WQ;
    lN = 1;
    var e = ms2(), t = /^\s+/;
    function r(n) {
      return n && n.slice(0, e(n) + 1).replace(t, "");
    }
    return WQ = r, WQ;
  }
  var YQ, cN;
  function $W() {
    if (cN) return YQ;
    cN = 1;
    var e = ys2(), t = K6(), r = us(), n = NaN, i = /^[-+]0x[0-9a-f]+$/i, o = /^0b[01]+$/i, u = /^0o[0-7]+$/i, c = parseInt;
    function f(d) {
      if (typeof d == "number")
        return d;
      if (r(d))
        return n;
      if (t(d)) {
        var g = typeof d.valueOf == "function" ? d.valueOf() : d;
        d = t(g) ? g + "" : g;
      }
      if (typeof d != "string")
        return d === 0 ? d : +d;
      d = e(d);
      var h = o.test(d);
      return h || u.test(d) ? c(d.slice(2), h ? 2 : 8) : i.test(d) ? n : +d;
    }
    return YQ = f, YQ;
  }
  var $Q, AN;
  function Is2() {
    if (AN) return $Q;
    AN = 1;
    var e = K6(), t = Es2(), r = $W(), n = "Expected a function", i = Math.max, o = Math.min;
    function u(c, f, d) {
      var g, h, E, y, I, Q, B = 0, _ = !1, M = !1, S = !0;
      if (typeof c != "function")
        throw new TypeError(n);
      f = r(f) || 0, e(d) && (_ = !!d.leading, M = "maxWait" in d, E = M ? i(r(d.maxWait) || 0, f) : E, S = "trailing" in d ? !!d.trailing : S);
      function O(W) {
        var t2 = g, n2 = h;
        return g = h = void 0, B = W, y = c.apply(n2, t2), y;
      }
      function w(W) {
        return B = W, I = setTimeout(F, f), _ ? O(W) : y;
      }
      function D(W) {
        var t2 = W - Q, n2 = W - B, s2 = f - t2;
        return M ? o(s2, E - n2) : s2;
      }
      function k(W) {
        var t2 = W - Q, n2 = W - B;
        return Q === void 0 || t2 >= f || t2 < 0 || M && n2 >= E;
      }
      function F() {
        var W = t();
        if (k(W))
          return z(W);
        I = setTimeout(F, D(W));
      }
      function z(W) {
        return I = void 0, S && g ? O(W) : (g = h = void 0, y);
      }
      function Z() {
        I !== void 0 && clearTimeout(I), B = 0, g = Q = h = I = void 0;
      }
      function V() {
        return I === void 0 ? y : z(t());
      }
      function $() {
        var W = t(), t2 = k(W);
        if (g = arguments, h = this, Q = W, t2) {
          if (I === void 0)
            return w(Q);
          if (M)
            return clearTimeout(I), I = setTimeout(F, f), O(Q);
        }
        return I === void 0 && (I = setTimeout(F, f)), y;
      }
      return $.cancel = Z, $.flush = V, $;
    }
    return $Q = u, $Q;
  }
  var GQ, fN;
  function Bs2() {
    if (fN) return GQ;
    fN = 1;
    var e = Is2(), t = K6(), r = "Expected a function";
    function n(i, o, u) {
      var c = !0, f = !0;
      if (typeof i != "function")
        throw new TypeError(r);
      return t(u) && (c = "leading" in u ? !!u.leading : c, f = "trailing" in u ? !!u.trailing : f), e(i, o, {
        leading: c,
        maxWait: o,
        trailing: f
      });
    }
    return GQ = n, GQ;
  }
  var Qs2 = Bs2();
  const GW = /* @__PURE__ */ tt(Qs2);
  function Ic(e) {
    "@babel/helpers - typeof";
    return Ic = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Ic(e);
  }
  function CN(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function _d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? CN(Object(r), !0).forEach(function(n) {
        xs2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CN(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function xs2(e, t, r) {
    return t = bs2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function bs2(e) {
    var t = ws2(e, "string");
    return Ic(t) == "symbol" ? t : t + "";
  }
  function ws2(e, t) {
    if (Ic(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Ic(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ss2(e, t) {
    return Ts2(e) || Os2(e, t) || _s2(e, t) || Ms2();
  }
  function Ms2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function _s2(e, t) {
    if (e) {
      if (typeof e == "string") return dN(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dN(e, t);
    }
  }
  function dN(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Os2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function Ts2(e) {
    if (Array.isArray(e)) return e;
  }
  var Ds2 = /* @__PURE__ */ q.forwardRef(function(e, t) {
    var r = e.aspect, n = e.initialDimension, i = n === void 0 ? {
      width: -1,
      height: -1
    } : n, o = e.width, u = o === void 0 ? "100%" : o, c = e.height, f = c === void 0 ? "100%" : c, d = e.minWidth, g = d === void 0 ? 0 : d, h = e.minHeight, E = e.maxHeight, y = e.children, I = e.debounce, Q = I === void 0 ? 0 : I, B = e.id, _ = e.className, M = e.onResize, S = e.style, O = S === void 0 ? {} : S, w = q.useRef(null), D = q.useRef();
    D.current = M, q.useImperativeHandle(t, function() {
      return Object.defineProperty(w.current, "current", {
        get: function() {
          return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), w.current;
        },
        configurable: !0
      });
    });
    var k = q.useState({
      containerWidth: i.width,
      containerHeight: i.height
    }), F = Ss2(k, 2), z = F[0], Z = F[1], V = q.useCallback(function(W, t2) {
      Z(function(n2) {
        var s2 = Math.round(W), l2 = Math.round(t2);
        return n2.containerWidth === s2 && n2.containerHeight === l2 ? n2 : {
          containerWidth: s2,
          containerHeight: l2
        };
      });
    }, []);
    q.useEffect(function() {
      var W = function(a2) {
        var e2, H = a2[0].contentRect, Y = H.width, r2 = H.height;
        V(Y, r2), (e2 = D.current) === null || e2 === void 0 || e2.call(D, Y, r2);
      };
      Q > 0 && (W = GW(W, Q, {
        trailing: !0,
        leading: !1
      }));
      var t2 = new ResizeObserver(W), n2 = w.current.getBoundingClientRect(), s2 = n2.width, l2 = n2.height;
      return V(s2, l2), t2.observe(w.current), function() {
        t2.disconnect();
      };
    }, [V, Q]);
    var $ = q.useMemo(function() {
      var W = z.containerWidth, t2 = z.containerHeight;
      if (W < 0 || t2 < 0)
        return null;
      v8(_i(u) || _i(f), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, u, f), v8(!r || r > 0, "The aspect(%s) must be greater than zero.", r);
      var n2 = _i(u) ? W : u, s2 = _i(f) ? t2 : f;
      r && r > 0 && (n2 ? s2 = n2 / r : s2 && (n2 = s2 * r), E && s2 > E && (s2 = E)), v8(n2 > 0 || s2 > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, n2, s2, u, f, g, h, r);
      var l2 = !Array.isArray(y) && h8(y.type).endsWith("Chart");
      return f2.Children.map(y, function(X) {
        return /* @__PURE__ */ f2.isValidElement(X) ? /* @__PURE__ */ q.cloneElement(X, _d({
          width: n2,
          height: s2
        }, l2 ? {
          style: _d({
            height: "100%",
            width: "100%",
            maxHeight: s2,
            maxWidth: n2
          }, X.props.style)
        } : {})) : X;
      });
    }, [r, y, f, E, h, g, z, u]);
    return /* @__PURE__ */ f2.createElement("div", {
      id: B ? "".concat(B) : void 0,
      className: pe("recharts-responsive-container", _),
      style: _d(_d({}, O), {}, {
        width: u,
        height: f,
        minWidth: g,
        minHeight: h,
        maxHeight: E
      }),
      ref: w
    }, $);
  }), KW = function(t) {
    return null;
  };
  KW.displayName = "Cell";
  function Bc(e) {
    "@babel/helpers - typeof";
    return Bc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Bc(e);
  }
  function gN(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Kb(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? gN(Object(r), !0).forEach(function(n) {
        Ls2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : gN(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ls2(e, t, r) {
    return t = ks2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function ks2(e) {
    var t = Rs2(e, "string");
    return Bc(t) == "symbol" ? t : t + "";
  }
  function Rs2(e, t) {
    if (Bc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Bc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Go = {
    widthCache: {},
    cacheCount: 0
  }, Ps2 = 2e3, Fs2 = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
  }, pN = "recharts_measurement_span";
  function Ns2(e) {
    var t = Kb({}, e);
    return Object.keys(t).forEach(function(r) {
      t[r] || delete t[r];
    }), t;
  }
  var rc = function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t == null || As.isSsr)
      return {
        width: 0,
        height: 0
      };
    var n = Ns2(r), i = JSON.stringify({
      text: t,
      copyStyle: n
    });
    if (Go.widthCache[i])
      return Go.widthCache[i];
    try {
      var o = document.getElementById(pN);
      o || (o = document.createElement("span"), o.setAttribute("id", pN), o.setAttribute("aria-hidden", "true"), document.body.appendChild(o));
      var u = Kb(Kb({}, Fs2), n);
      Object.assign(o.style, u), o.textContent = "".concat(t);
      var c = o.getBoundingClientRect(), f = {
        width: c.width,
        height: c.height
      };
      return Go.widthCache[i] = f, ++Go.cacheCount > Ps2 && (Go.cacheCount = 0, Go.widthCache = {}), f;
    } catch {
      return {
        width: 0,
        height: 0
      };
    }
  }, Hs2 = function(t) {
    return {
      top: t.top + window.scrollY - document.documentElement.clientTop,
      left: t.left + window.scrollX - document.documentElement.clientLeft
    };
  };
  function Qc(e) {
    "@babel/helpers - typeof";
    return Qc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Qc(e);
  }
  function up(e, t) {
    return zs2(e) || Zs2(e, t) || Vs2(e, t) || js2();
  }
  function js2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Vs2(e, t) {
    if (e) {
      if (typeof e == "string") return hN(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return hN(e, t);
    }
  }
  function hN(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Zs2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          f = !1;
        } else for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function zs2(e) {
    if (Array.isArray(e)) return e;
  }
  function Us2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function vN(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ws2(n.key), n);
    }
  }
  function qs2(e, t, r) {
    return t && vN(e.prototype, t), r && vN(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Ws2(e) {
    var t = Ys2(e, "string");
    return Qc(t) == "symbol" ? t : t + "";
  }
  function Ys2(e, t) {
    if (Qc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Qc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var EN = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, mN = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, $s2 = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Gs2 = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, XW = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 96 / 6,
    in: 96,
    Q: 96 / (2.54 * 40),
    px: 1
  }, Ks2 = Object.keys(XW), u9 = "NaN";
  function Xs2(e, t) {
    return e * XW[t];
  }
  var Od = /* @__PURE__ */ function() {
    function e(t, r) {
      Us2(this, e), this.num = t, this.unit = r, this.num = t, this.unit = r, Number.isNaN(t) && (this.unit = ""), r !== "" && !$s2.test(r) && (this.num = NaN, this.unit = ""), Ks2.includes(r) && (this.num = Xs2(t, r), this.unit = "px");
    }
    return qs2(e, [{
      key: "add",
      value: function(r) {
        return this.unit !== r.unit ? new e(NaN, "") : new e(this.num + r.num, this.unit);
      }
    }, {
      key: "subtract",
      value: function(r) {
        return this.unit !== r.unit ? new e(NaN, "") : new e(this.num - r.num, this.unit);
      }
    }, {
      key: "multiply",
      value: function(r) {
        return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num * r.num, this.unit || r.unit);
      }
    }, {
      key: "divide",
      value: function(r) {
        return this.unit !== "" && r.unit !== "" && this.unit !== r.unit ? new e(NaN, "") : new e(this.num / r.num, this.unit || r.unit);
      }
    }, {
      key: "toString",
      value: function() {
        return "".concat(this.num).concat(this.unit);
      }
    }, {
      key: "isNaN",
      value: function() {
        return Number.isNaN(this.num);
      }
    }], [{
      key: "parse",
      value: function(r) {
        var n, i = (n = Gs2.exec(r)) !== null && n !== void 0 ? n : [], o = up(i, 3), u = o[1], c = o[2];
        return new e(parseFloat(u), c ?? "");
      }
    }]);
  }();
  function JW(e) {
    if (e.includes(u9))
      return u9;
    for (var t = e; t.includes("*") || t.includes("/"); ) {
      var r, n = (r = EN.exec(t)) !== null && r !== void 0 ? r : [], i = up(n, 4), o = i[1], u = i[2], c = i[3], f = Od.parse(o ?? ""), d = Od.parse(c ?? ""), g = u === "*" ? f.multiply(d) : f.divide(d);
      if (g.isNaN())
        return u9;
      t = t.replace(EN, g.toString());
    }
    for (; t.includes("+") || /.-\d+(?:\.\d+)?/.test(t); ) {
      var h, E = (h = mN.exec(t)) !== null && h !== void 0 ? h : [], y = up(E, 4), I = y[1], Q = y[2], B = y[3], _ = Od.parse(I ?? ""), M = Od.parse(B ?? ""), S = Q === "+" ? _.add(M) : _.subtract(M);
      if (S.isNaN())
        return u9;
      t = t.replace(mN, S.toString());
    }
    return t;
  }
  var yN = /\(([^()]*)\)/;
  function Js2(e) {
    for (var t = e; t.includes("("); ) {
      var r = yN.exec(t), n = up(r, 2), i = n[1];
      t = t.replace(yN, JW(i));
    }
    return t;
  }
  function eu2(e) {
    var t = e.replace(/\s+/g, "");
    return t = Js2(t), t = JW(t), t;
  }
  function tu2(e) {
    try {
      return eu2(e);
    } catch {
      return u9;
    }
  }
  function KQ(e) {
    var t = tu2(e.slice(5, -1));
    return t === u9 ? "" : t;
  }
  var ru2 = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], nu2 = ["dx", "dy", "angle", "className", "breakAll"];
  function Xb() {
    return Xb = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Xb.apply(this, arguments);
  }
  function IN(e, t) {
    if (e == null) return {};
    var r = iu2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function iu2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function BN(e, t) {
    return uu2(e) || su2(e, t) || ou2(e, t) || au2();
  }
  function au2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function ou2(e, t) {
    if (e) {
      if (typeof e == "string") return QN(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return QN(e, t);
    }
  }
  function QN(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function su2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t === 0) {
          if (Object(r) !== r) return;
          f = !1;
        } else for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function uu2(e) {
    if (Array.isArray(e)) return e;
  }
  var eY = /[ \f\n\r\t\v\u2028\u2029]+/, tY = function(t) {
    var r = t.children, n = t.breakAll, i = t.style;
    try {
      var o = [];
      Ae(r) || (n ? o = r.toString().split("") : o = r.toString().split(eY));
      var u = o.map(function(f) {
        return {
          word: f,
          width: rc(f, i).width
        };
      }), c = n ? 0 : rc(" ", i).width;
      return {
        wordsWithComputedWidth: u,
        spaceWidth: c
      };
    } catch {
      return null;
    }
  }, lu2 = function(t, r, n, i, o) {
    var u = t.maxLines, c = t.children, f = t.style, d = t.breakAll, g = G2(u), h = c, E = function() {
      var n2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return n2.reduce(function(s2, l2) {
        var X = l2.word, a2 = l2.width, e2 = s2[s2.length - 1];
        if (e2 && (i == null || o || e2.width + a2 + n < Number(i)))
          e2.words.push(X), e2.width += a2 + n;
        else {
          var H = {
            words: [X],
            width: a2
          };
          s2.push(H);
        }
        return s2;
      }, []);
    }, y = E(r), I = function(n2) {
      return n2.reduce(function(s2, l2) {
        return s2.width > l2.width ? s2 : l2;
      });
    };
    if (!g)
      return y;
    for (var Q = "…", B = function(n2) {
      var s2 = h.slice(0, n2), l2 = tY({
        breakAll: d,
        style: f,
        children: s2 + Q
      }).wordsWithComputedWidth, X = E(l2), a2 = X.length > u || I(X).width > Number(i);
      return [a2, X];
    }, _ = 0, M = h.length - 1, S = 0, O; _ <= M && S <= h.length - 1; ) {
      var w = Math.floor((_ + M) / 2), D = w - 1, k = B(D), F = BN(k, 2), z = F[0], Z = F[1], V = B(w), $ = BN(V, 1), W = $[0];
      if (!z && !W && (_ = w + 1), z && W && (M = w - 1), !z && W) {
        O = Z;
        break;
      }
      S++;
    }
    return O || y;
  }, xN = function(t) {
    var r = Ae(t) ? [] : t.toString().split(eY);
    return [{
      words: r
    }];
  }, cu2 = function(t) {
    var r = t.width, n = t.scaleToFit, i = t.children, o = t.style, u = t.breakAll, c = t.maxLines;
    if ((r || n) && !As.isSsr) {
      var f, d, g = tY({
        breakAll: u,
        children: i,
        style: o
      });
      if (g) {
        var h = g.wordsWithComputedWidth, E = g.spaceWidth;
        f = h, d = E;
      } else
        return xN(i);
      return lu2({
        breakAll: u,
        children: i,
        maxLines: c,
        style: o
      }, f, d, r, n);
    }
    return xN(i);
  }, bN = "#808080", lp = function(t) {
    var r = t.x, n = r === void 0 ? 0 : r, i = t.y, o = i === void 0 ? 0 : i, u = t.lineHeight, c = u === void 0 ? "1em" : u, f = t.capHeight, d = f === void 0 ? "0.71em" : f, g = t.scaleToFit, h = g === void 0 ? !1 : g, E = t.textAnchor, y = E === void 0 ? "start" : E, I = t.verticalAnchor, Q = I === void 0 ? "end" : I, B = t.fill, _ = B === void 0 ? bN : B, M = IN(t, ru2), S = q.useMemo(function() {
      return cu2({
        breakAll: M.breakAll,
        children: M.children,
        maxLines: M.maxLines,
        scaleToFit: h,
        style: M.style,
        width: M.width
      });
    }, [M.breakAll, M.children, M.maxLines, h, M.style, M.width]), O = M.dx, w = M.dy, D = M.angle, k = M.className, F = M.breakAll, z = IN(M, nu2);
    if (!T5(n) || !T5(o))
      return null;
    var Z = n + (G2(O) ? O : 0), V = o + (G2(w) ? w : 0), $;
    switch (Q) {
      case "start":
        $ = KQ("calc(".concat(d, ")"));
        break;
      case "middle":
        $ = KQ("calc(".concat((S.length - 1) / 2, " * -").concat(c, " + (").concat(d, " / 2))"));
        break;
      default:
        $ = KQ("calc(".concat(S.length - 1, " * -").concat(c, ")"));
        break;
    }
    var W = [];
    if (h) {
      var t2 = S[0].width, n2 = M.width;
      W.push("scale(".concat((G2(n2) ? n2 / t2 : 1) / t2, ")"));
    }
    return D && W.push("rotate(".concat(D, ", ").concat(Z, ", ").concat(V, ")")), W.length && (z.transform = W.join(" ")), /* @__PURE__ */ f2.createElement("text", Xb({}, ge(z, !0), {
      x: Z,
      y: V,
      className: pe("recharts-text", k),
      textAnchor: y,
      fill: _.includes("url") ? bN : _
    }), S.map(function(s2, l2) {
      var X = s2.words.join(F ? "" : " ");
      return (
        // duplicate words will cause duplicate keys
        // eslint-disable-next-line react/no-array-index-key
        /* @__PURE__ */ f2.createElement("tspan", {
          x: Z,
          dy: l2 === 0 ? $ : c,
          key: "".concat(X, "-").concat(l2)
        }, X)
      );
    }));
  };
  function H6(e, t) {
    return e == null || t == null ? NaN : e < t ? -1 : e > t ? 1 : e >= t ? 0 : NaN;
  }
  function Au2(e, t) {
    return e == null || t == null ? NaN : t < e ? -1 : t > e ? 1 : t >= e ? 0 : NaN;
  }
  function mM(e) {
    let t, r, n;
    e.length !== 2 ? (t = H6, r = (c, f) => H6(e(c), f), n = (c, f) => e(c) - f) : (t = e === H6 || e === Au2 ? e : fu2, r = e, n = e);
    function i(c, f, d = 0, g = c.length) {
      if (d < g) {
        if (t(f, f) !== 0) return g;
        do {
          const h = d + g >>> 1;
          r(c[h], f) < 0 ? d = h + 1 : g = h;
        } while (d < g);
      }
      return d;
    }
    function o(c, f, d = 0, g = c.length) {
      if (d < g) {
        if (t(f, f) !== 0) return g;
        do {
          const h = d + g >>> 1;
          r(c[h], f) <= 0 ? d = h + 1 : g = h;
        } while (d < g);
      }
      return d;
    }
    function u(c, f, d = 0, g = c.length) {
      const h = i(c, f, d, g - 1);
      return h > d && n(c[h - 1], f) > -n(c[h], f) ? h - 1 : h;
    }
    return { left: i, center: u, right: o };
  }
  function fu2() {
    return 0;
  }
  function rY(e) {
    return e === null ? NaN : +e;
  }
  function* Cu2(e, t) {
    for (let r of e)
      r != null && (r = +r) >= r && (yield r);
  }
  const du2 = mM(H6), cA = du2.right;
  mM(rY).center;
  class wN extends Map {
    constructor(t, r = hu2) {
      if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: r } }), t != null) for (const [n, i] of t) this.set(n, i);
    }
    get(t) {
      return super.get(SN(this, t));
    }
    has(t) {
      return super.has(SN(this, t));
    }
    set(t, r) {
      return super.set(gu2(this, t), r);
    }
    delete(t) {
      return super.delete(pu2(this, t));
    }
  }
  function SN({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) ? e.get(n) : r;
  }
  function gu2({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) ? e.get(n) : (e.set(n, r), r);
  }
  function pu2({ _intern: e, _key: t }, r) {
    const n = t(r);
    return e.has(n) && (r = e.get(n), e.delete(n)), r;
  }
  function hu2(e) {
    return e !== null && typeof e == "object" ? e.valueOf() : e;
  }
  function vu2(e = H6) {
    if (e === H6) return nY;
    if (typeof e != "function") throw new TypeError("compare is not a function");
    return (t, r) => {
      const n = e(t, r);
      return n || n === 0 ? n : (e(r, r) === 0) - (e(t, t) === 0);
    };
  }
  function nY(e, t) {
    return (e == null || !(e >= e)) - (t == null || !(t >= t)) || (e < t ? -1 : e > t ? 1 : 0);
  }
  const Eu2 = Math.sqrt(50), mu2 = Math.sqrt(10), yu2 = Math.sqrt(2);
  function cp(e, t, r) {
    const n = (t - e) / Math.max(0, r), i = Math.floor(Math.log10(n)), o = n / Math.pow(10, i), u = o >= Eu2 ? 10 : o >= mu2 ? 5 : o >= yu2 ? 2 : 1;
    let c, f, d;
    return i < 0 ? (d = Math.pow(10, -i) / u, c = Math.round(e * d), f = Math.round(t * d), c / d < e && ++c, f / d > t && --f, d = -d) : (d = Math.pow(10, i) * u, c = Math.round(e / d), f = Math.round(t / d), c * d < e && ++c, f * d > t && --f), f < c && 0.5 <= r && r < 2 ? cp(e, t, r * 2) : [c, f, d];
  }
  function Jb(e, t, r) {
    if (t = +t, e = +e, r = +r, !(r > 0)) return [];
    if (e === t) return [e];
    const n = t < e, [i, o, u] = n ? cp(t, e, r) : cp(e, t, r);
    if (!(o >= i)) return [];
    const c = o - i + 1, f = new Array(c);
    if (n)
      if (u < 0) for (let d = 0; d < c; ++d) f[d] = (o - d) / -u;
      else for (let d = 0; d < c; ++d) f[d] = (o - d) * u;
    else if (u < 0) for (let d = 0; d < c; ++d) f[d] = (i + d) / -u;
    else for (let d = 0; d < c; ++d) f[d] = (i + d) * u;
    return f;
  }
  function ew(e, t, r) {
    return t = +t, e = +e, r = +r, cp(e, t, r)[2];
  }
  function tw(e, t, r) {
    t = +t, e = +e, r = +r;
    const n = t < e, i = n ? ew(t, e, r) : ew(e, t, r);
    return (n ? -1 : 1) * (i < 0 ? 1 / -i : i);
  }
  function MN(e, t) {
    let r;
    for (const n of e)
      n != null && (r < n || r === void 0 && n >= n) && (r = n);
    return r;
  }
  function _N(e, t) {
    let r;
    for (const n of e)
      n != null && (r > n || r === void 0 && n >= n) && (r = n);
    return r;
  }
  function iY(e, t, r = 0, n = 1 / 0, i) {
    if (t = Math.floor(t), r = Math.floor(Math.max(0, r)), n = Math.floor(Math.min(e.length - 1, n)), !(r <= t && t <= n)) return e;
    for (i = i === void 0 ? nY : vu2(i); n > r; ) {
      if (n - r > 600) {
        const f = n - r + 1, d = t - r + 1, g = Math.log(f), h = 0.5 * Math.exp(2 * g / 3), E = 0.5 * Math.sqrt(g * h * (f - h) / f) * (d - f / 2 < 0 ? -1 : 1), y = Math.max(r, Math.floor(t - d * h / f + E)), I = Math.min(n, Math.floor(t + (f - d) * h / f + E));
        iY(e, t, y, I, i);
      }
      const o = e[t];
      let u = r, c = n;
      for (Dl(e, r, t), i(e[n], o) > 0 && Dl(e, r, n); u < c; ) {
        for (Dl(e, u, c), ++u, --c; i(e[u], o) < 0; ) ++u;
        for (; i(e[c], o) > 0; ) --c;
      }
      i(e[r], o) === 0 ? Dl(e, r, c) : (++c, Dl(e, c, n)), c <= t && (r = c + 1), t <= c && (n = c - 1);
    }
    return e;
  }
  function Dl(e, t, r) {
    const n = e[t];
    e[t] = e[r], e[r] = n;
  }
  function Iu2(e, t, r) {
    if (e = Float64Array.from(Cu2(e)), !(!(n = e.length) || isNaN(t = +t))) {
      if (t <= 0 || n < 2) return _N(e);
      if (t >= 1) return MN(e);
      var n, i = (n - 1) * t, o = Math.floor(i), u = MN(iY(e, o).subarray(0, o + 1)), c = _N(e.subarray(o + 1));
      return u + (c - u) * (i - o);
    }
  }
  function Bu2(e, t, r = rY) {
    if (!(!(n = e.length) || isNaN(t = +t))) {
      if (t <= 0 || n < 2) return +r(e[0], 0, e);
      if (t >= 1) return +r(e[n - 1], n - 1, e);
      var n, i = (n - 1) * t, o = Math.floor(i), u = +r(e[o], o, e), c = +r(e[o + 1], o + 1, e);
      return u + (c - u) * (i - o);
    }
  }
  function Qu2(e, t, r) {
    e = +e, t = +t, r = (i = arguments.length) < 2 ? (t = e, e = 0, 1) : i < 3 ? 1 : +r;
    for (var n = -1, i = Math.max(0, Math.ceil((t - e) / r)) | 0, o = new Array(i); ++n < i; )
      o[n] = e + n * r;
    return o;
  }
  function O4(e, t) {
    switch (arguments.length) {
      case 0:
        break;
      case 1:
        this.range(e);
        break;
      default:
        this.range(t).domain(e);
        break;
    }
    return this;
  }
  function O8(e, t) {
    switch (arguments.length) {
      case 0:
        break;
      case 1: {
        typeof e == "function" ? this.interpolator(e) : this.range(e);
        break;
      }
      default: {
        this.domain(e), typeof t == "function" ? this.interpolator(t) : this.range(t);
        break;
      }
    }
    return this;
  }
  const rw = Symbol("implicit");
  function yM() {
    var e = new wN(), t = [], r = [], n = rw;
    function i(o) {
      let u = e.get(o);
      if (u === void 0) {
        if (n !== rw) return n;
        e.set(o, u = t.push(o) - 1);
      }
      return r[u % r.length];
    }
    return i.domain = function(o) {
      if (!arguments.length) return t.slice();
      t = [], e = new wN();
      for (const u of o)
        e.has(u) || e.set(u, t.push(u) - 1);
      return i;
    }, i.range = function(o) {
      return arguments.length ? (r = Array.from(o), i) : r.slice();
    }, i.unknown = function(o) {
      return arguments.length ? (n = o, i) : n;
    }, i.copy = function() {
      return yM(t, r).unknown(n);
    }, O4.apply(i, arguments), i;
  }
  function xc() {
    var e = yM().unknown(void 0), t = e.domain, r = e.range, n = 0, i = 1, o, u, c = !1, f = 0, d = 0, g = 0.5;
    delete e.unknown;
    function h() {
      var E = t().length, y = i < n, I = y ? i : n, Q = y ? n : i;
      o = (Q - I) / Math.max(1, E - f + d * 2), c && (o = Math.floor(o)), I += (Q - I - o * (E - f)) * g, u = o * (1 - f), c && (I = Math.round(I), u = Math.round(u));
      var B = Qu2(E).map(function(_) {
        return I + o * _;
      });
      return r(y ? B.reverse() : B);
    }
    return e.domain = function(E) {
      return arguments.length ? (t(E), h()) : t();
    }, e.range = function(E) {
      return arguments.length ? ([n, i] = E, n = +n, i = +i, h()) : [n, i];
    }, e.rangeRound = function(E) {
      return [n, i] = E, n = +n, i = +i, c = !0, h();
    }, e.bandwidth = function() {
      return u;
    }, e.step = function() {
      return o;
    }, e.round = function(E) {
      return arguments.length ? (c = !!E, h()) : c;
    }, e.padding = function(E) {
      return arguments.length ? (f = Math.min(1, d = +E), h()) : f;
    }, e.paddingInner = function(E) {
      return arguments.length ? (f = Math.min(1, E), h()) : f;
    }, e.paddingOuter = function(E) {
      return arguments.length ? (d = +E, h()) : d;
    }, e.align = function(E) {
      return arguments.length ? (g = Math.max(0, Math.min(1, E)), h()) : g;
    }, e.copy = function() {
      return xc(t(), [n, i]).round(c).paddingInner(f).paddingOuter(d).align(g);
    }, O4.apply(h(), arguments);
  }
  function aY(e) {
    var t = e.copy;
    return e.padding = e.paddingOuter, delete e.paddingInner, delete e.paddingOuter, e.copy = function() {
      return aY(t());
    }, e;
  }
  function nc() {
    return aY(xc.apply(null, arguments).paddingInner(1));
  }
  function IM(e, t, r) {
    e.prototype = t.prototype = r, r.constructor = e;
  }
  function oY(e, t) {
    var r = Object.create(e.prototype);
    for (var n in t) r[n] = t[n];
    return r;
  }
  function AA() {
  }
  var bc = 0.7, Ap = 1 / bc, E9 = "\\s*([+-]?\\d+)\\s*", wc = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", c3 = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", xu2 = /^#([0-9a-f]{3,8})$/, bu2 = new RegExp(`^rgb\\(${E9},${E9},${E9}\\)$`), wu2 = new RegExp(`^rgb\\(${c3},${c3},${c3}\\)$`), Su2 = new RegExp(`^rgba\\(${E9},${E9},${E9},${wc}\\)$`), Mu2 = new RegExp(`^rgba\\(${c3},${c3},${c3},${wc}\\)$`), _u2 = new RegExp(`^hsl\\(${wc},${c3},${c3}\\)$`), Ou2 = new RegExp(`^hsla\\(${wc},${c3},${c3},${wc}\\)$`), ON = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
  };
  IM(AA, Sc, {
    copy(e) {
      return Object.assign(new this.constructor(), this, e);
    },
    displayable() {
      return this.rgb().displayable();
    },
    hex: TN,
    // Deprecated! Use color.formatHex.
    formatHex: TN,
    formatHex8: Tu2,
    formatHsl: Du2,
    formatRgb: DN,
    toString: DN
  });
  function TN() {
    return this.rgb().formatHex();
  }
  function Tu2() {
    return this.rgb().formatHex8();
  }
  function Du2() {
    return sY(this).formatHsl();
  }
  function DN() {
    return this.rgb().formatRgb();
  }
  function Sc(e) {
    var t, r;
    return e = (e + "").trim().toLowerCase(), (t = xu2.exec(e)) ? (r = t[1].length, t = parseInt(t[1], 16), r === 6 ? LN(t) : r === 3 ? new Er(t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, (t & 15) << 4 | t & 15, 1) : r === 8 ? Td(t >> 24 & 255, t >> 16 & 255, t >> 8 & 255, (t & 255) / 255) : r === 4 ? Td(t >> 12 & 15 | t >> 8 & 240, t >> 8 & 15 | t >> 4 & 240, t >> 4 & 15 | t & 240, ((t & 15) << 4 | t & 15) / 255) : null) : (t = bu2.exec(e)) ? new Er(t[1], t[2], t[3], 1) : (t = wu2.exec(e)) ? new Er(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, 1) : (t = Su2.exec(e)) ? Td(t[1], t[2], t[3], t[4]) : (t = Mu2.exec(e)) ? Td(t[1] * 255 / 100, t[2] * 255 / 100, t[3] * 255 / 100, t[4]) : (t = _u2.exec(e)) ? PN(t[1], t[2] / 100, t[3] / 100, 1) : (t = Ou2.exec(e)) ? PN(t[1], t[2] / 100, t[3] / 100, t[4]) : ON.hasOwnProperty(e) ? LN(ON[e]) : e === "transparent" ? new Er(NaN, NaN, NaN, 0) : null;
  }
  function LN(e) {
    return new Er(e >> 16 & 255, e >> 8 & 255, e & 255, 1);
  }
  function Td(e, t, r, n) {
    return n <= 0 && (e = t = r = NaN), new Er(e, t, r, n);
  }
  function Lu2(e) {
    return e instanceof AA || (e = Sc(e)), e ? (e = e.rgb(), new Er(e.r, e.g, e.b, e.opacity)) : new Er();
  }
  function nw(e, t, r, n) {
    return arguments.length === 1 ? Lu2(e) : new Er(e, t, r, n ?? 1);
  }
  function Er(e, t, r, n) {
    this.r = +e, this.g = +t, this.b = +r, this.opacity = +n;
  }
  IM(Er, nw, oY(AA, {
    brighter(e) {
      return e = e == null ? Ap : Math.pow(Ap, e), new Er(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    darker(e) {
      return e = e == null ? bc : Math.pow(bc, e), new Er(this.r * e, this.g * e, this.b * e, this.opacity);
    },
    rgb() {
      return this;
    },
    clamp() {
      return new Er(ki(this.r), ki(this.g), ki(this.b), fp(this.opacity));
    },
    displayable() {
      return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: kN,
    // Deprecated! Use color.formatHex.
    formatHex: kN,
    formatHex8: ku2,
    formatRgb: RN,
    toString: RN
  }));
  function kN() {
    return `#${Oi(this.r)}${Oi(this.g)}${Oi(this.b)}`;
  }
  function ku2() {
    return `#${Oi(this.r)}${Oi(this.g)}${Oi(this.b)}${Oi((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
  }
  function RN() {
    const e = fp(this.opacity);
    return `${e === 1 ? "rgb(" : "rgba("}${ki(this.r)}, ${ki(this.g)}, ${ki(this.b)}${e === 1 ? ")" : `, ${e})`}`;
  }
  function fp(e) {
    return isNaN(e) ? 1 : Math.max(0, Math.min(1, e));
  }
  function ki(e) {
    return Math.max(0, Math.min(255, Math.round(e) || 0));
  }
  function Oi(e) {
    return e = ki(e), (e < 16 ? "0" : "") + e.toString(16);
  }
  function PN(e, t, r, n) {
    return n <= 0 ? e = t = r = NaN : r <= 0 || r >= 1 ? e = t = NaN : t <= 0 && (e = NaN), new gn(e, t, r, n);
  }
  function sY(e) {
    if (e instanceof gn) return new gn(e.h, e.s, e.l, e.opacity);
    if (e instanceof AA || (e = Sc(e)), !e) return new gn();
    if (e instanceof gn) return e;
    e = e.rgb();
    var t = e.r / 255, r = e.g / 255, n = e.b / 255, i = Math.min(t, r, n), o = Math.max(t, r, n), u = NaN, c = o - i, f = (o + i) / 2;
    return c ? (t === o ? u = (r - n) / c + (r < n) * 6 : r === o ? u = (n - t) / c + 2 : u = (t - r) / c + 4, c /= f < 0.5 ? o + i : 2 - o - i, u *= 60) : c = f > 0 && f < 1 ? 0 : u, new gn(u, c, f, e.opacity);
  }
  function Ru2(e, t, r, n) {
    return arguments.length === 1 ? sY(e) : new gn(e, t, r, n ?? 1);
  }
  function gn(e, t, r, n) {
    this.h = +e, this.s = +t, this.l = +r, this.opacity = +n;
  }
  IM(gn, Ru2, oY(AA, {
    brighter(e) {
      return e = e == null ? Ap : Math.pow(Ap, e), new gn(this.h, this.s, this.l * e, this.opacity);
    },
    darker(e) {
      return e = e == null ? bc : Math.pow(bc, e), new gn(this.h, this.s, this.l * e, this.opacity);
    },
    rgb() {
      var e = this.h % 360 + (this.h < 0) * 360, t = isNaN(e) || isNaN(this.s) ? 0 : this.s, r = this.l, n = r + (r < 0.5 ? r : 1 - r) * t, i = 2 * r - n;
      return new Er(
        XQ(e >= 240 ? e - 240 : e + 120, i, n),
        XQ(e, i, n),
        XQ(e < 120 ? e + 240 : e - 120, i, n),
        this.opacity
      );
    },
    clamp() {
      return new gn(FN(this.h), Dd(this.s), Dd(this.l), fp(this.opacity));
    },
    displayable() {
      return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl() {
      const e = fp(this.opacity);
      return `${e === 1 ? "hsl(" : "hsla("}${FN(this.h)}, ${Dd(this.s) * 100}%, ${Dd(this.l) * 100}%${e === 1 ? ")" : `, ${e})`}`;
    }
  }));
  function FN(e) {
    return e = (e || 0) % 360, e < 0 ? e + 360 : e;
  }
  function Dd(e) {
    return Math.max(0, Math.min(1, e || 0));
  }
  function XQ(e, t, r) {
    return (e < 60 ? t + (r - t) * e / 60 : e < 180 ? r : e < 240 ? t + (r - t) * (240 - e) / 60 : t) * 255;
  }
  const BM = (e) => () => e;
  function Pu2(e, t) {
    return function(r) {
      return e + r * t;
    };
  }
  function Fu2(e, t, r) {
    return e = Math.pow(e, r), t = Math.pow(t, r) - e, r = 1 / r, function(n) {
      return Math.pow(e + n * t, r);
    };
  }
  function Nu2(e) {
    return (e = +e) == 1 ? uY : function(t, r) {
      return r - t ? Fu2(t, r, e) : BM(isNaN(t) ? r : t);
    };
  }
  function uY(e, t) {
    var r = t - e;
    return r ? Pu2(e, r) : BM(isNaN(e) ? t : e);
  }
  const NN = function e(t) {
    var r = Nu2(t);
    function n(i, o) {
      var u = r((i = nw(i)).r, (o = nw(o)).r), c = r(i.g, o.g), f = r(i.b, o.b), d = uY(i.opacity, o.opacity);
      return function(g) {
        return i.r = u(g), i.g = c(g), i.b = f(g), i.opacity = d(g), i + "";
      };
    }
    return n.gamma = e, n;
  }(1);
  function Hu2(e, t) {
    t || (t = []);
    var r = e ? Math.min(t.length, e.length) : 0, n = t.slice(), i;
    return function(o) {
      for (i = 0; i < r; ++i) n[i] = e[i] * (1 - o) + t[i] * o;
      return n;
    };
  }
  function ju2(e) {
    return ArrayBuffer.isView(e) && !(e instanceof DataView);
  }
  function Vu2(e, t) {
    var r = t ? t.length : 0, n = e ? Math.min(r, e.length) : 0, i = new Array(n), o = new Array(r), u;
    for (u = 0; u < n; ++u) i[u] = fs(e[u], t[u]);
    for (; u < r; ++u) o[u] = t[u];
    return function(c) {
      for (u = 0; u < n; ++u) o[u] = i[u](c);
      return o;
    };
  }
  function Zu2(e, t) {
    var r = /* @__PURE__ */ new Date();
    return e = +e, t = +t, function(n) {
      return r.setTime(e * (1 - n) + t * n), r;
    };
  }
  function Cp(e, t) {
    return e = +e, t = +t, function(r) {
      return e * (1 - r) + t * r;
    };
  }
  function zu2(e, t) {
    var r = {}, n = {}, i;
    (e === null || typeof e != "object") && (e = {}), (t === null || typeof t != "object") && (t = {});
    for (i in t)
      i in e ? r[i] = fs(e[i], t[i]) : n[i] = t[i];
    return function(o) {
      for (i in r) n[i] = r[i](o);
      return n;
    };
  }
  var iw = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, JQ = new RegExp(iw.source, "g");
  function Uu2(e) {
    return function() {
      return e;
    };
  }
  function qu2(e) {
    return function(t) {
      return e(t) + "";
    };
  }
  function Wu2(e, t) {
    var r = iw.lastIndex = JQ.lastIndex = 0, n, i, o, u = -1, c = [], f = [];
    for (e = e + "", t = t + ""; (n = iw.exec(e)) && (i = JQ.exec(t)); )
      (o = i.index) > r && (o = t.slice(r, o), c[u] ? c[u] += o : c[++u] = o), (n = n[0]) === (i = i[0]) ? c[u] ? c[u] += i : c[++u] = i : (c[++u] = null, f.push({ i: u, x: Cp(n, i) })), r = JQ.lastIndex;
    return r < t.length && (o = t.slice(r), c[u] ? c[u] += o : c[++u] = o), c.length < 2 ? f[0] ? qu2(f[0].x) : Uu2(t) : (t = f.length, function(d) {
      for (var g = 0, h; g < t; ++g) c[(h = f[g]).i] = h.x(d);
      return c.join("");
    });
  }
  function fs(e, t) {
    var r = typeof t, n;
    return t == null || r === "boolean" ? BM(t) : (r === "number" ? Cp : r === "string" ? (n = Sc(t)) ? (t = n, NN) : Wu2 : t instanceof Sc ? NN : t instanceof Date ? Zu2 : ju2(t) ? Hu2 : Array.isArray(t) ? Vu2 : typeof t.valueOf != "function" && typeof t.toString != "function" || isNaN(t) ? zu2 : Cp)(e, t);
  }
  function QM(e, t) {
    return e = +e, t = +t, function(r) {
      return Math.round(e * (1 - r) + t * r);
    };
  }
  function Yu2(e, t) {
    t === void 0 && (t = e, e = fs);
    for (var r = 0, n = t.length - 1, i = t[0], o = new Array(n < 0 ? 0 : n); r < n; ) o[r] = e(i, i = t[++r]);
    return function(u) {
      var c = Math.max(0, Math.min(n - 1, Math.floor(u *= n)));
      return o[c](u - c);
    };
  }
  function $u2(e) {
    return function() {
      return e;
    };
  }
  function dp(e) {
    return +e;
  }
  var HN = [0, 1];
  function $1(e) {
    return e;
  }
  function aw(e, t) {
    return (t -= e = +e) ? function(r) {
      return (r - e) / t;
    } : $u2(isNaN(t) ? NaN : 0.5);
  }
  function Gu2(e, t) {
    var r;
    return e > t && (r = e, e = t, t = r), function(n) {
      return Math.max(e, Math.min(t, n));
    };
  }
  function Ku2(e, t, r) {
    var n = e[0], i = e[1], o = t[0], u = t[1];
    return i < n ? (n = aw(i, n), o = r(u, o)) : (n = aw(n, i), o = r(o, u)), function(c) {
      return o(n(c));
    };
  }
  function Xu2(e, t, r) {
    var n = Math.min(e.length, t.length) - 1, i = new Array(n), o = new Array(n), u = -1;
    for (e[n] < e[0] && (e = e.slice().reverse(), t = t.slice().reverse()); ++u < n; )
      i[u] = aw(e[u], e[u + 1]), o[u] = r(t[u], t[u + 1]);
    return function(c) {
      var f = cA(e, c, 1, n) - 1;
      return o[f](i[f](c));
    };
  }
  function fA(e, t) {
    return t.domain(e.domain()).range(e.range()).interpolate(e.interpolate()).clamp(e.clamp()).unknown(e.unknown());
  }
  function _h() {
    var e = HN, t = HN, r = fs, n, i, o, u = $1, c, f, d;
    function g() {
      var E = Math.min(e.length, t.length);
      return u !== $1 && (u = Gu2(e[0], e[E - 1])), c = E > 2 ? Xu2 : Ku2, f = d = null, h;
    }
    function h(E) {
      return E == null || isNaN(E = +E) ? o : (f || (f = c(e.map(n), t, r)))(n(u(E)));
    }
    return h.invert = function(E) {
      return u(i((d || (d = c(t, e.map(n), Cp)))(E)));
    }, h.domain = function(E) {
      return arguments.length ? (e = Array.from(E, dp), g()) : e.slice();
    }, h.range = function(E) {
      return arguments.length ? (t = Array.from(E), g()) : t.slice();
    }, h.rangeRound = function(E) {
      return t = Array.from(E), r = QM, g();
    }, h.clamp = function(E) {
      return arguments.length ? (u = E ? !0 : $1, g()) : u !== $1;
    }, h.interpolate = function(E) {
      return arguments.length ? (r = E, g()) : r;
    }, h.unknown = function(E) {
      return arguments.length ? (o = E, h) : o;
    }, function(E, y) {
      return n = E, i = y, g();
    };
  }
  function xM() {
    return _h()($1, $1);
  }
  function Ju2(e) {
    return Math.abs(e = Math.round(e)) >= 1e21 ? e.toLocaleString("en").replace(/,/g, "") : e.toString(10);
  }
  function gp(e, t) {
    if ((r = (e = t ? e.toExponential(t - 1) : e.toExponential()).indexOf("e")) < 0) return null;
    var r, n = e.slice(0, r);
    return [
      n.length > 1 ? n[0] + n.slice(2) : n,
      +e.slice(r + 1)
    ];
  }
  function T9(e) {
    return e = gp(Math.abs(e)), e ? e[1] : NaN;
  }
  function el2(e, t) {
    return function(r, n) {
      for (var i = r.length, o = [], u = 0, c = e[0], f = 0; i > 0 && c > 0 && (f + c + 1 > n && (c = Math.max(1, n - f)), o.push(r.substring(i -= c, i + c)), !((f += c + 1) > n)); )
        c = e[u = (u + 1) % e.length];
      return o.reverse().join(t);
    };
  }
  function tl2(e) {
    return function(t) {
      return t.replace(/[0-9]/g, function(r) {
        return e[+r];
      });
    };
  }
  var rl2 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
  function Mc(e) {
    if (!(t = rl2.exec(e))) throw new Error("invalid format: " + e);
    var t;
    return new bM({
      fill: t[1],
      align: t[2],
      sign: t[3],
      symbol: t[4],
      zero: t[5],
      width: t[6],
      comma: t[7],
      precision: t[8] && t[8].slice(1),
      trim: t[9],
      type: t[10]
    });
  }
  Mc.prototype = bM.prototype;
  function bM(e) {
    this.fill = e.fill === void 0 ? " " : e.fill + "", this.align = e.align === void 0 ? ">" : e.align + "", this.sign = e.sign === void 0 ? "-" : e.sign + "", this.symbol = e.symbol === void 0 ? "" : e.symbol + "", this.zero = !!e.zero, this.width = e.width === void 0 ? void 0 : +e.width, this.comma = !!e.comma, this.precision = e.precision === void 0 ? void 0 : +e.precision, this.trim = !!e.trim, this.type = e.type === void 0 ? "" : e.type + "";
  }
  bM.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
  };
  function nl2(e) {
    e: for (var t = e.length, r = 1, n = -1, i; r < t; ++r)
      switch (e[r]) {
        case ".":
          n = i = r;
          break;
        case "0":
          n === 0 && (n = r), i = r;
          break;
        default:
          if (!+e[r]) break e;
          n > 0 && (n = 0);
          break;
      }
    return n > 0 ? e.slice(0, n) + e.slice(i + 1) : e;
  }
  var lY;
  function il2(e, t) {
    var r = gp(e, t);
    if (!r) return e + "";
    var n = r[0], i = r[1], o = i - (lY = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, u = n.length;
    return o === u ? n : o > u ? n + new Array(o - u + 1).join("0") : o > 0 ? n.slice(0, o) + "." + n.slice(o) : "0." + new Array(1 - o).join("0") + gp(e, Math.max(0, t + o - 1))[0];
  }
  function jN(e, t) {
    var r = gp(e, t);
    if (!r) return e + "";
    var n = r[0], i = r[1];
    return i < 0 ? "0." + new Array(-i).join("0") + n : n.length > i + 1 ? n.slice(0, i + 1) + "." + n.slice(i + 1) : n + new Array(i - n.length + 2).join("0");
  }
  const VN = {
    "%": (e, t) => (e * 100).toFixed(t),
    b: (e) => Math.round(e).toString(2),
    c: (e) => e + "",
    d: Ju2,
    e: (e, t) => e.toExponential(t),
    f: (e, t) => e.toFixed(t),
    g: (e, t) => e.toPrecision(t),
    o: (e) => Math.round(e).toString(8),
    p: (e, t) => jN(e * 100, t),
    r: jN,
    s: il2,
    X: (e) => Math.round(e).toString(16).toUpperCase(),
    x: (e) => Math.round(e).toString(16)
  };
  function ZN(e) {
    return e;
  }
  var zN = Array.prototype.map, UN = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
  function al2(e) {
    var t = e.grouping === void 0 || e.thousands === void 0 ? ZN : el2(zN.call(e.grouping, Number), e.thousands + ""), r = e.currency === void 0 ? "" : e.currency[0] + "", n = e.currency === void 0 ? "" : e.currency[1] + "", i = e.decimal === void 0 ? "." : e.decimal + "", o = e.numerals === void 0 ? ZN : tl2(zN.call(e.numerals, String)), u = e.percent === void 0 ? "%" : e.percent + "", c = e.minus === void 0 ? "−" : e.minus + "", f = e.nan === void 0 ? "NaN" : e.nan + "";
    function d(h) {
      h = Mc(h);
      var E = h.fill, y = h.align, I = h.sign, Q = h.symbol, B = h.zero, _ = h.width, M = h.comma, S = h.precision, O = h.trim, w = h.type;
      w === "n" ? (M = !0, w = "g") : VN[w] || (S === void 0 && (S = 12), O = !0, w = "g"), (B || E === "0" && y === "=") && (B = !0, E = "0", y = "=");
      var D = Q === "$" ? r : Q === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", k = Q === "$" ? n : /[%p]/.test(w) ? u : "", F = VN[w], z = /[defgprs%]/.test(w);
      S = S === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, S)) : Math.max(0, Math.min(20, S));
      function Z(V) {
        var $ = D, W = k, t2, n2, s2;
        if (w === "c")
          W = F(V) + W, V = "";
        else {
          V = +V;
          var l2 = V < 0 || 1 / V < 0;
          if (V = isNaN(V) ? f : F(Math.abs(V), S), O && (V = nl2(V)), l2 && +V == 0 && I !== "+" && (l2 = !1), $ = (l2 ? I === "(" ? I : c : I === "-" || I === "(" ? "" : I) + $, W = (w === "s" ? UN[8 + lY / 3] : "") + W + (l2 && I === "(" ? ")" : ""), z) {
            for (t2 = -1, n2 = V.length; ++t2 < n2; )
              if (s2 = V.charCodeAt(t2), 48 > s2 || s2 > 57) {
                W = (s2 === 46 ? i + V.slice(t2 + 1) : V.slice(t2)) + W, V = V.slice(0, t2);
                break;
              }
          }
        }
        M && !B && (V = t(V, 1 / 0));
        var X = $.length + V.length + W.length, a2 = X < _ ? new Array(_ - X + 1).join(E) : "";
        switch (M && B && (V = t(a2 + V, a2.length ? _ - W.length : 1 / 0), a2 = ""), y) {
          case "<":
            V = $ + V + W + a2;
            break;
          case "=":
            V = $ + a2 + V + W;
            break;
          case "^":
            V = a2.slice(0, X = a2.length >> 1) + $ + V + W + a2.slice(X);
            break;
          default:
            V = a2 + $ + V + W;
            break;
        }
        return o(V);
      }
      return Z.toString = function() {
        return h + "";
      }, Z;
    }
    function g(h, E) {
      var y = d((h = Mc(h), h.type = "f", h)), I = Math.max(-8, Math.min(8, Math.floor(T9(E) / 3))) * 3, Q = Math.pow(10, -I), B = UN[8 + I / 3];
      return function(_) {
        return y(Q * _) + B;
      };
    }
    return {
      format: d,
      formatPrefix: g
    };
  }
  var Ld, wM, cY;
  ol2({
    thousands: ",",
    grouping: [3],
    currency: ["$", ""]
  });
  function ol2(e) {
    return Ld = al2(e), wM = Ld.format, cY = Ld.formatPrefix, Ld;
  }
  function sl2(e) {
    return Math.max(0, -T9(Math.abs(e)));
  }
  function ul2(e, t) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(T9(t) / 3))) * 3 - T9(Math.abs(e)));
  }
  function ll2(e, t) {
    return e = Math.abs(e), t = Math.abs(t) - e, Math.max(0, T9(t) - T9(e)) + 1;
  }
  function AY(e, t, r, n) {
    var i = tw(e, t, r), o;
    switch (n = Mc(n ?? ",f"), n.type) {
      case "s": {
        var u = Math.max(Math.abs(e), Math.abs(t));
        return n.precision == null && !isNaN(o = ul2(i, u)) && (n.precision = o), cY(n, u);
      }
      case "":
      case "e":
      case "g":
      case "p":
      case "r": {
        n.precision == null && !isNaN(o = ll2(i, Math.max(Math.abs(e), Math.abs(t)))) && (n.precision = o - (n.type === "e"));
        break;
      }
      case "f":
      case "%": {
        n.precision == null && !isNaN(o = sl2(i)) && (n.precision = o - (n.type === "%") * 2);
        break;
      }
    }
    return wM(n);
  }
  function J6(e) {
    var t = e.domain;
    return e.ticks = function(r) {
      var n = t();
      return Jb(n[0], n[n.length - 1], r ?? 10);
    }, e.tickFormat = function(r, n) {
      var i = t();
      return AY(i[0], i[i.length - 1], r ?? 10, n);
    }, e.nice = function(r) {
      r == null && (r = 10);
      var n = t(), i = 0, o = n.length - 1, u = n[i], c = n[o], f, d, g = 10;
      for (c < u && (d = u, u = c, c = d, d = i, i = o, o = d); g-- > 0; ) {
        if (d = ew(u, c, r), d === f)
          return n[i] = u, n[o] = c, t(n);
        if (d > 0)
          u = Math.floor(u / d) * d, c = Math.ceil(c / d) * d;
        else if (d < 0)
          u = Math.ceil(u * d) / d, c = Math.floor(c * d) / d;
        else
          break;
        f = d;
      }
      return e;
    }, e;
  }
  function pp() {
    var e = xM();
    return e.copy = function() {
      return fA(e, pp());
    }, O4.apply(e, arguments), J6(e);
  }
  function fY(e) {
    var t;
    function r(n) {
      return n == null || isNaN(n = +n) ? t : n;
    }
    return r.invert = r, r.domain = r.range = function(n) {
      return arguments.length ? (e = Array.from(n, dp), r) : e.slice();
    }, r.unknown = function(n) {
      return arguments.length ? (t = n, r) : t;
    }, r.copy = function() {
      return fY(e).unknown(t);
    }, e = arguments.length ? Array.from(e, dp) : [0, 1], J6(r);
  }
  function CY(e, t) {
    e = e.slice();
    var r = 0, n = e.length - 1, i = e[r], o = e[n], u;
    return o < i && (u = r, r = n, n = u, u = i, i = o, o = u), e[r] = t.floor(i), e[n] = t.ceil(o), e;
  }
  function qN(e) {
    return Math.log(e);
  }
  function WN(e) {
    return Math.exp(e);
  }
  function cl2(e) {
    return -Math.log(-e);
  }
  function Al2(e) {
    return -Math.exp(-e);
  }
  function fl2(e) {
    return isFinite(e) ? +("1e" + e) : e < 0 ? 0 : e;
  }
  function Cl2(e) {
    return e === 10 ? fl2 : e === Math.E ? Math.exp : (t) => Math.pow(e, t);
  }
  function dl2(e) {
    return e === Math.E ? Math.log : e === 10 && Math.log10 || e === 2 && Math.log2 || (e = Math.log(e), (t) => Math.log(t) / e);
  }
  function YN(e) {
    return (t, r) => -e(-t, r);
  }
  function SM(e) {
    const t = e(qN, WN), r = t.domain;
    let n = 10, i, o;
    function u() {
      return i = dl2(n), o = Cl2(n), r()[0] < 0 ? (i = YN(i), o = YN(o), e(cl2, Al2)) : e(qN, WN), t;
    }
    return t.base = function(c) {
      return arguments.length ? (n = +c, u()) : n;
    }, t.domain = function(c) {
      return arguments.length ? (r(c), u()) : r();
    }, t.ticks = (c) => {
      const f = r();
      let d = f[0], g = f[f.length - 1];
      const h = g < d;
      h && ([d, g] = [g, d]);
      let E = i(d), y = i(g), I, Q;
      const B = c == null ? 10 : +c;
      let _ = [];
      if (!(n % 1) && y - E < B) {
        if (E = Math.floor(E), y = Math.ceil(y), d > 0) {
          for (; E <= y; ++E)
            for (I = 1; I < n; ++I)
              if (Q = E < 0 ? I / o(-E) : I * o(E), !(Q < d)) {
                if (Q > g) break;
                _.push(Q);
              }
        } else for (; E <= y; ++E)
          for (I = n - 1; I >= 1; --I)
            if (Q = E > 0 ? I / o(-E) : I * o(E), !(Q < d)) {
              if (Q > g) break;
              _.push(Q);
            }
        _.length * 2 < B && (_ = Jb(d, g, B));
      } else
        _ = Jb(E, y, Math.min(y - E, B)).map(o);
      return h ? _.reverse() : _;
    }, t.tickFormat = (c, f) => {
      if (c == null && (c = 10), f == null && (f = n === 10 ? "s" : ","), typeof f != "function" && (!(n % 1) && (f = Mc(f)).precision == null && (f.trim = !0), f = wM(f)), c === 1 / 0) return f;
      const d = Math.max(1, n * c / t.ticks().length);
      return (g) => {
        let h = g / o(Math.round(i(g)));
        return h * n < n - 0.5 && (h *= n), h <= d ? f(g) : "";
      };
    }, t.nice = () => r(CY(r(), {
      floor: (c) => o(Math.floor(i(c))),
      ceil: (c) => o(Math.ceil(i(c)))
    })), t;
  }
  function dY() {
    const e = SM(_h()).domain([1, 10]);
    return e.copy = () => fA(e, dY()).base(e.base()), O4.apply(e, arguments), e;
  }
  function $N(e) {
    return function(t) {
      return Math.sign(t) * Math.log1p(Math.abs(t / e));
    };
  }
  function GN(e) {
    return function(t) {
      return Math.sign(t) * Math.expm1(Math.abs(t)) * e;
    };
  }
  function MM(e) {
    var t = 1, r = e($N(t), GN(t));
    return r.constant = function(n) {
      return arguments.length ? e($N(t = +n), GN(t)) : t;
    }, J6(r);
  }
  function gY() {
    var e = MM(_h());
    return e.copy = function() {
      return fA(e, gY()).constant(e.constant());
    }, O4.apply(e, arguments);
  }
  function KN(e) {
    return function(t) {
      return t < 0 ? -Math.pow(-t, e) : Math.pow(t, e);
    };
  }
  function gl2(e) {
    return e < 0 ? -Math.sqrt(-e) : Math.sqrt(e);
  }
  function pl2(e) {
    return e < 0 ? -e * e : e * e;
  }
  function _M(e) {
    var t = e($1, $1), r = 1;
    function n() {
      return r === 1 ? e($1, $1) : r === 0.5 ? e(gl2, pl2) : e(KN(r), KN(1 / r));
    }
    return t.exponent = function(i) {
      return arguments.length ? (r = +i, n()) : r;
    }, J6(t);
  }
  function OM() {
    var e = _M(_h());
    return e.copy = function() {
      return fA(e, OM()).exponent(e.exponent());
    }, O4.apply(e, arguments), e;
  }
  function hl2() {
    return OM.apply(null, arguments).exponent(0.5);
  }
  function XN(e) {
    return Math.sign(e) * e * e;
  }
  function vl2(e) {
    return Math.sign(e) * Math.sqrt(Math.abs(e));
  }
  function pY() {
    var e = xM(), t = [0, 1], r = !1, n;
    function i(o) {
      var u = vl2(e(o));
      return isNaN(u) ? n : r ? Math.round(u) : u;
    }
    return i.invert = function(o) {
      return e.invert(XN(o));
    }, i.domain = function(o) {
      return arguments.length ? (e.domain(o), i) : e.domain();
    }, i.range = function(o) {
      return arguments.length ? (e.range((t = Array.from(o, dp)).map(XN)), i) : t.slice();
    }, i.rangeRound = function(o) {
      return i.range(o).round(!0);
    }, i.round = function(o) {
      return arguments.length ? (r = !!o, i) : r;
    }, i.clamp = function(o) {
      return arguments.length ? (e.clamp(o), i) : e.clamp();
    }, i.unknown = function(o) {
      return arguments.length ? (n = o, i) : n;
    }, i.copy = function() {
      return pY(e.domain(), t).round(r).clamp(e.clamp()).unknown(n);
    }, O4.apply(i, arguments), J6(i);
  }
  function hY() {
    var e = [], t = [], r = [], n;
    function i() {
      var u = 0, c = Math.max(1, t.length);
      for (r = new Array(c - 1); ++u < c; ) r[u - 1] = Bu2(e, u / c);
      return o;
    }
    function o(u) {
      return u == null || isNaN(u = +u) ? n : t[cA(r, u)];
    }
    return o.invertExtent = function(u) {
      var c = t.indexOf(u);
      return c < 0 ? [NaN, NaN] : [
        c > 0 ? r[c - 1] : e[0],
        c < r.length ? r[c] : e[e.length - 1]
      ];
    }, o.domain = function(u) {
      if (!arguments.length) return e.slice();
      e = [];
      for (let c of u) c != null && !isNaN(c = +c) && e.push(c);
      return e.sort(H6), i();
    }, o.range = function(u) {
      return arguments.length ? (t = Array.from(u), i()) : t.slice();
    }, o.unknown = function(u) {
      return arguments.length ? (n = u, o) : n;
    }, o.quantiles = function() {
      return r.slice();
    }, o.copy = function() {
      return hY().domain(e).range(t).unknown(n);
    }, O4.apply(o, arguments);
  }
  function vY() {
    var e = 0, t = 1, r = 1, n = [0.5], i = [0, 1], o;
    function u(f) {
      return f != null && f <= f ? i[cA(n, f, 0, r)] : o;
    }
    function c() {
      var f = -1;
      for (n = new Array(r); ++f < r; ) n[f] = ((f + 1) * t - (f - r) * e) / (r + 1);
      return u;
    }
    return u.domain = function(f) {
      return arguments.length ? ([e, t] = f, e = +e, t = +t, c()) : [e, t];
    }, u.range = function(f) {
      return arguments.length ? (r = (i = Array.from(f)).length - 1, c()) : i.slice();
    }, u.invertExtent = function(f) {
      var d = i.indexOf(f);
      return d < 0 ? [NaN, NaN] : d < 1 ? [e, n[0]] : d >= r ? [n[r - 1], t] : [n[d - 1], n[d]];
    }, u.unknown = function(f) {
      return arguments.length && (o = f), u;
    }, u.thresholds = function() {
      return n.slice();
    }, u.copy = function() {
      return vY().domain([e, t]).range(i).unknown(o);
    }, O4.apply(J6(u), arguments);
  }
  function EY() {
    var e = [0.5], t = [0, 1], r, n = 1;
    function i(o) {
      return o != null && o <= o ? t[cA(e, o, 0, n)] : r;
    }
    return i.domain = function(o) {
      return arguments.length ? (e = Array.from(o), n = Math.min(e.length, t.length - 1), i) : e.slice();
    }, i.range = function(o) {
      return arguments.length ? (t = Array.from(o), n = Math.min(e.length, t.length - 1), i) : t.slice();
    }, i.invertExtent = function(o) {
      var u = t.indexOf(o);
      return [e[u - 1], e[u]];
    }, i.unknown = function(o) {
      return arguments.length ? (r = o, i) : r;
    }, i.copy = function() {
      return EY().domain(e).range(t).unknown(r);
    }, O4.apply(i, arguments);
  }
  const ex = /* @__PURE__ */ new Date(), tx = /* @__PURE__ */ new Date();
  function D5(e, t, r, n) {
    function i(o) {
      return e(o = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+o)), o;
    }
    return i.floor = (o) => (e(o = /* @__PURE__ */ new Date(+o)), o), i.ceil = (o) => (e(o = new Date(o - 1)), t(o, 1), e(o), o), i.round = (o) => {
      const u = i(o), c = i.ceil(o);
      return o - u < c - o ? u : c;
    }, i.offset = (o, u) => (t(o = /* @__PURE__ */ new Date(+o), u == null ? 1 : Math.floor(u)), o), i.range = (o, u, c) => {
      const f = [];
      if (o = i.ceil(o), c = c == null ? 1 : Math.floor(c), !(o < u) || !(c > 0)) return f;
      let d;
      do
        f.push(d = /* @__PURE__ */ new Date(+o)), t(o, c), e(o);
      while (d < o && o < u);
      return f;
    }, i.filter = (o) => D5((u) => {
      if (u >= u) for (; e(u), !o(u); ) u.setTime(u - 1);
    }, (u, c) => {
      if (u >= u)
        if (c < 0) for (; ++c <= 0; )
          for (; t(u, -1), !o(u); )
            ;
        else for (; --c >= 0; )
          for (; t(u, 1), !o(u); )
            ;
    }), r && (i.count = (o, u) => (ex.setTime(+o), tx.setTime(+u), e(ex), e(tx), Math.floor(r(ex, tx))), i.every = (o) => (o = Math.floor(o), !isFinite(o) || !(o > 0) ? null : o > 1 ? i.filter(n ? (u) => n(u) % o === 0 : (u) => i.count(0, u) % o === 0) : i)), i;
  }
  const hp = D5(() => {
  }, (e, t) => {
    e.setTime(+e + t);
  }, (e, t) => t - e);
  hp.every = (e) => (e = Math.floor(e), !isFinite(e) || !(e > 0) ? null : e > 1 ? D5((t) => {
    t.setTime(Math.floor(t / e) * e);
  }, (t, r) => {
    t.setTime(+t + r * e);
  }, (t, r) => (r - t) / e) : hp);
  hp.range;
  const C8 = 1e3, x4 = C8 * 60, d8 = x4 * 60, Q8 = d8 * 24, TM = Q8 * 7, JN = Q8 * 30, rx = Q8 * 365, Ti = D5((e) => {
    e.setTime(e - e.getMilliseconds());
  }, (e, t) => {
    e.setTime(+e + t * C8);
  }, (e, t) => (t - e) / C8, (e) => e.getUTCSeconds());
  Ti.range;
  const DM = D5((e) => {
    e.setTime(e - e.getMilliseconds() - e.getSeconds() * C8);
  }, (e, t) => {
    e.setTime(+e + t * x4);
  }, (e, t) => (t - e) / x4, (e) => e.getMinutes());
  DM.range;
  const LM = D5((e) => {
    e.setUTCSeconds(0, 0);
  }, (e, t) => {
    e.setTime(+e + t * x4);
  }, (e, t) => (t - e) / x4, (e) => e.getUTCMinutes());
  LM.range;
  const kM = D5((e) => {
    e.setTime(e - e.getMilliseconds() - e.getSeconds() * C8 - e.getMinutes() * x4);
  }, (e, t) => {
    e.setTime(+e + t * d8);
  }, (e, t) => (t - e) / d8, (e) => e.getHours());
  kM.range;
  const RM = D5((e) => {
    e.setUTCMinutes(0, 0, 0);
  }, (e, t) => {
    e.setTime(+e + t * d8);
  }, (e, t) => (t - e) / d8, (e) => e.getUTCHours());
  RM.range;
  const CA = D5(
    (e) => e.setHours(0, 0, 0, 0),
    (e, t) => e.setDate(e.getDate() + t),
    (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * x4) / Q8,
    (e) => e.getDate() - 1
  );
  CA.range;
  const Oh = D5((e) => {
    e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t);
  }, (e, t) => (t - e) / Q8, (e) => e.getUTCDate() - 1);
  Oh.range;
  const mY = D5((e) => {
    e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t);
  }, (e, t) => (t - e) / Q8, (e) => Math.floor(e / Q8));
  mY.range;
  function Ji(e) {
    return D5((t) => {
      t.setDate(t.getDate() - (t.getDay() + 7 - e) % 7), t.setHours(0, 0, 0, 0);
    }, (t, r) => {
      t.setDate(t.getDate() + r * 7);
    }, (t, r) => (r - t - (r.getTimezoneOffset() - t.getTimezoneOffset()) * x4) / TM);
  }
  const Th = Ji(0), vp = Ji(1), El2 = Ji(2), ml2 = Ji(3), D9 = Ji(4), yl2 = Ji(5), Il2 = Ji(6);
  Th.range;
  vp.range;
  El2.range;
  ml2.range;
  D9.range;
  yl2.range;
  Il2.range;
  function ea(e) {
    return D5((t) => {
      t.setUTCDate(t.getUTCDate() - (t.getUTCDay() + 7 - e) % 7), t.setUTCHours(0, 0, 0, 0);
    }, (t, r) => {
      t.setUTCDate(t.getUTCDate() + r * 7);
    }, (t, r) => (r - t) / TM);
  }
  const Dh = ea(0), Ep = ea(1), Bl2 = ea(2), Ql2 = ea(3), L9 = ea(4), xl2 = ea(5), bl2 = ea(6);
  Dh.range;
  Ep.range;
  Bl2.range;
  Ql2.range;
  L9.range;
  xl2.range;
  bl2.range;
  const PM = D5((e) => {
    e.setDate(1), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setMonth(e.getMonth() + t);
  }, (e, t) => t.getMonth() - e.getMonth() + (t.getFullYear() - e.getFullYear()) * 12, (e) => e.getMonth());
  PM.range;
  const FM = D5((e) => {
    e.setUTCDate(1), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCMonth(e.getUTCMonth() + t);
  }, (e, t) => t.getUTCMonth() - e.getUTCMonth() + (t.getUTCFullYear() - e.getUTCFullYear()) * 12, (e) => e.getUTCMonth());
  FM.range;
  const x8 = D5((e) => {
    e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setFullYear(e.getFullYear() + t);
  }, (e, t) => t.getFullYear() - e.getFullYear(), (e) => e.getFullYear());
  x8.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : D5((t) => {
    t.setFullYear(Math.floor(t.getFullYear() / e) * e), t.setMonth(0, 1), t.setHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setFullYear(t.getFullYear() + r * e);
  });
  x8.range;
  const b8 = D5((e) => {
    e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCFullYear(e.getUTCFullYear() + t);
  }, (e, t) => t.getUTCFullYear() - e.getUTCFullYear(), (e) => e.getUTCFullYear());
  b8.every = (e) => !isFinite(e = Math.floor(e)) || !(e > 0) ? null : D5((t) => {
    t.setUTCFullYear(Math.floor(t.getUTCFullYear() / e) * e), t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  }, (t, r) => {
    t.setUTCFullYear(t.getUTCFullYear() + r * e);
  });
  b8.range;
  function yY(e, t, r, n, i, o) {
    const u = [
      [Ti, 1, C8],
      [Ti, 5, 5 * C8],
      [Ti, 15, 15 * C8],
      [Ti, 30, 30 * C8],
      [o, 1, x4],
      [o, 5, 5 * x4],
      [o, 15, 15 * x4],
      [o, 30, 30 * x4],
      [i, 1, d8],
      [i, 3, 3 * d8],
      [i, 6, 6 * d8],
      [i, 12, 12 * d8],
      [n, 1, Q8],
      [n, 2, 2 * Q8],
      [r, 1, TM],
      [t, 1, JN],
      [t, 3, 3 * JN],
      [e, 1, rx]
    ];
    function c(d, g, h) {
      const E = g < d;
      E && ([d, g] = [g, d]);
      const y = h && typeof h.range == "function" ? h : f(d, g, h), I = y ? y.range(d, +g + 1) : [];
      return E ? I.reverse() : I;
    }
    function f(d, g, h) {
      const E = Math.abs(g - d) / h, y = mM(([, , B]) => B).right(u, E);
      if (y === u.length) return e.every(tw(d / rx, g / rx, h));
      if (y === 0) return hp.every(Math.max(tw(d, g, h), 1));
      const [I, Q] = u[E / u[y - 1][2] < u[y][2] / E ? y - 1 : y];
      return I.every(Q);
    }
    return [c, f];
  }
  const [wl2, Sl2] = yY(b8, FM, Dh, mY, RM, LM), [Ml2, _l2] = yY(x8, PM, Th, CA, kM, DM);
  function nx(e) {
    if (0 <= e.y && e.y < 100) {
      var t = new Date(-1, e.m, e.d, e.H, e.M, e.S, e.L);
      return t.setFullYear(e.y), t;
    }
    return new Date(e.y, e.m, e.d, e.H, e.M, e.S, e.L);
  }
  function ix(e) {
    if (0 <= e.y && e.y < 100) {
      var t = new Date(Date.UTC(-1, e.m, e.d, e.H, e.M, e.S, e.L));
      return t.setUTCFullYear(e.y), t;
    }
    return new Date(Date.UTC(e.y, e.m, e.d, e.H, e.M, e.S, e.L));
  }
  function Ll(e, t, r) {
    return { y: e, m: t, d: r, H: 0, M: 0, S: 0, L: 0 };
  }
  function Ol2(e) {
    var t = e.dateTime, r = e.date, n = e.time, i = e.periods, o = e.days, u = e.shortDays, c = e.months, f = e.shortMonths, d = kl(i), g = Rl(i), h = kl(o), E = Rl(o), y = kl(u), I = Rl(u), Q = kl(c), B = Rl(c), _ = kl(f), M = Rl(f), S = {
      a: l2,
      A: X,
      b: a2,
      B: e2,
      c: null,
      d: aH,
      e: aH,
      f: ec2,
      g: cc2,
      G: fc2,
      H: Kl2,
      I: Xl2,
      j: Jl2,
      L: IY,
      m: tc2,
      M: rc2,
      p: H,
      q: Y,
      Q: uH,
      s: lH,
      S: nc2,
      u: ic2,
      U: ac2,
      V: oc2,
      w: sc2,
      W: uc2,
      x: null,
      X: null,
      y: lc2,
      Y: Ac2,
      Z: Cc2,
      "%": sH
    }, O = {
      a: r2,
      A: o2,
      b: O2,
      B: S2,
      c: null,
      d: oH,
      e: oH,
      f: hc2,
      g: wc2,
      G: Mc2,
      H: dc2,
      I: gc2,
      j: pc2,
      L: QY,
      m: vc2,
      M: Ec2,
      p: M2,
      q: w2,
      Q: uH,
      s: lH,
      S: mc2,
      u: yc2,
      U: Ic2,
      V: Bc2,
      w: Qc2,
      W: xc2,
      x: null,
      X: null,
      y: bc2,
      Y: Sc2,
      Z: _c2,
      "%": sH
    }, w = {
      a: Z,
      A: V,
      b: $,
      B: W,
      c: t2,
      d: nH,
      e: nH,
      f: Wl2,
      g: rH,
      G: tH,
      H: iH,
      I: iH,
      j: Zl2,
      L: ql2,
      m: Vl2,
      M: zl2,
      p: z,
      q: jl2,
      Q: $l2,
      s: Gl2,
      S: Ul2,
      u: Rl2,
      U: Pl2,
      V: Fl2,
      w: kl2,
      W: Nl2,
      x: n2,
      X: s2,
      y: rH,
      Y: tH,
      Z: Hl2,
      "%": Yl2
    };
    S.x = D(r, S), S.X = D(n, S), S.c = D(t, S), O.x = D(r, O), O.X = D(n, O), O.c = D(t, O);
    function D(v2, L2) {
      return function(W2) {
        var d2 = [], X2 = -1, k2 = 0, b0 = v2.length, S0, G0, $e;
        for (W2 instanceof Date || (W2 = /* @__PURE__ */ new Date(+W2)); ++X2 < b0; )
          v2.charCodeAt(X2) === 37 && (d2.push(v2.slice(k2, X2)), (G0 = eH[S0 = v2.charAt(++X2)]) != null ? S0 = v2.charAt(++X2) : G0 = S0 === "e" ? " " : "0", ($e = L2[S0]) && (S0 = $e(W2, G0)), d2.push(S0), k2 = X2 + 1);
        return d2.push(v2.slice(k2, X2)), d2.join("");
      };
    }
    function k(v2, L2) {
      return function(W2) {
        var d2 = Ll(1900, void 0, 1), X2 = F(d2, v2, W2 += "", 0), k2, b0;
        if (X2 != W2.length) return null;
        if ("Q" in d2) return new Date(d2.Q);
        if ("s" in d2) return new Date(d2.s * 1e3 + ("L" in d2 ? d2.L : 0));
        if (L2 && !("Z" in d2) && (d2.Z = 0), "p" in d2 && (d2.H = d2.H % 12 + d2.p * 12), d2.m === void 0 && (d2.m = "q" in d2 ? d2.q : 0), "V" in d2) {
          if (d2.V < 1 || d2.V > 53) return null;
          "w" in d2 || (d2.w = 1), "Z" in d2 ? (k2 = ix(Ll(d2.y, 0, 1)), b0 = k2.getUTCDay(), k2 = b0 > 4 || b0 === 0 ? Ep.ceil(k2) : Ep(k2), k2 = Oh.offset(k2, (d2.V - 1) * 7), d2.y = k2.getUTCFullYear(), d2.m = k2.getUTCMonth(), d2.d = k2.getUTCDate() + (d2.w + 6) % 7) : (k2 = nx(Ll(d2.y, 0, 1)), b0 = k2.getDay(), k2 = b0 > 4 || b0 === 0 ? vp.ceil(k2) : vp(k2), k2 = CA.offset(k2, (d2.V - 1) * 7), d2.y = k2.getFullYear(), d2.m = k2.getMonth(), d2.d = k2.getDate() + (d2.w + 6) % 7);
        } else ("W" in d2 || "U" in d2) && ("w" in d2 || (d2.w = "u" in d2 ? d2.u % 7 : "W" in d2 ? 1 : 0), b0 = "Z" in d2 ? ix(Ll(d2.y, 0, 1)).getUTCDay() : nx(Ll(d2.y, 0, 1)).getDay(), d2.m = 0, d2.d = "W" in d2 ? (d2.w + 6) % 7 + d2.W * 7 - (b0 + 5) % 7 : d2.w + d2.U * 7 - (b0 + 6) % 7);
        return "Z" in d2 ? (d2.H += d2.Z / 100 | 0, d2.M += d2.Z % 100, ix(d2)) : nx(d2);
      };
    }
    function F(v2, L2, W2, d2) {
      for (var X2 = 0, k2 = L2.length, b0 = W2.length, S0, G0; X2 < k2; ) {
        if (d2 >= b0) return -1;
        if (S0 = L2.charCodeAt(X2++), S0 === 37) {
          if (S0 = L2.charAt(X2++), G0 = w[S0 in eH ? L2.charAt(X2++) : S0], !G0 || (d2 = G0(v2, W2, d2)) < 0) return -1;
        } else if (S0 != W2.charCodeAt(d2++))
          return -1;
      }
      return d2;
    }
    function z(v2, L2, W2) {
      var d2 = d.exec(L2.slice(W2));
      return d2 ? (v2.p = g.get(d2[0].toLowerCase()), W2 + d2[0].length) : -1;
    }
    function Z(v2, L2, W2) {
      var d2 = y.exec(L2.slice(W2));
      return d2 ? (v2.w = I.get(d2[0].toLowerCase()), W2 + d2[0].length) : -1;
    }
    function V(v2, L2, W2) {
      var d2 = h.exec(L2.slice(W2));
      return d2 ? (v2.w = E.get(d2[0].toLowerCase()), W2 + d2[0].length) : -1;
    }
    function $(v2, L2, W2) {
      var d2 = _.exec(L2.slice(W2));
      return d2 ? (v2.m = M.get(d2[0].toLowerCase()), W2 + d2[0].length) : -1;
    }
    function W(v2, L2, W2) {
      var d2 = Q.exec(L2.slice(W2));
      return d2 ? (v2.m = B.get(d2[0].toLowerCase()), W2 + d2[0].length) : -1;
    }
    function t2(v2, L2, W2) {
      return F(v2, t, L2, W2);
    }
    function n2(v2, L2, W2) {
      return F(v2, r, L2, W2);
    }
    function s2(v2, L2, W2) {
      return F(v2, n, L2, W2);
    }
    function l2(v2) {
      return u[v2.getDay()];
    }
    function X(v2) {
      return o[v2.getDay()];
    }
    function a2(v2) {
      return f[v2.getMonth()];
    }
    function e2(v2) {
      return c[v2.getMonth()];
    }
    function H(v2) {
      return i[+(v2.getHours() >= 12)];
    }
    function Y(v2) {
      return 1 + ~~(v2.getMonth() / 3);
    }
    function r2(v2) {
      return u[v2.getUTCDay()];
    }
    function o2(v2) {
      return o[v2.getUTCDay()];
    }
    function O2(v2) {
      return f[v2.getUTCMonth()];
    }
    function S2(v2) {
      return c[v2.getUTCMonth()];
    }
    function M2(v2) {
      return i[+(v2.getUTCHours() >= 12)];
    }
    function w2(v2) {
      return 1 + ~~(v2.getUTCMonth() / 3);
    }
    return {
      format: function(v2) {
        var L2 = D(v2 += "", S);
        return L2.toString = function() {
          return v2;
        }, L2;
      },
      parse: function(v2) {
        var L2 = k(v2 += "", !1);
        return L2.toString = function() {
          return v2;
        }, L2;
      },
      utcFormat: function(v2) {
        var L2 = D(v2 += "", O);
        return L2.toString = function() {
          return v2;
        }, L2;
      },
      utcParse: function(v2) {
        var L2 = k(v2 += "", !0);
        return L2.toString = function() {
          return v2;
        }, L2;
      }
    };
  }
  var eH = { "-": "", _: " ", 0: "0" }, j5 = /^\s*\d+/, Tl2 = /^%/, Dl2 = /[\\^$*+?|[\]().{}]/g;
  function Me(e, t, r) {
    var n = e < 0 ? "-" : "", i = (n ? -e : e) + "", o = i.length;
    return n + (o < r ? new Array(r - o + 1).join(t) + i : i);
  }
  function Ll2(e) {
    return e.replace(Dl2, "\\$&");
  }
  function kl(e) {
    return new RegExp("^(?:" + e.map(Ll2).join("|") + ")", "i");
  }
  function Rl(e) {
    return new Map(e.map((t, r) => [t.toLowerCase(), r]));
  }
  function kl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 1));
    return n ? (e.w = +n[0], r + n[0].length) : -1;
  }
  function Rl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 1));
    return n ? (e.u = +n[0], r + n[0].length) : -1;
  }
  function Pl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.U = +n[0], r + n[0].length) : -1;
  }
  function Fl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.V = +n[0], r + n[0].length) : -1;
  }
  function Nl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.W = +n[0], r + n[0].length) : -1;
  }
  function tH(e, t, r) {
    var n = j5.exec(t.slice(r, r + 4));
    return n ? (e.y = +n[0], r + n[0].length) : -1;
  }
  function rH(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.y = +n[0] + (+n[0] > 68 ? 1900 : 2e3), r + n[0].length) : -1;
  }
  function Hl2(e, t, r) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(t.slice(r, r + 6));
    return n ? (e.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), r + n[0].length) : -1;
  }
  function jl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 1));
    return n ? (e.q = n[0] * 3 - 3, r + n[0].length) : -1;
  }
  function Vl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.m = n[0] - 1, r + n[0].length) : -1;
  }
  function nH(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.d = +n[0], r + n[0].length) : -1;
  }
  function Zl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 3));
    return n ? (e.m = 0, e.d = +n[0], r + n[0].length) : -1;
  }
  function iH(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.H = +n[0], r + n[0].length) : -1;
  }
  function zl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.M = +n[0], r + n[0].length) : -1;
  }
  function Ul2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 2));
    return n ? (e.S = +n[0], r + n[0].length) : -1;
  }
  function ql2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 3));
    return n ? (e.L = +n[0], r + n[0].length) : -1;
  }
  function Wl2(e, t, r) {
    var n = j5.exec(t.slice(r, r + 6));
    return n ? (e.L = Math.floor(n[0] / 1e3), r + n[0].length) : -1;
  }
  function Yl2(e, t, r) {
    var n = Tl2.exec(t.slice(r, r + 1));
    return n ? r + n[0].length : -1;
  }
  function $l2(e, t, r) {
    var n = j5.exec(t.slice(r));
    return n ? (e.Q = +n[0], r + n[0].length) : -1;
  }
  function Gl2(e, t, r) {
    var n = j5.exec(t.slice(r));
    return n ? (e.s = +n[0], r + n[0].length) : -1;
  }
  function aH(e, t) {
    return Me(e.getDate(), t, 2);
  }
  function Kl2(e, t) {
    return Me(e.getHours(), t, 2);
  }
  function Xl2(e, t) {
    return Me(e.getHours() % 12 || 12, t, 2);
  }
  function Jl2(e, t) {
    return Me(1 + CA.count(x8(e), e), t, 3);
  }
  function IY(e, t) {
    return Me(e.getMilliseconds(), t, 3);
  }
  function ec2(e, t) {
    return IY(e, t) + "000";
  }
  function tc2(e, t) {
    return Me(e.getMonth() + 1, t, 2);
  }
  function rc2(e, t) {
    return Me(e.getMinutes(), t, 2);
  }
  function nc2(e, t) {
    return Me(e.getSeconds(), t, 2);
  }
  function ic2(e) {
    var t = e.getDay();
    return t === 0 ? 7 : t;
  }
  function ac2(e, t) {
    return Me(Th.count(x8(e) - 1, e), t, 2);
  }
  function BY(e) {
    var t = e.getDay();
    return t >= 4 || t === 0 ? D9(e) : D9.ceil(e);
  }
  function oc2(e, t) {
    return e = BY(e), Me(D9.count(x8(e), e) + (x8(e).getDay() === 4), t, 2);
  }
  function sc2(e) {
    return e.getDay();
  }
  function uc2(e, t) {
    return Me(vp.count(x8(e) - 1, e), t, 2);
  }
  function lc2(e, t) {
    return Me(e.getFullYear() % 100, t, 2);
  }
  function cc2(e, t) {
    return e = BY(e), Me(e.getFullYear() % 100, t, 2);
  }
  function Ac2(e, t) {
    return Me(e.getFullYear() % 1e4, t, 4);
  }
  function fc2(e, t) {
    var r = e.getDay();
    return e = r >= 4 || r === 0 ? D9(e) : D9.ceil(e), Me(e.getFullYear() % 1e4, t, 4);
  }
  function Cc2(e) {
    var t = e.getTimezoneOffset();
    return (t > 0 ? "-" : (t *= -1, "+")) + Me(t / 60 | 0, "0", 2) + Me(t % 60, "0", 2);
  }
  function oH(e, t) {
    return Me(e.getUTCDate(), t, 2);
  }
  function dc2(e, t) {
    return Me(e.getUTCHours(), t, 2);
  }
  function gc2(e, t) {
    return Me(e.getUTCHours() % 12 || 12, t, 2);
  }
  function pc2(e, t) {
    return Me(1 + Oh.count(b8(e), e), t, 3);
  }
  function QY(e, t) {
    return Me(e.getUTCMilliseconds(), t, 3);
  }
  function hc2(e, t) {
    return QY(e, t) + "000";
  }
  function vc2(e, t) {
    return Me(e.getUTCMonth() + 1, t, 2);
  }
  function Ec2(e, t) {
    return Me(e.getUTCMinutes(), t, 2);
  }
  function mc2(e, t) {
    return Me(e.getUTCSeconds(), t, 2);
  }
  function yc2(e) {
    var t = e.getUTCDay();
    return t === 0 ? 7 : t;
  }
  function Ic2(e, t) {
    return Me(Dh.count(b8(e) - 1, e), t, 2);
  }
  function xY(e) {
    var t = e.getUTCDay();
    return t >= 4 || t === 0 ? L9(e) : L9.ceil(e);
  }
  function Bc2(e, t) {
    return e = xY(e), Me(L9.count(b8(e), e) + (b8(e).getUTCDay() === 4), t, 2);
  }
  function Qc2(e) {
    return e.getUTCDay();
  }
  function xc2(e, t) {
    return Me(Ep.count(b8(e) - 1, e), t, 2);
  }
  function bc2(e, t) {
    return Me(e.getUTCFullYear() % 100, t, 2);
  }
  function wc2(e, t) {
    return e = xY(e), Me(e.getUTCFullYear() % 100, t, 2);
  }
  function Sc2(e, t) {
    return Me(e.getUTCFullYear() % 1e4, t, 4);
  }
  function Mc2(e, t) {
    var r = e.getUTCDay();
    return e = r >= 4 || r === 0 ? L9(e) : L9.ceil(e), Me(e.getUTCFullYear() % 1e4, t, 4);
  }
  function _c2() {
    return "+0000";
  }
  function sH() {
    return "%";
  }
  function uH(e) {
    return +e;
  }
  function lH(e) {
    return Math.floor(+e / 1e3);
  }
  var Ko, bY, wY;
  Oc2({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: ["AM", "PM"],
    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
  });
  function Oc2(e) {
    return Ko = Ol2(e), bY = Ko.format, Ko.parse, wY = Ko.utcFormat, Ko.utcParse, Ko;
  }
  function Tc2(e) {
    return new Date(e);
  }
  function Dc2(e) {
    return e instanceof Date ? +e : +/* @__PURE__ */ new Date(+e);
  }
  function NM(e, t, r, n, i, o, u, c, f, d) {
    var g = xM(), h = g.invert, E = g.domain, y = d(".%L"), I = d(":%S"), Q = d("%I:%M"), B = d("%I %p"), _ = d("%a %d"), M = d("%b %d"), S = d("%B"), O = d("%Y");
    function w(D) {
      return (f(D) < D ? y : c(D) < D ? I : u(D) < D ? Q : o(D) < D ? B : n(D) < D ? i(D) < D ? _ : M : r(D) < D ? S : O)(D);
    }
    return g.invert = function(D) {
      return new Date(h(D));
    }, g.domain = function(D) {
      return arguments.length ? E(Array.from(D, Dc2)) : E().map(Tc2);
    }, g.ticks = function(D) {
      var k = E();
      return e(k[0], k[k.length - 1], D ?? 10);
    }, g.tickFormat = function(D, k) {
      return k == null ? w : d(k);
    }, g.nice = function(D) {
      var k = E();
      return (!D || typeof D.range != "function") && (D = t(k[0], k[k.length - 1], D ?? 10)), D ? E(CY(k, D)) : g;
    }, g.copy = function() {
      return fA(g, NM(e, t, r, n, i, o, u, c, f, d));
    }, g;
  }
  function Lc2() {
    return O4.apply(NM(Ml2, _l2, x8, PM, Th, CA, kM, DM, Ti, bY).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
  }
  function kc2() {
    return O4.apply(NM(wl2, Sl2, b8, FM, Dh, Oh, RM, LM, Ti, wY).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
  }
  function Lh() {
    var e = 0, t = 1, r, n, i, o, u = $1, c = !1, f;
    function d(h) {
      return h == null || isNaN(h = +h) ? f : u(i === 0 ? 0.5 : (h = (o(h) - r) * i, c ? Math.max(0, Math.min(1, h)) : h));
    }
    d.domain = function(h) {
      return arguments.length ? ([e, t] = h, r = o(e = +e), n = o(t = +t), i = r === n ? 0 : 1 / (n - r), d) : [e, t];
    }, d.clamp = function(h) {
      return arguments.length ? (c = !!h, d) : c;
    }, d.interpolator = function(h) {
      return arguments.length ? (u = h, d) : u;
    };
    function g(h) {
      return function(E) {
        var y, I;
        return arguments.length ? ([y, I] = E, u = h(y, I), d) : [u(0), u(1)];
      };
    }
    return d.range = g(fs), d.rangeRound = g(QM), d.unknown = function(h) {
      return arguments.length ? (f = h, d) : f;
    }, function(h) {
      return o = h, r = h(e), n = h(t), i = r === n ? 0 : 1 / (n - r), d;
    };
  }
  function e7(e, t) {
    return t.domain(e.domain()).interpolator(e.interpolator()).clamp(e.clamp()).unknown(e.unknown());
  }
  function SY() {
    var e = J6(Lh()($1));
    return e.copy = function() {
      return e7(e, SY());
    }, O8.apply(e, arguments);
  }
  function MY() {
    var e = SM(Lh()).domain([1, 10]);
    return e.copy = function() {
      return e7(e, MY()).base(e.base());
    }, O8.apply(e, arguments);
  }
  function _Y() {
    var e = MM(Lh());
    return e.copy = function() {
      return e7(e, _Y()).constant(e.constant());
    }, O8.apply(e, arguments);
  }
  function HM() {
    var e = _M(Lh());
    return e.copy = function() {
      return e7(e, HM()).exponent(e.exponent());
    }, O8.apply(e, arguments);
  }
  function Rc2() {
    return HM.apply(null, arguments).exponent(0.5);
  }
  function OY() {
    var e = [], t = $1;
    function r(n) {
      if (n != null && !isNaN(n = +n)) return t((cA(e, n, 1) - 1) / (e.length - 1));
    }
    return r.domain = function(n) {
      if (!arguments.length) return e.slice();
      e = [];
      for (let i of n) i != null && !isNaN(i = +i) && e.push(i);
      return e.sort(H6), r;
    }, r.interpolator = function(n) {
      return arguments.length ? (t = n, r) : t;
    }, r.range = function() {
      return e.map((n, i) => t(i / (e.length - 1)));
    }, r.quantiles = function(n) {
      return Array.from({ length: n + 1 }, (i, o) => Iu2(e, o / n));
    }, r.copy = function() {
      return OY(t).domain(e);
    }, O8.apply(r, arguments);
  }
  function kh() {
    var e = 0, t = 0.5, r = 1, n = 1, i, o, u, c, f, d = $1, g, h = !1, E;
    function y(Q) {
      return isNaN(Q = +Q) ? E : (Q = 0.5 + ((Q = +g(Q)) - o) * (n * Q < n * o ? c : f), d(h ? Math.max(0, Math.min(1, Q)) : Q));
    }
    y.domain = function(Q) {
      return arguments.length ? ([e, t, r] = Q, i = g(e = +e), o = g(t = +t), u = g(r = +r), c = i === o ? 0 : 0.5 / (o - i), f = o === u ? 0 : 0.5 / (u - o), n = o < i ? -1 : 1, y) : [e, t, r];
    }, y.clamp = function(Q) {
      return arguments.length ? (h = !!Q, y) : h;
    }, y.interpolator = function(Q) {
      return arguments.length ? (d = Q, y) : d;
    };
    function I(Q) {
      return function(B) {
        var _, M, S;
        return arguments.length ? ([_, M, S] = B, d = Yu2(Q, [_, M, S]), y) : [d(0), d(0.5), d(1)];
      };
    }
    return y.range = I(fs), y.rangeRound = I(QM), y.unknown = function(Q) {
      return arguments.length ? (E = Q, y) : E;
    }, function(Q) {
      return g = Q, i = Q(e), o = Q(t), u = Q(r), c = i === o ? 0 : 0.5 / (o - i), f = o === u ? 0 : 0.5 / (u - o), n = o < i ? -1 : 1, y;
    };
  }
  function TY() {
    var e = J6(kh()($1));
    return e.copy = function() {
      return e7(e, TY());
    }, O8.apply(e, arguments);
  }
  function DY() {
    var e = SM(kh()).domain([0.1, 1, 10]);
    return e.copy = function() {
      return e7(e, DY()).base(e.base());
    }, O8.apply(e, arguments);
  }
  function LY() {
    var e = MM(kh());
    return e.copy = function() {
      return e7(e, LY()).constant(e.constant());
    }, O8.apply(e, arguments);
  }
  function jM() {
    var e = _M(kh());
    return e.copy = function() {
      return e7(e, jM()).exponent(e.exponent());
    }, O8.apply(e, arguments);
  }
  function Pc2() {
    return jM.apply(null, arguments).exponent(0.5);
  }
  const cH = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    scaleBand: xc,
    scaleDiverging: TY,
    scaleDivergingLog: DY,
    scaleDivergingPow: jM,
    scaleDivergingSqrt: Pc2,
    scaleDivergingSymlog: LY,
    scaleIdentity: fY,
    scaleImplicit: rw,
    scaleLinear: pp,
    scaleLog: dY,
    scaleOrdinal: yM,
    scalePoint: nc,
    scalePow: OM,
    scaleQuantile: hY,
    scaleQuantize: vY,
    scaleRadial: pY,
    scaleSequential: SY,
    scaleSequentialLog: MY,
    scaleSequentialPow: HM,
    scaleSequentialQuantile: OY,
    scaleSequentialSqrt: Rc2,
    scaleSequentialSymlog: _Y,
    scaleSqrt: hl2,
    scaleSymlog: gY,
    scaleThreshold: EY,
    scaleTime: Lc2,
    scaleUtc: kc2,
    tickFormat: AY
  }, Symbol.toStringTag, { value: "Module" }));
  var ax, AH;
  function kY() {
    if (AH) return ax;
    AH = 1;
    var e = us();
    function t(r, n, i) {
      for (var o = -1, u = r.length; ++o < u; ) {
        var c = r[o], f = n(c);
        if (f != null && (d === void 0 ? f === f && !e(f) : i(f, d)))
          var d = f, g = c;
      }
      return g;
    }
    return ax = t, ax;
  }
  var ox, fH;
  function Fc2() {
    if (fH) return ox;
    fH = 1;
    function e(t, r) {
      return t > r;
    }
    return ox = e, ox;
  }
  var sx, CH;
  function Nc2() {
    if (CH) return sx;
    CH = 1;
    var e = kY(), t = Fc2(), r = cs();
    function n(i) {
      return i && i.length ? e(i, r, t) : void 0;
    }
    return sx = n, sx;
  }
  var Hc2 = Nc2();
  const Rh = /* @__PURE__ */ tt(Hc2);
  var ux, dH;
  function jc2() {
    if (dH) return ux;
    dH = 1;
    function e(t, r) {
      return t < r;
    }
    return ux = e, ux;
  }
  var lx, gH;
  function Vc2() {
    if (gH) return lx;
    gH = 1;
    var e = kY(), t = jc2(), r = cs();
    function n(i) {
      return i && i.length ? e(i, r, t) : void 0;
    }
    return lx = n, lx;
  }
  var Zc2 = Vc2();
  const Ph = /* @__PURE__ */ tt(Zc2);
  var cx, pH;
  function zc2() {
    if (pH) return cx;
    pH = 1;
    var e = nM(), t = X6(), r = ZW(), n = Ir();
    function i(o, u) {
      var c = n(o) ? e : r;
      return c(o, t(u, 3));
    }
    return cx = i, cx;
  }
  var Ax, hH;
  function Uc2() {
    if (hH) return Ax;
    hH = 1;
    var e = jW(), t = zc2();
    function r(n, i) {
      return e(t(n, i), 1);
    }
    return Ax = r, Ax;
  }
  var qc2 = Uc2();
  const Wc2 = /* @__PURE__ */ tt(qc2);
  var fx, vH;
  function Yc2() {
    if (vH) return fx;
    vH = 1;
    var e = pM();
    function t(r, n) {
      return e(r, n);
    }
    return fx = t, fx;
  }
  var $c2 = Yc2();
  const Fh = /* @__PURE__ */ tt($c2);
  var Cs = 1e9, Gc2 = {
    // These values must be integers within the stated ranges (inclusive).
    // Most of these values can be changed during run-time using `Decimal.config`.
    // The maximum number of significant digits of the result of a calculation or base conversion.
    // E.g. `Decimal.config({ precision: 20 });`
    precision: 20,
    // 1 to MAX_DIGITS
    // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
    // `toFixed`, `toPrecision` and `toSignificantDigits`.
    //
    // ROUND_UP         0 Away from zero.
    // ROUND_DOWN       1 Towards zero.
    // ROUND_CEIL       2 Towards +Infinity.
    // ROUND_FLOOR      3 Towards -Infinity.
    // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
    // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
    // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
    // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
    // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
    //
    // E.g.
    // `Decimal.rounding = 4;`
    // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
    rounding: 4,
    // 0 to 8
    // The exponent value at and beneath which `toString` returns exponential notation.
    // JavaScript numbers: -7
    toExpNeg: -7,
    // 0 to -MAX_E
    // The exponent value at and above which `toString` returns exponential notation.
    // JavaScript numbers: 21
    toExpPos: 21,
    // 0 to MAX_E
    // The natural logarithm of 10.
    // 115 digits
    LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
  }, ZM, Bt = !0, _4 = "[DecimalError] ", Ri = _4 + "Invalid argument: ", VM = _4 + "Exponent out of range: ", ds = Math.floor, Qi = Math.pow, Kc2 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, Ur, F5 = 1e7, mt = 7, RY = 9007199254740991, mp = ds(RY / mt), g0 = {};
  g0.absoluteValue = g0.abs = function() {
    var e = new this.constructor(this);
    return e.s && (e.s = 1), e;
  };
  g0.comparedTo = g0.cmp = function(e) {
    var t, r, n, i, o = this;
    if (e = new o.constructor(e), o.s !== e.s) return o.s || -e.s;
    if (o.e !== e.e) return o.e > e.e ^ o.s < 0 ? 1 : -1;
    for (n = o.d.length, i = e.d.length, t = 0, r = n < i ? n : i; t < r; ++t)
      if (o.d[t] !== e.d[t]) return o.d[t] > e.d[t] ^ o.s < 0 ? 1 : -1;
    return n === i ? 0 : n > i ^ o.s < 0 ? 1 : -1;
  };
  g0.decimalPlaces = g0.dp = function() {
    var e = this, t = e.d.length - 1, r = (t - e.e) * mt;
    if (t = e.d[t], t) for (; t % 10 == 0; t /= 10) r--;
    return r < 0 ? 0 : r;
  };
  g0.dividedBy = g0.div = function(e) {
    return E8(this, new this.constructor(e));
  };
  g0.dividedToIntegerBy = g0.idiv = function(e) {
    var t = this, r = t.constructor;
    return ft(E8(t, new r(e), 0, 1), r.precision);
  };
  g0.equals = g0.eq = function(e) {
    return !this.cmp(e);
  };
  g0.exponent = function() {
    return C5(this);
  };
  g0.greaterThan = g0.gt = function(e) {
    return this.cmp(e) > 0;
  };
  g0.greaterThanOrEqualTo = g0.gte = function(e) {
    return this.cmp(e) >= 0;
  };
  g0.isInteger = g0.isint = function() {
    return this.e > this.d.length - 2;
  };
  g0.isNegative = g0.isneg = function() {
    return this.s < 0;
  };
  g0.isPositive = g0.ispos = function() {
    return this.s > 0;
  };
  g0.isZero = function() {
    return this.s === 0;
  };
  g0.lessThan = g0.lt = function(e) {
    return this.cmp(e) < 0;
  };
  g0.lessThanOrEqualTo = g0.lte = function(e) {
    return this.cmp(e) < 1;
  };
  g0.logarithm = g0.log = function(e) {
    var t, r = this, n = r.constructor, i = n.precision, o = i + 5;
    if (e === void 0)
      e = new n(10);
    else if (e = new n(e), e.s < 1 || e.eq(Ur)) throw Error(_4 + "NaN");
    if (r.s < 1) throw Error(_4 + (r.s ? "NaN" : "-Infinity"));
    return r.eq(Ur) ? new n(0) : (Bt = !1, t = E8(_c(r, o), _c(e, o), o), Bt = !0, ft(t, i));
  };
  g0.minus = g0.sub = function(e) {
    var t = this;
    return e = new t.constructor(e), t.s == e.s ? NY(t, e) : PY(t, (e.s = -e.s, e));
  };
  g0.modulo = g0.mod = function(e) {
    var t, r = this, n = r.constructor, i = n.precision;
    if (e = new n(e), !e.s) throw Error(_4 + "NaN");
    return r.s ? (Bt = !1, t = E8(r, e, 0, 1).times(e), Bt = !0, r.minus(t)) : ft(new n(r), i);
  };
  g0.naturalExponential = g0.exp = function() {
    return FY(this);
  };
  g0.naturalLogarithm = g0.ln = function() {
    return _c(this);
  };
  g0.negated = g0.neg = function() {
    var e = new this.constructor(this);
    return e.s = -e.s || 0, e;
  };
  g0.plus = g0.add = function(e) {
    var t = this;
    return e = new t.constructor(e), t.s == e.s ? PY(t, e) : NY(t, (e.s = -e.s, e));
  };
  g0.precision = g0.sd = function(e) {
    var t, r, n, i = this;
    if (e !== void 0 && e !== !!e && e !== 1 && e !== 0) throw Error(Ri + e);
    if (t = C5(i) + 1, n = i.d.length - 1, r = n * mt + 1, n = i.d[n], n) {
      for (; n % 10 == 0; n /= 10) r--;
      for (n = i.d[0]; n >= 10; n /= 10) r++;
    }
    return e && t > r ? t : r;
  };
  g0.squareRoot = g0.sqrt = function() {
    var e, t, r, n, i, o, u, c = this, f = c.constructor;
    if (c.s < 1) {
      if (!c.s) return new f(0);
      throw Error(_4 + "NaN");
    }
    for (e = C5(c), Bt = !1, i = Math.sqrt(+c), i == 0 || i == 1 / 0 ? (t = u3(c.d), (t.length + e) % 2 == 0 && (t += "0"), i = Math.sqrt(t), e = ds((e + 1) / 2) - (e < 0 || e % 2), i == 1 / 0 ? t = "5e" + e : (t = i.toExponential(), t = t.slice(0, t.indexOf("e") + 1) + e), n = new f(t)) : n = new f(i.toString()), r = f.precision, i = u = r + 3; ; )
      if (o = n, n = o.plus(E8(c, o, u + 2)).times(0.5), u3(o.d).slice(0, u) === (t = u3(n.d)).slice(0, u)) {
        if (t = t.slice(u - 3, u + 1), i == u && t == "4999") {
          if (ft(o, r + 1, 0), o.times(o).eq(c)) {
            n = o;
            break;
          }
        } else if (t != "9999")
          break;
        u += 4;
      }
    return Bt = !0, ft(n, r);
  };
  g0.times = g0.mul = function(e) {
    var t, r, n, i, o, u, c, f, d, g = this, h = g.constructor, E = g.d, y = (e = new h(e)).d;
    if (!g.s || !e.s) return new h(0);
    for (e.s *= g.s, r = g.e + e.e, f = E.length, d = y.length, f < d && (o = E, E = y, y = o, u = f, f = d, d = u), o = [], u = f + d, n = u; n--; ) o.push(0);
    for (n = d; --n >= 0; ) {
      for (t = 0, i = f + n; i > n; )
        c = o[i] + y[n] * E[i - n - 1] + t, o[i--] = c % F5 | 0, t = c / F5 | 0;
      o[i] = (o[i] + t) % F5 | 0;
    }
    for (; !o[--u]; ) o.pop();
    return t ? ++r : o.shift(), e.d = o, e.e = r, Bt ? ft(e, h.precision) : e;
  };
  g0.toDecimalPlaces = g0.todp = function(e, t) {
    var r = this, n = r.constructor;
    return r = new n(r), e === void 0 ? r : (d3(e, 0, Cs), t === void 0 ? t = n.rounding : d3(t, 0, 8), ft(r, e + C5(r) + 1, t));
  };
  g0.toExponential = function(e, t) {
    var r, n = this, i = n.constructor;
    return e === void 0 ? r = zi(n, !0) : (d3(e, 0, Cs), t === void 0 ? t = i.rounding : d3(t, 0, 8), n = ft(new i(n), e + 1, t), r = zi(n, !0, e + 1)), r;
  };
  g0.toFixed = function(e, t) {
    var r, n, i = this, o = i.constructor;
    return e === void 0 ? zi(i) : (d3(e, 0, Cs), t === void 0 ? t = o.rounding : d3(t, 0, 8), n = ft(new o(i), e + C5(i) + 1, t), r = zi(n.abs(), !1, e + C5(n) + 1), i.isneg() && !i.isZero() ? "-" + r : r);
  };
  g0.toInteger = g0.toint = function() {
    var e = this, t = e.constructor;
    return ft(new t(e), C5(e) + 1, t.rounding);
  };
  g0.toNumber = function() {
    return +this;
  };
  g0.toPower = g0.pow = function(e) {
    var t, r, n, i, o, u, c = this, f = c.constructor, d = 12, g = +(e = new f(e));
    if (!e.s) return new f(Ur);
    if (c = new f(c), !c.s) {
      if (e.s < 1) throw Error(_4 + "Infinity");
      return c;
    }
    if (c.eq(Ur)) return c;
    if (n = f.precision, e.eq(Ur)) return ft(c, n);
    if (t = e.e, r = e.d.length - 1, u = t >= r, o = c.s, u) {
      if ((r = g < 0 ? -g : g) <= RY) {
        for (i = new f(Ur), t = Math.ceil(n / mt + 4), Bt = !1; r % 2 && (i = i.times(c), mH(i.d, t)), r = ds(r / 2), r !== 0; )
          c = c.times(c), mH(c.d, t);
        return Bt = !0, e.s < 0 ? new f(Ur).div(i) : ft(i, n);
      }
    } else if (o < 0) throw Error(_4 + "NaN");
    return o = o < 0 && e.d[Math.max(t, r)] & 1 ? -1 : 1, c.s = 1, Bt = !1, i = e.times(_c(c, n + d)), Bt = !0, i = FY(i), i.s = o, i;
  };
  g0.toPrecision = function(e, t) {
    var r, n, i = this, o = i.constructor;
    return e === void 0 ? (r = C5(i), n = zi(i, r <= o.toExpNeg || r >= o.toExpPos)) : (d3(e, 1, Cs), t === void 0 ? t = o.rounding : d3(t, 0, 8), i = ft(new o(i), e, t), r = C5(i), n = zi(i, e <= r || r <= o.toExpNeg, e)), n;
  };
  g0.toSignificantDigits = g0.tosd = function(e, t) {
    var r = this, n = r.constructor;
    return e === void 0 ? (e = n.precision, t = n.rounding) : (d3(e, 1, Cs), t === void 0 ? t = n.rounding : d3(t, 0, 8)), ft(new n(r), e, t);
  };
  g0.toString = g0.valueOf = g0.val = g0.toJSON = g0[Symbol.for("nodejs.util.inspect.custom")] = function() {
    var e = this, t = C5(e), r = e.constructor;
    return zi(e, t <= r.toExpNeg || t >= r.toExpPos);
  };
  function PY(e, t) {
    var r, n, i, o, u, c, f, d, g = e.constructor, h = g.precision;
    if (!e.s || !t.s)
      return t.s || (t = new g(e)), Bt ? ft(t, h) : t;
    if (f = e.d, d = t.d, u = e.e, i = t.e, f = f.slice(), o = u - i, o) {
      for (o < 0 ? (n = f, o = -o, c = d.length) : (n = d, i = u, c = f.length), u = Math.ceil(h / mt), c = u > c ? u + 1 : c + 1, o > c && (o = c, n.length = 1), n.reverse(); o--; ) n.push(0);
      n.reverse();
    }
    for (c = f.length, o = d.length, c - o < 0 && (o = c, n = d, d = f, f = n), r = 0; o; )
      r = (f[--o] = f[o] + d[o] + r) / F5 | 0, f[o] %= F5;
    for (r && (f.unshift(r), ++i), c = f.length; f[--c] == 0; ) f.pop();
    return t.d = f, t.e = i, Bt ? ft(t, h) : t;
  }
  function d3(e, t, r) {
    if (e !== ~~e || e < t || e > r)
      throw Error(Ri + e);
  }
  function u3(e) {
    var t, r, n, i = e.length - 1, o = "", u = e[0];
    if (i > 0) {
      for (o += u, t = 1; t < i; t++)
        n = e[t] + "", r = mt - n.length, r && (o += R6(r)), o += n;
      u = e[t], n = u + "", r = mt - n.length, r && (o += R6(r));
    } else if (u === 0)
      return "0";
    for (; u % 10 === 0; ) u /= 10;
    return o + u;
  }
  var E8 = /* @__PURE__ */ function() {
    function e(n, i) {
      var o, u = 0, c = n.length;
      for (n = n.slice(); c--; )
        o = n[c] * i + u, n[c] = o % F5 | 0, u = o / F5 | 0;
      return u && n.unshift(u), n;
    }
    function t(n, i, o, u) {
      var c, f;
      if (o != u)
        f = o > u ? 1 : -1;
      else
        for (c = f = 0; c < o; c++)
          if (n[c] != i[c]) {
            f = n[c] > i[c] ? 1 : -1;
            break;
          }
      return f;
    }
    function r(n, i, o) {
      for (var u = 0; o--; )
        n[o] -= u, u = n[o] < i[o] ? 1 : 0, n[o] = u * F5 + n[o] - i[o];
      for (; !n[0] && n.length > 1; ) n.shift();
    }
    return function(n, i, o, u) {
      var c, f, d, g, h, E, y, I, Q, B, _, M, S, O, w, D, k, F, z = n.constructor, Z = n.s == i.s ? 1 : -1, V = n.d, $ = i.d;
      if (!n.s) return new z(n);
      if (!i.s) throw Error(_4 + "Division by zero");
      for (f = n.e - i.e, k = $.length, w = V.length, y = new z(Z), I = y.d = [], d = 0; $[d] == (V[d] || 0); ) ++d;
      if ($[d] > (V[d] || 0) && --f, o == null ? M = o = z.precision : u ? M = o + (C5(n) - C5(i)) + 1 : M = o, M < 0) return new z(0);
      if (M = M / mt + 2 | 0, d = 0, k == 1)
        for (g = 0, $ = $[0], M++; (d < w || g) && M--; d++)
          S = g * F5 + (V[d] || 0), I[d] = S / $ | 0, g = S % $ | 0;
      else {
        for (g = F5 / ($[0] + 1) | 0, g > 1 && ($ = e($, g), V = e(V, g), k = $.length, w = V.length), O = k, Q = V.slice(0, k), B = Q.length; B < k; ) Q[B++] = 0;
        F = $.slice(), F.unshift(0), D = $[0], $[1] >= F5 / 2 && ++D;
        do
          g = 0, c = t($, Q, k, B), c < 0 ? (_ = Q[0], k != B && (_ = _ * F5 + (Q[1] || 0)), g = _ / D | 0, g > 1 ? (g >= F5 && (g = F5 - 1), h = e($, g), E = h.length, B = Q.length, c = t(h, Q, E, B), c == 1 && (g--, r(h, k < E ? F : $, E))) : (g == 0 && (c = g = 1), h = $.slice()), E = h.length, E < B && h.unshift(0), r(Q, h, B), c == -1 && (B = Q.length, c = t($, Q, k, B), c < 1 && (g++, r(Q, k < B ? F : $, B))), B = Q.length) : c === 0 && (g++, Q = [0]), I[d++] = g, c && Q[0] ? Q[B++] = V[O] || 0 : (Q = [V[O]], B = 1);
        while ((O++ < w || Q[0] !== void 0) && M--);
      }
      return I[0] || I.shift(), y.e = f, ft(y, u ? o + C5(y) + 1 : o);
    };
  }();
  function FY(e, t) {
    var r, n, i, o, u, c, f = 0, d = 0, g = e.constructor, h = g.precision;
    if (C5(e) > 16) throw Error(VM + C5(e));
    if (!e.s) return new g(Ur);
    for (Bt = !1, c = h, u = new g(0.03125); e.abs().gte(0.1); )
      e = e.times(u), d += 5;
    for (n = Math.log(Qi(2, d)) / Math.LN10 * 2 + 5 | 0, c += n, r = i = o = new g(Ur), g.precision = c; ; ) {
      if (i = ft(i.times(e), c), r = r.times(++f), u = o.plus(E8(i, r, c)), u3(u.d).slice(0, c) === u3(o.d).slice(0, c)) {
        for (; d--; ) o = ft(o.times(o), c);
        return g.precision = h, t == null ? (Bt = !0, ft(o, h)) : o;
      }
      o = u;
    }
  }
  function C5(e) {
    for (var t = e.e * mt, r = e.d[0]; r >= 10; r /= 10) t++;
    return t;
  }
  function Cx(e, t, r) {
    if (t > e.LN10.sd())
      throw Bt = !0, r && (e.precision = r), Error(_4 + "LN10 precision limit exceeded");
    return ft(new e(e.LN10), t);
  }
  function R6(e) {
    for (var t = ""; e--; ) t += "0";
    return t;
  }
  function _c(e, t) {
    var r, n, i, o, u, c, f, d, g, h = 1, E = 10, y = e, I = y.d, Q = y.constructor, B = Q.precision;
    if (y.s < 1) throw Error(_4 + (y.s ? "NaN" : "-Infinity"));
    if (y.eq(Ur)) return new Q(0);
    if (t == null ? (Bt = !1, d = B) : d = t, y.eq(10))
      return t == null && (Bt = !0), Cx(Q, d);
    if (d += E, Q.precision = d, r = u3(I), n = r.charAt(0), o = C5(y), Math.abs(o) < 15e14) {
      for (; n < 7 && n != 1 || n == 1 && r.charAt(1) > 3; )
        y = y.times(e), r = u3(y.d), n = r.charAt(0), h++;
      o = C5(y), n > 1 ? (y = new Q("0." + r), o++) : y = new Q(n + "." + r.slice(1));
    } else
      return f = Cx(Q, d + 2, B).times(o + ""), y = _c(new Q(n + "." + r.slice(1)), d - E).plus(f), Q.precision = B, t == null ? (Bt = !0, ft(y, B)) : y;
    for (c = u = y = E8(y.minus(Ur), y.plus(Ur), d), g = ft(y.times(y), d), i = 3; ; ) {
      if (u = ft(u.times(g), d), f = c.plus(E8(u, new Q(i), d)), u3(f.d).slice(0, d) === u3(c.d).slice(0, d))
        return c = c.times(2), o !== 0 && (c = c.plus(Cx(Q, d + 2, B).times(o + ""))), c = E8(c, new Q(h), d), Q.precision = B, t == null ? (Bt = !0, ft(c, B)) : c;
      c = f, i += 2;
    }
  }
  function EH(e, t) {
    var r, n, i;
    for ((r = t.indexOf(".")) > -1 && (t = t.replace(".", "")), (n = t.search(/e/i)) > 0 ? (r < 0 && (r = n), r += +t.slice(n + 1), t = t.substring(0, n)) : r < 0 && (r = t.length), n = 0; t.charCodeAt(n) === 48; ) ++n;
    for (i = t.length; t.charCodeAt(i - 1) === 48; ) --i;
    if (t = t.slice(n, i), t) {
      if (i -= n, r = r - n - 1, e.e = ds(r / mt), e.d = [], n = (r + 1) % mt, r < 0 && (n += mt), n < i) {
        for (n && e.d.push(+t.slice(0, n)), i -= mt; n < i; ) e.d.push(+t.slice(n, n += mt));
        t = t.slice(n), n = mt - t.length;
      } else
        n -= i;
      for (; n--; ) t += "0";
      if (e.d.push(+t), Bt && (e.e > mp || e.e < -mp)) throw Error(VM + r);
    } else
      e.s = 0, e.e = 0, e.d = [0];
    return e;
  }
  function ft(e, t, r) {
    var n, i, o, u, c, f, d, g, h = e.d;
    for (u = 1, o = h[0]; o >= 10; o /= 10) u++;
    if (n = t - u, n < 0)
      n += mt, i = t, d = h[g = 0];
    else {
      if (g = Math.ceil((n + 1) / mt), o = h.length, g >= o) return e;
      for (d = o = h[g], u = 1; o >= 10; o /= 10) u++;
      n %= mt, i = n - mt + u;
    }
    if (r !== void 0 && (o = Qi(10, u - i - 1), c = d / o % 10 | 0, f = t < 0 || h[g + 1] !== void 0 || d % o, f = r < 4 ? (c || f) && (r == 0 || r == (e.s < 0 ? 3 : 2)) : c > 5 || c == 5 && (r == 4 || f || r == 6 && // Check whether the digit to the left of the rounding digit is odd.
    (n > 0 ? i > 0 ? d / Qi(10, u - i) : 0 : h[g - 1]) % 10 & 1 || r == (e.s < 0 ? 8 : 7))), t < 1 || !h[0])
      return f ? (o = C5(e), h.length = 1, t = t - o - 1, h[0] = Qi(10, (mt - t % mt) % mt), e.e = ds(-t / mt) || 0) : (h.length = 1, h[0] = e.e = e.s = 0), e;
    if (n == 0 ? (h.length = g, o = 1, g--) : (h.length = g + 1, o = Qi(10, mt - n), h[g] = i > 0 ? (d / Qi(10, u - i) % Qi(10, i) | 0) * o : 0), f)
      for (; ; )
        if (g == 0) {
          (h[0] += o) == F5 && (h[0] = 1, ++e.e);
          break;
        } else {
          if (h[g] += o, h[g] != F5) break;
          h[g--] = 0, o = 1;
        }
    for (n = h.length; h[--n] === 0; ) h.pop();
    if (Bt && (e.e > mp || e.e < -mp))
      throw Error(VM + C5(e));
    return e;
  }
  function NY(e, t) {
    var r, n, i, o, u, c, f, d, g, h, E = e.constructor, y = E.precision;
    if (!e.s || !t.s)
      return t.s ? t.s = -t.s : t = new E(e), Bt ? ft(t, y) : t;
    if (f = e.d, h = t.d, n = t.e, d = e.e, f = f.slice(), u = d - n, u) {
      for (g = u < 0, g ? (r = f, u = -u, c = h.length) : (r = h, n = d, c = f.length), i = Math.max(Math.ceil(y / mt), c) + 2, u > i && (u = i, r.length = 1), r.reverse(), i = u; i--; ) r.push(0);
      r.reverse();
    } else {
      for (i = f.length, c = h.length, g = i < c, g && (c = i), i = 0; i < c; i++)
        if (f[i] != h[i]) {
          g = f[i] < h[i];
          break;
        }
      u = 0;
    }
    for (g && (r = f, f = h, h = r, t.s = -t.s), c = f.length, i = h.length - c; i > 0; --i) f[c++] = 0;
    for (i = h.length; i > u; ) {
      if (f[--i] < h[i]) {
        for (o = i; o && f[--o] === 0; ) f[o] = F5 - 1;
        --f[o], f[i] += F5;
      }
      f[i] -= h[i];
    }
    for (; f[--c] === 0; ) f.pop();
    for (; f[0] === 0; f.shift()) --n;
    return f[0] ? (t.d = f, t.e = n, Bt ? ft(t, y) : t) : new E(0);
  }
  function zi(e, t, r) {
    var n, i = C5(e), o = u3(e.d), u = o.length;
    return t ? (r && (n = r - u) > 0 ? o = o.charAt(0) + "." + o.slice(1) + R6(n) : u > 1 && (o = o.charAt(0) + "." + o.slice(1)), o = o + (i < 0 ? "e" : "e+") + i) : i < 0 ? (o = "0." + R6(-i - 1) + o, r && (n = r - u) > 0 && (o += R6(n))) : i >= u ? (o += R6(i + 1 - u), r && (n = r - i - 1) > 0 && (o = o + "." + R6(n))) : ((n = i + 1) < u && (o = o.slice(0, n) + "." + o.slice(n)), r && (n = r - u) > 0 && (i + 1 === u && (o += "."), o += R6(n))), e.s < 0 ? "-" + o : o;
  }
  function mH(e, t) {
    if (e.length > t)
      return e.length = t, !0;
  }
  function HY(e) {
    var t, r, n;
    function i(o) {
      var u = this;
      if (!(u instanceof i)) return new i(o);
      if (u.constructor = i, o instanceof i) {
        u.s = o.s, u.e = o.e, u.d = (o = o.d) ? o.slice() : o;
        return;
      }
      if (typeof o == "number") {
        if (o * 0 !== 0)
          throw Error(Ri + o);
        if (o > 0)
          u.s = 1;
        else if (o < 0)
          o = -o, u.s = -1;
        else {
          u.s = 0, u.e = 0, u.d = [0];
          return;
        }
        if (o === ~~o && o < 1e7) {
          u.e = 0, u.d = [o];
          return;
        }
        return EH(u, o.toString());
      } else if (typeof o != "string")
        throw Error(Ri + o);
      if (o.charCodeAt(0) === 45 ? (o = o.slice(1), u.s = -1) : u.s = 1, Kc2.test(o)) EH(u, o);
      else throw Error(Ri + o);
    }
    if (i.prototype = g0, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = HY, i.config = i.set = Xc2, e === void 0 && (e = {}), e)
      for (n = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], t = 0; t < n.length; ) e.hasOwnProperty(r = n[t++]) || (e[r] = this[r]);
    return i.config(e), i;
  }
  function Xc2(e) {
    if (!e || typeof e != "object")
      throw Error(_4 + "Object expected");
    var t, r, n, i = [
      "precision",
      1,
      Cs,
      "rounding",
      0,
      8,
      "toExpNeg",
      -1 / 0,
      0,
      "toExpPos",
      0,
      1 / 0
    ];
    for (t = 0; t < i.length; t += 3)
      if ((n = e[r = i[t]]) !== void 0)
        if (ds(n) === n && n >= i[t + 1] && n <= i[t + 2]) this[r] = n;
        else throw Error(Ri + r + ": " + n);
    if ((n = e[r = "LN10"]) !== void 0)
      if (n == Math.LN10) this[r] = new this(n);
      else throw Error(Ri + r + ": " + n);
    return this;
  }
  var ZM = HY(Gc2);
  Ur = new ZM(1);
  const st = ZM;
  function Jc2(e) {
    return nA2(e) || rA2(e) || tA2(e) || eA2();
  }
  function eA2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function tA2(e, t) {
    if (e) {
      if (typeof e == "string") return ow(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return ow(e, t);
    }
  }
  function rA2(e) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
  }
  function nA2(e) {
    if (Array.isArray(e)) return ow(e);
  }
  function ow(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  var iA2 = function(t) {
    return t;
  }, jY = {}, VY = function(t) {
    return t === jY;
  }, yH = function(t) {
    return function r() {
      return arguments.length === 0 || arguments.length === 1 && VY(arguments.length <= 0 ? void 0 : arguments[0]) ? r : t.apply(void 0, arguments);
    };
  }, aA2 = function e(t, r) {
    return t === 1 ? r : yH(function() {
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      var u = i.filter(function(c) {
        return c !== jY;
      }).length;
      return u >= t ? r.apply(void 0, i) : e(t - u, yH(function() {
        for (var c = arguments.length, f = new Array(c), d = 0; d < c; d++)
          f[d] = arguments[d];
        var g = i.map(function(h) {
          return VY(h) ? f.shift() : h;
        });
        return r.apply(void 0, Jc2(g).concat(f));
      }));
    });
  }, Nh = function(t) {
    return aA2(t.length, t);
  }, sw = function(t, r) {
    for (var n = [], i = t; i < r; ++i)
      n[i - t] = i;
    return n;
  }, oA2 = Nh(function(e, t) {
    return Array.isArray(t) ? t.map(e) : Object.keys(t).map(function(r) {
      return t[r];
    }).map(e);
  }), sA2 = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    if (!r.length)
      return iA2;
    var i = r.reverse(), o = i[0], u = i.slice(1);
    return function() {
      return u.reduce(function(c, f) {
        return f(c);
      }, o.apply(void 0, arguments));
    };
  }, uw = function(t) {
    return Array.isArray(t) ? t.reverse() : t.split("").reverse.join("");
  }, ZY = function(t) {
    var r = null, n = null;
    return function() {
      for (var i = arguments.length, o = new Array(i), u = 0; u < i; u++)
        o[u] = arguments[u];
      return r && o.every(function(c, f) {
        return c === r[f];
      }) || (r = o, n = t.apply(void 0, o)), n;
    };
  };
  function uA2(e) {
    var t;
    return e === 0 ? t = 1 : t = Math.floor(new st(e).abs().log(10).toNumber()) + 1, t;
  }
  function lA2(e, t, r) {
    for (var n = new st(e), i = 0, o = []; n.lt(t) && i < 1e5; )
      o.push(n.toNumber()), n = n.add(r), i++;
    return o;
  }
  var cA2 = Nh(function(e, t, r) {
    var n = +e, i = +t;
    return n + r * (i - n);
  }), AA2 = Nh(function(e, t, r) {
    var n = t - +e;
    return n = n || 1 / 0, (r - e) / n;
  }), fA2 = Nh(function(e, t, r) {
    var n = t - +e;
    return n = n || 1 / 0, Math.max(0, Math.min(1, (r - e) / n));
  });
  const Hh = {
    rangeStep: lA2,
    getDigitCount: uA2,
    interpolateNumber: cA2,
    uninterpolateNumber: AA2,
    uninterpolateTruncation: fA2
  };
  function lw(e) {
    return gA2(e) || dA2(e) || zY(e) || CA2();
  }
  function CA2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function dA2(e) {
    if (typeof Symbol < "u" && Symbol.iterator in Object(e)) return Array.from(e);
  }
  function gA2(e) {
    if (Array.isArray(e)) return cw(e);
  }
  function Oc(e, t) {
    return vA2(e) || hA2(e, t) || zY(e, t) || pA2();
  }
  function pA2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function zY(e, t) {
    if (e) {
      if (typeof e == "string") return cw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cw(e, t);
    }
  }
  function cw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++)
      n[r] = e[r];
    return n;
  }
  function hA2(e, t) {
    if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
      var r = [], n = !0, i = !1, o = void 0;
      try {
        for (var u = e[Symbol.iterator](), c; !(n = (c = u.next()).done) && (r.push(c.value), !(t && r.length === t)); n = !0)
          ;
      } catch (f) {
        i = !0, o = f;
      } finally {
        try {
          !n && u.return != null && u.return();
        } finally {
          if (i) throw o;
        }
      }
      return r;
    }
  }
  function vA2(e) {
    if (Array.isArray(e)) return e;
  }
  function UY(e) {
    var t = Oc(e, 2), r = t[0], n = t[1], i = r, o = n;
    return r > n && (i = n, o = r), [i, o];
  }
  function qY(e, t, r) {
    if (e.lte(0))
      return new st(0);
    var n = Hh.getDigitCount(e.toNumber()), i = new st(10).pow(n), o = e.div(i), u = n !== 1 ? 0.05 : 0.1, c = new st(Math.ceil(o.div(u).toNumber())).add(r).mul(u), f = c.mul(i);
    return t ? f : new st(Math.ceil(f));
  }
  function EA2(e, t, r) {
    var n = 1, i = new st(e);
    if (!i.isint() && r) {
      var o = Math.abs(e);
      o < 1 ? (n = new st(10).pow(Hh.getDigitCount(e) - 1), i = new st(Math.floor(i.div(n).toNumber())).mul(n)) : o > 1 && (i = new st(Math.floor(e)));
    } else e === 0 ? i = new st(Math.floor((t - 1) / 2)) : r || (i = new st(Math.floor(e)));
    var u = Math.floor((t - 1) / 2), c = sA2(oA2(function(f) {
      return i.add(new st(f - u).mul(n)).toNumber();
    }), sw);
    return c(0, t);
  }
  function WY(e, t, r, n) {
    var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    if (!Number.isFinite((t - e) / (r - 1)))
      return {
        step: new st(0),
        tickMin: new st(0),
        tickMax: new st(0)
      };
    var o = qY(new st(t).sub(e).div(r - 1), n, i), u;
    e <= 0 && t >= 0 ? u = new st(0) : (u = new st(e).add(t).div(2), u = u.sub(new st(u).mod(o)));
    var c = Math.ceil(u.sub(e).div(o).toNumber()), f = Math.ceil(new st(t).sub(u).div(o).toNumber()), d = c + f + 1;
    return d > r ? WY(e, t, r, n, i + 1) : (d < r && (f = t > 0 ? f + (r - d) : f, c = t > 0 ? c : c + (r - d)), {
      step: o,
      tickMin: u.sub(new st(c).mul(o)),
      tickMax: u.add(new st(f).mul(o))
    });
  }
  function mA2(e) {
    var t = Oc(e, 2), r = t[0], n = t[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = Math.max(i, 2), c = UY([r, n]), f = Oc(c, 2), d = f[0], g = f[1];
    if (d === -1 / 0 || g === 1 / 0) {
      var h = g === 1 / 0 ? [d].concat(lw(sw(0, i - 1).map(function() {
        return 1 / 0;
      }))) : [].concat(lw(sw(0, i - 1).map(function() {
        return -1 / 0;
      })), [g]);
      return r > n ? uw(h) : h;
    }
    if (d === g)
      return EA2(d, i, o);
    var E = WY(d, g, u, o), y = E.step, I = E.tickMin, Q = E.tickMax, B = Hh.rangeStep(I, Q.add(new st(0.1).mul(y)), y);
    return r > n ? uw(B) : B;
  }
  function yA2(e, t) {
    var r = Oc(e, 2), n = r[0], i = r[1], o = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, u = UY([n, i]), c = Oc(u, 2), f = c[0], d = c[1];
    if (f === -1 / 0 || d === 1 / 0)
      return [n, i];
    if (f === d)
      return [f];
    var g = Math.max(t, 2), h = qY(new st(d).sub(f).div(g - 1), o, 0), E = [].concat(lw(Hh.rangeStep(new st(f), new st(d).sub(new st(0.99).mul(h)), h)), [d]);
    return n > i ? uw(E) : E;
  }
  var IA2 = ZY(mA2), BA2 = ZY(yA2), QA2 = process.env.NODE_ENV === "production", dx = "Invariant failed";
  function mr(e, t) {
    if (QA2)
      throw new Error(dx);
    var r = typeof t == "function" ? t() : t, n = r ? "".concat(dx, ": ").concat(r) : dx;
    throw new Error(n);
  }
  var xA2 = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
  function k9(e) {
    "@babel/helpers - typeof";
    return k9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, k9(e);
  }
  function yp() {
    return yp = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, yp.apply(this, arguments);
  }
  function bA2(e, t) {
    return _A2(e) || MA2(e, t) || SA2(e, t) || wA2();
  }
  function wA2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function SA2(e, t) {
    if (e) {
      if (typeof e == "string") return IH(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return IH(e, t);
    }
  }
  function IH(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function MA2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function _A2(e) {
    if (Array.isArray(e)) return e;
  }
  function OA2(e, t) {
    if (e == null) return {};
    var r = TA2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function TA2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function DA2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function LA2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, GY(n.key), n);
    }
  }
  function kA2(e, t, r) {
    return t && LA2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function RA2(e, t, r) {
    return t = Ip(t), PA2(e, YY() ? Reflect.construct(t, r || [], Ip(e).constructor) : t.apply(e, r));
  }
  function PA2(e, t) {
    if (t && (k9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return FA2(e);
  }
  function FA2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function YY() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (YY = function() {
      return !!e;
    })();
  }
  function Ip(e) {
    return Ip = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Ip(e);
  }
  function NA2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Aw(e, t);
  }
  function Aw(e, t) {
    return Aw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Aw(e, t);
  }
  function $Y(e, t, r) {
    return t = GY(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function GY(e) {
    var t = HA2(e, "string");
    return k9(t) == "symbol" ? t : t + "";
  }
  function HA2(e, t) {
    if (k9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (k9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var dA = /* @__PURE__ */ function(e) {
    function t() {
      return DA2(this, t), RA2(this, t, arguments);
    }
    return NA2(t, e), kA2(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.offset, o = n.layout, u = n.width, c = n.dataKey, f = n.data, d = n.dataPointFormatter, g = n.xAxis, h = n.yAxis, E = OA2(n, xA2), y = ge(E, !1);
        this.props.direction === "x" && g.type !== "number" && (process.env.NODE_ENV !== "production" ? mr(!1, 'ErrorBar requires Axis type property to be "number".') : mr());
        var I = f.map(function(Q) {
          var B = d(Q, c), _ = B.x, M = B.y, S = B.value, O = B.errorVal;
          if (!O)
            return null;
          var w = [], D, k;
          if (Array.isArray(O)) {
            var F = bA2(O, 2);
            D = F[0], k = F[1];
          } else
            D = k = O;
          if (o === "vertical") {
            var z = g.scale, Z = M + i, V = Z + u, $ = Z - u, W = z(S - D), t2 = z(S + k);
            w.push({
              x1: t2,
              y1: V,
              x2: t2,
              y2: $
            }), w.push({
              x1: W,
              y1: Z,
              x2: t2,
              y2: Z
            }), w.push({
              x1: W,
              y1: V,
              x2: W,
              y2: $
            });
          } else if (o === "horizontal") {
            var n2 = h.scale, s2 = _ + i, l2 = s2 - u, X = s2 + u, a2 = n2(S - D), e2 = n2(S + k);
            w.push({
              x1: l2,
              y1: e2,
              x2: X,
              y2: e2
            }), w.push({
              x1: s2,
              y1: a2,
              x2: s2,
              y2: e2
            }), w.push({
              x1: l2,
              y1: a2,
              x2: X,
              y2: a2
            });
          }
          return /* @__PURE__ */ f2.createElement(n5, yp({
            className: "recharts-errorBar",
            key: "bar-".concat(w.map(function(H) {
              return "".concat(H.x1, "-").concat(H.x2, "-").concat(H.y1, "-").concat(H.y2);
            }))
          }, y), w.map(function(H) {
            return /* @__PURE__ */ f2.createElement("line", yp({}, H, {
              key: "line-".concat(H.x1, "-").concat(H.x2, "-").concat(H.y1, "-").concat(H.y2)
            }));
          }));
        });
        return /* @__PURE__ */ f2.createElement(n5, {
          className: "recharts-errorBars"
        }, I);
      }
    }]);
  }(f2.Component);
  $Y(dA, "defaultProps", {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
  });
  $Y(dA, "displayName", "ErrorBar");
  function Tc(e) {
    "@babel/helpers - typeof";
    return Tc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Tc(e);
  }
  function BH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function yi(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? BH(Object(r), !0).forEach(function(n) {
        jA2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : BH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function jA2(e, t, r) {
    return t = VA2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function VA2(e) {
    var t = ZA2(e, "string");
    return Tc(t) == "symbol" ? t : t + "";
  }
  function ZA2(e, t) {
    if (Tc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Tc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var KY = function(t) {
    var r = t.children, n = t.formattedGraphicalItems, i = t.legendWidth, o = t.legendContent, u = Zr(r, v9);
    if (!u)
      return null;
    var c = v9.defaultProps, f = c !== void 0 ? yi(yi({}, c), u.props) : {}, d;
    return u.props && u.props.payload ? d = u.props && u.props.payload : o === "children" ? d = (n || []).reduce(function(g, h) {
      var E = h.item, y = h.props, I = y.sectors || y.data || [];
      return g.concat(I.map(function(Q) {
        return {
          type: u.props.iconType || E.props.legendType,
          value: Q.name,
          color: Q.fill,
          payload: Q
        };
      }));
    }, []) : d = (n || []).map(function(g) {
      var h = g.item, E = h.type.defaultProps, y = E !== void 0 ? yi(yi({}, E), h.props) : {}, I = y.dataKey, Q = y.name, B = y.legendType, _ = y.hide;
      return {
        inactive: _,
        dataKey: I,
        type: f.iconType || B || "square",
        color: zM(h),
        value: Q || I,
        // @ts-expect-error property strokeDasharray is required in Payload but optional in props
        payload: y
      };
    }), yi(yi(yi({}, f), v9.getWithHeight(u, i)), {}, {
      payload: d,
      item: u
    });
  };
  function Dc(e) {
    "@babel/helpers - typeof";
    return Dc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Dc(e);
  }
  function QH(e) {
    return WA2(e) || qA2(e) || UA2(e) || zA2();
  }
  function zA2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function UA2(e, t) {
    if (e) {
      if (typeof e == "string") return fw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return fw(e, t);
    }
  }
  function qA2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function WA2(e) {
    if (Array.isArray(e)) return fw(e);
  }
  function fw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function xH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Ut(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? xH(Object(r), !0).forEach(function(n) {
        m9(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : xH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function m9(e, t, r) {
    return t = YA2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function YA2(e) {
    var t = $A2(e, "string");
    return Dc(t) == "symbol" ? t : t + "";
  }
  function $A2(e, t) {
    if (Dc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Dc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Wr(e, t, r) {
    return Ae(e) || Ae(t) ? r : T5(t) ? w4(e, t, r) : te(t) ? t(e) : r;
  }
  function ic(e, t, r, n) {
    var i = Wc2(e, function(c) {
      return Wr(c, t);
    });
    if (r === "number") {
      var o = i.filter(function(c) {
        return G2(c) || parseFloat(c);
      });
      return o.length ? [Ph(o), Rh(o)] : [1 / 0, -1 / 0];
    }
    var u = n ? i.filter(function(c) {
      return !Ae(c);
    }) : i;
    return u.map(function(c) {
      return T5(c) || c instanceof Date ? c : "";
    });
  }
  var GA2 = function(t) {
    var r, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0, u = -1, c = (r = n == null ? void 0 : n.length) !== null && r !== void 0 ? r : 0;
    if (c <= 1)
      return 0;
    if (o && o.axisType === "angleAxis" && Math.abs(Math.abs(o.range[1] - o.range[0]) - 360) <= 1e-6)
      for (var f = o.range, d = 0; d < c; d++) {
        var g = d > 0 ? i[d - 1].coordinate : i[c - 1].coordinate, h = i[d].coordinate, E = d >= c - 1 ? i[0].coordinate : i[d + 1].coordinate, y = void 0;
        if (pn(h - g) !== pn(E - h)) {
          var I = [];
          if (pn(E - h) === pn(f[1] - f[0])) {
            y = E;
            var Q = h + f[1] - f[0];
            I[0] = Math.min(Q, (Q + g) / 2), I[1] = Math.max(Q, (Q + g) / 2);
          } else {
            y = g;
            var B = E + f[1] - f[0];
            I[0] = Math.min(h, (B + h) / 2), I[1] = Math.max(h, (B + h) / 2);
          }
          var _ = [Math.min(h, (y + h) / 2), Math.max(h, (y + h) / 2)];
          if (t > _[0] && t <= _[1] || t >= I[0] && t <= I[1]) {
            u = i[d].index;
            break;
          }
        } else {
          var M = Math.min(g, E), S = Math.max(g, E);
          if (t > (M + h) / 2 && t <= (S + h) / 2) {
            u = i[d].index;
            break;
          }
        }
      }
    else
      for (var O = 0; O < c; O++)
        if (O === 0 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O > 0 && O < c - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2 && t <= (n[O].coordinate + n[O + 1].coordinate) / 2 || O === c - 1 && t > (n[O].coordinate + n[O - 1].coordinate) / 2) {
          u = n[O].index;
          break;
        }
    return u;
  }, zM = function(t) {
    var r, n = t, i = n.type.displayName, o = (r = t.type) !== null && r !== void 0 && r.defaultProps ? Ut(Ut({}, t.type.defaultProps), t.props) : t.props, u = o.stroke, c = o.fill, f;
    switch (i) {
      case "Line":
        f = u;
        break;
      case "Area":
      case "Radar":
        f = u && u !== "none" ? u : c;
        break;
      default:
        f = c;
        break;
    }
    return f;
  }, KA2 = function(t) {
    var r = t.barSize, n = t.totalSize, i = t.stackGroups, o = i === void 0 ? {} : i;
    if (!o)
      return {};
    for (var u = {}, c = Object.keys(o), f = 0, d = c.length; f < d; f++)
      for (var g = o[c[f]].stackGroups, h = Object.keys(g), E = 0, y = h.length; E < y; E++) {
        var I = g[h[E]], Q = I.items, B = I.cateAxisId, _ = Q.filter(function(k) {
          return h8(k.type).indexOf("Bar") >= 0;
        });
        if (_ && _.length) {
          var M = _[0].type.defaultProps, S = M !== void 0 ? Ut(Ut({}, M), _[0].props) : _[0].props, O = S.barSize, w = S[B];
          u[w] || (u[w] = []);
          var D = Ae(O) ? r : O;
          u[w].push({
            item: _[0],
            stackList: _.slice(1),
            barSize: Ae(D) ? void 0 : Zi(D, n, 0)
          });
        }
      }
    return u;
  }, XA2 = function(t) {
    var r = t.barGap, n = t.barCategoryGap, i = t.bandSize, o = t.sizeList, u = o === void 0 ? [] : o, c = t.maxBarSize, f = u.length;
    if (f < 1) return null;
    var d = Zi(r, i, 0, !0), g, h = [];
    if (u[0].barSize === +u[0].barSize) {
      var E = !1, y = i / f, I = u.reduce(function(O, w) {
        return O + w.barSize || 0;
      }, 0);
      I += (f - 1) * d, I >= i && (I -= (f - 1) * d, d = 0), I >= i && y > 0 && (E = !0, y *= 0.9, I = f * y);
      var Q = (i - I) / 2 >> 0, B = {
        offset: Q - d,
        size: 0
      };
      g = u.reduce(function(O, w) {
        var D = {
          item: w.item,
          position: {
            offset: B.offset + B.size + d,
            // @ts-expect-error the type check above does not check for type number explicitly
            size: E ? y : w.barSize
          }
        }, k = [].concat(QH(O), [D]);
        return B = k[k.length - 1].position, w.stackList && w.stackList.length && w.stackList.forEach(function(F) {
          k.push({
            item: F,
            position: B
          });
        }), k;
      }, h);
    } else {
      var _ = Zi(n, i, 0, !0);
      i - 2 * _ - (f - 1) * d <= 0 && (d = 0);
      var M = (i - 2 * _ - (f - 1) * d) / f;
      M > 1 && (M >>= 0);
      var S = c === +c ? Math.min(M, c) : M;
      g = u.reduce(function(O, w, D) {
        var k = [].concat(QH(O), [{
          item: w.item,
          position: {
            offset: _ + (M + d) * D + (M - S) / 2,
            size: S
          }
        }]);
        return w.stackList && w.stackList.length && w.stackList.forEach(function(F) {
          k.push({
            item: F,
            position: k[k.length - 1].position
          });
        }), k;
      }, h);
    }
    return g;
  }, JA2 = function(t, r, n, i) {
    var o = n.children, u = n.width, c = n.margin, f = u - (c.left || 0) - (c.right || 0), d = KY({
      children: o,
      legendWidth: f
    });
    if (d) {
      var g = i || {}, h = g.width, E = g.height, y = d.align, I = d.verticalAlign, Q = d.layout;
      if ((Q === "vertical" || Q === "horizontal" && I === "middle") && y !== "center" && G2(t[y]))
        return Ut(Ut({}, t), {}, m9({}, y, t[y] + (h || 0)));
      if ((Q === "horizontal" || Q === "vertical" && y === "center") && I !== "middle" && G2(t[I]))
        return Ut(Ut({}, t), {}, m9({}, I, t[I] + (E || 0)));
    }
    return t;
  }, ef2 = function(t, r, n) {
    return Ae(r) ? !0 : t === "horizontal" ? r === "yAxis" : t === "vertical" || n === "x" ? r === "xAxis" : n === "y" ? r === "yAxis" : !0;
  }, XY = function(t, r, n, i, o) {
    var u = r.props.children, c = S4(u, dA).filter(function(d) {
      return ef2(i, o, d.props.direction);
    });
    if (c && c.length) {
      var f = c.map(function(d) {
        return d.props.dataKey;
      });
      return t.reduce(function(d, g) {
        var h = Wr(g, n);
        if (Ae(h)) return d;
        var E = Array.isArray(h) ? [Ph(h), Rh(h)] : [h, h], y = f.reduce(function(I, Q) {
          var B = Wr(g, Q, 0), _ = E[0] - Math.abs(Array.isArray(B) ? B[0] : B), M = E[1] + Math.abs(Array.isArray(B) ? B[1] : B);
          return [Math.min(_, I[0]), Math.max(M, I[1])];
        }, [1 / 0, -1 / 0]);
        return [Math.min(y[0], d[0]), Math.max(y[1], d[1])];
      }, [1 / 0, -1 / 0]);
    }
    return null;
  }, tf2 = function(t, r, n, i, o) {
    var u = r.map(function(c) {
      return XY(t, c, n, o, i);
    }).filter(function(c) {
      return !Ae(c);
    });
    return u && u.length ? u.reduce(function(c, f) {
      return [Math.min(c[0], f[0]), Math.max(c[1], f[1])];
    }, [1 / 0, -1 / 0]) : null;
  }, JY = function(t, r, n, i, o) {
    var u = r.map(function(f) {
      var d = f.props.dataKey;
      return n === "number" && d && XY(t, f, d, i) || ic(t, d, n, o);
    });
    if (n === "number")
      return u.reduce(
        // @ts-expect-error if (type === number) means that the domain is numerical type
        // - but this link is missing in the type definition
        function(f, d) {
          return [Math.min(f[0], d[0]), Math.max(f[1], d[1])];
        },
        [1 / 0, -1 / 0]
      );
    var c = {};
    return u.reduce(function(f, d) {
      for (var g = 0, h = d.length; g < h; g++)
        c[d[g]] || (c[d[g]] = !0, f.push(d[g]));
      return f;
    }, []);
  }, e$ = function(t, r) {
    return t === "horizontal" && r === "xAxis" || t === "vertical" && r === "yAxis" || t === "centric" && r === "angleAxis" || t === "radial" && r === "radiusAxis";
  }, t$ = function(t, r, n, i) {
    if (i)
      return t.map(function(f) {
        return f.coordinate;
      });
    var o, u, c = t.map(function(f) {
      return f.coordinate === r && (o = !0), f.coordinate === n && (u = !0), f.coordinate;
    });
    return o || c.push(r), u || c.push(n), c;
  }, g8 = function(t, r, n) {
    if (!t) return null;
    var i = t.scale, o = t.duplicateDomain, u = t.type, c = t.range, f = t.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, d = (r || n) && u === "category" && i.bandwidth ? i.bandwidth() / f : 0;
    if (d = t.axisType === "angleAxis" && (c == null ? void 0 : c.length) >= 2 ? pn(c[0] - c[1]) * 2 * d : d, r && (t.ticks || t.niceTicks)) {
      var g = (t.ticks || t.niceTicks).map(function(h) {
        var E = o ? o.indexOf(h) : h;
        return {
          // If the scaleContent is not a number, the coordinate will be NaN.
          // That could be the case for example with a PointScale and a string as domain.
          coordinate: i(E) + d,
          value: h,
          offset: d
        };
      });
      return g.filter(function(h) {
        return !sA(h.coordinate);
      });
    }
    return t.isCategorical && t.categoricalDomain ? t.categoricalDomain.map(function(h, E) {
      return {
        coordinate: i(h) + d,
        value: h,
        index: E,
        offset: d
      };
    }) : i.ticks && !n ? i.ticks(t.tickCount).map(function(h) {
      return {
        coordinate: i(h) + d,
        value: h,
        offset: d
      };
    }) : i.domain().map(function(h, E) {
      return {
        coordinate: i(h) + d,
        value: o ? o[h] : h,
        index: E,
        offset: d
      };
    });
  }, gx = /* @__PURE__ */ new WeakMap(), kd = function(t, r) {
    if (typeof r != "function")
      return t;
    gx.has(t) || gx.set(t, /* @__PURE__ */ new WeakMap());
    var n = gx.get(t);
    if (n.has(r))
      return n.get(r);
    var i = function() {
      t.apply(void 0, arguments), r.apply(void 0, arguments);
    };
    return n.set(r, i), i;
  }, rf2 = function(t, r, n) {
    var i = t.scale, o = t.type, u = t.layout, c = t.axisType;
    if (i === "auto")
      return u === "radial" && c === "radiusAxis" ? {
        scale: xc(),
        realScaleType: "band"
      } : u === "radial" && c === "angleAxis" ? {
        scale: pp(),
        realScaleType: "linear"
      } : o === "category" && r && (r.indexOf("LineChart") >= 0 || r.indexOf("AreaChart") >= 0 || r.indexOf("ComposedChart") >= 0 && !n) ? {
        scale: nc(),
        realScaleType: "point"
      } : o === "category" ? {
        scale: xc(),
        realScaleType: "band"
      } : {
        scale: pp(),
        realScaleType: "linear"
      };
    if (Vi(i)) {
      var f = "scale".concat(Bh(i));
      return {
        scale: (cH[f] || nc)(),
        realScaleType: cH[f] ? f : "point"
      };
    }
    return te(i) ? {
      scale: i
    } : {
      scale: nc(),
      realScaleType: "point"
    };
  }, bH = 1e-4, nf2 = function(t) {
    var r = t.domain();
    if (!(!r || r.length <= 2)) {
      var n = r.length, i = t.range(), o = Math.min(i[0], i[1]) - bH, u = Math.max(i[0], i[1]) + bH, c = t(r[0]), f = t(r[n - 1]);
      (c < o || c > u || f < o || f > u) && t.domain([r[0], r[n - 1]]);
    }
  }, if2 = function(t, r) {
    if (!t)
      return null;
    for (var n = 0, i = t.length; n < i; n++)
      if (t[n].item === r)
        return t[n].position;
    return null;
  }, af2 = function(t, r) {
    if (!r || r.length !== 2 || !G2(r[0]) || !G2(r[1]))
      return t;
    var n = Math.min(r[0], r[1]), i = Math.max(r[0], r[1]), o = [t[0], t[1]];
    return (!G2(t[0]) || t[0] < n) && (o[0] = n), (!G2(t[1]) || t[1] > i) && (o[1] = i), o[0] > i && (o[0] = i), o[1] < n && (o[1] = n), o;
  }, of2 = function(t) {
    var r = t.length;
    if (!(r <= 0))
      for (var n = 0, i = t[0].length; n < i; ++n)
        for (var o = 0, u = 0, c = 0; c < r; ++c) {
          var f = sA(t[c][n][1]) ? t[c][n][0] : t[c][n][1];
          f >= 0 ? (t[c][n][0] = o, t[c][n][1] = o + f, o = t[c][n][1]) : (t[c][n][0] = u, t[c][n][1] = u + f, u = t[c][n][1]);
        }
  }, sf2 = function(t) {
    var r = t.length;
    if (!(r <= 0))
      for (var n = 0, i = t[0].length; n < i; ++n)
        for (var o = 0, u = 0; u < r; ++u) {
          var c = sA(t[u][n][1]) ? t[u][n][0] : t[u][n][1];
          c >= 0 ? (t[u][n][0] = o, t[u][n][1] = o + c, o = t[u][n][1]) : (t[u][n][0] = 0, t[u][n][1] = 0);
        }
  }, uf2 = {
    sign: of2,
    // @ts-expect-error definitelytyped types are incorrect
    expand: za2,
    // @ts-expect-error definitelytyped types are incorrect
    none: w9,
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: Ua2,
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: qa2,
    positive: sf2
  }, lf2 = function(t, r, n) {
    var i = r.map(function(c) {
      return c.props.dataKey;
    }), o = uf2[n], u = Za2().keys(i).value(function(c, f) {
      return +Wr(c, f, 0);
    }).order(Vb).offset(o);
    return u(t);
  }, cf2 = function(t, r, n, i, o, u) {
    if (!t)
      return null;
    var c = u ? r.reverse() : r, f = {}, d = c.reduce(function(h, E) {
      var y, I = (y = E.type) !== null && y !== void 0 && y.defaultProps ? Ut(Ut({}, E.type.defaultProps), E.props) : E.props, Q = I.stackId, B = I.hide;
      if (B)
        return h;
      var _ = I[n], M = h[_] || {
        hasStack: !1,
        stackGroups: {}
      };
      if (T5(Q)) {
        var S = M.stackGroups[Q] || {
          numericAxisId: n,
          cateAxisId: i,
          items: []
        };
        S.items.push(E), M.hasStack = !0, M.stackGroups[Q] = S;
      } else
        M.stackGroups[uA("_stackId_")] = {
          numericAxisId: n,
          cateAxisId: i,
          items: [E]
        };
      return Ut(Ut({}, h), {}, m9({}, _, M));
    }, f), g = {};
    return Object.keys(d).reduce(function(h, E) {
      var y = d[E];
      if (y.hasStack) {
        var I = {};
        y.stackGroups = Object.keys(y.stackGroups).reduce(function(Q, B) {
          var _ = y.stackGroups[B];
          return Ut(Ut({}, Q), {}, m9({}, B, {
            numericAxisId: n,
            cateAxisId: i,
            items: _.items,
            stackedData: lf2(t, _.items, o)
          }));
        }, I);
      }
      return Ut(Ut({}, h), {}, m9({}, E, y));
    }, g);
  }, Af2 = function(t, r) {
    var n = r.realScaleType, i = r.type, o = r.tickCount, u = r.originalDomain, c = r.allowDecimals, f = n || r.scale;
    if (f !== "auto" && f !== "linear")
      return null;
    if (o && i === "number" && u && (u[0] === "auto" || u[1] === "auto")) {
      var d = t.domain();
      if (!d.length)
        return null;
      var g = IA2(d, o, c);
      return t.domain([Ph(g), Rh(g)]), {
        niceTicks: g
      };
    }
    if (o && i === "number") {
      var h = t.domain(), E = BA2(h, o, c);
      return {
        niceTicks: E
      };
    }
    return null;
  };
  function wH(e) {
    var t = e.axis, r = e.ticks, n = e.bandSize, i = e.entry, o = e.index, u = e.dataKey;
    if (t.type === "category") {
      if (!t.allowDuplicatedCategory && t.dataKey && !Ae(i[t.dataKey])) {
        var c = Gg(r, "value", i[t.dataKey]);
        if (c)
          return c.coordinate + n / 2;
      }
      return r[o] ? r[o].coordinate + n / 2 : null;
    }
    var f = Wr(i, Ae(u) ? t.dataKey : u);
    return Ae(f) ? null : t.scale(f);
  }
  var SH = function(t) {
    var r = t.axis, n = t.ticks, i = t.offset, o = t.bandSize, u = t.entry, c = t.index;
    if (r.type === "category")
      return n[c] ? n[c].coordinate + i : null;
    var f = Wr(u, r.dataKey, r.domain[c]);
    return Ae(f) ? null : r.scale(f) - o / 2 + i;
  }, ff2 = function(t) {
    var r = t.numericAxis, n = r.scale.domain();
    if (r.type === "number") {
      var i = Math.min(n[0], n[1]), o = Math.max(n[0], n[1]);
      return i <= 0 && o >= 0 ? 0 : o < 0 ? o : i;
    }
    return n[0];
  }, Cf2 = function(t, r) {
    var n, i = (n = t.type) !== null && n !== void 0 && n.defaultProps ? Ut(Ut({}, t.type.defaultProps), t.props) : t.props, o = i.stackId;
    if (T5(o)) {
      var u = r[o];
      if (u) {
        var c = u.items.indexOf(t);
        return c >= 0 ? u.stackedData[c] : null;
      }
    }
    return null;
  }, df2 = function(t) {
    return t.reduce(function(r, n) {
      return [Ph(n.concat([r[0]]).filter(G2)), Rh(n.concat([r[1]]).filter(G2))];
    }, [1 / 0, -1 / 0]);
  }, r$ = function(t, r, n) {
    return Object.keys(t).reduce(function(i, o) {
      var u = t[o], c = u.stackedData, f = c.reduce(function(d, g) {
        var h = df2(g.slice(r, n + 1));
        return [Math.min(d[0], h[0]), Math.max(d[1], h[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(f[0], i[0]), Math.max(f[1], i[1])];
    }, [1 / 0, -1 / 0]).map(function(i) {
      return i === 1 / 0 || i === -1 / 0 ? 0 : i;
    });
  }, MH = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, _H = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, Cw = function(t, r, n) {
    if (te(t))
      return t(r, n);
    if (!Array.isArray(t))
      return r;
    var i = [];
    if (G2(t[0]))
      i[0] = n ? t[0] : Math.min(t[0], r[0]);
    else if (MH.test(t[0])) {
      var o = +MH.exec(t[0])[1];
      i[0] = r[0] - o;
    } else te(t[0]) ? i[0] = t[0](r[0]) : i[0] = r[0];
    if (G2(t[1]))
      i[1] = n ? t[1] : Math.max(t[1], r[1]);
    else if (_H.test(t[1])) {
      var u = +_H.exec(t[1])[1];
      i[1] = r[1] + u;
    } else te(t[1]) ? i[1] = t[1](r[1]) : i[1] = r[1];
    return i;
  }, Bp = function(t, r, n) {
    if (t && t.scale && t.scale.bandwidth) {
      var i = t.scale.bandwidth();
      if (!n || i > 0)
        return i;
    }
    if (t && r && r.length >= 2) {
      for (var o = vM(r, function(h) {
        return h.coordinate;
      }), u = 1 / 0, c = 1, f = o.length; c < f; c++) {
        var d = o[c], g = o[c - 1];
        u = Math.min((d.coordinate || 0) - (g.coordinate || 0), u);
      }
      return u === 1 / 0 ? 0 : u;
    }
    return n ? void 0 : 0;
  }, OH = function(t, r, n) {
    return !t || !t.length || Fh(t, w4(n, "type.defaultProps.domain")) ? r : t;
  }, n$ = function(t, r) {
    var n = t.type.defaultProps ? Ut(Ut({}, t.type.defaultProps), t.props) : t.props, i = n.dataKey, o = n.name, u = n.unit, c = n.formatter, f = n.tooltipType, d = n.chartType, g = n.hide;
    return Ut(Ut({}, ge(t, !1)), {}, {
      dataKey: i,
      unit: u,
      formatter: c,
      name: o || i,
      color: zM(t),
      value: Wr(r, i),
      type: f,
      payload: r,
      chartType: d,
      hide: g
    });
  };
  function Lc(e) {
    "@babel/helpers - typeof";
    return Lc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Lc(e);
  }
  function TH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function DH(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? TH(Object(r), !0).forEach(function(n) {
        gf2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : TH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function gf2(e, t, r) {
    return t = pf2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function pf2(e) {
    var t = hf2(e, "string");
    return Lc(t) == "symbol" ? t : t + "";
  }
  function hf2(e, t) {
    if (Lc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Lc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Qp = Math.PI / 180, vf2 = function(t) {
    return t * 180 / Math.PI;
  }, u1 = function(t, r, n, i) {
    return {
      x: t + Math.cos(-Qp * i) * n,
      y: r + Math.sin(-Qp * i) * n
    };
  }, Ef2 = function(t, r) {
    var n = t.x, i = t.y, o = r.x, u = r.y;
    return Math.sqrt(Math.pow(n - o, 2) + Math.pow(i - u, 2));
  }, mf2 = function(t, r) {
    var n = t.x, i = t.y, o = r.cx, u = r.cy, c = Ef2({
      x: n,
      y: i
    }, {
      x: o,
      y: u
    });
    if (c <= 0)
      return {
        radius: c
      };
    var f = (n - o) / c, d = Math.acos(f);
    return i > u && (d = 2 * Math.PI - d), {
      radius: c,
      angle: vf2(d),
      angleInRadian: d
    };
  }, yf2 = function(t) {
    var r = t.startAngle, n = t.endAngle, i = Math.floor(r / 360), o = Math.floor(n / 360), u = Math.min(i, o);
    return {
      startAngle: r - u * 360,
      endAngle: n - u * 360
    };
  }, If2 = function(t, r) {
    var n = r.startAngle, i = r.endAngle, o = Math.floor(n / 360), u = Math.floor(i / 360), c = Math.min(o, u);
    return t + c * 360;
  }, LH = function(t, r) {
    var n = t.x, i = t.y, o = mf2({
      x: n,
      y: i
    }, r), u = o.radius, c = o.angle, f = r.innerRadius, d = r.outerRadius;
    if (u < f || u > d)
      return !1;
    if (u === 0)
      return !0;
    var g = yf2(r), h = g.startAngle, E = g.endAngle, y = c, I;
    if (h <= E) {
      for (; y > E; )
        y -= 360;
      for (; y < h; )
        y += 360;
      I = y >= h && y <= E;
    } else {
      for (; y > h; )
        y -= 360;
      for (; y < E; )
        y += 360;
      I = y >= E && y <= h;
    }
    return I ? DH(DH({}, r), {}, {
      radius: u,
      angle: If2(y, r)
    }) : null;
  };
  function kc(e) {
    "@babel/helpers - typeof";
    return kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, kc(e);
  }
  var Bf2 = ["offset"];
  function Qf2(e) {
    return Sf2(e) || wf2(e) || bf2(e) || xf2();
  }
  function xf2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function bf2(e, t) {
    if (e) {
      if (typeof e == "string") return dw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return dw(e, t);
    }
  }
  function wf2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function Sf2(e) {
    if (Array.isArray(e)) return dw(e);
  }
  function dw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Mf2(e, t) {
    if (e == null) return {};
    var r = _f2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function _f2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function kH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function O5(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? kH(Object(r), !0).forEach(function(n) {
        Of2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : kH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Of2(e, t, r) {
    return t = Tf2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Tf2(e) {
    var t = Df2(e, "string");
    return kc(t) == "symbol" ? t : t + "";
  }
  function Df2(e, t) {
    if (kc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (kc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Rc() {
    return Rc = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Rc.apply(this, arguments);
  }
  var Lf2 = function(t) {
    var r = t.value, n = t.formatter, i = Ae(t.children) ? r : t.children;
    return te(n) ? n(i) : i;
  }, kf2 = function(t, r) {
    var n = pn(r - t), i = Math.min(Math.abs(r - t), 360);
    return n * i;
  }, Rf2 = function(t, r, n) {
    var i = t.position, o = t.viewBox, u = t.offset, c = t.className, f = o, d = f.cx, g = f.cy, h = f.innerRadius, E = f.outerRadius, y = f.startAngle, I = f.endAngle, Q = f.clockWise, B = (h + E) / 2, _ = kf2(y, I), M = _ >= 0 ? 1 : -1, S, O;
    i === "insideStart" ? (S = y + M * u, O = Q) : i === "insideEnd" ? (S = I - M * u, O = !Q) : i === "end" && (S = I + M * u, O = Q), O = _ <= 0 ? O : !O;
    var w = u1(d, g, B, S), D = u1(d, g, B, S + (O ? 1 : -1) * 359), k = "M".concat(w.x, ",").concat(w.y, `
    A`).concat(B, ",").concat(B, ",0,1,").concat(O ? 0 : 1, `,
    `).concat(D.x, ",").concat(D.y), F = Ae(t.id) ? uA("recharts-radial-line-") : t.id;
    return /* @__PURE__ */ f2.createElement("text", Rc({}, n, {
      dominantBaseline: "central",
      className: pe("recharts-radial-bar-label", c)
    }), /* @__PURE__ */ f2.createElement("defs", null, /* @__PURE__ */ f2.createElement("path", {
      id: F,
      d: k
    })), /* @__PURE__ */ f2.createElement("textPath", {
      xlinkHref: "#".concat(F)
    }, r));
  }, Pf2 = function(t) {
    var r = t.viewBox, n = t.offset, i = t.position, o = r, u = o.cx, c = o.cy, f = o.innerRadius, d = o.outerRadius, g = o.startAngle, h = o.endAngle, E = (g + h) / 2;
    if (i === "outside") {
      var y = u1(u, c, d + n, E), I = y.x, Q = y.y;
      return {
        x: I,
        y: Q,
        textAnchor: I >= u ? "start" : "end",
        verticalAnchor: "middle"
      };
    }
    if (i === "center")
      return {
        x: u,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "middle"
      };
    if (i === "centerTop")
      return {
        x: u,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "start"
      };
    if (i === "centerBottom")
      return {
        x: u,
        y: c,
        textAnchor: "middle",
        verticalAnchor: "end"
      };
    var B = (f + d) / 2, _ = u1(u, c, B, E), M = _.x, S = _.y;
    return {
      x: M,
      y: S,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  }, Ff2 = function(t) {
    var r = t.viewBox, n = t.parentViewBox, i = t.offset, o = t.position, u = r, c = u.x, f = u.y, d = u.width, g = u.height, h = g >= 0 ? 1 : -1, E = h * i, y = h > 0 ? "end" : "start", I = h > 0 ? "start" : "end", Q = d >= 0 ? 1 : -1, B = Q * i, _ = Q > 0 ? "end" : "start", M = Q > 0 ? "start" : "end";
    if (o === "top") {
      var S = {
        x: c + d / 2,
        y: f - h * i,
        textAnchor: "middle",
        verticalAnchor: y
      };
      return O5(O5({}, S), n ? {
        height: Math.max(f - n.y, 0),
        width: d
      } : {});
    }
    if (o === "bottom") {
      var O = {
        x: c + d / 2,
        y: f + g + E,
        textAnchor: "middle",
        verticalAnchor: I
      };
      return O5(O5({}, O), n ? {
        height: Math.max(n.y + n.height - (f + g), 0),
        width: d
      } : {});
    }
    if (o === "left") {
      var w = {
        x: c - B,
        y: f + g / 2,
        textAnchor: _,
        verticalAnchor: "middle"
      };
      return O5(O5({}, w), n ? {
        width: Math.max(w.x - n.x, 0),
        height: g
      } : {});
    }
    if (o === "right") {
      var D = {
        x: c + d + B,
        y: f + g / 2,
        textAnchor: M,
        verticalAnchor: "middle"
      };
      return O5(O5({}, D), n ? {
        width: Math.max(n.x + n.width - D.x, 0),
        height: g
      } : {});
    }
    var k = n ? {
      width: d,
      height: g
    } : {};
    return o === "insideLeft" ? O5({
      x: c + B,
      y: f + g / 2,
      textAnchor: M,
      verticalAnchor: "middle"
    }, k) : o === "insideRight" ? O5({
      x: c + d - B,
      y: f + g / 2,
      textAnchor: _,
      verticalAnchor: "middle"
    }, k) : o === "insideTop" ? O5({
      x: c + d / 2,
      y: f + E,
      textAnchor: "middle",
      verticalAnchor: I
    }, k) : o === "insideBottom" ? O5({
      x: c + d / 2,
      y: f + g - E,
      textAnchor: "middle",
      verticalAnchor: y
    }, k) : o === "insideTopLeft" ? O5({
      x: c + B,
      y: f + E,
      textAnchor: M,
      verticalAnchor: I
    }, k) : o === "insideTopRight" ? O5({
      x: c + d - B,
      y: f + E,
      textAnchor: _,
      verticalAnchor: I
    }, k) : o === "insideBottomLeft" ? O5({
      x: c + B,
      y: f + g - E,
      textAnchor: M,
      verticalAnchor: y
    }, k) : o === "insideBottomRight" ? O5({
      x: c + d - B,
      y: f + g - E,
      textAnchor: _,
      verticalAnchor: y
    }, k) : ls(o) && (G2(o.x) || _i(o.x)) && (G2(o.y) || _i(o.y)) ? O5({
      x: c + Zi(o.x, d),
      y: f + Zi(o.y, g),
      textAnchor: "end",
      verticalAnchor: "end"
    }, k) : O5({
      x: c + d / 2,
      y: f + g / 2,
      textAnchor: "middle",
      verticalAnchor: "middle"
    }, k);
  }, Nf2 = function(t) {
    return "cx" in t && G2(t.cx);
  };
  function _1(e) {
    var t = e.offset, r = t === void 0 ? 5 : t, n = Mf2(e, Bf2), i = O5({
      offset: r
    }, n), o = i.viewBox, u = i.position, c = i.value, f = i.children, d = i.content, g = i.className, h = g === void 0 ? "" : g, E = i.textBreakAll;
    if (!o || Ae(c) && Ae(f) && !/* @__PURE__ */ q.isValidElement(d) && !te(d))
      return null;
    if (/* @__PURE__ */ q.isValidElement(d))
      return /* @__PURE__ */ q.cloneElement(d, i);
    var y;
    if (te(d)) {
      if (y = /* @__PURE__ */ q.createElement(d, i), /* @__PURE__ */ q.isValidElement(y))
        return y;
    } else
      y = Lf2(i);
    var I = Nf2(o), Q = ge(i, !0);
    if (I && (u === "insideStart" || u === "insideEnd" || u === "end"))
      return Rf2(i, y, Q);
    var B = I ? Pf2(i) : Ff2(i);
    return /* @__PURE__ */ f2.createElement(lp, Rc({
      className: pe("recharts-label", h)
    }, Q, B, {
      breakAll: E
    }), y);
  }
  _1.displayName = "Label";
  var i$ = function(t) {
    var r = t.cx, n = t.cy, i = t.angle, o = t.startAngle, u = t.endAngle, c = t.r, f = t.radius, d = t.innerRadius, g = t.outerRadius, h = t.x, E = t.y, y = t.top, I = t.left, Q = t.width, B = t.height, _ = t.clockWise, M = t.labelViewBox;
    if (M)
      return M;
    if (G2(Q) && G2(B)) {
      if (G2(h) && G2(E))
        return {
          x: h,
          y: E,
          width: Q,
          height: B
        };
      if (G2(y) && G2(I))
        return {
          x: y,
          y: I,
          width: Q,
          height: B
        };
    }
    return G2(h) && G2(E) ? {
      x: h,
      y: E,
      width: 0,
      height: 0
    } : G2(r) && G2(n) ? {
      cx: r,
      cy: n,
      startAngle: o || i || 0,
      endAngle: u || i || 0,
      innerRadius: d || 0,
      outerRadius: g || f || c || 0,
      clockWise: _
    } : t.viewBox ? t.viewBox : {};
  }, Hf2 = function(t, r) {
    return t ? t === !0 ? /* @__PURE__ */ f2.createElement(_1, {
      key: "label-implicit",
      viewBox: r
    }) : T5(t) ? /* @__PURE__ */ f2.createElement(_1, {
      key: "label-implicit",
      viewBox: r,
      value: t
    }) : /* @__PURE__ */ q.isValidElement(t) ? t.type === _1 ? /* @__PURE__ */ q.cloneElement(t, {
      key: "label-implicit",
      viewBox: r
    }) : /* @__PURE__ */ f2.createElement(_1, {
      key: "label-implicit",
      content: t,
      viewBox: r
    }) : te(t) ? /* @__PURE__ */ f2.createElement(_1, {
      key: "label-implicit",
      content: t,
      viewBox: r
    }) : ls(t) ? /* @__PURE__ */ f2.createElement(_1, Rc({
      viewBox: r
    }, t, {
      key: "label-implicit"
    })) : null : null;
  }, jf2 = function(t, r) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (!t || !t.children && n && !t.label)
      return null;
    var i = t.children, o = i$(t), u = S4(i, _1).map(function(f, d) {
      return /* @__PURE__ */ q.cloneElement(f, {
        viewBox: r || o,
        // eslint-disable-next-line react/no-array-index-key
        key: "label-".concat(d)
      });
    });
    if (!n)
      return u;
    var c = Hf2(t.label, r || o);
    return [c].concat(Qf2(u));
  };
  _1.parseViewBox = i$;
  _1.renderCallByParent = jf2;
  var px, RH;
  function Vf2() {
    if (RH) return px;
    RH = 1;
    function e(t) {
      var r = t == null ? 0 : t.length;
      return r ? t[r - 1] : void 0;
    }
    return px = e, px;
  }
  var Zf2 = Vf2();
  const zf2 = /* @__PURE__ */ tt(Zf2);
  function Pc(e) {
    "@babel/helpers - typeof";
    return Pc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Pc(e);
  }
  var Uf2 = ["valueAccessor"], qf2 = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
  function Wf2(e) {
    return Kf2(e) || Gf2(e) || $f2(e) || Yf2();
  }
  function Yf2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function $f2(e, t) {
    if (e) {
      if (typeof e == "string") return gw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return gw(e, t);
    }
  }
  function Gf2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function Kf2(e) {
    if (Array.isArray(e)) return gw(e);
  }
  function gw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function xp() {
    return xp = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, xp.apply(this, arguments);
  }
  function PH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function FH(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? PH(Object(r), !0).forEach(function(n) {
        Xf2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : PH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Xf2(e, t, r) {
    return t = Jf2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Jf2(e) {
    var t = eC2(e, "string");
    return Pc(t) == "symbol" ? t : t + "";
  }
  function eC2(e, t) {
    if (Pc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Pc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function NH(e, t) {
    if (e == null) return {};
    var r = tC2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function tC2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var rC2 = function(t) {
    return Array.isArray(t.value) ? zf2(t.value) : t.value;
  };
  function j6(e) {
    var t = e.valueAccessor, r = t === void 0 ? rC2 : t, n = NH(e, Uf2), i = n.data, o = n.dataKey, u = n.clockWise, c = n.id, f = n.textBreakAll, d = NH(n, qf2);
    return !i || !i.length ? null : /* @__PURE__ */ f2.createElement(n5, {
      className: "recharts-label-list"
    }, i.map(function(g, h) {
      var E = Ae(o) ? r(g, h) : Wr(g && g.payload, o), y = Ae(c) ? {} : {
        id: "".concat(c, "-").concat(h)
      };
      return /* @__PURE__ */ f2.createElement(_1, xp({}, ge(g, !0), d, y, {
        parentViewBox: g.parentViewBox,
        value: E,
        textBreakAll: f,
        viewBox: _1.parseViewBox(Ae(u) ? g : FH(FH({}, g), {}, {
          clockWise: u
        })),
        key: "label-".concat(h),
        index: h
      }));
    }));
  }
  j6.displayName = "LabelList";
  function nC2(e, t) {
    return e ? e === !0 ? /* @__PURE__ */ f2.createElement(j6, {
      key: "labelList-implicit",
      data: t
    }) : /* @__PURE__ */ f2.isValidElement(e) || te(e) ? /* @__PURE__ */ f2.createElement(j6, {
      key: "labelList-implicit",
      data: t,
      content: e
    }) : ls(e) ? /* @__PURE__ */ f2.createElement(j6, xp({
      data: t
    }, e, {
      key: "labelList-implicit"
    })) : null : null;
  }
  function iC2(e, t) {
    var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    if (!e || !e.children && r && !e.label)
      return null;
    var n = e.children, i = S4(n, j6).map(function(u, c) {
      return /* @__PURE__ */ q.cloneElement(u, {
        data: t,
        // eslint-disable-next-line react/no-array-index-key
        key: "labelList-".concat(c)
      });
    });
    if (!r)
      return i;
    var o = nC2(e.label, t);
    return [o].concat(Wf2(i));
  }
  j6.renderCallByParent = iC2;
  function Fc(e) {
    "@babel/helpers - typeof";
    return Fc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Fc(e);
  }
  function pw() {
    return pw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, pw.apply(this, arguments);
  }
  function HH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function jH(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? HH(Object(r), !0).forEach(function(n) {
        aC2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : HH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function aC2(e, t, r) {
    return t = oC2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function oC2(e) {
    var t = sC2(e, "string");
    return Fc(t) == "symbol" ? t : t + "";
  }
  function sC2(e, t) {
    if (Fc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Fc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var uC2 = function(t, r) {
    var n = pn(r - t), i = Math.min(Math.abs(r - t), 359.999);
    return n * i;
  }, Rd = function(t) {
    var r = t.cx, n = t.cy, i = t.radius, o = t.angle, u = t.sign, c = t.isExternal, f = t.cornerRadius, d = t.cornerIsExternal, g = f * (c ? 1 : -1) + i, h = Math.asin(f / g) / Qp, E = d ? o : o + u * h, y = u1(r, n, g, E), I = u1(r, n, i, E), Q = d ? o - u * h : o, B = u1(r, n, g * Math.cos(h * Qp), Q);
    return {
      center: y,
      circleTangency: I,
      lineTangency: B,
      theta: h
    };
  }, a$ = function(t) {
    var r = t.cx, n = t.cy, i = t.innerRadius, o = t.outerRadius, u = t.startAngle, c = t.endAngle, f = uC2(u, c), d = u + f, g = u1(r, n, o, u), h = u1(r, n, o, d), E = "M ".concat(g.x, ",").concat(g.y, `
    A `).concat(o, ",").concat(o, `,0,
    `).concat(+(Math.abs(f) > 180), ",").concat(+(u > d), `,
    `).concat(h.x, ",").concat(h.y, `
  `);
    if (i > 0) {
      var y = u1(r, n, i, u), I = u1(r, n, i, d);
      E += "L ".concat(I.x, ",").concat(I.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(f) > 180), ",").concat(+(u <= d), `,
            `).concat(y.x, ",").concat(y.y, " Z");
    } else
      E += "L ".concat(r, ",").concat(n, " Z");
    return E;
  }, lC2 = function(t) {
    var r = t.cx, n = t.cy, i = t.innerRadius, o = t.outerRadius, u = t.cornerRadius, c = t.forceCornerRadius, f = t.cornerIsExternal, d = t.startAngle, g = t.endAngle, h = pn(g - d), E = Rd({
      cx: r,
      cy: n,
      radius: o,
      angle: d,
      sign: h,
      cornerRadius: u,
      cornerIsExternal: f
    }), y = E.circleTangency, I = E.lineTangency, Q = E.theta, B = Rd({
      cx: r,
      cy: n,
      radius: o,
      angle: g,
      sign: -h,
      cornerRadius: u,
      cornerIsExternal: f
    }), _ = B.circleTangency, M = B.lineTangency, S = B.theta, O = f ? Math.abs(d - g) : Math.abs(d - g) - Q - S;
    if (O < 0)
      return c ? "M ".concat(I.x, ",").concat(I.y, `
        a`).concat(u, ",").concat(u, ",0,0,1,").concat(u * 2, `,0
        a`).concat(u, ",").concat(u, ",0,0,1,").concat(-u * 2, `,0
      `) : a$({
        cx: r,
        cy: n,
        innerRadius: i,
        outerRadius: o,
        startAngle: d,
        endAngle: g
      });
    var w = "M ".concat(I.x, ",").concat(I.y, `
    A`).concat(u, ",").concat(u, ",0,0,").concat(+(h < 0), ",").concat(y.x, ",").concat(y.y, `
    A`).concat(o, ",").concat(o, ",0,").concat(+(O > 180), ",").concat(+(h < 0), ",").concat(_.x, ",").concat(_.y, `
    A`).concat(u, ",").concat(u, ",0,0,").concat(+(h < 0), ",").concat(M.x, ",").concat(M.y, `
  `);
    if (i > 0) {
      var D = Rd({
        cx: r,
        cy: n,
        radius: i,
        angle: d,
        sign: h,
        isExternal: !0,
        cornerRadius: u,
        cornerIsExternal: f
      }), k = D.circleTangency, F = D.lineTangency, z = D.theta, Z = Rd({
        cx: r,
        cy: n,
        radius: i,
        angle: g,
        sign: -h,
        isExternal: !0,
        cornerRadius: u,
        cornerIsExternal: f
      }), V = Z.circleTangency, $ = Z.lineTangency, W = Z.theta, t2 = f ? Math.abs(d - g) : Math.abs(d - g) - z - W;
      if (t2 < 0 && u === 0)
        return "".concat(w, "L").concat(r, ",").concat(n, "Z");
      w += "L".concat($.x, ",").concat($.y, `
      A`).concat(u, ",").concat(u, ",0,0,").concat(+(h < 0), ",").concat(V.x, ",").concat(V.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(t2 > 180), ",").concat(+(h > 0), ",").concat(k.x, ",").concat(k.y, `
      A`).concat(u, ",").concat(u, ",0,0,").concat(+(h < 0), ",").concat(F.x, ",").concat(F.y, "Z");
    } else
      w += "L".concat(r, ",").concat(n, "Z");
    return w;
  }, cC2 = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: !1,
    cornerIsExternal: !1
  }, o$ = function(t) {
    var r = jH(jH({}, cC2), t), n = r.cx, i = r.cy, o = r.innerRadius, u = r.outerRadius, c = r.cornerRadius, f = r.forceCornerRadius, d = r.cornerIsExternal, g = r.startAngle, h = r.endAngle, E = r.className;
    if (u < o || g === h)
      return null;
    var y = pe("recharts-sector", E), I = u - o, Q = Zi(c, I, 0, !0), B;
    return Q > 0 && Math.abs(g - h) < 360 ? B = lC2({
      cx: n,
      cy: i,
      innerRadius: o,
      outerRadius: u,
      cornerRadius: Math.min(Q, I / 2),
      forceCornerRadius: f,
      cornerIsExternal: d,
      startAngle: g,
      endAngle: h
    }) : B = a$({
      cx: n,
      cy: i,
      innerRadius: o,
      outerRadius: u,
      startAngle: g,
      endAngle: h
    }), /* @__PURE__ */ f2.createElement("path", pw({}, ge(r, !0), {
      className: y,
      d: B,
      role: "img"
    }));
  };
  function Nc(e) {
    "@babel/helpers - typeof";
    return Nc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Nc(e);
  }
  function hw() {
    return hw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, hw.apply(this, arguments);
  }
  function VH(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function ZH(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? VH(Object(r), !0).forEach(function(n) {
        AC2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : VH(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function AC2(e, t, r) {
    return t = fC2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function fC2(e) {
    var t = CC2(e, "string");
    return Nc(t) == "symbol" ? t : t + "";
  }
  function CC2(e, t) {
    if (Nc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Nc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var zH = {
    curveBasisClosed: Ta2,
    curveBasisOpen: Da2,
    curveBasis: Oa2,
    curveBumpX: ha2,
    curveBumpY: va2,
    curveLinearClosed: La2,
    curveLinear: xh,
    curveMonotoneX: ka2,
    curveMonotoneY: Ra2,
    curveNatural: Pa2,
    curveStep: Fa2,
    curveStepAfter: Ha2,
    curveStepBefore: Na2
  }, Pd = function(t) {
    return t.x === +t.x && t.y === +t.y;
  }, Pl = function(t) {
    return t.x;
  }, Fl = function(t) {
    return t.y;
  }, dC2 = function(t, r) {
    if (te(t))
      return t;
    var n = "curve".concat(Bh(t));
    return (n === "curveMonotone" || n === "curveBump") && r ? zH["".concat(n).concat(r === "vertical" ? "Y" : "X")] : zH[n] || xh;
  }, gC2 = function(t) {
    var r = t.type, n = r === void 0 ? "linear" : r, i = t.points, o = i === void 0 ? [] : i, u = t.baseLine, c = t.layout, f = t.connectNulls, d = f === void 0 ? !1 : f, g = dC2(n, c), h = d ? o.filter(function(Q) {
      return Pd(Q);
    }) : o, E;
    if (Array.isArray(u)) {
      var y = d ? u.filter(function(Q) {
        return Pd(Q);
      }) : u, I = h.map(function(Q, B) {
        return ZH(ZH({}, Q), {}, {
          base: y[B]
        });
      });
      return c === "vertical" ? E = Sd().y(Fl).x1(Pl).x0(function(Q) {
        return Q.base.x;
      }) : E = Sd().x(Pl).y1(Fl).y0(function(Q) {
        return Q.base.y;
      }), E.defined(Pd).curve(g), E(I);
    }
    return c === "vertical" && G2(u) ? E = Sd().y(Fl).x1(Pl).x0(u) : G2(u) ? E = Sd().x(Pl).y1(Fl).y0(u) : E = cW().x(Pl).y(Fl), E.defined(Pd).curve(g), E(h);
  }, vw = function(t) {
    var r = t.className, n = t.points, i = t.path, o = t.pathRef;
    if ((!n || !n.length) && !i)
      return null;
    var u = n && n.length ? gC2(t) : i;
    return /* @__PURE__ */ f2.createElement("path", hw({}, ge(t, !1), Kg(t), {
      className: pe("recharts-curve", r),
      d: u,
      ref: o
    }));
  }, Fd = { exports: {} }, Nd = { exports: {} }, Ue = {};
  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var UH;
  function pC2() {
    if (UH) return Ue;
    UH = 1;
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, Q = e ? Symbol.for("react.block") : 60121, B = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
    function S(w) {
      if (typeof w == "object" && w !== null) {
        var D = w.$$typeof;
        switch (D) {
          case t:
            switch (w = w.type, w) {
              case f:
              case d:
              case n:
              case o:
              case i:
              case h:
                return w;
              default:
                switch (w = w && w.$$typeof, w) {
                  case c:
                  case g:
                  case I:
                  case y:
                  case u:
                    return w;
                  default:
                    return D;
                }
            }
          case r:
            return D;
        }
      }
    }
    function O(w) {
      return S(w) === d;
    }
    return Ue.AsyncMode = f, Ue.ConcurrentMode = d, Ue.ContextConsumer = c, Ue.ContextProvider = u, Ue.Element = t, Ue.ForwardRef = g, Ue.Fragment = n, Ue.Lazy = I, Ue.Memo = y, Ue.Portal = r, Ue.Profiler = o, Ue.StrictMode = i, Ue.Suspense = h, Ue.isAsyncMode = function(w) {
      return O(w) || S(w) === f;
    }, Ue.isConcurrentMode = O, Ue.isContextConsumer = function(w) {
      return S(w) === c;
    }, Ue.isContextProvider = function(w) {
      return S(w) === u;
    }, Ue.isElement = function(w) {
      return typeof w == "object" && w !== null && w.$$typeof === t;
    }, Ue.isForwardRef = function(w) {
      return S(w) === g;
    }, Ue.isFragment = function(w) {
      return S(w) === n;
    }, Ue.isLazy = function(w) {
      return S(w) === I;
    }, Ue.isMemo = function(w) {
      return S(w) === y;
    }, Ue.isPortal = function(w) {
      return S(w) === r;
    }, Ue.isProfiler = function(w) {
      return S(w) === o;
    }, Ue.isStrictMode = function(w) {
      return S(w) === i;
    }, Ue.isSuspense = function(w) {
      return S(w) === h;
    }, Ue.isValidElementType = function(w) {
      return typeof w == "string" || typeof w == "function" || w === n || w === d || w === o || w === i || w === h || w === E || typeof w == "object" && w !== null && (w.$$typeof === I || w.$$typeof === y || w.$$typeof === u || w.$$typeof === c || w.$$typeof === g || w.$$typeof === B || w.$$typeof === _ || w.$$typeof === M || w.$$typeof === Q);
    }, Ue.typeOf = S, Ue;
  }
  var qe = {};
  /** @license React v16.13.1
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var qH;
  function hC2() {
    return qH || (qH = 1, process.env.NODE_ENV !== "production" && function() {
      var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, u = e ? Symbol.for("react.provider") : 60109, c = e ? Symbol.for("react.context") : 60110, f = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, g = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, E = e ? Symbol.for("react.suspense_list") : 60120, y = e ? Symbol.for("react.memo") : 60115, I = e ? Symbol.for("react.lazy") : 60116, Q = e ? Symbol.for("react.block") : 60121, B = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, M = e ? Symbol.for("react.scope") : 60119;
      function S(d2) {
        return typeof d2 == "string" || typeof d2 == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
        d2 === n || d2 === d || d2 === o || d2 === i || d2 === h || d2 === E || typeof d2 == "object" && d2 !== null && (d2.$$typeof === I || d2.$$typeof === y || d2.$$typeof === u || d2.$$typeof === c || d2.$$typeof === g || d2.$$typeof === B || d2.$$typeof === _ || d2.$$typeof === M || d2.$$typeof === Q);
      }
      function O(d2) {
        if (typeof d2 == "object" && d2 !== null) {
          var X2 = d2.$$typeof;
          switch (X2) {
            case t:
              var k2 = d2.type;
              switch (k2) {
                case f:
                case d:
                case n:
                case o:
                case i:
                case h:
                  return k2;
                default:
                  var b0 = k2 && k2.$$typeof;
                  switch (b0) {
                    case c:
                    case g:
                    case I:
                    case y:
                    case u:
                      return b0;
                    default:
                      return X2;
                  }
              }
            case r:
              return X2;
          }
        }
      }
      var w = f, D = d, k = c, F = u, z = t, Z = g, V = n, $ = I, W = y, t2 = r, n2 = o, s2 = i, l2 = h, X = !1;
      function a2(d2) {
        return X || (X = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), e2(d2) || O(d2) === f;
      }
      function e2(d2) {
        return O(d2) === d;
      }
      function H(d2) {
        return O(d2) === c;
      }
      function Y(d2) {
        return O(d2) === u;
      }
      function r2(d2) {
        return typeof d2 == "object" && d2 !== null && d2.$$typeof === t;
      }
      function o2(d2) {
        return O(d2) === g;
      }
      function O2(d2) {
        return O(d2) === n;
      }
      function S2(d2) {
        return O(d2) === I;
      }
      function M2(d2) {
        return O(d2) === y;
      }
      function w2(d2) {
        return O(d2) === r;
      }
      function v2(d2) {
        return O(d2) === o;
      }
      function L2(d2) {
        return O(d2) === i;
      }
      function W2(d2) {
        return O(d2) === h;
      }
      qe.AsyncMode = w, qe.ConcurrentMode = D, qe.ContextConsumer = k, qe.ContextProvider = F, qe.Element = z, qe.ForwardRef = Z, qe.Fragment = V, qe.Lazy = $, qe.Memo = W, qe.Portal = t2, qe.Profiler = n2, qe.StrictMode = s2, qe.Suspense = l2, qe.isAsyncMode = a2, qe.isConcurrentMode = e2, qe.isContextConsumer = H, qe.isContextProvider = Y, qe.isElement = r2, qe.isForwardRef = o2, qe.isFragment = O2, qe.isLazy = S2, qe.isMemo = M2, qe.isPortal = w2, qe.isProfiler = v2, qe.isStrictMode = L2, qe.isSuspense = W2, qe.isValidElementType = S, qe.typeOf = O;
    }()), qe;
  }
  var WH;
  function s$() {
    return WH || (WH = 1, process.env.NODE_ENV === "production" ? Nd.exports = pC2() : Nd.exports = hC2()), Nd.exports;
  }
  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  var hx, YH;
  function vC2() {
    if (YH) return hx;
    YH = 1;
    var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
    function n(o) {
      if (o == null)
        throw new TypeError("Object.assign cannot be called with null or undefined");
      return Object(o);
    }
    function i() {
      try {
        if (!Object.assign)
          return !1;
        var o = new String("abc");
        if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
          return !1;
        for (var u = {}, c = 0; c < 10; c++)
          u["_" + String.fromCharCode(c)] = c;
        var f = Object.getOwnPropertyNames(u).map(function(g) {
          return u[g];
        });
        if (f.join("") !== "0123456789")
          return !1;
        var d = {};
        return "abcdefghijklmnopqrst".split("").forEach(function(g) {
          d[g] = g;
        }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
      } catch {
        return !1;
      }
    }
    return hx = i() ? Object.assign : function(o, u) {
      for (var c, f = n(o), d, g = 1; g < arguments.length; g++) {
        c = Object(arguments[g]);
        for (var h in c)
          t.call(c, h) && (f[h] = c[h]);
        if (e) {
          d = e(c);
          for (var E = 0; E < d.length; E++)
            r.call(c, d[E]) && (f[d[E]] = c[d[E]]);
        }
      }
      return f;
    }, hx;
  }
  var vx, $H;
  function UM() {
    if ($H) return vx;
    $H = 1;
    var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    return vx = e, vx;
  }
  var Ex, GH;
  function u$() {
    return GH || (GH = 1, Ex = Function.call.bind(Object.prototype.hasOwnProperty)), Ex;
  }
  var mx, KH;
  function EC2() {
    if (KH) return mx;
    KH = 1;
    var e = function() {
    };
    if (process.env.NODE_ENV !== "production") {
      var t = /* @__PURE__ */ UM(), r = {}, n = /* @__PURE__ */ u$();
      e = function(o) {
        var u = "Warning: " + o;
        typeof console < "u" && console.error(u);
        try {
          throw new Error(u);
        } catch {
        }
      };
    }
    function i(o, u, c, f, d) {
      if (process.env.NODE_ENV !== "production") {
        for (var g in o)
          if (n(o, g)) {
            var h;
            try {
              if (typeof o[g] != "function") {
                var E = Error(
                  (f || "React class") + ": " + c + " type `" + g + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[g] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
                );
                throw E.name = "Invariant Violation", E;
              }
              h = o[g](u, g, f, c, null, t);
            } catch (I) {
              h = I;
            }
            if (h && !(h instanceof Error) && e(
              (f || "React class") + ": type specification of " + c + " `" + g + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
            ), h instanceof Error && !(h.message in r)) {
              r[h.message] = !0;
              var y = d ? d() : "";
              e(
                "Failed " + c + " type: " + h.message + (y ?? "")
              );
            }
          }
      }
    }
    return i.resetWarningCache = function() {
      process.env.NODE_ENV !== "production" && (r = {});
    }, mx = i, mx;
  }
  var yx, XH;
  function mC2() {
    if (XH) return yx;
    XH = 1;
    var e = s$(), t = vC2(), r = /* @__PURE__ */ UM(), n = /* @__PURE__ */ u$(), i = /* @__PURE__ */ EC2(), o = function() {
    };
    process.env.NODE_ENV !== "production" && (o = function(c) {
      var f = "Warning: " + c;
      typeof console < "u" && console.error(f);
      try {
        throw new Error(f);
      } catch {
      }
    });
    function u() {
      return null;
    }
    return yx = function(c, f) {
      var d = typeof Symbol == "function" && Symbol.iterator, g = "@@iterator";
      function h(e2) {
        var H = e2 && (d && e2[d] || e2[g]);
        if (typeof H == "function")
          return H;
      }
      var E = "<<anonymous>>", y = {
        array: _("array"),
        bigint: _("bigint"),
        bool: _("boolean"),
        func: _("function"),
        number: _("number"),
        object: _("object"),
        string: _("string"),
        symbol: _("symbol"),
        any: M(),
        arrayOf: S,
        element: O(),
        elementType: w(),
        instanceOf: D,
        node: Z(),
        objectOf: F,
        oneOf: k,
        oneOfType: z,
        shape: $,
        exact: W
      };
      function I(e2, H) {
        return e2 === H ? e2 !== 0 || 1 / e2 === 1 / H : e2 !== e2 && H !== H;
      }
      function Q(e2, H) {
        this.message = e2, this.data = H && typeof H == "object" ? H : {}, this.stack = "";
      }
      Q.prototype = Error.prototype;
      function B(e2) {
        if (process.env.NODE_ENV !== "production")
          var H = {}, Y = 0;
        function r2(O2, S2, M2, w2, v2, L2, W2) {
          if (w2 = w2 || E, L2 = L2 || M2, W2 !== r) {
            if (f) {
              var d2 = new Error(
                "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
              );
              throw d2.name = "Invariant Violation", d2;
            } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
              var X2 = w2 + ":" + M2;
              !H[X2] && // Avoid spamming the console because they are often not actionable except for lib authors
              Y < 3 && (o(
                "You are manually calling a React.PropTypes validation function for the `" + L2 + "` prop on `" + w2 + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
              ), H[X2] = !0, Y++);
            }
          }
          return S2[M2] == null ? O2 ? S2[M2] === null ? new Q("The " + v2 + " `" + L2 + "` is marked as required " + ("in `" + w2 + "`, but its value is `null`.")) : new Q("The " + v2 + " `" + L2 + "` is marked as required in " + ("`" + w2 + "`, but its value is `undefined`.")) : null : e2(S2, M2, w2, v2, L2);
        }
        var o2 = r2.bind(null, !1);
        return o2.isRequired = r2.bind(null, !0), o2;
      }
      function _(e2) {
        function H(Y, r2, o2, O2, S2, M2) {
          var w2 = Y[r2], v2 = s2(w2);
          if (v2 !== e2) {
            var L2 = l2(w2);
            return new Q(
              "Invalid " + O2 + " `" + S2 + "` of type " + ("`" + L2 + "` supplied to `" + o2 + "`, expected ") + ("`" + e2 + "`."),
              { expectedType: e2 }
            );
          }
          return null;
        }
        return B(H);
      }
      function M() {
        return B(u);
      }
      function S(e2) {
        function H(Y, r2, o2, O2, S2) {
          if (typeof e2 != "function")
            return new Q("Property `" + S2 + "` of component `" + o2 + "` has invalid PropType notation inside arrayOf.");
          var M2 = Y[r2];
          if (!Array.isArray(M2)) {
            var w2 = s2(M2);
            return new Q("Invalid " + O2 + " `" + S2 + "` of type " + ("`" + w2 + "` supplied to `" + o2 + "`, expected an array."));
          }
          for (var v2 = 0; v2 < M2.length; v2++) {
            var L2 = e2(M2, v2, o2, O2, S2 + "[" + v2 + "]", r);
            if (L2 instanceof Error)
              return L2;
          }
          return null;
        }
        return B(H);
      }
      function O() {
        function e2(H, Y, r2, o2, O2) {
          var S2 = H[Y];
          if (!c(S2)) {
            var M2 = s2(S2);
            return new Q("Invalid " + o2 + " `" + O2 + "` of type " + ("`" + M2 + "` supplied to `" + r2 + "`, expected a single ReactElement."));
          }
          return null;
        }
        return B(e2);
      }
      function w() {
        function e2(H, Y, r2, o2, O2) {
          var S2 = H[Y];
          if (!e.isValidElementType(S2)) {
            var M2 = s2(S2);
            return new Q("Invalid " + o2 + " `" + O2 + "` of type " + ("`" + M2 + "` supplied to `" + r2 + "`, expected a single ReactElement type."));
          }
          return null;
        }
        return B(e2);
      }
      function D(e2) {
        function H(Y, r2, o2, O2, S2) {
          if (!(Y[r2] instanceof e2)) {
            var M2 = e2.name || E, w2 = a2(Y[r2]);
            return new Q("Invalid " + O2 + " `" + S2 + "` of type " + ("`" + w2 + "` supplied to `" + o2 + "`, expected ") + ("instance of `" + M2 + "`."));
          }
          return null;
        }
        return B(H);
      }
      function k(e2) {
        if (!Array.isArray(e2))
          return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
            "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
          ) : o("Invalid argument supplied to oneOf, expected an array.")), u;
        function H(Y, r2, o2, O2, S2) {
          for (var M2 = Y[r2], w2 = 0; w2 < e2.length; w2++)
            if (I(M2, e2[w2]))
              return null;
          var v2 = JSON.stringify(e2, function(W2, d2) {
            var X2 = l2(d2);
            return X2 === "symbol" ? String(d2) : d2;
          });
          return new Q("Invalid " + O2 + " `" + S2 + "` of value `" + String(M2) + "` " + ("supplied to `" + o2 + "`, expected one of " + v2 + "."));
        }
        return B(H);
      }
      function F(e2) {
        function H(Y, r2, o2, O2, S2) {
          if (typeof e2 != "function")
            return new Q("Property `" + S2 + "` of component `" + o2 + "` has invalid PropType notation inside objectOf.");
          var M2 = Y[r2], w2 = s2(M2);
          if (w2 !== "object")
            return new Q("Invalid " + O2 + " `" + S2 + "` of type " + ("`" + w2 + "` supplied to `" + o2 + "`, expected an object."));
          for (var v2 in M2)
            if (n(M2, v2)) {
              var L2 = e2(M2, v2, o2, O2, S2 + "." + v2, r);
              if (L2 instanceof Error)
                return L2;
            }
          return null;
        }
        return B(H);
      }
      function z(e2) {
        if (!Array.isArray(e2))
          return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), u;
        for (var H = 0; H < e2.length; H++) {
          var Y = e2[H];
          if (typeof Y != "function")
            return o(
              "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + X(Y) + " at index " + H + "."
            ), u;
        }
        function r2(o2, O2, S2, M2, w2) {
          for (var v2 = [], L2 = 0; L2 < e2.length; L2++) {
            var W2 = e2[L2], d2 = W2(o2, O2, S2, M2, w2, r);
            if (d2 == null)
              return null;
            d2.data && n(d2.data, "expectedType") && v2.push(d2.data.expectedType);
          }
          var X2 = v2.length > 0 ? ", expected one of type [" + v2.join(", ") + "]" : "";
          return new Q("Invalid " + M2 + " `" + w2 + "` supplied to " + ("`" + S2 + "`" + X2 + "."));
        }
        return B(r2);
      }
      function Z() {
        function e2(H, Y, r2, o2, O2) {
          return t2(H[Y]) ? null : new Q("Invalid " + o2 + " `" + O2 + "` supplied to " + ("`" + r2 + "`, expected a ReactNode."));
        }
        return B(e2);
      }
      function V(e2, H, Y, r2, o2) {
        return new Q(
          (e2 || "React class") + ": " + H + " type `" + Y + "." + r2 + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o2 + "`."
        );
      }
      function $(e2) {
        function H(Y, r2, o2, O2, S2) {
          var M2 = Y[r2], w2 = s2(M2);
          if (w2 !== "object")
            return new Q("Invalid " + O2 + " `" + S2 + "` of type `" + w2 + "` " + ("supplied to `" + o2 + "`, expected `object`."));
          for (var v2 in e2) {
            var L2 = e2[v2];
            if (typeof L2 != "function")
              return V(o2, O2, S2, v2, l2(L2));
            var W2 = L2(M2, v2, o2, O2, S2 + "." + v2, r);
            if (W2)
              return W2;
          }
          return null;
        }
        return B(H);
      }
      function W(e2) {
        function H(Y, r2, o2, O2, S2) {
          var M2 = Y[r2], w2 = s2(M2);
          if (w2 !== "object")
            return new Q("Invalid " + O2 + " `" + S2 + "` of type `" + w2 + "` " + ("supplied to `" + o2 + "`, expected `object`."));
          var v2 = t({}, Y[r2], e2);
          for (var L2 in v2) {
            var W2 = e2[L2];
            if (n(e2, L2) && typeof W2 != "function")
              return V(o2, O2, S2, L2, l2(W2));
            if (!W2)
              return new Q(
                "Invalid " + O2 + " `" + S2 + "` key `" + L2 + "` supplied to `" + o2 + "`.\nBad object: " + JSON.stringify(Y[r2], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(e2), null, "  ")
              );
            var d2 = W2(M2, L2, o2, O2, S2 + "." + L2, r);
            if (d2)
              return d2;
          }
          return null;
        }
        return B(H);
      }
      function t2(e2) {
        switch (typeof e2) {
          case "number":
          case "string":
          case "undefined":
            return !0;
          case "boolean":
            return !e2;
          case "object":
            if (Array.isArray(e2))
              return e2.every(t2);
            if (e2 === null || c(e2))
              return !0;
            var H = h(e2);
            if (H) {
              var Y = H.call(e2), r2;
              if (H !== e2.entries) {
                for (; !(r2 = Y.next()).done; )
                  if (!t2(r2.value))
                    return !1;
              } else
                for (; !(r2 = Y.next()).done; ) {
                  var o2 = r2.value;
                  if (o2 && !t2(o2[1]))
                    return !1;
                }
            } else
              return !1;
            return !0;
          default:
            return !1;
        }
      }
      function n2(e2, H) {
        return e2 === "symbol" ? !0 : H ? H["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && H instanceof Symbol : !1;
      }
      function s2(e2) {
        var H = typeof e2;
        return Array.isArray(e2) ? "array" : e2 instanceof RegExp ? "object" : n2(H, e2) ? "symbol" : H;
      }
      function l2(e2) {
        if (typeof e2 > "u" || e2 === null)
          return "" + e2;
        var H = s2(e2);
        if (H === "object") {
          if (e2 instanceof Date)
            return "date";
          if (e2 instanceof RegExp)
            return "regexp";
        }
        return H;
      }
      function X(e2) {
        var H = l2(e2);
        switch (H) {
          case "array":
          case "object":
            return "an " + H;
          case "boolean":
          case "date":
          case "regexp":
            return "a " + H;
          default:
            return H;
        }
      }
      function a2(e2) {
        return !e2.constructor || !e2.constructor.name ? E : e2.constructor.name;
      }
      return y.checkPropTypes = i, y.resetWarningCache = i.resetWarningCache, y.PropTypes = y, y;
    }, yx;
  }
  var Ix, JH;
  function yC2() {
    if (JH) return Ix;
    JH = 1;
    var e = /* @__PURE__ */ UM();
    function t() {
    }
    function r() {
    }
    return r.resetWarningCache = t, Ix = function() {
      function n(u, c, f, d, g, h) {
        if (h !== e) {
          var E = new Error(
            "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
          );
          throw E.name = "Invariant Violation", E;
        }
      }
      n.isRequired = n;
      function i() {
        return n;
      }
      var o = {
        array: n,
        bigint: n,
        bool: n,
        func: n,
        number: n,
        object: n,
        string: n,
        symbol: n,
        any: n,
        arrayOf: i,
        element: n,
        elementType: n,
        instanceOf: i,
        node: n,
        objectOf: i,
        oneOf: i,
        oneOfType: i,
        shape: i,
        exact: i,
        checkPropTypes: r,
        resetWarningCache: t
      };
      return o.PropTypes = o, o;
    }, Ix;
  }
  var ej;
  function IC2() {
    if (ej) return Fd.exports;
    if (ej = 1, process.env.NODE_ENV !== "production") {
      var e = s$(), t = !0;
      Fd.exports = /* @__PURE__ */ mC2()(e.isElement, t);
    } else
      Fd.exports = /* @__PURE__ */ yC2()();
    return Fd.exports;
  }
  var BC2 = /* @__PURE__ */ IC2();
  const We = /* @__PURE__ */ tt(BC2);
  var QC2 = Object.getOwnPropertyNames, xC2 = Object.getOwnPropertySymbols, bC2 = Object.prototype.hasOwnProperty;
  function tj(e, t) {
    return function(n, i, o) {
      return e(n, i, o) && t(n, i, o);
    };
  }
  function Hd(e) {
    return function(r, n, i) {
      if (!r || !n || typeof r != "object" || typeof n != "object")
        return e(r, n, i);
      var o = i.cache, u = o.get(r), c = o.get(n);
      if (u && c)
        return u === n && c === r;
      o.set(r, n), o.set(n, r);
      var f = e(r, n, i);
      return o.delete(r), o.delete(n), f;
    };
  }
  function rj(e) {
    return QC2(e).concat(xC2(e));
  }
  var wC2 = Object.hasOwn || function(e, t) {
    return bC2.call(e, t);
  };
  function ta(e, t) {
    return e === t || !e && !t && e !== e && t !== t;
  }
  var SC2 = "__v", MC2 = "__o", _C2 = "_owner", nj = Object.getOwnPropertyDescriptor, ij = Object.keys;
  function OC2(e, t, r) {
    var n = e.length;
    if (t.length !== n)
      return !1;
    for (; n-- > 0; )
      if (!r.equals(e[n], t[n], n, n, e, t, r))
        return !1;
    return !0;
  }
  function TC2(e, t) {
    return ta(e.getTime(), t.getTime());
  }
  function DC2(e, t) {
    return e.name === t.name && e.message === t.message && e.cause === t.cause && e.stack === t.stack;
  }
  function LC2(e, t) {
    return e === t;
  }
  function aj(e, t, r) {
    var n = e.size;
    if (n !== t.size)
      return !1;
    if (!n)
      return !0;
    for (var i = new Array(n), o = e.entries(), u, c, f = 0; (u = o.next()) && !u.done; ) {
      for (var d = t.entries(), g = !1, h = 0; (c = d.next()) && !c.done; ) {
        if (i[h]) {
          h++;
          continue;
        }
        var E = u.value, y = c.value;
        if (r.equals(E[0], y[0], f, h, e, t, r) && r.equals(E[1], y[1], E[0], y[0], e, t, r)) {
          g = i[h] = !0;
          break;
        }
        h++;
      }
      if (!g)
        return !1;
      f++;
    }
    return !0;
  }
  var kC2 = ta;
  function RC2(e, t, r) {
    var n = ij(e), i = n.length;
    if (ij(t).length !== i)
      return !1;
    for (; i-- > 0; )
      if (!l$(e, t, r, n[i]))
        return !1;
    return !0;
  }
  function Nl(e, t, r) {
    var n = rj(e), i = n.length;
    if (rj(t).length !== i)
      return !1;
    for (var o, u, c; i-- > 0; )
      if (o = n[i], !l$(e, t, r, o) || (u = nj(e, o), c = nj(t, o), (u || c) && (!u || !c || u.configurable !== c.configurable || u.enumerable !== c.enumerable || u.writable !== c.writable)))
        return !1;
    return !0;
  }
  function PC2(e, t) {
    return ta(e.valueOf(), t.valueOf());
  }
  function FC2(e, t) {
    return e.source === t.source && e.flags === t.flags;
  }
  function oj(e, t, r) {
    var n = e.size;
    if (n !== t.size)
      return !1;
    if (!n)
      return !0;
    for (var i = new Array(n), o = e.values(), u, c; (u = o.next()) && !u.done; ) {
      for (var f = t.values(), d = !1, g = 0; (c = f.next()) && !c.done; ) {
        if (!i[g] && r.equals(u.value, c.value, u.value, c.value, e, t, r)) {
          d = i[g] = !0;
          break;
        }
        g++;
      }
      if (!d)
        return !1;
    }
    return !0;
  }
  function NC2(e, t) {
    var r = e.length;
    if (t.length !== r)
      return !1;
    for (; r-- > 0; )
      if (e[r] !== t[r])
        return !1;
    return !0;
  }
  function HC2(e, t) {
    return e.hostname === t.hostname && e.pathname === t.pathname && e.protocol === t.protocol && e.port === t.port && e.hash === t.hash && e.username === t.username && e.password === t.password;
  }
  function l$(e, t, r, n) {
    return (n === _C2 || n === MC2 || n === SC2) && (e.$$typeof || t.$$typeof) ? !0 : wC2(t, n) && r.equals(e[n], t[n], n, n, e, t, r);
  }
  var jC2 = "[object Arguments]", VC2 = "[object Boolean]", ZC2 = "[object Date]", zC2 = "[object Error]", UC2 = "[object Map]", qC2 = "[object Number]", WC2 = "[object Object]", YC2 = "[object RegExp]", $C2 = "[object Set]", GC2 = "[object String]", KC2 = "[object URL]", XC2 = Array.isArray, sj = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, uj = Object.assign, JC2 = Object.prototype.toString.call.bind(Object.prototype.toString);
  function ed2(e) {
    var t = e.areArraysEqual, r = e.areDatesEqual, n = e.areErrorsEqual, i = e.areFunctionsEqual, o = e.areMapsEqual, u = e.areNumbersEqual, c = e.areObjectsEqual, f = e.arePrimitiveWrappersEqual, d = e.areRegExpsEqual, g = e.areSetsEqual, h = e.areTypedArraysEqual, E = e.areUrlsEqual;
    return function(I, Q, B) {
      if (I === Q)
        return !0;
      if (I == null || Q == null)
        return !1;
      var _ = typeof I;
      if (_ !== typeof Q)
        return !1;
      if (_ !== "object")
        return _ === "number" ? u(I, Q, B) : _ === "function" ? i(I, Q, B) : !1;
      var M = I.constructor;
      if (M !== Q.constructor)
        return !1;
      if (M === Object)
        return c(I, Q, B);
      if (XC2(I))
        return t(I, Q, B);
      if (sj != null && sj(I))
        return h(I, Q, B);
      if (M === Date)
        return r(I, Q, B);
      if (M === RegExp)
        return d(I, Q, B);
      if (M === Map)
        return o(I, Q, B);
      if (M === Set)
        return g(I, Q, B);
      var S = JC2(I);
      return S === ZC2 ? r(I, Q, B) : S === YC2 ? d(I, Q, B) : S === UC2 ? o(I, Q, B) : S === $C2 ? g(I, Q, B) : S === WC2 ? typeof I.then != "function" && typeof Q.then != "function" && c(I, Q, B) : S === KC2 ? E(I, Q, B) : S === zC2 ? n(I, Q, B) : S === jC2 ? c(I, Q, B) : S === VC2 || S === qC2 || S === GC2 ? f(I, Q, B) : !1;
    };
  }
  function td2(e) {
    var t = e.circular, r = e.createCustomConfig, n = e.strict, i = {
      areArraysEqual: n ? Nl : OC2,
      areDatesEqual: TC2,
      areErrorsEqual: DC2,
      areFunctionsEqual: LC2,
      areMapsEqual: n ? tj(aj, Nl) : aj,
      areNumbersEqual: kC2,
      areObjectsEqual: n ? Nl : RC2,
      arePrimitiveWrappersEqual: PC2,
      areRegExpsEqual: FC2,
      areSetsEqual: n ? tj(oj, Nl) : oj,
      areTypedArraysEqual: n ? Nl : NC2,
      areUrlsEqual: HC2
    };
    if (r && (i = uj({}, i, r(i))), t) {
      var o = Hd(i.areArraysEqual), u = Hd(i.areMapsEqual), c = Hd(i.areObjectsEqual), f = Hd(i.areSetsEqual);
      i = uj({}, i, {
        areArraysEqual: o,
        areMapsEqual: u,
        areObjectsEqual: c,
        areSetsEqual: f
      });
    }
    return i;
  }
  function rd2(e) {
    return function(t, r, n, i, o, u, c) {
      return e(t, r, c);
    };
  }
  function nd2(e) {
    var t = e.circular, r = e.comparator, n = e.createState, i = e.equals, o = e.strict;
    if (n)
      return function(f, d) {
        var g = n(), h = g.cache, E = h === void 0 ? t ? /* @__PURE__ */ new WeakMap() : void 0 : h, y = g.meta;
        return r(f, d, {
          cache: E,
          equals: i,
          meta: y,
          strict: o
        });
      };
    if (t)
      return function(f, d) {
        return r(f, d, {
          cache: /* @__PURE__ */ new WeakMap(),
          equals: i,
          meta: void 0,
          strict: o
        });
      };
    var u = {
      cache: void 0,
      equals: i,
      meta: void 0,
      strict: o
    };
    return function(f, d) {
      return r(f, d, u);
    };
  }
  var id2 = t7();
  t7({ strict: !0 });
  t7({ circular: !0 });
  t7({
    circular: !0,
    strict: !0
  });
  t7({
    createInternalComparator: function() {
      return ta;
    }
  });
  t7({
    strict: !0,
    createInternalComparator: function() {
      return ta;
    }
  });
  t7({
    circular: !0,
    createInternalComparator: function() {
      return ta;
    }
  });
  t7({
    circular: !0,
    createInternalComparator: function() {
      return ta;
    },
    strict: !0
  });
  function t7(e) {
    e === void 0 && (e = {});
    var t = e.circular, r = t === void 0 ? !1 : t, n = e.createInternalComparator, i = e.createState, o = e.strict, u = o === void 0 ? !1 : o, c = td2(e), f = ed2(c), d = n ? n(f) : rd2(f);
    return nd2({ circular: r, comparator: f, createState: i, equals: d, strict: u });
  }
  function ad2(e) {
    typeof requestAnimationFrame < "u" && requestAnimationFrame(e);
  }
  function lj(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = -1, n = function i(o) {
      r < 0 && (r = o), o - r > t ? (e(o), r = -1) : ad2(i);
    };
    requestAnimationFrame(n);
  }
  function Ew(e) {
    "@babel/helpers - typeof";
    return Ew = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Ew(e);
  }
  function od2(e) {
    return cd2(e) || ld2(e) || ud2(e) || sd2();
  }
  function sd2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function ud2(e, t) {
    if (e) {
      if (typeof e == "string") return cj(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return cj(e, t);
    }
  }
  function cj(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function ld2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function cd2(e) {
    if (Array.isArray(e)) return e;
  }
  function Ad2() {
    var e = {}, t = function() {
      return null;
    }, r = !1, n = function i(o) {
      if (!r) {
        if (Array.isArray(o)) {
          if (!o.length)
            return;
          var u = o, c = od2(u), f = c[0], d = c.slice(1);
          if (typeof f == "number") {
            lj(i.bind(null, d), f);
            return;
          }
          i(f), lj(i.bind(null, d));
          return;
        }
        Ew(o) === "object" && (e = o, t(e)), typeof o == "function" && o();
      }
    };
    return {
      stop: function() {
        r = !0;
      },
      start: function(o) {
        r = !1, n(o);
      },
      subscribe: function(o) {
        return t = o, function() {
          t = function() {
            return null;
          };
        };
      }
    };
  }
  function Hc(e) {
    "@babel/helpers - typeof";
    return Hc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Hc(e);
  }
  function Aj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function fj(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Aj(Object(r), !0).forEach(function(n) {
        c$(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Aj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function c$(e, t, r) {
    return t = fd2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function fd2(e) {
    var t = Cd2(e, "string");
    return Hc(t) === "symbol" ? t : String(t);
  }
  function Cd2(e, t) {
    if (Hc(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Hc(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var dd2 = function(t, r) {
    return [Object.keys(t), Object.keys(r)].reduce(function(n, i) {
      return n.filter(function(o) {
        return i.includes(o);
      });
    });
  }, gd2 = function(t) {
    return t;
  }, pd2 = function(t) {
    return t.replace(/([A-Z])/g, function(r) {
      return "-".concat(r.toLowerCase());
    });
  }, ac = function(t, r) {
    return Object.keys(r).reduce(function(n, i) {
      return fj(fj({}, n), {}, c$({}, i, t(i, r[i])));
    }, {});
  }, Cj = function(t, r, n) {
    return t.map(function(i) {
      return "".concat(pd2(i), " ").concat(r, "ms ").concat(n);
    }).join(",");
  }, hd2 = process.env.NODE_ENV !== "production", bp = function(t, r, n, i, o, u, c, f) {
    if (hd2 && typeof console < "u" && console.warn && (r === void 0 && console.warn("LogUtils requires an error message argument"), !t))
      if (r === void 0)
        console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
      else {
        var d = [n, i, o, u, c, f], g = 0;
        console.warn(r.replace(/%s/g, function() {
          return d[g++];
        }));
      }
  };
  function vd2(e, t) {
    return yd2(e) || md2(e, t) || A$(e, t) || Ed2();
  }
  function Ed2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function md2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function yd2(e) {
    if (Array.isArray(e)) return e;
  }
  function Id2(e) {
    return xd2(e) || Qd2(e) || A$(e) || Bd2();
  }
  function Bd2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function A$(e, t) {
    if (e) {
      if (typeof e == "string") return mw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return mw(e, t);
    }
  }
  function Qd2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function xd2(e) {
    if (Array.isArray(e)) return mw(e);
  }
  function mw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  var wp = 1e-4, f$ = function(t, r) {
    return [0, 3 * t, 3 * r - 6 * t, 3 * t - 3 * r + 1];
  }, C$ = function(t, r) {
    return t.map(function(n, i) {
      return n * Math.pow(r, i);
    }).reduce(function(n, i) {
      return n + i;
    });
  }, dj = function(t, r) {
    return function(n) {
      var i = f$(t, r);
      return C$(i, n);
    };
  }, bd2 = function(t, r) {
    return function(n) {
      var i = f$(t, r), o = [].concat(Id2(i.map(function(u, c) {
        return u * c;
      }).slice(1)), [0]);
      return C$(o, n);
    };
  }, gj = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    var i = r[0], o = r[1], u = r[2], c = r[3];
    if (r.length === 1)
      switch (r[0]) {
        case "linear":
          i = 0, o = 0, u = 1, c = 1;
          break;
        case "ease":
          i = 0.25, o = 0.1, u = 0.25, c = 1;
          break;
        case "ease-in":
          i = 0.42, o = 0, u = 1, c = 1;
          break;
        case "ease-out":
          i = 0.42, o = 0, u = 0.58, c = 1;
          break;
        case "ease-in-out":
          i = 0, o = 0, u = 0.58, c = 1;
          break;
        default: {
          var f = r[0].split("(");
          if (f[0] === "cubic-bezier" && f[1].split(")")[0].split(",").length === 4) {
            var d = f[1].split(")")[0].split(",").map(function(B) {
              return parseFloat(B);
            }), g = vd2(d, 4);
            i = g[0], o = g[1], u = g[2], c = g[3];
          } else
            bp(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", r);
        }
      }
    bp([i, u, o, c].every(function(B) {
      return typeof B == "number" && B >= 0 && B <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", r);
    var h = dj(i, u), E = dj(o, c), y = bd2(i, u), I = function(_) {
      return _ > 1 ? 1 : _ < 0 ? 0 : _;
    }, Q = function(_) {
      for (var M = _ > 1 ? 1 : _, S = M, O = 0; O < 8; ++O) {
        var w = h(S) - M, D = y(S);
        if (Math.abs(w - M) < wp || D < wp)
          return E(S);
        S = I(S - w / D);
      }
      return E(S);
    };
    return Q.isStepper = !1, Q;
  }, wd2 = function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = t.stiff, n = r === void 0 ? 100 : r, i = t.damping, o = i === void 0 ? 8 : i, u = t.dt, c = u === void 0 ? 17 : u, f = function(g, h, E) {
      var y = -(g - h) * n, I = E * o, Q = E + (y - I) * c / 1e3, B = E * c / 1e3 + g;
      return Math.abs(B - h) < wp && Math.abs(Q) < wp ? [h, 0] : [B, Q];
    };
    return f.isStepper = !0, f.dt = c, f;
  }, Sd2 = function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    var i = r[0];
    if (typeof i == "string")
      switch (i) {
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
          return gj(i);
        case "spring":
          return wd2();
        default:
          if (i.split("(")[0] === "cubic-bezier")
            return gj(i);
          bp(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", r);
      }
    return typeof i == "function" ? i : (bp(!1, "[configEasing]: first argument type should be function or string, instead received %s", r), null);
  };
  function jc(e) {
    "@babel/helpers - typeof";
    return jc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, jc(e);
  }
  function pj(e) {
    return Od2(e) || _d2(e) || d$(e) || Md2();
  }
  function Md2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function _d2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function Od2(e) {
    if (Array.isArray(e)) return Iw(e);
  }
  function hj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function s1(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? hj(Object(r), !0).forEach(function(n) {
        yw(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : hj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function yw(e, t, r) {
    return t = Td2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Td2(e) {
    var t = Dd2(e, "string");
    return jc(t) === "symbol" ? t : String(t);
  }
  function Dd2(e, t) {
    if (jc(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (jc(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Ld2(e, t) {
    return Pd2(e) || Rd2(e, t) || d$(e, t) || kd2();
  }
  function kd2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function d$(e, t) {
    if (e) {
      if (typeof e == "string") return Iw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Iw(e, t);
    }
  }
  function Iw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Rd2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function Pd2(e) {
    if (Array.isArray(e)) return e;
  }
  var Sp = function(t, r, n) {
    return t + (r - t) * n;
  }, Bw = function(t) {
    var r = t.from, n = t.to;
    return r !== n;
  }, Fd2 = function e(t, r, n) {
    var i = ac(function(o, u) {
      if (Bw(u)) {
        var c = t(u.from, u.to, u.velocity), f = Ld2(c, 2), d = f[0], g = f[1];
        return s1(s1({}, u), {}, {
          from: d,
          velocity: g
        });
      }
      return u;
    }, r);
    return n < 1 ? ac(function(o, u) {
      return Bw(u) ? s1(s1({}, u), {}, {
        velocity: Sp(u.velocity, i[o].velocity, n),
        from: Sp(u.from, i[o].from, n)
      }) : u;
    }, r) : e(t, i, n - 1);
  };
  const Nd2 = function(e, t, r, n, i) {
    var o = dd2(e, t), u = o.reduce(function(B, _) {
      return s1(s1({}, B), {}, yw({}, _, [e[_], t[_]]));
    }, {}), c = o.reduce(function(B, _) {
      return s1(s1({}, B), {}, yw({}, _, {
        from: e[_],
        velocity: 0,
        to: t[_]
      }));
    }, {}), f = -1, d, g, h = function() {
      return null;
    }, E = function() {
      return ac(function(_, M) {
        return M.from;
      }, c);
    }, y = function() {
      return !Object.values(c).filter(Bw).length;
    }, I = function(_) {
      d || (d = _);
      var M = _ - d, S = M / r.dt;
      c = Fd2(r, c, S), i(s1(s1(s1({}, e), t), E())), d = _, y() || (f = requestAnimationFrame(h));
    }, Q = function(_) {
      g || (g = _);
      var M = (_ - g) / n, S = ac(function(w, D) {
        return Sp.apply(void 0, pj(D).concat([r(M)]));
      }, u);
      if (i(s1(s1(s1({}, e), t), S)), M < 1)
        f = requestAnimationFrame(h);
      else {
        var O = ac(function(w, D) {
          return Sp.apply(void 0, pj(D).concat([r(1)]));
        }, u);
        i(s1(s1(s1({}, e), t), O));
      }
    };
    return h = r.isStepper ? I : Q, function() {
      return requestAnimationFrame(h), function() {
        cancelAnimationFrame(f);
      };
    };
  };
  function R9(e) {
    "@babel/helpers - typeof";
    return R9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, R9(e);
  }
  var Hd2 = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
  function jd2(e, t) {
    if (e == null) return {};
    var r = Vd2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Vd2(e, t) {
    if (e == null) return {};
    var r = {}, n = Object.keys(e), i, o;
    for (o = 0; o < n.length; o++)
      i = n[o], !(t.indexOf(i) >= 0) && (r[i] = e[i]);
    return r;
  }
  function Bx(e) {
    return qd2(e) || Ud2(e) || zd2(e) || Zd2();
  }
  function Zd2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function zd2(e, t) {
    if (e) {
      if (typeof e == "string") return Qw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Qw(e, t);
    }
  }
  function Ud2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function qd2(e) {
    if (Array.isArray(e)) return Qw(e);
  }
  function Qw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function vj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function ln(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? vj(Object(r), !0).forEach(function(n) {
        Gl(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Gl(e, t, r) {
    return t = g$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Wd2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Yd2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, g$(n.key), n);
    }
  }
  function $d2(e, t, r) {
    return t && Yd2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function g$(e) {
    var t = Gd2(e, "string");
    return R9(t) === "symbol" ? t : String(t);
  }
  function Gd2(e, t) {
    if (R9(e) !== "object" || e === null) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (R9(n) !== "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Kd2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && xw(e, t);
  }
  function xw(e, t) {
    return xw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, xw(e, t);
  }
  function Xd2(e) {
    var t = Jd2();
    return function() {
      var n = Mp(e), i;
      if (t) {
        var o = Mp(this).constructor;
        i = Reflect.construct(n, arguments, o);
      } else
        i = n.apply(this, arguments);
      return bw(this, i);
    };
  }
  function bw(e, t) {
    if (t && (R9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return ww(e);
  }
  function ww(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Jd2() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
    if (typeof Proxy == "function") return !0;
    try {
      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function Mp(e) {
    return Mp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Mp(e);
  }
  var w8 = /* @__PURE__ */ function(e) {
    Kd2(r, e);
    var t = Xd2(r);
    function r(n, i) {
      var o;
      Wd2(this, r), o = t.call(this, n, i);
      var u = o.props, c = u.isActive, f = u.attributeName, d = u.from, g = u.to, h = u.steps, E = u.children, y = u.duration;
      if (o.handleStyleChange = o.handleStyleChange.bind(ww(o)), o.changeStyle = o.changeStyle.bind(ww(o)), !c || y <= 0)
        return o.state = {
          style: {}
        }, typeof E == "function" && (o.state = {
          style: g
        }), bw(o);
      if (h && h.length)
        o.state = {
          style: h[0].style
        };
      else if (d) {
        if (typeof E == "function")
          return o.state = {
            style: d
          }, bw(o);
        o.state = {
          style: f ? Gl({}, f, d) : d
        };
      } else
        o.state = {
          style: {}
        };
      return o;
    }
    return $d2(r, [{
      key: "componentDidMount",
      value: function() {
        var i = this.props, o = i.isActive, u = i.canBegin;
        this.mounted = !0, !(!o || !u) && this.runAnimation(this.props);
      }
    }, {
      key: "componentDidUpdate",
      value: function(i) {
        var o = this.props, u = o.isActive, c = o.canBegin, f = o.attributeName, d = o.shouldReAnimate, g = o.to, h = o.from, E = this.state.style;
        if (c) {
          if (!u) {
            var y = {
              style: f ? Gl({}, f, g) : g
            };
            this.state && E && (f && E[f] !== g || !f && E !== g) && this.setState(y);
            return;
          }
          if (!(id2(i.to, g) && i.canBegin && i.isActive)) {
            var I = !i.canBegin || !i.isActive;
            this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
            var Q = I || d ? h : i.to;
            if (this.state && E) {
              var B = {
                style: f ? Gl({}, f, Q) : Q
              };
              (f && E[f] !== Q || !f && E !== Q) && this.setState(B);
            }
            this.runAnimation(ln(ln({}, this.props), {}, {
              from: Q,
              begin: 0
            }));
          }
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.mounted = !1;
        var i = this.props.onAnimationEnd;
        this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
      }
    }, {
      key: "handleStyleChange",
      value: function(i) {
        this.changeStyle(i);
      }
    }, {
      key: "changeStyle",
      value: function(i) {
        this.mounted && this.setState({
          style: i
        });
      }
    }, {
      key: "runJSAnimation",
      value: function(i) {
        var o = this, u = i.from, c = i.to, f = i.duration, d = i.easing, g = i.begin, h = i.onAnimationEnd, E = i.onAnimationStart, y = Nd2(u, c, Sd2(d), f, this.changeStyle), I = function() {
          o.stopJSAnimation = y();
        };
        this.manager.start([E, g, I, f, h]);
      }
    }, {
      key: "runStepAnimation",
      value: function(i) {
        var o = this, u = i.steps, c = i.begin, f = i.onAnimationStart, d = u[0], g = d.style, h = d.duration, E = h === void 0 ? 0 : h, y = function(Q, B, _) {
          if (_ === 0)
            return Q;
          var M = B.duration, S = B.easing, O = S === void 0 ? "ease" : S, w = B.style, D = B.properties, k = B.onAnimationEnd, F = _ > 0 ? u[_ - 1] : B, z = D || Object.keys(w);
          if (typeof O == "function" || O === "spring")
            return [].concat(Bx(Q), [o.runJSAnimation.bind(o, {
              from: F.style,
              to: w,
              duration: M,
              easing: O
            }), M]);
          var Z = Cj(z, M, O), V = ln(ln(ln({}, F.style), w), {}, {
            transition: Z
          });
          return [].concat(Bx(Q), [V, M, k]).filter(gd2);
        };
        return this.manager.start([f].concat(Bx(u.reduce(y, [g, Math.max(E, c)])), [i.onAnimationEnd]));
      }
    }, {
      key: "runAnimation",
      value: function(i) {
        this.manager || (this.manager = Ad2());
        var o = i.begin, u = i.duration, c = i.attributeName, f = i.to, d = i.easing, g = i.onAnimationStart, h = i.onAnimationEnd, E = i.steps, y = i.children, I = this.manager;
        if (this.unSubscribe = I.subscribe(this.handleStyleChange), typeof d == "function" || typeof y == "function" || d === "spring") {
          this.runJSAnimation(i);
          return;
        }
        if (E.length > 1) {
          this.runStepAnimation(i);
          return;
        }
        var Q = c ? Gl({}, c, f) : f, B = Cj(Object.keys(Q), u, d);
        I.start([g, o, ln(ln({}, Q), {}, {
          transition: B
        }), u, h]);
      }
    }, {
      key: "render",
      value: function() {
        var i = this.props, o = i.children;
        i.begin;
        var u = i.duration;
        i.attributeName, i.easing;
        var c = i.isActive;
        i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
        var f = jd2(i, Hd2), d = q.Children.count(o), g = this.state.style;
        if (typeof o == "function")
          return o(g);
        if (!c || d === 0 || u <= 0)
          return o;
        var h = function(y) {
          var I = y.props, Q = I.style, B = Q === void 0 ? {} : Q, _ = I.className, M = /* @__PURE__ */ q.cloneElement(y, ln(ln({}, f), {}, {
            style: ln(ln({}, B), g),
            className: _
          }));
          return M;
        };
        return d === 1 ? h(q.Children.only(o)) : /* @__PURE__ */ f2.createElement("div", null, q.Children.map(o, function(E) {
          return h(E);
        }));
      }
    }]), r;
  }(q.PureComponent);
  w8.displayName = "Animate";
  w8.defaultProps = {
    begin: 0,
    duration: 1e3,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: !0,
    canBegin: !0,
    steps: [],
    onAnimationEnd: function() {
    },
    onAnimationStart: function() {
    }
  };
  w8.propTypes = {
    from: We.oneOfType([We.object, We.string]),
    to: We.oneOfType([We.object, We.string]),
    attributeName: We.string,
    // animation duration
    duration: We.number,
    begin: We.number,
    easing: We.oneOfType([We.string, We.func]),
    steps: We.arrayOf(We.shape({
      duration: We.number.isRequired,
      style: We.object.isRequired,
      easing: We.oneOfType([We.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), We.func]),
      // transition css properties(dash case), optional
      properties: We.arrayOf("string"),
      onAnimationEnd: We.func
    })),
    children: We.oneOfType([We.node, We.func]),
    isActive: We.bool,
    canBegin: We.bool,
    onAnimationEnd: We.func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: We.bool,
    onAnimationStart: We.func,
    onAnimationReStart: We.func
  };
  function Vc(e) {
    "@babel/helpers - typeof";
    return Vc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Vc(e);
  }
  function _p() {
    return _p = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, _p.apply(this, arguments);
  }
  function eg2(e, t) {
    return ig2(e) || ng2(e, t) || rg2(e, t) || tg2();
  }
  function tg2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function rg2(e, t) {
    if (e) {
      if (typeof e == "string") return Ej(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Ej(e, t);
    }
  }
  function Ej(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function ng2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function ig2(e) {
    if (Array.isArray(e)) return e;
  }
  function mj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function yj(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? mj(Object(r), !0).forEach(function(n) {
        ag2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : mj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function ag2(e, t, r) {
    return t = og2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function og2(e) {
    var t = sg2(e, "string");
    return Vc(t) == "symbol" ? t : t + "";
  }
  function sg2(e, t) {
    if (Vc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Vc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var Ij = function(t, r, n, i, o) {
    var u = Math.min(Math.abs(n) / 2, Math.abs(i) / 2), c = i >= 0 ? 1 : -1, f = n >= 0 ? 1 : -1, d = i >= 0 && n >= 0 || i < 0 && n < 0 ? 1 : 0, g;
    if (u > 0 && o instanceof Array) {
      for (var h = [0, 0, 0, 0], E = 0, y = 4; E < y; E++)
        h[E] = o[E] > u ? u : o[E];
      g = "M".concat(t, ",").concat(r + c * h[0]), h[0] > 0 && (g += "A ".concat(h[0], ",").concat(h[0], ",0,0,").concat(d, ",").concat(t + f * h[0], ",").concat(r)), g += "L ".concat(t + n - f * h[1], ",").concat(r), h[1] > 0 && (g += "A ".concat(h[1], ",").concat(h[1], ",0,0,").concat(d, `,
        `).concat(t + n, ",").concat(r + c * h[1])), g += "L ".concat(t + n, ",").concat(r + i - c * h[2]), h[2] > 0 && (g += "A ".concat(h[2], ",").concat(h[2], ",0,0,").concat(d, `,
        `).concat(t + n - f * h[2], ",").concat(r + i)), g += "L ".concat(t + f * h[3], ",").concat(r + i), h[3] > 0 && (g += "A ".concat(h[3], ",").concat(h[3], ",0,0,").concat(d, `,
        `).concat(t, ",").concat(r + i - c * h[3])), g += "Z";
    } else if (u > 0 && o === +o && o > 0) {
      var I = Math.min(u, o);
      g = "M ".concat(t, ",").concat(r + c * I, `
            A `).concat(I, ",").concat(I, ",0,0,").concat(d, ",").concat(t + f * I, ",").concat(r, `
            L `).concat(t + n - f * I, ",").concat(r, `
            A `).concat(I, ",").concat(I, ",0,0,").concat(d, ",").concat(t + n, ",").concat(r + c * I, `
            L `).concat(t + n, ",").concat(r + i - c * I, `
            A `).concat(I, ",").concat(I, ",0,0,").concat(d, ",").concat(t + n - f * I, ",").concat(r + i, `
            L `).concat(t + f * I, ",").concat(r + i, `
            A `).concat(I, ",").concat(I, ",0,0,").concat(d, ",").concat(t, ",").concat(r + i - c * I, " Z");
    } else
      g = "M ".concat(t, ",").concat(r, " h ").concat(n, " v ").concat(i, " h ").concat(-n, " Z");
    return g;
  }, ug2 = function(t, r) {
    if (!t || !r)
      return !1;
    var n = t.x, i = t.y, o = r.x, u = r.y, c = r.width, f = r.height;
    if (Math.abs(c) > 0 && Math.abs(f) > 0) {
      var d = Math.min(o, o + c), g = Math.max(o, o + c), h = Math.min(u, u + f), E = Math.max(u, u + f);
      return n >= d && n <= g && i >= h && i <= E;
    }
    return !1;
  }, lg2 = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: !1,
    isUpdateAnimationActive: !1,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
  }, qM = function(t) {
    var r = yj(yj({}, lg2), t), n = q.useRef(), i = q.useState(-1), o = eg2(i, 2), u = o[0], c = o[1];
    q.useEffect(function() {
      if (n.current && n.current.getTotalLength)
        try {
          var O = n.current.getTotalLength();
          O && c(O);
        } catch {
        }
    }, []);
    var f = r.x, d = r.y, g = r.width, h = r.height, E = r.radius, y = r.className, I = r.animationEasing, Q = r.animationDuration, B = r.animationBegin, _ = r.isAnimationActive, M = r.isUpdateAnimationActive;
    if (f !== +f || d !== +d || g !== +g || h !== +h || g === 0 || h === 0)
      return null;
    var S = pe("recharts-rectangle", y);
    return M ? /* @__PURE__ */ f2.createElement(w8, {
      canBegin: u > 0,
      from: {
        width: g,
        height: h,
        x: f,
        y: d
      },
      to: {
        width: g,
        height: h,
        x: f,
        y: d
      },
      duration: Q,
      animationEasing: I,
      isActive: M
    }, function(O) {
      var w = O.width, D = O.height, k = O.x, F = O.y;
      return /* @__PURE__ */ f2.createElement(w8, {
        canBegin: u > 0,
        from: "0px ".concat(u === -1 ? 1 : u, "px"),
        to: "".concat(u, "px 0px"),
        attributeName: "strokeDasharray",
        begin: B,
        duration: Q,
        isActive: _,
        easing: I
      }, /* @__PURE__ */ f2.createElement("path", _p({}, ge(r, !0), {
        className: S,
        d: Ij(k, F, w, D, E),
        ref: n
      })));
    }) : /* @__PURE__ */ f2.createElement("path", _p({}, ge(r, !0), {
      className: S,
      d: Ij(f, d, g, h, E)
    }));
  };
  function Sw() {
    return Sw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Sw.apply(this, arguments);
  }
  var WM = function(t) {
    var r = t.cx, n = t.cy, i = t.r, o = t.className, u = pe("recharts-dot", o);
    return r === +r && n === +n && i === +i ? /* @__PURE__ */ f2.createElement("circle", Sw({}, ge(t, !1), Kg(t), {
      className: u,
      cx: r,
      cy: n,
      r: i
    })) : null;
  };
  function Zc(e) {
    "@babel/helpers - typeof";
    return Zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Zc(e);
  }
  var cg2 = ["x", "y", "top", "left", "width", "height", "className"];
  function Mw() {
    return Mw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Mw.apply(this, arguments);
  }
  function Bj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Ag2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Bj(Object(r), !0).forEach(function(n) {
        fg2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Bj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function fg2(e, t, r) {
    return t = Cg2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Cg2(e) {
    var t = dg2(e, "string");
    return Zc(t) == "symbol" ? t : t + "";
  }
  function dg2(e, t) {
    if (Zc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Zc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function gg2(e, t) {
    if (e == null) return {};
    var r = pg2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function pg2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var hg2 = function(t, r, n, i, o, u) {
    return "M".concat(t, ",").concat(o, "v").concat(i, "M").concat(u, ",").concat(r, "h").concat(n);
  }, vg2 = function(t) {
    var r = t.x, n = r === void 0 ? 0 : r, i = t.y, o = i === void 0 ? 0 : i, u = t.top, c = u === void 0 ? 0 : u, f = t.left, d = f === void 0 ? 0 : f, g = t.width, h = g === void 0 ? 0 : g, E = t.height, y = E === void 0 ? 0 : E, I = t.className, Q = gg2(t, cg2), B = Ag2({
      x: n,
      y: o,
      top: c,
      left: d,
      width: h,
      height: y
    }, Q);
    return !G2(n) || !G2(o) || !G2(h) || !G2(y) || !G2(c) || !G2(d) ? null : /* @__PURE__ */ f2.createElement("path", Mw({}, ge(B, !0), {
      className: pe("recharts-cross", I),
      d: hg2(n, o, h, y, c, d)
    }));
  }, Qx, Qj;
  function Eg2() {
    if (Qj) return Qx;
    Qj = 1;
    var e = DW(), t = e(Object.getPrototypeOf, Object);
    return Qx = t, Qx;
  }
  var xx, xj;
  function mg2() {
    if (xj) return xx;
    xj = 1;
    var e = M8(), t = Eg2(), r = _8(), n = "[object Object]", i = Function.prototype, o = Object.prototype, u = i.toString, c = o.hasOwnProperty, f = u.call(Object);
    function d(g) {
      if (!r(g) || e(g) != n)
        return !1;
      var h = t(g);
      if (h === null)
        return !0;
      var E = c.call(h, "constructor") && h.constructor;
      return typeof E == "function" && E instanceof E && u.call(E) == f;
    }
    return xx = d, xx;
  }
  var yg2 = mg2();
  const Ig2 = /* @__PURE__ */ tt(yg2);
  var bx, bj;
  function Bg2() {
    if (bj) return bx;
    bj = 1;
    var e = M8(), t = _8(), r = "[object Boolean]";
    function n(i) {
      return i === !0 || i === !1 || t(i) && e(i) == r;
    }
    return bx = n, bx;
  }
  var Qg2 = Bg2();
  const xg2 = /* @__PURE__ */ tt(Qg2);
  function zc(e) {
    "@babel/helpers - typeof";
    return zc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, zc(e);
  }
  function Op() {
    return Op = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Op.apply(this, arguments);
  }
  function bg2(e, t) {
    return _g2(e) || Mg2(e, t) || Sg2(e, t) || wg2();
  }
  function wg2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Sg2(e, t) {
    if (e) {
      if (typeof e == "string") return wj(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return wj(e, t);
    }
  }
  function wj(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Mg2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function _g2(e) {
    if (Array.isArray(e)) return e;
  }
  function Sj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Mj(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Sj(Object(r), !0).forEach(function(n) {
        Og2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Sj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Og2(e, t, r) {
    return t = Tg2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Tg2(e) {
    var t = Dg2(e, "string");
    return zc(t) == "symbol" ? t : t + "";
  }
  function Dg2(e, t) {
    if (zc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (zc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var _j = function(t, r, n, i, o) {
    var u = n - i, c;
    return c = "M ".concat(t, ",").concat(r), c += "L ".concat(t + n, ",").concat(r), c += "L ".concat(t + n - u / 2, ",").concat(r + o), c += "L ".concat(t + n - u / 2 - i, ",").concat(r + o), c += "L ".concat(t, ",").concat(r, " Z"), c;
  }, Lg2 = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: !1,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
  }, kg2 = function(t) {
    var r = Mj(Mj({}, Lg2), t), n = q.useRef(), i = q.useState(-1), o = bg2(i, 2), u = o[0], c = o[1];
    q.useEffect(function() {
      if (n.current && n.current.getTotalLength)
        try {
          var S = n.current.getTotalLength();
          S && c(S);
        } catch {
        }
    }, []);
    var f = r.x, d = r.y, g = r.upperWidth, h = r.lowerWidth, E = r.height, y = r.className, I = r.animationEasing, Q = r.animationDuration, B = r.animationBegin, _ = r.isUpdateAnimationActive;
    if (f !== +f || d !== +d || g !== +g || h !== +h || E !== +E || g === 0 && h === 0 || E === 0)
      return null;
    var M = pe("recharts-trapezoid", y);
    return _ ? /* @__PURE__ */ f2.createElement(w8, {
      canBegin: u > 0,
      from: {
        upperWidth: 0,
        lowerWidth: 0,
        height: E,
        x: f,
        y: d
      },
      to: {
        upperWidth: g,
        lowerWidth: h,
        height: E,
        x: f,
        y: d
      },
      duration: Q,
      animationEasing: I,
      isActive: _
    }, function(S) {
      var O = S.upperWidth, w = S.lowerWidth, D = S.height, k = S.x, F = S.y;
      return /* @__PURE__ */ f2.createElement(w8, {
        canBegin: u > 0,
        from: "0px ".concat(u === -1 ? 1 : u, "px"),
        to: "".concat(u, "px 0px"),
        attributeName: "strokeDasharray",
        begin: B,
        duration: Q,
        easing: I
      }, /* @__PURE__ */ f2.createElement("path", Op({}, ge(r, !0), {
        className: M,
        d: _j(k, F, O, w, D),
        ref: n
      })));
    }) : /* @__PURE__ */ f2.createElement("g", null, /* @__PURE__ */ f2.createElement("path", Op({}, ge(r, !0), {
      className: M,
      d: _j(f, d, g, h, E)
    })));
  }, Rg2 = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
  function Uc(e) {
    "@babel/helpers - typeof";
    return Uc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Uc(e);
  }
  function Pg2(e, t) {
    if (e == null) return {};
    var r = Fg2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Fg2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Oj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Tp(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Oj(Object(r), !0).forEach(function(n) {
        Ng2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Oj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Ng2(e, t, r) {
    return t = Hg2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Hg2(e) {
    var t = jg2(e, "string");
    return Uc(t) == "symbol" ? t : t + "";
  }
  function jg2(e, t) {
    if (Uc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Uc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Vg2(e, t) {
    return Tp(Tp({}, t), e);
  }
  function Zg2(e, t) {
    return e === "symbols";
  }
  function Tj(e) {
    var t = e.shapeType, r = e.elementProps;
    switch (t) {
      case "rectangle":
        return /* @__PURE__ */ f2.createElement(qM, r);
      case "trapezoid":
        return /* @__PURE__ */ f2.createElement(kg2, r);
      case "sector":
        return /* @__PURE__ */ f2.createElement(o$, r);
      case "symbols":
        if (Zg2(t))
          return /* @__PURE__ */ f2.createElement(cM, r);
        break;
      default:
        return null;
    }
  }
  function zg2(e) {
    return /* @__PURE__ */ q.isValidElement(e) ? e.props : e;
  }
  function Ug2(e) {
    var t = e.option, r = e.shapeType, n = e.propTransformer, i = n === void 0 ? Vg2 : n, o = e.activeClassName, u = o === void 0 ? "recharts-active-shape" : o, c = e.isActive, f = Pg2(e, Rg2), d;
    if (/* @__PURE__ */ q.isValidElement(t))
      d = /* @__PURE__ */ q.cloneElement(t, Tp(Tp({}, f), zg2(t)));
    else if (te(t))
      d = t(f);
    else if (Ig2(t) && !xg2(t)) {
      var g = i(t, f);
      d = /* @__PURE__ */ f2.createElement(Tj, {
        shapeType: r,
        elementProps: g
      });
    } else {
      var h = f;
      d = /* @__PURE__ */ f2.createElement(Tj, {
        shapeType: r,
        elementProps: h
      });
    }
    return c ? /* @__PURE__ */ f2.createElement(n5, {
      className: u
    }, d) : d;
  }
  function jh(e, t) {
    return t != null && "trapezoids" in e.props;
  }
  function Vh(e, t) {
    return t != null && "sectors" in e.props;
  }
  function qc(e, t) {
    return t != null && "points" in e.props;
  }
  function qg2(e, t) {
    var r, n, i = e.x === (t == null || (r = t.labelViewBox) === null || r === void 0 ? void 0 : r.x) || e.x === t.x, o = e.y === (t == null || (n = t.labelViewBox) === null || n === void 0 ? void 0 : n.y) || e.y === t.y;
    return i && o;
  }
  function Wg2(e, t) {
    var r = e.endAngle === t.endAngle, n = e.startAngle === t.startAngle;
    return r && n;
  }
  function Yg2(e, t) {
    var r = e.x === t.x, n = e.y === t.y, i = e.z === t.z;
    return r && n && i;
  }
  function $g2(e, t) {
    var r;
    return jh(e, t) ? r = qg2 : Vh(e, t) ? r = Wg2 : qc(e, t) && (r = Yg2), r;
  }
  function Gg2(e, t) {
    var r;
    return jh(e, t) ? r = "trapezoids" : Vh(e, t) ? r = "sectors" : qc(e, t) && (r = "points"), r;
  }
  function Kg2(e, t) {
    if (jh(e, t)) {
      var r;
      return (r = t.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
    }
    if (Vh(e, t)) {
      var n;
      return (n = t.tooltipPayload) === null || n === void 0 || (n = n[0]) === null || n === void 0 || (n = n.payload) === null || n === void 0 ? void 0 : n.payload;
    }
    return qc(e, t) ? t.payload : {};
  }
  function Xg2(e) {
    var t = e.activeTooltipItem, r = e.graphicalItem, n = e.itemData, i = Gg2(r, t), o = Kg2(r, t), u = n.filter(function(f, d) {
      var g = Fh(o, f), h = r.props[i].filter(function(I) {
        var Q = $g2(r, t);
        return Q(I, t);
      }), E = r.props[i].indexOf(h[h.length - 1]), y = d === E;
      return g && y;
    }), c = n.indexOf(u[u.length - 1]);
    return c;
  }
  var wx, Dj;
  function Jg2() {
    if (Dj) return wx;
    Dj = 1;
    var e = Math.ceil, t = Math.max;
    function r(n, i, o, u) {
      for (var c = -1, f = t(e((i - n) / (o || 1)), 0), d = Array(f); f--; )
        d[u ? f : ++c] = n, n += o;
      return d;
    }
    return wx = r, wx;
  }
  var Sx, Lj;
  function p$() {
    if (Lj) return Sx;
    Lj = 1;
    var e = $W(), t = 1 / 0, r = 17976931348623157e292;
    function n(i) {
      if (!i)
        return i === 0 ? i : 0;
      if (i = e(i), i === t || i === -1 / 0) {
        var o = i < 0 ? -1 : 1;
        return o * r;
      }
      return i === i ? i : 0;
    }
    return Sx = n, Sx;
  }
  var Mx, kj;
  function ep2() {
    if (kj) return Mx;
    kj = 1;
    var e = Jg2(), t = Mh(), r = p$();
    function n(i) {
      return function(o, u, c) {
        return c && typeof c != "number" && t(o, u, c) && (u = c = void 0), o = r(o), u === void 0 ? (u = o, o = 0) : u = r(u), c = c === void 0 ? o < u ? 1 : -1 : r(c), e(o, u, c, i);
      };
    }
    return Mx = n, Mx;
  }
  var _x, Rj;
  function tp2() {
    if (Rj) return _x;
    Rj = 1;
    var e = ep2(), t = e();
    return _x = t, _x;
  }
  var rp2 = tp2();
  const Dp = /* @__PURE__ */ tt(rp2);
  function Wc(e) {
    "@babel/helpers - typeof";
    return Wc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Wc(e);
  }
  function Pj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Fj(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Pj(Object(r), !0).forEach(function(n) {
        h$(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Pj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function h$(e, t, r) {
    return t = np2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function np2(e) {
    var t = ip2(e, "string");
    return Wc(t) == "symbol" ? t : t + "";
  }
  function ip2(e, t) {
    if (Wc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Wc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var ap2 = ["Webkit", "Moz", "O", "ms"], op2 = function(t, r) {
    var n = t.replace(/(\w)/, function(o) {
      return o.toUpperCase();
    }), i = ap2.reduce(function(o, u) {
      return Fj(Fj({}, o), {}, h$({}, u + n, r));
    }, {});
    return i[t] = r, i;
  };
  function P9(e) {
    "@babel/helpers - typeof";
    return P9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, P9(e);
  }
  function Lp() {
    return Lp = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Lp.apply(this, arguments);
  }
  function Nj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Ox(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Nj(Object(r), !0).forEach(function(n) {
        Vr(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Nj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function sp2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Hj(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, E$(n.key), n);
    }
  }
  function up2(e, t, r) {
    return t && Hj(e.prototype, t), r && Hj(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function lp2(e, t, r) {
    return t = kp(t), cp2(e, v$() ? Reflect.construct(t, r || [], kp(e).constructor) : t.apply(e, r));
  }
  function cp2(e, t) {
    if (t && (P9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Ap2(e);
  }
  function Ap2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function v$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (v$ = function() {
      return !!e;
    })();
  }
  function kp(e) {
    return kp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, kp(e);
  }
  function fp2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && _w(e, t);
  }
  function _w(e, t) {
    return _w = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, _w(e, t);
  }
  function Vr(e, t, r) {
    return t = E$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function E$(e) {
    var t = Cp2(e, "string");
    return P9(t) == "symbol" ? t : t + "";
  }
  function Cp2(e, t) {
    if (P9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (P9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var dp2 = function(t) {
    var r = t.data, n = t.startIndex, i = t.endIndex, o = t.x, u = t.width, c = t.travellerWidth;
    if (!r || !r.length)
      return {};
    var f = r.length, d = nc().domain(Dp(0, f)).range([o, o + u - c]), g = d.domain().map(function(h) {
      return d(h);
    });
    return {
      isTextActive: !1,
      isSlideMoving: !1,
      isTravellerMoving: !1,
      isTravellerFocused: !1,
      startX: d(n),
      endX: d(i),
      scale: d,
      scaleValues: g
    };
  }, jj = function(t) {
    return t.changedTouches && !!t.changedTouches.length;
  }, F9 = /* @__PURE__ */ function(e) {
    function t(r) {
      var n;
      return sp2(this, t), n = lp2(this, t, [r]), Vr(n, "handleDrag", function(i) {
        n.leaveTimer && (clearTimeout(n.leaveTimer), n.leaveTimer = null), n.state.isTravellerMoving ? n.handleTravellerMove(i) : n.state.isSlideMoving && n.handleSlideDrag(i);
      }), Vr(n, "handleTouchMove", function(i) {
        i.changedTouches != null && i.changedTouches.length > 0 && n.handleDrag(i.changedTouches[0]);
      }), Vr(n, "handleDragEnd", function() {
        n.setState({
          isTravellerMoving: !1,
          isSlideMoving: !1
        }, function() {
          var i = n.props, o = i.endIndex, u = i.onDragEnd, c = i.startIndex;
          u == null || u({
            endIndex: o,
            startIndex: c
          });
        }), n.detachDragEndListener();
      }), Vr(n, "handleLeaveWrapper", function() {
        (n.state.isTravellerMoving || n.state.isSlideMoving) && (n.leaveTimer = window.setTimeout(n.handleDragEnd, n.props.leaveTimeOut));
      }), Vr(n, "handleEnterSlideOrTraveller", function() {
        n.setState({
          isTextActive: !0
        });
      }), Vr(n, "handleLeaveSlideOrTraveller", function() {
        n.setState({
          isTextActive: !1
        });
      }), Vr(n, "handleSlideDragStart", function(i) {
        var o = jj(i) ? i.changedTouches[0] : i;
        n.setState({
          isTravellerMoving: !1,
          isSlideMoving: !0,
          slideMoveStartX: o.pageX
        }), n.attachDragEndListener();
      }), n.travellerDragStartHandlers = {
        startX: n.handleTravellerDragStart.bind(n, "startX"),
        endX: n.handleTravellerDragStart.bind(n, "endX")
      }, n.state = {}, n;
    }
    return fp2(t, e), up2(t, [{
      key: "componentWillUnmount",
      value: function() {
        this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
      }
    }, {
      key: "getIndex",
      value: function(n) {
        var i = n.startX, o = n.endX, u = this.state.scaleValues, c = this.props, f = c.gap, d = c.data, g = d.length - 1, h = Math.min(i, o), E = Math.max(i, o), y = t.getIndexInRange(u, h), I = t.getIndexInRange(u, E);
        return {
          startIndex: y - y % f,
          endIndex: I === g ? g : I - I % f
        };
      }
    }, {
      key: "getTextOfTick",
      value: function(n) {
        var i = this.props, o = i.data, u = i.tickFormatter, c = i.dataKey, f = Wr(o[n], c, n);
        return te(u) ? u(f, n) : f;
      }
    }, {
      key: "attachDragEndListener",
      value: function() {
        window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
      }
    }, {
      key: "detachDragEndListener",
      value: function() {
        window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
      }
    }, {
      key: "handleSlideDrag",
      value: function(n) {
        var i = this.state, o = i.slideMoveStartX, u = i.startX, c = i.endX, f = this.props, d = f.x, g = f.width, h = f.travellerWidth, E = f.startIndex, y = f.endIndex, I = f.onChange, Q = n.pageX - o;
        Q > 0 ? Q = Math.min(Q, d + g - h - c, d + g - h - u) : Q < 0 && (Q = Math.max(Q, d - u, d - c));
        var B = this.getIndex({
          startX: u + Q,
          endX: c + Q
        });
        (B.startIndex !== E || B.endIndex !== y) && I && I(B), this.setState({
          startX: u + Q,
          endX: c + Q,
          slideMoveStartX: n.pageX
        });
      }
    }, {
      key: "handleTravellerDragStart",
      value: function(n, i) {
        var o = jj(i) ? i.changedTouches[0] : i;
        this.setState({
          isSlideMoving: !1,
          isTravellerMoving: !0,
          movingTravellerId: n,
          brushMoveStartX: o.pageX
        }), this.attachDragEndListener();
      }
    }, {
      key: "handleTravellerMove",
      value: function(n) {
        var i = this.state, o = i.brushMoveStartX, u = i.movingTravellerId, c = i.endX, f = i.startX, d = this.state[u], g = this.props, h = g.x, E = g.width, y = g.travellerWidth, I = g.onChange, Q = g.gap, B = g.data, _ = {
          startX: this.state.startX,
          endX: this.state.endX
        }, M = n.pageX - o;
        M > 0 ? M = Math.min(M, h + E - y - d) : M < 0 && (M = Math.max(M, h - d)), _[u] = d + M;
        var S = this.getIndex(_), O = S.startIndex, w = S.endIndex, D = function() {
          var F = B.length - 1;
          return u === "startX" && (c > f ? O % Q === 0 : w % Q === 0) || c < f && w === F || u === "endX" && (c > f ? w % Q === 0 : O % Q === 0) || c > f && w === F;
        };
        this.setState(Vr(Vr({}, u, d + M), "brushMoveStartX", n.pageX), function() {
          I && D() && I(S);
        });
      }
    }, {
      key: "handleTravellerMoveKeyboard",
      value: function(n, i) {
        var o = this, u = this.state, c = u.scaleValues, f = u.startX, d = u.endX, g = this.state[i], h = c.indexOf(g);
        if (h !== -1) {
          var E = h + n;
          if (!(E === -1 || E >= c.length)) {
            var y = c[E];
            i === "startX" && y >= d || i === "endX" && y <= f || this.setState(Vr({}, i, y), function() {
              o.props.onChange(o.getIndex({
                startX: o.state.startX,
                endX: o.state.endX
              }));
            });
          }
        }
      }
    }, {
      key: "renderBackground",
      value: function() {
        var n = this.props, i = n.x, o = n.y, u = n.width, c = n.height, f = n.fill, d = n.stroke;
        return /* @__PURE__ */ f2.createElement("rect", {
          stroke: d,
          fill: f,
          x: i,
          y: o,
          width: u,
          height: c
        });
      }
    }, {
      key: "renderPanorama",
      value: function() {
        var n = this.props, i = n.x, o = n.y, u = n.width, c = n.height, f = n.data, d = n.children, g = n.padding, h = q.Children.only(d);
        return h ? /* @__PURE__ */ f2.cloneElement(h, {
          x: i,
          y: o,
          width: u,
          height: c,
          margin: g,
          compact: !0,
          data: f
        }) : null;
      }
    }, {
      key: "renderTravellerLayer",
      value: function(n, i) {
        var o, u, c = this, f = this.props, d = f.y, g = f.travellerWidth, h = f.height, E = f.traveller, y = f.ariaLabel, I = f.data, Q = f.startIndex, B = f.endIndex, _ = Math.max(n, this.props.x), M = Ox(Ox({}, ge(this.props, !1)), {}, {
          x: _,
          y: d,
          width: g,
          height: h
        }), S = y || "Min value: ".concat((o = I[Q]) === null || o === void 0 ? void 0 : o.name, ", Max value: ").concat((u = I[B]) === null || u === void 0 ? void 0 : u.name);
        return /* @__PURE__ */ f2.createElement(n5, {
          tabIndex: 0,
          role: "slider",
          "aria-label": S,
          "aria-valuenow": n,
          className: "recharts-brush-traveller",
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.travellerDragStartHandlers[i],
          onTouchStart: this.travellerDragStartHandlers[i],
          onKeyDown: function(w) {
            ["ArrowLeft", "ArrowRight"].includes(w.key) && (w.preventDefault(), w.stopPropagation(), c.handleTravellerMoveKeyboard(w.key === "ArrowRight" ? 1 : -1, i));
          },
          onFocus: function() {
            c.setState({
              isTravellerFocused: !0
            });
          },
          onBlur: function() {
            c.setState({
              isTravellerFocused: !1
            });
          },
          style: {
            cursor: "col-resize"
          }
        }, t.renderTraveller(E, M));
      }
    }, {
      key: "renderSlide",
      value: function(n, i) {
        var o = this.props, u = o.y, c = o.height, f = o.stroke, d = o.travellerWidth, g = Math.min(n, i) + d, h = Math.max(Math.abs(i - n) - d, 0);
        return /* @__PURE__ */ f2.createElement("rect", {
          className: "recharts-brush-slide",
          onMouseEnter: this.handleEnterSlideOrTraveller,
          onMouseLeave: this.handleLeaveSlideOrTraveller,
          onMouseDown: this.handleSlideDragStart,
          onTouchStart: this.handleSlideDragStart,
          style: {
            cursor: "move"
          },
          stroke: "none",
          fill: f,
          fillOpacity: 0.2,
          x: g,
          y: u,
          width: h,
          height: c
        });
      }
    }, {
      key: "renderText",
      value: function() {
        var n = this.props, i = n.startIndex, o = n.endIndex, u = n.y, c = n.height, f = n.travellerWidth, d = n.stroke, g = this.state, h = g.startX, E = g.endX, y = 5, I = {
          pointerEvents: "none",
          fill: d
        };
        return /* @__PURE__ */ f2.createElement(n5, {
          className: "recharts-brush-texts"
        }, /* @__PURE__ */ f2.createElement(lp, Lp({
          textAnchor: "end",
          verticalAnchor: "middle",
          x: Math.min(h, E) - y,
          y: u + c / 2
        }, I), this.getTextOfTick(i)), /* @__PURE__ */ f2.createElement(lp, Lp({
          textAnchor: "start",
          verticalAnchor: "middle",
          x: Math.max(h, E) + f + y,
          y: u + c / 2
        }, I), this.getTextOfTick(o)));
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.data, o = n.className, u = n.children, c = n.x, f = n.y, d = n.width, g = n.height, h = n.alwaysShowText, E = this.state, y = E.startX, I = E.endX, Q = E.isTextActive, B = E.isSlideMoving, _ = E.isTravellerMoving, M = E.isTravellerFocused;
        if (!i || !i.length || !G2(c) || !G2(f) || !G2(d) || !G2(g) || d <= 0 || g <= 0)
          return null;
        var S = pe("recharts-brush", o), O = f2.Children.count(u) === 1, w = op2("userSelect", "none");
        return /* @__PURE__ */ f2.createElement(n5, {
          className: S,
          onMouseLeave: this.handleLeaveWrapper,
          onTouchMove: this.handleTouchMove,
          style: w
        }, this.renderBackground(), O && this.renderPanorama(), this.renderSlide(y, I), this.renderTravellerLayer(y, "startX"), this.renderTravellerLayer(I, "endX"), (Q || B || _ || M || h) && this.renderText());
      }
    }], [{
      key: "renderDefaultTraveller",
      value: function(n) {
        var i = n.x, o = n.y, u = n.width, c = n.height, f = n.stroke, d = Math.floor(o + c / 2) - 1;
        return /* @__PURE__ */ f2.createElement(f2.Fragment, null, /* @__PURE__ */ f2.createElement("rect", {
          x: i,
          y: o,
          width: u,
          height: c,
          fill: f,
          stroke: "none"
        }), /* @__PURE__ */ f2.createElement("line", {
          x1: i + 1,
          y1: d,
          x2: i + u - 1,
          y2: d,
          fill: "none",
          stroke: "#fff"
        }), /* @__PURE__ */ f2.createElement("line", {
          x1: i + 1,
          y1: d + 2,
          x2: i + u - 1,
          y2: d + 2,
          fill: "none",
          stroke: "#fff"
        }));
      }
    }, {
      key: "renderTraveller",
      value: function(n, i) {
        var o;
        return /* @__PURE__ */ f2.isValidElement(n) ? o = /* @__PURE__ */ f2.cloneElement(n, i) : te(n) ? o = n(i) : o = t.renderDefaultTraveller(i), o;
      }
    }, {
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        var o = n.data, u = n.width, c = n.x, f = n.travellerWidth, d = n.updateId, g = n.startIndex, h = n.endIndex;
        if (o !== i.prevData || d !== i.prevUpdateId)
          return Ox({
            prevData: o,
            prevTravellerWidth: f,
            prevUpdateId: d,
            prevX: c,
            prevWidth: u
          }, o && o.length ? dp2({
            data: o,
            width: u,
            x: c,
            travellerWidth: f,
            startIndex: g,
            endIndex: h
          }) : {
            scale: null,
            scaleValues: null
          });
        if (i.scale && (u !== i.prevWidth || c !== i.prevX || f !== i.prevTravellerWidth)) {
          i.scale.range([c, c + u - f]);
          var E = i.scale.domain().map(function(y) {
            return i.scale(y);
          });
          return {
            prevData: o,
            prevTravellerWidth: f,
            prevUpdateId: d,
            prevX: c,
            prevWidth: u,
            startX: i.scale(n.startIndex),
            endX: i.scale(n.endIndex),
            scaleValues: E
          };
        }
        return null;
      }
    }, {
      key: "getIndexInRange",
      value: function(n, i) {
        for (var o = n.length, u = 0, c = o - 1; c - u > 1; ) {
          var f = Math.floor((u + c) / 2);
          n[f] > i ? c = f : u = f;
        }
        return i >= n[c] ? c : u;
      }
    }]);
  }(q.PureComponent);
  Vr(F9, "displayName", "Brush");
  Vr(F9, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
      top: 1,
      right: 1,
      bottom: 1,
      left: 1
    },
    leaveTimeOut: 1e3,
    alwaysShowText: !1
  });
  var Tx, Vj;
  function gp2() {
    if (Vj) return Tx;
    Vj = 1;
    var e = hM();
    function t(r, n) {
      var i;
      return e(r, function(o, u, c) {
        return i = n(o, u, c), !i;
      }), !!i;
    }
    return Tx = t, Tx;
  }
  var Dx, Zj;
  function pp2() {
    if (Zj) return Dx;
    Zj = 1;
    var e = bW(), t = X6(), r = gp2(), n = Ir(), i = Mh();
    function o(u, c, f) {
      var d = n(u) ? e : r;
      return f && i(u, c, f) && (c = void 0), d(u, t(c, 3));
    }
    return Dx = o, Dx;
  }
  var hp2 = pp2();
  const vp2 = /* @__PURE__ */ tt(hp2);
  var A3 = function(t, r) {
    var n = t.alwaysShow, i = t.ifOverflow;
    return n && (i = "extendDomain"), i === r;
  }, Lx, zj;
  function Ep2() {
    if (zj) return Lx;
    zj = 1;
    var e = zW();
    function t(r, n, i) {
      n == "__proto__" && e ? e(r, n, {
        configurable: !0,
        enumerable: !0,
        value: i,
        writable: !0
      }) : r[n] = i;
    }
    return Lx = t, Lx;
  }
  var kx, Uj;
  function mp2() {
    if (Uj) return kx;
    Uj = 1;
    var e = Ep2(), t = VW(), r = X6();
    function n(i, o) {
      var u = {};
      return o = r(o, 3), t(i, function(c, f, d) {
        e(u, f, o(c, f, d));
      }), u;
    }
    return kx = n, kx;
  }
  var yp2 = mp2();
  const Ip2 = /* @__PURE__ */ tt(yp2);
  var Rx, qj;
  function Bp2() {
    if (qj) return Rx;
    qj = 1;
    function e(t, r) {
      for (var n = -1, i = t == null ? 0 : t.length; ++n < i; )
        if (!r(t[n], n, t))
          return !1;
      return !0;
    }
    return Rx = e, Rx;
  }
  var Px, Wj;
  function Qp2() {
    if (Wj) return Px;
    Wj = 1;
    var e = hM();
    function t(r, n) {
      var i = !0;
      return e(r, function(o, u, c) {
        return i = !!n(o, u, c), i;
      }), i;
    }
    return Px = t, Px;
  }
  var Fx, Yj;
  function xp2() {
    if (Yj) return Fx;
    Yj = 1;
    var e = Bp2(), t = Qp2(), r = X6(), n = Ir(), i = Mh();
    function o(u, c, f) {
      var d = n(u) ? e : t;
      return f && i(u, c, f) && (c = void 0), d(u, r(c, 3));
    }
    return Fx = o, Fx;
  }
  var bp2 = xp2();
  const m$ = /* @__PURE__ */ tt(bp2);
  var wp2 = ["x", "y"];
  function N9(e) {
    "@babel/helpers - typeof";
    return N9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, N9(e);
  }
  function Ow() {
    return Ow = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Ow.apply(this, arguments);
  }
  function $j(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Hl(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? $j(Object(r), !0).forEach(function(n) {
        Sp2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : $j(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Sp2(e, t, r) {
    return t = Mp2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Mp2(e) {
    var t = _p2(e, "string");
    return N9(t) == "symbol" ? t : t + "";
  }
  function _p2(e, t) {
    if (N9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (N9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Op2(e, t) {
    if (e == null) return {};
    var r = Tp2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Tp2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Dp2(e, t) {
    var r = e.x, n = e.y, i = Op2(e, wp2), o = "".concat(r), u = parseInt(o, 10), c = "".concat(n), f = parseInt(c, 10), d = "".concat(t.height || i.height), g = parseInt(d, 10), h = "".concat(t.width || i.width), E = parseInt(h, 10);
    return Hl(Hl(Hl(Hl(Hl({}, t), i), u ? {
      x: u
    } : {}), f ? {
      y: f
    } : {}), {}, {
      height: g,
      width: E,
      name: t.name,
      radius: t.radius
    });
  }
  function Gj(e) {
    return /* @__PURE__ */ f2.createElement(Ug2, Ow({
      shapeType: "rectangle",
      propTransformer: Dp2,
      activeClassName: "recharts-active-bar"
    }, e));
  }
  var Lp2 = function(t) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return function(n, i) {
      if (typeof t == "number") return t;
      var o = typeof n == "number";
      return o ? t(n, i) : (o || (process.env.NODE_ENV !== "production" ? mr(!1, "minPointSize callback function received a value with type of ".concat(N9(n), ". Currently only numbers are supported.")) : mr()), r);
    };
  }, kp2 = ["value", "background"], y$;
  function H9(e) {
    "@babel/helpers - typeof";
    return H9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, H9(e);
  }
  function Rp2(e, t) {
    if (e == null) return {};
    var r = Pp2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function Pp2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function Rp() {
    return Rp = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Rp.apply(this, arguments);
  }
  function Kj(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function f5(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? Kj(Object(r), !0).forEach(function(n) {
        F6(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : Kj(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Fp2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Xj(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, B$(n.key), n);
    }
  }
  function Np2(e, t, r) {
    return t && Xj(e.prototype, t), r && Xj(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Hp2(e, t, r) {
    return t = Pp(t), jp2(e, I$() ? Reflect.construct(t, r || [], Pp(e).constructor) : t.apply(e, r));
  }
  function jp2(e, t) {
    if (t && (H9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Vp2(e);
  }
  function Vp2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function I$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (I$ = function() {
      return !!e;
    })();
  }
  function Pp(e) {
    return Pp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Pp(e);
  }
  function Zp2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Tw(e, t);
  }
  function Tw(e, t) {
    return Tw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Tw(e, t);
  }
  function F6(e, t, r) {
    return t = B$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function B$(e) {
    var t = zp2(e, "string");
    return H9(t) == "symbol" ? t : t + "";
  }
  function zp2(e, t) {
    if (H9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (H9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var ra = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      Fp2(this, t);
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      return r = Hp2(this, t, [].concat(i)), F6(r, "state", {
        isAnimationFinished: !1
      }), F6(r, "id", uA("recharts-bar-")), F6(r, "handleAnimationEnd", function() {
        var u = r.props.onAnimationEnd;
        r.setState({
          isAnimationFinished: !0
        }), u && u();
      }), F6(r, "handleAnimationStart", function() {
        var u = r.props.onAnimationStart;
        r.setState({
          isAnimationFinished: !1
        }), u && u();
      }), r;
    }
    return Zp2(t, e), Np2(t, [{
      key: "renderRectanglesStatically",
      value: function(n) {
        var i = this, o = this.props, u = o.shape, c = o.dataKey, f = o.activeIndex, d = o.activeBar, g = ge(this.props, !1);
        return n && n.map(function(h, E) {
          var y = E === f, I = y ? d : u, Q = f5(f5(f5({}, g), h), {}, {
            isActive: y,
            option: I,
            index: E,
            dataKey: c,
            onAnimationStart: i.handleAnimationStart,
            onAnimationEnd: i.handleAnimationEnd
          });
          return /* @__PURE__ */ f2.createElement(n5, Rp({
            className: "recharts-bar-rectangle"
          }, Xg(i.props, h, E), {
            // https://github.com/recharts/recharts/issues/5415
            // eslint-disable-next-line react/no-array-index-key
            key: "rectangle-".concat(h == null ? void 0 : h.x, "-").concat(h == null ? void 0 : h.y, "-").concat(h == null ? void 0 : h.value, "-").concat(E)
          }), /* @__PURE__ */ f2.createElement(Gj, Q));
        });
      }
    }, {
      key: "renderRectanglesWithAnimation",
      value: function() {
        var n = this, i = this.props, o = i.data, u = i.layout, c = i.isAnimationActive, f = i.animationBegin, d = i.animationDuration, g = i.animationEasing, h = i.animationId, E = this.state.prevData;
        return /* @__PURE__ */ f2.createElement(w8, {
          begin: f,
          duration: d,
          isActive: c,
          easing: g,
          from: {
            t: 0
          },
          to: {
            t: 1
          },
          key: "bar-".concat(h),
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        }, function(y) {
          var I = y.t, Q = o.map(function(B, _) {
            var M = E && E[_];
            if (M) {
              var S = dn(M.x, B.x), O = dn(M.y, B.y), w = dn(M.width, B.width), D = dn(M.height, B.height);
              return f5(f5({}, B), {}, {
                x: S(I),
                y: O(I),
                width: w(I),
                height: D(I)
              });
            }
            if (u === "horizontal") {
              var k = dn(0, B.height), F = k(I);
              return f5(f5({}, B), {}, {
                y: B.y + B.height - F,
                height: F
              });
            }
            var z = dn(0, B.width), Z = z(I);
            return f5(f5({}, B), {}, {
              width: Z
            });
          });
          return /* @__PURE__ */ f2.createElement(n5, null, n.renderRectanglesStatically(Q));
        });
      }
    }, {
      key: "renderRectangles",
      value: function() {
        var n = this.props, i = n.data, o = n.isAnimationActive, u = this.state.prevData;
        return o && i && i.length && (!u || !Fh(u, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
      }
    }, {
      key: "renderBackground",
      value: function() {
        var n = this, i = this.props, o = i.data, u = i.dataKey, c = i.activeIndex, f = ge(this.props.background, !1);
        return o.map(function(d, g) {
          d.value;
          var h = d.background, E = Rp2(d, kp2);
          if (!h)
            return null;
          var y = f5(f5(f5(f5(f5({}, E), {}, {
            fill: "#eee"
          }, h), f), Xg(n.props, d, g)), {}, {
            onAnimationStart: n.handleAnimationStart,
            onAnimationEnd: n.handleAnimationEnd,
            dataKey: u,
            index: g,
            className: "recharts-bar-background-rectangle"
          });
          return /* @__PURE__ */ f2.createElement(Gj, Rp({
            key: "background-bar-".concat(g),
            option: n.props.background,
            isActive: g === c
          }, y));
        });
      }
    }, {
      key: "renderErrorBar",
      value: function(n, i) {
        if (this.props.isAnimationActive && !this.state.isAnimationFinished)
          return null;
        var o = this.props, u = o.data, c = o.xAxis, f = o.yAxis, d = o.layout, g = o.children, h = S4(g, dA);
        if (!h)
          return null;
        var E = d === "vertical" ? u[0].height / 2 : u[0].width / 2, y = function(B, _) {
          var M = Array.isArray(B.value) ? B.value[1] : B.value;
          return {
            x: B.x,
            y: B.y,
            value: M,
            errorVal: Wr(B, _)
          };
        }, I = {
          clipPath: n ? "url(#clipPath-".concat(i, ")") : null
        };
        return /* @__PURE__ */ f2.createElement(n5, I, h.map(function(Q) {
          return /* @__PURE__ */ f2.cloneElement(Q, {
            key: "error-bar-".concat(i, "-").concat(Q.props.dataKey),
            data: u,
            xAxis: c,
            yAxis: f,
            layout: d,
            offset: E,
            dataPointFormatter: y
          });
        }));
      }
    }, {
      key: "render",
      value: function() {
        var n = this.props, i = n.hide, o = n.data, u = n.className, c = n.xAxis, f = n.yAxis, d = n.left, g = n.top, h = n.width, E = n.height, y = n.isAnimationActive, I = n.background, Q = n.id;
        if (i || !o || !o.length)
          return null;
        var B = this.state.isAnimationFinished, _ = pe("recharts-bar", u), M = c && c.allowDataOverflow, S = f && f.allowDataOverflow, O = M || S, w = Ae(Q) ? this.id : Q;
        return /* @__PURE__ */ f2.createElement(n5, {
          className: _
        }, M || S ? /* @__PURE__ */ f2.createElement("defs", null, /* @__PURE__ */ f2.createElement("clipPath", {
          id: "clipPath-".concat(w)
        }, /* @__PURE__ */ f2.createElement("rect", {
          x: M ? d : d - h / 2,
          y: S ? g : g - E / 2,
          width: M ? h : h * 2,
          height: S ? E : E * 2
        }))) : null, /* @__PURE__ */ f2.createElement(n5, {
          className: "recharts-bar-rectangles",
          clipPath: O ? "url(#clipPath-".concat(w, ")") : null
        }, I ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(O, w), (!y || B) && j6.renderCallByParent(this.props, o));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        return n.animationId !== i.prevAnimationId ? {
          prevAnimationId: n.animationId,
          curData: n.data,
          prevData: i.curData
        } : n.data !== i.curData ? {
          curData: n.data
        } : null;
      }
    }]);
  }(q.PureComponent);
  y$ = ra;
  F6(ra, "displayName", "Bar");
  F6(ra, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: !1,
    data: [],
    layout: "vertical",
    activeBar: !1,
    isAnimationActive: !As.isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
  });
  F6(ra, "getComposedData", function(e) {
    var t = e.props, r = e.item, n = e.barPosition, i = e.bandSize, o = e.xAxis, u = e.yAxis, c = e.xAxisTicks, f = e.yAxisTicks, d = e.stackedData, g = e.dataStartIndex, h = e.displayedData, E = e.offset, y = if2(n, r);
    if (!y)
      return null;
    var I = t.layout, Q = r.type.defaultProps, B = Q !== void 0 ? f5(f5({}, Q), r.props) : r.props, _ = B.dataKey, M = B.children, S = B.minPointSize, O = I === "horizontal" ? u : o, w = d ? O.scale.domain() : null, D = ff2({
      numericAxis: O
    }), k = S4(M, KW), F = h.map(function(z, Z) {
      var V, $, W, t2, n2, s2;
      d ? V = af2(d[g + Z], w) : (V = Wr(z, _), Array.isArray(V) || (V = [D, V]));
      var l2 = Lp2(S, y$.defaultProps.minPointSize)(V[1], Z);
      if (I === "horizontal") {
        var X, a2 = [u.scale(V[0]), u.scale(V[1])], e2 = a2[0], H = a2[1];
        $ = SH({
          axis: o,
          ticks: c,
          bandSize: i,
          offset: y.offset,
          entry: z,
          index: Z
        }), W = (X = H ?? e2) !== null && X !== void 0 ? X : void 0, t2 = y.size;
        var Y = e2 - H;
        if (n2 = Number.isNaN(Y) ? 0 : Y, s2 = {
          x: $,
          y: u.y,
          width: t2,
          height: u.height
        }, Math.abs(l2) > 0 && Math.abs(n2) < Math.abs(l2)) {
          var r2 = pn(n2 || l2) * (Math.abs(l2) - Math.abs(n2));
          W -= r2, n2 += r2;
        }
      } else {
        var o2 = [o.scale(V[0]), o.scale(V[1])], O2 = o2[0], S2 = o2[1];
        if ($ = O2, W = SH({
          axis: u,
          ticks: f,
          bandSize: i,
          offset: y.offset,
          entry: z,
          index: Z
        }), t2 = S2 - O2, n2 = y.size, s2 = {
          x: o.x,
          y: W,
          width: o.width,
          height: n2
        }, Math.abs(l2) > 0 && Math.abs(t2) < Math.abs(l2)) {
          var M2 = pn(t2 || l2) * (Math.abs(l2) - Math.abs(t2));
          t2 += M2;
        }
      }
      return f5(f5(f5({}, z), {}, {
        x: $,
        y: W,
        width: t2,
        height: n2,
        value: d ? V : V[1],
        payload: z,
        background: s2
      }, k && k[Z] && k[Z].props), {}, {
        tooltipPayload: [n$(r, z)],
        tooltipPosition: {
          x: $ + t2 / 2,
          y: W + n2 / 2
        }
      });
    });
    return f5({
      data: F,
      layout: I
    }, E);
  });
  function Yc(e) {
    "@babel/helpers - typeof";
    return Yc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Yc(e);
  }
  function Up2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Jj(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Q$(n.key), n);
    }
  }
  function qp2(e, t, r) {
    return t && Jj(e.prototype, t), r && Jj(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function eV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function An(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? eV(Object(r), !0).forEach(function(n) {
        Zh(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : eV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Zh(e, t, r) {
    return t = Q$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Q$(e) {
    var t = Wp2(e, "string");
    return Yc(t) == "symbol" ? t : t + "";
  }
  function Wp2(e, t) {
    if (Yc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Yc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var x$ = function(t, r, n, i, o) {
    var u = t.width, c = t.height, f = t.layout, d = t.children, g = Object.keys(r), h = {
      left: n.left,
      leftMirror: n.left,
      right: u - n.right,
      rightMirror: u - n.right,
      top: n.top,
      topMirror: n.top,
      bottom: c - n.bottom,
      bottomMirror: c - n.bottom
    }, E = !!Zr(d, ra);
    return g.reduce(function(y, I) {
      var Q = r[I], B = Q.orientation, _ = Q.domain, M = Q.padding, S = M === void 0 ? {} : M, O = Q.mirror, w = Q.reversed, D = "".concat(B).concat(O ? "Mirror" : ""), k, F, z, Z, V;
      if (Q.type === "number" && (Q.padding === "gap" || Q.padding === "no-gap")) {
        var $ = _[1] - _[0], W = 1 / 0, t2 = Q.categoricalDomain.sort(Hi2);
        if (t2.forEach(function(o2, O2) {
          O2 > 0 && (W = Math.min((o2 || 0) - (t2[O2 - 1] || 0), W));
        }), Number.isFinite(W)) {
          var n2 = W / $, s2 = Q.layout === "vertical" ? n.height : n.width;
          if (Q.padding === "gap" && (k = n2 * s2 / 2), Q.padding === "no-gap") {
            var l2 = Zi(t.barCategoryGap, n2 * s2), X = n2 * s2 / 2;
            k = X - l2 - (X - l2) / s2 * l2;
          }
        }
      }
      i === "xAxis" ? F = [n.left + (S.left || 0) + (k || 0), n.left + n.width - (S.right || 0) - (k || 0)] : i === "yAxis" ? F = f === "horizontal" ? [n.top + n.height - (S.bottom || 0), n.top + (S.top || 0)] : [n.top + (S.top || 0) + (k || 0), n.top + n.height - (S.bottom || 0) - (k || 0)] : F = Q.range, w && (F = [F[1], F[0]]);
      var a2 = rf2(Q, o, E), e2 = a2.scale, H = a2.realScaleType;
      e2.domain(_).range(F), nf2(e2);
      var Y = Af2(e2, An(An({}, Q), {}, {
        realScaleType: H
      }));
      i === "xAxis" ? (V = B === "top" && !O || B === "bottom" && O, z = n.left, Z = h[D] - V * Q.height) : i === "yAxis" && (V = B === "left" && !O || B === "right" && O, z = h[D] - V * Q.width, Z = n.top);
      var r2 = An(An(An({}, Q), Y), {}, {
        realScaleType: H,
        x: z,
        y: Z,
        scale: e2,
        width: i === "xAxis" ? n.width : Q.width,
        height: i === "yAxis" ? n.height : Q.height
      });
      return r2.bandSize = Bp(r2, Y), !Q.hide && i === "xAxis" ? h[D] += (V ? -1 : 1) * r2.height : Q.hide || (h[D] += (V ? -1 : 1) * r2.width), An(An({}, y), {}, Zh({}, I, r2));
    }, {});
  }, b$ = function(t, r) {
    var n = t.x, i = t.y, o = r.x, u = r.y;
    return {
      x: Math.min(n, o),
      y: Math.min(i, u),
      width: Math.abs(o - n),
      height: Math.abs(u - i)
    };
  }, Yp2 = function(t) {
    var r = t.x1, n = t.y1, i = t.x2, o = t.y2;
    return b$({
      x: r,
      y: n
    }, {
      x: i,
      y: o
    });
  }, w$ = /* @__PURE__ */ function() {
    function e(t) {
      Up2(this, e), this.scale = t;
    }
    return qp2(e, [{
      key: "domain",
      get: function() {
        return this.scale.domain;
      }
    }, {
      key: "range",
      get: function() {
        return this.scale.range;
      }
    }, {
      key: "rangeMin",
      get: function() {
        return this.range()[0];
      }
    }, {
      key: "rangeMax",
      get: function() {
        return this.range()[1];
      }
    }, {
      key: "bandwidth",
      get: function() {
        return this.scale.bandwidth;
      }
    }, {
      key: "apply",
      value: function(r) {
        var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = n.bandAware, o = n.position;
        if (r !== void 0) {
          if (o)
            switch (o) {
              case "start":
                return this.scale(r);
              case "middle": {
                var u = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(r) + u;
              }
              case "end": {
                var c = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(r) + c;
              }
              default:
                return this.scale(r);
            }
          if (i) {
            var f = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(r) + f;
          }
          return this.scale(r);
        }
      }
    }, {
      key: "isInRange",
      value: function(r) {
        var n = this.range(), i = n[0], o = n[n.length - 1];
        return i <= o ? r >= i && r <= o : r >= o && r <= i;
      }
    }], [{
      key: "create",
      value: function(r) {
        return new e(r);
      }
    }]);
  }();
  Zh(w$, "EPS", 1e-4);
  var YM = function(t) {
    var r = Object.keys(t).reduce(function(n, i) {
      return An(An({}, n), {}, Zh({}, i, w$.create(t[i])));
    }, {});
    return An(An({}, r), {}, {
      apply: function(i) {
        var o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, u = o.bandAware, c = o.position;
        return Ip2(i, function(f, d) {
          return r[d].apply(f, {
            bandAware: u,
            position: c
          });
        });
      },
      isInRange: function(i) {
        return m$(i, function(o, u) {
          return r[u].isInRange(o);
        });
      }
    });
  };
  function $p2(e) {
    return (e % 180 + 180) % 180;
  }
  var Gp2 = function(t) {
    var r = t.width, n = t.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = $p2(i), u = o * Math.PI / 180, c = Math.atan(n / r), f = u > c && u < Math.PI - c ? n / Math.sin(u) : r / Math.cos(u);
    return Math.abs(f);
  }, Nx, tV;
  function Kp2() {
    if (tV) return Nx;
    tV = 1;
    var e = X6(), t = lA(), r = wh();
    function n(i) {
      return function(o, u, c) {
        var f = Object(o);
        if (!t(o)) {
          var d = e(u, 3);
          o = r(o), u = function(h) {
            return d(f[h], h, f);
          };
        }
        var g = i(o, u, c);
        return g > -1 ? f[d ? o[g] : g] : void 0;
      };
    }
    return Nx = n, Nx;
  }
  var Hx, rV;
  function Xp2() {
    if (rV) return Hx;
    rV = 1;
    var e = p$();
    function t(r) {
      var n = e(r), i = n % 1;
      return n === n ? i ? n - i : n : 0;
    }
    return Hx = t, Hx;
  }
  var jx, nV;
  function Jp2() {
    if (nV) return jx;
    nV = 1;
    var e = PW(), t = X6(), r = Xp2(), n = Math.max;
    function i(o, u, c) {
      var f = o == null ? 0 : o.length;
      if (!f)
        return -1;
      var d = c == null ? 0 : r(c);
      return d < 0 && (d = n(f + d, 0)), e(o, t(u, 3), d);
    }
    return jx = i, jx;
  }
  var Vx, iV;
  function eh2() {
    if (iV) return Vx;
    iV = 1;
    var e = Kp2(), t = Jp2(), r = e(t);
    return Vx = r, Vx;
  }
  var th2 = eh2();
  const rh2 = /* @__PURE__ */ tt(th2);
  var nh2 = Jq();
  const ih2 = /* @__PURE__ */ tt(nh2);
  var ah2 = ih2(function(e) {
    return {
      x: e.left,
      y: e.top,
      width: e.width,
      height: e.height
    };
  }, function(e) {
    return ["l", e.left, "t", e.top, "w", e.width, "h", e.height].join("");
  });
  function Fp(e) {
    "@babel/helpers - typeof";
    return Fp = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Fp(e);
  }
  var $M = /* @__PURE__ */ q.createContext(void 0), GM = /* @__PURE__ */ q.createContext(void 0), S$ = /* @__PURE__ */ q.createContext(void 0), M$ = /* @__PURE__ */ q.createContext({}), _$ = /* @__PURE__ */ q.createContext(void 0), O$ = /* @__PURE__ */ q.createContext(0), T$ = /* @__PURE__ */ q.createContext(0), aV = function(t) {
    var r = t.state, n = r.xAxisMap, i = r.yAxisMap, o = r.offset, u = t.clipPathId, c = t.children, f = t.width, d = t.height, g = ah2(o);
    return /* @__PURE__ */ f2.createElement($M.Provider, {
      value: n
    }, /* @__PURE__ */ f2.createElement(GM.Provider, {
      value: i
    }, /* @__PURE__ */ f2.createElement(M$.Provider, {
      value: o
    }, /* @__PURE__ */ f2.createElement(S$.Provider, {
      value: g
    }, /* @__PURE__ */ f2.createElement(_$.Provider, {
      value: u
    }, /* @__PURE__ */ f2.createElement(O$.Provider, {
      value: d
    }, /* @__PURE__ */ f2.createElement(T$.Provider, {
      value: f
    }, c)))))));
  }, oh2 = function() {
    return q.useContext(_$);
  };
  function D$(e) {
    var t = Object.keys(e);
    return t.length === 0 ? "There are no available ids." : "Available ids are: ".concat(t, ".");
  }
  var L$ = function(t) {
    var r = q.useContext($M);
    r == null && (process.env.NODE_ENV !== "production" ? mr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : mr());
    var n = r[t];
    return n == null && (process.env.NODE_ENV !== "production" ? mr(!1, 'Could not find xAxis by id "'.concat(t, '" [').concat(Fp(t), "]. ").concat(D$(r))) : mr()), n;
  }, sh2 = function() {
    var t = q.useContext($M);
    return P6(t);
  }, uh2 = function() {
    var t = q.useContext(GM), r = rh2(t, function(n) {
      return m$(n.domain, Number.isFinite);
    });
    return r || P6(t);
  }, k$ = function(t) {
    var r = q.useContext(GM);
    r == null && (process.env.NODE_ENV !== "production" ? mr(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : mr());
    var n = r[t];
    return n == null && (process.env.NODE_ENV !== "production" ? mr(!1, 'Could not find yAxis by id "'.concat(t, '" [').concat(Fp(t), "]. ").concat(D$(r))) : mr()), n;
  }, lh2 = function() {
    var t = q.useContext(S$);
    return t;
  }, ch2 = function() {
    return q.useContext(M$);
  }, KM = function() {
    return q.useContext(T$);
  }, XM = function() {
    return q.useContext(O$);
  };
  function j9(e) {
    "@babel/helpers - typeof";
    return j9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, j9(e);
  }
  function Ah2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function fh2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, P$(n.key), n);
    }
  }
  function Ch2(e, t, r) {
    return t && fh2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function dh2(e, t, r) {
    return t = Np(t), gh2(e, R$() ? Reflect.construct(t, r || [], Np(e).constructor) : t.apply(e, r));
  }
  function gh2(e, t) {
    if (t && (j9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return ph2(e);
  }
  function ph2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function R$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (R$ = function() {
      return !!e;
    })();
  }
  function Np(e) {
    return Np = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Np(e);
  }
  function hh2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Dw(e, t);
  }
  function Dw(e, t) {
    return Dw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Dw(e, t);
  }
  function oV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function sV(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? oV(Object(r), !0).forEach(function(n) {
        JM(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : oV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function JM(e, t, r) {
    return t = P$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function P$(e) {
    var t = vh2(e, "string");
    return j9(t) == "symbol" ? t : t + "";
  }
  function vh2(e, t) {
    if (j9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (j9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Eh2(e, t) {
    return Bh2(e) || Ih2(e, t) || yh2(e, t) || mh2();
  }
  function mh2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function yh2(e, t) {
    if (e) {
      if (typeof e == "string") return uV(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return uV(e, t);
    }
  }
  function uV(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Ih2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function Bh2(e) {
    if (Array.isArray(e)) return e;
  }
  function Lw() {
    return Lw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Lw.apply(this, arguments);
  }
  var Qh2 = function(t, r) {
    var n;
    return /* @__PURE__ */ f2.isValidElement(t) ? n = /* @__PURE__ */ f2.cloneElement(t, r) : te(t) ? n = t(r) : n = /* @__PURE__ */ f2.createElement("line", Lw({}, r, {
      className: "recharts-reference-line-line"
    })), n;
  }, xh2 = function(t, r, n, i, o, u, c, f, d) {
    var g = o.x, h = o.y, E = o.width, y = o.height;
    if (n) {
      var I = d.y, Q = t.y.apply(I, {
        position: u
      });
      if (A3(d, "discard") && !t.y.isInRange(Q))
        return null;
      var B = [{
        x: g + E,
        y: Q
      }, {
        x: g,
        y: Q
      }];
      return f === "left" ? B.reverse() : B;
    }
    if (r) {
      var _ = d.x, M = t.x.apply(_, {
        position: u
      });
      if (A3(d, "discard") && !t.x.isInRange(M))
        return null;
      var S = [{
        x: M,
        y: h + y
      }, {
        x: M,
        y: h
      }];
      return c === "top" ? S.reverse() : S;
    }
    if (i) {
      var O = d.segment, w = O.map(function(D) {
        return t.apply(D, {
          position: u
        });
      });
      return A3(d, "discard") && vp2(w, function(D) {
        return !t.isInRange(D);
      }) ? null : w;
    }
    return null;
  };
  function bh2(e) {
    var t = e.x, r = e.y, n = e.segment, i = e.xAxisId, o = e.yAxisId, u = e.shape, c = e.className, f = e.alwaysShow, d = oh2(), g = L$(i), h = k$(o), E = lh2();
    if (!d || !E)
      return null;
    v8(f === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var y = YM({
      x: g.scale,
      y: h.scale
    }), I = T5(t), Q = T5(r), B = n && n.length === 2, _ = xh2(y, I, Q, B, E, e.position, g.orientation, h.orientation, e);
    if (!_)
      return null;
    var M = Eh2(_, 2), S = M[0], O = S.x, w = S.y, D = M[1], k = D.x, F = D.y, z = A3(e, "hidden") ? "url(#".concat(d, ")") : void 0, Z = sV(sV({
      clipPath: z
    }, ge(e, !0)), {}, {
      x1: O,
      y1: w,
      x2: k,
      y2: F
    });
    return /* @__PURE__ */ f2.createElement(n5, {
      className: pe("recharts-reference-line", c)
    }, Qh2(u, Z), _1.renderCallByParent(e, Yp2({
      x1: O,
      y1: w,
      x2: k,
      y2: F
    })));
  }
  var e_ = /* @__PURE__ */ function(e) {
    function t() {
      return Ah2(this, t), dh2(this, t, arguments);
    }
    return hh2(t, e), Ch2(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ f2.createElement(bh2, this.props);
      }
    }]);
  }(f2.Component);
  JM(e_, "displayName", "ReferenceLine");
  JM(e_, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
  });
  function kw() {
    return kw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, kw.apply(this, arguments);
  }
  function V9(e) {
    "@babel/helpers - typeof";
    return V9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, V9(e);
  }
  function lV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function cV(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? lV(Object(r), !0).forEach(function(n) {
        zh(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : lV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function wh2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Sh2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, N$(n.key), n);
    }
  }
  function Mh2(e, t, r) {
    return t && Sh2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function _h2(e, t, r) {
    return t = Hp(t), Oh2(e, F$() ? Reflect.construct(t, r || [], Hp(e).constructor) : t.apply(e, r));
  }
  function Oh2(e, t) {
    if (t && (V9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Th2(e);
  }
  function Th2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function F$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (F$ = function() {
      return !!e;
    })();
  }
  function Hp(e) {
    return Hp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Hp(e);
  }
  function Dh2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Rw(e, t);
  }
  function Rw(e, t) {
    return Rw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Rw(e, t);
  }
  function zh(e, t, r) {
    return t = N$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function N$(e) {
    var t = Lh2(e, "string");
    return V9(t) == "symbol" ? t : t + "";
  }
  function Lh2(e, t) {
    if (V9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (V9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var kh2 = function(t) {
    var r = t.x, n = t.y, i = t.xAxis, o = t.yAxis, u = YM({
      x: i.scale,
      y: o.scale
    }), c = u.apply({
      x: r,
      y: n
    }, {
      bandAware: !0
    });
    return A3(t, "discard") && !u.isInRange(c) ? null : c;
  }, Uh = /* @__PURE__ */ function(e) {
    function t() {
      return wh2(this, t), _h2(this, t, arguments);
    }
    return Dh2(t, e), Mh2(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.x, o = n.y, u = n.r, c = n.alwaysShow, f = n.clipPathId, d = T5(i), g = T5(o);
        if (v8(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !d || !g)
          return null;
        var h = kh2(this.props);
        if (!h)
          return null;
        var E = h.x, y = h.y, I = this.props, Q = I.shape, B = I.className, _ = A3(this.props, "hidden") ? "url(#".concat(f, ")") : void 0, M = cV(cV({
          clipPath: _
        }, ge(this.props, !0)), {}, {
          cx: E,
          cy: y
        });
        return /* @__PURE__ */ f2.createElement(n5, {
          className: pe("recharts-reference-dot", B)
        }, t.renderDot(Q, M), _1.renderCallByParent(this.props, {
          x: E - u,
          y: y - u,
          width: 2 * u,
          height: 2 * u
        }));
      }
    }]);
  }(f2.Component);
  zh(Uh, "displayName", "ReferenceDot");
  zh(Uh, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
  });
  zh(Uh, "renderDot", function(e, t) {
    var r;
    return /* @__PURE__ */ f2.isValidElement(e) ? r = /* @__PURE__ */ f2.cloneElement(e, t) : te(e) ? r = e(t) : r = /* @__PURE__ */ f2.createElement(WM, kw({}, t, {
      cx: t.cx,
      cy: t.cy,
      className: "recharts-reference-dot-dot"
    })), r;
  });
  function Pw() {
    return Pw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Pw.apply(this, arguments);
  }
  function Z9(e) {
    "@babel/helpers - typeof";
    return Z9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Z9(e);
  }
  function AV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function fV(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? AV(Object(r), !0).forEach(function(n) {
        qh(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : AV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Rh2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Ph2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, j$(n.key), n);
    }
  }
  function Fh2(e, t, r) {
    return t && Ph2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Nh2(e, t, r) {
    return t = jp(t), Hh2(e, H$() ? Reflect.construct(t, r || [], jp(e).constructor) : t.apply(e, r));
  }
  function Hh2(e, t) {
    if (t && (Z9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return jh2(e);
  }
  function jh2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function H$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (H$ = function() {
      return !!e;
    })();
  }
  function jp(e) {
    return jp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, jp(e);
  }
  function Vh2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Fw(e, t);
  }
  function Fw(e, t) {
    return Fw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Fw(e, t);
  }
  function qh(e, t, r) {
    return t = j$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function j$(e) {
    var t = Zh2(e, "string");
    return Z9(t) == "symbol" ? t : t + "";
  }
  function Zh2(e, t) {
    if (Z9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Z9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var zh2 = function(t, r, n, i, o) {
    var u = o.x1, c = o.x2, f = o.y1, d = o.y2, g = o.xAxis, h = o.yAxis;
    if (!g || !h) return null;
    var E = YM({
      x: g.scale,
      y: h.scale
    }), y = {
      x: t ? E.x.apply(u, {
        position: "start"
      }) : E.x.rangeMin,
      y: n ? E.y.apply(f, {
        position: "start"
      }) : E.y.rangeMin
    }, I = {
      x: r ? E.x.apply(c, {
        position: "end"
      }) : E.x.rangeMax,
      y: i ? E.y.apply(d, {
        position: "end"
      }) : E.y.rangeMax
    };
    return A3(o, "discard") && (!E.isInRange(y) || !E.isInRange(I)) ? null : b$(y, I);
  }, Wh = /* @__PURE__ */ function(e) {
    function t() {
      return Rh2(this, t), Nh2(this, t, arguments);
    }
    return Vh2(t, e), Fh2(t, [{
      key: "render",
      value: function() {
        var n = this.props, i = n.x1, o = n.x2, u = n.y1, c = n.y2, f = n.className, d = n.alwaysShow, g = n.clipPathId;
        v8(d === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
        var h = T5(i), E = T5(o), y = T5(u), I = T5(c), Q = this.props.shape;
        if (!h && !E && !y && !I && !Q)
          return null;
        var B = zh2(h, E, y, I, this.props);
        if (!B && !Q)
          return null;
        var _ = A3(this.props, "hidden") ? "url(#".concat(g, ")") : void 0;
        return /* @__PURE__ */ f2.createElement(n5, {
          className: pe("recharts-reference-area", f)
        }, t.renderRect(Q, fV(fV({
          clipPath: _
        }, ge(this.props, !0)), B)), _1.renderCallByParent(this.props, B));
      }
    }]);
  }(f2.Component);
  qh(Wh, "displayName", "ReferenceArea");
  qh(Wh, "defaultProps", {
    isFront: !1,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
  });
  qh(Wh, "renderRect", function(e, t) {
    var r;
    return /* @__PURE__ */ f2.isValidElement(e) ? r = /* @__PURE__ */ f2.cloneElement(e, t) : te(e) ? r = e(t) : r = /* @__PURE__ */ f2.createElement(qM, Pw({}, t, {
      className: "recharts-reference-area-rect"
    })), r;
  });
  function V$(e, t, r) {
    if (t < 1)
      return [];
    if (t === 1 && r === void 0)
      return e;
    for (var n = [], i = 0; i < e.length; i += t)
      n.push(e[i]);
    return n;
  }
  function Uh2(e, t, r) {
    var n = {
      width: e.width + t.width,
      height: e.height + t.height
    };
    return Gp2(n, r);
  }
  function qh2(e, t, r) {
    var n = r === "width", i = e.x, o = e.y, u = e.width, c = e.height;
    return t === 1 ? {
      start: n ? i : o,
      end: n ? i + u : o + c
    } : {
      start: n ? i + u : o + c,
      end: n ? i : o
    };
  }
  function Vp(e, t, r, n, i) {
    if (e * t < e * n || e * t > e * i)
      return !1;
    var o = r();
    return e * (t - e * o / 2 - n) >= 0 && e * (t + e * o / 2 - i) <= 0;
  }
  function Wh2(e, t) {
    return V$(e, t + 1);
  }
  function Yh2(e, t, r, n, i) {
    for (var o = (n || []).slice(), u = t.start, c = t.end, f = 0, d = 1, g = u, h = function() {
      var I = n == null ? void 0 : n[f];
      if (I === void 0)
        return {
          v: V$(n, d)
        };
      var Q = f, B, _ = function() {
        return B === void 0 && (B = r(I, Q)), B;
      }, M = I.coordinate, S = f === 0 || Vp(e, M, _, g, c);
      S || (f = 0, g = u, d += 1), S && (g = M + e * (_() / 2 + i), f += d);
    }, E; d <= o.length; )
      if (E = h(), E) return E.v;
    return [];
  }
  function $c(e) {
    "@babel/helpers - typeof";
    return $c = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $c(e);
  }
  function CV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function M1(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? CV(Object(r), !0).forEach(function(n) {
        $h2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : CV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function $h2(e, t, r) {
    return t = Gh2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Gh2(e) {
    var t = Kh2(e, "string");
    return $c(t) == "symbol" ? t : t + "";
  }
  function Kh2(e, t) {
    if ($c(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if ($c(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Xh2(e, t, r, n, i) {
    for (var o = (n || []).slice(), u = o.length, c = t.start, f = t.end, d = function(E) {
      var y = o[E], I, Q = function() {
        return I === void 0 && (I = r(y, E)), I;
      };
      if (E === u - 1) {
        var B = e * (y.coordinate + e * Q() / 2 - f);
        o[E] = y = M1(M1({}, y), {}, {
          tickCoord: B > 0 ? y.coordinate - B * e : y.coordinate
        });
      } else
        o[E] = y = M1(M1({}, y), {}, {
          tickCoord: y.coordinate
        });
      var _ = Vp(e, y.tickCoord, Q, c, f);
      _ && (f = y.tickCoord - e * (Q() / 2 + i), o[E] = M1(M1({}, y), {}, {
        isShow: !0
      }));
    }, g = u - 1; g >= 0; g--)
      d(g);
    return o;
  }
  function Jh2(e, t, r, n, i, o) {
    var u = (n || []).slice(), c = u.length, f = t.start, d = t.end;
    if (o) {
      var g = n[c - 1], h = r(g, c - 1), E = e * (g.coordinate + e * h / 2 - d);
      u[c - 1] = g = M1(M1({}, g), {}, {
        tickCoord: E > 0 ? g.coordinate - E * e : g.coordinate
      });
      var y = Vp(e, g.tickCoord, function() {
        return h;
      }, f, d);
      y && (d = g.tickCoord - e * (h / 2 + i), u[c - 1] = M1(M1({}, g), {}, {
        isShow: !0
      }));
    }
    for (var I = o ? c - 1 : c, Q = function(M) {
      var S = u[M], O, w = function() {
        return O === void 0 && (O = r(S, M)), O;
      };
      if (M === 0) {
        var D = e * (S.coordinate - e * w() / 2 - f);
        u[M] = S = M1(M1({}, S), {}, {
          tickCoord: D < 0 ? S.coordinate - D * e : S.coordinate
        });
      } else
        u[M] = S = M1(M1({}, S), {}, {
          tickCoord: S.coordinate
        });
      var k = Vp(e, S.tickCoord, w, f, d);
      k && (f = S.tickCoord + e * (w() / 2 + i), u[M] = M1(M1({}, S), {}, {
        isShow: !0
      }));
    }, B = 0; B < I; B++)
      Q(B);
    return u;
  }
  function t_(e, t, r) {
    var n = e.tick, i = e.ticks, o = e.viewBox, u = e.minTickGap, c = e.orientation, f = e.interval, d = e.tickFormatter, g = e.unit, h = e.angle;
    if (!i || !i.length || !n)
      return [];
    if (G2(f) || As.isSsr)
      return Wh2(i, typeof f == "number" && G2(f) ? f : 0);
    var E = [], y = c === "top" || c === "bottom" ? "width" : "height", I = g && y === "width" ? rc(g, {
      fontSize: t,
      letterSpacing: r
    }) : {
      width: 0,
      height: 0
    }, Q = function(S, O) {
      var w = te(d) ? d(S.value, O) : S.value;
      return y === "width" ? Uh2(rc(w, {
        fontSize: t,
        letterSpacing: r
      }), I, h) : rc(w, {
        fontSize: t,
        letterSpacing: r
      })[y];
    }, B = i.length >= 2 ? pn(i[1].coordinate - i[0].coordinate) : 1, _ = qh2(o, B, y);
    return f === "equidistantPreserveStart" ? Yh2(B, _, Q, i, u) : (f === "preserveStart" || f === "preserveStartEnd" ? E = Jh2(B, _, Q, i, u, f === "preserveStartEnd") : E = Xh2(B, _, Q, i, u), E.filter(function(M) {
      return M.isShow;
    }));
  }
  var ev2 = ["viewBox"], tv2 = ["viewBox"], rv2 = ["ticks"];
  function z9(e) {
    "@babel/helpers - typeof";
    return z9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, z9(e);
  }
  function l9() {
    return l9 = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, l9.apply(this, arguments);
  }
  function dV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function Y1(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? dV(Object(r), !0).forEach(function(n) {
        r_(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : dV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Zx(e, t) {
    if (e == null) return {};
    var r = nv2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function nv2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function iv2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function gV(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, z$(n.key), n);
    }
  }
  function av2(e, t, r) {
    return t && gV(e.prototype, t), r && gV(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function ov2(e, t, r) {
    return t = Zp(t), sv2(e, Z$() ? Reflect.construct(t, r || [], Zp(e).constructor) : t.apply(e, r));
  }
  function sv2(e, t) {
    if (t && (z9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return uv2(e);
  }
  function uv2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function Z$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (Z$ = function() {
      return !!e;
    })();
  }
  function Zp(e) {
    return Zp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Zp(e);
  }
  function lv2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Nw(e, t);
  }
  function Nw(e, t) {
    return Nw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Nw(e, t);
  }
  function r_(e, t, r) {
    return t = z$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function z$(e) {
    var t = cv2(e, "string");
    return z9(t) == "symbol" ? t : t + "";
  }
  function cv2(e, t) {
    if (z9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (z9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var gs = /* @__PURE__ */ function(e) {
    function t(r) {
      var n;
      return iv2(this, t), n = ov2(this, t, [r]), n.state = {
        fontSize: "",
        letterSpacing: ""
      }, n;
    }
    return lv2(t, e), av2(t, [{
      key: "shouldComponentUpdate",
      value: function(n, i) {
        var o = n.viewBox, u = Zx(n, ev2), c = this.props, f = c.viewBox, d = Zx(c, tv2);
        return !h9(o, f) || !h9(u, d) || !h9(i, this.state);
      }
    }, {
      key: "componentDidMount",
      value: function() {
        var n = this.layerReference;
        if (n) {
          var i = n.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
          i && this.setState({
            fontSize: window.getComputedStyle(i).fontSize,
            letterSpacing: window.getComputedStyle(i).letterSpacing
          });
        }
      }
      /**
       * Calculate the coordinates of endpoints in ticks
       * @param  {Object} data The data of a simple tick
       * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
       *  (x2, y2): The coordinate of endpoint close to axis
       */
    }, {
      key: "getTickLineCoord",
      value: function(n) {
        var i = this.props, o = i.x, u = i.y, c = i.width, f = i.height, d = i.orientation, g = i.tickSize, h = i.mirror, E = i.tickMargin, y, I, Q, B, _, M, S = h ? -1 : 1, O = n.tickSize || g, w = G2(n.tickCoord) ? n.tickCoord : n.coordinate;
        switch (d) {
          case "top":
            y = I = n.coordinate, B = u + +!h * f, Q = B - S * O, M = Q - S * E, _ = w;
            break;
          case "left":
            Q = B = n.coordinate, I = o + +!h * c, y = I - S * O, _ = y - S * E, M = w;
            break;
          case "right":
            Q = B = n.coordinate, I = o + +h * c, y = I + S * O, _ = y + S * E, M = w;
            break;
          default:
            y = I = n.coordinate, B = u + +h * f, Q = B + S * O, M = Q + S * E, _ = w;
            break;
        }
        return {
          line: {
            x1: y,
            y1: Q,
            x2: I,
            y2: B
          },
          tick: {
            x: _,
            y: M
          }
        };
      }
    }, {
      key: "getTickTextAnchor",
      value: function() {
        var n = this.props, i = n.orientation, o = n.mirror, u;
        switch (i) {
          case "left":
            u = o ? "start" : "end";
            break;
          case "right":
            u = o ? "end" : "start";
            break;
          default:
            u = "middle";
            break;
        }
        return u;
      }
    }, {
      key: "getTickVerticalAnchor",
      value: function() {
        var n = this.props, i = n.orientation, o = n.mirror, u = "end";
        switch (i) {
          case "left":
          case "right":
            u = "middle";
            break;
          case "top":
            u = o ? "start" : "end";
            break;
          default:
            u = o ? "end" : "start";
            break;
        }
        return u;
      }
    }, {
      key: "renderAxisLine",
      value: function() {
        var n = this.props, i = n.x, o = n.y, u = n.width, c = n.height, f = n.orientation, d = n.mirror, g = n.axisLine, h = Y1(Y1(Y1({}, ge(this.props, !1)), ge(g, !1)), {}, {
          fill: "none"
        });
        if (f === "top" || f === "bottom") {
          var E = +(f === "top" && !d || f === "bottom" && d);
          h = Y1(Y1({}, h), {}, {
            x1: i,
            y1: o + E * c,
            x2: i + u,
            y2: o + E * c
          });
        } else {
          var y = +(f === "left" && !d || f === "right" && d);
          h = Y1(Y1({}, h), {}, {
            x1: i + y * u,
            y1: o,
            x2: i + y * u,
            y2: o + c
          });
        }
        return /* @__PURE__ */ f2.createElement("line", l9({}, h, {
          className: pe("recharts-cartesian-axis-line", w4(g, "className"))
        }));
      }
    }, {
      key: "renderTicks",
      value: (
        /**
         * render the ticks
         * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
         * @param {string} fontSize Fontsize to consider for tick spacing
         * @param {string} letterSpacing Letterspacing to consider for tick spacing
         * @return {ReactComponent} renderedTicks
         */
        function(n, i, o) {
          var u = this, c = this.props, f = c.tickLine, d = c.stroke, g = c.tick, h = c.tickFormatter, E = c.unit, y = t_(Y1(Y1({}, this.props), {}, {
            ticks: n
          }), i, o), I = this.getTickTextAnchor(), Q = this.getTickVerticalAnchor(), B = ge(this.props, !1), _ = ge(g, !1), M = Y1(Y1({}, B), {}, {
            fill: "none"
          }, ge(f, !1)), S = y.map(function(O, w) {
            var D = u.getTickLineCoord(O), k = D.line, F = D.tick, z = Y1(Y1(Y1(Y1({
              textAnchor: I,
              verticalAnchor: Q
            }, B), {}, {
              stroke: "none",
              fill: d
            }, _), F), {}, {
              index: w,
              payload: O,
              visibleTicksCount: y.length,
              tickFormatter: h
            });
            return /* @__PURE__ */ f2.createElement(n5, l9({
              className: "recharts-cartesian-axis-tick",
              key: "tick-".concat(O.value, "-").concat(O.coordinate, "-").concat(O.tickCoord)
            }, Xg(u.props, O, w)), f && /* @__PURE__ */ f2.createElement("line", l9({}, M, k, {
              className: pe("recharts-cartesian-axis-tick-line", w4(f, "className"))
            })), g && t.renderTickItem(g, z, "".concat(te(h) ? h(O.value, w) : O.value).concat(E || "")));
          });
          return /* @__PURE__ */ f2.createElement("g", {
            className: "recharts-cartesian-axis-ticks"
          }, S);
        }
      )
    }, {
      key: "render",
      value: function() {
        var n = this, i = this.props, o = i.axisLine, u = i.width, c = i.height, f = i.ticksGenerator, d = i.className, g = i.hide;
        if (g)
          return null;
        var h = this.props, E = h.ticks, y = Zx(h, rv2), I = E;
        return te(f) && (I = E && E.length > 0 ? f(this.props) : f(y)), u <= 0 || c <= 0 || !I || !I.length ? null : /* @__PURE__ */ f2.createElement(n5, {
          className: pe("recharts-cartesian-axis", d),
          ref: function(B) {
            n.layerReference = B;
          }
        }, o && this.renderAxisLine(), this.renderTicks(I, this.state.fontSize, this.state.letterSpacing), _1.renderCallByParent(this.props));
      }
    }], [{
      key: "renderTickItem",
      value: function(n, i, o) {
        var u;
        return /* @__PURE__ */ f2.isValidElement(n) ? u = /* @__PURE__ */ f2.cloneElement(n, i) : te(n) ? u = n(i) : u = /* @__PURE__ */ f2.createElement(lp, l9({}, i, {
          className: "recharts-cartesian-axis-tick-value"
        }), o), u;
      }
    }]);
  }(q.Component);
  r_(gs, "displayName", "CartesianAxis");
  r_(gs, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: !0,
    axisLine: !0,
    tick: !0,
    mirror: !1,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
  });
  var Av2 = ["x1", "y1", "x2", "y2", "key"], fv2 = ["offset"];
  function Ui(e) {
    "@babel/helpers - typeof";
    return Ui = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Ui(e);
  }
  function pV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function O1(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? pV(Object(r), !0).forEach(function(n) {
        Cv2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : pV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Cv2(e, t, r) {
    return t = dv2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function dv2(e) {
    var t = gv2(e, "string");
    return Ui(t) == "symbol" ? t : t + "";
  }
  function gv2(e, t) {
    if (Ui(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Ui(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function Di() {
    return Di = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Di.apply(this, arguments);
  }
  function hV(e, t) {
    if (e == null) return {};
    var r = pv2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function pv2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  var hv2 = function(t) {
    var r = t.fill;
    if (!r || r === "none")
      return null;
    var n = t.fillOpacity, i = t.x, o = t.y, u = t.width, c = t.height, f = t.ry;
    return /* @__PURE__ */ f2.createElement("rect", {
      x: i,
      y: o,
      ry: f,
      width: u,
      height: c,
      stroke: "none",
      fill: r,
      fillOpacity: n,
      className: "recharts-cartesian-grid-bg"
    });
  };
  function U$(e, t) {
    var r;
    if (/* @__PURE__ */ f2.isValidElement(e))
      r = /* @__PURE__ */ f2.cloneElement(e, t);
    else if (te(e))
      r = e(t);
    else {
      var n = t.x1, i = t.y1, o = t.x2, u = t.y2, c = t.key, f = hV(t, Av2), d = ge(f, !1);
      d.offset;
      var g = hV(d, fv2);
      r = /* @__PURE__ */ f2.createElement("line", Di({}, g, {
        x1: n,
        y1: i,
        x2: o,
        y2: u,
        fill: "none",
        key: c
      }));
    }
    return r;
  }
  function vv2(e) {
    var t = e.x, r = e.width, n = e.horizontal, i = n === void 0 ? !0 : n, o = e.horizontalPoints;
    if (!i || !o || !o.length)
      return null;
    var u = o.map(function(c, f) {
      var d = O1(O1({}, e), {}, {
        x1: t,
        y1: c,
        x2: t + r,
        y2: c,
        key: "line-".concat(f),
        index: f
      });
      return U$(i, d);
    });
    return /* @__PURE__ */ f2.createElement("g", {
      className: "recharts-cartesian-grid-horizontal"
    }, u);
  }
  function Ev2(e) {
    var t = e.y, r = e.height, n = e.vertical, i = n === void 0 ? !0 : n, o = e.verticalPoints;
    if (!i || !o || !o.length)
      return null;
    var u = o.map(function(c, f) {
      var d = O1(O1({}, e), {}, {
        x1: c,
        y1: t,
        x2: c,
        y2: t + r,
        key: "line-".concat(f),
        index: f
      });
      return U$(i, d);
    });
    return /* @__PURE__ */ f2.createElement("g", {
      className: "recharts-cartesian-grid-vertical"
    }, u);
  }
  function mv2(e) {
    var t = e.horizontalFill, r = e.fillOpacity, n = e.x, i = e.y, o = e.width, u = e.height, c = e.horizontalPoints, f = e.horizontal, d = f === void 0 ? !0 : f;
    if (!d || !t || !t.length)
      return null;
    var g = c.map(function(E) {
      return Math.round(E + i - i);
    }).sort(function(E, y) {
      return E - y;
    });
    i !== g[0] && g.unshift(0);
    var h = g.map(function(E, y) {
      var I = !g[y + 1], Q = I ? i + u - E : g[y + 1] - E;
      if (Q <= 0)
        return null;
      var B = y % t.length;
      return /* @__PURE__ */ f2.createElement("rect", {
        key: "react-".concat(y),
        y: E,
        x: n,
        height: Q,
        width: o,
        stroke: "none",
        fill: t[B],
        fillOpacity: r,
        className: "recharts-cartesian-grid-bg"
      });
    });
    return /* @__PURE__ */ f2.createElement("g", {
      className: "recharts-cartesian-gridstripes-horizontal"
    }, h);
  }
  function yv2(e) {
    var t = e.vertical, r = t === void 0 ? !0 : t, n = e.verticalFill, i = e.fillOpacity, o = e.x, u = e.y, c = e.width, f = e.height, d = e.verticalPoints;
    if (!r || !n || !n.length)
      return null;
    var g = d.map(function(E) {
      return Math.round(E + o - o);
    }).sort(function(E, y) {
      return E - y;
    });
    o !== g[0] && g.unshift(0);
    var h = g.map(function(E, y) {
      var I = !g[y + 1], Q = I ? o + c - E : g[y + 1] - E;
      if (Q <= 0)
        return null;
      var B = y % n.length;
      return /* @__PURE__ */ f2.createElement("rect", {
        key: "react-".concat(y),
        x: E,
        y: u,
        width: Q,
        height: f,
        stroke: "none",
        fill: n[B],
        fillOpacity: i,
        className: "recharts-cartesian-grid-bg"
      });
    });
    return /* @__PURE__ */ f2.createElement("g", {
      className: "recharts-cartesian-gridstripes-vertical"
    }, h);
  }
  var Iv2 = function(t, r) {
    var n = t.xAxis, i = t.width, o = t.height, u = t.offset;
    return t$(t_(O1(O1(O1({}, gs.defaultProps), n), {}, {
      ticks: g8(n, !0),
      viewBox: {
        x: 0,
        y: 0,
        width: i,
        height: o
      }
    })), u.left, u.left + u.width, r);
  }, Bv2 = function(t, r) {
    var n = t.yAxis, i = t.width, o = t.height, u = t.offset;
    return t$(t_(O1(O1(O1({}, gs.defaultProps), n), {}, {
      ticks: g8(n, !0),
      viewBox: {
        x: 0,
        y: 0,
        width: i,
        height: o
      }
    })), u.top, u.top + u.height, r);
  }, Xo = {
    horizontal: !0,
    vertical: !0,
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
  };
  function q$(e) {
    var t, r, n, i, o, u, c = KM(), f = XM(), d = ch2(), g = O1(O1({}, e), {}, {
      stroke: (t = e.stroke) !== null && t !== void 0 ? t : Xo.stroke,
      fill: (r = e.fill) !== null && r !== void 0 ? r : Xo.fill,
      horizontal: (n = e.horizontal) !== null && n !== void 0 ? n : Xo.horizontal,
      horizontalFill: (i = e.horizontalFill) !== null && i !== void 0 ? i : Xo.horizontalFill,
      vertical: (o = e.vertical) !== null && o !== void 0 ? o : Xo.vertical,
      verticalFill: (u = e.verticalFill) !== null && u !== void 0 ? u : Xo.verticalFill,
      x: G2(e.x) ? e.x : d.left,
      y: G2(e.y) ? e.y : d.top,
      width: G2(e.width) ? e.width : d.width,
      height: G2(e.height) ? e.height : d.height
    }), h = g.x, E = g.y, y = g.width, I = g.height, Q = g.syncWithTicks, B = g.horizontalValues, _ = g.verticalValues, M = sh2(), S = uh2();
    if (!G2(y) || y <= 0 || !G2(I) || I <= 0 || !G2(h) || h !== +h || !G2(E) || E !== +E)
      return null;
    var O = g.verticalCoordinatesGenerator || Iv2, w = g.horizontalCoordinatesGenerator || Bv2, D = g.horizontalPoints, k = g.verticalPoints;
    if ((!D || !D.length) && te(w)) {
      var F = B && B.length, z = w({
        yAxis: S ? O1(O1({}, S), {}, {
          ticks: F ? B : S.ticks
        }) : void 0,
        width: c,
        height: f,
        offset: d
      }, F ? !0 : Q);
      v8(Array.isArray(z), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Ui(z), "]")), Array.isArray(z) && (D = z);
    }
    if ((!k || !k.length) && te(O)) {
      var Z = _ && _.length, V = O({
        xAxis: M ? O1(O1({}, M), {}, {
          ticks: Z ? _ : M.ticks
        }) : void 0,
        width: c,
        height: f,
        offset: d
      }, Z ? !0 : Q);
      v8(Array.isArray(V), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Ui(V), "]")), Array.isArray(V) && (k = V);
    }
    return /* @__PURE__ */ f2.createElement("g", {
      className: "recharts-cartesian-grid"
    }, /* @__PURE__ */ f2.createElement(hv2, {
      fill: g.fill,
      fillOpacity: g.fillOpacity,
      x: g.x,
      y: g.y,
      width: g.width,
      height: g.height,
      ry: g.ry
    }), /* @__PURE__ */ f2.createElement(vv2, Di({}, g, {
      offset: d,
      horizontalPoints: D,
      xAxis: M,
      yAxis: S
    })), /* @__PURE__ */ f2.createElement(Ev2, Di({}, g, {
      offset: d,
      verticalPoints: k,
      xAxis: M,
      yAxis: S
    })), /* @__PURE__ */ f2.createElement(mv2, Di({}, g, {
      horizontalPoints: D
    })), /* @__PURE__ */ f2.createElement(yv2, Di({}, g, {
      verticalPoints: k
    })));
  }
  q$.displayName = "CartesianGrid";
  var Qv2 = ["type", "layout", "connectNulls", "ref"], xv2 = ["key"];
  function U9(e) {
    "@babel/helpers - typeof";
    return U9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, U9(e);
  }
  function vV(e, t) {
    if (e == null) return {};
    var r = bv2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function bv2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function oc() {
    return oc = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, oc.apply(this, arguments);
  }
  function EV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function jr(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? EV(Object(r), !0).forEach(function(n) {
        fn(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : EV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function Jo(e) {
    return _v2(e) || Mv2(e) || Sv2(e) || wv2();
  }
  function wv2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Sv2(e, t) {
    if (e) {
      if (typeof e == "string") return Hw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Hw(e, t);
    }
  }
  function Mv2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function _v2(e) {
    if (Array.isArray(e)) return Hw(e);
  }
  function Hw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function Ov2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function mV(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Y$(n.key), n);
    }
  }
  function Tv2(e, t, r) {
    return t && mV(e.prototype, t), r && mV(e, r), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Dv2(e, t, r) {
    return t = zp(t), Lv2(e, W$() ? Reflect.construct(t, r || [], zp(e).constructor) : t.apply(e, r));
  }
  function Lv2(e, t) {
    if (t && (U9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return kv2(e);
  }
  function kv2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function W$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (W$ = function() {
      return !!e;
    })();
  }
  function zp(e) {
    return zp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, zp(e);
  }
  function Rv2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && jw(e, t);
  }
  function jw(e, t) {
    return jw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, jw(e, t);
  }
  function fn(e, t, r) {
    return t = Y$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function Y$(e) {
    var t = Pv2(e, "string");
    return U9(t) == "symbol" ? t : t + "";
  }
  function Pv2(e, t) {
    if (U9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (U9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var q9 = /* @__PURE__ */ function(e) {
    function t() {
      var r;
      Ov2(this, t);
      for (var n = arguments.length, i = new Array(n), o = 0; o < n; o++)
        i[o] = arguments[o];
      return r = Dv2(this, t, [].concat(i)), fn(r, "state", {
        isAnimationFinished: !0,
        totalLength: 0
      }), fn(r, "generateSimpleStrokeDasharray", function(u, c) {
        return "".concat(c, "px ").concat(u - c, "px");
      }), fn(r, "getStrokeDasharray", function(u, c, f) {
        var d = f.reduce(function(_, M) {
          return _ + M;
        });
        if (!d)
          return r.generateSimpleStrokeDasharray(c, u);
        for (var g = Math.floor(u / d), h = u % d, E = c - u, y = [], I = 0, Q = 0; I < f.length; Q += f[I], ++I)
          if (Q + f[I] > h) {
            y = [].concat(Jo(f.slice(0, I)), [h - Q]);
            break;
          }
        var B = y.length % 2 === 0 ? [0, E] : [E];
        return [].concat(Jo(t.repeat(f, g)), Jo(y), B).map(function(_) {
          return "".concat(_, "px");
        }).join(", ");
      }), fn(r, "id", uA("recharts-line-")), fn(r, "pathRef", function(u) {
        r.mainCurve = u;
      }), fn(r, "handleAnimationEnd", function() {
        r.setState({
          isAnimationFinished: !0
        }), r.props.onAnimationEnd && r.props.onAnimationEnd();
      }), fn(r, "handleAnimationStart", function() {
        r.setState({
          isAnimationFinished: !1
        }), r.props.onAnimationStart && r.props.onAnimationStart();
      }), r;
    }
    return Rv2(t, e), Tv2(t, [{
      key: "componentDidMount",
      value: function() {
        if (this.props.isAnimationActive) {
          var n = this.getTotalLength();
          this.setState({
            totalLength: n
          });
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function() {
        if (this.props.isAnimationActive) {
          var n = this.getTotalLength();
          n !== this.state.totalLength && this.setState({
            totalLength: n
          });
        }
      }
    }, {
      key: "getTotalLength",
      value: function() {
        var n = this.mainCurve;
        try {
          return n && n.getTotalLength && n.getTotalLength() || 0;
        } catch {
          return 0;
        }
      }
    }, {
      key: "renderErrorBar",
      value: function(n, i) {
        if (this.props.isAnimationActive && !this.state.isAnimationFinished)
          return null;
        var o = this.props, u = o.points, c = o.xAxis, f = o.yAxis, d = o.layout, g = o.children, h = S4(g, dA);
        if (!h)
          return null;
        var E = function(Q, B) {
          return {
            x: Q.x,
            y: Q.y,
            value: Q.value,
            errorVal: Wr(Q.payload, B)
          };
        }, y = {
          clipPath: n ? "url(#clipPath-".concat(i, ")") : null
        };
        return /* @__PURE__ */ f2.createElement(n5, y, h.map(function(I) {
          return /* @__PURE__ */ f2.cloneElement(I, {
            key: "bar-".concat(I.props.dataKey),
            data: u,
            xAxis: c,
            yAxis: f,
            layout: d,
            dataPointFormatter: E
          });
        }));
      }
    }, {
      key: "renderDots",
      value: function(n, i, o) {
        var u = this.props.isAnimationActive;
        if (u && !this.state.isAnimationFinished)
          return null;
        var c = this.props, f = c.dot, d = c.points, g = c.dataKey, h = ge(this.props, !1), E = ge(f, !0), y = d.map(function(Q, B) {
          var _ = jr(jr(jr({
            key: "dot-".concat(B),
            r: 3
          }, h), E), {}, {
            index: B,
            cx: Q.x,
            cy: Q.y,
            value: Q.value,
            dataKey: g,
            payload: Q.payload,
            points: d
          });
          return t.renderDotItem(f, _);
        }), I = {
          clipPath: n ? "url(#clipPath-".concat(i ? "" : "dots-").concat(o, ")") : null
        };
        return /* @__PURE__ */ f2.createElement(n5, oc({
          className: "recharts-line-dots",
          key: "dots"
        }, I), y);
      }
    }, {
      key: "renderCurveStatically",
      value: function(n, i, o, u) {
        var c = this.props, f = c.type, d = c.layout, g = c.connectNulls;
        c.ref;
        var h = vV(c, Qv2), E = jr(jr(jr({}, ge(h, !0)), {}, {
          fill: "none",
          className: "recharts-line-curve",
          clipPath: i ? "url(#clipPath-".concat(o, ")") : null,
          points: n
        }, u), {}, {
          type: f,
          layout: d,
          connectNulls: g
        });
        return /* @__PURE__ */ f2.createElement(vw, oc({}, E, {
          pathRef: this.pathRef
        }));
      }
    }, {
      key: "renderCurveWithAnimation",
      value: function(n, i) {
        var o = this, u = this.props, c = u.points, f = u.strokeDasharray, d = u.isAnimationActive, g = u.animationBegin, h = u.animationDuration, E = u.animationEasing, y = u.animationId, I = u.animateNewValues, Q = u.width, B = u.height, _ = this.state, M = _.prevPoints, S = _.totalLength;
        return /* @__PURE__ */ f2.createElement(w8, {
          begin: g,
          duration: h,
          isActive: d,
          easing: E,
          from: {
            t: 0
          },
          to: {
            t: 1
          },
          key: "line-".concat(y),
          onAnimationEnd: this.handleAnimationEnd,
          onAnimationStart: this.handleAnimationStart
        }, function(O) {
          var w = O.t;
          if (M) {
            var D = M.length / c.length, k = c.map(function($, W) {
              var t2 = Math.floor(W * D);
              if (M[t2]) {
                var n2 = M[t2], s2 = dn(n2.x, $.x), l2 = dn(n2.y, $.y);
                return jr(jr({}, $), {}, {
                  x: s2(w),
                  y: l2(w)
                });
              }
              if (I) {
                var X = dn(Q * 2, $.x), a2 = dn(B / 2, $.y);
                return jr(jr({}, $), {}, {
                  x: X(w),
                  y: a2(w)
                });
              }
              return jr(jr({}, $), {}, {
                x: $.x,
                y: $.y
              });
            });
            return o.renderCurveStatically(k, n, i);
          }
          var F = dn(0, S), z = F(w), Z;
          if (f) {
            var V = "".concat(f).split(/[,\s]+/gim).map(function($) {
              return parseFloat($);
            });
            Z = o.getStrokeDasharray(z, S, V);
          } else
            Z = o.generateSimpleStrokeDasharray(S, z);
          return o.renderCurveStatically(c, n, i, {
            strokeDasharray: Z
          });
        });
      }
    }, {
      key: "renderCurve",
      value: function(n, i) {
        var o = this.props, u = o.points, c = o.isAnimationActive, f = this.state, d = f.prevPoints, g = f.totalLength;
        return c && u && u.length && (!d && g > 0 || !Fh(d, u)) ? this.renderCurveWithAnimation(n, i) : this.renderCurveStatically(u, n, i);
      }
    }, {
      key: "render",
      value: function() {
        var n, i = this.props, o = i.hide, u = i.dot, c = i.points, f = i.className, d = i.xAxis, g = i.yAxis, h = i.top, E = i.left, y = i.width, I = i.height, Q = i.isAnimationActive, B = i.id;
        if (o || !c || !c.length)
          return null;
        var _ = this.state.isAnimationFinished, M = c.length === 1, S = pe("recharts-line", f), O = d && d.allowDataOverflow, w = g && g.allowDataOverflow, D = O || w, k = Ae(B) ? this.id : B, F = (n = ge(u, !1)) !== null && n !== void 0 ? n : {
          r: 3,
          strokeWidth: 2
        }, z = F.r, Z = z === void 0 ? 3 : z, V = F.strokeWidth, $ = V === void 0 ? 2 : V, W = $i2(u) ? u : {}, t2 = W.clipDot, n2 = t2 === void 0 ? !0 : t2, s2 = Z * 2 + $;
        return /* @__PURE__ */ f2.createElement(n5, {
          className: S
        }, O || w ? /* @__PURE__ */ f2.createElement("defs", null, /* @__PURE__ */ f2.createElement("clipPath", {
          id: "clipPath-".concat(k)
        }, /* @__PURE__ */ f2.createElement("rect", {
          x: O ? E : E - y / 2,
          y: w ? h : h - I / 2,
          width: O ? y : y * 2,
          height: w ? I : I * 2
        })), !n2 && /* @__PURE__ */ f2.createElement("clipPath", {
          id: "clipPath-dots-".concat(k)
        }, /* @__PURE__ */ f2.createElement("rect", {
          x: E - s2 / 2,
          y: h - s2 / 2,
          width: y + s2,
          height: I + s2
        }))) : null, !M && this.renderCurve(D, k), this.renderErrorBar(D, k), (M || u) && this.renderDots(D, n2, k), (!Q || _) && j6.renderCallByParent(this.props, c));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function(n, i) {
        return n.animationId !== i.prevAnimationId ? {
          prevAnimationId: n.animationId,
          curPoints: n.points,
          prevPoints: i.curPoints
        } : n.points !== i.curPoints ? {
          curPoints: n.points
        } : null;
      }
    }, {
      key: "repeat",
      value: function(n, i) {
        for (var o = n.length % 2 !== 0 ? [].concat(Jo(n), [0]) : n, u = [], c = 0; c < i; ++c)
          u = [].concat(Jo(u), Jo(o));
        return u;
      }
    }, {
      key: "renderDotItem",
      value: function(n, i) {
        var o;
        if (/* @__PURE__ */ f2.isValidElement(n))
          o = /* @__PURE__ */ f2.cloneElement(n, i);
        else if (te(n))
          o = n(i);
        else {
          var u = i.key, c = vV(i, xv2), f = pe("recharts-line-dot", typeof n != "boolean" ? n.className : "");
          o = /* @__PURE__ */ f2.createElement(WM, oc({
            key: u
          }, c, {
            className: f
          }));
        }
        return o;
      }
    }]);
  }(q.PureComponent);
  fn(q9, "displayName", "Line");
  fn(q9, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: !1,
    activeDot: !0,
    dot: !0,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !As.isSsr,
    animateNewValues: !0,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: !1,
    label: !1
  });
  fn(q9, "getComposedData", function(e) {
    var t = e.props, r = e.xAxis, n = e.yAxis, i = e.xAxisTicks, o = e.yAxisTicks, u = e.dataKey, c = e.bandSize, f = e.displayedData, d = e.offset, g = t.layout, h = f.map(function(E, y) {
      var I = Wr(E, u);
      return g === "horizontal" ? {
        x: wH({
          axis: r,
          ticks: i,
          bandSize: c,
          entry: E,
          index: y
        }),
        y: Ae(I) ? null : n.scale(I),
        value: I,
        payload: E
      } : {
        x: Ae(I) ? null : r.scale(I),
        y: wH({
          axis: n,
          ticks: o,
          bandSize: c,
          entry: E,
          index: y
        }),
        value: I,
        payload: E
      };
    });
    return jr({
      points: h,
      layout: g
    }, d);
  });
  function W9(e) {
    "@babel/helpers - typeof";
    return W9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, W9(e);
  }
  function Fv2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Nv2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, K$(n.key), n);
    }
  }
  function Hv2(e, t, r) {
    return t && Nv2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function jv2(e, t, r) {
    return t = Up(t), Vv2(e, $$() ? Reflect.construct(t, r || [], Up(e).constructor) : t.apply(e, r));
  }
  function Vv2(e, t) {
    if (t && (W9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Zv2(e);
  }
  function Zv2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function $$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return ($$ = function() {
      return !!e;
    })();
  }
  function Up(e) {
    return Up = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Up(e);
  }
  function zv2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Vw(e, t);
  }
  function Vw(e, t) {
    return Vw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Vw(e, t);
  }
  function G$(e, t, r) {
    return t = K$(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function K$(e) {
    var t = Uv2(e, "string");
    return W9(t) == "symbol" ? t : t + "";
  }
  function Uv2(e, t) {
    if (W9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (W9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Zw() {
    return Zw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Zw.apply(this, arguments);
  }
  function qv2(e) {
    var t = e.xAxisId, r = KM(), n = XM(), i = L$(t);
    return i == null ? null : (
      // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
      /* @__PURE__ */ f2.createElement(gs, Zw({}, i, {
        className: pe("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
        viewBox: {
          x: 0,
          y: 0,
          width: r,
          height: n
        },
        ticksGenerator: function(u) {
          return g8(u, !0);
        }
      }))
    );
  }
  var ps = /* @__PURE__ */ function(e) {
    function t() {
      return Fv2(this, t), jv2(this, t, arguments);
    }
    return zv2(t, e), Hv2(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ f2.createElement(qv2, this.props);
      }
    }]);
  }(f2.Component);
  G$(ps, "displayName", "XAxis");
  G$(ps, "defaultProps", {
    allowDecimals: !0,
    hide: !1,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: !1,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
      left: 0,
      right: 0
    },
    allowDataOverflow: !1,
    scale: "auto",
    reversed: !1,
    allowDuplicatedCategory: !0
  });
  function Y9(e) {
    "@babel/helpers - typeof";
    return Y9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Y9(e);
  }
  function Wv2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function Yv2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, eG(n.key), n);
    }
  }
  function $v2(e, t, r) {
    return t && Yv2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Gv2(e, t, r) {
    return t = qp(t), Kv2(e, X$() ? Reflect.construct(t, r || [], qp(e).constructor) : t.apply(e, r));
  }
  function Kv2(e, t) {
    if (t && (Y9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return Xv2(e);
  }
  function Xv2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function X$() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (X$ = function() {
      return !!e;
    })();
  }
  function qp(e) {
    return qp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, qp(e);
  }
  function Jv2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && zw(e, t);
  }
  function zw(e, t) {
    return zw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, zw(e, t);
  }
  function J$(e, t, r) {
    return t = eG(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function eG(e) {
    var t = eE2(e, "string");
    return Y9(t) == "symbol" ? t : t + "";
  }
  function eE2(e, t) {
    if (Y9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Y9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  function Uw() {
    return Uw = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, Uw.apply(this, arguments);
  }
  var tE2 = function(t) {
    var r = t.yAxisId, n = KM(), i = XM(), o = k$(r);
    return o == null ? null : (
      // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
      /* @__PURE__ */ f2.createElement(gs, Uw({}, o, {
        className: pe("recharts-".concat(o.axisType, " ").concat(o.axisType), o.className),
        viewBox: {
          x: 0,
          y: 0,
          width: n,
          height: i
        },
        ticksGenerator: function(c) {
          return g8(c, !0);
        }
      }))
    );
  }, hs = /* @__PURE__ */ function(e) {
    function t() {
      return Wv2(this, t), Gv2(this, t, arguments);
    }
    return Jv2(t, e), $v2(t, [{
      key: "render",
      value: function() {
        return /* @__PURE__ */ f2.createElement(tE2, this.props);
      }
    }]);
  }(f2.Component);
  J$(hs, "displayName", "YAxis");
  J$(hs, "defaultProps", {
    allowDuplicatedCategory: !0,
    allowDecimals: !0,
    hide: !1,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: !1,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
      top: 0,
      bottom: 0
    },
    allowDataOverflow: !1,
    scale: "auto",
    reversed: !1
  });
  function yV(e) {
    return aE2(e) || iE2(e) || nE2(e) || rE2();
  }
  function rE2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function nE2(e, t) {
    if (e) {
      if (typeof e == "string") return qw(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return qw(e, t);
    }
  }
  function iE2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function aE2(e) {
    if (Array.isArray(e)) return qw(e);
  }
  function qw(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  var Ww = function(t, r, n, i, o) {
    var u = S4(t, e_), c = S4(t, Uh), f = [].concat(yV(u), yV(c)), d = S4(t, Wh), g = "".concat(i, "Id"), h = i[0], E = r;
    if (f.length && (E = f.reduce(function(Q, B) {
      if (B.props[g] === n && A3(B.props, "extendDomain") && G2(B.props[h])) {
        var _ = B.props[h];
        return [Math.min(Q[0], _), Math.max(Q[1], _)];
      }
      return Q;
    }, E)), d.length) {
      var y = "".concat(h, "1"), I = "".concat(h, "2");
      E = d.reduce(function(Q, B) {
        if (B.props[g] === n && A3(B.props, "extendDomain") && G2(B.props[y]) && G2(B.props[I])) {
          var _ = B.props[y], M = B.props[I];
          return [Math.min(Q[0], _, M), Math.max(Q[1], _, M)];
        }
        return Q;
      }, E);
    }
    return o && o.length && (E = o.reduce(function(Q, B) {
      return G2(B) ? [Math.min(Q[0], B), Math.max(Q[1], B)] : Q;
    }, E)), E;
  }, zx = { exports: {} }, IV;
  function oE2() {
    return IV || (IV = 1, function(e) {
      var t = Object.prototype.hasOwnProperty, r = "~";
      function n() {
      }
      Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
      function i(f, d, g) {
        this.fn = f, this.context = d, this.once = g || !1;
      }
      function o(f, d, g, h, E) {
        if (typeof g != "function")
          throw new TypeError("The listener must be a function");
        var y = new i(g, h || f, E), I = r ? r + d : d;
        return f._events[I] ? f._events[I].fn ? f._events[I] = [f._events[I], y] : f._events[I].push(y) : (f._events[I] = y, f._eventsCount++), f;
      }
      function u(f, d) {
        --f._eventsCount === 0 ? f._events = new n() : delete f._events[d];
      }
      function c() {
        this._events = new n(), this._eventsCount = 0;
      }
      c.prototype.eventNames = function() {
        var d = [], g, h;
        if (this._eventsCount === 0) return d;
        for (h in g = this._events)
          t.call(g, h) && d.push(r ? h.slice(1) : h);
        return Object.getOwnPropertySymbols ? d.concat(Object.getOwnPropertySymbols(g)) : d;
      }, c.prototype.listeners = function(d) {
        var g = r ? r + d : d, h = this._events[g];
        if (!h) return [];
        if (h.fn) return [h.fn];
        for (var E = 0, y = h.length, I = new Array(y); E < y; E++)
          I[E] = h[E].fn;
        return I;
      }, c.prototype.listenerCount = function(d) {
        var g = r ? r + d : d, h = this._events[g];
        return h ? h.fn ? 1 : h.length : 0;
      }, c.prototype.emit = function(d, g, h, E, y, I) {
        var Q = r ? r + d : d;
        if (!this._events[Q]) return !1;
        var B = this._events[Q], _ = arguments.length, M, S;
        if (B.fn) {
          switch (B.once && this.removeListener(d, B.fn, void 0, !0), _) {
            case 1:
              return B.fn.call(B.context), !0;
            case 2:
              return B.fn.call(B.context, g), !0;
            case 3:
              return B.fn.call(B.context, g, h), !0;
            case 4:
              return B.fn.call(B.context, g, h, E), !0;
            case 5:
              return B.fn.call(B.context, g, h, E, y), !0;
            case 6:
              return B.fn.call(B.context, g, h, E, y, I), !0;
          }
          for (S = 1, M = new Array(_ - 1); S < _; S++)
            M[S - 1] = arguments[S];
          B.fn.apply(B.context, M);
        } else {
          var O = B.length, w;
          for (S = 0; S < O; S++)
            switch (B[S].once && this.removeListener(d, B[S].fn, void 0, !0), _) {
              case 1:
                B[S].fn.call(B[S].context);
                break;
              case 2:
                B[S].fn.call(B[S].context, g);
                break;
              case 3:
                B[S].fn.call(B[S].context, g, h);
                break;
              case 4:
                B[S].fn.call(B[S].context, g, h, E);
                break;
              default:
                if (!M) for (w = 1, M = new Array(_ - 1); w < _; w++)
                  M[w - 1] = arguments[w];
                B[S].fn.apply(B[S].context, M);
            }
        }
        return !0;
      }, c.prototype.on = function(d, g, h) {
        return o(this, d, g, h, !1);
      }, c.prototype.once = function(d, g, h) {
        return o(this, d, g, h, !0);
      }, c.prototype.removeListener = function(d, g, h, E) {
        var y = r ? r + d : d;
        if (!this._events[y]) return this;
        if (!g)
          return u(this, y), this;
        var I = this._events[y];
        if (I.fn)
          I.fn === g && (!E || I.once) && (!h || I.context === h) && u(this, y);
        else {
          for (var Q = 0, B = [], _ = I.length; Q < _; Q++)
            (I[Q].fn !== g || E && !I[Q].once || h && I[Q].context !== h) && B.push(I[Q]);
          B.length ? this._events[y] = B.length === 1 ? B[0] : B : u(this, y);
        }
        return this;
      }, c.prototype.removeAllListeners = function(d) {
        var g;
        return d ? (g = r ? r + d : d, this._events[g] && u(this, g)) : (this._events = new n(), this._eventsCount = 0), this;
      }, c.prototype.off = c.prototype.removeListener, c.prototype.addListener = c.prototype.on, c.prefixed = r, c.EventEmitter = c, e.exports = c;
    }(zx)), zx.exports;
  }
  var sE2 = oE2();
  const uE2 = /* @__PURE__ */ tt(sE2);
  var Ux = new uE2(), qx = "recharts.syncMouseEvents";
  function Gc(e) {
    "@babel/helpers - typeof";
    return Gc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Gc(e);
  }
  function lE2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function cE2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, tG(n.key), n);
    }
  }
  function AE2(e, t, r) {
    return t && cE2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function Wx(e, t, r) {
    return t = tG(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function tG(e) {
    var t = fE2(e, "string");
    return Gc(t) == "symbol" ? t : t + "";
  }
  function fE2(e, t) {
    if (Gc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Gc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return String(e);
  }
  var CE2 = /* @__PURE__ */ function() {
    function e() {
      lE2(this, e), Wx(this, "activeIndex", 0), Wx(this, "coordinateList", []), Wx(this, "layout", "horizontal");
    }
    return AE2(e, [{
      key: "setDetails",
      value: function(r) {
        var n, i = r.coordinateList, o = i === void 0 ? null : i, u = r.container, c = u === void 0 ? null : u, f = r.layout, d = f === void 0 ? null : f, g = r.offset, h = g === void 0 ? null : g, E = r.mouseHandlerCallback, y = E === void 0 ? null : E;
        this.coordinateList = (n = o ?? this.coordinateList) !== null && n !== void 0 ? n : [], this.container = c ?? this.container, this.layout = d ?? this.layout, this.offset = h ?? this.offset, this.mouseHandlerCallback = y ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
      }
    }, {
      key: "focus",
      value: function() {
        this.spoofMouse();
      }
    }, {
      key: "keyboardEvent",
      value: function(r) {
        if (this.coordinateList.length !== 0)
          switch (r.key) {
            case "ArrowRight": {
              if (this.layout !== "horizontal")
                return;
              this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
              break;
            }
            case "ArrowLeft": {
              if (this.layout !== "horizontal")
                return;
              this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
              break;
            }
          }
      }
    }, {
      key: "setIndex",
      value: function(r) {
        this.activeIndex = r;
      }
    }, {
      key: "spoofMouse",
      value: function() {
        var r, n;
        if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
          var i = this.container.getBoundingClientRect(), o = i.x, u = i.y, c = i.height, f = this.coordinateList[this.activeIndex].coordinate, d = ((r = window) === null || r === void 0 ? void 0 : r.scrollX) || 0, g = ((n = window) === null || n === void 0 ? void 0 : n.scrollY) || 0, h = o + f + d, E = u + this.offset.top + c / 2 + g;
          this.mouseHandlerCallback({
            pageX: h,
            pageY: E
          });
        }
      }
    }]);
  }();
  function dE2(e, t, r) {
    if (r === "number" && t === !0 && Array.isArray(e)) {
      var n = e == null ? void 0 : e[0], i = e == null ? void 0 : e[1];
      if (n && i && G2(n) && G2(i))
        return !0;
    }
    return !1;
  }
  function gE2(e, t, r, n) {
    var i = n / 2;
    return {
      stroke: "none",
      fill: "#ccc",
      x: e === "horizontal" ? t.x - i : r.left + 0.5,
      y: e === "horizontal" ? r.top + 0.5 : t.y - i,
      width: e === "horizontal" ? n : r.width - 1,
      height: e === "horizontal" ? r.height - 1 : n
    };
  }
  function rG(e) {
    var t = e.cx, r = e.cy, n = e.radius, i = e.startAngle, o = e.endAngle, u = u1(t, r, n, i), c = u1(t, r, n, o);
    return {
      points: [u, c],
      cx: t,
      cy: r,
      radius: n,
      startAngle: i,
      endAngle: o
    };
  }
  function pE2(e, t, r) {
    var n, i, o, u;
    if (e === "horizontal")
      n = t.x, o = n, i = r.top, u = r.top + r.height;
    else if (e === "vertical")
      i = t.y, u = i, n = r.left, o = r.left + r.width;
    else if (t.cx != null && t.cy != null)
      if (e === "centric") {
        var c = t.cx, f = t.cy, d = t.innerRadius, g = t.outerRadius, h = t.angle, E = u1(c, f, d, h), y = u1(c, f, g, h);
        n = E.x, i = E.y, o = y.x, u = y.y;
      } else
        return rG(t);
    return [{
      x: n,
      y: i
    }, {
      x: o,
      y: u
    }];
  }
  function Kc(e) {
    "@babel/helpers - typeof";
    return Kc = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, Kc(e);
  }
  function BV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function jd(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? BV(Object(r), !0).forEach(function(n) {
        hE2(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : BV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function hE2(e, t, r) {
    return t = vE2(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function vE2(e) {
    var t = EE2(e, "string");
    return Kc(t) == "symbol" ? t : t + "";
  }
  function EE2(e, t) {
    if (Kc(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if (Kc(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  function mE2(e) {
    var t, r, n = e.element, i = e.tooltipEventType, o = e.isActive, u = e.activeCoordinate, c = e.activePayload, f = e.offset, d = e.activeTooltipIndex, g = e.tooltipAxisBandSize, h = e.layout, E = e.chartName, y = (t = n.props.cursor) !== null && t !== void 0 ? t : (r = n.type.defaultProps) === null || r === void 0 ? void 0 : r.cursor;
    if (!n || !y || !o || !u || E !== "ScatterChart" && i !== "axis")
      return null;
    var I, Q = vw;
    if (E === "ScatterChart")
      I = u, Q = vg2;
    else if (E === "BarChart")
      I = gE2(h, u, f, g), Q = qM;
    else if (h === "radial") {
      var B = rG(u), _ = B.cx, M = B.cy, S = B.radius, O = B.startAngle, w = B.endAngle;
      I = {
        cx: _,
        cy: M,
        startAngle: O,
        endAngle: w,
        innerRadius: S,
        outerRadius: S
      }, Q = o$;
    } else
      I = {
        points: pE2(h, u, f)
      }, Q = vw;
    var D = jd(jd(jd(jd({
      stroke: "#ccc",
      pointerEvents: "none"
    }, f), I), ge(y, !1)), {}, {
      payload: c,
      payloadIndex: d,
      className: pe("recharts-tooltip-cursor", y.className)
    });
    return /* @__PURE__ */ q.isValidElement(y) ? /* @__PURE__ */ q.cloneElement(y, D) : /* @__PURE__ */ q.createElement(Q, D);
  }
  var yE2 = ["item"], IE2 = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
  function $9(e) {
    "@babel/helpers - typeof";
    return $9 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
      return typeof t;
    } : function(t) {
      return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    }, $9(e);
  }
  function c9() {
    return c9 = Object.assign ? Object.assign.bind() : function(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];
        for (var n in r)
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
      }
      return e;
    }, c9.apply(this, arguments);
  }
  function QV(e, t) {
    return xE2(e) || QE2(e, t) || iG(e, t) || BE2();
  }
  function BE2() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function QE2(e, t) {
    var r = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
    if (r != null) {
      var n, i, o, u, c = [], f = !0, d = !1;
      try {
        if (o = (r = r.call(e)).next, t !== 0) for (; !(f = (n = o.call(r)).done) && (c.push(n.value), c.length !== t); f = !0) ;
      } catch (g) {
        d = !0, i = g;
      } finally {
        try {
          if (!f && r.return != null && (u = r.return(), Object(u) !== u)) return;
        } finally {
          if (d) throw i;
        }
      }
      return c;
    }
  }
  function xE2(e) {
    if (Array.isArray(e)) return e;
  }
  function xV(e, t) {
    if (e == null) return {};
    var r = bE2(e, t), n, i;
    if (Object.getOwnPropertySymbols) {
      var o = Object.getOwnPropertySymbols(e);
      for (i = 0; i < o.length; i++)
        n = o[i], !(t.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(e, n) && (r[n] = e[n]);
    }
    return r;
  }
  function bE2(e, t) {
    if (e == null) return {};
    var r = {};
    for (var n in e)
      if (Object.prototype.hasOwnProperty.call(e, n)) {
        if (t.indexOf(n) >= 0) continue;
        r[n] = e[n];
      }
    return r;
  }
  function wE2(e, t) {
    if (!(e instanceof t))
      throw new TypeError("Cannot call a class as a function");
  }
  function SE2(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, aG(n.key), n);
    }
  }
  function ME2(e, t, r) {
    return t && SE2(e.prototype, t), Object.defineProperty(e, "prototype", { writable: !1 }), e;
  }
  function _E2(e, t, r) {
    return t = Wp(t), OE2(e, nG() ? Reflect.construct(t, r || [], Wp(e).constructor) : t.apply(e, r));
  }
  function OE2(e, t) {
    if (t && ($9(t) === "object" || typeof t == "function"))
      return t;
    if (t !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return TE2(e);
  }
  function TE2(e) {
    if (e === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }
  function nG() {
    try {
      var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
      }));
    } catch {
    }
    return (nG = function() {
      return !!e;
    })();
  }
  function Wp(e) {
    return Wp = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(r) {
      return r.__proto__ || Object.getPrototypeOf(r);
    }, Wp(e);
  }
  function DE2(e, t) {
    if (typeof t != "function" && t !== null)
      throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), Object.defineProperty(e, "prototype", { writable: !1 }), t && Yw(e, t);
  }
  function Yw(e, t) {
    return Yw = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, i) {
      return n.__proto__ = i, n;
    }, Yw(e, t);
  }
  function G9(e) {
    return RE2(e) || kE2(e) || iG(e) || LE2();
  }
  function LE2() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function iG(e, t) {
    if (e) {
      if (typeof e == "string") return $w(e, t);
      var r = Object.prototype.toString.call(e).slice(8, -1);
      if (r === "Object" && e.constructor && (r = e.constructor.name), r === "Map" || r === "Set") return Array.from(e);
      if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return $w(e, t);
    }
  }
  function kE2(e) {
    if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
  }
  function RE2(e) {
    if (Array.isArray(e)) return $w(e);
  }
  function $w(e, t) {
    (t == null || t > e.length) && (t = e.length);
    for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
    return n;
  }
  function bV(e, t) {
    var r = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);
      t && (n = n.filter(function(i) {
        return Object.getOwnPropertyDescriptor(e, i).enumerable;
      })), r.push.apply(r, n);
    }
    return r;
  }
  function R2(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t] != null ? arguments[t] : {};
      t % 2 ? bV(Object(r), !0).forEach(function(n) {
        L0(e, n, r[n]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : bV(Object(r)).forEach(function(n) {
        Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
      });
    }
    return e;
  }
  function L0(e, t, r) {
    return t = aG(t), t in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
  }
  function aG(e) {
    var t = PE2(e, "string");
    return $9(t) == "symbol" ? t : t + "";
  }
  function PE2(e, t) {
    if ($9(e) != "object" || !e) return e;
    var r = e[Symbol.toPrimitive];
    if (r !== void 0) {
      var n = r.call(e, t);
      if ($9(n) != "object") return n;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (t === "string" ? String : Number)(e);
  }
  var FE2 = {
    xAxis: ["bottom", "top"],
    yAxis: ["left", "right"]
  }, NE2 = {
    width: "100%",
    height: "100%"
  }, oG = {
    x: 0,
    y: 0
  };
  function Vd(e) {
    return e;
  }
  var HE2 = function(t, r) {
    return r === "horizontal" ? t.x : r === "vertical" ? t.y : r === "centric" ? t.angle : t.radius;
  }, jE2 = function(t, r, n, i) {
    var o = r.find(function(g) {
      return g && g.index === n;
    });
    if (o) {
      if (t === "horizontal")
        return {
          x: o.coordinate,
          y: i.y
        };
      if (t === "vertical")
        return {
          x: i.x,
          y: o.coordinate
        };
      if (t === "centric") {
        var u = o.coordinate, c = i.radius;
        return R2(R2(R2({}, i), u1(i.cx, i.cy, c, u)), {}, {
          angle: u,
          radius: c
        });
      }
      var f = o.coordinate, d = i.angle;
      return R2(R2(R2({}, i), u1(i.cx, i.cy, f, d)), {}, {
        angle: d,
        radius: f
      });
    }
    return oG;
  }, Yh = function(t, r) {
    var n = r.graphicalItems, i = r.dataStartIndex, o = r.dataEndIndex, u = (n ?? []).reduce(function(c, f) {
      var d = f.props.data;
      return d && d.length ? [].concat(G9(c), G9(d)) : c;
    }, []);
    return u.length > 0 ? u : t && t.length && G2(i) && G2(o) ? t.slice(i, o + 1) : [];
  };
  function sG(e) {
    return e === "number" ? [0, "auto"] : void 0;
  }
  var Gw = function(t, r, n, i) {
    var o = t.graphicalItems, u = t.tooltipAxis, c = Yh(r, t);
    return n < 0 || !o || !o.length || n >= c.length ? null : o.reduce(function(f, d) {
      var g, h = (g = d.props.data) !== null && g !== void 0 ? g : r;
      h && t.dataStartIndex + t.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
      // The data is sliced only when the active index is within the start/end index range.
      t.dataEndIndex - t.dataStartIndex >= n && (h = h.slice(t.dataStartIndex, t.dataEndIndex + 1));
      var E;
      if (u.dataKey && !u.allowDuplicatedCategory) {
        var y = h === void 0 ? c : h;
        E = Gg(y, u.dataKey, i);
      } else
        E = h && h[n] || c[n];
      return E ? [].concat(G9(f), [n$(d, E)]) : f;
    }, []);
  }, wV = function(t, r, n, i) {
    var o = i || {
      x: t.chartX,
      y: t.chartY
    }, u = HE2(o, n), c = t.orderedTooltipTicks, f = t.tooltipAxis, d = t.tooltipTicks, g = GA2(u, c, d, f);
    if (g >= 0 && d) {
      var h = d[g] && d[g].value, E = Gw(t, r, g, h), y = jE2(n, c, g, o);
      return {
        activeTooltipIndex: g,
        activeLabel: h,
        activePayload: E,
        activeCoordinate: y
      };
    }
    return null;
  }, VE2 = function(t, r) {
    var n = r.axes, i = r.graphicalItems, o = r.axisType, u = r.axisIdKey, c = r.stackGroups, f = r.dataStartIndex, d = r.dataEndIndex, g = t.layout, h = t.children, E = t.stackOffset, y = e$(g, o);
    return n.reduce(function(I, Q) {
      var B, _ = Q.type.defaultProps !== void 0 ? R2(R2({}, Q.type.defaultProps), Q.props) : Q.props, M = _.type, S = _.dataKey, O = _.allowDataOverflow, w = _.allowDuplicatedCategory, D = _.scale, k = _.ticks, F = _.includeHidden, z = _[u];
      if (I[z])
        return I;
      var Z = Yh(t.data, {
        graphicalItems: i.filter(function(Y) {
          var r2, o2 = u in Y.props ? Y.props[u] : (r2 = Y.type.defaultProps) === null || r2 === void 0 ? void 0 : r2[u];
          return o2 === z;
        }),
        dataStartIndex: f,
        dataEndIndex: d
      }), V = Z.length, $, W, t2;
      dE2(_.domain, O, M) && ($ = Cw(_.domain, null, O), y && (M === "number" || D !== "auto") && (t2 = ic(Z, S, "category")));
      var n2 = sG(M);
      if (!$ || $.length === 0) {
        var s2, l2 = (s2 = _.domain) !== null && s2 !== void 0 ? s2 : n2;
        if (S) {
          if ($ = ic(Z, S, M), M === "category" && y) {
            var X = Ni2($);
            w && X ? (W = $, $ = Dp(0, V)) : w || ($ = OH(l2, $, Q).reduce(function(Y, r2) {
              return Y.indexOf(r2) >= 0 ? Y : [].concat(G9(Y), [r2]);
            }, []));
          } else if (M === "category")
            w ? $ = $.filter(function(Y) {
              return Y !== "" && !Ae(Y);
            }) : $ = OH(l2, $, Q).reduce(function(Y, r2) {
              return Y.indexOf(r2) >= 0 || r2 === "" || Ae(r2) ? Y : [].concat(G9(Y), [r2]);
            }, []);
          else if (M === "number") {
            var a2 = tf2(Z, i.filter(function(Y) {
              var r2, o2, O2 = u in Y.props ? Y.props[u] : (r2 = Y.type.defaultProps) === null || r2 === void 0 ? void 0 : r2[u], S2 = "hide" in Y.props ? Y.props.hide : (o2 = Y.type.defaultProps) === null || o2 === void 0 ? void 0 : o2.hide;
              return O2 === z && (F || !S2);
            }), S, o, g);
            a2 && ($ = a2);
          }
          y && (M === "number" || D !== "auto") && (t2 = ic(Z, S, "category"));
        } else y ? $ = Dp(0, V) : c && c[z] && c[z].hasStack && M === "number" ? $ = E === "expand" ? [0, 1] : r$(c[z].stackGroups, f, d) : $ = JY(Z, i.filter(function(Y) {
          var r2 = u in Y.props ? Y.props[u] : Y.type.defaultProps[u], o2 = "hide" in Y.props ? Y.props.hide : Y.type.defaultProps.hide;
          return r2 === z && (F || !o2);
        }), M, g, !0);
        if (M === "number")
          $ = Ww(h, $, z, o, k), l2 && ($ = Cw(l2, $, O));
        else if (M === "category" && l2) {
          var e2 = l2, H = $.every(function(Y) {
            return e2.indexOf(Y) >= 0;
          });
          H && ($ = e2);
        }
      }
      return R2(R2({}, I), {}, L0({}, z, R2(R2({}, _), {}, {
        axisType: o,
        domain: $,
        categoricalDomain: t2,
        duplicateDomain: W,
        originalDomain: (B = _.domain) !== null && B !== void 0 ? B : n2,
        isCategorical: y,
        layout: g
      })));
    }, {});
  }, ZE2 = function(t, r) {
    var n = r.graphicalItems, i = r.Axis, o = r.axisType, u = r.axisIdKey, c = r.stackGroups, f = r.dataStartIndex, d = r.dataEndIndex, g = t.layout, h = t.children, E = Yh(t.data, {
      graphicalItems: n,
      dataStartIndex: f,
      dataEndIndex: d
    }), y = E.length, I = e$(g, o), Q = -1;
    return n.reduce(function(B, _) {
      var M = _.type.defaultProps !== void 0 ? R2(R2({}, _.type.defaultProps), _.props) : _.props, S = M[u], O = sG("number");
      if (!B[S]) {
        Q++;
        var w;
        return I ? w = Dp(0, y) : c && c[S] && c[S].hasStack ? (w = r$(c[S].stackGroups, f, d), w = Ww(h, w, S, o)) : (w = Cw(O, JY(E, n.filter(function(D) {
          var k, F, z = u in D.props ? D.props[u] : (k = D.type.defaultProps) === null || k === void 0 ? void 0 : k[u], Z = "hide" in D.props ? D.props.hide : (F = D.type.defaultProps) === null || F === void 0 ? void 0 : F.hide;
          return z === S && !Z;
        }), "number", g), i.defaultProps.allowDataOverflow), w = Ww(h, w, S, o)), R2(R2({}, B), {}, L0({}, S, R2(R2({
          axisType: o
        }, i.defaultProps), {}, {
          hide: !0,
          orientation: w4(FE2, "".concat(o, ".").concat(Q % 2), null),
          domain: w,
          originalDomain: O,
          isCategorical: I,
          layout: g
          // specify scale when no Axis
          // scale: isCategorical ? 'band' : 'linear',
        })));
      }
      return B;
    }, {});
  }, zE2 = function(t, r) {
    var n = r.axisType, i = n === void 0 ? "xAxis" : n, o = r.AxisComp, u = r.graphicalItems, c = r.stackGroups, f = r.dataStartIndex, d = r.dataEndIndex, g = t.children, h = "".concat(i, "Id"), E = S4(g, o), y = {};
    return E && E.length ? y = VE2(t, {
      axes: E,
      graphicalItems: u,
      axisType: i,
      axisIdKey: h,
      stackGroups: c,
      dataStartIndex: f,
      dataEndIndex: d
    }) : u && u.length && (y = ZE2(t, {
      Axis: o,
      graphicalItems: u,
      axisType: i,
      axisIdKey: h,
      stackGroups: c,
      dataStartIndex: f,
      dataEndIndex: d
    })), y;
  }, UE2 = function(t) {
    var r = P6(t), n = g8(r, !1, !0);
    return {
      tooltipTicks: n,
      orderedTooltipTicks: vM(n, function(i) {
        return i.coordinate;
      }),
      tooltipAxis: r,
      tooltipAxisBandSize: Bp(r, n)
    };
  }, SV = function(t) {
    var r = t.children, n = t.defaultShowTooltip, i = Zr(r, F9), o = 0, u = 0;
    return t.data && t.data.length !== 0 && (u = t.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (o = i.props.startIndex), i.props.endIndex >= 0 && (u = i.props.endIndex)), {
      chartX: 0,
      chartY: 0,
      dataStartIndex: o,
      dataEndIndex: u,
      activeTooltipIndex: -1,
      isTooltipActive: !!n
    };
  }, qE2 = function(t) {
    return !t || !t.length ? !1 : t.some(function(r) {
      var n = h8(r && r.type);
      return n && n.indexOf("Bar") >= 0;
    });
  }, MV = function(t) {
    return t === "horizontal" ? {
      numericAxisName: "yAxis",
      cateAxisName: "xAxis"
    } : t === "vertical" ? {
      numericAxisName: "xAxis",
      cateAxisName: "yAxis"
    } : t === "centric" ? {
      numericAxisName: "radiusAxis",
      cateAxisName: "angleAxis"
    } : {
      numericAxisName: "angleAxis",
      cateAxisName: "radiusAxis"
    };
  }, WE2 = function(t, r) {
    var n = t.props, i = t.graphicalItems, o = t.xAxisMap, u = o === void 0 ? {} : o, c = t.yAxisMap, f = c === void 0 ? {} : c, d = n.width, g = n.height, h = n.children, E = n.margin || {}, y = Zr(h, F9), I = Zr(h, v9), Q = Object.keys(f).reduce(function(w, D) {
      var k = f[D], F = k.orientation;
      return !k.mirror && !k.hide ? R2(R2({}, w), {}, L0({}, F, w[F] + k.width)) : w;
    }, {
      left: E.left || 0,
      right: E.right || 0
    }), B = Object.keys(u).reduce(function(w, D) {
      var k = u[D], F = k.orientation;
      return !k.mirror && !k.hide ? R2(R2({}, w), {}, L0({}, F, w4(w, "".concat(F)) + k.height)) : w;
    }, {
      top: E.top || 0,
      bottom: E.bottom || 0
    }), _ = R2(R2({}, B), Q), M = _.bottom;
    y && (_.bottom += y.props.height || F9.defaultProps.height), I && r && (_ = JA2(_, i, n, r));
    var S = d - _.left - _.right, O = g - _.top - _.bottom;
    return R2(R2({
      brushBottom: M
    }, _), {}, {
      // never return negative values for height and width
      width: Math.max(S, 0),
      height: Math.max(O, 0)
    });
  }, YE2 = function(t, r) {
    if (r === "xAxis")
      return t[r].width;
    if (r === "yAxis")
      return t[r].height;
  }, uG = function(t) {
    var r = t.chartName, n = t.GraphicalChild, i = t.defaultTooltipEventType, o = i === void 0 ? "axis" : i, u = t.validateTooltipEventTypes, c = u === void 0 ? ["axis"] : u, f = t.axisComponents, d = t.legendContent, g = t.formatAxisMap, h = t.defaultProps, E = function(_, M) {
      var S = M.graphicalItems, O = M.stackGroups, w = M.offset, D = M.updateId, k = M.dataStartIndex, F = M.dataEndIndex, z = _.barSize, Z = _.layout, V = _.barGap, $ = _.barCategoryGap, W = _.maxBarSize, t2 = MV(Z), n2 = t2.numericAxisName, s2 = t2.cateAxisName, l2 = qE2(S), X = [];
      return S.forEach(function(a2, e2) {
        var H = Yh(_.data, {
          graphicalItems: [a2],
          dataStartIndex: k,
          dataEndIndex: F
        }), Y = a2.type.defaultProps !== void 0 ? R2(R2({}, a2.type.defaultProps), a2.props) : a2.props, r2 = Y.dataKey, o2 = Y.maxBarSize, O2 = Y["".concat(n2, "Id")], S2 = Y["".concat(s2, "Id")], M2 = {}, w2 = f.reduce(function(U0, Z0) {
          var Te, Lt, Ge = M["".concat(Z0.axisType, "Map")], rt = Y["".concat(Z0.axisType, "Id")];
          Ge && Ge[rt] || Z0.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? mr(!1, "Specifying a(n) ".concat(Z0.axisType, "Id requires a corresponding ").concat(
            Z0.axisType,
            "Id on the targeted graphical component "
          ).concat((Te = a2 == null || (Lt = a2.type) === null || Lt === void 0 ? void 0 : Lt.displayName) !== null && Te !== void 0 ? Te : "")) : mr());
          var yt = Ge[rt];
          return R2(R2({}, U0), {}, L0(L0({}, Z0.axisType, yt), "".concat(Z0.axisType, "Ticks"), g8(yt)));
        }, M2), v2 = w2[s2], L2 = w2["".concat(s2, "Ticks")], W2 = O && O[O2] && O[O2].hasStack && Cf2(a2, O[O2].stackGroups), d2 = h8(a2.type).indexOf("Bar") >= 0, X2 = Bp(v2, L2), k2 = [], b0 = l2 && KA2({
          barSize: z,
          stackGroups: O,
          totalSize: YE2(w2, s2)
        });
        if (d2) {
          var S0, G0, $e = Ae(o2) ? W : o2, _e = (S0 = (G0 = Bp(v2, L2, !0)) !== null && G0 !== void 0 ? G0 : $e) !== null && S0 !== void 0 ? S0 : 0;
          k2 = XA2({
            barGap: V,
            barCategoryGap: $,
            bandSize: _e !== X2 ? _e : X2,
            sizeList: b0[S2],
            maxBarSize: $e
          }), _e !== X2 && (k2 = k2.map(function(U0) {
            return R2(R2({}, U0), {}, {
              position: R2(R2({}, U0.position), {}, {
                offset: U0.position.offset - _e / 2
              })
            });
          }));
        }
        var Oe = a2 && a2.type && a2.type.getComposedData;
        Oe && X.push({
          props: R2(R2({}, Oe(R2(R2({}, w2), {}, {
            displayedData: H,
            props: _,
            dataKey: r2,
            item: a2,
            bandSize: X2,
            barPosition: k2,
            offset: w,
            stackedData: W2,
            layout: Z,
            dataStartIndex: k,
            dataEndIndex: F
          }))), {}, L0(L0(L0({
            key: a2.key || "item-".concat(e2)
          }, n2, w2[n2]), s2, w2[s2]), "animationId", D)),
          childIndex: Xi2(a2, _.children),
          item: a2
        });
      }), X;
    }, y = function(_, M) {
      var S = _.props, O = _.dataStartIndex, w = _.dataEndIndex, D = _.updateId;
      if (!UR({
        props: S
      }))
        return null;
      var k = S.children, F = S.layout, z = S.stackOffset, Z = S.data, V = S.reverseStackOrder, $ = MV(F), W = $.numericAxisName, t2 = $.cateAxisName, n2 = S4(k, n), s2 = cf2(Z, n2, "".concat(W, "Id"), "".concat(t2, "Id"), z, V), l2 = f.reduce(function(Y, r2) {
        var o2 = "".concat(r2.axisType, "Map");
        return R2(R2({}, Y), {}, L0({}, o2, zE2(S, R2(R2({}, r2), {}, {
          graphicalItems: n2,
          stackGroups: r2.axisType === W && s2,
          dataStartIndex: O,
          dataEndIndex: w
        }))));
      }, {}), X = WE2(R2(R2({}, l2), {}, {
        props: S,
        graphicalItems: n2
      }), M == null ? void 0 : M.legendBBox);
      Object.keys(l2).forEach(function(Y) {
        l2[Y] = g(S, l2[Y], X, Y.replace("Map", ""), r);
      });
      var a2 = l2["".concat(t2, "Map")], e2 = UE2(a2), H = E(S, R2(R2({}, l2), {}, {
        dataStartIndex: O,
        dataEndIndex: w,
        updateId: D,
        graphicalItems: n2,
        stackGroups: s2,
        offset: X
      }));
      return R2(R2({
        formattedGraphicalItems: H,
        graphicalItems: n2,
        offset: X,
        stackGroups: s2
      }, e2), l2);
    }, I = /* @__PURE__ */ function(B) {
      function _(M) {
        var S, O, w;
        return wE2(this, _), w = _E2(this, _, [M]), L0(w, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), L0(w, "accessibilityManager", new CE2()), L0(w, "handleLegendBBoxUpdate", function(D) {
          if (D) {
            var k = w.state, F = k.dataStartIndex, z = k.dataEndIndex, Z = k.updateId;
            w.setState(R2({
              legendBBox: D
            }, y({
              props: w.props,
              dataStartIndex: F,
              dataEndIndex: z,
              updateId: Z
            }, R2(R2({}, w.state), {}, {
              legendBBox: D
            }))));
          }
        }), L0(w, "handleReceiveSyncEvent", function(D, k, F) {
          if (w.props.syncId === D) {
            if (F === w.eventEmitterSymbol && typeof w.props.syncMethod != "function")
              return;
            w.applySyncEvent(k);
          }
        }), L0(w, "handleBrushChange", function(D) {
          var k = D.startIndex, F = D.endIndex;
          if (k !== w.state.dataStartIndex || F !== w.state.dataEndIndex) {
            var z = w.state.updateId;
            w.setState(function() {
              return R2({
                dataStartIndex: k,
                dataEndIndex: F
              }, y({
                props: w.props,
                dataStartIndex: k,
                dataEndIndex: F,
                updateId: z
              }, w.state));
            }), w.triggerSyncEvent({
              dataStartIndex: k,
              dataEndIndex: F
            });
          }
        }), L0(w, "handleMouseEnter", function(D) {
          var k = w.getMouseInfo(D);
          if (k) {
            var F = R2(R2({}, k), {}, {
              isTooltipActive: !0
            });
            w.setState(F), w.triggerSyncEvent(F);
            var z = w.props.onMouseEnter;
            te(z) && z(F, D);
          }
        }), L0(w, "triggeredAfterMouseMove", function(D) {
          var k = w.getMouseInfo(D), F = k ? R2(R2({}, k), {}, {
            isTooltipActive: !0
          }) : {
            isTooltipActive: !1
          };
          w.setState(F), w.triggerSyncEvent(F);
          var z = w.props.onMouseMove;
          te(z) && z(F, D);
        }), L0(w, "handleItemMouseEnter", function(D) {
          w.setState(function() {
            return {
              isTooltipActive: !0,
              activeItem: D,
              activePayload: D.tooltipPayload,
              activeCoordinate: D.tooltipPosition || {
                x: D.cx,
                y: D.cy
              }
            };
          });
        }), L0(w, "handleItemMouseLeave", function() {
          w.setState(function() {
            return {
              isTooltipActive: !1
            };
          });
        }), L0(w, "handleMouseMove", function(D) {
          D.persist(), w.throttleTriggeredAfterMouseMove(D);
        }), L0(w, "handleMouseLeave", function(D) {
          w.throttleTriggeredAfterMouseMove.cancel();
          var k = {
            isTooltipActive: !1
          };
          w.setState(k), w.triggerSyncEvent(k);
          var F = w.props.onMouseLeave;
          te(F) && F(k, D);
        }), L0(w, "handleOuterEvent", function(D) {
          var k = Ki2(D), F = w4(w.props, "".concat(k));
          if (k && te(F)) {
            var z, Z;
            /.*touch.*/i.test(k) ? Z = w.getMouseInfo(D.changedTouches[0]) : Z = w.getMouseInfo(D), F((z = Z) !== null && z !== void 0 ? z : {}, D);
          }
        }), L0(w, "handleClick", function(D) {
          var k = w.getMouseInfo(D);
          if (k) {
            var F = R2(R2({}, k), {}, {
              isTooltipActive: !0
            });
            w.setState(F), w.triggerSyncEvent(F);
            var z = w.props.onClick;
            te(z) && z(F, D);
          }
        }), L0(w, "handleMouseDown", function(D) {
          var k = w.props.onMouseDown;
          if (te(k)) {
            var F = w.getMouseInfo(D);
            k(F, D);
          }
        }), L0(w, "handleMouseUp", function(D) {
          var k = w.props.onMouseUp;
          if (te(k)) {
            var F = w.getMouseInfo(D);
            k(F, D);
          }
        }), L0(w, "handleTouchMove", function(D) {
          D.changedTouches != null && D.changedTouches.length > 0 && w.throttleTriggeredAfterMouseMove(D.changedTouches[0]);
        }), L0(w, "handleTouchStart", function(D) {
          D.changedTouches != null && D.changedTouches.length > 0 && w.handleMouseDown(D.changedTouches[0]);
        }), L0(w, "handleTouchEnd", function(D) {
          D.changedTouches != null && D.changedTouches.length > 0 && w.handleMouseUp(D.changedTouches[0]);
        }), L0(w, "handleDoubleClick", function(D) {
          var k = w.props.onDoubleClick;
          if (te(k)) {
            var F = w.getMouseInfo(D);
            k(F, D);
          }
        }), L0(w, "handleContextMenu", function(D) {
          var k = w.props.onContextMenu;
          if (te(k)) {
            var F = w.getMouseInfo(D);
            k(F, D);
          }
        }), L0(w, "triggerSyncEvent", function(D) {
          w.props.syncId !== void 0 && Ux.emit(qx, w.props.syncId, D, w.eventEmitterSymbol);
        }), L0(w, "applySyncEvent", function(D) {
          var k = w.props, F = k.layout, z = k.syncMethod, Z = w.state.updateId, V = D.dataStartIndex, $ = D.dataEndIndex;
          if (D.dataStartIndex !== void 0 || D.dataEndIndex !== void 0)
            w.setState(R2({
              dataStartIndex: V,
              dataEndIndex: $
            }, y({
              props: w.props,
              dataStartIndex: V,
              dataEndIndex: $,
              updateId: Z
            }, w.state)));
          else if (D.activeTooltipIndex !== void 0) {
            var W = D.chartX, t2 = D.chartY, n2 = D.activeTooltipIndex, s2 = w.state, l2 = s2.offset, X = s2.tooltipTicks;
            if (!l2)
              return;
            if (typeof z == "function")
              n2 = z(X, D);
            else if (z === "value") {
              n2 = -1;
              for (var a2 = 0; a2 < X.length; a2++)
                if (X[a2].value === D.activeLabel) {
                  n2 = a2;
                  break;
                }
            }
            var e2 = R2(R2({}, l2), {}, {
              x: l2.left,
              y: l2.top
            }), H = Math.min(W, e2.x + e2.width), Y = Math.min(t2, e2.y + e2.height), r2 = X[n2] && X[n2].value, o2 = Gw(w.state, w.props.data, n2), O2 = X[n2] ? {
              x: F === "horizontal" ? X[n2].coordinate : H,
              y: F === "horizontal" ? Y : X[n2].coordinate
            } : oG;
            w.setState(R2(R2({}, D), {}, {
              activeLabel: r2,
              activeCoordinate: O2,
              activePayload: o2,
              activeTooltipIndex: n2
            }));
          } else
            w.setState(D);
        }), L0(w, "renderCursor", function(D) {
          var k, F = w.state, z = F.isTooltipActive, Z = F.activeCoordinate, V = F.activePayload, $ = F.offset, W = F.activeTooltipIndex, t2 = F.tooltipAxisBandSize, n2 = w.getTooltipEventType(), s2 = (k = D.props.active) !== null && k !== void 0 ? k : z, l2 = w.props.layout, X = D.key || "_recharts-cursor";
          return /* @__PURE__ */ f2.createElement(mE2, {
            key: X,
            activeCoordinate: Z,
            activePayload: V,
            activeTooltipIndex: W,
            chartName: r,
            element: D,
            isActive: s2,
            layout: l2,
            offset: $,
            tooltipAxisBandSize: t2,
            tooltipEventType: n2
          });
        }), L0(w, "renderPolarAxis", function(D, k, F) {
          var z = w4(D, "type.axisType"), Z = w4(w.state, "".concat(z, "Map")), V = D.type.defaultProps, $ = V !== void 0 ? R2(R2({}, V), D.props) : D.props, W = Z && Z[$["".concat(z, "Id")]];
          return /* @__PURE__ */ q.cloneElement(D, R2(R2({}, W), {}, {
            className: pe(z, W.className),
            key: D.key || "".concat(k, "-").concat(F),
            ticks: g8(W, !0)
          }));
        }), L0(w, "renderPolarGrid", function(D) {
          var k = D.props, F = k.radialLines, z = k.polarAngles, Z = k.polarRadius, V = w.state, $ = V.radiusAxisMap, W = V.angleAxisMap, t2 = P6($), n2 = P6(W), s2 = n2.cx, l2 = n2.cy, X = n2.innerRadius, a2 = n2.outerRadius;
          return /* @__PURE__ */ q.cloneElement(D, {
            polarAngles: Array.isArray(z) ? z : g8(n2, !0).map(function(e2) {
              return e2.coordinate;
            }),
            polarRadius: Array.isArray(Z) ? Z : g8(t2, !0).map(function(e2) {
              return e2.coordinate;
            }),
            cx: s2,
            cy: l2,
            innerRadius: X,
            outerRadius: a2,
            key: D.key || "polar-grid",
            radialLines: F
          });
        }), L0(w, "renderLegend", function() {
          var D = w.state.formattedGraphicalItems, k = w.props, F = k.children, z = k.width, Z = k.height, V = w.props.margin || {}, $ = z - (V.left || 0) - (V.right || 0), W = KY({
            children: F,
            formattedGraphicalItems: D,
            legendWidth: $,
            legendContent: d
          });
          if (!W)
            return null;
          var t2 = W.item, n2 = xV(W, yE2);
          return /* @__PURE__ */ q.cloneElement(t2, R2(R2({}, n2), {}, {
            chartWidth: z,
            chartHeight: Z,
            margin: V,
            onBBoxUpdate: w.handleLegendBBoxUpdate
          }));
        }), L0(w, "renderTooltip", function() {
          var D, k = w.props, F = k.children, z = k.accessibilityLayer, Z = Zr(F, cn);
          if (!Z)
            return null;
          var V = w.state, $ = V.isTooltipActive, W = V.activeCoordinate, t2 = V.activePayload, n2 = V.activeLabel, s2 = V.offset, l2 = (D = Z.props.active) !== null && D !== void 0 ? D : $;
          return /* @__PURE__ */ q.cloneElement(Z, {
            viewBox: R2(R2({}, s2), {}, {
              x: s2.left,
              y: s2.top
            }),
            active: l2,
            label: n2,
            payload: l2 ? t2 : [],
            coordinate: W,
            accessibilityLayer: z
          });
        }), L0(w, "renderBrush", function(D) {
          var k = w.props, F = k.margin, z = k.data, Z = w.state, V = Z.offset, $ = Z.dataStartIndex, W = Z.dataEndIndex, t2 = Z.updateId;
          return /* @__PURE__ */ q.cloneElement(D, {
            key: D.key || "_recharts-brush",
            onChange: kd(w.handleBrushChange, D.props.onChange),
            data: z,
            x: G2(D.props.x) ? D.props.x : V.left,
            y: G2(D.props.y) ? D.props.y : V.top + V.height + V.brushBottom - (F.bottom || 0),
            width: G2(D.props.width) ? D.props.width : V.width,
            startIndex: $,
            endIndex: W,
            updateId: "brush-".concat(t2)
          });
        }), L0(w, "renderReferenceElement", function(D, k, F) {
          if (!D)
            return null;
          var z = w, Z = z.clipPathId, V = w.state, $ = V.xAxisMap, W = V.yAxisMap, t2 = V.offset, n2 = D.type.defaultProps || {}, s2 = D.props, l2 = s2.xAxisId, X = l2 === void 0 ? n2.xAxisId : l2, a2 = s2.yAxisId, e2 = a2 === void 0 ? n2.yAxisId : a2;
          return /* @__PURE__ */ q.cloneElement(D, {
            key: D.key || "".concat(k, "-").concat(F),
            xAxis: $[X],
            yAxis: W[e2],
            viewBox: {
              x: t2.left,
              y: t2.top,
              width: t2.width,
              height: t2.height
            },
            clipPathId: Z
          });
        }), L0(w, "renderActivePoints", function(D) {
          var k = D.item, F = D.activePoint, z = D.basePoint, Z = D.childIndex, V = D.isRange, $ = [], W = k.props.key, t2 = k.item.type.defaultProps !== void 0 ? R2(R2({}, k.item.type.defaultProps), k.item.props) : k.item.props, n2 = t2.activeDot, s2 = t2.dataKey, l2 = R2(R2({
            index: Z,
            dataKey: s2,
            cx: F.x,
            cy: F.y,
            r: 4,
            fill: zM(k.item),
            strokeWidth: 2,
            stroke: "#fff",
            payload: F.payload,
            value: F.value
          }, ge(n2, !1)), Kg(n2));
          return $.push(_.renderActiveDot(n2, l2, "".concat(W, "-activePoint-").concat(Z))), z ? $.push(_.renderActiveDot(n2, R2(R2({}, l2), {}, {
            cx: z.x,
            cy: z.y
          }), "".concat(W, "-basePoint-").concat(Z))) : V && $.push(null), $;
        }), L0(w, "renderGraphicChild", function(D, k, F) {
          var z = w.filterFormatItem(D, k, F);
          if (!z)
            return null;
          var Z = w.getTooltipEventType(), V = w.state, $ = V.isTooltipActive, W = V.tooltipAxis, t2 = V.activeTooltipIndex, n2 = V.activeLabel, s2 = w.props.children, l2 = Zr(s2, cn), X = z.props, a2 = X.points, e2 = X.isRange, H = X.baseLine, Y = z.item.type.defaultProps !== void 0 ? R2(R2({}, z.item.type.defaultProps), z.item.props) : z.item.props, r2 = Y.activeDot, o2 = Y.hide, O2 = Y.activeBar, S2 = Y.activeShape, M2 = !!(!o2 && $ && l2 && (r2 || O2 || S2)), w2 = {};
          Z !== "axis" && l2 && l2.props.trigger === "click" ? w2 = {
            onClick: kd(w.handleItemMouseEnter, D.props.onClick)
          } : Z !== "axis" && (w2 = {
            onMouseLeave: kd(w.handleItemMouseLeave, D.props.onMouseLeave),
            onMouseEnter: kd(w.handleItemMouseEnter, D.props.onMouseEnter)
          });
          var v2 = /* @__PURE__ */ q.cloneElement(D, R2(R2({}, z.props), w2));
          function L2(Z0) {
            return typeof W.dataKey == "function" ? W.dataKey(Z0.payload) : null;
          }
          if (M2)
            if (t2 >= 0) {
              var W2, d2;
              if (W.dataKey && !W.allowDuplicatedCategory) {
                var X2 = typeof W.dataKey == "function" ? L2 : "payload.".concat(W.dataKey.toString());
                W2 = Gg(a2, X2, n2), d2 = e2 && H && Gg(H, X2, n2);
              } else
                W2 = a2 == null ? void 0 : a2[t2], d2 = e2 && H && H[t2];
              if (S2 || O2) {
                var k2 = D.props.activeIndex !== void 0 ? D.props.activeIndex : t2;
                return [/* @__PURE__ */ q.cloneElement(D, R2(R2(R2({}, z.props), w2), {}, {
                  activeIndex: k2
                })), null, null];
              }
              if (!Ae(W2))
                return [v2].concat(G9(w.renderActivePoints({
                  item: z,
                  activePoint: W2,
                  basePoint: d2,
                  childIndex: t2,
                  isRange: e2
                })));
            } else {
              var b0, S0 = (b0 = w.getItemByXY(w.state.activeCoordinate)) !== null && b0 !== void 0 ? b0 : {
                graphicalItem: v2
              }, G0 = S0.graphicalItem, $e = G0.item, _e = $e === void 0 ? D : $e, Oe = G0.childIndex, U0 = R2(R2(R2({}, z.props), w2), {}, {
                activeIndex: Oe
              });
              return [/* @__PURE__ */ q.cloneElement(_e, U0), null, null];
            }
          return e2 ? [v2, null, null] : [v2, null];
        }), L0(w, "renderCustomized", function(D, k, F) {
          return /* @__PURE__ */ q.cloneElement(D, R2(R2({
            key: "recharts-customized-".concat(F)
          }, w.props), w.state));
        }), L0(w, "renderMap", {
          CartesianGrid: {
            handler: Vd,
            once: !0
          },
          ReferenceArea: {
            handler: w.renderReferenceElement
          },
          ReferenceLine: {
            handler: Vd
          },
          ReferenceDot: {
            handler: w.renderReferenceElement
          },
          XAxis: {
            handler: Vd
          },
          YAxis: {
            handler: Vd
          },
          Brush: {
            handler: w.renderBrush,
            once: !0
          },
          Bar: {
            handler: w.renderGraphicChild
          },
          Line: {
            handler: w.renderGraphicChild
          },
          Area: {
            handler: w.renderGraphicChild
          },
          Radar: {
            handler: w.renderGraphicChild
          },
          RadialBar: {
            handler: w.renderGraphicChild
          },
          Scatter: {
            handler: w.renderGraphicChild
          },
          Pie: {
            handler: w.renderGraphicChild
          },
          Funnel: {
            handler: w.renderGraphicChild
          },
          Tooltip: {
            handler: w.renderCursor,
            once: !0
          },
          PolarGrid: {
            handler: w.renderPolarGrid,
            once: !0
          },
          PolarAngleAxis: {
            handler: w.renderPolarAxis
          },
          PolarRadiusAxis: {
            handler: w.renderPolarAxis
          },
          Customized: {
            handler: w.renderCustomized
          }
        }), w.clipPathId = "".concat((S = M.id) !== null && S !== void 0 ? S : uA("recharts"), "-clip"), w.throttleTriggeredAfterMouseMove = GW(w.triggeredAfterMouseMove, (O = M.throttleDelay) !== null && O !== void 0 ? O : 1e3 / 60), w.state = {}, w;
      }
      return DE2(_, B), ME2(_, [{
        key: "componentDidMount",
        value: function() {
          var S, O;
          this.addListener(), this.accessibilityManager.setDetails({
            container: this.container,
            offset: {
              left: (S = this.props.margin.left) !== null && S !== void 0 ? S : 0,
              top: (O = this.props.margin.top) !== null && O !== void 0 ? O : 0
            },
            coordinateList: this.state.tooltipTicks,
            mouseHandlerCallback: this.triggeredAfterMouseMove,
            layout: this.props.layout
          }), this.displayDefaultTooltip();
        }
      }, {
        key: "displayDefaultTooltip",
        value: function() {
          var S = this.props, O = S.children, w = S.data, D = S.height, k = S.layout, F = Zr(O, cn);
          if (F) {
            var z = F.props.defaultIndex;
            if (!(typeof z != "number" || z < 0 || z > this.state.tooltipTicks.length - 1)) {
              var Z = this.state.tooltipTicks[z] && this.state.tooltipTicks[z].value, V = Gw(this.state, w, z, Z), $ = this.state.tooltipTicks[z].coordinate, W = (this.state.offset.top + D) / 2, t2 = k === "horizontal", n2 = t2 ? {
                x: $,
                y: W
              } : {
                y: $,
                x: W
              }, s2 = this.state.formattedGraphicalItems.find(function(X) {
                var a2 = X.item;
                return a2.type.name === "Scatter";
              });
              s2 && (n2 = R2(R2({}, n2), s2.props.points[z].tooltipPosition), V = s2.props.points[z].tooltipPayload);
              var l2 = {
                activeTooltipIndex: z,
                isTooltipActive: !0,
                activeLabel: Z,
                activePayload: V,
                activeCoordinate: n2
              };
              this.setState(l2), this.renderCursor(F), this.accessibilityManager.setIndex(z);
            }
          }
        }
      }, {
        key: "getSnapshotBeforeUpdate",
        value: function(S, O) {
          if (!this.props.accessibilityLayer)
            return null;
          if (this.state.tooltipTicks !== O.tooltipTicks && this.accessibilityManager.setDetails({
            coordinateList: this.state.tooltipTicks
          }), this.props.layout !== S.layout && this.accessibilityManager.setDetails({
            layout: this.props.layout
          }), this.props.margin !== S.margin) {
            var w, D;
            this.accessibilityManager.setDetails({
              offset: {
                left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
                top: (D = this.props.margin.top) !== null && D !== void 0 ? D : 0
              }
            });
          }
          return null;
        }
      }, {
        key: "componentDidUpdate",
        value: function(S) {
          kb([Zr(S.children, cn)], [Zr(this.props.children, cn)]) || this.displayDefaultTooltip();
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
        }
      }, {
        key: "getTooltipEventType",
        value: function() {
          var S = Zr(this.props.children, cn);
          if (S && typeof S.props.shared == "boolean") {
            var O = S.props.shared ? "axis" : "item";
            return c.indexOf(O) >= 0 ? O : o;
          }
          return o;
        }
        /**
         * Get the information of mouse in chart, return null when the mouse is not in the chart
         * @param  {MousePointer} event    The event object
         * @return {Object}          Mouse data
         */
      }, {
        key: "getMouseInfo",
        value: function(S) {
          if (!this.container)
            return null;
          var O = this.container, w = O.getBoundingClientRect(), D = Hs2(w), k = {
            chartX: Math.round(S.pageX - D.left),
            chartY: Math.round(S.pageY - D.top)
          }, F = w.width / O.offsetWidth || 1, z = this.inRange(k.chartX, k.chartY, F);
          if (!z)
            return null;
          var Z = this.state, V = Z.xAxisMap, $ = Z.yAxisMap, W = this.getTooltipEventType(), t2 = wV(this.state, this.props.data, this.props.layout, z);
          if (W !== "axis" && V && $) {
            var n2 = P6(V).scale, s2 = P6($).scale, l2 = n2 && n2.invert ? n2.invert(k.chartX) : null, X = s2 && s2.invert ? s2.invert(k.chartY) : null;
            return R2(R2({}, k), {}, {
              xValue: l2,
              yValue: X
            }, t2);
          }
          return t2 ? R2(R2({}, k), t2) : null;
        }
      }, {
        key: "inRange",
        value: function(S, O) {
          var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, D = this.props.layout, k = S / w, F = O / w;
          if (D === "horizontal" || D === "vertical") {
            var z = this.state.offset, Z = k >= z.left && k <= z.left + z.width && F >= z.top && F <= z.top + z.height;
            return Z ? {
              x: k,
              y: F
            } : null;
          }
          var V = this.state, $ = V.angleAxisMap, W = V.radiusAxisMap;
          if ($ && W) {
            var t2 = P6($);
            return LH({
              x: k,
              y: F
            }, t2);
          }
          return null;
        }
      }, {
        key: "parseEventsOfWrapper",
        value: function() {
          var S = this.props.children, O = this.getTooltipEventType(), w = Zr(S, cn), D = {};
          w && O === "axis" && (w.props.trigger === "click" ? D = {
            onClick: this.handleClick
          } : D = {
            onMouseEnter: this.handleMouseEnter,
            onDoubleClick: this.handleDoubleClick,
            onMouseMove: this.handleMouseMove,
            onMouseLeave: this.handleMouseLeave,
            onTouchMove: this.handleTouchMove,
            onTouchStart: this.handleTouchStart,
            onTouchEnd: this.handleTouchEnd,
            onContextMenu: this.handleContextMenu
          });
          var k = Kg(this.props, this.handleOuterEvent);
          return R2(R2({}, k), D);
        }
      }, {
        key: "addListener",
        value: function() {
          Ux.on(qx, this.handleReceiveSyncEvent);
        }
      }, {
        key: "removeListener",
        value: function() {
          Ux.removeListener(qx, this.handleReceiveSyncEvent);
        }
      }, {
        key: "filterFormatItem",
        value: function(S, O, w) {
          for (var D = this.state.formattedGraphicalItems, k = 0, F = D.length; k < F; k++) {
            var z = D[k];
            if (z.item === S || z.props.key === S.key || O === h8(z.item.type) && w === z.childIndex)
              return z;
          }
          return null;
        }
      }, {
        key: "renderClipPath",
        value: function() {
          var S = this.clipPathId, O = this.state.offset, w = O.left, D = O.top, k = O.height, F = O.width;
          return /* @__PURE__ */ f2.createElement("defs", null, /* @__PURE__ */ f2.createElement("clipPath", {
            id: S
          }, /* @__PURE__ */ f2.createElement("rect", {
            x: w,
            y: D,
            height: k,
            width: F
          })));
        }
      }, {
        key: "getXScales",
        value: function() {
          var S = this.state.xAxisMap;
          return S ? Object.entries(S).reduce(function(O, w) {
            var D = QV(w, 2), k = D[0], F = D[1];
            return R2(R2({}, O), {}, L0({}, k, F.scale));
          }, {}) : null;
        }
      }, {
        key: "getYScales",
        value: function() {
          var S = this.state.yAxisMap;
          return S ? Object.entries(S).reduce(function(O, w) {
            var D = QV(w, 2), k = D[0], F = D[1];
            return R2(R2({}, O), {}, L0({}, k, F.scale));
          }, {}) : null;
        }
      }, {
        key: "getXScaleByAxisId",
        value: function(S) {
          var O;
          return (O = this.state.xAxisMap) === null || O === void 0 || (O = O[S]) === null || O === void 0 ? void 0 : O.scale;
        }
      }, {
        key: "getYScaleByAxisId",
        value: function(S) {
          var O;
          return (O = this.state.yAxisMap) === null || O === void 0 || (O = O[S]) === null || O === void 0 ? void 0 : O.scale;
        }
      }, {
        key: "getItemByXY",
        value: function(S) {
          var O = this.state, w = O.formattedGraphicalItems, D = O.activeItem;
          if (w && w.length)
            for (var k = 0, F = w.length; k < F; k++) {
              var z = w[k], Z = z.props, V = z.item, $ = V.type.defaultProps !== void 0 ? R2(R2({}, V.type.defaultProps), V.props) : V.props, W = h8(V.type);
              if (W === "Bar") {
                var t2 = (Z.data || []).find(function(X) {
                  return ug2(S, X);
                });
                if (t2)
                  return {
                    graphicalItem: z,
                    payload: t2
                  };
              } else if (W === "RadialBar") {
                var n2 = (Z.data || []).find(function(X) {
                  return LH(S, X);
                });
                if (n2)
                  return {
                    graphicalItem: z,
                    payload: n2
                  };
              } else if (jh(z, D) || Vh(z, D) || qc(z, D)) {
                var s2 = Xg2({
                  graphicalItem: z,
                  activeTooltipItem: D,
                  itemData: $.data
                }), l2 = $.activeIndex === void 0 ? s2 : $.activeIndex;
                return {
                  graphicalItem: R2(R2({}, z), {}, {
                    childIndex: l2
                  }),
                  payload: qc(z, D) ? $.data[s2] : z.props.data[s2]
                };
              }
            }
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var S = this;
          if (!UR(this))
            return null;
          var O = this.props, w = O.children, D = O.className, k = O.width, F = O.height, z = O.style, Z = O.compact, V = O.title, $ = O.desc, W = xV(O, IE2), t2 = ge(W, !1);
          if (Z)
            return /* @__PURE__ */ f2.createElement(aV, {
              state: this.state,
              width: this.props.width,
              height: this.props.height,
              clipPathId: this.clipPathId
            }, /* @__PURE__ */ f2.createElement(Pb, c9({}, t2, {
              width: k,
              height: F,
              title: V,
              desc: $
            }), this.renderClipPath(), WR(w, this.renderMap)));
          if (this.props.accessibilityLayer) {
            var n2, s2;
            t2.tabIndex = (n2 = this.props.tabIndex) !== null && n2 !== void 0 ? n2 : 0, t2.role = (s2 = this.props.role) !== null && s2 !== void 0 ? s2 : "application", t2.onKeyDown = function(X) {
              S.accessibilityManager.keyboardEvent(X);
            }, t2.onFocus = function() {
              S.accessibilityManager.focus();
            };
          }
          var l2 = this.parseEventsOfWrapper();
          return /* @__PURE__ */ f2.createElement(aV, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ f2.createElement("div", c9({
            className: pe("recharts-wrapper", D),
            style: R2({
              position: "relative",
              cursor: "default",
              width: k,
              height: F
            }, z)
          }, l2, {
            ref: function(a2) {
              S.container = a2;
            }
          }), /* @__PURE__ */ f2.createElement(Pb, c9({}, t2, {
            width: k,
            height: F,
            title: V,
            desc: $,
            style: NE2
          }), this.renderClipPath(), WR(w, this.renderMap)), this.renderLegend(), this.renderTooltip()));
        }
      }]);
    }(q.Component);
    L0(I, "displayName", r), L0(I, "defaultProps", R2({
      layout: "horizontal",
      stackOffset: "none",
      barCategoryGap: "10%",
      barGap: 4,
      margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
      },
      reverseStackOrder: !1,
      syncMethod: "index"
    }, h)), L0(I, "getDerivedStateFromProps", function(B, _) {
      var M = B.dataKey, S = B.data, O = B.children, w = B.width, D = B.height, k = B.layout, F = B.stackOffset, z = B.margin, Z = _.dataStartIndex, V = _.dataEndIndex;
      if (_.updateId === void 0) {
        var $ = SV(B);
        return R2(R2(R2({}, $), {}, {
          updateId: 0
        }, y(R2(R2({
          props: B
        }, $), {}, {
          updateId: 0
        }), _)), {}, {
          prevDataKey: M,
          prevData: S,
          prevWidth: w,
          prevHeight: D,
          prevLayout: k,
          prevStackOffset: F,
          prevMargin: z,
          prevChildren: O
        });
      }
      if (M !== _.prevDataKey || S !== _.prevData || w !== _.prevWidth || D !== _.prevHeight || k !== _.prevLayout || F !== _.prevStackOffset || !h9(z, _.prevMargin)) {
        var W = SV(B), t2 = {
          // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
          // any flickering
          chartX: _.chartX,
          chartY: _.chartY,
          // The tooltip should stay active when it was active in the previous render. If this is not
          // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
          isTooltipActive: _.isTooltipActive
        }, n2 = R2(R2({}, wV(_, S, k)), {}, {
          updateId: _.updateId + 1
        }), s2 = R2(R2(R2({}, W), t2), n2);
        return R2(R2(R2({}, s2), y(R2({
          props: B
        }, s2), _)), {}, {
          prevDataKey: M,
          prevData: S,
          prevWidth: w,
          prevHeight: D,
          prevLayout: k,
          prevStackOffset: F,
          prevMargin: z,
          prevChildren: O
        });
      }
      if (!kb(O, _.prevChildren)) {
        var l2, X, a2, e2, H = Zr(O, F9), Y = H && (l2 = (X = H.props) === null || X === void 0 ? void 0 : X.startIndex) !== null && l2 !== void 0 ? l2 : Z, r2 = H && (a2 = (e2 = H.props) === null || e2 === void 0 ? void 0 : e2.endIndex) !== null && a2 !== void 0 ? a2 : V, o2 = Y !== Z || r2 !== V, O2 = !Ae(S), S2 = O2 && !o2 ? _.updateId : _.updateId + 1;
        return R2(R2({
          updateId: S2
        }, y(R2(R2({
          props: B
        }, _), {}, {
          updateId: S2,
          dataStartIndex: Y,
          dataEndIndex: r2
        }), _)), {}, {
          prevChildren: O,
          dataStartIndex: Y,
          dataEndIndex: r2
        });
      }
      return null;
    }), L0(I, "renderActiveDot", function(B, _, M) {
      var S;
      return /* @__PURE__ */ q.isValidElement(B) ? S = /* @__PURE__ */ q.cloneElement(B, _) : te(B) ? S = B(_) : S = /* @__PURE__ */ f2.createElement(WM, _), /* @__PURE__ */ f2.createElement(n5, {
        className: "recharts-active-dot",
        key: M
      }, S);
    });
    var Q = /* @__PURE__ */ q.forwardRef(function(_, M) {
      return /* @__PURE__ */ f2.createElement(I, c9({}, _, {
        ref: M
      }));
    });
    return Q.displayName = I.displayName, Q;
  }, $E2 = uG({
    chartName: "LineChart",
    GraphicalChild: q9,
    axisComponents: [{
      axisType: "xAxis",
      AxisComp: ps
    }, {
      axisType: "yAxis",
      AxisComp: hs
    }],
    formatAxisMap: x$
  }), GE2 = uG({
    chartName: "BarChart",
    GraphicalChild: ra,
    defaultTooltipEventType: "axis",
    validateTooltipEventTypes: ["axis", "item"],
    axisComponents: [{
      axisType: "xAxis",
      AxisComp: ps
    }, {
      axisType: "yAxis",
      AxisComp: hs
    }],
    formatAxisMap: x$
  });
  const KE2 = { light: "", dark: ".dark" }, XE2 = q.createContext(null);
  function lG({
    id: e,
    className: t,
    children: r,
    config: n,
    ...i
  }) {
    const o = q.useId(), u = `chart-${e || o.replace(/:/g, "")}`;
    return /* @__PURE__ */ K.jsx(XE2.Provider, { value: { config: n }, children: /* @__PURE__ */ K.jsxs(
      "div",
      {
        "data-slot": "chart",
        "data-chart": u,
        className: T1(
          "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border [&_.recharts-polar-grid_[stroke='#ccc']]:stroke-border [&_.recharts-radial-bar-background-sector]:fill-muted [&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted [&_.recharts-reference-line_[stroke='#ccc']]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-dot[stroke='#fff']]:stroke-transparent [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-sector[stroke='#fff']]:stroke-transparent [&_.recharts-surface]:outline-hidden",
          t
        ),
        ...i,
        children: [
          /* @__PURE__ */ K.jsx(JE2, { id: u, config: n }),
          /* @__PURE__ */ K.jsx(Ds2, { children: r })
        ]
      }
    ) });
  }
  const JE2 = ({ id: e, config: t }) => {
    const r = Object.entries(t).filter(([, n]) => n.theme || n.color);
    return r.length ? /* @__PURE__ */ K.jsx(
      "style",
      {
        dangerouslySetInnerHTML: {
          __html: Object.entries(KE2).map(
            ([n, i]) => `
${i} [data-chart=${e}] {
${r.map(([o, u]) => {
              var f;
              const c = ((f = u.theme) == null ? void 0 : f[n]) || u.color;
              return c ? `  --color-${o}: ${c};` : null;
            }).join(`
`)}
}
`
          ).join(`
`)
        }
      }
    ) : null;
  }, em2 = (e) => ({ active: t, payload: r, label: n }) => !t || !r ? null : /* @__PURE__ */ K.jsx("div", { className: "bg-white rounded-md border-1 border-neutral-200 p-2 text-xs flex flex-col gap-4", children: r.map((i) => {
    var o;
    return /* @__PURE__ */ K.jsxs("div", { className: "flex flex-col items-start justify-start text-neutral-900", children: [
      /* @__PURE__ */ K.jsx("span", { className: "font-bold mb-1.5", children: e(n) }),
      /* @__PURE__ */ K.jsxs("div", { className: "flex flex-row items-center justify-start font-normal text-neutral-700", children: [
        /* @__PURE__ */ K.jsx("span", { className: "mr-2", children: ne.mostPopularBarChart.visits }),
        /* @__PURE__ */ K.jsx("span", { children: (o = i.value) == null ? void 0 : o.toLocaleString() })
      ] })
    ] }, i.dataKey);
  }) }), tm2 = (e) => (t) => {
    const { x: r, y: n, width: i, height: o, value: u, background: c } = t, f = u === e, d = u === 0, g = 4, h = d ? g : g + o, E = c.y + c.height, y = d ? E - g : n - g, I = f && e !== 0 ? "fill-purple-600" : "fill-neutral-300";
    return /* @__PURE__ */ K.jsx("rect", { x: r, y, width: i, height: h, rx: d ? 2 : 4, className: I });
  }, rm2 = (e) => ({ x: t, y: r, payload: n }) => {
    const i = e(n.value);
    return /* @__PURE__ */ K.jsx("g", { transform: `translate(${t},${r})`, children: /* @__PURE__ */ K.jsx("text", { x: 0, y: 0, dy: 8, textAnchor: "middle", className: "text-sm text-neutral-500", children: i }) });
  }, cG = ({
    xAxisKey: e,
    maxCount: t,
    xAxisTickInterval: r,
    data: n,
    xAxisTextHandler: i,
    tooltipTextHandler: o
  }) => /* @__PURE__ */ K.jsx(
    lG,
    {
      "aria-label": ne.mostPopularBarChart.ariaContainerLabel(e),
      className: "h-72 w-full",
      config: {},
      children: /* @__PURE__ */ K.jsxs(GE2, { accessibilityLayer: !0, data: n, margin: { top: 5, right: 0, left: 10, bottom: 0 }, barCategoryGap: "16%", children: [
        /* @__PURE__ */ K.jsx(cn, { content: em2(o), cursor: !1 }),
        /* @__PURE__ */ K.jsx(
          ps,
          {
            dataKey: e,
            tickLine: !1,
            tickMargin: 8,
            axisLine: !1,
            tick: rm2(i),
            interval: r
          }
        ),
        /* @__PURE__ */ K.jsx(hs, { domain: [0, t], hide: !0 }),
        /* @__PURE__ */ K.jsx(ra, { dataKey: "visits", shape: tm2(t) })
      ] })
    }
  ), AG = q.createContext(void 0), nm2 = ({ children: e, isLoading: t }) => /* @__PURE__ */ K.jsx(AG.Provider, { value: { isLoading: t }, children: e }), gA = () => {
    const e = q.useContext(AG);
    if (e === void 0)
      throw new Error("useFacilityDataLoading must be used within a FacilityDataLoadingProvider");
    return e;
  };
  function Li({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx("div", { "data-slot": "skeleton", className: T1("bg-accent animate-pulse rounded-md", e), ...t });
  }
  const im2 = () => /* @__PURE__ */ K.jsx(Li, { className: "h-85 w-full rounded-xl", "data-testid": "visit-trends-chart-skeleton" }), am2 = () => /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx(Li, { "data-testid": "visits-card-count-skeleton", className: "w-40 h-10 rounded-md" }),
    /* @__PURE__ */ K.jsx(Li, { "data-testid": "visits-card-percentage-skeleton", className: "w-20 h-5 rounded-md" })
  ] }), fG = () => /* @__PURE__ */ K.jsxs(
    "div",
    {
      className: "rounded-2xl border-1 border-neutral-300 p-6 gap-6 shadow-none",
      "data-testid": "popularity-chart-skeleton",
      children: [
        /* @__PURE__ */ K.jsx(Li, { className: "h-6 mb-3 w-full rounded-sm" }),
        /* @__PURE__ */ K.jsx(Li, { className: "h-6 mb-3 w-1/2 rounded-sm" }),
        /* @__PURE__ */ K.jsx(Li, { className: "h-4 mb-6 w-4/5 rounded-sm" }),
        /* @__PURE__ */ K.jsx(Li, { className: "h-72 w-full rounded-lg" })
      ]
    }
  ), CG = () => /* @__PURE__ */ K.jsxs("div", { className: "flex flex-row items-center gap-1", children: [
    /* @__PURE__ */ K.jsx("p", { children: ne.mostPopularDayCard.description() }),
    /* @__PURE__ */ K.jsx(
      U72,
      {
        trigger: /* @__PURE__ */ K.jsx(in2, { className: "stroke-current w-5 h-5" }),
        content: /* @__PURE__ */ K.jsx("p", { children: ne.mostPopularDayCard.tooltip })
      }
    )
  ] }), om2 = (e) => {
    let t = -1 / 0, r = [];
    for (const { day: n, visits: i } of e)
      i > t ? (t = i, r = [n]) : i === t && r.push(n);
    return { maxCount: t, daysWithMaxCount: r };
  }, sm2 = ({ data: e }) => {
    const { isLoading: t } = gA(), { maxCount: r, daysWithMaxCount: n } = q.useMemo(() => om2(e), [e]), i = q.useMemo(
      () => ne.mostPopularDayCard.title(r, n),
      [r, n]
    );
    return t ? /* @__PURE__ */ K.jsx(fG, {}) : /* @__PURE__ */ K.jsx(KS, { title: i, description: /* @__PURE__ */ K.jsx(CG, {}), children: /* @__PURE__ */ K.jsx(
      cG,
      {
        xAxisKey: "day",
        maxCount: r,
        xAxisTickInterval: 0,
        data: e,
        xAxisTextHandler: (o) => o.slice(0, 1).toUpperCase(),
        tooltipTextHandler: (o) => o
      }
    ) });
  }, um2 = (e) => {
    let t = -1 / 0, r = [];
    for (const { hour: n, visits: i } of e)
      i > t ? (t = i, r = [n]) : i === t && r.push(n);
    return { maxCount: t, hoursWithMaxCount: r };
  }, lm2 = ({ data: e }) => {
    const { isLoading: t } = gA(), { maxCount: r, hoursWithMaxCount: n } = q.useMemo(() => um2(e), [e]), i = q.useMemo(
      () => ne.mostPopularHourCard.title(r, n),
      [r, n]
    ), o = (u) => `${u}:00`;
    return t ? /* @__PURE__ */ K.jsx(fG, {}) : /* @__PURE__ */ K.jsx(KS, { title: i, description: /* @__PURE__ */ K.jsx(CG, {}), children: /* @__PURE__ */ K.jsx(
      cG,
      {
        xAxisKey: "hour",
        maxCount: r,
        xAxisTickInterval: 5,
        data: e,
        xAxisTextHandler: o,
        tooltipTextHandler: o
      }
    ) });
  }, cm2 = (e) => e === 0 || e === null ? {
    icon: null,
    textClass: "text-neutral-500",
    percentage: 0
  } : e > 0 ? {
    icon: /* @__PURE__ */ K.jsx(G42, { className: "w-5 h-5" }),
    textClass: "text-success-600",
    percentage: e
  } : {
    icon: /* @__PURE__ */ K.jsx(Y42, { className: "w-5 h-5" }),
    textClass: "text-destructive-600",
    percentage: Math.abs(e)
  }, Am2 = ({ percentChange: e }) => {
    const { icon: t, textClass: r, percentage: n } = cm2(e);
    return /* @__PURE__ */ K.jsxs("div", { className: SS("flex flex-row items-end justify-start", r), children: [
      t,
      /* @__PURE__ */ K.jsxs("span", { className: "text-sm font-bold", "data-testid": "visits-count-percentage", children: [
        n,
        "% ",
        ne.trendIndicator.yoy
      ] })
    ] });
  }, _V = ({ title: e, description: t, visitsCount: r, percentChangeYoY: n }) => {
    const { isLoading: i } = gA();
    return /* @__PURE__ */ K.jsx(KS, { title: e, description: t, children: /* @__PURE__ */ K.jsx("div", { className: "flex flex-row items-end justify-start gap-2", children: i ? /* @__PURE__ */ K.jsx(am2, {}) : /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
      /* @__PURE__ */ K.jsx("span", { className: "text-4xl font-normal text-neutral-700", "data-testid": "visits-count-text", children: ne.visitsCount.title(r) }),
      /* @__PURE__ */ K.jsx(Am2, { percentChange: n })
    ] }) }) });
  };
  function fm2(e) {
    const t = q.useRef({ value: e, previous: e });
    return q.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
  }
  var $h = "Switch", [Cm2, SQ2] = G6($h), [dm2, gm2] = Cm2($h), dG = q.forwardRef(
    (e, t) => {
      const {
        __scopeSwitch: r,
        name: n,
        checked: i,
        defaultChecked: o,
        required: u,
        disabled: c,
        value: f = "on",
        onCheckedChange: d,
        form: g,
        ...h
      } = e, [E, y] = q.useState(null), I = H5(t, (S) => y(S)), Q = q.useRef(!1), B = E ? g || !!E.closest("form") : !0, [_, M] = Yi({
        prop: i,
        defaultProp: o ?? !1,
        onChange: d,
        caller: $h
      });
      return /* @__PURE__ */ K.jsxs(dm2, { scope: r, checked: _, disabled: c, children: [
        /* @__PURE__ */ K.jsx(
          Yt.button,
          {
            type: "button",
            role: "switch",
            "aria-checked": _,
            "aria-required": u,
            "data-state": vG(_),
            "data-disabled": c ? "" : void 0,
            disabled: c,
            value: f,
            ...h,
            ref: I,
            onClick: $0(e.onClick, (S) => {
              M((O) => !O), B && (Q.current = S.isPropagationStopped(), Q.current || S.stopPropagation());
            })
          }
        ),
        B && /* @__PURE__ */ K.jsx(
          hG,
          {
            control: E,
            bubbles: !Q.current,
            name: n,
            value: f,
            checked: _,
            required: u,
            disabled: c,
            form: g,
            style: { transform: "translateX(-100%)" }
          }
        )
      ] });
    }
  );
  dG.displayName = $h;
  var gG = "SwitchThumb", pG = q.forwardRef(
    (e, t) => {
      const { __scopeSwitch: r, ...n } = e, i = gm2(gG, r);
      return /* @__PURE__ */ K.jsx(
        Yt.span,
        {
          "data-state": vG(i.checked),
          "data-disabled": i.disabled ? "" : void 0,
          ...n,
          ref: t
        }
      );
    }
  );
  pG.displayName = gG;
  var pm2 = "SwitchBubbleInput", hG = q.forwardRef(
    ({
      __scopeSwitch: e,
      control: t,
      checked: r,
      bubbles: n = !0,
      ...i
    }, o) => {
      const u = q.useRef(null), c = H5(u, o), f = fm2(r), d = DU(t);
      return q.useEffect(() => {
        const g = u.current;
        if (!g) return;
        const h = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(
          h,
          "checked"
        ).set;
        if (f !== r && y) {
          const I = new Event("click", { bubbles: n });
          y.call(g, r), g.dispatchEvent(I);
        }
      }, [f, r, n]), /* @__PURE__ */ K.jsx(
        "input",
        {
          type: "checkbox",
          "aria-hidden": !0,
          defaultChecked: r,
          ...i,
          tabIndex: -1,
          ref: c,
          style: {
            ...i.style,
            ...d,
            position: "absolute",
            pointerEvents: "none",
            opacity: 0,
            margin: 0
          }
        }
      );
    }
  );
  hG.displayName = pm2;
  function vG(e) {
    return e ? "checked" : "unchecked";
  }
  var hm2 = dG, vm2 = pG;
  function Em2({ className: e, ...t }) {
    return /* @__PURE__ */ K.jsx(
      hm2,
      {
        "data-slot": "switch",
        className: T1(
          "peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-input focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50",
          e
        ),
        ...t,
        children: /* @__PURE__ */ K.jsx(
          vm2,
          {
            "data-slot": "switch-thumb",
            className: T1(
              "bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0"
            )
          }
        )
      }
    );
  }
  const mm2 = ({ id: e, checked: t, onCheckedChange: r, disabled: n = !1 }) => /* @__PURE__ */ K.jsx(
    Em2,
    {
      id: e,
      checked: t,
      disabled: n,
      onCheckedChange: r,
      className: "bg-white h-6 w-11 p-0.5 data-[state=checked]:bg-primary-600 [&>span]:data-[state=unchecked]:bg-white [&>span]:h-5 [&>span]:w-5"
    }
  );
  var EG = "Toggle", mG = q.forwardRef((e, t) => {
    const { pressed: r, defaultPressed: n, onPressedChange: i, ...o } = e, [u, c] = Yi({
      prop: r,
      onChange: i,
      defaultProp: n ?? !1,
      caller: EG
    });
    return /* @__PURE__ */ K.jsx(
      Yt.button,
      {
        type: "button",
        "aria-pressed": u,
        "data-state": u ? "on" : "off",
        "data-disabled": e.disabled ? "" : void 0,
        ...o,
        ref: t,
        onClick: $0(e.onClick, () => {
          e.disabled || c(!u);
        })
      }
    );
  });
  mG.displayName = EG;
  var r7 = "ToggleGroup", [yG, MQ2] = G6(r7, [
    Ah
  ]), IG = Ah(), n_ = f2.forwardRef((e, t) => {
    const { type: r, ...n } = e;
    if (r === "single") {
      const i = n;
      return /* @__PURE__ */ K.jsx(ym2, { ...i, ref: t });
    }
    if (r === "multiple") {
      const i = n;
      return /* @__PURE__ */ K.jsx(Im2, { ...i, ref: t });
    }
    throw new Error(`Missing prop \`type\` expected on \`${r7}\``);
  });
  n_.displayName = r7;
  var [BG, QG] = yG(r7), ym2 = f2.forwardRef((e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: i = () => {
      },
      ...o
    } = e, [u, c] = Yi({
      prop: r,
      defaultProp: n ?? "",
      onChange: i,
      caller: r7
    });
    return /* @__PURE__ */ K.jsx(
      BG,
      {
        scope: e.__scopeToggleGroup,
        type: "single",
        value: f2.useMemo(() => u ? [u] : [], [u]),
        onItemActivate: c,
        onItemDeactivate: f2.useCallback(() => c(""), [c]),
        children: /* @__PURE__ */ K.jsx(xG, { ...o, ref: t })
      }
    );
  }), Im2 = f2.forwardRef((e, t) => {
    const {
      value: r,
      defaultValue: n,
      onValueChange: i = () => {
      },
      ...o
    } = e, [u, c] = Yi({
      prop: r,
      defaultProp: n ?? [],
      onChange: i,
      caller: r7
    }), f = f2.useCallback(
      (g) => c((h = []) => [...h, g]),
      [c]
    ), d = f2.useCallback(
      (g) => c((h = []) => h.filter((E) => E !== g)),
      [c]
    );
    return /* @__PURE__ */ K.jsx(
      BG,
      {
        scope: e.__scopeToggleGroup,
        type: "multiple",
        value: u,
        onItemActivate: f,
        onItemDeactivate: d,
        children: /* @__PURE__ */ K.jsx(xG, { ...o, ref: t })
      }
    );
  });
  n_.displayName = r7;
  var [Bm2, Qm2] = yG(r7), xG = f2.forwardRef(
    (e, t) => {
      const {
        __scopeToggleGroup: r,
        disabled: n = !1,
        rovingFocus: i = !0,
        orientation: o,
        dir: u,
        loop: c = !0,
        ...f
      } = e, d = IG(r), g = _S(u), h = { role: "group", dir: g, ...f };
      return /* @__PURE__ */ K.jsx(Bm2, { scope: r, rovingFocus: i, disabled: n, children: i ? /* @__PURE__ */ K.jsx(
        XU,
        {
          asChild: !0,
          ...d,
          orientation: o,
          dir: g,
          loop: c,
          children: /* @__PURE__ */ K.jsx(Yt.div, { ...h, ref: t })
        }
      ) : /* @__PURE__ */ K.jsx(Yt.div, { ...h, ref: t }) });
    }
  ), Yp = "ToggleGroupItem", bG = f2.forwardRef(
    (e, t) => {
      const r = QG(Yp, e.__scopeToggleGroup), n = Qm2(Yp, e.__scopeToggleGroup), i = IG(e.__scopeToggleGroup), o = r.value.includes(e.value), u = n.disabled || e.disabled, c = { ...e, pressed: o, disabled: u }, f = f2.useRef(null);
      return n.rovingFocus ? /* @__PURE__ */ K.jsx(
        JU,
        {
          asChild: !0,
          ...i,
          focusable: !u,
          active: o,
          ref: f,
          children: /* @__PURE__ */ K.jsx(OV, { ...c, ref: t })
        }
      ) : /* @__PURE__ */ K.jsx(OV, { ...c, ref: t });
    }
  );
  bG.displayName = Yp;
  var OV = f2.forwardRef(
    (e, t) => {
      const { __scopeToggleGroup: r, value: n, ...i } = e, o = QG(Yp, r), u = { role: "radio", "aria-checked": e.pressed, "aria-pressed": void 0 }, c = o.type === "single" ? u : void 0;
      return /* @__PURE__ */ K.jsx(
        mG,
        {
          ...c,
          ...i,
          ref: t,
          onPressedChange: (f) => {
            f ? o.onItemActivate(n) : o.onItemDeactivate(n);
          }
        }
      );
    }
  ), xm2 = n_, bm2 = bG;
  const TV = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, DV = pe, wm2 = (e, t) => (r) => {
    var n;
    if ((t == null ? void 0 : t.variants) == null) return DV(e, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
    const { variants: i, defaultVariants: o } = t, u = Object.keys(i).map((d) => {
      const g = r == null ? void 0 : r[d], h = o == null ? void 0 : o[d];
      if (g === null) return null;
      const E = TV(g) || TV(h);
      return i[d][E];
    }), c = r && Object.entries(r).reduce((d, g) => {
      let [h, E] = g;
      return E === void 0 || (d[h] = E), d;
    }, {}), f = t == null || (n = t.compoundVariants) === null || n === void 0 ? void 0 : n.reduce((d, g) => {
      let { class: h, className: E, ...y } = g;
      return Object.entries(y).every((I) => {
        let [Q, B] = I;
        return Array.isArray(B) ? B.includes({
          ...o,
          ...c
        }[Q]) : {
          ...o,
          ...c
        }[Q] === B;
      }) ? [
        ...d,
        h,
        E
      ] : d;
    }, []);
    return DV(e, u, f, r == null ? void 0 : r.class, r == null ? void 0 : r.className);
  }, Sm2 = wm2(
    "inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium hover:bg-muted hover:text-muted-foreground disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-accent data-[state=on]:text-accent-foreground [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 [&_svg]:shrink-0 focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none transition-[color,box-shadow] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive whitespace-nowrap",
    {
      variants: {
        variant: {
          default: "bg-transparent",
          outline: "border border-input bg-transparent shadow-xs hover:bg-accent hover:text-accent-foreground"
        },
        size: {
          default: "h-9 px-2 min-w-9",
          sm: "h-8 px-1.5 min-w-8",
          lg: "h-10 px-2.5 min-w-10"
        }
      },
      defaultVariants: {
        variant: "default",
        size: "default"
      }
    }
  ), wG = q.createContext({
    size: "default",
    variant: "default"
  });
  function Mm2({
    className: e,
    variant: t,
    size: r,
    children: n,
    ...i
  }) {
    return /* @__PURE__ */ K.jsx(
      xm2,
      {
        "data-slot": "toggle-group",
        "data-variant": t,
        "data-size": r,
        className: T1(
          "group/toggle-group flex w-fit items-center rounded-md data-[variant=outline]:shadow-xs",
          e
        ),
        ...i,
        children: /* @__PURE__ */ K.jsx(wG.Provider, { value: { variant: t, size: r }, children: n })
      }
    );
  }
  function _m2({
    className: e,
    children: t,
    variant: r,
    size: n,
    ...i
  }) {
    const o = q.useContext(wG);
    return /* @__PURE__ */ K.jsx(
      bm2,
      {
        "data-slot": "toggle-group-item",
        "data-variant": o.variant || r,
        "data-size": o.size || n,
        className: T1(
          Sm2({
            variant: o.variant || r,
            size: o.size || n
          }),
          "min-w-0 flex-1 shrink-0 rounded-none shadow-none first:rounded-l-md last:rounded-r-md focus:z-10 focus-visible:z-10 data-[variant=outline]:border-l-0 data-[variant=outline]:first:border-l",
          e
        ),
        ...i,
        children: t
      }
    );
  }
  const Om2 = ({ value: e, items: t, onValueChange: r, disabled: n = !1 }) => /* @__PURE__ */ K.jsx(
    Mm2,
    {
      variant: "outline",
      className: "border-neutral-300",
      type: "single",
      value: e,
      onValueChange: r,
      disabled: n,
      children: t.map(({ label: i, value: o }) => /* @__PURE__ */ K.jsx(
        _m2,
        {
          className: "text-sm font-normal px-4 py-2.5 data-[state=on]:border-primary-600 data-[state=on]:bg-white data-[state=on]:border-2 data-[variant=outline]:data-[state=on]:border-l-2",
          value: o,
          "aria-label": i,
          children: i
        },
        o
      ))
    }
  ), SG = 6048e5, Tm2 = 864e5, Dm2 = 6e4, Lm2 = 36e5, km2 = 1e3, LV = Symbol.for("constructDateFrom");
  function d5(e, t) {
    return typeof e == "function" ? e(t) : e && typeof e == "object" && LV in e ? e[LV](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
  }
  function Dt(e, t) {
    return d5(t || e, e);
  }
  function i_(e, t, r) {
    const n = Dt(e, r == null ? void 0 : r.in);
    return isNaN(t) ? d5((r == null ? void 0 : r.in) || e, NaN) : (t && n.setDate(n.getDate() + t), n);
  }
  function Rm2(e, t, r) {
    const n = Dt(e, r == null ? void 0 : r.in);
    if (isNaN(t)) return d5(e, NaN);
    const i = n.getDate(), o = d5(e, n.getTime());
    o.setMonth(n.getMonth() + t + 1, 0);
    const u = o.getDate();
    return i >= u ? o : (n.setFullYear(
      o.getFullYear(),
      o.getMonth(),
      i
    ), n);
  }
  let Pm2 = {};
  function vs() {
    return Pm2;
  }
  function $6(e, t) {
    var c, f, d, g;
    const r = vs(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.weekStartsOn) ?? r.weekStartsOn ?? ((g = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : g.weekStartsOn) ?? 0, i = Dt(e, t == null ? void 0 : t.in), o = i.getDay(), u = (o < n ? 7 : 0) + o - n;
    return i.setDate(i.getDate() - u), i.setHours(0, 0, 0, 0), i;
  }
  function K9(e, t) {
    return $6(e, { ...t, weekStartsOn: 1 });
  }
  function MG(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = d5(r, 0);
    i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
    const o = K9(i), u = d5(r, 0);
    u.setFullYear(n, 0, 4), u.setHours(0, 0, 0, 0);
    const c = K9(u);
    return r.getTime() >= o.getTime() ? n + 1 : r.getTime() >= c.getTime() ? n : n - 1;
  }
  function $p(e) {
    const t = Dt(e), r = new Date(
      Date.UTC(
        t.getFullYear(),
        t.getMonth(),
        t.getDate(),
        t.getHours(),
        t.getMinutes(),
        t.getSeconds(),
        t.getMilliseconds()
      )
    );
    return r.setUTCFullYear(t.getFullYear()), +e - +r;
  }
  function Fm2(e, ...t) {
    const r = d5.bind(
      null,
      t.find((n) => typeof n == "object")
    );
    return t.map(r);
  }
  function kV(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in);
    return r.setHours(0, 0, 0, 0), r;
  }
  function Nm2(e, t, r) {
    const [n, i] = Fm2(
      r == null ? void 0 : r.in,
      e,
      t
    ), o = kV(n), u = kV(i), c = +o - $p(o), f = +u - $p(u);
    return Math.round((c - f) / Tm2);
  }
  function Hm2(e, t) {
    const r = MG(e, t), n = d5(e, 0);
    return n.setFullYear(r, 0, 4), n.setHours(0, 0, 0, 0), K9(n);
  }
  function jm2(e, t, r) {
    return Rm2(e, t * 12, r);
  }
  function Vm2(e) {
    return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
  }
  function Zm2(e) {
    return !(!Vm2(e) && typeof e != "number" || isNaN(+Dt(e)));
  }
  function zm2(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in);
    return r.setFullYear(r.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
  }
  const Um2 = {
    lessThanXSeconds: {
      one: "less than a second",
      other: "less than {{count}} seconds"
    },
    xSeconds: {
      one: "1 second",
      other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
      one: "less than a minute",
      other: "less than {{count}} minutes"
    },
    xMinutes: {
      one: "1 minute",
      other: "{{count}} minutes"
    },
    aboutXHours: {
      one: "about 1 hour",
      other: "about {{count}} hours"
    },
    xHours: {
      one: "1 hour",
      other: "{{count}} hours"
    },
    xDays: {
      one: "1 day",
      other: "{{count}} days"
    },
    aboutXWeeks: {
      one: "about 1 week",
      other: "about {{count}} weeks"
    },
    xWeeks: {
      one: "1 week",
      other: "{{count}} weeks"
    },
    aboutXMonths: {
      one: "about 1 month",
      other: "about {{count}} months"
    },
    xMonths: {
      one: "1 month",
      other: "{{count}} months"
    },
    aboutXYears: {
      one: "about 1 year",
      other: "about {{count}} years"
    },
    xYears: {
      one: "1 year",
      other: "{{count}} years"
    },
    overXYears: {
      one: "over 1 year",
      other: "over {{count}} years"
    },
    almostXYears: {
      one: "almost 1 year",
      other: "almost {{count}} years"
    }
  }, qm2 = (e, t, r) => {
    let n;
    const i = Um2[e];
    return typeof i == "string" ? n = i : t === 1 ? n = i.one : n = i.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
  };
  function Yx(e) {
    return (t = {}) => {
      const r = t.width ? String(t.width) : e.defaultWidth;
      return e.formats[r] || e.formats[e.defaultWidth];
    };
  }
  const Wm2 = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
  }, Ym2 = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
  }, $m2 = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
  }, Gm2 = {
    date: Yx({
      formats: Wm2,
      defaultWidth: "full"
    }),
    time: Yx({
      formats: Ym2,
      defaultWidth: "full"
    }),
    dateTime: Yx({
      formats: $m2,
      defaultWidth: "full"
    })
  }, Km2 = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
  }, Xm2 = (e, t, r, n) => Km2[e];
  function jl(e) {
    return (t, r) => {
      const n = r != null && r.context ? String(r.context) : "standalone";
      let i;
      if (n === "formatting" && e.formattingValues) {
        const u = e.defaultFormattingWidth || e.defaultWidth, c = r != null && r.width ? String(r.width) : u;
        i = e.formattingValues[c] || e.formattingValues[u];
      } else {
        const u = e.defaultWidth, c = r != null && r.width ? String(r.width) : e.defaultWidth;
        i = e.values[c] || e.values[u];
      }
      const o = e.argumentCallback ? e.argumentCallback(t) : t;
      return i[o];
    };
  }
  const Jm2 = {
    narrow: ["B", "A"],
    abbreviated: ["BC", "AD"],
    wide: ["Before Christ", "Anno Domini"]
  }, ey2 = {
    narrow: ["1", "2", "3", "4"],
    abbreviated: ["Q1", "Q2", "Q3", "Q4"],
    wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
  }, ty2 = {
    narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    abbreviated: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    wide: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ]
  }, ry2 = {
    narrow: ["S", "M", "T", "W", "T", "F", "S"],
    short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    wide: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ]
  }, ny2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "morning",
      afternoon: "afternoon",
      evening: "evening",
      night: "night"
    }
  }, iy2 = {
    narrow: {
      am: "a",
      pm: "p",
      midnight: "mi",
      noon: "n",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    abbreviated: {
      am: "AM",
      pm: "PM",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    },
    wide: {
      am: "a.m.",
      pm: "p.m.",
      midnight: "midnight",
      noon: "noon",
      morning: "in the morning",
      afternoon: "in the afternoon",
      evening: "in the evening",
      night: "at night"
    }
  }, ay2 = (e, t) => {
    const r = Number(e), n = r % 100;
    if (n > 20 || n < 10)
      switch (n % 10) {
        case 1:
          return r + "st";
        case 2:
          return r + "nd";
        case 3:
          return r + "rd";
      }
    return r + "th";
  }, oy2 = {
    ordinalNumber: ay2,
    era: jl({
      values: Jm2,
      defaultWidth: "wide"
    }),
    quarter: jl({
      values: ey2,
      defaultWidth: "wide",
      argumentCallback: (e) => e - 1
    }),
    month: jl({
      values: ty2,
      defaultWidth: "wide"
    }),
    day: jl({
      values: ry2,
      defaultWidth: "wide"
    }),
    dayPeriod: jl({
      values: ny2,
      defaultWidth: "wide",
      formattingValues: iy2,
      defaultFormattingWidth: "wide"
    })
  };
  function Vl(e) {
    return (t, r = {}) => {
      const n = r.width, i = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
      if (!o)
        return null;
      const u = o[0], c = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], f = Array.isArray(c) ? uy2(c, (h) => h.test(u)) : (
        // [TODO] -- I challenge you to fix the type
        sy2(c, (h) => h.test(u))
      );
      let d;
      d = e.valueCallback ? e.valueCallback(f) : f, d = r.valueCallback ? (
        // [TODO] -- I challenge you to fix the type
        r.valueCallback(d)
      ) : d;
      const g = t.slice(u.length);
      return { value: d, rest: g };
    };
  }
  function sy2(e, t) {
    for (const r in e)
      if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
        return r;
  }
  function uy2(e, t) {
    for (let r = 0; r < e.length; r++)
      if (t(e[r]))
        return r;
  }
  function ly2(e) {
    return (t, r = {}) => {
      const n = t.match(e.matchPattern);
      if (!n) return null;
      const i = n[0], o = t.match(e.parsePattern);
      if (!o) return null;
      let u = e.valueCallback ? e.valueCallback(o[0]) : o[0];
      u = r.valueCallback ? r.valueCallback(u) : u;
      const c = t.slice(i.length);
      return { value: u, rest: c };
    };
  }
  const cy2 = /^(\d+)(th|st|nd|rd)?/i, Ay2 = /\d+/i, fy2 = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
  }, Cy2 = {
    any: [/^b/i, /^(a|c)/i]
  }, dy2 = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
  }, gy2 = {
    any: [/1/i, /2/i, /3/i, /4/i]
  }, py2 = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
  }, hy2 = {
    narrow: [
      /^j/i,
      /^f/i,
      /^m/i,
      /^a/i,
      /^m/i,
      /^j/i,
      /^j/i,
      /^a/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i
    ],
    any: [
      /^ja/i,
      /^f/i,
      /^mar/i,
      /^ap/i,
      /^may/i,
      /^jun/i,
      /^jul/i,
      /^au/i,
      /^s/i,
      /^o/i,
      /^n/i,
      /^d/i
    ]
  }, vy2 = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
  }, Ey2 = {
    narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
    any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
  }, my2 = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
  }, yy2 = {
    any: {
      am: /^a/i,
      pm: /^p/i,
      midnight: /^mi/i,
      noon: /^no/i,
      morning: /morning/i,
      afternoon: /afternoon/i,
      evening: /evening/i,
      night: /night/i
    }
  }, Iy2 = {
    ordinalNumber: ly2({
      matchPattern: cy2,
      parsePattern: Ay2,
      valueCallback: (e) => parseInt(e, 10)
    }),
    era: Vl({
      matchPatterns: fy2,
      defaultMatchWidth: "wide",
      parsePatterns: Cy2,
      defaultParseWidth: "any"
    }),
    quarter: Vl({
      matchPatterns: dy2,
      defaultMatchWidth: "wide",
      parsePatterns: gy2,
      defaultParseWidth: "any",
      valueCallback: (e) => e + 1
    }),
    month: Vl({
      matchPatterns: py2,
      defaultMatchWidth: "wide",
      parsePatterns: hy2,
      defaultParseWidth: "any"
    }),
    day: Vl({
      matchPatterns: vy2,
      defaultMatchWidth: "wide",
      parsePatterns: Ey2,
      defaultParseWidth: "any"
    }),
    dayPeriod: Vl({
      matchPatterns: my2,
      defaultMatchWidth: "any",
      parsePatterns: yy2,
      defaultParseWidth: "any"
    })
  }, _G = {
    code: "en-US",
    formatDistance: qm2,
    formatLong: Gm2,
    formatRelative: Xm2,
    localize: oy2,
    match: Iy2,
    options: {
      weekStartsOn: 0,
      firstWeekContainsDate: 1
    }
  };
  function By2(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in);
    return Nm2(r, zm2(r)) + 1;
  }
  function OG(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in), n = +K9(r) - +Hm2(r);
    return Math.round(n / SG) + 1;
  }
  function a_(e, t) {
    var g, h, E, y;
    const r = Dt(e, t == null ? void 0 : t.in), n = r.getFullYear(), i = vs(), o = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((h = (g = t == null ? void 0 : t.locale) == null ? void 0 : g.options) == null ? void 0 : h.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((y = (E = i.locale) == null ? void 0 : E.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, u = d5((t == null ? void 0 : t.in) || e, 0);
    u.setFullYear(n + 1, 0, o), u.setHours(0, 0, 0, 0);
    const c = $6(u, t), f = d5((t == null ? void 0 : t.in) || e, 0);
    f.setFullYear(n, 0, o), f.setHours(0, 0, 0, 0);
    const d = $6(f, t);
    return +r >= +c ? n + 1 : +r >= +d ? n : n - 1;
  }
  function Qy2(e, t) {
    var c, f, d, g;
    const r = vs(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((f = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((g = (d = r.locale) == null ? void 0 : d.options) == null ? void 0 : g.firstWeekContainsDate) ?? 1, i = a_(e, t), o = d5((t == null ? void 0 : t.in) || e, 0);
    return o.setFullYear(i, 0, n), o.setHours(0, 0, 0, 0), $6(o, t);
  }
  function TG(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in), n = +$6(r, t) - +Qy2(r, t);
    return Math.round(n / SG) + 1;
  }
  function Je(e, t) {
    const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
    return r + n;
  }
  const _6 = {
    // Year
    y(e, t) {
      const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
      return Je(t === "yy" ? n % 100 : n, t.length);
    },
    // Month
    M(e, t) {
      const r = e.getMonth();
      return t === "M" ? String(r + 1) : Je(r + 1, 2);
    },
    // Day of the month
    d(e, t) {
      return Je(e.getDate(), t.length);
    },
    // AM or PM
    a(e, t) {
      const r = e.getHours() / 12 >= 1 ? "pm" : "am";
      switch (t) {
        case "a":
        case "aa":
          return r.toUpperCase();
        case "aaa":
          return r;
        case "aaaaa":
          return r[0];
        case "aaaa":
        default:
          return r === "am" ? "a.m." : "p.m.";
      }
    },
    // Hour [1-12]
    h(e, t) {
      return Je(e.getHours() % 12 || 12, t.length);
    },
    // Hour [0-23]
    H(e, t) {
      return Je(e.getHours(), t.length);
    },
    // Minute
    m(e, t) {
      return Je(e.getMinutes(), t.length);
    },
    // Second
    s(e, t) {
      return Je(e.getSeconds(), t.length);
    },
    // Fraction of second
    S(e, t) {
      const r = t.length, n = e.getMilliseconds(), i = Math.trunc(
        n * Math.pow(10, r - 3)
      );
      return Je(i, t.length);
    }
  }, e9 = {
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }, RV = {
    // Era
    G: function(e, t, r) {
      const n = e.getFullYear() > 0 ? 1 : 0;
      switch (t) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return r.era(n, { width: "abbreviated" });
        // A, B
        case "GGGGG":
          return r.era(n, { width: "narrow" });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return r.era(n, { width: "wide" });
      }
    },
    // Year
    y: function(e, t, r) {
      if (t === "yo") {
        const n = e.getFullYear(), i = n > 0 ? n : 1 - n;
        return r.ordinalNumber(i, { unit: "year" });
      }
      return _6.y(e, t);
    },
    // Local week-numbering year
    Y: function(e, t, r, n) {
      const i = a_(e, n), o = i > 0 ? i : 1 - i;
      if (t === "YY") {
        const u = o % 100;
        return Je(u, 2);
      }
      return t === "Yo" ? r.ordinalNumber(o, { unit: "year" }) : Je(o, t.length);
    },
    // ISO week-numbering year
    R: function(e, t) {
      const r = MG(e);
      return Je(r, t.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(e, t) {
      const r = e.getFullYear();
      return Je(r, t.length);
    },
    // Quarter
    Q: function(e, t, r) {
      const n = Math.ceil((e.getMonth() + 1) / 3);
      switch (t) {
        // 1, 2, 3, 4
        case "Q":
          return String(n);
        // 01, 02, 03, 04
        case "QQ":
          return Je(n, 2);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return r.ordinalNumber(n, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return r.quarter(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return r.quarter(n, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return r.quarter(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone quarter
    q: function(e, t, r) {
      const n = Math.ceil((e.getMonth() + 1) / 3);
      switch (t) {
        // 1, 2, 3, 4
        case "q":
          return String(n);
        // 01, 02, 03, 04
        case "qq":
          return Je(n, 2);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return r.ordinalNumber(n, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return r.quarter(n, {
            width: "abbreviated",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return r.quarter(n, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return r.quarter(n, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // Month
    M: function(e, t, r) {
      const n = e.getMonth();
      switch (t) {
        case "M":
        case "MM":
          return _6.M(e, t);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return r.ordinalNumber(n + 1, { unit: "month" });
        // Jan, Feb, ..., Dec
        case "MMM":
          return r.month(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // J, F, ..., D
        case "MMMMM":
          return r.month(n, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return r.month(n, { width: "wide", context: "formatting" });
      }
    },
    // Stand-alone month
    L: function(e, t, r) {
      const n = e.getMonth();
      switch (t) {
        // 1, 2, ..., 12
        case "L":
          return String(n + 1);
        // 01, 02, ..., 12
        case "LL":
          return Je(n + 1, 2);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return r.ordinalNumber(n + 1, { unit: "month" });
        // Jan, Feb, ..., Dec
        case "LLL":
          return r.month(n, {
            width: "abbreviated",
            context: "standalone"
          });
        // J, F, ..., D
        case "LLLLL":
          return r.month(n, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return r.month(n, { width: "wide", context: "standalone" });
      }
    },
    // Local week of year
    w: function(e, t, r, n) {
      const i = TG(e, n);
      return t === "wo" ? r.ordinalNumber(i, { unit: "week" }) : Je(i, t.length);
    },
    // ISO week of year
    I: function(e, t, r) {
      const n = OG(e);
      return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : Je(n, t.length);
    },
    // Day of the month
    d: function(e, t, r) {
      return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : _6.d(e, t);
    },
    // Day of year
    D: function(e, t, r) {
      const n = By2(e);
      return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : Je(n, t.length);
    },
    // Day of week
    E: function(e, t, r) {
      const n = e.getDay();
      switch (t) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return r.day(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "EEEEE":
          return r.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return r.day(n, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "EEEE":
        default:
          return r.day(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Local day of week
    e: function(e, t, r, n) {
      const i = e.getDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        // Numerical value (Nth day of week with current locale or weekStartsOn)
        case "e":
          return String(o);
        // Padded numerical value
        case "ee":
          return Je(o, 2);
        // 1st, 2nd, ..., 7th
        case "eo":
          return r.ordinalNumber(o, { unit: "day" });
        case "eee":
          return r.day(i, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "eeeee":
          return r.day(i, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return r.day(i, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "eeee":
        default:
          return r.day(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Stand-alone local day of week
    c: function(e, t, r, n) {
      const i = e.getDay(), o = (i - n.weekStartsOn + 8) % 7 || 7;
      switch (t) {
        // Numerical value (same as in `e`)
        case "c":
          return String(o);
        // Padded numerical value
        case "cc":
          return Je(o, t.length);
        // 1st, 2nd, ..., 7th
        case "co":
          return r.ordinalNumber(o, { unit: "day" });
        case "ccc":
          return r.day(i, {
            width: "abbreviated",
            context: "standalone"
          });
        // T
        case "ccccc":
          return r.day(i, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return r.day(i, {
            width: "short",
            context: "standalone"
          });
        // Tuesday
        case "cccc":
        default:
          return r.day(i, {
            width: "wide",
            context: "standalone"
          });
      }
    },
    // ISO day of week
    i: function(e, t, r) {
      const n = e.getDay(), i = n === 0 ? 7 : n;
      switch (t) {
        // 2
        case "i":
          return String(i);
        // 02
        case "ii":
          return Je(i, t.length);
        // 2nd
        case "io":
          return r.ordinalNumber(i, { unit: "day" });
        // Tue
        case "iii":
          return r.day(n, {
            width: "abbreviated",
            context: "formatting"
          });
        // T
        case "iiiii":
          return r.day(n, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "iiiiii":
          return r.day(n, {
            width: "short",
            context: "formatting"
          });
        // Tuesday
        case "iiii":
        default:
          return r.day(n, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM or PM
    a: function(e, t, r) {
      const i = e.getHours() / 12 >= 1 ? "pm" : "am";
      switch (t) {
        case "a":
        case "aa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "aaa":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "aaaaa":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // AM, PM, midnight, noon
    b: function(e, t, r) {
      const n = e.getHours();
      let i;
      switch (n === 12 ? i = e9.noon : n === 0 ? i = e9.midnight : i = n / 12 >= 1 ? "pm" : "am", t) {
        case "b":
        case "bb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "bbb":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          }).toLowerCase();
        case "bbbbb":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(e, t, r) {
      const n = e.getHours();
      let i;
      switch (n >= 17 ? i = e9.evening : n >= 12 ? i = e9.afternoon : n >= 4 ? i = e9.morning : i = e9.night, t) {
        case "B":
        case "BB":
        case "BBB":
          return r.dayPeriod(i, {
            width: "abbreviated",
            context: "formatting"
          });
        case "BBBBB":
          return r.dayPeriod(i, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return r.dayPeriod(i, {
            width: "wide",
            context: "formatting"
          });
      }
    },
    // Hour [1-12]
    h: function(e, t, r) {
      if (t === "ho") {
        let n = e.getHours() % 12;
        return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
      }
      return _6.h(e, t);
    },
    // Hour [0-23]
    H: function(e, t, r) {
      return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : _6.H(e, t);
    },
    // Hour [0-11]
    K: function(e, t, r) {
      const n = e.getHours() % 12;
      return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : Je(n, t.length);
    },
    // Hour [1-24]
    k: function(e, t, r) {
      let n = e.getHours();
      return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : Je(n, t.length);
    },
    // Minute
    m: function(e, t, r) {
      return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : _6.m(e, t);
    },
    // Second
    s: function(e, t, r) {
      return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : _6.s(e, t);
    },
    // Fraction of second
    S: function(e, t) {
      return _6.S(e, t);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(e, t, r) {
      const n = e.getTimezoneOffset();
      if (n === 0)
        return "Z";
      switch (t) {
        // Hours and optional minutes
        case "X":
          return FV(n);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XX`
        case "XXXX":
        case "XX":
          return xi(n);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `XXX`
        case "XXXXX":
        case "XXX":
        // Hours and minutes with `:` delimiter
        default:
          return xi(n, ":");
      }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Hours and optional minutes
        case "x":
          return FV(n);
        // Hours, minutes and optional seconds without `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xx`
        case "xxxx":
        case "xx":
          return xi(n);
        // Hours, minutes and optional seconds with `:` delimiter
        // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
        // so this token always has the same output as `xxx`
        case "xxxxx":
        case "xxx":
        // Hours and minutes with `:` delimiter
        default:
          return xi(n, ":");
      }
    },
    // Timezone (GMT)
    O: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Short
        case "O":
        case "OO":
        case "OOO":
          return "GMT" + PV(n, ":");
        // Long
        case "OOOO":
        default:
          return "GMT" + xi(n, ":");
      }
    },
    // Timezone (specific non-location)
    z: function(e, t, r) {
      const n = e.getTimezoneOffset();
      switch (t) {
        // Short
        case "z":
        case "zz":
        case "zzz":
          return "GMT" + PV(n, ":");
        // Long
        case "zzzz":
        default:
          return "GMT" + xi(n, ":");
      }
    },
    // Seconds timestamp
    t: function(e, t, r) {
      const n = Math.trunc(+e / 1e3);
      return Je(n, t.length);
    },
    // Milliseconds timestamp
    T: function(e, t, r) {
      return Je(+e, t.length);
    }
  };
  function PV(e, t = "") {
    const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Math.trunc(n / 60), o = n % 60;
    return o === 0 ? r + String(i) : r + String(i) + t + Je(o, 2);
  }
  function FV(e, t) {
    return e % 60 === 0 ? (e > 0 ? "-" : "+") + Je(Math.abs(e) / 60, 2) : xi(e, t);
  }
  function xi(e, t = "") {
    const r = e > 0 ? "-" : "+", n = Math.abs(e), i = Je(Math.trunc(n / 60), 2), o = Je(n % 60, 2);
    return r + i + t + o;
  }
  const NV = (e, t) => {
    switch (e) {
      case "P":
        return t.date({ width: "short" });
      case "PP":
        return t.date({ width: "medium" });
      case "PPP":
        return t.date({ width: "long" });
      case "PPPP":
      default:
        return t.date({ width: "full" });
    }
  }, DG = (e, t) => {
    switch (e) {
      case "p":
        return t.time({ width: "short" });
      case "pp":
        return t.time({ width: "medium" });
      case "ppp":
        return t.time({ width: "long" });
      case "pppp":
      default:
        return t.time({ width: "full" });
    }
  }, xy2 = (e, t) => {
    const r = e.match(/(P+)(p+)?/) || [], n = r[1], i = r[2];
    if (!i)
      return NV(e, t);
    let o;
    switch (n) {
      case "P":
        o = t.dateTime({ width: "short" });
        break;
      case "PP":
        o = t.dateTime({ width: "medium" });
        break;
      case "PPP":
        o = t.dateTime({ width: "long" });
        break;
      case "PPPP":
      default:
        o = t.dateTime({ width: "full" });
        break;
    }
    return o.replace("{{date}}", NV(n, t)).replace("{{time}}", DG(i, t));
  }, Kw = {
    p: DG,
    P: xy2
  }, by2 = /^D+$/, wy2 = /^Y+$/, Sy2 = ["D", "DD", "YY", "YYYY"];
  function LG(e) {
    return by2.test(e);
  }
  function kG(e) {
    return wy2.test(e);
  }
  function Xw(e, t, r) {
    const n = My2(e, t, r);
    if (console.warn(n), Sy2.includes(e)) throw new RangeError(n);
  }
  function My2(e, t, r) {
    const n = e[0] === "Y" ? "years" : "days of the month";
    return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
  }
  const _y2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Oy2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ty2 = /^'([^]*?)'?$/, Dy2 = /''/g, Ly2 = /[a-zA-Z]/;
  function o_(e, t, r) {
    var g, h, E, y;
    const n = vs(), i = n.locale ?? _G, o = n.firstWeekContainsDate ?? ((h = (g = n.locale) == null ? void 0 : g.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, u = n.weekStartsOn ?? ((y = (E = n.locale) == null ? void 0 : E.options) == null ? void 0 : y.weekStartsOn) ?? 0, c = Dt(e, r == null ? void 0 : r.in);
    if (!Zm2(c))
      throw new RangeError("Invalid time value");
    let f = t.match(Oy2).map((I) => {
      const Q = I[0];
      if (Q === "p" || Q === "P") {
        const B = Kw[Q];
        return B(I, i.formatLong);
      }
      return I;
    }).join("").match(_y2).map((I) => {
      if (I === "''")
        return { isToken: !1, value: "'" };
      const Q = I[0];
      if (Q === "'")
        return { isToken: !1, value: ky2(I) };
      if (RV[Q])
        return { isToken: !0, value: I };
      if (Q.match(Ly2))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + Q + "`"
        );
      return { isToken: !1, value: I };
    });
    i.localize.preprocessor && (f = i.localize.preprocessor(c, f));
    const d = {
      firstWeekContainsDate: o,
      weekStartsOn: u,
      locale: i
    };
    return f.map((I) => {
      if (!I.isToken) return I.value;
      const Q = I.value;
      (kG(Q) || LG(Q)) && Xw(Q, t, String(e));
      const B = RV[Q[0]];
      return B(c, Q, i.localize, d);
    }).join("");
  }
  function ky2(e) {
    const t = e.match(Ty2);
    return t ? t[1].replace(Dy2, "'") : e;
  }
  function Ry2() {
    return Object.assign({}, vs());
  }
  function Py2(e, t) {
    const r = Dt(e, t == null ? void 0 : t.in).getDay();
    return r === 0 ? 7 : r;
  }
  function Fy2(e, t) {
    return +Dt(e) > +Dt(t);
  }
  function Ny2(e, t) {
    const r = Hy2(t) ? new t(0) : d5(t, 0);
    return r.setFullYear(e.getFullYear(), e.getMonth(), e.getDate()), r.setHours(
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    ), r;
  }
  function Hy2(e) {
    var t;
    return typeof e == "function" && ((t = e.prototype) == null ? void 0 : t.constructor) === e;
  }
  const jy2 = 10;
  class RG {
    constructor() {
      A0(this, "subPriority", 0);
    }
    validate(t, r) {
      return !0;
    }
  }
  class Vy2 extends RG {
    constructor(t, r, n, i, o) {
      super(), this.value = t, this.validateValue = r, this.setValue = n, this.priority = i, o && (this.subPriority = o);
    }
    validate(t, r) {
      return this.validateValue(t, this.value, r);
    }
    set(t, r, n) {
      return this.setValue(t, r, this.value, n);
    }
  }
  class Zy2 extends RG {
    constructor(r, n) {
      super();
      A0(this, "priority", jy2);
      A0(this, "subPriority", -1);
      this.context = r || ((i) => d5(n, i));
    }
    set(r, n) {
      return n.timestampIsSet ? r : d5(r, Ny2(r, this.context));
    }
  }
  class Re {
    run(t, r, n, i) {
      const o = this.parse(t, r, n, i);
      return o ? {
        setter: new Vy2(
          o.value,
          this.validate,
          this.set,
          this.priority,
          this.subPriority
        ),
        rest: o.rest
      } : null;
    }
    validate(t, r, n) {
      return !0;
    }
  }
  class zy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 140);
      A0(this, "incompatibleTokens", ["R", "u", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        // AD, BC
        case "G":
        case "GG":
        case "GGG":
          return i.era(r, { width: "abbreviated" }) || i.era(r, { width: "narrow" });
        // A, B
        case "GGGGG":
          return i.era(r, { width: "narrow" });
        // Anno Domini, Before Christ
        case "GGGG":
        default:
          return i.era(r, { width: "wide" }) || i.era(r, { width: "abbreviated" }) || i.era(r, { width: "narrow" });
      }
    }
    set(r, n, i) {
      return n.era = i, r.setFullYear(i, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  const i5 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/
    // 0 to 9999, -0 to -9999
  }, a3 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
  };
  function a5(e, t) {
    return e && {
      value: t(e.value),
      rest: e.rest
    };
  }
  function Tt(e, t) {
    const r = t.match(e);
    return r ? {
      value: parseInt(r[0], 10),
      rest: t.slice(r[0].length)
    } : null;
  }
  function o3(e, t) {
    const r = t.match(e);
    if (!r)
      return null;
    if (r[0] === "Z")
      return {
        value: 0,
        rest: t.slice(1)
      };
    const n = r[1] === "+" ? 1 : -1, i = r[2] ? parseInt(r[2], 10) : 0, o = r[3] ? parseInt(r[3], 10) : 0, u = r[5] ? parseInt(r[5], 10) : 0;
    return {
      value: n * (i * Lm2 + o * Dm2 + u * km2),
      rest: t.slice(r[0].length)
    };
  }
  function PG(e) {
    return Tt(i5.anyDigitsSigned, e);
  }
  function $t(e, t) {
    switch (e) {
      case 1:
        return Tt(i5.singleDigit, t);
      case 2:
        return Tt(i5.twoDigits, t);
      case 3:
        return Tt(i5.threeDigits, t);
      case 4:
        return Tt(i5.fourDigits, t);
      default:
        return Tt(new RegExp("^\\d{1," + e + "}"), t);
    }
  }
  function Gp(e, t) {
    switch (e) {
      case 1:
        return Tt(i5.singleDigitSigned, t);
      case 2:
        return Tt(i5.twoDigitsSigned, t);
      case 3:
        return Tt(i5.threeDigitsSigned, t);
      case 4:
        return Tt(i5.fourDigitsSigned, t);
      default:
        return Tt(new RegExp("^-?\\d{1," + e + "}"), t);
    }
  }
  function s_(e) {
    switch (e) {
      case "morning":
        return 4;
      case "evening":
        return 17;
      case "pm":
      case "noon":
      case "afternoon":
        return 12;
      case "am":
      case "midnight":
      case "night":
      default:
        return 0;
    }
  }
  function FG(e, t) {
    const r = t > 0, n = r ? t : 1 - t;
    let i;
    if (n <= 50)
      i = e || 100;
    else {
      const o = n + 50, u = Math.trunc(o / 100) * 100, c = e >= o % 100;
      i = e + u - (c ? 100 : 0);
    }
    return r ? i : 1 - i;
  }
  function NG(e) {
    return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
  }
  class Uy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 130);
      A0(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
    }
    parse(r, n, i) {
      const o = (u) => ({
        year: u,
        isTwoDigitYear: n === "yy"
      });
      switch (n) {
        case "y":
          return a5($t(4, r), o);
        case "yo":
          return a5(
            i.ordinalNumber(r, {
              unit: "year"
            }),
            o
          );
        default:
          return a5($t(n.length, r), o);
      }
    }
    validate(r, n) {
      return n.isTwoDigitYear || n.year > 0;
    }
    set(r, n, i) {
      const o = r.getFullYear();
      if (i.isTwoDigitYear) {
        const c = FG(
          i.year,
          o
        );
        return r.setFullYear(c, 0, 1), r.setHours(0, 0, 0, 0), r;
      }
      const u = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
      return r.setFullYear(u, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class qy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 130);
      A0(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const o = (u) => ({
        year: u,
        isTwoDigitYear: n === "YY"
      });
      switch (n) {
        case "Y":
          return a5($t(4, r), o);
        case "Yo":
          return a5(
            i.ordinalNumber(r, {
              unit: "year"
            }),
            o
          );
        default:
          return a5($t(n.length, r), o);
      }
    }
    validate(r, n) {
      return n.isTwoDigitYear || n.year > 0;
    }
    set(r, n, i, o) {
      const u = a_(r, o);
      if (i.isTwoDigitYear) {
        const f = FG(
          i.year,
          u
        );
        return r.setFullYear(
          f,
          0,
          o.firstWeekContainsDate
        ), r.setHours(0, 0, 0, 0), $6(r, o);
      }
      const c = !("era" in n) || n.era === 1 ? i.year : 1 - i.year;
      return r.setFullYear(c, 0, o.firstWeekContainsDate), r.setHours(0, 0, 0, 0), $6(r, o);
    }
  }
  class Wy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 130);
      A0(this, "incompatibleTokens", [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n) {
      return Gp(n === "R" ? 4 : n.length, r);
    }
    set(r, n, i) {
      const o = d5(r, 0);
      return o.setFullYear(i, 0, 4), o.setHours(0, 0, 0, 0), K9(o);
    }
  }
  class Yy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 130);
      A0(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
    }
    parse(r, n) {
      return Gp(n === "u" ? 4 : n.length, r);
    }
    set(r, n, i) {
      return r.setFullYear(i, 0, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class $y2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 120);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        // 1, 2, 3, 4
        case "Q":
        case "QQ":
          return $t(n.length, r);
        // 1st, 2nd, 3rd, 4th
        case "Qo":
          return i.ordinalNumber(r, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "QQQ":
          return i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "QQQQQ":
          return i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
        // 1st quarter, 2nd quarter, ...
        case "QQQQ":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "formatting"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.quarter(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 4;
    }
    set(r, n, i) {
      return r.setMonth((i - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class Gy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 120);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        // 1, 2, 3, 4
        case "q":
        case "qq":
          return $t(n.length, r);
        // 1st, 2nd, 3rd, 4th
        case "qo":
          return i.ordinalNumber(r, { unit: "quarter" });
        // Q1, Q2, Q3, Q4
        case "qqq":
          return i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case "qqqqq":
          return i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
        // 1st quarter, 2nd quarter, ...
        case "qqqq":
        default:
          return i.quarter(r, {
            width: "wide",
            context: "standalone"
          }) || i.quarter(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.quarter(r, {
            width: "narrow",
            context: "standalone"
          });
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 4;
    }
    set(r, n, i) {
      return r.setMonth((i - 1) * 3, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class Ky2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
      A0(this, "priority", 110);
    }
    parse(r, n, i) {
      const o = (u) => u - 1;
      switch (n) {
        // 1, 2, ..., 12
        case "M":
          return a5(
            Tt(i5.month, r),
            o
          );
        // 01, 02, ..., 12
        case "MM":
          return a5($t(2, r), o);
        // 1st, 2nd, ..., 12th
        case "Mo":
          return a5(
            i.ordinalNumber(r, {
              unit: "month"
            }),
            o
          );
        // Jan, Feb, ..., Dec
        case "MMM":
          return i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, { width: "narrow", context: "formatting" });
        // J, F, ..., D
        case "MMMMM":
          return i.month(r, {
            width: "narrow",
            context: "formatting"
          });
        // January, February, ..., December
        case "MMMM":
        default:
          return i.month(r, { width: "wide", context: "formatting" }) || i.month(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.month(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.setMonth(i, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  class Xy2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 110);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const o = (u) => u - 1;
      switch (n) {
        // 1, 2, ..., 12
        case "L":
          return a5(
            Tt(i5.month, r),
            o
          );
        // 01, 02, ..., 12
        case "LL":
          return a5($t(2, r), o);
        // 1st, 2nd, ..., 12th
        case "Lo":
          return a5(
            i.ordinalNumber(r, {
              unit: "month"
            }),
            o
          );
        // Jan, Feb, ..., Dec
        case "LLL":
          return i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, { width: "narrow", context: "standalone" });
        // J, F, ..., D
        case "LLLLL":
          return i.month(r, {
            width: "narrow",
            context: "standalone"
          });
        // January, February, ..., December
        case "LLLL":
        default:
          return i.month(r, { width: "wide", context: "standalone" }) || i.month(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.month(r, { width: "narrow", context: "standalone" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.setMonth(i, 1), r.setHours(0, 0, 0, 0), r;
    }
  }
  function Jy2(e, t, r) {
    const n = Dt(e, r == null ? void 0 : r.in), i = TG(n, r) - t;
    return n.setDate(n.getDate() - i * 7), Dt(n, r == null ? void 0 : r.in);
  }
  class eI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 100);
      A0(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "w":
          return Tt(i5.week, r);
        case "wo":
          return i.ordinalNumber(r, { unit: "week" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 53;
    }
    set(r, n, i, o) {
      return $6(Jy2(r, i, o), o);
    }
  }
  function tI2(e, t, r) {
    const n = Dt(e, r == null ? void 0 : r.in), i = OG(n, r) - t;
    return n.setDate(n.getDate() - i * 7), n;
  }
  class rI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 100);
      A0(this, "incompatibleTokens", [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "I":
          return Tt(i5.week, r);
        case "Io":
          return i.ordinalNumber(r, { unit: "week" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 53;
    }
    set(r, n, i) {
      return K9(tI2(r, i));
    }
  }
  const nI2 = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], iI2 = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
  ];
  class aI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "subPriority", 1);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "d":
          return Tt(i5.date, r);
        case "do":
          return i.ordinalNumber(r, { unit: "date" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      const i = r.getFullYear(), o = NG(i), u = r.getMonth();
      return o ? n >= 1 && n <= iI2[u] : n >= 1 && n <= nI2[u];
    }
    set(r, n, i) {
      return r.setDate(i), r.setHours(0, 0, 0, 0), r;
    }
  }
  class oI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "subpriority", 1);
      A0(this, "incompatibleTokens", [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      switch (n) {
        case "D":
        case "DD":
          return Tt(i5.dayOfYear, r);
        case "Do":
          return i.ordinalNumber(r, { unit: "date" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      const i = r.getFullYear();
      return NG(i) ? n >= 1 && n <= 366 : n >= 1 && n <= 365;
    }
    set(r, n, i) {
      return r.setMonth(0, i), r.setHours(0, 0, 0, 0), r;
    }
  }
  function u_(e, t, r) {
    var h, E, y, I;
    const n = vs(), i = (r == null ? void 0 : r.weekStartsOn) ?? ((E = (h = r == null ? void 0 : r.locale) == null ? void 0 : h.options) == null ? void 0 : E.weekStartsOn) ?? n.weekStartsOn ?? ((I = (y = n.locale) == null ? void 0 : y.options) == null ? void 0 : I.weekStartsOn) ?? 0, o = Dt(e, r == null ? void 0 : r.in), u = o.getDay(), f = (t % 7 + 7) % 7, d = 7 - i, g = t < 0 || t > 6 ? t - (u + d) % 7 : (f + d) % 7 - (u + d) % 7;
    return i_(o, g, r);
  }
  class sI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        // Tue
        case "E":
        case "EE":
        case "EEE":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // T
        case "EEEEE":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "EEEEEE":
          return i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // Tuesday
        case "EEEE":
        default:
          return i.day(r, { width: "wide", context: "formatting" }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, o) {
      return r = u_(r, i, o), r.setHours(0, 0, 0, 0), r;
    }
  }
  class uI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i, o) {
      const u = (c) => {
        const f = Math.floor((c - 1) / 7) * 7;
        return (c + o.weekStartsOn + 6) % 7 + f;
      };
      switch (n) {
        // 3
        case "e":
        case "ee":
          return a5($t(n.length, r), u);
        // 3rd
        case "eo":
          return a5(
            i.ordinalNumber(r, {
              unit: "day"
            }),
            u
          );
        // Tue
        case "eee":
          return i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // T
        case "eeeee":
          return i.day(r, {
            width: "narrow",
            context: "formatting"
          });
        // Tu
        case "eeeeee":
          return i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
        // Tuesday
        case "eeee":
        default:
          return i.day(r, { width: "wide", context: "formatting" }) || i.day(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.day(r, { width: "short", context: "formatting" }) || i.day(r, { width: "narrow", context: "formatting" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, o) {
      return r = u_(r, i, o), r.setHours(0, 0, 0, 0), r;
    }
  }
  class lI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "incompatibleTokens", [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
      ]);
    }
    parse(r, n, i, o) {
      const u = (c) => {
        const f = Math.floor((c - 1) / 7) * 7;
        return (c + o.weekStartsOn + 6) % 7 + f;
      };
      switch (n) {
        // 3
        case "c":
        case "cc":
          return a5($t(n.length, r), u);
        // 3rd
        case "co":
          return a5(
            i.ordinalNumber(r, {
              unit: "day"
            }),
            u
          );
        // Tue
        case "ccc":
          return i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
        // T
        case "ccccc":
          return i.day(r, {
            width: "narrow",
            context: "standalone"
          });
        // Tu
        case "cccccc":
          return i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
        // Tuesday
        case "cccc":
        default:
          return i.day(r, { width: "wide", context: "standalone" }) || i.day(r, {
            width: "abbreviated",
            context: "standalone"
          }) || i.day(r, { width: "short", context: "standalone" }) || i.day(r, { width: "narrow", context: "standalone" });
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 6;
    }
    set(r, n, i, o) {
      return r = u_(r, i, o), r.setHours(0, 0, 0, 0), r;
    }
  }
  function cI2(e, t, r) {
    const n = Dt(e, r == null ? void 0 : r.in), i = Py2(n, r), o = t - i;
    return i_(n, o, r);
  }
  class AI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 90);
      A0(this, "incompatibleTokens", [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
      ]);
    }
    parse(r, n, i) {
      const o = (u) => u === 0 ? 7 : u;
      switch (n) {
        // 2
        case "i":
        case "ii":
          return $t(n.length, r);
        // 2nd
        case "io":
          return i.ordinalNumber(r, { unit: "day" });
        // Tue
        case "iii":
          return a5(
            i.day(r, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            o
          );
        // T
        case "iiiii":
          return a5(
            i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            o
          );
        // Tu
        case "iiiiii":
          return a5(
            i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            o
          );
        // Tuesday
        case "iiii":
        default:
          return a5(
            i.day(r, {
              width: "wide",
              context: "formatting"
            }) || i.day(r, {
              width: "abbreviated",
              context: "formatting"
            }) || i.day(r, {
              width: "short",
              context: "formatting"
            }) || i.day(r, {
              width: "narrow",
              context: "formatting"
            }),
            o
          );
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 7;
    }
    set(r, n, i) {
      return r = cI2(r, i), r.setHours(0, 0, 0, 0), r;
    }
  }
  class fI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 80);
      A0(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "a":
        case "aa":
        case "aaa":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaaa":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "aaaa":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(s_(i), 0, 0, 0), r;
    }
  }
  class CI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 80);
      A0(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "b":
        case "bb":
        case "bbb":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbbb":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "bbbb":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(s_(i), 0, 0, 0), r;
    }
  }
  class dI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 80);
      A0(this, "incompatibleTokens", ["a", "b", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "B":
        case "BB":
        case "BBB":
          return i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBBB":
          return i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
        case "BBBB":
        default:
          return i.dayPeriod(r, {
            width: "wide",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "abbreviated",
            context: "formatting"
          }) || i.dayPeriod(r, {
            width: "narrow",
            context: "formatting"
          });
      }
    }
    set(r, n, i) {
      return r.setHours(s_(i), 0, 0, 0), r;
    }
  }
  class gI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 70);
      A0(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "h":
          return Tt(i5.hour12h, r);
        case "ho":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 12;
    }
    set(r, n, i) {
      const o = r.getHours() >= 12;
      return o && i < 12 ? r.setHours(i + 12, 0, 0, 0) : !o && i === 12 ? r.setHours(0, 0, 0, 0) : r.setHours(i, 0, 0, 0), r;
    }
  }
  class pI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 70);
      A0(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "H":
          return Tt(i5.hour23h, r);
        case "Ho":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 23;
    }
    set(r, n, i) {
      return r.setHours(i, 0, 0, 0), r;
    }
  }
  class hI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 70);
      A0(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "K":
          return Tt(i5.hour11h, r);
        case "Ko":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 11;
    }
    set(r, n, i) {
      return r.getHours() >= 12 && i < 12 ? r.setHours(i + 12, 0, 0, 0) : r.setHours(i, 0, 0, 0), r;
    }
  }
  class vI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 70);
      A0(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "k":
          return Tt(i5.hour24h, r);
        case "ko":
          return i.ordinalNumber(r, { unit: "hour" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 1 && n <= 24;
    }
    set(r, n, i) {
      const o = i <= 24 ? i % 24 : i;
      return r.setHours(o, 0, 0, 0), r;
    }
  }
  class EI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 60);
      A0(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "m":
          return Tt(i5.minute, r);
        case "mo":
          return i.ordinalNumber(r, { unit: "minute" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 59;
    }
    set(r, n, i) {
      return r.setMinutes(i, 0, 0), r;
    }
  }
  class mI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 50);
      A0(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n, i) {
      switch (n) {
        case "s":
          return Tt(i5.second, r);
        case "so":
          return i.ordinalNumber(r, { unit: "second" });
        default:
          return $t(n.length, r);
      }
    }
    validate(r, n) {
      return n >= 0 && n <= 59;
    }
    set(r, n, i) {
      return r.setSeconds(i, 0), r;
    }
  }
  class yI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 30);
      A0(this, "incompatibleTokens", ["t", "T"]);
    }
    parse(r, n) {
      const i = (o) => Math.trunc(o * Math.pow(10, -n.length + 3));
      return a5($t(n.length, r), i);
    }
    set(r, n, i) {
      return r.setMilliseconds(i), r;
    }
  }
  class II2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 10);
      A0(this, "incompatibleTokens", ["t", "T", "x"]);
    }
    parse(r, n) {
      switch (n) {
        case "X":
          return o3(
            a3.basicOptionalMinutes,
            r
          );
        case "XX":
          return o3(a3.basic, r);
        case "XXXX":
          return o3(
            a3.basicOptionalSeconds,
            r
          );
        case "XXXXX":
          return o3(
            a3.extendedOptionalSeconds,
            r
          );
        case "XXX":
        default:
          return o3(a3.extended, r);
      }
    }
    set(r, n, i) {
      return n.timestampIsSet ? r : d5(
        r,
        r.getTime() - $p(r) - i
      );
    }
  }
  class BI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 10);
      A0(this, "incompatibleTokens", ["t", "T", "X"]);
    }
    parse(r, n) {
      switch (n) {
        case "x":
          return o3(
            a3.basicOptionalMinutes,
            r
          );
        case "xx":
          return o3(a3.basic, r);
        case "xxxx":
          return o3(
            a3.basicOptionalSeconds,
            r
          );
        case "xxxxx":
          return o3(
            a3.extendedOptionalSeconds,
            r
          );
        case "xxx":
        default:
          return o3(a3.extended, r);
      }
    }
    set(r, n, i) {
      return n.timestampIsSet ? r : d5(
        r,
        r.getTime() - $p(r) - i
      );
    }
  }
  class QI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 40);
      A0(this, "incompatibleTokens", "*");
    }
    parse(r) {
      return PG(r);
    }
    set(r, n, i) {
      return [d5(r, i * 1e3), { timestampIsSet: !0 }];
    }
  }
  class xI2 extends Re {
    constructor() {
      super(...arguments);
      A0(this, "priority", 20);
      A0(this, "incompatibleTokens", "*");
    }
    parse(r) {
      return PG(r);
    }
    set(r, n, i) {
      return [d5(r, i), { timestampIsSet: !0 }];
    }
  }
  const bI2 = {
    G: new zy2(),
    y: new Uy2(),
    Y: new qy2(),
    R: new Wy2(),
    u: new Yy2(),
    Q: new $y2(),
    q: new Gy2(),
    M: new Ky2(),
    L: new Xy2(),
    w: new eI2(),
    I: new rI2(),
    d: new aI2(),
    D: new oI2(),
    E: new sI2(),
    e: new uI2(),
    c: new lI2(),
    i: new AI2(),
    a: new fI2(),
    b: new CI2(),
    B: new dI2(),
    h: new gI2(),
    H: new pI2(),
    K: new hI2(),
    k: new vI2(),
    m: new EI2(),
    s: new mI2(),
    S: new yI2(),
    X: new II2(),
    x: new BI2(),
    t: new QI2(),
    T: new xI2()
  }, wI2 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, SI2 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, MI2 = /^'([^]*?)'?$/, _I2 = /''/g, OI2 = /\S/, TI2 = /[a-zA-Z]/;
  function HG(e, t, r, n) {
    var B, _, M, S;
    const i = () => d5(r, NaN), o = Ry2(), u = o.locale ?? _G, c = o.firstWeekContainsDate ?? ((_ = (B = o.locale) == null ? void 0 : B.options) == null ? void 0 : _.firstWeekContainsDate) ?? 1, f = o.weekStartsOn ?? ((S = (M = o.locale) == null ? void 0 : M.options) == null ? void 0 : S.weekStartsOn) ?? 0;
    if (!t)
      return e ? i() : Dt(r, n == null ? void 0 : n.in);
    const d = {
      firstWeekContainsDate: c,
      weekStartsOn: f,
      locale: u
    }, g = [new Zy2(n == null ? void 0 : n.in, r)], h = t.match(SI2).map((O) => {
      const w = O[0];
      if (w in Kw) {
        const D = Kw[w];
        return D(O, u.formatLong);
      }
      return O;
    }).join("").match(wI2), E = [];
    for (let O of h) {
      kG(O) && Xw(O, t, e), LG(O) && Xw(O, t, e);
      const w = O[0], D = bI2[w];
      if (D) {
        const { incompatibleTokens: k } = D;
        if (Array.isArray(k)) {
          const z = E.find(
            (Z) => k.includes(Z.token) || Z.token === w
          );
          if (z)
            throw new RangeError(
              `The format string mustn't contain \`${z.fullToken}\` and \`${O}\` at the same time`
            );
        } else if (D.incompatibleTokens === "*" && E.length > 0)
          throw new RangeError(
            `The format string mustn't contain \`${O}\` and any other token at the same time`
          );
        E.push({ token: w, fullToken: O });
        const F = D.run(
          e,
          O,
          u.match,
          d
        );
        if (!F)
          return i();
        g.push(F.setter), e = F.rest;
      } else {
        if (w.match(TI2))
          throw new RangeError(
            "Format string contains an unescaped latin alphabet character `" + w + "`"
          );
        if (O === "''" ? O = "'" : w === "'" && (O = DI2(O)), e.indexOf(O) === 0)
          e = e.slice(O.length);
        else
          return i();
      }
    }
    if (e.length > 0 && OI2.test(e))
      return i();
    const y = g.map((O) => O.priority).sort((O, w) => w - O).filter((O, w, D) => D.indexOf(O) === w).map(
      (O) => g.filter((w) => w.priority === O).sort((w, D) => D.subPriority - w.subPriority)
    ).map((O) => O[0]);
    let I = Dt(r, n == null ? void 0 : n.in);
    if (isNaN(+I)) return i();
    const Q = {};
    for (const O of y) {
      if (!O.validate(I, d))
        return i();
      const w = O.set(I, Q, d);
      Array.isArray(w) ? (I = w[0], Object.assign(Q, w[1])) : I = w;
    }
    return I;
  }
  function DI2(e) {
    return e.match(MI2)[1].replace(_I2, "'");
  }
  function HV(e, t, r) {
    return i_(e, -7, r);
  }
  function LI2(e, t, r) {
    return jm2(e, -1, r);
  }
  const jV = {
    yearly: {
      inputFormat: "yyyy-MM",
      tooltipFormat: "MMM yyyy",
      //'Feb 2024'
      xAxisFormat: "MMM"
    },
    monthly: {
      inputFormat: "yyyy-MM-dd",
      tooltipFormat: "dd MMM yyyy",
      // '12 Feb 2024'
      xAxisFormat: "d MMM"
    }
  }, l_ = (e) => e === "year" ? jV.yearly : jV.monthly, kI2 = (e, t, r) => {
    const { inputFormat: n, tooltipFormat: i } = l_(t), o = HG(e, n, /* @__PURE__ */ new Date()), u = r ? o : LI2(o);
    return o_(u, i);
  }, RI2 = (e, t) => {
    if (!N42(e)) return [];
    if (t === "year") {
      const f = [];
      for (const d of e)
        f.push(d.date);
      return f;
    }
    const r = e[e.length - 1];
    if (!r) return [];
    const n = new Date(e[0].date), i = new Date(r.date), o = [];
    o.push(i);
    let u = HV(i);
    for (; Fy2(u, n); )
      o.unshift(u), u = HV(u);
    return o.unshift(n), o.map((f) => o_(f, l_(t).inputFormat));
  }, PI2 = (e, t) => {
    const { inputFormat: r, xAxisFormat: n } = l_(t), i = HG(e, r, /* @__PURE__ */ new Date());
    return o_(i, n);
  }, $x = (e) => {
    const { currentPeriod: t, previousPeriod: r } = e, n = /* @__PURE__ */ new Map();
    for (const { year: i, month: o, visits: u } of r) {
      const c = `${i}-${o}`;
      n.set(c, u);
    }
    return t.map(({ year: i, month: o, visits: u }) => {
      const c = `${i - 1}-${o}`, f = `${i}-${String(o).padStart(2, "0")}`, d = n.get(c) ?? 0;
      return { date: f, visit: u, yearOnYearVisit: d };
    });
  }, VV = (e) => {
    const { currentPeriod: t, previousPeriod: r } = e;
    return t.map(({ year: n, month: i, day: o, visits: u }, c) => {
      const f = r[c];
      return {
        date: `${n}-${String(i).padStart(2, "0")}-${String(o).padStart(2, "0")}`,
        visit: u,
        yearOnYearVisit: (f == null ? void 0 : f.visits) ?? 0
      };
    });
  }, FI2 = () => {
    const e = [
      {
        label: ne.chart.legend.thisYear,
        color: Jw.visit.color
      },
      {
        label: ne.chart.legend.yoy,
        color: Jw.yearOnYearVisit.color
      }
    ];
    return /* @__PURE__ */ K.jsx("ul", { className: "mb-6 flex flex-row text-sm text-neutral-700 gap-9", children: e.map((t) => /* @__PURE__ */ K.jsxs("li", { className: "flex flex-row items-center gap-2", children: [
      /* @__PURE__ */ K.jsx(
        "span",
        {
          className: "inline-block w-3.5 h-3.5 rounded-[4px]",
          "data-testid": "visitation-report-legend-indicator",
          style: { backgroundColor: t.color }
        }
      ),
      /* @__PURE__ */ K.jsx("span", { className: "text-xs font-normal", "data-testid": "visitation-report-legend-label", children: t.label })
    ] }, t.label)) });
  }, NI2 = (e, t) => (r) => {
    const { x: n, y: i, payload: o } = r, u = e(o.value, t);
    return /* @__PURE__ */ K.jsx("g", { transform: `translate(${n},${i})`, children: /* @__PURE__ */ K.jsx("text", { dy: 8, dx: -10, textAnchor: "start", className: "text-sm text-neutral-500", children: u }) });
  }, HI2 = (e) => {
    const { x: t, y: r, payload: n } = e;
    return /* @__PURE__ */ K.jsx("g", { transform: `translate(${t},${r})`, children: /* @__PURE__ */ K.jsx("text", { dy: 0, textAnchor: "end", className: "text-sm text-neutral-500", children: n.value }) });
  }, jI2 = (e) => ({ active: t, payload: r, label: n }) => !t || !r ? null : /* @__PURE__ */ K.jsx(
    "div",
    {
      className: "bg-white rounded-md border-1 border-neutral-200 p-2 text-xs flex flex-col gap-4",
      "data-testid": "visitation-report-tooltip-item",
      children: r.map((i) => {
        var o;
        return /* @__PURE__ */ K.jsxs("div", { className: "flex flex-col items-start justify-start text-neutral-900", children: [
          /* @__PURE__ */ K.jsx("p", { className: "font-bold mb-1.5", children: kI2(n, e, i.dataKey === "visit") }),
          /* @__PURE__ */ K.jsxs("div", { className: "flex flex-row items-center justify-start font-normal text-neutral-700", children: [
            /* @__PURE__ */ K.jsx("span", { className: "inline-block w-3.5 h-3.5 rounded-[4px] mr-2", style: { backgroundColor: i.color } }),
            /* @__PURE__ */ K.jsx("span", { className: "mr-8", children: ne.visitTrendsTooltip.visits }),
            /* @__PURE__ */ K.jsx("span", { children: (o = i.value) == null ? void 0 : o.toLocaleString() })
          ] })
        ] }, i.dataKey);
      })
    }
  ), Jw = {
    visit: {
      color: "var(--color-purple-600)"
    },
    yearOnYearVisit: {
      color: "var(--color-neutral-400)"
    },
    axis: {
      color: "var(--color-neutral-400)"
    },
    cartesian: {
      color: "var(--color-neutral-300)"
    },
    tooltipBorder: {
      color: "var(--color-neutral-200)"
    }
  }, VI2 = ({ data: { chartData: e, range: t }, showYearOnYear: r }) => {
    const n = q.useRef(!1), { isLoading: i } = gA(), o = () => {
      n.current = !0;
    };
    return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
      /* @__PURE__ */ K.jsx(FI2, {}),
      i ? /* @__PURE__ */ K.jsx(im2, {}) : /* @__PURE__ */ K.jsx(lG, { "aria-label": ne.chart.ariaContainerLabel, config: Jw, className: "h-85 w-full", children: /* @__PURE__ */ K.jsxs(
        $E2,
        {
          accessibilityLayer: !0,
          data: e,
          margin: {
            left: 0,
            right: 10,
            top: 5,
            bottom: 0
          },
          children: [
            /* @__PURE__ */ K.jsx(q$, { stroke: "var(--color-cartesian)", vertical: !1 }),
            /* @__PURE__ */ K.jsx(cn, { content: jI2(t), cursor: !1 }),
            /* @__PURE__ */ K.jsx(
              ps,
              {
                dataKey: "date",
                tickLine: !1,
                tickMargin: 8,
                stroke: "var(--color-axis)",
                tick: NI2(PI2, t),
                ticks: RI2(e, t),
                interval: t === "year" ? 0 : void 0
              }
            ),
            /* @__PURE__ */ K.jsx(hs, { stroke: "var(--color-axis)", tickLine: !1, tickMargin: 8, tick: HI2 }),
            r && /* @__PURE__ */ K.jsx(
              q9,
              {
                dataKey: "yearOnYearVisit",
                type: "monotone",
                stroke: "var(--color-yearOnYearVisit)",
                strokeWidth: 2,
                dot: !1,
                isAnimationActive: !n.current,
                onAnimationEnd: o,
                animationDuration: 1e3
              },
              "yearOnYearVisit"
            ),
            /* @__PURE__ */ K.jsx(
              q9,
              {
                dataKey: "visit",
                type: "monotone",
                stroke: "var(--color-visit)",
                strokeWidth: 2,
                dot: !1,
                z: 2,
                isAnimationActive: !n.current,
                onAnimationEnd: o,
                animationDuration: 1e3
              },
              "visit"
            )
          ]
        }
      ) })
    ] });
  }, ZI2 = ({ lastTwelveMonths: e, lastMonth: t }) => {
    const { isLoading: r } = gA(), [n, i] = q.useState(!0), [o, u] = q.useState(() => ({
      range: "year",
      chartData: $x(e)
    }));
    q.useEffect(() => {
      const d = o.range === "year" ? $x(e) : VV(t);
      u((g) => ({
        ...g,
        chartData: d
      }));
    }, [e, t]);
    const c = (d) => {
      if (d === "" || d === o.range)
        return;
      const g = d === "year" ? $x(e) : VV(t);
      u({
        range: d,
        chartData: g
      });
    }, f = (d) => {
      i(d);
    };
    return /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
      /* @__PURE__ */ K.jsxs("div", { className: SS("flex flex-row items-center justify-start gap-x-5 mb-6", r && "pointer-events-none"), children: [
        /* @__PURE__ */ K.jsx(
          Om2,
          {
            value: o.range,
            disabled: r,
            items: [
              {
                value: "month",
                label: ne.trends.monthlyDimensionLabel
              },
              {
                value: "year",
                label: ne.trends.yearlyDimensionLabel
              }
            ],
            onValueChange: c
          }
        ),
        /* @__PURE__ */ K.jsxs("div", { className: "flex flex-row items-center justify-start gap-x-3", children: [
          /* @__PURE__ */ K.jsx(
            mm2,
            {
              id: "visitation-report-year-on-year-switch",
              checked: n,
              onCheckedChange: f,
              disabled: r
            }
          ),
          /* @__PURE__ */ K.jsx("label", { htmlFor: "visitation-report-year-on-year-switch", className: "text-sm font-normal", children: ne.trends.toggleYoYLabel })
        ] })
      ] }),
      /* @__PURE__ */ K.jsx(VI2, { showYearOnYear: n, data: o })
    ] });
  }, zI2 = ({ visitAggregates: e, pastReportsUrl: t }) => /* @__PURE__ */ K.jsxs(K.Fragment, { children: [
    /* @__PURE__ */ K.jsx("section", { className: "mb-24", children: /* @__PURE__ */ K.jsx(ZI2, { lastTwelveMonths: e.lastTwelveMonths, lastMonth: e.lastMonth }) }),
    /* @__PURE__ */ K.jsxs("section", { className: "mb-24", children: [
      /* @__PURE__ */ K.jsx("h2", { className: "text-3xl text-neutral-900 mb-6", children: ne.report.headingTwo }),
      /* @__PURE__ */ K.jsxs("div", { className: "grid grid-cols-2 gap-6", children: [
        /* @__PURE__ */ K.jsx(
          _V,
          {
            title: ne.report.visitCountTitleOne,
            description: ne.report.visitsCountDescription,
            visitsCount: e.averageVisitsPerDay.visits,
            percentChangeYoY: e.averageVisitsPerDay.percentageChangeYearOnYear
          }
        ),
        /* @__PURE__ */ K.jsx(
          _V,
          {
            title: ne.report.visitCountTitleTwo,
            description: ne.report.visitsCountDescription,
            visitsCount: e.totalVisitsThisMonth.visits,
            percentChangeYoY: e.totalVisitsThisMonth.percentageChangeYearOnYear
          }
        ),
        /* @__PURE__ */ K.jsx(sm2, { data: p72(e.mostPopularDay) }),
        /* @__PURE__ */ K.jsx(lm2, { data: e.mostPopularHour })
      ] })
    ] }),
    /* @__PURE__ */ K.jsxs("section", { children: [
      /* @__PURE__ */ K.jsx("h3", { className: "text-2xl text-neutral-900 mb-6", children: ne.report.headingThree }),
      /* @__PURE__ */ K.jsx(
        "a",
        {
          href: t,
          className: "inline-block text-base font-bold text-primary-600 px-4 py-2 border-1 rounded-3xl border-primary-600 hover:text-primary-700 hover:border-primary-700",
          children: ne.report.viewPastReports
        }
      )
    ] })
  ] }), UI2 = Hi`
  query GET_ONE_FACILITY_VISITATION($facilityId: ID!) {
    facility(id: $facilityId) {
      name
      visitAggregates {
        averageVisitsPerDay {
          visits
          percentageChangeYearOnYear
        }
        lastMonth {
          currentPeriod {
            day
            month
            year
            visits
          }
          previousPeriod {
            day
            month
            year
            visits
          }
        }
        lastTwelveMonths {
          currentPeriod {
            month
            year
            visits
          }
          previousPeriod {
            month
            year
            visits
          }
        }
        mostPopularDay {
          day
          dayOfWeekNumber
          visits
        }
        mostPopularHour {
          hour
          visits
        }
        totalVisitsThisMonth {
          visits
          percentageChangeYearOnYear
        }
      }
    }
  }
`, qI2 = (e) => {
    const [t, r] = q.useState(e[0] || null), [n, i] = q.useState({
      data: null,
      loading: !1,
      error: null,
      facilityId: null
    }), [o, { loading: u }] = $r2(UI2, {
      onCompleted: (f) => {
        const d = f == null ? void 0 : f.facility;
        d != null && d.visitAggregates ? i((g) => ({
          ...g,
          data: d,
          loading: !1,
          error: null
        })) : i((g) => ({
          ...g,
          data: null,
          loading: !1,
          error: new Error("No facility data returned from server")
        }));
      },
      onError: (f) => {
        console.error("Failed to fetch facility data:", f), i((d) => ({
          ...d,
          data: null,
          loading: !1,
          error: f
        }));
      }
    });
    q.useEffect(() => {
      e.length > 0 && !t && r(e[0]);
    }, [e, t]), q.useEffect(() => {
      t && (i((f) => ({
        ...f,
        loading: !0,
        error: null,
        facilityId: t.id
      })), o({
        variables: { facilityId: t.id }
      }));
    }, [t, o]), q.useEffect(() => {
      i((f) => ({
        ...f,
        loading: u
      }));
    }, [u]);
    const c = q.useCallback(
      (f) => {
        const d = e.find(({ id: g }) => g === f);
        if (!d) {
          console.error("facility not found in available facility list: ", f);
          return;
        }
        (t == null ? void 0 : t.id) !== d.id && r(d);
      },
      [e]
    );
    return {
      selectedFacility: t,
      currentFacilityData: n.data,
      facilityLoading: n.loading,
      facilityError: n.error,
      handleFacilityChange: c
    };
  }, WI2 = Hi`
  query GET_FACILITY_LIST {
    facilities {
      id
      name
    }
  }
`, YI2 = () => {
    const { data: e, loading: t, error: r } = Fr2(WI2);
    return {
      facilityList: (e == null ? void 0 : e.facilities) || [],
      loading: t,
      error: r
    };
  };
  function $I2(e) {
    return new ns(function(t, r) {
      var n = yr(t, []);
      return new At(function(i) {
        var o, u = !1;
        return Promise.resolve(n).then(function(c) {
          return e(c, t.getContext());
        }).then(t.setContext).then(function() {
          u || (o = r(t).subscribe({
            next: i.next.bind(i),
            error: i.error.bind(i),
            complete: i.complete.bind(i)
          }));
        }).catch(i.error.bind(i)), function() {
          u = !0, o && o.unsubscribe();
        };
      });
    });
  }
  var eg = { exports: {} };
  function GI2(e) {
    throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
  }
  var tg = { exports: {} };
  const KI2 = {}, XI2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
    __proto__: null,
    default: KI2
  }, Symbol.toStringTag, { value: "Module" })), JI2 = /* @__PURE__ */ Te2(XI2);
  var eB2 = tg.exports, ZV;
  function he() {
    return ZV || (ZV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n();
      })(eB2, function() {
        var r = r || function(n, i) {
          var o;
          if (typeof window < "u" && window.crypto && (o = window.crypto), typeof self < "u" && self.crypto && (o = self.crypto), typeof globalThis < "u" && globalThis.crypto && (o = globalThis.crypto), !o && typeof window < "u" && window.msCrypto && (o = window.msCrypto), !o && typeof wi < "u" && wi.crypto && (o = wi.crypto), !o && typeof GI2 == "function")
            try {
              o = JI2;
            } catch {
            }
          var u = function() {
            if (o) {
              if (typeof o.getRandomValues == "function")
                try {
                  return o.getRandomValues(new Uint32Array(1))[0];
                } catch {
                }
              if (typeof o.randomBytes == "function")
                try {
                  return o.randomBytes(4).readInt32LE();
                } catch {
                }
            }
            throw new Error("Native crypto module could not be used to get secure random number.");
          }, c = Object.create || /* @__PURE__ */ function() {
            function M() {
            }
            return function(S) {
              var O;
              return M.prototype = S, O = new M(), M.prototype = null, O;
            };
          }(), f = {}, d = f.lib = {}, g = d.Base = /* @__PURE__ */ function() {
            return {
              /**
               * Creates a new object that inherits from this object.
               *
               * @param {Object} overrides Properties to copy into the new object.
               *
               * @return {Object} The new object.
               *
               * @static
               *
               * @example
               *
               *     var MyType = CryptoJS.lib.Base.extend({
               *         field: 'value',
               *
               *         method: function () {
               *         }
               *     });
               */
              extend: function(M) {
                var S = c(this);
                return M && S.mixIn(M), (!S.hasOwnProperty("init") || this.init === S.init) && (S.init = function() {
                  S.$super.init.apply(this, arguments);
                }), S.init.prototype = S, S.$super = this, S;
              },
              /**
               * Extends this object and runs the init method.
               * Arguments to create() will be passed to init().
               *
               * @return {Object} The new object.
               *
               * @static
               *
               * @example
               *
               *     var instance = MyType.create();
               */
              create: function() {
                var M = this.extend();
                return M.init.apply(M, arguments), M;
              },
              /**
               * Initializes a newly created object.
               * Override this method to add some logic when your objects are created.
               *
               * @example
               *
               *     var MyType = CryptoJS.lib.Base.extend({
               *         init: function () {
               *             // ...
               *         }
               *     });
               */
              init: function() {
              },
              /**
               * Copies properties into this object.
               *
               * @param {Object} properties The properties to mix in.
               *
               * @example
               *
               *     MyType.mixIn({
               *         field: 'value'
               *     });
               */
              mixIn: function(M) {
                for (var S in M)
                  M.hasOwnProperty(S) && (this[S] = M[S]);
                M.hasOwnProperty("toString") && (this.toString = M.toString);
              },
              /**
               * Creates a copy of this object.
               *
               * @return {Object} The clone.
               *
               * @example
               *
               *     var clone = instance.clone();
               */
              clone: function() {
                return this.init.prototype.extend(this);
              }
            };
          }(), h = d.WordArray = g.extend({
            /**
             * Initializes a newly created word array.
             *
             * @param {Array} words (Optional) An array of 32-bit words.
             * @param {number} sigBytes (Optional) The number of significant bytes in the words.
             *
             * @example
             *
             *     var wordArray = CryptoJS.lib.WordArray.create();
             *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
             *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
             */
            init: function(M, S) {
              M = this.words = M || [], S != i ? this.sigBytes = S : this.sigBytes = M.length * 4;
            },
            /**
             * Converts this word array to a string.
             *
             * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
             *
             * @return {string} The stringified word array.
             *
             * @example
             *
             *     var string = wordArray + '';
             *     var string = wordArray.toString();
             *     var string = wordArray.toString(CryptoJS.enc.Utf8);
             */
            toString: function(M) {
              return (M || y).stringify(this);
            },
            /**
             * Concatenates a word array to this word array.
             *
             * @param {WordArray} wordArray The word array to append.
             *
             * @return {WordArray} This word array.
             *
             * @example
             *
             *     wordArray1.concat(wordArray2);
             */
            concat: function(M) {
              var S = this.words, O = M.words, w = this.sigBytes, D = M.sigBytes;
              if (this.clamp(), w % 4)
                for (var k = 0; k < D; k++) {
                  var F = O[k >>> 2] >>> 24 - k % 4 * 8 & 255;
                  S[w + k >>> 2] |= F << 24 - (w + k) % 4 * 8;
                }
              else
                for (var z = 0; z < D; z += 4)
                  S[w + z >>> 2] = O[z >>> 2];
              return this.sigBytes += D, this;
            },
            /**
             * Removes insignificant bits.
             *
             * @example
             *
             *     wordArray.clamp();
             */
            clamp: function() {
              var M = this.words, S = this.sigBytes;
              M[S >>> 2] &= 4294967295 << 32 - S % 4 * 8, M.length = n.ceil(S / 4);
            },
            /**
             * Creates a copy of this word array.
             *
             * @return {WordArray} The clone.
             *
             * @example
             *
             *     var clone = wordArray.clone();
             */
            clone: function() {
              var M = g.clone.call(this);
              return M.words = this.words.slice(0), M;
            },
            /**
             * Creates a word array filled with random bytes.
             *
             * @param {number} nBytes The number of random bytes to generate.
             *
             * @return {WordArray} The random word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.lib.WordArray.random(16);
             */
            random: function(M) {
              for (var S = [], O = 0; O < M; O += 4)
                S.push(u());
              return new h.init(S, M);
            }
          }), E = f.enc = {}, y = E.Hex = {
            /**
             * Converts a word array to a hex string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The hex string.
             *
             * @static
             *
             * @example
             *
             *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
             */
            stringify: function(M) {
              for (var S = M.words, O = M.sigBytes, w = [], D = 0; D < O; D++) {
                var k = S[D >>> 2] >>> 24 - D % 4 * 8 & 255;
                w.push((k >>> 4).toString(16)), w.push((k & 15).toString(16));
              }
              return w.join("");
            },
            /**
             * Converts a hex string to a word array.
             *
             * @param {string} hexStr The hex string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
             */
            parse: function(M) {
              for (var S = M.length, O = [], w = 0; w < S; w += 2)
                O[w >>> 3] |= parseInt(M.substr(w, 2), 16) << 24 - w % 8 * 4;
              return new h.init(O, S / 2);
            }
          }, I = E.Latin1 = {
            /**
             * Converts a word array to a Latin1 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The Latin1 string.
             *
             * @static
             *
             * @example
             *
             *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
             */
            stringify: function(M) {
              for (var S = M.words, O = M.sigBytes, w = [], D = 0; D < O; D++) {
                var k = S[D >>> 2] >>> 24 - D % 4 * 8 & 255;
                w.push(String.fromCharCode(k));
              }
              return w.join("");
            },
            /**
             * Converts a Latin1 string to a word array.
             *
             * @param {string} latin1Str The Latin1 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
             */
            parse: function(M) {
              for (var S = M.length, O = [], w = 0; w < S; w++)
                O[w >>> 2] |= (M.charCodeAt(w) & 255) << 24 - w % 4 * 8;
              return new h.init(O, S);
            }
          }, Q = E.Utf8 = {
            /**
             * Converts a word array to a UTF-8 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-8 string.
             *
             * @static
             *
             * @example
             *
             *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
             */
            stringify: function(M) {
              try {
                return decodeURIComponent(escape(I.stringify(M)));
              } catch {
                throw new Error("Malformed UTF-8 data");
              }
            },
            /**
             * Converts a UTF-8 string to a word array.
             *
             * @param {string} utf8Str The UTF-8 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
             */
            parse: function(M) {
              return I.parse(unescape(encodeURIComponent(M)));
            }
          }, B = d.BufferedBlockAlgorithm = g.extend({
            /**
             * Resets this block algorithm's data buffer to its initial state.
             *
             * @example
             *
             *     bufferedBlockAlgorithm.reset();
             */
            reset: function() {
              this._data = new h.init(), this._nDataBytes = 0;
            },
            /**
             * Adds new data to this block algorithm's buffer.
             *
             * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
             *
             * @example
             *
             *     bufferedBlockAlgorithm._append('data');
             *     bufferedBlockAlgorithm._append(wordArray);
             */
            _append: function(M) {
              typeof M == "string" && (M = Q.parse(M)), this._data.concat(M), this._nDataBytes += M.sigBytes;
            },
            /**
             * Processes available data blocks.
             *
             * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
             *
             * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
             *
             * @return {WordArray} The processed data.
             *
             * @example
             *
             *     var processedData = bufferedBlockAlgorithm._process();
             *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
             */
            _process: function(M) {
              var S, O = this._data, w = O.words, D = O.sigBytes, k = this.blockSize, F = k * 4, z = D / F;
              M ? z = n.ceil(z) : z = n.max((z | 0) - this._minBufferSize, 0);
              var Z = z * k, V = n.min(Z * 4, D);
              if (Z) {
                for (var $ = 0; $ < Z; $ += k)
                  this._doProcessBlock(w, $);
                S = w.splice(0, Z), O.sigBytes -= V;
              }
              return new h.init(S, V);
            },
            /**
             * Creates a copy of this object.
             *
             * @return {Object} The clone.
             *
             * @example
             *
             *     var clone = bufferedBlockAlgorithm.clone();
             */
            clone: function() {
              var M = g.clone.call(this);
              return M._data = this._data.clone(), M;
            },
            _minBufferSize: 0
          });
          d.Hasher = B.extend({
            /**
             * Configuration options.
             */
            cfg: g.extend(),
            /**
             * Initializes a newly created hasher.
             *
             * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
             *
             * @example
             *
             *     var hasher = CryptoJS.algo.SHA256.create();
             */
            init: function(M) {
              this.cfg = this.cfg.extend(M), this.reset();
            },
            /**
             * Resets this hasher to its initial state.
             *
             * @example
             *
             *     hasher.reset();
             */
            reset: function() {
              B.reset.call(this), this._doReset();
            },
            /**
             * Updates this hasher with a message.
             *
             * @param {WordArray|string} messageUpdate The message to append.
             *
             * @return {Hasher} This hasher.
             *
             * @example
             *
             *     hasher.update('message');
             *     hasher.update(wordArray);
             */
            update: function(M) {
              return this._append(M), this._process(), this;
            },
            /**
             * Finalizes the hash computation.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} messageUpdate (Optional) A final message update.
             *
             * @return {WordArray} The hash.
             *
             * @example
             *
             *     var hash = hasher.finalize();
             *     var hash = hasher.finalize('message');
             *     var hash = hasher.finalize(wordArray);
             */
            finalize: function(M) {
              M && this._append(M);
              var S = this._doFinalize();
              return S;
            },
            blockSize: 16,
            /**
             * Creates a shortcut function to a hasher's object interface.
             *
             * @param {Hasher} hasher The hasher to create a helper for.
             *
             * @return {Function} The shortcut function.
             *
             * @static
             *
             * @example
             *
             *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
             */
            _createHelper: function(M) {
              return function(S, O) {
                return new M.init(O).finalize(S);
              };
            },
            /**
             * Creates a shortcut function to the HMAC's object interface.
             *
             * @param {Hasher} hasher The hasher to use in this HMAC helper.
             *
             * @return {Function} The shortcut function.
             *
             * @static
             *
             * @example
             *
             *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
             */
            _createHmacHelper: function(M) {
              return function(S, O) {
                return new _.HMAC.init(M, O).finalize(S);
              };
            }
          });
          var _ = f.algo = {};
          return f;
        }(Math);
        return r;
      });
    }(tg)), tg.exports;
  }
  var rg = { exports: {} }, tB2 = rg.exports, zV;
  function Gh() {
    return zV || (zV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(tB2, function(r) {
        return function(n) {
          var i = r, o = i.lib, u = o.Base, c = o.WordArray, f = i.x64 = {};
          f.Word = u.extend({
            /**
             * Initializes a newly created 64-bit word.
             *
             * @param {number} high The high 32 bits.
             * @param {number} low The low 32 bits.
             *
             * @example
             *
             *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
             */
            init: function(d, g) {
              this.high = d, this.low = g;
            }
            /**
             * Bitwise NOTs this word.
             *
             * @return {X64Word} A new x64-Word object after negating.
             *
             * @example
             *
             *     var negated = x64Word.not();
             */
            // not: function () {
            // var high = ~this.high;
            // var low = ~this.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise ANDs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to AND with this word.
             *
             * @return {X64Word} A new x64-Word object after ANDing.
             *
             * @example
             *
             *     var anded = x64Word.and(anotherX64Word);
             */
            // and: function (word) {
            // var high = this.high & word.high;
            // var low = this.low & word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise ORs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to OR with this word.
             *
             * @return {X64Word} A new x64-Word object after ORing.
             *
             * @example
             *
             *     var ored = x64Word.or(anotherX64Word);
             */
            // or: function (word) {
            // var high = this.high | word.high;
            // var low = this.low | word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Bitwise XORs this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to XOR with this word.
             *
             * @return {X64Word} A new x64-Word object after XORing.
             *
             * @example
             *
             *     var xored = x64Word.xor(anotherX64Word);
             */
            // xor: function (word) {
            // var high = this.high ^ word.high;
            // var low = this.low ^ word.low;
            // return X64Word.create(high, low);
            // },
            /**
             * Shifts this word n bits to the left.
             *
             * @param {number} n The number of bits to shift.
             *
             * @return {X64Word} A new x64-Word object after shifting.
             *
             * @example
             *
             *     var shifted = x64Word.shiftL(25);
             */
            // shiftL: function (n) {
            // if (n < 32) {
            // var high = (this.high << n) | (this.low >>> (32 - n));
            // var low = this.low << n;
            // } else {
            // var high = this.low << (n - 32);
            // var low = 0;
            // }
            // return X64Word.create(high, low);
            // },
            /**
             * Shifts this word n bits to the right.
             *
             * @param {number} n The number of bits to shift.
             *
             * @return {X64Word} A new x64-Word object after shifting.
             *
             * @example
             *
             *     var shifted = x64Word.shiftR(7);
             */
            // shiftR: function (n) {
            // if (n < 32) {
            // var low = (this.low >>> n) | (this.high << (32 - n));
            // var high = this.high >>> n;
            // } else {
            // var low = this.high >>> (n - 32);
            // var high = 0;
            // }
            // return X64Word.create(high, low);
            // },
            /**
             * Rotates this word n bits to the left.
             *
             * @param {number} n The number of bits to rotate.
             *
             * @return {X64Word} A new x64-Word object after rotating.
             *
             * @example
             *
             *     var rotated = x64Word.rotL(25);
             */
            // rotL: function (n) {
            // return this.shiftL(n).or(this.shiftR(64 - n));
            // },
            /**
             * Rotates this word n bits to the right.
             *
             * @param {number} n The number of bits to rotate.
             *
             * @return {X64Word} A new x64-Word object after rotating.
             *
             * @example
             *
             *     var rotated = x64Word.rotR(7);
             */
            // rotR: function (n) {
            // return this.shiftR(n).or(this.shiftL(64 - n));
            // },
            /**
             * Adds this word with the passed word.
             *
             * @param {X64Word} word The x64-Word to add with this word.
             *
             * @return {X64Word} A new x64-Word object after adding.
             *
             * @example
             *
             *     var added = x64Word.add(anotherX64Word);
             */
            // add: function (word) {
            // var low = (this.low + word.low) | 0;
            // var carry = (low >>> 0) < (this.low >>> 0) ? 1 : 0;
            // var high = (this.high + word.high + carry) | 0;
            // return X64Word.create(high, low);
            // }
          }), f.WordArray = u.extend({
            /**
             * Initializes a newly created word array.
             *
             * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
             * @param {number} sigBytes (Optional) The number of significant bytes in the words.
             *
             * @example
             *
             *     var wordArray = CryptoJS.x64.WordArray.create();
             *
             *     var wordArray = CryptoJS.x64.WordArray.create([
             *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
             *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
             *     ]);
             *
             *     var wordArray = CryptoJS.x64.WordArray.create([
             *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
             *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
             *     ], 10);
             */
            init: function(d, g) {
              d = this.words = d || [], g != n ? this.sigBytes = g : this.sigBytes = d.length * 8;
            },
            /**
             * Converts this 64-bit word array to a 32-bit word array.
             *
             * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
             *
             * @example
             *
             *     var x32WordArray = x64WordArray.toX32();
             */
            toX32: function() {
              for (var d = this.words, g = d.length, h = [], E = 0; E < g; E++) {
                var y = d[E];
                h.push(y.high), h.push(y.low);
              }
              return c.create(h, this.sigBytes);
            },
            /**
             * Creates a copy of this word array.
             *
             * @return {X64WordArray} The clone.
             *
             * @example
             *
             *     var clone = x64WordArray.clone();
             */
            clone: function() {
              for (var d = u.clone.call(this), g = d.words = this.words.slice(0), h = g.length, E = 0; E < h; E++)
                g[E] = g[E].clone();
              return d;
            }
          });
        }(), r;
      });
    }(rg)), rg.exports;
  }
  var ng = { exports: {} }, rB2 = ng.exports, UV;
  function nB2() {
    return UV || (UV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(rB2, function(r) {
        return function() {
          if (typeof ArrayBuffer == "function") {
            var n = r, i = n.lib, o = i.WordArray, u = o.init, c = o.init = function(f) {
              if (f instanceof ArrayBuffer && (f = new Uint8Array(f)), (f instanceof Int8Array || typeof Uint8ClampedArray < "u" && f instanceof Uint8ClampedArray || f instanceof Int16Array || f instanceof Uint16Array || f instanceof Int32Array || f instanceof Uint32Array || f instanceof Float32Array || f instanceof Float64Array) && (f = new Uint8Array(f.buffer, f.byteOffset, f.byteLength)), f instanceof Uint8Array) {
                for (var d = f.byteLength, g = [], h = 0; h < d; h++)
                  g[h >>> 2] |= f[h] << 24 - h % 4 * 8;
                u.call(this, g, d);
              } else
                u.apply(this, arguments);
            };
            c.prototype = o;
          }
        }(), r.lib.WordArray;
      });
    }(ng)), ng.exports;
  }
  var ig = { exports: {} }, iB2 = ig.exports, qV;
  function aB2() {
    return qV || (qV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(iB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = n.enc;
          u.Utf16 = u.Utf16BE = {
            /**
             * Converts a word array to a UTF-16 BE string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-16 BE string.
             *
             * @static
             *
             * @example
             *
             *     var utf16String = CryptoJS.enc.Utf16.stringify(wordArray);
             */
            stringify: function(f) {
              for (var d = f.words, g = f.sigBytes, h = [], E = 0; E < g; E += 2) {
                var y = d[E >>> 2] >>> 16 - E % 4 * 8 & 65535;
                h.push(String.fromCharCode(y));
              }
              return h.join("");
            },
            /**
             * Converts a UTF-16 BE string to a word array.
             *
             * @param {string} utf16Str The UTF-16 BE string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf16.parse(utf16String);
             */
            parse: function(f) {
              for (var d = f.length, g = [], h = 0; h < d; h++)
                g[h >>> 1] |= f.charCodeAt(h) << 16 - h % 2 * 16;
              return o.create(g, d * 2);
            }
          }, u.Utf16LE = {
            /**
             * Converts a word array to a UTF-16 LE string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The UTF-16 LE string.
             *
             * @static
             *
             * @example
             *
             *     var utf16Str = CryptoJS.enc.Utf16LE.stringify(wordArray);
             */
            stringify: function(f) {
              for (var d = f.words, g = f.sigBytes, h = [], E = 0; E < g; E += 2) {
                var y = c(d[E >>> 2] >>> 16 - E % 4 * 8 & 65535);
                h.push(String.fromCharCode(y));
              }
              return h.join("");
            },
            /**
             * Converts a UTF-16 LE string to a word array.
             *
             * @param {string} utf16Str The UTF-16 LE string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Utf16LE.parse(utf16Str);
             */
            parse: function(f) {
              for (var d = f.length, g = [], h = 0; h < d; h++)
                g[h >>> 1] |= c(f.charCodeAt(h) << 16 - h % 2 * 16);
              return o.create(g, d * 2);
            }
          };
          function c(f) {
            return f << 8 & 4278255360 | f >>> 8 & 16711935;
          }
        }(), r.enc.Utf16;
      });
    }(ig)), ig.exports;
  }
  var ag = { exports: {} }, oB2 = ag.exports, WV;
  function na() {
    return WV || (WV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(oB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = n.enc;
          u.Base64 = {
            /**
             * Converts a word array to a Base64 string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @return {string} The Base64 string.
             *
             * @static
             *
             * @example
             *
             *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
             */
            stringify: function(f) {
              var d = f.words, g = f.sigBytes, h = this._map;
              f.clamp();
              for (var E = [], y = 0; y < g; y += 3)
                for (var I = d[y >>> 2] >>> 24 - y % 4 * 8 & 255, Q = d[y + 1 >>> 2] >>> 24 - (y + 1) % 4 * 8 & 255, B = d[y + 2 >>> 2] >>> 24 - (y + 2) % 4 * 8 & 255, _ = I << 16 | Q << 8 | B, M = 0; M < 4 && y + M * 0.75 < g; M++)
                  E.push(h.charAt(_ >>> 6 * (3 - M) & 63));
              var S = h.charAt(64);
              if (S)
                for (; E.length % 4; )
                  E.push(S);
              return E.join("");
            },
            /**
             * Converts a Base64 string to a word array.
             *
             * @param {string} base64Str The Base64 string.
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
             */
            parse: function(f) {
              var d = f.length, g = this._map, h = this._reverseMap;
              if (!h) {
                h = this._reverseMap = [];
                for (var E = 0; E < g.length; E++)
                  h[g.charCodeAt(E)] = E;
              }
              var y = g.charAt(64);
              if (y) {
                var I = f.indexOf(y);
                I !== -1 && (d = I);
              }
              return c(f, d, h);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="
          };
          function c(f, d, g) {
            for (var h = [], E = 0, y = 0; y < d; y++)
              if (y % 4) {
                var I = g[f.charCodeAt(y - 1)] << y % 4 * 2, Q = g[f.charCodeAt(y)] >>> 6 - y % 4 * 2, B = I | Q;
                h[E >>> 2] |= B << 24 - E % 4 * 8, E++;
              }
            return o.create(h, E);
          }
        }(), r.enc.Base64;
      });
    }(ag)), ag.exports;
  }
  var og = { exports: {} }, sB2 = og.exports, YV;
  function uB2() {
    return YV || (YV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(sB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = n.enc;
          u.Base64url = {
            /**
             * Converts a word array to a Base64url string.
             *
             * @param {WordArray} wordArray The word array.
             *
             * @param {boolean} urlSafe Whether to use url safe
             *
             * @return {string} The Base64url string.
             *
             * @static
             *
             * @example
             *
             *     var base64String = CryptoJS.enc.Base64url.stringify(wordArray);
             */
            stringify: function(f, d) {
              d === void 0 && (d = !0);
              var g = f.words, h = f.sigBytes, E = d ? this._safe_map : this._map;
              f.clamp();
              for (var y = [], I = 0; I < h; I += 3)
                for (var Q = g[I >>> 2] >>> 24 - I % 4 * 8 & 255, B = g[I + 1 >>> 2] >>> 24 - (I + 1) % 4 * 8 & 255, _ = g[I + 2 >>> 2] >>> 24 - (I + 2) % 4 * 8 & 255, M = Q << 16 | B << 8 | _, S = 0; S < 4 && I + S * 0.75 < h; S++)
                  y.push(E.charAt(M >>> 6 * (3 - S) & 63));
              var O = E.charAt(64);
              if (O)
                for (; y.length % 4; )
                  y.push(O);
              return y.join("");
            },
            /**
             * Converts a Base64url string to a word array.
             *
             * @param {string} base64Str The Base64url string.
             *
             * @param {boolean} urlSafe Whether to use url safe
             *
             * @return {WordArray} The word array.
             *
             * @static
             *
             * @example
             *
             *     var wordArray = CryptoJS.enc.Base64url.parse(base64String);
             */
            parse: function(f, d) {
              d === void 0 && (d = !0);
              var g = f.length, h = d ? this._safe_map : this._map, E = this._reverseMap;
              if (!E) {
                E = this._reverseMap = [];
                for (var y = 0; y < h.length; y++)
                  E[h.charCodeAt(y)] = y;
              }
              var I = h.charAt(64);
              if (I) {
                var Q = f.indexOf(I);
                Q !== -1 && (g = Q);
              }
              return c(f, g, E);
            },
            _map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
            _safe_map: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"
          };
          function c(f, d, g) {
            for (var h = [], E = 0, y = 0; y < d; y++)
              if (y % 4) {
                var I = g[f.charCodeAt(y - 1)] << y % 4 * 2, Q = g[f.charCodeAt(y)] >>> 6 - y % 4 * 2, B = I | Q;
                h[E >>> 2] |= B << 24 - E % 4 * 8, E++;
              }
            return o.create(h, E);
          }
        }(), r.enc.Base64url;
      });
    }(og)), og.exports;
  }
  var sg = { exports: {} }, lB2 = sg.exports, $V;
  function ia() {
    return $V || ($V = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(lB2, function(r) {
        return function(n) {
          var i = r, o = i.lib, u = o.WordArray, c = o.Hasher, f = i.algo, d = [];
          (function() {
            for (var Q = 0; Q < 64; Q++)
              d[Q] = n.abs(n.sin(Q + 1)) * 4294967296 | 0;
          })();
          var g = f.MD5 = c.extend({
            _doReset: function() {
              this._hash = new u.init([
                1732584193,
                4023233417,
                2562383102,
                271733878
              ]);
            },
            _doProcessBlock: function(Q, B) {
              for (var _ = 0; _ < 16; _++) {
                var M = B + _, S = Q[M];
                Q[M] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360;
              }
              var O = this._hash.words, w = Q[B + 0], D = Q[B + 1], k = Q[B + 2], F = Q[B + 3], z = Q[B + 4], Z = Q[B + 5], V = Q[B + 6], $ = Q[B + 7], W = Q[B + 8], t2 = Q[B + 9], n2 = Q[B + 10], s2 = Q[B + 11], l2 = Q[B + 12], X = Q[B + 13], a2 = Q[B + 14], e2 = Q[B + 15], H = O[0], Y = O[1], r2 = O[2], o2 = O[3];
              H = h(H, Y, r2, o2, w, 7, d[0]), o2 = h(o2, H, Y, r2, D, 12, d[1]), r2 = h(r2, o2, H, Y, k, 17, d[2]), Y = h(Y, r2, o2, H, F, 22, d[3]), H = h(H, Y, r2, o2, z, 7, d[4]), o2 = h(o2, H, Y, r2, Z, 12, d[5]), r2 = h(r2, o2, H, Y, V, 17, d[6]), Y = h(Y, r2, o2, H, $, 22, d[7]), H = h(H, Y, r2, o2, W, 7, d[8]), o2 = h(o2, H, Y, r2, t2, 12, d[9]), r2 = h(r2, o2, H, Y, n2, 17, d[10]), Y = h(Y, r2, o2, H, s2, 22, d[11]), H = h(H, Y, r2, o2, l2, 7, d[12]), o2 = h(o2, H, Y, r2, X, 12, d[13]), r2 = h(r2, o2, H, Y, a2, 17, d[14]), Y = h(Y, r2, o2, H, e2, 22, d[15]), H = E(H, Y, r2, o2, D, 5, d[16]), o2 = E(o2, H, Y, r2, V, 9, d[17]), r2 = E(r2, o2, H, Y, s2, 14, d[18]), Y = E(Y, r2, o2, H, w, 20, d[19]), H = E(H, Y, r2, o2, Z, 5, d[20]), o2 = E(o2, H, Y, r2, n2, 9, d[21]), r2 = E(r2, o2, H, Y, e2, 14, d[22]), Y = E(Y, r2, o2, H, z, 20, d[23]), H = E(H, Y, r2, o2, t2, 5, d[24]), o2 = E(o2, H, Y, r2, a2, 9, d[25]), r2 = E(r2, o2, H, Y, F, 14, d[26]), Y = E(Y, r2, o2, H, W, 20, d[27]), H = E(H, Y, r2, o2, X, 5, d[28]), o2 = E(o2, H, Y, r2, k, 9, d[29]), r2 = E(r2, o2, H, Y, $, 14, d[30]), Y = E(Y, r2, o2, H, l2, 20, d[31]), H = y(H, Y, r2, o2, Z, 4, d[32]), o2 = y(o2, H, Y, r2, W, 11, d[33]), r2 = y(r2, o2, H, Y, s2, 16, d[34]), Y = y(Y, r2, o2, H, a2, 23, d[35]), H = y(H, Y, r2, o2, D, 4, d[36]), o2 = y(o2, H, Y, r2, z, 11, d[37]), r2 = y(r2, o2, H, Y, $, 16, d[38]), Y = y(Y, r2, o2, H, n2, 23, d[39]), H = y(H, Y, r2, o2, X, 4, d[40]), o2 = y(o2, H, Y, r2, w, 11, d[41]), r2 = y(r2, o2, H, Y, F, 16, d[42]), Y = y(Y, r2, o2, H, V, 23, d[43]), H = y(H, Y, r2, o2, t2, 4, d[44]), o2 = y(o2, H, Y, r2, l2, 11, d[45]), r2 = y(r2, o2, H, Y, e2, 16, d[46]), Y = y(Y, r2, o2, H, k, 23, d[47]), H = I(H, Y, r2, o2, w, 6, d[48]), o2 = I(o2, H, Y, r2, $, 10, d[49]), r2 = I(r2, o2, H, Y, a2, 15, d[50]), Y = I(Y, r2, o2, H, Z, 21, d[51]), H = I(H, Y, r2, o2, l2, 6, d[52]), o2 = I(o2, H, Y, r2, F, 10, d[53]), r2 = I(r2, o2, H, Y, n2, 15, d[54]), Y = I(Y, r2, o2, H, D, 21, d[55]), H = I(H, Y, r2, o2, W, 6, d[56]), o2 = I(o2, H, Y, r2, e2, 10, d[57]), r2 = I(r2, o2, H, Y, V, 15, d[58]), Y = I(Y, r2, o2, H, X, 21, d[59]), H = I(H, Y, r2, o2, z, 6, d[60]), o2 = I(o2, H, Y, r2, s2, 10, d[61]), r2 = I(r2, o2, H, Y, k, 15, d[62]), Y = I(Y, r2, o2, H, t2, 21, d[63]), O[0] = O[0] + H | 0, O[1] = O[1] + Y | 0, O[2] = O[2] + r2 | 0, O[3] = O[3] + o2 | 0;
            },
            _doFinalize: function() {
              var Q = this._data, B = Q.words, _ = this._nDataBytes * 8, M = Q.sigBytes * 8;
              B[M >>> 5] |= 128 << 24 - M % 32;
              var S = n.floor(_ / 4294967296), O = _;
              B[(M + 64 >>> 9 << 4) + 15] = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, B[(M + 64 >>> 9 << 4) + 14] = (O << 8 | O >>> 24) & 16711935 | (O << 24 | O >>> 8) & 4278255360, Q.sigBytes = (B.length + 1) * 4, this._process();
              for (var w = this._hash, D = w.words, k = 0; k < 4; k++) {
                var F = D[k];
                D[k] = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360;
              }
              return w;
            },
            clone: function() {
              var Q = c.clone.call(this);
              return Q._hash = this._hash.clone(), Q;
            }
          });
          function h(Q, B, _, M, S, O, w) {
            var D = Q + (B & _ | ~B & M) + S + w;
            return (D << O | D >>> 32 - O) + B;
          }
          function E(Q, B, _, M, S, O, w) {
            var D = Q + (B & M | _ & ~M) + S + w;
            return (D << O | D >>> 32 - O) + B;
          }
          function y(Q, B, _, M, S, O, w) {
            var D = Q + (B ^ _ ^ M) + S + w;
            return (D << O | D >>> 32 - O) + B;
          }
          function I(Q, B, _, M, S, O, w) {
            var D = Q + (_ ^ (B | ~M)) + S + w;
            return (D << O | D >>> 32 - O) + B;
          }
          i.MD5 = c._createHelper(g), i.HmacMD5 = c._createHmacHelper(g);
        }(Math), r.MD5;
      });
    }(sg)), sg.exports;
  }
  var ug = { exports: {} }, cB2 = ug.exports, GV;
  function jG() {
    return GV || (GV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(cB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = i.Hasher, c = n.algo, f = [], d = c.SHA1 = u.extend({
            _doReset: function() {
              this._hash = new o.init([
                1732584193,
                4023233417,
                2562383102,
                271733878,
                3285377520
              ]);
            },
            _doProcessBlock: function(g, h) {
              for (var E = this._hash.words, y = E[0], I = E[1], Q = E[2], B = E[3], _ = E[4], M = 0; M < 80; M++) {
                if (M < 16)
                  f[M] = g[h + M] | 0;
                else {
                  var S = f[M - 3] ^ f[M - 8] ^ f[M - 14] ^ f[M - 16];
                  f[M] = S << 1 | S >>> 31;
                }
                var O = (y << 5 | y >>> 27) + _ + f[M];
                M < 20 ? O += (I & Q | ~I & B) + 1518500249 : M < 40 ? O += (I ^ Q ^ B) + 1859775393 : M < 60 ? O += (I & Q | I & B | Q & B) - 1894007588 : O += (I ^ Q ^ B) - 899497514, _ = B, B = Q, Q = I << 30 | I >>> 2, I = y, y = O;
              }
              E[0] = E[0] + y | 0, E[1] = E[1] + I | 0, E[2] = E[2] + Q | 0, E[3] = E[3] + B | 0, E[4] = E[4] + _ | 0;
            },
            _doFinalize: function() {
              var g = this._data, h = g.words, E = this._nDataBytes * 8, y = g.sigBytes * 8;
              return h[y >>> 5] |= 128 << 24 - y % 32, h[(y + 64 >>> 9 << 4) + 14] = Math.floor(E / 4294967296), h[(y + 64 >>> 9 << 4) + 15] = E, g.sigBytes = h.length * 4, this._process(), this._hash;
            },
            clone: function() {
              var g = u.clone.call(this);
              return g._hash = this._hash.clone(), g;
            }
          });
          n.SHA1 = u._createHelper(d), n.HmacSHA1 = u._createHmacHelper(d);
        }(), r.SHA1;
      });
    }(ug)), ug.exports;
  }
  var lg = { exports: {} }, AB2 = lg.exports, KV;
  function c_() {
    return KV || (KV = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(AB2, function(r) {
        return function(n) {
          var i = r, o = i.lib, u = o.WordArray, c = o.Hasher, f = i.algo, d = [], g = [];
          (function() {
            function y(_) {
              for (var M = n.sqrt(_), S = 2; S <= M; S++)
                if (!(_ % S))
                  return !1;
              return !0;
            }
            function I(_) {
              return (_ - (_ | 0)) * 4294967296 | 0;
            }
            for (var Q = 2, B = 0; B < 64; )
              y(Q) && (B < 8 && (d[B] = I(n.pow(Q, 1 / 2))), g[B] = I(n.pow(Q, 1 / 3)), B++), Q++;
          })();
          var h = [], E = f.SHA256 = c.extend({
            _doReset: function() {
              this._hash = new u.init(d.slice(0));
            },
            _doProcessBlock: function(y, I) {
              for (var Q = this._hash.words, B = Q[0], _ = Q[1], M = Q[2], S = Q[3], O = Q[4], w = Q[5], D = Q[6], k = Q[7], F = 0; F < 64; F++) {
                if (F < 16)
                  h[F] = y[I + F] | 0;
                else {
                  var z = h[F - 15], Z = (z << 25 | z >>> 7) ^ (z << 14 | z >>> 18) ^ z >>> 3, V = h[F - 2], $ = (V << 15 | V >>> 17) ^ (V << 13 | V >>> 19) ^ V >>> 10;
                  h[F] = Z + h[F - 7] + $ + h[F - 16];
                }
                var W = O & w ^ ~O & D, t2 = B & _ ^ B & M ^ _ & M, n2 = (B << 30 | B >>> 2) ^ (B << 19 | B >>> 13) ^ (B << 10 | B >>> 22), s2 = (O << 26 | O >>> 6) ^ (O << 21 | O >>> 11) ^ (O << 7 | O >>> 25), l2 = k + s2 + W + g[F] + h[F], X = n2 + t2;
                k = D, D = w, w = O, O = S + l2 | 0, S = M, M = _, _ = B, B = l2 + X | 0;
              }
              Q[0] = Q[0] + B | 0, Q[1] = Q[1] + _ | 0, Q[2] = Q[2] + M | 0, Q[3] = Q[3] + S | 0, Q[4] = Q[4] + O | 0, Q[5] = Q[5] + w | 0, Q[6] = Q[6] + D | 0, Q[7] = Q[7] + k | 0;
            },
            _doFinalize: function() {
              var y = this._data, I = y.words, Q = this._nDataBytes * 8, B = y.sigBytes * 8;
              return I[B >>> 5] |= 128 << 24 - B % 32, I[(B + 64 >>> 9 << 4) + 14] = n.floor(Q / 4294967296), I[(B + 64 >>> 9 << 4) + 15] = Q, y.sigBytes = I.length * 4, this._process(), this._hash;
            },
            clone: function() {
              var y = c.clone.call(this);
              return y._hash = this._hash.clone(), y;
            }
          });
          i.SHA256 = c._createHelper(E), i.HmacSHA256 = c._createHmacHelper(E);
        }(Math), r.SHA256;
      });
    }(lg)), lg.exports;
  }
  var cg = { exports: {} }, fB2 = cg.exports, XV;
  function CB2() {
    return XV || (XV = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), c_());
      })(fB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = n.algo, c = u.SHA256, f = u.SHA224 = c.extend({
            _doReset: function() {
              this._hash = new o.init([
                3238371032,
                914150663,
                812702999,
                4144912697,
                4290775857,
                1750603025,
                1694076839,
                3204075428
              ]);
            },
            _doFinalize: function() {
              var d = c._doFinalize.call(this);
              return d.sigBytes -= 4, d;
            }
          });
          n.SHA224 = c._createHelper(f), n.HmacSHA224 = c._createHmacHelper(f);
        }(), r.SHA224;
      });
    }(cg)), cg.exports;
  }
  var Ag = { exports: {} }, dB2 = Ag.exports, JV;
  function VG() {
    return JV || (JV = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), Gh());
      })(dB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.Hasher, u = n.x64, c = u.Word, f = u.WordArray, d = n.algo;
          function g() {
            return c.create.apply(c, arguments);
          }
          var h = [
            g(1116352408, 3609767458),
            g(1899447441, 602891725),
            g(3049323471, 3964484399),
            g(3921009573, 2173295548),
            g(961987163, 4081628472),
            g(1508970993, 3053834265),
            g(2453635748, 2937671579),
            g(2870763221, 3664609560),
            g(3624381080, 2734883394),
            g(310598401, 1164996542),
            g(607225278, 1323610764),
            g(1426881987, 3590304994),
            g(1925078388, 4068182383),
            g(2162078206, 991336113),
            g(2614888103, 633803317),
            g(3248222580, 3479774868),
            g(3835390401, 2666613458),
            g(4022224774, 944711139),
            g(264347078, 2341262773),
            g(604807628, 2007800933),
            g(770255983, 1495990901),
            g(1249150122, 1856431235),
            g(1555081692, 3175218132),
            g(1996064986, 2198950837),
            g(2554220882, 3999719339),
            g(2821834349, 766784016),
            g(2952996808, 2566594879),
            g(3210313671, 3203337956),
            g(3336571891, 1034457026),
            g(3584528711, 2466948901),
            g(113926993, 3758326383),
            g(338241895, 168717936),
            g(666307205, 1188179964),
            g(773529912, 1546045734),
            g(1294757372, 1522805485),
            g(1396182291, 2643833823),
            g(1695183700, 2343527390),
            g(1986661051, 1014477480),
            g(2177026350, 1206759142),
            g(2456956037, 344077627),
            g(2730485921, 1290863460),
            g(2820302411, 3158454273),
            g(3259730800, 3505952657),
            g(3345764771, 106217008),
            g(3516065817, 3606008344),
            g(3600352804, 1432725776),
            g(4094571909, 1467031594),
            g(275423344, 851169720),
            g(430227734, 3100823752),
            g(506948616, 1363258195),
            g(659060556, 3750685593),
            g(883997877, 3785050280),
            g(958139571, 3318307427),
            g(1322822218, 3812723403),
            g(1537002063, 2003034995),
            g(1747873779, 3602036899),
            g(1955562222, 1575990012),
            g(2024104815, 1125592928),
            g(2227730452, 2716904306),
            g(2361852424, 442776044),
            g(2428436474, 593698344),
            g(2756734187, 3733110249),
            g(3204031479, 2999351573),
            g(3329325298, 3815920427),
            g(3391569614, 3928383900),
            g(3515267271, 566280711),
            g(3940187606, 3454069534),
            g(4118630271, 4000239992),
            g(116418474, 1914138554),
            g(174292421, 2731055270),
            g(289380356, 3203993006),
            g(460393269, 320620315),
            g(685471733, 587496836),
            g(852142971, 1086792851),
            g(1017036298, 365543100),
            g(1126000580, 2618297676),
            g(1288033470, 3409855158),
            g(1501505948, 4234509866),
            g(1607167915, 987167468),
            g(1816402316, 1246189591)
          ], E = [];
          (function() {
            for (var I = 0; I < 80; I++)
              E[I] = g();
          })();
          var y = d.SHA512 = o.extend({
            _doReset: function() {
              this._hash = new f.init([
                new c.init(1779033703, 4089235720),
                new c.init(3144134277, 2227873595),
                new c.init(1013904242, 4271175723),
                new c.init(2773480762, 1595750129),
                new c.init(1359893119, 2917565137),
                new c.init(2600822924, 725511199),
                new c.init(528734635, 4215389547),
                new c.init(1541459225, 327033209)
              ]);
            },
            _doProcessBlock: function(I, Q) {
              for (var B = this._hash.words, _ = B[0], M = B[1], S = B[2], O = B[3], w = B[4], D = B[5], k = B[6], F = B[7], z = _.high, Z = _.low, V = M.high, $ = M.low, W = S.high, t2 = S.low, n2 = O.high, s2 = O.low, l2 = w.high, X = w.low, a2 = D.high, e2 = D.low, H = k.high, Y = k.low, r2 = F.high, o2 = F.low, O2 = z, S2 = Z, M2 = V, w2 = $, v2 = W, L2 = t2, W2 = n2, d2 = s2, X2 = l2, k2 = X, b0 = a2, S0 = e2, G0 = H, $e = Y, _e = r2, Oe = o2, U0 = 0; U0 < 80; U0++) {
                var Z0, Te, Lt = E[U0];
                if (U0 < 16)
                  Te = Lt.high = I[Q + U0 * 2] | 0, Z0 = Lt.low = I[Q + U0 * 2 + 1] | 0;
                else {
                  var Ge = E[U0 - 15], rt = Ge.high, yt = Ge.low, D1 = (rt >>> 1 | yt << 31) ^ (rt >>> 8 | yt << 24) ^ rt >>> 7, L1 = (yt >>> 1 | rt << 31) ^ (yt >>> 8 | rt << 24) ^ (yt >>> 7 | rt << 25), Y2 = E[U0 - 2], c0 = Y2.high, k0 = Y2.low, fe = (c0 >>> 19 | k0 << 13) ^ (c0 << 3 | k0 >>> 29) ^ c0 >>> 6, De = (k0 >>> 19 | c0 << 13) ^ (k0 << 3 | c0 >>> 29) ^ (k0 >>> 6 | c0 << 26), nt = E[U0 - 7], Ke = nt.high, kt = nt.low, Le = E[U0 - 16], be = Le.high, Qe = Le.low;
                  Z0 = L1 + kt, Te = D1 + Ke + (Z0 >>> 0 < L1 >>> 0 ? 1 : 0), Z0 = Z0 + De, Te = Te + fe + (Z0 >>> 0 < De >>> 0 ? 1 : 0), Z0 = Z0 + Qe, Te = Te + be + (Z0 >>> 0 < Qe >>> 0 ? 1 : 0), Lt.high = Te, Lt.low = Z0;
                }
                var Z5 = X2 & b0 ^ ~X2 & G0, Gt = k2 & S0 ^ ~k2 & $e, c1 = O2 & M2 ^ O2 & v2 ^ M2 & v2, Br = S2 & w2 ^ S2 & L2 ^ w2 & L2, T4 = (O2 >>> 28 | S2 << 4) ^ (O2 << 30 | S2 >>> 2) ^ (O2 << 25 | S2 >>> 7), Yr = (S2 >>> 28 | O2 << 4) ^ (S2 << 30 | O2 >>> 2) ^ (S2 << 25 | O2 >>> 7), $r = (X2 >>> 14 | k2 << 18) ^ (X2 >>> 18 | k2 << 14) ^ (X2 << 23 | k2 >>> 9), Gr = (k2 >>> 14 | X2 << 18) ^ (k2 >>> 18 | X2 << 14) ^ (k2 << 23 | X2 >>> 9), Kr = h[U0], g5 = Kr.high, o5 = Kr.low, xe = Oe + Gr, Kt = _e + $r + (xe >>> 0 < Oe >>> 0 ? 1 : 0), xe = xe + Gt, Kt = Kt + Z5 + (xe >>> 0 < Gt >>> 0 ? 1 : 0), xe = xe + o5, Kt = Kt + g5 + (xe >>> 0 < o5 >>> 0 ? 1 : 0), xe = xe + Z0, Kt = Kt + Te + (xe >>> 0 < Z0 >>> 0 ? 1 : 0), A1 = Yr + Br, X1 = T4 + c1 + (A1 >>> 0 < Yr >>> 0 ? 1 : 0);
                _e = G0, Oe = $e, G0 = b0, $e = S0, b0 = X2, S0 = k2, k2 = d2 + xe | 0, X2 = W2 + Kt + (k2 >>> 0 < d2 >>> 0 ? 1 : 0) | 0, W2 = v2, d2 = L2, v2 = M2, L2 = w2, M2 = O2, w2 = S2, S2 = xe + A1 | 0, O2 = Kt + X1 + (S2 >>> 0 < xe >>> 0 ? 1 : 0) | 0;
              }
              Z = _.low = Z + S2, _.high = z + O2 + (Z >>> 0 < S2 >>> 0 ? 1 : 0), $ = M.low = $ + w2, M.high = V + M2 + ($ >>> 0 < w2 >>> 0 ? 1 : 0), t2 = S.low = t2 + L2, S.high = W + v2 + (t2 >>> 0 < L2 >>> 0 ? 1 : 0), s2 = O.low = s2 + d2, O.high = n2 + W2 + (s2 >>> 0 < d2 >>> 0 ? 1 : 0), X = w.low = X + k2, w.high = l2 + X2 + (X >>> 0 < k2 >>> 0 ? 1 : 0), e2 = D.low = e2 + S0, D.high = a2 + b0 + (e2 >>> 0 < S0 >>> 0 ? 1 : 0), Y = k.low = Y + $e, k.high = H + G0 + (Y >>> 0 < $e >>> 0 ? 1 : 0), o2 = F.low = o2 + Oe, F.high = r2 + _e + (o2 >>> 0 < Oe >>> 0 ? 1 : 0);
            },
            _doFinalize: function() {
              var I = this._data, Q = I.words, B = this._nDataBytes * 8, _ = I.sigBytes * 8;
              Q[_ >>> 5] |= 128 << 24 - _ % 32, Q[(_ + 128 >>> 10 << 5) + 30] = Math.floor(B / 4294967296), Q[(_ + 128 >>> 10 << 5) + 31] = B, I.sigBytes = Q.length * 4, this._process();
              var M = this._hash.toX32();
              return M;
            },
            clone: function() {
              var I = o.clone.call(this);
              return I._hash = this._hash.clone(), I;
            },
            blockSize: 1024 / 32
          });
          n.SHA512 = o._createHelper(y), n.HmacSHA512 = o._createHmacHelper(y);
        }(), r.SHA512;
      });
    }(Ag)), Ag.exports;
  }
  var fg = { exports: {} }, gB2 = fg.exports, eZ;
  function pB2() {
    return eZ || (eZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), Gh(), VG());
      })(gB2, function(r) {
        return function() {
          var n = r, i = n.x64, o = i.Word, u = i.WordArray, c = n.algo, f = c.SHA512, d = c.SHA384 = f.extend({
            _doReset: function() {
              this._hash = new u.init([
                new o.init(3418070365, 3238371032),
                new o.init(1654270250, 914150663),
                new o.init(2438529370, 812702999),
                new o.init(355462360, 4144912697),
                new o.init(1731405415, 4290775857),
                new o.init(2394180231, 1750603025),
                new o.init(3675008525, 1694076839),
                new o.init(1203062813, 3204075428)
              ]);
            },
            _doFinalize: function() {
              var g = f._doFinalize.call(this);
              return g.sigBytes -= 16, g;
            }
          });
          n.SHA384 = f._createHelper(d), n.HmacSHA384 = f._createHmacHelper(d);
        }(), r.SHA384;
      });
    }(fg)), fg.exports;
  }
  var Cg = { exports: {} }, hB2 = Cg.exports, tZ;
  function vB2() {
    return tZ || (tZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), Gh());
      })(hB2, function(r) {
        return function(n) {
          var i = r, o = i.lib, u = o.WordArray, c = o.Hasher, f = i.x64, d = f.Word, g = i.algo, h = [], E = [], y = [];
          (function() {
            for (var B = 1, _ = 0, M = 0; M < 24; M++) {
              h[B + 5 * _] = (M + 1) * (M + 2) / 2 % 64;
              var S = _ % 5, O = (2 * B + 3 * _) % 5;
              B = S, _ = O;
            }
            for (var B = 0; B < 5; B++)
              for (var _ = 0; _ < 5; _++)
                E[B + 5 * _] = _ + (2 * B + 3 * _) % 5 * 5;
            for (var w = 1, D = 0; D < 24; D++) {
              for (var k = 0, F = 0, z = 0; z < 7; z++) {
                if (w & 1) {
                  var Z = (1 << z) - 1;
                  Z < 32 ? F ^= 1 << Z : k ^= 1 << Z - 32;
                }
                w & 128 ? w = w << 1 ^ 113 : w <<= 1;
              }
              y[D] = d.create(k, F);
            }
          })();
          var I = [];
          (function() {
            for (var B = 0; B < 25; B++)
              I[B] = d.create();
          })();
          var Q = g.SHA3 = c.extend({
            /**
             * Configuration options.
             *
             * @property {number} outputLength
             *   The desired number of bits in the output hash.
             *   Only values permitted are: 224, 256, 384, 512.
             *   Default: 512
             */
            cfg: c.cfg.extend({
              outputLength: 512
            }),
            _doReset: function() {
              for (var B = this._state = [], _ = 0; _ < 25; _++)
                B[_] = new d.init();
              this.blockSize = (1600 - 2 * this.cfg.outputLength) / 32;
            },
            _doProcessBlock: function(B, _) {
              for (var M = this._state, S = this.blockSize / 2, O = 0; O < S; O++) {
                var w = B[_ + 2 * O], D = B[_ + 2 * O + 1];
                w = (w << 8 | w >>> 24) & 16711935 | (w << 24 | w >>> 8) & 4278255360, D = (D << 8 | D >>> 24) & 16711935 | (D << 24 | D >>> 8) & 4278255360;
                var k = M[O];
                k.high ^= D, k.low ^= w;
              }
              for (var F = 0; F < 24; F++) {
                for (var z = 0; z < 5; z++) {
                  for (var Z = 0, V = 0, $ = 0; $ < 5; $++) {
                    var k = M[z + 5 * $];
                    Z ^= k.high, V ^= k.low;
                  }
                  var W = I[z];
                  W.high = Z, W.low = V;
                }
                for (var z = 0; z < 5; z++)
                  for (var t2 = I[(z + 4) % 5], n2 = I[(z + 1) % 5], s2 = n2.high, l2 = n2.low, Z = t2.high ^ (s2 << 1 | l2 >>> 31), V = t2.low ^ (l2 << 1 | s2 >>> 31), $ = 0; $ < 5; $++) {
                    var k = M[z + 5 * $];
                    k.high ^= Z, k.low ^= V;
                  }
                for (var X = 1; X < 25; X++) {
                  var Z, V, k = M[X], a2 = k.high, e2 = k.low, H = h[X];
                  H < 32 ? (Z = a2 << H | e2 >>> 32 - H, V = e2 << H | a2 >>> 32 - H) : (Z = e2 << H - 32 | a2 >>> 64 - H, V = a2 << H - 32 | e2 >>> 64 - H);
                  var Y = I[E[X]];
                  Y.high = Z, Y.low = V;
                }
                var r2 = I[0], o2 = M[0];
                r2.high = o2.high, r2.low = o2.low;
                for (var z = 0; z < 5; z++)
                  for (var $ = 0; $ < 5; $++) {
                    var X = z + 5 * $, k = M[X], O2 = I[X], S2 = I[(z + 1) % 5 + 5 * $], M2 = I[(z + 2) % 5 + 5 * $];
                    k.high = O2.high ^ ~S2.high & M2.high, k.low = O2.low ^ ~S2.low & M2.low;
                  }
                var k = M[0], w2 = y[F];
                k.high ^= w2.high, k.low ^= w2.low;
              }
            },
            _doFinalize: function() {
              var B = this._data, _ = B.words;
              this._nDataBytes * 8;
              var M = B.sigBytes * 8, S = this.blockSize * 32;
              _[M >>> 5] |= 1 << 24 - M % 32, _[(n.ceil((M + 1) / S) * S >>> 5) - 1] |= 128, B.sigBytes = _.length * 4, this._process();
              for (var O = this._state, w = this.cfg.outputLength / 8, D = w / 8, k = [], F = 0; F < D; F++) {
                var z = O[F], Z = z.high, V = z.low;
                Z = (Z << 8 | Z >>> 24) & 16711935 | (Z << 24 | Z >>> 8) & 4278255360, V = (V << 8 | V >>> 24) & 16711935 | (V << 24 | V >>> 8) & 4278255360, k.push(V), k.push(Z);
              }
              return new u.init(k, w);
            },
            clone: function() {
              for (var B = c.clone.call(this), _ = B._state = this._state.slice(0), M = 0; M < 25; M++)
                _[M] = _[M].clone();
              return B;
            }
          });
          i.SHA3 = c._createHelper(Q), i.HmacSHA3 = c._createHmacHelper(Q);
        }(Math), r.SHA3;
      });
    }(Cg)), Cg.exports;
  }
  var dg = { exports: {} }, EB2 = dg.exports, rZ;
  function mB2() {
    return rZ || (rZ = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(EB2, function(r) {
        /** @preserve
        			(c) 2012 by Cédric Mesnil. All rights reserved.
        
        			Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
        
        			    - Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
        			    - Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
        
        			THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
        			*/
        return function(n) {
          var i = r, o = i.lib, u = o.WordArray, c = o.Hasher, f = i.algo, d = u.create([
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12,
            13,
            14,
            15,
            7,
            4,
            13,
            1,
            10,
            6,
            15,
            3,
            12,
            0,
            9,
            5,
            2,
            14,
            11,
            8,
            3,
            10,
            14,
            4,
            9,
            15,
            8,
            1,
            2,
            7,
            0,
            6,
            13,
            11,
            5,
            12,
            1,
            9,
            11,
            10,
            0,
            8,
            12,
            4,
            13,
            3,
            7,
            15,
            14,
            5,
            6,
            2,
            4,
            0,
            5,
            9,
            7,
            12,
            2,
            10,
            14,
            1,
            3,
            8,
            11,
            6,
            15,
            13
          ]), g = u.create([
            5,
            14,
            7,
            0,
            9,
            2,
            11,
            4,
            13,
            6,
            15,
            8,
            1,
            10,
            3,
            12,
            6,
            11,
            3,
            7,
            0,
            13,
            5,
            10,
            14,
            15,
            8,
            12,
            4,
            9,
            1,
            2,
            15,
            5,
            1,
            3,
            7,
            14,
            6,
            9,
            11,
            8,
            12,
            2,
            10,
            0,
            4,
            13,
            8,
            6,
            4,
            1,
            3,
            11,
            15,
            0,
            5,
            12,
            2,
            13,
            9,
            7,
            10,
            14,
            12,
            15,
            10,
            4,
            1,
            5,
            8,
            7,
            6,
            2,
            13,
            14,
            0,
            3,
            9,
            11
          ]), h = u.create([
            11,
            14,
            15,
            12,
            5,
            8,
            7,
            9,
            11,
            13,
            14,
            15,
            6,
            7,
            9,
            8,
            7,
            6,
            8,
            13,
            11,
            9,
            7,
            15,
            7,
            12,
            15,
            9,
            11,
            7,
            13,
            12,
            11,
            13,
            6,
            7,
            14,
            9,
            13,
            15,
            14,
            8,
            13,
            6,
            5,
            12,
            7,
            5,
            11,
            12,
            14,
            15,
            14,
            15,
            9,
            8,
            9,
            14,
            5,
            6,
            8,
            6,
            5,
            12,
            9,
            15,
            5,
            11,
            6,
            8,
            13,
            12,
            5,
            12,
            13,
            14,
            11,
            8,
            5,
            6
          ]), E = u.create([
            8,
            9,
            9,
            11,
            13,
            15,
            15,
            5,
            7,
            7,
            8,
            11,
            14,
            14,
            12,
            6,
            9,
            13,
            15,
            7,
            12,
            8,
            9,
            11,
            7,
            7,
            12,
            7,
            6,
            15,
            13,
            11,
            9,
            7,
            15,
            11,
            8,
            6,
            6,
            14,
            12,
            13,
            5,
            14,
            13,
            13,
            7,
            5,
            15,
            5,
            8,
            11,
            14,
            14,
            6,
            14,
            6,
            9,
            12,
            9,
            12,
            5,
            15,
            8,
            8,
            5,
            12,
            9,
            12,
            5,
            14,
            6,
            8,
            13,
            6,
            5,
            15,
            13,
            11,
            11
          ]), y = u.create([0, 1518500249, 1859775393, 2400959708, 2840853838]), I = u.create([1352829926, 1548603684, 1836072691, 2053994217, 0]), Q = f.RIPEMD160 = c.extend({
            _doReset: function() {
              this._hash = u.create([1732584193, 4023233417, 2562383102, 271733878, 3285377520]);
            },
            _doProcessBlock: function(D, k) {
              for (var F = 0; F < 16; F++) {
                var z = k + F, Z = D[z];
                D[z] = (Z << 8 | Z >>> 24) & 16711935 | (Z << 24 | Z >>> 8) & 4278255360;
              }
              var V = this._hash.words, $ = y.words, W = I.words, t2 = d.words, n2 = g.words, s2 = h.words, l2 = E.words, X, a2, e2, H, Y, r2, o2, O2, S2, M2;
              r2 = X = V[0], o2 = a2 = V[1], O2 = e2 = V[2], S2 = H = V[3], M2 = Y = V[4];
              for (var w2, F = 0; F < 80; F += 1)
                w2 = X + D[k + t2[F]] | 0, F < 16 ? w2 += B(a2, e2, H) + $[0] : F < 32 ? w2 += _(a2, e2, H) + $[1] : F < 48 ? w2 += M(a2, e2, H) + $[2] : F < 64 ? w2 += S(a2, e2, H) + $[3] : w2 += O(a2, e2, H) + $[4], w2 = w2 | 0, w2 = w(w2, s2[F]), w2 = w2 + Y | 0, X = Y, Y = H, H = w(e2, 10), e2 = a2, a2 = w2, w2 = r2 + D[k + n2[F]] | 0, F < 16 ? w2 += O(o2, O2, S2) + W[0] : F < 32 ? w2 += S(o2, O2, S2) + W[1] : F < 48 ? w2 += M(o2, O2, S2) + W[2] : F < 64 ? w2 += _(o2, O2, S2) + W[3] : w2 += B(o2, O2, S2) + W[4], w2 = w2 | 0, w2 = w(w2, l2[F]), w2 = w2 + M2 | 0, r2 = M2, M2 = S2, S2 = w(O2, 10), O2 = o2, o2 = w2;
              w2 = V[1] + e2 + S2 | 0, V[1] = V[2] + H + M2 | 0, V[2] = V[3] + Y + r2 | 0, V[3] = V[4] + X + o2 | 0, V[4] = V[0] + a2 + O2 | 0, V[0] = w2;
            },
            _doFinalize: function() {
              var D = this._data, k = D.words, F = this._nDataBytes * 8, z = D.sigBytes * 8;
              k[z >>> 5] |= 128 << 24 - z % 32, k[(z + 64 >>> 9 << 4) + 14] = (F << 8 | F >>> 24) & 16711935 | (F << 24 | F >>> 8) & 4278255360, D.sigBytes = (k.length + 1) * 4, this._process();
              for (var Z = this._hash, V = Z.words, $ = 0; $ < 5; $++) {
                var W = V[$];
                V[$] = (W << 8 | W >>> 24) & 16711935 | (W << 24 | W >>> 8) & 4278255360;
              }
              return Z;
            },
            clone: function() {
              var D = c.clone.call(this);
              return D._hash = this._hash.clone(), D;
            }
          });
          function B(D, k, F) {
            return D ^ k ^ F;
          }
          function _(D, k, F) {
            return D & k | ~D & F;
          }
          function M(D, k, F) {
            return (D | ~k) ^ F;
          }
          function S(D, k, F) {
            return D & F | k & ~F;
          }
          function O(D, k, F) {
            return D ^ (k | ~F);
          }
          function w(D, k) {
            return D << k | D >>> 32 - k;
          }
          i.RIPEMD160 = c._createHelper(Q), i.HmacRIPEMD160 = c._createHmacHelper(Q);
        }(), r.RIPEMD160;
      });
    }(dg)), dg.exports;
  }
  var gg = { exports: {} }, yB2 = gg.exports, nZ;
  function A_() {
    return nZ || (nZ = 1, function(e, t) {
      (function(r, n) {
        e.exports = n(he());
      })(yB2, function(r) {
        (function() {
          var n = r, i = n.lib, o = i.Base, u = n.enc, c = u.Utf8, f = n.algo;
          f.HMAC = o.extend({
            /**
             * Initializes a newly created HMAC.
             *
             * @param {Hasher} hasher The hash algorithm to use.
             * @param {WordArray|string} key The secret key.
             *
             * @example
             *
             *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
             */
            init: function(d, g) {
              d = this._hasher = new d.init(), typeof g == "string" && (g = c.parse(g));
              var h = d.blockSize, E = h * 4;
              g.sigBytes > E && (g = d.finalize(g)), g.clamp();
              for (var y = this._oKey = g.clone(), I = this._iKey = g.clone(), Q = y.words, B = I.words, _ = 0; _ < h; _++)
                Q[_] ^= 1549556828, B[_] ^= 909522486;
              y.sigBytes = I.sigBytes = E, this.reset();
            },
            /**
             * Resets this HMAC to its initial state.
             *
             * @example
             *
             *     hmacHasher.reset();
             */
            reset: function() {
              var d = this._hasher;
              d.reset(), d.update(this._iKey);
            },
            /**
             * Updates this HMAC with a message.
             *
             * @param {WordArray|string} messageUpdate The message to append.
             *
             * @return {HMAC} This HMAC instance.
             *
             * @example
             *
             *     hmacHasher.update('message');
             *     hmacHasher.update(wordArray);
             */
            update: function(d) {
              return this._hasher.update(d), this;
            },
            /**
             * Finalizes the HMAC computation.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} messageUpdate (Optional) A final message update.
             *
             * @return {WordArray} The HMAC.
             *
             * @example
             *
             *     var hmac = hmacHasher.finalize();
             *     var hmac = hmacHasher.finalize('message');
             *     var hmac = hmacHasher.finalize(wordArray);
             */
            finalize: function(d) {
              var g = this._hasher, h = g.finalize(d);
              g.reset();
              var E = g.finalize(this._oKey.clone().concat(h));
              return E;
            }
          });
        })();
      });
    }(gg)), gg.exports;
  }
  var pg = { exports: {} }, IB2 = pg.exports, iZ;
  function BB2() {
    return iZ || (iZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), c_(), A_());
      })(IB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.Base, u = i.WordArray, c = n.algo, f = c.SHA256, d = c.HMAC, g = c.PBKDF2 = o.extend({
            /**
             * Configuration options.
             *
             * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
             * @property {Hasher} hasher The hasher to use. Default: SHA256
             * @property {number} iterations The number of iterations to perform. Default: 250000
             */
            cfg: o.extend({
              keySize: 128 / 32,
              hasher: f,
              iterations: 25e4
            }),
            /**
             * Initializes a newly created key derivation function.
             *
             * @param {Object} cfg (Optional) The configuration options to use for the derivation.
             *
             * @example
             *
             *     var kdf = CryptoJS.algo.PBKDF2.create();
             *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8 });
             *     var kdf = CryptoJS.algo.PBKDF2.create({ keySize: 8, iterations: 1000 });
             */
            init: function(h) {
              this.cfg = this.cfg.extend(h);
            },
            /**
             * Computes the Password-Based Key Derivation Function 2.
             *
             * @param {WordArray|string} password The password.
             * @param {WordArray|string} salt A salt.
             *
             * @return {WordArray} The derived key.
             *
             * @example
             *
             *     var key = kdf.compute(password, salt);
             */
            compute: function(h, E) {
              for (var y = this.cfg, I = d.create(y.hasher, h), Q = u.create(), B = u.create([1]), _ = Q.words, M = B.words, S = y.keySize, O = y.iterations; _.length < S; ) {
                var w = I.update(E).finalize(B);
                I.reset();
                for (var D = w.words, k = D.length, F = w, z = 1; z < O; z++) {
                  F = I.finalize(F), I.reset();
                  for (var Z = F.words, V = 0; V < k; V++)
                    D[V] ^= Z[V];
                }
                Q.concat(w), M[0]++;
              }
              return Q.sigBytes = S * 4, Q;
            }
          });
          n.PBKDF2 = function(h, E, y) {
            return g.create(y).compute(h, E);
          };
        }(), r.PBKDF2;
      });
    }(pg)), pg.exports;
  }
  var hg = { exports: {} }, QB2 = hg.exports, aZ;
  function n7() {
    return aZ || (aZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), jG(), A_());
      })(QB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.Base, u = i.WordArray, c = n.algo, f = c.MD5, d = c.EvpKDF = o.extend({
            /**
             * Configuration options.
             *
             * @property {number} keySize The key size in words to generate. Default: 4 (128 bits)
             * @property {Hasher} hasher The hash algorithm to use. Default: MD5
             * @property {number} iterations The number of iterations to perform. Default: 1
             */
            cfg: o.extend({
              keySize: 128 / 32,
              hasher: f,
              iterations: 1
            }),
            /**
             * Initializes a newly created key derivation function.
             *
             * @param {Object} cfg (Optional) The configuration options to use for the derivation.
             *
             * @example
             *
             *     var kdf = CryptoJS.algo.EvpKDF.create();
             *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8 });
             *     var kdf = CryptoJS.algo.EvpKDF.create({ keySize: 8, iterations: 1000 });
             */
            init: function(g) {
              this.cfg = this.cfg.extend(g);
            },
            /**
             * Derives a key from a password.
             *
             * @param {WordArray|string} password The password.
             * @param {WordArray|string} salt A salt.
             *
             * @return {WordArray} The derived key.
             *
             * @example
             *
             *     var key = kdf.compute(password, salt);
             */
            compute: function(g, h) {
              for (var E, y = this.cfg, I = y.hasher.create(), Q = u.create(), B = Q.words, _ = y.keySize, M = y.iterations; B.length < _; ) {
                E && I.update(E), E = I.update(g).finalize(h), I.reset();
                for (var S = 1; S < M; S++)
                  E = I.finalize(E), I.reset();
                Q.concat(E);
              }
              return Q.sigBytes = _ * 4, Q;
            }
          });
          n.EvpKDF = function(g, h, E) {
            return d.create(E).compute(g, h);
          };
        }(), r.EvpKDF;
      });
    }(hg)), hg.exports;
  }
  var vg = { exports: {} }, xB2 = vg.exports, oZ;
  function V5() {
    return oZ || (oZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), n7());
      })(xB2, function(r) {
        r.lib.Cipher || function(n) {
          var i = r, o = i.lib, u = o.Base, c = o.WordArray, f = o.BufferedBlockAlgorithm, d = i.enc;
          d.Utf8;
          var g = d.Base64, h = i.algo, E = h.EvpKDF, y = o.Cipher = f.extend({
            /**
             * Configuration options.
             *
             * @property {WordArray} iv The IV to use for this operation.
             */
            cfg: u.extend(),
            /**
             * Creates this cipher in encryption mode.
             *
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {Cipher} A cipher instance.
             *
             * @static
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.createEncryptor(keyWordArray, { iv: ivWordArray });
             */
            createEncryptor: function(Z, V) {
              return this.create(this._ENC_XFORM_MODE, Z, V);
            },
            /**
             * Creates this cipher in decryption mode.
             *
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {Cipher} A cipher instance.
             *
             * @static
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.createDecryptor(keyWordArray, { iv: ivWordArray });
             */
            createDecryptor: function(Z, V) {
              return this.create(this._DEC_XFORM_MODE, Z, V);
            },
            /**
             * Initializes a newly created cipher.
             *
             * @param {number} xformMode Either the encryption or decryption transormation mode constant.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @example
             *
             *     var cipher = CryptoJS.algo.AES.create(CryptoJS.algo.AES._ENC_XFORM_MODE, keyWordArray, { iv: ivWordArray });
             */
            init: function(Z, V, $) {
              this.cfg = this.cfg.extend($), this._xformMode = Z, this._key = V, this.reset();
            },
            /**
             * Resets this cipher to its initial state.
             *
             * @example
             *
             *     cipher.reset();
             */
            reset: function() {
              f.reset.call(this), this._doReset();
            },
            /**
             * Adds data to be encrypted or decrypted.
             *
             * @param {WordArray|string} dataUpdate The data to encrypt or decrypt.
             *
             * @return {WordArray} The data after processing.
             *
             * @example
             *
             *     var encrypted = cipher.process('data');
             *     var encrypted = cipher.process(wordArray);
             */
            process: function(Z) {
              return this._append(Z), this._process();
            },
            /**
             * Finalizes the encryption or decryption process.
             * Note that the finalize operation is effectively a destructive, read-once operation.
             *
             * @param {WordArray|string} dataUpdate The final data to encrypt or decrypt.
             *
             * @return {WordArray} The data after final processing.
             *
             * @example
             *
             *     var encrypted = cipher.finalize();
             *     var encrypted = cipher.finalize('data');
             *     var encrypted = cipher.finalize(wordArray);
             */
            finalize: function(Z) {
              Z && this._append(Z);
              var V = this._doFinalize();
              return V;
            },
            keySize: 128 / 32,
            ivSize: 128 / 32,
            _ENC_XFORM_MODE: 1,
            _DEC_XFORM_MODE: 2,
            /**
             * Creates shortcut functions to a cipher's object interface.
             *
             * @param {Cipher} cipher The cipher to create a helper for.
             *
             * @return {Object} An object with encrypt and decrypt shortcut functions.
             *
             * @static
             *
             * @example
             *
             *     var AES = CryptoJS.lib.Cipher._createHelper(CryptoJS.algo.AES);
             */
            _createHelper: /* @__PURE__ */ function() {
              function Z(V) {
                return typeof V == "string" ? z : D;
              }
              return function(V) {
                return {
                  encrypt: function($, W, t2) {
                    return Z(W).encrypt(V, $, W, t2);
                  },
                  decrypt: function($, W, t2) {
                    return Z(W).decrypt(V, $, W, t2);
                  }
                };
              };
            }()
          });
          o.StreamCipher = y.extend({
            _doFinalize: function() {
              var Z = this._process(!0);
              return Z;
            },
            blockSize: 1
          });
          var I = i.mode = {}, Q = o.BlockCipherMode = u.extend({
            /**
             * Creates this mode for encryption.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @static
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.createEncryptor(cipher, iv.words);
             */
            createEncryptor: function(Z, V) {
              return this.Encryptor.create(Z, V);
            },
            /**
             * Creates this mode for decryption.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @static
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.createDecryptor(cipher, iv.words);
             */
            createDecryptor: function(Z, V) {
              return this.Decryptor.create(Z, V);
            },
            /**
             * Initializes a newly created mode.
             *
             * @param {Cipher} cipher A block cipher instance.
             * @param {Array} iv The IV words.
             *
             * @example
             *
             *     var mode = CryptoJS.mode.CBC.Encryptor.create(cipher, iv.words);
             */
            init: function(Z, V) {
              this._cipher = Z, this._iv = V;
            }
          }), B = I.CBC = function() {
            var Z = Q.extend();
            Z.Encryptor = Z.extend({
              /**
               * Processes the data block at offset.
               *
               * @param {Array} words The data words to operate on.
               * @param {number} offset The offset where the block starts.
               *
               * @example
               *
               *     mode.processBlock(data.words, offset);
               */
              processBlock: function($, W) {
                var t2 = this._cipher, n2 = t2.blockSize;
                V.call(this, $, W, n2), t2.encryptBlock($, W), this._prevBlock = $.slice(W, W + n2);
              }
            }), Z.Decryptor = Z.extend({
              /**
               * Processes the data block at offset.
               *
               * @param {Array} words The data words to operate on.
               * @param {number} offset The offset where the block starts.
               *
               * @example
               *
               *     mode.processBlock(data.words, offset);
               */
              processBlock: function($, W) {
                var t2 = this._cipher, n2 = t2.blockSize, s2 = $.slice(W, W + n2);
                t2.decryptBlock($, W), V.call(this, $, W, n2), this._prevBlock = s2;
              }
            });
            function V($, W, t2) {
              var n2, s2 = this._iv;
              s2 ? (n2 = s2, this._iv = n) : n2 = this._prevBlock;
              for (var l2 = 0; l2 < t2; l2++)
                $[W + l2] ^= n2[l2];
            }
            return Z;
          }(), _ = i.pad = {}, M = _.Pkcs7 = {
            /**
             * Pads data using the algorithm defined in PKCS #5/7.
             *
             * @param {WordArray} data The data to pad.
             * @param {number} blockSize The multiple that the data should be padded to.
             *
             * @static
             *
             * @example
             *
             *     CryptoJS.pad.Pkcs7.pad(wordArray, 4);
             */
            pad: function(Z, V) {
              for (var $ = V * 4, W = $ - Z.sigBytes % $, t2 = W << 24 | W << 16 | W << 8 | W, n2 = [], s2 = 0; s2 < W; s2 += 4)
                n2.push(t2);
              var l2 = c.create(n2, W);
              Z.concat(l2);
            },
            /**
             * Unpads data that had been padded using the algorithm defined in PKCS #5/7.
             *
             * @param {WordArray} data The data to unpad.
             *
             * @static
             *
             * @example
             *
             *     CryptoJS.pad.Pkcs7.unpad(wordArray);
             */
            unpad: function(Z) {
              var V = Z.words[Z.sigBytes - 1 >>> 2] & 255;
              Z.sigBytes -= V;
            }
          };
          o.BlockCipher = y.extend({
            /**
             * Configuration options.
             *
             * @property {Mode} mode The block mode to use. Default: CBC
             * @property {Padding} padding The padding strategy to use. Default: Pkcs7
             */
            cfg: y.cfg.extend({
              mode: B,
              padding: M
            }),
            reset: function() {
              var Z;
              y.reset.call(this);
              var V = this.cfg, $ = V.iv, W = V.mode;
              this._xformMode == this._ENC_XFORM_MODE ? Z = W.createEncryptor : (Z = W.createDecryptor, this._minBufferSize = 1), this._mode && this._mode.__creator == Z ? this._mode.init(this, $ && $.words) : (this._mode = Z.call(W, this, $ && $.words), this._mode.__creator = Z);
            },
            _doProcessBlock: function(Z, V) {
              this._mode.processBlock(Z, V);
            },
            _doFinalize: function() {
              var Z, V = this.cfg.padding;
              return this._xformMode == this._ENC_XFORM_MODE ? (V.pad(this._data, this.blockSize), Z = this._process(!0)) : (Z = this._process(!0), V.unpad(Z)), Z;
            },
            blockSize: 128 / 32
          });
          var S = o.CipherParams = u.extend({
            /**
             * Initializes a newly created cipher params object.
             *
             * @param {Object} cipherParams An object with any of the possible cipher parameters.
             *
             * @example
             *
             *     var cipherParams = CryptoJS.lib.CipherParams.create({
             *         ciphertext: ciphertextWordArray,
             *         key: keyWordArray,
             *         iv: ivWordArray,
             *         salt: saltWordArray,
             *         algorithm: CryptoJS.algo.AES,
             *         mode: CryptoJS.mode.CBC,
             *         padding: CryptoJS.pad.PKCS7,
             *         blockSize: 4,
             *         formatter: CryptoJS.format.OpenSSL
             *     });
             */
            init: function(Z) {
              this.mixIn(Z);
            },
            /**
             * Converts this cipher params object to a string.
             *
             * @param {Format} formatter (Optional) The formatting strategy to use.
             *
             * @return {string} The stringified cipher params.
             *
             * @throws Error If neither the formatter nor the default formatter is set.
             *
             * @example
             *
             *     var string = cipherParams + '';
             *     var string = cipherParams.toString();
             *     var string = cipherParams.toString(CryptoJS.format.OpenSSL);
             */
            toString: function(Z) {
              return (Z || this.formatter).stringify(this);
            }
          }), O = i.format = {}, w = O.OpenSSL = {
            /**
             * Converts a cipher params object to an OpenSSL-compatible string.
             *
             * @param {CipherParams} cipherParams The cipher params object.
             *
             * @return {string} The OpenSSL-compatible string.
             *
             * @static
             *
             * @example
             *
             *     var openSSLString = CryptoJS.format.OpenSSL.stringify(cipherParams);
             */
            stringify: function(Z) {
              var V, $ = Z.ciphertext, W = Z.salt;
              return W ? V = c.create([1398893684, 1701076831]).concat(W).concat($) : V = $, V.toString(g);
            },
            /**
             * Converts an OpenSSL-compatible string to a cipher params object.
             *
             * @param {string} openSSLStr The OpenSSL-compatible string.
             *
             * @return {CipherParams} The cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var cipherParams = CryptoJS.format.OpenSSL.parse(openSSLString);
             */
            parse: function(Z) {
              var V, $ = g.parse(Z), W = $.words;
              return W[0] == 1398893684 && W[1] == 1701076831 && (V = c.create(W.slice(2, 4)), W.splice(0, 4), $.sigBytes -= 16), S.create({ ciphertext: $, salt: V });
            }
          }, D = o.SerializableCipher = u.extend({
            /**
             * Configuration options.
             *
             * @property {Formatter} format The formatting strategy to convert cipher param objects to and from a string. Default: OpenSSL
             */
            cfg: u.extend({
              format: w
            }),
            /**
             * Encrypts a message.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {WordArray|string} message The message to encrypt.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {CipherParams} A cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key);
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv });
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher.encrypt(CryptoJS.algo.AES, message, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             */
            encrypt: function(Z, V, $, W) {
              W = this.cfg.extend(W);
              var t2 = Z.createEncryptor($, W), n2 = t2.finalize(V), s2 = t2.cfg;
              return S.create({
                ciphertext: n2,
                key: $,
                iv: s2.iv,
                algorithm: Z,
                mode: s2.mode,
                padding: s2.padding,
                blockSize: Z.blockSize,
                formatter: W.format
              });
            },
            /**
             * Decrypts serialized ciphertext.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
             * @param {WordArray} key The key.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {WordArray} The plaintext.
             *
             * @static
             *
             * @example
             *
             *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             *     var plaintext = CryptoJS.lib.SerializableCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, key, { iv: iv, format: CryptoJS.format.OpenSSL });
             */
            decrypt: function(Z, V, $, W) {
              W = this.cfg.extend(W), V = this._parse(V, W.format);
              var t2 = Z.createDecryptor($, W).finalize(V.ciphertext);
              return t2;
            },
            /**
             * Converts serialized ciphertext to CipherParams,
             * else assumed CipherParams already and returns ciphertext unchanged.
             *
             * @param {CipherParams|string} ciphertext The ciphertext.
             * @param {Formatter} format The formatting strategy to use to parse serialized ciphertext.
             *
             * @return {CipherParams} The unserialized ciphertext.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.SerializableCipher._parse(ciphertextStringOrParams, format);
             */
            _parse: function(Z, V) {
              return typeof Z == "string" ? V.parse(Z, this) : Z;
            }
          }), k = i.kdf = {}, F = k.OpenSSL = {
            /**
             * Derives a key and IV from a password.
             *
             * @param {string} password The password to derive from.
             * @param {number} keySize The size in words of the key to generate.
             * @param {number} ivSize The size in words of the IV to generate.
             * @param {WordArray|string} salt (Optional) A 64-bit salt to use. If omitted, a salt will be generated randomly.
             *
             * @return {CipherParams} A cipher params object with the key, IV, and salt.
             *
             * @static
             *
             * @example
             *
             *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32);
             *     var derivedParams = CryptoJS.kdf.OpenSSL.execute('Password', 256/32, 128/32, 'saltsalt');
             */
            execute: function(Z, V, $, W, t2) {
              if (W || (W = c.random(64 / 8)), t2)
                var n2 = E.create({ keySize: V + $, hasher: t2 }).compute(Z, W);
              else
                var n2 = E.create({ keySize: V + $ }).compute(Z, W);
              var s2 = c.create(n2.words.slice(V), $ * 4);
              return n2.sigBytes = V * 4, S.create({ key: n2, iv: s2, salt: W });
            }
          }, z = o.PasswordBasedCipher = D.extend({
            /**
             * Configuration options.
             *
             * @property {KDF} kdf The key derivation function to use to generate a key and IV from a password. Default: OpenSSL
             */
            cfg: D.cfg.extend({
              kdf: F
            }),
            /**
             * Encrypts a message using a password.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {WordArray|string} message The message to encrypt.
             * @param {string} password The password.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {CipherParams} A cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password');
             *     var ciphertextParams = CryptoJS.lib.PasswordBasedCipher.encrypt(CryptoJS.algo.AES, message, 'password', { format: CryptoJS.format.OpenSSL });
             */
            encrypt: function(Z, V, $, W) {
              W = this.cfg.extend(W);
              var t2 = W.kdf.execute($, Z.keySize, Z.ivSize, W.salt, W.hasher);
              W.iv = t2.iv;
              var n2 = D.encrypt.call(this, Z, V, t2.key, W);
              return n2.mixIn(t2), n2;
            },
            /**
             * Decrypts serialized ciphertext using a password.
             *
             * @param {Cipher} cipher The cipher algorithm to use.
             * @param {CipherParams|string} ciphertext The ciphertext to decrypt.
             * @param {string} password The password.
             * @param {Object} cfg (Optional) The configuration options to use for this operation.
             *
             * @return {WordArray} The plaintext.
             *
             * @static
             *
             * @example
             *
             *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, formattedCiphertext, 'password', { format: CryptoJS.format.OpenSSL });
             *     var plaintext = CryptoJS.lib.PasswordBasedCipher.decrypt(CryptoJS.algo.AES, ciphertextParams, 'password', { format: CryptoJS.format.OpenSSL });
             */
            decrypt: function(Z, V, $, W) {
              W = this.cfg.extend(W), V = this._parse(V, W.format);
              var t2 = W.kdf.execute($, Z.keySize, Z.ivSize, V.salt, W.hasher);
              W.iv = t2.iv;
              var n2 = D.decrypt.call(this, Z, V, t2.key, W);
              return n2;
            }
          });
        }();
      });
    }(vg)), vg.exports;
  }
  var Eg = { exports: {} }, bB2 = Eg.exports, sZ;
  function wB2() {
    return sZ || (sZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(bB2, function(r) {
        return r.mode.CFB = function() {
          var n = r.lib.BlockCipherMode.extend();
          n.Encryptor = n.extend({
            processBlock: function(o, u) {
              var c = this._cipher, f = c.blockSize;
              i.call(this, o, u, f, c), this._prevBlock = o.slice(u, u + f);
            }
          }), n.Decryptor = n.extend({
            processBlock: function(o, u) {
              var c = this._cipher, f = c.blockSize, d = o.slice(u, u + f);
              i.call(this, o, u, f, c), this._prevBlock = d;
            }
          });
          function i(o, u, c, f) {
            var d, g = this._iv;
            g ? (d = g.slice(0), this._iv = void 0) : d = this._prevBlock, f.encryptBlock(d, 0);
            for (var h = 0; h < c; h++)
              o[u + h] ^= d[h];
          }
          return n;
        }(), r.mode.CFB;
      });
    }(Eg)), Eg.exports;
  }
  var mg = { exports: {} }, SB2 = mg.exports, uZ;
  function MB2() {
    return uZ || (uZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(SB2, function(r) {
        return r.mode.CTR = function() {
          var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
            processBlock: function(o, u) {
              var c = this._cipher, f = c.blockSize, d = this._iv, g = this._counter;
              d && (g = this._counter = d.slice(0), this._iv = void 0);
              var h = g.slice(0);
              c.encryptBlock(h, 0), g[f - 1] = g[f - 1] + 1 | 0;
              for (var E = 0; E < f; E++)
                o[u + E] ^= h[E];
            }
          });
          return n.Decryptor = i, n;
        }(), r.mode.CTR;
      });
    }(mg)), mg.exports;
  }
  var yg = { exports: {} }, _B2 = yg.exports, lZ;
  function OB2() {
    return lZ || (lZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(_B2, function(r) {
        /** @preserve
         * Counter block mode compatible with  Dr Brian Gladman fileenc.c
         * derived from CryptoJS.mode.CTR
         * Jan Hruby jhruby.web@gmail.com
         */
        return r.mode.CTRGladman = function() {
          var n = r.lib.BlockCipherMode.extend();
          function i(c) {
            if ((c >> 24 & 255) === 255) {
              var f = c >> 16 & 255, d = c >> 8 & 255, g = c & 255;
              f === 255 ? (f = 0, d === 255 ? (d = 0, g === 255 ? g = 0 : ++g) : ++d) : ++f, c = 0, c += f << 16, c += d << 8, c += g;
            } else
              c += 1 << 24;
            return c;
          }
          function o(c) {
            return (c[0] = i(c[0])) === 0 && (c[1] = i(c[1])), c;
          }
          var u = n.Encryptor = n.extend({
            processBlock: function(c, f) {
              var d = this._cipher, g = d.blockSize, h = this._iv, E = this._counter;
              h && (E = this._counter = h.slice(0), this._iv = void 0), o(E);
              var y = E.slice(0);
              d.encryptBlock(y, 0);
              for (var I = 0; I < g; I++)
                c[f + I] ^= y[I];
            }
          });
          return n.Decryptor = u, n;
        }(), r.mode.CTRGladman;
      });
    }(yg)), yg.exports;
  }
  var Ig = { exports: {} }, TB2 = Ig.exports, cZ;
  function DB2() {
    return cZ || (cZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(TB2, function(r) {
        return r.mode.OFB = function() {
          var n = r.lib.BlockCipherMode.extend(), i = n.Encryptor = n.extend({
            processBlock: function(o, u) {
              var c = this._cipher, f = c.blockSize, d = this._iv, g = this._keystream;
              d && (g = this._keystream = d.slice(0), this._iv = void 0), c.encryptBlock(g, 0);
              for (var h = 0; h < f; h++)
                o[u + h] ^= g[h];
            }
          });
          return n.Decryptor = i, n;
        }(), r.mode.OFB;
      });
    }(Ig)), Ig.exports;
  }
  var Bg = { exports: {} }, LB2 = Bg.exports, AZ;
  function kB2() {
    return AZ || (AZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(LB2, function(r) {
        return r.mode.ECB = function() {
          var n = r.lib.BlockCipherMode.extend();
          return n.Encryptor = n.extend({
            processBlock: function(i, o) {
              this._cipher.encryptBlock(i, o);
            }
          }), n.Decryptor = n.extend({
            processBlock: function(i, o) {
              this._cipher.decryptBlock(i, o);
            }
          }), n;
        }(), r.mode.ECB;
      });
    }(Bg)), Bg.exports;
  }
  var Qg = { exports: {} }, RB2 = Qg.exports, fZ;
  function PB2() {
    return fZ || (fZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(RB2, function(r) {
        return r.pad.AnsiX923 = {
          pad: function(n, i) {
            var o = n.sigBytes, u = i * 4, c = u - o % u, f = o + c - 1;
            n.clamp(), n.words[f >>> 2] |= c << 24 - f % 4 * 8, n.sigBytes += c;
          },
          unpad: function(n) {
            var i = n.words[n.sigBytes - 1 >>> 2] & 255;
            n.sigBytes -= i;
          }
        }, r.pad.Ansix923;
      });
    }(Qg)), Qg.exports;
  }
  var xg = { exports: {} }, FB2 = xg.exports, CZ;
  function NB2() {
    return CZ || (CZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(FB2, function(r) {
        return r.pad.Iso10126 = {
          pad: function(n, i) {
            var o = i * 4, u = o - n.sigBytes % o;
            n.concat(r.lib.WordArray.random(u - 1)).concat(r.lib.WordArray.create([u << 24], 1));
          },
          unpad: function(n) {
            var i = n.words[n.sigBytes - 1 >>> 2] & 255;
            n.sigBytes -= i;
          }
        }, r.pad.Iso10126;
      });
    }(xg)), xg.exports;
  }
  var bg = { exports: {} }, HB2 = bg.exports, dZ;
  function jB2() {
    return dZ || (dZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(HB2, function(r) {
        return r.pad.Iso97971 = {
          pad: function(n, i) {
            n.concat(r.lib.WordArray.create([2147483648], 1)), r.pad.ZeroPadding.pad(n, i);
          },
          unpad: function(n) {
            r.pad.ZeroPadding.unpad(n), n.sigBytes--;
          }
        }, r.pad.Iso97971;
      });
    }(bg)), bg.exports;
  }
  var wg = { exports: {} }, VB2 = wg.exports, gZ;
  function ZB2() {
    return gZ || (gZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(VB2, function(r) {
        return r.pad.ZeroPadding = {
          pad: function(n, i) {
            var o = i * 4;
            n.clamp(), n.sigBytes += o - (n.sigBytes % o || o);
          },
          unpad: function(n) {
            for (var i = n.words, o = n.sigBytes - 1, o = n.sigBytes - 1; o >= 0; o--)
              if (i[o >>> 2] >>> 24 - o % 4 * 8 & 255) {
                n.sigBytes = o + 1;
                break;
              }
          }
        }, r.pad.ZeroPadding;
      });
    }(wg)), wg.exports;
  }
  var Sg = { exports: {} }, zB2 = Sg.exports, pZ;
  function UB2() {
    return pZ || (pZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(zB2, function(r) {
        return r.pad.NoPadding = {
          pad: function() {
          },
          unpad: function() {
          }
        }, r.pad.NoPadding;
      });
    }(Sg)), Sg.exports;
  }
  var Mg = { exports: {} }, qB2 = Mg.exports, hZ;
  function WB2() {
    return hZ || (hZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), V5());
      })(qB2, function(r) {
        return function(n) {
          var i = r, o = i.lib, u = o.CipherParams, c = i.enc, f = c.Hex, d = i.format;
          d.Hex = {
            /**
             * Converts the ciphertext of a cipher params object to a hexadecimally encoded string.
             *
             * @param {CipherParams} cipherParams The cipher params object.
             *
             * @return {string} The hexadecimally encoded string.
             *
             * @static
             *
             * @example
             *
             *     var hexString = CryptoJS.format.Hex.stringify(cipherParams);
             */
            stringify: function(g) {
              return g.ciphertext.toString(f);
            },
            /**
             * Converts a hexadecimally encoded ciphertext string to a cipher params object.
             *
             * @param {string} input The hexadecimally encoded string.
             *
             * @return {CipherParams} The cipher params object.
             *
             * @static
             *
             * @example
             *
             *     var cipherParams = CryptoJS.format.Hex.parse(hexString);
             */
            parse: function(g) {
              var h = f.parse(g);
              return u.create({ ciphertext: h });
            }
          };
        }(), r.format.Hex;
      });
    }(Mg)), Mg.exports;
  }
  var _g = { exports: {} }, YB2 = _g.exports, vZ;
  function $B2() {
    return vZ || (vZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(YB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.BlockCipher, u = n.algo, c = [], f = [], d = [], g = [], h = [], E = [], y = [], I = [], Q = [], B = [];
          (function() {
            for (var S = [], O = 0; O < 256; O++)
              O < 128 ? S[O] = O << 1 : S[O] = O << 1 ^ 283;
            for (var w = 0, D = 0, O = 0; O < 256; O++) {
              var k = D ^ D << 1 ^ D << 2 ^ D << 3 ^ D << 4;
              k = k >>> 8 ^ k & 255 ^ 99, c[w] = k, f[k] = w;
              var F = S[w], z = S[F], Z = S[z], V = S[k] * 257 ^ k * 16843008;
              d[w] = V << 24 | V >>> 8, g[w] = V << 16 | V >>> 16, h[w] = V << 8 | V >>> 24, E[w] = V;
              var V = Z * 16843009 ^ z * 65537 ^ F * 257 ^ w * 16843008;
              y[k] = V << 24 | V >>> 8, I[k] = V << 16 | V >>> 16, Q[k] = V << 8 | V >>> 24, B[k] = V, w ? (w = F ^ S[S[S[Z ^ F]]], D ^= S[S[D]]) : w = D = 1;
            }
          })();
          var _ = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], M = u.AES = o.extend({
            _doReset: function() {
              var S;
              if (!(this._nRounds && this._keyPriorReset === this._key)) {
                for (var O = this._keyPriorReset = this._key, w = O.words, D = O.sigBytes / 4, k = this._nRounds = D + 6, F = (k + 1) * 4, z = this._keySchedule = [], Z = 0; Z < F; Z++)
                  Z < D ? z[Z] = w[Z] : (S = z[Z - 1], Z % D ? D > 6 && Z % D == 4 && (S = c[S >>> 24] << 24 | c[S >>> 16 & 255] << 16 | c[S >>> 8 & 255] << 8 | c[S & 255]) : (S = S << 8 | S >>> 24, S = c[S >>> 24] << 24 | c[S >>> 16 & 255] << 16 | c[S >>> 8 & 255] << 8 | c[S & 255], S ^= _[Z / D | 0] << 24), z[Z] = z[Z - D] ^ S);
                for (var V = this._invKeySchedule = [], $ = 0; $ < F; $++) {
                  var Z = F - $;
                  if ($ % 4)
                    var S = z[Z];
                  else
                    var S = z[Z - 4];
                  $ < 4 || Z <= 4 ? V[$] = S : V[$] = y[c[S >>> 24]] ^ I[c[S >>> 16 & 255]] ^ Q[c[S >>> 8 & 255]] ^ B[c[S & 255]];
                }
              }
            },
            encryptBlock: function(S, O) {
              this._doCryptBlock(S, O, this._keySchedule, d, g, h, E, c);
            },
            decryptBlock: function(S, O) {
              var w = S[O + 1];
              S[O + 1] = S[O + 3], S[O + 3] = w, this._doCryptBlock(S, O, this._invKeySchedule, y, I, Q, B, f);
              var w = S[O + 1];
              S[O + 1] = S[O + 3], S[O + 3] = w;
            },
            _doCryptBlock: function(S, O, w, D, k, F, z, Z) {
              for (var V = this._nRounds, $ = S[O] ^ w[0], W = S[O + 1] ^ w[1], t2 = S[O + 2] ^ w[2], n2 = S[O + 3] ^ w[3], s2 = 4, l2 = 1; l2 < V; l2++) {
                var X = D[$ >>> 24] ^ k[W >>> 16 & 255] ^ F[t2 >>> 8 & 255] ^ z[n2 & 255] ^ w[s2++], a2 = D[W >>> 24] ^ k[t2 >>> 16 & 255] ^ F[n2 >>> 8 & 255] ^ z[$ & 255] ^ w[s2++], e2 = D[t2 >>> 24] ^ k[n2 >>> 16 & 255] ^ F[$ >>> 8 & 255] ^ z[W & 255] ^ w[s2++], H = D[n2 >>> 24] ^ k[$ >>> 16 & 255] ^ F[W >>> 8 & 255] ^ z[t2 & 255] ^ w[s2++];
                $ = X, W = a2, t2 = e2, n2 = H;
              }
              var X = (Z[$ >>> 24] << 24 | Z[W >>> 16 & 255] << 16 | Z[t2 >>> 8 & 255] << 8 | Z[n2 & 255]) ^ w[s2++], a2 = (Z[W >>> 24] << 24 | Z[t2 >>> 16 & 255] << 16 | Z[n2 >>> 8 & 255] << 8 | Z[$ & 255]) ^ w[s2++], e2 = (Z[t2 >>> 24] << 24 | Z[n2 >>> 16 & 255] << 16 | Z[$ >>> 8 & 255] << 8 | Z[W & 255]) ^ w[s2++], H = (Z[n2 >>> 24] << 24 | Z[$ >>> 16 & 255] << 16 | Z[W >>> 8 & 255] << 8 | Z[t2 & 255]) ^ w[s2++];
              S[O] = X, S[O + 1] = a2, S[O + 2] = e2, S[O + 3] = H;
            },
            keySize: 256 / 32
          });
          n.AES = o._createHelper(M);
        }(), r.AES;
      });
    }(_g)), _g.exports;
  }
  var Og = { exports: {} }, GB2 = Og.exports, EZ;
  function KB2() {
    return EZ || (EZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(GB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.WordArray, u = i.BlockCipher, c = n.algo, f = [
            57,
            49,
            41,
            33,
            25,
            17,
            9,
            1,
            58,
            50,
            42,
            34,
            26,
            18,
            10,
            2,
            59,
            51,
            43,
            35,
            27,
            19,
            11,
            3,
            60,
            52,
            44,
            36,
            63,
            55,
            47,
            39,
            31,
            23,
            15,
            7,
            62,
            54,
            46,
            38,
            30,
            22,
            14,
            6,
            61,
            53,
            45,
            37,
            29,
            21,
            13,
            5,
            28,
            20,
            12,
            4
          ], d = [
            14,
            17,
            11,
            24,
            1,
            5,
            3,
            28,
            15,
            6,
            21,
            10,
            23,
            19,
            12,
            4,
            26,
            8,
            16,
            7,
            27,
            20,
            13,
            2,
            41,
            52,
            31,
            37,
            47,
            55,
            30,
            40,
            51,
            45,
            33,
            48,
            44,
            49,
            39,
            56,
            34,
            53,
            46,
            42,
            50,
            36,
            29,
            32
          ], g = [1, 2, 4, 6, 8, 10, 12, 14, 15, 17, 19, 21, 23, 25, 27, 28], h = [
            {
              0: 8421888,
              268435456: 32768,
              536870912: 8421378,
              805306368: 2,
              1073741824: 512,
              1342177280: 8421890,
              1610612736: 8389122,
              1879048192: 8388608,
              2147483648: 514,
              2415919104: 8389120,
              2684354560: 33280,
              2952790016: 8421376,
              3221225472: 32770,
              3489660928: 8388610,
              3758096384: 0,
              4026531840: 33282,
              134217728: 0,
              402653184: 8421890,
              671088640: 33282,
              939524096: 32768,
              1207959552: 8421888,
              1476395008: 512,
              1744830464: 8421378,
              2013265920: 2,
              2281701376: 8389120,
              2550136832: 33280,
              2818572288: 8421376,
              3087007744: 8389122,
              3355443200: 8388610,
              3623878656: 32770,
              3892314112: 514,
              4160749568: 8388608,
              1: 32768,
              268435457: 2,
              536870913: 8421888,
              805306369: 8388608,
              1073741825: 8421378,
              1342177281: 33280,
              1610612737: 512,
              1879048193: 8389122,
              2147483649: 8421890,
              2415919105: 8421376,
              2684354561: 8388610,
              2952790017: 33282,
              3221225473: 514,
              3489660929: 8389120,
              3758096385: 32770,
              4026531841: 0,
              134217729: 8421890,
              402653185: 8421376,
              671088641: 8388608,
              939524097: 512,
              1207959553: 32768,
              1476395009: 8388610,
              1744830465: 2,
              2013265921: 33282,
              2281701377: 32770,
              2550136833: 8389122,
              2818572289: 514,
              3087007745: 8421888,
              3355443201: 8389120,
              3623878657: 0,
              3892314113: 33280,
              4160749569: 8421378
            },
            {
              0: 1074282512,
              16777216: 16384,
              33554432: 524288,
              50331648: 1074266128,
              67108864: 1073741840,
              83886080: 1074282496,
              100663296: 1073758208,
              117440512: 16,
              134217728: 540672,
              150994944: 1073758224,
              167772160: 1073741824,
              184549376: 540688,
              201326592: 524304,
              218103808: 0,
              234881024: 16400,
              251658240: 1074266112,
              8388608: 1073758208,
              25165824: 540688,
              41943040: 16,
              58720256: 1073758224,
              75497472: 1074282512,
              92274688: 1073741824,
              109051904: 524288,
              125829120: 1074266128,
              142606336: 524304,
              159383552: 0,
              176160768: 16384,
              192937984: 1074266112,
              209715200: 1073741840,
              226492416: 540672,
              243269632: 1074282496,
              260046848: 16400,
              268435456: 0,
              285212672: 1074266128,
              301989888: 1073758224,
              318767104: 1074282496,
              335544320: 1074266112,
              352321536: 16,
              369098752: 540688,
              385875968: 16384,
              402653184: 16400,
              419430400: 524288,
              436207616: 524304,
              452984832: 1073741840,
              469762048: 540672,
              486539264: 1073758208,
              503316480: 1073741824,
              520093696: 1074282512,
              276824064: 540688,
              293601280: 524288,
              310378496: 1074266112,
              327155712: 16384,
              343932928: 1073758208,
              360710144: 1074282512,
              377487360: 16,
              394264576: 1073741824,
              411041792: 1074282496,
              427819008: 1073741840,
              444596224: 1073758224,
              461373440: 524304,
              478150656: 0,
              494927872: 16400,
              511705088: 1074266128,
              528482304: 540672
            },
            {
              0: 260,
              1048576: 0,
              2097152: 67109120,
              3145728: 65796,
              4194304: 65540,
              5242880: 67108868,
              6291456: 67174660,
              7340032: 67174400,
              8388608: 67108864,
              9437184: 67174656,
              10485760: 65792,
              11534336: 67174404,
              12582912: 67109124,
              13631488: 65536,
              14680064: 4,
              15728640: 256,
              524288: 67174656,
              1572864: 67174404,
              2621440: 0,
              3670016: 67109120,
              4718592: 67108868,
              5767168: 65536,
              6815744: 65540,
              7864320: 260,
              8912896: 4,
              9961472: 256,
              11010048: 67174400,
              12058624: 65796,
              13107200: 65792,
              14155776: 67109124,
              15204352: 67174660,
              16252928: 67108864,
              16777216: 67174656,
              17825792: 65540,
              18874368: 65536,
              19922944: 67109120,
              20971520: 256,
              22020096: 67174660,
              23068672: 67108868,
              24117248: 0,
              25165824: 67109124,
              26214400: 67108864,
              27262976: 4,
              28311552: 65792,
              29360128: 67174400,
              30408704: 260,
              31457280: 65796,
              32505856: 67174404,
              17301504: 67108864,
              18350080: 260,
              19398656: 67174656,
              20447232: 0,
              21495808: 65540,
              22544384: 67109120,
              23592960: 256,
              24641536: 67174404,
              25690112: 65536,
              26738688: 67174660,
              27787264: 65796,
              28835840: 67108868,
              29884416: 67109124,
              30932992: 67174400,
              31981568: 4,
              33030144: 65792
            },
            {
              0: 2151682048,
              65536: 2147487808,
              131072: 4198464,
              196608: 2151677952,
              262144: 0,
              327680: 4198400,
              393216: 2147483712,
              458752: 4194368,
              524288: 2147483648,
              589824: 4194304,
              655360: 64,
              720896: 2147487744,
              786432: 2151678016,
              851968: 4160,
              917504: 4096,
              983040: 2151682112,
              32768: 2147487808,
              98304: 64,
              163840: 2151678016,
              229376: 2147487744,
              294912: 4198400,
              360448: 2151682112,
              425984: 0,
              491520: 2151677952,
              557056: 4096,
              622592: 2151682048,
              688128: 4194304,
              753664: 4160,
              819200: 2147483648,
              884736: 4194368,
              950272: 4198464,
              1015808: 2147483712,
              1048576: 4194368,
              1114112: 4198400,
              1179648: 2147483712,
              1245184: 0,
              1310720: 4160,
              1376256: 2151678016,
              1441792: 2151682048,
              1507328: 2147487808,
              1572864: 2151682112,
              1638400: 2147483648,
              1703936: 2151677952,
              1769472: 4198464,
              1835008: 2147487744,
              1900544: 4194304,
              1966080: 64,
              2031616: 4096,
              1081344: 2151677952,
              1146880: 2151682112,
              1212416: 0,
              1277952: 4198400,
              1343488: 4194368,
              1409024: 2147483648,
              1474560: 2147487808,
              1540096: 64,
              1605632: 2147483712,
              1671168: 4096,
              1736704: 2147487744,
              1802240: 2151678016,
              1867776: 4160,
              1933312: 2151682048,
              1998848: 4194304,
              2064384: 4198464
            },
            {
              0: 128,
              4096: 17039360,
              8192: 262144,
              12288: 536870912,
              16384: 537133184,
              20480: 16777344,
              24576: 553648256,
              28672: 262272,
              32768: 16777216,
              36864: 537133056,
              40960: 536871040,
              45056: 553910400,
              49152: 553910272,
              53248: 0,
              57344: 17039488,
              61440: 553648128,
              2048: 17039488,
              6144: 553648256,
              10240: 128,
              14336: 17039360,
              18432: 262144,
              22528: 537133184,
              26624: 553910272,
              30720: 536870912,
              34816: 537133056,
              38912: 0,
              43008: 553910400,
              47104: 16777344,
              51200: 536871040,
              55296: 553648128,
              59392: 16777216,
              63488: 262272,
              65536: 262144,
              69632: 128,
              73728: 536870912,
              77824: 553648256,
              81920: 16777344,
              86016: 553910272,
              90112: 537133184,
              94208: 16777216,
              98304: 553910400,
              102400: 553648128,
              106496: 17039360,
              110592: 537133056,
              114688: 262272,
              118784: 536871040,
              122880: 0,
              126976: 17039488,
              67584: 553648256,
              71680: 16777216,
              75776: 17039360,
              79872: 537133184,
              83968: 536870912,
              88064: 17039488,
              92160: 128,
              96256: 553910272,
              100352: 262272,
              104448: 553910400,
              108544: 0,
              112640: 553648128,
              116736: 16777344,
              120832: 262144,
              124928: 537133056,
              129024: 536871040
            },
            {
              0: 268435464,
              256: 8192,
              512: 270532608,
              768: 270540808,
              1024: 268443648,
              1280: 2097152,
              1536: 2097160,
              1792: 268435456,
              2048: 0,
              2304: 268443656,
              2560: 2105344,
              2816: 8,
              3072: 270532616,
              3328: 2105352,
              3584: 8200,
              3840: 270540800,
              128: 270532608,
              384: 270540808,
              640: 8,
              896: 2097152,
              1152: 2105352,
              1408: 268435464,
              1664: 268443648,
              1920: 8200,
              2176: 2097160,
              2432: 8192,
              2688: 268443656,
              2944: 270532616,
              3200: 0,
              3456: 270540800,
              3712: 2105344,
              3968: 268435456,
              4096: 268443648,
              4352: 270532616,
              4608: 270540808,
              4864: 8200,
              5120: 2097152,
              5376: 268435456,
              5632: 268435464,
              5888: 2105344,
              6144: 2105352,
              6400: 0,
              6656: 8,
              6912: 270532608,
              7168: 8192,
              7424: 268443656,
              7680: 270540800,
              7936: 2097160,
              4224: 8,
              4480: 2105344,
              4736: 2097152,
              4992: 268435464,
              5248: 268443648,
              5504: 8200,
              5760: 270540808,
              6016: 270532608,
              6272: 270540800,
              6528: 270532616,
              6784: 8192,
              7040: 2105352,
              7296: 2097160,
              7552: 0,
              7808: 268435456,
              8064: 268443656
            },
            {
              0: 1048576,
              16: 33555457,
              32: 1024,
              48: 1049601,
              64: 34604033,
              80: 0,
              96: 1,
              112: 34603009,
              128: 33555456,
              144: 1048577,
              160: 33554433,
              176: 34604032,
              192: 34603008,
              208: 1025,
              224: 1049600,
              240: 33554432,
              8: 34603009,
              24: 0,
              40: 33555457,
              56: 34604032,
              72: 1048576,
              88: 33554433,
              104: 33554432,
              120: 1025,
              136: 1049601,
              152: 33555456,
              168: 34603008,
              184: 1048577,
              200: 1024,
              216: 34604033,
              232: 1,
              248: 1049600,
              256: 33554432,
              272: 1048576,
              288: 33555457,
              304: 34603009,
              320: 1048577,
              336: 33555456,
              352: 34604032,
              368: 1049601,
              384: 1025,
              400: 34604033,
              416: 1049600,
              432: 1,
              448: 0,
              464: 34603008,
              480: 33554433,
              496: 1024,
              264: 1049600,
              280: 33555457,
              296: 34603009,
              312: 1,
              328: 33554432,
              344: 1048576,
              360: 1025,
              376: 34604032,
              392: 33554433,
              408: 34603008,
              424: 0,
              440: 34604033,
              456: 1049601,
              472: 1024,
              488: 33555456,
              504: 1048577
            },
            {
              0: 134219808,
              1: 131072,
              2: 134217728,
              3: 32,
              4: 131104,
              5: 134350880,
              6: 134350848,
              7: 2048,
              8: 134348800,
              9: 134219776,
              10: 133120,
              11: 134348832,
              12: 2080,
              13: 0,
              14: 134217760,
              15: 133152,
              2147483648: 2048,
              2147483649: 134350880,
              2147483650: 134219808,
              2147483651: 134217728,
              2147483652: 134348800,
              2147483653: 133120,
              2147483654: 133152,
              2147483655: 32,
              2147483656: 134217760,
              2147483657: 2080,
              2147483658: 131104,
              2147483659: 134350848,
              2147483660: 0,
              2147483661: 134348832,
              2147483662: 134219776,
              2147483663: 131072,
              16: 133152,
              17: 134350848,
              18: 32,
              19: 2048,
              20: 134219776,
              21: 134217760,
              22: 134348832,
              23: 131072,
              24: 0,
              25: 131104,
              26: 134348800,
              27: 134219808,
              28: 134350880,
              29: 133120,
              30: 2080,
              31: 134217728,
              2147483664: 131072,
              2147483665: 2048,
              2147483666: 134348832,
              2147483667: 133152,
              2147483668: 32,
              2147483669: 134348800,
              2147483670: 134217728,
              2147483671: 134219808,
              2147483672: 134350880,
              2147483673: 134217760,
              2147483674: 134219776,
              2147483675: 0,
              2147483676: 133120,
              2147483677: 2080,
              2147483678: 131104,
              2147483679: 134350848
            }
          ], E = [
            4160749569,
            528482304,
            33030144,
            2064384,
            129024,
            8064,
            504,
            2147483679
          ], y = c.DES = u.extend({
            _doReset: function() {
              for (var _ = this._key, M = _.words, S = [], O = 0; O < 56; O++) {
                var w = f[O] - 1;
                S[O] = M[w >>> 5] >>> 31 - w % 32 & 1;
              }
              for (var D = this._subKeys = [], k = 0; k < 16; k++) {
                for (var F = D[k] = [], z = g[k], O = 0; O < 24; O++)
                  F[O / 6 | 0] |= S[(d[O] - 1 + z) % 28] << 31 - O % 6, F[4 + (O / 6 | 0)] |= S[28 + (d[O + 24] - 1 + z) % 28] << 31 - O % 6;
                F[0] = F[0] << 1 | F[0] >>> 31;
                for (var O = 1; O < 7; O++)
                  F[O] = F[O] >>> (O - 1) * 4 + 3;
                F[7] = F[7] << 5 | F[7] >>> 27;
              }
              for (var Z = this._invSubKeys = [], O = 0; O < 16; O++)
                Z[O] = D[15 - O];
            },
            encryptBlock: function(_, M) {
              this._doCryptBlock(_, M, this._subKeys);
            },
            decryptBlock: function(_, M) {
              this._doCryptBlock(_, M, this._invSubKeys);
            },
            _doCryptBlock: function(_, M, S) {
              this._lBlock = _[M], this._rBlock = _[M + 1], I.call(this, 4, 252645135), I.call(this, 16, 65535), Q.call(this, 2, 858993459), Q.call(this, 8, 16711935), I.call(this, 1, 1431655765);
              for (var O = 0; O < 16; O++) {
                for (var w = S[O], D = this._lBlock, k = this._rBlock, F = 0, z = 0; z < 8; z++)
                  F |= h[z][((k ^ w[z]) & E[z]) >>> 0];
                this._lBlock = k, this._rBlock = D ^ F;
              }
              var Z = this._lBlock;
              this._lBlock = this._rBlock, this._rBlock = Z, I.call(this, 1, 1431655765), Q.call(this, 8, 16711935), Q.call(this, 2, 858993459), I.call(this, 16, 65535), I.call(this, 4, 252645135), _[M] = this._lBlock, _[M + 1] = this._rBlock;
            },
            keySize: 64 / 32,
            ivSize: 64 / 32,
            blockSize: 64 / 32
          });
          function I(_, M) {
            var S = (this._lBlock >>> _ ^ this._rBlock) & M;
            this._rBlock ^= S, this._lBlock ^= S << _;
          }
          function Q(_, M) {
            var S = (this._rBlock >>> _ ^ this._lBlock) & M;
            this._lBlock ^= S, this._rBlock ^= S << _;
          }
          n.DES = u._createHelper(y);
          var B = c.TripleDES = u.extend({
            _doReset: function() {
              var _ = this._key, M = _.words;
              if (M.length !== 2 && M.length !== 4 && M.length < 6)
                throw new Error("Invalid key length - 3DES requires the key length to be 64, 128, 192 or >192.");
              var S = M.slice(0, 2), O = M.length < 4 ? M.slice(0, 2) : M.slice(2, 4), w = M.length < 6 ? M.slice(0, 2) : M.slice(4, 6);
              this._des1 = y.createEncryptor(o.create(S)), this._des2 = y.createEncryptor(o.create(O)), this._des3 = y.createEncryptor(o.create(w));
            },
            encryptBlock: function(_, M) {
              this._des1.encryptBlock(_, M), this._des2.decryptBlock(_, M), this._des3.encryptBlock(_, M);
            },
            decryptBlock: function(_, M) {
              this._des3.decryptBlock(_, M), this._des2.encryptBlock(_, M), this._des1.decryptBlock(_, M);
            },
            keySize: 192 / 32,
            ivSize: 64 / 32,
            blockSize: 64 / 32
          });
          n.TripleDES = u._createHelper(B);
        }(), r.TripleDES;
      });
    }(Og)), Og.exports;
  }
  var Tg = { exports: {} }, XB2 = Tg.exports, mZ;
  function JB2() {
    return mZ || (mZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(XB2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.StreamCipher, u = n.algo, c = u.RC4 = o.extend({
            _doReset: function() {
              for (var g = this._key, h = g.words, E = g.sigBytes, y = this._S = [], I = 0; I < 256; I++)
                y[I] = I;
              for (var I = 0, Q = 0; I < 256; I++) {
                var B = I % E, _ = h[B >>> 2] >>> 24 - B % 4 * 8 & 255;
                Q = (Q + y[I] + _) % 256;
                var M = y[I];
                y[I] = y[Q], y[Q] = M;
              }
              this._i = this._j = 0;
            },
            _doProcessBlock: function(g, h) {
              g[h] ^= f.call(this);
            },
            keySize: 256 / 32,
            ivSize: 0
          });
          function f() {
            for (var g = this._S, h = this._i, E = this._j, y = 0, I = 0; I < 4; I++) {
              h = (h + 1) % 256, E = (E + g[h]) % 256;
              var Q = g[h];
              g[h] = g[E], g[E] = Q, y |= g[(g[h] + g[E]) % 256] << 24 - I * 8;
            }
            return this._i = h, this._j = E, y;
          }
          n.RC4 = o._createHelper(c);
          var d = u.RC4Drop = c.extend({
            /**
             * Configuration options.
             *
             * @property {number} drop The number of keystream words to drop. Default 192
             */
            cfg: c.cfg.extend({
              drop: 192
            }),
            _doReset: function() {
              c._doReset.call(this);
              for (var g = this.cfg.drop; g > 0; g--)
                f.call(this);
            }
          });
          n.RC4Drop = o._createHelper(d);
        }(), r.RC4;
      });
    }(Tg)), Tg.exports;
  }
  var Dg = { exports: {} }, eQ2 = Dg.exports, yZ;
  function tQ2() {
    return yZ || (yZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(eQ2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.StreamCipher, u = n.algo, c = [], f = [], d = [], g = u.Rabbit = o.extend({
            _doReset: function() {
              for (var E = this._key.words, y = this.cfg.iv, I = 0; I < 4; I++)
                E[I] = (E[I] << 8 | E[I] >>> 24) & 16711935 | (E[I] << 24 | E[I] >>> 8) & 4278255360;
              var Q = this._X = [
                E[0],
                E[3] << 16 | E[2] >>> 16,
                E[1],
                E[0] << 16 | E[3] >>> 16,
                E[2],
                E[1] << 16 | E[0] >>> 16,
                E[3],
                E[2] << 16 | E[1] >>> 16
              ], B = this._C = [
                E[2] << 16 | E[2] >>> 16,
                E[0] & 4294901760 | E[1] & 65535,
                E[3] << 16 | E[3] >>> 16,
                E[1] & 4294901760 | E[2] & 65535,
                E[0] << 16 | E[0] >>> 16,
                E[2] & 4294901760 | E[3] & 65535,
                E[1] << 16 | E[1] >>> 16,
                E[3] & 4294901760 | E[0] & 65535
              ];
              this._b = 0;
              for (var I = 0; I < 4; I++)
                h.call(this);
              for (var I = 0; I < 8; I++)
                B[I] ^= Q[I + 4 & 7];
              if (y) {
                var _ = y.words, M = _[0], S = _[1], O = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360, w = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, D = O >>> 16 | w & 4294901760, k = w << 16 | O & 65535;
                B[0] ^= O, B[1] ^= D, B[2] ^= w, B[3] ^= k, B[4] ^= O, B[5] ^= D, B[6] ^= w, B[7] ^= k;
                for (var I = 0; I < 4; I++)
                  h.call(this);
              }
            },
            _doProcessBlock: function(E, y) {
              var I = this._X;
              h.call(this), c[0] = I[0] ^ I[5] >>> 16 ^ I[3] << 16, c[1] = I[2] ^ I[7] >>> 16 ^ I[5] << 16, c[2] = I[4] ^ I[1] >>> 16 ^ I[7] << 16, c[3] = I[6] ^ I[3] >>> 16 ^ I[1] << 16;
              for (var Q = 0; Q < 4; Q++)
                c[Q] = (c[Q] << 8 | c[Q] >>> 24) & 16711935 | (c[Q] << 24 | c[Q] >>> 8) & 4278255360, E[y + Q] ^= c[Q];
            },
            blockSize: 128 / 32,
            ivSize: 64 / 32
          });
          function h() {
            for (var E = this._X, y = this._C, I = 0; I < 8; I++)
              f[I] = y[I];
            y[0] = y[0] + 1295307597 + this._b | 0, y[1] = y[1] + 3545052371 + (y[0] >>> 0 < f[0] >>> 0 ? 1 : 0) | 0, y[2] = y[2] + 886263092 + (y[1] >>> 0 < f[1] >>> 0 ? 1 : 0) | 0, y[3] = y[3] + 1295307597 + (y[2] >>> 0 < f[2] >>> 0 ? 1 : 0) | 0, y[4] = y[4] + 3545052371 + (y[3] >>> 0 < f[3] >>> 0 ? 1 : 0) | 0, y[5] = y[5] + 886263092 + (y[4] >>> 0 < f[4] >>> 0 ? 1 : 0) | 0, y[6] = y[6] + 1295307597 + (y[5] >>> 0 < f[5] >>> 0 ? 1 : 0) | 0, y[7] = y[7] + 3545052371 + (y[6] >>> 0 < f[6] >>> 0 ? 1 : 0) | 0, this._b = y[7] >>> 0 < f[7] >>> 0 ? 1 : 0;
            for (var I = 0; I < 8; I++) {
              var Q = E[I] + y[I], B = Q & 65535, _ = Q >>> 16, M = ((B * B >>> 17) + B * _ >>> 15) + _ * _, S = ((Q & 4294901760) * Q | 0) + ((Q & 65535) * Q | 0);
              d[I] = M ^ S;
            }
            E[0] = d[0] + (d[7] << 16 | d[7] >>> 16) + (d[6] << 16 | d[6] >>> 16) | 0, E[1] = d[1] + (d[0] << 8 | d[0] >>> 24) + d[7] | 0, E[2] = d[2] + (d[1] << 16 | d[1] >>> 16) + (d[0] << 16 | d[0] >>> 16) | 0, E[3] = d[3] + (d[2] << 8 | d[2] >>> 24) + d[1] | 0, E[4] = d[4] + (d[3] << 16 | d[3] >>> 16) + (d[2] << 16 | d[2] >>> 16) | 0, E[5] = d[5] + (d[4] << 8 | d[4] >>> 24) + d[3] | 0, E[6] = d[6] + (d[5] << 16 | d[5] >>> 16) + (d[4] << 16 | d[4] >>> 16) | 0, E[7] = d[7] + (d[6] << 8 | d[6] >>> 24) + d[5] | 0;
          }
          n.Rabbit = o._createHelper(g);
        }(), r.Rabbit;
      });
    }(Dg)), Dg.exports;
  }
  var Lg = { exports: {} }, rQ2 = Lg.exports, IZ;
  function nQ2() {
    return IZ || (IZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(rQ2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.StreamCipher, u = n.algo, c = [], f = [], d = [], g = u.RabbitLegacy = o.extend({
            _doReset: function() {
              var E = this._key.words, y = this.cfg.iv, I = this._X = [
                E[0],
                E[3] << 16 | E[2] >>> 16,
                E[1],
                E[0] << 16 | E[3] >>> 16,
                E[2],
                E[1] << 16 | E[0] >>> 16,
                E[3],
                E[2] << 16 | E[1] >>> 16
              ], Q = this._C = [
                E[2] << 16 | E[2] >>> 16,
                E[0] & 4294901760 | E[1] & 65535,
                E[3] << 16 | E[3] >>> 16,
                E[1] & 4294901760 | E[2] & 65535,
                E[0] << 16 | E[0] >>> 16,
                E[2] & 4294901760 | E[3] & 65535,
                E[1] << 16 | E[1] >>> 16,
                E[3] & 4294901760 | E[0] & 65535
              ];
              this._b = 0;
              for (var B = 0; B < 4; B++)
                h.call(this);
              for (var B = 0; B < 8; B++)
                Q[B] ^= I[B + 4 & 7];
              if (y) {
                var _ = y.words, M = _[0], S = _[1], O = (M << 8 | M >>> 24) & 16711935 | (M << 24 | M >>> 8) & 4278255360, w = (S << 8 | S >>> 24) & 16711935 | (S << 24 | S >>> 8) & 4278255360, D = O >>> 16 | w & 4294901760, k = w << 16 | O & 65535;
                Q[0] ^= O, Q[1] ^= D, Q[2] ^= w, Q[3] ^= k, Q[4] ^= O, Q[5] ^= D, Q[6] ^= w, Q[7] ^= k;
                for (var B = 0; B < 4; B++)
                  h.call(this);
              }
            },
            _doProcessBlock: function(E, y) {
              var I = this._X;
              h.call(this), c[0] = I[0] ^ I[5] >>> 16 ^ I[3] << 16, c[1] = I[2] ^ I[7] >>> 16 ^ I[5] << 16, c[2] = I[4] ^ I[1] >>> 16 ^ I[7] << 16, c[3] = I[6] ^ I[3] >>> 16 ^ I[1] << 16;
              for (var Q = 0; Q < 4; Q++)
                c[Q] = (c[Q] << 8 | c[Q] >>> 24) & 16711935 | (c[Q] << 24 | c[Q] >>> 8) & 4278255360, E[y + Q] ^= c[Q];
            },
            blockSize: 128 / 32,
            ivSize: 64 / 32
          });
          function h() {
            for (var E = this._X, y = this._C, I = 0; I < 8; I++)
              f[I] = y[I];
            y[0] = y[0] + 1295307597 + this._b | 0, y[1] = y[1] + 3545052371 + (y[0] >>> 0 < f[0] >>> 0 ? 1 : 0) | 0, y[2] = y[2] + 886263092 + (y[1] >>> 0 < f[1] >>> 0 ? 1 : 0) | 0, y[3] = y[3] + 1295307597 + (y[2] >>> 0 < f[2] >>> 0 ? 1 : 0) | 0, y[4] = y[4] + 3545052371 + (y[3] >>> 0 < f[3] >>> 0 ? 1 : 0) | 0, y[5] = y[5] + 886263092 + (y[4] >>> 0 < f[4] >>> 0 ? 1 : 0) | 0, y[6] = y[6] + 1295307597 + (y[5] >>> 0 < f[5] >>> 0 ? 1 : 0) | 0, y[7] = y[7] + 3545052371 + (y[6] >>> 0 < f[6] >>> 0 ? 1 : 0) | 0, this._b = y[7] >>> 0 < f[7] >>> 0 ? 1 : 0;
            for (var I = 0; I < 8; I++) {
              var Q = E[I] + y[I], B = Q & 65535, _ = Q >>> 16, M = ((B * B >>> 17) + B * _ >>> 15) + _ * _, S = ((Q & 4294901760) * Q | 0) + ((Q & 65535) * Q | 0);
              d[I] = M ^ S;
            }
            E[0] = d[0] + (d[7] << 16 | d[7] >>> 16) + (d[6] << 16 | d[6] >>> 16) | 0, E[1] = d[1] + (d[0] << 8 | d[0] >>> 24) + d[7] | 0, E[2] = d[2] + (d[1] << 16 | d[1] >>> 16) + (d[0] << 16 | d[0] >>> 16) | 0, E[3] = d[3] + (d[2] << 8 | d[2] >>> 24) + d[1] | 0, E[4] = d[4] + (d[3] << 16 | d[3] >>> 16) + (d[2] << 16 | d[2] >>> 16) | 0, E[5] = d[5] + (d[4] << 8 | d[4] >>> 24) + d[3] | 0, E[6] = d[6] + (d[5] << 16 | d[5] >>> 16) + (d[4] << 16 | d[4] >>> 16) | 0, E[7] = d[7] + (d[6] << 8 | d[6] >>> 24) + d[5] | 0;
          }
          n.RabbitLegacy = o._createHelper(g);
        }(), r.RabbitLegacy;
      });
    }(Lg)), Lg.exports;
  }
  var kg = { exports: {} }, iQ2 = kg.exports, BZ;
  function aQ2() {
    return BZ || (BZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), na(), ia(), n7(), V5());
      })(iQ2, function(r) {
        return function() {
          var n = r, i = n.lib, o = i.BlockCipher, u = n.algo;
          const c = 16, f = [
            608135816,
            2242054355,
            320440878,
            57701188,
            2752067618,
            698298832,
            137296536,
            3964562569,
            1160258022,
            953160567,
            3193202383,
            887688300,
            3232508343,
            3380367581,
            1065670069,
            3041331479,
            2450970073,
            2306472731
          ], d = [
            [
              3509652390,
              2564797868,
              805139163,
              3491422135,
              3101798381,
              1780907670,
              3128725573,
              4046225305,
              614570311,
              3012652279,
              134345442,
              2240740374,
              1667834072,
              1901547113,
              2757295779,
              4103290238,
              227898511,
              1921955416,
              1904987480,
              2182433518,
              2069144605,
              3260701109,
              2620446009,
              720527379,
              3318853667,
              677414384,
              3393288472,
              3101374703,
              2390351024,
              1614419982,
              1822297739,
              2954791486,
              3608508353,
              3174124327,
              2024746970,
              1432378464,
              3864339955,
              2857741204,
              1464375394,
              1676153920,
              1439316330,
              715854006,
              3033291828,
              289532110,
              2706671279,
              2087905683,
              3018724369,
              1668267050,
              732546397,
              1947742710,
              3462151702,
              2609353502,
              2950085171,
              1814351708,
              2050118529,
              680887927,
              999245976,
              1800124847,
              3300911131,
              1713906067,
              1641548236,
              4213287313,
              1216130144,
              1575780402,
              4018429277,
              3917837745,
              3693486850,
              3949271944,
              596196993,
              3549867205,
              258830323,
              2213823033,
              772490370,
              2760122372,
              1774776394,
              2652871518,
              566650946,
              4142492826,
              1728879713,
              2882767088,
              1783734482,
              3629395816,
              2517608232,
              2874225571,
              1861159788,
              326777828,
              3124490320,
              2130389656,
              2716951837,
              967770486,
              1724537150,
              2185432712,
              2364442137,
              1164943284,
              2105845187,
              998989502,
              3765401048,
              2244026483,
              1075463327,
              1455516326,
              1322494562,
              910128902,
              469688178,
              1117454909,
              936433444,
              3490320968,
              3675253459,
              1240580251,
              122909385,
              2157517691,
              634681816,
              4142456567,
              3825094682,
              3061402683,
              2540495037,
              79693498,
              3249098678,
              1084186820,
              1583128258,
              426386531,
              1761308591,
              1047286709,
              322548459,
              995290223,
              1845252383,
              2603652396,
              3431023940,
              2942221577,
              3202600964,
              3727903485,
              1712269319,
              422464435,
              3234572375,
              1170764815,
              3523960633,
              3117677531,
              1434042557,
              442511882,
              3600875718,
              1076654713,
              1738483198,
              4213154764,
              2393238008,
              3677496056,
              1014306527,
              4251020053,
              793779912,
              2902807211,
              842905082,
              4246964064,
              1395751752,
              1040244610,
              2656851899,
              3396308128,
              445077038,
              3742853595,
              3577915638,
              679411651,
              2892444358,
              2354009459,
              1767581616,
              3150600392,
              3791627101,
              3102740896,
              284835224,
              4246832056,
              1258075500,
              768725851,
              2589189241,
              3069724005,
              3532540348,
              1274779536,
              3789419226,
              2764799539,
              1660621633,
              3471099624,
              4011903706,
              913787905,
              3497959166,
              737222580,
              2514213453,
              2928710040,
              3937242737,
              1804850592,
              3499020752,
              2949064160,
              2386320175,
              2390070455,
              2415321851,
              4061277028,
              2290661394,
              2416832540,
              1336762016,
              1754252060,
              3520065937,
              3014181293,
              791618072,
              3188594551,
              3933548030,
              2332172193,
              3852520463,
              3043980520,
              413987798,
              3465142937,
              3030929376,
              4245938359,
              2093235073,
              3534596313,
              375366246,
              2157278981,
              2479649556,
              555357303,
              3870105701,
              2008414854,
              3344188149,
              4221384143,
              3956125452,
              2067696032,
              3594591187,
              2921233993,
              2428461,
              544322398,
              577241275,
              1471733935,
              610547355,
              4027169054,
              1432588573,
              1507829418,
              2025931657,
              3646575487,
              545086370,
              48609733,
              2200306550,
              1653985193,
              298326376,
              1316178497,
              3007786442,
              2064951626,
              458293330,
              2589141269,
              3591329599,
              3164325604,
              727753846,
              2179363840,
              146436021,
              1461446943,
              4069977195,
              705550613,
              3059967265,
              3887724982,
              4281599278,
              3313849956,
              1404054877,
              2845806497,
              146425753,
              1854211946
            ],
            [
              1266315497,
              3048417604,
              3681880366,
              3289982499,
              290971e4,
              1235738493,
              2632868024,
              2414719590,
              3970600049,
              1771706367,
              1449415276,
              3266420449,
              422970021,
              1963543593,
              2690192192,
              3826793022,
              1062508698,
              1531092325,
              1804592342,
              2583117782,
              2714934279,
              4024971509,
              1294809318,
              4028980673,
              1289560198,
              2221992742,
              1669523910,
              35572830,
              157838143,
              1052438473,
              1016535060,
              1802137761,
              1753167236,
              1386275462,
              3080475397,
              2857371447,
              1040679964,
              2145300060,
              2390574316,
              1461121720,
              2956646967,
              4031777805,
              4028374788,
              33600511,
              2920084762,
              1018524850,
              629373528,
              3691585981,
              3515945977,
              2091462646,
              2486323059,
              586499841,
              988145025,
              935516892,
              3367335476,
              2599673255,
              2839830854,
              265290510,
              3972581182,
              2759138881,
              3795373465,
              1005194799,
              847297441,
              406762289,
              1314163512,
              1332590856,
              1866599683,
              4127851711,
              750260880,
              613907577,
              1450815602,
              3165620655,
              3734664991,
              3650291728,
              3012275730,
              3704569646,
              1427272223,
              778793252,
              1343938022,
              2676280711,
              2052605720,
              1946737175,
              3164576444,
              3914038668,
              3967478842,
              3682934266,
              1661551462,
              3294938066,
              4011595847,
              840292616,
              3712170807,
              616741398,
              312560963,
              711312465,
              1351876610,
              322626781,
              1910503582,
              271666773,
              2175563734,
              1594956187,
              70604529,
              3617834859,
              1007753275,
              1495573769,
              4069517037,
              2549218298,
              2663038764,
              504708206,
              2263041392,
              3941167025,
              2249088522,
              1514023603,
              1998579484,
              1312622330,
              694541497,
              2582060303,
              2151582166,
              1382467621,
              776784248,
              2618340202,
              3323268794,
              2497899128,
              2784771155,
              503983604,
              4076293799,
              907881277,
              423175695,
              432175456,
              1378068232,
              4145222326,
              3954048622,
              3938656102,
              3820766613,
              2793130115,
              2977904593,
              26017576,
              3274890735,
              3194772133,
              1700274565,
              1756076034,
              4006520079,
              3677328699,
              720338349,
              1533947780,
              354530856,
              688349552,
              3973924725,
              1637815568,
              332179504,
              3949051286,
              53804574,
              2852348879,
              3044236432,
              1282449977,
              3583942155,
              3416972820,
              4006381244,
              1617046695,
              2628476075,
              3002303598,
              1686838959,
              431878346,
              2686675385,
              1700445008,
              1080580658,
              1009431731,
              832498133,
              3223435511,
              2605976345,
              2271191193,
              2516031870,
              1648197032,
              4164389018,
              2548247927,
              300782431,
              375919233,
              238389289,
              3353747414,
              2531188641,
              2019080857,
              1475708069,
              455242339,
              2609103871,
              448939670,
              3451063019,
              1395535956,
              2413381860,
              1841049896,
              1491858159,
              885456874,
              4264095073,
              4001119347,
              1565136089,
              3898914787,
              1108368660,
              540939232,
              1173283510,
              2745871338,
              3681308437,
              4207628240,
              3343053890,
              4016749493,
              1699691293,
              1103962373,
              3625875870,
              2256883143,
              3830138730,
              1031889488,
              3479347698,
              1535977030,
              4236805024,
              3251091107,
              2132092099,
              1774941330,
              1199868427,
              1452454533,
              157007616,
              2904115357,
              342012276,
              595725824,
              1480756522,
              206960106,
              497939518,
              591360097,
              863170706,
              2375253569,
              3596610801,
              1814182875,
              2094937945,
              3421402208,
              1082520231,
              3463918190,
              2785509508,
              435703966,
              3908032597,
              1641649973,
              2842273706,
              3305899714,
              1510255612,
              2148256476,
              2655287854,
              3276092548,
              4258621189,
              236887753,
              3681803219,
              274041037,
              1734335097,
              3815195456,
              3317970021,
              1899903192,
              1026095262,
              4050517792,
              356393447,
              2410691914,
              3873677099,
              3682840055
            ],
            [
              3913112168,
              2491498743,
              4132185628,
              2489919796,
              1091903735,
              1979897079,
              3170134830,
              3567386728,
              3557303409,
              857797738,
              1136121015,
              1342202287,
              507115054,
              2535736646,
              337727348,
              3213592640,
              1301675037,
              2528481711,
              1895095763,
              1721773893,
              3216771564,
              62756741,
              2142006736,
              835421444,
              2531993523,
              1442658625,
              3659876326,
              2882144922,
              676362277,
              1392781812,
              170690266,
              3921047035,
              1759253602,
              3611846912,
              1745797284,
              664899054,
              1329594018,
              3901205900,
              3045908486,
              2062866102,
              2865634940,
              3543621612,
              3464012697,
              1080764994,
              553557557,
              3656615353,
              3996768171,
              991055499,
              499776247,
              1265440854,
              648242737,
              3940784050,
              980351604,
              3713745714,
              1749149687,
              3396870395,
              4211799374,
              3640570775,
              1161844396,
              3125318951,
              1431517754,
              545492359,
              4268468663,
              3499529547,
              1437099964,
              2702547544,
              3433638243,
              2581715763,
              2787789398,
              1060185593,
              1593081372,
              2418618748,
              4260947970,
              69676912,
              2159744348,
              86519011,
              2512459080,
              3838209314,
              1220612927,
              3339683548,
              133810670,
              1090789135,
              1078426020,
              1569222167,
              845107691,
              3583754449,
              4072456591,
              1091646820,
              628848692,
              1613405280,
              3757631651,
              526609435,
              236106946,
              48312990,
              2942717905,
              3402727701,
              1797494240,
              859738849,
              992217954,
              4005476642,
              2243076622,
              3870952857,
              3732016268,
              765654824,
              3490871365,
              2511836413,
              1685915746,
              3888969200,
              1414112111,
              2273134842,
              3281911079,
              4080962846,
              172450625,
              2569994100,
              980381355,
              4109958455,
              2819808352,
              2716589560,
              2568741196,
              3681446669,
              3329971472,
              1835478071,
              660984891,
              3704678404,
              4045999559,
              3422617507,
              3040415634,
              1762651403,
              1719377915,
              3470491036,
              2693910283,
              3642056355,
              3138596744,
              1364962596,
              2073328063,
              1983633131,
              926494387,
              3423689081,
              2150032023,
              4096667949,
              1749200295,
              3328846651,
              309677260,
              2016342300,
              1779581495,
              3079819751,
              111262694,
              1274766160,
              443224088,
              298511866,
              1025883608,
              3806446537,
              1145181785,
              168956806,
              3641502830,
              3584813610,
              1689216846,
              3666258015,
              3200248200,
              1692713982,
              2646376535,
              4042768518,
              1618508792,
              1610833997,
              3523052358,
              4130873264,
              2001055236,
              3610705100,
              2202168115,
              4028541809,
              2961195399,
              1006657119,
              2006996926,
              3186142756,
              1430667929,
              3210227297,
              1314452623,
              4074634658,
              4101304120,
              2273951170,
              1399257539,
              3367210612,
              3027628629,
              1190975929,
              2062231137,
              2333990788,
              2221543033,
              2438960610,
              1181637006,
              548689776,
              2362791313,
              3372408396,
              3104550113,
              3145860560,
              296247880,
              1970579870,
              3078560182,
              3769228297,
              1714227617,
              3291629107,
              3898220290,
              166772364,
              1251581989,
              493813264,
              448347421,
              195405023,
              2709975567,
              677966185,
              3703036547,
              1463355134,
              2715995803,
              1338867538,
              1343315457,
              2802222074,
              2684532164,
              233230375,
              2599980071,
              2000651841,
              3277868038,
              1638401717,
              4028070440,
              3237316320,
              6314154,
              819756386,
              300326615,
              590932579,
              1405279636,
              3267499572,
              3150704214,
              2428286686,
              3959192993,
              3461946742,
              1862657033,
              1266418056,
              963775037,
              2089974820,
              2263052895,
              1917689273,
              448879540,
              3550394620,
              3981727096,
              150775221,
              3627908307,
              1303187396,
              508620638,
              2975983352,
              2726630617,
              1817252668,
              1876281319,
              1457606340,
              908771278,
              3720792119,
              3617206836,
              2455994898,
              1729034894,
              1080033504
            ],
            [
              976866871,
              3556439503,
              2881648439,
              1522871579,
              1555064734,
              1336096578,
              3548522304,
              2579274686,
              3574697629,
              3205460757,
              3593280638,
              3338716283,
              3079412587,
              564236357,
              2993598910,
              1781952180,
              1464380207,
              3163844217,
              3332601554,
              1699332808,
              1393555694,
              1183702653,
              3581086237,
              1288719814,
              691649499,
              2847557200,
              2895455976,
              3193889540,
              2717570544,
              1781354906,
              1676643554,
              2592534050,
              3230253752,
              1126444790,
              2770207658,
              2633158820,
              2210423226,
              2615765581,
              2414155088,
              3127139286,
              673620729,
              2805611233,
              1269405062,
              4015350505,
              3341807571,
              4149409754,
              1057255273,
              2012875353,
              2162469141,
              2276492801,
              2601117357,
              993977747,
              3918593370,
              2654263191,
              753973209,
              36408145,
              2530585658,
              25011837,
              3520020182,
              2088578344,
              530523599,
              2918365339,
              1524020338,
              1518925132,
              3760827505,
              3759777254,
              1202760957,
              3985898139,
              3906192525,
              674977740,
              4174734889,
              2031300136,
              2019492241,
              3983892565,
              4153806404,
              3822280332,
              352677332,
              2297720250,
              60907813,
              90501309,
              3286998549,
              1016092578,
              2535922412,
              2839152426,
              457141659,
              509813237,
              4120667899,
              652014361,
              1966332200,
              2975202805,
              55981186,
              2327461051,
              676427537,
              3255491064,
              2882294119,
              3433927263,
              1307055953,
              942726286,
              933058658,
              2468411793,
              3933900994,
              4215176142,
              1361170020,
              2001714738,
              2830558078,
              3274259782,
              1222529897,
              1679025792,
              2729314320,
              3714953764,
              1770335741,
              151462246,
              3013232138,
              1682292957,
              1483529935,
              471910574,
              1539241949,
              458788160,
              3436315007,
              1807016891,
              3718408830,
              978976581,
              1043663428,
              3165965781,
              1927990952,
              4200891579,
              2372276910,
              3208408903,
              3533431907,
              1412390302,
              2931980059,
              4132332400,
              1947078029,
              3881505623,
              4168226417,
              2941484381,
              1077988104,
              1320477388,
              886195818,
              18198404,
              3786409e3,
              2509781533,
              112762804,
              3463356488,
              1866414978,
              891333506,
              18488651,
              661792760,
              1628790961,
              3885187036,
              3141171499,
              876946877,
              2693282273,
              1372485963,
              791857591,
              2686433993,
              3759982718,
              3167212022,
              3472953795,
              2716379847,
              445679433,
              3561995674,
              3504004811,
              3574258232,
              54117162,
              3331405415,
              2381918588,
              3769707343,
              4154350007,
              1140177722,
              4074052095,
              668550556,
              3214352940,
              367459370,
              261225585,
              2610173221,
              4209349473,
              3468074219,
              3265815641,
              314222801,
              3066103646,
              3808782860,
              282218597,
              3406013506,
              3773591054,
              379116347,
              1285071038,
              846784868,
              2669647154,
              3771962079,
              3550491691,
              2305946142,
              453669953,
              1268987020,
              3317592352,
              3279303384,
              3744833421,
              2610507566,
              3859509063,
              266596637,
              3847019092,
              517658769,
              3462560207,
              3443424879,
              370717030,
              4247526661,
              2224018117,
              4143653529,
              4112773975,
              2788324899,
              2477274417,
              1456262402,
              2901442914,
              1517677493,
              1846949527,
              2295493580,
              3734397586,
              2176403920,
              1280348187,
              1908823572,
              3871786941,
              846861322,
              1172426758,
              3287448474,
              3383383037,
              1655181056,
              3139813346,
              901632758,
              1897031941,
              2986607138,
              3066810236,
              3447102507,
              1393639104,
              373351379,
              950779232,
              625454576,
              3124240540,
              4148612726,
              2007998917,
              544563296,
              2244738638,
              2330496472,
              2058025392,
              1291430526,
              424198748,
              50039436,
              29584100,
              3605783033,
              2429876329,
              2791104160,
              1057563949,
              3255363231,
              3075367218,
              3463963227,
              1469046755,
              985887462
            ]
          ];
          var g = {
            pbox: [],
            sbox: []
          };
          function h(B, _) {
            let M = _ >> 24 & 255, S = _ >> 16 & 255, O = _ >> 8 & 255, w = _ & 255, D = B.sbox[0][M] + B.sbox[1][S];
            return D = D ^ B.sbox[2][O], D = D + B.sbox[3][w], D;
          }
          function E(B, _, M) {
            let S = _, O = M, w;
            for (let D = 0; D < c; ++D)
              S = S ^ B.pbox[D], O = h(B, S) ^ O, w = S, S = O, O = w;
            return w = S, S = O, O = w, O = O ^ B.pbox[c], S = S ^ B.pbox[c + 1], { left: S, right: O };
          }
          function y(B, _, M) {
            let S = _, O = M, w;
            for (let D = c + 1; D > 1; --D)
              S = S ^ B.pbox[D], O = h(B, S) ^ O, w = S, S = O, O = w;
            return w = S, S = O, O = w, O = O ^ B.pbox[1], S = S ^ B.pbox[0], { left: S, right: O };
          }
          function I(B, _, M) {
            for (let k = 0; k < 4; k++) {
              B.sbox[k] = [];
              for (let F = 0; F < 256; F++)
                B.sbox[k][F] = d[k][F];
            }
            let S = 0;
            for (let k = 0; k < c + 2; k++)
              B.pbox[k] = f[k] ^ _[S], S++, S >= M && (S = 0);
            let O = 0, w = 0, D = 0;
            for (let k = 0; k < c + 2; k += 2)
              D = E(B, O, w), O = D.left, w = D.right, B.pbox[k] = O, B.pbox[k + 1] = w;
            for (let k = 0; k < 4; k++)
              for (let F = 0; F < 256; F += 2)
                D = E(B, O, w), O = D.left, w = D.right, B.sbox[k][F] = O, B.sbox[k][F + 1] = w;
            return !0;
          }
          var Q = u.Blowfish = o.extend({
            _doReset: function() {
              if (this._keyPriorReset !== this._key) {
                var B = this._keyPriorReset = this._key, _ = B.words, M = B.sigBytes / 4;
                I(g, _, M);
              }
            },
            encryptBlock: function(B, _) {
              var M = E(g, B[_], B[_ + 1]);
              B[_] = M.left, B[_ + 1] = M.right;
            },
            decryptBlock: function(B, _) {
              var M = y(g, B[_], B[_ + 1]);
              B[_] = M.left, B[_ + 1] = M.right;
            },
            blockSize: 64 / 32,
            keySize: 128 / 32,
            ivSize: 64 / 32
          });
          n.Blowfish = o._createHelper(Q);
        }(), r.Blowfish;
      });
    }(kg)), kg.exports;
  }
  var oQ2 = eg.exports, QZ;
  function sQ2() {
    return QZ || (QZ = 1, function(e, t) {
      (function(r, n, i) {
        e.exports = n(he(), Gh(), nB2(), aB2(), na(), uB2(), ia(), jG(), c_(), CB2(), VG(), pB2(), vB2(), mB2(), A_(), BB2(), n7(), V5(), wB2(), MB2(), OB2(), DB2(), kB2(), PB2(), NB2(), jB2(), ZB2(), UB2(), WB2(), $B2(), KB2(), JB2(), tQ2(), nQ2(), aQ2());
      })(oQ2, function(r) {
        return r;
      });
    }(eg)), eg.exports;
  }
  var xZ = sQ2();
  const uQ2 = () => {
    const e = localStorage.getItem("accessToken"), t = "1950277964321";
    if (e === null)
      return null;
    try {
      const r = xZ.AES.decrypt(e, t).toString(xZ.enc.Utf8);
      if (r == null) {
        const n = "Unexpected null or undefined return from CryptoJS.AES.decrypt when attempting to decrypt access token from localStorage";
        throw new Error(n);
      }
      return r;
    } catch (r) {
      throw console.error(r), new Error(
        "Unexpected exception when attempting to decrypt access token from localStorage using CryptoJS.AES.decrypt"
      );
    }
  }, lQ2 = (e, t) => {
    const r = uQ2();
    return {
      headers: {
        ...t.headers ?? {},
        authorization: r ? `Bearer ${r}` : ""
      }
    };
  }, cQ2 = $I2(lQ2), AQ2 = (e) => new Bz({ uri: e }), fQ2 = (e) => new Uz({
    link: cQ2.concat(AQ2(e)),
    cache: new Zz({
      typePolicies: {
        Query: {
          fields: {
            currentUser: {
              merge(t, r) {
                return {
                  ...t,
                  ...r
                };
              }
            }
          }
        },
        CurrentUser: {
          fields: {
            facilities: {
              merge(t, r) {
                return r;
              }
            },
            facility: {
              keyArgs: ["id"]
            }
          }
        }
      }
    })
  }), CQ2 = ({ pastReportsUrl: e }) => {
    const { facilityList: t, loading: r, error: n } = YI2(), { selectedFacility: i, currentFacilityData: o, handleFacilityChange: u, facilityLoading: c, facilityError: f } = qI2(t);
    return r ? /* @__PURE__ */ K.jsx(Uy, {}) : n ? (console.error("Failed to load facility list.", n), /* @__PURE__ */ K.jsx(Ck, {})) : t.length === 0 ? /* @__PURE__ */ K.jsx(j42, {}) : i ? /* @__PURE__ */ K.jsxs("div", { className: "max-w-258 mx-auto pt-6 pb-24", children: [
      /* @__PURE__ */ K.jsxs("section", { className: "flex flex-row items-start justify-between  mb-6", children: [
        /* @__PURE__ */ K.jsx("h1", { className: "text-4xl text-neutral-900", children: ne.report.headingOne }),
        /* @__PURE__ */ K.jsx(
          C72,
          {
            facilities: t,
            selectedFacility: i,
            onFacilityChange: u
          }
        )
      ] }),
      f ? /* @__PURE__ */ K.jsx(Ck, { className: "mt-6 mb-23" }) : o != null && o.visitAggregates ? /* @__PURE__ */ K.jsx(nm2, { isLoading: c, children: /* @__PURE__ */ K.jsx(
        zI2,
        {
          visitAggregates: o.visitAggregates,
          pastReportsUrl: e
        }
      ) }) : /* @__PURE__ */ K.jsx(Uy, {})
    ] }) : /* @__PURE__ */ K.jsx(Uy, {});
  }, dQ2 = ({
    pastReportsUrl: e,
    apiUrl: t,
    environment: r = "development"
  }) => {
    r === "production" || r === "prod" || (n42(), i42());
    const i = q.useMemo(() => fQ2(t), [t]);
    return /* @__PURE__ */ K.jsx(Mr2, { client: i, children: /* @__PURE__ */ K.jsx(CQ2, { pastReportsUrl: e }) });
  }, gQ2 = Je2(dQ2, {
    props: {
      pastReportsUrl: "string",
      apiUrl: "string",
      environment: "string"
    }
  });
  customElements.define("visitation-report", gQ2);
});
export default pQ2();
